import _objectWithoutProperties2 from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray2 from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["scope", "children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["asChild"],
  _excluded5 = ["__scopeScrollArea", "type", "scrollHideDelay"],
  _excluded6 = ["__scopeScrollArea", "children"],
  _excluded7 = ["forceMount"],
  _excluded8 = ["forceMount"],
  _excluded9 = ["forceMount"],
  _excluded10 = ["forceMount"],
  _excluded11 = ["orientation"],
  _excluded12 = ["sizes", "onSizesChange"],
  _excluded13 = ["sizes", "onSizesChange"],
  _excluded14 = ["__scopeScrollArea", "sizes", "hasThumb", "onThumbChange", "onThumbPointerUp", "onThumbPointerDown", "onThumbPositionChange", "onDragScroll", "onWheelScroll", "onResize"],
  _excluded15 = ["__scopeScrollArea", "style"],
  _excluded16 = ["__scopeScrollArea"];
import React__default, { createContext, useContext, forwardRef, createElement, Fragment, useRef, useLayoutEffect, Children, useEffect, useState, useCallback, useReducer, useMemo, cloneElement, isValidElement } from 'react';
import { flushSync, createPortal } from 'react-dom';
import propTypes from 'prop-types';
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css = "/* \nAsurion Design guidelines\nhttps://asurion.sharepoint.com/teams/BrandSource/FormServerTemplates/Forms/All%20Forms.aspx?id=%2Fteams%2FBrandSource%2FFormServerTemplates%2FGuidelines%2FAsurion%20Brand%20Guidelines%201%2E2%5FFINAL%2Epdf&parent=%2Fteams%2FBrandSource%2FFormServerTemplates%2FGuidelines */\ncode {\n  font-family: 'Apercu Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',\n    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n    'Helvetica Neue', sans-serif !important;\n}\n\n:root {\n  --company-primary-color: #8223d2;\n  --company-primary-color-alternate-light: #ffffff;\n  --company-primary-color-alternate-dark: #000000;\n  --company-secondary-color-1: #6efac3;\n  --company-secondary-color-2: #6b8bff;\n  --company-secondary-color-3: #e6e6eb;\n  --company-secondary-color-4: #a6aaaf;\n  --company-tertiarty-color-1: #d2fa46;\n  --company-tertiarty-color-2: #333f48;\n  --company-error-color-bright: #ff5070;\n  --company-error-color-dark: #d91b1b;\n  --company-warn-color-bright: #f9d51c;\n  --company-warn-color-dark: #edb800;\n  --company-success-color-bright: #37e7a7;\n  --company-success-color-dark: #00bf63;\n  --company-typography-primary-light: 'Apercu Pro Light';\n  --company-typography-primary-regular: 'Apercu Pro Regular';\n  --company-typography-primary-bold: 'Apercu Pro Bold';\n  --company-typography-primary-black: 'Apercu Pro Black';\n  --company-typography-secondary-light: 'Apercu Pro Mono Light';\n  --company-typography-secondary-regular: 'Apercu Pro Mono Regular';\n  --company-typography-system-primary-regular: 'Calibri';\n  --company-typography-system-secondary-regular: 'Arial';\n  --default-border-radius: 4px;\n  --default-table-border-color: #d3d3d3;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Apercu Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',\n    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n    'Helvetica Neue', sans-serif !important;\n  font-weight: 100;\n  line-height: 16px;\n  font-size: 14px;\n  background-color: var(--leader-background);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nsvg:empty {\n  height: 0px;\n  width: 0px;\n}\n";
styleInject(css);
var css$1 = "/* FIXME add adminpage container selector to classes to prevent affecting other sub apps */\n/*FIXME Go through and combine redundant css into classes*/\n/*FIXME Currently using id selector for main containter to avoid any css conflicts with other packages. This should be removed\nafter standardized css has been implemented*/\n:root {\n  --button-hover-brightness: 85%;\n  --admin-controls-container-height: 9rem;\n}\n\n/*FIXME remove this once the wildcard selector is gone*/\n#admin-view-container #submit-query-button > div > span {\n  color: var(--company-primary-color-alternate-light);\n}\n/*Container rules*/\n#admin-view-container .container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0rem 0.5rem;\n  margin: 0.2rem 0 0;\n}\n#admin-view-container {\n  padding: 0 0.5rem;\n  width: 100%;\n  justify-content: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0rem 0.5rem;\n  margin: 0.2rem 0 0;\n}\n#admin-view-container #controls-container {\n  flex-direction: column;\n  width: 100%;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background: var(--company-primary-color-alternate-light);\n  height: var(--admin-controls-container-height);\n}\n#admin-view-container .aux-table-items {\n  justify-content: space-between;\n  margin: 0;\n  position: -webkit-sticky;\n  position: sticky;\n  top: var(--admin-controls-container-height);\n  background: var(--company-primary-color-alternate-light);\n}\n\n/*End container rules */\n\n/*Button Rules*/\n#admin-view-container .button-primary {\n  background-color: var(--company-primary-color);\n  color: var(--company-primary-color-alternate-light);\n}\n#admin-view-container .button-secondary {\n  background-color: var(--company-secondary-color-1);\n  color: var(--company-primary-color-alternate-dark);\n}\n\n#admin-view-container #submit-query-button {\n  align-self: flex-end;\n}\n#admin-view-container #submit-query-button:hover {\n  background-color: var(--company-primary-color);\n  filter: brightness(var(--button-hover-brightness));\n}\n#admin-view-container #download-csv-button:hover {\n  background-color: var(--company-secondary-color-1);\n  filter: brightness(var(--button-hover-brightness));\n}\n#admin-view-container #download-csv-button a {\n  text-decoration-line: none;\n}\n/*End Button Rules*/\n\n/*Table rules */\n#admin-view-container .admin-display-table {\n  table-layout: fixed;\n  margin: 0 0.1rem;\n  max-width: calc(100% - 2px); /*Acounts for shadow box border*/\n  width: auto;\n}\n#admin-view-container .admin-display-table td {\n  overflow-wrap: break-word;\n  white-space: pre-line;\n  font-weight: 300;\n}\n#admin-view-container .admin-display-table > thead {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 11.3rem;\n  background: var(--company-primary-color-alternate-light);\n}\n#admin-view-container .admin-table-border {\n  border-radius: var(--default-border-radius);\n  border-color: var(--default-table-border-color);\n  border-spacing: 0px;\n  border-style: hidden;\n  box-shadow: 0 0 0 1px var(--default-table-border-color);\n}\n\n#admin-view-container .admin-display-table td,\nth {\n  width: min-content;\n}\n\n/*End Table Rules*/\n\n#admin-view-container button.mantine-Pagination-active {\n  background-color: var(--company-primary-color);\n}\n#admin-view-container #admin-table-filter-input {\n  width: 22.75rem;\n}\n#admin-view-container #table-total-items > span {\n  color: var(--company-primary-color-alternate-light);\n}\n#admin-view-container #table-total-items {\n  align-self: end;\n  background-color: var(--company-primary-color);\n  border-radius: var(--default-border-radius);\n}\n\n#admin-view-container .drop-down div > select {\n  cursor: pointer;\n}\n";
styleInject(css$1);
var DEFAULT_COLORS = {
  dark: ["#C1C2C5", "#A6A7AB", "#909296", "#5c5f66", "#373A40", "#2C2E33", "#25262b", "#1A1B1E", "#141517", "#101113"],
  gray: ["#f8f9fa", "#f1f3f5", "#e9ecef", "#dee2e6", "#ced4da", "#adb5bd", "#868e96", "#495057", "#343a40", "#212529"],
  red: ["#fff5f5", "#ffe3e3", "#ffc9c9", "#ffa8a8", "#ff8787", "#ff6b6b", "#fa5252", "#f03e3e", "#e03131", "#c92a2a"],
  pink: ["#fff0f6", "#ffdeeb", "#fcc2d7", "#faa2c1", "#f783ac", "#f06595", "#e64980", "#d6336c", "#c2255c", "#a61e4d"],
  grape: ["#f8f0fc", "#f3d9fa", "#eebefa", "#e599f7", "#da77f2", "#cc5de8", "#be4bdb", "#ae3ec9", "#9c36b5", "#862e9c"],
  violet: ["#f3f0ff", "#e5dbff", "#d0bfff", "#b197fc", "#9775fa", "#845ef7", "#7950f2", "#7048e8", "#6741d9", "#5f3dc4"],
  indigo: ["#edf2ff", "#dbe4ff", "#bac8ff", "#91a7ff", "#748ffc", "#5c7cfa", "#4c6ef5", "#4263eb", "#3b5bdb", "#364fc7"],
  blue: ["#e7f5ff", "#d0ebff", "#a5d8ff", "#74c0fc", "#4dabf7", "#339af0", "#228be6", "#1c7ed6", "#1971c2", "#1864ab"],
  cyan: ["#e3fafc", "#c5f6fa", "#99e9f2", "#66d9e8", "#3bc9db", "#22b8cf", "#15aabf", "#1098ad", "#0c8599", "#0b7285"],
  teal: ["#e6fcf5", "#c3fae8", "#96f2d7", "#63e6be", "#38d9a9", "#20c997", "#12b886", "#0ca678", "#099268", "#087f5b"],
  green: ["#ebfbee", "#d3f9d8", "#b2f2bb", "#8ce99a", "#69db7c", "#51cf66", "#40c057", "#37b24d", "#2f9e44", "#2b8a3e"],
  lime: ["#f4fce3", "#e9fac8", "#d8f5a2", "#c0eb75", "#a9e34b", "#94d82d", "#82c91e", "#74b816", "#66a80f", "#5c940d"],
  yellow: ["#fff9db", "#fff3bf", "#ffec99", "#ffe066", "#ffd43b", "#fcc419", "#fab005", "#f59f00", "#f08c00", "#e67700"],
  orange: ["#fff4e6", "#ffe8cc", "#ffd8a8", "#ffc078", "#ffa94d", "#ff922b", "#fd7e14", "#f76707", "#e8590c", "#d9480f"]
};
function fontStyles(theme) {
  return function () {
    return {
      fontFamily: theme.fontFamily || "sans-serif"
    };
  };
}
function focusStyles(theme) {
  return function () {
    return {
      WebkitTapHighlightColor: "transparent",
      "&:focus": {
        outlineOffset: 2,
        outline: theme.focusRing === "always" || theme.focusRing === "auto" ? "2px solid ".concat(theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5]) : "none"
      },
      "&:focus:not(:focus-visible)": {
        outline: theme.focusRing === "auto" || theme.focusRing === "never" ? "none" : void 0
      }
    };
  };
}
function themeColor(theme) {
  return function (color, shade) {
    var primaryFallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var primaryShades = theme.colors[theme.primaryColor];
    return color in theme.colors ? theme.colors[color][shade] : primaryFallback ? primaryShades[shade] : color;
  };
}
function getGradientColorStops(colors) {
  var stops = "";
  for (var _i3 = 1; _i3 < colors.length - 1; _i3 += 1) {
    stops += "".concat(colors[_i3], " ").concat(_i3 / (colors.length - 1) * 100, "%, ");
  }
  return "".concat(colors[0], " 0%, ").concat(stops).concat(colors[colors.length - 1], " 100%");
}
function linearGradient(deg) {
  for (var _len3 = arguments.length, colors = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    colors[_key3 - 1] = arguments[_key3];
  }
  return "linear-gradient(".concat(deg, "deg, ").concat(getGradientColorStops(colors), ")");
}
function radialGradient() {
  for (var _len4 = arguments.length, colors = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    colors[_key4] = arguments[_key4];
  }
  return "radial-gradient(circle, ".concat(getGradientColorStops(colors), ")");
}
function size(props) {
  if (typeof props.size === "number") {
    return props.size;
  }
  return props.sizes[props.size] || props.size || props.sizes.md;
}
function largerThan(theme) {
  return function (breakpoint) {
    return "@media (min-width: ".concat(size({
      size: breakpoint,
      sizes: theme.breakpoints
    }) + 1, "px)");
  };
}
function smallerThan(theme) {
  return function (breakpoint) {
    return "@media (max-width: ".concat(size({
      size: breakpoint,
      sizes: theme.breakpoints
    }), "px)");
  };
}
function isHexColor(hex) {
  var HEX_REGEXP = /^#?([0-9A-F]{3}){1,2}$/i;
  return HEX_REGEXP.test(hex);
}
function hexToRgba(color) {
  var hexString = color.replace("#", "");
  if (hexString.length === 3) {
    var shorthandHex = hexString.split("");
    hexString = [shorthandHex[0], shorthandHex[0], shorthandHex[1], shorthandHex[1], shorthandHex[2], shorthandHex[2]].join("");
  }
  var parsed = parseInt(hexString, 16);
  var r = parsed >> 16 & 255;
  var g = parsed >> 8 & 255;
  var b = parsed & 255;
  return {
    r: r,
    g: g,
    b: b,
    a: 1
  };
}
function rgbStringToRgba(color) {
  var _color$replace$split$ = color.replace(/[^0-9,.]/g, "").split(",").map(Number),
    _color$replace$split$2 = _slicedToArray(_color$replace$split$, 4),
    r = _color$replace$split$2[0],
    g = _color$replace$split$2[1],
    b = _color$replace$split$2[2],
    a = _color$replace$split$2[3];
  return {
    r: r,
    g: g,
    b: b,
    a: a || 1
  };
}
function toRgba(color) {
  if (isHexColor(color)) {
    return hexToRgba(color);
  }
  if (color.startsWith("rgb")) {
    return rgbStringToRgba(color);
  }
  return {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
function rgba(color, alpha) {
  if (typeof color !== "string" || alpha > 1 || alpha < 0) {
    return "rgba(0, 0, 0, 1)";
  }
  var _toRgba = toRgba(color),
    r = _toRgba.r,
    g = _toRgba.g,
    b = _toRgba.b;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
}
function cover() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    position: "absolute",
    top: offset,
    right: offset,
    left: offset,
    bottom: offset
  };
}
function darken(color, alpha) {
  var _toRgba2 = toRgba(color),
    r = _toRgba2.r,
    g = _toRgba2.g,
    b = _toRgba2.b,
    a = _toRgba2.a;
  var f = 1 - alpha;
  var dark = function dark(input) {
    return Math.round(input * f);
  };
  return "rgba(".concat(dark(r), ", ").concat(dark(g), ", ").concat(dark(b), ", ").concat(a, ")");
}
function lighten(color, alpha) {
  var _toRgba3 = toRgba(color),
    r = _toRgba3.r,
    g = _toRgba3.g,
    b = _toRgba3.b,
    a = _toRgba3.a;
  var light = function light(input) {
    return Math.round(input + (255 - input) * alpha);
  };
  return "rgba(".concat(light(r), ", ").concat(light(g), ", ").concat(light(b), ", ").concat(a, ")");
}
function radius(theme) {
  return function (size) {
    if (typeof size === "number") {
      return size;
    }
    var defaultRadius = typeof theme.defaultRadius === "number" ? theme.defaultRadius : theme.radius[theme.defaultRadius] || theme.defaultRadius;
    return theme.radius[size] || size || defaultRadius;
  };
}
function primaryShade(theme) {
  return function (colorScheme) {
    if (typeof theme.primaryShade === "number") {
      return theme.primaryShade;
    }
    return theme.primaryShade[colorScheme || theme.colorScheme];
  };
}
var DEFAULT_GRADIENT = {
  from: "indigo",
  to: "cyan",
  deg: 45
};
function variant(theme) {
  var getThemeColor = themeColor(theme);
  var getPrimaryShade = primaryShade(theme);
  return function (_ref14) {
    var variant2 = _ref14.variant,
      color = _ref14.color,
      gradient = _ref14.gradient;
    if (variant2 === "light") {
      return {
        border: "transparent",
        background: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 8 : 0), theme.colorScheme === "dark" ? 0.35 : 1),
        color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
        hover: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 7 : 1), theme.colorScheme === "dark" ? 0.45 : 0.65)
      };
    }
    if (variant2 === "default") {
      return {
        border: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[4],
        background: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.white,
        color: theme.colorScheme === "dark" ? theme.white : theme.black,
        hover: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[0]
      };
    }
    if (variant2 === "white") {
      return {
        border: "transparent",
        background: theme.white,
        color: getThemeColor(color, getPrimaryShade()),
        hover: null
      };
    }
    if (variant2 === "outline") {
      return {
        border: getThemeColor(color, theme.colorScheme === "dark" ? 4 : getPrimaryShade("light")),
        background: "transparent",
        color: getThemeColor(color, theme.colorScheme === "dark" ? 4 : getPrimaryShade("light")),
        hover: theme.colorScheme === "dark" ? rgba(getThemeColor(color, 4), 0.05) : rgba(getThemeColor(color, 0), 0.35)
      };
    }
    if (variant2 === "gradient") {
      var merged = {
        from: (gradient == null ? void 0 : gradient.from) || DEFAULT_GRADIENT.from,
        to: (gradient == null ? void 0 : gradient.to) || DEFAULT_GRADIENT.to,
        deg: (gradient == null ? void 0 : gradient.deg) || DEFAULT_GRADIENT.deg
      };
      return {
        background: "linear-gradient(".concat(merged.deg, "deg, ").concat(getThemeColor(merged.from, getPrimaryShade(), false), " 0%, ").concat(getThemeColor(merged.to, getPrimaryShade(), false), " 100%)"),
        color: theme.white,
        border: "transparent",
        hover: null
      };
    }
    if (variant2 === "subtle") {
      return {
        border: "transparent",
        background: "transparent",
        color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
        hover: rgba(getThemeColor(color, theme.colorScheme === "dark" ? 8 : 0), theme.colorScheme === "dark" ? 0.35 : 1)
      };
    }
    return {
      border: "transparent",
      background: getThemeColor(color, getPrimaryShade()),
      color: theme.white,
      hover: getThemeColor(color, getPrimaryShade() === 9 ? 8 : getPrimaryShade() + 1)
    };
  };
}
function hover(hoverStyle) {
  return {
    "@media (hover: hover)": {
      "&:hover": hoverStyle
    },
    "@media (hover: none)": {
      "&:active": hoverStyle
    }
  };
}
var fns = {
  fontStyles: fontStyles,
  themeColor: themeColor,
  focusStyles: focusStyles,
  linearGradient: linearGradient,
  radialGradient: radialGradient,
  smallerThan: smallerThan,
  largerThan: largerThan,
  rgba: rgba,
  size: size,
  cover: cover,
  darken: darken,
  lighten: lighten,
  radius: radius,
  variant: variant,
  primaryShade: primaryShade,
  hover: hover
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step2;
    try {
      for (_iterator.s(); !(_step2 = _iterator.n()).done;) {
        var prop = _step2.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function attachFunctions(themeBase) {
  return __spreadProps(__spreadValues({}, themeBase), {
    fn: {
      fontStyles: fns.fontStyles(themeBase),
      themeColor: fns.themeColor(themeBase),
      focusStyles: fns.focusStyles(themeBase),
      largerThan: fns.largerThan(themeBase),
      smallerThan: fns.smallerThan(themeBase),
      radialGradient: fns.radialGradient,
      linearGradient: fns.linearGradient,
      rgba: fns.rgba,
      size: fns.size,
      cover: fns.cover,
      lighten: fns.lighten,
      darken: fns.darken,
      primaryShade: fns.primaryShade(themeBase),
      radius: fns.radius(themeBase),
      variant: fns.variant(themeBase),
      hover: fns.hover
    }
  });
}
var MANTINE_SIZES = ["xs", "sm", "md", "lg", "xl"];
var _DEFAULT_THEME = {
  dir: "ltr",
  primaryShade: {
    light: 6,
    dark: 8
  },
  focusRing: "auto",
  loader: "oval",
  dateFormat: "MMMM D, YYYY",
  colorScheme: "light",
  white: "#fff",
  black: "#000",
  defaultRadius: "sm",
  transitionTimingFunction: "ease",
  colors: DEFAULT_COLORS,
  lineHeight: 1.55,
  fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  primaryColor: "blue",
  shadows: {
    xs: "0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)",
    sm: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 10px 15px -5px, rgba(0, 0, 0, 0.04) 0px 7px 7px -5px",
    md: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
    lg: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 28px 23px -7px, rgba(0, 0, 0, 0.04) 0px 12px 12px -7px",
    xl: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 36px 28px -7px, rgba(0, 0, 0, 0.04) 0px 17px 17px -7px"
  },
  fontSizes: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20
  },
  radius: {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 16,
    xl: 32
  },
  spacing: {
    xs: 10,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24
  },
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1400
  },
  headings: {
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontWeight: 700,
    sizes: {
      h1: {
        fontSize: 34,
        lineHeight: 1.3
      },
      h2: {
        fontSize: 26,
        lineHeight: 1.35
      },
      h3: {
        fontSize: 22,
        lineHeight: 1.4
      },
      h4: {
        fontSize: 18,
        lineHeight: 1.45
      },
      h5: {
        fontSize: 16,
        lineHeight: 1.5
      },
      h6: {
        fontSize: 14,
        lineHeight: 1.5
      }
    }
  },
  other: {},
  datesLocale: "en"
};
var DEFAULT_THEME = attachFunctions(_DEFAULT_THEME);

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */

  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);
  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }
  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}
var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;
    this._insertTag = function (tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };
  return StyleSheet;
}();
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var c = "comm";
var n = "rule";
var t = "decl";
var i = "@import";
var p = "@keyframes";
var k = Math.abs;
var d = String.fromCharCode;
var g = Object.assign;
function m(e, r) {
  return (((r << 2 ^ z(e, 0)) << 2 ^ z(e, 1)) << 2 ^ z(e, 2)) << 2 ^ z(e, 3);
}
function x(e) {
  return e.trim();
}
function y(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function j(e, r, a) {
  return e.replace(r, a);
}
function C(e, r) {
  return e.indexOf(r);
}
function z(e, r) {
  return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
  return e.slice(r, a);
}
function O(e) {
  return e.length;
}
function M(e) {
  return e.length;
}
function S(e, r) {
  return r.push(e), e;
}
function q(e, r) {
  return e.map(r).join("");
}
var B = 1;
var D = 1;
var E = 0;
var F = 0;
var G = 0;
var H = "";
function I(e, r, a, c, n, t, s) {
  return {
    value: e,
    root: r,
    parent: a,
    type: c,
    props: n,
    children: t,
    line: B,
    column: D,
    length: s,
    return: ""
  };
}
function J(e, r) {
  return g(I("", null, null, "", null, null, 0), e, {
    length: -e.length
  }, r);
}
function K() {
  return G;
}
function L() {
  G = F > 0 ? z(H, --F) : 0;
  if (D--, G === 10) D = 1, B--;
  return G;
}
function N() {
  G = F < E ? z(H, F++) : 0;
  if (D++, G === 10) D = 1, B++;
  return G;
}
function P() {
  return z(H, F);
}
function Q() {
  return F;
}
function R(e, r) {
  return A(H, e, r);
}
function T(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function U(e) {
  return B = D = 1, E = O(H = e), F = 0, [];
}
function V(e) {
  return H = "", e;
}
function W(e) {
  return x(R(F - 1, ee(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
  while (G = P()) if (G < 33) N();else break;
  return T(e) > 2 || T(G) > 3 ? "" : " ";
}
function _(e, r) {
  while (--r && N()) if (G < 48 || G > 102 || G > 57 && G < 65 || G > 70 && G < 97) break;
  return R(e, Q() + (r < 6 && P() == 32 && N() == 32));
}
function ee(e) {
  while (N()) switch (G) {
    case e:
      return F;
    case 34:
    case 39:
      if (e !== 34 && e !== 39) ee(G);
      break;
    case 40:
      if (e === 41) ee(e);
      break;
    case 92:
      N();
      break;
  }
  return F;
}
function re(e, r) {
  while (N()) if (e + G === 47 + 10) break;else if (e + G === 42 + 42 && P() === 47) break;
  return "/*" + R(r, F - 1) + "*" + d(e === 47 ? e : N());
}
function ae(e) {
  while (!T(P())) N();
  return R(e, F);
}
function ce(e) {
  return V(ne("", null, null, null, [""], e = U(e), 0, [0], e));
}
function ne(e, r, a, c, n, t, s, u, i) {
  var f = 0;
  var o = 0;
  var l = s;
  var v = 0;
  var h = 0;
  var p = 0;
  var b = 1;
  var w = 1;
  var $ = 1;
  var k = 0;
  var g = "";
  var m = n;
  var x = t;
  var y = c;
  var z = g;
  while (w) switch (p = k, k = N()) {
    case 40:
      if (p != 108 && z.charCodeAt(l - 1) == 58) {
        if (C(z += j(W(k), "&", "&\f"), "&\f") != -1) $ = -1;
        break;
      }
    case 34:
    case 39:
    case 91:
      z += W(k);
      break;
    case 9:
    case 10:
    case 13:
    case 32:
      z += Y(p);
      break;
    case 92:
      z += _(Q() - 1, 7);
      continue;
    case 47:
      switch (P()) {
        case 42:
        case 47:
          S(se(re(N(), Q()), r, a), i);
          break;
        default:
          z += "/";
      }
      break;
    case 123 * b:
      u[f++] = O(z) * $;
    case 125 * b:
    case 59:
    case 0:
      switch (k) {
        case 0:
        case 125:
          w = 0;
        case 59 + o:
          if (h > 0 && O(z) - l) S(h > 32 ? ue(z + ";", c, a, l - 1) : ue(j(z, " ", "") + ";", c, a, l - 2), i);
          break;
        case 59:
          z += ";";
        default:
          S(y = te(z, r, a, f, o, n, u, g, m = [], x = [], l), t);
          if (k === 123) if (o === 0) ne(z, r, y, y, m, t, l, u, x);else switch (v) {
            case 100:
            case 109:
            case 115:
              ne(e, y, y, c && S(te(e, y, y, 0, 0, n, u, g, n, m = [], l), x), n, x, l, u, c ? m : x);
              break;
            default:
              ne(z, y, y, y, [""], x, 0, u, x);
          }
      }
      f = o = h = 0, b = $ = 1, g = z = "", l = s;
      break;
    case 58:
      l = 1 + O(z), h = p;
    default:
      if (b < 1) if (k == 123) --b;else if (k == 125 && b++ == 0 && L() == 125) continue;
      switch (z += d(k), k * b) {
        case 38:
          $ = o > 0 ? 1 : (z += "\f", -1);
          break;
        case 44:
          u[f++] = (O(z) - 1) * $, $ = 1;
          break;
        case 64:
          if (P() === 45) z += W(N());
          v = P(), o = l = O(g = z += ae(Q())), k++;
          break;
        case 45:
          if (p === 45 && O(z) == 2) b = 0;
      }
  }
  return t;
}
function te(e, r, a, c, t, s, u, i, f, o, l) {
  var v = t - 1;
  var h = t === 0 ? s : [""];
  var p = M(h);
  for (var b = 0, w = 0, $ = 0; b < c; ++b) for (var d = 0, g = A(e, v + 1, v = k(w = u[b])), m = e; d < p; ++d) if (m = x(w > 0 ? h[d] + " " + g : j(g, /&\f/g, h[d]))) f[$++] = m;
  return I(e, r, a, t === 0 ? n : i, f, o, l);
}
function se(e, r, a) {
  return I(e, r, a, c, d(K()), A(e, 2, -2), 0);
}
function ue(e, r, a, c) {
  return I(e, r, a, t, A(e, 0, c), A(e, c + 1, -1), c);
}
function ie(c, n) {
  switch (m(c, n)) {
    case 5103:
      return a + "print-" + c + c;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return a + c + c;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return a + c + r + c + e + c + c;
    case 6828:
    case 4268:
      return a + c + e + c + c;
    case 6165:
      return a + c + e + "flex-" + c + c;
    case 5187:
      return a + c + j(c, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + c;
    case 5443:
      return a + c + e + "flex-item-" + j(c, /flex-|-self/, "") + c;
    case 4675:
      return a + c + e + "flex-line-pack" + j(c, /align-content|flex-|-self/, "") + c;
    case 5548:
      return a + c + e + j(c, "shrink", "negative") + c;
    case 5292:
      return a + c + e + j(c, "basis", "preferred-size") + c;
    case 6060:
      return a + "box-" + j(c, "-grow", "") + a + c + e + j(c, "grow", "positive") + c;
    case 4554:
      return a + j(c, /([^-])(transform)/g, "$1" + a + "$2") + c;
    case 6187:
      return j(j(j(c, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), c, "") + c;
    case 5495:
    case 3959:
      return j(c, /(image-set\([^]*)/, a + "$1" + "$`$1");
    case 4968:
      return j(j(c, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + c + c;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return j(c, /(.+)-inline(.+)/, a + "$1$2") + c;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (O(c) - 1 - n > 6) switch (z(c, n + 1)) {
        case 109:
          if (z(c, n + 4) !== 45) break;
        case 102:
          return j(c, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (z(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
        case 115:
          return ~C(c, "stretch") ? ie(j(c, "stretch", "fill-available"), n) + c : c;
      }
      break;
    case 4949:
      if (z(c, n + 1) !== 115) break;
    case 6444:
      switch (z(c, O(c) - 3 - (~C(c, "!important") && 10))) {
        case 107:
          return j(c, ":", ":" + a) + c;
        case 101:
          return j(c, /(.+:)([^;!]+)(;|!.+)?/, "$1" + a + (z(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + c;
      }
      break;
    case 5936:
      switch (z(c, n + 11)) {
        case 114:
          return a + c + e + j(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
        case 108:
          return a + c + e + j(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
        case 45:
          return a + c + e + j(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
      }
      return a + c + e + c + c;
  }
  return c;
}
function fe(e, r) {
  var a = "";
  var c = M(e);
  for (var n = 0; n < c; n++) a += r(e[n], n, e, r) || "";
  return a;
}
function oe(e, r, a, s) {
  switch (e.type) {
    case i:
    case t:
      return e.return = e.return || e.value;
    case c:
      return "";
    case p:
      return e.return = e.value + "{" + fe(e.children, s) + "}";
    case n:
      e.value = e.props.join(",");
  }
  return O(a = fe(e.children, s)) ? e.return = e.value + "{" + a + "}" : "";
}
function le(e) {
  var r = M(e);
  return function (a, c, n, t) {
    var s = "";
    for (var u = 0; u < r; u++) s += e[u](a, c, n, t) || "";
    return s;
  };
}
function ve(e) {
  return function (r) {
    if (!r.root) if (r = r.return) e(r);
  };
}
function he(c, s, u, i) {
  if (c.length > -1) if (!c.return) switch (c.type) {
    case t:
      c.return = ie(c.value, c.length);
      break;
    case p:
      return fe([J(c, {
        value: j(c.value, "@", "@" + a)
      })], i);
    case n:
      if (c.length) return q(c.props, function (n) {
        switch (y(n, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return fe([J(c, {
              props: [j(n, /:(read-\w+)/, ":" + r + "$1")]
            })], i);
          case "::placeholder":
            return fe([J(c, {
              props: [j(n, /:(plac\w+)/, ":" + a + "input-$1")]
            }), J(c, {
              props: [j(n, /:(plac\w+)/, ":" + r + "$1")]
            }), J(c, {
              props: [j(n, /:(plac\w+)/, e + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;
  while (true) {
    previous = character;
    character = P(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }
    if (T(character)) {
      break;
    }
    N();
  }
  return R(begin, F);
};
var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;
  do {
    switch (T(character)) {
      case 0:
        // &\f
        if (character === 38 && P() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(F - 1, points, index);
        break;
      case 2:
        parsed[index] += W(character);
        break;
      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = P() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += d(character);
    }
  } while (character = N());
  return parsed;
};
var getRules = function getRules(value, points) {
  return V(toRules(U(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11

var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent ||
  // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value,
    parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case

  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */ && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"

  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i$$1 = 0, k$$1 = 0; i$$1 < rules.length; i$$1++) {
    for (var j$$1 = 0; j$$1 < parentRules.length; j$$1++, k$$1++) {
      element.props[k$$1] = points[i$$1] ? rules[i$$1].replace(/&\f/g, parentRules[j$$1]) : parentRules[j$$1] + " " + rules[i$$1];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;
    if (
    // charcode for l
    value.charCodeAt(0) === 108 &&
    // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;
      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }
      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};
var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i$$1 = index - 1; i$$1 >= 0; i$$1--) {
    if (!isImportRule(children[i$$1])) {
      return true;
    }
  }
  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user

var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }
  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};
var isBrowser = typeof document !== 'undefined';
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [he];
var createCache = function createCache(options) {
  var key = options.key;
  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }
  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');
      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i$$1 = 1; i$$1 < attrib.length; i$$1++) {
        inserted[attrib[i$$1]] = true;
      }
      nodesToHydrate.push(node);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }
    }), incorrectImportAlarm);
  }
  if (isBrowser) {
    var currentSheet;
    var finalizingPlugins = [oe, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== c) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : ve(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = le(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
      return fe(ce(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [oe];
    var _serializer = le(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
    var _stylis = function _stylis(styles) {
      return fe(ce(styles), _serializer);
    }; // $FlowFixMe

    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;
      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }
      return serverStylisCache[name];
    };
    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);
      {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }
        if (
        // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }
        return rules;
      }
    };
  }
  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var weakMemoize$1 = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1 = "function" === typeof Symbol && Symbol.for,
  c$1 = b$1 ? Symbol.for("react.element") : 60103,
  d$1 = b$1 ? Symbol.for("react.portal") : 60106,
  e$1 = b$1 ? Symbol.for("react.fragment") : 60107,
  f$1 = b$1 ? Symbol.for("react.strict_mode") : 60108,
  g$1 = b$1 ? Symbol.for("react.profiler") : 60114,
  h$1 = b$1 ? Symbol.for("react.provider") : 60109,
  k$1 = b$1 ? Symbol.for("react.context") : 60110,
  l$1 = b$1 ? Symbol.for("react.async_mode") : 60111,
  m$1 = b$1 ? Symbol.for("react.concurrent_mode") : 60111,
  n$1 = b$1 ? Symbol.for("react.forward_ref") : 60112,
  p$1 = b$1 ? Symbol.for("react.suspense") : 60113,
  q$1 = b$1 ? Symbol.for("react.suspense_list") : 60120,
  r$1 = b$1 ? Symbol.for("react.memo") : 60115,
  t$1 = b$1 ? Symbol.for("react.lazy") : 60116,
  v$1 = b$1 ? Symbol.for("react.block") : 60121,
  w$1 = b$1 ? Symbol.for("react.fundamental") : 60117,
  x$1 = b$1 ? Symbol.for("react.responder") : 60118,
  y$1 = b$1 ? Symbol.for("react.scope") : 60119;
function z$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e$1:
          case g$1:
          case f$1:
          case p$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$1:
              case t$1:
              case r$1:
              case h$1:
                return a;
              default:
                return u;
            }
        }
      case d$1:
        return u;
    }
  }
}
function A$1(a) {
  return z$1(a) === m$1;
}
var AsyncMode = l$1;
var ConcurrentMode = m$1;
var ContextConsumer = k$1;
var ContextProvider = h$1;
var Element$1 = c$1;
var ForwardRef = n$1;
var Fragment$1 = e$1;
var Lazy = t$1;
var Memo = r$1;
var Portal = d$1;
var Profiler = g$1;
var StrictMode = f$1;
var Suspense = p$1;
var isAsyncMode = function isAsyncMode(a) {
  return A$1(a) || z$1(a) === l$1;
};
var isConcurrentMode = A$1;
var isContextConsumer = function isContextConsumer(a) {
  return z$1(a) === k$1;
};
var isContextProvider = function isContextProvider(a) {
  return z$1(a) === h$1;
};
var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1;
};
var isForwardRef = function isForwardRef(a) {
  return z$1(a) === n$1;
};
var isFragment = function isFragment(a) {
  return z$1(a) === e$1;
};
var isLazy = function isLazy(a) {
  return z$1(a) === t$1;
};
var isMemo = function isMemo(a) {
  return z$1(a) === r$1;
};
var isPortal = function isPortal(a) {
  return z$1(a) === d$1;
};
var isProfiler = function isProfiler(a) {
  return z$1(a) === g$1;
};
var isStrictMode = function isStrictMode(a) {
  return z$1(a) === f$1;
};
var isSuspense = function isSuspense(a) {
  return z$1(a) === p$1;
};
var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$1 || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};
var typeOf = z$1;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment$1,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment$$1 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment$$1;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};
  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }
        if (interpolation.styles !== undefined) {
          var next = interpolation.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = interpolation.styles + ";";
          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
        break;
      }
    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }
      break;
  } // finalize string values (regular strings and functions interpolated into css calls)

  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time

  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' +
    // $FlowFixMe we know it's not null
    match[1];
  }
  var name = murmur2(styles) + identifierName;
  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name: name,
    styles: styles,
    next: cursor
  };
};
var isBrowser$2 = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */createContext(
// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);
if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
if (!isBrowser$2) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);
      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}
var ThemeContext = /* #__PURE__ */createContext({});
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var Noop = function Noop() {
  return null;
};
var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }
  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';
  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));
  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }
  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/createElement(Noop, null);
  if (!isBrowser$2 && rules !== undefined) {
    var _ref;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    possiblyStyleElement = /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // Need to return the same number of siblings or else `React.useId` will cause hydration mismatches.

  return /*#__PURE__*/createElement(Fragment, null, possiblyStyleElement, ele);
});
if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}
var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
  }
  module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(_extends_1);
var pkg = {
  name: "@emotion/react",
  version: "11.7.1",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  types: "types/index.d.ts",
  files: ["src", "dist", "jsx-runtime", "jsx-dev-runtime", "_isolated-hnrs", "types/*.d.ts", "macro.js", "macro.d.ts", "macro.js.flow"],
  sideEffects: false,
  author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.13.10",
    "@emotion/cache": "^11.7.1",
    "@emotion/serialize": "^1.0.2",
    "@emotion/sheet": "^1.1.0",
    "@emotion/utils": "^1.0.0",
    "@emotion/weak-memoize": "^0.2.5",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: true
    },
    "@types/react": {
      optional: true
    }
  },
  devDependencies: {
    "@babel/core": "^7.13.10",
    "@emotion/css": "11.7.1",
    "@emotion/css-prettifier": "1.0.1",
    "@emotion/server": "11.4.0",
    "@emotion/styled": "11.6.0",
    "@types/react": "^16.9.11",
    dtslint: "^0.3.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: ["./index.js", "./jsx-runtime.js", "./jsx-dev-runtime.js", "./_isolated-hnrs.js"],
    umdName: "emotionReact"
  }
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && (
  // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }
  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  if (!isBrowser$2) {
    var _ref;
    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }
    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);
    if (shouldCache) {
      return null;
    }
    return /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything

  var sheetRef = useRef();
  useLayoutEffect(function () {
    var key = cache.key + "-global";
    var sheet = new StyleSheet({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }
    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useLayoutEffect(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
      rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }
    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});
if (process.env.NODE_ENV !== 'production') {
  Global.displayName = 'EmotionGlobal';
}
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes = function keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames(args) {
  var len = args.length;
  var i$$1 = 0;
  var cls = '';
  for (; i$$1 < len; i$$1++) {
    var arg = args[i$$1];
    if (arg == null) continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case 'boolean':
        break;
      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }
            toAdd = '';
            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }
          break;
        }
      default:
        {
          toAdd = arg;
        }
    }
    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css(registeredStyles);
}
var Noop$1 = function Noop() {
  return null;
};
var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var rules = '';
  var serializedHashes = '';
  var hasRendered = false;
  var css = function css() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('css can only be used during render');
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    if (isBrowser$2) {
      insertStyles(cache, serialized, false);
    } else {
      var res = insertStyles(cache, serialized, false);
      if (res !== undefined) {
        rules += res;
      }
    }
    if (!isBrowser$2) {
      serializedHashes += " " + serialized.name;
    }
    return cache.key + "-" + serialized.name;
  };
  var cx = function cx() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('cx can only be used during render');
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css, classnames(args));
  };
  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  var possiblyStyleElement = /*#__PURE__*/createElement(Noop$1, null);
  if (!isBrowser$2 && rules.length !== 0) {
    var _ref;
    possiblyStyleElement = /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // Need to return the same number of siblings or else `React.useId` will cause hydration mismatches.

  return /*#__PURE__*/createElement(Fragment, null, possiblyStyleElement, ele);
});
if (process.env.NODE_ENV !== 'production') {
  ClassNames.displayName = 'EmotionClassNames';
}
if (process.env.NODE_ENV !== 'production') {
  var isBrowser$3 = typeof document !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

  var isJest = typeof jest !== 'undefined';
  if (isBrowser$3 && !isJest) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext =
    // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser$3 ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";
    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }
    globalContext[globalKey] = true;
  }
}
function filterProps(props) {
  return Object.keys(props).reduce(function (acc, key) {
    if (props[key] !== void 0) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
}
var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues$3(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols$3(b)),
      _step3;
    try {
      for (_iterator2.s(); !(_step3 = _iterator2.n()).done;) {
        var prop = _step3.value;
        if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return a;
};
var MantineProviderContext = createContext({
  theme: DEFAULT_THEME,
  styles: {},
  classNames: {},
  emotionOptions: {
    key: "mantine",
    prepend: true
  },
  defaultProps: {}
});
function useMantineTheme() {
  var _a;
  return ((_a = useContext(MantineProviderContext)) == null ? void 0 : _a.theme) || DEFAULT_THEME;
}
function useMantineThemeStyles(component) {
  var ctx = useContext(MantineProviderContext);
  return {
    styles: ctx.styles[component] || {},
    classNames: ctx.classNames[component] || {}
  };
}
function useMantineEmotionOptions() {
  var _a;
  return ((_a = useContext(MantineProviderContext)) == null ? void 0 : _a.emotionOptions) || {
    key: "mantine",
    prepend: true
  };
}
function useMantineDefaultProps(component, defaultProps, props) {
  var _a, _b;
  var contextProps = ((_b = (_a = useContext(MantineProviderContext)) == null ? void 0 : _a.defaultProps) == null ? void 0 : _b[component]) || {};
  return __spreadValues$3(__spreadValues$3(__spreadValues$3({}, defaultProps), contextProps), filterProps(props));
}
var ColorSchemeContext = createContext(null);
var elevations = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400
};
function getDefaultZIndex(level) {
  return elevations[level];
}
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4) {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropSymbols$4(source)),
      _step4;
    try {
      for (_iterator3.s(); !(_step4 = _iterator3.n()).done;) {
        var prop = _step4.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return target;
};
function extractSystemStyles(others) {
  var _a = others,
    m = _a.m,
    mx = _a.mx,
    my = _a.my,
    mt = _a.mt,
    mb = _a.mb,
    ml = _a.ml,
    mr = _a.mr,
    p = _a.p,
    px = _a.px,
    py = _a.py,
    pt = _a.pt,
    pb = _a.pb,
    pl = _a.pl,
    pr = _a.pr,
    rest = __objRest(_a, ["m", "mx", "my", "mt", "mb", "ml", "mr", "p", "px", "py", "pt", "pb", "pl", "pr"]);
  var systemStyles = {
    m: m,
    mx: mx,
    my: my,
    mt: mt,
    mb: mb,
    ml: ml,
    mr: mr,
    p: p,
    px: px,
    py: py,
    pt: pt,
    pb: pb,
    pl: pl,
    pr: pr
  };
  Object.keys(systemStyles).forEach(function (key) {
    if (systemStyles[key] === void 0) {
      delete systemStyles[key];
    }
  });
  return {
    systemStyles: systemStyles,
    rest: rest
  };
}
function fromEntries(entries) {
  var o = {};
  Object.keys(entries).forEach(function (key) {
    var _entries$key = _slicedToArray(entries[key], 2),
      k = _entries$key[0],
      v = _entries$key[1];
    o[k] = v;
  });
  return o;
}
function r$2(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r$2(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r$2(e)) && (n && (n += " "), n += t);
  return n;
}

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2$1(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys$1 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize$2(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR$1 = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex$1 = /[A-Z]|^ms/g;
var animationRegex$1 = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty$1 = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue$1 = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName$1 = /* #__PURE__ */memoize$2(function (styleName) {
  return isCustomProperty$1(styleName) ? styleName : styleName.replace(hyphenateRegex$1, '-$&').toLowerCase();
});
var processStyleValue$1 = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex$1, function (match, p1, p2) {
            cursor$1 = {
              name: p1,
              styles: p2,
              next: cursor$1
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys$1[key] !== 1 && !isCustomProperty$1(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern$1 = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues$1 = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue$1 = processStyleValue$1;
  var msPattern$1 = /^-ms-/;
  var hyphenPattern$1 = /-(.)/g;
  var hyphenatedCache$1 = {};
  processStyleValue$1 = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues$1.indexOf(value) === -1 && !contentValuePattern$1.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue$1(key, value);
    if (processed !== '' && !isCustomProperty$1(key) && key.indexOf('-') !== -1 && hyphenatedCache$1[key] === undefined) {
      hyphenatedCache$1[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern$1, 'ms-').replace(hyphenPattern$1, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
function handleInterpolation$1(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor$1 = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor$1
          };
          return interpolation.name;
        }
        if (interpolation.styles !== undefined) {
          var next = interpolation.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor$1 = {
                name: next.name,
                styles: next.styles,
                next: cursor$1
              };
              next = next.next;
            }
          }
          var styles = interpolation.styles + ";";
          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }
          return styles;
        }
        return createStringFromObject$1(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor$1;
          var result = interpolation(mergedProps);
          cursor$1 = previousCursor;
          return handleInterpolation$1(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
        break;
      }
    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex$1, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }
      break;
  } // finalize string values (regular strings and functions interpolated into css calls)

  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}
function createStringFromObject$1(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation$1(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue$1(value)) {
          string += processStyleName$1(_key) + ":" + processStyleValue$1(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue$1(value[_i])) {
              string += processStyleName$1(_key) + ":" + processStyleValue$1(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation$1(mergedProps, registered, value);
          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName$1(_key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR$1);
                }
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern$1 = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern$1;
if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern$1 = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor$1;
var serializeStyles$1 = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor$1 = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation$1(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation$1(mergedProps, registered, args[i]);
    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern$1, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time

  labelPattern$1.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern$1.exec(styles)) !== null) {
    identifierName += '-' +
    // $FlowFixMe we know it's not null
    match[1];
  }
  var name = murmur2$1(styles) + identifierName;
  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor$1,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name: name,
    styles: styles,
    next: cursor$1
  };
};
var isBrowser$4 = typeof document !== 'undefined';
function getRegisteredStyles$1(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles$1 = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$4 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      if (!isBrowser$4 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$4 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};
function useGuaranteedMemo(fn, deps) {
  var ref = useRef();
  if (!ref.current || deps.length !== ref.current.prevDeps.length || ref.current.prevDeps.map(function (v, i) {
    return v === deps[i];
  }).indexOf(false) >= 0) {
    ref.current = {
      v: fn(),
      prevDeps: _toConsumableArray2(deps)
    };
  }
  return ref.current.v;
}
var last$1 = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244

var identifierWithPointTracking$1 = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;
  while (true) {
    previous = character;
    character = P(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }
    if (T(character)) {
      break;
    }
    N();
  }
  return R(begin, F);
};
var toRules$1 = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;
  do {
    switch (T(character)) {
      case 0:
        // &\f
        if (character === 38 && P() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking$1(F - 1, points, index);
        break;
      case 2:
        parsed[index] += W(character);
        break;
      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = P() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += d(character);
    }
  } while (character = N());
  return parsed;
};
var getRules$1 = function getRules(value, points) {
  return V(toRules$1(U(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11

var fixedElements$1 = /* #__PURE__ */new WeakMap();
var compat$1 = function compat(element) {
  if (element.type !== 'rule' || !element.parent ||
  // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value,
    parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case

  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */ && !fixedElements$1.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"

  if (isImplicitRule) {
    return;
  }
  fixedElements$1.set(element, true);
  var points = [];
  var rules = getRules$1(value, points);
  var parentRules = parent.props;
  for (var i$$1 = 0, k$$1 = 0; i$$1 < rules.length; i$$1++) {
    for (var j$$1 = 0; j$$1 < parentRules.length; j$$1++, k$$1++) {
      element.props[k$$1] = points[i$$1] ? rules[i$$1].replace(/&\f/g, parentRules[j$$1]) : parentRules[j$$1] + " " + rules[i$$1];
    }
  }
};
var removeLabel$1 = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;
    if (
    // charcode for l
    value.charCodeAt(0) === 108 &&
    // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag$1 = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var isIgnoringComment$1 = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag$1) > -1;
};
var createUnsafeSelectorsAlarm$1 = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;
      if (prevElement && isIgnoringComment$1(last$1(prevElement.children))) {
        return;
      }
      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};
var isImportRule$1 = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules$1 = function isPrependedWithRegularRules(index, children) {
  for (var i$$1 = index - 1; i$$1 >= 0; i$$1--) {
    if (!isImportRule$1(children[i$$1])) {
      return true;
    }
  }
  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user

var nullifyElement$1 = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};
var incorrectImportAlarm$1 = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule$1(element)) {
    return;
  }
  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement$1(element);
  } else if (isPrependedWithRegularRules$1(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement$1(element);
  }
};
var isBrowser$5 = typeof document !== 'undefined';
var getServerStylisCache$1 = isBrowser$5 ? undefined : weakMemoize$1(function () {
  return memoize$2(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins$1 = [he];
var createCache$1 = function createCache(options) {
  var key = options.key;
  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }
  if (isBrowser$5 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');
      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins$1;
  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }
  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];
  if (isBrowser$5) {
    container = options.container || document.head;
    Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i$$1 = 1; i$$1 < attrib.length; i$$1++) {
        inserted[attrib[i$$1]] = true;
      }
      nodesToHydrate.push(node);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat$1, removeLabel$1];
  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm$1({
      get compat() {
        return cache.compat;
      }
    }), incorrectImportAlarm$1);
  }
  if (isBrowser$5) {
    var currentSheet;
    var finalizingPlugins = [oe, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== c) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : ve(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = le(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
      return fe(ce(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [oe];
    var _serializer = le(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
    var _stylis = function _stylis(styles) {
      return fe(ce(styles), _serializer);
    }; // $FlowFixMe

    var serverStylisCache = getServerStylisCache$1(stylisPlugins)(key);
    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;
      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }
      return serverStylisCache[name];
    };
    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);
      {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }
        if (
        // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }
        return rules;
      }
    };
  }
  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var defaultCacheOptions = {
  key: "mantine",
  prepend: true
};
var _ref15 = function () {
    var cache;
    var _key = defaultCacheOptions.key;
    function _getCache(options) {
      if (cache === void 0 || _key !== (options == null ? void 0 : options.key)) {
        _key = (options == null ? void 0 : options.key) || "mantine";
        cache = createCache$1((options == null ? void 0 : options.key) ? options : defaultCacheOptions);
      }
      return cache;
    }
    return {
      getCache: _getCache
    };
  }(),
  getCache = _ref15.getCache;
function useEmotionCache() {
  var options = useMantineEmotionOptions();
  return getCache(options);
}
var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues$4(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$5.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$5) {
    var _iterator4 = _createForOfIteratorHelper(__getOwnPropSymbols$5(b)),
      _step5;
    try {
      for (_iterator4.s(); !(_step5 = _iterator4.n()).done;) {
        var prop = _step5.value;
        if (__propIsEnum$5.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  return a;
};
var refPropertyName = "ref";
function getRef(args) {
  var ref;
  if (args.length !== 1) {
    return {
      args: args,
      ref: ref
    };
  }
  var _args = _slicedToArray(args, 1),
    arg = _args[0];
  if (!(arg instanceof Object)) {
    return {
      args: args,
      ref: ref
    };
  }
  if (!(refPropertyName in arg)) {
    return {
      args: args,
      ref: ref
    };
  }
  ref = arg[refPropertyName];
  var argCopy = __spreadValues$4({}, arg);
  delete argCopy[refPropertyName];
  return {
    args: [argCopy],
    ref: ref
  };
}
var _ref16 = function () {
    function merge(registered, css, className) {
      var registeredStyles = [];
      var rawClassName = getRegisteredStyles$1(registered, registeredStyles, className);
      if (registeredStyles.length < 2) {
        return className;
      }
      return rawClassName + css(registeredStyles);
    }
    function _cssFactory(params) {
      var cache = params.cache;
      var css = function css() {
        for (var _len5 = arguments.length, styles = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          styles[_key5] = arguments[_key5];
        }
        var _getRef = getRef(styles),
          ref = _getRef.ref,
          args = _getRef.args;
        var serialized = serializeStyles$1(args, cache.registered);
        insertStyles$1(cache, serialized, false);
        return "".concat(cache.key, "-").concat(serialized.name).concat(ref === void 0 ? "" : " ".concat(ref));
      };
      var cx = function cx() {
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }
        return merge(cache.registered, css, clsx(args));
      };
      return {
        css: css,
        cx: cx
      };
    }
    return {
      cssFactory: _cssFactory
    };
  }(),
  cssFactory = _ref16.cssFactory;
function useCss() {
  var cache = useEmotionCache();
  return useGuaranteedMemo(function () {
    return cssFactory({
      cache: cache
    });
  }, [cache]);
}
function mergeClassNames(cx, classes, themeClassNames, classNames, name) {
  return Object.keys(classes).reduce(function (acc, className) {
    acc[className] = cx(classes[className], themeClassNames !== null && themeClassNames[className], classNames != null && classNames[className], name ? "mantine-".concat(name, "-").concat(className) : null);
    return acc;
  }, {});
}
function createStyles(getCssObjectOrCssObject) {
  var getCssObject = typeof getCssObjectOrCssObject === "function" ? getCssObjectOrCssObject : function () {
    return getCssObjectOrCssObject;
  };
  function useStyles(params, options) {
    var theme = useMantineTheme();
    var _useMantineThemeStyle = useMantineThemeStyles(options == null ? void 0 : options.name),
      themeStyles = _useMantineThemeStyle.styles,
      themeClassNames = _useMantineThemeStyle.classNames;
    var _useCss = useCss(),
      css = _useCss.css,
      cx = _useCss.cx;
    function createRef(refName) {
      return "__mantine-ref-".concat(refName || "");
    }
    var cssObject = getCssObject(theme, params, createRef);
    var _styles = typeof (options == null ? void 0 : options.styles) === "function" ? options == null ? void 0 : options.styles(theme) : (options == null ? void 0 : options.styles) || {};
    var _themeStyles = typeof themeStyles === "function" ? themeStyles(theme, params || {}) : themeStyles || {};
    var classes = fromEntries(Object.keys(cssObject).map(function (key) {
      var mergedStyles = cx(css(cssObject[key]), css(_themeStyles[key]), css(_styles[key]));
      return [key, mergedStyles];
    }));
    return {
      classes: mergeClassNames(cx, classes, themeClassNames, options == null ? void 0 : options.classNames, options == null ? void 0 : options.name),
      cx: cx,
      theme: theme
    };
  }
  return useStyles;
}
function Global$1(_ref17) {
  var styles = _ref17.styles;
  var theme = useMantineTheme();
  return /* @__PURE__ */React__default.createElement(Global, {
    styles: css$2(typeof styles === "function" ? styles(theme) : styles)
  });
}
var __defProp$5 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues$5(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$6.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$6) {
    var _iterator5 = _createForOfIteratorHelper(__getOwnPropSymbols$6(b)),
      _step6;
    try {
      for (_iterator5.s(); !(_step6 = _iterator5.n()).done;) {
        var prop = _step6.value;
        if (__propIsEnum$6.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  return a;
};
var __spreadProps$3 = function __spreadProps$3(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
var popIn = {
  in: {
    opacity: 1,
    transform: "scale(1)"
  },
  out: {
    opacity: 0,
    transform: "scale(.9) translateY(10px)"
  },
  transitionProperty: "transform, opacity"
};
var transitions = {
  fade: {
    in: {
      opacity: 1
    },
    out: {
      opacity: 0
    },
    transitionProperty: "opacity"
  },
  scale: {
    in: {
      opacity: 1,
      transform: "scale(1)"
    },
    out: {
      opacity: 0,
      transform: "scale(0)"
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    in: {
      opacity: 1,
      transform: "scaleY(1)"
    },
    out: {
      opacity: 0,
      transform: "scaleY(0)"
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    in: {
      opacity: 1,
      transform: "scaleX(1)"
    },
    out: {
      opacity: 0,
      transform: "scaleX(0)"
    },
    common: {
      transformOrigin: "left"
    },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    in: {
      opacity: 1,
      transform: "translateY(0) skew(0deg, 0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(-20px) skew(-10deg, -5deg)"
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    in: {
      opacity: 1,
      transform: "translateY(0) skew(0deg, 0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(20px) skew(-10deg, -5deg)"
    },
    common: {
      transformOrigin: "bottom"
    },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    in: {
      opacity: 1,
      transform: "translateY(0) rotate(0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(20px) rotate(-5deg)"
    },
    common: {
      transformOrigin: "bottom"
    },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    in: {
      opacity: 1,
      transform: "translateY(0) rotate(0deg)"
    },
    out: {
      opacity: 0,
      transform: "translateY(20px) rotate(5deg)"
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    in: {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(-100%)"
    },
    common: {
      transformOrigin: "top"
    },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    in: {
      opacity: 1,
      transform: "translateY(0)"
    },
    out: {
      opacity: 0,
      transform: "translateY(100%)"
    },
    common: {
      transformOrigin: "bottom"
    },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    in: {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(100%)"
    },
    common: {
      transformOrigin: "left"
    },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    in: {
      opacity: 1,
      transform: "translateX(0)"
    },
    out: {
      opacity: 0,
      transform: "translateX(-100%)"
    },
    common: {
      transformOrigin: "right"
    },
    transitionProperty: "transform, opacity"
  },
  pop: __spreadProps$3(__spreadValues$5({}, popIn), {
    common: {
      transformOrigin: "center center"
    }
  }),
  "pop-bottom-left": __spreadProps$3(__spreadValues$5({}, popIn), {
    common: {
      transformOrigin: "bottom left"
    }
  }),
  "pop-bottom-right": __spreadProps$3(__spreadValues$5({}, popIn), {
    common: {
      transformOrigin: "bottom right"
    }
  }),
  "pop-top-left": __spreadProps$3(__spreadValues$5({}, popIn), {
    common: {
      transformOrigin: "top left"
    }
  }),
  "pop-top-right": __spreadProps$3(__spreadValues$5({}, popIn), {
    common: {
      transformOrigin: "top right"
    }
  })
};
function filterChildrenByType(children, type) {
  return Children.toArray(children).filter(function (item) {
    return Array.isArray(type) ? type.some(function (component) {
      return component === item.type;
    }) : item.type === type;
  });
}
function findChildByType(children, type) {
  return Children.toArray(children).find(function (item) {
    return item.type === type;
  });
}
function filterFalsyChildren(children) {
  return Children.toArray(children).filter(Boolean);
}
function groupOptions(_ref18) {
  var data = _ref18.data;
  var sortedData = [];
  var unGroupedData = [];
  var groupedData = data.reduce(function (acc, item, index) {
    if (item.group) {
      if (acc[item.group]) acc[item.group].push(index);else acc[item.group] = [index];
    } else {
      unGroupedData.push(index);
    }
    return acc;
  }, {});
  Object.keys(groupedData).forEach(function (groupName) {
    sortedData.push.apply(sortedData, _toConsumableArray2(groupedData[groupName].map(function (index) {
      return data[index];
    })));
  });
  sortedData.push.apply(sortedData, _toConsumableArray2(unGroupedData.map(function (itemIndex) {
    return data[itemIndex];
  })));
  return sortedData;
}
function findAncestor(element, className) {
  var _element = element;
  while ((_element = _element.parentElement) && !_element.classList.contains(className));
  return _element;
}
function getContextItemIndex(options, node) {
  if (!node) {
    return -1;
  }
  return Array.from(findAncestor(node, options.parentClassName).querySelectorAll(options.elementSelector)).findIndex(function (element) {
    return element === node;
  });
}
function createUseContext(defaultValue) {
  var Context = createContext(defaultValue);
  function useContextConsumer(component) {
    var ctx = useContext(Context);
    var _component$split = component.split("."),
      _component$split2 = _slicedToArray(_component$split, 1),
      parentName = _component$split2[0];
    if (!ctx) {
      throw new Error("".concat(component, " component was rendered outside of ").concat(parentName, " component context"));
    }
    return ctx;
  }
  return [Context.Provider, useContextConsumer];
}
var getInputMode = function getInputMode(step, precision, os) {
  if (Number.isInteger(step) && step >= 0 && precision === 0) return "numeric";
  if (!Number.isInteger(step) && step >= 0 && precision !== 0) return "decimal";
  if (Number.isInteger(step) && step < 0 && precision === 0) {
    if (os === "ios") return "text";
    return "decimal";
  }
  if (!Number.isInteger(step) && step < 0 && precision !== 0) {
    if (os === "ios") return "text";
    return "decimal";
  }
  return "numeric";
};
var DEFAULT_EVENTS = ["mousedown", "touchstart"];
function useClickOutside(handler, events, nodes) {
  var ref = useRef();
  useEffect(function () {
    var listener = function listener(event) {
      var _a;
      if (Array.isArray(nodes)) {
        var shouldIgnore = (_a = event == null ? void 0 : event.target) == null ? void 0 : _a.hasAttribute("data-ignore-outside-clicks");
        var shouldTrigger = nodes.every(function (node) {
          return !!node && !node.contains(event.target);
        });
        shouldTrigger && !shouldIgnore && handler();
      } else if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };
    (events || DEFAULT_EVENTS).forEach(function (fn) {
      return document.addEventListener(fn, listener);
    });
    return function () {
      (events || DEFAULT_EVENTS).forEach(function (fn) {
        return document.removeEventListener(fn, listener);
      });
    };
  }, [ref, handler, nodes]);
  return ref;
}
function attachMediaListener(query, callback) {
  try {
    query.addEventListener("change", callback);
    return function () {
      return query.removeEventListener("change", callback);
    };
  } catch (e) {
    query.addListener(callback);
    return function () {
      return query.removeListener(callback);
    };
  }
}
function getInitialValue(query, initialValue) {
  if (initialValue !== void 0) {
    return initialValue;
  }
  if (typeof window !== "undefined" && "matchMedia" in window) {
    return window.matchMedia(query).matches;
  }
  return false;
}
function useMediaQuery(query, initialValue) {
  var _useState = useState(getInitialValue(query, initialValue)),
    _useState2 = _slicedToArray(_useState, 2),
    matches = _useState2[0],
    setMatches = _useState2[1];
  var queryRef = useRef();
  useEffect(function () {
    if ("matchMedia" in window) {
      queryRef.current = window.matchMedia(query);
      setMatches(queryRef.current.matches);
      return attachMediaListener(queryRef.current, function (event) {
        return setMatches(event.matches);
      });
    }
    return void 0;
  }, [query]);
  return matches;
}
var useIsomorphicEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function useDidUpdate(fn, dependencies) {
  var mounted = useRef(false);
  useEffect(function () {
    if (mounted.current) {
      fn();
    } else {
      mounted.current = true;
    }
  }, dependencies);
}
function useFocusReturn(_ref19) {
  var opened = _ref19.opened,
    transitionDuration = _ref19.transitionDuration,
    _ref19$shouldReturnFo = _ref19.shouldReturnFocus,
    shouldReturnFocus = _ref19$shouldReturnFo === void 0 ? true : _ref19$shouldReturnFo;
  var lastActiveElement = useRef();
  var returnFocus = function returnFocus() {
    var _a;
    if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") {
      (_a = lastActiveElement.current) == null ? void 0 : _a.focus();
    }
  };
  useDidUpdate(function () {
    var timeout = -1;
    var clearFocusTimeout = function clearFocusTimeout(event) {
      if (event.code === "Tab") {
        window.clearTimeout(timeout);
      }
    };
    document.addEventListener("keydown", clearFocusTimeout);
    if (opened) {
      lastActiveElement.current = document.activeElement;
    } else if (shouldReturnFocus) {
      timeout = window.setTimeout(returnFocus, transitionDuration + 10);
    }
    return function () {
      window.clearTimeout(timeout);
      document.removeEventListener("keydown", clearFocusTimeout);
    };
  }, [opened]);
  return returnFocus;
}
var TABBABLE_NODES = /input|select|textarea|button|object/;
var FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function hidden(element) {
  if (process.env.NODE_ENV === "test") {
    return false;
  }
  return element.style.display === "none";
}
function visible(element) {
  var isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
  if (isHidden) {
    return false;
  }
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) {
      break;
    }
    if (hidden(parentElement)) {
      return false;
    }
    parentElement = parentElement.parentNode;
  }
  return true;
}
function getElementTabIndex(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) {
    tabIndex = void 0;
  }
  return parseInt(tabIndex, 10);
}
function focusable(element) {
  var nodeName = element.nodeName.toLowerCase();
  var isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
  var res = TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}
function tabbable(element) {
  var tabIndex = getElementTabIndex(element);
  var isTabIndexNaN = Number.isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
  return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}
function scopeTab(node, event) {
  var tabbable$$1 = findTabbableDescendants(node);
  if (!tabbable$$1.length) {
    event.preventDefault();
    return;
  }
  var finalTabbable = tabbable$$1[event.shiftKey ? 0 : tabbable$$1.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement || node === document.activeElement;
  if (!leavingFinalTabbable) {
    return;
  }
  event.preventDefault();
  var target = tabbable$$1[event.shiftKey ? tabbable$$1.length - 1 : 0];
  if (target) {
    target.focus();
  }
}
function createAriaHider(containerNode) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "body > :not(script)";
  var rootNodes = Array.from(document.querySelectorAll(selector)).map(function (node) {
    if (node.contains(containerNode)) {
      return void 0;
    }
    var ariaHidden = node.getAttribute("aria-hidden");
    if (ariaHidden === null || ariaHidden === "false") {
      node.setAttribute("aria-hidden", "true");
    }
    return {
      node: node,
      ariaHidden: ariaHidden
    };
  });
  return function () {
    rootNodes.forEach(function (item) {
      if (!item) {
        return;
      }
      if (item.ariaHidden === null) {
        item.node.removeAttribute("aria-hidden");
      } else {
        item.node.setAttribute("aria-hidden", item.ariaHidden);
      }
    });
  };
}
function useFocusTrap() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var ref = useRef();
  var restoreAria = useRef(null);
  var setRef = useCallback(function (node) {
    if (!active) {
      return;
    }
    if (restoreAria.current) {
      restoreAria.current();
    }
    if (node) {
      var processNode = function processNode(_node) {
        restoreAria.current = createAriaHider(_node);
        var focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
          var children = Array.from(node.querySelectorAll(FOCUS_SELECTOR));
          focusElement = children.find(tabbable) || children.find(focusable) || null;
          if (!focusElement && focusable(node)) focusElement = node;
        }
        if (focusElement) {
          focusElement.focus();
        } else if (process.env.NODE_ENV === "development") {
          console.warn("[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node", node);
        }
      };
      setTimeout(function () {
        if (node.ownerDocument) {
          processNode(node);
        } else if (process.env.NODE_ENV === "development") {
          console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", node);
        }
      });
      ref.current = node;
    } else {
      ref.current = null;
    }
  }, [active]);
  useEffect(function () {
    if (!active) {
      return void 0;
    }
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === "Tab" && ref.current) {
        scopeTab(ref.current, event);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [active]);
  return setRef;
}
function randomId() {
  return "mantine-".concat(Math.random().toString(36).slice(2, 11));
}
function useWindowEvent(type, listener, options) {
  useEffect(function () {
    window.addEventListener(type, listener, options);
    return function () {
      return window.removeEventListener(type, listener, options);
    };
  }, []);
}
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (typeof ref === "object" && ref !== null && "current" in ref) {
    ref.current = value;
  }
}
function useMergedRef() {
  for (var _len7 = arguments.length, refs = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    refs[_key7] = arguments[_key7];
  }
  return useCallback(function (node) {
    refs.forEach(function (ref) {
      return assignRef(ref, node);
    });
  }, refs);
}
function mergeRefs() {
  for (var _len8 = arguments.length, refs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    refs[_key8] = arguments[_key8];
  }
  return function (node) {
    refs.forEach(function (ref) {
      return assignRef(ref, node);
    });
  };
}
var __defProp$9 = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = function __defNormalProp$9(obj, key, value) {
  return key in obj ? __defProp$9(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$9 = function __spreadValues$9(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$a.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$a) {
    var _iterator6 = _createForOfIteratorHelper(__getOwnPropSymbols$a(b)),
      _step7;
    try {
      for (_iterator6.s(); !(_step7 = _iterator6.n()).done;) {
        var prop = _step7.value;
        if (__propIsEnum$a.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
  return a;
};
function useMouse() {
  var _useState3 = useState({
      x: 0,
      y: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    position = _useState4[0],
    setPosition = _useState4[1];
  var ref = useRef();
  var setMousePosition = function setMousePosition(event) {
    if (ref.current) {
      var rect = event.currentTarget.getBoundingClientRect();
      var _x2 = Math.max(0, Math.round(event.pageX - rect.left - (window.pageXOffset || window.scrollX)));
      var _y = Math.max(0, Math.round(event.pageY - rect.top - (window.pageYOffset || window.scrollY)));
      setPosition({
        x: _x2,
        y: _y
      });
    } else {
      setPosition({
        x: event.clientX,
        y: event.clientY
      });
    }
  };
  useEffect(function () {
    var element = (ref == null ? void 0 : ref.current) ? ref.current : document;
    element.addEventListener("mousemove", setMousePosition);
    return function () {
      return element.removeEventListener("mousemove", setMousePosition);
    };
  }, [ref.current]);
  return __spreadValues$9({
    ref: ref
  }, position);
}
function clamp(_ref20) {
  var value = _ref20.value,
    min = _ref20.min,
    max = _ref20.max;
  return Math.min(Math.max(value, min), max);
}
var clampUseMovePosition = function clampUseMovePosition(position) {
  return {
    x: clamp({
      min: 0,
      max: 1,
      value: position.x
    }),
    y: clamp({
      min: 0,
      max: 1,
      value: position.y
    })
  };
};
function useMove(onChange, handlers) {
  var dir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ltr";
  var ref = useRef();
  var mounted = useRef(false);
  var isSliding = useRef(false);
  var frame = useRef(0);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    active = _useState6[0],
    setActive = _useState6[1];
  useEffect(function () {
    mounted.current = true;
  }, []);
  useEffect(function () {
    var onScrub = function onScrub(_ref21) {
      var x = _ref21.x,
        y = _ref21.y;
      cancelAnimationFrame(frame.current);
      frame.current = requestAnimationFrame(function () {
        if (mounted.current && ref.current) {
          ref.current.style.userSelect = "none";
          var rect = ref.current.getBoundingClientRect();
          if (rect.width && rect.height) {
            var _x = clamp({
              value: (x - rect.left) / rect.width,
              min: 0,
              max: 1
            });
            onChange({
              x: dir === "ltr" ? _x : 1 - _x,
              y: clamp({
                value: (y - rect.top) / rect.height,
                min: 0,
                max: 1
              })
            });
          }
        }
      });
    };
    var bindEvents = function bindEvents() {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", stopScrubbing);
      document.addEventListener("touchmove", onTouchMove);
      document.addEventListener("touchend", stopScrubbing);
    };
    var unbindEvents = function unbindEvents() {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", stopScrubbing);
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", stopScrubbing);
    };
    var startScrubbing = function startScrubbing() {
      if (!isSliding.current && mounted.current) {
        isSliding.current = true;
        typeof (handlers == null ? void 0 : handlers.onScrubStart) === "function" && handlers.onScrubStart();
        setActive(true);
        bindEvents();
      }
    };
    var stopScrubbing = function stopScrubbing() {
      if (isSliding.current && mounted.current) {
        isSliding.current = false;
        setActive(false);
        unbindEvents();
        setTimeout(function () {
          typeof (handlers == null ? void 0 : handlers.onScrubEnd) === "function" && handlers.onScrubEnd();
        }, 0);
      }
    };
    var onMouseDown = function onMouseDown(event) {
      startScrubbing();
      onMouseMove(event);
    };
    var onMouseMove = function onMouseMove(event) {
      return onScrub({
        x: event.clientX,
        y: event.clientY
      });
    };
    var onTouchStart = function onTouchStart(event) {
      startScrubbing();
      event == null ? void 0 : event.preventDefault();
      onTouchMove(event);
    };
    var onTouchMove = function onTouchMove(event) {
      event == null ? void 0 : event.preventDefault();
      onScrub({
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
      });
    };
    ref.current.addEventListener("mousedown", onMouseDown);
    ref.current.addEventListener("touchstart", onTouchStart, {
      passive: false
    });
    return function () {
      if (ref.current) {
        ref.current.removeEventListener("mousedown", onMouseDown);
        ref.current.removeEventListener("touchstart", onTouchStart);
      }
    };
  }, [dir, onChange]);
  return {
    ref: ref,
    active: active
  };
}
function useUncontrolled(_ref22) {
  var value = _ref22.value,
    defaultValue = _ref22.defaultValue,
    finalValue = _ref22.finalValue,
    rule = _ref22.rule,
    onChange = _ref22.onChange,
    onValueUpdate = _ref22.onValueUpdate;
  var shouldBeControlled = rule(value);
  var modeRef = useRef("initial");
  var initialValue = rule(defaultValue) ? defaultValue : finalValue;
  var _useState7 = useState(initialValue),
    _useState8 = _slicedToArray(_useState7, 2),
    uncontrolledValue = _useState8[0],
    setUncontrolledValue = _useState8[1];
  var effectiveValue = shouldBeControlled ? value : uncontrolledValue;
  if (!shouldBeControlled && modeRef.current === "controlled") {
    effectiveValue = finalValue;
  }
  modeRef.current = shouldBeControlled ? "controlled" : "uncontrolled";
  var mode = modeRef.current;
  var handleChange = function handleChange(nextValue) {
    typeof onChange === "function" && onChange(nextValue);
    if (mode === "uncontrolled") {
      setUncontrolledValue(nextValue);
    }
  };
  useEffect(function () {
    if (mode === "uncontrolled") {
      setUncontrolledValue(effectiveValue);
    }
    typeof onValueUpdate === "function" && onValueUpdate(effectiveValue);
  }, [mode, effectiveValue]);
  return [effectiveValue, handleChange, modeRef.current];
}
function range(start, end) {
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (_, index) {
    return index + start;
  });
}
var DOTS = "dots";
function usePagination(_ref23) {
  var total = _ref23.total,
    _ref23$siblings = _ref23.siblings,
    siblings = _ref23$siblings === void 0 ? 1 : _ref23$siblings,
    _ref23$boundaries = _ref23.boundaries,
    boundaries = _ref23$boundaries === void 0 ? 1 : _ref23$boundaries,
    page = _ref23.page,
    _ref23$initialPage = _ref23.initialPage,
    initialPage = _ref23$initialPage === void 0 ? 1 : _ref23$initialPage,
    onChange = _ref23.onChange;
  var _useUncontrolled = useUncontrolled({
      value: page,
      onChange: onChange,
      defaultValue: initialPage,
      finalValue: initialPage,
      rule: function rule(_page) {
        return typeof _page === "number" && _page <= total;
      }
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    activePage = _useUncontrolled2[0],
    setActivePage = _useUncontrolled2[1];
  var setPage = function setPage(pageNumber) {
    if (pageNumber <= 0) {
      setActivePage(1);
    } else if (pageNumber > total) {
      setActivePage(total);
    } else {
      setActivePage(pageNumber);
    }
  };
  var next = function next() {
    return setPage(activePage + 1);
  };
  var previous = function previous() {
    return setPage(activePage - 1);
  };
  var first = function first() {
    return setPage(1);
  };
  var last = function last() {
    return setPage(total);
  };
  var paginationRange = useMemo(function () {
    var totalPageNumbers = siblings * 2 + 3 + boundaries * 2;
    if (totalPageNumbers >= total) {
      return range(1, total);
    }
    var leftSiblingIndex = Math.max(activePage - siblings, boundaries);
    var rightSiblingIndex = Math.min(activePage + siblings, total - boundaries);
    var shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
    var shouldShowRightDots = rightSiblingIndex < total - (boundaries + 1);
    if (!shouldShowLeftDots && shouldShowRightDots) {
      var leftItemCount = siblings * 2 + boundaries + 2;
      return [].concat(_toConsumableArray2(range(1, leftItemCount)), [DOTS], _toConsumableArray2(range(total - (boundaries - 1), total)));
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
      var rightItemCount = boundaries + 1 + 2 * siblings;
      return [].concat(_toConsumableArray2(range(1, boundaries)), [DOTS], _toConsumableArray2(range(total - rightItemCount, total)));
    }
    return [].concat(_toConsumableArray2(range(1, boundaries)), [DOTS], _toConsumableArray2(range(leftSiblingIndex, rightSiblingIndex)), [DOTS], _toConsumableArray2(range(total - boundaries + 1, total)));
  }, [total, siblings, activePage]);
  return {
    range: paginationRange,
    active: activePage,
    setPage: setPage,
    next: next,
    previous: previous,
    first: first,
    last: last
  };
}
function useReducedMotion(initialValue) {
  return useMediaQuery("(prefers-reduced-motion: reduce)", initialValue);
}
var easeInOutQuad = function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
var getRelativePosition = function getRelativePosition(_ref24) {
  var axis = _ref24.axis,
    target = _ref24.target,
    parent = _ref24.parent,
    alignment = _ref24.alignment,
    offset = _ref24.offset,
    isList = _ref24.isList;
  if (!target || !parent && typeof document === "undefined") {
    return 0;
  }
  var isCustomParent = !!parent;
  var parentElement = parent || document.body;
  var parentPosition = parentElement.getBoundingClientRect();
  var targetPosition = target.getBoundingClientRect();
  var getDiff = function getDiff(property) {
    return targetPosition[property] - parentPosition[property];
  };
  if (axis === "y") {
    var diff = getDiff("top");
    if (diff === 0) return 0;
    if (alignment === "start") {
      var distance = diff - offset;
      var shouldScroll = distance <= targetPosition.height * (isList ? 0 : 1) || !isList;
      return shouldScroll ? distance : 0;
    }
    var parentHeight = isCustomParent ? parentPosition.height : window.innerHeight;
    if (alignment === "end") {
      var _distance = diff + offset - parentHeight + targetPosition.height;
      var _shouldScroll = _distance >= -targetPosition.height * (isList ? 0 : 1) || !isList;
      return _shouldScroll ? _distance : 0;
    }
    if (alignment === "center") {
      return diff - parentHeight / 2 + targetPosition.height / 2;
    }
    return 0;
  }
  if (axis === "x") {
    var _diff = getDiff("left");
    if (_diff === 0) return 0;
    if (alignment === "start") {
      var _distance2 = _diff - offset;
      var _shouldScroll2 = _distance2 <= targetPosition.width || !isList;
      return _shouldScroll2 ? _distance2 : 0;
    }
    var parentWidth = isCustomParent ? parentPosition.width : window.innerWidth;
    if (alignment === "end") {
      var _distance3 = _diff + offset - parentWidth + targetPosition.width;
      var _shouldScroll3 = _distance3 >= -targetPosition.width || !isList;
      return _shouldScroll3 ? _distance3 : 0;
    }
    if (alignment === "center") {
      return _diff - parentWidth / 2 + targetPosition.width / 2;
    }
    return 0;
  }
  return 0;
};
var getScrollStart = function getScrollStart(_ref25) {
  var axis = _ref25.axis,
    parent = _ref25.parent;
  if (!parent && typeof document === "undefined") {
    return 0;
  }
  var method = axis === "y" ? "scrollTop" : "scrollLeft";
  if (parent) {
    return parent[method];
  }
  var _document = document,
    body = _document.body,
    documentElement = _document.documentElement;
  return body[method] + documentElement[method];
};
var setScrollParam = function setScrollParam(_ref26) {
  var axis = _ref26.axis,
    parent = _ref26.parent,
    distance = _ref26.distance;
  if (!parent && typeof document === "undefined") {
    return;
  }
  var method = axis === "y" ? "scrollTop" : "scrollLeft";
  if (parent) {
    parent[method] = distance;
  } else {
    var _document2 = document,
      body = _document2.body,
      documentElement = _document2.documentElement;
    body[method] = distance;
    documentElement[method] = distance;
  }
};
function useScrollIntoView() {
  var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref27$duration = _ref27.duration,
    duration = _ref27$duration === void 0 ? 1250 : _ref27$duration,
    _ref27$axis = _ref27.axis,
    axis = _ref27$axis === void 0 ? "y" : _ref27$axis,
    onScrollFinish = _ref27.onScrollFinish,
    _ref27$easing = _ref27.easing,
    easing = _ref27$easing === void 0 ? easeInOutQuad : _ref27$easing,
    _ref27$offset = _ref27.offset,
    offset = _ref27$offset === void 0 ? 0 : _ref27$offset,
    _ref27$cancelable = _ref27.cancelable,
    cancelable = _ref27$cancelable === void 0 ? true : _ref27$cancelable,
    _ref27$isList = _ref27.isList,
    isList = _ref27$isList === void 0 ? false : _ref27$isList;
  var frameID = useRef(0);
  var startTime = useRef(0);
  var shouldStop = useRef(false);
  var scrollableRef = useRef(null);
  var targetRef = useRef(null);
  var reducedMotion = useReducedMotion();
  var cancel = function cancel() {
    if (frameID.current) {
      cancelAnimationFrame(frameID.current);
    }
  };
  var scrollIntoView = useCallback(function () {
    var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref28$alignment = _ref28.alignment,
      alignment = _ref28$alignment === void 0 ? "start" : _ref28$alignment;
    var _a;
    shouldStop.current = false;
    if (frameID.current) {
      cancel();
    }
    var start = (_a = getScrollStart({
      parent: scrollableRef.current,
      axis: axis
    })) != null ? _a : 0;
    var change = getRelativePosition({
      parent: scrollableRef.current,
      target: targetRef.current,
      axis: axis,
      alignment: alignment,
      offset: offset,
      isList: isList
    }) - (scrollableRef.current ? 0 : start);
    function animateScroll() {
      if (startTime.current === 0) {
        startTime.current = performance.now();
      }
      var now = performance.now();
      var elapsed = now - startTime.current;
      var t = reducedMotion || duration === 0 ? 1 : elapsed / duration;
      var distance = start + change * easing(t);
      setScrollParam({
        parent: scrollableRef.current,
        axis: axis,
        distance: distance
      });
      if (!shouldStop.current && t < 1) {
        frameID.current = requestAnimationFrame(animateScroll);
      } else {
        typeof onScrollFinish === "function" && onScrollFinish();
        startTime.current = 0;
        frameID.current = 0;
        cancel();
      }
    }
    animateScroll();
  }, [scrollableRef.current]);
  var handleStop = function handleStop() {
    if (cancelable) {
      shouldStop.current = true;
    }
  };
  useWindowEvent("wheel", handleStop, {
    passive: true
  });
  useWindowEvent("touchmove", handleStop, {
    passive: true
  });
  useEffect(function () {
    return cancel;
  }, []);
  return {
    scrollableRef: scrollableRef,
    targetRef: targetRef,
    scrollIntoView: scrollIntoView,
    cancel: cancel
  };
}
var defaultState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
var browser = typeof window !== "undefined";
function useResizeObserver() {
  var frameID = useRef(0);
  var ref = useRef(null);
  var _useState9 = useState(defaultState),
    _useState10 = _slicedToArray(_useState9, 2),
    rect = _useState10[0],
    setRect = _useState10[1];
  var observer = useMemo(function () {
    return browser ? new ResizeObserver(function (entries) {
      var entry = entries[0];
      if (entry) {
        cancelAnimationFrame(frameID.current);
        frameID.current = requestAnimationFrame(function () {
          if (ref.current) {
            setRect(entry.contentRect);
          }
        });
      }
    }) : null;
  }, []);
  useEffect(function () {
    if (ref.current) {
      observer.observe(ref.current);
    }
    return function () {
      observer.disconnect();
      if (frameID.current) {
        cancelAnimationFrame(frameID.current);
      }
    };
  }, [ref.current]);
  return [ref, rect];
}
function getScrollWidth() {
  if (typeof window === "undefined" || typeof document === "undefined") return 0;
  var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
  var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  return paddingRight + scrollbarWidth;
}
var getLockStyles = function getLockStyles(_ref29) {
  var disableBodyPadding = _ref29.disableBodyPadding;
  var scrollWidth = disableBodyPadding ? null : getScrollWidth();
  var styles = "body {\n        --removed-scroll-width: ".concat(scrollWidth, "px;\n        touch-action: none;\n        overflow: hidden !important;\n        position: relative !important;\n        ").concat(scrollWidth ? "padding-right: var(--removed-scroll-width) !important;" : "", "\n        ");
  return styles;
};
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
function makeStyleTag() {
  var tag = document.createElement("style");
  tag.type = "text/css";
  tag.setAttribute("mantine-scroll-lock", "");
  return tag;
}
function useScrollLock(lock) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    disableBodyPadding: false
  };
  var _useState11 = useState(lock || false),
    _useState12 = _slicedToArray(_useState11, 2),
    scrollLocked = _useState12[0],
    setScrollLocked = _useState12[1];
  var scrollTop = useRef(0);
  var disableBodyPadding = options.disableBodyPadding;
  var stylesheet = useRef(null);
  var lockScroll = function lockScroll() {
    scrollTop.current = window.scrollY;
    var styles = getLockStyles({
      disableBodyPadding: disableBodyPadding
    });
    var sheet = makeStyleTag();
    injectStyles(sheet, styles);
    insertStyleTag(sheet);
    stylesheet.current = sheet;
  };
  var unlockScroll = function unlockScroll() {
    if (!(stylesheet == null ? void 0 : stylesheet.current)) return;
    stylesheet.current.parentNode.removeChild(stylesheet.current);
    stylesheet.current = null;
  };
  useEffect(function () {
    if (scrollLocked) {
      lockScroll();
    } else {
      unlockScroll();
    }
    return unlockScroll;
  }, [scrollLocked]);
  useEffect(function () {
    if (lock !== void 0) {
      setScrollLocked(lock);
    }
  }, [lock]);
  useEffect(function () {
    if (lock === void 0 && typeof window !== "undefined") {
      window.document.body.style.overflow === "hidden" && setScrollLocked(true);
    }
  }, [setScrollLocked]);
  return [scrollLocked, setScrollLocked];
}
function useToggle(initialValue, options) {
  var _useState13 = useState(initialValue),
    _useState14 = _slicedToArray(_useState13, 2),
    state = _useState14[0],
    setState = _useState14[1];
  var toggle = function toggle(value) {
    if (typeof value !== "undefined") {
      setState(value);
    } else {
      setState(function (current) {
        if (current === options[0]) {
          return options[1];
        }
        return options[0];
      });
    }
  };
  return [state, toggle];
}
function useBooleanToggle() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return useToggle(initialValue, [true, false]);
}
function useUuid(staticId) {
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    uuid = _useState16[0],
    setUuid = _useState16[1];
  useIsomorphicEffect(function () {
    setUuid(randomId());
  }, []);
  return staticId || uuid;
}
function getOS() {
  var userAgent = window.navigator.userAgent;
  var macosPlatforms = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i;
  var windowsPlatforms = /(Win32)|(Win64)|(Windows)|(WinCE)/i;
  var iosPlatforms = /(iPhone)|(iPad)|(iPod)/i;
  if (macosPlatforms.test(userAgent)) {
    return "macos";
  }
  if (iosPlatforms.test(userAgent)) {
    return "ios";
  }
  if (windowsPlatforms.test(userAgent)) {
    return "windows";
  }
  if (/Android/i.test(userAgent)) {
    return "android";
  }
  if (/Linux/i.test(userAgent)) {
    return "linux";
  }
  return "undetermined";
}
function useOs() {
  if (typeof window !== "undefined") {
    return getOS();
  }
  return "undetermined";
}
function upperFirst(value) {
  return typeof value !== "string" ? "" : value.charAt(0).toUpperCase() + value.slice(1);
}
var __defProp$d = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = function __defNormalProp$d(obj, key, value) {
  return key in obj ? __defProp$d(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$d = function __spreadValues$d(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$e.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$e) {
    var _iterator7 = _createForOfIteratorHelper(__getOwnPropSymbols$e(b)),
      _step8;
    try {
      for (_iterator7.s(); !(_step8 = _iterator7.n()).done;) {
        var prop = _step8.value;
        if (__propIsEnum$e.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }
  return a;
};
var __spreadProps$7 = function __spreadProps$7(a, b) {
  return __defProps$7(a, __getOwnPropDescs$7(b));
};
function createAccordionState(length) {
  var initialItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  return Array.from({
    length: length
  }).reduce(function (acc, _item, index) {
    acc[index] = index === initialItem;
    return acc;
  }, {});
}
function useAccordionState(_ref30) {
  var initialState = _ref30.initialState,
    total = _ref30.total,
    _ref30$initialItem = _ref30.initialItem,
    initialItem = _ref30$initialItem === void 0 ? -1 : _ref30$initialItem,
    state = _ref30.state,
    onChange = _ref30.onChange,
    _ref30$multiple = _ref30.multiple,
    multiple = _ref30$multiple === void 0 ? false : _ref30$multiple;
  var _useUncontrolled3 = useUncontrolled({
      value: state,
      defaultValue: initialState || createAccordionState(total, initialItem),
      finalValue: {},
      onChange: onChange,
      rule: function rule(val) {
        return val !== null && typeof val === "object";
      }
    }),
    _useUncontrolled4 = _slicedToArray(_useUncontrolled3, 2),
    value = _useUncontrolled4[0],
    setState = _useUncontrolled4[1];
  var toggle = function toggle(index) {
    if (multiple) {
      setState(__spreadProps$7(__spreadValues$d({}, value), _defineProperty({}, index, !value[index])));
    } else {
      var newValues = Array(total).fill(0).reduce(function (acc, _, itemIndex) {
        acc[itemIndex] = false;
        return acc;
      }, {});
      newValues[index] = !value[index];
      setState(newValues);
    }
  };
  useDidUpdate(function () {
    if (!multiple) {
      setState(createAccordionState(total));
    }
  }, [multiple]);
  return [value, {
    toggle: toggle,
    setState: setState
  }];
}
var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = function __defNormalProp$e(obj, key, value) {
  return key in obj ? __defProp$e(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$e = function __spreadValues$e(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$f.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$f) {
    var _iterator8 = _createForOfIteratorHelper(__getOwnPropSymbols$f(b)),
      _step9;
    try {
      for (_iterator8.s(); !(_step9 = _iterator8.n()).done;) {
        var prop = _step9.value;
        if (__propIsEnum$f.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }
  return a;
};
function ChevronIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$e({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var __defProp$f = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = function __defNormalProp$f(obj, key, value) {
  return key in obj ? __defProp$f(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$f = function __spreadValues$f(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$g.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$g) {
    var _iterator9 = _createForOfIteratorHelper(__getOwnPropSymbols$g(b)),
      _step10;
    try {
      for (_iterator9.s(); !(_step10 = _iterator9.n()).done;) {
        var prop = _step10.value;
        if (__propIsEnum$g.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }
  return a;
};
var __spreadProps$8 = function __spreadProps$8(a, b) {
  return __defProps$8(a, __getOwnPropDescs$8(b));
};
var useStyles = createStyles(function (theme, _ref31, getRef) {
  var transitionDuration = _ref31.transitionDuration,
    disableIconRotation = _ref31.disableIconRotation,
    iconPosition = _ref31.iconPosition,
    offsetIcon = _ref31.offsetIcon,
    iconSize = _ref31.iconSize;
  return {
    icon: {
      ref: getRef("icon"),
      transition: "transform ".concat(transitionDuration, "ms ease"),
      marginRight: iconPosition === "right" ? 0 : theme.spacing.sm,
      marginLeft: iconPosition === "right" ? theme.spacing.lg : 0,
      width: iconSize,
      minWidth: iconSize
    },
    label: {
      color: "inherit",
      fontWeight: 500,
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    item: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3])
    },
    itemOpened: _defineProperty({}, "& > .".concat(getRef("itemTitle"), " > .").concat(getRef("control"), " .").concat(getRef("icon")), {
      transform: disableIconRotation ? "none" : "rotate(180deg)"
    }),
    itemTitle: {
      ref: getRef("itemTitle"),
      margin: 0,
      padding: 0,
      fontWeight: "normal"
    },
    control: __spreadValues$f(__spreadProps$8(__spreadValues$f(__spreadValues$f({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
      ref: getRef("control"),
      width: "100%",
      display: "flex",
      alignItems: "center",
      flexDirection: iconPosition === "right" ? "row-reverse" : "row",
      padding: "".concat(theme.spacing.md, "px ").concat(theme.spacing.md / 2, "px"),
      paddingLeft: iconPosition === "right" ? theme.spacing.sm + 4 : null,
      fontWeight: 500,
      textAlign: "left",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    }), theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
    })),
    content: __spreadProps$8(__spreadValues$f({}, theme.fn.fontStyles()), {
      wordBreak: "break-word",
      lineHeight: theme.lineHeight,
      paddingLeft: iconPosition === "right" ? 0 : offsetIcon ? iconSize + theme.spacing.xs / 2 : 0
    }),
    contentInner: {
      padding: theme.spacing.md,
      paddingTop: theme.spacing.xs / 2
    }
  };
});
var SYSTEM_PROPS = {
  mt: "marginTop",
  mb: "marginBottom",
  ml: "marginLeft",
  mr: "marginRight",
  pt: "paddingTop",
  pb: "paddingBottom",
  pl: "paddingLeft",
  pr: "paddingRight"
};
var NEGATIVE_VALUES = ["-xs", "-sm", "-md", "-lg", "-xl"];
function isValidSizeValue(margin) {
  return typeof margin === "string" || typeof margin === "number";
}
function getSizeValue(margin, theme) {
  if (NEGATIVE_VALUES.includes(margin)) {
    return theme.fn.size({
      size: margin.replace("-", ""),
      sizes: theme.spacing
    }) * -1;
  }
  return theme.fn.size({
    size: margin,
    sizes: theme.spacing
  });
}
function getSystemStyles(systemStyles, theme) {
  var styles = {};
  if (isValidSizeValue(systemStyles.p)) {
    var value = getSizeValue(systemStyles.p, theme);
    styles.padding = value;
  }
  if (isValidSizeValue(systemStyles.m)) {
    var _value2 = getSizeValue(systemStyles.m, theme);
    styles.margin = _value2;
  }
  if (isValidSizeValue(systemStyles.py)) {
    var _value3 = getSizeValue(systemStyles.py, theme);
    styles.paddingTop = _value3;
    styles.paddingBottom = _value3;
  }
  if (isValidSizeValue(systemStyles.px)) {
    var _value4 = getSizeValue(systemStyles.px, theme);
    styles.paddingLeft = _value4;
    styles.paddingRight = _value4;
  }
  if (isValidSizeValue(systemStyles.my)) {
    var _value5 = getSizeValue(systemStyles.my, theme);
    styles.marginTop = _value5;
    styles.marginBottom = _value5;
  }
  if (isValidSizeValue(systemStyles.mx)) {
    var _value6 = getSizeValue(systemStyles.mx, theme);
    styles.marginLeft = _value6;
    styles.marginRight = _value6;
  }
  Object.keys(SYSTEM_PROPS).forEach(function (property) {
    if (isValidSizeValue(systemStyles[property])) {
      styles[SYSTEM_PROPS[property]] = theme.fn.size({
        size: getSizeValue(systemStyles[property], theme),
        sizes: theme.spacing
      });
    }
  });
  return styles;
}
function extractSx(sx, theme) {
  return typeof sx === "function" ? sx(theme) : sx;
}
function useSx(sx, systemProps, className) {
  var theme = useMantineTheme();
  var _useCss2 = useCss(),
    css = _useCss2.css,
    cx = _useCss2.cx;
  if (Array.isArray(sx)) {
    return cx(className, css(getSystemStyles(systemProps, theme)), sx.map(function (partial) {
      return css(extractSx(partial, theme));
    }));
  }
  return cx(className, css(extractSx(sx, theme)), css(getSystemStyles(systemProps, theme)));
}
var __defProp$g = Object.defineProperty;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = function __defNormalProp$g(obj, key, value) {
  return key in obj ? __defProp$g(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$g = function __spreadValues$g(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$h.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$h) {
    var _iterator10 = _createForOfIteratorHelper(__getOwnPropSymbols$h(b)),
      _step11;
    try {
      for (_iterator10.s(); !(_step11 = _iterator10.n()).done;) {
        var prop = _step11.value;
        if (__propIsEnum$h.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
  }
  return a;
};
var __objRest$1 = function __objRest$1(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$h.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$h) {
    var _iterator11 = _createForOfIteratorHelper(__getOwnPropSymbols$h(source)),
      _step12;
    try {
      for (_iterator11.s(); !(_step12 = _iterator11.n()).done;) {
        var prop = _step12.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$h.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  }
  return target;
};
var Box = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    component = _b.component,
    style = _b.style,
    sx = _b.sx,
    others = __objRest$1(_b, ["className", "component", "style", "sx"]);
  var _extractSystemStyles = extractSystemStyles(others),
    systemStyles = _extractSystemStyles.systemStyles,
    rest = _extractSystemStyles.rest;
  var Element = component || "div";
  return /* @__PURE__ */React__default.createElement(Element, __spreadValues$g({
    ref: ref,
    className: useSx(sx, systemStyles, className),
    style: style
  }, rest));
});
Box.displayName = "@mantine/core/Box";
var __defProp$h = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = function __defNormalProp$h(obj, key, value) {
  return key in obj ? __defProp$h(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$h = function __spreadValues$h(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$i.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$i) {
    var _iterator12 = _createForOfIteratorHelper(__getOwnPropSymbols$i(b)),
      _step13;
    try {
      for (_iterator12.s(); !(_step13 = _iterator12.n()).done;) {
        var prop = _step13.value;
        if (__propIsEnum$i.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
  }
  return a;
};
var __spreadProps$9 = function __spreadProps$9(a, b) {
  return __defProps$9(a, __getOwnPropDescs$9(b));
};
var useStyles$1 = createStyles(function (theme) {
  return {
    root: __spreadProps$9(__spreadValues$h(__spreadValues$h({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
      cursor: "pointer",
      border: 0,
      padding: 0,
      appearance: "none",
      fontSize: theme.fontSizes.md,
      backgroundColor: "transparent",
      textAlign: "left",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      textDecoration: "none"
    })
  };
});
var __defProp$i = Object.defineProperty;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = function __defNormalProp$i(obj, key, value) {
  return key in obj ? __defProp$i(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$i = function __spreadValues$i(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$j.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$j) {
    var _iterator13 = _createForOfIteratorHelper(__getOwnPropSymbols$j(b)),
      _step14;
    try {
      for (_iterator13.s(); !(_step14 = _iterator13.n()).done;) {
        var prop = _step14.value;
        if (__propIsEnum$j.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }
  }
  return a;
};
var __objRest$2 = function __objRest$2(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$j.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$j) {
    var _iterator14 = _createForOfIteratorHelper(__getOwnPropSymbols$j(source)),
      _step15;
    try {
      for (_iterator14.s(); !(_step15 = _iterator14.n()).done;) {
        var prop = _step15.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$j.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
  }
  return target;
};
var UnstyledButton = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    _b$component = _b.component,
    component = _b$component === void 0 ? "button" : _b$component,
    others = __objRest$2(_b, ["className", "component"]);
  var _useStyles$ = useStyles$1(null, {
      name: "UnstyledButton"
    }),
    classes = _useStyles$.classes,
    cx = _useStyles$.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$i({
    component: component,
    ref: ref,
    className: cx(classes.root, className),
    type: component === "button" ? "button" : void 0
  }, others));
});
UnstyledButton.displayName = "@mantine/core/UnstyledButton";
var __defProp$j = Object.defineProperty;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = function __defNormalProp$j(obj, key, value) {
  return key in obj ? __defProp$j(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$j = function __spreadValues$j(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$k.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$k) {
    var _iterator15 = _createForOfIteratorHelper(__getOwnPropSymbols$k(b)),
      _step16;
    try {
      for (_iterator15.s(); !(_step16 = _iterator15.n()).done;) {
        var prop = _step16.value;
        if (__propIsEnum$k.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
  }
  return a;
};
var __objRest$3 = function __objRest$3(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$k.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$k) {
    var _iterator16 = _createForOfIteratorHelper(__getOwnPropSymbols$k(source)),
      _step17;
    try {
      for (_iterator16.s(); !(_step17 = _iterator16.n()).done;) {
        var prop = _step17.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$k.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }
  }
  return target;
};
var Center = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Center", {}, props),
    inline = _a.inline,
    sx = _a.sx,
    others = __objRest$3(_a, ["inline", "sx"]);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$j({
    ref: ref,
    sx: [{
      display: inline ? "inline-flex" : "flex",
      alignItems: "center",
      justifyContent: "center"
    }].concat(_toConsumableArray2(Array.isArray(sx) ? sx : [sx]))
  }, others));
});
Center.displayName = "@mantine/core/Center";
var __defProp$k = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = function __defNormalProp$k(obj, key, value) {
  return key in obj ? __defProp$k(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$k = function __spreadValues$k(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$l.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$l) {
    var _iterator17 = _createForOfIteratorHelper(__getOwnPropSymbols$l(b)),
      _step18;
    try {
      for (_iterator17.s(); !(_step18 = _iterator17.n()).done;) {
        var prop = _step18.value;
        if (__propIsEnum$l.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator17.e(err);
    } finally {
      _iterator17.f();
    }
  }
  return a;
};
var __spreadProps$a = function __spreadProps$a(a, b) {
  return __defProps$a(a, __getOwnPropDescs$a(b));
};
var __objRest$4 = function __objRest$4(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$l.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$l) {
    var _iterator18 = _createForOfIteratorHelper(__getOwnPropSymbols$l(source)),
      _step19;
    try {
      for (_iterator18.s(); !(_step19 = _iterator18.n()).done;) {
        var prop = _step19.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$l.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator18.e(err);
    } finally {
      _iterator18.f();
    }
  }
  return target;
};
function getAutoHeightDuration(height) {
  if (!height || typeof height === "string") {
    return 0;
  }
  var constant = height / 36;
  return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function getElementHeight(el) {
  return (el == null ? void 0 : el.current) ? el.current.scrollHeight : "auto";
}
var raf = typeof window !== "undefined" && window.requestAnimationFrame;
function useCollapse(_ref32) {
  var transitionDuration = _ref32.transitionDuration,
    _ref32$transitionTimi = _ref32.transitionTimingFunction,
    transitionTimingFunction = _ref32$transitionTimi === void 0 ? "ease" : _ref32$transitionTimi,
    _ref32$onTransitionEn = _ref32.onTransitionEnd,
    onTransitionEnd = _ref32$onTransitionEn === void 0 ? function () {} : _ref32$onTransitionEn,
    opened = _ref32.opened;
  var el = useRef(null);
  var collapsedHeight = "0px";
  var collapsedStyles = {
    display: "none",
    height: "0px",
    overflow: "hidden"
  };
  var _useState17 = useState(opened ? {} : collapsedStyles),
    _useState18 = _slicedToArray(_useState17, 2),
    styles = _useState18[0],
    setStylesRaw = _useState18[1];
  var setStyles = function setStyles(newStyles) {
    flushSync(function () {
      return setStylesRaw(newStyles);
    });
  };
  var mergeStyles = function mergeStyles(newStyles) {
    setStyles(function (oldStyles) {
      return __spreadValues$k(__spreadValues$k({}, oldStyles), newStyles);
    });
  };
  function getTransitionStyles(height) {
    var _duration = transitionDuration || getAutoHeightDuration(height);
    return {
      transition: "height ".concat(_duration, "ms ").concat(transitionTimingFunction)
    };
  }
  useDidUpdate(function () {
    if (opened) {
      raf(function () {
        mergeStyles({
          willChange: "height",
          display: "block",
          overflow: "hidden"
        });
        raf(function () {
          var height = getElementHeight(el);
          mergeStyles(__spreadProps$a(__spreadValues$k({}, getTransitionStyles(height)), {
            height: height
          }));
        });
      });
    } else {
      raf(function () {
        var height = getElementHeight(el);
        mergeStyles(__spreadProps$a(__spreadValues$k({}, getTransitionStyles(height)), {
          willChange: "height",
          height: height
        }));
        raf(function () {
          return mergeStyles({
            height: collapsedHeight,
            overflow: "hidden"
          });
        });
      });
    }
  }, [opened]);
  var handleTransitionEnd = function handleTransitionEnd(e) {
    if (e.target !== el.current || e.propertyName !== "height") {
      return;
    }
    if (opened) {
      var height = getElementHeight(el);
      if (height === styles.height) {
        setStyles({});
      } else {
        mergeStyles({
          height: height
        });
      }
      onTransitionEnd();
    } else if (styles.height === collapsedHeight) {
      setStyles(collapsedStyles);
      onTransitionEnd();
    }
  };
  function getCollapseProps() {
    var _spreadProps$a;
    var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _b = _a,
      _b$style = _b.style,
      style = _b$style === void 0 ? {} : _b$style,
      _b$refKey = _b.refKey,
      refKey = _b$refKey === void 0 ? "ref" : _b$refKey,
      rest = __objRest$4(_b, ["style", "refKey"]);
    var theirRef = rest[refKey];
    return __spreadProps$a(__spreadValues$k({
      "aria-hidden": !opened
    }, rest), (_spreadProps$a = {}, _defineProperty(_spreadProps$a, refKey, useMergedRef(el, theirRef)), _defineProperty(_spreadProps$a, "onTransitionEnd", handleTransitionEnd), _defineProperty(_spreadProps$a, "style", __spreadValues$k(__spreadValues$k({
      boxSizing: "border-box"
    }, style), styles)), _spreadProps$a));
  }
  return getCollapseProps;
}
var __defProp$l = Object.defineProperty;
var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
var __hasOwnProp$m = Object.prototype.hasOwnProperty;
var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = function __defNormalProp$l(obj, key, value) {
  return key in obj ? __defProp$l(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$l = function __spreadValues$l(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$m.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$m) {
    var _iterator19 = _createForOfIteratorHelper(__getOwnPropSymbols$m(b)),
      _step20;
    try {
      for (_iterator19.s(); !(_step20 = _iterator19.n()).done;) {
        var prop = _step20.value;
        if (__propIsEnum$m.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator19.e(err);
    } finally {
      _iterator19.f();
    }
  }
  return a;
};
var __objRest$5 = function __objRest$5(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$m) {
    var _iterator20 = _createForOfIteratorHelper(__getOwnPropSymbols$m(source)),
      _step21;
    try {
      for (_iterator20.s(); !(_step21 = _iterator20.n()).done;) {
        var prop = _step21.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator20.e(err);
    } finally {
      _iterator20.f();
    }
  }
  return target;
};
var defaultProps = {
  transitionDuration: 200,
  transitionTimingFunction: "ease",
  animateOpacity: true
};
function Collapse(props) {
  var _a = useMantineDefaultProps("Collapse", defaultProps, props),
    children = _a.children,
    opened = _a.in,
    transitionDuration = _a.transitionDuration,
    transitionTimingFunction = _a.transitionTimingFunction,
    style = _a.style,
    onTransitionEnd = _a.onTransitionEnd,
    animateOpacity = _a.animateOpacity,
    others = __objRest$5(_a, ["children", "in", "transitionDuration", "transitionTimingFunction", "style", "onTransitionEnd", "animateOpacity"]);
  var reduceMotion = useReducedMotion();
  var duration = reduceMotion ? 0 : transitionDuration;
  var _extractSystemStyles2 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles2.systemStyles,
    rest = _extractSystemStyles2.rest;
  var getCollapseProps = useCollapse({
    opened: opened,
    transitionDuration: duration,
    transitionTimingFunction: transitionTimingFunction,
    onTransitionEnd: onTransitionEnd
  });
  if (duration === 0) {
    return opened ? /* @__PURE__ */React__default.createElement(Box, __spreadValues$l({}, rest), children) : null;
  }
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$l({}, getCollapseProps(__spreadValues$l(__spreadValues$l({
    style: style
  }, rest), systemStyles))), /* @__PURE__ */React__default.createElement("div", {
    style: {
      opacity: opened || !animateOpacity ? 1 : 0,
      transition: animateOpacity ? "opacity ".concat(duration, "ms ").concat(transitionTimingFunction) : "none"
    }
  }, children));
}
Collapse.displayName = "@mantine/core/Collapse";
var __defProp$m = Object.defineProperty;
var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
var __hasOwnProp$n = Object.prototype.hasOwnProperty;
var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = function __defNormalProp$m(obj, key, value) {
  return key in obj ? __defProp$m(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$m = function __spreadValues$m(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$n.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$n) {
    var _iterator21 = _createForOfIteratorHelper(__getOwnPropSymbols$n(b)),
      _step22;
    try {
      for (_iterator21.s(); !(_step22 = _iterator21.n()).done;) {
        var prop = _step22.value;
        if (__propIsEnum$n.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator21.e(err);
    } finally {
      _iterator21.f();
    }
  }
  return a;
};
var __objRest$6 = function __objRest$6(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$n.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$n) {
    var _iterator22 = _createForOfIteratorHelper(__getOwnPropSymbols$n(source)),
      _step23;
    try {
      for (_iterator22.s(); !(_step23 = _iterator22.n()).done;) {
        var prop = _step23.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$n.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator22.e(err);
    } finally {
      _iterator22.f();
    }
  }
  return target;
};
function AccordionItem(_a) {
  var _b = _a,
    opened = _b.opened,
    onToggle = _b.onToggle,
    label = _b.label,
    children = _b.children,
    className = _b.className,
    classNames = _b.classNames,
    styles = _b.styles,
    transitionDuration = _b.transitionDuration,
    _b$icon = _b.icon,
    icon = _b$icon === void 0 ? /* @__PURE__ */React__default.createElement(ChevronIcon, null) : _b$icon,
    _b$disableIconRotatio = _b.disableIconRotation,
    disableIconRotation = _b$disableIconRotatio === void 0 ? false : _b$disableIconRotatio,
    _b$offsetIcon = _b.offsetIcon,
    offsetIcon = _b$offsetIcon === void 0 ? true : _b$offsetIcon,
    _b$iconSize = _b.iconSize,
    iconSize = _b$iconSize === void 0 ? 24 : _b$iconSize,
    _b$iconPosition = _b.iconPosition,
    iconPosition = _b$iconPosition === void 0 ? "left" : _b$iconPosition,
    _b$order = _b.order,
    order = _b$order === void 0 ? 3 : _b$order,
    id = _b.id,
    controlRef = _b.controlRef,
    onControlKeyDown = _b.onControlKeyDown,
    others = __objRest$6(_b, ["opened", "onToggle", "label", "children", "className", "classNames", "styles", "transitionDuration", "icon", "disableIconRotation", "offsetIcon", "iconSize", "iconPosition", "order", "id", "controlRef", "onControlKeyDown"]);
  var reduceMotion = useReducedMotion();
  var duration = reduceMotion ? 0 : transitionDuration;
  var _useStyles = useStyles({
      transitionDuration: duration,
      disableIconRotation: disableIconRotation,
      iconPosition: iconPosition,
      offsetIcon: offsetIcon,
      iconSize: iconSize
    }, {
      classNames: classNames,
      styles: styles,
      name: "Accordion"
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var cappedOrder = Math.min(6, Math.max(2, order));
  var Heading = "h".concat(cappedOrder);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$m({
    className: cx(classes.item, _defineProperty({}, classes.itemOpened, opened), className)
  }, others), /* @__PURE__ */React__default.createElement(Heading, {
    className: classes.itemTitle
  }, /* @__PURE__ */React__default.createElement(UnstyledButton, {
    className: classes.control,
    onClick: onToggle,
    type: "button",
    "aria-expanded": opened,
    "aria-controls": "".concat(id, "-body"),
    id: id,
    ref: controlRef,
    onKeyDown: onControlKeyDown
  }, /* @__PURE__ */React__default.createElement(Center, {
    className: classes.icon
  }, icon), /* @__PURE__ */React__default.createElement("div", {
    className: classes.label
  }, label))), /* @__PURE__ */React__default.createElement(Collapse, {
    in: opened,
    transitionDuration: duration
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.content,
    role: "region",
    id: "".concat(id, "-body"),
    "aria-labelledby": id
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.contentInner
  }, children))));
}
AccordionItem.displayName = "@mantine/core/AccordionItem";
function useAccordionFocus(itemsCount) {
  var controlsRefs = useRef([]);
  var handleItemKeydown = function handleItemKeydown(index) {
    return function (event) {
      var _a, _b;
      if (event.code === "ArrowDown") {
        event.preventDefault();
        var nextFocusElement = controlsRefs.current[index + 1];
        if (nextFocusElement) {
          nextFocusElement.focus();
        } else {
          (_a = controlsRefs.current[0]) == null ? void 0 : _a.focus();
        }
      }
      if (event.code === "ArrowUp") {
        event.preventDefault();
        var previousFocusElement = controlsRefs.current[index - 1];
        if (previousFocusElement) {
          previousFocusElement.focus();
        } else {
          (_b = controlsRefs.current[controlsRefs.current.length - 1]) == null ? void 0 : _b.focus();
        }
      }
    };
  };
  var assignControlRef = function assignControlRef(index) {
    return function (node) {
      controlsRefs.current[index] = node;
    };
  };
  useDidUpdate(function () {
    controlsRefs.current = controlsRefs.current.slice(0, itemsCount);
  }, [itemsCount]);
  return {
    handleItemKeydown: handleItemKeydown,
    assignControlRef: assignControlRef
  };
}
var __defProp$n = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = function __defNormalProp$n(obj, key, value) {
  return key in obj ? __defProp$n(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$n = function __spreadValues$n(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$o.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
  if (__getOwnPropSymbols$o) {
    var _iterator23 = _createForOfIteratorHelper(__getOwnPropSymbols$o(b)),
      _step24;
    try {
      for (_iterator23.s(); !(_step24 = _iterator23.n()).done;) {
        var prop = _step24.value;
        if (__propIsEnum$o.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator23.e(err);
    } finally {
      _iterator23.f();
    }
  }
  return a;
};
var __spreadProps$b = function __spreadProps$b(a, b) {
  return __defProps$b(a, __getOwnPropDescs$b(b));
};
var __objRest$7 = function __objRest$7(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$o.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$o) {
    var _iterator24 = _createForOfIteratorHelper(__getOwnPropSymbols$o(source)),
      _step25;
    try {
      for (_iterator24.s(); !(_step25 = _iterator24.n()).done;) {
        var prop = _step25.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$o.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator24.e(err);
    } finally {
      _iterator24.f();
    }
  }
  return target;
};
var defaultProps$1 = {
  initialItem: -1,
  multiple: false,
  disableIconRotation: false,
  transitionDuration: 200,
  iconPosition: "left",
  offsetIcon: true,
  iconSize: 24,
  order: 3
};
var Accordion = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Accordion", defaultProps$1, props),
    children = _a.children,
    initialItem = _a.initialItem,
    initialState = _a.initialState,
    state = _a.state,
    onChange = _a.onChange,
    multiple = _a.multiple,
    disableIconRotation = _a.disableIconRotation,
    transitionDuration = _a.transitionDuration,
    iconPosition = _a.iconPosition,
    offsetIcon = _a.offsetIcon,
    iconSize = _a.iconSize,
    order = _a.order,
    icon = _a.icon,
    classNames = _a.classNames,
    styles = _a.styles,
    id = _a.id,
    others = __objRest$7(_a, ["children", "initialItem", "initialState", "state", "onChange", "multiple", "disableIconRotation", "transitionDuration", "iconPosition", "offsetIcon", "iconSize", "order", "icon", "classNames", "styles", "id"]);
  var uuid = useUuid(id);
  var items = filterChildrenByType(children, AccordionItem);
  var _useAccordionFocus = useAccordionFocus(items.length),
    handleItemKeydown = _useAccordionFocus.handleItemKeydown,
    assignControlRef = _useAccordionFocus.assignControlRef;
  var _useAccordionState = useAccordionState({
      multiple: multiple,
      total: items.length,
      initialItem: initialItem,
      state: state,
      initialState: initialState,
      onChange: onChange
    }),
    _useAccordionState2 = _slicedToArray(_useAccordionState, 2),
    value = _useAccordionState2[0],
    handlers = _useAccordionState2[1];
  var controls = items.map(function (item, index) {
    var _a2, _b, _c;
    return /* @__PURE__ */React__default.createElement(AccordionItem, __spreadProps$b(__spreadValues$n({}, item.props), {
      icon: item.props.icon || icon,
      iconPosition: item.props.iconPosition || iconPosition,
      disableIconRotation: disableIconRotation,
      key: index,
      transitionDuration: transitionDuration,
      opened: value[index],
      onToggle: function onToggle() {
        return handlers.toggle(index);
      },
      classNames: ((_a2 = item.props) == null ? void 0 : _a2.classNames) || classNames,
      styles: ((_b = item.props) == null ? void 0 : _b.styles) || styles,
      id: "".concat(uuid, "-").concat(index),
      onControlKeyDown: handleItemKeydown(index),
      controlRef: mergeRefs(assignControlRef(index), (_c = item.props) == null ? void 0 : _c.controlRef),
      offsetIcon: offsetIcon,
      iconSize: iconSize,
      order: order
    }));
  });
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$n({
    ref: ref
  }, others), controls);
});
Accordion.Item = AccordionItem;
Accordion.displayName = "@mantine/core/Accordion";
var __defProp$o = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
var __hasOwnProp$p = Object.prototype.hasOwnProperty;
var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$o = function __defNormalProp$o(obj, key, value) {
  return key in obj ? __defProp$o(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$o = function __spreadValues$o(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$p.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
  if (__getOwnPropSymbols$p) {
    var _iterator25 = _createForOfIteratorHelper(__getOwnPropSymbols$p(b)),
      _step26;
    try {
      for (_iterator25.s(); !(_step26 = _iterator25.n()).done;) {
        var prop = _step26.value;
        if (__propIsEnum$p.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator25.e(err);
    } finally {
      _iterator25.f();
    }
  }
  return a;
};
var __spreadProps$c = function __spreadProps$c(a, b) {
  return __defProps$c(a, __getOwnPropDescs$c(b));
};
var sizes = {
  xs: 18,
  sm: 22,
  md: 28,
  lg: 34,
  xl: 44
};
function getVariantStyles(_ref33) {
  var variant = _ref33.variant,
    theme = _ref33.theme,
    color = _ref33.color;
  if (variant === "hover" || variant === "transparent") {
    return __spreadValues$o({
      border: "1px solid transparent",
      color: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 4 : 7),
      backgroundColor: "transparent"
    }, theme.fn.hover(variant === "transparent" ? {} : {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.fn.themeColor(color, 0)
    }));
  }
  var colors = theme.fn.variant({
    color: color,
    variant: variant
  });
  return __spreadValues$o({
    backgroundColor: colors.background,
    color: colors.color,
    border: "1px solid ".concat(colors.border)
  }, theme.fn.hover({
    backgroundColor: colors.hover
  }));
}
var useStyles$2 = createStyles(function (theme, _ref34) {
  var color = _ref34.color,
    size = _ref34.size,
    radius = _ref34.radius;
  return {
    root: __spreadProps$c(__spreadValues$o(__spreadValues$o({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
      position: "relative",
      appearance: "none",
      WebkitAppearance: "none",
      WebkitTapHighlightColor: "transparent",
      boxSizing: "border-box",
      height: theme.fn.size({
        size: size,
        sizes: sizes
      }),
      minHeight: theme.fn.size({
        size: size,
        sizes: sizes
      }),
      width: theme.fn.size({
        size: size,
        sizes: sizes
      }),
      minWidth: theme.fn.size({
        size: size,
        sizes: sizes
      }),
      borderRadius: theme.fn.radius(radius),
      padding: 0,
      lineHeight: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      "&:disabled": {
        color: theme.colors.gray[theme.colorScheme === "dark" ? 6 : 4],
        cursor: "not-allowed",
        backgroundColor: theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1),
        borderColor: theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1)
      },
      "&:not(:disabled):active": {
        transform: "translateY(1px)"
      }
    }),
    outline: getVariantStyles({
      theme: theme,
      color: color,
      variant: "outline"
    }),
    filled: getVariantStyles({
      theme: theme,
      color: color,
      variant: "filled"
    }),
    default: getVariantStyles({
      theme: theme,
      color: color,
      variant: "default"
    }),
    light: getVariantStyles({
      theme: theme,
      color: color,
      variant: "light"
    }),
    hover: getVariantStyles({
      theme: theme,
      color: color,
      variant: "hover"
    }),
    transparent: getVariantStyles({
      theme: theme,
      color: color,
      variant: "transparent"
    }),
    loading: {
      "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: theme.fn.radius(radius),
        cursor: "not-allowed"
      }
    }
  };
});
var __defProp$p = Object.defineProperty;
var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
var __hasOwnProp$q = Object.prototype.hasOwnProperty;
var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$p = function __defNormalProp$p(obj, key, value) {
  return key in obj ? __defProp$p(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$p = function __spreadValues$p(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$q.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
  if (__getOwnPropSymbols$q) {
    var _iterator26 = _createForOfIteratorHelper(__getOwnPropSymbols$q(b)),
      _step27;
    try {
      for (_iterator26.s(); !(_step27 = _iterator26.n()).done;) {
        var prop = _step27.value;
        if (__propIsEnum$q.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator26.e(err);
    } finally {
      _iterator26.f();
    }
  }
  return a;
};
var __objRest$8 = function __objRest$8(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$q) {
    var _iterator27 = _createForOfIteratorHelper(__getOwnPropSymbols$q(source)),
      _step28;
    try {
      for (_iterator27.s(); !(_step28 = _iterator27.n()).done;) {
        var prop = _step28.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$q.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator27.e(err);
    } finally {
      _iterator27.f();
    }
  }
  return target;
};
function Bars(_a) {
  var _b = _a,
    size = _b.size,
    color = _b.color,
    others = __objRest$8(_b, ["size", "color"]);
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$p({
    viewBox: "0 0 135 140",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    width: "".concat(size, "px")
  }, others), /* @__PURE__ */React__default.createElement("rect", {
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */React__default.createElement("rect", {
    x: "30",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */React__default.createElement("rect", {
    x: "60",
    width: "15",
    height: "140",
    rx: "6"
  }, /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */React__default.createElement("rect", {
    x: "90",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */React__default.createElement("rect", {
    x: "120",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}
var __defProp$q = Object.defineProperty;
var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
var __hasOwnProp$r = Object.prototype.hasOwnProperty;
var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$q = function __defNormalProp$q(obj, key, value) {
  return key in obj ? __defProp$q(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$q = function __spreadValues$q(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$r.call(b, prop)) __defNormalProp$q(a, prop, b[prop]);
  if (__getOwnPropSymbols$r) {
    var _iterator28 = _createForOfIteratorHelper(__getOwnPropSymbols$r(b)),
      _step29;
    try {
      for (_iterator28.s(); !(_step29 = _iterator28.n()).done;) {
        var prop = _step29.value;
        if (__propIsEnum$r.call(b, prop)) __defNormalProp$q(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator28.e(err);
    } finally {
      _iterator28.f();
    }
  }
  return a;
};
var __objRest$9 = function __objRest$9(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$r.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$r) {
    var _iterator29 = _createForOfIteratorHelper(__getOwnPropSymbols$r(source)),
      _step30;
    try {
      for (_iterator29.s(); !(_step30 = _iterator29.n()).done;) {
        var prop = _step30.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$r.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator29.e(err);
    } finally {
      _iterator29.f();
    }
  }
  return target;
};
function Oval(_a) {
  var _b = _a,
    size = _b.size,
    color = _b.color,
    others = __objRest$9(_b, ["size", "color"]);
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$q({
    width: "".concat(size, "px"),
    height: "".concat(size, "px"),
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: color
  }, others), /* @__PURE__ */React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */React__default.createElement("g", {
    transform: "translate(2.5 2.5)",
    strokeWidth: "5"
  }, /* @__PURE__ */React__default.createElement("circle", {
    strokeOpacity: ".5",
    cx: "16",
    cy: "16",
    r: "16"
  }), /* @__PURE__ */React__default.createElement("path", {
    d: "M32 16c0-9.94-8.06-16-16-16"
  }, /* @__PURE__ */React__default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 16 16",
    to: "360 16 16",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}
var __defProp$r = Object.defineProperty;
var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
var __hasOwnProp$s = Object.prototype.hasOwnProperty;
var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$r = function __defNormalProp$r(obj, key, value) {
  return key in obj ? __defProp$r(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$r = function __spreadValues$r(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$s.call(b, prop)) __defNormalProp$r(a, prop, b[prop]);
  if (__getOwnPropSymbols$s) {
    var _iterator30 = _createForOfIteratorHelper(__getOwnPropSymbols$s(b)),
      _step31;
    try {
      for (_iterator30.s(); !(_step31 = _iterator30.n()).done;) {
        var prop = _step31.value;
        if (__propIsEnum$s.call(b, prop)) __defNormalProp$r(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator30.e(err);
    } finally {
      _iterator30.f();
    }
  }
  return a;
};
var __objRest$a = function __objRest$a(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$s.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$s) {
    var _iterator31 = _createForOfIteratorHelper(__getOwnPropSymbols$s(source)),
      _step32;
    try {
      for (_iterator31.s(); !(_step32 = _iterator31.n()).done;) {
        var prop = _step32.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$s.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator31.e(err);
    } finally {
      _iterator31.f();
    }
  }
  return target;
};
function Dots(_a) {
  var _b = _a,
    size = _b.size,
    color = _b.color,
    others = __objRest$a(_b, ["size", "color"]);
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$r({
    width: "".concat(size, "px"),
    height: "".concat(size / 4, "px"),
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color
  }, others), /* @__PURE__ */React__default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */React__default.createElement("circle", {
    cx: "60",
    cy: "15",
    r: "9",
    fillOpacity: "0.3"
  }, /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "r",
    from: "9",
    to: "9",
    begin: "0s",
    dur: "0.8s",
    values: "9;15;9",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "fill-opacity",
    from: "0.5",
    to: "0.5",
    begin: "0s",
    dur: "0.8s",
    values: ".5;1;.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */React__default.createElement("circle", {
    cx: "105",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */React__default.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}
var __defProp$s = Object.defineProperty;
var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
var __hasOwnProp$t = Object.prototype.hasOwnProperty;
var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$s = function __defNormalProp$s(obj, key, value) {
  return key in obj ? __defProp$s(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$s = function __spreadValues$s(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$t.call(b, prop)) __defNormalProp$s(a, prop, b[prop]);
  if (__getOwnPropSymbols$t) {
    var _iterator32 = _createForOfIteratorHelper(__getOwnPropSymbols$t(b)),
      _step33;
    try {
      for (_iterator32.s(); !(_step33 = _iterator32.n()).done;) {
        var prop = _step33.value;
        if (__propIsEnum$t.call(b, prop)) __defNormalProp$s(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator32.e(err);
    } finally {
      _iterator32.f();
    }
  }
  return a;
};
var __objRest$b = function __objRest$b(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$t) {
    var _iterator33 = _createForOfIteratorHelper(__getOwnPropSymbols$t(source)),
      _step34;
    try {
      for (_iterator33.s(); !(_step34 = _iterator33.n()).done;) {
        var prop = _step34.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator33.e(err);
    } finally {
      _iterator33.f();
    }
  }
  return target;
};
var LOADERS = {
  bars: Bars,
  oval: Oval,
  dots: Dots
};
var LOADER_SIZES = {
  xs: 18,
  sm: 22,
  md: 36,
  lg: 44,
  xl: 58
};
var defaultProps$2 = {
  size: "md"
};
function Loader(props) {
  var _a = useMantineDefaultProps("Loader", defaultProps$2, props),
    _a$size = _a.size,
    size = _a$size === void 0 ? "md" : _a$size,
    color = _a.color,
    variant = _a.variant,
    others = __objRest$b(_a, ["size", "color", "variant"]);
  var theme = useMantineTheme();
  var defaultLoader = variant in LOADERS ? variant : theme.loader;
  var _color = color || theme.primaryColor;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$s({
    role: "presentation",
    component: LOADERS[defaultLoader] || LOADERS.bars,
    size: theme.fn.size({
      size: size,
      sizes: LOADER_SIZES
    }),
    color: _color in theme.colors ? theme.fn.themeColor(_color, theme.colorScheme === "dark" ? 4 : theme.fn.primaryShade("light")) : color
  }, others));
}
Loader.displayName = "@mantine/core/Loader";
var __defProp$t = Object.defineProperty;
var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
var __hasOwnProp$u = Object.prototype.hasOwnProperty;
var __propIsEnum$u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$t = function __defNormalProp$t(obj, key, value) {
  return key in obj ? __defProp$t(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$t = function __spreadValues$t(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$u.call(b, prop)) __defNormalProp$t(a, prop, b[prop]);
  if (__getOwnPropSymbols$u) {
    var _iterator34 = _createForOfIteratorHelper(__getOwnPropSymbols$u(b)),
      _step35;
    try {
      for (_iterator34.s(); !(_step35 = _iterator34.n()).done;) {
        var prop = _step35.value;
        if (__propIsEnum$u.call(b, prop)) __defNormalProp$t(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator34.e(err);
    } finally {
      _iterator34.f();
    }
  }
  return a;
};
var __objRest$c = function __objRest$c(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$u.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$u) {
    var _iterator35 = _createForOfIteratorHelper(__getOwnPropSymbols$u(source)),
      _step36;
    try {
      for (_iterator35.s(); !(_step36 = _iterator35.n()).done;) {
        var prop = _step36.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$u.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator35.e(err);
    } finally {
      _iterator35.f();
    }
  }
  return target;
};
var defaultProps$3 = {
  color: "gray",
  size: "md",
  variant: "hover",
  disabled: false,
  loading: false
};
var ActionIcon = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("ActionIcon", defaultProps$3, props),
    className = _a.className,
    color = _a.color,
    children = _a.children,
    radius = _a.radius,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    loaderProps = _a.loaderProps,
    loading = _a.loading,
    component = _a.component,
    styles = _a.styles,
    classNames = _a.classNames,
    others = __objRest$c(_a, ["className", "color", "children", "radius", "size", "variant", "disabled", "loaderProps", "loading", "component", "styles", "classNames"]);
  var _useStyles$2 = useStyles$2({
      size: size,
      radius: radius,
      color: color
    }, {
      name: "ActionIcon",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$2.classes,
    cx = _useStyles$2.cx,
    theme = _useStyles$2.theme;
  var colors = theme.fn.variant({
    color: color,
    variant: "light"
  });
  var loader = /* @__PURE__ */React__default.createElement(Loader, __spreadValues$t({
    color: colors.color,
    size: theme.fn.size({
      size: size,
      sizes: sizes
    }) - 12
  }, loaderProps));
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$t({
    component: component || "button",
    className: cx(classes[variant], classes.root, _defineProperty({}, classes.loading, loading), className),
    type: "button",
    ref: ref,
    disabled: disabled || loading
  }, others), loading ? loader : children);
});
ActionIcon.displayName = "@mantine/core/ActionIcon";
var __defProp$u = Object.defineProperty;
var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
var __hasOwnProp$v = Object.prototype.hasOwnProperty;
var __propIsEnum$v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$u = function __defNormalProp$u(obj, key, value) {
  return key in obj ? __defProp$u(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$u = function __spreadValues$u(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$v.call(b, prop)) __defNormalProp$u(a, prop, b[prop]);
  if (__getOwnPropSymbols$v) {
    var _iterator36 = _createForOfIteratorHelper(__getOwnPropSymbols$v(b)),
      _step37;
    try {
      for (_iterator36.s(); !(_step37 = _iterator36.n()).done;) {
        var prop = _step37.value;
        if (__propIsEnum$v.call(b, prop)) __defNormalProp$u(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator36.e(err);
    } finally {
      _iterator36.f();
    }
  }
  return a;
};
function CloseIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$u({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
CloseIcon.displayName = "@mantine/core/CloseIcon";
var __defProp$v = Object.defineProperty;
var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
var __hasOwnProp$w = Object.prototype.hasOwnProperty;
var __propIsEnum$w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$v = function __defNormalProp$v(obj, key, value) {
  return key in obj ? __defProp$v(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$v = function __spreadValues$v(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$w.call(b, prop)) __defNormalProp$v(a, prop, b[prop]);
  if (__getOwnPropSymbols$w) {
    var _iterator37 = _createForOfIteratorHelper(__getOwnPropSymbols$w(b)),
      _step38;
    try {
      for (_iterator37.s(); !(_step38 = _iterator37.n()).done;) {
        var prop = _step38.value;
        if (__propIsEnum$w.call(b, prop)) __defNormalProp$v(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator37.e(err);
    } finally {
      _iterator37.f();
    }
  }
  return a;
};
var __objRest$d = function __objRest$d(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$w) {
    var _iterator38 = _createForOfIteratorHelper(__getOwnPropSymbols$w(source)),
      _step39;
    try {
      for (_iterator38.s(); !(_step39 = _iterator38.n()).done;) {
        var prop = _step39.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator38.e(err);
    } finally {
      _iterator38.f();
    }
  }
  return target;
};
var iconSizes = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24
};
var CloseButton = forwardRef(function (_a, ref) {
  var _b = _a,
    iconSize = _b.iconSize,
    _b$size = _b.size,
    size = _b$size === void 0 ? "md" : _b$size,
    others = __objRest$d(_b, ["iconSize", "size"]);
  var theme = useMantineTheme();
  var _iconSize = iconSize || theme.fn.size({
    size: size,
    sizes: iconSizes
  });
  return /* @__PURE__ */React__default.createElement(ActionIcon, __spreadValues$v({
    size: size,
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement(CloseIcon, {
    width: _iconSize,
    height: _iconSize
  }));
});
CloseButton.displayName = "@mantine/core/CloseButton";
var defaultProps$4 = {
  zIndex: 1,
  position: "relative"
};
function Portal$1(props) {
  var _useMantineDefaultPro = useMantineDefaultProps("Portal", defaultProps$4, props),
    children = _useMantineDefaultPro.children,
    zIndex = _useMantineDefaultPro.zIndex,
    target = _useMantineDefaultPro.target,
    className = _useMantineDefaultPro.className,
    position = _useMantineDefaultPro.position;
  var theme = useMantineTheme();
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    mounted = _useState20[0],
    setMounted = _useState20[1];
  var ref = useRef();
  useIsomorphicEffect(function () {
    setMounted(true);
    ref.current = !target ? document.createElement("div") : typeof target === "string" ? document.querySelector(target) : target;
    if (!target) {
      document.body.appendChild(ref.current);
    }
    return function () {
      !target && document.body.removeChild(ref.current);
    };
  }, [target]);
  if (!mounted) {
    return null;
  }
  return createPortal( /* @__PURE__ */React__default.createElement("div", {
    className: className,
    dir: theme.dir,
    style: {
      position: position,
      zIndex: zIndex
    }
  }, children), ref.current);
}
Portal$1.displayName = "@mantine/core/Portal";
var __defProp$w = Object.defineProperty;
var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
var __hasOwnProp$x = Object.prototype.hasOwnProperty;
var __propIsEnum$x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$w = function __defNormalProp$w(obj, key, value) {
  return key in obj ? __defProp$w(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$w = function __spreadValues$w(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$x.call(b, prop)) __defNormalProp$w(a, prop, b[prop]);
  if (__getOwnPropSymbols$x) {
    var _iterator39 = _createForOfIteratorHelper(__getOwnPropSymbols$x(b)),
      _step40;
    try {
      for (_iterator39.s(); !(_step40 = _iterator39.n()).done;) {
        var prop = _step40.value;
        if (__propIsEnum$x.call(b, prop)) __defNormalProp$w(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator39.e(err);
    } finally {
      _iterator39.f();
    }
  }
  return a;
};
var __objRest$e = function __objRest$e(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$x.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$x) {
    var _iterator40 = _createForOfIteratorHelper(__getOwnPropSymbols$x(source)),
      _step41;
    try {
      for (_iterator40.s(); !(_step41 = _iterator40.n()).done;) {
        var prop = _step41.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$x.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator40.e(err);
    } finally {
      _iterator40.f();
    }
  }
  return target;
};
var defaultProps$5 = {
  position: {
    bottom: 0,
    right: 0
  },
  zIndex: getDefaultZIndex("modal")
};
var Affix = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Affix", defaultProps$5, props),
    target = _a.target,
    position = _a.position,
    zIndex = _a.zIndex,
    sx = _a.sx,
    others = __objRest$e(_a, ["target", "position", "zIndex", "sx"]);
  return /* @__PURE__ */React__default.createElement(Portal$1, {
    zIndex: zIndex,
    target: target
  }, /* @__PURE__ */React__default.createElement(Box, __spreadValues$w({
    sx: [__spreadValues$w({
      position: "fixed"
    }, position)].concat(_toConsumableArray2(Array.isArray(sx) ? sx : [sx])),
    ref: ref
  }, others)));
});
Affix.displayName = "@mantine/core/Affix";
var __defProp$x = Object.defineProperty;
var __defProps$d = Object.defineProperties;
var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
var __hasOwnProp$y = Object.prototype.hasOwnProperty;
var __propIsEnum$y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$x = function __defNormalProp$x(obj, key, value) {
  return key in obj ? __defProp$x(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$x = function __spreadValues$x(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$y.call(b, prop)) __defNormalProp$x(a, prop, b[prop]);
  if (__getOwnPropSymbols$y) {
    var _iterator41 = _createForOfIteratorHelper(__getOwnPropSymbols$y(b)),
      _step42;
    try {
      for (_iterator41.s(); !(_step42 = _iterator41.n()).done;) {
        var prop = _step42.value;
        if (__propIsEnum$y.call(b, prop)) __defNormalProp$x(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator41.e(err);
    } finally {
      _iterator41.f();
    }
  }
  return a;
};
var __spreadProps$d = function __spreadProps$d(a, b) {
  return __defProps$d(a, __getOwnPropDescs$d(b));
};
var useStyles$3 = createStyles(function (theme, _ref35, getRef) {
  var color = _ref35.color,
    radius = _ref35.radius,
    variant = _ref35.variant;
  return {
    root: __spreadProps$d(__spreadValues$x({}, theme.fn.fontStyles()), {
      position: "relative",
      overflow: "hidden",
      padding: "".concat(theme.spacing.sm, "px ").concat(theme.spacing.md, "px"),
      borderRadius: theme.fn.radius(radius),
      border: "1px solid transparent"
    }),
    wrapper: {
      display: "flex"
    },
    body: {
      flex: 1
    },
    title: {
      boxSizing: "border-box",
      margin: 0,
      marginBottom: 7,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      lineHeight: theme.lineHeight,
      fontSize: theme.fontSizes.sm,
      fontWeight: 700
    },
    label: {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    light: {
      backgroundColor: theme.fn.variant({
        variant: "light",
        color: color
      }).background,
      color: theme.fn.variant({
        variant: "light",
        color: color
      }).color
    },
    filled: _defineProperty({
      backgroundColor: theme.fn.variant({
        variant: "filled",
        color: color
      }).background,
      color: theme.white
    }, "& .".concat(getRef("closeButton")), {
      color: theme.white
    }),
    outline: {
      color: theme.fn.variant({
        variant: "outline",
        color: color
      }).color,
      borderColor: theme.fn.variant({
        variant: "outline",
        color: color
      }).border
    },
    icon: {
      lineHeight: 1,
      width: 20,
      height: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      marginRight: theme.spacing.md,
      marginTop: 1
    },
    message: __spreadProps$d(__spreadValues$x({}, theme.fn.fontStyles()), {
      lineHeight: theme.lineHeight,
      textOverflow: "ellipsis",
      overflow: "hidden",
      fontSize: theme.fontSizes.sm,
      color: variant === "filled" ? theme.white : theme.colorScheme === "dark" ? variant === "light" ? theme.white : theme.colors.dark[0] : theme.black
    }),
    closeButton: {
      ref: getRef("closeButton"),
      marginTop: 2
    }
  };
});
var __defProp$y = Object.defineProperty;
var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
var __hasOwnProp$z = Object.prototype.hasOwnProperty;
var __propIsEnum$z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$y = function __defNormalProp$y(obj, key, value) {
  return key in obj ? __defProp$y(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$y = function __spreadValues$y(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$z.call(b, prop)) __defNormalProp$y(a, prop, b[prop]);
  if (__getOwnPropSymbols$z) {
    var _iterator42 = _createForOfIteratorHelper(__getOwnPropSymbols$z(b)),
      _step43;
    try {
      for (_iterator42.s(); !(_step43 = _iterator42.n()).done;) {
        var prop = _step43.value;
        if (__propIsEnum$z.call(b, prop)) __defNormalProp$y(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator42.e(err);
    } finally {
      _iterator42.f();
    }
  }
  return a;
};
var __objRest$f = function __objRest$f(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$z.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$z) {
    var _iterator43 = _createForOfIteratorHelper(__getOwnPropSymbols$z(source)),
      _step44;
    try {
      for (_iterator43.s(); !(_step44 = _iterator43.n()).done;) {
        var prop = _step44.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$z.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator43.e(err);
    } finally {
      _iterator43.f();
    }
  }
  return target;
};
var defaultProps$6 = {
  variant: "light"
};
var Alert = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Alert", defaultProps$6, props),
    id = _a.id,
    className = _a.className,
    title = _a.title,
    variant = _a.variant,
    children = _a.children,
    color = _a.color,
    classNames = _a.classNames,
    icon = _a.icon,
    styles = _a.styles,
    onClose = _a.onClose,
    radius = _a.radius,
    withCloseButton = _a.withCloseButton,
    closeButtonLabel = _a.closeButtonLabel,
    others = __objRest$f(_a, ["id", "className", "title", "variant", "children", "color", "classNames", "icon", "styles", "onClose", "radius", "withCloseButton", "closeButtonLabel"]);
  var _useStyles$3 = useStyles$3({
      color: color,
      radius: radius,
      variant: variant
    }, {
      classNames: classNames,
      styles: styles,
      name: "Alert"
    }),
    classes = _useStyles$3.classes,
    cx = _useStyles$3.cx;
  var rootId = useUuid(id);
  var titleId = title && "".concat(rootId, "-title");
  var bodyId = "".concat(rootId, "-body");
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$y({
    id: rootId,
    role: "alert",
    "aria-labelledby": titleId,
    "aria-describedby": bodyId,
    className: cx(classes.root, classes[variant], className),
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: classes.wrapper
  }, icon && /* @__PURE__ */React__default.createElement("div", {
    className: classes.icon
  }, icon), /* @__PURE__ */React__default.createElement("div", {
    className: classes.body
  }, title && /* @__PURE__ */React__default.createElement("div", {
    className: classes.title
  }, /* @__PURE__ */React__default.createElement("span", {
    id: titleId,
    className: classes.label
  }, title), withCloseButton && /* @__PURE__ */React__default.createElement(CloseButton, {
    className: classes.closeButton,
    onClick: function onClick() {
      return onClose == null ? void 0 : onClose();
    },
    variant: "transparent",
    size: 16,
    iconSize: 16,
    "aria-label": closeButtonLabel
  })), /* @__PURE__ */React__default.createElement("div", {
    id: bodyId,
    className: classes.message
  }, children))));
});
Alert.displayName = "@mantine/core/Alert";
var __defProp$z = Object.defineProperty;
var __defProps$e = Object.defineProperties;
var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
var __hasOwnProp$A = Object.prototype.hasOwnProperty;
var __propIsEnum$A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$z = function __defNormalProp$z(obj, key, value) {
  return key in obj ? __defProp$z(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$z = function __spreadValues$z(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$A.call(b, prop)) __defNormalProp$z(a, prop, b[prop]);
  if (__getOwnPropSymbols$A) {
    var _iterator44 = _createForOfIteratorHelper(__getOwnPropSymbols$A(b)),
      _step45;
    try {
      for (_iterator44.s(); !(_step45 = _iterator44.n()).done;) {
        var prop = _step45.value;
        if (__propIsEnum$A.call(b, prop)) __defNormalProp$z(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator44.e(err);
    } finally {
      _iterator44.f();
    }
  }
  return a;
};
var __spreadProps$e = function __spreadProps$e(a, b) {
  return __defProps$e(a, __getOwnPropDescs$e(b));
};
function getTextColor(_ref36) {
  var theme = _ref36.theme,
    color = _ref36.color,
    variant = _ref36.variant;
  if (color === "dimmed") {
    return theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6];
  }
  return color in theme.colors ? theme.colors[color][theme.colorScheme === "dark" ? 5 : 7] : variant === "link" ? theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 4 : 7] : color || "inherit";
}
function getLineClamp(lineClamp) {
  if (typeof lineClamp === "number") {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: lineClamp,
      WebkitBoxOrient: "vertical"
    };
  }
  return null;
}
var useStyles$4 = createStyles(function (theme, _ref37) {
  var color = _ref37.color,
    variant = _ref37.variant,
    size = _ref37.size,
    lineClamp = _ref37.lineClamp,
    inline = _ref37.inline,
    inherit = _ref37.inherit,
    underline = _ref37.underline,
    gradientDeg = _ref37.gradientDeg,
    gradientTo = _ref37.gradientTo,
    gradientFrom = _ref37.gradientFrom,
    weight = _ref37.weight,
    transform = _ref37.transform,
    align = _ref37.align;
  var colors = theme.fn.variant({
    variant: "gradient",
    gradient: {
      from: gradientFrom,
      to: gradientTo,
      deg: gradientDeg
    }
  });
  return {
    root: __spreadValues$z(__spreadProps$e(__spreadValues$z(__spreadValues$z(__spreadValues$z({}, theme.fn.fontStyles()), theme.fn.focusStyles()), getLineClamp(lineClamp)), {
      color: getTextColor({
        color: color,
        theme: theme,
        variant: variant
      }),
      fontFamily: inherit ? "inherit" : theme.fontFamily,
      fontSize: inherit ? "inherit" : theme.fontSizes[size],
      lineHeight: inherit ? "inherit" : inline ? 1 : theme.lineHeight,
      textDecoration: underline ? "underline" : "none",
      WebkitTapHighlightColor: "transparent",
      fontWeight: inherit ? "inherit" : weight,
      textTransform: transform,
      textAlign: align
    }), theme.fn.hover(variant === "link" && underline === void 0 ? {
      textDecoration: "underline"
    } : void 0)),
    gradient: {
      backgroundImage: colors.background,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    }
  };
});
var __defProp$A = Object.defineProperty;
var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
var __hasOwnProp$B = Object.prototype.hasOwnProperty;
var __propIsEnum$B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$A = function __defNormalProp$A(obj, key, value) {
  return key in obj ? __defProp$A(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$A = function __spreadValues$A(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$B.call(b, prop)) __defNormalProp$A(a, prop, b[prop]);
  if (__getOwnPropSymbols$B) {
    var _iterator45 = _createForOfIteratorHelper(__getOwnPropSymbols$B(b)),
      _step46;
    try {
      for (_iterator45.s(); !(_step46 = _iterator45.n()).done;) {
        var prop = _step46.value;
        if (__propIsEnum$B.call(b, prop)) __defNormalProp$A(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator45.e(err);
    } finally {
      _iterator45.f();
    }
  }
  return a;
};
var __objRest$g = function __objRest$g(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$B.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$B) {
    var _iterator46 = _createForOfIteratorHelper(__getOwnPropSymbols$B(source)),
      _step47;
    try {
      for (_iterator46.s(); !(_step47 = _iterator46.n()).done;) {
        var prop = _step47.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$B.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator46.e(err);
    } finally {
      _iterator46.f();
    }
  }
  return target;
};
var defaultProps$7 = {
  size: "md",
  variant: "text",
  gradient: {
    from: "blue",
    to: "cyan",
    deg: 45
  },
  inline: false,
  inherit: false
};
var Text = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Text", defaultProps$7, props),
    className = _a.className,
    component = _a.component,
    _a$size2 = _a.size,
    size = _a$size2 === void 0 ? "md" : _a$size2,
    weight = _a.weight,
    transform = _a.transform,
    color = _a.color,
    align = _a.align,
    _a$variant = _a.variant,
    variant = _a$variant === void 0 ? "text" : _a$variant,
    lineClamp = _a.lineClamp,
    _a$gradient = _a.gradient,
    gradient = _a$gradient === void 0 ? {
      from: "blue",
      to: "cyan",
      deg: 45
    } : _a$gradient,
    _a$inline = _a.inline,
    inline = _a$inline === void 0 ? false : _a$inline,
    _a$inherit = _a.inherit,
    inherit = _a$inherit === void 0 ? false : _a$inherit,
    underline = _a.underline,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$g(_a, ["className", "component", "size", "weight", "transform", "color", "align", "variant", "lineClamp", "gradient", "inline", "inherit", "underline", "classNames", "styles"]);
  var _useStyles$4 = useStyles$4({
      variant: variant,
      color: color,
      size: size,
      lineClamp: lineClamp,
      inline: inline,
      inherit: inherit,
      underline: underline,
      weight: weight,
      transform: transform,
      align: align,
      gradientFrom: gradient.from,
      gradientTo: gradient.to,
      gradientDeg: gradient.deg
    }, {
      classNames: classNames,
      styles: styles,
      name: "Text"
    }),
    classes = _useStyles$4.classes,
    cx = _useStyles$4.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$A({
    ref: ref,
    component: component || "div",
    className: cx(classes.root, _defineProperty({}, classes.gradient, variant === "gradient"), className)
  }, others));
});
Text.displayName = "@mantine/core/Text";
var useStyles$5 = createStyles(function () {
  return {
    root: {
      backgroundColor: "transparent",
      cursor: "pointer",
      padding: 0,
      border: 0
    }
  };
});
var __defProp$B = Object.defineProperty;
var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
var __hasOwnProp$C = Object.prototype.hasOwnProperty;
var __propIsEnum$C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$B = function __defNormalProp$B(obj, key, value) {
  return key in obj ? __defProp$B(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$B = function __spreadValues$B(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$C.call(b, prop)) __defNormalProp$B(a, prop, b[prop]);
  if (__getOwnPropSymbols$C) {
    var _iterator47 = _createForOfIteratorHelper(__getOwnPropSymbols$C(b)),
      _step48;
    try {
      for (_iterator47.s(); !(_step48 = _iterator47.n()).done;) {
        var prop = _step48.value;
        if (__propIsEnum$C.call(b, prop)) __defNormalProp$B(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator47.e(err);
    } finally {
      _iterator47.f();
    }
  }
  return a;
};
var __objRest$h = function __objRest$h(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$C.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$C) {
    var _iterator48 = _createForOfIteratorHelper(__getOwnPropSymbols$C(source)),
      _step49;
    try {
      for (_iterator48.s(); !(_step49 = _iterator48.n()).done;) {
        var prop = _step49.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$C.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator48.e(err);
    } finally {
      _iterator48.f();
    }
  }
  return target;
};
var defaultProps$8 = {};
var Anchor = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Anchor", defaultProps$8, props),
    component = _a.component,
    className = _a.className,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$h(_a, ["component", "className", "classNames", "styles"]);
  var _useStyles$5 = useStyles$5(null, {
      name: "Anchor",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$5.classes,
    cx = _useStyles$5.cx;
  var buttonProps = component === "button" ? {
    type: "button"
  } : null;
  return /* @__PURE__ */React__default.createElement(Text, __spreadValues$B(__spreadValues$B({
    component: component || "a",
    variant: "link",
    ref: ref,
    className: cx(classes.root, className)
  }, buttonProps), others));
});
Anchor.displayName = "@mantine/core/Anchor";
var AppShellContext = createContext({});
var AppShellProvider = AppShellContext.Provider;
function useAppShellContext() {
  return useContext(AppShellContext);
}
function getSortedBreakpoints(breakpoints, theme) {
  if (!breakpoints) {
    return [];
  }
  var values = Object.keys(breakpoints).filter(function (breakpoint) {
    return breakpoint !== "base";
  }).map(function (breakpoint) {
    return [theme.fn.size({
      size: breakpoint,
      sizes: theme.breakpoints
    }), breakpoints[breakpoint]];
  });
  values.sort(function (a, b) {
    return a[0] - b[0];
  });
  return values;
}
var __defProp$C = Object.defineProperty;
var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
var __hasOwnProp$D = Object.prototype.hasOwnProperty;
var __propIsEnum$D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$C = function __defNormalProp$C(obj, key, value) {
  return key in obj ? __defProp$C(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$C = function __spreadValues$C(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$D.call(b, prop)) __defNormalProp$C(a, prop, b[prop]);
  if (__getOwnPropSymbols$D) {
    var _iterator49 = _createForOfIteratorHelper(__getOwnPropSymbols$D(b)),
      _step50;
    try {
      for (_iterator49.s(); !(_step50 = _iterator49.n()).done;) {
        var prop = _step50.value;
        if (__propIsEnum$D.call(b, prop)) __defNormalProp$C(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator49.e(err);
    } finally {
      _iterator49.f();
    }
  }
  return a;
};
var __objRest$i = function __objRest$i(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$D.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$D) {
    var _iterator50 = _createForOfIteratorHelper(__getOwnPropSymbols$D(source)),
      _step51;
    try {
      for (_iterator50.s(); !(_step51 = _iterator50.n()).done;) {
        var prop = _step51.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$D.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator50.e(err);
    } finally {
      _iterator50.f();
    }
  }
  return target;
};
var Section = forwardRef(function (_a, ref) {
  var _b = _a,
    component = _b.component,
    children = _b.children,
    _b$grow = _b.grow,
    grow = _b$grow === void 0 ? false : _b$grow,
    sx = _b.sx,
    others = __objRest$i(_b, ["component", "children", "grow", "sx"]);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$C({
    component: component || "div",
    ref: ref,
    sx: [{
      flex: grow ? 1 : 0,
      boxSizing: "border-box"
    }].concat(_toConsumableArray2(Array.isArray(sx) ? sx : [sx]))
  }, others), children);
});
Section.displayName = "@mantine/core/Section";
var __defProp$D = Object.defineProperty;
var __defProps$f = Object.defineProperties;
var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$E = Object.getOwnPropertySymbols;
var __hasOwnProp$E = Object.prototype.hasOwnProperty;
var __propIsEnum$E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$D = function __defNormalProp$D(obj, key, value) {
  return key in obj ? __defProp$D(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$D = function __spreadValues$D(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$E.call(b, prop)) __defNormalProp$D(a, prop, b[prop]);
  if (__getOwnPropSymbols$E) {
    var _iterator51 = _createForOfIteratorHelper(__getOwnPropSymbols$E(b)),
      _step52;
    try {
      for (_iterator51.s(); !(_step52 = _iterator51.n()).done;) {
        var prop = _step52.value;
        if (__propIsEnum$E.call(b, prop)) __defNormalProp$D(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator51.e(err);
    } finally {
      _iterator51.f();
    }
  }
  return a;
};
var __spreadProps$f = function __spreadProps$f(a, b) {
  return __defProps$f(a, __getOwnPropDescs$f(b));
};
var useStyles$6 = createStyles(function (theme, _ref38) {
  var height = _ref38.height,
    width = _ref38.width,
    fixed = _ref38.fixed,
    position = _ref38.position,
    hiddenBreakpoint = _ref38.hiddenBreakpoint,
    zIndex = _ref38.zIndex,
    section = _ref38.section;
  var breakpoints = typeof width === "object" && width !== null ? getSortedBreakpoints(width, theme).reduce(function (acc, _ref39) {
    var _ref40 = _slicedToArray(_ref39, 2),
      breakpoint = _ref40[0],
      breakpointSize = _ref40[1];
    acc["@media (min-width: ".concat(breakpoint + 1, "px)")] = {
      width: breakpointSize,
      minWidth: breakpointSize
    };
    return acc;
  }, {}) : null;
  return {
    root: __spreadValues$D(__spreadProps$f(__spreadValues$D(__spreadValues$D({}, theme.fn.fontStyles()), position), _defineProperty({
      top: (position == null ? void 0 : position.top) || "var(--mantine-header-height)",
      zIndex: zIndex,
      height: height || "calc(100vh - var(--mantine-header-height, 0px) - var(--mantine-footer-height, 0px))",
      width: (width == null ? void 0 : width.base) || "100%",
      position: fixed ? "fixed" : "static",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
    }, section === "navbar" ? "borderRight" : "borderLeft", "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]))), breakpoints),
    hidden: _defineProperty({}, "@media (max-width: ".concat(theme.fn.size({
      size: hiddenBreakpoint,
      sizes: theme.breakpoints
    }), "px)"), {
      display: "none"
    })
  };
});
var __defProp$E = Object.defineProperty;
var __getOwnPropSymbols$F = Object.getOwnPropertySymbols;
var __hasOwnProp$F = Object.prototype.hasOwnProperty;
var __propIsEnum$F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$E = function __defNormalProp$E(obj, key, value) {
  return key in obj ? __defProp$E(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$E = function __spreadValues$E(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$F.call(b, prop)) __defNormalProp$E(a, prop, b[prop]);
  if (__getOwnPropSymbols$F) {
    var _iterator52 = _createForOfIteratorHelper(__getOwnPropSymbols$F(b)),
      _step53;
    try {
      for (_iterator52.s(); !(_step53 = _iterator52.n()).done;) {
        var prop = _step53.value;
        if (__propIsEnum$F.call(b, prop)) __defNormalProp$E(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator52.e(err);
    } finally {
      _iterator52.f();
    }
  }
  return a;
};
var __objRest$j = function __objRest$j(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$F.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$F) {
    var _iterator53 = _createForOfIteratorHelper(__getOwnPropSymbols$F(source)),
      _step54;
    try {
      for (_iterator53.s(); !(_step54 = _iterator53.n()).done;) {
        var prop = _step54.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$F.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator53.e(err);
    } finally {
      _iterator53.f();
    }
  }
  return target;
};
var HorizontalSection = forwardRef(function (_a, ref) {
  var _b = _a,
    width = _b.width,
    height = _b.height,
    _b$fixed = _b.fixed,
    fixed = _b$fixed === void 0 ? false : _b$fixed,
    position = _b.position,
    _b$zIndex = _b.zIndex,
    zIndex = _b$zIndex === void 0 ? getDefaultZIndex("app") : _b$zIndex,
    _b$hiddenBreakpoint = _b.hiddenBreakpoint,
    hiddenBreakpoint = _b$hiddenBreakpoint === void 0 ? "md" : _b$hiddenBreakpoint,
    _b$hidden = _b.hidden,
    hidden = _b$hidden === void 0 ? false : _b$hidden,
    className = _b.className,
    classNames = _b.classNames,
    styles = _b.styles,
    children = _b.children,
    section = _b.section,
    __staticSelector = _b.__staticSelector,
    others = __objRest$j(_b, ["width", "height", "fixed", "position", "zIndex", "hiddenBreakpoint", "hidden", "className", "classNames", "styles", "children", "section", "__staticSelector"]);
  var ctx = useAppShellContext();
  var _useStyles$6 = useStyles$6({
      width: width,
      height: height,
      fixed: ctx.fixed || fixed,
      position: position,
      hiddenBreakpoint: hiddenBreakpoint,
      zIndex: ctx.zIndex || zIndex,
      section: section
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$6.classes,
    cx = _useStyles$6.cx,
    theme = _useStyles$6.theme;
  var breakpoints = getSortedBreakpoints(width, theme).reduce(function (acc, _ref41) {
    var _ref42 = _slicedToArray(_ref41, 2),
      breakpoint = _ref42[0],
      breakpointSize = _ref42[1];
    acc["@media (min-width: ".concat(breakpoint + 1, "px)")] = _defineProperty({}, "--mantine-".concat(section, "-width"), "".concat(breakpointSize, "px"));
    return acc;
  }, {});
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$E({
    component: section === "navbar" ? "nav" : "aside",
    ref: ref,
    className: cx(classes.root, _defineProperty({}, classes.hidden, hidden), className)
  }, others), children, /* @__PURE__ */React__default.createElement(Global$1, {
    styles: function styles() {
      return {
        ":root": __spreadValues$E(_defineProperty({}, "--mantine-".concat(section, "-width"), (width == null ? void 0 : width.base) ? "".concat(width.base, "px") : "0px"), breakpoints)
      };
    }
  }));
});
HorizontalSection.Section = Section;
HorizontalSection.displayName = "@mantine/core/HorizontalSection";
var __defProp$F = Object.defineProperty;
var __getOwnPropSymbols$G = Object.getOwnPropertySymbols;
var __hasOwnProp$G = Object.prototype.hasOwnProperty;
var __propIsEnum$G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$F = function __defNormalProp$F(obj, key, value) {
  return key in obj ? __defProp$F(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$F = function __spreadValues$F(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$G.call(b, prop)) __defNormalProp$F(a, prop, b[prop]);
  if (__getOwnPropSymbols$G) {
    var _iterator54 = _createForOfIteratorHelper(__getOwnPropSymbols$G(b)),
      _step55;
    try {
      for (_iterator54.s(); !(_step55 = _iterator54.n()).done;) {
        var prop = _step55.value;
        if (__propIsEnum$G.call(b, prop)) __defNormalProp$F(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator54.e(err);
    } finally {
      _iterator54.f();
    }
  }
  return a;
};
var defaultProps$9 = {
  fixed: false,
  position: {
    top: 0,
    left: 0
  },
  zIndex: getDefaultZIndex("app"),
  hiddenBreakpoint: "md",
  hidden: false
};
var Navbar = forwardRef(function (props, ref) {
  var _props = useMantineDefaultProps("Navbar", defaultProps$9, props);
  return /* @__PURE__ */React__default.createElement(HorizontalSection, __spreadValues$F({
    section: "navbar",
    __staticSelector: "Navbar",
    ref: ref
  }, _props));
});
Navbar.Section = HorizontalSection.Section;
Navbar.displayName = "@mantine/core/Navbar";
var __defProp$G = Object.defineProperty;
var __defProps$g = Object.defineProperties;
var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$H = Object.getOwnPropertySymbols;
var __hasOwnProp$H = Object.prototype.hasOwnProperty;
var __propIsEnum$H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$G = function __defNormalProp$G(obj, key, value) {
  return key in obj ? __defProp$G(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$G = function __spreadValues$G(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$H.call(b, prop)) __defNormalProp$G(a, prop, b[prop]);
  if (__getOwnPropSymbols$H) {
    var _iterator55 = _createForOfIteratorHelper(__getOwnPropSymbols$H(b)),
      _step56;
    try {
      for (_iterator55.s(); !(_step56 = _iterator55.n()).done;) {
        var prop = _step56.value;
        if (__propIsEnum$H.call(b, prop)) __defNormalProp$G(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator55.e(err);
    } finally {
      _iterator55.f();
    }
  }
  return a;
};
var __spreadProps$g = function __spreadProps$g(a, b) {
  return __defProps$g(a, __getOwnPropDescs$g(b));
};
var useStyles$7 = createStyles(function (theme, _ref43) {
  var height = _ref43.height,
    fixed = _ref43.fixed,
    position = _ref43.position,
    zIndex = _ref43.zIndex,
    borderPosition = _ref43.borderPosition;
  return {
    root: __spreadProps$g(__spreadValues$G(__spreadValues$G({}, theme.fn.fontStyles()), position), {
      zIndex: zIndex,
      height: height,
      maxHeight: height,
      position: fixed ? "fixed" : "static",
      boxSizing: "border-box",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      borderBottom: borderPosition === "bottom" ? "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]) : void 0,
      borderTop: borderPosition === "top" ? "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]) : void 0
    })
  };
});
var __defProp$H = Object.defineProperty;
var __getOwnPropSymbols$I = Object.getOwnPropertySymbols;
var __hasOwnProp$I = Object.prototype.hasOwnProperty;
var __propIsEnum$I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$H = function __defNormalProp$H(obj, key, value) {
  return key in obj ? __defProp$H(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$H = function __spreadValues$H(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$I.call(b, prop)) __defNormalProp$H(a, prop, b[prop]);
  if (__getOwnPropSymbols$I) {
    var _iterator56 = _createForOfIteratorHelper(__getOwnPropSymbols$I(b)),
      _step57;
    try {
      for (_iterator56.s(); !(_step57 = _iterator56.n()).done;) {
        var prop = _step57.value;
        if (__propIsEnum$I.call(b, prop)) __defNormalProp$H(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator56.e(err);
    } finally {
      _iterator56.f();
    }
  }
  return a;
};
var __objRest$k = function __objRest$k(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$I.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$I) {
    var _iterator57 = _createForOfIteratorHelper(__getOwnPropSymbols$I(source)),
      _step58;
    try {
      for (_iterator57.s(); !(_step58 = _iterator57.n()).done;) {
        var prop = _step58.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$I.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator57.e(err);
    } finally {
      _iterator57.f();
    }
  }
  return target;
};
var VerticalSection = forwardRef(function (_a, ref) {
  var _b = _a,
    children = _b.children,
    className = _b.className,
    classNames = _b.classNames,
    styles = _b.styles,
    height = _b.height,
    _b$fixed2 = _b.fixed,
    fixed = _b$fixed2 === void 0 ? false : _b$fixed2,
    position = _b.position,
    _b$zIndex2 = _b.zIndex,
    zIndex = _b$zIndex2 === void 0 ? getDefaultZIndex("app") : _b$zIndex2,
    section = _b.section,
    __staticSelector = _b.__staticSelector,
    others = __objRest$k(_b, ["children", "className", "classNames", "styles", "height", "fixed", "position", "zIndex", "section", "__staticSelector"]);
  var ctx = useAppShellContext();
  var _useStyles$7 = useStyles$7({
      height: height,
      fixed: ctx.fixed || fixed,
      position: position,
      zIndex: ctx.zIndex || zIndex,
      borderPosition: section === "header" ? "bottom" : "top"
    }, {
      name: __staticSelector,
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$7.classes,
    cx = _useStyles$7.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$H({
    component: section === "header" ? "nav" : "footer",
    className: cx(classes.root, className),
    ref: ref
  }, others), children, /* @__PURE__ */React__default.createElement(Global$1, {
    styles: function styles() {
      return {
        ":root": _defineProperty({}, "--mantine-".concat(section, "-height"), "".concat(height, "px"))
      };
    }
  }));
});
VerticalSection.displayName = "@mantine/core/VerticalSection";
var __defProp$I = Object.defineProperty;
var __defProps$h = Object.defineProperties;
var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$J = Object.getOwnPropertySymbols;
var __hasOwnProp$J = Object.prototype.hasOwnProperty;
var __propIsEnum$J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$I = function __defNormalProp$I(obj, key, value) {
  return key in obj ? __defProp$I(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$I = function __spreadValues$I(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$J.call(b, prop)) __defNormalProp$I(a, prop, b[prop]);
  if (__getOwnPropSymbols$J) {
    var _iterator58 = _createForOfIteratorHelper(__getOwnPropSymbols$J(b)),
      _step59;
    try {
      for (_iterator58.s(); !(_step59 = _iterator58.n()).done;) {
        var prop = _step59.value;
        if (__propIsEnum$J.call(b, prop)) __defNormalProp$I(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator58.e(err);
    } finally {
      _iterator58.f();
    }
  }
  return a;
};
var __spreadProps$h = function __spreadProps$h(a, b) {
  return __defProps$h(a, __getOwnPropDescs$h(b));
};
var defaultProps$a = {
  fixed: false,
  position: {
    top: 0,
    left: 0,
    right: 0
  },
  zIndex: getDefaultZIndex("app")
};
var Header = forwardRef(function (props, ref) {
  var _props = useMantineDefaultProps("Header", defaultProps$a, props);
  return /* @__PURE__ */React__default.createElement(VerticalSection, __spreadProps$h(__spreadValues$I({
    section: "header",
    __staticSelector: "Header"
  }, _props), {
    ref: ref
  }));
});
Header.displayName = "@mantine/core/Header";
var __defProp$J = Object.defineProperty;
var __getOwnPropSymbols$K = Object.getOwnPropertySymbols;
var __hasOwnProp$K = Object.prototype.hasOwnProperty;
var __propIsEnum$K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$J = function __defNormalProp$J(obj, key, value) {
  return key in obj ? __defProp$J(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$J = function __spreadValues$J(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$K.call(b, prop)) __defNormalProp$J(a, prop, b[prop]);
  if (__getOwnPropSymbols$K) {
    var _iterator59 = _createForOfIteratorHelper(__getOwnPropSymbols$K(b)),
      _step60;
    try {
      for (_iterator59.s(); !(_step60 = _iterator59.n()).done;) {
        var prop = _step60.value;
        if (__propIsEnum$K.call(b, prop)) __defNormalProp$J(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator59.e(err);
    } finally {
      _iterator59.f();
    }
  }
  return a;
};
var defaultProps$b = {
  fixed: false,
  position: {
    top: 0,
    right: 0
  },
  zIndex: getDefaultZIndex("app"),
  hiddenBreakpoint: "md",
  hidden: false
};
var Aside = forwardRef(function (props, ref) {
  var _props = useMantineDefaultProps("Aside", defaultProps$b, props);
  return /* @__PURE__ */React__default.createElement(HorizontalSection, __spreadValues$J({
    section: "aside",
    __staticSelector: "Aside",
    ref: ref
  }, _props));
});
Aside.Section = HorizontalSection.Section;
Aside.displayName = "@mantine/core/Aside";
var __defProp$K = Object.defineProperty;
var __defProps$i = Object.defineProperties;
var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$L = Object.getOwnPropertySymbols;
var __hasOwnProp$L = Object.prototype.hasOwnProperty;
var __propIsEnum$L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$K = function __defNormalProp$K(obj, key, value) {
  return key in obj ? __defProp$K(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$K = function __spreadValues$K(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$L.call(b, prop)) __defNormalProp$K(a, prop, b[prop]);
  if (__getOwnPropSymbols$L) {
    var _iterator60 = _createForOfIteratorHelper(__getOwnPropSymbols$L(b)),
      _step61;
    try {
      for (_iterator60.s(); !(_step61 = _iterator60.n()).done;) {
        var prop = _step61.value;
        if (__propIsEnum$L.call(b, prop)) __defNormalProp$K(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator60.e(err);
    } finally {
      _iterator60.f();
    }
  }
  return a;
};
var __spreadProps$i = function __spreadProps$i(a, b) {
  return __defProps$i(a, __getOwnPropDescs$i(b));
};
var __objRest$l = function __objRest$l(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$L.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$L) {
    var _iterator61 = _createForOfIteratorHelper(__getOwnPropSymbols$L(source)),
      _step62;
    try {
      for (_iterator61.s(); !(_step62 = _iterator61.n()).done;) {
        var prop = _step62.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$L.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator61.e(err);
    } finally {
      _iterator61.f();
    }
  }
  return target;
};
var defaultProps$c = {
  fixed: false,
  position: {
    bottom: 0,
    left: 0,
    right: 0
  },
  zIndex: getDefaultZIndex("app")
};
var Footer = forwardRef(function (props, ref) {
  var others = __objRest$l(useMantineDefaultProps("Footer", defaultProps$c, props), []);
  return /* @__PURE__ */React__default.createElement(VerticalSection, __spreadProps$i(__spreadValues$K({
    section: "footer",
    __staticSelector: "Footer"
  }, others), {
    ref: ref
  }));
});
Footer.displayName = "@mantine/core/Footer";
var __defProp$L = Object.defineProperty;
var __getOwnPropSymbols$M = Object.getOwnPropertySymbols;
var __hasOwnProp$M = Object.prototype.hasOwnProperty;
var __propIsEnum$M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$L = function __defNormalProp$L(obj, key, value) {
  return key in obj ? __defProp$L(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$L = function __spreadValues$L(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$M.call(b, prop)) __defNormalProp$L(a, prop, b[prop]);
  if (__getOwnPropSymbols$M) {
    var _iterator62 = _createForOfIteratorHelper(__getOwnPropSymbols$M(b)),
      _step63;
    try {
      for (_iterator62.s(); !(_step63 = _iterator62.n()).done;) {
        var prop = _step63.value;
        if (__propIsEnum$M.call(b, prop)) __defNormalProp$L(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator62.e(err);
    } finally {
      _iterator62.f();
    }
  }
  return a;
};
function getPositionStyles(props, theme) {
  var _ref44;
  var padding = theme.fn.size({
    size: props.padding,
    sizes: theme.spacing
  });
  var navbarOffset = props.navbarOffsetBreakpoint ? theme.fn.size({
    size: props.navbarOffsetBreakpoint,
    sizes: theme.breakpoints
  }) : null;
  var asideOffset = props.asideOffsetBreakpoint ? theme.fn.size({
    size: props.asideOffsetBreakpoint,
    sizes: theme.breakpoints
  }) : null;
  if (!props.fixed) {
    return {
      padding: padding
    };
  }
  return _ref44 = {
    minHeight: "100vh",
    paddingTop: "calc(var(--mantine-header-height, 0px) + ".concat(padding, "px)"),
    paddingBottom: "calc(var(--mantine-footer-height, 0px) + ".concat(padding, "px)"),
    paddingLeft: "calc(var(--mantine-navbar-width, 0px) + ".concat(padding, "px)"),
    paddingRight: "calc(var(--mantine-aside-width, 0px) + ".concat(padding, "px)")
  }, _defineProperty(_ref44, "@media (max-width: ".concat(navbarOffset, "px)"), {
    paddingLeft: padding
  }), _defineProperty(_ref44, "@media (max-width: ".concat(asideOffset, "px)"), {
    paddingRight: padding
  }), _ref44;
}
var useStyles$8 = createStyles(function (theme, props) {
  return {
    root: {
      boxSizing: "border-box"
    },
    body: {
      display: "flex",
      boxSizing: "border-box"
    },
    main: __spreadValues$L({
      flex: 1,
      width: "100vw",
      boxSizing: "border-box"
    }, getPositionStyles(props, theme))
  };
});
var __defProp$M = Object.defineProperty;
var __getOwnPropSymbols$N = Object.getOwnPropertySymbols;
var __hasOwnProp$N = Object.prototype.hasOwnProperty;
var __propIsEnum$N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$M = function __defNormalProp$M(obj, key, value) {
  return key in obj ? __defProp$M(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$M = function __spreadValues$M(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$N.call(b, prop)) __defNormalProp$M(a, prop, b[prop]);
  if (__getOwnPropSymbols$N) {
    var _iterator63 = _createForOfIteratorHelper(__getOwnPropSymbols$N(b)),
      _step64;
    try {
      for (_iterator63.s(); !(_step64 = _iterator63.n()).done;) {
        var prop = _step64.value;
        if (__propIsEnum$N.call(b, prop)) __defNormalProp$M(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator63.e(err);
    } finally {
      _iterator63.f();
    }
  }
  return a;
};
var __objRest$m = function __objRest$m(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$N.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$N) {
    var _iterator64 = _createForOfIteratorHelper(__getOwnPropSymbols$N(source)),
      _step65;
    try {
      for (_iterator64.s(); !(_step65 = _iterator64.n()).done;) {
        var prop = _step65.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$N.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator64.e(err);
    } finally {
      _iterator64.f();
    }
  }
  return target;
};
var defaultProps$d = {
  fixed: false,
  zIndex: getDefaultZIndex("app"),
  padding: "md"
};
var AppShell = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("AppShell", defaultProps$d, props),
    children = _a.children,
    navbar = _a.navbar,
    header = _a.header,
    footer = _a.footer,
    aside = _a.aside,
    fixed = _a.fixed,
    zIndex = _a.zIndex,
    padding = _a.padding,
    navbarOffsetBreakpoint = _a.navbarOffsetBreakpoint,
    asideOffsetBreakpoint = _a.asideOffsetBreakpoint,
    className = _a.className,
    styles = _a.styles,
    classNames = _a.classNames,
    others = __objRest$m(_a, ["children", "navbar", "header", "footer", "aside", "fixed", "zIndex", "padding", "navbarOffsetBreakpoint", "asideOffsetBreakpoint", "className", "styles", "classNames"]);
  var _useStyles$8 = useStyles$8({
      padding: padding,
      fixed: fixed,
      navbarOffsetBreakpoint: navbarOffsetBreakpoint,
      asideOffsetBreakpoint: asideOffsetBreakpoint
    }, {
      styles: styles,
      classNames: classNames,
      name: "AppShell"
    }),
    classes = _useStyles$8.classes,
    cx = _useStyles$8.cx;
  return /* @__PURE__ */React__default.createElement(AppShellProvider, {
    value: {
      fixed: fixed,
      zIndex: zIndex
    }
  }, /* @__PURE__ */React__default.createElement(Box, __spreadValues$M({
    className: cx(classes.root, className),
    ref: ref
  }, others), header, /* @__PURE__ */React__default.createElement("div", {
    className: classes.body
  }, navbar, /* @__PURE__ */React__default.createElement("main", {
    className: classes.main
  }, children), aside), footer));
});
AppShell.displayName = "@mantine/core/AppShell";
var useStyles$9 = createStyles(function (theme, _ref45) {
  var ratio = _ref45.ratio;
  return {
    root: {
      position: "relative",
      maxWidth: "100%",
      "&::before": {
        content: '""',
        height: 0,
        display: "block",
        paddingBottom: "".concat(1 / ratio * 100, "%")
      },
      "&::after": {
        content: '""',
        display: "table",
        clear: "both"
      },
      "& > *:not(style)": {
        overflow: "hidden",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%"
      },
      "& > img, & > video": {
        objectFit: "cover"
      }
    }
  };
});
var __defProp$N = Object.defineProperty;
var __getOwnPropSymbols$O = Object.getOwnPropertySymbols;
var __hasOwnProp$O = Object.prototype.hasOwnProperty;
var __propIsEnum$O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$N = function __defNormalProp$N(obj, key, value) {
  return key in obj ? __defProp$N(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$N = function __spreadValues$N(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$O.call(b, prop)) __defNormalProp$N(a, prop, b[prop]);
  if (__getOwnPropSymbols$O) {
    var _iterator65 = _createForOfIteratorHelper(__getOwnPropSymbols$O(b)),
      _step66;
    try {
      for (_iterator65.s(); !(_step66 = _iterator65.n()).done;) {
        var prop = _step66.value;
        if (__propIsEnum$O.call(b, prop)) __defNormalProp$N(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator65.e(err);
    } finally {
      _iterator65.f();
    }
  }
  return a;
};
var __objRest$n = function __objRest$n(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$O.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$O) {
    var _iterator66 = _createForOfIteratorHelper(__getOwnPropSymbols$O(source)),
      _step67;
    try {
      for (_iterator66.s(); !(_step67 = _iterator66.n()).done;) {
        var prop = _step67.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$O.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator66.e(err);
    } finally {
      _iterator66.f();
    }
  }
  return target;
};
var AspectRatio = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("AspectRatio", {}, props),
    className = _a.className,
    ratio = _a.ratio,
    children = _a.children,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$n(_a, ["className", "ratio", "children", "classNames", "styles"]);
  var _useStyles$9 = useStyles$9({
      ratio: ratio
    }, {
      name: "AspectRatio",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$9.classes,
    cx = _useStyles$9.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$N({
    ref: ref,
    className: cx(classes.root, className)
  }, others), children);
});
AspectRatio.displayName = "@mantine/core/AspectRatio";
function composeEventHandlers(e, n) {
  var _ref46 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref46$checkForDefaul = _ref46.checkForDefaultPrevented,
    t = _ref46$checkForDefaul === void 0 ? !0 : _ref46$checkForDefaul;
  return function (r) {
    if (null == e || e(r), !1 === t || !r.defaultPrevented) return null == n ? void 0 : n(r);
  };
}
function clamp$1(t, _ref47) {
  var _ref48 = _slicedToArray(_ref47, 2),
    a = _ref48[0],
    n = _ref48[1];
  return Math.min(n, Math.max(a, t));
}
var useLayoutEffect$1 = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? useLayoutEffect : function () {};
function useDirection(t, n) {
  var _useState21 = useState("ltr"),
    _useState22 = _slicedToArray(_useState21, 2),
    r = _useState22[0],
    o = _useState22[1],
    _useState23 = useState(),
    _useState24 = _slicedToArray(_useState23, 2),
    i = _useState24[0],
    u = _useState24[1],
    c = useRef(0);
  return useEffect(function () {
    if (void 0 === n && null != t && t.parentElement) {
      var _e = getComputedStyle(t.parentElement);
      u(_e);
    }
  }, [t, n]), useEffect(function () {
    return void 0 === n && function e() {
      c.current = requestAnimationFrame(function () {
        var t = null == i ? void 0 : i.direction;
        t && o(t), e();
      });
    }(), function () {
      return cancelAnimationFrame(c.current);
    };
  }, [i, n, o]), n || r;
}
function useCallbackRef(r) {
  var t = useRef(r);
  return useEffect(function () {
    t.current = r;
  }), useMemo(function () {
    return function () {
      var _r;
      var r;
      for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        e[_key9] = arguments[_key9];
      }
      return null === (r = t.current) || void 0 === r ? void 0 : (_r = r).call.apply(_r, [t].concat(e));
    };
  }, []);
}
function composeRefs() {
  for (var _len10 = arguments.length, o = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    o[_key10] = arguments[_key10];
  }
  return function (e) {
    return o.forEach(function (o) {
      return function (o, e) {
        "function" == typeof o ? o(e) : null != o && (o.current = e);
      }(o, e);
    });
  };
}
function useComposedRefs() {
  for (var _len11 = arguments.length, e = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    e[_key11] = arguments[_key11];
  }
  return useCallback(composeRefs.apply(void 0, e), e);
}
function createContextScope(n) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var r = [];
  var c = function c() {
    var t = r.map(function (t) {
      return /*#__PURE__*/createContext(t);
    });
    return function (o) {
      var r = (null == o ? void 0 : o[n]) || t;
      return useMemo(function () {
        return _defineProperty({}, "__scope".concat(n), _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, n, r)));
      }, [o, r]);
    };
  };
  return c.scopeName = n, [function (t, o) {
    var c = /*#__PURE__*/createContext(o),
      u = r.length;
    function s(t) {
      var o = t.scope,
        r = t.children,
        s = _objectWithoutProperties2(t, _excluded),
        i = (null == o ? void 0 : o[n][u]) || c,
        a = useMemo(function () {
          return s;
        }, Object.values(s)); /*#__PURE__*/
      return createElement(i.Provider, {
        value: a
      }, r);
    }
    return r = [].concat(_toConsumableArray2(r), [o]), s.displayName = t + "Provider", [s, function (r, s) {
      var i = (null == s ? void 0 : s[n][u]) || c,
        a = useContext(i);
      if (a) return a;
      if (void 0 !== o) return o;
      throw new Error("`".concat(r, "` must be used within `").concat(t, "`"));
    }];
  }, t$2.apply(void 0, [c].concat(_toConsumableArray2(o)))];
}
function t$2() {
  for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    t[_key12] = arguments[_key12];
  }
  var n = t[0];
  if (1 === t.length) return n;
  var o = function o() {
    var o = t.map(function (e) {
      return {
        useScope: e(),
        scopeName: e.scopeName
      };
    });
    return function (t) {
      var r = o.reduce(function (e, _ref50) {
        var n = _ref50.useScope,
          o = _ref50.scopeName;
        return _objectSpread(_objectSpread({}, e), n(t)["__scope".concat(o)]);
      }, {});
      return useMemo(function () {
        return _defineProperty({}, "__scope".concat(n.scopeName), r);
      }, [r]);
    };
  };
  return o.scopeName = n.scopeName, o;
}
var Presence = function Presence(u) {
  var o = u.present,
    i = u.children,
    s = function (n) {
      var _useState25 = useState(),
        _useState26 = _slicedToArray(_useState25, 2),
        u = _useState26[0],
        o = _useState26[1],
        i = useRef({}),
        s = useRef(n),
        c = useRef("none"),
        a = n ? "mounted" : "unmounted",
        _ref52 = function (e, n) {
          return useReducer(function (e, t) {
            var r = n[e][t];
            return null != r ? r : e;
          }, e);
        }(a, {
          mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
          },
          unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
          },
          unmounted: {
            MOUNT: "mounted"
          }
        }),
        _ref53 = _slicedToArray(_ref52, 2),
        d = _ref53[0],
        m = _ref53[1];
      return useEffect(function () {
        var e = r$3(i.current);
        c.current = "mounted" === d ? e : "none";
      }, [d]), useLayoutEffect$1(function () {
        var e = i.current,
          t = s.current;
        if (t !== n) {
          var _u = c.current,
            _o = r$3(e);
          if (n) m("MOUNT");else if ("none" === _o || "none" === (null == e ? void 0 : e.display)) m("UNMOUNT");else {
            var _e2 = _u !== _o;
            m(t && _e2 ? "ANIMATION_OUT" : "UNMOUNT");
          }
          s.current = n;
        }
      }, [n, m]), useLayoutEffect$1(function () {
        if (u) {
          var _e3 = function _e3(e) {
              var n = r$3(i.current).includes(e.animationName);
              e.target === u && n && m("ANIMATION_END");
            },
            _n = function _n(e) {
              e.target === u && (c.current = r$3(i.current));
            };
          return u.addEventListener("animationstart", _n), u.addEventListener("animationcancel", _e3), u.addEventListener("animationend", _e3), function () {
            u.removeEventListener("animationstart", _n), u.removeEventListener("animationcancel", _e3), u.removeEventListener("animationend", _e3);
          };
        }
        m("ANIMATION_END");
      }, [u, m]), {
        isPresent: ["mounted", "unmountSuspended"].includes(d),
        ref: useCallback(function (e) {
          e && (i.current = getComputedStyle(e)), o(e);
        }, [])
      };
    }(o),
    c = "function" == typeof i ? i({
      present: s.isPresent
    }) : Children.only(i),
    a = useComposedRefs(s.ref, c.ref);
  return "function" == typeof i || s.isPresent ? /*#__PURE__*/cloneElement(c, {
    ref: a
  }) : null;
};
function r$3(e) {
  return (null == e ? void 0 : e.animationName) || "none";
}
Presence.displayName = "Presence";
var Slot = /*#__PURE__*/forwardRef(function (e, o) {
  var a = e.children,
    s = _objectWithoutProperties2(e, _excluded2);
  return Children.toArray(a).some(l$2) ? /*#__PURE__*/createElement(Fragment, null, Children.map(a, function (e) {
    return l$2(e) ? /*#__PURE__*/createElement(n$2, _extends({}, s, {
      ref: o
    }), e.props.children) : e;
  })) : /*#__PURE__*/createElement(n$2, _extends({}, s, {
    ref: o
  }), a);
});
Slot.displayName = "Slot";
var n$2 = /*#__PURE__*/forwardRef(function (r, n) {
  var l = r.children,
    a = _objectWithoutProperties2(r, _excluded3); /*#__PURE__*/
  return isValidElement(l) ? /*#__PURE__*/cloneElement(l, _objectSpread(_objectSpread({}, o$1(a, l.props)), {}, {
    ref: composeRefs(n, l.ref)
  })) : Children.count(l) > 1 ? Children.only(null) : null;
});
n$2.displayName = "SlotClone";
var Slottable = function Slottable(_ref54) {
  var e = _ref54.children;
  return /*#__PURE__*/createElement(Fragment, null, e);
};
function l$2(e) {
  /*#__PURE__*/return isValidElement(e) && e.type === Slottable;
}
function o$1(e, t) {
  var r = _objectSpread({}, t);
  var _loop2 = function _loop2() {
    var l = e[_n2],
      o = t[_n2];
    /^on[A-Z]/.test(_n2) ? r[_n2] = function () {
      null == o || o.apply(void 0, arguments), null == l || l.apply(void 0, arguments);
    } : "style" === _n2 ? r[_n2] = _objectSpread(_objectSpread({}, l), o) : "className" === _n2 && (r[_n2] = [l, o].filter(Boolean).join(" "));
  };
  for (var _n2 in t) {
    _loop2();
  }
  return _objectSpread(_objectSpread({}, e), r);
}
var Primitive = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (o, i) {
  return _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, i, /*#__PURE__*/forwardRef(function (o, m) {
    var a = o.asChild,
      s = _objectWithoutProperties2(o, _excluded4),
      n = a ? Slot : i;
    return useEffect(function () {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /*#__PURE__*/createElement(n, _extends({}, s, {
      ref: m
    }));
  })));
}, {});
var _createContextScope = createContextScope("ScrollArea"),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  d$2 = _createContextScope2[0],
  p$2 = _createContextScope2[1];
var _d$ = d$2("ScrollArea"),
  _d$2 = _slicedToArray(_d$, 2),
  f$2 = _d$2[0],
  h$2 = _d$2[1];
var ScrollArea = /*#__PURE__*/forwardRef(function (e, r) {
  var t = e.__scopeScrollArea,
    _e$type = e.type,
    n = _e$type === void 0 ? "hover" : _e$type,
    _e$scrollHideDelay = e.scrollHideDelay,
    i = _e$scrollHideDelay === void 0 ? 600 : _e$scrollHideDelay,
    a = _objectWithoutProperties2(e, _excluded5),
    _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    d = _useState28[0],
    p = _useState28[1],
    _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    h = _useState30[0],
    m = _useState30[1],
    _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    w = _useState32[0],
    b = _useState32[1],
    _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    v = _useState34[0],
    S = _useState34[1],
    _useState35 = useState(null),
    _useState36 = _slicedToArray(_useState35, 2),
    g = _useState36[0],
    E = _useState36[1],
    _useState37 = useState(0),
    _useState38 = _slicedToArray(_useState37, 2),
    C = _useState38[0],
    T = _useState38[1],
    _useState39 = useState(0),
    _useState40 = _slicedToArray(_useState39, 2),
    y = _useState40[0],
    A = _useState40[1],
    _useState41 = useState(!1),
    _useState42 = _slicedToArray(_useState41, 2),
    x = _useState42[0],
    R = _useState42[1],
    _useState43 = useState(!1),
    _useState44 = _slicedToArray(_useState43, 2),
    P = _useState44[0],
    L = _useState44[1],
    _ = useComposedRefs(r, function (e) {
      return p(e);
    }),
    D = useDirection(d, a.dir); /*#__PURE__*/
  return createElement(f$2, {
    scope: t,
    type: n,
    dir: D,
    scrollHideDelay: i,
    scrollArea: d,
    viewport: h,
    onViewportChange: m,
    content: w,
    onContentChange: b,
    scrollbarX: v,
    onScrollbarXChange: S,
    scrollbarXEnabled: x,
    onScrollbarXEnabledChange: R,
    scrollbarY: g,
    onScrollbarYChange: E,
    scrollbarYEnabled: P,
    onScrollbarYEnabledChange: L,
    onCornerWidthChange: T,
    onCornerHeightChange: A
  }, /*#__PURE__*/createElement(Primitive.div, _extends({}, a, {
    ref: _,
    style: _objectSpread({
      position: "relative",
      "--radix-scroll-area-corner-width": C + "px",
      "--radix-scroll-area-corner-height": y + "px"
    }, e.style)
  })));
}); /*#__PURE__*/
var ScrollAreaViewport = /*#__PURE__*/forwardRef(function (e, r) {
  var t = e.__scopeScrollArea,
    o = e.children,
    n = _objectWithoutProperties2(e, _excluded6),
    i = h$2("ScrollAreaViewport", t),
    a = useRef(null),
    d = useComposedRefs(r, a, i.onViewportChange); /*#__PURE__*/
  return createElement(Fragment, null, /*#__PURE__*/createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /*#__PURE__*/createElement(Primitive.div, _extends({
    "data-radix-scroll-area-viewport": ""
  }, n, {
    ref: d,
    style: _objectSpread({
      overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: i.scrollbarYEnabled ? "scroll" : "hidden"
    }, e.style)
  }), /*#__PURE__*/createElement("div", {
    ref: i.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, o)));
}); /*#__PURE__*/
var ScrollAreaScrollbar = /*#__PURE__*/forwardRef(function (e, r) {
  var t = e.forceMount,
    o = _objectWithoutProperties2(e, _excluded7),
    n = h$2("ScrollAreaScrollbar", e.__scopeScrollArea),
    l = n.onScrollbarXEnabledChange,
    i = n.onScrollbarYEnabledChange,
    a = "horizontal" === e.orientation;
  return useEffect(function () {
    return a ? l(!0) : i(!0), function () {
      a ? l(!1) : i(!1);
    };
  }, [a, l, i]), "hover" === n.type ? /*#__PURE__*/createElement(m$2, _extends({}, o, {
    ref: r,
    forceMount: t
  })) : "scroll" === n.type ? /*#__PURE__*/createElement(w$2, _extends({}, o, {
    ref: r,
    forceMount: t
  })) : "auto" === n.type ? /*#__PURE__*/createElement(b$2, _extends({}, o, {
    ref: r,
    forceMount: t
  })) : "always" === n.type ? /*#__PURE__*/createElement(v$2, _extends({}, o, {
    ref: r
  })) : null;
}); /*#__PURE__*/
var m$2 = /*#__PURE__*/forwardRef(function (e, r) {
    var t = e.forceMount,
      o = _objectWithoutProperties2(e, _excluded8),
      n = h$2("ScrollAreaScrollbar", e.__scopeScrollArea),
      _useState45 = useState(!1),
      _useState46 = _slicedToArray(_useState45, 2),
      l = _useState46[0],
      i = _useState46[1];
    return useEffect(function () {
      var e = n.scrollArea;
      var r = 0;
      if (e) {
        var _t = function _t() {
            window.clearTimeout(r), i(!0);
          },
          _o2 = function _o2() {
            r = window.setTimeout(function () {
              return i(!1);
            }, n.scrollHideDelay);
          };
        return e.addEventListener("pointerenter", _t), e.addEventListener("pointerleave", _o2), function () {
          e.removeEventListener("pointerenter", _t), e.removeEventListener("pointerleave", _o2);
        };
      }
    }, [n.scrollArea, n.scrollHideDelay]), /*#__PURE__*/createElement(Presence, {
      present: t || l
    }, /*#__PURE__*/createElement(b$2, _extends({
      "data-state": l ? "visible" : "hidden"
    }, o, {
      ref: r
    })));
  }),
  w$2 = /*#__PURE__*/forwardRef(function (r, t) {
    var o = r.forceMount,
      n = _objectWithoutProperties2(r, _excluded9),
      l = h$2("ScrollAreaScrollbar", r.__scopeScrollArea),
      i = "horizontal" === r.orientation,
      c = z$2(function () {
        return p("SCROLL_END");
      }, 100),
      _ref49 = (f = "hidden", m = {
        hidden: {
          SCROLL: "scrolling"
        },
        scrolling: {
          SCROLL_END: "idle",
          POINTER_ENTER: "interacting"
        },
        interacting: {
          SCROLL: "interacting",
          POINTER_LEAVE: "idle"
        },
        idle: {
          HIDE: "hidden",
          SCROLL: "scrolling",
          POINTER_ENTER: "interacting"
        }
      }, useReducer(function (e, r) {
        var t = m[e][r];
        return null != t ? t : e;
      }, f)),
      _ref51 = _slicedToArray(_ref49, 2),
      d = _ref51[0],
      p = _ref51[1];
    var f, m;
    return useEffect(function () {
      if ("idle" === d) {
        var _e4 = window.setTimeout(function () {
          return p("HIDE");
        }, l.scrollHideDelay);
        return function () {
          return window.clearTimeout(_e4);
        };
      }
    }, [d, l.scrollHideDelay, p]), useEffect(function () {
      var e = l.viewport,
        r = i ? "scrollLeft" : "scrollTop";
      if (e) {
        var _t2 = e[r];
        var _o3 = function _o3() {
          var o = e[r];
          _t2 !== o && (p("SCROLL"), c()), _t2 = o;
        };
        return e.addEventListener("scroll", _o3), function () {
          return e.removeEventListener("scroll", _o3);
        };
      }
    }, [l.viewport, i, p, c]), /*#__PURE__*/createElement(Presence, {
      present: o || "hidden" !== d
    }, /*#__PURE__*/createElement(v$2, _extends({
      "data-state": "hidden" === d ? "hidden" : "visible"
    }, n, {
      ref: t,
      onPointerEnter: composeEventHandlers(r.onPointerEnter, function () {
        return p("POINTER_ENTER");
      }),
      onPointerLeave: composeEventHandlers(r.onPointerLeave, function () {
        return p("POINTER_LEAVE");
      })
    })));
  }),
  b$2 = /*#__PURE__*/forwardRef(function (e, r) {
    var t = h$2("ScrollAreaScrollbar", e.__scopeScrollArea),
      o = e.forceMount,
      n = _objectWithoutProperties2(e, _excluded10),
      _useState47 = useState(!1),
      _useState48 = _slicedToArray(_useState47, 2),
      l = _useState48[0],
      i = _useState48[1],
      c = "horizontal" === e.orientation,
      d = z$2(function () {
        if (t.viewport) {
          var _e5 = t.viewport.offsetWidth < t.viewport.scrollWidth,
            _r2 = t.viewport.offsetHeight < t.viewport.scrollHeight;
          i(c ? _e5 : _r2);
        }
      }, 10);
    return H$1(t.viewport, d), H$1(t.content, d), /*#__PURE__*/createElement(Presence, {
      present: o || l
    }, /*#__PURE__*/createElement(v$2, _extends({
      "data-state": l ? "visible" : "hidden"
    }, n, {
      ref: r
    })));
  }),
  v$2 = /*#__PURE__*/forwardRef(function (e, r) {
    var _e$orientation = e.orientation,
      t = _e$orientation === void 0 ? "vertical" : _e$orientation,
      o = _objectWithoutProperties2(e, _excluded11),
      n = h$2("ScrollAreaScrollbar", e.__scopeScrollArea),
      l = useRef(null),
      i = useRef(0),
      _useState49 = useState({
        content: 0,
        viewport: 0,
        scrollbar: {
          size: 0,
          paddingStart: 0,
          paddingEnd: 0
        }
      }),
      _useState50 = _slicedToArray(_useState49, 2),
      a = _useState50[0],
      c = _useState50[1],
      d = x$2(a.viewport, a.content),
      p = _objectSpread(_objectSpread({}, o), {}, {
        sizes: a,
        onSizesChange: c,
        hasThumb: Boolean(d > 0 && d < 1),
        onThumbChange: function onThumbChange(e) {
          return l.current = e;
        },
        onThumbPointerUp: function onThumbPointerUp() {
          return i.current = 0;
        },
        onThumbPointerDown: function onThumbPointerDown(e) {
          return i.current = e;
        }
      });
    function f(e, r) {
      return function (e, r, t) {
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ltr";
        var n = R$1(t),
          l = n / 2,
          i = r || l,
          a = n - i,
          c = t.scrollbar.paddingStart + i,
          s = t.scrollbar.size - t.scrollbar.paddingEnd - a,
          u = t.content - t.viewport;
        return L$1([c, s], "ltr" === o ? [0, u] : [-1 * u, 0])(e);
      }(e, i.current, a, r);
    }
    return "horizontal" === t ? /*#__PURE__*/createElement(S$1, _extends({}, p, {
      ref: r,
      onThumbPositionChange: function onThumbPositionChange() {
        if (n.viewport && l.current) {
          var _e6 = P$1(n.viewport.scrollLeft, a, n.dir);
          l.current.style.transform = "translate3d(".concat(_e6, "px, 0, 0)");
        }
      },
      onWheelScroll: function onWheelScroll(e) {
        n.viewport && (n.viewport.scrollLeft = e);
      },
      onDragScroll: function onDragScroll(e) {
        n.viewport && (n.viewport.scrollLeft = f(e, n.dir));
      }
    })) : "vertical" === t ? /*#__PURE__*/createElement(g$2, _extends({}, p, {
      ref: r,
      onThumbPositionChange: function onThumbPositionChange() {
        if (n.viewport && l.current) {
          var _e7 = P$1(n.viewport.scrollTop, a);
          l.current.style.transform = "translate3d(0, ".concat(_e7, "px, 0)");
        }
      },
      onWheelScroll: function onWheelScroll(e) {
        n.viewport && (n.viewport.scrollTop = e);
      },
      onDragScroll: function onDragScroll(e) {
        n.viewport && (n.viewport.scrollTop = f(e));
      }
    })) : null;
  }),
  S$1 = /*#__PURE__*/forwardRef(function (e, r) {
    var t = e.sizes,
      o = e.onSizesChange,
      n = _objectWithoutProperties2(e, _excluded12),
      i = h$2("ScrollAreaScrollbar", e.__scopeScrollArea),
      _useState51 = useState(),
      _useState52 = _slicedToArray(_useState51, 2),
      a = _useState52[0],
      c = _useState52[1],
      d = useRef(null),
      p = useComposedRefs(r, d, i.onScrollbarXChange);
    return useEffect(function () {
      d.current && c(getComputedStyle(d.current));
    }, [d]), /*#__PURE__*/createElement(T$1, _extends({
      "data-orientation": "horizontal"
    }, n, {
      ref: p,
      sizes: t,
      style: _objectSpread({
        bottom: 0,
        left: "rtl" === i.dir ? "var(--radix-scroll-area-corner-width)" : 0,
        right: "ltr" === i.dir ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": R$1(t) + "px"
      }, e.style),
      onThumbPointerDown: function onThumbPointerDown(r) {
        return e.onThumbPointerDown(r.x);
      },
      onDragScroll: function onDragScroll(r) {
        return e.onDragScroll(r.x);
      },
      onWheelScroll: function onWheelScroll(r, t) {
        if (i.viewport) {
          var _o4 = i.viewport.scrollLeft + r.deltaX;
          e.onWheelScroll(_o4), _$1(_o4, t) && r.preventDefault();
        }
      },
      onResize: function onResize() {
        d.current && i.viewport && a && o({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: d.current.clientWidth,
            paddingStart: A$2(a.paddingLeft),
            paddingEnd: A$2(a.paddingRight)
          }
        });
      }
    }));
  }),
  g$2 = /*#__PURE__*/forwardRef(function (e, r) {
    var t = e.sizes,
      o = e.onSizesChange,
      n = _objectWithoutProperties2(e, _excluded13),
      i = h$2("ScrollAreaScrollbar", e.__scopeScrollArea),
      _useState53 = useState(),
      _useState54 = _slicedToArray(_useState53, 2),
      a = _useState54[0],
      c = _useState54[1],
      d = useRef(null),
      p = useComposedRefs(r, d, i.onScrollbarYChange);
    return useEffect(function () {
      d.current && c(getComputedStyle(d.current));
    }, [d]), /*#__PURE__*/createElement(T$1, _extends({
      "data-orientation": "vertical"
    }, n, {
      ref: p,
      sizes: t,
      style: _objectSpread({
        top: 0,
        right: "ltr" === i.dir ? 0 : void 0,
        left: "rtl" === i.dir ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": R$1(t) + "px"
      }, e.style),
      onThumbPointerDown: function onThumbPointerDown(r) {
        return e.onThumbPointerDown(r.y);
      },
      onDragScroll: function onDragScroll(r) {
        return e.onDragScroll(r.y);
      },
      onWheelScroll: function onWheelScroll(r, t) {
        if (i.viewport) {
          var _o5 = i.viewport.scrollTop + r.deltaY;
          e.onWheelScroll(_o5), _$1(_o5, t) && r.preventDefault();
        }
      },
      onResize: function onResize() {
        d.current && i.viewport && a && o({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: d.current.clientHeight,
            paddingStart: A$2(a.paddingTop),
            paddingEnd: A$2(a.paddingBottom)
          }
        });
      }
    }));
  }),
  _d$3 = d$2("ScrollAreaScrollbar"),
  _d$4 = _slicedToArray(_d$3, 2),
  E$1 = _d$4[0],
  C$1 = _d$4[1],
  T$1 = /*#__PURE__*/forwardRef(function (r, t) {
    var o = r.__scopeScrollArea,
      i = r.sizes,
      a = r.hasThumb,
      d = r.onThumbChange,
      p = r.onThumbPointerUp,
      f = r.onThumbPointerDown,
      m = r.onThumbPositionChange,
      w = r.onDragScroll,
      b = r.onWheelScroll,
      v = r.onResize,
      S = _objectWithoutProperties2(r, _excluded14),
      g = h$2("ScrollAreaScrollbar", o),
      _useState55 = useState(null),
      _useState56 = _slicedToArray(_useState55, 2),
      C = _useState56[0],
      T = _useState56[1],
      y = useComposedRefs(t, function (e) {
        return T(e);
      }),
      A = useRef(null),
      x = useRef(""),
      R = g.viewport,
      P = i.content - i.viewport,
      L = useCallbackRef(b),
      _ = useCallbackRef(m),
      D = z$2(v, 10);
    function W(e) {
      if (A.current) {
        var _r3 = e.clientX - A.current.left,
          _t3 = e.clientY - A.current.top;
        w({
          x: _r3,
          y: _t3
        });
      }
    }
    return useEffect(function () {
      var e = function e(_e8) {
        var r = _e8.target;
        (null == C ? void 0 : C.contains(r)) && L(_e8, P);
      };
      return document.addEventListener("wheel", e, {
        passive: !1
      }), function () {
        return document.removeEventListener("wheel", e, {
          passive: !1
        });
      };
    }, [R, C, P, L]), useEffect(_, [i, _]), H$1(C, D), H$1(g.content, D), /*#__PURE__*/createElement(E$1, {
      scope: o,
      scrollbar: C,
      hasThumb: a,
      onThumbChange: useCallbackRef(d),
      onThumbPointerUp: useCallbackRef(p),
      onThumbPositionChange: _,
      onThumbPointerDown: useCallbackRef(f)
    }, /*#__PURE__*/createElement(Primitive.div, _extends({}, S, {
      ref: y,
      style: _objectSpread({
        position: "absolute"
      }, S.style),
      onPointerDown: composeEventHandlers(r.onPointerDown, function (e) {
        if (0 === e.button) {
          e.target.setPointerCapture(e.pointerId), A.current = C.getBoundingClientRect(), x.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", W(e);
        }
      }),
      onPointerMove: composeEventHandlers(r.onPointerMove, W),
      onPointerUp: composeEventHandlers(r.onPointerUp, function (e) {
        e.target.releasePointerCapture(e.pointerId), document.body.style.webkitUserSelect = x.current, A.current = null;
      })
    })));
  });
var ScrollAreaThumb = /*#__PURE__*/forwardRef(function (r, t) {
  var o = r.__scopeScrollArea,
    n = r.style,
    i = _objectWithoutProperties2(r, _excluded15),
    a = h$2("ScrollbarThumb", o),
    d = C$1("ScrollbarThumb", o),
    p = d.onThumbPositionChange,
    f = useComposedRefs(t, function (e) {
      return d.onThumbChange(e);
    }),
    m = useRef(),
    w = z$2(function () {
      m.current && (m.current(), m.current = void 0);
    }, 100);
  return useEffect(function () {
    var e = a.viewport;
    if (e) {
      var _r4 = function _r4() {
        if (w(), !m.current) {
          var _r5 = D$1(e, p);
          m.current = _r5, p();
        }
      };
      return p(), e.addEventListener("scroll", _r4), function () {
        return e.removeEventListener("scroll", _r4);
      };
    }
  }, [a.viewport, w, p]), d.hasThumb ? /*#__PURE__*/createElement(Primitive.div, _extends({}, i, {
    ref: f,
    style: _objectSpread({
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)"
    }, n),
    onPointerDownCapture: composeEventHandlers(r.onPointerDownCapture, function (e) {
      var r = e.target.getBoundingClientRect(),
        t = e.clientX - r.left,
        o = e.clientY - r.top;
      d.onThumbPointerDown({
        x: t,
        y: o
      });
    }),
    onPointerUp: composeEventHandlers(r.onPointerUp, d.onThumbPointerUp)
  })) : null;
}); /*#__PURE__*/
var ScrollAreaCorner = /*#__PURE__*/forwardRef(function (e, r) {
  var t = h$2("ScrollAreaCorner", e.__scopeScrollArea),
    o = Boolean(t.scrollbarX && t.scrollbarY);
  return "scroll" !== t.type && o ? /*#__PURE__*/createElement(y$2, _extends({}, e, {
    ref: r
  })) : null;
}); /*#__PURE__*/
var y$2 = /*#__PURE__*/forwardRef(function (e, r) {
  var t = e.__scopeScrollArea,
    o = _objectWithoutProperties2(e, _excluded16),
    n = h$2("ScrollAreaCorner", t),
    _useState57 = useState(0),
    _useState58 = _slicedToArray(_useState57, 2),
    l = _useState58[0],
    i = _useState58[1],
    _useState59 = useState(0),
    _useState60 = _slicedToArray(_useState59, 2),
    a = _useState60[0],
    d = _useState60[1],
    p = Boolean(l && a);
  return H$1(n.scrollbarX, function () {
    var e;
    var r = (null === (e = n.scrollbarX) || void 0 === e ? void 0 : e.offsetHeight) || 0;
    n.onCornerHeightChange(r), d(r);
  }), H$1(n.scrollbarY, function () {
    var e;
    var r = (null === (e = n.scrollbarY) || void 0 === e ? void 0 : e.offsetWidth) || 0;
    n.onCornerWidthChange(r), i(r);
  }), p ? /*#__PURE__*/createElement(Primitive.div, _extends({}, o, {
    ref: r,
    style: _objectSpread({
      width: l,
      height: a,
      position: "absolute",
      right: "ltr" === n.dir ? 0 : void 0,
      left: "rtl" === n.dir ? 0 : void 0,
      bottom: 0
    }, e.style)
  })) : null;
});
function A$2(e) {
  return e ? parseInt(e, 10) : 0;
}
function x$2(e, r) {
  var t = e / r;
  return isNaN(t) ? 0 : t;
}
function R$1(e) {
  var r = x$2(e.viewport, e.content),
    t = e.scrollbar.paddingStart + e.scrollbar.paddingEnd,
    o = (e.scrollbar.size - t) * r;
  return Math.max(o, 18);
}
function P$1(e, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ltr";
  var n = R$1(t),
    l = t.scrollbar.paddingStart + t.scrollbar.paddingEnd,
    i = t.scrollbar.size - l,
    a = t.content - t.viewport,
    c = i - n,
    s = clamp$1(e, "ltr" === o ? [0, a] : [-1 * a, 0]);
  return L$1([0, a], [0, c])(s);
}
function L$1(e, r) {
  return function (t) {
    if (e[0] === e[1] || r[0] === r[1]) return r[0];
    var o = (r[1] - r[0]) / (e[1] - e[0]);
    return r[0] + o * (t - e[0]);
  };
}
function _$1(e, r) {
  return e > 0 && e < r;
}
var D$1 = function D$1(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var t = {
      left: e.scrollLeft,
      top: e.scrollTop
    },
    o = 0;
  return function n() {
    var l = {
        left: e.scrollLeft,
        top: e.scrollTop
      },
      i = t.left !== l.left,
      a = t.top !== l.top;
    (i || a) && r(), t = l, o = window.requestAnimationFrame(n);
  }(), function () {
    return window.cancelAnimationFrame(o);
  };
};
function z$2(e, r) {
  var t = useCallbackRef(e),
    o = useRef(0);
  return useEffect(function () {
    return function () {
      return window.clearTimeout(o.current);
    };
  }, []), useCallback(function () {
    window.clearTimeout(o.current), o.current = window.setTimeout(t, r);
  }, [t, r]);
}
function H$1(e, r) {
  var o = useCallbackRef(r);
  useLayoutEffect$1(function () {
    var r = 0;
    if (e) {
      var _t4 = new ResizeObserver(function () {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(o);
      });
      return _t4.observe(e), function () {
        window.cancelAnimationFrame(r), _t4.unobserve(e);
      };
    }
  }, [e, o]);
}
var Root$2 = ScrollArea;
var Viewport = ScrollAreaViewport;
var Scrollbar = ScrollAreaScrollbar;
var Thumb = ScrollAreaThumb;
var Corner = ScrollAreaCorner;
var useStyles$a = createStyles(function (theme, _ref55, getRef) {
  var scrollbarSize = _ref55.scrollbarSize,
    offsetScrollbars = _ref55.offsetScrollbars,
    scrollbarHovered = _ref55.scrollbarHovered;
  return {
    root: {
      overflow: "hidden"
    },
    viewport: {
      width: "100%",
      height: "100%",
      paddingRight: offsetScrollbars ? scrollbarSize : void 0
    },
    scrollbar: {
      display: "flex",
      userSelect: "none",
      touchAction: "none",
      boxSizing: "border-box",
      padding: scrollbarSize / 5,
      transition: "background-color 150ms ease, opacity 150ms ease",
      "&:hover": _defineProperty({
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
      }, "& .".concat(getRef("thumb")), {
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.white, 0.5) : theme.fn.rgba(theme.black, 0.5)
      }),
      '&[data-orientation="vertical"]': {
        width: scrollbarSize
      },
      '&[data-orientation="horizontal"]': {
        flexDirection: "column",
        height: scrollbarSize
      },
      '&[data-state="hidden"]': {
        display: "none",
        opacity: 0
      }
    },
    thumb: {
      ref: getRef("thumb"),
      flex: 1,
      backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.white, 0.4) : theme.fn.rgba(theme.black, 0.4),
      borderRadius: scrollbarSize,
      position: "relative",
      transition: "background-color 150ms ease",
      "&::before": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        height: "100%",
        minWidth: 44,
        minHeight: 44
      }
    },
    corner: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
      transition: "opacity 150ms ease",
      opacity: scrollbarHovered ? 1 : 0
    }
  };
});
var __defProp$O = Object.defineProperty;
var __getOwnPropSymbols$P = Object.getOwnPropertySymbols;
var __hasOwnProp$P = Object.prototype.hasOwnProperty;
var __propIsEnum$P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$O = function __defNormalProp$O(obj, key, value) {
  return key in obj ? __defProp$O(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$O = function __spreadValues$O(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$P.call(b, prop)) __defNormalProp$O(a, prop, b[prop]);
  if (__getOwnPropSymbols$P) {
    var _iterator67 = _createForOfIteratorHelper(__getOwnPropSymbols$P(b)),
      _step68;
    try {
      for (_iterator67.s(); !(_step68 = _iterator67.n()).done;) {
        var prop = _step68.value;
        if (__propIsEnum$P.call(b, prop)) __defNormalProp$O(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator67.e(err);
    } finally {
      _iterator67.f();
    }
  }
  return a;
};
var __objRest$o = function __objRest$o(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$P.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$P) {
    var _iterator68 = _createForOfIteratorHelper(__getOwnPropSymbols$P(source)),
      _step69;
    try {
      for (_iterator68.s(); !(_step69 = _iterator68.n()).done;) {
        var prop = _step69.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$P.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator68.e(err);
    } finally {
      _iterator68.f();
    }
  }
  return target;
};
var defaultProps$e = {
  scrollbarSize: 12,
  scrollHideDelay: 1e3,
  type: "hover",
  offsetScrollbars: false
};
var ScrollArea$1 = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("ScrollArea", defaultProps$e, props),
    children = _a.children,
    className = _a.className,
    classNames = _a.classNames,
    styles = _a.styles,
    scrollbarSize = _a.scrollbarSize,
    scrollHideDelay = _a.scrollHideDelay,
    type = _a.type,
    dir = _a.dir,
    offsetScrollbars = _a.offsetScrollbars,
    viewportRef = _a.viewportRef,
    onScrollPositionChange = _a.onScrollPositionChange,
    others = __objRest$o(_a, ["children", "className", "classNames", "styles", "scrollbarSize", "scrollHideDelay", "type", "dir", "offsetScrollbars", "viewportRef", "onScrollPositionChange"]);
  var _useState61 = useState(false),
    _useState62 = _slicedToArray(_useState61, 2),
    scrollbarHovered = _useState62[0],
    setScrollbarHovered = _useState62[1];
  var theme = useMantineTheme();
  var _useStyles$a = useStyles$a({
      scrollbarSize: scrollbarSize,
      offsetScrollbars: offsetScrollbars,
      scrollbarHovered: scrollbarHovered
    }, {
      name: "ScrollArea",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$a.classes,
    cx = _useStyles$a.cx;
  return /* @__PURE__ */React__default.createElement(Root$2, {
    type: type,
    scrollHideDelay: scrollHideDelay,
    dir: dir || theme.dir,
    ref: ref,
    asChild: true
  }, /* @__PURE__ */React__default.createElement(Box, __spreadValues$O({
    className: cx(classes.root, className)
  }, others), /* @__PURE__ */React__default.createElement(Viewport, {
    className: classes.viewport,
    ref: viewportRef,
    onScroll: typeof onScrollPositionChange === "function" ? function (_ref56) {
      var currentTarget = _ref56.currentTarget;
      return onScrollPositionChange({
        x: currentTarget.scrollLeft,
        y: currentTarget.scrollTop
      });
    } : void 0
  }, children), /* @__PURE__ */React__default.createElement(Scrollbar, {
    orientation: "horizontal",
    className: classes.scrollbar,
    forceMount: true,
    onMouseEnter: function onMouseEnter() {
      return setScrollbarHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setScrollbarHovered(false);
    }
  }, /* @__PURE__ */React__default.createElement(Thumb, {
    className: classes.thumb
  })), /* @__PURE__ */React__default.createElement(Scrollbar, {
    orientation: "vertical",
    className: classes.scrollbar,
    forceMount: true,
    onMouseEnter: function onMouseEnter() {
      return setScrollbarHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setScrollbarHovered(false);
    }
  }, /* @__PURE__ */React__default.createElement(Thumb, {
    className: classes.thumb
  })), /* @__PURE__ */React__default.createElement(Corner, {
    className: classes.corner
  })));
});
ScrollArea$1.displayName = "@mantine/core/ScrollArea";
var __defProp$P = Object.defineProperty;
var __defProps$j = Object.defineProperties;
var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$Q = Object.getOwnPropertySymbols;
var __hasOwnProp$Q = Object.prototype.hasOwnProperty;
var __propIsEnum$Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$P = function __defNormalProp$P(obj, key, value) {
  return key in obj ? __defProp$P(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$P = function __spreadValues$P(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$Q.call(b, prop)) __defNormalProp$P(a, prop, b[prop]);
  if (__getOwnPropSymbols$Q) {
    var _iterator69 = _createForOfIteratorHelper(__getOwnPropSymbols$Q(b)),
      _step70;
    try {
      for (_iterator69.s(); !(_step70 = _iterator69.n()).done;) {
        var prop = _step70.value;
        if (__propIsEnum$Q.call(b, prop)) __defNormalProp$P(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator69.e(err);
    } finally {
      _iterator69.f();
    }
  }
  return a;
};
var __spreadProps$j = function __spreadProps$j(a, b) {
  return __defProps$j(a, __getOwnPropDescs$j(b));
};
var __objRest$p = function __objRest$p(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$Q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Q) {
    var _iterator70 = _createForOfIteratorHelper(__getOwnPropSymbols$Q(source)),
      _step71;
    try {
      for (_iterator70.s(); !(_step71 = _iterator70.n()).done;) {
        var prop = _step71.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$Q.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator70.e(err);
    } finally {
      _iterator70.f();
    }
  }
  return target;
};
var SelectScrollArea = forwardRef(function (_a, ref) {
  var _b = _a,
    style = _b.style,
    others = __objRest$p(_b, ["style"]);
  return /* @__PURE__ */React__default.createElement(ScrollArea$1, __spreadProps$j(__spreadValues$P({}, others), {
    style: __spreadValues$P({
      width: "100%"
    }, style),
    viewportRef: ref
  }), others.children);
});
SelectScrollArea.displayName = "@mantine/core/SelectScrollArea";
var __defProp$Q = Object.defineProperty;
var __defProps$k = Object.defineProperties;
var __getOwnPropDescs$k = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$R = Object.getOwnPropertySymbols;
var __hasOwnProp$R = Object.prototype.hasOwnProperty;
var __propIsEnum$R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Q = function __defNormalProp$Q(obj, key, value) {
  return key in obj ? __defProp$Q(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$Q = function __spreadValues$Q(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$R.call(b, prop)) __defNormalProp$Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$R) {
    var _iterator71 = _createForOfIteratorHelper(__getOwnPropSymbols$R(b)),
      _step72;
    try {
      for (_iterator71.s(); !(_step72 = _iterator71.n()).done;) {
        var prop = _step72.value;
        if (__propIsEnum$R.call(b, prop)) __defNormalProp$Q(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator71.e(err);
    } finally {
      _iterator71.f();
    }
  }
  return a;
};
var __spreadProps$k = function __spreadProps$k(a, b) {
  return __defProps$k(a, __getOwnPropDescs$k(b));
};
var useStyles$b = createStyles(function (theme, _ref57) {
  var native = _ref57.native;
  return {
    dropdown: __spreadProps$k(__spreadValues$Q({}, theme.fn.fontStyles()), {
      boxSizing: "border-box",
      pointerEvents: "auto",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]),
      padding: 4,
      overflowY: native ? "auto" : "hidden",
      overscrollBehaviorY: "contain",
      width: "100%"
    })
  };
});
var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries$1 = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? useLayoutEffect : useEffect;
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function isElement$1(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
};
function getBasePlacement(placement) {
  return placement.split('-')[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement$1(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$1(element) ? element.ownerDocument :
  // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot ||
    // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (
    // DOM Element detected
    isShadowRoot(element) ? element.host : null) ||
    // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) ||
  // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
function within(min$$1, value, max$$1) {
  return max(min$$1, min(value, max$$1));
}
function withinMaxClamp(min$$1, value, max$$1) {
  var v = within(min$$1, value, max$$1);
  return v > max$$1 ? max$$1 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }
    return;
  }
  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};
function getVariation(placement) {
  return placement.split('-')[1];
}
var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
    y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper$$1 = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper$$1);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper$$1)) {
      offsetParent = getDocumentElement(popper$$1);
      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';
    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect$2(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$2,
  data: {}
};
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents$$1 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement$1(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents$$1.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents$$1 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents$$1[0];
  var clippingRect = clippingParents$$1.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference$$1 = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference$$1.x + reference$$1.width / 2 - element.width / 2;
  var commonY = reference$$1.y + reference$$1.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference$$1.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference$$1.y + reference$$1.height
      };
      break;
    case right:
      offsets = {
        x: reference$$1.x + reference$$1.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference$$1.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference$$1.x,
        y: reference$$1.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference$$1[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference$$1[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$$1;
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements$$1 = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements$$1[0];
  for (var i = 0; i < placements$$1.length; i++) {
    var placement = placements$$1[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements$$1.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules

var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};
function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$$1 = offset + overflow[mainSide];
    var max$$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$$1, tetherMin) : min$$1, offset, tether ? max(max$$1, tetherMax) : max$$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}
function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}
var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }
          break;
        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }
          break;
        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }
          break;
        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }
          break;
        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }
          break;
        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }
          break;
        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }
          break;
        case 'options':
        case 'data':
          break;
        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }
      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}
function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS$1 = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS$1 : _generatorOptions$def2;
  return function createPopper(reference$$1, popper$$1, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS$1, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference$$1,
        popper: popper$$1
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference$$1) ? listScrollParents(reference$$1) : reference$$1.contextElement ? listScrollParents(reference$$1.contextElement) : [],
          popper: listScrollParents(popper$$1)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }
          var _getComputedStyle = getComputedStyle$1(popper$$1),
            marginTop = _getComputedStyle.marginTop,
            marginRight = _getComputedStyle.marginRight,
            marginBottom = _getComputedStyle.marginBottom,
            marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer

          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference$$1 = _state$elements.reference,
          popper$$1 = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference$$1, popper$$1)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference$$1, getOffsetParent(popper$$1), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper$$1)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference$$1, popper$$1)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
          _ref3$options = _ref3.options,
          options = _ref3$options === void 0 ? {} : _ref3$options,
          effect = _ref3.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
var createPopper$1 = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper$2 = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers$1
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0'
        },
        arrow: {
          position: 'absolute'
        }
      },
      attributes: {}
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var updateStateModifier = useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        flushSync(function () {
          setState({
            styles: fromEntries$1(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries$1(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };
    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$$1 = options.createPopper || createPopper$2;
    var popperInstance = createPopper$$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

// Public components
// Public types

function parsePopperPosition(position) {
  if (typeof position !== "string") {
    return {
      position: "top",
      placement: "center"
    };
  }
  var splitted = position.split("-");
  if (splitted.length === 1) {
    return {
      position: position,
      placement: "center"
    };
  }
  return {
    position: splitted[0],
    placement: splitted[1]
  };
}
function PopperContainer(_ref58) {
  var children = _ref58.children,
    _ref58$zIndex = _ref58.zIndex,
    zIndex = _ref58$zIndex === void 0 ? getDefaultZIndex("popover") : _ref58$zIndex,
    className = _ref58.className,
    _ref58$withinPortal = _ref58.withinPortal,
    withinPortal = _ref58$withinPortal === void 0 ? true : _ref58$withinPortal;
  if (withinPortal) {
    return /* @__PURE__ */React__default.createElement(Portal$1, {
      className: className,
      zIndex: zIndex
    }, children);
  }
  return /* @__PURE__ */React__default.createElement("div", {
    className: className,
    style: {
      position: "relative",
      zIndex: zIndex
    }
  }, children);
}
PopperContainer.displayName = "@mantine/core/PopperContainer";
var __defProp$R = Object.defineProperty;
var __defProps$l = Object.defineProperties;
var __getOwnPropDescs$l = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$S = Object.getOwnPropertySymbols;
var __hasOwnProp$S = Object.prototype.hasOwnProperty;
var __propIsEnum$S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$R = function __defNormalProp$R(obj, key, value) {
  return key in obj ? __defProp$R(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$R = function __spreadValues$R(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$S.call(b, prop)) __defNormalProp$R(a, prop, b[prop]);
  if (__getOwnPropSymbols$S) {
    var _iterator72 = _createForOfIteratorHelper(__getOwnPropSymbols$S(b)),
      _step73;
    try {
      for (_iterator72.s(); !(_step73 = _iterator72.n()).done;) {
        var prop = _step73.value;
        if (__propIsEnum$S.call(b, prop)) __defNormalProp$R(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator72.e(err);
    } finally {
      _iterator72.f();
    }
  }
  return a;
};
var __spreadProps$l = function __spreadProps$l(a, b) {
  return __defProps$l(a, __getOwnPropDescs$l(b));
};
var horizontalPlacement = function horizontalPlacement(arrowSize, distance, classes) {
  var _ref59;
  return _ref59 = {}, _defineProperty(_ref59, "&.".concat(classes.center), {
    top: "calc(50% - ".concat(arrowSize, "px)")
  }), _defineProperty(_ref59, "&.".concat(classes.end), {
    bottom: arrowSize * distance
  }), _defineProperty(_ref59, "&.".concat(classes.start), {
    top: arrowSize * distance
  }), _ref59;
};
var verticalPlacement = function verticalPlacement(arrowSize, distance, classes, theme) {
  var _ref60;
  return _ref60 = {}, _defineProperty(_ref60, "&.".concat(classes.center), {
    left: "calc(50% - ".concat(arrowSize, "px)")
  }), _defineProperty(_ref60, "&.".concat(classes.end), {
    right: theme.dir === "ltr" ? arrowSize * distance : void 0,
    left: theme.dir === "rtl" ? arrowSize * distance : void 0
  }), _defineProperty(_ref60, "&.".concat(classes.start), {
    left: theme.dir === "ltr" ? arrowSize * distance : void 0,
    right: theme.dir === "rtl" ? arrowSize * distance : void 0
  }), _ref60;
};
var useStyles$c = createStyles(function (theme, _ref61, getRef) {
  var arrowSize = _ref61.arrowSize,
    arrowDistance = _ref61.arrowDistance;
  var center = {
    ref: getRef("center")
  };
  var start = {
    ref: getRef("start")
  };
  var end = {
    ref: getRef("end")
  };
  var placementClasses = {
    center: center.ref,
    start: start.ref,
    end: end.ref
  };
  return {
    center: center,
    start: start,
    end: end,
    arrow: {
      width: arrowSize * 2,
      height: arrowSize * 2,
      position: "absolute",
      transform: "rotate(45deg)",
      border: "1px solid transparent",
      zIndex: 1
    },
    left: __spreadProps$l(__spreadValues$R({}, horizontalPlacement(arrowSize, arrowDistance, placementClasses)), {
      right: theme.dir === "ltr" ? -arrowSize : "unset",
      left: theme.dir === "rtl" ? -arrowSize : "unset",
      borderLeft: theme.dir === "ltr" ? 0 : void 0,
      borderRight: theme.dir === "rtl" ? 0 : void 0,
      borderBottom: 0
    }),
    right: __spreadProps$l(__spreadValues$R({}, horizontalPlacement(arrowSize, arrowDistance, placementClasses)), {
      left: theme.dir === "ltr" ? -arrowSize : "unset",
      right: theme.dir === "rtl" ? -arrowSize : "unset",
      borderRight: theme.dir === "ltr" ? 0 : void 0,
      borderLeft: theme.dir === "rtl" ? 0 : void 0,
      borderTop: 0
    }),
    top: __spreadProps$l(__spreadValues$R({}, verticalPlacement(arrowSize, arrowDistance, placementClasses, theme)), {
      bottom: -arrowSize,
      borderLeft: theme.dir === "ltr" ? 0 : void 0,
      borderRight: theme.dir === "rtl" ? 0 : void 0,
      borderTop: 0
    }),
    bottom: __spreadProps$l(__spreadValues$R({}, verticalPlacement(arrowSize, arrowDistance, placementClasses, theme)), {
      top: -arrowSize,
      borderRight: theme.dir === "ltr" ? 0 : void 0,
      borderLeft: theme.dir === "rtl" ? 0 : void 0,
      borderBottom: 0
    })
  };
});
var __defProp$S = Object.defineProperty;
var __getOwnPropSymbols$T = Object.getOwnPropertySymbols;
var __hasOwnProp$T = Object.prototype.hasOwnProperty;
var __propIsEnum$T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$S = function __defNormalProp$S(obj, key, value) {
  return key in obj ? __defProp$S(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$S = function __spreadValues$S(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$T.call(b, prop)) __defNormalProp$S(a, prop, b[prop]);
  if (__getOwnPropSymbols$T) {
    var _iterator73 = _createForOfIteratorHelper(__getOwnPropSymbols$T(b)),
      _step74;
    try {
      for (_iterator73.s(); !(_step74 = _iterator73.n()).done;) {
        var prop = _step74.value;
        if (__propIsEnum$T.call(b, prop)) __defNormalProp$S(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator73.e(err);
    } finally {
      _iterator73.f();
    }
  }
  return a;
};
var transitionStatuses = {
  entering: "in",
  entered: "in",
  exiting: "out",
  exited: "out",
  "pre-exiting": "out",
  "pre-entering": "out"
};
function getTransitionStyles(_ref62) {
  var transition = _ref62.transition,
    state = _ref62.state,
    duration = _ref62.duration,
    timingFunction = _ref62.timingFunction;
  var shared = {
    transitionDuration: "".concat(duration, "ms"),
    transitionTimingFunction: timingFunction
  };
  if (typeof transition === "string") {
    if (!(transition in transitions)) {
      return null;
    }
    return __spreadValues$S(__spreadValues$S(__spreadValues$S({
      transitionProperty: transitions[transition].transitionProperty
    }, shared), transitions[transition].common), transitions[transition][transitionStatuses[state]]);
  }
  return __spreadValues$S(__spreadValues$S(__spreadValues$S({
    transitionProperty: transition.transitionProperty
  }, shared), transition.common), transition[transitionStatuses[state]]);
}
function useTransition(_ref63) {
  var duration = _ref63.duration,
    exitDuration = _ref63.exitDuration,
    timingFunction = _ref63.timingFunction,
    mounted = _ref63.mounted,
    onEnter = _ref63.onEnter,
    onExit = _ref63.onExit,
    onEntered = _ref63.onEntered,
    onExited = _ref63.onExited;
  var theme = useMantineTheme();
  var reduceMotion = useReducedMotion();
  var _useState63 = useState(mounted ? "entered" : "exited"),
    _useState64 = _slicedToArray(_useState63, 2),
    transitionStatus = _useState64[0],
    setStatus = _useState64[1];
  var _useState65 = useState(reduceMotion ? 0 : duration),
    _useState66 = _slicedToArray(_useState65, 2),
    transitionDuration = _useState66[0],
    setTransitionDuration = _useState66[1];
  var timeoutRef = useRef(-1);
  var handleStateChange = function handleStateChange(shouldMount) {
    var preHandler = shouldMount ? onEnter : onExit;
    var handler = shouldMount ? onEntered : onExited;
    setStatus(shouldMount ? "pre-entering" : "pre-exiting");
    window.clearTimeout(timeoutRef.current);
    var _duration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
    setTransitionDuration(_duration);
    if (_duration === 0) {
      typeof preHandler === "function" && preHandler();
      typeof handler === "function" && handler();
      setStatus(shouldMount ? "entered" : "exited");
    } else {
      var preStateTimeout = window.setTimeout(function () {
        typeof preHandler === "function" && preHandler();
        setStatus(shouldMount ? "entering" : "exiting");
      }, 10);
      timeoutRef.current = window.setTimeout(function () {
        window.clearTimeout(preStateTimeout);
        typeof handler === "function" && handler();
        setStatus(shouldMount ? "entered" : "exited");
      }, _duration);
    }
  };
  useDidUpdate(function () {
    handleStateChange(mounted);
  }, [mounted]);
  useEffect(function () {
    return function () {
      return window.clearTimeout(timeoutRef.current);
    };
  }, []);
  return {
    transitionDuration: transitionDuration,
    transitionStatus: transitionStatus,
    transitionTimingFunction: timingFunction || theme.transitionTimingFunction
  };
}
function Transition(_ref64) {
  var transition = _ref64.transition,
    _ref64$duration = _ref64.duration,
    duration = _ref64$duration === void 0 ? 250 : _ref64$duration,
    _ref64$exitDuration = _ref64.exitDuration,
    exitDuration = _ref64$exitDuration === void 0 ? duration : _ref64$exitDuration,
    mounted = _ref64.mounted,
    children = _ref64.children,
    timingFunction = _ref64.timingFunction,
    onExit = _ref64.onExit,
    onEntered = _ref64.onEntered,
    onEnter = _ref64.onEnter,
    onExited = _ref64.onExited;
  var _useTransition = useTransition({
      mounted: mounted,
      exitDuration: exitDuration,
      duration: duration,
      timingFunction: timingFunction,
      onExit: onExit,
      onEntered: onEntered,
      onEnter: onEnter,
      onExited: onExited
    }),
    transitionDuration = _useTransition.transitionDuration,
    transitionStatus = _useTransition.transitionStatus,
    transitionTimingFunction = _useTransition.transitionTimingFunction;
  if (transitionDuration === 0) {
    return mounted ? /* @__PURE__ */React__default.createElement(React__default.Fragment, null, children({})) : null;
  }
  return transitionStatus === "exited" ? null : /* @__PURE__ */React__default.createElement(React__default.Fragment, null, children(getTransitionStyles({
    transition: transition,
    duration: transitionDuration,
    state: transitionStatus,
    timingFunction: transitionTimingFunction
  })));
}
Transition.displayName = "@mantine/core/Transition";
var __defProp$T = Object.defineProperty;
var __defProps$m = Object.defineProperties;
var __getOwnPropDescs$m = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$U = Object.getOwnPropertySymbols;
var __hasOwnProp$U = Object.prototype.hasOwnProperty;
var __propIsEnum$U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$T = function __defNormalProp$T(obj, key, value) {
  return key in obj ? __defProp$T(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$T = function __spreadValues$T(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$U.call(b, prop)) __defNormalProp$T(a, prop, b[prop]);
  if (__getOwnPropSymbols$U) {
    var _iterator74 = _createForOfIteratorHelper(__getOwnPropSymbols$U(b)),
      _step75;
    try {
      for (_iterator74.s(); !(_step75 = _iterator74.n()).done;) {
        var prop = _step75.value;
        if (__propIsEnum$U.call(b, prop)) __defNormalProp$T(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator74.e(err);
    } finally {
      _iterator74.f();
    }
  }
  return a;
};
var __spreadProps$m = function __spreadProps$m(a, b) {
  return __defProps$m(a, __getOwnPropDescs$m(b));
};
function flipPlacement(placement, dir) {
  if (placement === "center") {
    return placement;
  }
  if (dir === "rtl") {
    if (placement === "end") {
      return "start";
    }
    return "end";
  }
  return placement;
}
function flipPosition(position, dir) {
  if (position === "top" || position === "bottom") {
    return position;
  }
  if (dir === "rtl") {
    if (position === "left") {
      return "right";
    }
    return "left";
  }
  return position;
}
function Popper$1(_ref65) {
  var _ref65$position = _ref65.position,
    position = _ref65$position === void 0 ? "top" : _ref65$position,
    _ref65$placement = _ref65.placement,
    placement = _ref65$placement === void 0 ? "center" : _ref65$placement,
    _ref65$gutter = _ref65.gutter,
    gutter = _ref65$gutter === void 0 ? 5 : _ref65$gutter,
    _ref65$arrowSize = _ref65.arrowSize,
    arrowSize = _ref65$arrowSize === void 0 ? 2 : _ref65$arrowSize,
    _ref65$arrowDistance = _ref65.arrowDistance,
    arrowDistance = _ref65$arrowDistance === void 0 ? 2 : _ref65$arrowDistance,
    _ref65$withArrow = _ref65.withArrow,
    withArrow = _ref65$withArrow === void 0 ? false : _ref65$withArrow,
    referenceElement = _ref65.referenceElement,
    children = _ref65.children,
    mounted = _ref65.mounted,
    _ref65$transition = _ref65.transition,
    transition = _ref65$transition === void 0 ? "pop-top-left" : _ref65$transition,
    transitionDuration = _ref65.transitionDuration,
    _ref65$exitTransition = _ref65.exitTransitionDuration,
    exitTransitionDuration = _ref65$exitTransition === void 0 ? transitionDuration : _ref65$exitTransition,
    transitionTimingFunction = _ref65.transitionTimingFunction,
    arrowClassName = _ref65.arrowClassName,
    arrowStyle = _ref65.arrowStyle,
    _ref65$zIndex = _ref65.zIndex,
    zIndex = _ref65$zIndex === void 0 ? getDefaultZIndex("popover") : _ref65$zIndex,
    _ref65$forceUpdateDep = _ref65.forceUpdateDependencies,
    forceUpdateDependencies = _ref65$forceUpdateDep === void 0 ? [] : _ref65$forceUpdateDep,
    _ref65$modifiers = _ref65.modifiers,
    modifiers = _ref65$modifiers === void 0 ? [] : _ref65$modifiers,
    onTransitionEnd = _ref65.onTransitionEnd,
    _ref65$withinPortal = _ref65.withinPortal,
    withinPortal = _ref65$withinPortal === void 0 ? true : _ref65$withinPortal;
  var _a;
  var padding = withArrow ? gutter + arrowSize : gutter;
  var _useStyles$c = useStyles$c({
      arrowSize: arrowSize,
      arrowDistance: arrowDistance
    }, {
      name: "Popper"
    }),
    classes = _useStyles$c.classes,
    cx = _useStyles$c.cx,
    theme = _useStyles$c.theme;
  var _useState67 = useState(null),
    _useState68 = _slicedToArray(_useState67, 2),
    popperElement = _useState68[0],
    setPopperElement = _useState68[1];
  var _placement = flipPlacement(placement, theme.dir);
  var _position = flipPosition(position, theme.dir);
  var initialPlacement = _placement === "center" ? _position : "".concat(_position, "-").concat(_placement);
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: initialPlacement,
      modifiers: [{
        name: "offset",
        options: {
          offset: [0, padding]
        }
      }].concat(_toConsumableArray2(modifiers))
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes,
    forceUpdate = _usePopper.forceUpdate;
  var parsedAttributes = parsePopperPosition((_a = attributes.popper) == null ? void 0 : _a["data-popper-placement"]);
  useDidUpdate(function () {
    typeof forceUpdate === "function" && forceUpdate();
  }, forceUpdateDependencies);
  return /* @__PURE__ */React__default.createElement(Transition, {
    mounted: mounted && !!referenceElement,
    duration: transitionDuration,
    exitDuration: exitTransitionDuration,
    transition: transition,
    timingFunction: transitionTimingFunction,
    onExited: onTransitionEnd
  }, function (transitionStyles) {
    return /* @__PURE__ */React__default.createElement("div", null, /* @__PURE__ */React__default.createElement(PopperContainer, {
      withinPortal: withinPortal,
      zIndex: zIndex
    }, /* @__PURE__ */React__default.createElement("div", __spreadValues$T({
      ref: setPopperElement,
      style: __spreadProps$m(__spreadValues$T({}, styles.popper), {
        pointerEvents: "none"
      })
    }, attributes.popper), /* @__PURE__ */React__default.createElement("div", {
      style: transitionStyles
    }, children, withArrow && /* @__PURE__ */React__default.createElement("div", {
      style: arrowStyle,
      className: cx(classes.arrow, classes[parsedAttributes.placement], classes[parsedAttributes.position], arrowClassName)
    })))));
  });
}
Popper$1.displayName = "@mantine/core/Popper";
var useStyles$d = createStyles(function (theme, _ref66) {
  var radius = _ref66.radius,
    shadow = _ref66.shadow,
    withBorder = _ref66.withBorder;
  return {
    root: {
      outline: 0,
      WebkitTapHighlightColor: "transparent",
      display: "block",
      textDecoration: "none",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      boxSizing: "border-box",
      borderRadius: theme.fn.radius(radius),
      boxShadow: theme.shadows[shadow] || shadow || "none",
      border: withBorder ? "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]) : void 0
    }
  };
});
var __defProp$U = Object.defineProperty;
var __getOwnPropSymbols$V = Object.getOwnPropertySymbols;
var __hasOwnProp$V = Object.prototype.hasOwnProperty;
var __propIsEnum$V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$U = function __defNormalProp$U(obj, key, value) {
  return key in obj ? __defProp$U(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$U = function __spreadValues$U(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$V.call(b, prop)) __defNormalProp$U(a, prop, b[prop]);
  if (__getOwnPropSymbols$V) {
    var _iterator75 = _createForOfIteratorHelper(__getOwnPropSymbols$V(b)),
      _step76;
    try {
      for (_iterator75.s(); !(_step76 = _iterator75.n()).done;) {
        var prop = _step76.value;
        if (__propIsEnum$V.call(b, prop)) __defNormalProp$U(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator75.e(err);
    } finally {
      _iterator75.f();
    }
  }
  return a;
};
var __objRest$q = function __objRest$q(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$V.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$V) {
    var _iterator76 = _createForOfIteratorHelper(__getOwnPropSymbols$V(source)),
      _step77;
    try {
      for (_iterator76.s(); !(_step77 = _iterator76.n()).done;) {
        var prop = _step77.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$V.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator76.e(err);
    } finally {
      _iterator76.f();
    }
  }
  return target;
};
var defaultProps$f = {};
var Paper = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Paper", defaultProps$f, props),
    component = _a.component,
    className = _a.className,
    children = _a.children,
    radius = _a.radius,
    withBorder = _a.withBorder,
    shadow = _a.shadow,
    others = __objRest$q(_a, ["component", "className", "children", "radius", "withBorder", "shadow"]);
  var _useStyles$d = useStyles$d({
      radius: radius,
      shadow: shadow,
      withBorder: withBorder
    }, {
      name: "Paper"
    }),
    classes = _useStyles$d.classes,
    cx = _useStyles$d.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$U({
    component: component || "div",
    className: cx(classes.root, className),
    ref: ref
  }, others), children);
});
Paper.displayName = "@mantine/core/Paper";
var SelectDropdown = forwardRef(function (_ref67, ref) {
  var mounted = _ref67.mounted,
    transition = _ref67.transition,
    transitionDuration = _ref67.transitionDuration,
    transitionTimingFunction = _ref67.transitionTimingFunction,
    uuid = _ref67.uuid,
    shadow = _ref67.shadow,
    maxDropdownHeight = _ref67.maxDropdownHeight,
    _ref67$withinPortal = _ref67.withinPortal,
    withinPortal = _ref67$withinPortal === void 0 ? true : _ref67$withinPortal,
    children = _ref67.children,
    classNames = _ref67.classNames,
    styles = _ref67.styles,
    dropdownComponent = _ref67.dropdownComponent,
    referenceElement = _ref67.referenceElement,
    _ref67$direction = _ref67.direction,
    direction = _ref67$direction === void 0 ? "column" : _ref67$direction,
    onDirectionChange = _ref67.onDirectionChange,
    _ref67$switchDirectio = _ref67.switchDirectionOnFlip,
    switchDirectionOnFlip = _ref67$switchDirectio === void 0 ? false : _ref67$switchDirectio,
    _ref67$zIndex = _ref67.zIndex,
    zIndex = _ref67$zIndex === void 0 ? getDefaultZIndex("popover") : _ref67$zIndex,
    _ref67$dropdownPositi = _ref67.dropdownPosition,
    dropdownPosition = _ref67$dropdownPositi === void 0 ? "flip" : _ref67$dropdownPositi,
    __staticSelector = _ref67.__staticSelector,
    _ref67$positionDepend = _ref67.positionDependencies,
    positionDependencies = _ref67$positionDepend === void 0 ? [] : _ref67$positionDepend;
  var _useStyles$b = useStyles$b({
      native: dropdownComponent !== SelectScrollArea
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$b.classes;
  var previousPlacement = useRef("bottom");
  return /* @__PURE__ */React__default.createElement(Popper$1, {
    referenceElement: referenceElement,
    mounted: mounted,
    transition: transition,
    transitionDuration: transitionDuration,
    exitTransitionDuration: 0,
    transitionTimingFunction: transitionTimingFunction,
    position: dropdownPosition === "flip" ? "bottom" : dropdownPosition,
    withinPortal: withinPortal,
    forceUpdateDependencies: positionDependencies,
    zIndex: zIndex,
    modifiers: [{
      name: "preventOverflow",
      enabled: false
    }, {
      name: "flip",
      enabled: dropdownPosition === "flip"
    }, {
      name: "sameWidth",
      enabled: true,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function fn(_ref68) {
        var state = _ref68.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
      },
      effect: function effect(_ref69) {
        var state = _ref69.state;
        state.elements.popper.style.width = "".concat(state.elements.reference.offsetWidth, "px");
      }
    }, {
      name: "directionControl",
      enabled: true,
      phase: "main",
      fn: function fn(_ref70) {
        var state = _ref70.state;
        if (previousPlacement.current !== state.placement) {
          previousPlacement.current = state.placement;
          var nextDirection = state.placement === "top" ? "column-reverse" : "column";
          if (direction !== nextDirection && switchDirectionOnFlip) {
            onDirectionChange && onDirectionChange(nextDirection);
          }
        }
      }
    }]
  }, /* @__PURE__ */React__default.createElement("div", {
    style: {
      maxHeight: maxDropdownHeight,
      display: "flex"
    }
  }, /* @__PURE__ */React__default.createElement(Paper, {
    radius: "sm",
    component: dropdownComponent || "div",
    id: "".concat(uuid, "-items"),
    "aria-labelledby": "".concat(uuid, "-label"),
    role: "listbox",
    className: classes.dropdown,
    shadow: shadow,
    ref: ref,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    }
  }, /* @__PURE__ */React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: direction,
      width: "100%"
    }
  }, children))));
});
SelectDropdown.displayName = "@mantine/core/SelectDropdown";
var sizes$1 = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};
var useStyles$e = createStyles(function (theme, _ref71) {
  var size = _ref71.size,
    variant = _ref71.variant,
    color = _ref71.color;
  return {
    root: {},
    withLabel: {
      borderTop: "0 !important"
    },
    left: {
      "&::before": {
        display: "none"
      }
    },
    right: {
      "&::after": {
        display: "none"
      }
    },
    label: {
      display: "flex",
      alignItems: "center",
      "&::before": {
        content: '""',
        flex: 1,
        height: 1,
        borderTop: "".concat(theme.fn.size({
          size: size,
          sizes: sizes$1
        }), "px ").concat(variant, " ").concat(theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 4, false)),
        marginRight: theme.spacing.xs
      },
      "&::after": {
        content: '""',
        flex: 1,
        borderTop: "".concat(theme.fn.size({
          size: size,
          sizes: sizes$1
        }), "px ").concat(variant, " ").concat(theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 4, false)),
        marginLeft: theme.spacing.xs
      }
    },
    labelDefaultStyles: {
      color: color === "dark" ? theme.colors.dark[1] : theme.fn.themeColor(color, theme.colorScheme === "dark" ? 5 : theme.fn.primaryShade(), false)
    },
    horizontal: {
      border: 0,
      borderTopWidth: theme.fn.size({
        size: size,
        sizes: sizes$1
      }),
      borderTopColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 4, false),
      borderTopStyle: variant,
      margin: 0
    },
    vertical: {
      border: 0,
      alignSelf: "stretch",
      height: "100%",
      borderLeftWidth: theme.fn.size({
        size: size,
        sizes: sizes$1
      }),
      borderLeftColor: theme.fn.themeColor(color, 4, false),
      borderLeftStyle: variant
    }
  };
});
var __defProp$V = Object.defineProperty;
var __defProps$n = Object.defineProperties;
var __getOwnPropDescs$n = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$W = Object.getOwnPropertySymbols;
var __hasOwnProp$W = Object.prototype.hasOwnProperty;
var __propIsEnum$W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$V = function __defNormalProp$V(obj, key, value) {
  return key in obj ? __defProp$V(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$V = function __spreadValues$V(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$W.call(b, prop)) __defNormalProp$V(a, prop, b[prop]);
  if (__getOwnPropSymbols$W) {
    var _iterator77 = _createForOfIteratorHelper(__getOwnPropSymbols$W(b)),
      _step78;
    try {
      for (_iterator77.s(); !(_step78 = _iterator77.n()).done;) {
        var prop = _step78.value;
        if (__propIsEnum$W.call(b, prop)) __defNormalProp$V(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator77.e(err);
    } finally {
      _iterator77.f();
    }
  }
  return a;
};
var __spreadProps$n = function __spreadProps$n(a, b) {
  return __defProps$n(a, __getOwnPropDescs$n(b));
};
var __objRest$r = function __objRest$r(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$W.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$W) {
    var _iterator78 = _createForOfIteratorHelper(__getOwnPropSymbols$W(source)),
      _step79;
    try {
      for (_iterator78.s(); !(_step79 = _iterator78.n()).done;) {
        var prop = _step79.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$W.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator78.e(err);
    } finally {
      _iterator78.f();
    }
  }
  return target;
};
var defaultProps$g = {
  orientation: "horizontal",
  size: "xs",
  labelPosition: "left",
  variant: "solid"
};
var Divider = forwardRef(function (props, ref) {
  var _cx;
  var _a = useMantineDefaultProps("Divider", defaultProps$g, props),
    className = _a.className,
    color = _a.color,
    orientation = _a.orientation,
    size = _a.size,
    label = _a.label,
    labelPosition = _a.labelPosition,
    labelProps = _a.labelProps,
    variant = _a.variant,
    styles = _a.styles,
    classNames = _a.classNames,
    others = __objRest$r(_a, ["className", "color", "orientation", "size", "label", "labelPosition", "labelProps", "variant", "styles", "classNames"]);
  var theme = useMantineTheme();
  var _color = color || (theme.colorScheme === "dark" ? "dark" : "gray");
  var _useStyles$e = useStyles$e({
      color: _color,
      size: size,
      variant: variant
    }, {
      classNames: classNames,
      styles: styles,
      name: "Divider"
    }),
    classes = _useStyles$e.classes,
    cx = _useStyles$e.cx;
  var vertical = orientation === "vertical";
  var horizontal = orientation === "horizontal";
  var withLabel = !!label && horizontal;
  var useLabelDefaultStyles = !(labelProps == null ? void 0 : labelProps.color);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$V({
    ref: ref,
    className: cx(classes.root, (_cx = {}, _defineProperty(_cx, classes.vertical, vertical), _defineProperty(_cx, classes.horizontal, horizontal), _defineProperty(_cx, classes.withLabel, withLabel), _cx), className)
  }, others), withLabel && /* @__PURE__ */React__default.createElement(Text, __spreadProps$n(__spreadValues$V({}, labelProps), {
    size: (labelProps == null ? void 0 : labelProps.size) || "xs",
    sx: {
      marginTop: 2
    },
    className: cx(classes.label, classes[labelPosition], _defineProperty({}, classes.labelDefaultStyles, useLabelDefaultStyles))
  }), label));
});
Divider.displayName = "@mantine/core/Divider";
var useStyles$f = createStyles(function (theme, _ref72) {
  var size = _ref72.size;
  return {
    item: {
      boxSizing: "border-box",
      textAlign: "left",
      width: "100%",
      padding: "".concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 1.5, "px ").concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }), "px"),
      cursor: "pointer",
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      borderRadius: theme.radius.sm
    },
    selected: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors[theme.primaryColor][0],
      color: theme.colorScheme === "dark" ? theme.white : theme.colors[theme.primaryColor][9]
    },
    hovered: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[1]
    },
    nothingFound: {
      boxSizing: "border-box",
      color: theme.colors.gray[6],
      paddingTop: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 2,
      paddingBottom: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 2,
      textAlign: "center"
    },
    disabled: {
      cursor: "default",
      color: theme.colors.dark[2]
    },
    separator: {
      boxSizing: "border-box",
      textAlign: "left",
      width: "100%",
      padding: "".concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 1.5, "px ").concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }), "px")
    },
    separatorLabel: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
    }
  };
});
var __defProp$W = Object.defineProperty;
var __getOwnPropSymbols$X = Object.getOwnPropertySymbols;
var __hasOwnProp$X = Object.prototype.hasOwnProperty;
var __propIsEnum$X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$W = function __defNormalProp$W(obj, key, value) {
  return key in obj ? __defProp$W(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$W = function __spreadValues$W(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$X.call(b, prop)) __defNormalProp$W(a, prop, b[prop]);
  if (__getOwnPropSymbols$X) {
    var _iterator79 = _createForOfIteratorHelper(__getOwnPropSymbols$X(b)),
      _step80;
    try {
      for (_iterator79.s(); !(_step80 = _iterator79.n()).done;) {
        var prop = _step80.value;
        if (__propIsEnum$X.call(b, prop)) __defNormalProp$W(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator79.e(err);
    } finally {
      _iterator79.f();
    }
  }
  return a;
};
function SelectItems(_ref73) {
  var data = _ref73.data,
    hovered = _ref73.hovered,
    classNames = _ref73.classNames,
    styles = _ref73.styles,
    isItemSelected = _ref73.isItemSelected,
    uuid = _ref73.uuid,
    __staticSelector = _ref73.__staticSelector,
    onItemHover = _ref73.onItemHover,
    onItemSelect = _ref73.onItemSelect,
    itemsRefs = _ref73.itemsRefs,
    Item = _ref73.itemComponent,
    size = _ref73.size,
    nothingFound = _ref73.nothingFound,
    creatable = _ref73.creatable,
    createLabel = _ref73.createLabel;
  var _useStyles$f = useStyles$f({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$f.classes,
    cx = _useStyles$f.cx;
  var unGroupedItems = [];
  var groupedItems = [];
  var creatableDataIndex = null;
  var constructItemComponent = function constructItemComponent(item, index) {
    var _cx3;
    var selected = typeof isItemSelected === "function" ? isItemSelected(item.value) : false;
    return /* @__PURE__ */React__default.createElement(Item, __spreadValues$W({
      key: item.value,
      className: cx(classes.item, (_cx3 = {}, _defineProperty(_cx3, classes.hovered, !item.disabled && hovered === index), _defineProperty(_cx3, classes.selected, !item.disabled && selected), _defineProperty(_cx3, classes.disabled, item.disabled), _cx3)),
      onMouseEnter: function onMouseEnter() {
        return onItemHover(index);
      },
      id: "".concat(uuid, "-").concat(index),
      role: "option",
      "data-ignore-outside-clicks": true,
      tabIndex: -1,
      "aria-selected": hovered === index,
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[item.value] = node;
        }
      },
      onMouseDown: !item.disabled ? function (event) {
        event.preventDefault();
        onItemSelect(item);
      } : null,
      disabled: item.disabled
    }, item));
  };
  var groupName = null;
  data.forEach(function (item, index) {
    if (item.creatable) {
      creatableDataIndex = index;
    } else if (!item.group) {
      unGroupedItems.push(constructItemComponent(item, index));
    } else {
      if (groupName !== item.group) {
        groupName = item.group;
        groupedItems.push( /* @__PURE__ */React__default.createElement("div", {
          className: classes.separator,
          key: "__mantine-divider-".concat(index)
        }, /* @__PURE__ */React__default.createElement(Divider, {
          classNames: {
            label: classes.separatorLabel
          },
          label: item.group
        })));
      }
      groupedItems.push(constructItemComponent(item, index));
    }
  });
  if (creatable) {
    var _cx4;
    var creatableDataItem = data[creatableDataIndex];
    var selected = typeof isItemSelected === "function" ? isItemSelected(data[creatableDataIndex].value) : false;
    unGroupedItems.push( /* @__PURE__ */React__default.createElement("div", {
      key: creatableDataItem.value,
      className: cx(classes.item, (_cx4 = {}, _defineProperty(_cx4, classes.hovered, hovered === creatableDataIndex), _defineProperty(_cx4, classes.selected, selected), _cx4)),
      onMouseEnter: function onMouseEnter() {
        return onItemHover(creatableDataIndex);
      },
      onMouseDown: function onMouseDown(event) {
        event.preventDefault();
        onItemSelect(creatableDataItem);
      },
      tabIndex: -1,
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[creatableDataItem.value] = node;
        }
      }
    }, createLabel));
  }
  if (groupedItems.length > 0 && unGroupedItems.length > 0) {
    unGroupedItems.unshift( /* @__PURE__ */React__default.createElement("div", {
      className: classes.separator
    }, /* @__PURE__ */React__default.createElement(Divider, null)));
  }
  return groupedItems.length > 0 || unGroupedItems.length > 0 ? /* @__PURE__ */React__default.createElement(React__default.Fragment, null, groupedItems, unGroupedItems) : /* @__PURE__ */React__default.createElement(Text, {
    size: size,
    className: classes.nothingFound
  }, nothingFound);
}
SelectItems.displayName = "@mantine/core/SelectItems";
var __defProp$X = Object.defineProperty;
var __getOwnPropSymbols$Y = Object.getOwnPropertySymbols;
var __hasOwnProp$Y = Object.prototype.hasOwnProperty;
var __propIsEnum$Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$X = function __defNormalProp$X(obj, key, value) {
  return key in obj ? __defProp$X(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$X = function __spreadValues$X(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$Y.call(b, prop)) __defNormalProp$X(a, prop, b[prop]);
  if (__getOwnPropSymbols$Y) {
    var _iterator80 = _createForOfIteratorHelper(__getOwnPropSymbols$Y(b)),
      _step81;
    try {
      for (_iterator80.s(); !(_step81 = _iterator80.n()).done;) {
        var prop = _step81.value;
        if (__propIsEnum$Y.call(b, prop)) __defNormalProp$X(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator80.e(err);
    } finally {
      _iterator80.f();
    }
  }
  return a;
};
var __objRest$s = function __objRest$s(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$Y.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Y) {
    var _iterator81 = _createForOfIteratorHelper(__getOwnPropSymbols$Y(source)),
      _step82;
    try {
      for (_iterator81.s(); !(_step82 = _iterator81.n()).done;) {
        var prop = _step82.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$Y.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator81.e(err);
    } finally {
      _iterator81.f();
    }
  }
  return target;
};
var DefaultItem = forwardRef(function (_a, ref) {
  var _b = _a,
    label = _b.label,
    value = _b.value,
    others = __objRest$s(_b, ["label", "value"]);
  return /* @__PURE__ */React__default.createElement("div", __spreadValues$X({
    ref: ref
  }, others), label || value);
});
DefaultItem.displayName = "@mantine/core/DefaultItem";
function filterData(_ref74) {
  var data = _ref74.data,
    limit = _ref74.limit,
    value = _ref74.value,
    filter = _ref74.filter;
  var result = [];
  for (var _i4 = 0; _i4 < data.length; _i4 += 1) {
    if (filter(value, data[_i4])) {
      result.push(data[_i4]);
    }
    if (result.length >= limit) {
      break;
    }
  }
  return result;
}
var useStyles$g = createStyles(function (theme, _ref75) {
  var size = _ref75.size;
  var spacing = theme.fn.size({
    size: size,
    sizes: theme.spacing
  });
  return {
    wrapper: {
      position: "relative"
    },
    item: {
      textAlign: "left",
      width: "100%",
      padding: "".concat(spacing / 1.5, "px ").concat(spacing),
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    },
    hovered: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[1]
    },
    nothingFound: {
      boxSizing: "border-box",
      color: theme.colors.gray[6],
      paddingTop: spacing / 2,
      paddingBottom: spacing / 2,
      textAlign: "center"
    }
  };
});
var __defProp$Y = Object.defineProperty;
var __defProps$o = Object.defineProperties;
var __getOwnPropDescs$o = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$Z = Object.getOwnPropertySymbols;
var __hasOwnProp$Z = Object.prototype.hasOwnProperty;
var __propIsEnum$Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Y = function __defNormalProp$Y(obj, key, value) {
  return key in obj ? __defProp$Y(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$Y = function __spreadValues$Y(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$Z.call(b, prop)) __defNormalProp$Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$Z) {
    var _iterator82 = _createForOfIteratorHelper(__getOwnPropSymbols$Z(b)),
      _step83;
    try {
      for (_iterator82.s(); !(_step83 = _iterator82.n()).done;) {
        var prop = _step83.value;
        if (__propIsEnum$Z.call(b, prop)) __defNormalProp$Y(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator82.e(err);
    } finally {
      _iterator82.f();
    }
  }
  return a;
};
var __spreadProps$o = function __spreadProps$o(a, b) {
  return __defProps$o(a, __getOwnPropDescs$o(b));
};
var useStyles$h = createStyles(function (theme, _ref76) {
  var size = _ref76.size;
  return {
    root: __spreadProps$o(__spreadValues$Y({}, theme.fn.fontStyles()), {
      lineHeight: theme.lineHeight
    }),
    label: {
      display: "inline-block",
      marginBottom: 4,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      fontWeight: 500,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
      wordBreak: "break-word",
      cursor: "default",
      WebkitTapHighlightColor: "transparent"
    },
    error: {
      marginTop: theme.spacing.xs / 2,
      wordBreak: "break-word",
      color: theme.colors.red[theme.colorScheme === "dark" ? 6 : 7]
    },
    description: {
      marginTop: -3,
      marginBottom: 7,
      wordBreak: "break-word",
      color: "".concat(theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6], " !important"),
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }) - 2,
      lineHeight: 1.2
    },
    required: {
      color: theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7]
    }
  };
});
var __defProp$Z = Object.defineProperty;
var __defProps$p = Object.defineProperties;
var __getOwnPropDescs$p = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$_ = Object.getOwnPropertySymbols;
var __hasOwnProp$_ = Object.prototype.hasOwnProperty;
var __propIsEnum$_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Z = function __defNormalProp$Z(obj, key, value) {
  return key in obj ? __defProp$Z(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$Z = function __spreadValues$Z(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$_.call(b, prop)) __defNormalProp$Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$_) {
    var _iterator83 = _createForOfIteratorHelper(__getOwnPropSymbols$_(b)),
      _step84;
    try {
      for (_iterator83.s(); !(_step84 = _iterator83.n()).done;) {
        var prop = _step84.value;
        if (__propIsEnum$_.call(b, prop)) __defNormalProp$Z(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator83.e(err);
    } finally {
      _iterator83.f();
    }
  }
  return a;
};
var __spreadProps$p = function __spreadProps$p(a, b) {
  return __defProps$p(a, __getOwnPropDescs$p(b));
};
var __objRest$t = function __objRest$t(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$_.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$_) {
    var _iterator84 = _createForOfIteratorHelper(__getOwnPropSymbols$_(source)),
      _step85;
    try {
      for (_iterator84.s(); !(_step85 = _iterator84.n()).done;) {
        var prop = _step85.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$_.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator84.e(err);
    } finally {
      _iterator84.f();
    }
  }
  return target;
};
var defaultProps$h = {
  labelElement: "label",
  size: "sm",
  __staticSelector: "InputWrapper"
};
var InputWrapper = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("InputWrapper", defaultProps$h, props),
    className = _a.className,
    label = _a.label,
    children = _a.children,
    required = _a.required,
    id = _a.id,
    error = _a.error,
    description = _a.description,
    labelElement = _a.labelElement,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    errorProps = _a.errorProps,
    classNames = _a.classNames,
    styles = _a.styles,
    size = _a.size,
    __staticSelector = _a.__staticSelector,
    others = __objRest$t(_a, ["className", "label", "children", "required", "id", "error", "description", "labelElement", "labelProps", "descriptionProps", "errorProps", "classNames", "styles", "size", "__staticSelector"]);
  var _useStyles$h = useStyles$h({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$h.classes,
    cx = _useStyles$h.cx;
  var _labelProps = labelElement === "label" ? {
    htmlFor: id
  } : {};
  var inputLabel = createElement(labelElement, __spreadProps$p(__spreadValues$Z(__spreadValues$Z({}, _labelProps), labelProps), {
    id: id ? "".concat(id, "-label") : void 0,
    className: classes.label
  }), /* @__PURE__ */React__default.createElement(React__default.Fragment, null, label, required && /* @__PURE__ */React__default.createElement("span", {
    className: classes.required,
    "aria-hidden": true
  }, " *")));
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$Z({
    className: cx(classes.root, className),
    ref: ref
  }, others), label && inputLabel, description && /* @__PURE__ */React__default.createElement(Text, __spreadProps$p(__spreadValues$Z({}, descriptionProps), {
    color: "gray",
    className: classes.description
  }), description), children, typeof error !== "boolean" && error && /* @__PURE__ */React__default.createElement(Text, __spreadProps$p(__spreadValues$Z({}, errorProps), {
    size: size,
    className: classes.error
  }), error));
});
InputWrapper.displayName = "@mantine/core/InputWrapper";
var __defProp$_ = Object.defineProperty;
var __defProps$q = Object.defineProperties;
var __getOwnPropDescs$q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$10 = Object.getOwnPropertySymbols;
var __hasOwnProp$10 = Object.prototype.hasOwnProperty;
var __propIsEnum$10 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$_ = function __defNormalProp$_(obj, key, value) {
  return key in obj ? __defProp$_(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$_ = function __spreadValues$_(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$10.call(b, prop)) __defNormalProp$_(a, prop, b[prop]);
  if (__getOwnPropSymbols$10) {
    var _iterator85 = _createForOfIteratorHelper(__getOwnPropSymbols$10(b)),
      _step86;
    try {
      for (_iterator85.s(); !(_step86 = _iterator85.n()).done;) {
        var prop = _step86.value;
        if (__propIsEnum$10.call(b, prop)) __defNormalProp$_(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator85.e(err);
    } finally {
      _iterator85.f();
    }
  }
  return a;
};
var __spreadProps$q = function __spreadProps$q(a, b) {
  return __defProps$q(a, __getOwnPropDescs$q(b));
};
var sizes$2 = {
  xs: 30,
  sm: 36,
  md: 42,
  lg: 50,
  xl: 60
};
var useStyles$i = createStyles(function (theme, _ref77) {
  var size = _ref77.size,
    multiline = _ref77.multiline,
    radius = _ref77.radius,
    variant = _ref77.variant,
    invalid = _ref77.invalid,
    rightSectionWidth = _ref77.rightSectionWidth,
    withRightSection = _ref77.withRightSection,
    iconWidth = _ref77.iconWidth;
  var invalidColor = theme.colors.red[theme.colorScheme === "dark" ? 6 : 7];
  var sizeStyles = variant === "default" || variant === "filled" ? {
    minHeight: theme.fn.size({
      size: size,
      sizes: sizes$2
    }),
    paddingLeft: theme.fn.size({
      size: size,
      sizes: sizes$2
    }) / 3,
    paddingRight: withRightSection ? rightSectionWidth : theme.fn.size({
      size: size,
      sizes: sizes$2
    }) / 3,
    borderRadius: theme.fn.radius(radius)
  } : null;
  return {
    wrapper: {
      position: "relative"
    },
    input: variant === "headless" ? {} : __spreadProps$q(__spreadValues$_(__spreadProps$q(__spreadValues$_({}, theme.fn.fontStyles()), {
      height: multiline ? variant === "unstyled" ? void 0 : "auto" : theme.fn.size({
        size: size,
        sizes: sizes$2
      }),
      WebkitTapHighlightColor: "transparent",
      lineHeight: multiline ? theme.lineHeight : "".concat(theme.fn.size({
        size: size,
        sizes: sizes$2
      }) - 2, "px"),
      appearance: "none",
      resize: "none",
      boxSizing: "border-box",
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      width: "100%",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      display: "block",
      textAlign: "left"
    }), sizeStyles), {
      "&:disabled": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
        color: theme.colors.dark[2],
        opacity: 0.6,
        cursor: "not-allowed",
        "&::placeholder": {
          color: theme.colors.dark[2]
        }
      },
      "&::placeholder": {
        opacity: 1,
        userSelect: "none",
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
      },
      "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button, &::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
        appearance: "none"
      },
      "&[type=number]": {
        MozAppearance: "textfield"
      }
    }),
    defaultVariant: {
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[4]),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
      transition: "border-color 100ms ease",
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 8 : 5]
      }
    },
    filledVariant: {
      border: "1px solid transparent",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: "".concat(theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 8 : 5], " !important")
      }
    },
    unstyledVariant: {
      borderWidth: 0,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      backgroundColor: "transparent",
      minHeight: 28,
      outline: 0,
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: "transparent"
      },
      "&:disabled": {
        backgroundColor: "transparent",
        "&:focus, &:focus-within": {
          outline: "none",
          borderColor: "transparent"
        }
      }
    },
    withIcon: {
      paddingLeft: typeof iconWidth === "number" ? iconWidth : theme.fn.size({
        size: size,
        sizes: sizes$2
      })
    },
    invalid: {
      color: invalidColor,
      borderColor: invalidColor,
      "&::placeholder": {
        opacity: 1,
        color: invalidColor
      }
    },
    disabled: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
      color: theme.colors.dark[2],
      opacity: 0.6,
      cursor: "not-allowed",
      "&::placeholder": {
        color: theme.colors.dark[2]
      }
    },
    icon: {
      pointerEvents: "none",
      position: "absolute",
      zIndex: 1,
      left: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: typeof iconWidth === "number" ? iconWidth : theme.fn.size({
        size: size,
        sizes: sizes$2
      }),
      color: invalid ? theme.colors.red[theme.colorScheme === "dark" ? 6 : 7] : theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5]
    },
    rightSection: {
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: rightSectionWidth
    }
  };
});
var __defProp$10 = Object.defineProperty;
var __defProps$r = Object.defineProperties;
var __getOwnPropDescs$r = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$11 = Object.getOwnPropertySymbols;
var __hasOwnProp$11 = Object.prototype.hasOwnProperty;
var __propIsEnum$11 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$10 = function __defNormalProp$10(obj, key, value) {
  return key in obj ? __defProp$10(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$10 = function __spreadValues$10(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$11.call(b, prop)) __defNormalProp$10(a, prop, b[prop]);
  if (__getOwnPropSymbols$11) {
    var _iterator86 = _createForOfIteratorHelper(__getOwnPropSymbols$11(b)),
      _step87;
    try {
      for (_iterator86.s(); !(_step87 = _iterator86.n()).done;) {
        var prop = _step87.value;
        if (__propIsEnum$11.call(b, prop)) __defNormalProp$10(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator86.e(err);
    } finally {
      _iterator86.f();
    }
  }
  return a;
};
var __spreadProps$r = function __spreadProps$r(a, b) {
  return __defProps$r(a, __getOwnPropDescs$r(b));
};
var __objRest$u = function __objRest$u(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$11.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$11) {
    var _iterator87 = _createForOfIteratorHelper(__getOwnPropSymbols$11(source)),
      _step88;
    try {
      for (_iterator87.s(); !(_step88 = _iterator87.n()).done;) {
        var prop = _step88.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$11.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator87.e(err);
    } finally {
      _iterator87.f();
    }
  }
  return target;
};
var defaultProps$i = {
  rightSectionWidth: 36,
  size: "sm",
  __staticSelector: "Input"
};
var Input = forwardRef(function (props, ref) {
  var _cx5;
  var _a = useMantineDefaultProps("Input", defaultProps$i, props),
    component = _a.component,
    className = _a.className,
    invalid = _a.invalid,
    required = _a.required,
    disabled = _a.disabled,
    variant = _a.variant,
    icon = _a.icon,
    style = _a.style,
    rightSectionWidth = _a.rightSectionWidth,
    iconWidth = _a.iconWidth,
    rightSection = _a.rightSection,
    rightSectionProps = _a.rightSectionProps,
    radius = _a.radius,
    size = _a.size,
    wrapperProps = _a.wrapperProps,
    classNames = _a.classNames,
    styles = _a.styles,
    __staticSelector = _a.__staticSelector,
    multiline = _a.multiline,
    sx = _a.sx,
    others = __objRest$u(_a, ["component", "className", "invalid", "required", "disabled", "variant", "icon", "style", "rightSectionWidth", "iconWidth", "rightSection", "rightSectionProps", "radius", "size", "wrapperProps", "classNames", "styles", "__staticSelector", "multiline", "sx"]);
  var theme = useMantineTheme();
  var _variant = variant || (theme.colorScheme === "dark" ? "filled" : "default");
  var _useStyles$i = useStyles$i({
      radius: radius,
      size: size,
      multiline: multiline,
      variant: _variant,
      invalid: invalid,
      rightSectionWidth: rightSectionWidth,
      iconWidth: iconWidth,
      withRightSection: !!rightSection
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$i.classes,
    cx = _useStyles$i.cx;
  var _extractSystemStyles3 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles3.systemStyles,
    rest = _extractSystemStyles3.rest;
  var Element = component || "input";
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$10(__spreadValues$10({
    className: cx(classes.wrapper, className),
    sx: sx,
    style: style
  }, systemStyles), wrapperProps), icon && /* @__PURE__ */React__default.createElement("div", {
    className: classes.icon
  }, icon), /* @__PURE__ */React__default.createElement(Element, __spreadProps$r(__spreadValues$10({}, rest), {
    ref: ref,
    required: required,
    "aria-invalid": invalid,
    disabled: disabled,
    className: cx(classes["".concat(_variant, "Variant")], classes.input, (_cx5 = {}, _defineProperty(_cx5, classes.withIcon, icon), _defineProperty(_cx5, classes.invalid, invalid), _defineProperty(_cx5, classes.disabled, disabled), _cx5))
  })), rightSection && /* @__PURE__ */React__default.createElement("div", __spreadProps$r(__spreadValues$10({}, rightSectionProps), {
    className: classes.rightSection
  }), rightSection));
});
Input.displayName = "@mantine/core/Input";
var __defProp$11 = Object.defineProperty;
var __defProps$s = Object.defineProperties;
var __getOwnPropDescs$s = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$12 = Object.getOwnPropertySymbols;
var __hasOwnProp$12 = Object.prototype.hasOwnProperty;
var __propIsEnum$12 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$11 = function __defNormalProp$11(obj, key, value) {
  return key in obj ? __defProp$11(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$11 = function __spreadValues$11(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$12.call(b, prop)) __defNormalProp$11(a, prop, b[prop]);
  if (__getOwnPropSymbols$12) {
    var _iterator88 = _createForOfIteratorHelper(__getOwnPropSymbols$12(b)),
      _step89;
    try {
      for (_iterator88.s(); !(_step89 = _iterator88.n()).done;) {
        var prop = _step89.value;
        if (__propIsEnum$12.call(b, prop)) __defNormalProp$11(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator88.e(err);
    } finally {
      _iterator88.f();
    }
  }
  return a;
};
var __spreadProps$s = function __spreadProps$s(a, b) {
  return __defProps$s(a, __getOwnPropDescs$s(b));
};
var __objRest$v = function __objRest$v(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$12.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$12) {
    var _iterator89 = _createForOfIteratorHelper(__getOwnPropSymbols$12(source)),
      _step90;
    try {
      for (_iterator89.s(); !(_step90 = _iterator89.n()).done;) {
        var prop = _step90.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$12.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator89.e(err);
    } finally {
      _iterator89.f();
    }
  }
  return target;
};
function defaultFilter(value, item) {
  return item.value.toLowerCase().trim().includes(value.toLowerCase().trim());
}
var defaultProps$j = {
  required: false,
  size: "sm",
  shadow: "sm",
  limit: 5,
  itemComponent: DefaultItem,
  transition: "pop",
  transitionDuration: 0,
  initiallyOpened: false,
  filter: defaultFilter,
  switchDirectionOnFlip: false,
  zIndex: getDefaultZIndex("popover"),
  dropdownPosition: "flip",
  maxDropdownHeight: "auto",
  positionDependencies: []
};
var Autocomplete = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Autocomplete", defaultProps$j, props),
    className = _a.className,
    style = _a.style,
    sx = _a.sx,
    _a$required = _a.required,
    required = _a$required === void 0 ? false : _a$required,
    label = _a.label,
    id = _a.id,
    error = _a.error,
    description = _a.description,
    _a$size3 = _a.size,
    size = _a$size3 === void 0 ? "sm" : _a$size3,
    _a$shadow = _a.shadow,
    shadow = _a$shadow === void 0 ? "sm" : _a$shadow,
    data = _a.data,
    _a$limit = _a.limit,
    limit = _a$limit === void 0 ? 5 : _a$limit,
    value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    _a$itemComponent = _a.itemComponent,
    itemComponent = _a$itemComponent === void 0 ? DefaultItem : _a$itemComponent,
    onItemSubmit = _a.onItemSubmit,
    onKeyDown = _a.onKeyDown,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    onClick = _a.onClick,
    _a$transition = _a.transition,
    transition = _a$transition === void 0 ? "skew-up" : _a$transition,
    _a$transitionDuration = _a.transitionDuration,
    transitionDuration = _a$transitionDuration === void 0 ? 0 : _a$transitionDuration,
    _a$initiallyOpened = _a.initiallyOpened,
    initiallyOpened = _a$initiallyOpened === void 0 ? false : _a$initiallyOpened,
    transitionTimingFunction = _a.transitionTimingFunction,
    wrapperProps = _a.wrapperProps,
    classNames = _a.classNames,
    styles = _a.styles,
    _a$filter = _a.filter,
    filter = _a$filter === void 0 ? defaultFilter : _a$filter,
    nothingFound = _a.nothingFound,
    onDropdownClose = _a.onDropdownClose,
    onDropdownOpen = _a.onDropdownOpen,
    withinPortal = _a.withinPortal,
    _a$switchDirectionOnF = _a.switchDirectionOnFlip,
    switchDirectionOnFlip = _a$switchDirectionOnF === void 0 ? false : _a$switchDirectionOnF,
    _a$zIndex = _a.zIndex,
    zIndex = _a$zIndex === void 0 ? getDefaultZIndex("popover") : _a$zIndex,
    dropdownPosition = _a.dropdownPosition,
    maxDropdownHeight = _a.maxDropdownHeight,
    dropdownComponent = _a.dropdownComponent,
    errorProps = _a.errorProps,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    positionDependencies = _a.positionDependencies,
    others = __objRest$v(_a, ["className", "style", "sx", "required", "label", "id", "error", "description", "size", "shadow", "data", "limit", "value", "defaultValue", "onChange", "itemComponent", "onItemSubmit", "onKeyDown", "onFocus", "onBlur", "onClick", "transition", "transitionDuration", "initiallyOpened", "transitionTimingFunction", "wrapperProps", "classNames", "styles", "filter", "nothingFound", "onDropdownClose", "onDropdownOpen", "withinPortal", "switchDirectionOnFlip", "zIndex", "dropdownPosition", "maxDropdownHeight", "dropdownComponent", "errorProps", "labelProps", "descriptionProps", "positionDependencies"]);
  var _useStyles$g = useStyles$g({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "Autocomplete"
    }),
    classes = _useStyles$g.classes;
  var _extractSystemStyles4 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles4.systemStyles,
    rest = _extractSystemStyles4.rest;
  var _useState69 = useState(initiallyOpened),
    _useState70 = _slicedToArray(_useState69, 2),
    dropdownOpened = _useState70[0],
    _setDropdownOpened = _useState70[1];
  var _useState71 = useState(-1),
    _useState72 = _slicedToArray(_useState71, 2),
    hovered = _useState72[0],
    setHovered = _useState72[1];
  var _useState73 = useState("column"),
    _useState74 = _slicedToArray(_useState73, 2),
    direction = _useState74[0],
    setDirection = _useState74[1];
  var inputRef = useRef(null);
  var uuid = useUuid(id);
  var _useState75 = useState(false),
    _useState76 = _slicedToArray(_useState75, 2),
    IMEOpen = _useState76[0],
    setIMEOpen = _useState76[1];
  var _useUncontrolled5 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: "",
      onChange: onChange,
      rule: function rule(val) {
        return typeof val === "string";
      }
    }),
    _useUncontrolled6 = _slicedToArray(_useUncontrolled5, 2),
    _value = _useUncontrolled6[0],
    handleChange = _useUncontrolled6[1];
  var setDropdownOpened = function setDropdownOpened(opened) {
    _setDropdownOpened(opened);
    var handler = opened ? onDropdownOpen : onDropdownClose;
    typeof handler === "function" && handler();
  };
  useDidUpdate(function () {
    setHovered(0);
  }, [_value]);
  var handleItemClick = function handleItemClick(item) {
    handleChange(item.value);
    typeof onItemSubmit === "function" && onItemSubmit(item);
    setDropdownOpened(false);
  };
  var formattedData = data.map(function (item) {
    return typeof item === "string" ? {
      value: item
    } : item;
  });
  var filteredData = filterData({
    data: formattedData,
    value: _value,
    limit: limit,
    filter: filter
  });
  var handleInputKeydown = function handleInputKeydown(event) {
    if (IMEOpen) {
      return;
    }
    typeof onKeyDown === "function" && onKeyDown(event);
    var isColumn = direction === "column";
    var handleNext = function handleNext() {
      setHovered(function (current) {
        return current < filteredData.length - 1 ? current + 1 : current;
      });
    };
    var handlePrevious = function handlePrevious() {
      setHovered(function (current) {
        return current > 0 ? current - 1 : current;
      });
    };
    switch (event.nativeEvent.code) {
      case "ArrowUp":
        {
          event.preventDefault();
          isColumn ? handlePrevious() : handleNext();
          break;
        }
      case "ArrowDown":
        {
          event.preventDefault();
          isColumn ? handleNext() : handlePrevious();
          break;
        }
      case "Enter":
        {
          if (filteredData[hovered] && dropdownOpened) {
            event.preventDefault();
            handleChange(filteredData[hovered].value);
            typeof onItemSubmit === "function" && onItemSubmit(filteredData[hovered]);
            setDropdownOpened(false);
          }
          break;
        }
      case "Escape":
        {
          if (dropdownOpened) {
            event.preventDefault();
            setDropdownOpened(false);
          }
        }
    }
  };
  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    setDropdownOpened(true);
  };
  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    setDropdownOpened(false);
  };
  var handleInputClick = function handleInputClick(event) {
    typeof onClick === "function" && onClick(event);
    setDropdownOpened(true);
  };
  var shouldRenderDropdown = dropdownOpened && (filteredData.length > 0 || filteredData.length === 0 && !!nothingFound);
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$11(__spreadValues$11({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    size: size,
    className: className,
    classNames: classNames,
    styles: styles,
    __staticSelector: "Autocomplete",
    sx: sx,
    style: style,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement("div", {
    className: classes.wrapper,
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-owns": shouldRenderDropdown ? "".concat(uuid, "-items") : null,
    "aria-controls": uuid,
    "aria-expanded": shouldRenderDropdown,
    onMouseLeave: function onMouseLeave() {
      return setHovered(-1);
    },
    tabIndex: -1
  }, /* @__PURE__ */React__default.createElement(Input, __spreadProps$s(__spreadValues$11({
    type: "search",
    autoComplete: "off"
  }, rest), {
    "data-mantine-stop-propagation": dropdownOpened,
    required: required,
    ref: useMergedRef(ref, inputRef),
    id: uuid,
    invalid: !!error,
    size: size,
    onKeyDown: handleInputKeydown,
    classNames: classNames,
    styles: styles,
    __staticSelector: "Autocomplete",
    value: _value,
    onChange: function onChange(event) {
      handleChange(event.currentTarget.value);
      setDropdownOpened(true);
    },
    onFocus: handleInputFocus,
    onCompositionStart: function onCompositionStart() {
      return setIMEOpen(true);
    },
    onCompositionEnd: function onCompositionEnd() {
      return setIMEOpen(false);
    },
    onBlur: handleInputBlur,
    onClick: handleInputClick,
    "aria-autocomplete": "list",
    "aria-controls": shouldRenderDropdown ? "".concat(uuid, "-items") : null,
    "aria-activedescendant": hovered >= 0 ? "".concat(uuid, "-").concat(hovered) : null
  })), /* @__PURE__ */React__default.createElement(SelectDropdown, {
    mounted: shouldRenderDropdown,
    transition: transition,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    uuid: uuid,
    shadow: shadow,
    maxDropdownHeight: maxDropdownHeight,
    dropdownComponent: dropdownComponent || SelectScrollArea,
    classNames: classNames,
    styles: styles,
    __staticSelector: "Autocomplete",
    direction: direction,
    onDirectionChange: setDirection,
    switchDirectionOnFlip: switchDirectionOnFlip,
    referenceElement: inputRef.current,
    withinPortal: withinPortal,
    zIndex: zIndex,
    dropdownPosition: dropdownPosition,
    positionDependencies: positionDependencies
  }, /* @__PURE__ */React__default.createElement(SelectItems, {
    data: filteredData,
    hovered: hovered,
    classNames: classNames,
    styles: styles,
    uuid: uuid,
    __staticSelector: "Autocomplete",
    onItemHover: setHovered,
    onItemSelect: handleItemClick,
    itemComponent: itemComponent,
    size: size,
    nothingFound: nothingFound
  }))));
});
Autocomplete.displayName = "@mantine/core/Autocomplete";
var __defProp$12 = Object.defineProperty;
var __defProps$t = Object.defineProperties;
var __getOwnPropDescs$t = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$13 = Object.getOwnPropertySymbols;
var __hasOwnProp$13 = Object.prototype.hasOwnProperty;
var __propIsEnum$13 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$12 = function __defNormalProp$12(obj, key, value) {
  return key in obj ? __defProp$12(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$12 = function __spreadValues$12(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$13.call(b, prop)) __defNormalProp$12(a, prop, b[prop]);
  if (__getOwnPropSymbols$13) {
    var _iterator90 = _createForOfIteratorHelper(__getOwnPropSymbols$13(b)),
      _step91;
    try {
      for (_iterator90.s(); !(_step91 = _iterator90.n()).done;) {
        var prop = _step91.value;
        if (__propIsEnum$13.call(b, prop)) __defNormalProp$12(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator90.e(err);
    } finally {
      _iterator90.f();
    }
  }
  return a;
};
var __spreadProps$t = function __spreadProps$t(a, b) {
  return __defProps$t(a, __getOwnPropDescs$t(b));
};
var sizes$3 = {
  xs: 16,
  sm: 26,
  md: 38,
  lg: 56,
  xl: 84
};
var useStyles$j = createStyles(function (theme, _ref78) {
  var size = _ref78.size,
    radius = _ref78.radius,
    color = _ref78.color;
  var colors = theme.fn.variant({
    variant: "light",
    color: color
  });
  return {
    root: __spreadProps$t(__spreadValues$12({}, theme.fn.focusStyles()), {
      WebkitTapHighlightColor: "transparent",
      boxSizing: "border-box",
      position: "relative",
      display: "block",
      userSelect: "none",
      overflow: "hidden",
      width: theme.fn.size({
        size: size,
        sizes: sizes$3
      }),
      minWidth: theme.fn.size({
        size: size,
        sizes: sizes$3
      }),
      height: theme.fn.size({
        size: size,
        sizes: sizes$3
      }),
      borderRadius: theme.fn.radius(radius)
    }),
    image: {
      objectFit: "cover",
      width: "100%",
      height: "100%",
      display: "block"
    },
    placeholder: __spreadProps$t(__spreadValues$12({}, theme.fn.fontStyles()), {
      fontSize: theme.fn.size({
        size: size,
        sizes: sizes$3
      }) / 2.5,
      color: colors.color,
      fontWeight: 700,
      backgroundColor: colors.background,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      userSelect: "none"
    }),
    placeholderIcon: {
      width: "70%",
      height: "70%",
      color: colors.color
    }
  };
});
var __defProp$13 = Object.defineProperty;
var __defProps$u = Object.defineProperties;
var __getOwnPropDescs$u = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$14 = Object.getOwnPropertySymbols;
var __hasOwnProp$14 = Object.prototype.hasOwnProperty;
var __propIsEnum$14 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$13 = function __defNormalProp$13(obj, key, value) {
  return key in obj ? __defProp$13(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$13 = function __spreadValues$13(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$14.call(b, prop)) __defNormalProp$13(a, prop, b[prop]);
  if (__getOwnPropSymbols$14) {
    var _iterator91 = _createForOfIteratorHelper(__getOwnPropSymbols$14(b)),
      _step92;
    try {
      for (_iterator91.s(); !(_step92 = _iterator91.n()).done;) {
        var prop = _step92.value;
        if (__propIsEnum$14.call(b, prop)) __defNormalProp$13(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator91.e(err);
    } finally {
      _iterator91.f();
    }
  }
  return a;
};
var __spreadProps$u = function __spreadProps$u(a, b) {
  return __defProps$u(a, __getOwnPropDescs$u(b));
};
function AvatarPlaceholderIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadProps$u(__spreadValues$13({}, props), {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /* @__PURE__ */React__default.createElement("path", {
    d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var __defProp$14 = Object.defineProperty;
var __defProps$v = Object.defineProperties;
var __getOwnPropDescs$v = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$15 = Object.getOwnPropertySymbols;
var __hasOwnProp$15 = Object.prototype.hasOwnProperty;
var __propIsEnum$15 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$14 = function __defNormalProp$14(obj, key, value) {
  return key in obj ? __defProp$14(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$14 = function __spreadValues$14(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$15.call(b, prop)) __defNormalProp$14(a, prop, b[prop]);
  if (__getOwnPropSymbols$15) {
    var _iterator92 = _createForOfIteratorHelper(__getOwnPropSymbols$15(b)),
      _step93;
    try {
      for (_iterator92.s(); !(_step93 = _iterator92.n()).done;) {
        var prop = _step93.value;
        if (__propIsEnum$15.call(b, prop)) __defNormalProp$14(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator92.e(err);
    } finally {
      _iterator92.f();
    }
  }
  return a;
};
var __spreadProps$v = function __spreadProps$v(a, b) {
  return __defProps$v(a, __getOwnPropDescs$v(b));
};
var __objRest$w = function __objRest$w(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$15.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$15) {
    var _iterator93 = _createForOfIteratorHelper(__getOwnPropSymbols$15(source)),
      _step94;
    try {
      for (_iterator93.s(); !(_step94 = _iterator93.n()).done;) {
        var prop = _step94.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$15.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator93.e(err);
    } finally {
      _iterator93.f();
    }
  }
  return target;
};
var defaultProps$k = {
  size: "md",
  color: "gray"
};
var Avatar = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Avatar", defaultProps$k, props),
    component = _a.component,
    className = _a.className,
    size = _a.size,
    src = _a.src,
    alt = _a.alt,
    radius = _a.radius,
    children = _a.children,
    color = _a.color,
    classNames = _a.classNames,
    styles = _a.styles,
    imageProps = _a.imageProps,
    others = __objRest$w(_a, ["component", "className", "size", "src", "alt", "radius", "children", "color", "classNames", "styles", "imageProps"]);
  var _useStyles$j = useStyles$j({
      color: color,
      radius: radius,
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "Avatar"
    }),
    classes = _useStyles$j.classes,
    cx = _useStyles$j.cx;
  var _useState77 = useState(!src),
    _useState78 = _slicedToArray(_useState77, 2),
    error = _useState78[0],
    setError = _useState78[1];
  useEffect(function () {
    !src ? setError(true) : setError(false);
  }, [src]);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$14({
    component: component || "div",
    className: cx(classes.root, className),
    ref: ref
  }, others), error ? /* @__PURE__ */React__default.createElement("div", {
    className: classes.placeholder,
    title: alt
  }, children || /* @__PURE__ */React__default.createElement(AvatarPlaceholderIcon, {
    className: classes.placeholderIcon
  })) : /* @__PURE__ */React__default.createElement("img", __spreadProps$v(__spreadValues$14({}, imageProps), {
    className: classes.image,
    src: src,
    alt: alt,
    onError: function onError() {
      return setError(true);
    }
  })));
});
Avatar.displayName = "@mantine/core/Avatar";
var __defProp$15 = Object.defineProperty;
var __defProps$w = Object.defineProperties;
var __getOwnPropDescs$w = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$16 = Object.getOwnPropertySymbols;
var __hasOwnProp$16 = Object.prototype.hasOwnProperty;
var __propIsEnum$16 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$15 = function __defNormalProp$15(obj, key, value) {
  return key in obj ? __defProp$15(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$15 = function __spreadValues$15(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$16.call(b, prop)) __defNormalProp$15(a, prop, b[prop]);
  if (__getOwnPropSymbols$16) {
    var _iterator94 = _createForOfIteratorHelper(__getOwnPropSymbols$16(b)),
      _step95;
    try {
      for (_iterator94.s(); !(_step95 = _iterator94.n()).done;) {
        var prop = _step95.value;
        if (__propIsEnum$16.call(b, prop)) __defNormalProp$15(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator94.e(err);
    } finally {
      _iterator94.f();
    }
  }
  return a;
};
var __spreadProps$w = function __spreadProps$w(a, b) {
  return __defProps$w(a, __getOwnPropDescs$w(b));
};
var useStyles$k = createStyles(function (theme, _ref79) {
  var spacing = _ref79.spacing;
  return {
    root: {
      display: "flex",
      paddingLeft: theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      }) / 2
    },
    child: {
      marginLeft: -theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      }) / 2,
      background: "".concat(theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white),
      border: "2px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white)
    },
    truncated: __spreadProps$w(__spreadValues$15({}, theme.fn.fontStyles()), {
      lineHeight: 1,
      fontSize: "".concat(theme.fontSizes.sm, "px !important"),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      width: "100%",
      height: "100%",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
    })
  };
});
var __defProp$16 = Object.defineProperty;
var __defProps$x = Object.defineProperties;
var __getOwnPropDescs$x = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$17 = Object.getOwnPropertySymbols;
var __hasOwnProp$17 = Object.prototype.hasOwnProperty;
var __propIsEnum$17 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$16 = function __defNormalProp$16(obj, key, value) {
  return key in obj ? __defProp$16(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$16 = function __spreadValues$16(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$17.call(b, prop)) __defNormalProp$16(a, prop, b[prop]);
  if (__getOwnPropSymbols$17) {
    var _iterator95 = _createForOfIteratorHelper(__getOwnPropSymbols$17(b)),
      _step96;
    try {
      for (_iterator95.s(); !(_step96 = _iterator95.n()).done;) {
        var prop = _step96.value;
        if (__propIsEnum$17.call(b, prop)) __defNormalProp$16(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator95.e(err);
    } finally {
      _iterator95.f();
    }
  }
  return a;
};
var __spreadProps$x = function __spreadProps$x(a, b) {
  return __defProps$x(a, __getOwnPropDescs$x(b));
};
var __objRest$x = function __objRest$x(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$17.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$17) {
    var _iterator96 = _createForOfIteratorHelper(__getOwnPropSymbols$17(source)),
      _step97;
    try {
      for (_iterator96.s(); !(_step97 = _iterator96.n()).done;) {
        var prop = _step97.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$17.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator96.e(err);
    } finally {
      _iterator96.f();
    }
  }
  return target;
};
var defaultProps$l = {
  size: "md",
  radius: "xl",
  limit: 2,
  spacing: "lg"
};
var AvatarsGroup = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("AvatarsGroup", defaultProps$l, props),
    className = _a.className,
    children = _a.children,
    _a$size4 = _a.size,
    size = _a$size4 === void 0 ? "md" : _a$size4,
    _a$radius = _a.radius,
    radius = _a$radius === void 0 ? "xl" : _a$radius,
    _a$limit2 = _a.limit,
    limit = _a$limit2 === void 0 ? 2 : _a$limit2,
    classNames = _a.classNames,
    styles = _a.styles,
    _a$spacing = _a.spacing,
    spacing = _a$spacing === void 0 ? "lg" : _a$spacing,
    total = _a.total,
    others = __objRest$x(_a, ["className", "children", "size", "radius", "limit", "classNames", "styles", "spacing", "total"]);
  var _useStyles$k = useStyles$k({
      spacing: spacing
    }, {
      classNames: classNames,
      styles: styles,
      name: "AvatarsGroup"
    }),
    classes = _useStyles$k.classes,
    cx = _useStyles$k.cx;
  var avatars = filterChildrenByType(children, Avatar).map(function (child, index) {
    return React__default.cloneElement(child, {
      size: size,
      radius: radius,
      key: index,
      className: cx(classes.child, child.props.className),
      style: __spreadProps$x(__spreadValues$16({}, child.props.style), {
        zIndex: index + 1
      })
    });
  });
  var clampedMax = limit < 2 ? 2 : limit;
  var extraAvatars = avatars.length > clampedMax ? avatars.length - clampedMax : 0;
  var truncatedAvatars = total ? total - Math.min(avatars.length, clampedMax) : extraAvatars;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$16({
    className: cx(className, classes.root),
    ref: ref
  }, others), avatars.slice(0, avatars.length - extraAvatars), truncatedAvatars ? /* @__PURE__ */React__default.createElement(Avatar, {
    size: size,
    radius: radius,
    className: classes.child,
    style: {
      zIndex: limit + 1
    }
  }, /* @__PURE__ */React__default.createElement(Center, {
    className: classes.truncated
  }, "+", truncatedAvatars)) : null);
});
AvatarsGroup.displayName = "@mantine/core/AvatarsGroup";
var __defProp$17 = Object.defineProperty;
var __defProps$y = Object.defineProperties;
var __getOwnPropDescs$y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$18 = Object.getOwnPropertySymbols;
var __hasOwnProp$18 = Object.prototype.hasOwnProperty;
var __propIsEnum$18 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$17 = function __defNormalProp$17(obj, key, value) {
  return key in obj ? __defProp$17(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$17 = function __spreadValues$17(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$18.call(b, prop)) __defNormalProp$17(a, prop, b[prop]);
  if (__getOwnPropSymbols$18) {
    var _iterator97 = _createForOfIteratorHelper(__getOwnPropSymbols$18(b)),
      _step98;
    try {
      for (_iterator97.s(); !(_step98 = _iterator97.n()).done;) {
        var prop = _step98.value;
        if (__propIsEnum$18.call(b, prop)) __defNormalProp$17(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator97.e(err);
    } finally {
      _iterator97.f();
    }
  }
  return a;
};
var __spreadProps$y = function __spreadProps$y(a, b) {
  return __defProps$y(a, __getOwnPropDescs$y(b));
};
var sizes$4 = {
  xs: {
    fontSize: 9,
    height: 16
  },
  sm: {
    fontSize: 10,
    height: 18
  },
  md: {
    fontSize: 11,
    height: 20
  },
  lg: {
    fontSize: 13,
    height: 26
  },
  xl: {
    fontSize: 16,
    height: 32
  }
};
var dotSizes = {
  xs: 4,
  sm: 4,
  md: 6,
  lg: 8,
  xl: 10
};
var heights = Object.keys(sizes$4).reduce(function (acc, key) {
  acc[key] = sizes$4[key].height;
  return acc;
}, {});
var useStyles$l = createStyles(function (theme, _ref80) {
  var color = _ref80.color,
    size = _ref80.size,
    radius = _ref80.radius,
    gradientFrom = _ref80.gradientFrom,
    gradientTo = _ref80.gradientTo,
    gradientDeg = _ref80.gradientDeg,
    fullWidth = _ref80.fullWidth;
  var dotSize = theme.fn.size({
    size: size,
    sizes: dotSizes
  });
  var _ref81 = size in sizes$4 ? sizes$4[size] : sizes$4.md,
    fontSize = _ref81.fontSize,
    height = _ref81.height;
  var lightColors = theme.fn.variant({
    color: color,
    variant: "light"
  });
  var filledColors = theme.fn.variant({
    color: color,
    variant: "filled"
  });
  var outlineColors = theme.fn.variant({
    color: color,
    variant: "outline"
  });
  var gradientColors = theme.fn.variant({
    variant: "gradient",
    gradient: {
      from: gradientFrom,
      to: gradientTo,
      deg: gradientDeg
    }
  });
  return {
    leftSection: {
      marginRight: theme.spacing.xs / 2
    },
    rightSection: {
      marginLeft: theme.spacing.xs / 2
    },
    inner: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    root: __spreadProps$y(__spreadValues$17(__spreadValues$17({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
      fontSize: fontSize,
      height: height,
      WebkitTapHighlightColor: "transparent",
      lineHeight: "".concat(height - 2, "px"),
      textDecoration: "none",
      padding: "0 ".concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 1.5, "px"),
      boxSizing: "border-box",
      display: fullWidth ? "flex" : "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: fullWidth ? "100%" : "auto",
      textTransform: "uppercase",
      borderRadius: theme.fn.radius(radius),
      fontWeight: 700,
      letterSpacing: 0.25,
      cursor: "default",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }),
    light: {
      backgroundColor: lightColors.background,
      color: lightColors.color,
      border: "1px solid transparent"
    },
    filled: {
      backgroundColor: filledColors.background,
      color: filledColors.color,
      border: "1px solid transparent"
    },
    outline: {
      backgroundColor: outlineColors.background,
      color: outlineColors.color,
      border: "1px solid ".concat(outlineColors.border)
    },
    gradient: {
      backgroundImage: gradientColors.background,
      color: gradientColors.color,
      border: 0
    },
    dot: {
      backgroundColor: "transparent",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[3]),
      paddingLeft: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 1.5 - dotSize / 2,
      "&::before": {
        content: '""',
        display: "block",
        width: dotSize,
        height: dotSize,
        borderRadius: dotSize,
        backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 4 : theme.fn.primaryShade("light")),
        marginRight: dotSize
      }
    }
  };
});
var __defProp$18 = Object.defineProperty;
var __getOwnPropSymbols$19 = Object.getOwnPropertySymbols;
var __hasOwnProp$19 = Object.prototype.hasOwnProperty;
var __propIsEnum$19 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$18 = function __defNormalProp$18(obj, key, value) {
  return key in obj ? __defProp$18(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$18 = function __spreadValues$18(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$19.call(b, prop)) __defNormalProp$18(a, prop, b[prop]);
  if (__getOwnPropSymbols$19) {
    var _iterator98 = _createForOfIteratorHelper(__getOwnPropSymbols$19(b)),
      _step99;
    try {
      for (_iterator98.s(); !(_step99 = _iterator98.n()).done;) {
        var prop = _step99.value;
        if (__propIsEnum$19.call(b, prop)) __defNormalProp$18(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator98.e(err);
    } finally {
      _iterator98.f();
    }
  }
  return a;
};
var __objRest$y = function __objRest$y(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$19.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$19) {
    var _iterator99 = _createForOfIteratorHelper(__getOwnPropSymbols$19(source)),
      _step100;
    try {
      for (_iterator99.s(); !(_step100 = _iterator99.n()).done;) {
        var prop = _step100.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$19.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator99.e(err);
    } finally {
      _iterator99.f();
    }
  }
  return target;
};
var defaultProps$m = {
  variant: "light",
  size: "md",
  radius: "xl",
  gradient: {
    from: "blue",
    to: "cyan",
    deg: 45
  }
};
var Badge = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Badge", defaultProps$m, props),
    component = _a.component,
    className = _a.className,
    color = _a.color,
    variant = _a.variant,
    fullWidth = _a.fullWidth,
    children = _a.children,
    size = _a.size,
    leftSection = _a.leftSection,
    rightSection = _a.rightSection,
    radius = _a.radius,
    gradient = _a.gradient,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$y(_a, ["component", "className", "color", "variant", "fullWidth", "children", "size", "leftSection", "rightSection", "radius", "gradient", "classNames", "styles"]);
  var _useStyles$l = useStyles$l({
      size: size,
      fullWidth: fullWidth,
      color: color,
      radius: radius,
      gradientFrom: gradient.from,
      gradientTo: gradient.to,
      gradientDeg: gradient.deg
    }, {
      classNames: classNames,
      styles: styles,
      name: "Badge"
    }),
    classes = _useStyles$l.classes,
    cx = _useStyles$l.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$18({
    component: component || "div",
    className: cx(classes[variant], classes.root, className),
    ref: ref
  }, others), leftSection && /* @__PURE__ */React__default.createElement("span", {
    className: classes.leftSection
  }, leftSection), /* @__PURE__ */React__default.createElement("span", {
    className: classes.inner
  }, children), rightSection && /* @__PURE__ */React__default.createElement("span", {
    className: classes.rightSection
  }, rightSection));
});
Badge.displayName = "@mantine/core/Badge";
var __defProp$19 = Object.defineProperty;
var __getOwnPropSymbols$1a = Object.getOwnPropertySymbols;
var __hasOwnProp$1a = Object.prototype.hasOwnProperty;
var __propIsEnum$1a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$19 = function __defNormalProp$19(obj, key, value) {
  return key in obj ? __defProp$19(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$19 = function __spreadValues$19(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1a.call(b, prop)) __defNormalProp$19(a, prop, b[prop]);
  if (__getOwnPropSymbols$1a) {
    var _iterator100 = _createForOfIteratorHelper(__getOwnPropSymbols$1a(b)),
      _step101;
    try {
      for (_iterator100.s(); !(_step101 = _iterator100.n()).done;) {
        var prop = _step101.value;
        if (__propIsEnum$1a.call(b, prop)) __defNormalProp$19(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator100.e(err);
    } finally {
      _iterator100.f();
    }
  }
  return a;
};
function QuoteIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$19({
    width: "20",
    height: "20",
    viewBox: "0 0 409.294 409.294",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M0 204.647v175.412h175.412V204.647H58.471c0-64.48 52.461-116.941 116.941-116.941V29.235C78.684 29.235 0 107.919 0 204.647zM409.294 87.706V29.235c-96.728 0-175.412 78.684-175.412 175.412v175.412h175.412V204.647H292.353c0-64.48 52.461-116.941 116.941-116.941z"
  }));
}
var __defProp$1a = Object.defineProperty;
var __defProps$z = Object.defineProperties;
var __getOwnPropDescs$z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1b = Object.getOwnPropertySymbols;
var __hasOwnProp$1b = Object.prototype.hasOwnProperty;
var __propIsEnum$1b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1a = function __defNormalProp$1a(obj, key, value) {
  return key in obj ? __defProp$1a(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1a = function __spreadValues$1a(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1b.call(b, prop)) __defNormalProp$1a(a, prop, b[prop]);
  if (__getOwnPropSymbols$1b) {
    var _iterator101 = _createForOfIteratorHelper(__getOwnPropSymbols$1b(b)),
      _step102;
    try {
      for (_iterator101.s(); !(_step102 = _iterator101.n()).done;) {
        var prop = _step102.value;
        if (__propIsEnum$1b.call(b, prop)) __defNormalProp$1a(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator101.e(err);
    } finally {
      _iterator101.f();
    }
  }
  return a;
};
var __spreadProps$z = function __spreadProps$z(a, b) {
  return __defProps$z(a, __getOwnPropDescs$z(b));
};
var useStyles$m = createStyles(function (theme, _ref82) {
  var color = _ref82.color;
  return {
    root: __spreadProps$z(__spreadValues$1a({}, theme.fn.fontStyles()), {
      fontSize: theme.fontSizes.lg,
      lineHeight: theme.lineHeight,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      margin: 0,
      borderTopRightRadius: theme.radius.sm,
      borderBottomRightRadius: theme.radius.sm,
      padding: "".concat(theme.spacing.md, "px ").concat(theme.spacing.lg, "px")
    }),
    inner: {
      display: "flex"
    },
    body: {
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    icon: {
      color: theme.fn.variant({
        variant: "filled",
        color: color
      }).background,
      marginRight: theme.spacing.lg,
      marginTop: 2,
      width: 22
    },
    cite: {
      display: "block",
      fontSize: theme.fontSizes.sm,
      marginTop: theme.spacing.xs,
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  };
});
var __defProp$1b = Object.defineProperty;
var __getOwnPropSymbols$1c = Object.getOwnPropertySymbols;
var __hasOwnProp$1c = Object.prototype.hasOwnProperty;
var __propIsEnum$1c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1b = function __defNormalProp$1b(obj, key, value) {
  return key in obj ? __defProp$1b(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1b = function __spreadValues$1b(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1c.call(b, prop)) __defNormalProp$1b(a, prop, b[prop]);
  if (__getOwnPropSymbols$1c) {
    var _iterator102 = _createForOfIteratorHelper(__getOwnPropSymbols$1c(b)),
      _step103;
    try {
      for (_iterator102.s(); !(_step103 = _iterator102.n()).done;) {
        var prop = _step103.value;
        if (__propIsEnum$1c.call(b, prop)) __defNormalProp$1b(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator102.e(err);
    } finally {
      _iterator102.f();
    }
  }
  return a;
};
var __objRest$z = function __objRest$z(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1c.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1c) {
    var _iterator103 = _createForOfIteratorHelper(__getOwnPropSymbols$1c(source)),
      _step104;
    try {
      for (_iterator103.s(); !(_step104 = _iterator103.n()).done;) {
        var prop = _step104.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1c.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator103.e(err);
    } finally {
      _iterator103.f();
    }
  }
  return target;
};
var defaultProps$n = {
  color: "gray",
  icon: /* @__PURE__ */React__default.createElement(QuoteIcon, null)
};
var Blockquote = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Blockquote", defaultProps$n, props),
    className = _a.className,
    color = _a.color,
    icon = _a.icon,
    cite = _a.cite,
    children = _a.children,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$z(_a, ["className", "color", "icon", "cite", "children", "classNames", "styles"]);
  var _useStyles$m = useStyles$m({
      color: color
    }, {
      classNames: classNames,
      styles: styles,
      name: "Blockquote"
    }),
    classes = _useStyles$m.classes,
    cx = _useStyles$m.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1b({
    component: "blockquote",
    className: cx(classes.root, className),
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: classes.inner
  }, icon && /* @__PURE__ */React__default.createElement("div", {
    className: classes.icon
  }, icon), /* @__PURE__ */React__default.createElement("div", {
    className: classes.body
  }, children, cite && /* @__PURE__ */React__default.createElement("cite", {
    className: classes.cite
  }, cite))));
});
Blockquote.displayName = "@mantine/core/Blockquote";
var useStyles$n = createStyles(function (theme) {
  return {
    root: {
      display: "flex"
    },
    breadcrumb: {
      lineHeight: 1,
      whiteSpace: "nowrap",
      WebkitTapHighlightColor: "transparent"
    },
    separator: {
      marginLeft: theme.spacing.xs,
      marginRight: theme.spacing.xs,
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
      lineHeight: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});
var __defProp$1c = Object.defineProperty;
var __getOwnPropSymbols$1d = Object.getOwnPropertySymbols;
var __hasOwnProp$1d = Object.prototype.hasOwnProperty;
var __propIsEnum$1d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1c = function __defNormalProp$1c(obj, key, value) {
  return key in obj ? __defProp$1c(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1c = function __spreadValues$1c(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1d.call(b, prop)) __defNormalProp$1c(a, prop, b[prop]);
  if (__getOwnPropSymbols$1d) {
    var _iterator104 = _createForOfIteratorHelper(__getOwnPropSymbols$1d(b)),
      _step105;
    try {
      for (_iterator104.s(); !(_step105 = _iterator104.n()).done;) {
        var prop = _step105.value;
        if (__propIsEnum$1d.call(b, prop)) __defNormalProp$1c(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator104.e(err);
    } finally {
      _iterator104.f();
    }
  }
  return a;
};
var __objRest$A = function __objRest$A(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1d.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1d) {
    var _iterator105 = _createForOfIteratorHelper(__getOwnPropSymbols$1d(source)),
      _step106;
    try {
      for (_iterator105.s(); !(_step106 = _iterator105.n()).done;) {
        var prop = _step106.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1d.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator105.e(err);
    } finally {
      _iterator105.f();
    }
  }
  return target;
};
var defaultProps$o = {
  separator: "/"
};
var Breadcrumbs = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Breadcrumbs", defaultProps$o, props),
    className = _a.className,
    children = _a.children,
    separator = _a.separator,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$A(_a, ["className", "children", "separator", "classNames", "styles"]);
  var _useStyles$n = useStyles$n(null, {
      classNames: classNames,
      styles: styles,
      name: "Breadcrumbs"
    }),
    classes = _useStyles$n.classes,
    cx = _useStyles$n.cx;
  var items = React__default.Children.toArray(children).reduce(function (acc, child, index, array) {
    acc.push(React__default.cloneElement(child, {
      className: classes.breadcrumb,
      key: index
    }));
    if (index !== array.length - 1) {
      acc.push( /* @__PURE__ */React__default.createElement(Text, {
        size: "sm",
        className: classes.separator,
        key: "separator-".concat(index)
      }, separator));
    }
    return acc;
  }, []);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1c({
    className: cx(classes.root, className),
    ref: ref
  }, others), items);
});
Breadcrumbs.displayName = "@mantine/core/Breadcrumbs";
var sizes$5 = {
  xs: 12,
  sm: 18,
  md: 24,
  lg: 34,
  xl: 42
};
var useStyles$o = createStyles(function (theme, _ref83, getRef) {
  var size = _ref83.size,
    color = _ref83.color;
  var sizeValue = theme.fn.size({
    size: size,
    sizes: sizes$5
  });
  return {
    opened: {
      ref: getRef("opened")
    },
    root: {
      borderRadius: theme.radius.sm,
      width: sizeValue + theme.spacing.xs,
      height: sizeValue + theme.spacing.xs,
      padding: theme.spacing.xs / 2,
      cursor: "pointer"
    },
    burger: _defineProperty({
      position: "relative",
      userSelect: "none",
      boxSizing: "border-box",
      "&, &:before, &:after": {
        display: "block",
        width: sizeValue,
        height: Math.ceil(sizeValue / 12),
        backgroundColor: color,
        outline: "1px solid transparent",
        transitionProperty: "background-color, transform",
        transitionDuration: "300ms",
        "@media (prefers-reduced-motion)": {
          transitionDuration: "0ms"
        }
      },
      "&:before, &:after": {
        position: "absolute",
        content: '""',
        left: 0
      },
      "&:before": {
        top: sizeValue / 3 * -1
      },
      "&:after": {
        top: sizeValue / 3
      }
    }, "&.".concat(getRef("opened")), {
      backgroundColor: "transparent",
      "&:before": {
        transform: "translateY(".concat(sizeValue / 3, "px) rotate(45deg)")
      },
      "&:after": {
        transform: "translateY(-".concat(sizeValue / 3, "px) rotate(-45deg)")
      }
    })
  };
});
var __defProp$1d = Object.defineProperty;
var __getOwnPropSymbols$1e = Object.getOwnPropertySymbols;
var __hasOwnProp$1e = Object.prototype.hasOwnProperty;
var __propIsEnum$1e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1d = function __defNormalProp$1d(obj, key, value) {
  return key in obj ? __defProp$1d(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1d = function __spreadValues$1d(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1e.call(b, prop)) __defNormalProp$1d(a, prop, b[prop]);
  if (__getOwnPropSymbols$1e) {
    var _iterator106 = _createForOfIteratorHelper(__getOwnPropSymbols$1e(b)),
      _step107;
    try {
      for (_iterator106.s(); !(_step107 = _iterator106.n()).done;) {
        var prop = _step107.value;
        if (__propIsEnum$1e.call(b, prop)) __defNormalProp$1d(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator106.e(err);
    } finally {
      _iterator106.f();
    }
  }
  return a;
};
var __objRest$B = function __objRest$B(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1e.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1e) {
    var _iterator107 = _createForOfIteratorHelper(__getOwnPropSymbols$1e(source)),
      _step108;
    try {
      for (_iterator107.s(); !(_step108 = _iterator107.n()).done;) {
        var prop = _step108.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1e.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator107.e(err);
    } finally {
      _iterator107.f();
    }
  }
  return target;
};
var defaultProps$p = {
  size: "md"
};
var Burger = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Burger", defaultProps$p, props),
    className = _a.className,
    opened = _a.opened,
    color = _a.color,
    _a$size5 = _a.size,
    size = _a$size5 === void 0 ? "md" : _a$size5,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$B(_a, ["className", "opened", "color", "size", "classNames", "styles"]);
  var theme = useMantineTheme();
  var _color = color || (theme.colorScheme === "dark" ? theme.white : theme.black);
  var _useStyles$o = useStyles$o({
      color: _color,
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "Burger"
    }),
    classes = _useStyles$o.classes,
    cx = _useStyles$o.cx;
  return /* @__PURE__ */React__default.createElement(UnstyledButton, __spreadValues$1d({
    className: cx(classes.root, className),
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: cx(classes.burger, _defineProperty({}, classes.opened, opened))
  }));
});
Burger.displayName = "@mantine/core/Burger";
var __defProp$1e = Object.defineProperty;
var __defProps$A = Object.defineProperties;
var __getOwnPropDescs$A = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1f = Object.getOwnPropertySymbols;
var __hasOwnProp$1f = Object.prototype.hasOwnProperty;
var __propIsEnum$1f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1e = function __defNormalProp$1e(obj, key, value) {
  return key in obj ? __defProp$1e(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1e = function __spreadValues$1e(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1f.call(b, prop)) __defNormalProp$1e(a, prop, b[prop]);
  if (__getOwnPropSymbols$1f) {
    var _iterator108 = _createForOfIteratorHelper(__getOwnPropSymbols$1f(b)),
      _step109;
    try {
      for (_iterator108.s(); !(_step109 = _iterator108.n()).done;) {
        var prop = _step109.value;
        if (__propIsEnum$1f.call(b, prop)) __defNormalProp$1e(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator108.e(err);
    } finally {
      _iterator108.f();
    }
  }
  return a;
};
var __spreadProps$A = function __spreadProps$A(a, b) {
  return __defProps$A(a, __getOwnPropDescs$A(b));
};
var sizes$6 = {
  xs: {
    height: sizes$2.xs,
    padding: "0 14px"
  },
  sm: {
    height: sizes$2.sm,
    padding: "0 18px"
  },
  md: {
    height: sizes$2.md,
    padding: "0 22px"
  },
  lg: {
    height: sizes$2.lg,
    padding: "0 26px"
  },
  xl: {
    height: sizes$2.xl,
    padding: "0 32px"
  },
  "compact-xs": {
    height: 22,
    padding: "0 7px"
  },
  "compact-sm": {
    height: 26,
    padding: "0 8px"
  },
  "compact-md": {
    height: 30,
    padding: "0 10px"
  },
  "compact-lg": {
    height: 34,
    padding: "0 12px"
  },
  "compact-xl": {
    height: 40,
    padding: "0 14px"
  }
};
var heights$1 = Object.keys(sizes$6).reduce(function (acc, size) {
  acc[size] = sizes$6[size].height;
  return acc;
}, {});
var getSizeStyles = function getSizeStyles(_ref84) {
  var compact = _ref84.compact,
    size = _ref84.size;
  if (!compact) {
    return sizes$6[size];
  }
  return sizes$6["compact-".concat(size)];
};
var getWidthStyles = function getWidthStyles(fullWidth) {
  return {
    display: fullWidth ? "block" : "inline-block",
    width: fullWidth ? "100%" : "auto"
  };
};
function getVariantStyles$1(_ref85) {
  var variant = _ref85.variant,
    theme = _ref85.theme,
    color = _ref85.color;
  var colors = theme.fn.variant({
    color: color,
    variant: variant
  });
  return __spreadValues$1e({
    border: "1px solid ".concat(colors.border),
    backgroundColor: colors.background,
    backgroundImage: colors.background,
    color: colors.color
  }, theme.fn.hover({
    backgroundColor: colors.hover
  }));
}
var useStyles$p = createStyles(function (theme, _ref86, getRef) {
  var color = _ref86.color,
    size = _ref86.size,
    radius = _ref86.radius,
    fullWidth = _ref86.fullWidth,
    compact = _ref86.compact,
    gradientFrom = _ref86.gradientFrom,
    gradientTo = _ref86.gradientTo,
    gradientDeg = _ref86.gradientDeg;
  var gradient = theme.fn.variant({
    color: color,
    variant: "gradient",
    gradient: {
      from: gradientFrom,
      to: gradientTo,
      deg: gradientDeg
    }
  });
  return {
    loading: {
      ref: getRef("loading"),
      pointerEvents: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: theme.fn.radius(radius),
        cursor: "not-allowed"
      }
    },
    outline: getVariantStyles$1({
      variant: "outline",
      theme: theme,
      color: color
    }),
    filled: getVariantStyles$1({
      variant: "filled",
      theme: theme,
      color: color
    }),
    light: getVariantStyles$1({
      variant: "light",
      theme: theme,
      color: color
    }),
    default: getVariantStyles$1({
      variant: "default",
      theme: theme,
      color: color
    }),
    white: getVariantStyles$1({
      variant: "white",
      theme: theme,
      color: color
    }),
    subtle: getVariantStyles$1({
      variant: "subtle",
      theme: theme,
      color: color
    }),
    gradient: {
      border: 0,
      backgroundImage: gradient.background,
      color: gradient.color,
      "&:hover": theme.fn.hover({
        backgroundSize: "200%"
      })
    },
    root: __spreadProps$A(__spreadValues$1e(__spreadValues$1e(__spreadValues$1e(__spreadValues$1e({}, getSizeStyles({
      compact: compact,
      size: size
    })), theme.fn.fontStyles()), theme.fn.focusStyles()), getWidthStyles(fullWidth)), _defineProperty({
      borderRadius: theme.fn.radius(radius),
      fontWeight: 600,
      position: "relative",
      lineHeight: 1,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      WebkitTapHighlightColor: "transparent",
      userSelect: "none",
      boxSizing: "border-box",
      textDecoration: "none",
      cursor: "pointer",
      appearance: "none",
      WebkitAppearance: "none",
      "&:not(:disabled):active": {
        transform: "translateY(1px)"
      }
    }, "&:not(.".concat(getRef("loading"), "):disabled"), {
      borderColor: "transparent",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
      color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[5],
      cursor: "not-allowed"
    })),
    icon: {
      display: "flex",
      alignItems: "center"
    },
    leftIcon: {
      marginRight: 10
    },
    rightIcon: {
      marginLeft: 10
    },
    inner: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      overflow: "visible"
    },
    label: {
      whiteSpace: "nowrap",
      height: "100%",
      overflow: "hidden",
      display: "flex",
      alignItems: "center"
    }
  };
});
var __defProp$1f = Object.defineProperty;
var __getOwnPropSymbols$1g = Object.getOwnPropertySymbols;
var __hasOwnProp$1g = Object.prototype.hasOwnProperty;
var __propIsEnum$1g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1f = function __defNormalProp$1f(obj, key, value) {
  return key in obj ? __defProp$1f(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1f = function __spreadValues$1f(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1g.call(b, prop)) __defNormalProp$1f(a, prop, b[prop]);
  if (__getOwnPropSymbols$1g) {
    var _iterator109 = _createForOfIteratorHelper(__getOwnPropSymbols$1g(b)),
      _step110;
    try {
      for (_iterator109.s(); !(_step110 = _iterator109.n()).done;) {
        var prop = _step110.value;
        if (__propIsEnum$1g.call(b, prop)) __defNormalProp$1f(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator109.e(err);
    } finally {
      _iterator109.f();
    }
  }
  return a;
};
var __objRest$C = function __objRest$C(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1g.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1g) {
    var _iterator110 = _createForOfIteratorHelper(__getOwnPropSymbols$1g(source)),
      _step111;
    try {
      for (_iterator110.s(); !(_step111 = _iterator110.n()).done;) {
        var prop = _step111.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1g.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator110.e(err);
    } finally {
      _iterator110.f();
    }
  }
  return target;
};
var defaultProps$q = {
  size: "sm",
  type: "button",
  variant: "filled",
  loaderPosition: "left",
  gradient: {
    from: "blue",
    to: "cyan",
    deg: 45
  }
};
var Button = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Button", defaultProps$q, props),
    className = _a.className,
    size = _a.size,
    color = _a.color,
    type = _a.type,
    disabled = _a.disabled,
    children = _a.children,
    leftIcon = _a.leftIcon,
    rightIcon = _a.rightIcon,
    fullWidth = _a.fullWidth,
    variant = _a.variant,
    radius = _a.radius,
    component = _a.component,
    uppercase = _a.uppercase,
    compact = _a.compact,
    loading = _a.loading,
    loaderPosition = _a.loaderPosition,
    loaderProps = _a.loaderProps,
    gradient = _a.gradient,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$C(_a, ["className", "size", "color", "type", "disabled", "children", "leftIcon", "rightIcon", "fullWidth", "variant", "radius", "component", "uppercase", "compact", "loading", "loaderPosition", "loaderProps", "gradient", "classNames", "styles"]);
  var _useStyles$p = useStyles$p({
      radius: radius,
      color: color,
      size: size,
      fullWidth: fullWidth,
      compact: compact,
      gradientFrom: gradient.from,
      gradientTo: gradient.to,
      gradientDeg: gradient.deg
    }, {
      classNames: classNames,
      styles: styles,
      name: "Button"
    }),
    classes = _useStyles$p.classes,
    cx = _useStyles$p.cx,
    theme = _useStyles$p.theme;
  var colors = theme.fn.variant({
    color: color,
    variant: variant
  });
  var loader = /* @__PURE__ */React__default.createElement(Loader, __spreadValues$1f({
    color: colors.color,
    size: theme.fn.size({
      size: size,
      sizes: heights$1
    }) / 2
  }, loaderProps));
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1f({
    component: component || "button",
    className: cx(classes[variant], _defineProperty({}, classes.loading, loading), classes.root, className),
    type: type,
    disabled: disabled || loading,
    ref: ref,
    onTouchStart: function onTouchStart() {}
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: classes.inner
  }, (leftIcon || loading && loaderPosition === "left") && /* @__PURE__ */React__default.createElement("span", {
    className: cx(classes.icon, classes.leftIcon)
  }, loading && loaderPosition === "left" ? loader : leftIcon), /* @__PURE__ */React__default.createElement("span", {
    className: classes.label,
    style: {
      textTransform: uppercase ? "uppercase" : void 0
    }
  }, children), (rightIcon || loading && loaderPosition === "right") && /* @__PURE__ */React__default.createElement("span", {
    className: cx(classes.icon, classes.rightIcon)
  }, loading && loaderPosition === "right" ? loader : rightIcon)));
});
Button.displayName = "@mantine/core/Button";
var useStyles$q = createStyles(function (theme, _ref87) {
  var padding = _ref87.padding,
    first = _ref87.first,
    last = _ref87.last;
  return {
    cardSection: {
      display: "block",
      marginLeft: -1 * theme.fn.size({
        size: padding,
        sizes: theme.spacing
      }),
      marginRight: -1 * theme.fn.size({
        size: padding,
        sizes: theme.spacing
      }),
      marginTop: first ? -1 * theme.fn.size({
        size: padding,
        sizes: theme.spacing
      }) : void 0,
      marginBottom: last ? -1 * theme.fn.size({
        size: padding,
        sizes: theme.spacing
      }) : void 0
    }
  };
});
var __defProp$1g = Object.defineProperty;
var __getOwnPropSymbols$1h = Object.getOwnPropertySymbols;
var __hasOwnProp$1h = Object.prototype.hasOwnProperty;
var __propIsEnum$1h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1g = function __defNormalProp$1g(obj, key, value) {
  return key in obj ? __defProp$1g(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1g = function __spreadValues$1g(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1h.call(b, prop)) __defNormalProp$1g(a, prop, b[prop]);
  if (__getOwnPropSymbols$1h) {
    var _iterator111 = _createForOfIteratorHelper(__getOwnPropSymbols$1h(b)),
      _step112;
    try {
      for (_iterator111.s(); !(_step112 = _iterator111.n()).done;) {
        var prop = _step112.value;
        if (__propIsEnum$1h.call(b, prop)) __defNormalProp$1g(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator111.e(err);
    } finally {
      _iterator111.f();
    }
  }
  return a;
};
var __objRest$D = function __objRest$D(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1h.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1h) {
    var _iterator112 = _createForOfIteratorHelper(__getOwnPropSymbols$1h(source)),
      _step113;
    try {
      for (_iterator112.s(); !(_step113 = _iterator112.n()).done;) {
        var prop = _step113.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1h.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator112.e(err);
    } finally {
      _iterator112.f();
    }
  }
  return target;
};
var CardSection = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    _b$padding = _b.padding,
    padding = _b$padding === void 0 ? 0 : _b$padding,
    component = _b.component,
    first = _b.first,
    last = _b.last,
    others = __objRest$D(_b, ["className", "padding", "component", "first", "last"]);
  var _useStyles$q = useStyles$q({
      padding: padding,
      first: first,
      last: last
    }, {
      name: "Card"
    }),
    classes = _useStyles$q.classes,
    cx = _useStyles$q.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1g({
    component: component || "div",
    className: cx(classes.cardSection, className),
    ref: ref
  }, others));
});
CardSection.displayName = "@mantine/core/CardSection";
var useStyles$r = createStyles(function (theme) {
  return {
    root: {
      position: "relative",
      overflow: "hidden",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
    }
  };
});
var __defProp$1h = Object.defineProperty;
var __getOwnPropSymbols$1i = Object.getOwnPropertySymbols;
var __hasOwnProp$1i = Object.prototype.hasOwnProperty;
var __propIsEnum$1i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1h = function __defNormalProp$1h(obj, key, value) {
  return key in obj ? __defProp$1h(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1h = function __spreadValues$1h(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1i.call(b, prop)) __defNormalProp$1h(a, prop, b[prop]);
  if (__getOwnPropSymbols$1i) {
    var _iterator113 = _createForOfIteratorHelper(__getOwnPropSymbols$1i(b)),
      _step114;
    try {
      for (_iterator113.s(); !(_step114 = _iterator113.n()).done;) {
        var prop = _step114.value;
        if (__propIsEnum$1i.call(b, prop)) __defNormalProp$1h(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator113.e(err);
    } finally {
      _iterator113.f();
    }
  }
  return a;
};
var __objRest$E = function __objRest$E(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1i.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1i) {
    var _iterator114 = _createForOfIteratorHelper(__getOwnPropSymbols$1i(source)),
      _step115;
    try {
      for (_iterator114.s(); !(_step115 = _iterator114.n()).done;) {
        var prop = _step115.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1i.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator114.e(err);
    } finally {
      _iterator114.f();
    }
  }
  return target;
};
var defaultProps$r = {
  p: "md"
};
var Card = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Card", defaultProps$r, props),
    component = _a.component,
    className = _a.className,
    p = _a.p,
    radius = _a.radius,
    children = _a.children,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$E(_a, ["component", "className", "p", "radius", "children", "classNames", "styles"]);
  var _useStyles$r = useStyles$r(null, {
      name: "Card",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$r.classes,
    cx = _useStyles$r.cx;
  var _children = Children.toArray(children);
  var content = _children.map(function (child, index) {
    if (typeof child === "object" && child && "type" in child && child.type === CardSection) {
      return cloneElement(child, {
        padding: p,
        first: index === 0,
        last: index === _children.length - 1
      });
    }
    return child;
  });
  return /* @__PURE__ */React__default.createElement(Paper, __spreadValues$1h({
    className: cx(classes.root, className),
    radius: radius,
    p: p,
    component: component || "div",
    ref: ref
  }, others), content);
});
Card.Section = CardSection;
Card.displayName = "@mantine/core/Card";
var __defProp$1i = Object.defineProperty;
var __getOwnPropSymbols$1j = Object.getOwnPropertySymbols;
var __hasOwnProp$1j = Object.prototype.hasOwnProperty;
var __propIsEnum$1j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1i = function __defNormalProp$1i(obj, key, value) {
  return key in obj ? __defProp$1i(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1i = function __spreadValues$1i(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1j.call(b, prop)) __defNormalProp$1i(a, prop, b[prop]);
  if (__getOwnPropSymbols$1j) {
    var _iterator115 = _createForOfIteratorHelper(__getOwnPropSymbols$1j(b)),
      _step116;
    try {
      for (_iterator115.s(); !(_step116 = _iterator115.n()).done;) {
        var prop = _step116.value;
        if (__propIsEnum$1j.call(b, prop)) __defNormalProp$1i(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator115.e(err);
    } finally {
      _iterator115.f();
    }
  }
  return a;
};
var __objRest$F = function __objRest$F(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1j.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1j) {
    var _iterator116 = _createForOfIteratorHelper(__getOwnPropSymbols$1j(source)),
      _step117;
    try {
      for (_iterator116.s(); !(_step117 = _iterator116.n()).done;) {
        var prop = _step117.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1j.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator116.e(err);
    } finally {
      _iterator116.f();
    }
  }
  return target;
};
function CheckboxIcon(_a) {
  var _b = _a,
    indeterminate = _b.indeterminate,
    others = __objRest$F(_b, ["indeterminate"]);
  if (indeterminate) {
    return /* @__PURE__ */React__default.createElement("svg", __spreadValues$1i({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 6"
    }, others), /* @__PURE__ */React__default.createElement("rect", {
      width: "32",
      height: "6",
      fill: "currentColor",
      rx: "3"
    }));
  }
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$1i({
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, others), /* @__PURE__ */React__default.createElement("path", {
    d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var __defProp$1j = Object.defineProperty;
var __defProps$B = Object.defineProperties;
var __getOwnPropDescs$B = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1k = Object.getOwnPropertySymbols;
var __hasOwnProp$1k = Object.prototype.hasOwnProperty;
var __propIsEnum$1k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1j = function __defNormalProp$1j(obj, key, value) {
  return key in obj ? __defProp$1j(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1j = function __spreadValues$1j(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1k.call(b, prop)) __defNormalProp$1j(a, prop, b[prop]);
  if (__getOwnPropSymbols$1k) {
    var _iterator117 = _createForOfIteratorHelper(__getOwnPropSymbols$1k(b)),
      _step118;
    try {
      for (_iterator117.s(); !(_step118 = _iterator117.n()).done;) {
        var prop = _step118.value;
        if (__propIsEnum$1k.call(b, prop)) __defNormalProp$1j(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator117.e(err);
    } finally {
      _iterator117.f();
    }
  }
  return a;
};
var __spreadProps$B = function __spreadProps$B(a, b) {
  return __defProps$B(a, __getOwnPropDescs$B(b));
};
var sizes$7 = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 30,
  xl: 36
};
var iconSizes$1 = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 16,
  xl: 20
};
var useStyles$s = createStyles(function (theme, _ref88, getRef) {
  var size = _ref88.size,
    radius = _ref88.radius,
    color = _ref88.color,
    transitionDuration = _ref88.transitionDuration;
  var _size = theme.fn.size({
    size: size,
    sizes: sizes$7
  });
  var colors = theme.fn.variant({
    variant: "filled",
    color: color
  });
  return {
    icon: {
      ref: getRef("icon"),
      color: theme.white,
      transform: "translateY(5px) scale(0.5)",
      opacity: 0,
      transitionProperty: "opacity, transform",
      transitionTimingFunction: "ease",
      transitionDuration: "".concat(transitionDuration, "ms"),
      pointerEvents: "none",
      width: theme.fn.size({
        size: size,
        sizes: iconSizes$1
      }),
      position: "absolute",
      zIndex: 1,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
      "@media (prefers-reduced-motion)": {
        transitionDuration: "0ms"
      }
    },
    root: {
      display: "flex",
      alignItems: "center"
    },
    inner: {
      position: "relative",
      width: _size,
      height: _size
    },
    label: __spreadProps$B(__spreadValues$1j({}, theme.fn.fontStyles()), {
      WebkitTapHighlightColor: "transparent",
      paddingLeft: theme.spacing.sm,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      lineHeight: "".concat(_size, "px"),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    }),
    input: __spreadProps$B(__spreadValues$1j({}, theme.fn.focusStyles()), {
      appearance: "none",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.white,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]),
      width: _size,
      height: _size,
      borderRadius: theme.fn.radius(radius),
      padding: 0,
      display: "block",
      margin: 0,
      transition: "border-color ".concat(transitionDuration, "ms ease, background-color ").concat(transitionDuration, "ms ease"),
      "&:checked": _defineProperty({
        backgroundColor: colors.background,
        borderColor: colors.background
      }, "& + .".concat(getRef("icon")), {
        opacity: 1,
        transform: "translateY(0) scale(1)"
      }),
      "&:disabled": _defineProperty({
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[3],
        cursor: "not-allowed"
      }, "& + .".concat(getRef("icon")), {
        color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[5]
      })
    })
  };
});
var __defProp$1k = Object.defineProperty;
var __getOwnPropSymbols$1l = Object.getOwnPropertySymbols;
var __hasOwnProp$1l = Object.prototype.hasOwnProperty;
var __propIsEnum$1l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1k = function __defNormalProp$1k(obj, key, value) {
  return key in obj ? __defProp$1k(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1k = function __spreadValues$1k(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1l.call(b, prop)) __defNormalProp$1k(a, prop, b[prop]);
  if (__getOwnPropSymbols$1l) {
    var _iterator118 = _createForOfIteratorHelper(__getOwnPropSymbols$1l(b)),
      _step119;
    try {
      for (_iterator118.s(); !(_step119 = _iterator118.n()).done;) {
        var prop = _step119.value;
        if (__propIsEnum$1l.call(b, prop)) __defNormalProp$1k(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator118.e(err);
    } finally {
      _iterator118.f();
    }
  }
  return a;
};
var __objRest$G = function __objRest$G(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1l.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1l) {
    var _iterator119 = _createForOfIteratorHelper(__getOwnPropSymbols$1l(source)),
      _step120;
    try {
      for (_iterator119.s(); !(_step120 = _iterator119.n()).done;) {
        var prop = _step120.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1l.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator119.e(err);
    } finally {
      _iterator119.f();
    }
  }
  return target;
};
var defaultProps$s = {
  size: "sm",
  __staticSelector: "Checkbox",
  transitionDuration: 100,
  icon: CheckboxIcon
};
var Checkbox = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Checkbox", defaultProps$s, props),
    className = _a.className,
    style = _a.style,
    sx = _a.sx,
    checked = _a.checked,
    color = _a.color,
    label = _a.label,
    indeterminate = _a.indeterminate,
    id = _a.id,
    size = _a.size,
    radius = _a.radius,
    wrapperProps = _a.wrapperProps,
    children = _a.children,
    classNames = _a.classNames,
    styles = _a.styles,
    transitionDuration = _a.transitionDuration,
    Icon = _a.icon,
    __staticSelector = _a.__staticSelector,
    others = __objRest$G(_a, ["className", "style", "sx", "checked", "color", "label", "indeterminate", "id", "size", "radius", "wrapperProps", "children", "classNames", "styles", "transitionDuration", "icon", "__staticSelector"]);
  var uuid = useUuid(id);
  var _extractSystemStyles5 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles5.systemStyles,
    rest = _extractSystemStyles5.rest;
  var _useStyles$s = useStyles$s({
      size: size,
      radius: radius,
      color: color,
      transitionDuration: transitionDuration
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$s.classes,
    cx = _useStyles$s.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1k(__spreadValues$1k({
    className: cx(classes.root, className),
    style: style,
    sx: sx
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement("div", {
    className: classes.inner
  }, /* @__PURE__ */React__default.createElement("input", __spreadValues$1k({
    id: uuid,
    ref: ref,
    type: "checkbox",
    className: classes.input,
    checked: indeterminate || checked
  }, rest)), /* @__PURE__ */React__default.createElement(Icon, {
    indeterminate: indeterminate,
    className: classes.icon
  })), label && /* @__PURE__ */React__default.createElement("label", {
    className: classes.label,
    htmlFor: uuid
  }, label));
});
Checkbox.displayName = "@mantine/core/Checkbox";
var POSITIONS = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
  apart: "space-between"
};
var useStyles$t = createStyles(function (theme, _ref89) {
  var spacing = _ref89.spacing,
    position = _ref89.position,
    noWrap = _ref89.noWrap,
    direction = _ref89.direction,
    grow = _ref89.grow,
    align = _ref89.align,
    count = _ref89.count;
  return {
    root: {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: direction,
      alignItems: align || (direction === "row" ? "center" : grow ? "stretch" : position === "apart" ? "flex-start" : POSITIONS[position]),
      flexWrap: noWrap ? "nowrap" : "wrap",
      justifyContent: direction === "row" ? POSITIONS[position] : void 0,
      gap: theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      })
    },
    child: {
      boxSizing: "border-box",
      maxWidth: grow && direction === "row" ? "calc(".concat(100 / count, "% - ").concat(theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      }) - theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      }) / count, "px)") : void 0,
      flexGrow: grow ? 1 : 0
    }
  };
});
var __defProp$1l = Object.defineProperty;
var __getOwnPropSymbols$1m = Object.getOwnPropertySymbols;
var __hasOwnProp$1m = Object.prototype.hasOwnProperty;
var __propIsEnum$1m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1l = function __defNormalProp$1l(obj, key, value) {
  return key in obj ? __defProp$1l(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1l = function __spreadValues$1l(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1m.call(b, prop)) __defNormalProp$1l(a, prop, b[prop]);
  if (__getOwnPropSymbols$1m) {
    var _iterator120 = _createForOfIteratorHelper(__getOwnPropSymbols$1m(b)),
      _step121;
    try {
      for (_iterator120.s(); !(_step121 = _iterator120.n()).done;) {
        var prop = _step121.value;
        if (__propIsEnum$1m.call(b, prop)) __defNormalProp$1l(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator120.e(err);
    } finally {
      _iterator120.f();
    }
  }
  return a;
};
var __objRest$H = function __objRest$H(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1m.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1m) {
    var _iterator121 = _createForOfIteratorHelper(__getOwnPropSymbols$1m(source)),
      _step122;
    try {
      for (_iterator121.s(); !(_step122 = _iterator121.n()).done;) {
        var prop = _step122.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1m.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator121.e(err);
    } finally {
      _iterator121.f();
    }
  }
  return target;
};
var defaultProps$t = {
  position: "left",
  spacing: "md",
  direction: "row"
};
var Group = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Group", defaultProps$t, props),
    className = _a.className,
    position = _a.position,
    align = _a.align,
    children = _a.children,
    noWrap = _a.noWrap,
    grow = _a.grow,
    spacing = _a.spacing,
    direction = _a.direction,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$H(_a, ["className", "position", "align", "children", "noWrap", "grow", "spacing", "direction", "classNames", "styles"]);
  var filteredChildren = filterFalsyChildren(children);
  var _useStyles$t = useStyles$t({
      align: align,
      grow: grow,
      noWrap: noWrap,
      spacing: spacing,
      position: position,
      direction: direction,
      count: filteredChildren.length
    }, {
      classNames: classNames,
      styles: styles,
      name: "Group"
    }),
    classes = _useStyles$t.classes,
    cx = _useStyles$t.cx;
  var items = filteredChildren.map(function (child) {
    var _a2;
    if (typeof child === "object" && child !== null && "props" in child) {
      return React__default.cloneElement(child, {
        className: cx(classes.child, (_a2 = child.props) == null ? void 0 : _a2.className)
      });
    }
    return child;
  });
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1l({
    className: cx(classes.root, className),
    ref: ref
  }, others), items);
});
Group.displayName = "@mantine/core/Group";
var __defProp$1m = Object.defineProperty;
var __getOwnPropSymbols$1n = Object.getOwnPropertySymbols;
var __hasOwnProp$1n = Object.prototype.hasOwnProperty;
var __propIsEnum$1n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1m = function __defNormalProp$1m(obj, key, value) {
  return key in obj ? __defProp$1m(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1m = function __spreadValues$1m(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1n.call(b, prop)) __defNormalProp$1m(a, prop, b[prop]);
  if (__getOwnPropSymbols$1n) {
    var _iterator122 = _createForOfIteratorHelper(__getOwnPropSymbols$1n(b)),
      _step123;
    try {
      for (_iterator122.s(); !(_step123 = _iterator122.n()).done;) {
        var prop = _step123.value;
        if (__propIsEnum$1n.call(b, prop)) __defNormalProp$1m(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator122.e(err);
    } finally {
      _iterator122.f();
    }
  }
  return a;
};
var __objRest$I = function __objRest$I(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1n.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1n) {
    var _iterator123 = _createForOfIteratorHelper(__getOwnPropSymbols$1n(source)),
      _step124;
    try {
      for (_iterator123.s(); !(_step124 = _iterator123.n()).done;) {
        var prop = _step124.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1n.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator123.e(err);
    } finally {
      _iterator123.f();
    }
  }
  return target;
};
var defaultProps$u = {
  orientation: "horizontal",
  spacing: "lg",
  size: "sm"
};
var CheckboxGroup = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("CheckboxGroup", defaultProps$u, props),
    children = _a.children,
    value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    orientation = _a.orientation,
    spacing = _a.spacing,
    color = _a.color,
    size = _a.size,
    classNames = _a.classNames,
    styles = _a.styles,
    wrapperProps = _a.wrapperProps,
    errorProps = _a.errorProps,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    others = __objRest$I(_a, ["children", "value", "defaultValue", "onChange", "orientation", "spacing", "color", "size", "classNames", "styles", "wrapperProps", "errorProps", "labelProps", "descriptionProps"]);
  var _useUncontrolled7 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: [],
      onChange: onChange,
      rule: function rule(val) {
        return Array.isArray(val);
      }
    }),
    _useUncontrolled8 = _slicedToArray(_useUncontrolled7, 2),
    _value = _useUncontrolled8[0],
    setValue = _useUncontrolled8[1];
  var checkboxes = filterChildrenByType(children, Checkbox).map(function (checkbox, index) {
    return cloneElement(checkbox, {
      key: index,
      checked: _value.includes(checkbox.props.value),
      color: color,
      size: size,
      classNames: classNames,
      styles: styles,
      __staticSelector: "CheckboxGroup",
      onChange: function onChange(event) {
        var itemValue = event.currentTarget.value;
        setValue(_value.includes(itemValue) ? _value.filter(function (item) {
          return item !== itemValue;
        }) : [].concat(_toConsumableArray2(_value), [itemValue]));
      }
    });
  });
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$1m(__spreadValues$1m({
    labelElement: "div",
    size: size,
    __staticSelector: "CheckboxGroup",
    classNames: classNames,
    styles: styles,
    ref: ref,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, wrapperProps), others), /* @__PURE__ */React__default.createElement(Group, {
    spacing: spacing,
    direction: orientation === "horizontal" ? "row" : "column",
    sx: {
      paddingTop: 5
    }
  }, checkboxes));
});
CheckboxGroup.displayName = "@mantine/core/CheckboxGroup";
var __defProp$1n = Object.defineProperty;
var __defProps$C = Object.defineProperties;
var __getOwnPropDescs$C = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1o = Object.getOwnPropertySymbols;
var __hasOwnProp$1o = Object.prototype.hasOwnProperty;
var __propIsEnum$1o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1n = function __defNormalProp$1n(obj, key, value) {
  return key in obj ? __defProp$1n(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1n = function __spreadValues$1n(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1o.call(b, prop)) __defNormalProp$1n(a, prop, b[prop]);
  if (__getOwnPropSymbols$1o) {
    var _iterator124 = _createForOfIteratorHelper(__getOwnPropSymbols$1o(b)),
      _step125;
    try {
      for (_iterator124.s(); !(_step125 = _iterator124.n()).done;) {
        var prop = _step125.value;
        if (__propIsEnum$1o.call(b, prop)) __defNormalProp$1n(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator124.e(err);
    } finally {
      _iterator124.f();
    }
  }
  return a;
};
var __spreadProps$C = function __spreadProps$C(a, b) {
  return __defProps$C(a, __getOwnPropDescs$C(b));
};
var sizes$8 = {
  xs: 24,
  sm: 28,
  md: 32,
  lg: 36,
  xl: 40
};
var iconSizes$2 = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18
};
var padding = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 28,
  xl: 32
};
var checkedPadding = {
  xs: 7.5,
  sm: 10,
  md: 11.5,
  lg: 13,
  xl: 15
};
var useStyles$u = createStyles(function (theme, _ref90, getRef) {
  var _checked2, _focus;
  var radius = _ref90.radius,
    size = _ref90.size,
    color = _ref90.color;
  return {
    root: {},
    label: __spreadProps$C(__spreadValues$1n({
      ref: getRef("label")
    }, theme.fn.fontStyles()), {
      boxSizing: "border-box",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      display: "inline-block",
      alignItems: "center",
      userSelect: "none",
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4]),
      borderRadius: theme.fn.radius(radius),
      height: theme.fn.size({
        size: size,
        sizes: sizes$8
      }),
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      lineHeight: "".concat(theme.fn.size({
        size: size,
        sizes: sizes$8
      }) - 2, "px"),
      paddingLeft: theme.fn.size({
        size: size,
        sizes: padding
      }),
      paddingRight: theme.fn.size({
        size: size,
        sizes: padding
      }),
      cursor: "pointer",
      whiteSpace: "nowrap",
      transition: "background-color 100ms ease",
      WebkitTapHighlightColor: "transparent"
    }),
    outline: __spreadValues$1n({
      ref: getRef("outline"),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
    })),
    filled: __spreadValues$1n({
      ref: getRef("filled"),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
      borderColor: "transparent"
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
    })),
    iconWrapper: {
      ref: getRef("iconWrapper"),
      color: theme.fn.variant({
        variant: "filled",
        color: color
      }).background,
      width: theme.fn.size({
        size: size,
        sizes: iconSizes$2
      }) + theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 1.5,
      maxWidth: theme.fn.size({
        size: size,
        sizes: iconSizes$2
      }) + theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 1.5,
      height: theme.fn.size({
        size: size,
        sizes: iconSizes$2
      }),
      display: "inline-block",
      verticalAlign: "middle",
      overflow: "hidden"
    },
    disabled: __spreadProps$C(__spreadValues$1n({
      backgroundColor: "".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1], " !important"),
      borderColor: "".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1], " !important"),
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5],
      cursor: "not-allowed"
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]
    })), _defineProperty({}, "& .".concat(getRef("iconWrapper")), {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
    })),
    checked: (_checked2 = {
      paddingLeft: theme.fn.size({
        size: size,
        sizes: checkedPadding
      }),
      paddingRight: theme.fn.size({
        size: size,
        sizes: checkedPadding
      })
    }, _defineProperty(_checked2, "&.".concat(getRef("outline")), {
      border: "1px solid ".concat(theme.fn.variant({
        variant: "filled",
        color: color
      }).background)
    }), _defineProperty(_checked2, "&.".concat(getRef("filled")), {
      "&, &:hover": {
        backgroundColor: theme.fn.variant({
          variant: "light",
          color: color
        }).background
      }
    }), _checked2),
    checkIcon: {
      width: theme.fn.size({
        size: size,
        sizes: iconSizes$2
      }),
      height: theme.fn.size({
        size: size,
        sizes: iconSizes$2
      }) / 1.1,
      display: "block"
    },
    input: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: 0,
      "&:focus": (_focus = {
        outline: "none"
      }, _defineProperty(_focus, "& + .".concat(getRef("label")), {
        outline: "none",
        boxShadow: theme.focusRing === "always" || theme.focusRing === "auto" ? "0 0 0 2px ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white, ", 0 0 0 4px ").concat(theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5]) : void 0
      }), _defineProperty(_focus, "&:focus:not(:focus-visible)", _defineProperty({}, "& + .".concat(getRef("label")), {
        boxShadow: theme.focusRing === "auto" || theme.focusRing === "never" ? "none" : void 0
      })), _focus)
    }
  };
});
var __defProp$1o = Object.defineProperty;
var __getOwnPropSymbols$1p = Object.getOwnPropertySymbols;
var __hasOwnProp$1p = Object.prototype.hasOwnProperty;
var __propIsEnum$1p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1o = function __defNormalProp$1o(obj, key, value) {
  return key in obj ? __defProp$1o(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1o = function __spreadValues$1o(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1p.call(b, prop)) __defNormalProp$1o(a, prop, b[prop]);
  if (__getOwnPropSymbols$1p) {
    var _iterator125 = _createForOfIteratorHelper(__getOwnPropSymbols$1p(b)),
      _step126;
    try {
      for (_iterator125.s(); !(_step126 = _iterator125.n()).done;) {
        var prop = _step126.value;
        if (__propIsEnum$1p.call(b, prop)) __defNormalProp$1o(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator125.e(err);
    } finally {
      _iterator125.f();
    }
  }
  return a;
};
var __objRest$J = function __objRest$J(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1p.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1p) {
    var _iterator126 = _createForOfIteratorHelper(__getOwnPropSymbols$1p(source)),
      _step127;
    try {
      for (_iterator126.s(); !(_step127 = _iterator126.n()).done;) {
        var prop = _step127.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1p.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator126.e(err);
    } finally {
      _iterator126.f();
    }
  }
  return target;
};
var defaultProps$v = {
  type: "checkbox",
  size: "sm",
  radius: "xl",
  __staticSelector: "Chip"
};
var Chip = forwardRef(function (props, ref) {
  var _cx8;
  var _a = useMantineDefaultProps("Chip", defaultProps$v, props),
    radius = _a.radius,
    type = _a.type,
    size = _a.size,
    variant = _a.variant,
    disabled = _a.disabled,
    __staticSelector = _a.__staticSelector,
    id = _a.id,
    color = _a.color,
    children = _a.children,
    className = _a.className,
    classNames = _a.classNames,
    style = _a.style,
    styles = _a.styles,
    checked = _a.checked,
    defaultChecked = _a.defaultChecked,
    onChange = _a.onChange,
    sx = _a.sx,
    wrapperProps = _a.wrapperProps,
    others = __objRest$J(_a, ["radius", "type", "size", "variant", "disabled", "__staticSelector", "id", "color", "children", "className", "classNames", "style", "styles", "checked", "defaultChecked", "onChange", "sx", "wrapperProps"]);
  var uuid = useUuid(id);
  var _extractSystemStyles6 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles6.systemStyles,
    rest = _extractSystemStyles6.rest;
  var _useStyles$u = useStyles$u({
      radius: radius,
      size: size,
      color: color
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$u.classes,
    cx = _useStyles$u.cx,
    theme = _useStyles$u.theme;
  var _useUncontrolled9 = useUncontrolled({
      value: checked,
      defaultValue: defaultChecked,
      finalValue: false,
      onChange: onChange,
      rule: function rule(val) {
        return typeof val === "boolean";
      }
    }),
    _useUncontrolled10 = _slicedToArray(_useUncontrolled9, 2),
    value = _useUncontrolled10[0],
    setValue = _useUncontrolled10[1];
  var defaultVariant = theme.colorScheme === "dark" ? "filled" : "outline";
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1o(__spreadValues$1o({
    className: cx(classes.root, className),
    style: style,
    sx: sx
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement("input", __spreadValues$1o({
    type: type,
    className: classes.input,
    checked: value,
    onChange: function onChange(event) {
      return setValue(event.currentTarget.checked);
    },
    id: uuid,
    disabled: disabled,
    ref: ref
  }, rest)), /* @__PURE__ */React__default.createElement("label", {
    htmlFor: uuid,
    className: cx(classes.label, (_cx8 = {}, _defineProperty(_cx8, classes.checked, value), _defineProperty(_cx8, classes.disabled, disabled), _cx8), classes[variant || defaultVariant])
  }, value && /* @__PURE__ */React__default.createElement("span", {
    className: classes.iconWrapper
  }, /* @__PURE__ */React__default.createElement(CheckboxIcon, {
    indeterminate: false,
    className: classes.checkIcon
  })), children));
});
Chip.displayName = "@mantine/core/Chip";
var __defProp$1q = Object.defineProperty;
var __defProps$D = Object.defineProperties;
var __getOwnPropDescs$D = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1r = Object.getOwnPropertySymbols;
var __hasOwnProp$1r = Object.prototype.hasOwnProperty;
var __propIsEnum$1r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1q = function __defNormalProp$1q(obj, key, value) {
  return key in obj ? __defProp$1q(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1q = function __spreadValues$1q(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1r.call(b, prop)) __defNormalProp$1q(a, prop, b[prop]);
  if (__getOwnPropSymbols$1r) {
    var _iterator127 = _createForOfIteratorHelper(__getOwnPropSymbols$1r(b)),
      _step128;
    try {
      for (_iterator127.s(); !(_step128 = _iterator127.n()).done;) {
        var prop = _step128.value;
        if (__propIsEnum$1r.call(b, prop)) __defNormalProp$1q(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator127.e(err);
    } finally {
      _iterator127.f();
    }
  }
  return a;
};
var __spreadProps$D = function __spreadProps$D(a, b) {
  return __defProps$D(a, __getOwnPropDescs$D(b));
};
var useStyles$v = createStyles(function (theme, _ref91) {
  var color = _ref91.color;
  var colors = theme.fn.variant({
    color: color,
    variant: "light"
  });
  return {
    root: __spreadProps$D(__spreadValues$1q({}, theme.fn.fontStyles()), {
      lineHeight: theme.lineHeight,
      padding: "2px ".concat(theme.spacing.xs / 2, "px"),
      borderRadius: theme.radius.sm,
      color: theme.colorScheme === "dark" ? color === "dark" ? theme.colors.dark[0] : theme.white : theme.colors.dark[7],
      backgroundColor: theme.colorScheme === "dark" && color === "dark" ? theme.colors.dark[4] : colors.background,
      fontFamily: theme.fontFamilyMonospace,
      fontSize: theme.fontSizes.xs
    }),
    block: {
      padding: theme.spacing.xs,
      margin: 0,
      overflowX: "auto"
    }
  };
});
var __defProp$1r = Object.defineProperty;
var __getOwnPropSymbols$1s = Object.getOwnPropertySymbols;
var __hasOwnProp$1s = Object.prototype.hasOwnProperty;
var __propIsEnum$1s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1r = function __defNormalProp$1r(obj, key, value) {
  return key in obj ? __defProp$1r(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1r = function __spreadValues$1r(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1s.call(b, prop)) __defNormalProp$1r(a, prop, b[prop]);
  if (__getOwnPropSymbols$1s) {
    var _iterator128 = _createForOfIteratorHelper(__getOwnPropSymbols$1s(b)),
      _step129;
    try {
      for (_iterator128.s(); !(_step129 = _iterator128.n()).done;) {
        var prop = _step129.value;
        if (__propIsEnum$1s.call(b, prop)) __defNormalProp$1r(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator128.e(err);
    } finally {
      _iterator128.f();
    }
  }
  return a;
};
var __objRest$L = function __objRest$L(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1s.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1s) {
    var _iterator129 = _createForOfIteratorHelper(__getOwnPropSymbols$1s(source)),
      _step130;
    try {
      for (_iterator129.s(); !(_step130 = _iterator129.n()).done;) {
        var prop = _step130.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1s.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator129.e(err);
    } finally {
      _iterator129.f();
    }
  }
  return target;
};
var Code = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Code", {}, props),
    className = _a.className,
    children = _a.children,
    block = _a.block,
    color = _a.color,
    styles = _a.styles,
    classNames = _a.classNames,
    others = __objRest$L(_a, ["className", "children", "block", "color", "styles", "classNames"]);
  var theme = useMantineTheme();
  var themeColor = color || (theme.colorScheme === "dark" ? "dark" : "gray");
  var _useStyles$v = useStyles$v({
      color: themeColor
    }, {
      name: "Code",
      styles: styles,
      classNames: classNames
    }),
    classes = _useStyles$v.classes,
    cx = _useStyles$v.cx;
  if (block) {
    return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1r({
      component: "pre",
      dir: "ltr",
      className: cx(classes.root, classes.block, className),
      ref: ref
    }, others), children);
  }
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1r({
    component: "code",
    className: cx(classes.root, className),
    ref: ref,
    dir: "ltr"
  }, others), children);
});
Code.displayName = "@mantine/core/Code";
var __defProp$1s = Object.defineProperty;
var __defProps$E = Object.defineProperties;
var __getOwnPropDescs$E = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1t = Object.getOwnPropertySymbols;
var __hasOwnProp$1t = Object.prototype.hasOwnProperty;
var __propIsEnum$1t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1s = function __defNormalProp$1s(obj, key, value) {
  return key in obj ? __defProp$1s(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1s = function __spreadValues$1s(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1t.call(b, prop)) __defNormalProp$1s(a, prop, b[prop]);
  if (__getOwnPropSymbols$1t) {
    var _iterator130 = _createForOfIteratorHelper(__getOwnPropSymbols$1t(b)),
      _step131;
    try {
      for (_iterator130.s(); !(_step131 = _iterator130.n()).done;) {
        var prop = _step131.value;
        if (__propIsEnum$1t.call(b, prop)) __defNormalProp$1s(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator130.e(err);
    } finally {
      _iterator130.f();
    }
  }
  return a;
};
var __spreadProps$E = function __spreadProps$E(a, b) {
  return __defProps$E(a, __getOwnPropDescs$E(b));
};
var useStyles$w = createStyles(function (theme, _ref92) {
  var size = _ref92.size,
    radius = _ref92.radius;
  var overlayColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
  return {
    root: __spreadProps$E(__spreadValues$1s({}, theme.fn.focusStyles()), {
      width: size,
      height: size,
      WebkitTapHighlightColor: "transparent",
      border: 0,
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }),
      appearance: "none",
      WebkitAppearance: "none",
      padding: 0,
      position: "relative",
      overflow: "hidden"
    }),
    overlay: {
      position: "absolute",
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }),
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    children: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center"
    },
    shadowOverlay: {
      boxShadow: "rgba(0, 0, 0, .1) 0px 0px 0px 1px inset, rgb(0, 0, 0, .15) 0px 0px 4px inset",
      zIndex: 1
    },
    alphaOverlay: {
      backgroundImage: "linear-gradient(45deg, ".concat(overlayColor, " 25%, transparent 25%), linear-gradient(-45deg, ").concat(overlayColor, " 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ").concat(overlayColor, " 75%), linear-gradient(-45deg, ").concat(theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white, " 75%, ").concat(overlayColor, " 75%)"),
      backgroundSize: "8px 8px",
      backgroundPosition: "0 0, 0 4px, 4px -4px, -4px 0px"
    }
  };
});
var __defProp$1t = Object.defineProperty;
var __getOwnPropSymbols$1u = Object.getOwnPropertySymbols;
var __hasOwnProp$1u = Object.prototype.hasOwnProperty;
var __propIsEnum$1u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1t = function __defNormalProp$1t(obj, key, value) {
  return key in obj ? __defProp$1t(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1t = function __spreadValues$1t(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1u.call(b, prop)) __defNormalProp$1t(a, prop, b[prop]);
  if (__getOwnPropSymbols$1u) {
    var _iterator131 = _createForOfIteratorHelper(__getOwnPropSymbols$1u(b)),
      _step132;
    try {
      for (_iterator131.s(); !(_step132 = _iterator131.n()).done;) {
        var prop = _step132.value;
        if (__propIsEnum$1u.call(b, prop)) __defNormalProp$1t(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator131.e(err);
    } finally {
      _iterator131.f();
    }
  }
  return a;
};
var __objRest$M = function __objRest$M(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1u.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1u) {
    var _iterator132 = _createForOfIteratorHelper(__getOwnPropSymbols$1u(source)),
      _step133;
    try {
      for (_iterator132.s(); !(_step133 = _iterator132.n()).done;) {
        var prop = _step133.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1u.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator132.e(err);
    } finally {
      _iterator132.f();
    }
  }
  return target;
};
var defaultProps$x = {
  size: 25,
  radius: 25
};
var ColorSwatch = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("ColorSwatch", defaultProps$x, props),
    component = _a.component,
    color = _a.color,
    size = _a.size,
    radius = _a.radius,
    className = _a.className,
    children = _a.children,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$M(_a, ["component", "color", "size", "radius", "className", "children", "classNames", "styles"]);
  var _useStyles$w = useStyles$w({
      radius: radius,
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "ColorSwatch"
    }),
    classes = _useStyles$w.classes,
    cx = _useStyles$w.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1t({
    component: component || "div",
    className: cx(classes.root, className),
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: cx(classes.alphaOverlay, classes.overlay)
  }), /* @__PURE__ */React__default.createElement("div", {
    className: cx(classes.shadowOverlay, classes.overlay)
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.overlay,
    style: {
      backgroundColor: color
    }
  }), /* @__PURE__ */React__default.createElement("div", {
    className: cx(classes.children, classes.overlay)
  }, children));
});
ColorSwatch.displayName = "@mantine/core/ColorSwatch";
var THUMB_SIZES = {
  xs: 8,
  sm: 12,
  md: 16,
  lg: 20,
  xl: 22
};
var useStyles$x = createStyles(function (theme, _ref93) {
  var size = _ref93.size;
  var _size = theme.fn.size({
    size: size,
    sizes: THUMB_SIZES
  });
  return {
    thumb: {
      overflow: "hidden",
      boxSizing: "border-box",
      position: "absolute",
      boxShadow: "0 0 1px rgba(0, 0, 0, .6)",
      border: "2px solid ".concat(theme.white),
      backgroundColor: "transparent",
      width: _size,
      height: _size,
      borderRadius: _size
    }
  };
});
var __defProp$1u = Object.defineProperty;
var __getOwnPropSymbols$1v = Object.getOwnPropertySymbols;
var __hasOwnProp$1v = Object.prototype.hasOwnProperty;
var __propIsEnum$1v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1u = function __defNormalProp$1u(obj, key, value) {
  return key in obj ? __defProp$1u(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1u = function __spreadValues$1u(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1v.call(b, prop)) __defNormalProp$1u(a, prop, b[prop]);
  if (__getOwnPropSymbols$1v) {
    var _iterator133 = _createForOfIteratorHelper(__getOwnPropSymbols$1v(b)),
      _step134;
    try {
      for (_iterator133.s(); !(_step134 = _iterator133.n()).done;) {
        var prop = _step134.value;
        if (__propIsEnum$1v.call(b, prop)) __defNormalProp$1u(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator133.e(err);
    } finally {
      _iterator133.f();
    }
  }
  return a;
};
function Thumb$1(_ref94) {
  var position = _ref94.position,
    className = _ref94.className,
    styles = _ref94.styles,
    classNames = _ref94.classNames,
    style = _ref94.style,
    size = _ref94.size,
    __staticSelector = _ref94.__staticSelector;
  var _useStyles$x = useStyles$x({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$x.classes,
    cx = _useStyles$x.cx;
  return /* @__PURE__ */React__default.createElement("div", {
    className: cx(classes.thumb, className),
    style: __spreadValues$1u({
      left: "calc(".concat(position.x * 100, "% - ").concat(THUMB_SIZES[size] / 2, "px)"),
      top: "calc(".concat(position.y * 100, "% - ").concat(THUMB_SIZES[size] / 2, "px)")
    }, style)
  });
}
Thumb$1.displayName = "@mantine/core/Thumb";
var useStyles$y = createStyles(function (theme, _ref95, getRef) {
  var _slider;
  var size = _ref95.size;
  var sliderThumb = {
    ref: getRef("sliderThumb")
  };
  return {
    sliderThumb: sliderThumb,
    slider: (_slider = {
      position: "relative",
      height: theme.fn.size({
        size: size,
        sizes: THUMB_SIZES
      }) + 2,
      boxSizing: "border-box",
      marginLeft: theme.fn.size({
        size: size,
        sizes: THUMB_SIZES
      }) / 2,
      marginRight: theme.fn.size({
        size: size,
        sizes: THUMB_SIZES
      }) / 2,
      outline: 0
    }, _defineProperty(_slider, "&:focus .".concat(sliderThumb.ref), {
      outline: "none",
      boxShadow: theme.focusRing === "always" || theme.focusRing === "auto" ? "0 0 0 2px ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white, ", 0 0 0 4px ").concat(theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5]) : void 0
    }), _defineProperty(_slider, "&:focus:not(:focus-visible) .".concat(sliderThumb.ref), {
      boxShadow: theme.focusRing === "auto" || theme.focusRing === "never" ? "none" : void 0
    }), _slider),
    sliderOverlay: {
      position: "absolute",
      boxSizing: "border-box",
      top: 0,
      bottom: 0,
      left: -theme.fn.size({
        size: size,
        sizes: THUMB_SIZES
      }) / 2 - 1,
      right: -theme.fn.size({
        size: size,
        sizes: THUMB_SIZES
      }) / 2 - 1,
      borderRadius: 1e3
    }
  };
});
var __defProp$1v = Object.defineProperty;
var __defProps$F = Object.defineProperties;
var __getOwnPropDescs$F = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1w = Object.getOwnPropertySymbols;
var __hasOwnProp$1w = Object.prototype.hasOwnProperty;
var __propIsEnum$1w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1v = function __defNormalProp$1v(obj, key, value) {
  return key in obj ? __defProp$1v(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1v = function __spreadValues$1v(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1w.call(b, prop)) __defNormalProp$1v(a, prop, b[prop]);
  if (__getOwnPropSymbols$1w) {
    var _iterator134 = _createForOfIteratorHelper(__getOwnPropSymbols$1w(b)),
      _step135;
    try {
      for (_iterator134.s(); !(_step135 = _iterator134.n()).done;) {
        var prop = _step135.value;
        if (__propIsEnum$1w.call(b, prop)) __defNormalProp$1v(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator134.e(err);
    } finally {
      _iterator134.f();
    }
  }
  return a;
};
var __spreadProps$F = function __spreadProps$F(a, b) {
  return __defProps$F(a, __getOwnPropDescs$F(b));
};
var __objRest$N = function __objRest$N(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1w.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1w) {
    var _iterator135 = _createForOfIteratorHelper(__getOwnPropSymbols$1w(source)),
      _step136;
    try {
      for (_iterator135.s(); !(_step136 = _iterator135.n()).done;) {
        var prop = _step136.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1w.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator135.e(err);
    } finally {
      _iterator135.f();
    }
  }
  return target;
};
var ColorSlider = forwardRef(function (_a, ref) {
  var _b = _a,
    value = _b.value,
    onChange = _b.onChange,
    maxValue = _b.maxValue,
    round = _b.round,
    _b$size2 = _b.size,
    size = _b$size2 === void 0 ? "md" : _b$size2,
    _b$thumbColor = _b.thumbColor,
    thumbColor = _b$thumbColor === void 0 ? "transparent" : _b$thumbColor,
    _b$__staticSelector = _b.__staticSelector,
    __staticSelector = _b$__staticSelector === void 0 ? "ColorSlider" : _b$__staticSelector,
    _b$focusable = _b.focusable,
    focusable = _b$focusable === void 0 ? true : _b$focusable,
    overlays = _b.overlays,
    classNames = _b.classNames,
    styles = _b.styles,
    className = _b.className,
    others = __objRest$N(_b, ["value", "onChange", "maxValue", "round", "size", "thumbColor", "__staticSelector", "focusable", "overlays", "classNames", "styles", "className"]);
  var _useStyles$y = useStyles$y({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$y.classes,
    cx = _useStyles$y.cx;
  var _useState79 = useState({
      y: 0,
      x: value / maxValue
    }),
    _useState80 = _slicedToArray(_useState79, 2),
    position = _useState80[0],
    setPosition = _useState80[1];
  var getChangeValue = function getChangeValue(val) {
    return round ? Math.round(val * maxValue) : val * maxValue;
  };
  var _useMove = useMove(function (_ref96) {
      var x = _ref96.x;
      return onChange(getChangeValue(x));
    }),
    sliderRef = _useMove.ref;
  useDidUpdate(function () {
    setPosition({
      y: 0,
      x: value / maxValue
    });
  }, [value]);
  var handleArrow = function handleArrow(event, pos) {
    event.preventDefault();
    var _position = clampUseMovePosition(pos);
    onChange(getChangeValue(_position.x));
  };
  var handleKeyDown = function handleKeyDown(event) {
    switch (event.nativeEvent.code) {
      case "ArrowRight":
        {
          handleArrow(event, {
            x: position.x + 0.05,
            y: position.y
          });
          break;
        }
      case "ArrowLeft":
        {
          handleArrow(event, {
            x: position.x - 0.05,
            y: position.y
          });
          break;
        }
    }
  };
  var layers = overlays.map(function (overlay, index) {
    return /* @__PURE__ */React__default.createElement("div", {
      className: classes.sliderOverlay,
      style: overlay,
      key: index
    });
  });
  return /* @__PURE__ */React__default.createElement(Box, __spreadProps$F(__spreadValues$1v({}, others), {
    ref: useMergedRef(sliderRef, ref),
    className: cx(classes.slider, className),
    role: "slider",
    "aria-valuenow": value,
    "aria-valuemax": maxValue,
    "aria-valuemin": 0,
    tabIndex: focusable ? 0 : -1,
    onKeyDown: handleKeyDown
  }), layers, /* @__PURE__ */React__default.createElement(Thumb$1, {
    __staticSelector: __staticSelector,
    classNames: classNames,
    styles: styles,
    position: position,
    style: {
      top: 1,
      backgroundColor: thumbColor
    },
    className: classes.sliderThumb,
    size: size
  }));
});
ColorSlider.displayName = "@mantine/core/ColorSlider";
var __defProp$1w = Object.defineProperty;
var __defProps$G = Object.defineProperties;
var __getOwnPropDescs$G = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1x = Object.getOwnPropertySymbols;
var __hasOwnProp$1x = Object.prototype.hasOwnProperty;
var __propIsEnum$1x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1w = function __defNormalProp$1w(obj, key, value) {
  return key in obj ? __defProp$1w(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1w = function __spreadValues$1w(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1x.call(b, prop)) __defNormalProp$1w(a, prop, b[prop]);
  if (__getOwnPropSymbols$1x) {
    var _iterator136 = _createForOfIteratorHelper(__getOwnPropSymbols$1x(b)),
      _step137;
    try {
      for (_iterator136.s(); !(_step137 = _iterator136.n()).done;) {
        var prop = _step137.value;
        if (__propIsEnum$1x.call(b, prop)) __defNormalProp$1w(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator136.e(err);
    } finally {
      _iterator136.f();
    }
  }
  return a;
};
var __spreadProps$G = function __spreadProps$G(a, b) {
  return __defProps$G(a, __getOwnPropDescs$G(b));
};
var __objRest$O = function __objRest$O(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1x.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1x) {
    var _iterator137 = _createForOfIteratorHelper(__getOwnPropSymbols$1x(source)),
      _step138;
    try {
      for (_iterator137.s(); !(_step138 = _iterator137.n()).done;) {
        var prop = _step138.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1x.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator137.e(err);
    } finally {
      _iterator137.f();
    }
  }
  return target;
};
var HueSlider = forwardRef(function (_a, ref) {
  var _b = _a,
    value = _b.value,
    onChange = _b.onChange,
    others = __objRest$O(_b, ["value", "onChange"]);
  return /* @__PURE__ */React__default.createElement(ColorSlider, __spreadProps$G(__spreadValues$1w({}, others), {
    ref: ref,
    value: value,
    onChange: onChange,
    maxValue: 360,
    thumbColor: "hsl(".concat(value, ", 100%, 50%)"),
    round: true,
    overlays: [{
      backgroundImage: "linear-gradient(to right,hsl(0,100%,50%),hsl(60,100%,50%),hsl(120,100%,50%),hsl(170,100%,50%),hsl(240,100%,50%),hsl(300,100%,50%),hsl(360,100%,50%))"
    }, {
      boxShadow: "rgba(0, 0, 0, .1) 0px 0px 0px 1px inset, rgb(0, 0, 0, .15) 0px 0px 4px inset"
    }]
  }));
});
HueSlider.displayName = "@mantine/core/HueSlider";
function round$1(number) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Math.pow(10, digits);
  return Math.round(base * number) / base;
}
function hslaToHsva(_ref97) {
  var h = _ref97.h,
    s = _ref97.s,
    l = _ref97.l,
    a = _ref97.a;
  var ss = s * ((l < 50 ? l : 100 - l) / 100);
  return {
    h: h,
    s: ss > 0 ? 2 * ss / (l + ss) * 100 : 0,
    v: l + ss,
    a: a
  };
}
var angleUnits = {
  grad: 360 / 400,
  turn: 360,
  rad: 360 / (Math.PI * 2)
};
function parseHue(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "deg";
  return Number(value) * (angleUnits[unit] || 1);
}
var HSL_REGEXP = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
function parseHsla(color) {
  var match = HSL_REGEXP.exec(color);
  if (!match) {
    return {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    };
  }
  return hslaToHsva({
    h: parseHue(match[1], match[2]),
    s: Number(match[3]),
    l: Number(match[4]),
    a: match[5] === void 0 ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
  });
}
function rgbaToHsva(_ref98) {
  var r = _ref98.r,
    g = _ref98.g,
    b = _ref98.b,
    a = _ref98.a;
  var max = Math.max(r, g, b);
  var delta = max - Math.min(r, g, b);
  var hh = delta ? max === r ? (g - b) / delta : max === g ? 2 + (b - r) / delta : 4 + (r - g) / delta : 0;
  return {
    h: round$1(60 * (hh < 0 ? hh + 6 : hh)),
    s: round$1(max ? delta / max * 100 : 0),
    v: round$1(max / 255 * 100),
    a: a
  };
}
function parseHex(color) {
  var hex = color[0] === "#" ? color.slice(1) : color;
  if (hex.length === 3) {
    return rgbaToHsva({
      r: parseInt(hex[0] + hex[0], 16),
      g: parseInt(hex[1] + hex[1], 16),
      b: parseInt(hex[2] + hex[2], 16),
      a: 1
    });
  }
  return rgbaToHsva({
    r: parseInt(hex.slice(0, 2), 16),
    g: parseInt(hex.slice(2, 4), 16),
    b: parseInt(hex.slice(4, 6), 16),
    a: 1
  });
}
var RGB_REGEXP = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
function parseRgba(color) {
  var match = RGB_REGEXP.exec(color);
  if (!match) {
    return {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    };
  }
  return rgbaToHsva({
    r: Number(match[1]) / (match[2] ? 100 / 255 : 1),
    g: Number(match[3]) / (match[4] ? 100 / 255 : 1),
    b: Number(match[5]) / (match[6] ? 100 / 255 : 1),
    a: match[7] === void 0 ? 1 : Number(match[7]) / (match[8] ? 100 : 1)
  });
}
var VALIDATION_REGEXP = {
  hex: /^#?([0-9A-F]{3}){1,2}$/i,
  rgb: /^rgb\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i,
  rgba: /^rgba\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i,
  hsl: /hsl\(\s*(\d+)\s*,\s*(\d+(?:\.\d+)?%)\s*,\s*(\d+(?:\.\d+)?%)\)/i,
  hsla: /^hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/i
};
var CONVERTERS = {
  hex: parseHex,
  rgb: parseRgba,
  rgba: parseRgba,
  hsl: parseHsla,
  hsla: parseHsla
};
function isColorValid(color) {
  for (var _i5 = 0, _Object$entries = Object.entries(VALIDATION_REGEXP); _i5 < _Object$entries.length; _i5++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i5], 2),
      regexp = _Object$entries$_i[1];
    if (regexp.test(color)) {
      return true;
    }
  }
  return false;
}
function parseColor(color) {
  if (typeof color !== "string") {
    return {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    };
  }
  if (color === "transparent") {
    return {
      h: 0,
      s: 0,
      v: 0,
      a: 0
    };
  }
  var trimmed = color.trim();
  for (var _i6 = 0, _Object$entries2 = Object.entries(VALIDATION_REGEXP); _i6 < _Object$entries2.length; _i6++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i6], 2),
      rule = _Object$entries2$_i[0],
      regexp = _Object$entries2$_i[1];
    if (regexp.test(trimmed)) {
      return CONVERTERS[rule](trimmed);
    }
  }
  return {
    h: 0,
    s: 0,
    v: 0,
    a: 1
  };
}
var __defProp$1x = Object.defineProperty;
var __defProps$H = Object.defineProperties;
var __getOwnPropDescs$H = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1y = Object.getOwnPropertySymbols;
var __hasOwnProp$1y = Object.prototype.hasOwnProperty;
var __propIsEnum$1y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1x = function __defNormalProp$1x(obj, key, value) {
  return key in obj ? __defProp$1x(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1x = function __spreadValues$1x(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1y.call(b, prop)) __defNormalProp$1x(a, prop, b[prop]);
  if (__getOwnPropSymbols$1y) {
    var _iterator138 = _createForOfIteratorHelper(__getOwnPropSymbols$1y(b)),
      _step139;
    try {
      for (_iterator138.s(); !(_step139 = _iterator138.n()).done;) {
        var prop = _step139.value;
        if (__propIsEnum$1y.call(b, prop)) __defNormalProp$1x(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator138.e(err);
    } finally {
      _iterator138.f();
    }
  }
  return a;
};
var __spreadProps$H = function __spreadProps$H(a, b) {
  return __defProps$H(a, __getOwnPropDescs$H(b));
};
var __objRest$P = function __objRest$P(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1y.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1y) {
    var _iterator139 = _createForOfIteratorHelper(__getOwnPropSymbols$1y(source)),
      _step140;
    try {
      for (_iterator139.s(); !(_step140 = _iterator139.n()).done;) {
        var prop = _step140.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1y.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator139.e(err);
    } finally {
      _iterator139.f();
    }
  }
  return target;
};
var AlphaSlider = forwardRef(function (_a, ref) {
  var _b = _a,
    value = _b.value,
    _onChange = _b.onChange,
    color = _b.color,
    others = __objRest$P(_b, ["value", "onChange", "color"]);
  var theme = useMantineTheme();
  var _color = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
  return /* @__PURE__ */React__default.createElement(ColorSlider, __spreadProps$H(__spreadValues$1x({}, others), {
    ref: ref,
    value: value,
    onChange: function onChange(val) {
      return _onChange(round$1(val, 2));
    },
    maxValue: 1,
    round: false,
    overlays: [{
      backgroundImage: "linear-gradient(45deg, ".concat(_color, " 25%, transparent 25%), linear-gradient(-45deg, ").concat(_color, " 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ").concat(_color, " 75%), linear-gradient(-45deg, ").concat(theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white, " 75%, ").concat(_color, " 75%)"),
      backgroundSize: "8px 8px",
      backgroundPosition: "0 0, 0 4px, 4px -4px, -4px 0px"
    }, {
      backgroundImage: "linear-gradient(90deg, transparent, ".concat(color, ")")
    }, {
      boxShadow: "rgba(0, 0, 0, .1) 0px 0px 0px 1px inset, rgb(0, 0, 0, .15) 0px 0px 4px inset"
    }]
  }));
});
AlphaSlider.displayName = "@mantine/core/AlphaSlider";
var SATURATION_HEIGHTS = {
  xs: 100,
  sm: 110,
  md: 120,
  lg: 140,
  xl: 160
};
var useStyles$z = createStyles(function (theme, _ref99, getRef) {
  var _saturation;
  var size = _ref99.size;
  var position = -theme.fn.size({
    size: size,
    sizes: THUMB_SIZES
  }) / 2 - 1;
  var saturationThumb = {
    ref: getRef("saturationThumb")
  };
  return {
    saturationThumb: saturationThumb,
    saturation: (_saturation = {
      boxSizing: "border-box",
      position: "relative",
      height: theme.fn.size({
        size: size,
        sizes: SATURATION_HEIGHTS
      }),
      borderRadius: theme.radius.sm,
      margin: theme.fn.size({
        size: size,
        sizes: THUMB_SIZES
      }) / 2,
      WebkitTapHighlightColor: "transparent"
    }, _defineProperty(_saturation, "&:focus .".concat(saturationThumb.ref), {
      outline: "none",
      boxShadow: "0 0 0 1px ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white, ", 0 0 0 3px ").concat(theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5])
    }), _defineProperty(_saturation, "&:focus:not(:focus-visible) .".concat(saturationThumb.ref), {
      boxShadow: theme.focusRing === "auto" || theme.focusRing === "never" ? "none" : void 0
    }), _saturation),
    saturationOverlay: {
      position: "absolute",
      boxSizing: "border-box",
      borderRadius: theme.radius.sm,
      top: position,
      left: position,
      right: position,
      bottom: position
    }
  };
});
function hsvaToRgbaObject(_ref100) {
  var h = _ref100.h,
    s = _ref100.s,
    v = _ref100.v,
    a = _ref100.a;
  var _h = h / 360 * 6;
  var _s = s / 100;
  var _v = v / 100;
  var hh = Math.floor(_h);
  var l = _v * (1 - _s);
  var c = _v * (1 - (_h - hh) * _s);
  var d = _v * (1 - (1 - _h + hh) * _s);
  var module = hh % 6;
  return {
    r: round$1([_v, c, l, l, d, _v][module] * 255),
    g: round$1([d, _v, _v, c, l, l][module] * 255),
    b: round$1([l, l, d, _v, _v, c][module] * 255),
    a: round$1(a, 2)
  };
}
function hsvaToRgba(color, includeAlpha) {
  var _hsvaToRgbaObject = hsvaToRgbaObject(color),
    r = _hsvaToRgbaObject.r,
    g = _hsvaToRgbaObject.g,
    b = _hsvaToRgbaObject.b,
    a = _hsvaToRgbaObject.a;
  if (!includeAlpha) {
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
  }
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(round$1(a, 2), ")");
}
function hsvaToHsl(_ref101, includeAlpha) {
  var h = _ref101.h,
    s = _ref101.s,
    v = _ref101.v,
    a = _ref101.a;
  var hh = (200 - s) * v / 100;
  var result = {
    h: Math.round(h),
    s: Math.round(hh > 0 && hh < 200 ? s * v / 100 / (hh <= 100 ? hh : 200 - hh) * 100 : 0),
    l: Math.round(hh / 2)
  };
  if (!includeAlpha) {
    return "hsl(".concat(result.h, ", ").concat(result.s, "%, ").concat(result.l, "%)");
  }
  return "hsla(".concat(result.h, ", ").concat(result.s, "%, ").concat(result.l, "%, ").concat(round$1(a, 2), ")");
}
function formatHexPart(number) {
  var hex = number.toString(16);
  return hex.length < 2 ? "0".concat(hex) : hex;
}
function hsvaToHex(color) {
  var _hsvaToRgbaObject2 = hsvaToRgbaObject(color),
    r = _hsvaToRgbaObject2.r,
    g = _hsvaToRgbaObject2.g,
    b = _hsvaToRgbaObject2.b;
  return "#".concat(formatHexPart(r)).concat(formatHexPart(g)).concat(formatHexPart(b));
}
var CONVERTERS$1 = {
  hex: hsvaToHex,
  rgb: function rgb(color) {
    return hsvaToRgba(color, false);
  },
  rgba: function rgba(color) {
    return hsvaToRgba(color, true);
  },
  hsl: function hsl(color) {
    return hsvaToHsl(color, false);
  },
  hsla: function hsla(color) {
    return hsvaToHsl(color, true);
  }
};
function convertHsvaTo(format, color) {
  if (!color) {
    return "#000000";
  }
  if (!(format in CONVERTERS$1)) {
    return CONVERTERS$1.hex(color);
  }
  return CONVERTERS$1[format](color);
}
function Saturation(_ref102) {
  var value = _ref102.value,
    onChange = _ref102.onChange,
    _ref102$focusable = _ref102.focusable,
    focusable = _ref102$focusable === void 0 ? true : _ref102$focusable,
    _ref102$__staticSelec = _ref102.__staticSelector,
    __staticSelector = _ref102$__staticSelec === void 0 ? "saturation" : _ref102$__staticSelec,
    size = _ref102.size,
    color = _ref102.color,
    saturationLabel = _ref102.saturationLabel,
    classNames = _ref102.classNames,
    styles = _ref102.styles;
  var _useStyles$z = useStyles$z({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$z.classes;
  var _useState81 = useState({
      x: value.s / 100,
      y: 1 - value.v / 100
    }),
    _useState82 = _slicedToArray(_useState81, 2),
    position = _useState82[0],
    setPosition = _useState82[1];
  var _useMove2 = useMove(function (_ref103) {
      var x = _ref103.x,
        y = _ref103.y;
      onChange({
        s: Math.round(x * 100),
        v: Math.round((1 - y) * 100)
      });
    }),
    ref = _useMove2.ref;
  useEffect(function () {
    setPosition({
      x: value.s / 100,
      y: 1 - value.v / 100
    });
  }, [value.s, value.v]);
  var handleArrow = function handleArrow(event, pos) {
    event.preventDefault();
    var _position = clampUseMovePosition(pos);
    onChange({
      s: Math.round(_position.x * 100),
      v: Math.round((1 - _position.y) * 100)
    });
  };
  var handleKeyDown = function handleKeyDown(event) {
    switch (event.nativeEvent.code) {
      case "ArrowUp":
        {
          handleArrow(event, {
            y: position.y - 0.05,
            x: position.x
          });
          break;
        }
      case "ArrowDown":
        {
          handleArrow(event, {
            y: position.y + 0.05,
            x: position.x
          });
          break;
        }
      case "ArrowRight":
        {
          handleArrow(event, {
            x: position.x + 0.05,
            y: position.y
          });
          break;
        }
      case "ArrowLeft":
        {
          handleArrow(event, {
            x: position.x - 0.05,
            y: position.y
          });
          break;
        }
    }
  };
  return /* @__PURE__ */React__default.createElement("div", {
    className: classes.saturation,
    ref: ref,
    role: "slider",
    "aria-label": saturationLabel,
    "aria-valuenow": position.x,
    "aria-valuetext": convertHsvaTo("rgba", value),
    tabIndex: focusable ? 0 : -1,
    onKeyDown: handleKeyDown
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.saturationOverlay,
    style: {
      backgroundColor: "hsl(".concat(value.h, ", 100%, 50%)")
    }
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.saturationOverlay,
    style: {
      backgroundImage: "linear-gradient(90deg, #fff, transparent)"
    }
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.saturationOverlay,
    style: {
      backgroundImage: "linear-gradient(0deg, #000, transparent)"
    }
  }), /* @__PURE__ */React__default.createElement(Thumb$1, {
    __staticSelector: __staticSelector,
    classNames: classNames,
    styles: styles,
    position: position,
    className: classes.saturationThumb,
    style: {
      backgroundColor: color
    },
    size: size
  }));
}
Saturation.displayName = "@mantine/core/Saturation";
var useStyles$A = createStyles(function (_theme, _ref104) {
  var swatchesPerRow = _ref104.swatchesPerRow;
  return {
    swatch: {
      width: "calc(".concat(100 / swatchesPerRow, "% - 4px)"),
      height: 0,
      paddingBottom: "calc(".concat(100 / swatchesPerRow, "% - 4px)"),
      margin: 2,
      boxSizing: "content-box"
    },
    swatches: {
      boxSizing: "border-box",
      marginLeft: -2,
      marginRight: -2,
      display: "flex",
      flexWrap: "wrap"
    }
  };
});
var __defProp$1y = Object.defineProperty;
var __getOwnPropSymbols$1z = Object.getOwnPropertySymbols;
var __hasOwnProp$1z = Object.prototype.hasOwnProperty;
var __propIsEnum$1z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1y = function __defNormalProp$1y(obj, key, value) {
  return key in obj ? __defProp$1y(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1y = function __spreadValues$1y(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1z.call(b, prop)) __defNormalProp$1y(a, prop, b[prop]);
  if (__getOwnPropSymbols$1z) {
    var _iterator140 = _createForOfIteratorHelper(__getOwnPropSymbols$1z(b)),
      _step141;
    try {
      for (_iterator140.s(); !(_step141 = _iterator140.n()).done;) {
        var prop = _step141.value;
        if (__propIsEnum$1z.call(b, prop)) __defNormalProp$1y(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator140.e(err);
    } finally {
      _iterator140.f();
    }
  }
  return a;
};
var __objRest$Q = function __objRest$Q(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1z.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1z) {
    var _iterator141 = _createForOfIteratorHelper(__getOwnPropSymbols$1z(source)),
      _step142;
    try {
      for (_iterator141.s(); !(_step142 = _iterator141.n()).done;) {
        var prop = _step142.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1z.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator141.e(err);
    } finally {
      _iterator141.f();
    }
  }
  return target;
};
function Swatches(_a) {
  var _b = _a,
    data = _b.data,
    onSelect = _b.onSelect,
    _b$swatchesPerRow = _b.swatchesPerRow,
    swatchesPerRow = _b$swatchesPerRow === void 0 ? 10 : _b$swatchesPerRow,
    _b$focusable2 = _b.focusable,
    focusable = _b$focusable2 === void 0 ? true : _b$focusable2,
    classNames = _b.classNames,
    styles = _b.styles,
    _b$__staticSelector2 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector2 === void 0 ? "color-picker" : _b$__staticSelector2,
    others = __objRest$Q(_b, ["data", "onSelect", "swatchesPerRow", "focusable", "classNames", "styles", "__staticSelector"]);
  var _useStyles$A = useStyles$A({
      swatchesPerRow: swatchesPerRow
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$A.classes;
  var colors = data.map(function (color, index) {
    return /* @__PURE__ */React__default.createElement(ColorSwatch, {
      className: classes.swatch,
      component: "button",
      type: "button",
      color: color,
      key: index,
      radius: "sm",
      onClick: function onClick() {
        return onSelect(parseColor(color));
      },
      style: {
        cursor: "pointer"
      },
      "aria-label": color,
      tabIndex: focusable ? 0 : -1
    });
  });
  return /* @__PURE__ */React__default.createElement("div", __spreadValues$1y({
    className: classes.swatches
  }, others), colors);
}
Swatches.displayName = "@mantine/core/Swatches";
var sizes$9 = {
  xs: 180,
  sm: 200,
  md: 240,
  lg: 280,
  xl: 320
};
var useStyles$B = createStyles(function (theme, _ref105) {
  var size = _ref105.size,
    fullWidth = _ref105.fullWidth;
  return {
    preview: {},
    wrapper: {
      boxSizing: "border-box",
      width: fullWidth ? "100%" : theme.fn.size({
        size: size,
        sizes: sizes$9
      }),
      padding: 1
    },
    body: {
      display: "flex",
      boxSizing: "border-box",
      paddingTop: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 2
    },
    sliders: {
      flex: 1,
      boxSizing: "border-box",
      "&:not(:only-child)": {
        marginRight: theme.spacing.xs
      }
    },
    slider: {
      boxSizing: "border-box",
      "& + &": {
        marginTop: 5
      }
    },
    swatch: {
      cursor: "pointer"
    }
  };
});
var __defProp$1z = Object.defineProperty;
var __getOwnPropSymbols$1A = Object.getOwnPropertySymbols;
var __hasOwnProp$1A = Object.prototype.hasOwnProperty;
var __propIsEnum$1A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1z = function __defNormalProp$1z(obj, key, value) {
  return key in obj ? __defProp$1z(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1z = function __spreadValues$1z(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1A.call(b, prop)) __defNormalProp$1z(a, prop, b[prop]);
  if (__getOwnPropSymbols$1A) {
    var _iterator142 = _createForOfIteratorHelper(__getOwnPropSymbols$1A(b)),
      _step143;
    try {
      for (_iterator142.s(); !(_step143 = _iterator142.n()).done;) {
        var prop = _step143.value;
        if (__propIsEnum$1A.call(b, prop)) __defNormalProp$1z(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator142.e(err);
    } finally {
      _iterator142.f();
    }
  }
  return a;
};
var __objRest$R = function __objRest$R(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1A.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1A) {
    var _iterator143 = _createForOfIteratorHelper(__getOwnPropSymbols$1A(source)),
      _step144;
    try {
      for (_iterator143.s(); !(_step144 = _iterator143.n()).done;) {
        var prop = _step144.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1A.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator143.e(err);
    } finally {
      _iterator143.f();
    }
  }
  return target;
};
var SWATCH_SIZES = {
  xs: 26,
  sm: 34,
  md: 42,
  lg: 50,
  xl: 54
};
var defaultProps$y = {
  swatchesPerRow: 10,
  size: "sm",
  withPicker: true,
  focusable: true,
  __staticSelector: "ColorPicker"
};
var ColorPicker = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("ColorPicker", defaultProps$y, props),
    value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    format = _a.format,
    swatches = _a.swatches,
    swatchesPerRow = _a.swatchesPerRow,
    size = _a.size,
    withPicker = _a.withPicker,
    fullWidth = _a.fullWidth,
    focusable = _a.focusable,
    __staticSelector = _a.__staticSelector,
    saturationLabel = _a.saturationLabel,
    hueLabel = _a.hueLabel,
    alphaLabel = _a.alphaLabel,
    className = _a.className,
    styles = _a.styles,
    classNames = _a.classNames,
    others = __objRest$R(_a, ["value", "defaultValue", "onChange", "format", "swatches", "swatchesPerRow", "size", "withPicker", "fullWidth", "focusable", "__staticSelector", "saturationLabel", "hueLabel", "alphaLabel", "className", "styles", "classNames"]);
  var _useStyles$B = useStyles$B({
      size: size,
      fullWidth: fullWidth
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$B.classes,
    cx = _useStyles$B.cx,
    theme = _useStyles$B.theme;
  var formatRef = useRef(format);
  var valueRef = useRef(null);
  var withAlpha = format === "rgba" || format === "hsla";
  var _useState83 = useState(false),
    _useState84 = _slicedToArray(_useState83, 2),
    shouldSkip = _useState84[0],
    setShouldSkip = _useState84[1];
  var _useUncontrolled11 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: "#FFFFFF",
      rule: function rule(val) {
        return isColorValid(val);
      },
      onChange: onChange
    }),
    _useUncontrolled12 = _slicedToArray(_useUncontrolled11, 2),
    _value = _useUncontrolled12[0],
    setValue = _useUncontrolled12[1];
  var _useState85 = useState(parseColor(_value)),
    _useState86 = _slicedToArray(_useState85, 2),
    parsed = _useState86[0],
    setParsed = _useState86[1];
  var handleChange = function handleChange(color) {
    setShouldSkip(true);
    setParsed(function (current) {
      var next = __spreadValues$1z(__spreadValues$1z({}, current), color);
      valueRef.current = convertHsvaTo(formatRef.current, next);
      return next;
    });
    Promise.resolve().then(function () {
      return setValue(valueRef.current);
    }).then(function () {
      return setShouldSkip(false);
    });
  };
  useEffect(function () {
    if (isColorValid(value) && !shouldSkip) {
      setParsed(parseColor(value));
    }
  }, [value]);
  useDidUpdate(function () {
    formatRef.current = format;
    setValue(convertHsvaTo(format, parsed));
  }, [format]);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1z({
    className: cx(classes.wrapper, className),
    ref: ref
  }, others), withPicker && /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement(Saturation, {
    value: parsed,
    onChange: handleChange,
    color: _value,
    styles: styles,
    classNames: classNames,
    size: size,
    focusable: focusable,
    saturationLabel: saturationLabel,
    __staticSelector: __staticSelector
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.body
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.sliders
  }, /* @__PURE__ */React__default.createElement(HueSlider, {
    value: parsed.h,
    onChange: function onChange(h) {
      return handleChange({
        h: h
      });
    },
    size: size,
    styles: styles,
    classNames: classNames,
    focusable: focusable,
    "aria-label": hueLabel,
    __staticSelector: __staticSelector
  }), withAlpha && /* @__PURE__ */React__default.createElement(AlphaSlider, {
    value: parsed.a,
    onChange: function onChange(a) {
      return handleChange({
        a: a
      });
    },
    size: size,
    color: convertHsvaTo("hex", parsed),
    style: {
      marginTop: 6
    },
    styles: styles,
    classNames: classNames,
    focusable: focusable,
    "aria-label": alphaLabel,
    __staticSelector: __staticSelector
  })), withAlpha && /* @__PURE__ */React__default.createElement(ColorSwatch, {
    color: _value,
    radius: "sm",
    size: theme.fn.size({
      size: size,
      sizes: SWATCH_SIZES
    }),
    className: classes.preview
  }))), Array.isArray(swatches) && /* @__PURE__ */React__default.createElement(Swatches, {
    data: swatches,
    onSelect: handleChange,
    style: {
      marginTop: 5
    },
    swatchesPerRow: swatchesPerRow,
    focusable: focusable,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector
  }));
});
ColorPicker.displayName = "@mantine/core/ColorPicker";
var useStyles$C = createStyles(function (theme, _ref106) {
  var disallowInput = _ref106.disallowInput;
  return {
    dropdownBody: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2])
    },
    input: {
      cursor: disallowInput ? "pointer" : void 0
    }
  };
});
var __defProp$1A = Object.defineProperty;
var __defProps$I = Object.defineProperties;
var __getOwnPropDescs$I = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1B = Object.getOwnPropertySymbols;
var __hasOwnProp$1B = Object.prototype.hasOwnProperty;
var __propIsEnum$1B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1A = function __defNormalProp$1A(obj, key, value) {
  return key in obj ? __defProp$1A(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1A = function __spreadValues$1A(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1B.call(b, prop)) __defNormalProp$1A(a, prop, b[prop]);
  if (__getOwnPropSymbols$1B) {
    var _iterator144 = _createForOfIteratorHelper(__getOwnPropSymbols$1B(b)),
      _step145;
    try {
      for (_iterator144.s(); !(_step145 = _iterator144.n()).done;) {
        var prop = _step145.value;
        if (__propIsEnum$1B.call(b, prop)) __defNormalProp$1A(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator144.e(err);
    } finally {
      _iterator144.f();
    }
  }
  return a;
};
var __spreadProps$I = function __spreadProps$I(a, b) {
  return __defProps$I(a, __getOwnPropDescs$I(b));
};
var __objRest$S = function __objRest$S(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1B.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1B) {
    var _iterator145 = _createForOfIteratorHelper(__getOwnPropSymbols$1B(source)),
      _step146;
    try {
      for (_iterator145.s(); !(_step146 = _iterator145.n()).done;) {
        var prop = _step146.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1B.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator145.e(err);
    } finally {
      _iterator145.f();
    }
  }
  return target;
};
var SWATCH_SIZES$1 = {
  xs: 16,
  sm: 18,
  md: 22,
  lg: 28,
  xl: 36
};
var ARROW_OFFSET = {
  xs: 12,
  sm: 15,
  md: 17,
  lg: 21,
  xl: 25
};
var defaultProps$z = {
  size: "sm",
  format: "hex",
  fixOnBlur: true,
  withPreview: true,
  swatchesPerRow: 10,
  withPicker: true,
  transition: "pop-top-left",
  dropdownZIndex: getDefaultZIndex("popover"),
  transitionDuration: 0,
  withinPortal: true
};
var ColorInput = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("ColorInput", defaultProps$z, props),
    label = _a.label,
    description = _a.description,
    error = _a.error,
    required = _a.required,
    wrapperProps = _a.wrapperProps,
    size = _a.size,
    format = _a.format,
    onChange = _a.onChange,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    value = _a.value,
    defaultValue = _a.defaultValue,
    classNames = _a.classNames,
    styles = _a.styles,
    disallowInput = _a.disallowInput,
    fixOnBlur = _a.fixOnBlur,
    withPreview = _a.withPreview,
    swatchesPerRow = _a.swatchesPerRow,
    withPicker = _a.withPicker,
    icon = _a.icon,
    transition = _a.transition,
    id = _a.id,
    dropdownZIndex = _a.dropdownZIndex,
    transitionDuration = _a.transitionDuration,
    transitionTimingFunction = _a.transitionTimingFunction,
    withinPortal = _a.withinPortal,
    className = _a.className,
    style = _a.style,
    swatches = _a.swatches,
    sx = _a.sx,
    errorProps = _a.errorProps,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    others = __objRest$S(_a, ["label", "description", "error", "required", "wrapperProps", "size", "format", "onChange", "onFocus", "onBlur", "value", "defaultValue", "classNames", "styles", "disallowInput", "fixOnBlur", "withPreview", "swatchesPerRow", "withPicker", "icon", "transition", "id", "dropdownZIndex", "transitionDuration", "transitionTimingFunction", "withinPortal", "className", "style", "swatches", "sx", "errorProps", "labelProps", "descriptionProps"]);
  var _useStyles$C = useStyles$C({
      disallowInput: disallowInput
    }, {
      classNames: classNames,
      styles: styles,
      name: "ColorInput"
    }),
    classes = _useStyles$C.classes,
    cx = _useStyles$C.cx,
    theme = _useStyles$C.theme;
  var _extractSystemStyles7 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles7.systemStyles,
    rest = _extractSystemStyles7.rest;
  var uuid = useUuid(id);
  var _useState87 = useState(null),
    _useState88 = _slicedToArray(_useState87, 2),
    referenceElement = _useState88[0],
    setReferenceElement = _useState88[1];
  var _useState89 = useState(false),
    _useState90 = _slicedToArray(_useState89, 2),
    dropdownOpened = _useState90[0],
    setDropdownOpened = _useState90[1];
  var _useState91 = useState(""),
    _useState92 = _slicedToArray(_useState91, 2),
    lastValidValue = _useState92[0],
    setLastValidValue = _useState92[1];
  var _useUncontrolled13 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: "",
      rule: function rule(val) {
        return typeof val === "string";
      },
      onChange: onChange
    }),
    _useUncontrolled14 = _slicedToArray(_useUncontrolled13, 2),
    _value = _useUncontrolled14[0],
    setValue = _useUncontrolled14[1];
  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    setDropdownOpened(true);
  };
  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    setDropdownOpened(false);
    fixOnBlur && setValue(lastValidValue);
  };
  useEffect(function () {
    if (isColorValid(_value) || _value.trim() === "") {
      setLastValidValue(_value);
    }
  }, [_value]);
  useDidUpdate(function () {
    if (isColorValid(_value)) {
      setValue(convertHsvaTo(format, parseColor(_value)));
    }
  }, [format]);
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$1A(__spreadValues$1A({
    label: label,
    description: description,
    error: error,
    required: required,
    classNames: classNames,
    styles: styles,
    size: size,
    id: uuid,
    className: className,
    style: style,
    __staticSelector: "ColorInput",
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement("div", {
    ref: setReferenceElement
  }, /* @__PURE__ */React__default.createElement(Input, __spreadProps$I(__spreadValues$1A({}, rest), {
    ref: ref,
    __staticSelector: "ColorInput",
    id: uuid,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    spellCheck: false,
    size: size,
    value: _value,
    onChange: function onChange(event) {
      return setValue(event.currentTarget.value);
    },
    invalid: !!error,
    required: required,
    autoComplete: "nope",
    icon: icon || (withPreview ? /* @__PURE__ */React__default.createElement(ColorSwatch, {
      color: isColorValid(_value) ? _value : "#fff",
      size: theme.fn.size({
        size: size,
        sizes: SWATCH_SIZES$1
      })
    }) : null),
    readOnly: disallowInput,
    classNames: __spreadProps$I(__spreadValues$1A({}, classNames), {
      input: cx(classes.input, classNames == null ? void 0 : classNames.input)
    }),
    styles: styles
  }))), /* @__PURE__ */React__default.createElement(Popper$1, {
    referenceElement: referenceElement,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    transition: transition,
    mounted: dropdownOpened,
    position: "bottom",
    placement: "start",
    gutter: 5,
    arrowSize: 3,
    zIndex: dropdownZIndex,
    arrowStyle: {
      left: theme.fn.size({
        size: size,
        sizes: ARROW_OFFSET
      })
    },
    withinPortal: withinPortal
  }, /* @__PURE__ */React__default.createElement("div", {
    style: {
      pointerEvents: "all"
    }
  }, /* @__PURE__ */React__default.createElement(Paper, {
    shadow: "sm",
    p: size,
    className: classes.dropdownBody,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    }
  }, /* @__PURE__ */React__default.createElement(ColorPicker, {
    __staticSelector: "ColorInput",
    value: _value,
    onChange: setValue,
    format: format,
    swatches: swatches,
    swatchesPerRow: swatchesPerRow,
    withPicker: withPicker,
    size: size,
    focusable: false,
    styles: styles,
    classNames: classNames
  })))));
});
ColorInput.displayName = "@mantine/core/ColorInput";
var useStyles$D = createStyles(function (theme, _ref107) {
  var fluid = _ref107.fluid,
    size = _ref107.size,
    sizes = _ref107.sizes;
  return {
    root: {
      paddingLeft: theme.spacing.md,
      paddingRight: theme.spacing.md,
      maxWidth: fluid ? "100%" : theme.fn.size({
        size: size,
        sizes: sizes
      }),
      marginLeft: "auto",
      marginRight: "auto"
    }
  };
});
var __defProp$1B = Object.defineProperty;
var __getOwnPropSymbols$1C = Object.getOwnPropertySymbols;
var __hasOwnProp$1C = Object.prototype.hasOwnProperty;
var __propIsEnum$1C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1B = function __defNormalProp$1B(obj, key, value) {
  return key in obj ? __defProp$1B(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1B = function __spreadValues$1B(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1C.call(b, prop)) __defNormalProp$1B(a, prop, b[prop]);
  if (__getOwnPropSymbols$1C) {
    var _iterator146 = _createForOfIteratorHelper(__getOwnPropSymbols$1C(b)),
      _step147;
    try {
      for (_iterator146.s(); !(_step147 = _iterator146.n()).done;) {
        var prop = _step147.value;
        if (__propIsEnum$1C.call(b, prop)) __defNormalProp$1B(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator146.e(err);
    } finally {
      _iterator146.f();
    }
  }
  return a;
};
var __objRest$T = function __objRest$T(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1C.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1C) {
    var _iterator147 = _createForOfIteratorHelper(__getOwnPropSymbols$1C(source)),
      _step148;
    try {
      for (_iterator147.s(); !(_step148 = _iterator147.n()).done;) {
        var prop = _step148.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1C.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator147.e(err);
    } finally {
      _iterator147.f();
    }
  }
  return target;
};
var defaultProps$A = {
  sizes: {
    xs: 540,
    sm: 720,
    md: 960,
    lg: 1140,
    xl: 1320
  }
};
var Container = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Container", defaultProps$A, props),
    className = _a.className,
    fluid = _a.fluid,
    size = _a.size,
    styles = _a.styles,
    classNames = _a.classNames,
    sizes = _a.sizes,
    others = __objRest$T(_a, ["className", "fluid", "size", "styles", "classNames", "sizes"]);
  var _useStyles$D = useStyles$D({
      fluid: fluid,
      size: size,
      sizes: sizes
    }, {
      styles: styles,
      classNames: classNames,
      name: "Container"
    }),
    classes = _useStyles$D.classes,
    cx = _useStyles$D.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1B({
    className: cx(classes.root, className),
    ref: ref
  }, others));
});
Container.displayName = "@mantine/core/Container";
var __defProp$1C = Object.defineProperty;
var __defProps$J = Object.defineProperties;
var __getOwnPropDescs$J = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1D = Object.getOwnPropertySymbols;
var __hasOwnProp$1D = Object.prototype.hasOwnProperty;
var __propIsEnum$1D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1C = function __defNormalProp$1C(obj, key, value) {
  return key in obj ? __defProp$1C(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1C = function __spreadValues$1C(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1D.call(b, prop)) __defNormalProp$1C(a, prop, b[prop]);
  if (__getOwnPropSymbols$1D) {
    var _iterator148 = _createForOfIteratorHelper(__getOwnPropSymbols$1D(b)),
      _step149;
    try {
      for (_iterator148.s(); !(_step149 = _iterator148.n()).done;) {
        var prop = _step149.value;
        if (__propIsEnum$1D.call(b, prop)) __defNormalProp$1C(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator148.e(err);
    } finally {
      _iterator148.f();
    }
  }
  return a;
};
var __spreadProps$J = function __spreadProps$J(a, b) {
  return __defProps$J(a, __getOwnPropDescs$J(b));
};
var sizes$a = {
  xs: 160,
  sm: 200,
  md: 340,
  lg: 400,
  xl: 500
};
var useStyles$E = createStyles(function (theme, _ref108) {
  var size = _ref108.size;
  return {
    root: __spreadProps$J(__spreadValues$1C({}, theme.fn.fontStyles()), {
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      position: "relative",
      width: theme.fn.size({
        size: size,
        sizes: sizes$a
      }),
      maxWidth: "100%",
      minHeight: 50,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white
    }),
    closeButton: {
      position: "absolute",
      top: theme.spacing.md / 2,
      right: theme.spacing.md / 2
    }
  };
});
var __defProp$1D = Object.defineProperty;
var __getOwnPropSymbols$1E = Object.getOwnPropertySymbols;
var __hasOwnProp$1E = Object.prototype.hasOwnProperty;
var __propIsEnum$1E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1D = function __defNormalProp$1D(obj, key, value) {
  return key in obj ? __defProp$1D(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1D = function __spreadValues$1D(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1E.call(b, prop)) __defNormalProp$1D(a, prop, b[prop]);
  if (__getOwnPropSymbols$1E) {
    var _iterator149 = _createForOfIteratorHelper(__getOwnPropSymbols$1E(b)),
      _step150;
    try {
      for (_iterator149.s(); !(_step150 = _iterator149.n()).done;) {
        var prop = _step150.value;
        if (__propIsEnum$1E.call(b, prop)) __defNormalProp$1D(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator149.e(err);
    } finally {
      _iterator149.f();
    }
  }
  return a;
};
var __objRest$U = function __objRest$U(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1E.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1E) {
    var _iterator150 = _createForOfIteratorHelper(__getOwnPropSymbols$1E(source)),
      _step151;
    try {
      for (_iterator150.s(); !(_step151 = _iterator150.n()).done;) {
        var prop = _step151.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1E.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator150.e(err);
    } finally {
      _iterator150.f();
    }
  }
  return target;
};
var defaultProps$B = {
  shadow: "md",
  p: "md",
  withBorder: true,
  size: "md",
  transition: "pop-top-right",
  transitionDuration: 200
};
function MantineDialog(props) {
  var _a = useMantineDefaultProps("Dialog", defaultProps$B, props),
    withCloseButton = _a.withCloseButton,
    onClose = _a.onClose,
    position = _a.position,
    shadow = _a.shadow,
    children = _a.children,
    className = _a.className,
    style = _a.style,
    classNames = _a.classNames,
    styles = _a.styles,
    opened = _a.opened,
    withBorder = _a.withBorder,
    size = _a.size,
    transition = _a.transition,
    transitionDuration = _a.transitionDuration,
    transitionTimingFunction = _a.transitionTimingFunction,
    others = __objRest$U(_a, ["withCloseButton", "onClose", "position", "shadow", "children", "className", "style", "classNames", "styles", "opened", "withBorder", "size", "transition", "transitionDuration", "transitionTimingFunction"]);
  var _useStyles$E = useStyles$E({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "Dialog"
    }),
    classes = _useStyles$E.classes,
    cx = _useStyles$E.cx;
  return /* @__PURE__ */React__default.createElement(Transition, {
    mounted: opened,
    transition: transition,
    duration: transitionDuration,
    timingFunction: transitionTimingFunction
  }, function (transitionStyles) {
    return /* @__PURE__ */React__default.createElement(Paper, __spreadValues$1D({
      className: cx(classes.root, className),
      style: __spreadValues$1D(__spreadValues$1D({}, style), transitionStyles),
      shadow: shadow,
      withBorder: withBorder
    }, others), withCloseButton && /* @__PURE__ */React__default.createElement(CloseButton, {
      onClick: onClose,
      className: classes.closeButton
    }), children);
  });
}
var Dialog = forwardRef(function (_a, ref) {
  var _b = _a,
    _b$zIndex3 = _b.zIndex,
    zIndex = _b$zIndex3 === void 0 ? getDefaultZIndex("modal") : _b$zIndex3,
    props = __objRest$U(_b, ["zIndex"]);
  var theme = useMantineTheme();
  return /* @__PURE__ */React__default.createElement(Affix, {
    zIndex: zIndex,
    position: props.position || {
      bottom: theme.spacing.xl,
      right: theme.spacing.xl
    },
    ref: ref
  }, /* @__PURE__ */React__default.createElement(MantineDialog, __spreadValues$1D({}, props)));
});
Dialog.displayName = "@mantine/core/Dialog";
var __defProp$1F = Object.defineProperty;
var __getOwnPropSymbols$1G = Object.getOwnPropertySymbols;
var __hasOwnProp$1G = Object.prototype.hasOwnProperty;
var __propIsEnum$1G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1F = function __defNormalProp$1F(obj, key, value) {
  return key in obj ? __defProp$1F(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1F = function __spreadValues$1F(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1G.call(b, prop)) __defNormalProp$1F(a, prop, b[prop]);
  if (__getOwnPropSymbols$1G) {
    var _iterator151 = _createForOfIteratorHelper(__getOwnPropSymbols$1G(b)),
      _step152;
    try {
      for (_iterator151.s(); !(_step152 = _iterator151.n()).done;) {
        var prop = _step152.value;
        if (__propIsEnum$1G.call(b, prop)) __defNormalProp$1F(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator151.e(err);
    } finally {
      _iterator151.f();
    }
  }
  return a;
};
var __objRest$V = function __objRest$V(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1G.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1G) {
    var _iterator152 = _createForOfIteratorHelper(__getOwnPropSymbols$1G(source)),
      _step153;
    try {
      for (_iterator152.s(); !(_step153 = _iterator152.n()).done;) {
        var prop = _step153.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1G.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator152.e(err);
    } finally {
      _iterator152.f();
    }
  }
  return target;
};
function OptionalPortal(_a) {
  var _b = _a,
    _b$withinPortal = _b.withinPortal,
    withinPortal = _b$withinPortal === void 0 ? true : _b$withinPortal,
    children = _b.children,
    others = __objRest$V(_b, ["withinPortal", "children"]);
  if (withinPortal) {
    return /* @__PURE__ */React__default.createElement(Portal$1, __spreadValues$1F({}, others), children);
  }
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, children);
}
OptionalPortal.displayName = "@mantine/core/OptionalPortal";
function GroupedTransition(_ref109) {
  var transitions = _ref109.transitions,
    _ref109$duration = _ref109.duration,
    duration = _ref109$duration === void 0 ? 250 : _ref109$duration,
    _ref109$exitDuration = _ref109.exitDuration,
    exitDuration = _ref109$exitDuration === void 0 ? duration : _ref109$exitDuration,
    mounted = _ref109.mounted,
    children = _ref109.children,
    timingFunction = _ref109.timingFunction,
    onExit = _ref109.onExit,
    onEntered = _ref109.onEntered,
    onEnter = _ref109.onEnter,
    onExited = _ref109.onExited;
  var _useTransition2 = useTransition({
      mounted: mounted,
      duration: duration,
      exitDuration: exitDuration,
      timingFunction: timingFunction,
      onExit: onExit,
      onEntered: onEntered,
      onEnter: onEnter,
      onExited: onExited
    }),
    transitionDuration = _useTransition2.transitionDuration,
    transitionStatus = _useTransition2.transitionStatus,
    transitionTimingFunction = _useTransition2.transitionTimingFunction;
  if (transitionDuration === 0) {
    return mounted ? /* @__PURE__ */React__default.createElement(React__default.Fragment, null, children({})) : null;
  }
  if (transitionStatus === "exited") {
    return null;
  }
  var transitionsStyles = Object.keys(transitions).reduce(function (acc, transition) {
    acc[transition] = getTransitionStyles({
      duration: transitions[transition].duration,
      transition: transitions[transition].transition,
      timingFunction: transitions[transition].timingFunction || transitionTimingFunction,
      state: transitionStatus
    });
    return acc;
  }, {});
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, children(transitionsStyles));
}
GroupedTransition.displayName = "@mantine/core/GroupedTransition";
var __defProp$1G = Object.defineProperty;
var __defProps$L = Object.defineProperties;
var __getOwnPropDescs$L = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1H = Object.getOwnPropertySymbols;
var __hasOwnProp$1H = Object.prototype.hasOwnProperty;
var __propIsEnum$1H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1G = function __defNormalProp$1G(obj, key, value) {
  return key in obj ? __defProp$1G(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1G = function __spreadValues$1G(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1H.call(b, prop)) __defNormalProp$1G(a, prop, b[prop]);
  if (__getOwnPropSymbols$1H) {
    var _iterator153 = _createForOfIteratorHelper(__getOwnPropSymbols$1H(b)),
      _step154;
    try {
      for (_iterator153.s(); !(_step154 = _iterator153.n()).done;) {
        var prop = _step154.value;
        if (__propIsEnum$1H.call(b, prop)) __defNormalProp$1G(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator153.e(err);
    } finally {
      _iterator153.f();
    }
  }
  return a;
};
var __spreadProps$L = function __spreadProps$L(a, b) {
  return __defProps$L(a, __getOwnPropDescs$L(b));
};
var __objRest$W = function __objRest$W(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1H.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1H) {
    var _iterator154 = _createForOfIteratorHelper(__getOwnPropSymbols$1H(source)),
      _step155;
    try {
      for (_iterator154.s(); !(_step155 = _iterator154.n()).done;) {
        var prop = _step155.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1H.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator154.e(err);
    } finally {
      _iterator154.f();
    }
  }
  return target;
};
var defaultProps$C = {
  opacity: 0.6,
  color: "#fff",
  zIndex: getDefaultZIndex("modal"),
  radius: 0,
  blur: 0
};
var Overlay = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Overlay", defaultProps$C, props),
    opacity = _a.opacity,
    blur = _a.blur,
    color = _a.color,
    gradient = _a.gradient,
    zIndex = _a.zIndex,
    component = _a.component,
    radius = _a.radius,
    sx = _a.sx,
    others = __objRest$W(_a, ["opacity", "blur", "color", "gradient", "zIndex", "component", "radius", "sx"]);
  var background = gradient ? {
    backgroundImage: gradient
  } : {
    backgroundColor: color
  };
  var baseStyles = {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex
  };
  var innerOverlay = function innerOverlay(otherProps) {
    return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1G({
      component: component || "div",
      ref: ref,
      sx: [function (theme) {
        return __spreadProps$L(__spreadValues$1G(__spreadValues$1G({}, background), baseStyles), {
          opacity: opacity,
          borderRadius: theme.fn.size({
            size: radius,
            sizes: theme.radius
          })
        });
      }].concat(_toConsumableArray2(Array.isArray(sx) ? sx : [sx]))
    }, otherProps));
  };
  if (blur) {
    return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1G({
      sx: [function () {
        return __spreadProps$L(__spreadValues$1G({}, baseStyles), {
          backdropFilter: "blur(".concat(blur, "px)")
        });
      }].concat(_toConsumableArray2(Array.isArray(sx) ? sx : [sx]))
    }, others), innerOverlay());
  }
  return innerOverlay(others);
});
Overlay.displayName = "@mantine/core/Overlay";
var _createUseContext = createUseContext(null),
  _createUseContext2 = _slicedToArray(_createUseContext, 2),
  GridProvider = _createUseContext2[0],
  useGridContext = _createUseContext2[1];
var __defProp$1I = Object.defineProperty;
var __getOwnPropSymbols$1J = Object.getOwnPropertySymbols;
var __hasOwnProp$1J = Object.prototype.hasOwnProperty;
var __propIsEnum$1J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1I = function __defNormalProp$1I(obj, key, value) {
  return key in obj ? __defProp$1I(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1I = function __spreadValues$1I(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1J.call(b, prop)) __defNormalProp$1I(a, prop, b[prop]);
  if (__getOwnPropSymbols$1J) {
    var _iterator155 = _createForOfIteratorHelper(__getOwnPropSymbols$1J(b)),
      _step156;
    try {
      for (_iterator155.s(); !(_step156 = _iterator155.n()).done;) {
        var prop = _step156.value;
        if (__propIsEnum$1J.call(b, prop)) __defNormalProp$1I(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator155.e(err);
    } finally {
      _iterator155.f();
    }
  }
  return a;
};
var getColumnWidth = function getColumnWidth(colSpan, columns) {
  return "".concat(100 / (columns / colSpan), "%");
};
var getColumnOffset = function getColumnOffset(offset, columns) {
  return offset ? "".concat(100 / (columns / offset), "%") : void 0;
};
function getBreakpointsStyles(_ref110) {
  var sizes = _ref110.sizes,
    offsets = _ref110.offsets,
    theme = _ref110.theme,
    columns = _ref110.columns,
    grow = _ref110.grow;
  return MANTINE_SIZES.reduce(function (acc, size) {
    if (typeof sizes[size] === "number") {
      acc["@media (min-width: ".concat(theme.breakpoints[size] + 1, "px)")] = {
        flexBasis: getColumnWidth(sizes[size], columns),
        flexShrink: 0,
        maxWidth: grow ? "unset" : getColumnWidth(sizes[size], columns),
        marginLeft: getColumnOffset(offsets[size], columns)
      };
    }
    return acc;
  }, {});
}
var useStyles$G = createStyles(function (theme, _ref111) {
  var gutter = _ref111.gutter,
    grow = _ref111.grow,
    offset = _ref111.offset,
    offsetXs = _ref111.offsetXs,
    offsetSm = _ref111.offsetSm,
    offsetMd = _ref111.offsetMd,
    offsetLg = _ref111.offsetLg,
    offsetXl = _ref111.offsetXl,
    columns = _ref111.columns,
    span = _ref111.span,
    xs = _ref111.xs,
    sm = _ref111.sm,
    md = _ref111.md,
    lg = _ref111.lg,
    xl = _ref111.xl;
  return {
    root: __spreadValues$1I({
      boxSizing: "border-box",
      flexGrow: grow ? 1 : 0,
      padding: theme.fn.size({
        size: gutter,
        sizes: theme.spacing
      }) / 2,
      marginLeft: getColumnOffset(offset, columns),
      flexBasis: getColumnWidth(span, columns),
      flexShrink: 0,
      maxWidth: grow ? "unset" : getColumnWidth(span, columns)
    }, getBreakpointsStyles({
      sizes: {
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl
      },
      offsets: {
        xs: offsetXs,
        sm: offsetSm,
        md: offsetMd,
        lg: offsetLg,
        xl: offsetXl
      },
      theme: theme,
      columns: columns,
      grow: grow
    }))
  };
});
var __defProp$1J = Object.defineProperty;
var __getOwnPropSymbols$1K = Object.getOwnPropertySymbols;
var __hasOwnProp$1K = Object.prototype.hasOwnProperty;
var __propIsEnum$1K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1J = function __defNormalProp$1J(obj, key, value) {
  return key in obj ? __defProp$1J(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1J = function __spreadValues$1J(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1K.call(b, prop)) __defNormalProp$1J(a, prop, b[prop]);
  if (__getOwnPropSymbols$1K) {
    var _iterator156 = _createForOfIteratorHelper(__getOwnPropSymbols$1K(b)),
      _step157;
    try {
      for (_iterator156.s(); !(_step157 = _iterator156.n()).done;) {
        var prop = _step157.value;
        if (__propIsEnum$1K.call(b, prop)) __defNormalProp$1J(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator156.e(err);
    } finally {
      _iterator156.f();
    }
  }
  return a;
};
var __objRest$Y = function __objRest$Y(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1K.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1K) {
    var _iterator157 = _createForOfIteratorHelper(__getOwnPropSymbols$1K(source)),
      _step158;
    try {
      for (_iterator157.s(); !(_step158 = _iterator157.n()).done;) {
        var prop = _step158.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1K.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator157.e(err);
    } finally {
      _iterator157.f();
    }
  }
  return target;
};
var defaultProps$E = {
  offset: 0,
  offsetXs: 0,
  offsetSm: 0,
  offsetMd: 0,
  offsetLg: 0,
  offsetXl: 0
};
function isValidSpan(span) {
  return typeof span === "number" && span > 0 && span % 1 === 0;
}
var Col = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Col", defaultProps$E, props),
    children = _a.children,
    span = _a.span,
    offset = _a.offset,
    offsetXs = _a.offsetXs,
    offsetSm = _a.offsetSm,
    offsetMd = _a.offsetMd,
    offsetLg = _a.offsetLg,
    offsetXl = _a.offsetXl,
    xs = _a.xs,
    sm = _a.sm,
    md = _a.md,
    lg = _a.lg,
    xl = _a.xl,
    className = _a.className,
    classNames = _a.classNames,
    styles = _a.styles,
    id = _a.id,
    others = __objRest$Y(_a, ["children", "span", "offset", "offsetXs", "offsetSm", "offsetMd", "offsetLg", "offsetXl", "xs", "sm", "md", "lg", "xl", "className", "classNames", "styles", "id"]);
  var _useGridContext = useGridContext("Grid.Col"),
    columns = _useGridContext.columns,
    gutter = _useGridContext.gutter,
    grow = _useGridContext.grow;
  var colSpan = span || columns;
  var _useStyles$G = useStyles$G({
      gutter: gutter,
      offset: offset,
      offsetXs: offsetXs,
      offsetSm: offsetSm,
      offsetMd: offsetMd,
      offsetLg: offsetLg,
      offsetXl: offsetXl,
      xs: xs,
      sm: sm,
      md: md,
      lg: lg,
      xl: xl,
      grow: grow,
      columns: columns,
      span: colSpan
    }, {
      classNames: classNames,
      styles: styles,
      name: "Col"
    }),
    classes = _useStyles$G.classes,
    cx = _useStyles$G.cx;
  if (!isValidSpan(colSpan) || colSpan > columns) {
    return null;
  }
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1J({
    className: cx(classes.root, className),
    ref: ref
  }, others), children);
});
Col.displayName = "@mantine/core/Col";
var useStyles$H = createStyles(function (theme, _ref112) {
  var justify = _ref112.justify,
    align = _ref112.align,
    gutter = _ref112.gutter;
  return {
    root: {
      margin: -theme.fn.size({
        size: gutter,
        sizes: theme.spacing
      }) / 2,
      display: "flex",
      flexWrap: "wrap",
      justifyContent: justify,
      alignItems: align
    }
  };
});
var __defProp$1K = Object.defineProperty;
var __getOwnPropSymbols$1L = Object.getOwnPropertySymbols;
var __hasOwnProp$1L = Object.prototype.hasOwnProperty;
var __propIsEnum$1L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1K = function __defNormalProp$1K(obj, key, value) {
  return key in obj ? __defProp$1K(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1K = function __spreadValues$1K(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1L.call(b, prop)) __defNormalProp$1K(a, prop, b[prop]);
  if (__getOwnPropSymbols$1L) {
    var _iterator158 = _createForOfIteratorHelper(__getOwnPropSymbols$1L(b)),
      _step159;
    try {
      for (_iterator158.s(); !(_step159 = _iterator158.n()).done;) {
        var prop = _step159.value;
        if (__propIsEnum$1L.call(b, prop)) __defNormalProp$1K(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator158.e(err);
    } finally {
      _iterator158.f();
    }
  }
  return a;
};
var __objRest$Z = function __objRest$Z(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1L.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1L) {
    var _iterator159 = _createForOfIteratorHelper(__getOwnPropSymbols$1L(source)),
      _step160;
    try {
      for (_iterator159.s(); !(_step160 = _iterator159.n()).done;) {
        var prop = _step160.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1L.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator159.e(err);
    } finally {
      _iterator159.f();
    }
  }
  return target;
};
var defaultProps$F = {
  gutter: "md",
  justify: "flex-start",
  align: "stretch",
  columns: 12
};
var Grid = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Grid", defaultProps$F, props),
    gutter = _a.gutter,
    children = _a.children,
    grow = _a.grow,
    justify = _a.justify,
    align = _a.align,
    columns = _a.columns,
    className = _a.className,
    classNames = _a.classNames,
    styles = _a.styles,
    id = _a.id,
    others = __objRest$Z(_a, ["gutter", "children", "grow", "justify", "align", "columns", "className", "classNames", "styles", "id"]);
  var _useStyles$H = useStyles$H({
      gutter: gutter,
      justify: justify,
      align: align
    }, {
      classNames: classNames,
      styles: styles,
      name: "Grid"
    }),
    classes = _useStyles$H.classes,
    cx = _useStyles$H.cx;
  return /* @__PURE__ */React__default.createElement(GridProvider, {
    value: {
      gutter: gutter,
      grow: grow,
      columns: columns
    }
  }, /* @__PURE__ */React__default.createElement(Box, __spreadValues$1K({
    className: cx(classes.root, className),
    ref: ref
  }, others), children));
});
Grid.Col = Col;
Grid.displayName = "@mantine/core/Grid";
var useStyles$I = createStyles(function (theme, _ref113) {
  var color = _ref113.color;
  return {
    root: {
      backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 5 : 2),
      color: theme.colorScheme === "dark" ? theme.colors.dark[9] : "inherit"
    }
  };
});
var __defProp$1L = Object.defineProperty;
var __getOwnPropSymbols$1M = Object.getOwnPropertySymbols;
var __hasOwnProp$1M = Object.prototype.hasOwnProperty;
var __propIsEnum$1M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1L = function __defNormalProp$1L(obj, key, value) {
  return key in obj ? __defProp$1L(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1L = function __spreadValues$1L(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1M.call(b, prop)) __defNormalProp$1L(a, prop, b[prop]);
  if (__getOwnPropSymbols$1M) {
    var _iterator160 = _createForOfIteratorHelper(__getOwnPropSymbols$1M(b)),
      _step161;
    try {
      for (_iterator160.s(); !(_step161 = _iterator160.n()).done;) {
        var prop = _step161.value;
        if (__propIsEnum$1M.call(b, prop)) __defNormalProp$1L(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator160.e(err);
    } finally {
      _iterator160.f();
    }
  }
  return a;
};
var __objRest$_ = function __objRest$_(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1M.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1M) {
    var _iterator161 = _createForOfIteratorHelper(__getOwnPropSymbols$1M(source)),
      _step162;
    try {
      for (_iterator161.s(); !(_step162 = _iterator161.n()).done;) {
        var prop = _step162.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1M.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator161.e(err);
    } finally {
      _iterator161.f();
    }
  }
  return target;
};
var defaultProps$G = {
  color: "yellow"
};
var Mark = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Mark", defaultProps$G, props),
    color = _a.color,
    className = _a.className,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$_(_a, ["color", "className", "classNames", "styles"]);
  var _useStyles$I = useStyles$I({
      color: color
    }, {
      classNames: classNames,
      styles: styles,
      name: "Mark"
    }),
    classes = _useStyles$I.classes,
    cx = _useStyles$I.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1L({
    component: "mark",
    ref: ref,
    className: cx(classes.root, className)
  }, others));
});
Mark.displayName = "@mantine/core/Mark";
function escapeRegex(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&");
}
function highlighter(value, _highlight) {
  if (_highlight == null) {
    return [{
      chunk: value,
      highlighted: false
    }];
  }
  var highlight = Array.isArray(_highlight) ? _highlight.map(escapeRegex) : escapeRegex(_highlight);
  var shouldHighlight = Array.isArray(highlight) ? highlight.filter(function (part) {
    return part.trim().length > 0;
  }).length > 0 : highlight.trim() !== "";
  if (!shouldHighlight) {
    return [{
      chunk: value,
      highlighted: false
    }];
  }
  var matcher = typeof highlight === "string" ? highlight.trim() : highlight.filter(function (part) {
    return part.trim().length !== 0;
  }).map(function (part) {
    return part.trim();
  }).join("|");
  var re = new RegExp("(".concat(matcher, ")"), "gi");
  var chunks = value.split(re).map(function (part) {
    return {
      chunk: part,
      highlighted: re.test(part)
    };
  }).filter(function (_ref114) {
    var chunk = _ref114.chunk;
    return chunk;
  });
  return chunks;
}
var __defProp$1M = Object.defineProperty;
var __getOwnPropSymbols$1N = Object.getOwnPropertySymbols;
var __hasOwnProp$1N = Object.prototype.hasOwnProperty;
var __propIsEnum$1N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1M = function __defNormalProp$1M(obj, key, value) {
  return key in obj ? __defProp$1M(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1M = function __spreadValues$1M(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1N.call(b, prop)) __defNormalProp$1M(a, prop, b[prop]);
  if (__getOwnPropSymbols$1N) {
    var _iterator162 = _createForOfIteratorHelper(__getOwnPropSymbols$1N(b)),
      _step163;
    try {
      for (_iterator162.s(); !(_step163 = _iterator162.n()).done;) {
        var prop = _step163.value;
        if (__propIsEnum$1N.call(b, prop)) __defNormalProp$1M(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator162.e(err);
    } finally {
      _iterator162.f();
    }
  }
  return a;
};
var __objRest$10 = function __objRest$10(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1N.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1N) {
    var _iterator163 = _createForOfIteratorHelper(__getOwnPropSymbols$1N(source)),
      _step164;
    try {
      for (_iterator163.s(); !(_step164 = _iterator163.n()).done;) {
        var prop = _step164.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1N.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator163.e(err);
    } finally {
      _iterator163.f();
    }
  }
  return target;
};
var defaultProps$H = {
  highlightColor: "yellow"
};
var Highlight = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Highlight", defaultProps$H, props),
    children = _a.children,
    highlight = _a.highlight,
    highlightColor = _a.highlightColor,
    component = _a.component,
    highlightStyles = _a.highlightStyles,
    others = __objRest$10(_a, ["children", "highlight", "highlightColor", "component", "highlightStyles"]);
  var highlightChunks = highlighter(children, highlight);
  return /* @__PURE__ */React__default.createElement(Text, __spreadValues$1M({
    component: component,
    ref: ref
  }, others), highlightChunks.map(function (_ref115, i) {
    var chunk = _ref115.chunk,
      highlighted = _ref115.highlighted;
    return highlighted ? /* @__PURE__ */React__default.createElement(Mark, {
      key: i,
      color: highlightColor,
      sx: highlightStyles
    }, chunk) : /* @__PURE__ */React__default.createElement("span", {
      key: i
    }, chunk);
  }));
});
Highlight.displayName = "@mantine/core/Highlight";
var __defProp$1N = Object.defineProperty;
var __getOwnPropSymbols$1O = Object.getOwnPropertySymbols;
var __hasOwnProp$1O = Object.prototype.hasOwnProperty;
var __propIsEnum$1O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1N = function __defNormalProp$1N(obj, key, value) {
  return key in obj ? __defProp$1N(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1N = function __spreadValues$1N(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1O.call(b, prop)) __defNormalProp$1N(a, prop, b[prop]);
  if (__getOwnPropSymbols$1O) {
    var _iterator164 = _createForOfIteratorHelper(__getOwnPropSymbols$1O(b)),
      _step165;
    try {
      for (_iterator164.s(); !(_step165 = _iterator164.n()).done;) {
        var prop = _step165.value;
        if (__propIsEnum$1O.call(b, prop)) __defNormalProp$1N(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator164.e(err);
    } finally {
      _iterator164.f();
    }
  }
  return a;
};
function ImageIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$1N({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var __defProp$1O = Object.defineProperty;
var __defProps$M = Object.defineProperties;
var __getOwnPropDescs$M = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1P = Object.getOwnPropertySymbols;
var __hasOwnProp$1P = Object.prototype.hasOwnProperty;
var __propIsEnum$1P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1O = function __defNormalProp$1O(obj, key, value) {
  return key in obj ? __defProp$1O(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1O = function __spreadValues$1O(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1P.call(b, prop)) __defNormalProp$1O(a, prop, b[prop]);
  if (__getOwnPropSymbols$1P) {
    var _iterator165 = _createForOfIteratorHelper(__getOwnPropSymbols$1P(b)),
      _step166;
    try {
      for (_iterator165.s(); !(_step166 = _iterator165.n()).done;) {
        var prop = _step166.value;
        if (__propIsEnum$1P.call(b, prop)) __defNormalProp$1O(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator165.e(err);
    } finally {
      _iterator165.f();
    }
  }
  return a;
};
var __spreadProps$M = function __spreadProps$M(a, b) {
  return __defProps$M(a, __getOwnPropDescs$M(b));
};
var useStyles$J = createStyles(function (theme, _ref116) {
  var radius = _ref116.radius;
  return {
    root: {},
    imageWrapper: {
      position: "relative"
    },
    figure: {
      margin: 0
    },
    image: __spreadProps$M(__spreadValues$1O({}, theme.fn.fontStyles()), {
      display: "block",
      width: "100%",
      height: "100%",
      border: 0,
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      })
    }),
    caption: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
      marginTop: theme.spacing.xs
    },
    placeholder: __spreadProps$M(__spreadValues$1O({}, theme.fn.cover()), {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0],
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      })
    })
  };
});
var __defProp$1P = Object.defineProperty;
var __getOwnPropSymbols$1Q = Object.getOwnPropertySymbols;
var __hasOwnProp$1Q = Object.prototype.hasOwnProperty;
var __propIsEnum$1Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1P = function __defNormalProp$1P(obj, key, value) {
  return key in obj ? __defProp$1P(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1P = function __spreadValues$1P(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1Q.call(b, prop)) __defNormalProp$1P(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Q) {
    var _iterator166 = _createForOfIteratorHelper(__getOwnPropSymbols$1Q(b)),
      _step167;
    try {
      for (_iterator166.s(); !(_step167 = _iterator166.n()).done;) {
        var prop = _step167.value;
        if (__propIsEnum$1Q.call(b, prop)) __defNormalProp$1P(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator166.e(err);
    } finally {
      _iterator166.f();
    }
  }
  return a;
};
var __objRest$11 = function __objRest$11(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1Q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1Q) {
    var _iterator167 = _createForOfIteratorHelper(__getOwnPropSymbols$1Q(source)),
      _step168;
    try {
      for (_iterator167.s(); !(_step168 = _iterator167.n()).done;) {
        var prop = _step168.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1Q.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator167.e(err);
    } finally {
      _iterator167.f();
    }
  }
  return target;
};
var defaultProps$I = {
  fit: "cover",
  width: "100%",
  height: "auto",
  radius: 0
};
var Image = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Image", defaultProps$I, props),
    className = _a.className,
    alt = _a.alt,
    src = _a.src,
    fit = _a.fit,
    width = _a.width,
    height = _a.height,
    radius = _a.radius,
    imageProps = _a.imageProps,
    withPlaceholder = _a.withPlaceholder,
    placeholder = _a.placeholder,
    imageRef = _a.imageRef,
    classNames = _a.classNames,
    styles = _a.styles,
    caption = _a.caption,
    others = __objRest$11(_a, ["className", "alt", "src", "fit", "width", "height", "radius", "imageProps", "withPlaceholder", "placeholder", "imageRef", "classNames", "styles", "caption"]);
  var _useStyles$J = useStyles$J({
      radius: radius
    }, {
      classNames: classNames,
      styles: styles,
      name: "Image"
    }),
    classes = _useStyles$J.classes,
    cx = _useStyles$J.cx;
  var _useState93 = useState(false),
    _useState94 = _slicedToArray(_useState93, 2),
    loaded = _useState94[0],
    setLoaded = _useState94[1];
  var _useState95 = useState(!src),
    _useState96 = _slicedToArray(_useState95, 2),
    error = _useState96[0],
    setError = _useState96[1];
  var isPlaceholder = withPlaceholder && (!loaded || error);
  useDidUpdate(function () {
    setLoaded(false);
    setError(false);
  }, [src]);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1P({
    className: cx(classes.root, className),
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("figure", {
    className: classes.figure
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.imageWrapper
  }, /* @__PURE__ */React__default.createElement("img", __spreadValues$1P({
    className: classes.image,
    src: src,
    alt: alt,
    style: {
      objectFit: fit,
      width: width,
      height: height
    },
    ref: imageRef,
    onLoad: function onLoad(event) {
      setLoaded(true);
      typeof (imageProps == null ? void 0 : imageProps.onLoad) === "function" && imageProps.onLoad(event);
    },
    onError: function onError(event) {
      setError(true);
      typeof (imageProps == null ? void 0 : imageProps.onError) === "function" && imageProps.onError(event);
    }
  }, imageProps)), isPlaceholder && /* @__PURE__ */React__default.createElement("div", {
    className: classes.placeholder,
    title: alt
  }, placeholder || /* @__PURE__ */React__default.createElement(ImageIcon, {
    style: {
      width: 40,
      height: 40
    }
  }))), !!caption && /* @__PURE__ */React__default.createElement(Text, {
    component: "figcaption",
    size: "sm",
    align: "center",
    className: classes.caption
  }, caption)));
});
Image.displayName = "@mantine/core/Image";
var __defProp$1Q = Object.defineProperty;
var __defProps$N = Object.defineProperties;
var __getOwnPropDescs$N = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1R = Object.getOwnPropertySymbols;
var __hasOwnProp$1R = Object.prototype.hasOwnProperty;
var __propIsEnum$1R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Q = function __defNormalProp$1Q(obj, key, value) {
  return key in obj ? __defProp$1Q(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1Q = function __spreadValues$1Q(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1R.call(b, prop)) __defNormalProp$1Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$1R) {
    var _iterator168 = _createForOfIteratorHelper(__getOwnPropSymbols$1R(b)),
      _step169;
    try {
      for (_iterator168.s(); !(_step169 = _iterator168.n()).done;) {
        var prop = _step169.value;
        if (__propIsEnum$1R.call(b, prop)) __defNormalProp$1Q(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator168.e(err);
    } finally {
      _iterator168.f();
    }
  }
  return a;
};
var __spreadProps$N = function __spreadProps$N(a, b) {
  return __defProps$N(a, __getOwnPropDescs$N(b));
};
var __objRest$12 = function __objRest$12(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1R.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1R) {
    var _iterator169 = _createForOfIteratorHelper(__getOwnPropSymbols$1R(source)),
      _step170;
    try {
      for (_iterator169.s(); !(_step170 = _iterator169.n()).done;) {
        var prop = _step170.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1R.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator169.e(err);
    } finally {
      _iterator169.f();
    }
  }
  return target;
};
var defaultProps$J = {
  radius: 0
};
var BackgroundImage = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("BackgroundImage", defaultProps$J, props),
    src = _a.src,
    radius = _a.radius,
    sx = _a.sx,
    others = __objRest$12(_a, ["src", "radius", "sx"]);
  return /* @__PURE__ */React__default.createElement(Box, __spreadProps$N(__spreadValues$1Q({}, others), {
    ref: ref,
    sx: [function (theme) {
      return __spreadProps$N(__spreadValues$1Q({}, theme.fn.focusStyles()), {
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "block",
        width: "100%",
        border: 0,
        textDecoration: "none",
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        backgroundImage: "url(".concat(src, ")"),
        borderRadius: theme.fn.radius(radius)
      });
    }].concat(_toConsumableArray2(Array.isArray(sx) ? sx : [sx]))
  }));
});
BackgroundImage.displayName = "@mantine/core/BackgroundImage";
var __defProp$1R = Object.defineProperty;
var __defProps$O = Object.defineProperties;
var __getOwnPropDescs$O = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1S = Object.getOwnPropertySymbols;
var __hasOwnProp$1S = Object.prototype.hasOwnProperty;
var __propIsEnum$1S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1R = function __defNormalProp$1R(obj, key, value) {
  return key in obj ? __defProp$1R(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1R = function __spreadValues$1R(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1S.call(b, prop)) __defNormalProp$1R(a, prop, b[prop]);
  if (__getOwnPropSymbols$1S) {
    var _iterator170 = _createForOfIteratorHelper(__getOwnPropSymbols$1S(b)),
      _step171;
    try {
      for (_iterator170.s(); !(_step171 = _iterator170.n()).done;) {
        var prop = _step171.value;
        if (__propIsEnum$1S.call(b, prop)) __defNormalProp$1R(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator170.e(err);
    } finally {
      _iterator170.f();
    }
  }
  return a;
};
var __spreadProps$O = function __spreadProps$O(a, b) {
  return __defProps$O(a, __getOwnPropDescs$O(b));
};
function getPositionStyles$2(_position) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var styles = {};
  var _position$split = _position.split("-"),
    _position$split2 = _slicedToArray(_position$split, 2),
    position = _position$split2[0],
    placement = _position$split2[1];
  var translateX = "";
  var translateY = "";
  if (position === "top") {
    styles.top = offset;
    translateY = "-50%";
  }
  if (position === "middle") {
    styles.top = "50%";
    translateY = "-50%";
  }
  if (position === "bottom") {
    styles.bottom = offset;
    translateY = "50%";
  }
  if (placement === "start") {
    styles.left = offset;
    translateX = "-50%";
  }
  if (placement === "center") {
    styles.left = "50%";
    translateX = "-50%";
  }
  if (placement === "end") {
    styles.right = offset;
    translateX = "50%";
  }
  styles.transform = "translate(".concat(translateX, ", ").concat(translateY, ")");
  return styles;
}
var useStyles$K = createStyles(function (theme, _ref117) {
  var _spreadProps$O;
  var radius = _ref117.radius,
    size = _ref117.size,
    color = _ref117.color,
    position = _ref117.position,
    offset = _ref117.offset,
    inline = _ref117.inline,
    withBorder = _ref117.withBorder,
    withLabel = _ref117.withLabel,
    zIndex = _ref117.zIndex;
  return {
    root: {
      position: "relative",
      display: inline ? "inline-block" : "block"
    },
    indicator: __spreadProps$O(__spreadValues$1R({}, getPositionStyles$2(position, offset)), (_spreadProps$O = {
      zIndex: zIndex,
      position: "absolute"
    }, _defineProperty(_spreadProps$O, withLabel ? "minWidth" : "width", size), _defineProperty(_spreadProps$O, "height", size), _defineProperty(_spreadProps$O, "display", "flex"), _defineProperty(_spreadProps$O, "justifyContent", "center"), _defineProperty(_spreadProps$O, "alignItems", "center"), _defineProperty(_spreadProps$O, "fontSize", theme.fontSizes.xs), _defineProperty(_spreadProps$O, "paddingLeft", withLabel ? theme.spacing.xs / 2 : 0), _defineProperty(_spreadProps$O, "paddingRight", withLabel ? theme.spacing.xs / 2 : 0), _defineProperty(_spreadProps$O, "borderRadius", theme.fn.size({
      size: radius,
      sizes: theme.radius
    })), _defineProperty(_spreadProps$O, "backgroundColor", theme.fn.themeColor(color || theme.primaryColor, theme.fn.primaryShade(), false)), _defineProperty(_spreadProps$O, "border", withBorder ? "2px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white) : void 0), _defineProperty(_spreadProps$O, "color", theme.white), _defineProperty(_spreadProps$O, "whiteSpace", "nowrap"), _spreadProps$O))
  };
});
var __defProp$1S = Object.defineProperty;
var __getOwnPropSymbols$1T = Object.getOwnPropertySymbols;
var __hasOwnProp$1T = Object.prototype.hasOwnProperty;
var __propIsEnum$1T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1S = function __defNormalProp$1S(obj, key, value) {
  return key in obj ? __defProp$1S(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1S = function __spreadValues$1S(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1T.call(b, prop)) __defNormalProp$1S(a, prop, b[prop]);
  if (__getOwnPropSymbols$1T) {
    var _iterator171 = _createForOfIteratorHelper(__getOwnPropSymbols$1T(b)),
      _step172;
    try {
      for (_iterator171.s(); !(_step172 = _iterator171.n()).done;) {
        var prop = _step172.value;
        if (__propIsEnum$1T.call(b, prop)) __defNormalProp$1S(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator171.e(err);
    } finally {
      _iterator171.f();
    }
  }
  return a;
};
var __objRest$13 = function __objRest$13(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1T.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1T) {
    var _iterator172 = _createForOfIteratorHelper(__getOwnPropSymbols$1T(source)),
      _step173;
    try {
      for (_iterator172.s(); !(_step173 = _iterator172.n()).done;) {
        var prop = _step173.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1T.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator172.e(err);
    } finally {
      _iterator172.f();
    }
  }
  return target;
};
var defaultProps$K = {
  position: "top-end",
  offset: 0,
  inline: false,
  withBorder: false,
  disabled: false,
  size: 10,
  radius: 1e3,
  zIndex: getDefaultZIndex("app")
};
var Indicator = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Indicator", defaultProps$K, props),
    children = _a.children,
    position = _a.position,
    offset = _a.offset,
    size = _a.size,
    radius = _a.radius,
    inline = _a.inline,
    withBorder = _a.withBorder,
    className = _a.className,
    color = _a.color,
    styles = _a.styles,
    label = _a.label,
    classNames = _a.classNames,
    disabled = _a.disabled,
    zIndex = _a.zIndex,
    others = __objRest$13(_a, ["children", "position", "offset", "size", "radius", "inline", "withBorder", "className", "color", "styles", "label", "classNames", "disabled", "zIndex"]);
  var _useStyles$K = useStyles$K({
      position: position,
      offset: offset,
      size: size,
      radius: radius,
      inline: inline,
      color: color,
      withBorder: withBorder,
      zIndex: zIndex,
      withLabel: !!label
    }, {
      name: "Indicator",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$K.classes,
    cx = _useStyles$K.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1S({
    ref: ref,
    className: cx(classes.root, className)
  }, others), !disabled && /* @__PURE__ */React__default.createElement("div", {
    className: classes.indicator
  }, label), children);
});
Indicator.displayName = "@mantine/core/Indicator";
function validateJson(value) {
  if (typeof value === "string" && value.trim().length === 0) {
    return true;
  }
  try {
    JSON.parse(value);
    return true;
  } catch (e) {
    return false;
  }
}
var useStyles$L = createStyles(function (theme, _ref118) {
  var size = _ref118.size;
  return {
    input: {
      fontFamily: theme.fontFamilyMonospace,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }) - 2
    }
  };
});
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var index = typeof document !== 'undefined' ? useLayoutEffect : useEffect;
var useLatest = function useLatest(value) {
  var ref = useRef(value);
  index(function () {
    ref.current = value;
  });
  return ref;
};
var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  ref.current = value;
};
var useComposedRef = function useComposedRef(libRef, userRef) {
  var prevUserRef = useRef();
  return useCallback(function (instance) {
    libRef.current = instance;
    if (prevUserRef.current) {
      updateRef(prevUserRef.current, null);
    }
    prevUserRef.current = userRef;
    if (!userRef) {
      return;
    }
    updateRef(userRef, instance);
  }, [userRef]);
};
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};

//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259

var hiddenTextarea = null;
var getHeight = function getHeight(node, sizingData) {
  var height = node.scrollHeight;
  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
  } // remove padding, since height = content

  return height - sizingData.paddingSize;
};
function calculateNodeHeight(sizingData, value, minRows, maxRows) {
  if (minRows === void 0) {
    minRows = 1;
  }
  if (maxRows === void 0) {
    maxRows = Infinity;
  }
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tabindex', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    forceHiddenStyles(hiddenTextarea);
  }
  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }
  var paddingSize = sizingData.paddingSize,
    borderSize = sizingData.borderSize,
    sizingStyle = sizingData.sizingStyle;
  var boxSizing = sizingStyle.boxSizing;
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  var height = getHeight(hiddenTextarea, sizingData); // measure height of a textarea with a single row

  hiddenTextarea.value = 'x';
  var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
  var minHeight = rowHeight * minRows;
  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }
  height = Math.max(minHeight, height);
  var maxHeight = rowHeight * maxRows;
  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }
  height = Math.min(maxHeight, height);
  return [height, rowHeight];
}
var noop = function noop() {};
var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};
var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop',
// non-standard
'tabSize', 'textIndent',
// non-standard
'textRendering', 'textTransform', 'width', 'wordBreak'];
var isIE = typeof document !== 'undefined' ? !!document.documentElement.currentStyle : false;
var getSizingData = function getSizingData(node) {
  var style = window.getComputedStyle(node);
  if (style === null) {
    return null;
  }
  var sizingStyle = pick(SIZING_STYLE, style);
  var boxSizing = sizingStyle.boxSizing; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths

  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
  }
  var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
  var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};
var useWindowResizeListener = function useWindowResizeListener(listener) {
  var latestListener = useLatest(listener);
  useLayoutEffect(function () {
    var handler = function handler(event) {
      latestListener.current(event);
    };
    window.addEventListener('resize', handler);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, []);
};
var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
  var cacheMeasurements = _ref.cacheMeasurements,
    maxRows = _ref.maxRows,
    minRows = _ref.minRows,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    _ref$onHeightChange = _ref.onHeightChange,
    onHeightChange = _ref$onHeightChange === void 0 ? noop : _ref$onHeightChange,
    props = _objectWithoutPropertiesLoose(_ref, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);
  if (process.env.NODE_ENV !== 'production' && props.style) {
    if ('maxHeight' in props.style) {
      throw new Error('Using `style.maxHeight` for <TextareaAutosize/> is not supported. Please use `maxRows`.');
    }
    if ('minHeight' in props.style) {
      throw new Error('Using `style.minHeight` for <TextareaAutosize/> is not supported. Please use `minRows`.');
    }
  }
  var isControlled = props.value !== undefined;
  var libRef = useRef(null);
  var ref = useComposedRef(libRef, userRef);
  var heightRef = useRef(0);
  var measurementsCacheRef = useRef();
  var resizeTextarea = function resizeTextarea() {
    var node = libRef.current;
    var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);
    if (!nodeSizingData) {
      return;
    }
    measurementsCacheRef.current = nodeSizingData;
    var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows),
      height = _calculateNodeHeight[0],
      rowHeight = _calculateNodeHeight[1];
    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty('height', height + "px", 'important');
      onHeightChange(height, {
        rowHeight: rowHeight
      });
    }
  };
  var handleChange = function handleChange(event) {
    if (!isControlled) {
      resizeTextarea();
    }
    onChange(event);
  };
  if (typeof document !== 'undefined') {
    useLayoutEffect(resizeTextarea);
    useWindowResizeListener(resizeTextarea);
  }
  return /*#__PURE__*/createElement("textarea", _extends({}, props, {
    onChange: handleChange,
    ref: ref
  }));
};
var index$1 = /* #__PURE__ */forwardRef(TextareaAutosize);
var useStyles$M = createStyles(function (theme) {
  return {
    input: {
      paddingTop: theme.spacing.xs,
      paddingBottom: theme.spacing.xs
    }
  };
});
var __defProp$1T = Object.defineProperty;
var __defProps$P = Object.defineProperties;
var __getOwnPropDescs$P = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1U = Object.getOwnPropertySymbols;
var __hasOwnProp$1U = Object.prototype.hasOwnProperty;
var __propIsEnum$1U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1T = function __defNormalProp$1T(obj, key, value) {
  return key in obj ? __defProp$1T(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1T = function __spreadValues$1T(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1U.call(b, prop)) __defNormalProp$1T(a, prop, b[prop]);
  if (__getOwnPropSymbols$1U) {
    var _iterator173 = _createForOfIteratorHelper(__getOwnPropSymbols$1U(b)),
      _step174;
    try {
      for (_iterator173.s(); !(_step174 = _iterator173.n()).done;) {
        var prop = _step174.value;
        if (__propIsEnum$1U.call(b, prop)) __defNormalProp$1T(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator173.e(err);
    } finally {
      _iterator173.f();
    }
  }
  return a;
};
var __spreadProps$P = function __spreadProps$P(a, b) {
  return __defProps$P(a, __getOwnPropDescs$P(b));
};
var __objRest$14 = function __objRest$14(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1U.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1U) {
    var _iterator174 = _createForOfIteratorHelper(__getOwnPropSymbols$1U(source)),
      _step175;
    try {
      for (_iterator174.s(); !(_step175 = _iterator174.n()).done;) {
        var prop = _step175.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1U.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator174.e(err);
    } finally {
      _iterator174.f();
    }
  }
  return target;
};
var defaultProps$L = {
  autosize: false,
  size: "sm",
  __staticSelector: "Textarea"
};
var Textarea = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Textarea", defaultProps$L, props),
    autosize = _a.autosize,
    maxRows = _a.maxRows,
    minRows = _a.minRows,
    label = _a.label,
    error = _a.error,
    description = _a.description,
    id = _a.id,
    className = _a.className,
    required = _a.required,
    style = _a.style,
    wrapperProps = _a.wrapperProps,
    classNames = _a.classNames,
    styles = _a.styles,
    size = _a.size,
    __staticSelector = _a.__staticSelector,
    sx = _a.sx,
    errorProps = _a.errorProps,
    descriptionProps = _a.descriptionProps,
    labelProps = _a.labelProps,
    others = __objRest$14(_a, ["autosize", "maxRows", "minRows", "label", "error", "description", "id", "className", "required", "style", "wrapperProps", "classNames", "styles", "size", "__staticSelector", "sx", "errorProps", "descriptionProps", "labelProps"]);
  var uuid = useUuid(id);
  var _useStyles$M = useStyles$M(),
    classes = _useStyles$M.classes,
    cx = _useStyles$M.cx;
  var _extractSystemStyles8 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles8.systemStyles,
    rest = _extractSystemStyles8.rest;
  var sharedProps = __spreadValues$1T({
    required: required,
    ref: ref,
    invalid: !!error,
    id: uuid,
    classNames: __spreadProps$P(__spreadValues$1T({}, classNames), {
      input: cx(classes.input, classNames == null ? void 0 : classNames.input)
    }),
    styles: styles,
    __staticSelector: __staticSelector,
    size: size,
    multiline: true
  }, rest);
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$1T(__spreadValues$1T({
    label: label,
    error: error,
    id: uuid,
    description: description,
    required: required,
    style: style,
    className: className,
    classNames: classNames,
    styles: styles,
    size: size,
    __staticSelector: __staticSelector,
    sx: sx,
    errorProps: errorProps,
    labelProps: labelProps,
    descriptionProps: descriptionProps
  }, systemStyles), wrapperProps), autosize ? /* @__PURE__ */React__default.createElement(Input, __spreadProps$P(__spreadValues$1T({}, sharedProps), {
    component: index$1,
    maxRows: maxRows,
    minRows: minRows
  })) : /* @__PURE__ */React__default.createElement(Input, __spreadProps$P(__spreadValues$1T({}, sharedProps), {
    component: "textarea",
    rows: minRows
  })));
});
Textarea.displayName = "@mantine/core/Textarea";
var __defProp$1U = Object.defineProperty;
var __defProps$Q = Object.defineProperties;
var __getOwnPropDescs$Q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1V = Object.getOwnPropertySymbols;
var __hasOwnProp$1V = Object.prototype.hasOwnProperty;
var __propIsEnum$1V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1U = function __defNormalProp$1U(obj, key, value) {
  return key in obj ? __defProp$1U(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1U = function __spreadValues$1U(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1V.call(b, prop)) __defNormalProp$1U(a, prop, b[prop]);
  if (__getOwnPropSymbols$1V) {
    var _iterator175 = _createForOfIteratorHelper(__getOwnPropSymbols$1V(b)),
      _step176;
    try {
      for (_iterator175.s(); !(_step176 = _iterator175.n()).done;) {
        var prop = _step176.value;
        if (__propIsEnum$1V.call(b, prop)) __defNormalProp$1U(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator175.e(err);
    } finally {
      _iterator175.f();
    }
  }
  return a;
};
var __spreadProps$Q = function __spreadProps$Q(a, b) {
  return __defProps$Q(a, __getOwnPropDescs$Q(b));
};
var __objRest$15 = function __objRest$15(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1V.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1V) {
    var _iterator176 = _createForOfIteratorHelper(__getOwnPropSymbols$1V(source)),
      _step177;
    try {
      for (_iterator176.s(); !(_step177 = _iterator176.n()).done;) {
        var prop = _step177.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1V.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator176.e(err);
    } finally {
      _iterator176.f();
    }
  }
  return target;
};
var defaultProps$M = {
  formatOnBlur: false,
  size: "sm"
};
var JsonInput = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("JsonInput", defaultProps$M, props),
    value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    error = _a.error,
    formatOnBlur = _a.formatOnBlur,
    size = _a.size,
    validationError = _a.validationError,
    classNames = _a.classNames,
    others = __objRest$15(_a, ["value", "defaultValue", "onChange", "onFocus", "onBlur", "error", "formatOnBlur", "size", "validationError", "classNames"]);
  var _useStyles$L = useStyles$L({
      size: size
    }, {
      name: "JsonInput"
    }),
    classes = _useStyles$L.classes,
    cx = _useStyles$L.cx;
  var _useUncontrolled15 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: "",
      rule: function rule(val) {
        return typeof val === "string";
      },
      onChange: onChange
    }),
    _useUncontrolled16 = _slicedToArray(_useUncontrolled15, 2),
    _value = _useUncontrolled16[0],
    setValue = _useUncontrolled16[1];
  var _useState97 = useState(validateJson(_value)),
    _useState98 = _slicedToArray(_useState97, 2),
    valid = _useState98[0],
    setValid = _useState98[1];
  var handleFocus = function handleFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    setValid(true);
  };
  var handleBlur = function handleBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    var isValid = validateJson(event.currentTarget.value);
    formatOnBlur && isValid && event.currentTarget.value.trim() !== "" && setValue(JSON.stringify(JSON.parse(event.currentTarget.value), null, 2));
    setValid(isValid);
  };
  return /* @__PURE__ */React__default.createElement(Textarea, __spreadValues$1U({
    value: _value,
    onChange: function onChange(event) {
      return setValue(event.currentTarget.value);
    },
    onFocus: handleFocus,
    onBlur: handleBlur,
    error: valid ? error : validationError || true,
    __staticSelector: "JsonInput",
    classNames: __spreadProps$Q(__spreadValues$1U({}, classNames), {
      input: cx(classes.input, classNames == null ? void 0 : classNames.input)
    }),
    autoComplete: "nope",
    ref: ref
  }, others));
});
JsonInput.displayName = "@mantine/core/JsonInput";
var useStyles$N = createStyles(function (theme) {
  return {
    root: {
      lineHeight: theme.lineHeight,
      fontFamily: theme.fontFamilyMonospace,
      fontSize: theme.fontSizes.xs,
      fontWeight: 700,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[0],
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
      padding: "3px ".concat(theme.spacing.xs / 2, "px"),
      borderRadius: theme.radius.sm,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.colors.gray[3]),
      borderBottom: "3px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.colors.gray[3])
    }
  };
});
var __defProp$1V = Object.defineProperty;
var __getOwnPropSymbols$1W = Object.getOwnPropertySymbols;
var __hasOwnProp$1W = Object.prototype.hasOwnProperty;
var __propIsEnum$1W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1V = function __defNormalProp$1V(obj, key, value) {
  return key in obj ? __defProp$1V(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1V = function __spreadValues$1V(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1W.call(b, prop)) __defNormalProp$1V(a, prop, b[prop]);
  if (__getOwnPropSymbols$1W) {
    var _iterator177 = _createForOfIteratorHelper(__getOwnPropSymbols$1W(b)),
      _step178;
    try {
      for (_iterator177.s(); !(_step178 = _iterator177.n()).done;) {
        var prop = _step178.value;
        if (__propIsEnum$1W.call(b, prop)) __defNormalProp$1V(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator177.e(err);
    } finally {
      _iterator177.f();
    }
  }
  return a;
};
var __objRest$16 = function __objRest$16(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1W.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1W) {
    var _iterator178 = _createForOfIteratorHelper(__getOwnPropSymbols$1W(source)),
      _step179;
    try {
      for (_iterator178.s(); !(_step179 = _iterator178.n()).done;) {
        var prop = _step179.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1W.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator178.e(err);
    } finally {
      _iterator178.f();
    }
  }
  return target;
};
var Kbd = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Kbd", {}, props),
    className = _a.className,
    children = _a.children,
    others = __objRest$16(_a, ["className", "children"]);
  var _useStyles$N = useStyles$N(null, {
      name: "Kbd"
    }),
    classes = _useStyles$N.classes,
    cx = _useStyles$N.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1V({
    component: "kbd",
    className: cx(classes.root, className),
    ref: ref
  }, others), children);
});
Kbd.displayName = "@mantine/core/Kbd";
var ListContext = createContext(null);
function useListContext() {
  return useContext(ListContext) || {};
}
var useStyles$O = createStyles(function (theme, _ref119, getRef) {
  var spacing = _ref119.spacing,
    center = _ref119.center;
  var itemWrapper = {
    ref: getRef("itemWrapper"),
    display: "inline"
  };
  return {
    itemWrapper: itemWrapper,
    item: {
      lineHeight: center ? 1 : theme.lineHeight,
      "&:not(:first-of-type)": {
        marginTop: theme.fn.size({
          size: spacing,
          sizes: theme.spacing
        })
      }
    },
    withIcon: _defineProperty({
      listStyle: "none"
    }, "& .".concat(itemWrapper.ref), {
      display: "inline-flex",
      alignItems: center ? "center" : "flex-start"
    }),
    itemIcon: {
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: theme.spacing.sm
    }
  };
});
var __defProp$1W = Object.defineProperty;
var __getOwnPropSymbols$1X = Object.getOwnPropertySymbols;
var __hasOwnProp$1X = Object.prototype.hasOwnProperty;
var __propIsEnum$1X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1W = function __defNormalProp$1W(obj, key, value) {
  return key in obj ? __defProp$1W(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1W = function __spreadValues$1W(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1X.call(b, prop)) __defNormalProp$1W(a, prop, b[prop]);
  if (__getOwnPropSymbols$1X) {
    var _iterator179 = _createForOfIteratorHelper(__getOwnPropSymbols$1X(b)),
      _step180;
    try {
      for (_iterator179.s(); !(_step180 = _iterator179.n()).done;) {
        var prop = _step180.value;
        if (__propIsEnum$1X.call(b, prop)) __defNormalProp$1W(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator179.e(err);
    } finally {
      _iterator179.f();
    }
  }
  return a;
};
var __objRest$17 = function __objRest$17(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1X.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1X) {
    var _iterator180 = _createForOfIteratorHelper(__getOwnPropSymbols$1X(source)),
      _step181;
    try {
      for (_iterator180.s(); !(_step181 = _iterator180.n()).done;) {
        var prop = _step181.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1X.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator180.e(err);
    } finally {
      _iterator180.f();
    }
  }
  return target;
};
function ListItem(_a) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    icon = _b.icon,
    others = __objRest$17(_b, ["className", "children", "icon"]);
  var _useListContext = useListContext(),
    classNames = _useListContext.classNames,
    styles = _useListContext.styles,
    ctxIcon = _useListContext.icon,
    spacing = _useListContext.spacing,
    center = _useListContext.center;
  var _icon = icon || ctxIcon;
  var _useStyles$O = useStyles$O({
      spacing: spacing,
      center: center
    }, {
      classNames: classNames,
      styles: styles,
      name: "List"
    }),
    classes = _useStyles$O.classes,
    cx = _useStyles$O.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1W({
    component: "li",
    className: cx(classes.item, _defineProperty({}, classes.withIcon, _icon), className)
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: classes.itemWrapper
  }, _icon && /* @__PURE__ */React__default.createElement("span", {
    className: classes.itemIcon
  }, _icon), /* @__PURE__ */React__default.createElement("span", null, children)));
}
ListItem.displayName = "@mantine/core/ListItem";
var __defProp$1X = Object.defineProperty;
var __defProps$R = Object.defineProperties;
var __getOwnPropDescs$R = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1Y = Object.getOwnPropertySymbols;
var __hasOwnProp$1Y = Object.prototype.hasOwnProperty;
var __propIsEnum$1Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1X = function __defNormalProp$1X(obj, key, value) {
  return key in obj ? __defProp$1X(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1X = function __spreadValues$1X(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1Y.call(b, prop)) __defNormalProp$1X(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Y) {
    var _iterator181 = _createForOfIteratorHelper(__getOwnPropSymbols$1Y(b)),
      _step182;
    try {
      for (_iterator181.s(); !(_step182 = _iterator181.n()).done;) {
        var prop = _step182.value;
        if (__propIsEnum$1Y.call(b, prop)) __defNormalProp$1X(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator181.e(err);
    } finally {
      _iterator181.f();
    }
  }
  return a;
};
var __spreadProps$R = function __spreadProps$R(a, b) {
  return __defProps$R(a, __getOwnPropDescs$R(b));
};
var useStyles$P = createStyles(function (theme, _ref120) {
  var withPadding = _ref120.withPadding,
    size = _ref120.size,
    listStyleType = _ref120.listStyleType;
  return {
    root: __spreadProps$R(__spreadValues$1X({}, theme.fn.fontStyles()), {
      listStyleType: listStyleType,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      lineHeight: theme.lineHeight,
      margin: 0,
      paddingLeft: withPadding ? theme.spacing.xl : 0,
      listStylePosition: "inside"
    })
  };
});
var __defProp$1Y = Object.defineProperty;
var __getOwnPropSymbols$1Z = Object.getOwnPropertySymbols;
var __hasOwnProp$1Z = Object.prototype.hasOwnProperty;
var __propIsEnum$1Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Y = function __defNormalProp$1Y(obj, key, value) {
  return key in obj ? __defProp$1Y(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1Y = function __spreadValues$1Y(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1Z.call(b, prop)) __defNormalProp$1Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Z) {
    var _iterator182 = _createForOfIteratorHelper(__getOwnPropSymbols$1Z(b)),
      _step183;
    try {
      for (_iterator182.s(); !(_step183 = _iterator182.n()).done;) {
        var prop = _step183.value;
        if (__propIsEnum$1Z.call(b, prop)) __defNormalProp$1Y(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator182.e(err);
    } finally {
      _iterator182.f();
    }
  }
  return a;
};
var __objRest$18 = function __objRest$18(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1Z.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1Z) {
    var _iterator183 = _createForOfIteratorHelper(__getOwnPropSymbols$1Z(source)),
      _step184;
    try {
      for (_iterator183.s(); !(_step184 = _iterator183.n()).done;) {
        var prop = _step184.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1Z.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator183.e(err);
    } finally {
      _iterator183.f();
    }
  }
  return target;
};
var defaultProps$N = {
  type: "unordered",
  size: "md",
  spacing: 0
};
var List = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("List", defaultProps$N, props),
    children = _a.children,
    type = _a.type,
    size = _a.size,
    listStyleType = _a.listStyleType,
    withPadding = _a.withPadding,
    center = _a.center,
    spacing = _a.spacing,
    icon = _a.icon,
    className = _a.className,
    styles = _a.styles,
    classNames = _a.classNames,
    others = __objRest$18(_a, ["children", "type", "size", "listStyleType", "withPadding", "center", "spacing", "icon", "className", "styles", "classNames"]);
  var _useStyles$P = useStyles$P({
      withPadding: withPadding,
      size: size,
      listStyleType: listStyleType
    }, {
      classNames: classNames,
      styles: styles,
      name: "List"
    }),
    classes = _useStyles$P.classes,
    cx = _useStyles$P.cx;
  return /* @__PURE__ */React__default.createElement(ListContext.Provider, {
    value: {
      classNames: classNames,
      styles: styles,
      spacing: spacing,
      center: center,
      icon: icon
    }
  }, /* @__PURE__ */React__default.createElement(Box, __spreadValues$1Y({
    component: type === "unordered" ? "ul" : "ol",
    className: cx(classes.root, className),
    ref: ref
  }, others), children));
});
List.Item = ListItem;
List.displayName = "@mantine/core/List";
var useStyles$Q = createStyles({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden"
  }
});
var __defProp$1Z = Object.defineProperty;
var __defProps$S = Object.defineProperties;
var __getOwnPropDescs$S = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1_ = Object.getOwnPropertySymbols;
var __hasOwnProp$1_ = Object.prototype.hasOwnProperty;
var __propIsEnum$1_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Z = function __defNormalProp$1Z(obj, key, value) {
  return key in obj ? __defProp$1Z(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1Z = function __spreadValues$1Z(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1_.call(b, prop)) __defNormalProp$1Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$1_) {
    var _iterator184 = _createForOfIteratorHelper(__getOwnPropSymbols$1_(b)),
      _step185;
    try {
      for (_iterator184.s(); !(_step185 = _iterator184.n()).done;) {
        var prop = _step185.value;
        if (__propIsEnum$1_.call(b, prop)) __defNormalProp$1Z(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator184.e(err);
    } finally {
      _iterator184.f();
    }
  }
  return a;
};
var __spreadProps$S = function __spreadProps$S(a, b) {
  return __defProps$S(a, __getOwnPropDescs$S(b));
};
var __objRest$19 = function __objRest$19(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1_.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1_) {
    var _iterator185 = _createForOfIteratorHelper(__getOwnPropSymbols$1_(source)),
      _step186;
    try {
      for (_iterator185.s(); !(_step186 = _iterator185.n()).done;) {
        var prop = _step186.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1_.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator185.e(err);
    } finally {
      _iterator185.f();
    }
  }
  return target;
};
var defaultProps$O = {
  overlayOpacity: 0.75,
  transitionDuration: 200,
  zIndex: getDefaultZIndex("overlay")
};
var LoadingOverlay = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("LoadingOverlay", defaultProps$O, props),
    className = _a.className,
    visible = _a.visible,
    loaderProps = _a.loaderProps,
    overlayOpacity = _a.overlayOpacity,
    overlayColor = _a.overlayColor,
    transitionDuration = _a.transitionDuration,
    exitTransitionDuration = _a.exitTransitionDuration,
    zIndex = _a.zIndex,
    style = _a.style,
    loader = _a.loader,
    radius = _a.radius,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$19(_a, ["className", "visible", "loaderProps", "overlayOpacity", "overlayColor", "transitionDuration", "exitTransitionDuration", "zIndex", "style", "loader", "radius", "classNames", "styles"]);
  var _useStyles$Q = useStyles$Q(null, {
      name: "LoadingOverlay",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$Q.classes,
    cx = _useStyles$Q.cx,
    theme = _useStyles$Q.theme;
  return /* @__PURE__ */React__default.createElement(Transition, {
    duration: transitionDuration,
    exitDuration: exitTransitionDuration,
    mounted: visible,
    transition: "fade"
  }, function (transitionStyles) {
    return /* @__PURE__ */React__default.createElement(Box, __spreadValues$1Z({
      className: cx(classes.root, className),
      style: __spreadProps$S(__spreadValues$1Z(__spreadValues$1Z({}, transitionStyles), style), {
        zIndex: zIndex
      }),
      ref: ref
    }, others), loader ? /* @__PURE__ */React__default.createElement("div", {
      style: {
        zIndex: zIndex + 1
      }
    }, loader) : /* @__PURE__ */React__default.createElement(Loader, __spreadValues$1Z({
      style: {
        zIndex: zIndex + 1
      }
    }, loaderProps)), /* @__PURE__ */React__default.createElement(Overlay, {
      opacity: overlayOpacity,
      zIndex: zIndex,
      radius: radius,
      color: overlayColor || (theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.white)
    }));
  });
});
LoadingOverlay.displayName = "@mantine/core/LoadingOverlay";
var __defProp$1_ = Object.defineProperty;
var __getOwnPropSymbols$20 = Object.getOwnPropertySymbols;
var __hasOwnProp$20 = Object.prototype.hasOwnProperty;
var __propIsEnum$20 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1_ = function __defNormalProp$1_(obj, key, value) {
  return key in obj ? __defProp$1_(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1_ = function __spreadValues$1_(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$20.call(b, prop)) __defNormalProp$1_(a, prop, b[prop]);
  if (__getOwnPropSymbols$20) {
    var _iterator186 = _createForOfIteratorHelper(__getOwnPropSymbols$20(b)),
      _step187;
    try {
      for (_iterator186.s(); !(_step187 = _iterator186.n()).done;) {
        var prop = _step187.value;
        if (__propIsEnum$20.call(b, prop)) __defNormalProp$1_(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator186.e(err);
    } finally {
      _iterator186.f();
    }
  }
  return a;
};
function MenuIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$1_({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var _createUseContext3 = createUseContext(null),
  _createUseContext4 = _slicedToArray(_createUseContext3, 2),
  MenuProvider = _createUseContext4[0],
  useMenuContext = _createUseContext4[1];
var __defProp$20 = Object.defineProperty;
var __defProps$T = Object.defineProperties;
var __getOwnPropDescs$T = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$21 = Object.getOwnPropertySymbols;
var __hasOwnProp$21 = Object.prototype.hasOwnProperty;
var __propIsEnum$21 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$20 = function __defNormalProp$20(obj, key, value) {
  return key in obj ? __defProp$20(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$20 = function __spreadValues$20(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$21.call(b, prop)) __defNormalProp$20(a, prop, b[prop]);
  if (__getOwnPropSymbols$21) {
    var _iterator187 = _createForOfIteratorHelper(__getOwnPropSymbols$21(b)),
      _step188;
    try {
      for (_iterator187.s(); !(_step188 = _iterator187.n()).done;) {
        var prop = _step188.value;
        if (__propIsEnum$21.call(b, prop)) __defNormalProp$20(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator187.e(err);
    } finally {
      _iterator187.f();
    }
  }
  return a;
};
var __spreadProps$T = function __spreadProps$T(a, b) {
  return __defProps$T(a, __getOwnPropDescs$T(b));
};
var useStyles$S = createStyles(function (theme, _ref121) {
  var radius = _ref121.radius,
    color = _ref121.color;
  return {
    item: __spreadProps$T(__spreadValues$20({}, theme.fn.fontStyles()), {
      WebkitTapHighlightColor: "transparent",
      fontSize: theme.fontSizes.sm,
      border: 0,
      backgroundColor: "transparent",
      outline: 0,
      width: "100%",
      textAlign: "left",
      display: "inline-block",
      textDecoration: "none",
      boxSizing: "border-box",
      padding: "".concat(theme.spacing.xs, "px ").concat(theme.spacing.sm, "px"),
      cursor: "pointer",
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }),
      color: color ? theme.fn.themeColor(color, theme.colorScheme === "dark" ? 5 : 7) : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      "&:disabled": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5],
        pointerEvents: "none"
      }
    }),
    itemHovered: {
      backgroundColor: color ? theme.fn.variant({
        variant: "light",
        color: color
      }).background : theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[3], 0.35) : theme.colors.gray[0]
    },
    itemInner: {
      display: "flex",
      alignItems: "center",
      height: "100%"
    },
    itemBody: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1
    },
    itemIcon: {
      marginRight: theme.spacing.xs,
      "& *": {
        display: "block"
      }
    },
    itemLabel: {
      lineHeight: 1
    }
  };
});
var __defProp$21 = Object.defineProperty;
var __getOwnPropSymbols$22 = Object.getOwnPropertySymbols;
var __hasOwnProp$22 = Object.prototype.hasOwnProperty;
var __propIsEnum$22 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$21 = function __defNormalProp$21(obj, key, value) {
  return key in obj ? __defProp$21(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$21 = function __spreadValues$21(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$22.call(b, prop)) __defNormalProp$21(a, prop, b[prop]);
  if (__getOwnPropSymbols$22) {
    var _iterator188 = _createForOfIteratorHelper(__getOwnPropSymbols$22(b)),
      _step189;
    try {
      for (_iterator188.s(); !(_step189 = _iterator188.n()).done;) {
        var prop = _step189.value;
        if (__propIsEnum$22.call(b, prop)) __defNormalProp$21(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator188.e(err);
    } finally {
      _iterator188.f();
    }
  }
  return a;
};
var __objRest$1a = function __objRest$1a(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$22.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$22) {
    var _iterator189 = _createForOfIteratorHelper(__getOwnPropSymbols$22(source)),
      _step190;
    try {
      for (_iterator189.s(); !(_step190 = _iterator189.n()).done;) {
        var prop = _step190.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$22.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator189.e(err);
    } finally {
      _iterator189.f();
    }
  }
  return target;
};
var _MenuItem = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    icon = _b.icon,
    color = _b.color,
    disabled = _b.disabled,
    rightSection = _b.rightSection,
    component = _b.component,
    _onClick = _b.onClick,
    others = __objRest$1a(_b, ["className", "children", "icon", "color", "disabled", "rightSection", "component", "onClick"]);
  var itemRef = useRef();
  var _useMenuContext = useMenuContext("Menu.Item"),
    hovered = _useMenuContext.hovered,
    onItemHover = _useMenuContext.onItemHover,
    radius = _useMenuContext.radius,
    onItemKeyDown = _useMenuContext.onItemKeyDown,
    classNames = _useMenuContext.classNames,
    styles = _useMenuContext.styles,
    onItemClick = _useMenuContext.onItemClick;
  var _useStyles$S = useStyles$S({
      color: color,
      radius: radius
    }, {
      classNames: classNames,
      styles: styles,
      name: "Menu"
    }),
    classes = _useStyles$S.classes,
    cx = _useStyles$S.cx;
  var itemIndex = getContextItemIndex({
    elementSelector: ".mantine-Menu-item",
    parentClassName: "mantine-Menu-body"
  }, itemRef.current);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$21({
    component: component || "button",
    type: "button",
    role: "menuitem",
    className: cx(classes.item, _defineProperty({}, classes.itemHovered, hovered === itemIndex), className),
    onMouseEnter: function onMouseEnter() {
      return !disabled && onItemHover(itemIndex);
    },
    onMouseLeave: function onMouseLeave() {
      return onItemHover(-1);
    },
    onKeyDown: onItemKeyDown,
    ref: mergeRefs(ref, itemRef),
    disabled: disabled,
    onClick: function onClick(event) {
      typeof _onClick === "function" && _onClick(event);
      onItemClick();
    }
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: classes.itemInner
  }, icon && /* @__PURE__ */React__default.createElement("div", {
    className: classes.itemIcon
  }, icon), /* @__PURE__ */React__default.createElement("div", {
    className: classes.itemBody
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.itemLabel
  }, children), rightSection)));
});
var MenuItem = _MenuItem;
MenuItem.displayName = "@mantine/core/MenuItem";
var useStyles$T = createStyles(function (theme) {
  return {
    label: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
      fontWeight: 500,
      fontSize: theme.fontSizes.xs,
      padding: "".concat(theme.spacing.xs / 2, "px ").concat(theme.spacing.sm, "px"),
      cursor: "default"
    }
  };
});
var __defProp$22 = Object.defineProperty;
var __getOwnPropSymbols$23 = Object.getOwnPropertySymbols;
var __hasOwnProp$23 = Object.prototype.hasOwnProperty;
var __propIsEnum$23 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$22 = function __defNormalProp$22(obj, key, value) {
  return key in obj ? __defProp$22(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$22 = function __spreadValues$22(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$23.call(b, prop)) __defNormalProp$22(a, prop, b[prop]);
  if (__getOwnPropSymbols$23) {
    var _iterator190 = _createForOfIteratorHelper(__getOwnPropSymbols$23(b)),
      _step191;
    try {
      for (_iterator190.s(); !(_step191 = _iterator190.n()).done;) {
        var prop = _step191.value;
        if (__propIsEnum$23.call(b, prop)) __defNormalProp$22(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator190.e(err);
    } finally {
      _iterator190.f();
    }
  }
  return a;
};
function MenuLabel(props) {
  var _useMenuContext2 = useMenuContext("Menu.Label"),
    classNames = _useMenuContext2.classNames,
    styles = _useMenuContext2.styles;
  var _useStyles$T = useStyles$T(null, {
      name: "Menu",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$T.classes;
  return /* @__PURE__ */React__default.createElement(Text, __spreadValues$22({
    className: classes.label
  }, props));
}
MenuLabel.displayName = "@mantine/core/MenuLabel";
var sizes$c = {
  xs: 120,
  sm: 160,
  md: 200,
  lg: 240,
  xl: 300
};
var MENU_PADDING = 4;
var useStyles$U = createStyles(function (theme, _ref122) {
  var size = _ref122.size;
  return {
    root: {
      display: "inline-block",
      position: "relative"
    },
    arrow: {
      borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2],
      background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
    },
    body: {
      width: theme.fn.size({
        size: size,
        sizes: sizes$c
      }),
      overflow: "hidden",
      pointerEvents: "all",
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      padding: MENU_PADDING,
      "& .mantine-Divider-horizontal": {
        margin: "".concat(theme.spacing.xs / 2, "px -").concat(MENU_PADDING, "px"),
        borderTopColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[2]
      }
    },
    label: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
      fontWeight: 500,
      fontSize: theme.fontSizes.xs,
      padding: "".concat(theme.spacing.xs / 2, "px ").concat(theme.spacing.sm, "px"),
      cursor: "default"
    }
  };
});
var __defProp$23 = Object.defineProperty;
var __defProps$U = Object.defineProperties;
var __getOwnPropDescs$U = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$24 = Object.getOwnPropertySymbols;
var __hasOwnProp$24 = Object.prototype.hasOwnProperty;
var __propIsEnum$24 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$23 = function __defNormalProp$23(obj, key, value) {
  return key in obj ? __defProp$23(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$23 = function __spreadValues$23(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$24.call(b, prop)) __defNormalProp$23(a, prop, b[prop]);
  if (__getOwnPropSymbols$24) {
    var _iterator191 = _createForOfIteratorHelper(__getOwnPropSymbols$24(b)),
      _step192;
    try {
      for (_iterator191.s(); !(_step192 = _iterator191.n()).done;) {
        var prop = _step192.value;
        if (__propIsEnum$24.call(b, prop)) __defNormalProp$23(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator191.e(err);
    } finally {
      _iterator191.f();
    }
  }
  return a;
};
var __spreadProps$U = function __spreadProps$U(a, b) {
  return __defProps$U(a, __getOwnPropDescs$U(b));
};
var __objRest$1b = function __objRest$1b(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$24.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$24) {
    var _iterator192 = _createForOfIteratorHelper(__getOwnPropSymbols$24(source)),
      _step193;
    try {
      for (_iterator192.s(); !(_step193 = _iterator192.n()).done;) {
        var prop = _step193.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$24.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator192.e(err);
    } finally {
      _iterator192.f();
    }
  }
  return target;
};
var defaultControl = /* @__PURE__ */React__default.createElement(ActionIcon, null, /* @__PURE__ */React__default.createElement(MenuIcon, null));
function getNextItem(active, items) {
  for (var _i7 = active + 1; _i7 < items.length; _i7 += 1) {
    if (!items[_i7].disabled) {
      return _i7;
    }
  }
  return active;
}
function findInitialItem(items) {
  for (var _i8 = 0; _i8 < items.length; _i8 += 1) {
    if (!items[_i8].disabled) {
      return _i8;
    }
  }
  return -1;
}
function getPreviousItem(active, items) {
  for (var _i9 = active - 1; _i9 >= 0; _i9 -= 1) {
    if (!items[_i9].disabled) {
      return _i9;
    }
  }
  if (!items[active]) {
    return findInitialItem(items);
  }
  return active;
}
var defaultProps$P = {
  control: defaultControl,
  closeOnItemClick: true,
  transitionDuration: 150,
  size: "md",
  shadow: "md",
  position: "bottom",
  placement: "start",
  gutter: 5,
  withArrow: false,
  transition: "pop-top-left",
  controlRefProp: "ref",
  trigger: "click",
  radius: "sm",
  delay: 100,
  zIndex: getDefaultZIndex("popover"),
  withinPortal: true,
  trapFocus: true,
  closeOnScroll: false,
  clickOutsideEvents: ["mousedown", "touchstart"]
};
var Menu = forwardRef(function (props, ref) {
  var _spreadProps$U;
  var _a = useMantineDefaultProps("Menu", defaultProps$P, props),
    control = _a.control,
    children = _a.children,
    onClose = _a.onClose,
    onOpen = _a.onOpen,
    opened = _a.opened,
    menuId = _a.menuId,
    closeOnItemClick = _a.closeOnItemClick,
    transitionDuration = _a.transitionDuration,
    size = _a.size,
    shadow = _a.shadow,
    position = _a.position,
    placement = _a.placement,
    gutter = _a.gutter,
    withArrow = _a.withArrow,
    transition = _a.transition,
    transitionTimingFunction = _a.transitionTimingFunction,
    menuButtonLabel = _a.menuButtonLabel,
    controlRefProp = _a.controlRefProp,
    trigger = _a.trigger,
    radius = _a.radius,
    delay = _a.delay,
    zIndex = _a.zIndex,
    withinPortal = _a.withinPortal,
    trapFocus = _a.trapFocus,
    classNames = _a.classNames,
    styles = _a.styles,
    closeOnScroll = _a.closeOnScroll,
    onMouseLeave = _a.onMouseLeave,
    onMouseEnter = _a.onMouseEnter,
    onChange = _a.onChange,
    className = _a.className,
    sx = _a.sx,
    clickOutsideEvents = _a.clickOutsideEvents,
    others = __objRest$1b(_a, ["control", "children", "onClose", "onOpen", "opened", "menuId", "closeOnItemClick", "transitionDuration", "size", "shadow", "position", "placement", "gutter", "withArrow", "transition", "transitionTimingFunction", "menuButtonLabel", "controlRefProp", "trigger", "radius", "delay", "zIndex", "withinPortal", "trapFocus", "classNames", "styles", "closeOnScroll", "onMouseLeave", "onMouseEnter", "onChange", "className", "sx", "clickOutsideEvents"]);
  var _useState99 = useState(-1),
    _useState100 = _slicedToArray(_useState99, 2),
    hovered = _useState100[0],
    setHovered = _useState100[1];
  var _useStyles$U = useStyles$U({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "Menu"
    }),
    classes = _useStyles$U.classes,
    cx = _useStyles$U.cx;
  var delayTimeout = useRef();
  var _useState101 = useState(null),
    _useState102 = _slicedToArray(_useState101, 2),
    referenceElement = _useState102[0],
    setReferenceElement = _useState102[1];
  var _useState103 = useState(null),
    _useState104 = _slicedToArray(_useState103, 2),
    wrapperElement = _useState104[0],
    setWrapperElement = _useState104[1];
  var _useState105 = useState(null),
    _useState106 = _slicedToArray(_useState105, 2),
    dropdownElement = _useState106[0],
    setDropdownElement = _useState106[1];
  var uuid = useUuid(menuId);
  var focusReference = function focusReference() {
    return window.setTimeout(function () {
      return referenceElement == null ? void 0 : referenceElement.focus();
    }, 0);
  };
  var _useUncontrolled17 = useUncontrolled({
      value: opened,
      defaultValue: false,
      finalValue: false,
      rule: function rule(val) {
        return typeof val === "boolean";
      },
      onChange: function onChange(value) {
        return value ? typeof onOpen === "function" && onOpen() : typeof onClose === "function" && onClose();
      }
    }),
    _useUncontrolled18 = _slicedToArray(_useUncontrolled17, 2),
    _opened = _useUncontrolled18[0],
    setOpened = _useUncontrolled18[1];
  var openedRef = useRef(_opened);
  var handleClose = function handleClose() {
    if (openedRef.current) {
      openedRef.current = false;
      setOpened(false);
    }
  };
  var handleOpen = function handleOpen() {
    openedRef.current = true;
    setOpened(true);
  };
  useWindowEvent("scroll", function () {
    return closeOnScroll && handleClose();
  });
  useClickOutside(function () {
    return _opened && handleClose();
  }, clickOutsideEvents, [dropdownElement, wrapperElement]);
  var toggleMenu = function toggleMenu() {
    _opened ? handleClose() : handleOpen();
  };
  var controlEventHandlers = trigger === "click" ? {
    onClick: toggleMenu
  } : {
    onMouseEnter: handleOpen,
    onClick: toggleMenu
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    typeof onMouseLeave === "function" && onMouseLeave(event);
    if (trigger === "hover") {
      if (delay > 0) {
        delayTimeout.current = window.setTimeout(function () {
          return handleClose();
        }, delay);
      } else {
        handleClose();
      }
    }
  };
  var handleMouseEnter = function handleMouseEnter(event) {
    typeof onMouseEnter === "function" && onMouseEnter(event);
    window.clearTimeout(delayTimeout.current);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (_opened) {
      var elements = Array.from(dropdownElement.querySelectorAll(".mantine-Menu-item"));
      if (event.nativeEvent.code === "Tab" && trapFocus) {
        event.preventDefault();
      }
      if (event.nativeEvent.code === "ArrowDown") {
        event.preventDefault();
        var prevIndex = getNextItem(hovered, elements);
        setHovered(prevIndex);
        elements[prevIndex].focus();
      }
      if (event.nativeEvent.code === "ArrowUp") {
        event.preventDefault();
        var _prevIndex = getPreviousItem(hovered, elements);
        setHovered(_prevIndex);
        elements[_prevIndex].focus();
      }
      if (event.nativeEvent.code === "Escape") {
        handleClose();
        focusReference();
      }
    }
  };
  var menuControl = cloneElement(control, __spreadProps$U(__spreadValues$23({}, controlEventHandlers), (_spreadProps$U = {
    onClick: function onClick(event) {
      controlEventHandlers.onClick();
      typeof control.props.onClick === "function" && control.props.onClick(event);
    },
    role: "button",
    "aria-haspopup": "menu",
    "aria-expanded": _opened,
    "aria-controls": uuid,
    "aria-label": menuButtonLabel,
    title: menuButtonLabel
  }, _defineProperty(_spreadProps$U, controlRefProp, useMergedRef(setReferenceElement, ref)), _defineProperty(_spreadProps$U, "onKeyDown", handleKeyDown), _spreadProps$U)));
  var handleItemClick = function handleItemClick() {
    if (closeOnItemClick) {
      handleClose();
      trigger === "click" && focusReference();
    }
  };
  return /* @__PURE__ */React__default.createElement(MenuProvider, {
    value: {
      hovered: hovered,
      radius: radius,
      styles: styles,
      classNames: classNames,
      onItemHover: setHovered,
      onItemKeyDown: handleKeyDown,
      onItemClick: handleItemClick
    }
  }, /* @__PURE__ */React__default.createElement(Box, __spreadValues$23({
    ref: setWrapperElement,
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    className: cx(classes.root, className),
    sx: sx
  }, others), menuControl, /* @__PURE__ */React__default.createElement(Popper$1, {
    referenceElement: referenceElement,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    transition: transition,
    mounted: _opened,
    position: position,
    placement: placement,
    gutter: gutter,
    withArrow: withArrow,
    arrowSize: 3,
    zIndex: zIndex,
    arrowClassName: classes.arrow,
    withinPortal: withinPortal
  }, /* @__PURE__ */React__default.createElement(Paper, __spreadValues$23({
    shadow: shadow,
    className: classes.body,
    role: "menu",
    "aria-orientation": "vertical",
    radius: radius,
    onMouseLeave: function onMouseLeave() {
      return setHovered(-1);
    },
    ref: setDropdownElement,
    id: uuid
  }, others), children))));
});
Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.displayName = "@mantine/core/Menu";
var sizes$d = {
  xs: 320,
  sm: 380,
  md: 440,
  lg: 620,
  xl: 780,
  full: "100%"
};
var useStyles$V = createStyles(function (theme, _ref123) {
  var overflow = _ref123.overflow,
    size = _ref123.size,
    centered = _ref123.centered,
    zIndex = _ref123.zIndex;
  return {
    close: {},
    overlay: {},
    root: {
      position: "fixed",
      zIndex: zIndex,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    inner: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflowY: "auto",
      padding: "".concat(theme.spacing.xl * 2, "px ").concat(theme.spacing.md, "px"),
      display: "flex",
      justifyContent: "center",
      alignItems: centered ? "center" : "flex-start"
    },
    title: {
      marginRight: theme.spacing.md,
      textOverflow: "ellipsis",
      display: "block",
      wordBreak: "break-word"
    },
    modal: {
      position: "relative",
      width: theme.fn.size({
        sizes: sizes$d,
        size: size
      }),
      outline: 0,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      marginTop: centered ? "auto" : void 0,
      marginBottom: centered ? "auto" : void 0,
      zIndex: 1,
      marginLeft: "calc(var(--removed-scroll-width, 0px) * -1)"
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: theme.spacing.md,
      marginRight: -9
    },
    body: {
      maxHeight: overflow === "inside" ? "calc(100vh - 185px)" : null,
      overflowY: overflow === "inside" ? "auto" : null,
      wordBreak: "break-word"
    }
  };
});
var __defProp$24 = Object.defineProperty;
var __getOwnPropSymbols$25 = Object.getOwnPropertySymbols;
var __hasOwnProp$25 = Object.prototype.hasOwnProperty;
var __propIsEnum$25 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$24 = function __defNormalProp$24(obj, key, value) {
  return key in obj ? __defProp$24(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$24 = function __spreadValues$24(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$25.call(b, prop)) __defNormalProp$24(a, prop, b[prop]);
  if (__getOwnPropSymbols$25) {
    var _iterator193 = _createForOfIteratorHelper(__getOwnPropSymbols$25(b)),
      _step194;
    try {
      for (_iterator193.s(); !(_step194 = _iterator193.n()).done;) {
        var prop = _step194.value;
        if (__propIsEnum$25.call(b, prop)) __defNormalProp$24(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator193.e(err);
    } finally {
      _iterator193.f();
    }
  }
  return a;
};
var __objRest$1c = function __objRest$1c(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$25.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$25) {
    var _iterator194 = _createForOfIteratorHelper(__getOwnPropSymbols$25(source)),
      _step195;
    try {
      for (_iterator194.s(); !(_step195 = _iterator194.n()).done;) {
        var prop = _step195.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$25.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator194.e(err);
    } finally {
      _iterator194.f();
    }
  }
  return target;
};
var defaultProps$Q = {
  size: "md",
  transitionDuration: 250,
  overflow: "outside",
  transition: "pop",
  padding: "lg",
  shadow: "lg",
  closeOnClickOutside: true,
  closeOnEscape: true,
  trapFocus: true,
  withCloseButton: true,
  withinPortal: true,
  overlayBlur: 0,
  zIndex: getDefaultZIndex("modal")
};
function Modal(props) {
  var _a = useMantineDefaultProps("Modal", defaultProps$Q, props),
    className = _a.className,
    opened = _a.opened,
    title = _a.title,
    onClose = _a.onClose,
    children = _a.children,
    withCloseButton = _a.withCloseButton,
    overlayOpacity = _a.overlayOpacity,
    size = _a.size,
    transitionDuration = _a.transitionDuration,
    closeButtonLabel = _a.closeButtonLabel,
    overlayColor = _a.overlayColor,
    overflow = _a.overflow,
    transition = _a.transition,
    padding = _a.padding,
    shadow = _a.shadow,
    radius = _a.radius,
    id = _a.id,
    classNames = _a.classNames,
    styles = _a.styles,
    closeOnClickOutside = _a.closeOnClickOutside,
    trapFocus = _a.trapFocus,
    closeOnEscape = _a.closeOnEscape,
    centered = _a.centered,
    target = _a.target,
    withinPortal = _a.withinPortal,
    zIndex = _a.zIndex,
    overlayBlur = _a.overlayBlur,
    transitionTimingFunction = _a.transitionTimingFunction,
    others = __objRest$1c(_a, ["className", "opened", "title", "onClose", "children", "withCloseButton", "overlayOpacity", "size", "transitionDuration", "closeButtonLabel", "overlayColor", "overflow", "transition", "padding", "shadow", "radius", "id", "classNames", "styles", "closeOnClickOutside", "trapFocus", "closeOnEscape", "centered", "target", "withinPortal", "zIndex", "overlayBlur", "transitionTimingFunction"]);
  var baseId = useUuid(id);
  var titleId = "".concat(baseId, "-title");
  var bodyId = "".concat(baseId, "-body");
  var _useStyles$V = useStyles$V({
      size: size,
      overflow: overflow,
      centered: centered,
      zIndex: zIndex
    }, {
      classNames: classNames,
      styles: styles,
      name: "Modal"
    }),
    classes = _useStyles$V.classes,
    cx = _useStyles$V.cx,
    theme = _useStyles$V.theme;
  var focusTrapRef = useFocusTrap(trapFocus && opened);
  var _overlayOpacity = typeof overlayOpacity === "number" ? overlayOpacity : theme.colorScheme === "dark" ? 0.85 : 0.75;
  var _useScrollLock = useScrollLock(),
    _useScrollLock2 = _slicedToArray(_useScrollLock, 2),
    lockScroll = _useScrollLock2[1];
  var closeOnEscapePress = function closeOnEscapePress(event) {
    if (!trapFocus && event.code === "Escape" && closeOnEscape) {
      onClose();
    }
  };
  useEffect(function () {
    if (!trapFocus) {
      window.addEventListener("keydown", closeOnEscapePress);
      return function () {
        return window.removeEventListener("keydown", closeOnEscapePress);
      };
    }
    return void 0;
  }, [trapFocus]);
  useFocusReturn({
    opened: opened,
    transitionDuration: 0,
    shouldReturnFocus: trapFocus
  });
  return /* @__PURE__ */React__default.createElement(OptionalPortal, {
    withinPortal: withinPortal,
    zIndex: zIndex,
    target: target
  }, /* @__PURE__ */React__default.createElement(GroupedTransition, {
    onExited: function onExited() {
      return lockScroll(false);
    },
    onEntered: function onEntered() {
      return lockScroll(true);
    },
    mounted: opened,
    duration: transitionDuration,
    exitDuration: transitionDuration,
    timingFunction: transitionTimingFunction,
    transitions: {
      modal: {
        duration: transitionDuration,
        transition: transition
      },
      overlay: {
        duration: transitionDuration / 2,
        transition: "fade",
        timingFunction: "ease"
      }
    }
  }, function (transitionStyles) {
    return /* @__PURE__ */React__default.createElement(Box, __spreadValues$24({
      id: baseId,
      className: cx(classes.root, className)
    }, others), /* @__PURE__ */React__default.createElement("div", {
      className: classes.inner,
      onKeyDownCapture: function onKeyDownCapture(event) {
        var _a2;
        var shouldTrigger = ((_a2 = event.target) == null ? void 0 : _a2.getAttribute("data-mantine-stop-propagation")) !== "true";
        shouldTrigger && event.nativeEvent.code === "Escape" && closeOnEscape && onClose();
      },
      ref: focusTrapRef
    }, /* @__PURE__ */React__default.createElement(Paper, {
      className: classes.modal,
      shadow: shadow,
      p: padding,
      radius: radius,
      role: "dialog",
      "aria-labelledby": titleId,
      "aria-describedby": bodyId,
      "aria-modal": true,
      tabIndex: -1,
      style: transitionStyles.modal
    }, (title || withCloseButton) && /* @__PURE__ */React__default.createElement("div", {
      className: classes.header
    }, /* @__PURE__ */React__default.createElement(Text, {
      id: titleId,
      className: classes.title
    }, title), withCloseButton && /* @__PURE__ */React__default.createElement(CloseButton, {
      iconSize: 16,
      onClick: onClose,
      "aria-label": closeButtonLabel,
      className: classes.close
    })), /* @__PURE__ */React__default.createElement("div", {
      id: bodyId,
      className: classes.body
    }, children)), /* @__PURE__ */React__default.createElement("div", {
      style: transitionStyles.overlay
    }, /* @__PURE__ */React__default.createElement(Overlay, {
      className: classes.overlay,
      sx: {
        position: "fixed"
      },
      zIndex: 0,
      onMouseDown: function onMouseDown() {
        return closeOnClickOutside && onClose();
      },
      blur: overlayBlur,
      color: overlayColor || (theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.black),
      opacity: _overlayOpacity
    }))));
  }));
}
Modal.displayName = "@mantine/core/Modal";
var sizes$e = {
  xs: 16,
  sm: 22,
  md: 26,
  lg: 30,
  xl: 36
};
var fontSizes = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18
};
var useStyles$W = createStyles(function (theme, _ref124) {
  var size = _ref124.size,
    disabled = _ref124.disabled,
    radius = _ref124.radius;
  return {
    defaultValue: {
      display: "flex",
      alignItems: "center",
      backgroundColor: disabled ? theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[3] : theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[1],
      color: disabled ? theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7] : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
      height: theme.fn.size({
        size: size,
        sizes: sizes$e
      }),
      paddingLeft: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }),
      paddingRight: disabled ? theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) : 0,
      fontWeight: 500,
      fontSize: theme.fn.size({
        size: size,
        sizes: fontSizes
      }),
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }),
      cursor: disabled ? "not-allowed" : "default",
      userSelect: "none",
      maxWidth: "calc(100% - 20px)"
    },
    defaultValueRemove: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
      marginLeft: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 6
    },
    defaultValueLabel: {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  };
});
var __defProp$25 = Object.defineProperty;
var __getOwnPropSymbols$26 = Object.getOwnPropertySymbols;
var __hasOwnProp$26 = Object.prototype.hasOwnProperty;
var __propIsEnum$26 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$25 = function __defNormalProp$25(obj, key, value) {
  return key in obj ? __defProp$25(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$25 = function __spreadValues$25(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$26.call(b, prop)) __defNormalProp$25(a, prop, b[prop]);
  if (__getOwnPropSymbols$26) {
    var _iterator195 = _createForOfIteratorHelper(__getOwnPropSymbols$26(b)),
      _step196;
    try {
      for (_iterator195.s(); !(_step196 = _iterator195.n()).done;) {
        var prop = _step196.value;
        if (__propIsEnum$26.call(b, prop)) __defNormalProp$25(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator195.e(err);
    } finally {
      _iterator195.f();
    }
  }
  return a;
};
var __objRest$1d = function __objRest$1d(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$26.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$26) {
    var _iterator196 = _createForOfIteratorHelper(__getOwnPropSymbols$26(source)),
      _step197;
    try {
      for (_iterator196.s(); !(_step197 = _iterator196.n()).done;) {
        var prop = _step197.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$26.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator196.e(err);
    } finally {
      _iterator196.f();
    }
  }
  return target;
};
var buttonSizes = {
  xs: 16,
  sm: 22,
  md: 24,
  lg: 26,
  xl: 30
};
function DefaultValue(_a) {
  var _b = _a,
    label = _b.label,
    classNames = _b.classNames,
    styles = _b.styles,
    className = _b.className,
    onRemove = _b.onRemove,
    disabled = _b.disabled,
    size = _b.size,
    radius = _b.radius,
    others = __objRest$1d(_b, ["label", "classNames", "styles", "className", "onRemove", "disabled", "size", "radius"]);
  var _useStyles$W = useStyles$W({
      size: size,
      disabled: disabled,
      radius: radius
    }, {
      classNames: classNames,
      styles: styles,
      name: "MultiSelect"
    }),
    classes = _useStyles$W.classes,
    cx = _useStyles$W.cx;
  return /* @__PURE__ */React__default.createElement("div", __spreadValues$25({
    className: cx(classes.defaultValue, className)
  }, others), /* @__PURE__ */React__default.createElement("span", {
    className: classes.defaultValueLabel
  }, label), !disabled && /* @__PURE__ */React__default.createElement(CloseButton, {
    "aria-hidden": true,
    onMouseDown: onRemove,
    size: buttonSizes[size],
    radius: 2,
    color: "blue",
    variant: "transparent",
    iconSize: buttonSizes[size] / 2,
    className: classes.defaultValueRemove,
    tabIndex: -1
  }));
}
DefaultValue.displayName = "@mantine/core/MultiSelect/DefaultValue";
function filterData$1(_ref125) {
  var data = _ref125.data,
    searchable = _ref125.searchable,
    limit = _ref125.limit,
    searchValue = _ref125.searchValue,
    filter = _ref125.filter,
    value = _ref125.value;
  if (!searchable && value.length === 0) {
    return data;
  }
  if (!searchable) {
    var result2 = [];
    var _loop3 = function _loop3(i) {
      if (!value.some(function (val) {
        return val === data[i].value && !data[i].disabled;
      })) {
        result2.push(data[i]);
      }
    };
    for (var _i10 = 0; _i10 < data.length; _i10 += 1) {
      _loop3(_i10);
    }
    return result2;
  }
  var result = [];
  var _loop4 = function _loop4(i) {
    if (filter(searchValue, value.some(function (val) {
      return val === data[i].value && !data[i].disabled;
    }), data[i])) {
      result.push(data[i]);
    }
    if (result.length >= limit) {
      return "break";
    }
  };
  for (var _i11 = 0; _i11 < data.length; _i11 += 1) {
    var _ret2 = _loop4(_i11);
    if (_ret2 === "break") break;
  }
  return result;
}
var __defProp$26 = Object.defineProperty;
var __getOwnPropSymbols$27 = Object.getOwnPropertySymbols;
var __hasOwnProp$27 = Object.prototype.hasOwnProperty;
var __propIsEnum$27 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$26 = function __defNormalProp$26(obj, key, value) {
  return key in obj ? __defProp$26(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$26 = function __spreadValues$26(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$27.call(b, prop)) __defNormalProp$26(a, prop, b[prop]);
  if (__getOwnPropSymbols$27) {
    var _iterator197 = _createForOfIteratorHelper(__getOwnPropSymbols$27(b)),
      _step198;
    try {
      for (_iterator197.s(); !(_step198 = _iterator197.n()).done;) {
        var prop = _step198.value;
        if (__propIsEnum$27.call(b, prop)) __defNormalProp$26(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator197.e(err);
    } finally {
      _iterator197.f();
    }
  }
  return a;
};
var __objRest$1e = function __objRest$1e(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$27.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$27) {
    var _iterator198 = _createForOfIteratorHelper(__getOwnPropSymbols$27(source)),
      _step199;
    try {
      for (_iterator198.s(); !(_step199 = _iterator198.n()).done;) {
        var prop = _step199.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$27.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator198.e(err);
    } finally {
      _iterator198.f();
    }
  }
  return target;
};
var iconSizes$3 = {
  xs: 14,
  sm: 18,
  md: 20,
  lg: 24,
  xl: 28
};
function ChevronIcon$1(_a) {
  var _b = _a,
    size = _b.size,
    error = _b.error,
    style = _b.style,
    others = __objRest$1e(_b, ["size", "error", "style"]);
  var theme = useMantineTheme();
  var _size = theme.fn.size({
    size: size,
    sizes: iconSizes$3
  });
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$26({
    width: _size,
    height: _size,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: __spreadValues$26({
      color: error ? theme.colors.red[6] : theme.colors.gray[6]
    }, style),
    "data-chevron": true
  }, others), /* @__PURE__ */React__default.createElement("path", {
    d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
function SelectRightSection(_ref126) {
  var shouldClear = _ref126.shouldClear,
    clearButtonLabel = _ref126.clearButtonLabel,
    onClear = _ref126.onClear,
    size = _ref126.size,
    error = _ref126.error,
    clearButtonTabIndex = _ref126.clearButtonTabIndex;
  return shouldClear ? /* @__PURE__ */React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: onClear,
    size: size,
    tabIndex: clearButtonTabIndex
  }) : /* @__PURE__ */React__default.createElement(ChevronIcon$1, {
    error: error,
    size: size
  });
}
SelectRightSection.displayName = "@mantine/core/SelectRightSection";
var __defProp$27 = Object.defineProperty;
var __defProps$V = Object.defineProperties;
var __getOwnPropDescs$V = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$28 = Object.getOwnPropertySymbols;
var __hasOwnProp$28 = Object.prototype.hasOwnProperty;
var __propIsEnum$28 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$27 = function __defNormalProp$27(obj, key, value) {
  return key in obj ? __defProp$27(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$27 = function __spreadValues$27(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$28.call(b, prop)) __defNormalProp$27(a, prop, b[prop]);
  if (__getOwnPropSymbols$28) {
    var _iterator199 = _createForOfIteratorHelper(__getOwnPropSymbols$28(b)),
      _step200;
    try {
      for (_iterator199.s(); !(_step200 = _iterator199.n()).done;) {
        var prop = _step200.value;
        if (__propIsEnum$28.call(b, prop)) __defNormalProp$27(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator199.e(err);
    } finally {
      _iterator199.f();
    }
  }
  return a;
};
var __spreadProps$V = function __spreadProps$V(a, b) {
  return __defProps$V(a, __getOwnPropDescs$V(b));
};
var __objRest$1f = function __objRest$1f(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$28.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$28) {
    var _iterator200 = _createForOfIteratorHelper(__getOwnPropSymbols$28(source)),
      _step201;
    try {
      for (_iterator200.s(); !(_step201 = _iterator200.n()).done;) {
        var prop = _step201.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$28.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator200.e(err);
    } finally {
      _iterator200.f();
    }
  }
  return target;
};
var RIGHT_SECTION_WIDTH = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 44,
  xl: 54
};
function getSelectRightSectionProps(_a) {
  var _b = _a,
    styles = _b.styles,
    rightSection = _b.rightSection,
    rightSectionWidth = _b.rightSectionWidth,
    theme = _b.theme,
    props = __objRest$1f(_b, ["styles", "rightSection", "rightSectionWidth", "theme"]);
  if (rightSection) {
    return {
      rightSection: rightSection,
      rightSectionWidth: rightSectionWidth,
      styles: styles
    };
  }
  var _styles = typeof styles === "function" ? styles(theme) : styles;
  return {
    rightSectionWidth: theme.fn.size({
      size: props.size,
      sizes: RIGHT_SECTION_WIDTH
    }),
    rightSection: !(props.disabled && props.shouldClear) && /* @__PURE__ */React__default.createElement(SelectRightSection, __spreadValues$27({}, props)),
    styles: __spreadProps$V(__spreadValues$27({}, _styles), {
      rightSection: __spreadProps$V(__spreadValues$27({}, _styles == null ? void 0 : _styles.rightSection), {
        pointerEvents: props.shouldClear ? void 0 : "none"
      })
    })
  };
}
var useStyles$X = createStyles(function (theme, _ref127) {
  var size = _ref127.size,
    invalid = _ref127.invalid;
  return {
    wrapper: {
      position: "relative"
    },
    values: {
      minHeight: theme.fn.size({
        size: size,
        sizes: sizes$2
      }) - 2,
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      marginLeft: -theme.spacing.xs / 2,
      paddingTop: theme.spacing.xs / 2 - 2,
      paddingBottom: theme.spacing.xs / 2 - 2,
      boxSizing: "border-box"
    },
    value: {
      margin: "".concat(theme.spacing.xs / 2 - 2, "px ").concat(theme.spacing.xs / 2, "px")
    },
    searchInput: {
      flex: 1,
      minWidth: 60,
      backgroundColor: "transparent",
      border: 0,
      outline: 0,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      padding: 0,
      margin: theme.spacing.xs / 2,
      appearance: "none",
      color: "inherit",
      "&::placeholder": {
        color: invalid ? theme.colors.red[theme.colorScheme === "dark" ? 6 : 7] : theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
      },
      "&:disabled": {
        cursor: "not-allowed"
      }
    },
    searchInputEmpty: {
      width: "100%"
    },
    searchInputInputHidden: {
      width: 0,
      height: 0,
      margin: 0,
      overflow: "hidden"
    },
    searchInputPointer: {
      cursor: "pointer",
      "&:disabled": {
        cursor: "not-allowed"
      }
    },
    input: {
      cursor: "pointer",
      "&:disabled": {
        cursor: "not-allowed"
      }
    }
  };
});
var __defProp$28 = Object.defineProperty;
var __defProps$W = Object.defineProperties;
var __getOwnPropDescs$W = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$29 = Object.getOwnPropertySymbols;
var __hasOwnProp$29 = Object.prototype.hasOwnProperty;
var __propIsEnum$29 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$28 = function __defNormalProp$28(obj, key, value) {
  return key in obj ? __defProp$28(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$28 = function __spreadValues$28(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$29.call(b, prop)) __defNormalProp$28(a, prop, b[prop]);
  if (__getOwnPropSymbols$29) {
    var _iterator201 = _createForOfIteratorHelper(__getOwnPropSymbols$29(b)),
      _step202;
    try {
      for (_iterator201.s(); !(_step202 = _iterator201.n()).done;) {
        var prop = _step202.value;
        if (__propIsEnum$29.call(b, prop)) __defNormalProp$28(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator201.e(err);
    } finally {
      _iterator201.f();
    }
  }
  return a;
};
var __spreadProps$W = function __spreadProps$W(a, b) {
  return __defProps$W(a, __getOwnPropDescs$W(b));
};
var __objRest$1g = function __objRest$1g(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$29.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$29) {
    var _iterator202 = _createForOfIteratorHelper(__getOwnPropSymbols$29(source)),
      _step203;
    try {
      for (_iterator202.s(); !(_step203 = _iterator202.n()).done;) {
        var prop = _step203.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$29.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator202.e(err);
    } finally {
      _iterator202.f();
    }
  }
  return target;
};
function defaultFilter$1(value, selected, item) {
  if (selected) {
    return false;
  }
  return item.label.toLowerCase().trim().includes(value.toLowerCase().trim());
}
function defaultShouldCreate(query, data) {
  return !!query && !data.some(function (item) {
    return item.value.toLowerCase() === query.toLowerCase();
  });
}
var defaultProps$R = {
  size: "sm",
  valueComponent: DefaultValue,
  itemComponent: DefaultItem,
  transition: "pop-top-left",
  transitionDuration: 0,
  maxDropdownHeight: 220,
  shadow: "sm",
  searchable: false,
  filter: defaultFilter$1,
  limit: Infinity,
  clearSearchOnChange: true,
  clearable: false,
  clearSearchOnBlur: false,
  disabled: false,
  initiallyOpened: false,
  creatable: false,
  shouldCreate: defaultShouldCreate,
  switchDirectionOnFlip: false,
  zIndex: getDefaultZIndex("popover"),
  selectOnBlur: false,
  clearButtonTabIndex: 0,
  positionDependencies: []
};
var MultiSelect = forwardRef(function (props, ref) {
  var _cx7;
  var _a = useMantineDefaultProps("MultiSelect", defaultProps$R, props),
    className = _a.className,
    style = _a.style,
    required = _a.required,
    label = _a.label,
    description = _a.description,
    size = _a.size,
    error = _a.error,
    classNames = _a.classNames,
    styles = _a.styles,
    wrapperProps = _a.wrapperProps,
    value = _a.value,
    defaultValue = _a.defaultValue,
    data = _a.data,
    onChange = _a.onChange,
    Value = _a.valueComponent,
    itemComponent = _a.itemComponent,
    id = _a.id,
    transition = _a.transition,
    transitionDuration = _a.transitionDuration,
    transitionTimingFunction = _a.transitionTimingFunction,
    maxDropdownHeight = _a.maxDropdownHeight,
    shadow = _a.shadow,
    nothingFound = _a.nothingFound,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    searchable = _a.searchable,
    placeholder = _a.placeholder,
    filter = _a.filter,
    limit = _a.limit,
    clearSearchOnChange = _a.clearSearchOnChange,
    clearable = _a.clearable,
    clearSearchOnBlur = _a.clearSearchOnBlur,
    clearButtonLabel = _a.clearButtonLabel,
    variant = _a.variant,
    onSearchChange = _a.onSearchChange,
    disabled = _a.disabled,
    initiallyOpened = _a.initiallyOpened,
    radius = _a.radius,
    icon = _a.icon,
    rightSection = _a.rightSection,
    rightSectionWidth = _a.rightSectionWidth,
    creatable = _a.creatable,
    getCreateLabel = _a.getCreateLabel,
    shouldCreate = _a.shouldCreate,
    onCreate = _a.onCreate,
    sx = _a.sx,
    dropdownComponent = _a.dropdownComponent,
    onDropdownClose = _a.onDropdownClose,
    onDropdownOpen = _a.onDropdownOpen,
    maxSelectedValues = _a.maxSelectedValues,
    withinPortal = _a.withinPortal,
    switchDirectionOnFlip = _a.switchDirectionOnFlip,
    zIndex = _a.zIndex,
    selectOnBlur = _a.selectOnBlur,
    name = _a.name,
    dropdownPosition = _a.dropdownPosition,
    errorProps = _a.errorProps,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    clearButtonTabIndex = _a.clearButtonTabIndex,
    form = _a.form,
    positionDependencies = _a.positionDependencies,
    onKeyDown = _a.onKeyDown,
    others = __objRest$1g(_a, ["className", "style", "required", "label", "description", "size", "error", "classNames", "styles", "wrapperProps", "value", "defaultValue", "data", "onChange", "valueComponent", "itemComponent", "id", "transition", "transitionDuration", "transitionTimingFunction", "maxDropdownHeight", "shadow", "nothingFound", "onFocus", "onBlur", "searchable", "placeholder", "filter", "limit", "clearSearchOnChange", "clearable", "clearSearchOnBlur", "clearButtonLabel", "variant", "onSearchChange", "disabled", "initiallyOpened", "radius", "icon", "rightSection", "rightSectionWidth", "creatable", "getCreateLabel", "shouldCreate", "onCreate", "sx", "dropdownComponent", "onDropdownClose", "onDropdownOpen", "maxSelectedValues", "withinPortal", "switchDirectionOnFlip", "zIndex", "selectOnBlur", "name", "dropdownPosition", "errorProps", "labelProps", "descriptionProps", "clearButtonTabIndex", "form", "positionDependencies", "onKeyDown"]);
  var _useStyles$X = useStyles$X({
      size: size,
      invalid: !!error
    }, {
      classNames: classNames,
      styles: styles,
      name: "MultiSelect"
    }),
    classes = _useStyles$X.classes,
    cx = _useStyles$X.cx,
    theme = _useStyles$X.theme;
  var _extractSystemStyles9 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles9.systemStyles,
    rest = _extractSystemStyles9.rest;
  var dropdownRef = useRef();
  var inputRef = useRef();
  var wrapperRef = useRef();
  var itemsRefs = useRef({});
  var uuid = useUuid(id);
  var _useState107 = useState(initiallyOpened),
    _useState108 = _slicedToArray(_useState107, 2),
    dropdownOpened = _useState108[0],
    _setDropdownOpened = _useState108[1];
  var _useState109 = useState(-1),
    _useState110 = _slicedToArray(_useState109, 2),
    hovered = _useState110[0],
    setHovered = _useState110[1];
  var _useState111 = useState("column"),
    _useState112 = _slicedToArray(_useState111, 2),
    direction = _useState112[0],
    setDirection = _useState112[1];
  var _useState113 = useState(""),
    _useState114 = _slicedToArray(_useState113, 2),
    searchValue = _useState114[0],
    setSearchValue = _useState114[1];
  var _useState115 = useState(false),
    _useState116 = _slicedToArray(_useState115, 2),
    IMEOpen = _useState116[0],
    setIMEOpen = _useState116[1];
  var _useScrollIntoView = useScrollIntoView({
      duration: 0,
      offset: 5,
      cancelable: false,
      isList: true
    }),
    scrollIntoView = _useScrollIntoView.scrollIntoView,
    targetRef = _useScrollIntoView.targetRef,
    scrollableRef = _useScrollIntoView.scrollableRef;
  var isCreatable = creatable && typeof getCreateLabel === "function";
  var createLabel = null;
  var setDropdownOpened = function setDropdownOpened(opened) {
    _setDropdownOpened(opened);
    var handler = opened ? onDropdownOpen : onDropdownClose;
    typeof handler === "function" && handler();
  };
  var handleSearchChange = function handleSearchChange(val) {
    typeof onSearchChange === "function" && onSearchChange(val);
    setSearchValue(val);
  };
  var formattedData = data.map(function (item) {
    return typeof item === "string" ? {
      label: item,
      value: item
    } : item;
  });
  var sortedData = groupOptions({
    data: formattedData
  });
  var _useUncontrolled19 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: [],
      rule: function rule(val) {
        return Array.isArray(val);
      },
      onChange: onChange
    }),
    _useUncontrolled20 = _slicedToArray(_useUncontrolled19, 2),
    _value = _useUncontrolled20[0],
    setValue = _useUncontrolled20[1];
  var valuesOverflow = useRef(!!maxSelectedValues && maxSelectedValues < _value.length);
  var handleValueRemove = function handleValueRemove(_val) {
    var newValue = _value.filter(function (val) {
      return val !== _val;
    });
    setValue(newValue);
    if (!!maxSelectedValues && newValue.length < maxSelectedValues) {
      valuesOverflow.current = false;
    }
  };
  var handleInputChange = function handleInputChange(event) {
    handleSearchChange(event.currentTarget.value);
    setDropdownOpened(true);
  };
  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);
  };
  var filteredData = filterData$1({
    data: sortedData,
    searchable: searchable,
    searchValue: searchValue,
    limit: limit,
    filter: filter,
    value: _value
  });
  var getNextIndex = function getNextIndex(index, nextItem, compareFn) {
    var i = index;
    while (compareFn(i)) {
      i = nextItem(i);
      if (!filteredData[i].disabled) return i;
    }
    return index;
  };
  useDidUpdate(function () {
    setHovered(getNextIndex(-1, function (index) {
      return index + 1;
    }, function (index) {
      return index < filteredData.length - 1;
    }));
  }, [searchValue]);
  useDidUpdate(function () {
    if (!disabled && _value.length >= data.length) {
      setDropdownOpened(false);
    }
    if (!!maxSelectedValues && _value.length < maxSelectedValues) {
      valuesOverflow.current = false;
    }
    if (!!maxSelectedValues && _value.length >= maxSelectedValues) {
      valuesOverflow.current = true;
      setDropdownOpened(false);
    }
  }, [_value]);
  var handleItemSelect = function handleItemSelect(item) {
    clearSearchOnChange && handleSearchChange("");
    if (_value.includes(item.value)) {
      handleValueRemove(item.value);
    } else {
      setValue([].concat(_toConsumableArray2(_value), [item.value]));
      if (_value.length === maxSelectedValues - 1) {
        valuesOverflow.current = true;
        setDropdownOpened(false);
      }
      if (hovered === filteredData.length - 1) {
        setHovered(filteredData.length - 2);
      }
    }
    if (item.creatable) {
      typeof onCreate === "function" && onCreate(item.value);
    }
  };
  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    if (selectOnBlur && filteredData[hovered] && dropdownOpened) {
      handleItemSelect(filteredData[hovered]);
    }
    clearSearchOnBlur && handleSearchChange("");
    setDropdownOpened(false);
  };
  var handleInputKeydown = function handleInputKeydown(event) {
    if (IMEOpen) {
      return;
    }
    onKeyDown == null ? void 0 : onKeyDown(event);
    if (event.nativeEvent.code !== "Backspace" && !!maxSelectedValues && valuesOverflow.current) {
      return;
    }
    var isColumn = direction === "column";
    var handleNext = function handleNext() {
      setHovered(function (current) {
        var _a2;
        var nextIndex = getNextIndex(current, function (index) {
          return index + 1;
        }, function (index) {
          return index < filteredData.length - 1;
        });
        if (dropdownOpened) {
          targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
          scrollIntoView({
            alignment: isColumn ? "end" : "start"
          });
        }
        return nextIndex;
      });
    };
    var handlePrevious = function handlePrevious() {
      setHovered(function (current) {
        var _a2;
        var nextIndex = getNextIndex(current, function (index) {
          return index - 1;
        }, function (index) {
          return index > 0;
        });
        if (dropdownOpened) {
          targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
          scrollIntoView({
            alignment: isColumn ? "start" : "end"
          });
        }
        return nextIndex;
      });
    };
    switch (event.nativeEvent.code) {
      case "ArrowUp":
        {
          event.preventDefault();
          setDropdownOpened(true);
          isColumn ? handlePrevious() : handleNext();
          break;
        }
      case "ArrowDown":
        {
          event.preventDefault();
          setDropdownOpened(true);
          isColumn ? handleNext() : handlePrevious();
          break;
        }
      case "Enter":
        {
          event.preventDefault();
          if (filteredData[hovered] && dropdownOpened) {
            handleItemSelect(filteredData[hovered]);
          } else {
            setDropdownOpened(true);
          }
          break;
        }
      case "Space":
        {
          if (!searchable) {
            event.preventDefault();
            if (filteredData[hovered] && dropdownOpened) {
              handleItemSelect(filteredData[hovered]);
            } else {
              setDropdownOpened(true);
            }
          }
          break;
        }
      case "Backspace":
        {
          if (_value.length > 0 && searchValue.length === 0) {
            setValue(_value.slice(0, -1));
            setDropdownOpened(true);
            if (maxSelectedValues) {
              valuesOverflow.current = false;
            }
          }
          break;
        }
      case "Home":
        {
          if (!searchable) {
            event.preventDefault();
            if (!dropdownOpened) {
              setDropdownOpened(true);
            }
            var firstItemIndex = filteredData.findIndex(function (item) {
              return !item.disabled;
            });
            setHovered(firstItemIndex);
            scrollIntoView({
              alignment: isColumn ? "end" : "start"
            });
          }
          break;
        }
      case "End":
        {
          if (!searchable) {
            event.preventDefault();
            if (!dropdownOpened) {
              setDropdownOpened(true);
            }
            var lastItemIndex = filteredData.map(function (item) {
              return !!item.disabled;
            }).lastIndexOf(false);
            setHovered(lastItemIndex);
            scrollIntoView({
              alignment: isColumn ? "end" : "start"
            });
          }
          break;
        }
      case "Escape":
        {
          setDropdownOpened(false);
        }
    }
  };
  var selectedItems = _value.map(function (val) {
    var selectedItem = sortedData.find(function (item) {
      return item.value === val && !item.disabled;
    });
    if (!selectedItem && isCreatable) {
      selectedItem = {
        value: val,
        label: val
      };
    }
    return selectedItem;
  }).filter(function (val) {
    return !!val;
  }).map(function (item) {
    return /* @__PURE__ */React__default.createElement(Value, __spreadProps$W(__spreadValues$28({}, item), {
      disabled: disabled,
      className: classes.value,
      onRemove: function onRemove(event) {
        if (dropdownOpened) {
          event.preventDefault();
          event.stopPropagation();
        }
        handleValueRemove(item.value);
        setDropdownOpened(true);
      },
      key: item.value,
      size: size,
      styles: styles,
      classNames: classNames,
      radius: radius
    }));
  });
  var handleClear = function handleClear() {
    var _a2;
    handleSearchChange("");
    setValue([]);
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
    if (maxSelectedValues) {
      valuesOverflow.current = false;
    }
  };
  if (isCreatable && shouldCreate(searchValue, sortedData)) {
    createLabel = getCreateLabel(searchValue);
    filteredData.push({
      label: searchValue,
      value: searchValue,
      creatable: true
    });
  }
  var shouldRenderDropdown = filteredData.length > 0 ? dropdownOpened : dropdownOpened && !!nothingFound;
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$28(__spreadValues$28({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    size: size,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    __staticSelector: "MultiSelect",
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement("div", {
    className: classes.wrapper,
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-owns": dropdownOpened && shouldRenderDropdown ? "".concat(uuid, "-items") : null,
    "aria-controls": uuid,
    "aria-expanded": dropdownOpened,
    onMouseLeave: function onMouseLeave() {
      return setHovered(-1);
    },
    tabIndex: -1,
    ref: wrapperRef
  }, /* @__PURE__ */React__default.createElement("input", {
    type: "hidden",
    name: name,
    value: _value.join(","),
    form: form
  }), /* @__PURE__ */React__default.createElement(Input, __spreadValues$28({
    __staticSelector: "MultiSelect",
    style: {
      overflow: "hidden"
    },
    component: "div",
    multiline: true,
    size: size,
    variant: variant,
    disabled: disabled,
    invalid: !!error,
    required: required,
    radius: radius,
    icon: icon,
    onMouseDown: function onMouseDown(event) {
      var _a2;
      event.preventDefault();
      !disabled && !valuesOverflow.current && setDropdownOpened(!dropdownOpened);
      (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
    },
    classNames: __spreadProps$W(__spreadValues$28({}, classNames), {
      input: cx(_defineProperty({}, classes.input, !searchable), classNames == null ? void 0 : classNames.input)
    })
  }, getSelectRightSectionProps({
    theme: theme,
    rightSection: rightSection,
    rightSectionWidth: rightSectionWidth,
    styles: styles,
    size: size,
    shouldClear: clearable && _value.length > 0,
    clearButtonLabel: clearButtonLabel,
    onClear: handleClear,
    error: error,
    disabled: disabled,
    clearButtonTabIndex: clearButtonTabIndex
  })), /* @__PURE__ */React__default.createElement("div", {
    className: classes.values
  }, selectedItems, /* @__PURE__ */React__default.createElement("input", __spreadValues$28({
    ref: useMergedRef(ref, inputRef),
    type: "search",
    autoComplete: "off",
    id: uuid,
    className: cx(classes.searchInput, (_cx7 = {}, _defineProperty(_cx7, classes.searchInputPointer, !searchable), _defineProperty(_cx7, classes.searchInputInputHidden, !dropdownOpened && _value.length > 0 || !searchable && _value.length > 0), _defineProperty(_cx7, classes.searchInputEmpty, _value.length === 0), _cx7)),
    onKeyDown: handleInputKeydown,
    value: searchValue,
    onChange: handleInputChange,
    onFocus: handleInputFocus,
    onCompositionStart: function onCompositionStart() {
      return setIMEOpen(true);
    },
    onCompositionEnd: function onCompositionEnd() {
      return setIMEOpen(false);
    },
    onBlur: handleInputBlur,
    readOnly: !searchable || valuesOverflow.current,
    placeholder: _value.length === 0 ? placeholder : void 0,
    disabled: disabled,
    "data-mantine-stop-propagation": dropdownOpened
  }, rest)))), /* @__PURE__ */React__default.createElement(SelectDropdown, {
    mounted: dropdownOpened && shouldRenderDropdown,
    transition: transition,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    uuid: uuid,
    shadow: shadow,
    maxDropdownHeight: maxDropdownHeight,
    classNames: classNames,
    styles: styles,
    ref: useMergedRef(dropdownRef, scrollableRef),
    __staticSelector: "MultiSelect",
    dropdownComponent: dropdownComponent || SelectScrollArea,
    referenceElement: wrapperRef.current,
    direction: direction,
    onDirectionChange: setDirection,
    switchDirectionOnFlip: switchDirectionOnFlip,
    withinPortal: withinPortal,
    zIndex: zIndex,
    dropdownPosition: dropdownPosition,
    positionDependencies: positionDependencies
  }, /* @__PURE__ */React__default.createElement(SelectItems, {
    data: filteredData,
    hovered: hovered,
    classNames: classNames,
    styles: styles,
    uuid: uuid,
    __staticSelector: "MultiSelect",
    onItemHover: setHovered,
    onItemSelect: handleItemSelect,
    itemsRefs: itemsRefs,
    itemComponent: itemComponent,
    size: size,
    nothingFound: nothingFound,
    creatable: creatable && !!createLabel,
    createLabel: createLabel
  }))));
});
MultiSelect.displayName = "@mantine/core/MultiSelect";
var __defProp$29 = Object.defineProperty;
var __defProps$X = Object.defineProperties;
var __getOwnPropDescs$X = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2a = Object.getOwnPropertySymbols;
var __hasOwnProp$2a = Object.prototype.hasOwnProperty;
var __propIsEnum$2a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$29 = function __defNormalProp$29(obj, key, value) {
  return key in obj ? __defProp$29(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$29 = function __spreadValues$29(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2a.call(b, prop)) __defNormalProp$29(a, prop, b[prop]);
  if (__getOwnPropSymbols$2a) {
    var _iterator203 = _createForOfIteratorHelper(__getOwnPropSymbols$2a(b)),
      _step204;
    try {
      for (_iterator203.s(); !(_step204 = _iterator203.n()).done;) {
        var prop = _step204.value;
        if (__propIsEnum$2a.call(b, prop)) __defNormalProp$29(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator203.e(err);
    } finally {
      _iterator203.f();
    }
  }
  return a;
};
var __spreadProps$X = function __spreadProps$X(a, b) {
  return __defProps$X(a, __getOwnPropDescs$X(b));
};
var __objRest$1h = function __objRest$1h(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2a.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2a) {
    var _iterator204 = _createForOfIteratorHelper(__getOwnPropSymbols$2a(source)),
      _step205;
    try {
      for (_iterator204.s(); !(_step205 = _iterator204.n()).done;) {
        var prop = _step205.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2a.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator204.e(err);
    } finally {
      _iterator204.f();
    }
  }
  return target;
};
var defaultProps$S = {
  size: "sm"
};
var NativeSelect = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("NativeSelect", defaultProps$S, props),
    id = _a.id,
    className = _a.className,
    required = _a.required,
    label = _a.label,
    error = _a.error,
    style = _a.style,
    data = _a.data,
    placeholder = _a.placeholder,
    wrapperProps = _a.wrapperProps,
    inputStyle = _a.inputStyle,
    description = _a.description,
    onChange = _a.onChange,
    value = _a.value,
    classNames = _a.classNames,
    styles = _a.styles,
    size = _a.size,
    rightSection = _a.rightSection,
    rightSectionWidth = _a.rightSectionWidth,
    sx = _a.sx,
    errorProps = _a.errorProps,
    descriptionProps = _a.descriptionProps,
    labelProps = _a.labelProps,
    others = __objRest$1h(_a, ["id", "className", "required", "label", "error", "style", "data", "placeholder", "wrapperProps", "inputStyle", "description", "onChange", "value", "classNames", "styles", "size", "rightSection", "rightSectionWidth", "sx", "errorProps", "descriptionProps", "labelProps"]);
  var uuid = useUuid(id);
  var theme = useMantineTheme();
  var _extractSystemStyles10 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles10.systemStyles,
    rest = _extractSystemStyles10.rest;
  var formattedData = data.map(function (item) {
    return typeof item === "string" ? {
      label: item,
      value: item
    } : item;
  });
  var options = formattedData.map(function (item) {
    return /* @__PURE__ */React__default.createElement("option", {
      key: item.value,
      value: item.value,
      disabled: item.disabled
    }, item.label);
  });
  if (placeholder) {
    options.unshift( /* @__PURE__ */React__default.createElement("option", {
      key: "placeholder",
      value: "",
      disabled: true,
      hidden: true
    }, placeholder));
  }
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$29(__spreadValues$29({
    required: required,
    id: uuid,
    label: label,
    error: error,
    className: className,
    style: style,
    description: description,
    size: size,
    styles: styles,
    classNames: classNames,
    sx: sx,
    __staticSelector: "NativeSelect",
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement(Input, __spreadValues$29(__spreadProps$X(__spreadValues$29({}, rest), {
    onChange: onChange,
    component: "select",
    invalid: !!error,
    style: inputStyle,
    "aria-required": required,
    ref: ref,
    id: uuid,
    required: required,
    value: value === null ? "" : value,
    size: size,
    classNames: classNames,
    __staticSelector: "NativeSelect"
  }), getSelectRightSectionProps({
    theme: theme,
    rightSection: rightSection,
    rightSectionWidth: rightSectionWidth,
    styles: styles,
    shouldClear: false,
    size: size,
    error: error
  })), options));
});
NativeSelect.displayName = "@mantine/core/NativeSelect";
var useStyles$Y = createStyles(function (theme, _ref128, getRef) {
  var color = _ref128.color,
    radius = _ref128.radius;
  var _radius = theme.fn.radius(radius);
  var topBottom = Math.min(Math.max(_radius / 1.2, 4), 30);
  var colors = theme.fn.variant({
    variant: "filled",
    color: color
  });
  return {
    closeButton: {},
    icon: {
      ref: getRef("icon"),
      boxSizing: "border-box",
      marginRight: theme.spacing.md,
      width: 28,
      height: 28,
      borderRadius: 28,
      display: "flex",
      flex: "none",
      alignItems: "center",
      justifyContent: "center",
      color: theme.white
    },
    withIcon: {
      paddingLeft: theme.spacing.xs,
      "&::before": {
        display: "none"
      }
    },
    root: _defineProperty({
      boxSizing: "border-box",
      position: "relative",
      display: "flex",
      alignItems: "center",
      paddingLeft: 22,
      paddingRight: 5,
      paddingTop: theme.spacing.xs,
      paddingBottom: theme.spacing.xs,
      borderRadius: _radius,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      boxShadow: theme.shadows.lg,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]),
      "&::before": {
        content: "''",
        display: "block",
        position: "absolute",
        width: 6,
        top: topBottom,
        bottom: topBottom,
        left: 4,
        borderRadius: _radius,
        backgroundColor: colors.background
      }
    }, "& .".concat(getRef("icon")), {
      backgroundColor: colors.background,
      color: theme.white
    }),
    body: {
      flex: 1,
      overflow: "hidden",
      marginRight: 10
    },
    loader: {
      marginRight: theme.spacing.md
    },
    title: {
      lineHeight: 1.4,
      marginBottom: 2,
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: theme.colorScheme === "dark" ? theme.white : theme.colors.gray[9]
    },
    description: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
      lineHeight: 1.4,
      overflow: "hidden",
      textOverflow: "ellipsis",
      "&:only-child": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
      }
    }
  };
});
var __defProp$2a = Object.defineProperty;
var __defProps$Y = Object.defineProperties;
var __getOwnPropDescs$Y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2b = Object.getOwnPropertySymbols;
var __hasOwnProp$2b = Object.prototype.hasOwnProperty;
var __propIsEnum$2b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2a = function __defNormalProp$2a(obj, key, value) {
  return key in obj ? __defProp$2a(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2a = function __spreadValues$2a(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2b.call(b, prop)) __defNormalProp$2a(a, prop, b[prop]);
  if (__getOwnPropSymbols$2b) {
    var _iterator205 = _createForOfIteratorHelper(__getOwnPropSymbols$2b(b)),
      _step206;
    try {
      for (_iterator205.s(); !(_step206 = _iterator205.n()).done;) {
        var prop = _step206.value;
        if (__propIsEnum$2b.call(b, prop)) __defNormalProp$2a(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator205.e(err);
    } finally {
      _iterator205.f();
    }
  }
  return a;
};
var __spreadProps$Y = function __spreadProps$Y(a, b) {
  return __defProps$Y(a, __getOwnPropDescs$Y(b));
};
var __objRest$1i = function __objRest$1i(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2b.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2b) {
    var _iterator206 = _createForOfIteratorHelper(__getOwnPropSymbols$2b(source)),
      _step207;
    try {
      for (_iterator206.s(); !(_step207 = _iterator206.n()).done;) {
        var prop = _step207.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2b.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator206.e(err);
    } finally {
      _iterator206.f();
    }
  }
  return target;
};
var Notification = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Notification", {}, props),
    className = _a.className,
    color = _a.color,
    radius = _a.radius,
    loading = _a.loading,
    disallowClose = _a.disallowClose,
    title = _a.title,
    icon = _a.icon,
    children = _a.children,
    onClose = _a.onClose,
    closeButtonProps = _a.closeButtonProps,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$1i(_a, ["className", "color", "radius", "loading", "disallowClose", "title", "icon", "children", "onClose", "closeButtonProps", "classNames", "styles"]);
  var _useStyles$Y = useStyles$Y({
      color: color,
      radius: radius
    }, {
      classNames: classNames,
      styles: styles,
      name: "Notification"
    }),
    classes = _useStyles$Y.classes,
    cx = _useStyles$Y.cx;
  var withIcon = icon || loading;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2a({
    className: cx(classes.root, _defineProperty({}, classes.withIcon, withIcon), className),
    role: "alert",
    ref: ref
  }, others), icon && !loading && /* @__PURE__ */React__default.createElement("div", {
    className: classes.icon
  }, icon), loading && /* @__PURE__ */React__default.createElement(Loader, {
    size: 28,
    color: color,
    className: classes.loader
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.body
  }, title && /* @__PURE__ */React__default.createElement(Text, {
    className: classes.title,
    size: "sm",
    weight: 500
  }, title), /* @__PURE__ */React__default.createElement(Text, {
    color: "dimmed",
    className: classes.description,
    size: "sm"
  }, children)), !disallowClose && /* @__PURE__ */React__default.createElement(CloseButton, __spreadProps$Y(__spreadValues$2a({}, closeButtonProps), {
    iconSize: 16,
    color: "gray",
    onClick: onClose,
    variant: "hover",
    className: classes.closeButton
  })));
});
Notification.displayName = "@mantine/core/Notification";
var __defProp$2b = Object.defineProperty;
var __defProps$Z = Object.defineProperties;
var __getOwnPropDescs$Z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2c = Object.getOwnPropertySymbols;
var __hasOwnProp$2c = Object.prototype.hasOwnProperty;
var __propIsEnum$2c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2b = function __defNormalProp$2b(obj, key, value) {
  return key in obj ? __defProp$2b(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2b = function __spreadValues$2b(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2c.call(b, prop)) __defNormalProp$2b(a, prop, b[prop]);
  if (__getOwnPropSymbols$2c) {
    var _iterator207 = _createForOfIteratorHelper(__getOwnPropSymbols$2c(b)),
      _step208;
    try {
      for (_iterator207.s(); !(_step208 = _iterator207.n()).done;) {
        var prop = _step208.value;
        if (__propIsEnum$2c.call(b, prop)) __defNormalProp$2b(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator207.e(err);
    } finally {
      _iterator207.f();
    }
  }
  return a;
};
var __spreadProps$Z = function __spreadProps$Z(a, b) {
  return __defProps$Z(a, __getOwnPropDescs$Z(b));
};
var __objRest$1j = function __objRest$1j(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2c.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2c) {
    var _iterator208 = _createForOfIteratorHelper(__getOwnPropSymbols$2c(source)),
      _step209;
    try {
      for (_iterator208.s(); !(_step209 = _iterator208.n()).done;) {
        var prop = _step209.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2c.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator208.e(err);
    } finally {
      _iterator208.f();
    }
  }
  return target;
};
var defaultProps$T = {
  type: "text",
  size: "sm",
  __staticSelector: "TextInput"
};
var TextInput = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("TextInput", defaultProps$T, props),
    className = _a.className,
    id = _a.id,
    label = _a.label,
    error = _a.error,
    required = _a.required,
    type = _a.type,
    style = _a.style,
    icon = _a.icon,
    description = _a.description,
    wrapperProps = _a.wrapperProps,
    size = _a.size,
    classNames = _a.classNames,
    styles = _a.styles,
    errorProps = _a.errorProps,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    __staticSelector = _a.__staticSelector,
    sx = _a.sx,
    others = __objRest$1j(_a, ["className", "id", "label", "error", "required", "type", "style", "icon", "description", "wrapperProps", "size", "classNames", "styles", "errorProps", "labelProps", "descriptionProps", "__staticSelector", "sx"]);
  var uuid = useUuid(id);
  var _extractSystemStyles11 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles11.systemStyles,
    rest = _extractSystemStyles11.rest;
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$2b(__spreadValues$2b({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    size: size,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    sx: sx,
    errorProps: errorProps,
    labelProps: labelProps,
    descriptionProps: descriptionProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement(Input, __spreadProps$Z(__spreadValues$2b({}, rest), {
    required: required,
    ref: ref,
    id: uuid,
    type: type,
    invalid: !!error,
    icon: icon,
    size: size,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector
  })));
});
TextInput.displayName = "@mantine/core/TextInput";
var CONTROL_SIZES = {
  xs: 20,
  sm: 24,
  md: 30,
  lg: 34,
  xl: 36
};
var useStyles$Z = createStyles(function (theme, _ref129) {
  var radius = _ref129.radius,
    size = _ref129.size;
  return {
    rightSection: {
      display: "flex",
      flexDirection: "column",
      height: "calc(100% - 2px)",
      margin: 1,
      marginRight: 1
    },
    control: {
      margin: 0,
      position: "relative",
      flex: "0 0 50%",
      boxSizing: "border-box",
      width: theme.fn.size({
        size: size,
        sizes: CONTROL_SIZES
      }),
      padding: 0,
      WebkitTapHighlightColor: "transparent",
      borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]),
      borderLeft: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]),
      borderTop: 0,
      borderRight: 0,
      backgroundColor: "transparent",
      marginRight: 1,
      "&:not(:disabled):hover": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
      },
      "&::after": {
        position: "absolute",
        top: "calc(50% - 2.5px)",
        left: "calc(50% - 4.5px)",
        content: '""',
        display: "block",
        width: 0,
        height: 0,
        borderStyle: "solid"
      }
    },
    controlUp: {
      borderTopRightRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }) - 1,
      "&::after": {
        borderWidth: "0 5px 5px 5px",
        borderColor: "transparent transparent ".concat(theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black, " transparent")
      },
      "&:disabled::after": {
        borderBottomColor: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5]
      }
    },
    controlDown: {
      borderBottomRightRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }) - 1,
      borderBottom: 0,
      "&::after": {
        borderWidth: "5px 5px 0 5px",
        borderColor: "".concat(theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black, " transparent transparent transparent")
      },
      "&:disabled::after": {
        borderTopColor: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5]
      }
    }
  };
});
var __defProp$2c = Object.defineProperty;
var __defProps$_ = Object.defineProperties;
var __getOwnPropDescs$_ = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2d = Object.getOwnPropertySymbols;
var __hasOwnProp$2d = Object.prototype.hasOwnProperty;
var __propIsEnum$2d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2c = function __defNormalProp$2c(obj, key, value) {
  return key in obj ? __defProp$2c(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2c = function __spreadValues$2c(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2d.call(b, prop)) __defNormalProp$2c(a, prop, b[prop]);
  if (__getOwnPropSymbols$2d) {
    var _iterator209 = _createForOfIteratorHelper(__getOwnPropSymbols$2d(b)),
      _step210;
    try {
      for (_iterator209.s(); !(_step210 = _iterator209.n()).done;) {
        var prop = _step210.value;
        if (__propIsEnum$2d.call(b, prop)) __defNormalProp$2c(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator209.e(err);
    } finally {
      _iterator209.f();
    }
  }
  return a;
};
var __spreadProps$_ = function __spreadProps$_(a, b) {
  return __defProps$_(a, __getOwnPropDescs$_(b));
};
var __objRest$1k = function __objRest$1k(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2d.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2d) {
    var _iterator210 = _createForOfIteratorHelper(__getOwnPropSymbols$2d(source)),
      _step211;
    try {
      for (_iterator210.s(); !(_step211 = _iterator210.n()).done;) {
        var prop = _step211.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2d.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator210.e(err);
    } finally {
      _iterator210.f();
    }
  }
  return target;
};
var defaultFormatter = function defaultFormatter(value) {
  return value || "";
};
var defaultParser = function defaultParser(num) {
  if (num === "-") {
    return num;
  }
  var tempNum = num;
  if (tempNum[0] === ".") {
    tempNum = "0".concat(num);
  }
  var parsedNum = parseFloat(tempNum);
  if (Number.isNaN(parsedNum)) {
    return void 0;
  }
  return num;
};
var defaultProps$U = {
  step: 1,
  hideControls: false,
  size: "sm",
  precision: 0,
  noClampOnBlur: false,
  formatter: defaultFormatter,
  parser: defaultParser
};
var NumberInput = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("NumberInput", defaultProps$U, props),
    disabled = _a.disabled,
    value = _a.value,
    onChange = _a.onChange,
    decimalSeparator = _a.decimalSeparator,
    min = _a.min,
    max = _a.max,
    step = _a.step,
    stepHoldInterval = _a.stepHoldInterval,
    stepHoldDelay = _a.stepHoldDelay,
    onBlur = _a.onBlur,
    onFocus = _a.onFocus,
    hideControls = _a.hideControls,
    radius = _a.radius,
    variant = _a.variant,
    precision = _a.precision,
    defaultValue = _a.defaultValue,
    noClampOnBlur = _a.noClampOnBlur,
    handlersRef = _a.handlersRef,
    classNames = _a.classNames,
    styles = _a.styles,
    size = _a.size,
    rightSection = _a.rightSection,
    rightSectionWidth = _a.rightSectionWidth,
    formatter = _a.formatter,
    parser = _a.parser,
    others = __objRest$1k(_a, ["disabled", "value", "onChange", "decimalSeparator", "min", "max", "step", "stepHoldInterval", "stepHoldDelay", "onBlur", "onFocus", "hideControls", "radius", "variant", "precision", "defaultValue", "noClampOnBlur", "handlersRef", "classNames", "styles", "size", "rightSection", "rightSectionWidth", "formatter", "parser"]);
  var _useStyles$Z = useStyles$Z({
      radius: radius,
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "NumberInput"
    }),
    classes = _useStyles$Z.classes,
    cx = _useStyles$Z.cx,
    theme = _useStyles$Z.theme;
  var _useState117 = useState(false),
    _useState118 = _slicedToArray(_useState117, 2),
    focused = _useState118[0],
    setFocused = _useState118[1];
  var _useState119 = useState(typeof value === "number" ? value : typeof defaultValue === "number" ? defaultValue : void 0),
    _useState120 = _slicedToArray(_useState119, 2),
    _value = _useState120[0],
    setValue = _useState120[1];
  var finalValue = typeof value === "number" ? value : _value;
  var _useState121 = useState(typeof finalValue === "number" ? finalValue.toFixed(precision) : ""),
    _useState122 = _slicedToArray(_useState121, 2),
    tempValue = _useState122[0],
    setTempValue = _useState122[1];
  var inputRef = useRef();
  var handleValueChange = function handleValueChange(val) {
    typeof onChange === "function" && onChange(val);
    setValue(val);
  };
  var formatNum = function formatNum() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var parsedStr = typeof val === "number" ? String(val) : val;
    if (decimalSeparator) {
      parsedStr = parsedStr.replace(/\./g, decimalSeparator);
    }
    return formatter(parsedStr);
  };
  var parseNum = function parseNum(val) {
    var num = val;
    if (decimalSeparator) {
      num = num.replace(new RegExp("\\".concat(decimalSeparator), "g"), ".");
    }
    return parser(num);
  };
  var _min = typeof min === "number" ? min : -Infinity;
  var _max = typeof max === "number" ? max : Infinity;
  var incrementRef = useRef();
  incrementRef.current = function () {
    var _a2;
    if (_value === void 0) {
      handleValueChange(min != null ? min : 0);
      setTempValue((_a2 = min == null ? void 0 : min.toFixed(precision)) != null ? _a2 : "0");
    } else {
      var result = clamp({
        value: _value + step,
        min: _min,
        max: _max
      }).toFixed(precision);
      handleValueChange(parseFloat(result));
      setTempValue(result);
    }
  };
  var decrementRef = useRef();
  decrementRef.current = function () {
    var _a2;
    if (_value === void 0) {
      handleValueChange(min != null ? min : 0);
      setTempValue((_a2 = min == null ? void 0 : min.toFixed(precision)) != null ? _a2 : "0");
    } else {
      var result = clamp({
        value: _value - step,
        min: _min,
        max: _max
      }).toFixed(precision);
      handleValueChange(parseFloat(result));
      setTempValue(result);
    }
  };
  assignRef(handlersRef, {
    increment: incrementRef.current,
    decrement: decrementRef.current
  });
  useEffect(function () {
    if (typeof value === "number" && !focused) {
      setValue(value);
      setTempValue(value.toFixed(precision));
    }
    if (defaultValue === void 0 && value === void 0 && !focused) {
      setValue(value);
      setTempValue("");
    }
  }, [value]);
  var shouldUseStepInterval = stepHoldDelay !== void 0 && stepHoldInterval !== void 0;
  var onStepTimeoutRef = useRef(null);
  var stepCountRef = useRef(0);
  var onStepDone = function onStepDone() {
    if (onStepTimeoutRef.current) {
      window.clearTimeout(onStepTimeoutRef.current);
    }
    onStepTimeoutRef.current = null;
    stepCountRef.current = 0;
  };
  var onStepHandleChange = function onStepHandleChange(isIncrement) {
    if (isIncrement) {
      incrementRef.current();
    } else {
      decrementRef.current();
    }
    stepCountRef.current += 1;
  };
  var onStepLoop = function onStepLoop(isIncrement) {
    onStepHandleChange(isIncrement);
    if (shouldUseStepInterval) {
      var interval = typeof stepHoldInterval === "number" ? stepHoldInterval : stepHoldInterval(stepCountRef.current);
      onStepTimeoutRef.current = window.setTimeout(function () {
        return onStepLoop(isIncrement);
      }, interval);
    }
  };
  var onStep = function onStep(event, isIncrement) {
    event.preventDefault();
    inputRef.current.focus();
    onStepHandleChange(isIncrement);
    if (shouldUseStepInterval) {
      onStepTimeoutRef.current = window.setTimeout(function () {
        return onStepLoop(isIncrement);
      }, stepHoldDelay);
    }
  };
  useEffect(function () {
    onStepDone();
    return onStepDone;
  }, []);
  var controls = /* @__PURE__ */React__default.createElement("div", {
    className: classes.rightSection
  }, /* @__PURE__ */React__default.createElement("button", {
    type: "button",
    tabIndex: -1,
    "aria-hidden": true,
    disabled: finalValue >= max,
    className: cx(classes.control, classes.controlUp),
    onMouseDown: function onMouseDown(event) {
      onStep(event, true);
    },
    onMouseUp: onStepDone,
    onMouseLeave: onStepDone
  }), /* @__PURE__ */React__default.createElement("button", {
    type: "button",
    tabIndex: -1,
    "aria-hidden": true,
    disabled: finalValue <= min,
    className: cx(classes.control, classes.controlDown),
    onMouseDown: function onMouseDown(event) {
      onStep(event, false);
    },
    onMouseUp: onStepDone,
    onMouseLeave: onStepDone
  }));
  var handleChange = function handleChange(event) {
    var val = event.target.value;
    var parsed = parseNum(val);
    setTempValue(parsed);
    if (val === "" || val === "-") {
      handleValueChange(void 0);
    } else {
      val.trim() !== "" && !Number.isNaN(parsed) && handleValueChange(parseFloat(parsed));
    }
  };
  var handleBlur = function handleBlur(event) {
    var _a2;
    if (event.target.value === "") {
      setTempValue("");
      handleValueChange(void 0);
    } else {
      var newNumber = event.target.value;
      if (newNumber[0] === "".concat(decimalSeparator) || newNumber[0] === ".") {
        newNumber = "0".concat(newNumber);
      }
      var parsedVal = parseNum(newNumber);
      var val = clamp({
        value: parseFloat(parsedVal),
        min: _min,
        max: _max
      });
      if (!Number.isNaN(val)) {
        if (!noClampOnBlur) {
          setTempValue(val.toFixed(precision));
          handleValueChange(parseFloat(val.toFixed(precision)));
        }
      } else {
        setTempValue((_a2 = finalValue == null ? void 0 : finalValue.toFixed(precision)) != null ? _a2 : "");
      }
    }
    setFocused(false);
    typeof onBlur === "function" && onBlur(event);
  };
  var handleFocus = function handleFocus(event) {
    setFocused(true);
    typeof onFocus === "function" && onFocus(event);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.repeat && shouldUseStepInterval && (event.key === "ArrowUp" || event.key === "ArrowDown")) {
      event.preventDefault();
      return;
    }
    if (event.key === "ArrowUp") {
      onStep(event, true);
    } else if (event.key === "ArrowDown") {
      onStep(event, false);
    }
  };
  var handleKeyUp = function handleKeyUp(event) {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      onStepDone();
    }
  };
  return /* @__PURE__ */React__default.createElement(TextInput, __spreadProps$_(__spreadValues$2c({}, others), {
    variant: variant,
    value: formatNum(tempValue),
    disabled: disabled,
    ref: useMergedRef(inputRef, ref),
    type: "text",
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    rightSection: rightSection || (disabled || hideControls || variant === "unstyled" ? null : controls),
    rightSectionWidth: rightSectionWidth || theme.fn.size({
      size: size,
      sizes: CONTROL_SIZES
    }) + 1,
    radius: radius,
    max: max,
    min: min,
    step: step,
    size: size,
    styles: styles,
    classNames: classNames,
    inputMode: getInputMode(step, precision, useOs()),
    __staticSelector: "NumberInput"
  }));
});
NumberInput.displayName = "@mantine/core/NumberInput";
var __defProp$2d = Object.defineProperty;
var __getOwnPropSymbols$2e = Object.getOwnPropertySymbols;
var __hasOwnProp$2e = Object.prototype.hasOwnProperty;
var __propIsEnum$2e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2d = function __defNormalProp$2d(obj, key, value) {
  return key in obj ? __defProp$2d(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2d = function __spreadValues$2d(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2e.call(b, prop)) __defNormalProp$2d(a, prop, b[prop]);
  if (__getOwnPropSymbols$2e) {
    var _iterator211 = _createForOfIteratorHelper(__getOwnPropSymbols$2e(b)),
      _step212;
    try {
      for (_iterator211.s(); !(_step212 = _iterator211.n()).done;) {
        var prop = _step212.value;
        if (__propIsEnum$2e.call(b, prop)) __defNormalProp$2d(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator211.e(err);
    } finally {
      _iterator211.f();
    }
  }
  return a;
};
function DotsIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$2d({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M2 8c0-.733.6-1.333 1.333-1.333.734 0 1.334.6 1.334 1.333s-.6 1.333-1.334 1.333C2.6 9.333 2 8.733 2 8zm9.333 0c0-.733.6-1.333 1.334-1.333C13.4 6.667 14 7.267 14 8s-.6 1.333-1.333 1.333c-.734 0-1.334-.6-1.334-1.333zM6.667 8c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333S8.733 9.333 8 9.333 6.667 8.733 6.667 8z",
    fill: "currentColor"
  }));
}
var __defProp$2e = Object.defineProperty;
var __getOwnPropSymbols$2f = Object.getOwnPropertySymbols;
var __hasOwnProp$2f = Object.prototype.hasOwnProperty;
var __propIsEnum$2f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2e = function __defNormalProp$2e(obj, key, value) {
  return key in obj ? __defProp$2e(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2e = function __spreadValues$2e(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2f.call(b, prop)) __defNormalProp$2e(a, prop, b[prop]);
  if (__getOwnPropSymbols$2f) {
    var _iterator212 = _createForOfIteratorHelper(__getOwnPropSymbols$2f(b)),
      _step213;
    try {
      for (_iterator212.s(); !(_step213 = _iterator212.n()).done;) {
        var prop = _step213.value;
        if (__propIsEnum$2f.call(b, prop)) __defNormalProp$2e(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator212.e(err);
    } finally {
      _iterator212.f();
    }
  }
  return a;
};
function NextIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$2e({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M8.781 8l-3.3-3.3.943-.943L10.667 8l-4.243 4.243-.943-.943 3.3-3.3z",
    fill: "currentColor"
  }));
}
var __defProp$2f = Object.defineProperty;
var __getOwnPropSymbols$2g = Object.getOwnPropertySymbols;
var __hasOwnProp$2g = Object.prototype.hasOwnProperty;
var __propIsEnum$2g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2f = function __defNormalProp$2f(obj, key, value) {
  return key in obj ? __defProp$2f(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2f = function __spreadValues$2f(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2g.call(b, prop)) __defNormalProp$2f(a, prop, b[prop]);
  if (__getOwnPropSymbols$2g) {
    var _iterator213 = _createForOfIteratorHelper(__getOwnPropSymbols$2g(b)),
      _step214;
    try {
      for (_iterator213.s(); !(_step214 = _iterator213.n()).done;) {
        var prop = _step214.value;
        if (__propIsEnum$2g.call(b, prop)) __defNormalProp$2f(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator213.e(err);
    } finally {
      _iterator213.f();
    }
  }
  return a;
};
function PrevIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$2f({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M7.219 8l3.3 3.3-.943.943L5.333 8l4.243-4.243.943.943-3.3 3.3z",
    fill: "currentColor"
  }));
}
var __defProp$2g = Object.defineProperty;
var __getOwnPropSymbols$2h = Object.getOwnPropertySymbols;
var __hasOwnProp$2h = Object.prototype.hasOwnProperty;
var __propIsEnum$2h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2g = function __defNormalProp$2g(obj, key, value) {
  return key in obj ? __defProp$2g(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2g = function __spreadValues$2g(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2h.call(b, prop)) __defNormalProp$2g(a, prop, b[prop]);
  if (__getOwnPropSymbols$2h) {
    var _iterator214 = _createForOfIteratorHelper(__getOwnPropSymbols$2h(b)),
      _step215;
    try {
      for (_iterator214.s(); !(_step215 = _iterator214.n()).done;) {
        var prop = _step215.value;
        if (__propIsEnum$2h.call(b, prop)) __defNormalProp$2g(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator214.e(err);
    } finally {
      _iterator214.f();
    }
  }
  return a;
};
function FirstIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$2g({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z",
    fill: "currentColor"
  }));
}
var __defProp$2h = Object.defineProperty;
var __getOwnPropSymbols$2i = Object.getOwnPropertySymbols;
var __hasOwnProp$2i = Object.prototype.hasOwnProperty;
var __propIsEnum$2i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2h = function __defNormalProp$2h(obj, key, value) {
  return key in obj ? __defProp$2h(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2h = function __spreadValues$2h(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2i.call(b, prop)) __defNormalProp$2h(a, prop, b[prop]);
  if (__getOwnPropSymbols$2i) {
    var _iterator215 = _createForOfIteratorHelper(__getOwnPropSymbols$2i(b)),
      _step216;
    try {
      for (_iterator215.s(); !(_step216 = _iterator215.n()).done;) {
        var prop = _step216.value;
        if (__propIsEnum$2i.call(b, prop)) __defNormalProp$2h(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator215.e(err);
    } finally {
      _iterator215.f();
    }
  }
  return a;
};
function LastIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$2h({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    d: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z",
    fill: "currentColor"
  }));
}
var __defProp$2i = Object.defineProperty;
var __getOwnPropSymbols$2j = Object.getOwnPropertySymbols;
var __hasOwnProp$2j = Object.prototype.hasOwnProperty;
var __propIsEnum$2j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2i = function __defNormalProp$2i(obj, key, value) {
  return key in obj ? __defProp$2i(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2i = function __spreadValues$2i(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2j.call(b, prop)) __defNormalProp$2i(a, prop, b[prop]);
  if (__getOwnPropSymbols$2j) {
    var _iterator216 = _createForOfIteratorHelper(__getOwnPropSymbols$2j(b)),
      _step217;
    try {
      for (_iterator216.s(); !(_step217 = _iterator216.n()).done;) {
        var prop = _step217.value;
        if (__propIsEnum$2j.call(b, prop)) __defNormalProp$2i(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator216.e(err);
    } finally {
      _iterator216.f();
    }
  }
  return a;
};
var __objRest$1l = function __objRest$1l(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2j.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2j) {
    var _iterator217 = _createForOfIteratorHelper(__getOwnPropSymbols$2j(source)),
      _step218;
    try {
      for (_iterator217.s(); !(_step218 = _iterator217.n()).done;) {
        var prop = _step218.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2j.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator217.e(err);
    } finally {
      _iterator217.f();
    }
  }
  return target;
};
var icons = {
  dots: DotsIcon,
  next: NextIcon,
  prev: PrevIcon,
  first: FirstIcon,
  last: LastIcon
};
var rtlIcons = {
  dots: DotsIcon,
  prev: NextIcon,
  next: PrevIcon,
  last: FirstIcon,
  first: LastIcon
};
function DefaultItem$1(_a) {
  var _b = _a,
    page = _b.page,
    active = _b.active,
    onClick = _b.onClick,
    others = __objRest$1l(_b, ["page", "active", "onClick"]);
  var theme = useMantineTheme();
  var Item = (theme.dir === "rtl" ? rtlIcons : icons)[page];
  var children = Item ? /* @__PURE__ */React__default.createElement(Item, null) : page;
  return /* @__PURE__ */React__default.createElement("button", __spreadValues$2i({
    type: "button",
    onClick: onClick
  }, others), children);
}
DefaultItem$1.displayName = "@mantine/core/Pagination/DefaultItem";
var __defProp$2j = Object.defineProperty;
var __defProps$10 = Object.defineProperties;
var __getOwnPropDescs$10 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2k = Object.getOwnPropertySymbols;
var __hasOwnProp$2k = Object.prototype.hasOwnProperty;
var __propIsEnum$2k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2j = function __defNormalProp$2j(obj, key, value) {
  return key in obj ? __defProp$2j(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2j = function __spreadValues$2j(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2k.call(b, prop)) __defNormalProp$2j(a, prop, b[prop]);
  if (__getOwnPropSymbols$2k) {
    var _iterator218 = _createForOfIteratorHelper(__getOwnPropSymbols$2k(b)),
      _step219;
    try {
      for (_iterator218.s(); !(_step219 = _iterator218.n()).done;) {
        var prop = _step219.value;
        if (__propIsEnum$2k.call(b, prop)) __defNormalProp$2j(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator218.e(err);
    } finally {
      _iterator218.f();
    }
  }
  return a;
};
var __spreadProps$10 = function __spreadProps$10(a, b) {
  return __defProps$10(a, __getOwnPropDescs$10(b));
};
var sizes$f = {
  xs: 22,
  sm: 26,
  md: 32,
  lg: 38,
  xl: 44
};
var useStyles$_ = createStyles(function (theme, _ref130, getRef) {
  var _spreadProps$;
  var size = _ref130.size,
    radius = _ref130.radius,
    color = _ref130.color;
  var colors = theme.fn.variant({
    color: color,
    variant: "filled"
  });
  return {
    item: __spreadProps$10(__spreadValues$2j({}, theme.fn.focusStyles()), (_spreadProps$ = {
      cursor: "pointer",
      userSelect: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 500,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[3]),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      height: theme.fn.size({
        size: size,
        sizes: sizes$f
      }),
      minWidth: theme.fn.size({
        size: size,
        sizes: sizes$f
      }),
      padding: "0 ".concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 2, "px"),
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      borderRadius: theme.fn.radius(radius),
      lineHeight: 1,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.white
    }, _defineProperty(_spreadProps$, "&:active:not(:disabled):not(.".concat(getRef("dots"), ")"), {
      transform: "translateY(1px)"
    }), _defineProperty(_spreadProps$, "&:disabled", {
      opacity: 0.6,
      cursor: "not-allowed",
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
    }), _spreadProps$)),
    active: {
      borderColor: "transparent",
      color: colors.color,
      backgroundColor: colors.background
    },
    dots: {
      ref: getRef("dots"),
      cursor: "default",
      borderColor: "transparent",
      backgroundColor: "transparent"
    }
  };
});
var __defProp$2k = Object.defineProperty;
var __getOwnPropSymbols$2l = Object.getOwnPropertySymbols;
var __hasOwnProp$2l = Object.prototype.hasOwnProperty;
var __propIsEnum$2l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2k = function __defNormalProp$2k(obj, key, value) {
  return key in obj ? __defProp$2k(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2k = function __spreadValues$2k(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2l.call(b, prop)) __defNormalProp$2k(a, prop, b[prop]);
  if (__getOwnPropSymbols$2l) {
    var _iterator219 = _createForOfIteratorHelper(__getOwnPropSymbols$2l(b)),
      _step220;
    try {
      for (_iterator219.s(); !(_step220 = _iterator219.n()).done;) {
        var prop = _step220.value;
        if (__propIsEnum$2l.call(b, prop)) __defNormalProp$2k(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator219.e(err);
    } finally {
      _iterator219.f();
    }
  }
  return a;
};
var __objRest$1m = function __objRest$1m(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2l.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2l) {
    var _iterator220 = _createForOfIteratorHelper(__getOwnPropSymbols$2l(source)),
      _step221;
    try {
      for (_iterator220.s(); !(_step221 = _iterator220.n()).done;) {
        var prop = _step221.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2l.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator220.e(err);
    } finally {
      _iterator220.f();
    }
  }
  return target;
};
var defaultProps$V = {
  itemComponent: DefaultItem$1,
  initialPage: 1,
  siblings: 1,
  boundaries: 1,
  size: "md",
  radius: "sm",
  withEdges: false,
  withControls: true
};
var Pagination = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Pagination", defaultProps$V, props),
    Item = _a.itemComponent,
    classNames = _a.classNames,
    styles = _a.styles,
    page = _a.page,
    initialPage = _a.initialPage,
    color = _a.color,
    total = _a.total,
    siblings = _a.siblings,
    boundaries = _a.boundaries,
    size = _a.size,
    radius = _a.radius,
    onChange = _a.onChange,
    getItemAriaLabel = _a.getItemAriaLabel,
    spacing = _a.spacing,
    withEdges = _a.withEdges,
    withControls = _a.withControls,
    sx = _a.sx,
    others = __objRest$1m(_a, ["itemComponent", "classNames", "styles", "page", "initialPage", "color", "total", "siblings", "boundaries", "size", "radius", "onChange", "getItemAriaLabel", "spacing", "withEdges", "withControls", "sx"]);
  var _useStyles$_ = useStyles$_({
      color: color,
      size: size,
      radius: radius
    }, {
      classNames: classNames,
      styles: styles,
      name: "Pagination"
    }),
    classes = _useStyles$_.classes,
    cx = _useStyles$_.cx,
    theme = _useStyles$_.theme;
  var _usePagination = usePagination({
      page: page,
      siblings: siblings,
      total: total,
      onChange: onChange,
      initialPage: initialPage,
      boundaries: boundaries
    }),
    range$$1 = _usePagination.range,
    setPage = _usePagination.setPage,
    next = _usePagination.next,
    previous = _usePagination.previous,
    active = _usePagination.active,
    first = _usePagination.first,
    last = _usePagination.last;
  var items = range$$1.map(function (pageNumber, index) {
    var _cx10;
    return /* @__PURE__ */React__default.createElement(Item, {
      key: index,
      page: pageNumber,
      active: pageNumber === active,
      "aria-current": pageNumber === active ? "page" : void 0,
      "aria-label": typeof getItemAriaLabel === "function" ? getItemAriaLabel(pageNumber) : null,
      tabIndex: pageNumber === "dots" ? -1 : 0,
      className: cx(classes.item, (_cx10 = {}, _defineProperty(_cx10, classes.active, pageNumber === active), _defineProperty(_cx10, classes.dots, pageNumber === "dots"), _cx10)),
      onClick: pageNumber !== "dots" ? function () {
        return setPage(pageNumber);
      } : void 0
    });
  });
  return /* @__PURE__ */React__default.createElement(Group, __spreadValues$2k({
    role: "navigation",
    spacing: spacing || theme.fn.size({
      size: size,
      sizes: theme.spacing
    }) / 2,
    ref: ref,
    sx: sx
  }, others), withEdges && /* @__PURE__ */React__default.createElement(Item, {
    page: "first",
    onClick: first,
    "aria-label": getItemAriaLabel ? getItemAriaLabel("first") : void 0,
    "aria-disabled": active === 1,
    className: classes.item,
    disabled: active === 1
  }), withControls && /* @__PURE__ */React__default.createElement(Item, {
    page: "prev",
    onClick: previous,
    "aria-label": getItemAriaLabel ? getItemAriaLabel("prev") : void 0,
    "aria-disabled": active === 1,
    className: classes.item,
    disabled: active === 1
  }), items, withControls && /* @__PURE__ */React__default.createElement(Item, {
    page: "next",
    onClick: next,
    "aria-label": getItemAriaLabel ? getItemAriaLabel("next") : void 0,
    "aria-disabled": active === total,
    className: classes.item,
    disabled: active === total
  }), withEdges && /* @__PURE__ */React__default.createElement(Item, {
    page: "last",
    onClick: last,
    "aria-label": getItemAriaLabel ? getItemAriaLabel("last") : void 0,
    "aria-disabled": active === total,
    className: classes.item,
    disabled: active === total
  }));
});
Pagination.displayName = "@mantine/core/Pagination";
var PasswordToggleIcon = function PasswordToggleIcon(_ref131) {
  var reveal = _ref131.reveal,
    _ref131$size = _ref131.size,
    size = _ref131$size === void 0 ? 15 : _ref131$size;
  return /* @__PURE__ */React__default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React__default.createElement("path", {
    d: reveal ? "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" : "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
};
var __defProp$2l = Object.defineProperty;
var __defProps$11 = Object.defineProperties;
var __getOwnPropDescs$11 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2m = Object.getOwnPropertySymbols;
var __hasOwnProp$2m = Object.prototype.hasOwnProperty;
var __propIsEnum$2m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2l = function __defNormalProp$2l(obj, key, value) {
  return key in obj ? __defProp$2l(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2l = function __spreadValues$2l(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2m.call(b, prop)) __defNormalProp$2l(a, prop, b[prop]);
  if (__getOwnPropSymbols$2m) {
    var _iterator221 = _createForOfIteratorHelper(__getOwnPropSymbols$2m(b)),
      _step222;
    try {
      for (_iterator221.s(); !(_step222 = _iterator221.n()).done;) {
        var prop = _step222.value;
        if (__propIsEnum$2m.call(b, prop)) __defNormalProp$2l(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator221.e(err);
    } finally {
      _iterator221.f();
    }
  }
  return a;
};
var __spreadProps$11 = function __spreadProps$11(a, b) {
  return __defProps$11(a, __getOwnPropDescs$11(b));
};
var useStyles$10 = createStyles(function (theme, _ref132) {
  var size = _ref132.size,
    rightSectionWidth = _ref132.rightSectionWidth;
  return {
    visibilityToggle: {},
    input: {
      position: "relative",
      overflow: "hidden"
    },
    innerInput: __spreadProps$11(__spreadValues$2l({}, theme.fn.fontStyles()), {
      backgroundColor: "transparent",
      border: 0,
      boxSizing: "border-box",
      position: "absolute",
      display: "block",
      width: "calc(100% - ".concat(rightSectionWidth, "px)"),
      paddingLeft: theme.fn.size({
        size: size,
        sizes: sizes$2
      }) / 3,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      height: theme.fn.size({
        size: size,
        sizes: sizes$2
      }) - 2,
      lineHeight: "".concat(theme.fn.size({
        size: size,
        sizes: sizes$2
      }) - 2, "px"),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      "&:focus": {
        outline: 0
      },
      "&:disabled": {
        cursor: "not-allowed"
      },
      "&::placeholder": {
        opacity: 1,
        userSelect: "none",
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
      }
    }),
    invalid: {
      color: theme.colors.red[theme.colorScheme === "dark" ? 6 : 7],
      "&::placeholder": {
        opacity: 1,
        color: theme.colors.red[theme.colorScheme === "dark" ? 6 : 7]
      }
    },
    withIcon: {
      paddingLeft: "".concat(theme.fn.size({
        size: size,
        sizes: sizes$2
      }), "px !important")
    }
  };
});
var __defProp$2m = Object.defineProperty;
var __defProps$12 = Object.defineProperties;
var __getOwnPropDescs$12 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2n = Object.getOwnPropertySymbols;
var __hasOwnProp$2n = Object.prototype.hasOwnProperty;
var __propIsEnum$2n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2m = function __defNormalProp$2m(obj, key, value) {
  return key in obj ? __defProp$2m(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2m = function __spreadValues$2m(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2n.call(b, prop)) __defNormalProp$2m(a, prop, b[prop]);
  if (__getOwnPropSymbols$2n) {
    var _iterator222 = _createForOfIteratorHelper(__getOwnPropSymbols$2n(b)),
      _step223;
    try {
      for (_iterator222.s(); !(_step223 = _iterator222.n()).done;) {
        var prop = _step223.value;
        if (__propIsEnum$2n.call(b, prop)) __defNormalProp$2m(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator222.e(err);
    } finally {
      _iterator222.f();
    }
  }
  return a;
};
var __spreadProps$12 = function __spreadProps$12(a, b) {
  return __defProps$12(a, __getOwnPropDescs$12(b));
};
var __objRest$1n = function __objRest$1n(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2n.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2n) {
    var _iterator223 = _createForOfIteratorHelper(__getOwnPropSymbols$2n(source)),
      _step224;
    try {
      for (_iterator223.s(); !(_step224 = _iterator223.n()).done;) {
        var prop = _step224.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2n.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator223.e(err);
    } finally {
      _iterator223.f();
    }
  }
  return target;
};
var buttonSizes$1 = {
  xs: 22,
  sm: 28,
  md: 26,
  lg: 32,
  xl: 40
};
var iconSizes$4 = {
  xs: 12,
  sm: 15,
  md: 17,
  lg: 19,
  xl: 21
};
var rightSectionSizes = {
  xs: 28,
  sm: 34,
  md: 34,
  lg: 44,
  xl: 54
};
var defaultProps$W = {
  size: "sm",
  toggleTabIndex: -1,
  visibilityToggleIcon: PasswordToggleIcon,
  __staticSelector: "PasswordInput"
};
var PasswordInput = forwardRef(function (props, ref) {
  var _cx11;
  var _a = useMantineDefaultProps("PasswordInput", defaultProps$W, props),
    radius = _a.radius,
    disabled = _a.disabled,
    size = _a.size,
    toggleTabIndex = _a.toggleTabIndex,
    className = _a.className,
    id = _a.id,
    label = _a.label,
    error = _a.error,
    required = _a.required,
    style = _a.style,
    icon = _a.icon,
    description = _a.description,
    wrapperProps = _a.wrapperProps,
    classNames = _a.classNames,
    styles = _a.styles,
    variant = _a.variant,
    VisibilityToggleIcon = _a.visibilityToggleIcon,
    __staticSelector = _a.__staticSelector,
    _rightSection = _a.rightSection,
    _rightSectionWidth = _a.rightSectionWidth,
    _rightSectionProps = _a.rightSectionProps,
    sx = _a.sx,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    errorProps = _a.errorProps,
    others = __objRest$1n(_a, ["radius", "disabled", "size", "toggleTabIndex", "className", "id", "label", "error", "required", "style", "icon", "description", "wrapperProps", "classNames", "styles", "variant", "visibilityToggleIcon", "__staticSelector", "rightSection", "rightSectionWidth", "rightSectionProps", "sx", "labelProps", "descriptionProps", "errorProps"]);
  var theme = useMantineTheme();
  var rightSectionWidth = theme.fn.size({
    size: size,
    sizes: rightSectionSizes
  });
  var _useStyles$10 = useStyles$10({
      size: size,
      rightSectionWidth: rightSectionWidth
    }, {
      name: "PasswordInput",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$10.classes,
    cx = _useStyles$10.cx;
  var uuid = useUuid(id);
  var _extractSystemStyles12 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles12.systemStyles,
    rest = _extractSystemStyles12.rest;
  var _useBooleanToggle = useBooleanToggle(false),
    _useBooleanToggle2 = _slicedToArray(_useBooleanToggle, 2),
    reveal = _useBooleanToggle2[0],
    toggle = _useBooleanToggle2[1];
  var rightSection = /* @__PURE__ */React__default.createElement(ActionIcon, {
    className: classes.visibilityToggle,
    tabIndex: toggleTabIndex,
    radius: radius,
    size: theme.fn.size({
      size: size,
      sizes: buttonSizes$1
    }),
    "aria-hidden": true,
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggle();
    },
    onKeyDown: function onKeyDown(event) {
      if (event.nativeEvent.code === "Space") {
        event.preventDefault();
        toggle();
      }
    }
  }, /* @__PURE__ */React__default.createElement(VisibilityToggleIcon, {
    reveal: reveal,
    size: theme.fn.size({
      size: size,
      sizes: iconSizes$4
    })
  }));
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$2m(__spreadValues$2m({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    size: size,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement(Input, {
    component: "div",
    invalid: !!error,
    icon: icon,
    size: size,
    classNames: __spreadProps$12(__spreadValues$2m({}, classNames), {
      input: classes.input
    }),
    styles: styles,
    radius: radius,
    disabled: disabled,
    __staticSelector: __staticSelector,
    rightSectionWidth: rightSectionWidth,
    rightSection: !disabled && rightSection,
    variant: variant
  }, /* @__PURE__ */React__default.createElement("input", __spreadValues$2m({
    type: reveal ? "text" : "password",
    required: required,
    className: cx(classes.innerInput, (_cx11 = {}, _defineProperty(_cx11, classes.withIcon, icon), _defineProperty(_cx11, classes.invalid, !!error), _cx11)),
    disabled: disabled,
    id: uuid,
    ref: ref
  }, rest))));
});
PasswordInput.displayName = "@mantine/core/PasswordInput";
var useStyles$11 = createStyles(function (theme, _ref133) {
  var radius = _ref133.radius,
    shadow = _ref133.shadow,
    spacing = _ref133.spacing,
    width = _ref133.width;
  return {
    title: {},
    wrapper: {
      outline: 0
    },
    popover: {
      background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      pointerEvents: "all",
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }),
      width: width
    },
    body: {
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]),
      boxShadow: shadow in theme.shadows ? theme.shadows[shadow] : shadow,
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      })
    },
    inner: {
      padding: theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      })
    },
    header: {
      borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[2]),
      padding: "".concat(theme.spacing.xs / 1.5, "px ").concat(theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      }), "px"),
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    close: {
      position: "absolute",
      top: 7,
      zIndex: 2,
      right: 10
    }
  };
});
var __defProp$2n = Object.defineProperty;
var __getOwnPropSymbols$2o = Object.getOwnPropertySymbols;
var __hasOwnProp$2o = Object.prototype.hasOwnProperty;
var __propIsEnum$2o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2n = function __defNormalProp$2n(obj, key, value) {
  return key in obj ? __defProp$2n(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2n = function __spreadValues$2n(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2o.call(b, prop)) __defNormalProp$2n(a, prop, b[prop]);
  if (__getOwnPropSymbols$2o) {
    var _iterator224 = _createForOfIteratorHelper(__getOwnPropSymbols$2o(b)),
      _step225;
    try {
      for (_iterator224.s(); !(_step225 = _iterator224.n()).done;) {
        var prop = _step225.value;
        if (__propIsEnum$2o.call(b, prop)) __defNormalProp$2n(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator224.e(err);
    } finally {
      _iterator224.f();
    }
  }
  return a;
};
var __objRest$1o = function __objRest$1o(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2o.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2o) {
    var _iterator225 = _createForOfIteratorHelper(__getOwnPropSymbols$2o(source)),
      _step226;
    try {
      for (_iterator225.s(); !(_step226 = _iterator225.n()).done;) {
        var prop = _step226.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2o.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator225.e(err);
    } finally {
      _iterator225.f();
    }
  }
  return target;
};
var PopoverBody = forwardRef(function (_a, ref) {
  var _b = _a,
    classNames = _b.classNames,
    styles = _b.styles,
    shadow = _b.shadow,
    spacing = _b.spacing,
    radius = _b.radius,
    withCloseButton = _b.withCloseButton,
    title = _b.title,
    titleId = _b.titleId,
    bodyId = _b.bodyId,
    onClose = _b.onClose,
    closeButtonLabel = _b.closeButtonLabel,
    children = _b.children,
    width = _b.width,
    others = __objRest$1o(_b, ["classNames", "styles", "shadow", "spacing", "radius", "withCloseButton", "title", "titleId", "bodyId", "onClose", "closeButtonLabel", "children", "width"]);
  var _useStyles$11 = useStyles$11({
      shadow: shadow,
      radius: radius,
      spacing: spacing,
      width: width
    }, {
      classNames: classNames,
      styles: styles,
      name: "Popover"
    }),
    classes = _useStyles$11.classes;
  return /* @__PURE__ */React__default.createElement("div", __spreadValues$2n({
    role: "dialog",
    tabIndex: -1,
    "aria-labelledby": titleId,
    "aria-describedby": bodyId,
    className: classes.wrapper,
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: classes.popover
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.body
  }, !!title && /* @__PURE__ */React__default.createElement("div", {
    className: classes.header
  }, /* @__PURE__ */React__default.createElement(Text, {
    size: "sm",
    id: titleId,
    className: classes.title
  }, title)), withCloseButton && /* @__PURE__ */React__default.createElement(CloseButton, {
    size: "sm",
    onClick: onClose,
    "aria-label": closeButtonLabel,
    className: classes.close
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.inner,
    id: bodyId
  }, children))));
});
PopoverBody.displayName = "@mantine/core/PopoverBody";
var sizes$g = {
  xs: 3,
  sm: 5,
  md: 8,
  lg: 12,
  xl: 16
};
var stripesAnimation = keyframes({
  from: {
    backgroundPosition: "0 0"
  },
  to: {
    backgroundPosition: "40px 0"
  }
});
var useStyles$13 = createStyles(function (theme, _ref134) {
  var color = _ref134.color,
    radius = _ref134.radius,
    size = _ref134.size,
    striped = _ref134.striped,
    animate = _ref134.animate;
  return {
    root: {
      position: "relative",
      height: theme.fn.size({
        size: size,
        sizes: sizes$g
      }),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }),
      overflow: "hidden"
    },
    bar: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: theme.fn.themeColor(color || theme.primaryColor, theme.fn.primaryShade(), false),
      transition: "width 100ms linear",
      animation: animate ? "".concat(stripesAnimation, " 1000ms linear infinite") : "none",
      backgroundSize: "20px 20px",
      backgroundImage: striped ? "linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)" : "none",
      "&:last-of-type": {
        borderTopRightRadius: theme.fn.size({
          size: radius,
          sizes: theme.radius
        }),
        borderBottomRightRadius: theme.fn.size({
          size: radius,
          sizes: theme.radius
        })
      },
      "&:first-of-type": {
        borderTopLeftRadius: theme.fn.size({
          size: radius,
          sizes: theme.radius
        }),
        borderBottomLeftRadius: theme.fn.size({
          size: radius,
          sizes: theme.radius
        })
      },
      "@media (prefers-reduced-motion)": {
        transitionDuration: "0ms"
      }
    },
    label: {
      color: theme.white,
      fontSize: theme.fn.size({
        size: size,
        sizes: sizes$g
      }) * 0.65,
      fontWeight: 700,
      userSelect: "none",
      overflow: "hidden",
      whiteSpace: "nowrap"
    }
  };
});
var __defProp$2p = Object.defineProperty;
var __defProps$13 = Object.defineProperties;
var __getOwnPropDescs$13 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2q = Object.getOwnPropertySymbols;
var __hasOwnProp$2q = Object.prototype.hasOwnProperty;
var __propIsEnum$2q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2p = function __defNormalProp$2p(obj, key, value) {
  return key in obj ? __defProp$2p(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2p = function __spreadValues$2p(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2q.call(b, prop)) __defNormalProp$2p(a, prop, b[prop]);
  if (__getOwnPropSymbols$2q) {
    var _iterator226 = _createForOfIteratorHelper(__getOwnPropSymbols$2q(b)),
      _step227;
    try {
      for (_iterator226.s(); !(_step227 = _iterator226.n()).done;) {
        var prop = _step227.value;
        if (__propIsEnum$2q.call(b, prop)) __defNormalProp$2p(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator226.e(err);
    } finally {
      _iterator226.f();
    }
  }
  return a;
};
var __spreadProps$13 = function __spreadProps$13(a, b) {
  return __defProps$13(a, __getOwnPropDescs$13(b));
};
var __objRest$1q = function __objRest$1q(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2q) {
    var _iterator227 = _createForOfIteratorHelper(__getOwnPropSymbols$2q(source)),
      _step228;
    try {
      for (_iterator227.s(); !(_step228 = _iterator227.n()).done;) {
        var prop = _step228.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2q.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator227.e(err);
    } finally {
      _iterator227.f();
    }
  }
  return target;
};
function getCumulativeSections(sections) {
  return sections.reduce(function (acc, section) {
    acc.sections.push(__spreadProps$13(__spreadValues$2p({}, section), {
      accumulated: acc.accumulated
    }));
    acc.accumulated += section.value;
    return acc;
  }, {
    accumulated: 0,
    sections: []
  }).sections;
}
var defaultProps$Y = {
  size: "md",
  radius: "sm",
  striped: false,
  animate: false,
  label: ""
};
var Progress = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Progress", defaultProps$Y, props),
    className = _a.className,
    value = _a.value,
    color = _a.color,
    size = _a.size,
    radius = _a.radius,
    striped = _a.striped,
    animate = _a.animate,
    label = _a.label,
    ariaLabel = _a["aria-label"],
    classNames = _a.classNames,
    styles = _a.styles,
    sections = _a.sections,
    others = __objRest$1q(_a, ["className", "value", "color", "size", "radius", "striped", "animate", "label", "aria-label", "classNames", "styles", "sections"]);
  var _useStyles$12 = useStyles$13({
      color: color,
      size: size,
      radius: radius,
      striped: striped || animate,
      animate: animate
    }, {
      classNames: classNames,
      styles: styles,
      name: "Progress"
    }),
    classes = _useStyles$12.classes,
    cx = _useStyles$12.cx,
    theme = _useStyles$12.theme;
  var segments = Array.isArray(sections) ? getCumulativeSections(sections).map(function (section, index) {
    return /* @__PURE__ */React__default.createElement(Box, {
      key: index,
      className: classes.bar,
      sx: {
        width: "".concat(section.value, "%"),
        left: "".concat(section.accumulated, "%"),
        backgroundColor: theme.fn.themeColor(section.color, theme.fn.primaryShade(), false)
      }
    }, section.label && /* @__PURE__ */React__default.createElement(Text, {
      className: classes.label
    }, section.label));
  }) : null;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2p({
    className: cx(classes.root, className),
    ref: ref
  }, others), segments || /* @__PURE__ */React__default.createElement("div", {
    role: "progressbar",
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": value,
    "aria-label": ariaLabel,
    className: classes.bar,
    style: {
      width: "".concat(value, "%")
    }
  }, label ? /* @__PURE__ */React__default.createElement(Text, {
    className: classes.label
  }, label) : ""));
});
Progress.displayName = "@mantine/core/Progress";
var __defProp$2q = Object.defineProperty;
var __getOwnPropSymbols$2r = Object.getOwnPropertySymbols;
var __hasOwnProp$2r = Object.prototype.hasOwnProperty;
var __propIsEnum$2r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2q = function __defNormalProp$2q(obj, key, value) {
  return key in obj ? __defProp$2q(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2q = function __spreadValues$2q(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2r.call(b, prop)) __defNormalProp$2q(a, prop, b[prop]);
  if (__getOwnPropSymbols$2r) {
    var _iterator228 = _createForOfIteratorHelper(__getOwnPropSymbols$2r(b)),
      _step229;
    try {
      for (_iterator228.s(); !(_step229 = _iterator228.n()).done;) {
        var prop = _step229.value;
        if (__propIsEnum$2r.call(b, prop)) __defNormalProp$2q(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator228.e(err);
    } finally {
      _iterator228.f();
    }
  }
  return a;
};
function RadioIcon(props) {
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$2q({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 5 5"
  }, props), /* @__PURE__ */React__default.createElement("path", {
    fill: "currentColor",
    d: "M0 2.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z"
  }));
}
var __defProp$2r = Object.defineProperty;
var __defProps$14 = Object.defineProperties;
var __getOwnPropDescs$14 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2s = Object.getOwnPropertySymbols;
var __hasOwnProp$2s = Object.prototype.hasOwnProperty;
var __propIsEnum$2s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2r = function __defNormalProp$2r(obj, key, value) {
  return key in obj ? __defProp$2r(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2r = function __spreadValues$2r(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2s.call(b, prop)) __defNormalProp$2r(a, prop, b[prop]);
  if (__getOwnPropSymbols$2s) {
    var _iterator229 = _createForOfIteratorHelper(__getOwnPropSymbols$2s(b)),
      _step230;
    try {
      for (_iterator229.s(); !(_step230 = _iterator229.n()).done;) {
        var prop = _step230.value;
        if (__propIsEnum$2s.call(b, prop)) __defNormalProp$2r(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator229.e(err);
    } finally {
      _iterator229.f();
    }
  }
  return a;
};
var __spreadProps$14 = function __spreadProps$14(a, b) {
  return __defProps$14(a, __getOwnPropDescs$14(b));
};
var sizes$h = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 36
};
var useStyles$14 = createStyles(function (theme, _ref135, getRef) {
  var size = _ref135.size,
    color = _ref135.color,
    transitionDuration = _ref135.transitionDuration;
  var labelDisabled = {
    ref: getRef("labelDisabled")
  };
  var colors = theme.fn.variant({
    variant: "filled",
    color: color
  });
  return {
    labelDisabled: labelDisabled,
    radioWrapper: {
      display: "flex",
      alignItems: "center",
      WebkitTapHighlightColor: "transparent"
    },
    inner: {
      position: "relative"
    },
    icon: {
      ref: getRef("icon"),
      color: theme.white,
      opacity: 0,
      transform: "scale(0.75) translateY(2px)",
      transition: "opacity ".concat(transitionDuration, "ms ").concat(theme.transitionTimingFunction),
      pointerEvents: "none",
      width: theme.fn.size({
        sizes: sizes$h,
        size: size
      }) / 2,
      height: theme.fn.size({
        sizes: sizes$h,
        size: size
      }) / 2,
      position: "absolute",
      top: "calc(50% - ".concat(theme.fn.size({
        sizes: sizes$h,
        size: size
      }) / 4, "px)"),
      left: "calc(50% - ".concat(theme.fn.size({
        sizes: sizes$h,
        size: size
      }) / 4, "px)")
    },
    radio: __spreadProps$14(__spreadValues$2r({}, theme.fn.focusStyles()), {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.white,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]),
      position: "relative",
      appearance: "none",
      width: theme.fn.size({
        sizes: sizes$h,
        size: size
      }),
      height: theme.fn.size({
        sizes: sizes$h,
        size: size
      }),
      borderRadius: theme.fn.size({
        sizes: sizes$h,
        size: size
      }),
      margin: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transitionProperty: "background-color, border-color",
      transitionTimingFunction: theme.transitionTimingFunction,
      transitionDuration: "".concat(transitionDuration, "ms"),
      "&:checked": _defineProperty({
        background: colors.background,
        borderColor: colors.background
      }, "& + .".concat(getRef("icon")), {
        opacity: 1,
        transform: "scale(1)"
      }),
      "&:disabled": _defineProperty({
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[4],
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]
      }, "& + .".concat(getRef("icon")), {
        color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[4]
      })
    }),
    label: __spreadProps$14(__spreadValues$2r({}, theme.fn.fontStyles()), _defineProperty({
      display: "flex",
      alignItems: "flex-start",
      fontSize: theme.fontSizes[size] || theme.fontSizes.md,
      lineHeight: "".concat(theme.fn.size({
        sizes: sizes$h,
        size: size
      }), "px"),
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      marginLeft: theme.spacing.sm
    }, "&.".concat(labelDisabled.ref), {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
    }))
  };
});
var __defProp$2s = Object.defineProperty;
var __getOwnPropSymbols$2t = Object.getOwnPropertySymbols;
var __hasOwnProp$2t = Object.prototype.hasOwnProperty;
var __propIsEnum$2t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2s = function __defNormalProp$2s(obj, key, value) {
  return key in obj ? __defProp$2s(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2s = function __spreadValues$2s(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2t.call(b, prop)) __defNormalProp$2s(a, prop, b[prop]);
  if (__getOwnPropSymbols$2t) {
    var _iterator230 = _createForOfIteratorHelper(__getOwnPropSymbols$2t(b)),
      _step231;
    try {
      for (_iterator230.s(); !(_step231 = _iterator230.n()).done;) {
        var prop = _step231.value;
        if (__propIsEnum$2t.call(b, prop)) __defNormalProp$2s(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator230.e(err);
    } finally {
      _iterator230.f();
    }
  }
  return a;
};
var __objRest$1r = function __objRest$1r(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2t.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2t) {
    var _iterator231 = _createForOfIteratorHelper(__getOwnPropSymbols$2t(source)),
      _step232;
    try {
      for (_iterator231.s(); !(_step232 = _iterator231.n()).done;) {
        var prop = _step232.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2t.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator231.e(err);
    } finally {
      _iterator231.f();
    }
  }
  return target;
};
var defaultProps$Z = {
  __staticSelector: "Radio",
  icon: RadioIcon,
  transitionDuration: 100
};
var Radio = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Radio", defaultProps$Z, props),
    className = _a.className,
    style = _a.style,
    id = _a.id,
    label = _a.label,
    size = _a.size,
    title = _a.title,
    disabled = _a.disabled,
    color = _a.color,
    classNames = _a.classNames,
    styles = _a.styles,
    __staticSelector = _a.__staticSelector,
    sx = _a.sx,
    Icon = _a.icon,
    transitionDuration = _a.transitionDuration,
    others = __objRest$1r(_a, ["className", "style", "id", "label", "size", "title", "disabled", "color", "classNames", "styles", "__staticSelector", "sx", "icon", "transitionDuration"]);
  var _useStyles$13 = useStyles$14({
      color: color,
      size: size,
      transitionDuration: transitionDuration
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$13.classes,
    cx = _useStyles$13.cx;
  var _extractSystemStyles13 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles13.systemStyles,
    rest = _extractSystemStyles13.rest;
  var uuid = useUuid(id);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2s({
    className: cx(classes.radioWrapper, className),
    style: style,
    title: title,
    sx: sx
  }, systemStyles), /* @__PURE__ */React__default.createElement("div", {
    className: classes.inner
  }, /* @__PURE__ */React__default.createElement("input", __spreadValues$2s({
    ref: ref,
    className: classes.radio,
    type: "radio",
    id: uuid,
    disabled: disabled
  }, rest)), /* @__PURE__ */React__default.createElement(Icon, {
    className: classes.icon,
    "aria-hidden": true
  })), label && /* @__PURE__ */React__default.createElement("label", {
    className: cx(classes.label, _defineProperty({}, classes.labelDisabled, disabled)),
    htmlFor: uuid
  }, label));
});
Radio.displayName = "@mantine/core/Radio";
var __defProp$2t = Object.defineProperty;
var __getOwnPropSymbols$2u = Object.getOwnPropertySymbols;
var __hasOwnProp$2u = Object.prototype.hasOwnProperty;
var __propIsEnum$2u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2t = function __defNormalProp$2t(obj, key, value) {
  return key in obj ? __defProp$2t(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2t = function __spreadValues$2t(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2u.call(b, prop)) __defNormalProp$2t(a, prop, b[prop]);
  if (__getOwnPropSymbols$2u) {
    var _iterator232 = _createForOfIteratorHelper(__getOwnPropSymbols$2u(b)),
      _step233;
    try {
      for (_iterator232.s(); !(_step233 = _iterator232.n()).done;) {
        var prop = _step233.value;
        if (__propIsEnum$2u.call(b, prop)) __defNormalProp$2t(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator232.e(err);
    } finally {
      _iterator232.f();
    }
  }
  return a;
};
var __objRest$1s = function __objRest$1s(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2u.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2u) {
    var _iterator233 = _createForOfIteratorHelper(__getOwnPropSymbols$2u(source)),
      _step234;
    try {
      for (_iterator233.s(); !(_step234 = _iterator233.n()).done;) {
        var prop = _step234.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2u.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator233.e(err);
    } finally {
      _iterator233.f();
    }
  }
  return target;
};
var defaultProps$_ = {
  orientation: "horizontal",
  spacing: "sm"
};
var RadioGroup = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("RadioGroup", defaultProps$_, props),
    id = _a.id,
    name = _a.name,
    children = _a.children,
    value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    orientation = _a.orientation,
    spacing = _a.spacing,
    color = _a.color,
    size = _a.size,
    classNames = _a.classNames,
    styles = _a.styles,
    wrapperProps = _a.wrapperProps,
    errorProps = _a.errorProps,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    others = __objRest$1s(_a, ["id", "name", "children", "value", "defaultValue", "onChange", "orientation", "spacing", "color", "size", "classNames", "styles", "wrapperProps", "errorProps", "labelProps", "descriptionProps"]);
  var rootId = useUuid(id);
  var uuid = useUuid(name);
  var _useUncontrolled21 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: "",
      onChange: onChange,
      rule: function rule(val) {
        return typeof val === "string";
      }
    }),
    _useUncontrolled22 = _slicedToArray(_useUncontrolled21, 2),
    _value = _useUncontrolled22[0],
    setValue = _useUncontrolled22[1];
  var radios = filterChildrenByType(children, Radio).map(function (radio, index) {
    return cloneElement(radio, {
      key: index,
      checked: _value === radio.props.value,
      name: uuid,
      color: color,
      size: size,
      classNames: classNames,
      styles: styles,
      __staticSelector: "RadioGroup",
      onChange: function onChange(event) {
        return setValue(event.currentTarget.value);
      }
    });
  });
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$2t(__spreadValues$2t({
    id: rootId,
    labelElement: "div",
    size: size,
    __staticSelector: "RadioGroup",
    classNames: classNames,
    styles: styles,
    ref: ref,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, wrapperProps), others), /* @__PURE__ */React__default.createElement(Group, {
    role: "radiogroup",
    "aria-labelledby": "".concat(rootId, "-label"),
    spacing: spacing,
    direction: orientation === "horizontal" ? "row" : "column",
    style: {
      paddingTop: 5
    }
  }, radios));
});
RadioGroup.displayName = "@mantine/core/RadioGroup";
function getCurveProps(_ref136) {
  var size = _ref136.size,
    thickness = _ref136.thickness,
    sum = _ref136.sum,
    value = _ref136.value,
    root = _ref136.root,
    offset = _ref136.offset;
  var radius = (size * 0.9 - thickness * 2) / 2;
  var deg = Math.PI * radius * 2 / 100;
  var strokeDasharray = root ? "".concat((100 - sum) * deg, ", ").concat(sum * deg) : "".concat(value * deg, ", ").concat((100 - value) * deg);
  return {
    strokeWidth: thickness,
    cx: size / 2,
    cy: size / 2,
    r: radius,
    transform: root ? "scale(1, -1) translate(0, -".concat(size, ")") : null,
    strokeDasharray: strokeDasharray,
    strokeDashoffset: root ? 0 : offset
  };
}
var __defProp$2u = Object.defineProperty;
var __getOwnPropSymbols$2v = Object.getOwnPropertySymbols;
var __hasOwnProp$2v = Object.prototype.hasOwnProperty;
var __propIsEnum$2v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2u = function __defNormalProp$2u(obj, key, value) {
  return key in obj ? __defProp$2u(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2u = function __spreadValues$2u(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2v.call(b, prop)) __defNormalProp$2u(a, prop, b[prop]);
  if (__getOwnPropSymbols$2v) {
    var _iterator234 = _createForOfIteratorHelper(__getOwnPropSymbols$2v(b)),
      _step235;
    try {
      for (_iterator234.s(); !(_step235 = _iterator234.n()).done;) {
        var prop = _step235.value;
        if (__propIsEnum$2v.call(b, prop)) __defNormalProp$2u(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator234.e(err);
    } finally {
      _iterator234.f();
    }
  }
  return a;
};
function Curve(_ref137) {
  var size = _ref137.size,
    value = _ref137.value,
    offset = _ref137.offset,
    sum = _ref137.sum,
    thickness = _ref137.thickness,
    root = _ref137.root,
    color = _ref137.color,
    lineRoundCaps = _ref137.lineRoundCaps;
  var theme = useMantineTheme();
  var stroke = theme.fn.themeColor(color || (theme.colorScheme === "dark" ? "dark" : "gray"), color ? theme.fn.primaryShade() : theme.colorScheme === "dark" ? 4 : 1, false);
  return /* @__PURE__ */React__default.createElement("circle", __spreadValues$2u({
    fill: "none",
    strokeLinecap: lineRoundCaps ? "round" : "butt",
    stroke: stroke
  }, getCurveProps({
    sum: sum,
    size: size,
    thickness: thickness,
    value: value,
    offset: offset,
    root: root
  })));
}
Curve.displayName = "@mantine/core/Curve";
var __defProp$2v = Object.defineProperty;
var __defProps$15 = Object.defineProperties;
var __getOwnPropDescs$15 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2w = Object.getOwnPropertySymbols;
var __hasOwnProp$2w = Object.prototype.hasOwnProperty;
var __propIsEnum$2w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2v = function __defNormalProp$2v(obj, key, value) {
  return key in obj ? __defProp$2v(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2v = function __spreadValues$2v(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2w.call(b, prop)) __defNormalProp$2v(a, prop, b[prop]);
  if (__getOwnPropSymbols$2w) {
    var _iterator235 = _createForOfIteratorHelper(__getOwnPropSymbols$2w(b)),
      _step236;
    try {
      for (_iterator235.s(); !(_step236 = _iterator235.n()).done;) {
        var prop = _step236.value;
        if (__propIsEnum$2w.call(b, prop)) __defNormalProp$2v(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator235.e(err);
    } finally {
      _iterator235.f();
    }
  }
  return a;
};
var __spreadProps$15 = function __spreadProps$15(a, b) {
  return __defProps$15(a, __getOwnPropDescs$15(b));
};
function getCurves(_ref138) {
  var size = _ref138.size,
    thickness = _ref138.thickness,
    sections = _ref138.sections,
    renderRoundedLineCaps = _ref138.renderRoundedLineCaps;
  var sum = sections.reduce(function (acc, current) {
    return acc + current.value;
  }, 0);
  var accumulated = Math.PI * ((size * 0.9 - thickness * 2) / 2) * 2;
  var offset = accumulated;
  var curves = [];
  var curvesInOrder = [];
  for (var _i12 = 0; _i12 < sections.length; _i12 += 1) {
    curves.push({
      sum: sum,
      offset: offset,
      data: sections[_i12],
      root: false
    });
    offset -= sections[_i12].value / 100 * accumulated;
  }
  curves.push({
    sum: sum,
    offset: offset,
    data: null,
    root: true
  });
  curvesInOrder.push(__spreadProps$15(__spreadValues$2v({}, curves[curves.length - 1]), {
    lineRoundCaps: false
  }));
  if (curves.length > 2) {
    curvesInOrder.push(__spreadProps$15(__spreadValues$2v({}, curves[0]), {
      lineRoundCaps: renderRoundedLineCaps
    }));
    curvesInOrder.push(__spreadProps$15(__spreadValues$2v({}, curves[curves.length - 2]), {
      lineRoundCaps: renderRoundedLineCaps
    }));
    for (var _i13 = 1; _i13 <= curves.length - 3; _i13 += 1) {
      curvesInOrder.push(__spreadProps$15(__spreadValues$2v({}, curves[_i13]), {
        lineRoundCaps: false
      }));
    }
  } else {
    curvesInOrder.push(__spreadProps$15(__spreadValues$2v({}, curves[0]), {
      lineRoundCaps: renderRoundedLineCaps
    }));
  }
  return curvesInOrder;
}
var useStyles$15 = createStyles({
  root: {
    position: "relative"
  },
  label: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var __defProp$2w = Object.defineProperty;
var __getOwnPropSymbols$2x = Object.getOwnPropertySymbols;
var __hasOwnProp$2x = Object.prototype.hasOwnProperty;
var __propIsEnum$2x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2w = function __defNormalProp$2w(obj, key, value) {
  return key in obj ? __defProp$2w(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2w = function __spreadValues$2w(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2x.call(b, prop)) __defNormalProp$2w(a, prop, b[prop]);
  if (__getOwnPropSymbols$2x) {
    var _iterator236 = _createForOfIteratorHelper(__getOwnPropSymbols$2x(b)),
      _step237;
    try {
      for (_iterator236.s(); !(_step237 = _iterator236.n()).done;) {
        var prop = _step237.value;
        if (__propIsEnum$2x.call(b, prop)) __defNormalProp$2w(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator236.e(err);
    } finally {
      _iterator236.f();
    }
  }
  return a;
};
var __objRest$1t = function __objRest$1t(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2x.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2x) {
    var _iterator237 = _createForOfIteratorHelper(__getOwnPropSymbols$2x(source)),
      _step238;
    try {
      for (_iterator237.s(); !(_step238 = _iterator237.n()).done;) {
        var prop = _step238.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2x.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator237.e(err);
    } finally {
      _iterator237.f();
    }
  }
  return target;
};
var defaultProps$10 = {
  size: 120,
  thickness: 12
};
var RingProgress = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("RingProgress", defaultProps$10, props),
    className = _a.className,
    style = _a.style,
    label = _a.label,
    sections = _a.sections,
    size = _a.size,
    thickness = _a.thickness,
    classNames = _a.classNames,
    styles = _a.styles,
    roundCaps = _a.roundCaps,
    others = __objRest$1t(_a, ["className", "style", "label", "sections", "size", "thickness", "classNames", "styles", "roundCaps"]);
  var _useStyles$14 = useStyles$15(null, {
      classNames: classNames,
      styles: styles,
      name: "RingProgress"
    }),
    classes = _useStyles$14.classes,
    cx = _useStyles$14.cx;
  var curves = getCurves({
    size: size,
    thickness: thickness,
    sections: sections,
    renderRoundedLineCaps: roundCaps
  }).map(function (curve, index) {
    var _a2, _b;
    return /* @__PURE__ */React__default.createElement(Curve, {
      key: index,
      value: (_a2 = curve.data) == null ? void 0 : _a2.value,
      size: size,
      thickness: thickness,
      sum: curve.sum,
      offset: curve.offset,
      color: (_b = curve.data) == null ? void 0 : _b.color,
      root: curve.root,
      lineRoundCaps: curve.lineRoundCaps
    });
  });
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2w({
    style: __spreadValues$2w({
      width: size,
      height: size
    }, style),
    className: cx(classes.root, className),
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("svg", {
    width: size,
    height: size,
    style: {
      transform: "rotate(-90deg)"
    }
  }, curves), label && /* @__PURE__ */React__default.createElement("div", {
    className: classes.label,
    style: {
      right: thickness * 2,
      left: thickness * 2
    }
  }, label));
});
RingProgress.displayName = "@mantine/core/RingProgress";
var __defProp$2x = Object.defineProperty;
var __defProps$16 = Object.defineProperties;
var __getOwnPropDescs$16 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2y = Object.getOwnPropertySymbols;
var __hasOwnProp$2y = Object.prototype.hasOwnProperty;
var __propIsEnum$2y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2x = function __defNormalProp$2x(obj, key, value) {
  return key in obj ? __defProp$2x(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2x = function __spreadValues$2x(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2y.call(b, prop)) __defNormalProp$2x(a, prop, b[prop]);
  if (__getOwnPropSymbols$2y) {
    var _iterator238 = _createForOfIteratorHelper(__getOwnPropSymbols$2y(b)),
      _step239;
    try {
      for (_iterator238.s(); !(_step239 = _iterator238.n()).done;) {
        var prop = _step239.value;
        if (__propIsEnum$2y.call(b, prop)) __defNormalProp$2x(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator238.e(err);
    } finally {
      _iterator238.f();
    }
  }
  return a;
};
var __spreadProps$16 = function __spreadProps$16(a, b) {
  return __defProps$16(a, __getOwnPropDescs$16(b));
};
var WRAPPER_PADDING = 4;
var sizes$i = {
  xs: "3px 6px",
  sm: "5px 10px",
  md: "7px 14px",
  lg: "9px 16px",
  xl: "12px 20px"
};
var useStyles$16 = createStyles(function (theme, _ref139, getRef) {
  var _focus2, _controlActive;
  var fullWidth = _ref139.fullWidth,
    color = _ref139.color,
    radius = _ref139.radius,
    shouldAnimate = _ref139.shouldAnimate,
    transitionDuration = _ref139.transitionDuration,
    transitionTimingFunction = _ref139.transitionTimingFunction,
    size = _ref139.size,
    orientation = _ref139.orientation;
  var vertical = orientation === "vertical";
  var colors = theme.fn.variant({
    variant: "filled",
    color: color
  });
  return {
    label: __spreadProps$16(__spreadValues$2x(__spreadValues$2x({
      ref: getRef("label")
    }, theme.fn.focusStyles()), theme.fn.fontStyles()), {
      WebkitTapHighlightColor: "transparent",
      borderRadius: theme.fn.radius(radius),
      fontWeight: 500,
      fontSize: size in theme.fontSizes ? theme.fontSizes[size] : theme.fontSizes.sm,
      cursor: "pointer",
      display: "block",
      textAlign: "center",
      padding: sizes$i[size in sizes$i ? size : "sm"],
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      userSelect: "none",
      color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7],
      transition: "color ".concat(shouldAnimate ? 0 : transitionDuration, "ms ").concat(transitionTimingFunction || theme.transitionTimingFunction),
      "&:hover": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
      }
    }),
    control: {
      ref: getRef("control"),
      position: "relative",
      boxSizing: "border-box",
      flex: 1,
      zIndex: 2,
      transition: "border-left-color ".concat(shouldAnimate ? 0 : transitionDuration, "ms ").concat(transitionTimingFunction || theme.transitionTimingFunction),
      "&:not(:first-of-type)": {
        borderStyle: "solid",
        borderWidth: vertical ? "1px 0 0 0" : "0 0 0 1px",
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
      }
    },
    input: {
      height: 0,
      width: 0,
      position: "absolute",
      overflow: "hidden",
      whiteSpace: "nowrap",
      opacity: 0,
      "&:focus": (_focus2 = {
        outline: "none"
      }, _defineProperty(_focus2, "& + .".concat(getRef("label")), {
        outline: "none",
        boxShadow: theme.focusRing === "always" || theme.focusRing === "auto" ? "0 0 0 2px ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white, ", 0 0 0 4px ").concat(theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5]) : void 0
      }), _defineProperty(_focus2, "&:focus:not(:focus-visible)", _defineProperty({}, "& + .".concat(getRef("label")), {
        boxShadow: theme.focusRing === "auto" || theme.focusRing === "never" ? "none" : void 0
      })), _focus2)
    },
    root: {
      position: "relative",
      display: fullWidth || vertical ? "flex" : "inline-flex",
      width: vertical && !fullWidth ? "max-content" : "auto",
      flexDirection: vertical ? "column" : "row",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[1],
      borderRadius: theme.fn.radius(radius),
      overflow: "hidden",
      padding: WRAPPER_PADDING
    },
    controlActive: (_controlActive = {
      borderLeftColor: "transparent !important",
      borderTopColor: "transparent !important"
    }, _defineProperty(_controlActive, "& + .".concat(getRef("control")), {
      borderLeftColor: "transparent !important",
      borderTopColor: "transparent !important"
    }), _defineProperty(_controlActive, "borderRadius", theme.fn.radius(radius)), _defineProperty(_controlActive, "boxShadow", shouldAnimate ? color || theme.colorScheme === "dark" ? "none" : theme.shadows.xs : void 0), _defineProperty(_controlActive, "backgroundColor", shouldAnimate ? color in theme.colors ? colors.background : theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.white : void 0), _controlActive),
    labelActive: {
      "&, &:hover": {
        color: color in theme.colors || theme.colorScheme === "dark" ? theme.white : theme.black
      }
    },
    disabled: {
      "&, &:hover": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5],
        cursor: "not-allowed"
      }
    },
    active: {
      boxSizing: "border-box",
      borderRadius: theme.fn.radius(radius),
      position: "absolute",
      zIndex: 1,
      boxShadow: color || theme.colorScheme === "dark" ? "none" : theme.shadows.xs,
      transition: "transform ".concat(shouldAnimate ? 0 : transitionDuration, "ms ").concat(theme.transitionTimingFunction, ", width ").concat(shouldAnimate ? 0 : transitionDuration / 2, "ms ").concat(transitionTimingFunction || theme.transitionTimingFunction),
      backgroundColor: color in theme.colors ? colors.background : theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.white
    }
  };
});
var __defProp$2y = Object.defineProperty;
var __getOwnPropSymbols$2z = Object.getOwnPropertySymbols;
var __hasOwnProp$2z = Object.prototype.hasOwnProperty;
var __propIsEnum$2z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2y = function __defNormalProp$2y(obj, key, value) {
  return key in obj ? __defProp$2y(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2y = function __spreadValues$2y(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2z.call(b, prop)) __defNormalProp$2y(a, prop, b[prop]);
  if (__getOwnPropSymbols$2z) {
    var _iterator239 = _createForOfIteratorHelper(__getOwnPropSymbols$2z(b)),
      _step240;
    try {
      for (_iterator239.s(); !(_step240 = _iterator239.n()).done;) {
        var prop = _step240.value;
        if (__propIsEnum$2z.call(b, prop)) __defNormalProp$2y(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator239.e(err);
    } finally {
      _iterator239.f();
    }
  }
  return a;
};
var __objRest$1u = function __objRest$1u(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2z.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2z) {
    var _iterator240 = _createForOfIteratorHelper(__getOwnPropSymbols$2z(source)),
      _step241;
    try {
      for (_iterator240.s(); !(_step241 = _iterator240.n()).done;) {
        var prop = _step241.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2z.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator240.e(err);
    } finally {
      _iterator240.f();
    }
  }
  return target;
};
var defaultProps$11 = {
  disabled: false,
  size: "sm",
  transitionDuration: 200
};
var SegmentedControl = forwardRef(function (props, ref) {
  var _b, _c;
  var _a = useMantineDefaultProps("SegmentedControl", defaultProps$11, props),
    className = _a.className,
    disabled = _a.disabled,
    _data = _a.data,
    name = _a.name,
    value = _a.value,
    onChange = _a.onChange,
    color = _a.color,
    fullWidth = _a.fullWidth,
    radius = _a.radius,
    size = _a.size,
    transitionDuration = _a.transitionDuration,
    transitionTimingFunction = _a.transitionTimingFunction,
    classNames = _a.classNames,
    styles = _a.styles,
    defaultValue = _a.defaultValue,
    orientation = _a.orientation,
    others = __objRest$1u(_a, ["className", "disabled", "data", "name", "value", "onChange", "color", "fullWidth", "radius", "size", "transitionDuration", "transitionTimingFunction", "classNames", "styles", "defaultValue", "orientation"]);
  var reduceMotion = useReducedMotion();
  var data = _data.map(function (item) {
    return typeof item === "string" ? {
      label: item,
      value: item
    } : item;
  });
  var mounted = useRef();
  var _useState123 = useState(false),
    _useState124 = _slicedToArray(_useState123, 2),
    shouldAnimate = _useState124[0],
    setShouldAnimate = _useState124[1];
  var _useUncontrolled23 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: Array.isArray(data) ? (_c = (_b = data.find(function (item) {
        return !item.disabled;
      })) == null ? void 0 : _b.value) != null ? _c : data[0].value : null,
      onChange: onChange,
      rule: function rule(val) {
        return !!val;
      }
    }),
    _useUncontrolled24 = _slicedToArray(_useUncontrolled23, 2),
    _value = _useUncontrolled24[0],
    handleValueChange = _useUncontrolled24[1];
  var _useStyles$15 = useStyles$16({
      size: size,
      fullWidth: fullWidth,
      color: color,
      radius: radius,
      shouldAnimate: reduceMotion || !shouldAnimate,
      transitionDuration: transitionDuration,
      transitionTimingFunction: transitionTimingFunction,
      orientation: orientation
    }, {
      classNames: classNames,
      styles: styles,
      name: "SegmentedControl"
    }),
    classes = _useStyles$15.classes,
    cx = _useStyles$15.cx,
    theme = _useStyles$15.theme;
  var _useState125 = useState({
      width: 0,
      height: 0,
      translate: [0, 0]
    }),
    _useState126 = _slicedToArray(_useState125, 2),
    activePosition = _useState126[0],
    setActivePosition = _useState126[1];
  var uuid = useUuid(name);
  var refs = useRef({});
  var _useResizeObserver = useResizeObserver(),
    _useResizeObserver2 = _slicedToArray(_useResizeObserver, 2),
    observerRef = _useResizeObserver2[0],
    containerRect = _useResizeObserver2[1];
  useIsomorphicEffect(function () {
    if (!mounted.current) {
      mounted.current = true;
      setShouldAnimate(false);
    } else {
      setShouldAnimate(true);
    }
  });
  useEffect(function () {
    if (_value in refs.current && observerRef.current) {
      var element = refs.current[_value];
      var elementRect = element.getBoundingClientRect();
      var scaledValue = element.offsetWidth / elementRect.width;
      var width = elementRect.width * scaledValue || 0;
      var height = elementRect.height * scaledValue || 0;
      var offsetRight = containerRect.width - element.parentElement.offsetLeft + WRAPPER_PADDING - width;
      var offsetLeft = element.parentElement.offsetLeft - WRAPPER_PADDING;
      setActivePosition({
        width: width,
        height: height,
        translate: [theme.dir === "rtl" ? offsetRight : offsetLeft, element.parentElement.offsetTop - WRAPPER_PADDING]
      });
    }
  }, [_value, containerRect]);
  var controls = data.map(function (item) {
    var _cx14;
    return /* @__PURE__ */React__default.createElement("div", {
      className: cx(classes.control, _defineProperty({}, classes.controlActive, _value === item.value)),
      key: item.value
    }, /* @__PURE__ */React__default.createElement("input", {
      className: classes.input,
      disabled: disabled || item.disabled,
      type: "radio",
      name: uuid,
      value: item.value,
      id: "".concat(uuid, "-").concat(item.value),
      checked: _value === item.value,
      onChange: function onChange() {
        return handleValueChange(item.value);
      }
    }), /* @__PURE__ */React__default.createElement("label", {
      className: cx(classes.label, (_cx14 = {}, _defineProperty(_cx14, classes.labelActive, _value === item.value), _defineProperty(_cx14, classes.disabled, disabled || item.disabled), _cx14)),
      htmlFor: "".concat(uuid, "-").concat(item.value),
      ref: function ref(node) {
        refs.current[item.value] = node;
      }
    }, item.label));
  });
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2y({
    className: cx(classes.root, className),
    ref: useMergedRef(observerRef, ref)
  }, others), !!_value && shouldAnimate && /* @__PURE__ */React__default.createElement(Box, {
    component: "span",
    className: classes.active,
    sx: {
      width: activePosition.width,
      height: activePosition.height,
      transform: "translate(".concat(activePosition.translate[0], "px, ").concat(activePosition.translate[1], "px )")
    }
  }), controls);
});
SegmentedControl.displayName = "@mantine/core/SegmentedControl";
function filterData$2(_ref140) {
  var data = _ref140.data,
    searchable = _ref140.searchable,
    limit = _ref140.limit,
    searchValue = _ref140.searchValue,
    filter = _ref140.filter,
    value = _ref140.value,
    filterDataOnExactSearchMatch = _ref140.filterDataOnExactSearchMatch;
  if (!searchable) {
    return data;
  }
  var selected = value != null ? data.find(function (item) {
    return item.value === value;
  }) || null : null;
  if (selected && !filterDataOnExactSearchMatch && (selected == null ? void 0 : selected.label) === searchValue) {
    return data;
  }
  var result = [];
  for (var _i14 = 0; _i14 < data.length; _i14 += 1) {
    if (filter(searchValue, data[_i14])) {
      result.push(data[_i14]);
    }
    if (result.length >= limit) {
      break;
    }
  }
  return result;
}
var useStyles$17 = createStyles(function () {
  return {
    input: {
      "&:not(:disabled)": {
        cursor: "pointer",
        "&::selection": {
          backgroundColor: "transparent"
        }
      }
    }
  };
});
var __defProp$2z = Object.defineProperty;
var __defProps$17 = Object.defineProperties;
var __getOwnPropDescs$17 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2A = Object.getOwnPropertySymbols;
var __hasOwnProp$2A = Object.prototype.hasOwnProperty;
var __propIsEnum$2A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2z = function __defNormalProp$2z(obj, key, value) {
  return key in obj ? __defProp$2z(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2z = function __spreadValues$2z(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2A.call(b, prop)) __defNormalProp$2z(a, prop, b[prop]);
  if (__getOwnPropSymbols$2A) {
    var _iterator241 = _createForOfIteratorHelper(__getOwnPropSymbols$2A(b)),
      _step242;
    try {
      for (_iterator241.s(); !(_step242 = _iterator241.n()).done;) {
        var prop = _step242.value;
        if (__propIsEnum$2A.call(b, prop)) __defNormalProp$2z(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator241.e(err);
    } finally {
      _iterator241.f();
    }
  }
  return a;
};
var __spreadProps$17 = function __spreadProps$17(a, b) {
  return __defProps$17(a, __getOwnPropDescs$17(b));
};
var __objRest$1v = function __objRest$1v(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2A.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2A) {
    var _iterator242 = _createForOfIteratorHelper(__getOwnPropSymbols$2A(source)),
      _step243;
    try {
      for (_iterator242.s(); !(_step243 = _iterator242.n()).done;) {
        var prop = _step243.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2A.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator242.e(err);
    } finally {
      _iterator242.f();
    }
  }
  return target;
};
function defaultFilter$2(value, item) {
  return item.label.toLowerCase().trim().includes(value.toLowerCase().trim());
}
function defaultShouldCreate$1(query, data) {
  return !!query && !data.some(function (item) {
    return item.label.toLowerCase() === query.toLowerCase();
  });
}
var defaultProps$12 = {
  required: false,
  size: "sm",
  shadow: "sm",
  itemComponent: DefaultItem,
  transition: "fade",
  transitionDuration: 0,
  initiallyOpened: false,
  filter: defaultFilter$2,
  maxDropdownHeight: 220,
  searchable: false,
  clearable: false,
  limit: Infinity,
  disabled: false,
  creatable: false,
  shouldCreate: defaultShouldCreate$1,
  selectOnBlur: false,
  switchDirectionOnFlip: false,
  filterDataOnExactSearchMatch: false,
  zIndex: getDefaultZIndex("popover"),
  clearButtonTabIndex: 0,
  positionDependencies: []
};
var Select = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Select", defaultProps$12, props),
    className = _a.className,
    style = _a.style,
    required = _a.required,
    label = _a.label,
    id = _a.id,
    error = _a.error,
    description = _a.description,
    size = _a.size,
    shadow = _a.shadow,
    data = _a.data,
    value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    itemComponent = _a.itemComponent,
    onKeyDown = _a.onKeyDown,
    onBlur = _a.onBlur,
    onFocus = _a.onFocus,
    transition = _a.transition,
    transitionDuration = _a.transitionDuration,
    initiallyOpened = _a.initiallyOpened,
    transitionTimingFunction = _a.transitionTimingFunction,
    wrapperProps = _a.wrapperProps,
    classNames = _a.classNames,
    styles = _a.styles,
    filter = _a.filter,
    maxDropdownHeight = _a.maxDropdownHeight,
    searchable = _a.searchable,
    clearable = _a.clearable,
    nothingFound = _a.nothingFound,
    clearButtonLabel = _a.clearButtonLabel,
    limit = _a.limit,
    disabled = _a.disabled,
    onSearchChange = _a.onSearchChange,
    rightSection = _a.rightSection,
    rightSectionWidth = _a.rightSectionWidth,
    creatable = _a.creatable,
    getCreateLabel = _a.getCreateLabel,
    shouldCreate = _a.shouldCreate,
    selectOnBlur = _a.selectOnBlur,
    onCreate = _a.onCreate,
    sx = _a.sx,
    dropdownComponent = _a.dropdownComponent,
    onDropdownClose = _a.onDropdownClose,
    onDropdownOpen = _a.onDropdownOpen,
    withinPortal = _a.withinPortal,
    switchDirectionOnFlip = _a.switchDirectionOnFlip,
    zIndex = _a.zIndex,
    name = _a.name,
    dropdownPosition = _a.dropdownPosition,
    allowDeselect = _a.allowDeselect,
    errorProps = _a.errorProps,
    descriptionProps = _a.descriptionProps,
    labelProps = _a.labelProps,
    placeholder = _a.placeholder,
    filterDataOnExactSearchMatch = _a.filterDataOnExactSearchMatch,
    clearButtonTabIndex = _a.clearButtonTabIndex,
    form = _a.form,
    positionDependencies = _a.positionDependencies,
    others = __objRest$1v(_a, ["className", "style", "required", "label", "id", "error", "description", "size", "shadow", "data", "value", "defaultValue", "onChange", "itemComponent", "onKeyDown", "onBlur", "onFocus", "transition", "transitionDuration", "initiallyOpened", "transitionTimingFunction", "wrapperProps", "classNames", "styles", "filter", "maxDropdownHeight", "searchable", "clearable", "nothingFound", "clearButtonLabel", "limit", "disabled", "onSearchChange", "rightSection", "rightSectionWidth", "creatable", "getCreateLabel", "shouldCreate", "selectOnBlur", "onCreate", "sx", "dropdownComponent", "onDropdownClose", "onDropdownOpen", "withinPortal", "switchDirectionOnFlip", "zIndex", "name", "dropdownPosition", "allowDeselect", "errorProps", "descriptionProps", "labelProps", "placeholder", "filterDataOnExactSearchMatch", "clearButtonTabIndex", "form", "positionDependencies"]);
  var _useStyles$16 = useStyles$17(),
    classes = _useStyles$16.classes,
    cx = _useStyles$16.cx,
    theme = _useStyles$16.theme;
  var _extractSystemStyles14 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles14.systemStyles,
    rest = _extractSystemStyles14.rest;
  var _useState127 = useState(initiallyOpened),
    _useState128 = _slicedToArray(_useState127, 2),
    dropdownOpened = _useState128[0],
    _setDropdownOpened = _useState128[1];
  var _useState129 = useState(-1),
    _useState130 = _slicedToArray(_useState129, 2),
    hovered = _useState130[0],
    setHovered = _useState130[1];
  var inputRef = useRef();
  var dropdownRef = useRef();
  var itemsRefs = useRef({});
  var _useState131 = useState("column"),
    _useState132 = _slicedToArray(_useState131, 2),
    direction = _useState132[0],
    setDirection = _useState132[1];
  var isColumn = direction === "column";
  var uuid = useUuid(id);
  var _useScrollIntoView2 = useScrollIntoView({
      duration: 0,
      offset: 5,
      cancelable: false,
      isList: true
    }),
    scrollIntoView = _useScrollIntoView2.scrollIntoView,
    targetRef = _useScrollIntoView2.targetRef,
    scrollableRef = _useScrollIntoView2.scrollableRef;
  var isDeselectable = allowDeselect === void 0 ? clearable : allowDeselect;
  var setDropdownOpened = function setDropdownOpened(opened) {
    if (dropdownOpened !== opened) {
      _setDropdownOpened(opened);
      var handler = opened ? onDropdownOpen : onDropdownClose;
      typeof handler === "function" && handler();
    }
  };
  var isCreatable = creatable && typeof getCreateLabel === "function";
  var createLabel = null;
  var formattedData = data.map(function (item) {
    return typeof item === "string" ? {
      label: item,
      value: item
    } : item;
  });
  var sortedData = groupOptions({
    data: formattedData
  });
  var _useUncontrolled25 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: null,
      onChange: onChange,
      rule: function rule(val) {
        return typeof val === "string" || val === null;
      }
    }),
    _useUncontrolled26 = _slicedToArray(_useUncontrolled25, 3),
    _value = _useUncontrolled26[0],
    handleChange = _useUncontrolled26[1],
    inputMode = _useUncontrolled26[2];
  var selectedValue = sortedData.find(function (item) {
    return item.value === _value;
  });
  var _useState133 = useState((selectedValue == null ? void 0 : selectedValue.label) || ""),
    _useState134 = _slicedToArray(_useState133, 2),
    inputValue = _useState134[0],
    setInputValue = _useState134[1];
  var handleSearchChange = function handleSearchChange(val) {
    setInputValue(val);
    if (searchable && typeof onSearchChange === "function") {
      onSearchChange(val);
    }
  };
  var handleClear = function handleClear() {
    var _a2;
    handleChange(null);
    if (inputMode === "uncontrolled") {
      handleSearchChange("");
    }
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  useEffect(function () {
    var newSelectedValue = sortedData.find(function (item) {
      return item.value === _value;
    });
    if (newSelectedValue) {
      handleSearchChange(newSelectedValue.label);
    } else if (!isCreatable || !_value) {
      handleSearchChange("");
    }
  }, [_value]);
  useEffect(function () {
    if (selectedValue && (!searchable || !dropdownOpened)) {
      handleSearchChange(selectedValue.label);
    }
  }, [selectedValue == null ? void 0 : selectedValue.label]);
  var handleItemSelect = function handleItemSelect(item) {
    if (isDeselectable && (selectedValue == null ? void 0 : selectedValue.value) === item.value) {
      handleChange(null);
      setDropdownOpened(false);
    } else {
      handleChange(item.value);
      if (item.creatable) {
        typeof onCreate === "function" && onCreate(item.value);
      }
      if (inputMode === "uncontrolled") {
        handleSearchChange(item.label);
      }
      setHovered(-1);
      setDropdownOpened(false);
      inputRef.current.focus();
    }
  };
  var filteredData = filterData$2({
    data: sortedData,
    searchable: searchable,
    limit: limit,
    searchValue: inputValue,
    filter: filter,
    filterDataOnExactSearchMatch: filterDataOnExactSearchMatch,
    value: _value
  });
  if (isCreatable && shouldCreate(inputValue, filteredData)) {
    createLabel = getCreateLabel(inputValue);
    filteredData.push({
      label: inputValue,
      value: inputValue,
      creatable: true
    });
  }
  var getNextIndex = function getNextIndex(index, nextItem, compareFn) {
    var i = index;
    while (compareFn(i)) {
      i = nextItem(i);
      if (!filteredData[i].disabled) return i;
    }
    return index;
  };
  useDidUpdate(function () {
    setHovered(getNextIndex(-1, function (index) {
      return index + 1;
    }, function (index) {
      return index < filteredData.length - 1;
    }));
  }, [inputValue]);
  var selectedItemIndex = _value ? filteredData.findIndex(function (el) {
    return el.value === _value;
  }) : 0;
  var handlePrevious = function handlePrevious() {
    setHovered(function (current) {
      var _a2;
      var nextIndex = getNextIndex(current, function (index) {
        return index - 1;
      }, function (index) {
        return index > 0;
      });
      targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
      scrollIntoView({
        alignment: isColumn ? "start" : "end"
      });
      return nextIndex;
    });
  };
  var handleNext = function handleNext() {
    setHovered(function (current) {
      var _a2;
      var nextIndex = getNextIndex(current, function (index) {
        return index + 1;
      }, function (index) {
        return index < filteredData.length - 1;
      });
      targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
      scrollIntoView({
        alignment: isColumn ? "end" : "start"
      });
      return nextIndex;
    });
  };
  var scrollSelectedItemIntoView = function scrollSelectedItemIntoView() {
    return window.setTimeout(function () {
      var _a2;
      targetRef.current = itemsRefs.current[(_a2 = filteredData[selectedItemIndex]) == null ? void 0 : _a2.value];
      scrollIntoView({
        alignment: isColumn ? "end" : "start"
      });
    }, 0);
  };
  var handleInputKeydown = function handleInputKeydown(event) {
    typeof onKeyDown === "function" && onKeyDown(event);
    switch (event.nativeEvent.code) {
      case "ArrowUp":
        {
          event.preventDefault();
          if (!dropdownOpened) {
            setHovered(selectedItemIndex);
            setDropdownOpened(true);
            scrollSelectedItemIntoView();
          } else {
            isColumn ? handlePrevious() : handleNext();
          }
          break;
        }
      case "ArrowDown":
        {
          event.preventDefault();
          if (!dropdownOpened) {
            setHovered(selectedItemIndex);
            setDropdownOpened(true);
            scrollSelectedItemIntoView();
          } else {
            isColumn ? handleNext() : handlePrevious();
          }
          break;
        }
      case "Home":
        {
          if (!searchable) {
            event.preventDefault();
            if (!dropdownOpened) {
              setDropdownOpened(true);
            }
            var firstItemIndex = filteredData.findIndex(function (item) {
              return !item.disabled;
            });
            setHovered(firstItemIndex);
            scrollIntoView({
              alignment: isColumn ? "end" : "start"
            });
          }
          break;
        }
      case "End":
        {
          if (!searchable) {
            event.preventDefault();
            if (!dropdownOpened) {
              setDropdownOpened(true);
            }
            var lastItemIndex = filteredData.map(function (item) {
              return !!item.disabled;
            }).lastIndexOf(false);
            setHovered(lastItemIndex);
            scrollIntoView({
              alignment: isColumn ? "end" : "start"
            });
          }
          break;
        }
      case "Escape":
        {
          event.preventDefault();
          setDropdownOpened(false);
          setHovered(-1);
          break;
        }
      case "Space":
        {
          if (!searchable) {
            if (filteredData[hovered] && dropdownOpened) {
              event.preventDefault();
              handleItemSelect(filteredData[hovered]);
            } else {
              setDropdownOpened(true);
              setHovered(selectedItemIndex);
              scrollSelectedItemIntoView();
            }
          }
          break;
        }
      case "Enter":
        {
          if (!searchable) {
            event.preventDefault();
          }
          if (filteredData[hovered] && dropdownOpened) {
            event.preventDefault();
            handleItemSelect(filteredData[hovered]);
          }
        }
    }
  };
  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    var selected = sortedData.find(function (item) {
      return item.value === _value;
    });
    if (selectOnBlur && filteredData[hovered] && dropdownOpened) {
      handleItemSelect(filteredData[hovered]);
    }
    handleSearchChange((selected == null ? void 0 : selected.label) || "");
    setDropdownOpened(false);
  };
  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    if (searchable) {
      setDropdownOpened(true);
      scrollSelectedItemIntoView();
    }
  };
  var handleInputChange = function handleInputChange(event) {
    handleSearchChange(event.currentTarget.value);
    if (clearable && event.currentTarget.value === "") {
      handleChange(null);
    }
    setHovered(0);
    setDropdownOpened(true);
  };
  var handleInputClick = function handleInputClick() {
    var dropdownOpen = true;
    if (!searchable) {
      dropdownOpen = !dropdownOpened;
    }
    setDropdownOpened(dropdownOpen);
    if (_value && dropdownOpen) {
      setHovered(selectedItemIndex);
      scrollSelectedItemIntoView();
    }
  };
  var shouldShowDropdown = filteredData.length > 0 ? dropdownOpened : dropdownOpened && !!nothingFound;
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$2z(__spreadValues$2z({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    size: size,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    __staticSelector: "Select",
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement("div", {
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-owns": shouldShowDropdown ? "".concat(uuid, "-items") : null,
    "aria-controls": uuid,
    "aria-expanded": shouldShowDropdown,
    onMouseLeave: function onMouseLeave() {
      return setHovered(-1);
    },
    tabIndex: -1
  }, /* @__PURE__ */React__default.createElement("input", {
    type: "hidden",
    name: name,
    value: _value || "",
    form: form
  }), /* @__PURE__ */React__default.createElement(Input, __spreadValues$2z(__spreadProps$17(__spreadValues$2z({
    autoComplete: "off",
    type: "search"
  }, rest), {
    required: required,
    ref: useMergedRef(ref, inputRef),
    id: uuid,
    invalid: !!error,
    size: size,
    onKeyDown: handleInputKeydown,
    __staticSelector: "Select",
    value: inputValue,
    placeholder: placeholder,
    onChange: handleInputChange,
    "aria-autocomplete": "list",
    "aria-controls": shouldShowDropdown ? "".concat(uuid, "-items") : null,
    "aria-activedescendant": hovered >= 0 ? "".concat(uuid, "-").concat(hovered) : null,
    onClick: handleInputClick,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    readOnly: !searchable,
    disabled: disabled,
    "data-mantine-stop-propagation": shouldShowDropdown,
    name: null,
    classNames: __spreadProps$17(__spreadValues$2z({}, classNames), {
      input: cx(_defineProperty({}, classes.input, !searchable), classNames == null ? void 0 : classNames.input)
    })
  }), getSelectRightSectionProps({
    theme: theme,
    rightSection: rightSection,
    rightSectionWidth: rightSectionWidth,
    styles: styles,
    size: size,
    shouldClear: clearable && !!selectedValue,
    clearButtonLabel: clearButtonLabel,
    onClear: handleClear,
    error: error,
    clearButtonTabIndex: clearButtonTabIndex
  }))), /* @__PURE__ */React__default.createElement(SelectDropdown, {
    referenceElement: inputRef.current,
    mounted: shouldShowDropdown,
    transition: transition,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    uuid: uuid,
    shadow: shadow,
    maxDropdownHeight: maxDropdownHeight,
    classNames: classNames,
    styles: styles,
    ref: useMergedRef(dropdownRef, scrollableRef),
    __staticSelector: "Select",
    dropdownComponent: dropdownComponent || SelectScrollArea,
    direction: direction,
    onDirectionChange: setDirection,
    switchDirectionOnFlip: switchDirectionOnFlip,
    withinPortal: withinPortal,
    zIndex: zIndex,
    dropdownPosition: dropdownPosition,
    positionDependencies: positionDependencies
  }, /* @__PURE__ */React__default.createElement(SelectItems, {
    data: filteredData,
    hovered: hovered,
    classNames: classNames,
    styles: styles,
    isItemSelected: function isItemSelected(val) {
      return val === _value;
    },
    uuid: uuid,
    __staticSelector: "Select",
    onItemHover: setHovered,
    onItemSelect: handleItemSelect,
    itemsRefs: itemsRefs,
    itemComponent: itemComponent,
    size: size,
    nothingFound: nothingFound,
    creatable: isCreatable && !!createLabel,
    createLabel: createLabel,
    "aria-label": label
  }))));
});
Select.displayName = "@mantine/core/Select";
function getSortedBreakpoints$1(theme, breakpoints) {
  if (breakpoints.length === 0) {
    return breakpoints;
  }
  var property = "maxWidth" in breakpoints[0] ? "maxWidth" : "minWidth";
  var sorted = _toConsumableArray2(breakpoints).sort(function (a, b) {
    return theme.fn.size({
      size: b[property],
      sizes: theme.breakpoints
    }) - theme.fn.size({
      size: a[property],
      sizes: theme.breakpoints
    });
  });
  return property === "minWidth" ? sorted.reverse() : sorted;
}
var __defProp$2A = Object.defineProperty;
var __getOwnPropSymbols$2B = Object.getOwnPropertySymbols;
var __hasOwnProp$2B = Object.prototype.hasOwnProperty;
var __propIsEnum$2B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2A = function __defNormalProp$2A(obj, key, value) {
  return key in obj ? __defProp$2A(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2A = function __spreadValues$2A(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2B.call(b, prop)) __defNormalProp$2A(a, prop, b[prop]);
  if (__getOwnPropSymbols$2B) {
    var _iterator243 = _createForOfIteratorHelper(__getOwnPropSymbols$2B(b)),
      _step244;
    try {
      for (_iterator243.s(); !(_step244 = _iterator243.n()).done;) {
        var prop = _step244.value;
        if (__propIsEnum$2B.call(b, prop)) __defNormalProp$2A(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator243.e(err);
    } finally {
      _iterator243.f();
    }
  }
  return a;
};
var useStyles$18 = createStyles(function (theme, _ref141) {
  var spacing = _ref141.spacing,
    breakpoints = _ref141.breakpoints,
    cols = _ref141.cols;
  var gridBreakpoints = getSortedBreakpoints$1(theme, breakpoints).reduce(function (acc, breakpoint) {
    var property = "maxWidth" in breakpoint ? "max-width" : "min-width";
    var breakpointSize = theme.fn.size({
      size: property === "max-width" ? breakpoint.maxWidth : breakpoint.minWidth,
      sizes: theme.breakpoints
    });
    acc["@media (".concat(property, ": ").concat(breakpointSize + (property === "max-width" ? 0 : 1), "px)")] = {
      gridTemplateColumns: "repeat(".concat(breakpoint.cols, ", minmax(0, 1fr))"),
      gap: theme.fn.size({
        size: breakpoint.spacing || spacing,
        sizes: theme.spacing
      })
    };
    return acc;
  }, {});
  return {
    root: __spreadValues$2A({
      boxSizing: "border-box",
      display: "grid",
      gridTemplateColumns: "repeat(".concat(cols, ", minmax(0, 1fr))"),
      gap: theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      })
    }, gridBreakpoints)
  };
});
var __defProp$2B = Object.defineProperty;
var __getOwnPropSymbols$2C = Object.getOwnPropertySymbols;
var __hasOwnProp$2C = Object.prototype.hasOwnProperty;
var __propIsEnum$2C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2B = function __defNormalProp$2B(obj, key, value) {
  return key in obj ? __defProp$2B(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2B = function __spreadValues$2B(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2C.call(b, prop)) __defNormalProp$2B(a, prop, b[prop]);
  if (__getOwnPropSymbols$2C) {
    var _iterator244 = _createForOfIteratorHelper(__getOwnPropSymbols$2C(b)),
      _step245;
    try {
      for (_iterator244.s(); !(_step245 = _iterator244.n()).done;) {
        var prop = _step245.value;
        if (__propIsEnum$2C.call(b, prop)) __defNormalProp$2B(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator244.e(err);
    } finally {
      _iterator244.f();
    }
  }
  return a;
};
var __objRest$1w = function __objRest$1w(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2C.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2C) {
    var _iterator245 = _createForOfIteratorHelper(__getOwnPropSymbols$2C(source)),
      _step246;
    try {
      for (_iterator245.s(); !(_step246 = _iterator245.n()).done;) {
        var prop = _step246.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2C.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator245.e(err);
    } finally {
      _iterator245.f();
    }
  }
  return target;
};
var defaultProps$13 = {
  breakpoints: [],
  cols: 1,
  spacing: "md"
};
var SimpleGrid = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("SimpleGrid", defaultProps$13, props),
    className = _a.className,
    breakpoints = _a.breakpoints,
    cols = _a.cols,
    spacing = _a.spacing,
    children = _a.children,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$1w(_a, ["className", "breakpoints", "cols", "spacing", "children", "classNames", "styles"]);
  var _useStyles$17 = useStyles$18({
      breakpoints: breakpoints,
      cols: cols,
      spacing: spacing
    }, {
      classNames: classNames,
      styles: styles,
      name: "SimpleGrid"
    }),
    classes = _useStyles$17.classes,
    cx = _useStyles$17.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2B({
    className: cx(classes.root, className),
    ref: ref
  }, others), children);
});
SimpleGrid.displayName = "@mantine/core/SimpleGrid";
var fade = keyframes({
  "from, to": {
    opacity: 0.4
  },
  "50%": {
    opacity: 1
  }
});
var useStyles$19 = createStyles(function (theme, _ref142) {
  var height = _ref142.height,
    width = _ref142.width,
    radius = _ref142.radius,
    circle = _ref142.circle,
    animate = _ref142.animate;
  return {
    root: {
      height: height,
      width: circle ? height : width,
      borderRadius: circle ? height : theme.fn.radius(radius),
      position: "relative",
      overflow: "hidden"
    },
    visible: {
      "&::before": {
        content: '""',
        position: "absolute",
        background: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10
      },
      "&::after": {
        content: '""',
        position: "absolute",
        background: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        animation: animate ? "".concat(fade, " 1500ms linear infinite") : "none",
        zIndex: 11
      }
    }
  };
});
var __defProp$2C = Object.defineProperty;
var __getOwnPropSymbols$2D = Object.getOwnPropertySymbols;
var __hasOwnProp$2D = Object.prototype.hasOwnProperty;
var __propIsEnum$2D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2C = function __defNormalProp$2C(obj, key, value) {
  return key in obj ? __defProp$2C(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2C = function __spreadValues$2C(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2D.call(b, prop)) __defNormalProp$2C(a, prop, b[prop]);
  if (__getOwnPropSymbols$2D) {
    var _iterator246 = _createForOfIteratorHelper(__getOwnPropSymbols$2D(b)),
      _step247;
    try {
      for (_iterator246.s(); !(_step247 = _iterator246.n()).done;) {
        var prop = _step247.value;
        if (__propIsEnum$2D.call(b, prop)) __defNormalProp$2C(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator246.e(err);
    } finally {
      _iterator246.f();
    }
  }
  return a;
};
var __objRest$1x = function __objRest$1x(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2D.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2D) {
    var _iterator247 = _createForOfIteratorHelper(__getOwnPropSymbols$2D(source)),
      _step248;
    try {
      for (_iterator247.s(); !(_step248 = _iterator247.n()).done;) {
        var prop = _step248.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2D.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator247.e(err);
    } finally {
      _iterator247.f();
    }
  }
  return target;
};
var defaultProps$14 = {
  height: "auto",
  width: "100%",
  visible: true,
  animate: true
};
var Skeleton = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Skeleton", defaultProps$14, props),
    height = _a.height,
    width = _a.width,
    visible = _a.visible,
    animate = _a.animate,
    className = _a.className,
    circle = _a.circle,
    radius = _a.radius,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$1x(_a, ["height", "width", "visible", "animate", "className", "circle", "radius", "classNames", "styles"]);
  var _useStyles$18 = useStyles$19({
      height: height,
      width: width,
      circle: circle,
      radius: radius,
      animate: animate
    }, {
      classNames: classNames,
      styles: styles,
      name: "Skeleton"
    }),
    classes = _useStyles$18.classes,
    cx = _useStyles$18.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2C({
    className: cx(classes.root, _defineProperty({}, classes.visible, visible), className),
    ref: ref
  }, others));
});
Skeleton.displayName = "@mantine/core/Skeleton";
function getPosition(_ref143) {
  var value = _ref143.value,
    min = _ref143.min,
    max = _ref143.max;
  var position = (value - min) / (max - min) * 100;
  return Math.min(Math.max(position, 0), 100);
}
function getChangeValue(_ref144) {
  var value = _ref144.value,
    containerWidth = _ref144.containerWidth,
    min = _ref144.min,
    max = _ref144.max,
    step = _ref144.step,
    precision = _ref144.precision;
  var left = !containerWidth ? value : Math.min(Math.max(value, 0), containerWidth) / containerWidth;
  var dx = left * (max - min);
  var nextValue = (dx !== 0 ? Math.round(dx / step) * step : 0) + min;
  if (precision !== void 0) {
    return Number(nextValue.toFixed(precision));
  }
  return nextValue;
}
var __defProp$2D = Object.defineProperty;
var __defProps$18 = Object.defineProperties;
var __getOwnPropDescs$18 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2E = Object.getOwnPropertySymbols;
var __hasOwnProp$2E = Object.prototype.hasOwnProperty;
var __propIsEnum$2E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2D = function __defNormalProp$2D(obj, key, value) {
  return key in obj ? __defProp$2D(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2D = function __spreadValues$2D(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2E.call(b, prop)) __defNormalProp$2D(a, prop, b[prop]);
  if (__getOwnPropSymbols$2E) {
    var _iterator248 = _createForOfIteratorHelper(__getOwnPropSymbols$2E(b)),
      _step249;
    try {
      for (_iterator248.s(); !(_step249 = _iterator248.n()).done;) {
        var prop = _step249.value;
        if (__propIsEnum$2E.call(b, prop)) __defNormalProp$2D(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator248.e(err);
    } finally {
      _iterator248.f();
    }
  }
  return a;
};
var __spreadProps$18 = function __spreadProps$18(a, b) {
  return __defProps$18(a, __getOwnPropDescs$18(b));
};
var sizes$j = {
  xs: 4,
  sm: 6,
  md: 8,
  lg: 10,
  xl: 12
};
var useStyles$1a = createStyles(function (theme, _ref145) {
  var size = _ref145.size,
    disabled = _ref145.disabled;
  return {
    root: __spreadProps$18(__spreadValues$2D({}, theme.fn.fontStyles()), {
      WebkitTapHighlightColor: "transparent",
      outline: 0,
      height: theme.fn.size({
        sizes: sizes$j,
        size: size
      }) * 2,
      display: "flex",
      alignItems: "center",
      cursor: disabled ? "not-allowed" : "pointer"
    })
  };
});
var __defProp$2E = Object.defineProperty;
var __defProps$19 = Object.defineProperties;
var __getOwnPropDescs$19 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2F = Object.getOwnPropertySymbols;
var __hasOwnProp$2F = Object.prototype.hasOwnProperty;
var __propIsEnum$2F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2E = function __defNormalProp$2E(obj, key, value) {
  return key in obj ? __defProp$2E(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2E = function __spreadValues$2E(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2F.call(b, prop)) __defNormalProp$2E(a, prop, b[prop]);
  if (__getOwnPropSymbols$2F) {
    var _iterator249 = _createForOfIteratorHelper(__getOwnPropSymbols$2F(b)),
      _step250;
    try {
      for (_iterator249.s(); !(_step250 = _iterator249.n()).done;) {
        var prop = _step250.value;
        if (__propIsEnum$2F.call(b, prop)) __defNormalProp$2E(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator249.e(err);
    } finally {
      _iterator249.f();
    }
  }
  return a;
};
var __spreadProps$19 = function __spreadProps$19(a, b) {
  return __defProps$19(a, __getOwnPropDescs$19(b));
};
var useStyles$1b = createStyles(function (theme, _ref146) {
  var color = _ref146.color,
    size = _ref146.size,
    disabled = _ref146.disabled;
  return {
    label: {
      position: "absolute",
      top: -36,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[9],
      fontSize: theme.fontSizes.xs,
      color: theme.white,
      padding: theme.spacing.xs / 2,
      borderRadius: theme.radius.sm,
      whiteSpace: "nowrap",
      pointerEvents: "none"
    },
    thumb: __spreadProps$19(__spreadValues$2E({}, theme.fn.focusStyles()), {
      boxSizing: "border-box",
      position: "absolute",
      display: disabled ? "none" : "flex",
      height: theme.fn.size({
        sizes: sizes$j,
        size: size
      }) * 2,
      width: theme.fn.size({
        sizes: sizes$j,
        size: size
      }) * 2,
      backgroundColor: theme.colorScheme === "dark" ? theme.fn.themeColor(color, theme.fn.primaryShade()) : theme.white,
      border: "4px solid ".concat(theme.colorScheme === "dark" ? theme.white : theme.fn.themeColor(color, theme.fn.primaryShade())),
      color: theme.colorScheme === "dark" ? theme.white : theme.fn.themeColor(color, theme.fn.primaryShade()),
      transform: "translate(-50%, -50%)",
      top: "50%",
      cursor: "pointer",
      borderRadius: 1e3,
      alignItems: "center",
      justifyContent: "center",
      transitionDuration: "100ms",
      transitionProperty: "box-shadow, transform",
      transitionTimingFunction: theme.transitionTimingFunction,
      zIndex: 3
    }),
    dragging: {
      transform: "translate(-50%, -50%) scale(1.05)",
      boxShadow: theme.shadows.sm
    }
  };
});
var Thumb$2 = forwardRef(function (_ref147, ref) {
  var max = _ref147.max,
    min = _ref147.min,
    value = _ref147.value,
    position = _ref147.position,
    label = _ref147.label,
    dragging = _ref147.dragging,
    onMouseDown = _ref147.onMouseDown,
    color = _ref147.color,
    classNames = _ref147.classNames,
    styles = _ref147.styles,
    size = _ref147.size,
    labelTransition = _ref147.labelTransition,
    labelTransitionDuration = _ref147.labelTransitionDuration,
    labelTransitionTimingFunction = _ref147.labelTransitionTimingFunction,
    labelAlwaysOn = _ref147.labelAlwaysOn,
    thumbLabel = _ref147.thumbLabel,
    _onFocus = _ref147.onFocus,
    _onBlur = _ref147.onBlur,
    showLabelOnHover = _ref147.showLabelOnHover,
    _ref147$children = _ref147.children,
    children = _ref147$children === void 0 ? null : _ref147$children,
    disabled = _ref147.disabled;
  var _useStyles$1b = useStyles$1b({
      color: color,
      size: size,
      disabled: disabled
    }, {
      classNames: classNames,
      styles: styles,
      name: "Slider"
    }),
    classes = _useStyles$1b.classes,
    cx = _useStyles$1b.cx,
    theme = _useStyles$1b.theme;
  var _useState135 = useState(false),
    _useState136 = _slicedToArray(_useState135, 2),
    focused = _useState136[0],
    setFocused = _useState136[1];
  var isVisible = labelAlwaysOn || dragging || focused || showLabelOnHover;
  return /* @__PURE__ */React__default.createElement(Box, {
    tabIndex: 0,
    role: "slider",
    "aria-label": thumbLabel,
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    ref: ref,
    className: cx(classes.thumb, _defineProperty({}, classes.dragging, dragging)),
    onFocus: function onFocus() {
      setFocused(true);
      typeof _onFocus === "function" && _onFocus();
    },
    onBlur: function onBlur() {
      setFocused(false);
      typeof _onBlur === "function" && _onBlur();
    },
    onTouchStart: onMouseDown,
    onMouseDown: onMouseDown,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    style: _defineProperty({}, theme.dir === "rtl" ? "right" : "left", "".concat(position, "%"))
  }, children, /* @__PURE__ */React__default.createElement(Transition, {
    mounted: label != null && isVisible,
    duration: labelTransitionDuration,
    transition: labelTransition,
    timingFunction: labelTransitionTimingFunction || theme.transitionTimingFunction
  }, function (transitionStyles) {
    return /* @__PURE__ */React__default.createElement("div", {
      style: transitionStyles,
      className: classes.label
    }, label);
  }));
});
Thumb$2.displayName = "@mantine/core/SliderThumb";
function isMarkFilled(_ref148) {
  var mark = _ref148.mark,
    offset = _ref148.offset,
    value = _ref148.value;
  return typeof offset === "number" ? mark.value >= offset && mark.value <= value : mark.value <= value;
}
var useStyles$1c = createStyles(function (theme, _ref149) {
  var size = _ref149.size,
    color = _ref149.color,
    disabled = _ref149.disabled;
  return {
    markWrapper: {
      position: "absolute",
      top: 0,
      zIndex: 2
    },
    mark: {
      boxSizing: "border-box",
      border: "".concat(theme.fn.size({
        size: size,
        sizes: sizes$j
      }) >= 8 ? "2px" : "1px", " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]),
      height: theme.fn.size({
        sizes: sizes$j,
        size: size
      }),
      width: theme.fn.size({
        sizes: sizes$j,
        size: size
      }),
      borderRadius: 1e3,
      transform: "translateX(-".concat(theme.fn.size({
        sizes: sizes$j,
        size: size
      }) / 2, "px)"),
      backgroundColor: theme.white
    },
    markFilled: {
      borderColor: disabled ? theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4] : theme.fn.variant({
        variant: "filled",
        color: color
      }).background
    },
    markLabel: {
      transform: "translate(-50%, 0)",
      fontSize: theme.fontSizes.sm,
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
      marginTop: theme.spacing.xs / 2,
      whiteSpace: "nowrap"
    }
  };
});
function Marks(_ref150) {
  var marks = _ref150.marks,
    color = _ref150.color,
    size = _ref150.size,
    min = _ref150.min,
    max = _ref150.max,
    value = _ref150.value,
    classNames = _ref150.classNames,
    styles = _ref150.styles,
    offset = _ref150.offset,
    onChange = _ref150.onChange,
    disabled = _ref150.disabled;
  var _useStyles$1c = useStyles$1c({
      size: size,
      color: color,
      disabled: disabled
    }, {
      classNames: classNames,
      styles: styles,
      name: "Slider"
    }),
    classes = _useStyles$1c.classes,
    cx = _useStyles$1c.cx;
  var items = marks.map(function (mark, index) {
    return /* @__PURE__ */React__default.createElement(Box, {
      className: classes.markWrapper,
      sx: {
        left: "".concat(getPosition({
          value: mark.value,
          min: min,
          max: max
        }), "%")
      },
      key: index
    }, /* @__PURE__ */React__default.createElement("div", {
      className: cx(classes.mark, _defineProperty({}, classes.markFilled, isMarkFilled({
        mark: mark,
        value: value,
        offset: offset
      })))
    }), mark.label && /* @__PURE__ */React__default.createElement("div", {
      className: classes.markLabel,
      onMouseDown: function onMouseDown(event) {
        event.stopPropagation();
        onChange(mark.value);
      },
      onTouchStart: function onTouchStart(event) {
        event.stopPropagation();
        onChange(mark.value);
      }
    }, mark.label));
  });
  return /* @__PURE__ */React__default.createElement("div", null, items);
}
Marks.displayName = "@mantine/core/SliderMarks";
var useStyles$1d = createStyles(function (theme, _ref151) {
  var radius = _ref151.radius,
    size = _ref151.size,
    color = _ref151.color,
    disabled = _ref151.disabled;
  return {
    track: {
      position: "relative",
      height: theme.fn.size({
        sizes: sizes$j,
        size: size
      }),
      width: "100%",
      marginRight: theme.fn.size({
        size: size,
        sizes: sizes$j
      }),
      marginLeft: theme.fn.size({
        size: size,
        sizes: sizes$j
      }),
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        borderRadius: theme.fn.size({
          size: radius,
          sizes: theme.radius
        }),
        right: -theme.fn.size({
          size: size,
          sizes: sizes$j
        }),
        left: -theme.fn.size({
          size: size,
          sizes: sizes$j
        }),
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        zIndex: 0
      }
    },
    bar: {
      position: "absolute",
      zIndex: 1,
      top: 0,
      bottom: 0,
      backgroundColor: disabled ? theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4] : theme.fn.variant({
        variant: "filled",
        color: color
      }).background,
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      })
    }
  };
});
var __defProp$2F = Object.defineProperty;
var __defProps$1a = Object.defineProperties;
var __getOwnPropDescs$1a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2G = Object.getOwnPropertySymbols;
var __hasOwnProp$2G = Object.prototype.hasOwnProperty;
var __propIsEnum$2G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2F = function __defNormalProp$2F(obj, key, value) {
  return key in obj ? __defProp$2F(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2F = function __spreadValues$2F(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2G.call(b, prop)) __defNormalProp$2F(a, prop, b[prop]);
  if (__getOwnPropSymbols$2G) {
    var _iterator250 = _createForOfIteratorHelper(__getOwnPropSymbols$2G(b)),
      _step251;
    try {
      for (_iterator250.s(); !(_step251 = _iterator250.n()).done;) {
        var prop = _step251.value;
        if (__propIsEnum$2G.call(b, prop)) __defNormalProp$2F(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator250.e(err);
    } finally {
      _iterator250.f();
    }
  }
  return a;
};
var __spreadProps$1a = function __spreadProps$1a(a, b) {
  return __defProps$1a(a, __getOwnPropDescs$1a(b));
};
var __objRest$1y = function __objRest$1y(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2G.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2G) {
    var _iterator251 = _createForOfIteratorHelper(__getOwnPropSymbols$2G(source)),
      _step252;
    try {
      for (_iterator251.s(); !(_step252 = _iterator251.n()).done;) {
        var prop = _step252.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2G.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator251.e(err);
    } finally {
      _iterator251.f();
    }
  }
  return target;
};
function Track(_a) {
  var _b = _a,
    filled = _b.filled,
    size = _b.size,
    color = _b.color,
    classNames = _b.classNames,
    styles = _b.styles,
    radius = _b.radius,
    children = _b.children,
    offset = _b.offset,
    onMouseLeave = _b.onMouseLeave,
    onMouseEnter = _b.onMouseEnter,
    disabled = _b.disabled,
    marksOffset = _b.marksOffset,
    others = __objRest$1y(_b, ["filled", "size", "color", "classNames", "styles", "radius", "children", "offset", "onMouseLeave", "onMouseEnter", "disabled", "marksOffset"]);
  var _useStyles$1d = useStyles$1d({
      color: color,
      size: size,
      radius: radius,
      disabled: disabled
    }, {
      classNames: classNames,
      styles: styles,
      name: "Slider"
    }),
    classes = _useStyles$1d.classes;
  return /* @__PURE__ */React__default.createElement("div", {
    className: classes.track,
    onMouseLeave: onMouseLeave,
    onMouseEnter: onMouseEnter
  }, /* @__PURE__ */React__default.createElement(Box, {
    className: classes.bar,
    sx: function sx(theme) {
      return {
        left: "calc(".concat(offset, "% - ").concat(theme.fn.size({
          size: size,
          sizes: sizes$j
        }), "px)"),
        width: "calc(".concat(filled, "% + ").concat(theme.fn.size({
          size: size,
          sizes: sizes$j
        }), "px)")
      };
    }
  }), children, /* @__PURE__ */React__default.createElement(Marks, __spreadProps$1a(__spreadValues$2F({}, others), {
    size: size,
    color: color,
    offset: marksOffset,
    classNames: classNames,
    styles: styles,
    disabled: disabled
  })));
}
Track.displayName = "@mantine/core/SliderTrack";
var __defProp$2G = Object.defineProperty;
var __defProps$1b = Object.defineProperties;
var __getOwnPropDescs$1b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2H = Object.getOwnPropertySymbols;
var __hasOwnProp$2H = Object.prototype.hasOwnProperty;
var __propIsEnum$2H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2G = function __defNormalProp$2G(obj, key, value) {
  return key in obj ? __defProp$2G(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2G = function __spreadValues$2G(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2H.call(b, prop)) __defNormalProp$2G(a, prop, b[prop]);
  if (__getOwnPropSymbols$2H) {
    var _iterator252 = _createForOfIteratorHelper(__getOwnPropSymbols$2H(b)),
      _step253;
    try {
      for (_iterator252.s(); !(_step253 = _iterator252.n()).done;) {
        var prop = _step253.value;
        if (__propIsEnum$2H.call(b, prop)) __defNormalProp$2G(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator252.e(err);
    } finally {
      _iterator252.f();
    }
  }
  return a;
};
var __spreadProps$1b = function __spreadProps$1b(a, b) {
  return __defProps$1b(a, __getOwnPropDescs$1b(b));
};
var __objRest$1z = function __objRest$1z(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2H.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2H) {
    var _iterator253 = _createForOfIteratorHelper(__getOwnPropSymbols$2H(source)),
      _step254;
    try {
      for (_iterator253.s(); !(_step254 = _iterator253.n()).done;) {
        var prop = _step254.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2H.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator253.e(err);
    } finally {
      _iterator253.f();
    }
  }
  return target;
};
var SliderRoot = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    size = _b.size,
    classNames = _b.classNames,
    styles = _b.styles,
    disabled = _b.disabled,
    others = __objRest$1z(_b, ["className", "size", "classNames", "styles", "disabled"]);
  var _useStyles$1a = useStyles$1a({
      size: size,
      disabled: disabled
    }, {
      classNames: classNames,
      styles: styles,
      name: "Slider"
    }),
    classes = _useStyles$1a.classes,
    cx = _useStyles$1a.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadProps$1b(__spreadValues$2G({}, others), {
    tabIndex: -1,
    className: cx(classes.root, className),
    ref: ref
  }));
});
SliderRoot.displayName = "@mantine/core/SliderRoot";
var __defProp$2H = Object.defineProperty;
var __defProps$1c = Object.defineProperties;
var __getOwnPropDescs$1c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2I = Object.getOwnPropertySymbols;
var __hasOwnProp$2I = Object.prototype.hasOwnProperty;
var __propIsEnum$2I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2H = function __defNormalProp$2H(obj, key, value) {
  return key in obj ? __defProp$2H(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2H = function __spreadValues$2H(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2I.call(b, prop)) __defNormalProp$2H(a, prop, b[prop]);
  if (__getOwnPropSymbols$2I) {
    var _iterator254 = _createForOfIteratorHelper(__getOwnPropSymbols$2I(b)),
      _step255;
    try {
      for (_iterator254.s(); !(_step255 = _iterator254.n()).done;) {
        var prop = _step255.value;
        if (__propIsEnum$2I.call(b, prop)) __defNormalProp$2H(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator254.e(err);
    } finally {
      _iterator254.f();
    }
  }
  return a;
};
var __spreadProps$1c = function __spreadProps$1c(a, b) {
  return __defProps$1c(a, __getOwnPropDescs$1c(b));
};
var __objRest$1A = function __objRest$1A(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2I.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2I) {
    var _iterator255 = _createForOfIteratorHelper(__getOwnPropSymbols$2I(source)),
      _step256;
    try {
      for (_iterator255.s(); !(_step256 = _iterator255.n()).done;) {
        var prop = _step256.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2I.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator255.e(err);
    } finally {
      _iterator255.f();
    }
  }
  return target;
};
var defaultProps$15 = {
  size: "md",
  radius: "xl",
  min: 0,
  max: 100,
  step: 1,
  marks: [],
  label: function label(f) {
    return f;
  },
  labelTransition: "skew-down",
  labelTransitionDuration: 0,
  labelAlwaysOn: false,
  thumbLabel: "",
  showLabelOnHover: true,
  disabled: false
};
var Slider = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Slider", defaultProps$15, props),
    classNames = _a.classNames,
    styles = _a.styles,
    color = _a.color,
    value = _a.value,
    onChange = _a.onChange,
    onChangeEnd = _a.onChangeEnd,
    size = _a.size,
    radius = _a.radius,
    min = _a.min,
    max = _a.max,
    step = _a.step,
    precision = _a.precision,
    defaultValue = _a.defaultValue,
    name = _a.name,
    marks = _a.marks,
    label = _a.label,
    labelTransition = _a.labelTransition,
    labelTransitionDuration = _a.labelTransitionDuration,
    labelTransitionTimingFunction = _a.labelTransitionTimingFunction,
    labelAlwaysOn = _a.labelAlwaysOn,
    thumbLabel = _a.thumbLabel,
    showLabelOnHover = _a.showLabelOnHover,
    thumbChildren = _a.thumbChildren,
    disabled = _a.disabled,
    others = __objRest$1A(_a, ["classNames", "styles", "color", "value", "onChange", "onChangeEnd", "size", "radius", "min", "max", "step", "precision", "defaultValue", "name", "marks", "label", "labelTransition", "labelTransitionDuration", "labelTransitionTimingFunction", "labelAlwaysOn", "thumbLabel", "showLabelOnHover", "thumbChildren", "disabled"]);
  var theme = useMantineTheme();
  var _useState137 = useState(false),
    _useState138 = _slicedToArray(_useState137, 2),
    hovered = _useState138[0],
    setHovered = _useState138[1];
  var _useUncontrolled27 = useUncontrolled({
      value: typeof value === "number" ? clamp({
        value: value,
        min: min,
        max: max
      }) : value,
      defaultValue: typeof defaultValue === "number" ? clamp({
        value: defaultValue,
        min: min,
        max: max
      }) : defaultValue,
      finalValue: clamp({
        value: 0,
        min: min,
        max: max
      }),
      rule: function rule(val) {
        return typeof val === "number";
      },
      onChange: onChange
    }),
    _useUncontrolled28 = _slicedToArray(_useUncontrolled27, 2),
    _value = _useUncontrolled28[0],
    setValue = _useUncontrolled28[1];
  var valueRef = useRef(_value);
  var thumb = useRef();
  var position = getPosition({
    value: _value,
    min: min,
    max: max
  });
  var _label = typeof label === "function" ? label(_value) : label;
  var handleChange = useCallback(function (_ref152) {
    var x = _ref152.x;
    if (!disabled) {
      var nextValue = getChangeValue({
        value: x,
        min: min,
        max: max,
        step: step,
        precision: precision
      });
      setValue(nextValue);
      valueRef.current = nextValue;
    }
  }, [disabled, min, max, step, precision]);
  var _useMove3 = useMove(handleChange, {
      onScrubEnd: function onScrubEnd() {
        return onChangeEnd == null ? void 0 : onChangeEnd(valueRef.current);
      }
    }, theme.dir),
    container = _useMove3.ref,
    active = _useMove3.active;
  var handleThumbMouseDown = function handleThumbMouseDown(event) {
    if (event.cancelable) {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  var handleTrackKeydownCapture = function handleTrackKeydownCapture(event) {
    if (!disabled) {
      switch (event.nativeEvent.code) {
        case "ArrowUp":
          {
            event.preventDefault();
            thumb.current.focus();
            var nextValue = Math.min(Math.max(_value + step, min), max);
            onChangeEnd == null ? void 0 : onChangeEnd(nextValue);
            setValue(nextValue);
            break;
          }
        case "ArrowRight":
          {
            event.preventDefault();
            thumb.current.focus();
            var _nextValue = Math.min(Math.max(theme.dir === "rtl" ? _value - step : _value + step, min), max);
            onChangeEnd == null ? void 0 : onChangeEnd(_nextValue);
            setValue(_nextValue);
            break;
          }
        case "ArrowDown":
          {
            event.preventDefault();
            thumb.current.focus();
            var _nextValue2 = Math.min(Math.max(_value - step, min), max);
            onChangeEnd == null ? void 0 : onChangeEnd(_nextValue2);
            setValue(_nextValue2);
            break;
          }
        case "ArrowLeft":
          {
            event.preventDefault();
            thumb.current.focus();
            var _nextValue3 = Math.min(Math.max(theme.dir === "rtl" ? _value + step : _value - step, min), max);
            onChangeEnd == null ? void 0 : onChangeEnd(_nextValue3);
            setValue(_nextValue3);
            break;
          }
      }
    }
  };
  return /* @__PURE__ */React__default.createElement(SliderRoot, __spreadProps$1c(__spreadValues$2H({}, others), {
    size: size,
    ref: useMergedRef(container, ref),
    onKeyDownCapture: handleTrackKeydownCapture,
    onMouseDownCapture: function onMouseDownCapture() {
      var _a2;
      return (_a2 = container.current) == null ? void 0 : _a2.focus();
    },
    classNames: classNames,
    styles: styles,
    disabled: disabled
  }), /* @__PURE__ */React__default.createElement(Track, {
    offset: 0,
    filled: position,
    marks: marks,
    size: size,
    radius: radius,
    color: color,
    min: min,
    max: max,
    value: _value,
    onChange: setValue,
    onMouseEnter: showLabelOnHover ? function () {
      return setHovered(true);
    } : void 0,
    onMouseLeave: showLabelOnHover ? function () {
      return setHovered(false);
    } : void 0,
    classNames: classNames,
    styles: styles,
    disabled: disabled
  }, /* @__PURE__ */React__default.createElement(Thumb$2, {
    max: max,
    min: min,
    value: _value,
    position: position,
    dragging: active,
    color: color,
    size: size,
    label: _label,
    ref: thumb,
    onMouseDown: handleThumbMouseDown,
    labelTransition: labelTransition,
    labelTransitionDuration: labelTransitionDuration,
    labelTransitionTimingFunction: labelTransitionTimingFunction,
    labelAlwaysOn: labelAlwaysOn,
    classNames: classNames,
    styles: styles,
    thumbLabel: thumbLabel,
    showLabelOnHover: showLabelOnHover && hovered,
    disabled: disabled
  }, thumbChildren)), /* @__PURE__ */React__default.createElement("input", {
    type: "hidden",
    name: name,
    value: _value
  }));
});
Slider.displayName = "@mantine/core/Slider";
function getClientPosition(event) {
  if ("TouchEvent" in window && event instanceof window.TouchEvent) {
    var touch = event.touches[0];
    return touch.clientX;
  }
  return event.clientX;
}
var __defProp$2I = Object.defineProperty;
var __defProps$1d = Object.defineProperties;
var __getOwnPropDescs$1d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2J = Object.getOwnPropertySymbols;
var __hasOwnProp$2J = Object.prototype.hasOwnProperty;
var __propIsEnum$2J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2I = function __defNormalProp$2I(obj, key, value) {
  return key in obj ? __defProp$2I(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2I = function __spreadValues$2I(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2J.call(b, prop)) __defNormalProp$2I(a, prop, b[prop]);
  if (__getOwnPropSymbols$2J) {
    var _iterator256 = _createForOfIteratorHelper(__getOwnPropSymbols$2J(b)),
      _step257;
    try {
      for (_iterator256.s(); !(_step257 = _iterator256.n()).done;) {
        var prop = _step257.value;
        if (__propIsEnum$2J.call(b, prop)) __defNormalProp$2I(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator256.e(err);
    } finally {
      _iterator256.f();
    }
  }
  return a;
};
var __spreadProps$1d = function __spreadProps$1d(a, b) {
  return __defProps$1d(a, __getOwnPropDescs$1d(b));
};
var __objRest$1B = function __objRest$1B(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2J.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2J) {
    var _iterator257 = _createForOfIteratorHelper(__getOwnPropSymbols$2J(source)),
      _step258;
    try {
      for (_iterator257.s(); !(_step258 = _iterator257.n()).done;) {
        var prop = _step258.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2J.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator257.e(err);
    } finally {
      _iterator257.f();
    }
  }
  return target;
};
var defaultProps$16 = {
  size: "md",
  radius: "xl",
  min: 0,
  max: 100,
  minRange: 10,
  step: 1,
  marks: [],
  label: function label(f) {
    return f;
  },
  labelTransition: "skew-down",
  labelTransitionDuration: 0,
  labelAlwaysOn: false,
  thumbFromLabel: "",
  thumbToLabel: "",
  showLabelOnHover: true,
  disabled: false
};
var RangeSlider = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("RangeSlider", defaultProps$16, props),
    classNames = _a.classNames,
    styles = _a.styles,
    color = _a.color,
    value = _a.value,
    onChange = _a.onChange,
    onChangeEnd = _a.onChangeEnd,
    size = _a.size,
    radius = _a.radius,
    min = _a.min,
    max = _a.max,
    minRange = _a.minRange,
    step = _a.step,
    precision = _a.precision,
    defaultValue = _a.defaultValue,
    name = _a.name,
    marks = _a.marks,
    label = _a.label,
    labelTransition = _a.labelTransition,
    labelTransitionDuration = _a.labelTransitionDuration,
    labelTransitionTimingFunction = _a.labelTransitionTimingFunction,
    labelAlwaysOn = _a.labelAlwaysOn,
    thumbFromLabel = _a.thumbFromLabel,
    thumbToLabel = _a.thumbToLabel,
    showLabelOnHover = _a.showLabelOnHover,
    thumbChildren = _a.thumbChildren,
    disabled = _a.disabled,
    others = __objRest$1B(_a, ["classNames", "styles", "color", "value", "onChange", "onChangeEnd", "size", "radius", "min", "max", "minRange", "step", "precision", "defaultValue", "name", "marks", "label", "labelTransition", "labelTransitionDuration", "labelTransitionTimingFunction", "labelAlwaysOn", "thumbFromLabel", "thumbToLabel", "showLabelOnHover", "thumbChildren", "disabled"]);
  var theme = useMantineTheme();
  var _useState139 = useState(-1),
    _useState140 = _slicedToArray(_useState139, 2),
    focused = _useState140[0],
    setFocused = _useState140[1];
  var _useState141 = useState(false),
    _useState142 = _slicedToArray(_useState141, 2),
    hovered = _useState142[0],
    setHovered = _useState142[1];
  var _useUncontrolled29 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: [min, max],
      rule: function rule(val) {
        return Array.isArray(val);
      },
      onChange: onChange
    }),
    _useUncontrolled30 = _slicedToArray(_useUncontrolled29, 2),
    _value = _useUncontrolled30[0],
    setValue = _useUncontrolled30[1];
  var valueRef = useRef(_value);
  var thumbs = useRef([]);
  var thumbIndex = useRef(void 0);
  var positions = [getPosition({
    value: _value[0],
    min: min,
    max: max
  }), getPosition({
    value: _value[1],
    min: min,
    max: max
  })];
  var _setValue = function _setValue(val) {
    setValue(val);
    valueRef.current = val;
  };
  useEffect(function () {
    if (Array.isArray(value)) {
      valueRef.current = value;
    }
  }, Array.isArray(value) ? [value[0], value[1]] : [null, null]);
  var setRangedValue = function setRangedValue(val, index, triggerChangeEnd) {
    var clone = _toConsumableArray2(valueRef.current);
    clone[index] = val;
    if (index === 0) {
      if (val > clone[1] - minRange) {
        clone[1] = Math.min(val + minRange, max);
      }
      if (val > (max - minRange || min)) {
        clone[index] = valueRef.current[index];
      }
    }
    if (index === 1) {
      if (val < clone[0] + minRange) {
        clone[0] = Math.max(val - minRange, min);
      }
      if (val < clone[0] + minRange) {
        clone[index] = valueRef.current[index];
      }
    }
    _setValue(clone);
    if (triggerChangeEnd) {
      onChangeEnd == null ? void 0 : onChangeEnd(valueRef.current);
    }
  };
  var handleChange = function handleChange(val) {
    if (!disabled) {
      var nextValue = getChangeValue({
        value: val,
        min: min,
        max: max,
        step: step,
        precision: precision
      });
      setRangedValue(nextValue, thumbIndex.current, false);
    }
  };
  var _useMove4 = useMove(function (_ref153) {
      var x = _ref153.x;
      return handleChange(x);
    }, {
      onScrubEnd: function onScrubEnd() {
        return onChangeEnd == null ? void 0 : onChangeEnd(valueRef.current);
      }
    }, theme.dir),
    container = _useMove4.ref,
    active = _useMove4.active;
  function handleThumbMouseDown(event, index) {
    if (event.cancelable) {
      event.preventDefault();
      event.stopPropagation();
    }
    thumbIndex.current = index;
  }
  var handleTrackMouseDownCapture = function handleTrackMouseDownCapture(event) {
    if (event.cancelable) {
      event.preventDefault();
    }
    container.current.focus();
    var rect = container.current.getBoundingClientRect();
    var changePosition = getClientPosition(event.nativeEvent);
    var changeValue = getChangeValue({
      value: changePosition - rect.left,
      max: max,
      min: min,
      step: step,
      containerWidth: rect.width
    });
    var nearestHandle = Math.abs(_value[0] - changeValue) > Math.abs(_value[1] - changeValue) ? 1 : 0;
    var _nearestHandle = theme.dir === "ltr" ? nearestHandle : nearestHandle === 1 ? 0 : 1;
    thumbIndex.current = _nearestHandle;
  };
  var getFocusedThumbIndex = function getFocusedThumbIndex() {
    if (focused !== 1 && focused !== 0) {
      setFocused(0);
      return 0;
    }
    return focused;
  };
  var handleTrackKeydownCapture = function handleTrackKeydownCapture(event) {
    if (!disabled) {
      switch (event.nativeEvent.code) {
        case "ArrowUp":
          {
            event.preventDefault();
            var focusedIndex = getFocusedThumbIndex();
            thumbs.current[focusedIndex].focus();
            setRangedValue(Math.min(Math.max(valueRef.current[focusedIndex] + step, min), max), focusedIndex, true);
            break;
          }
        case "ArrowRight":
          {
            event.preventDefault();
            var _focusedIndex = getFocusedThumbIndex();
            thumbs.current[_focusedIndex].focus();
            setRangedValue(Math.min(Math.max(theme.dir === "rtl" ? valueRef.current[_focusedIndex] - step : valueRef.current[_focusedIndex] + step, min), max), _focusedIndex, true);
            break;
          }
        case "ArrowDown":
          {
            event.preventDefault();
            var _focusedIndex2 = getFocusedThumbIndex();
            thumbs.current[_focusedIndex2].focus();
            setRangedValue(Math.min(Math.max(valueRef.current[_focusedIndex2] - step, min), max), _focusedIndex2, true);
            break;
          }
        case "ArrowLeft":
          {
            event.preventDefault();
            var _focusedIndex3 = getFocusedThumbIndex();
            thumbs.current[_focusedIndex3].focus();
            setRangedValue(Math.min(Math.max(theme.dir === "rtl" ? valueRef.current[_focusedIndex3] + step : valueRef.current[_focusedIndex3] - step, min), max), _focusedIndex3, true);
            break;
          }
      }
    }
  };
  var sharedThumbProps = {
    max: max,
    min: min,
    color: color,
    size: size,
    labelTransition: labelTransition,
    labelTransitionDuration: labelTransitionDuration,
    labelTransitionTimingFunction: labelTransitionTimingFunction,
    labelAlwaysOn: labelAlwaysOn,
    onBlur: function onBlur() {
      return setFocused(-1);
    },
    classNames: classNames,
    styles: styles
  };
  var hasArrayThumbChildren = Array.isArray(thumbChildren);
  return /* @__PURE__ */React__default.createElement(SliderRoot, __spreadProps$1d(__spreadValues$2I({}, others), {
    size: size,
    ref: useMergedRef(container, ref),
    onTouchStartCapture: handleTrackMouseDownCapture,
    onTouchEndCapture: function onTouchEndCapture() {
      thumbIndex.current = -1;
    },
    onMouseDownCapture: handleTrackMouseDownCapture,
    onMouseUpCapture: function onMouseUpCapture() {
      thumbIndex.current = -1;
    },
    onKeyDownCapture: handleTrackKeydownCapture,
    styles: styles,
    classNames: classNames,
    disabled: disabled
  }), /* @__PURE__ */React__default.createElement(Track, {
    offset: positions[0],
    marksOffset: _value[0],
    filled: positions[1] - positions[0],
    marks: marks,
    size: size,
    radius: radius,
    color: color,
    min: min,
    max: max,
    value: _value[1],
    styles: styles,
    classNames: classNames,
    onMouseEnter: showLabelOnHover ? function () {
      return setHovered(true);
    } : void 0,
    onMouseLeave: showLabelOnHover ? function () {
      return setHovered(false);
    } : void 0,
    onChange: function onChange(val) {
      var nearestValue = Math.abs(_value[0] - val) > Math.abs(_value[1] - val) ? 1 : 0;
      var clone = _toConsumableArray2(_value);
      clone[nearestValue] = val;
      _setValue(clone);
    },
    disabled: disabled
  }, /* @__PURE__ */React__default.createElement(Thumb$2, __spreadProps$1d(__spreadValues$2I({}, sharedThumbProps), {
    value: _value[0],
    position: positions[0],
    dragging: active,
    label: typeof label === "function" ? label(_value[0]) : label,
    ref: function ref(node) {
      thumbs.current[0] = node;
    },
    thumbLabel: thumbFromLabel,
    onMouseDown: function onMouseDown(event) {
      return handleThumbMouseDown(event, 0);
    },
    onFocus: function onFocus() {
      return setFocused(0);
    },
    showLabelOnHover: showLabelOnHover && hovered,
    disabled: disabled
  }), hasArrayThumbChildren ? thumbChildren[0] : thumbChildren), /* @__PURE__ */React__default.createElement(Thumb$2, __spreadProps$1d(__spreadValues$2I({}, sharedThumbProps), {
    thumbLabel: thumbToLabel,
    value: _value[1],
    position: positions[1],
    dragging: active,
    label: typeof label === "function" ? label(_value[1]) : label,
    ref: function ref(node) {
      thumbs.current[1] = node;
    },
    onMouseDown: function onMouseDown(event) {
      return handleThumbMouseDown(event, 1);
    },
    onFocus: function onFocus() {
      return setFocused(1);
    },
    showLabelOnHover: showLabelOnHover && hovered,
    disabled: disabled
  }), hasArrayThumbChildren ? thumbChildren[1] : thumbChildren)), /* @__PURE__ */React__default.createElement("input", {
    type: "hidden",
    name: "".concat(name, "_from"),
    value: _value[0]
  }), /* @__PURE__ */React__default.createElement("input", {
    type: "hidden",
    name: "".concat(name, "_to"),
    value: _value[1]
  }));
});
RangeSlider.displayName = "@mantine/core/RangeSlider";
var __defProp$2J = Object.defineProperty;
var __getOwnPropSymbols$2K = Object.getOwnPropertySymbols;
var __hasOwnProp$2K = Object.prototype.hasOwnProperty;
var __propIsEnum$2K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2J = function __defNormalProp$2J(obj, key, value) {
  return key in obj ? __defProp$2J(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2J = function __spreadValues$2J(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2K.call(b, prop)) __defNormalProp$2J(a, prop, b[prop]);
  if (__getOwnPropSymbols$2K) {
    var _iterator258 = _createForOfIteratorHelper(__getOwnPropSymbols$2K(b)),
      _step259;
    try {
      for (_iterator258.s(); !(_step259 = _iterator258.n()).done;) {
        var prop = _step259.value;
        if (__propIsEnum$2K.call(b, prop)) __defNormalProp$2J(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator258.e(err);
    } finally {
      _iterator258.f();
    }
  }
  return a;
};
var __objRest$1C = function __objRest$1C(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2K.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2K) {
    var _iterator259 = _createForOfIteratorHelper(__getOwnPropSymbols$2K(source)),
      _step260;
    try {
      for (_iterator259.s(); !(_step260 = _iterator259.n()).done;) {
        var prop = _step260.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2K.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator259.e(err);
    } finally {
      _iterator259.f();
    }
  }
  return target;
};
var defaultProps$17 = {
  w: 0,
  h: 0
};
var Space = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Space", defaultProps$17, props),
    w = _a.w,
    h = _a.h,
    sx = _a.sx,
    others = __objRest$1C(_a, ["w", "h", "sx"]);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2J({
    ref: ref,
    sx: [function (theme) {
      var width = theme.fn.size({
        size: w,
        sizes: theme.spacing
      });
      var height = theme.fn.size({
        size: h,
        sizes: theme.spacing
      });
      return {
        width: width,
        height: height,
        minWidth: width,
        minHeight: height
      };
    }].concat(_toConsumableArray2(Array.isArray(sx) ? sx : [sx]))
  }, others));
});
Space.displayName = "@mantine/core/Space";
var useStyles$1e = createStyles(function (_theme, _ref154) {
  var transitionDuration = _ref154.transitionDuration;
  return {
    control: {},
    root: {
      position: "relative"
    },
    content: {
      overflow: "hidden",
      transitionProperty: "max-height",
      transitionTimingFunction: "ease",
      transitionDuration: "".concat(transitionDuration, "ms"),
      "@media (prefers-reduced-motion)": {
        transitionDuration: "0ms"
      }
    }
  };
});
var __defProp$2K = Object.defineProperty;
var __getOwnPropSymbols$2L = Object.getOwnPropertySymbols;
var __hasOwnProp$2L = Object.prototype.hasOwnProperty;
var __propIsEnum$2L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2K = function __defNormalProp$2K(obj, key, value) {
  return key in obj ? __defProp$2K(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2K = function __spreadValues$2K(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2L.call(b, prop)) __defNormalProp$2K(a, prop, b[prop]);
  if (__getOwnPropSymbols$2L) {
    var _iterator260 = _createForOfIteratorHelper(__getOwnPropSymbols$2L(b)),
      _step261;
    try {
      for (_iterator260.s(); !(_step261 = _iterator260.n()).done;) {
        var prop = _step261.value;
        if (__propIsEnum$2L.call(b, prop)) __defNormalProp$2K(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator260.e(err);
    } finally {
      _iterator260.f();
    }
  }
  return a;
};
var __objRest$1D = function __objRest$1D(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2L.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2L) {
    var _iterator261 = _createForOfIteratorHelper(__getOwnPropSymbols$2L(source)),
      _step262;
    try {
      for (_iterator261.s(); !(_step262 = _iterator261.n()).done;) {
        var prop = _step262.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2L.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator261.e(err);
    } finally {
      _iterator261.f();
    }
  }
  return target;
};
var defaultProps$18 = {
  maxHeight: 100,
  transitionDuration: 200,
  initialState: false
};
var Spoiler = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Spoiler", defaultProps$18, props),
    className = _a.className,
    children = _a.children,
    maxHeight = _a.maxHeight,
    hideLabel = _a.hideLabel,
    showLabel = _a.showLabel,
    transitionDuration = _a.transitionDuration,
    controlRef = _a.controlRef,
    initialState = _a.initialState,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$1D(_a, ["className", "children", "maxHeight", "hideLabel", "showLabel", "transitionDuration", "controlRef", "initialState", "classNames", "styles"]);
  var _useStyles$1e = useStyles$1e({
      transitionDuration: transitionDuration
    }, {
      classNames: classNames,
      styles: styles,
      name: "Spoiler"
    }),
    classes = _useStyles$1e.classes,
    cx = _useStyles$1e.cx;
  var _useState143 = useState(initialState),
    _useState144 = _slicedToArray(_useState143, 2),
    show = _useState144[0],
    setShowState = _useState144[1];
  var _useState145 = useState(initialState),
    _useState146 = _slicedToArray(_useState145, 2),
    spoiler = _useState146[0],
    setSpoilerState = _useState146[1];
  var contentRef = useRef(null);
  var spoilerMoreContent = show ? hideLabel : showLabel;
  useEffect(function () {
    setSpoilerState(maxHeight < contentRef.current.clientHeight);
  }, [maxHeight, children]);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2K({
    className: cx(classes.root, className),
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: classes.content,
    style: {
      maxHeight: !show ? maxHeight : contentRef.current && contentRef.current.clientHeight
    }
  }, /* @__PURE__ */React__default.createElement("div", {
    ref: contentRef
  }, children)), spoiler && /* @__PURE__ */React__default.createElement(Anchor, {
    component: "button",
    ref: controlRef,
    onClick: function onClick() {
      return setShowState(function (opened) {
        return !opened;
      });
    },
    className: classes.control
  }, spoilerMoreContent));
});
Spoiler.displayName = "@mantine/core/Spoiler";
var useStyles$1f = createStyles(function (theme, _ref155) {
  var spacing = _ref155.spacing,
    align = _ref155.align,
    justify = _ref155.justify;
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: align,
      justifyContent: justify,
      gap: theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      })
    }
  };
});
var __defProp$2L = Object.defineProperty;
var __getOwnPropSymbols$2M = Object.getOwnPropertySymbols;
var __hasOwnProp$2M = Object.prototype.hasOwnProperty;
var __propIsEnum$2M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2L = function __defNormalProp$2L(obj, key, value) {
  return key in obj ? __defProp$2L(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2L = function __spreadValues$2L(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2M.call(b, prop)) __defNormalProp$2L(a, prop, b[prop]);
  if (__getOwnPropSymbols$2M) {
    var _iterator262 = _createForOfIteratorHelper(__getOwnPropSymbols$2M(b)),
      _step263;
    try {
      for (_iterator262.s(); !(_step263 = _iterator262.n()).done;) {
        var prop = _step263.value;
        if (__propIsEnum$2M.call(b, prop)) __defNormalProp$2L(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator262.e(err);
    } finally {
      _iterator262.f();
    }
  }
  return a;
};
var __objRest$1E = function __objRest$1E(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2M.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2M) {
    var _iterator263 = _createForOfIteratorHelper(__getOwnPropSymbols$2M(source)),
      _step264;
    try {
      for (_iterator263.s(); !(_step264 = _iterator263.n()).done;) {
        var prop = _step264.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2M.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator263.e(err);
    } finally {
      _iterator263.f();
    }
  }
  return target;
};
var defaultProps$19 = {
  spacing: "md",
  align: "stretch",
  justify: "top"
};
var Stack = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Stack", defaultProps$19, props),
    spacing = _a.spacing,
    className = _a.className,
    classNames = _a.classNames,
    styles = _a.styles,
    align = _a.align,
    justify = _a.justify,
    others = __objRest$1E(_a, ["spacing", "className", "classNames", "styles", "align", "justify"]);
  var _useStyles$1f = useStyles$1f({
      spacing: spacing,
      align: align,
      justify: justify
    }, {
      name: "Stack",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$1f.classes,
    cx = _useStyles$1f.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2L({
    className: cx(classes.root, className),
    ref: ref
  }, others));
});
Stack.displayName = "@mantine/core/Stack";
var __defProp$2M = Object.defineProperty;
var __defProps$1e = Object.defineProperties;
var __getOwnPropDescs$1e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2N = Object.getOwnPropertySymbols;
var __hasOwnProp$2N = Object.prototype.hasOwnProperty;
var __propIsEnum$2N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2M = function __defNormalProp$2M(obj, key, value) {
  return key in obj ? __defProp$2M(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2M = function __spreadValues$2M(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2N.call(b, prop)) __defNormalProp$2M(a, prop, b[prop]);
  if (__getOwnPropSymbols$2N) {
    var _iterator264 = _createForOfIteratorHelper(__getOwnPropSymbols$2N(b)),
      _step265;
    try {
      for (_iterator264.s(); !(_step265 = _iterator264.n()).done;) {
        var prop = _step265.value;
        if (__propIsEnum$2N.call(b, prop)) __defNormalProp$2M(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator264.e(err);
    } finally {
      _iterator264.f();
    }
  }
  return a;
};
var __spreadProps$1e = function __spreadProps$1e(a, b) {
  return __defProps$1e(a, __getOwnPropDescs$1e(b));
};
var iconSizes$5 = {
  xs: 34,
  sm: 36,
  md: 42,
  lg: 48,
  xl: 52
};
var useStyles$1g = createStyles(function (theme, _ref156, getRef) {
  var color = _ref156.color,
    iconSize = _ref156.iconSize,
    size = _ref156.size,
    radius = _ref156.radius,
    allowStepClick = _ref156.allowStepClick,
    iconPosition = _ref156.iconPosition;
  var _iconSize = iconSize || theme.fn.size({
    size: size,
    sizes: iconSizes$5
  });
  var iconMargin = size === "xl" || size === "lg" ? theme.spacing.md : theme.spacing.sm;
  var _radius = theme.fn.size({
    size: radius,
    sizes: theme.radius
  });
  var colors = theme.fn.variant({
    variant: "filled",
    color: color
  });
  return {
    stepLoader: {},
    step: {
      display: "flex",
      alignItems: "center",
      flexDirection: iconPosition === "left" ? "row" : "row-reverse",
      cursor: allowStepClick ? "pointer" : "default"
    },
    stepIcon: {
      ref: getRef("stepIcon"),
      boxSizing: "border-box",
      height: _iconSize,
      width: _iconSize,
      minWidth: _iconSize,
      borderRadius: _radius,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
      border: "2px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]),
      transition: "background-color 150ms ease, border-color 150ms ease",
      position: "relative",
      fontWeight: 700,
      color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7],
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      })
    },
    stepCompletedIcon: __spreadProps$1e(__spreadValues$2M({}, theme.fn.cover()), {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.white
    }),
    stepProgress: _defineProperty({}, "& .".concat(getRef("stepIcon")), {
      borderColor: colors.background
    }),
    stepCompleted: _defineProperty({}, "& .".concat(getRef("stepIcon")), {
      backgroundColor: colors.background,
      borderColor: colors.background,
      color: theme.white
    }),
    stepBody: {
      marginLeft: iconPosition === "left" ? iconMargin : void 0,
      marginRight: iconPosition === "right" ? iconMargin : void 0
    },
    stepLabel: {
      textAlign: iconPosition,
      fontWeight: 500,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      lineHeight: 1
    },
    stepDescription: {
      textAlign: iconPosition,
      marginTop: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 3,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }) - 2,
      lineHeight: 1
    }
  };
});
var __defProp$2N = Object.defineProperty;
var __getOwnPropSymbols$2O = Object.getOwnPropertySymbols;
var __hasOwnProp$2O = Object.prototype.hasOwnProperty;
var __propIsEnum$2O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2N = function __defNormalProp$2N(obj, key, value) {
  return key in obj ? __defProp$2N(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2N = function __spreadValues$2N(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2O.call(b, prop)) __defNormalProp$2N(a, prop, b[prop]);
  if (__getOwnPropSymbols$2O) {
    var _iterator265 = _createForOfIteratorHelper(__getOwnPropSymbols$2O(b)),
      _step266;
    try {
      for (_iterator265.s(); !(_step266 = _iterator265.n()).done;) {
        var prop = _step266.value;
        if (__propIsEnum$2O.call(b, prop)) __defNormalProp$2N(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator265.e(err);
    } finally {
      _iterator265.f();
    }
  }
  return a;
};
var __objRest$1F = function __objRest$1F(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2O.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2O) {
    var _iterator266 = _createForOfIteratorHelper(__getOwnPropSymbols$2O(source)),
      _step267;
    try {
      for (_iterator266.s(); !(_step267 = _iterator266.n()).done;) {
        var prop = _step267.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2O.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator266.e(err);
    } finally {
      _iterator266.f();
    }
  }
  return target;
};
var defaultIconSizes = {
  xs: 16,
  sm: 18,
  md: 20,
  lg: 22,
  xl: 24
};
var Step = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    state = _b.state,
    color = _b.color,
    icon = _b.icon,
    completedIcon = _b.completedIcon,
    progressIcon = _b.progressIcon,
    label = _b.label,
    description = _b.description,
    _b$withIcon = _b.withIcon,
    withIcon = _b$withIcon === void 0 ? true : _b$withIcon,
    iconSize = _b.iconSize,
    _b$size3 = _b.size,
    size = _b$size3 === void 0 ? "md" : _b$size3,
    _b$radius = _b.radius,
    radius = _b$radius === void 0 ? "xl" : _b$radius,
    loading = _b.loading,
    _b$allowStepClick = _b.allowStepClick,
    allowStepClick = _b$allowStepClick === void 0 ? true : _b$allowStepClick,
    allowStepSelect = _b.allowStepSelect,
    _b$iconPosition2 = _b.iconPosition,
    iconPosition = _b$iconPosition2 === void 0 ? "left" : _b$iconPosition2,
    _b$__staticSelector3 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector3 === void 0 ? "Step" : _b$__staticSelector3,
    classNames = _b.classNames,
    styles = _b.styles,
    others = __objRest$1F(_b, ["className", "state", "color", "icon", "completedIcon", "progressIcon", "label", "description", "withIcon", "iconSize", "size", "radius", "loading", "allowStepClick", "allowStepSelect", "iconPosition", "__staticSelector", "classNames", "styles"]);
  var _useStyles$1g = useStyles$1g({
      color: color,
      iconSize: iconSize,
      size: size,
      radius: radius,
      allowStepClick: allowStepClick,
      iconPosition: iconPosition
    }, {
      name: __staticSelector,
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$1g.classes,
    cx = _useStyles$1g.cx,
    theme = _useStyles$1g.theme;
  var _iconSize = theme.fn.size({
    size: size,
    sizes: defaultIconSizes
  });
  var _icon = state === "stepCompleted" ? null : state === "stepProgress" ? progressIcon : icon;
  return /* @__PURE__ */React__default.createElement(UnstyledButton, __spreadValues$2N({
    className: cx(classes.step, classes[state], className),
    tabIndex: allowStepClick ? 0 : -1,
    ref: ref
  }, others), withIcon && /* @__PURE__ */React__default.createElement("div", {
    className: classes.stepIcon
  }, /* @__PURE__ */React__default.createElement(Transition, {
    mounted: state === "stepCompleted",
    transition: "pop",
    duration: 200
  }, function (transitionStyles) {
    return /* @__PURE__ */React__default.createElement("div", {
      className: classes.stepCompletedIcon,
      style: transitionStyles
    }, loading ? /* @__PURE__ */React__default.createElement(Loader, {
      color: "#fff",
      size: _iconSize,
      className: classes.stepLoader
    }) : completedIcon || /* @__PURE__ */React__default.createElement(CheckboxIcon, {
      indeterminate: false,
      width: _iconSize,
      height: _iconSize
    }));
  }), state !== "stepCompleted" ? loading ? /* @__PURE__ */React__default.createElement(Loader, {
    size: _iconSize,
    color: color
  }) : _icon || icon : null), (label || description) && /* @__PURE__ */React__default.createElement("div", {
    className: classes.stepBody
  }, label && /* @__PURE__ */React__default.createElement(Text, {
    className: classes.stepLabel
  }, label), description && /* @__PURE__ */React__default.createElement(Text, {
    className: classes.stepDescription,
    color: "dimmed"
  }, description)));
});
Step.displayName = "@mantine/core/Step";
function StepCompleted(props) {
  return null;
}
StepCompleted.displayName = "@mantine/core/StepCompleted";
var __defProp$2O = Object.defineProperty;
var __defProps$1f = Object.defineProperties;
var __getOwnPropDescs$1f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2P = Object.getOwnPropertySymbols;
var __hasOwnProp$2P = Object.prototype.hasOwnProperty;
var __propIsEnum$2P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2O = function __defNormalProp$2O(obj, key, value) {
  return key in obj ? __defProp$2O(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2O = function __spreadValues$2O(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2P.call(b, prop)) __defNormalProp$2O(a, prop, b[prop]);
  if (__getOwnPropSymbols$2P) {
    var _iterator267 = _createForOfIteratorHelper(__getOwnPropSymbols$2P(b)),
      _step268;
    try {
      for (_iterator267.s(); !(_step268 = _iterator267.n()).done;) {
        var prop = _step268.value;
        if (__propIsEnum$2P.call(b, prop)) __defNormalProp$2O(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator267.e(err);
    } finally {
      _iterator267.f();
    }
  }
  return a;
};
var __spreadProps$1f = function __spreadProps$1f(a, b) {
  return __defProps$1f(a, __getOwnPropDescs$1f(b));
};
var useStyles$1h = createStyles(function (theme, _ref157) {
  var contentPadding = _ref157.contentPadding,
    color = _ref157.color,
    orientation = _ref157.orientation,
    iconPosition = _ref157.iconPosition,
    iconSize = _ref157.iconSize,
    size = _ref157.size,
    breakpoint = _ref157.breakpoint;
  var shouldBeResponsive = typeof breakpoint !== "undefined";
  var breakpointValue = theme.fn.size({
    size: breakpoint,
    sizes: theme.breakpoints
  });
  var separatorOffset = typeof iconSize !== "undefined" ? iconSize / 2 - 1 : theme.fn.size({
    size: size,
    sizes: iconSizes$5
  }) / 2 - 1;
  var verticalOrientationStyles = {
    steps: {
      flexDirection: "column",
      alignItems: iconPosition === "left" ? "flex-start" : "flex-end"
    },
    separator: {
      width: 2,
      minHeight: theme.spacing.xl,
      marginLeft: iconPosition === "left" ? separatorOffset : 0,
      marginRight: iconPosition === "right" ? separatorOffset : 0,
      marginTop: theme.spacing.xs / 2,
      marginBottom: theme.spacing.xs / 2
    }
  };
  var responsiveStyles = {
    steps: _defineProperty({}, "@media (max-width: ".concat(breakpointValue, "px)"), verticalOrientationStyles.steps),
    separator: _defineProperty({}, "@media (max-width: ".concat(breakpointValue, "px)"), verticalOrientationStyles.separator)
  };
  return {
    root: {},
    steps: __spreadValues$2O(__spreadValues$2O({
      display: "flex",
      boxSizing: "border-box",
      alignItems: "center"
    }, orientation === "vertical" ? verticalOrientationStyles.steps : null), shouldBeResponsive ? responsiveStyles.steps : null),
    separator: __spreadValues$2O(__spreadValues$2O({
      boxSizing: "border-box",
      transition: "background-color 150ms ease",
      flex: 1,
      height: 2,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
      marginLeft: theme.spacing.md,
      marginRight: theme.spacing.md
    }, orientation === "vertical" ? verticalOrientationStyles.separator : null), shouldBeResponsive ? responsiveStyles.separator : null),
    separatorActive: {
      backgroundColor: theme.fn.variant({
        variant: "filled",
        color: color
      }).background
    },
    content: __spreadProps$1f(__spreadValues$2O({}, theme.fn.fontStyles()), {
      paddingTop: theme.fn.size({
        size: contentPadding,
        sizes: theme.spacing
      })
    })
  };
});
var __defProp$2P = Object.defineProperty;
var __defProps$1g = Object.defineProperties;
var __getOwnPropDescs$1g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2Q = Object.getOwnPropertySymbols;
var __hasOwnProp$2Q = Object.prototype.hasOwnProperty;
var __propIsEnum$2Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2P = function __defNormalProp$2P(obj, key, value) {
  return key in obj ? __defProp$2P(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2P = function __spreadValues$2P(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2Q.call(b, prop)) __defNormalProp$2P(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Q) {
    var _iterator268 = _createForOfIteratorHelper(__getOwnPropSymbols$2Q(b)),
      _step269;
    try {
      for (_iterator268.s(); !(_step269 = _iterator268.n()).done;) {
        var prop = _step269.value;
        if (__propIsEnum$2Q.call(b, prop)) __defNormalProp$2P(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator268.e(err);
    } finally {
      _iterator268.f();
    }
  }
  return a;
};
var __spreadProps$1g = function __spreadProps$1g(a, b) {
  return __defProps$1g(a, __getOwnPropDescs$1g(b));
};
var __objRest$1G = function __objRest$1G(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2Q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2Q) {
    var _iterator269 = _createForOfIteratorHelper(__getOwnPropSymbols$2Q(source)),
      _step270;
    try {
      for (_iterator269.s(); !(_step270 = _iterator269.n()).done;) {
        var prop = _step270.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2Q.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator269.e(err);
    } finally {
      _iterator269.f();
    }
  }
  return target;
};
var defaultProps$1a = {
  contentPadding: "md",
  size: "md",
  radius: "xl",
  orientation: "horizontal",
  iconPosition: "left"
};
var Stepper = forwardRef(function (props, ref) {
  var _b, _c, _d;
  var _a = useMantineDefaultProps("Stepper", defaultProps$1a, props),
    className = _a.className,
    children = _a.children,
    onStepClick = _a.onStepClick,
    active = _a.active,
    completedIcon = _a.completedIcon,
    progressIcon = _a.progressIcon,
    color = _a.color,
    iconSize = _a.iconSize,
    contentPadding = _a.contentPadding,
    size = _a.size,
    radius = _a.radius,
    orientation = _a.orientation,
    breakpoint = _a.breakpoint,
    iconPosition = _a.iconPosition,
    classNames = _a.classNames,
    styles = _a.styles,
    others = __objRest$1G(_a, ["className", "children", "onStepClick", "active", "completedIcon", "progressIcon", "color", "iconSize", "contentPadding", "size", "radius", "orientation", "breakpoint", "iconPosition", "classNames", "styles"]);
  var _useStyles$1h = useStyles$1h({
      contentPadding: contentPadding,
      color: color,
      orientation: orientation,
      iconPosition: iconPosition,
      size: size,
      iconSize: iconSize,
      breakpoint: breakpoint
    }, {
      classNames: classNames,
      styles: styles,
      name: "Stepper"
    }),
    classes = _useStyles$1h.classes,
    cx = _useStyles$1h.cx;
  var filteredChildren = filterChildrenByType(children, Step);
  var completedStep = findChildByType(children, StepCompleted);
  var items = filteredChildren.reduce(function (acc, item, index, array) {
    var shouldAllowSelect = typeof item.props.allowStepSelect === "boolean" ? item.props.allowStepSelect : typeof onStepClick === "function";
    acc.push( /* @__PURE__ */React__default.createElement(Step, __spreadProps$1g(__spreadValues$2P({}, item.props), {
      __staticSelector: "Stepper",
      icon: item.props.icon || index + 1,
      key: index,
      state: active === index ? "stepProgress" : active > index ? "stepCompleted" : "stepInactive",
      onClick: function onClick() {
        return shouldAllowSelect && typeof onStepClick === "function" && onStepClick(index);
      },
      allowStepClick: shouldAllowSelect && typeof onStepClick === "function",
      completedIcon: item.props.completedIcon || completedIcon,
      progressIcon: item.props.progressIcon || progressIcon,
      color: item.props.color || color,
      iconSize: iconSize,
      size: size,
      radius: radius,
      classNames: classNames,
      styles: styles,
      iconPosition: item.props.iconPosition || iconPosition
    })));
    if (index !== array.length - 1) {
      acc.push( /* @__PURE__ */React__default.createElement("div", {
        className: cx(classes.separator, _defineProperty({}, classes.separatorActive, index < active)),
        key: "separator-".concat(index)
      }));
    }
    return acc;
  }, []);
  var stepContent = (_c = (_b = filteredChildren[active]) == null ? void 0 : _b.props) == null ? void 0 : _c.children;
  var completedContent = (_d = completedStep == null ? void 0 : completedStep.props) == null ? void 0 : _d.children;
  var content = active > filteredChildren.length - 1 ? completedContent : stepContent;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2P({
    className: cx(classes.root, className),
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: classes.steps
  }, items), content && /* @__PURE__ */React__default.createElement("div", {
    className: classes.content
  }, content));
});
Stepper.Step = Step;
Stepper.Completed = StepCompleted;
Stepper.displayName = "@mantine/core/Stepper";
var __defProp$2Q = Object.defineProperty;
var __defProps$1h = Object.defineProperties;
var __getOwnPropDescs$1h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2R = Object.getOwnPropertySymbols;
var __hasOwnProp$2R = Object.prototype.hasOwnProperty;
var __propIsEnum$2R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Q = function __defNormalProp$2Q(obj, key, value) {
  return key in obj ? __defProp$2Q(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2Q = function __spreadValues$2Q(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2R.call(b, prop)) __defNormalProp$2Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$2R) {
    var _iterator270 = _createForOfIteratorHelper(__getOwnPropSymbols$2R(b)),
      _step271;
    try {
      for (_iterator270.s(); !(_step271 = _iterator270.n()).done;) {
        var prop = _step271.value;
        if (__propIsEnum$2R.call(b, prop)) __defNormalProp$2Q(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator270.e(err);
    } finally {
      _iterator270.f();
    }
  }
  return a;
};
var __spreadProps$1h = function __spreadProps$1h(a, b) {
  return __defProps$1h(a, __getOwnPropDescs$1h(b));
};
var switchHeight = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 30,
  xl: 36
};
var switchWidth = {
  xs: 30,
  sm: 38,
  md: 46,
  lg: 56,
  xl: 68
};
var handleSizes = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 22,
  xl: 28
};
var labelFontSizes = {
  xs: 5,
  sm: 6,
  md: 7,
  lg: 9,
  xl: 11
};
var sizes$k = Object.keys(switchHeight).reduce(function (acc, size) {
  acc[size] = {
    width: switchWidth[size],
    height: switchHeight[size]
  };
  return acc;
}, {});
var useStyles$1i = createStyles(function (theme, _ref158) {
  var size = _ref158.size,
    radius = _ref158.radius,
    color = _ref158.color,
    offLabel = _ref158.offLabel,
    onLabel = _ref158.onLabel;
  var handleSize = theme.fn.size({
    size: size,
    sizes: handleSizes
  });
  var borderRadius = theme.fn.size({
    size: radius,
    sizes: theme.radius
  });
  var colors = theme.fn.variant({
    variant: "filled",
    color: color
  });
  return {
    root: {
      display: "flex",
      alignItems: "center"
    },
    input: __spreadProps$1h(__spreadValues$2Q({}, theme.fn.focusStyles()), {
      overflow: "hidden",
      WebkitTapHighlightColor: "transparent",
      position: "relative",
      borderRadius: borderRadius,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]),
      height: theme.fn.size({
        size: size,
        sizes: switchHeight
      }),
      width: theme.fn.size({
        size: size,
        sizes: switchWidth
      }),
      minWidth: theme.fn.size({
        size: size,
        sizes: switchWidth
      }),
      margin: 0,
      transitionProperty: "background-color, border-color",
      transitionTimingFunction: theme.transitionTimingFunction,
      transitionDuration: "150ms",
      boxSizing: "border-box",
      appearance: "none",
      display: "flex",
      alignItems: "center",
      fontSize: theme.fn.size({
        size: size,
        sizes: labelFontSizes
      }),
      fontWeight: 600,
      "&::before": {
        zIndex: 1,
        borderRadius: borderRadius,
        boxSizing: "border-box",
        content: "''",
        display: "block",
        backgroundColor: theme.white,
        height: handleSize,
        width: handleSize,
        border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.white : theme.colors.gray[3]),
        transition: "transform 150ms ".concat(theme.transitionTimingFunction),
        transform: "translateX(".concat(size === "xs" ? 1 : 2, "px)"),
        "@media (prefers-reduced-motion)": {
          transitionDuration: "0ms"
        }
      },
      "&::after": {
        position: "absolute",
        zIndex: 0,
        display: "flex",
        height: "100%",
        alignItems: "center",
        lineHeight: 0,
        right: "10%",
        transform: "translateX(0)",
        content: offLabel ? "'".concat(offLabel, "'") : "''",
        color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[6],
        transition: "color 150ms ".concat(theme.transitionTimingFunction)
      },
      "&:checked": {
        backgroundColor: colors.background,
        borderColor: colors.background,
        "&::before": {
          transform: "translateX(".concat(theme.fn.size({
            size: size,
            sizes: switchWidth
          }) - theme.fn.size({
            size: size,
            sizes: handleSizes
          }) - (size === "xs" ? 3 : 4), "px)"),
          borderColor: theme.white
        },
        "&::after": {
          position: "absolute",
          zIndex: 0,
          display: "flex",
          height: "100%",
          alignItems: "center",
          lineHeight: 0,
          left: "10%",
          transform: "translateX(0)",
          content: onLabel ? "'".concat(onLabel, "'") : "''",
          color: theme.white,
          transition: "color 150ms ".concat(theme.transitionTimingFunction)
        }
      },
      "&:disabled": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        cursor: "not-allowed",
        "&::before": {
          borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
          backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[0]
        }
      }
    }),
    label: __spreadProps$1h(__spreadValues$2Q({}, theme.fn.fontStyles()), {
      WebkitTapHighlightColor: "transparent",
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      fontFamily: theme.fontFamily,
      paddingLeft: theme.spacing.sm,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    })
  };
});
var __defProp$2R = Object.defineProperty;
var __defProps$1i = Object.defineProperties;
var __getOwnPropDescs$1i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2S = Object.getOwnPropertySymbols;
var __hasOwnProp$2S = Object.prototype.hasOwnProperty;
var __propIsEnum$2S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2R = function __defNormalProp$2R(obj, key, value) {
  return key in obj ? __defProp$2R(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2R = function __spreadValues$2R(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2S.call(b, prop)) __defNormalProp$2R(a, prop, b[prop]);
  if (__getOwnPropSymbols$2S) {
    var _iterator271 = _createForOfIteratorHelper(__getOwnPropSymbols$2S(b)),
      _step272;
    try {
      for (_iterator271.s(); !(_step272 = _iterator271.n()).done;) {
        var prop = _step272.value;
        if (__propIsEnum$2S.call(b, prop)) __defNormalProp$2R(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator271.e(err);
    } finally {
      _iterator271.f();
    }
  }
  return a;
};
var __spreadProps$1i = function __spreadProps$1i(a, b) {
  return __defProps$1i(a, __getOwnPropDescs$1i(b));
};
var __objRest$1H = function __objRest$1H(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2S.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2S) {
    var _iterator272 = _createForOfIteratorHelper(__getOwnPropSymbols$2S(source)),
      _step273;
    try {
      for (_iterator272.s(); !(_step273 = _iterator272.n()).done;) {
        var prop = _step273.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2S.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator272.e(err);
    } finally {
      _iterator272.f();
    }
  }
  return target;
};
var defaultProps$1b = {
  offLabel: "",
  onLabel: "",
  size: "sm",
  radius: "xl"
};
var Switch = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Switch", defaultProps$1b, props),
    className = _a.className,
    color = _a.color,
    label = _a.label,
    offLabel = _a.offLabel,
    onLabel = _a.onLabel,
    id = _a.id,
    style = _a.style,
    size = _a.size,
    radius = _a.radius,
    wrapperProps = _a.wrapperProps,
    children = _a.children,
    classNames = _a.classNames,
    styles = _a.styles,
    sx = _a.sx,
    others = __objRest$1H(_a, ["className", "color", "label", "offLabel", "onLabel", "id", "style", "size", "radius", "wrapperProps", "children", "classNames", "styles", "sx"]);
  var _useStyles$1i = useStyles$1i({
      size: size,
      color: color,
      radius: radius,
      offLabel: offLabel,
      onLabel: onLabel
    }, {
      classNames: classNames,
      styles: styles,
      name: "Switch"
    }),
    classes = _useStyles$1i.classes,
    cx = _useStyles$1i.cx;
  var _extractSystemStyles15 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles15.systemStyles,
    rest = _extractSystemStyles15.rest;
  var uuid = useUuid(id);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2R(__spreadValues$2R({
    className: cx(classes.root, className),
    style: style,
    sx: sx
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement("input", __spreadProps$1i(__spreadValues$2R({}, rest), {
    id: uuid,
    ref: ref,
    type: "checkbox",
    className: classes.input
  })), label && /* @__PURE__ */React__default.createElement("label", {
    className: classes.label,
    htmlFor: uuid
  }, label));
});
Switch.displayName = "@mantine/core/Switch";
var __defProp$2S = Object.defineProperty;
var __defProps$1j = Object.defineProperties;
var __getOwnPropDescs$1j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2T = Object.getOwnPropertySymbols;
var __hasOwnProp$2T = Object.prototype.hasOwnProperty;
var __propIsEnum$2T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2S = function __defNormalProp$2S(obj, key, value) {
  return key in obj ? __defProp$2S(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2S = function __spreadValues$2S(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2T.call(b, prop)) __defNormalProp$2S(a, prop, b[prop]);
  if (__getOwnPropSymbols$2T) {
    var _iterator273 = _createForOfIteratorHelper(__getOwnPropSymbols$2T(b)),
      _step274;
    try {
      for (_iterator273.s(); !(_step274 = _iterator273.n()).done;) {
        var prop = _step274.value;
        if (__propIsEnum$2T.call(b, prop)) __defNormalProp$2S(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator273.e(err);
    } finally {
      _iterator273.f();
    }
  }
  return a;
};
var __spreadProps$1j = function __spreadProps$1j(a, b) {
  return __defProps$1j(a, __getOwnPropDescs$1j(b));
};
var useStyles$1j = createStyles(function (theme, _ref159, getRef) {
  var _spreadProps$1j;
  var captionSide = _ref159.captionSide,
    horizontalSpacing = _ref159.horizontalSpacing,
    verticalSpacing = _ref159.verticalSpacing,
    fontSize = _ref159.fontSize;
  var striped = {
    ref: getRef("striped")
  };
  var hover = {
    ref: getRef("hover")
  };
  return {
    striped: striped,
    hover: hover,
    root: __spreadProps$1j(__spreadValues$2S({}, theme.fn.fontStyles()), (_spreadProps$1j = {
      width: "100%",
      borderCollapse: "collapse",
      captionSide: captionSide,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      lineHeight: theme.lineHeight,
      "& caption": {
        marginTop: captionSide === "top" ? 0 : theme.spacing.xs,
        marginBottom: captionSide === "bottom" ? 0 : theme.spacing.xs,
        fontSize: theme.fontSizes.sm,
        color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6]
      },
      "& thead tr th, & tfoot tr th": {
        textAlign: "left",
        fontWeight: "bold",
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
        fontSize: theme.fn.size({
          size: fontSize,
          sizes: theme.fontSizes
        }),
        padding: "".concat(theme.fn.size({
          size: verticalSpacing,
          sizes: theme.spacing
        }), "px ").concat(theme.fn.size({
          size: horizontalSpacing,
          sizes: theme.spacing
        }), "px")
      },
      "& thead tr th": {
        borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3])
      },
      "& tfoot tr th": {
        borderTop: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3])
      },
      "& tbody tr td": {
        padding: "".concat(theme.fn.size({
          size: verticalSpacing,
          sizes: theme.spacing
        }), "px ").concat(theme.fn.size({
          size: horizontalSpacing,
          sizes: theme.spacing
        }), "px"),
        borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]),
        fontSize: theme.fn.size({
          size: fontSize,
          sizes: theme.fontSizes
        })
      },
      "& tbody tr:last-of-type td": {
        borderBottom: "none"
      }
    }, _defineProperty(_spreadProps$1j, "&.".concat(striped.ref, " tbody tr:nth-of-type(odd)"), {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
    }), _defineProperty(_spreadProps$1j, "&.".concat(hover.ref, " tbody tr:hover"), {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]
    }), _spreadProps$1j))
  };
});
var __defProp$2T = Object.defineProperty;
var __defProps$1k = Object.defineProperties;
var __getOwnPropDescs$1k = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2U = Object.getOwnPropertySymbols;
var __hasOwnProp$2U = Object.prototype.hasOwnProperty;
var __propIsEnum$2U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2T = function __defNormalProp$2T(obj, key, value) {
  return key in obj ? __defProp$2T(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2T = function __spreadValues$2T(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2U.call(b, prop)) __defNormalProp$2T(a, prop, b[prop]);
  if (__getOwnPropSymbols$2U) {
    var _iterator274 = _createForOfIteratorHelper(__getOwnPropSymbols$2U(b)),
      _step275;
    try {
      for (_iterator274.s(); !(_step275 = _iterator274.n()).done;) {
        var prop = _step275.value;
        if (__propIsEnum$2U.call(b, prop)) __defNormalProp$2T(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator274.e(err);
    } finally {
      _iterator274.f();
    }
  }
  return a;
};
var __spreadProps$1k = function __spreadProps$1k(a, b) {
  return __defProps$1k(a, __getOwnPropDescs$1k(b));
};
var __objRest$1I = function __objRest$1I(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2U.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2U) {
    var _iterator275 = _createForOfIteratorHelper(__getOwnPropSymbols$2U(source)),
      _step276;
    try {
      for (_iterator275.s(); !(_step276 = _iterator275.n()).done;) {
        var prop = _step276.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2U.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator275.e(err);
    } finally {
      _iterator275.f();
    }
  }
  return target;
};
var defaultProps$1c = {
  striped: false,
  highlightOnHover: false,
  captionSide: "top",
  horizontalSpacing: "xs",
  fontSize: "sm",
  verticalSpacing: 7
};
var Table = forwardRef(function (props, ref) {
  var _cx20;
  var _a = useMantineDefaultProps("Table", defaultProps$1c, props),
    className = _a.className,
    children = _a.children,
    striped = _a.striped,
    highlightOnHover = _a.highlightOnHover,
    captionSide = _a.captionSide,
    horizontalSpacing = _a.horizontalSpacing,
    verticalSpacing = _a.verticalSpacing,
    fontSize = _a.fontSize,
    others = __objRest$1I(_a, ["className", "children", "striped", "highlightOnHover", "captionSide", "horizontalSpacing", "verticalSpacing", "fontSize"]);
  var _useStyles$1j = useStyles$1j({
      captionSide: captionSide,
      verticalSpacing: verticalSpacing,
      horizontalSpacing: horizontalSpacing,
      fontSize: fontSize
    }, {
      name: "Table"
    }),
    classes = _useStyles$1j.classes,
    cx = _useStyles$1j.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadProps$1k(__spreadValues$2T({}, others), {
    component: "table",
    ref: ref,
    className: cx(classes.root, (_cx20 = {}, _defineProperty(_cx20, classes.striped, striped), _defineProperty(_cx20, classes.hover, highlightOnHover), _cx20), className)
  }), children);
});
Table.displayName = "@mantine/core/Table";
var __defProp$2U = Object.defineProperty;
var __defProps$1l = Object.defineProperties;
var __getOwnPropDescs$1l = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2V = Object.getOwnPropertySymbols;
var __hasOwnProp$2V = Object.prototype.hasOwnProperty;
var __propIsEnum$2V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2U = function __defNormalProp$2U(obj, key, value) {
  return key in obj ? __defProp$2U(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2U = function __spreadValues$2U(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2V.call(b, prop)) __defNormalProp$2U(a, prop, b[prop]);
  if (__getOwnPropSymbols$2V) {
    var _iterator276 = _createForOfIteratorHelper(__getOwnPropSymbols$2V(b)),
      _step277;
    try {
      for (_iterator276.s(); !(_step277 = _iterator276.n()).done;) {
        var prop = _step277.value;
        if (__propIsEnum$2V.call(b, prop)) __defNormalProp$2U(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator276.e(err);
    } finally {
      _iterator276.f();
    }
  }
  return a;
};
var __spreadProps$1l = function __spreadProps$1l(a, b) {
  return __defProps$1l(a, __getOwnPropDescs$1l(b));
};
var useStyles$1k = createStyles(function (theme, _ref160, getRef) {
  var _default;
  var color = _ref160.color,
    orientation = _ref160.orientation;
  var tabActive = {
    ref: getRef("tabActive")
  };
  return {
    tabActive: tabActive,
    tabLabel: {},
    tabControl: __spreadProps$1l(__spreadValues$2U(__spreadValues$2U({}, theme.fn.fontStyles()), theme.fn.focusStyles()), {
      WebkitTapHighlightColor: "transparent",
      boxSizing: "border-box",
      display: "block",
      height: 40,
      backgroundColor: "transparent",
      border: 0,
      padding: "0 ".concat(theme.spacing.md, "px"),
      fontSize: theme.fontSizes.sm,
      cursor: "pointer",
      width: orientation === "vertical" ? "100%" : "auto",
      "&:disabled": {
        cursor: "not-allowed",
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
      }
    }),
    default: (_default = {
      transition: "border-color 150ms ease, color 150ms ease",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    }, _defineProperty(_default, orientation === "horizontal" ? "borderBottom" : "borderRight", "2px solid transparent"), _defineProperty(_default, "&.".concat(tabActive.ref), _defineProperty({
      color: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 4 : 7)
    }, orientation === "horizontal" ? "borderBottomColor" : "borderRightColor", theme.fn.themeColor(color, theme.colorScheme === "dark" ? 4 : 7))), _default),
    outline: _defineProperty({
      borderBottomLeftRadius: orientation === "vertical" ? theme.radius.sm : 0,
      borderTopRightRadius: orientation === "horizontal" ? theme.radius.sm : 0,
      borderTopLeftRadius: theme.radius.sm,
      border: "1px solid transparent",
      borderBottom: orientation === "horizontal" ? 0 : "1px solid transparent",
      borderRight: orientation === "vertical" ? 0 : "1px solid transparent",
      color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7]
    }, "&.".concat(tabActive.ref), {
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
      background: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
    }),
    pills: _defineProperty({
      borderRadius: theme.radius.sm,
      backgroundColor: "transparent",
      color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7],
      fontSize: theme.fontSizes.sm,
      height: "auto",
      padding: "".concat(theme.spacing.xs, "px ").concat(theme.spacing.lg, "px"),
      fontWeight: 500,
      "&:hover": {
        background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
      }
    }, "&.".concat(tabActive.ref), {
      color: theme.colorScheme === "dark" ? theme.white : theme.black,
      background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
    }),
    tabInner: {
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: orientation === "horizontal" ? "center" : "flex-start",
      lineHeight: 1,
      height: "100%"
    },
    tabIcon: {
      "&:not(:only-child)": {
        marginRight: theme.spacing.xs
      },
      "& *": {
        display: "block"
      }
    }
  };
});
var __defProp$2V = Object.defineProperty;
var __defProps$1m = Object.defineProperties;
var __getOwnPropDescs$1m = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2W = Object.getOwnPropertySymbols;
var __hasOwnProp$2W = Object.prototype.hasOwnProperty;
var __propIsEnum$2W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2V = function __defNormalProp$2V(obj, key, value) {
  return key in obj ? __defProp$2V(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2V = function __spreadValues$2V(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2W.call(b, prop)) __defNormalProp$2V(a, prop, b[prop]);
  if (__getOwnPropSymbols$2W) {
    var _iterator277 = _createForOfIteratorHelper(__getOwnPropSymbols$2W(b)),
      _step278;
    try {
      for (_iterator277.s(); !(_step278 = _iterator277.n()).done;) {
        var prop = _step278.value;
        if (__propIsEnum$2W.call(b, prop)) __defNormalProp$2V(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator277.e(err);
    } finally {
      _iterator277.f();
    }
  }
  return a;
};
var __spreadProps$1m = function __spreadProps$1m(a, b) {
  return __defProps$1m(a, __getOwnPropDescs$1m(b));
};
var __objRest$1J = function __objRest$1J(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2W.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2W) {
    var _iterator278 = _createForOfIteratorHelper(__getOwnPropSymbols$2W(source)),
      _step279;
    try {
      for (_iterator278.s(); !(_step279 = _iterator278.n()).done;) {
        var prop = _step279.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2W.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator278.e(err);
    } finally {
      _iterator278.f();
    }
  }
  return target;
};
var TabControl = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    active = _b.active,
    color = _b.color,
    _b$variant = _b.variant,
    variant = _b$variant === void 0 ? "default" : _b$variant,
    classNames = _b.classNames,
    styles = _b.styles,
    _b$orientation = _b.orientation,
    orientation = _b$orientation === void 0 ? "horizontal" : _b$orientation,
    __ = _b.icon,
    label = _b.label,
    icon = _b.icon,
    tabKey = _b.tabKey,
    overrideColor = _b.color,
    elementRef = _b.elementRef,
    others = __objRest$1J(_b, ["className", "active", "color", "variant", "classNames", "styles", "orientation", "icon", "label", "icon", "tabKey", "color", "elementRef"]);
  var _useStyles$1k = useStyles$1k({
      color: overrideColor || color,
      orientation: orientation
    }, {
      classNames: classNames,
      styles: styles,
      name: "Tabs"
    }),
    classes = _useStyles$1k.classes,
    cx = _useStyles$1k.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadProps$1m(__spreadValues$2V({}, others), {
    component: "button",
    tabIndex: active ? 0 : -1,
    className: cx(classes.tabControl, classes[variant], _defineProperty({}, classes.tabActive, active), className),
    type: "button",
    role: "tab",
    "aria-selected": active,
    ref: mergeRefs(ref, elementRef)
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.tabInner
  }, icon && /* @__PURE__ */React__default.createElement("div", {
    className: classes.tabIcon
  }, icon), label && /* @__PURE__ */React__default.createElement("div", {
    className: classes.tabLabel
  }, label)));
});
TabControl.displayName = "@mantine/core/TabControl";
var useStyles$1l = createStyles(function (theme, _ref161, getRef) {
  var _default2, _outline2;
  var tabPadding = _ref161.tabPadding,
    orientation = _ref161.orientation;
  var tabsList = {
    ref: getRef("tabsList")
  };
  return {
    tabsListWrapper: {},
    tabsList: tabsList,
    root: {
      display: orientation === "vertical" ? "flex" : "block"
    },
    pills: {
      marginRight: orientation === "vertical" ? 20 : 0
    },
    body: _defineProperty({}, orientation === "horizontal" ? "paddingTop" : "paddingLeft", theme.fn.size({
      size: tabPadding,
      sizes: theme.spacing
    })),
    default: (_default2 = {}, _defineProperty(_default2, orientation === "horizontal" ? "borderBottom" : "borderRight", "2px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2])), _defineProperty(_default2, "& .".concat(tabsList.ref), _defineProperty({}, orientation === "horizontal" ? "marginBottom" : "marginRight", -2)), _default2),
    outline: (_outline2 = {}, _defineProperty(_outline2, orientation === "horizontal" ? "borderBottom" : "borderRight", "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2])), _defineProperty(_outline2, "& .".concat(tabsList.ref), _defineProperty({}, orientation === "horizontal" ? "marginBottom" : "marginRight", -1)), _outline2)
  };
});
var __defProp$2W = Object.defineProperty;
var __getOwnPropSymbols$2X = Object.getOwnPropertySymbols;
var __hasOwnProp$2X = Object.prototype.hasOwnProperty;
var __propIsEnum$2X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2W = function __defNormalProp$2W(obj, key, value) {
  return key in obj ? __defProp$2W(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2W = function __spreadValues$2W(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2X.call(b, prop)) __defNormalProp$2W(a, prop, b[prop]);
  if (__getOwnPropSymbols$2X) {
    var _iterator279 = _createForOfIteratorHelper(__getOwnPropSymbols$2X(b)),
      _step280;
    try {
      for (_iterator279.s(); !(_step280 = _iterator279.n()).done;) {
        var prop = _step280.value;
        if (__propIsEnum$2X.call(b, prop)) __defNormalProp$2W(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator279.e(err);
    } finally {
      _iterator279.f();
    }
  }
  return a;
};
var __objRest$1K = function __objRest$1K(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2X.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2X) {
    var _iterator280 = _createForOfIteratorHelper(__getOwnPropSymbols$2X(source)),
      _step281;
    try {
      for (_iterator280.s(); !(_step281 = _iterator280.n()).done;) {
        var prop = _step281.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2X.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator280.e(err);
    } finally {
      _iterator280.f();
    }
  }
  return target;
};
function getPreviousTab(active, tabs) {
  for (var _i15 = active - 1; _i15 >= 0; _i15 -= 1) {
    if (!tabs[_i15].props.disabled) {
      return _i15;
    }
  }
  return active;
}
function getNextTab(active, tabs) {
  for (var _i16 = active + 1; _i16 < tabs.length; _i16 += 1) {
    if (!tabs[_i16].props.disabled) {
      return _i16;
    }
  }
  return active;
}
function findInitialTab(tabs) {
  for (var _i17 = 0; _i17 < tabs.length; _i17 += 1) {
    if (!tabs[_i17].props.disabled) {
      return _i17;
    }
  }
  return -1;
}
var defaultProps$1d = {
  position: "left",
  grow: false,
  variant: "default",
  tabPadding: "xs",
  orientation: "horizontal"
};
var Tabs = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Tabs", defaultProps$1d, props),
    className = _a.className,
    children = _a.children,
    initialTab = _a.initialTab,
    active = _a.active,
    position = _a.position,
    grow = _a.grow,
    onTabChange = _a.onTabChange,
    color = _a.color,
    variant = _a.variant,
    classNames = _a.classNames,
    styles = _a.styles,
    tabPadding = _a.tabPadding,
    orientation = _a.orientation,
    others = __objRest$1K(_a, ["className", "children", "initialTab", "active", "position", "grow", "onTabChange", "color", "variant", "classNames", "styles", "tabPadding", "orientation"]);
  var _useStyles$1l = useStyles$1l({
      tabPadding: tabPadding,
      orientation: orientation
    }, {
      classNames: classNames,
      styles: styles,
      name: "Tabs"
    }),
    classes = _useStyles$1l.classes,
    cx = _useStyles$1l.cx,
    theme = _useStyles$1l.theme;
  var controlRefs = useRef({});
  var tabs = Children.toArray(children);
  var _useUncontrolled31 = useUncontrolled({
      value: active,
      defaultValue: initialTab,
      finalValue: findInitialTab(tabs),
      rule: function rule(value) {
        return typeof value === "number";
      },
      onChange: function onChange(value) {
        if (onTabChange) {
          tabs.some(function (tab) {
            return tab.props.tabKey;
          }) ? onTabChange(value, tabs[value].props.tabKey) : onTabChange(value);
        }
      }
    }),
    _useUncontrolled32 = _slicedToArray(_useUncontrolled31, 2),
    _activeTab = _useUncontrolled32[0],
    handleActiveTabChange = _useUncontrolled32[1];
  var activeTab = clamp({
    value: _activeTab,
    min: 0,
    max: tabs.length - 1
  });
  var nextTabCode = orientation === "horizontal" ? theme.dir === "ltr" ? "ArrowRight" : "ArrowLeft" : "ArrowDown";
  var previousTabCode = orientation === "horizontal" ? theme.dir === "ltr" ? "ArrowLeft" : "ArrowRight" : "ArrowUp";
  var handleKeyDown = function handleKeyDown(event) {
    if (event.nativeEvent.code === nextTabCode) {
      event.preventDefault();
      var nextTab = getNextTab(activeTab, tabs);
      handleActiveTabChange(nextTab);
      controlRefs.current[nextTab].focus();
    }
    if (event.nativeEvent.code === previousTabCode) {
      event.preventDefault();
      var previousTab = getPreviousTab(activeTab, tabs);
      handleActiveTabChange(previousTab);
      controlRefs.current[previousTab].focus();
    }
  };
  var panes = tabs.map(function (tab, index) {
    return React__default.cloneElement(tab, {
      key: index,
      active: activeTab === index,
      onKeyDown: handleKeyDown,
      color: tab.props.color || color,
      variant: variant,
      orientation: orientation,
      elementRef: function elementRef(node) {
        controlRefs.current[index] = node;
      },
      onClick: function onClick() {
        return activeTab !== index && handleActiveTabChange(index);
      },
      classNames: classNames,
      styles: styles
    });
  });
  var content = tabs[activeTab].props.children;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2W({
    ref: ref,
    className: cx(classes.root, className)
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: cx(classes.tabsListWrapper, classes[variant])
  }, /* @__PURE__ */React__default.createElement(Group, {
    className: classes.tabsList,
    role: "tablist",
    direction: orientation === "horizontal" ? "row" : "column",
    "aria-orientation": orientation,
    spacing: variant === "pills" ? 5 : 0,
    position: position,
    grow: grow
  }, panes)), content && /* @__PURE__ */React__default.createElement("div", {
    role: "tabpanel",
    className: classes.body,
    key: activeTab
  }, content));
});
Tabs.displayName = "@mantine/core/Tabs";
Tabs.Tab = TabControl;
var __defProp$2X = Object.defineProperty;
var __defProps$1n = Object.defineProperties;
var __getOwnPropDescs$1n = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2Y = Object.getOwnPropertySymbols;
var __hasOwnProp$2Y = Object.prototype.hasOwnProperty;
var __propIsEnum$2Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2X = function __defNormalProp$2X(obj, key, value) {
  return key in obj ? __defProp$2X(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2X = function __spreadValues$2X(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2Y.call(b, prop)) __defNormalProp$2X(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Y) {
    var _iterator281 = _createForOfIteratorHelper(__getOwnPropSymbols$2Y(b)),
      _step282;
    try {
      for (_iterator281.s(); !(_step282 = _iterator281.n()).done;) {
        var prop = _step282.value;
        if (__propIsEnum$2Y.call(b, prop)) __defNormalProp$2X(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator281.e(err);
    } finally {
      _iterator281.f();
    }
  }
  return a;
};
var __spreadProps$1n = function __spreadProps$1n(a, b) {
  return __defProps$1n(a, __getOwnPropDescs$1n(b));
};
var sizes$l = {
  xs: 16,
  sm: 20,
  md: 26,
  lg: 32,
  xl: 40
};
var useStyles$1m = createStyles(function (theme, _ref162) {
  var color = _ref162.color,
    size = _ref162.size,
    radius = _ref162.radius,
    gradientFrom = _ref162.gradientFrom,
    gradientTo = _ref162.gradientTo,
    gradientDeg = _ref162.gradientDeg,
    variant = _ref162.variant;
  var colors = theme.fn.variant({
    variant: variant,
    color: color,
    gradient: {
      from: gradientFrom,
      to: gradientTo,
      deg: gradientDeg
    }
  });
  var iconSize = theme.fn.size({
    size: size,
    sizes: sizes$l
  });
  return {
    root: __spreadProps$1n(__spreadValues$2X({}, theme.fn.fontStyles()), {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
      width: iconSize,
      height: iconSize,
      minWidth: iconSize,
      minHeight: iconSize,
      borderRadius: theme.fn.radius(radius),
      backgroundColor: colors.background,
      color: colors.color,
      backgroundImage: variant === "gradient" ? colors.background : null,
      border: "1px solid ".concat(colors.border)
    })
  };
});
var __defProp$2Y = Object.defineProperty;
var __getOwnPropSymbols$2Z = Object.getOwnPropertySymbols;
var __hasOwnProp$2Z = Object.prototype.hasOwnProperty;
var __propIsEnum$2Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Y = function __defNormalProp$2Y(obj, key, value) {
  return key in obj ? __defProp$2Y(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2Y = function __spreadValues$2Y(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2Z.call(b, prop)) __defNormalProp$2Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Z) {
    var _iterator282 = _createForOfIteratorHelper(__getOwnPropSymbols$2Z(b)),
      _step283;
    try {
      for (_iterator282.s(); !(_step283 = _iterator282.n()).done;) {
        var prop = _step283.value;
        if (__propIsEnum$2Z.call(b, prop)) __defNormalProp$2Y(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator282.e(err);
    } finally {
      _iterator282.f();
    }
  }
  return a;
};
var __objRest$1L = function __objRest$1L(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2Z.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2Z) {
    var _iterator283 = _createForOfIteratorHelper(__getOwnPropSymbols$2Z(source)),
      _step284;
    try {
      for (_iterator283.s(); !(_step284 = _iterator283.n()).done;) {
        var prop = _step284.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2Z.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator283.e(err);
    } finally {
      _iterator283.f();
    }
  }
  return target;
};
var defaultProps$1e = {
  size: "md",
  variant: "filled",
  gradient: {
    from: "blue",
    to: "cyan",
    deg: 45
  }
};
var ThemeIcon = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("ThemeIcon", defaultProps$1e, props),
    className = _a.className,
    size = _a.size,
    radius = _a.radius,
    variant = _a.variant,
    color = _a.color,
    children = _a.children,
    gradient = _a.gradient,
    others = __objRest$1L(_a, ["className", "size", "radius", "variant", "color", "children", "gradient"]);
  var _useStyles$1m = useStyles$1m({
      variant: variant,
      radius: radius,
      color: color,
      size: size,
      gradientFrom: gradient.from,
      gradientTo: gradient.to,
      gradientDeg: gradient.deg
    }, {
      name: "ThemeIcon"
    }),
    classes = _useStyles$1m.classes,
    cx = _useStyles$1m.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2Y({
    className: cx(classes.root, className),
    ref: ref
  }, others), children);
});
ThemeIcon.displayName = "@mantine/core/ThemeIcon";
var useStyles$1n = createStyles(function (theme, _ref163, getRef) {
  var _itemActive;
  var bulletSize = _ref163.bulletSize,
    color = _ref163.color,
    radius = _ref163.radius,
    align = _ref163.align,
    lineVariant = _ref163.lineVariant,
    lineWidth = _ref163.lineWidth;
  var colors = theme.fn.variant({
    variant: "filled",
    color: color
  });
  return {
    itemBody: {},
    itemContent: {},
    itemBulletWithChild: {
      ref: getRef("itemBulletWithChild"),
      borderWidth: 1,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    },
    itemBullet: {
      ref: getRef("itemBullet"),
      boxSizing: "border-box",
      width: bulletSize,
      height: bulletSize,
      borderRadius: theme.fn.size({
        size: radius,
        sizes: theme.radius
      }),
      border: "".concat(lineWidth, "px solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      position: "absolute",
      top: 0,
      left: align === "left" ? -bulletSize / 2 - lineWidth / 2 : "auto",
      right: align === "right" ? -bulletSize / 2 - lineWidth / 2 : "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.white
    },
    item: {
      position: "relative",
      boxSizing: "border-box",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      paddingLeft: align === "left" ? theme.spacing.xl : 0,
      paddingRight: align === "right" ? theme.spacing.xl : 0,
      textAlign: align,
      "&:not(:last-of-type)::before": {
        display: "block"
      },
      "&:not(:first-of-type)": {
        marginTop: theme.spacing.xl
      },
      "&::before": {
        boxSizing: "border-box",
        position: "absolute",
        top: 0,
        left: align === "left" ? -lineWidth : "auto",
        right: align === "right" ? -lineWidth : "auto",
        bottom: -theme.spacing.xl,
        borderLeft: "".concat(lineWidth, "px ").concat(lineVariant, " ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]),
        content: '""',
        display: "none"
      }
    },
    itemLineActive: {
      "&::before": {
        borderLeftColor: colors.background
      }
    },
    itemActive: (_itemActive = {}, _defineProperty(_itemActive, "& .".concat(getRef("itemBullet")), {
      borderColor: colors.background,
      backgroundColor: theme.white
    }), _defineProperty(_itemActive, "& .".concat(getRef("itemBulletWithChild")), {
      backgroundColor: colors.background,
      color: theme.white
    }), _itemActive),
    itemTitle: {
      fontWeight: 500,
      lineHeight: 1,
      marginBottom: theme.spacing.xs / 2,
      textAlign: align
    }
  };
});
var __defProp$2Z = Object.defineProperty;
var __getOwnPropSymbols$2_ = Object.getOwnPropertySymbols;
var __hasOwnProp$2_ = Object.prototype.hasOwnProperty;
var __propIsEnum$2_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Z = function __defNormalProp$2Z(obj, key, value) {
  return key in obj ? __defProp$2Z(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2Z = function __spreadValues$2Z(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2_.call(b, prop)) __defNormalProp$2Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$2_) {
    var _iterator284 = _createForOfIteratorHelper(__getOwnPropSymbols$2_(b)),
      _step285;
    try {
      for (_iterator284.s(); !(_step285 = _iterator284.n()).done;) {
        var prop = _step285.value;
        if (__propIsEnum$2_.call(b, prop)) __defNormalProp$2Z(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator284.e(err);
    } finally {
      _iterator284.f();
    }
  }
  return a;
};
var __objRest$1M = function __objRest$1M(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$2_.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2_) {
    var _iterator285 = _createForOfIteratorHelper(__getOwnPropSymbols$2_(source)),
      _step286;
    try {
      for (_iterator285.s(); !(_step286 = _iterator285.n()).done;) {
        var prop = _step286.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2_.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator285.e(err);
    } finally {
      _iterator285.f();
    }
  }
  return target;
};
function TimelineItem(_a) {
  var _cx22;
  var _b = _a,
    className = _b.className,
    bullet = _b.bullet,
    title = _b.title,
    _b$bulletSize = _b.bulletSize,
    bulletSize = _b$bulletSize === void 0 ? 20 : _b$bulletSize,
    _b$radius2 = _b.radius,
    radius = _b$radius2 === void 0 ? "xl" : _b$radius2,
    _b$lineWidth = _b.lineWidth,
    lineWidth = _b$lineWidth === void 0 ? 4 : _b$lineWidth,
    active = _b.active,
    lineActive = _b.lineActive,
    classNames = _b.classNames,
    styles = _b.styles,
    children = _b.children,
    color = _b.color,
    align = _b.align,
    _b$lineVariant = _b.lineVariant,
    lineVariant = _b$lineVariant === void 0 ? "solid" : _b$lineVariant,
    others = __objRest$1M(_b, ["className", "bullet", "title", "bulletSize", "radius", "lineWidth", "active", "lineActive", "classNames", "styles", "children", "color", "align", "lineVariant"]);
  var _useStyles$1n = useStyles$1n({
      bulletSize: bulletSize,
      color: color,
      radius: radius,
      align: align,
      lineVariant: lineVariant,
      lineWidth: lineWidth
    }, {
      classNames: classNames,
      styles: styles,
      name: "Timeline"
    }),
    classes = _useStyles$1n.classes,
    cx = _useStyles$1n.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2Z({
    className: cx(classes.item, (_cx22 = {}, _defineProperty(_cx22, classes.itemLineActive, lineActive), _defineProperty(_cx22, classes.itemActive, active), _cx22), className)
  }, others), /* @__PURE__ */React__default.createElement("div", {
    className: cx(classes.itemBullet, _defineProperty({}, classes.itemBulletWithChild, bullet))
  }, bullet), /* @__PURE__ */React__default.createElement("div", {
    className: classes.itemBody
  }, title && /* @__PURE__ */React__default.createElement(Text, {
    className: classes.itemTitle
  }, title), /* @__PURE__ */React__default.createElement("div", {
    className: classes.itemContent
  }, children)));
}
TimelineItem.displayName = "@mantine/core/TimelineItem";
var __defProp$2_ = Object.defineProperty;
var __getOwnPropSymbols$30 = Object.getOwnPropertySymbols;
var __hasOwnProp$30 = Object.prototype.hasOwnProperty;
var __propIsEnum$30 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2_ = function __defNormalProp$2_(obj, key, value) {
  return key in obj ? __defProp$2_(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2_ = function __spreadValues$2_(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$30.call(b, prop)) __defNormalProp$2_(a, prop, b[prop]);
  if (__getOwnPropSymbols$30) {
    var _iterator286 = _createForOfIteratorHelper(__getOwnPropSymbols$30(b)),
      _step287;
    try {
      for (_iterator286.s(); !(_step287 = _iterator286.n()).done;) {
        var prop = _step287.value;
        if (__propIsEnum$30.call(b, prop)) __defNormalProp$2_(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator286.e(err);
    } finally {
      _iterator286.f();
    }
  }
  return a;
};
var __objRest$1N = function __objRest$1N(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$30.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$30) {
    var _iterator287 = _createForOfIteratorHelper(__getOwnPropSymbols$30(source)),
      _step288;
    try {
      for (_iterator287.s(); !(_step288 = _iterator287.n()).done;) {
        var prop = _step288.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$30.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator287.e(err);
    } finally {
      _iterator287.f();
    }
  }
  return target;
};
var defaultProps$1f = {
  active: -1,
  radius: "xl",
  bulletSize: 20,
  align: "left",
  lineWidth: 4,
  reverseActive: false
};
var Timeline = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Timeline", defaultProps$1f, props),
    children = _a.children,
    active = _a.active,
    color = _a.color,
    radius = _a.radius,
    bulletSize = _a.bulletSize,
    align = _a.align,
    lineWidth = _a.lineWidth,
    classNames = _a.classNames,
    styles = _a.styles,
    sx = _a.sx,
    reverseActive = _a.reverseActive,
    others = __objRest$1N(_a, ["children", "active", "color", "radius", "bulletSize", "align", "lineWidth", "classNames", "styles", "sx", "reverseActive"]);
  var _children = filterChildrenByType(children, TimelineItem);
  var items = _children.map(function (item, index) {
    return React__default.cloneElement(item, {
      classNames: classNames,
      styles: styles,
      align: align,
      lineWidth: lineWidth,
      radius: item.props.radius || radius,
      color: item.props.color || color,
      bulletSize: item.props.bulletSize || bulletSize,
      active: item.props.active || (reverseActive ? active >= _children.length - index - 1 : active >= index),
      lineActive: item.props.lineActive || (reverseActive ? active >= _children.length - index - 1 : active - 1 >= index)
    });
  });
  var offset = align === "left" ? {
    paddingLeft: bulletSize / 2 + lineWidth / 2
  } : {
    paddingRight: bulletSize / 2 + lineWidth / 2
  };
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$2_({
    ref: ref,
    sx: [offset].concat(_toConsumableArray2(Array.isArray(sx) ? sx : [sx]))
  }, others), items);
});
Timeline.Item = TimelineItem;
Timeline.displayName = "@mantine/core/Timeline";
var __defProp$30 = Object.defineProperty;
var __defProps$1o = Object.defineProperties;
var __getOwnPropDescs$1o = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$31 = Object.getOwnPropertySymbols;
var __hasOwnProp$31 = Object.prototype.hasOwnProperty;
var __propIsEnum$31 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$30 = function __defNormalProp$30(obj, key, value) {
  return key in obj ? __defProp$30(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$30 = function __spreadValues$30(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$31.call(b, prop)) __defNormalProp$30(a, prop, b[prop]);
  if (__getOwnPropSymbols$31) {
    var _iterator288 = _createForOfIteratorHelper(__getOwnPropSymbols$31(b)),
      _step289;
    try {
      for (_iterator288.s(); !(_step289 = _iterator288.n()).done;) {
        var prop = _step289.value;
        if (__propIsEnum$31.call(b, prop)) __defNormalProp$30(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator288.e(err);
    } finally {
      _iterator288.f();
    }
  }
  return a;
};
var __spreadProps$1o = function __spreadProps$1o(a, b) {
  return __defProps$1o(a, __getOwnPropDescs$1o(b));
};
var useStyles$1o = createStyles(function (theme, _ref164) {
  var element = _ref164.element,
    align = _ref164.align;
  return {
    root: __spreadProps$1o(__spreadValues$30({}, theme.fn.fontStyles()), {
      fontFamily: theme.headings.fontFamily,
      fontWeight: theme.headings.fontWeight,
      fontSize: theme.headings.sizes[element].fontSize,
      lineHeight: theme.headings.sizes[element].lineHeight,
      margin: 0,
      color: "inherit",
      textAlign: align
    })
  };
});
var __defProp$31 = Object.defineProperty;
var __getOwnPropSymbols$32 = Object.getOwnPropertySymbols;
var __hasOwnProp$32 = Object.prototype.hasOwnProperty;
var __propIsEnum$32 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$31 = function __defNormalProp$31(obj, key, value) {
  return key in obj ? __defProp$31(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$31 = function __spreadValues$31(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$32.call(b, prop)) __defNormalProp$31(a, prop, b[prop]);
  if (__getOwnPropSymbols$32) {
    var _iterator289 = _createForOfIteratorHelper(__getOwnPropSymbols$32(b)),
      _step290;
    try {
      for (_iterator289.s(); !(_step290 = _iterator289.n()).done;) {
        var prop = _step290.value;
        if (__propIsEnum$32.call(b, prop)) __defNormalProp$31(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator289.e(err);
    } finally {
      _iterator289.f();
    }
  }
  return a;
};
var __objRest$1O = function __objRest$1O(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$32.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$32) {
    var _iterator290 = _createForOfIteratorHelper(__getOwnPropSymbols$32(source)),
      _step291;
    try {
      for (_iterator290.s(); !(_step291 = _iterator290.n()).done;) {
        var prop = _step291.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$32.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator290.e(err);
    } finally {
      _iterator290.f();
    }
  }
  return target;
};
var defaultProps$1g = {
  order: 1
};
var Title = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Title", defaultProps$1g, props),
    className = _a.className,
    order = _a.order,
    children = _a.children,
    align = _a.align,
    others = __objRest$1O(_a, ["className", "order", "children", "align"]);
  var _useStyles$1o = useStyles$1o({
      element: "h".concat(order),
      align: align
    }, {
      name: "Title"
    }),
    classes = _useStyles$1o.classes,
    cx = _useStyles$1o.cx;
  if (![1, 2, 3, 4, 5, 6].includes(order)) {
    return null;
  }
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$31({
    component: "h".concat(order),
    ref: ref,
    className: cx(classes.root, className)
  }, others), children);
});
Title.displayName = "@mantine/core/Title";
var __defProp$32 = Object.defineProperty;
var __defProps$1p = Object.defineProperties;
var __getOwnPropDescs$1p = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$33 = Object.getOwnPropertySymbols;
var __hasOwnProp$33 = Object.prototype.hasOwnProperty;
var __propIsEnum$33 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$32 = function __defNormalProp$32(obj, key, value) {
  return key in obj ? __defProp$32(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$32 = function __spreadValues$32(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$33.call(b, prop)) __defNormalProp$32(a, prop, b[prop]);
  if (__getOwnPropSymbols$33) {
    var _iterator291 = _createForOfIteratorHelper(__getOwnPropSymbols$33(b)),
      _step292;
    try {
      for (_iterator291.s(); !(_step292 = _iterator291.n()).done;) {
        var prop = _step292.value;
        if (__propIsEnum$33.call(b, prop)) __defNormalProp$32(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator291.e(err);
    } finally {
      _iterator291.f();
    }
  }
  return a;
};
var __spreadProps$1p = function __spreadProps$1p(a, b) {
  return __defProps$1p(a, __getOwnPropDescs$1p(b));
};
var useStyles$1p = createStyles(function (theme, _ref165) {
  var color = _ref165.color,
    radius = _ref165.radius;
  return {
    root: {
      position: "relative",
      display: "inline-block"
    },
    body: __spreadProps$1p(__spreadValues$32({}, theme.fn.fontStyles()), {
      backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 9),
      lineHeight: theme.lineHeight,
      fontSize: theme.fontSizes.sm,
      borderRadius: theme.fn.radius(radius),
      padding: "".concat(theme.spacing.xs / 2, "px ").concat(theme.spacing.xs, "px"),
      color: theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white,
      position: "relative",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }),
    arrow: {
      border: 0,
      background: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 9),
      zIndex: 1
    }
  };
});
var __defProp$33 = Object.defineProperty;
var __getOwnPropSymbols$34 = Object.getOwnPropertySymbols;
var __hasOwnProp$34 = Object.prototype.hasOwnProperty;
var __propIsEnum$34 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$33 = function __defNormalProp$33(obj, key, value) {
  return key in obj ? __defProp$33(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$33 = function __spreadValues$33(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$34.call(b, prop)) __defNormalProp$33(a, prop, b[prop]);
  if (__getOwnPropSymbols$34) {
    var _iterator292 = _createForOfIteratorHelper(__getOwnPropSymbols$34(b)),
      _step293;
    try {
      for (_iterator292.s(); !(_step293 = _iterator292.n()).done;) {
        var prop = _step293.value;
        if (__propIsEnum$34.call(b, prop)) __defNormalProp$33(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator292.e(err);
    } finally {
      _iterator292.f();
    }
  }
  return a;
};
var __objRest$1P = function __objRest$1P(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$34.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$34) {
    var _iterator293 = _createForOfIteratorHelper(__getOwnPropSymbols$34(source)),
      _step294;
    try {
      for (_iterator293.s(); !(_step294 = _iterator293.n()).done;) {
        var prop = _step294.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$34.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator293.e(err);
    } finally {
      _iterator293.f();
    }
  }
  return target;
};
var defaultProps$1h = {
  openDelay: 0,
  closeDelay: 0,
  gutter: 5,
  color: "gray",
  disabled: false,
  withArrow: false,
  arrowSize: 2,
  position: "top",
  placement: "center",
  transition: "pop-top-left",
  transitionDuration: 100,
  zIndex: getDefaultZIndex("popover"),
  width: "auto",
  wrapLines: false,
  allowPointerEvents: false,
  positionDependencies: [],
  withinPortal: true
};
var Tooltip = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Tooltip", defaultProps$1h, props),
    className = _a.className,
    label = _a.label,
    children = _a.children,
    opened = _a.opened,
    openDelay = _a.openDelay,
    closeDelay = _a.closeDelay,
    gutter = _a.gutter,
    color = _a.color,
    radius = _a.radius,
    disabled = _a.disabled,
    withArrow = _a.withArrow,
    arrowSize = _a.arrowSize,
    position = _a.position,
    placement = _a.placement,
    transition = _a.transition,
    transitionDuration = _a.transitionDuration,
    zIndex = _a.zIndex,
    transitionTimingFunction = _a.transitionTimingFunction,
    width = _a.width,
    wrapLines = _a.wrapLines,
    allowPointerEvents = _a.allowPointerEvents,
    positionDependencies = _a.positionDependencies,
    withinPortal = _a.withinPortal,
    tooltipRef = _a.tooltipRef,
    tooltipId = _a.tooltipId,
    classNames = _a.classNames,
    styles = _a.styles,
    onMouseLeave = _a.onMouseLeave,
    onMouseEnter = _a.onMouseEnter,
    others = __objRest$1P(_a, ["className", "label", "children", "opened", "openDelay", "closeDelay", "gutter", "color", "radius", "disabled", "withArrow", "arrowSize", "position", "placement", "transition", "transitionDuration", "zIndex", "transitionTimingFunction", "width", "wrapLines", "allowPointerEvents", "positionDependencies", "withinPortal", "tooltipRef", "tooltipId", "classNames", "styles", "onMouseLeave", "onMouseEnter"]);
  var _useStyles$1p = useStyles$1p({
      color: color,
      radius: radius
    }, {
      classNames: classNames,
      styles: styles,
      name: "Tooltip"
    }),
    classes = _useStyles$1p.classes,
    cx = _useStyles$1p.cx,
    theme = _useStyles$1p.theme;
  var openTimeoutRef = useRef();
  var closeTimeoutRef = useRef();
  var _useState147 = useState(false),
    _useState148 = _slicedToArray(_useState147, 2),
    _opened = _useState148[0],
    setOpened = _useState148[1];
  var visible = (typeof opened === "boolean" ? opened : _opened) && !disabled;
  var _useState149 = useState(null),
    _useState150 = _slicedToArray(_useState149, 2),
    referenceElement = _useState150[0],
    setReferenceElement = _useState150[1];
  var mergedRefs = useMergedRef(ref, setReferenceElement);
  var handleOpen = function handleOpen() {
    window.clearTimeout(closeTimeoutRef.current);
    if (openDelay !== 0) {
      openTimeoutRef.current = window.setTimeout(function () {
        setOpened(true);
      }, openDelay);
    } else {
      setOpened(true);
    }
  };
  var handleClose = function handleClose() {
    window.clearTimeout(openTimeoutRef.current);
    if (closeDelay !== 0) {
      closeTimeoutRef.current = window.setTimeout(function () {
        setOpened(false);
      }, closeDelay);
    } else {
      setOpened(false);
    }
  };
  useEffect(function () {
    return function () {
      window.clearTimeout(openTimeoutRef.current);
      window.clearTimeout(closeTimeoutRef.current);
    };
  }, []);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$33({
    className: cx(classes.root, className),
    onPointerEnter: function onPointerEnter(event) {
      handleOpen();
      typeof onMouseEnter === "function" && onMouseEnter(event);
    },
    onPointerLeave: function onPointerLeave(event) {
      handleClose();
      typeof onMouseLeave === "function" && onMouseLeave(event);
    },
    onFocusCapture: handleOpen,
    onBlurCapture: handleClose,
    ref: mergedRefs
  }, others), /* @__PURE__ */React__default.createElement(Popper$1, {
    referenceElement: referenceElement,
    transitionDuration: transitionDuration,
    transition: transition,
    mounted: visible,
    position: position,
    placement: placement,
    gutter: gutter,
    withArrow: withArrow,
    arrowSize: arrowSize,
    arrowDistance: theme.fn.radius(radius) > 10 ? 7 : 3,
    zIndex: zIndex,
    arrowClassName: classes.arrow,
    forceUpdateDependencies: [color, radius].concat(_toConsumableArray2(positionDependencies)),
    withinPortal: withinPortal
  }, /* @__PURE__ */React__default.createElement(Box, {
    className: classes.body,
    ref: tooltipRef,
    sx: {
      pointerEvents: allowPointerEvents ? "all" : "none",
      whiteSpace: wrapLines ? "normal" : "nowrap",
      width: width
    }
  }, label)), children);
});
Tooltip.displayName = "@mantine/core/Tooltip";
var __defProp$34 = Object.defineProperty;
var __defProps$1q = Object.defineProperties;
var __getOwnPropDescs$1q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$35 = Object.getOwnPropertySymbols;
var __hasOwnProp$35 = Object.prototype.hasOwnProperty;
var __propIsEnum$35 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$34 = function __defNormalProp$34(obj, key, value) {
  return key in obj ? __defProp$34(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$34 = function __spreadValues$34(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$35.call(b, prop)) __defNormalProp$34(a, prop, b[prop]);
  if (__getOwnPropSymbols$35) {
    var _iterator294 = _createForOfIteratorHelper(__getOwnPropSymbols$35(b)),
      _step295;
    try {
      for (_iterator294.s(); !(_step295 = _iterator294.n()).done;) {
        var prop = _step295.value;
        if (__propIsEnum$35.call(b, prop)) __defNormalProp$34(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator294.e(err);
    } finally {
      _iterator294.f();
    }
  }
  return a;
};
var __spreadProps$1q = function __spreadProps$1q(a, b) {
  return __defProps$1q(a, __getOwnPropDescs$1q(b));
};
var useStyles$1q = createStyles(function (theme, _ref166) {
  var color = _ref166.color,
    radius = _ref166.radius;
  return {
    root: {
      position: "relative",
      display: "inline-block"
    },
    body: __spreadProps$1q(__spreadValues$34({}, theme.fn.fontStyles()), {
      backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 3 : 9),
      lineHeight: theme.lineHeight,
      fontSize: theme.fontSizes.sm,
      borderRadius: theme.fn.radius(radius),
      padding: "".concat(theme.spacing.xs / 2, "px ").concat(theme.spacing.xs, "px"),
      color: theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white,
      position: "absolute",
      overflow: "hidden",
      textOverflow: "ellipsis",
      pointerEvents: "none"
    })
  };
});
var __defProp$35 = Object.defineProperty;
var __defProps$1r = Object.defineProperties;
var __getOwnPropDescs$1r = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$36 = Object.getOwnPropertySymbols;
var __hasOwnProp$36 = Object.prototype.hasOwnProperty;
var __propIsEnum$36 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$35 = function __defNormalProp$35(obj, key, value) {
  return key in obj ? __defProp$35(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$35 = function __spreadValues$35(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$36.call(b, prop)) __defNormalProp$35(a, prop, b[prop]);
  if (__getOwnPropSymbols$36) {
    var _iterator295 = _createForOfIteratorHelper(__getOwnPropSymbols$36(b)),
      _step296;
    try {
      for (_iterator295.s(); !(_step296 = _iterator295.n()).done;) {
        var prop = _step296.value;
        if (__propIsEnum$36.call(b, prop)) __defNormalProp$35(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator295.e(err);
    } finally {
      _iterator295.f();
    }
  }
  return a;
};
var __spreadProps$1r = function __spreadProps$1r(a, b) {
  return __defProps$1r(a, __getOwnPropDescs$1r(b));
};
var __objRest$1Q = function __objRest$1Q(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$36.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$36) {
    var _iterator296 = _createForOfIteratorHelper(__getOwnPropSymbols$36(source)),
      _step297;
    try {
      for (_iterator296.s(); !(_step297 = _iterator296.n()).done;) {
        var prop = _step297.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$36.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator296.e(err);
    } finally {
      _iterator296.f();
    }
  }
  return target;
};
var defaultProps$1i = {
  openDelay: 0,
  closeDelay: 0,
  color: "gray",
  disabled: false,
  position: "right",
  transition: "pop-top-left",
  transitionDuration: 0,
  zIndex: getDefaultZIndex("popover"),
  width: "auto",
  wrapLines: false,
  positionDependencies: []
};
var FloatingTooltip = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("FloatingTooltip", defaultProps$1i, props),
    className = _a.className,
    label = _a.label,
    children = _a.children,
    openDelay = _a.openDelay,
    closeDelay = _a.closeDelay,
    color = _a.color,
    radius = _a.radius,
    disabled = _a.disabled,
    position = _a.position,
    transition = _a.transition,
    transitionDuration = _a.transitionDuration,
    zIndex = _a.zIndex,
    transitionTimingFunction = _a.transitionTimingFunction,
    width = _a.width,
    wrapLines = _a.wrapLines,
    positionDependencies = _a.positionDependencies,
    tooltipRef = _a.tooltipRef,
    tooltipId = _a.tooltipId,
    classNames = _a.classNames,
    styles = _a.styles,
    _onMouseLeave = _a.onMouseLeave,
    _onMouseEnter = _a.onMouseEnter,
    others = __objRest$1Q(_a, ["className", "label", "children", "openDelay", "closeDelay", "color", "radius", "disabled", "position", "transition", "transitionDuration", "zIndex", "transitionTimingFunction", "width", "wrapLines", "positionDependencies", "tooltipRef", "tooltipId", "classNames", "styles", "onMouseLeave", "onMouseEnter"]);
  var _useStyles$1q = useStyles$1q({
      color: color,
      radius: radius
    }, {
      classNames: classNames,
      styles: styles,
      name: "FloatingTooltip"
    }),
    classes = _useStyles$1q.classes,
    cx = _useStyles$1q.cx;
  var openTimeoutRef = useRef();
  var closeTimeoutRef = useRef();
  var _tooltipRef = useRef();
  var mergedTooltipRefs = useMergedRef(_tooltipRef, tooltipRef);
  var _useState151 = useState(false),
    _useState152 = _slicedToArray(_useState151, 2),
    opened = _useState152[0],
    setOpened = _useState152[1];
  var _useMouse = useMouse(),
    mouseRef = _useMouse.ref,
    x = _useMouse.x,
    y = _useMouse.y;
  var visible = opened && !disabled;
  var mergedRefs = useMergedRef(ref, mouseRef);
  var coordinates = useMemo(function () {
    var _a2, _b;
    var estimatedCursorSize = 32;
    var tooltipWidth = typeof width === "number" ? width : ((_a2 = _tooltipRef.current) == null ? void 0 : _a2.offsetWidth) || 0;
    var tooltipHeight = ((_b = _tooltipRef.current) == null ? void 0 : _b.offsetHeight) || 0;
    switch (position) {
      case "top":
        return {
          left: x - tooltipWidth / 2,
          top: y - tooltipHeight
        };
      case "left":
        return {
          left: x - tooltipWidth - estimatedCursorSize / 2,
          top: y
        };
      case "right":
        return {
          left: x + estimatedCursorSize / 2,
          top: y
        };
      case "bottom":
        return {
          left: x - tooltipWidth / 2,
          top: y + tooltipHeight
        };
      default:
        return {
          left: x || 0,
          top: y || 0
        };
    }
  }, [x, y].concat(_toConsumableArray2(positionDependencies)));
  var handleOpen = function handleOpen() {
    window.clearTimeout(closeTimeoutRef.current);
    if (openDelay !== 0) {
      openTimeoutRef.current = window.setTimeout(function () {
        setOpened(true);
      }, openDelay);
    } else {
      setOpened(true);
    }
  };
  var handleClose = function handleClose() {
    window.clearTimeout(openTimeoutRef.current);
    if (closeDelay !== 0) {
      closeTimeoutRef.current = window.setTimeout(function () {
        setOpened(false);
      }, closeDelay);
    } else {
      setOpened(false);
    }
  };
  useEffect(function () {
    return function () {
      window.clearTimeout(openTimeoutRef.current);
      window.clearTimeout(closeTimeoutRef.current);
    };
  }, []);
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$35({
    className: cx(classes.root, className),
    onMouseEnter: function onMouseEnter(event) {
      handleOpen();
      typeof _onMouseEnter === "function" && _onMouseEnter(event);
    },
    onMouseLeave: function onMouseLeave(event) {
      handleClose();
      typeof _onMouseLeave === "function" && _onMouseLeave(event);
    },
    onFocusCapture: handleOpen,
    onBlurCapture: handleClose,
    ref: mergedRefs
  }, others), /* @__PURE__ */React__default.createElement(Transition, {
    mounted: visible,
    duration: transitionDuration,
    transition: transition,
    exitDuration: transitionDuration,
    timingFunction: transitionTimingFunction
  }, function (transitionStyles) {
    return /* @__PURE__ */React__default.createElement("div", {
      style: __spreadProps$1r(__spreadValues$35({}, transitionStyles), {
        zIndex: zIndex,
        position: "relative"
      })
    }, /* @__PURE__ */React__default.createElement(Box, {
      className: classes.body,
      ref: mergedTooltipRefs,
      sx: __spreadValues$35({
        whiteSpace: wrapLines ? "normal" : "nowrap",
        width: width
      }, coordinates)
    }, label));
  }), children);
});
FloatingTooltip.displayName = "@mantine/core/FloatingTooltip";
var ITEM_PADDING = 7;
var useStyles$1r = createStyles(function (theme, _ref167) {
  var reversed = _ref167.reversed,
    native = _ref167.native,
    radius = _ref167.radius;
  return {
    transferList: {
      flex: 1,
      display: "flex",
      flexDirection: "column"
    },
    transferListItem: {
      display: "block",
      width: "calc(100% - ".concat(ITEM_PADDING * 2, "px)"),
      padding: ITEM_PADDING,
      marginLeft: theme.spacing.sm - ITEM_PADDING,
      marginRight: theme.spacing.sm - ITEM_PADDING,
      borderRadius: theme.fn.radius(radius),
      "&:first-of-type": {
        marginTop: theme.spacing.sm - ITEM_PADDING
      },
      "&:last-of-type": {
        marginBottom: theme.spacing.sm - ITEM_PADDING
      }
    },
    transferListItemHovered: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
    },
    transferListItems: {
      overflow: native ? "auto" : "hidden"
    },
    transferListHeader: {
      display: "flex",
      flexDirection: reversed ? "row-reverse" : "row"
    },
    transferListBody: {
      flex: 1,
      borderRadius: theme.fn.radius(radius),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4])
    },
    transferListTitle: {
      marginBottom: 5
    },
    transferListSearch: {
      borderTopWidth: 0,
      borderRightWidth: 0,
      borderLeftWidth: 0,
      borderTopLeftRadius: reversed ? 0 : "calc(".concat(theme.fn.radius(radius), "px - 1px)"),
      borderTopRightRadius: reversed ? "calc(".concat(theme.fn.radius(radius), "px - 1px)") : 0,
      display: "block",
      borderBottomColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]
    },
    transferListControl: {
      borderTop: 0,
      borderRightWidth: reversed ? void 0 : 0,
      borderLeftWidth: reversed ? 0 : void 0,
      borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
      "&:last-of-type": {
        borderTopLeftRadius: reversed ? "calc(".concat(theme.fn.radius(radius), "px - 1px)") : 0,
        borderTopRightRadius: reversed ? 0 : "calc(".concat(theme.fn.radius(radius), "px - 1px)")
      },
      "&:disabled": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : "transparent",
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]
      }
    },
    separator: {
      boxSizing: "border-box",
      textAlign: "left",
      width: "100%",
      padding: "7px 12px"
    },
    separatorLabel: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
    }
  };
});
var icons$1 = {
  Prev: PrevIcon,
  Next: NextIcon,
  First: FirstIcon,
  Last: LastIcon
};
var rtlIons = {
  Next: PrevIcon,
  Prev: NextIcon,
  Last: FirstIcon,
  First: LastIcon
};
function RenderList(_ref168) {
  var className = _ref168.className,
    data = _ref168.data,
    onSelect = _ref168.onSelect,
    selection = _ref168.selection,
    ItemComponent = _ref168.itemComponent,
    listComponent = _ref168.listComponent,
    searchPlaceholder = _ref168.searchPlaceholder,
    filter = _ref168.filter,
    nothingFound = _ref168.nothingFound,
    title = _ref168.title,
    showTransferAll = _ref168.showTransferAll,
    reversed = _ref168.reversed,
    onMoveAll = _ref168.onMoveAll,
    onMove = _ref168.onMove,
    height = _ref168.height,
    radius = _ref168.radius,
    classNames = _ref168.classNames,
    styles = _ref168.styles,
    limit = _ref168.limit;
  var _useStyles$1r = useStyles$1r({
      reversed: reversed,
      native: listComponent !== SelectScrollArea,
      radius: radius
    }, {
      name: "TransferList",
      classNames: classNames,
      styles: styles
    }),
    classes = _useStyles$1r.classes,
    cx = _useStyles$1r.cx,
    theme = _useStyles$1r.theme;
  var unGroupedItems = [];
  var groupedItems = [];
  var _useState153 = useState(""),
    _useState154 = _slicedToArray(_useState153, 2),
    query = _useState154[0],
    setQuery = _useState154[1];
  var _useState155 = useState(-1),
    _useState156 = _slicedToArray(_useState155, 2),
    hovered = _useState156[0],
    setHovered = _useState156[1];
  var filteredData = data.filter(function (item) {
    return filter(query, item);
  }).slice(0, limit);
  var ListComponent = listComponent || "div";
  var Icons = theme.dir === "rtl" ? rtlIons : icons$1;
  var itemsRefs = useRef({});
  var sortedData = groupOptions({
    data: filteredData
  });
  var _useScrollIntoView3 = useScrollIntoView({
      duration: 0,
      offset: 5,
      cancelable: false,
      isList: true
    }),
    scrollIntoView = _useScrollIntoView3.scrollIntoView,
    targetRef = _useScrollIntoView3.targetRef,
    scrollableRef = _useScrollIntoView3.scrollableRef;
  var groupName = null;
  sortedData.forEach(function (item, index) {
    var itemComponent = /* @__PURE__ */React__default.createElement(UnstyledButton, {
      tabIndex: -1,
      onClick: function onClick() {
        return onSelect(item.value);
      },
      key: item.value,
      onMouseEnter: function onMouseEnter() {
        return setHovered(index);
      },
      className: cx(classes.transferListItem, _defineProperty({}, classes.transferListItemHovered, index === hovered)),
      ref: function ref(node) {
        if (itemsRefs && itemsRefs.current) {
          itemsRefs.current[item.value] = node;
        }
      }
    }, /* @__PURE__ */React__default.createElement(ItemComponent, {
      data: item,
      selected: selection.includes(item.value),
      radius: radius
    }));
    if (!item.group) {
      unGroupedItems.push(itemComponent);
    } else {
      if (groupName !== item.group) {
        groupName = item.group;
        groupedItems.push( /* @__PURE__ */React__default.createElement("div", {
          className: classes.separator,
          key: groupName
        }, /* @__PURE__ */React__default.createElement(Divider, {
          classNames: {
            label: classes.separatorLabel
          },
          label: groupName
        })));
      }
      groupedItems.push(itemComponent);
    }
  });
  if (groupedItems.length > 0 && unGroupedItems.length > 0) {
    unGroupedItems.unshift( /* @__PURE__ */React__default.createElement("div", {
      className: classes.separator
    }, /* @__PURE__ */React__default.createElement(Divider, {
      classNames: {
        label: classes.separatorLabel
      }
    })));
  }
  var handleSearchKeydown = function handleSearchKeydown(event) {
    switch (event.code) {
      case "Enter":
        {
          event.preventDefault();
          if (filteredData[hovered]) {
            onSelect(filteredData[hovered].value);
          }
          break;
        }
      case "ArrowDown":
        {
          event.preventDefault();
          setHovered(function (current) {
            var _a;
            var nextIndex = current < filteredData.length - 1 ? current + 1 : current;
            targetRef.current = itemsRefs.current[(_a = filteredData[nextIndex]) == null ? void 0 : _a.value];
            scrollIntoView({
              alignment: "end"
            });
            return nextIndex;
          });
          break;
        }
      case "ArrowUp":
        {
          event.preventDefault();
          setHovered(function (current) {
            var _a;
            var nextIndex = current > 0 ? current - 1 : current;
            targetRef.current = itemsRefs.current[(_a = filteredData[nextIndex]) == null ? void 0 : _a.value];
            scrollIntoView({
              alignment: "start"
            });
            return nextIndex;
          });
        }
    }
  };
  return /* @__PURE__ */React__default.createElement("div", {
    className: cx(classes.transferList, className)
  }, title && /* @__PURE__ */React__default.createElement(Text, {
    weight: 500,
    className: classes.transferListTitle
  }, title), /* @__PURE__ */React__default.createElement("div", {
    className: classes.transferListBody
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.transferListHeader
  }, /* @__PURE__ */React__default.createElement(TextInput, {
    value: query,
    onChange: function onChange(event) {
      setQuery(event.currentTarget.value);
      setHovered(0);
    },
    onFocus: function onFocus() {
      return setHovered(0);
    },
    onBlur: function onBlur() {
      return setHovered(-1);
    },
    placeholder: searchPlaceholder,
    radius: 0,
    onKeyDown: handleSearchKeydown,
    sx: {
      flex: 1
    },
    classNames: {
      input: classes.transferListSearch
    }
  }), /* @__PURE__ */React__default.createElement(ActionIcon, {
    variant: "default",
    size: 36,
    radius: 0,
    className: classes.transferListControl,
    disabled: selection.length === 0,
    onClick: onMove
  }, reversed ? /* @__PURE__ */React__default.createElement(Icons.Prev, null) : /* @__PURE__ */React__default.createElement(Icons.Next, null)), showTransferAll && /* @__PURE__ */React__default.createElement(ActionIcon, {
    variant: "default",
    size: 36,
    radius: 0,
    className: classes.transferListControl,
    disabled: data.length === 0,
    onClick: onMoveAll
  }, reversed ? /* @__PURE__ */React__default.createElement(Icons.First, null) : /* @__PURE__ */React__default.createElement(Icons.Last, null))), /* @__PURE__ */React__default.createElement(ListComponent, {
    ref: scrollableRef,
    onMouseLeave: function onMouseLeave() {
      return setHovered(-1);
    },
    className: classes.transferListItems,
    style: {
      height: height,
      position: "relative",
      overflowX: "hidden"
    }
  }, groupedItems.length > 0 || unGroupedItems.length > 0 ? /* @__PURE__ */React__default.createElement(React__default.Fragment, null, groupedItems, unGroupedItems) : /* @__PURE__ */React__default.createElement(Text, {
    color: "dimmed",
    size: "sm",
    align: "center",
    mt: "sm"
  }, nothingFound))));
}
RenderList.displayName = "@mantine/core/RenderList";
var DefaultItem$2 = React__default.memo(function (_ref169) {
  var data = _ref169.data,
    selected = _ref169.selected,
    radius = _ref169.radius;
  return /* @__PURE__ */React__default.createElement(Checkbox, {
    checked: selected,
    onChange: function onChange() {},
    label: data.label,
    tabIndex: -1,
    radius: radius,
    sx: {
      pointerEvents: "none"
    }
  });
});
function useSelectionState() {
  var initialSelection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [[], []];
  var _useState157 = useState(initialSelection),
    _useState158 = _slicedToArray(_useState157, 2),
    selection = _useState158[0],
    setSelection = _useState158[1];
  var handleSelect = function handleSelect(listIndex, value) {
    return setSelection(function (currentSelection) {
      var listSelection = currentSelection[listIndex];
      var result = listSelection;
      if (typeof value === "string") {
        if (listSelection.includes(value)) {
          result = listSelection.filter(function (item) {
            return item !== value;
          });
        } else {
          result = [].concat(_toConsumableArray2(listSelection), [value]);
        }
      }
      var clone = _toConsumableArray2(currentSelection);
      clone[listIndex] = result;
      return clone;
    });
  };
  var handleDeselect = function handleDeselect(listIndex, values) {
    return setSelection(function (currentSelection) {
      var clone = _toConsumableArray2(currentSelection);
      clone[listIndex] = currentSelection[listIndex].filter(function (item) {
        return !values.includes(item);
      });
      return clone;
    });
  };
  var handleDeselectAll = function handleDeselectAll(listIndex) {
    return setSelection(function (currentSelection) {
      var clone = _toConsumableArray2(currentSelection);
      clone[listIndex] = [];
      return clone;
    });
  };
  var handlers = {
    select: handleSelect,
    deselect: handleDeselect,
    deselectAll: handleDeselectAll
  };
  return [selection, handlers];
}
var __defProp$36 = Object.defineProperty;
var __defProps$1s = Object.defineProperties;
var __getOwnPropDescs$1s = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$37 = Object.getOwnPropertySymbols;
var __hasOwnProp$37 = Object.prototype.hasOwnProperty;
var __propIsEnum$37 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$36 = function __defNormalProp$36(obj, key, value) {
  return key in obj ? __defProp$36(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$36 = function __spreadValues$36(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$37.call(b, prop)) __defNormalProp$36(a, prop, b[prop]);
  if (__getOwnPropSymbols$37) {
    var _iterator297 = _createForOfIteratorHelper(__getOwnPropSymbols$37(b)),
      _step298;
    try {
      for (_iterator297.s(); !(_step298 = _iterator297.n()).done;) {
        var prop = _step298.value;
        if (__propIsEnum$37.call(b, prop)) __defNormalProp$36(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator297.e(err);
    } finally {
      _iterator297.f();
    }
  }
  return a;
};
var __spreadProps$1s = function __spreadProps$1s(a, b) {
  return __defProps$1s(a, __getOwnPropDescs$1s(b));
};
var __objRest$1R = function __objRest$1R(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$37.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$37) {
    var _iterator298 = _createForOfIteratorHelper(__getOwnPropSymbols$37(source)),
      _step299;
    try {
      for (_iterator298.s(); !(_step299 = _iterator298.n()).done;) {
        var prop = _step299.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$37.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator298.e(err);
    } finally {
      _iterator298.f();
    }
  }
  return target;
};
function defaultFilter$3(query, item) {
  return item.label.toLowerCase().trim().includes(query.toLowerCase().trim());
}
var defaultProps$1j = {
  itemComponent: DefaultItem$2,
  filter: defaultFilter$3,
  titles: [null, null],
  listHeight: 150,
  listComponent: SelectScrollArea,
  showTransferAll: true,
  limit: Infinity
};
var TransferList = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("TransferList", defaultProps$1j, props),
    value = _a.value,
    onChange = _a.onChange,
    itemComponent = _a.itemComponent,
    searchPlaceholder = _a.searchPlaceholder,
    filter = _a.filter,
    nothingFound = _a.nothingFound,
    titles = _a.titles,
    initialSelection = _a.initialSelection,
    listHeight = _a.listHeight,
    listComponent = _a.listComponent,
    showTransferAll = _a.showTransferAll,
    breakpoint = _a.breakpoint,
    radius = _a.radius,
    classNames = _a.classNames,
    styles = _a.styles,
    limit = _a.limit,
    others = __objRest$1R(_a, ["value", "onChange", "itemComponent", "searchPlaceholder", "filter", "nothingFound", "titles", "initialSelection", "listHeight", "listComponent", "showTransferAll", "breakpoint", "radius", "classNames", "styles", "limit"]);
  var _useSelectionState = useSelectionState(initialSelection),
    _useSelectionState2 = _slicedToArray(_useSelectionState, 2),
    selection = _useSelectionState2[0],
    handlers = _useSelectionState2[1];
  var handleMoveAll = function handleMoveAll(listIndex) {
    var items = Array(2);
    var moveToIndex = listIndex === 0 ? 1 : 0;
    items[listIndex] = [];
    items[moveToIndex] = [].concat(_toConsumableArray2(value[moveToIndex]), _toConsumableArray2(value[listIndex]));
    onChange(items);
    handlers.deselectAll(listIndex);
  };
  var handleMove = function handleMove(listIndex) {
    var moveToIndex = listIndex === 0 ? 1 : 0;
    var items = Array(2);
    var transferData = value[listIndex].reduce(function (acc, item) {
      if (!selection[listIndex].includes(item.value)) {
        acc.filtered.push(item);
      } else {
        acc.current.push(item);
      }
      return acc;
    }, {
      filtered: [],
      current: []
    });
    items[listIndex] = transferData.filtered;
    items[moveToIndex] = [].concat(_toConsumableArray2(transferData.current), _toConsumableArray2(value[moveToIndex]));
    onChange(items);
    handlers.deselectAll(listIndex);
  };
  var breakpoints = breakpoint ? [{
    maxWidth: breakpoint,
    cols: 1
  }] : [];
  var sharedListProps = {
    itemComponent: itemComponent,
    listComponent: listComponent,
    searchPlaceholder: searchPlaceholder,
    filter: filter,
    nothingFound: nothingFound,
    height: listHeight,
    showTransferAll: showTransferAll,
    classNames: classNames,
    styles: styles,
    limit: limit,
    radius: radius
  };
  return /* @__PURE__ */React__default.createElement(SimpleGrid, __spreadValues$36({
    cols: 2,
    spacing: "xl",
    breakpoints: breakpoints,
    ref: ref
  }, others), /* @__PURE__ */React__default.createElement(RenderList, __spreadProps$1s(__spreadValues$36({}, sharedListProps), {
    data: value[0],
    selection: selection[0],
    onSelect: function onSelect(val) {
      return handlers.select(0, val);
    },
    onMoveAll: function onMoveAll() {
      return handleMoveAll(0);
    },
    onMove: function onMove() {
      return handleMove(0);
    },
    title: titles[0]
  })), /* @__PURE__ */React__default.createElement(RenderList, __spreadProps$1s(__spreadValues$36({}, sharedListProps), {
    data: value[1],
    selection: selection[1],
    onSelect: function onSelect(val) {
      return handlers.select(1, val);
    },
    onMoveAll: function onMoveAll() {
      return handleMoveAll(1);
    },
    onMove: function onMove() {
      return handleMove(1);
    },
    title: titles[1],
    reversed: true
  })));
});
TransferList.displayName = "@mantine/core/TransferList";
var __defProp$37 = Object.defineProperty;
var __defProps$1t = Object.defineProperties;
var __getOwnPropDescs$1t = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$38 = Object.getOwnPropertySymbols;
var __hasOwnProp$38 = Object.prototype.hasOwnProperty;
var __propIsEnum$38 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$37 = function __defNormalProp$37(obj, key, value) {
  return key in obj ? __defProp$37(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$37 = function __spreadValues$37(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$38.call(b, prop)) __defNormalProp$37(a, prop, b[prop]);
  if (__getOwnPropSymbols$38) {
    var _iterator299 = _createForOfIteratorHelper(__getOwnPropSymbols$38(b)),
      _step300;
    try {
      for (_iterator299.s(); !(_step300 = _iterator299.n()).done;) {
        var prop = _step300.value;
        if (__propIsEnum$38.call(b, prop)) __defNormalProp$37(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator299.e(err);
    } finally {
      _iterator299.f();
    }
  }
  return a;
};
var __spreadProps$1t = function __spreadProps$1t(a, b) {
  return __defProps$1t(a, __getOwnPropDescs$1t(b));
};
var useStyles$1s = createStyles(function (theme) {
  var headings = Object.keys(theme.headings.sizes).reduce(function (acc, h) {
    acc["& ".concat(h)] = __spreadProps$1t(__spreadValues$37({
      fontFamily: theme.headings.fontFamily,
      fontWeight: theme.headings.fontWeight,
      marginTop: theme.spacing.xl * theme.headings.sizes[h].lineHeight,
      marginBottom: theme.spacing.sm
    }, theme.headings.sizes[h]), {
      "@media (max-width: 755px)": {
        fontSize: typeof theme.headings.sizes[h].fontSize === "number" && theme.headings.sizes[h].fontSize / 1.3
      }
    });
    return acc;
  }, {});
  return {
    root: __spreadProps$1t(__spreadValues$37(__spreadProps$1t(__spreadValues$37({}, theme.fn.fontStyles()), {
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      lineHeight: theme.lineHeight,
      fontSize: theme.fontSizes.md,
      "@media (max-width: 755px)": {
        fontSize: theme.fontSizes.sm
      }
    }), headings), {
      "& .ql-align-center": {
        textAlign: "center"
      },
      "& .ql-align-right": {
        textAlign: "right"
      },
      "& .ql-align-left": {
        textAlign: "left"
      },
      "& img": {
        maxWidth: "100%",
        marginBottom: theme.spacing.xs
      },
      "& p": {
        marginTop: 0,
        marginBottom: theme.spacing.lg
      },
      "& hr": {
        marginTop: theme.spacing.md,
        marginBottom: theme.spacing.sm,
        borderBottom: 0,
        borderLeft: 0,
        borderRight: 0,
        borderTop: "1px dashed ".concat(theme.colors.gray[theme.colorScheme === "dark" ? 4 : 6])
      },
      "& a": __spreadProps$1t(__spreadValues$37({}, theme.fn.focusStyles()), {
        color: theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 4 : 6],
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline"
        }
      }),
      "& pre": {
        padding: theme.spacing.xs,
        lineHeight: theme.lineHeight,
        margin: 0,
        marginTop: theme.spacing.md,
        marginBottom: theme.spacing.md,
        overflowX: "auto",
        fontFamily: theme.fontFamilyMonospace,
        fontSize: theme.fontSizes.sm,
        borderRadius: theme.radius.sm,
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
      },
      "& code": {
        lineHeight: theme.lineHeight,
        padding: "1px ".concat(theme.spacing.xs / 1, "px"),
        borderRadius: theme.radius.sm,
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.colors.gray[0],
        fontFamily: theme.fontFamilyMonospace,
        fontSize: theme.fontSizes.xs,
        border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.colors.gray[3])
      },
      "& ul, & ol": {
        marginBottom: theme.spacing.md,
        paddingLeft: theme.spacing.lg * 2,
        "& li": {
          marginTop: theme.spacing.xs
        }
      },
      "& table": {
        width: "100%",
        borderCollapse: "collapse",
        captionSide: "bottom",
        marginBottom: theme.spacing.md,
        "& caption": {
          marginTop: theme.spacing.xs,
          fontSize: theme.fontSizes.sm,
          color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6]
        },
        "& th": {
          textAlign: "left",
          fontWeight: "bold",
          color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
          fontSize: 14,
          padding: "7px 10px"
        },
        "& thead th": {
          borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3])
        },
        "& tfoot th": {
          borderTop: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3])
        },
        "& td": {
          padding: "7px 10px",
          borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]),
          fontSize: 14
        },
        "& tr:last-of-type td": {
          borderBottom: "none"
        }
      },
      "& blockquote": {
        fontSize: theme.fontSizes.lg,
        lineHeight: theme.lineHeight,
        margin: "".concat(theme.spacing.md, "px 0"),
        borderTopRightRadius: theme.radius.sm,
        borderBottomRightRadius: theme.radius.sm,
        padding: "".concat(theme.spacing.md, "px ").concat(theme.spacing.lg, "px"),
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        "& cite": {
          display: "block",
          fontSize: theme.fontSizes.sm,
          marginTop: theme.spacing.xs,
          color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }
    })
  };
});
var __defProp$38 = Object.defineProperty;
var __getOwnPropSymbols$39 = Object.getOwnPropertySymbols;
var __hasOwnProp$39 = Object.prototype.hasOwnProperty;
var __propIsEnum$39 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$38 = function __defNormalProp$38(obj, key, value) {
  return key in obj ? __defProp$38(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$38 = function __spreadValues$38(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$39.call(b, prop)) __defNormalProp$38(a, prop, b[prop]);
  if (__getOwnPropSymbols$39) {
    var _iterator300 = _createForOfIteratorHelper(__getOwnPropSymbols$39(b)),
      _step301;
    try {
      for (_iterator300.s(); !(_step301 = _iterator300.n()).done;) {
        var prop = _step301.value;
        if (__propIsEnum$39.call(b, prop)) __defNormalProp$38(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator300.e(err);
    } finally {
      _iterator300.f();
    }
  }
  return a;
};
var __objRest$1S = function __objRest$1S(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$39.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$39) {
    var _iterator301 = _createForOfIteratorHelper(__getOwnPropSymbols$39(source)),
      _step302;
    try {
      for (_iterator301.s(); !(_step302 = _iterator301.n()).done;) {
        var prop = _step302.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$39.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator301.e(err);
    } finally {
      _iterator301.f();
    }
  }
  return target;
};
var TypographyStylesProvider = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("TypographyStylesProvider", {}, props),
    className = _a.className,
    others = __objRest$1S(_a, ["className"]);
  var _useStyles$1s = useStyles$1s(null, {
      name: "TypographyStylesProvider"
    }),
    classes = _useStyles$1s.classes,
    cx = _useStyles$1s.cx;
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$38({
    className: cx(classes.root, className),
    ref: ref
  }, others));
});
TypographyStylesProvider.displayName = "@mantine/core/TypographyStylesProvider";
function getEndOfWeek(date) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "monday";
  var value = new Date(date);
  var day = value.getDay();
  var isSunday = firstDayOfWeek === "sunday";
  var clampToLastDay = 7 - (isSunday ? day + 1 : day);
  if (isSunday && day !== 6 || day !== 0) {
    value.setDate(value.getDate() + clampToLastDay);
  }
  return value;
}
function getStartOfWeek(date) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "monday";
  var value = new Date(date);
  var day = value.getDay() || 7;
  var isSunday = firstDayOfWeek === "sunday";
  var clampToFirstDay = isSunday ? day : day - 1;
  if (isSunday && day !== 0 || day !== 1) {
    value.setHours(-24 * clampToFirstDay);
  }
  return value;
}
function getMonthDays(month) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "monday";
  var currentMonth = month.getMonth();
  var startOfMonth = new Date(month.getFullYear(), currentMonth, 1);
  var endOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
  var endDate = getEndOfWeek(endOfMonth, firstDayOfWeek);
  var date = getStartOfWeek(startOfMonth, firstDayOfWeek);
  var weeks = [];
  while (date <= endDate) {
    var days = [];
    for (var _i18 = 0; _i18 < 7; _i18 += 1) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    weeks.push(days);
  }
  return weeks;
}
var dayjs_min = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e();
  }(commonjsGlobal, function () {
    var t = 1e3,
      e = 6e4,
      n = 36e5,
      r = "millisecond",
      i = "second",
      s = "minute",
      u = "hour",
      a = "day",
      o = "week",
      f = "month",
      h = "quarter",
      c = "year",
      d = "date",
      $ = "Invalid Date",
      l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
      y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
      M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
      },
      m = function m(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
      },
      g = {
        s: m,
        z: function z(t) {
          var e = -t.utcOffset(),
            n = Math.abs(e),
            r = Math.floor(n / 60),
            i = n % 60;
          return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
          if (e.date() < n.date()) return -t(n, e);
          var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
            i = e.clone().add(r, f),
            s = n - i < 0,
            u = e.clone().add(r + (s ? -1 : 1), f);
          return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function a(t) {
          return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function p(t) {
          return {
            M: f,
            y: c,
            w: o,
            d: a,
            D: d,
            h: u,
            m: s,
            s: i,
            ms: r,
            Q: h
          }[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function u(t) {
          return void 0 === t;
        }
      },
      v = "en",
      D = {};
    D[v] = M;
    var p = function p(t) {
        return t instanceof _;
      },
      S = function t(e, n, r) {
        var i;
        if (!e) return v;
        if ("string" == typeof e) {
          var s = e.toLowerCase();
          D[s] && (i = s), n && (D[s] = n, i = s);
          var u = e.split("-");
          if (!i && u.length > 1) return t(u[0]);
        } else {
          var a = e.name;
          D[a] = e, i = a;
        }
        return !r && i && (v = i), i || !r && v;
      },
      w = function w(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
      },
      O = g;
    O.l = S, O.i = p, O.w = function (t, e) {
      return w(t, {
        locale: e.$L,
        utc: e.$u,
        x: e.$x,
        $offset: e.$offset
      });
    };
    var _ = function () {
        function M(t) {
          this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function (t) {
          this.$d = function (t) {
            var e = t.date,
              n = t.utc;
            if (null === e) return new Date(NaN);
            if (O.u(e)) return new Date();
            if (e instanceof Date) return new Date(e);
            if ("string" == typeof e && !/Z$/i.test(e)) {
              var r = e.match(l);
              if (r) {
                var i = r[2] - 1 || 0,
                  s = (r[7] || "0").substring(0, 3);
                return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
              }
            }
            return new Date(e);
          }(t), this.$x = t.x || {}, this.init();
        }, m.init = function () {
          var t = this.$d;
          this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function () {
          return O;
        }, m.isValid = function () {
          return !(this.$d.toString() === $);
        }, m.isSame = function (t, e) {
          var n = w(t);
          return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function (t, e) {
          return w(t) < this.startOf(e);
        }, m.isBefore = function (t, e) {
          return this.endOf(e) < w(t);
        }, m.$g = function (t, e, n) {
          return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function () {
          return this.$d.getTime();
        }, m.startOf = function (t, e) {
          var n = this,
            r = !!O.u(e) || e,
            h = O.p(t),
            $ = function $(t, e) {
              var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
              return r ? i : i.endOf(a);
            },
            l = function l(t, e) {
              return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
            },
            y = this.$W,
            M = this.$M,
            m = this.$D,
            g = "set" + (this.$u ? "UTC" : "");
          switch (h) {
            case c:
              return r ? $(1, 0) : $(31, 11);
            case f:
              return r ? $(1, M) : $(0, M + 1);
            case o:
              var v = this.$locale().weekStart || 0,
                D = (y < v ? y + 7 : y) - v;
              return $(r ? m - D : m + (6 - D), M);
            case a:
            case d:
              return l(g + "Hours", 0);
            case u:
              return l(g + "Minutes", 1);
            case s:
              return l(g + "Seconds", 2);
            case i:
              return l(g + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m.endOf = function (t) {
          return this.startOf(t, !1);
        }, m.$set = function (t, e) {
          var n,
            o = O.p(t),
            h = "set" + (this.$u ? "UTC" : ""),
            $ = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o],
            l = o === a ? this.$D + (e - this.$W) : e;
          if (o === f || o === c) {
            var y = this.clone().set(d, 1);
            y.$d[$](l), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
          } else $ && this.$d[$](l);
          return this.init(), this;
        }, m.set = function (t, e) {
          return this.clone().$set(t, e);
        }, m.get = function (t) {
          return this[O.p(t)]();
        }, m.add = function (r, h) {
          var d,
            $ = this;
          r = Number(r);
          var l = O.p(h),
            y = function y(t) {
              var e = w($);
              return O.w(e.date(e.date() + Math.round(t * r)), $);
            };
          if (l === f) return this.set(f, this.$M + r);
          if (l === c) return this.set(c, this.$y + r);
          if (l === a) return y(1);
          if (l === o) return y(7);
          var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[l] || 1,
            m = this.$d.getTime() + r * M;
          return O.w(m, this);
        }, m.subtract = function (t, e) {
          return this.add(-1 * t, e);
        }, m.format = function (t) {
          var e = this,
            n = this.$locale();
          if (!this.isValid()) return n.invalidDate || $;
          var r = t || "YYYY-MM-DDTHH:mm:ssZ",
            i = O.z(this),
            s = this.$H,
            u = this.$m,
            a = this.$M,
            o = n.weekdays,
            f = n.months,
            h = function h(t, n, i, s) {
              return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            },
            c = function c(t) {
              return O.s(s % 12 || 12, t, "0");
            },
            d = n.meridiem || function (t, e, n) {
              var r = t < 12 ? "AM" : "PM";
              return n ? r.toLowerCase() : r;
            },
            l = {
              YY: String(this.$y).slice(-2),
              YYYY: this.$y,
              M: a + 1,
              MM: O.s(a + 1, 2, "0"),
              MMM: h(n.monthsShort, a, f, 3),
              MMMM: h(f, a),
              D: this.$D,
              DD: O.s(this.$D, 2, "0"),
              d: String(this.$W),
              dd: h(n.weekdaysMin, this.$W, o, 2),
              ddd: h(n.weekdaysShort, this.$W, o, 3),
              dddd: o[this.$W],
              H: String(s),
              HH: O.s(s, 2, "0"),
              h: c(1),
              hh: c(2),
              a: d(s, u, !0),
              A: d(s, u, !1),
              m: String(u),
              mm: O.s(u, 2, "0"),
              s: String(this.$s),
              ss: O.s(this.$s, 2, "0"),
              SSS: O.s(this.$ms, 3, "0"),
              Z: i
            };
          return r.replace(y, function (t, e) {
            return e || l[t] || i.replace(":", "");
          });
        }, m.utcOffset = function () {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function (r, d, $) {
          var l,
            y = O.p(d),
            M = w(r),
            m = (M.utcOffset() - this.utcOffset()) * e,
            g = this - M,
            v = O.m(this, M);
          return v = (l = {}, l[c] = v / 12, l[f] = v, l[h] = v / 3, l[o] = (g - m) / 6048e5, l[a] = (g - m) / 864e5, l[u] = g / n, l[s] = g / e, l[i] = g / t, l)[y] || g, $ ? v : O.a(v);
        }, m.daysInMonth = function () {
          return this.endOf(f).$D;
        }, m.$locale = function () {
          return D[this.$L];
        }, m.locale = function (t, e) {
          if (!t) return this.$L;
          var n = this.clone(),
            r = S(t, e, !0);
          return r && (n.$L = r), n;
        }, m.clone = function () {
          return O.w(this.$d, this);
        }, m.toDate = function () {
          return new Date(this.valueOf());
        }, m.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function () {
          return this.$d.toISOString();
        }, m.toString = function () {
          return this.$d.toUTCString();
        }, M;
      }(),
      T = _.prototype;
    return w.prototype = T, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function (t) {
      T[t[1]] = function (e) {
        return this.$g(e, t[0], t[1]);
      };
    }), w.extend = function (t, e) {
      return t.$i || (t(e, _, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function (t) {
      return w(1e3 * t);
    }, w.en = D[v], w.Ls = D, w.p = {}, w;
  });
});
function getMonthsNames(locale) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "MMM";
  var names = [];
  var date = new Date(2021, 0, 1);
  for (var _i19 = 0; _i19 < 12; _i19 += 1) {
    names.push(dayjs_min(date).locale(locale).format(format));
    date.setMonth(date.getMonth() + 1);
  }
  return names;
}
function getWeekdaysNames(locale) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "monday";
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "dd";
  var names = [];
  var date = getStartOfWeek(new Date(), firstDayOfWeek);
  for (var _i20 = 0; _i20 < 7; _i20 += 1) {
    names.push(dayjs_min(date).locale(locale).format(format));
    date.setDate(date.getDate() + 1);
  }
  return names;
}
function isSameMonth(date, comparison) {
  return date.getFullYear() === comparison.getFullYear() && date.getMonth() === comparison.getMonth();
}
function isSameDate(date, comparison) {
  return isSameMonth(date, comparison) && date.getDate() === comparison.getDate();
}
function getDecadeRange(year) {
  var rounded = year - year % 10 - 1;
  var range = [];
  for (var _i21 = 0; _i21 < 12; _i21 += 1) {
    var rangeYear = rounded + _i21;
    range.push(rangeYear);
  }
  return range;
}
var __defProp$39 = Object.defineProperty;
var __defProps$1u = Object.defineProperties;
var __getOwnPropDescs$1u = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3a = Object.getOwnPropertySymbols;
var __hasOwnProp$3a = Object.prototype.hasOwnProperty;
var __propIsEnum$3a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$39 = function __defNormalProp$39(obj, key, value) {
  return key in obj ? __defProp$39(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$39 = function __spreadValues$39(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3a.call(b, prop)) __defNormalProp$39(a, prop, b[prop]);
  if (__getOwnPropSymbols$3a) {
    var _iterator302 = _createForOfIteratorHelper(__getOwnPropSymbols$3a(b)),
      _step303;
    try {
      for (_iterator302.s(); !(_step303 = _iterator302.n()).done;) {
        var prop = _step303.value;
        if (__propIsEnum$3a.call(b, prop)) __defNormalProp$39(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator302.e(err);
    } finally {
      _iterator302.f();
    }
  }
  return a;
};
var __spreadProps$1u = function __spreadProps$1u(a, b) {
  return __defProps$1u(a, __getOwnPropDescs$1u(b));
};
var __objRest$1T = function __objRest$1T(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3a.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3a) {
    var _iterator303 = _createForOfIteratorHelper(__getOwnPropSymbols$3a(source)),
      _step304;
    try {
      for (_iterator303.s(); !(_step304 = _iterator303.n()).done;) {
        var prop = _step304.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3a.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator303.e(err);
    } finally {
      _iterator303.f();
    }
  }
  return target;
};
function ArrowIcon(_a) {
  var _b = _a,
    direction = _b.direction,
    style = _b.style,
    others = __objRest$1T(_b, ["direction", "style"]);
  var theme = useMantineTheme();
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues$39({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: __spreadProps$1u(__spreadValues$39({}, style), {
      transform: direction === "right" && theme.dir === "ltr" || direction === "left" && theme.dir === "rtl" ? "rotate(180deg)" : "none"
    })
  }, others), /* @__PURE__ */React__default.createElement("path", {
    d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
ArrowIcon.displayName = "@mantine/dates/ArrowIcon";
var __defProp$3a = Object.defineProperty;
var __defProps$1v = Object.defineProperties;
var __getOwnPropDescs$1v = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3b = Object.getOwnPropertySymbols;
var __hasOwnProp$3b = Object.prototype.hasOwnProperty;
var __propIsEnum$3b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3a = function __defNormalProp$3a(obj, key, value) {
  return key in obj ? __defProp$3a(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3a = function __spreadValues$3a(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3b.call(b, prop)) __defNormalProp$3a(a, prop, b[prop]);
  if (__getOwnPropSymbols$3b) {
    var _iterator304 = _createForOfIteratorHelper(__getOwnPropSymbols$3b(b)),
      _step305;
    try {
      for (_iterator304.s(); !(_step305 = _iterator304.n()).done;) {
        var prop = _step305.value;
        if (__propIsEnum$3b.call(b, prop)) __defNormalProp$3a(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator304.e(err);
    } finally {
      _iterator304.f();
    }
  }
  return a;
};
var __spreadProps$1v = function __spreadProps$1v(a, b) {
  return __defProps$1v(a, __getOwnPropDescs$1v(b));
};
var sizes$m = {
  xs: 32,
  sm: 40,
  md: 44,
  lg: 50,
  xl: 54
};
var useStyles$1t = createStyles(function (theme, _ref170) {
  var size = _ref170.size;
  return {
    calendarHeader: {
      display: "flex",
      justifyContent: "space-between",
      align: "center",
      marginBottom: theme.fn.size({
        size: size,
        sizes: theme.spacing
      })
    },
    calendarHeaderControl: {
      width: theme.fn.size({
        size: size,
        sizes: sizes$m
      }),
      height: theme.fn.size({
        size: size,
        sizes: sizes$m
      }),
      "&:disabled": {
        opacity: 0,
        cursor: "default"
      }
    },
    calendarHeaderLevel: __spreadProps$1v(__spreadValues$3a({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: theme.fn.size({
        size: size,
        sizes: sizes$m
      }),
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      padding: "0 ".concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }), "px"),
      borderRadius: theme.radius.sm,
      fontWeight: 500,
      flex: 1,
      textAlign: "center",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
    })), {
      "&:disabled": theme.fn.hover({
        backgroundColor: "transparent",
        cursor: "default"
      })
    }),
    calendarHeaderLevelIcon: {
      marginLeft: 4
    }
  };
});
var __defProp$3b = Object.defineProperty;
var __getOwnPropSymbols$3c = Object.getOwnPropertySymbols;
var __hasOwnProp$3c = Object.prototype.hasOwnProperty;
var __propIsEnum$3c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3b = function __defNormalProp$3b(obj, key, value) {
  return key in obj ? __defProp$3b(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3b = function __spreadValues$3b(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3c.call(b, prop)) __defNormalProp$3b(a, prop, b[prop]);
  if (__getOwnPropSymbols$3c) {
    var _iterator305 = _createForOfIteratorHelper(__getOwnPropSymbols$3c(b)),
      _step306;
    try {
      for (_iterator305.s(); !(_step306 = _iterator305.n()).done;) {
        var prop = _step306.value;
        if (__propIsEnum$3c.call(b, prop)) __defNormalProp$3b(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator305.e(err);
    } finally {
      _iterator305.f();
    }
  }
  return a;
};
var __objRest$1U = function __objRest$1U(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3c.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3c) {
    var _iterator306 = _createForOfIteratorHelper(__getOwnPropSymbols$3c(source)),
      _step307;
    try {
      for (_iterator306.s(); !(_step307 = _iterator306.n()).done;) {
        var prop = _step307.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3c.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator306.e(err);
    } finally {
      _iterator306.f();
    }
  }
  return target;
};
var iconSizes$6 = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 22,
  xl: 28
};
function CalendarHeader(_a) {
  var _b = _a,
    hasNext = _b.hasNext,
    hasPrevious = _b.hasPrevious,
    onNext = _b.onNext,
    onPrevious = _b.onPrevious,
    onNextLevel = _b.onNextLevel,
    className = _b.className,
    label = _b.label,
    nextLevelDisabled = _b.nextLevelDisabled,
    size = _b.size,
    classNames = _b.classNames,
    styles = _b.styles,
    _b$__staticSelector4 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector4 === void 0 ? "CalendarHeader" : _b$__staticSelector4,
    nextLabel = _b.nextLabel,
    previousLabel = _b.previousLabel,
    _b$preventLevelFocus = _b.preventLevelFocus,
    preventLevelFocus = _b$preventLevelFocus === void 0 ? false : _b$preventLevelFocus,
    preventFocus = _b.preventFocus,
    others = __objRest$1U(_b, ["hasNext", "hasPrevious", "onNext", "onPrevious", "onNextLevel", "className", "label", "nextLevelDisabled", "size", "classNames", "styles", "__staticSelector", "nextLabel", "previousLabel", "preventLevelFocus", "preventFocus"]);
  var _useStyles$1t = useStyles$1t({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$1t.classes,
    cx = _useStyles$1t.cx,
    theme = _useStyles$1t.theme;
  var iconSize = theme.fn.size({
    size: size,
    sizes: iconSizes$6
  });
  return /* @__PURE__ */React__default.createElement("div", __spreadValues$3b({
    className: cx(classes.calendarHeader, className)
  }, others), /* @__PURE__ */React__default.createElement(ActionIcon, {
    className: classes.calendarHeaderControl,
    disabled: !hasPrevious,
    onClick: onPrevious,
    "aria-label": previousLabel,
    onMouseDown: function onMouseDown(event) {
      return preventFocus && event.preventDefault();
    }
  }, /* @__PURE__ */React__default.createElement(ArrowIcon, {
    direction: "left",
    width: iconSize,
    height: iconSize
  })), /* @__PURE__ */React__default.createElement(UnstyledButton, {
    className: classes.calendarHeaderLevel,
    disabled: nextLevelDisabled,
    onClick: onNextLevel,
    tabIndex: preventLevelFocus ? -1 : 0,
    onMouseDown: function onMouseDown(event) {
      return preventFocus && event.preventDefault();
    }
  }, label, !nextLevelDisabled && /* @__PURE__ */React__default.createElement(ChevronIcon$1, {
    error: false,
    size: size,
    className: classes.calendarHeaderLevelIcon
  })), /* @__PURE__ */React__default.createElement(ActionIcon, {
    className: classes.calendarHeaderControl,
    disabled: !hasNext,
    onClick: onNext,
    "aria-label": nextLabel,
    onMouseDown: function onMouseDown(event) {
      return preventFocus && event.preventDefault();
    }
  }, /* @__PURE__ */React__default.createElement(ArrowIcon, {
    direction: "right",
    width: iconSize,
    height: iconSize
  })));
}
CalendarHeader.displayName = "@mantine/dates/CalendarHeader";
var __defProp$3c = Object.defineProperty;
var __defProps$1w = Object.defineProperties;
var __getOwnPropDescs$1w = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3d = Object.getOwnPropertySymbols;
var __hasOwnProp$3d = Object.prototype.hasOwnProperty;
var __propIsEnum$3d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3c = function __defNormalProp$3c(obj, key, value) {
  return key in obj ? __defProp$3c(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3c = function __spreadValues$3c(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3d.call(b, prop)) __defNormalProp$3c(a, prop, b[prop]);
  if (__getOwnPropSymbols$3d) {
    var _iterator307 = _createForOfIteratorHelper(__getOwnPropSymbols$3d(b)),
      _step308;
    try {
      for (_iterator307.s(); !(_step308 = _iterator307.n()).done;) {
        var prop = _step308.value;
        if (__propIsEnum$3d.call(b, prop)) __defNormalProp$3c(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator307.e(err);
    } finally {
      _iterator307.f();
    }
  }
  return a;
};
var __spreadProps$1w = function __spreadProps$1w(a, b) {
  return __defProps$1w(a, __getOwnPropDescs$1w(b));
};
var sizes$n = {
  xs: 32,
  sm: 40,
  md: 46,
  lg: 52,
  xl: 56
};
var useStyles$1u = createStyles(function (theme, _ref171) {
  var size = _ref171.size;
  var colors = theme.fn.variant({
    color: theme.primaryColor,
    variant: "filled"
  });
  return {
    yearPicker: {
      width: "100%"
    },
    yearPickerControls: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center"
    },
    yearPickerControl: __spreadProps$1w(__spreadValues$3c({
      flex: "0 0 25%",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      height: theme.fn.size({
        size: size,
        sizes: sizes$n
      }),
      textAlign: "center",
      borderRadius: theme.radius.sm,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      })
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
    })), {
      "&:disabled": __spreadValues$3c({
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4],
        cursor: "not-allowed"
      }, theme.fn.hover({
        backgroundColor: "transparent"
      }))
    }),
    yearPickerControlActive: __spreadValues$3c({
      backgroundColor: colors.background,
      color: colors.color
    }, theme.fn.hover({
      backgroundColor: colors.hover
    }))
  };
});
var __defProp$3d = Object.defineProperty;
var __getOwnPropSymbols$3e = Object.getOwnPropertySymbols;
var __hasOwnProp$3e = Object.prototype.hasOwnProperty;
var __propIsEnum$3e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3d = function __defNormalProp$3d(obj, key, value) {
  return key in obj ? __defProp$3d(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3d = function __spreadValues$3d(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3e.call(b, prop)) __defNormalProp$3d(a, prop, b[prop]);
  if (__getOwnPropSymbols$3e) {
    var _iterator308 = _createForOfIteratorHelper(__getOwnPropSymbols$3e(b)),
      _step309;
    try {
      for (_iterator308.s(); !(_step309 = _iterator308.n()).done;) {
        var prop = _step309.value;
        if (__propIsEnum$3e.call(b, prop)) __defNormalProp$3d(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator308.e(err);
    } finally {
      _iterator308.f();
    }
  }
  return a;
};
var __objRest$1V = function __objRest$1V(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3e.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3e) {
    var _iterator309 = _createForOfIteratorHelper(__getOwnPropSymbols$3e(source)),
      _step310;
    try {
      for (_iterator309.s(); !(_step310 = _iterator309.n()).done;) {
        var prop = _step310.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3e.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator309.e(err);
    } finally {
      _iterator309.f();
    }
  }
  return target;
};
function YearPicker(_a) {
  var _b = _a,
    className = _b.className,
    styles = _b.styles,
    classNames = _b.classNames,
    value = _b.value,
    onChange = _b.onChange,
    size = _b.size,
    minYear = _b.minYear,
    maxYear = _b.maxYear,
    _b$__staticSelector5 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector5 === void 0 ? "YearPicker" : _b$__staticSelector5,
    nextDecadeLabel = _b.nextDecadeLabel,
    previousDecadeLabel = _b.previousDecadeLabel,
    preventFocus = _b.preventFocus,
    others = __objRest$1V(_b, ["className", "styles", "classNames", "value", "onChange", "size", "minYear", "maxYear", "__staticSelector", "nextDecadeLabel", "previousDecadeLabel", "preventFocus"]);
  var _useStyles$1u = useStyles$1u({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$1u.classes,
    cx = _useStyles$1u.cx;
  var _useState159 = useState(value),
    _useState160 = _slicedToArray(_useState159, 2),
    decade = _useState160[0],
    setDecade = _useState160[1];
  var range = getDecadeRange(decade);
  var years = range.map(function (year) {
    return /* @__PURE__ */React__default.createElement(UnstyledButton, {
      key: year,
      onClick: function onClick() {
        return onChange(year);
      },
      disabled: year < minYear || year > maxYear,
      onMouseDown: function onMouseDown(event) {
        return preventFocus && event.preventDefault();
      },
      className: cx(classes.yearPickerControl, _defineProperty({}, classes.yearPickerControlActive, year === value))
    }, year);
  });
  return /* @__PURE__ */React__default.createElement("div", __spreadValues$3d({
    className: cx(classes.yearPicker, className)
  }, others), /* @__PURE__ */React__default.createElement(CalendarHeader, {
    label: "".concat(range[0], " \u2013 ").concat(range[range.length - 1]),
    hasPrevious: typeof minYear === "number" ? minYear < range[0] : true,
    hasNext: typeof maxYear === "number" ? maxYear > range[range.length - 1] : true,
    onNext: function onNext() {
      return setDecade(function (current) {
        return current + 10;
      });
    },
    onPrevious: function onPrevious() {
      return setDecade(function (current) {
        return current - 10;
      });
    },
    nextLevelDisabled: true,
    size: size,
    nextLabel: nextDecadeLabel,
    previousLabel: previousDecadeLabel,
    styles: styles,
    classNames: classNames,
    __staticSelector: __staticSelector,
    preventFocus: preventFocus
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.yearPickerControls
  }, years));
}
YearPicker.displayName = "@mantine/dates/YearPicker";
function isMonthInRange(_ref172) {
  var date = _ref172.date,
    minDate = _ref172.minDate,
    maxDate = _ref172.maxDate;
  var hasMinDate = minDate instanceof Date;
  var hasMaxDate = maxDate instanceof Date;
  if (!hasMaxDate && !hasMinDate) {
    return true;
  }
  var endOfMonth = dayjs_min(date).endOf("month");
  var startOfMonth = dayjs_min(date).startOf("month");
  var maxInRange = hasMaxDate ? startOfMonth.isBefore(maxDate) : true;
  var minInRange = hasMinDate ? endOfMonth.isAfter(minDate) : true;
  return maxInRange && minInRange;
}
var __defProp$3e = Object.defineProperty;
var __defProps$1x = Object.defineProperties;
var __getOwnPropDescs$1x = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3f = Object.getOwnPropertySymbols;
var __hasOwnProp$3f = Object.prototype.hasOwnProperty;
var __propIsEnum$3f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3e = function __defNormalProp$3e(obj, key, value) {
  return key in obj ? __defProp$3e(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3e = function __spreadValues$3e(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3f.call(b, prop)) __defNormalProp$3e(a, prop, b[prop]);
  if (__getOwnPropSymbols$3f) {
    var _iterator310 = _createForOfIteratorHelper(__getOwnPropSymbols$3f(b)),
      _step311;
    try {
      for (_iterator310.s(); !(_step311 = _iterator310.n()).done;) {
        var prop = _step311.value;
        if (__propIsEnum$3f.call(b, prop)) __defNormalProp$3e(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator310.e(err);
    } finally {
      _iterator310.f();
    }
  }
  return a;
};
var __spreadProps$1x = function __spreadProps$1x(a, b) {
  return __defProps$1x(a, __getOwnPropDescs$1x(b));
};
var sizes$o = {
  xs: 32,
  sm: 40,
  md: 46,
  lg: 52,
  xl: 56
};
var useStyles$1v = createStyles(function (theme, _ref173) {
  var size = _ref173.size;
  var colors = theme.fn.variant({
    color: theme.primaryColor,
    variant: "filled"
  });
  return {
    monthPicker: {
      width: "100%"
    },
    monthPickerControls: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center"
    },
    monthPickerControl: __spreadProps$1x(__spreadValues$3e({
      flex: "0 0 33.3333%",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      height: theme.fn.size({
        size: size,
        sizes: sizes$o
      }),
      textAlign: "center",
      borderRadius: theme.radius.sm,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      })
    }, theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
    })), {
      "&:disabled": __spreadValues$3e({
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4],
        cursor: "not-allowed"
      }, theme.fn.hover({
        backgroundColor: "transparent"
      }))
    }),
    monthPickerControlActive: __spreadValues$3e({
      backgroundColor: colors.background,
      color: colors.color
    }, theme.fn.hover({
      backgroundColor: colors.hover
    }))
  };
});
var __defProp$3f = Object.defineProperty;
var __getOwnPropSymbols$3g = Object.getOwnPropertySymbols;
var __hasOwnProp$3g = Object.prototype.hasOwnProperty;
var __propIsEnum$3g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3f = function __defNormalProp$3f(obj, key, value) {
  return key in obj ? __defProp$3f(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3f = function __spreadValues$3f(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3g.call(b, prop)) __defNormalProp$3f(a, prop, b[prop]);
  if (__getOwnPropSymbols$3g) {
    var _iterator311 = _createForOfIteratorHelper(__getOwnPropSymbols$3g(b)),
      _step312;
    try {
      for (_iterator311.s(); !(_step312 = _iterator311.n()).done;) {
        var prop = _step312.value;
        if (__propIsEnum$3g.call(b, prop)) __defNormalProp$3f(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator311.e(err);
    } finally {
      _iterator311.f();
    }
  }
  return a;
};
var __objRest$1W = function __objRest$1W(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3g.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3g) {
    var _iterator312 = _createForOfIteratorHelper(__getOwnPropSymbols$3g(source)),
      _step313;
    try {
      for (_iterator312.s(); !(_step313 = _iterator312.n()).done;) {
        var prop = _step313.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3g.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator312.e(err);
    } finally {
      _iterator312.f();
    }
  }
  return target;
};
function MonthPicker(_a) {
  var _b = _a,
    className = _b.className,
    styles = _b.styles,
    classNames = _b.classNames,
    value = _b.value,
    onChange = _b.onChange,
    locale = _b.locale,
    year = _b.year,
    onYearChange = _b.onYearChange,
    onNextLevel = _b.onNextLevel,
    size = _b.size,
    minDate = _b.minDate,
    maxDate = _b.maxDate,
    _b$__staticSelector6 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector6 === void 0 ? "MonthPicker" : _b$__staticSelector6,
    nextYearLabel = _b.nextYearLabel,
    previousYearLabel = _b.previousYearLabel,
    preventFocus = _b.preventFocus,
    others = __objRest$1W(_b, ["className", "styles", "classNames", "value", "onChange", "locale", "year", "onYearChange", "onNextLevel", "size", "minDate", "maxDate", "__staticSelector", "nextYearLabel", "previousYearLabel", "preventFocus"]);
  var _useStyles$1v = useStyles$1v({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$1v.classes,
    cx = _useStyles$1v.cx;
  var range = getMonthsNames(locale);
  var minYear = minDate instanceof Date ? minDate.getFullYear() : void 0;
  var maxYear = maxDate instanceof Date ? maxDate.getFullYear() : void 0;
  var months = range.map(function (month, index) {
    return /* @__PURE__ */React__default.createElement(UnstyledButton, {
      key: month,
      onClick: function onClick() {
        return onChange(index);
      },
      className: cx(classes.monthPickerControl, _defineProperty({}, classes.monthPickerControlActive, index === value.month && year === value.year)),
      disabled: !isMonthInRange({
        date: new Date(year, index),
        minDate: minDate,
        maxDate: maxDate
      }),
      onMouseDown: function onMouseDown(event) {
        return preventFocus && event.preventDefault();
      }
    }, month);
  });
  return /* @__PURE__ */React__default.createElement("div", __spreadValues$3f({
    className: cx(classes.monthPicker, className)
  }, others), /* @__PURE__ */React__default.createElement(CalendarHeader, {
    label: year.toString(),
    hasNext: typeof maxYear === "number" ? year < maxYear : true,
    hasPrevious: typeof minYear === "number" ? year > minYear : true,
    onNext: function onNext() {
      return onYearChange(year + 1);
    },
    onPrevious: function onPrevious() {
      return onYearChange(year - 1);
    },
    onNextLevel: onNextLevel,
    size: size,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    nextLabel: nextYearLabel,
    previousLabel: previousYearLabel,
    preventFocus: preventFocus
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classes.monthPickerControls
  }, months));
}
MonthPicker.displayName = "@mantine/dates/MonthPicker";
function formatMonthLabel(_ref174) {
  var month = _ref174.month,
    locale = _ref174.locale,
    format = _ref174.format;
  return upperFirst(dayjs_min(month).locale(locale).format(format));
}
function getDayTabIndex(_ref175) {
  var focusable = _ref175.focusable,
    hasValue = _ref175.hasValue,
    selected = _ref175.selected,
    firstInMonth = _ref175.firstInMonth;
  if (!focusable) {
    return -1;
  }
  if (hasValue) {
    return selected ? 0 : -1;
  }
  return firstInMonth ? 0 : -1;
}
function getDayAutofocus(_ref176) {
  var hasValue = _ref176.hasValue,
    selected = _ref176.selected,
    firstInMonth = _ref176.firstInMonth;
  if (hasValue) {
    return selected ? true : void 0;
  }
  return firstInMonth ? true : void 0;
}
var __defProp$3g = Object.defineProperty;
var __defProps$1y = Object.defineProperties;
var __getOwnPropDescs$1y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3h = Object.getOwnPropertySymbols;
var __hasOwnProp$3h = Object.prototype.hasOwnProperty;
var __propIsEnum$3h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3g = function __defNormalProp$3g(obj, key, value) {
  return key in obj ? __defProp$3g(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3g = function __spreadValues$3g(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3h.call(b, prop)) __defNormalProp$3g(a, prop, b[prop]);
  if (__getOwnPropSymbols$3h) {
    var _iterator313 = _createForOfIteratorHelper(__getOwnPropSymbols$3h(b)),
      _step314;
    try {
      for (_iterator313.s(); !(_step314 = _iterator313.n()).done;) {
        var prop = _step314.value;
        if (__propIsEnum$3h.call(b, prop)) __defNormalProp$3g(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator313.e(err);
    } finally {
      _iterator313.f();
    }
  }
  return a;
};
var __spreadProps$1y = function __spreadProps$1y(a, b) {
  return __defProps$1y(a, __getOwnPropDescs$1y(b));
};
var sizes$p = {
  xs: 34,
  sm: 38,
  md: 46,
  lg: 58,
  xl: 66
};
var useStyles$1w = createStyles(function (theme, _ref177, getRef) {
  var _spreadProps$1y;
  var size = _ref177.size,
    fullWidth = _ref177.fullWidth,
    hideOutsideDates = _ref177.hideOutsideDates;
  var weekend = {
    ref: getRef("weekend")
  };
  var outside = {
    ref: getRef("outside")
  };
  var selected = {
    ref: getRef("selected")
  };
  var inRange = {
    ref: getRef("inRange")
  };
  var firstInRange = {
    ref: getRef("firstInRange")
  };
  var lastInRange = {
    ref: getRef("lastInRange")
  };
  return {
    weekend: weekend,
    outside: outside,
    selected: selected,
    inRange: inRange,
    firstInRange: firstInRange,
    lastInRange: lastInRange,
    day: __spreadProps$1y(__spreadValues$3g(__spreadProps$1y(__spreadValues$3g(__spreadValues$3g({}, theme.fn.fontStyles()), theme.fn.focusStyles()), {
      position: "relative",
      WebkitTapHighlightColor: "transparent",
      backgroundColor: "transparent",
      width: fullWidth ? "100%" : theme.fn.size({
        size: size,
        sizes: sizes$p
      }),
      height: theme.fn.size({
        size: size,
        sizes: sizes$p
      }),
      lineHeight: "".concat(theme.fn.size({
        size: size,
        sizes: sizes$p
      }), "px"),
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      padding: 0,
      borderRadius: theme.radius.sm,
      border: "none",
      cursor: "pointer",
      userSelect: "none",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
      "&:disabled": {
        pointerEvents: "none",
        color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4]
      }
    }), theme.fn.hover({
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
    })), (_spreadProps$1y = {}, _defineProperty(_spreadProps$1y, "&.".concat(weekend.ref, ":not(:disabled)"), {
      color: theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7]
    }), _defineProperty(_spreadProps$1y, "&.".concat(outside.ref), {
      display: hideOutsideDates ? "none" : void 0,
      color: "".concat(theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4], " !important")
    }), _defineProperty(_spreadProps$1y, "&.".concat(inRange.ref, ":not(:disabled)"), {
      backgroundColor: theme.fn.variant({
        variant: "light"
      }).background,
      borderRadius: 0
    }), _defineProperty(_spreadProps$1y, "&.".concat(selected.ref, ":not(:disabled)"), {
      backgroundColor: theme.fn.variant({
        variant: "filled"
      }).background,
      color: theme.white
    }), _defineProperty(_spreadProps$1y, "&.".concat(firstInRange.ref, ":not(:disabled)"), {
      borderTopLeftRadius: theme.radius.sm,
      borderBottomLeftRadius: theme.radius.sm
    }), _defineProperty(_spreadProps$1y, "&.".concat(lastInRange.ref, ":not(:disabled)"), {
      borderTopRightRadius: theme.radius.sm,
      borderBottomRightRadius: theme.radius.sm
    }), _spreadProps$1y))
  };
});
var __defProp$3h = Object.defineProperty;
var __defProps$1z = Object.defineProperties;
var __getOwnPropDescs$1z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3i = Object.getOwnPropertySymbols;
var __hasOwnProp$3i = Object.prototype.hasOwnProperty;
var __propIsEnum$3i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3h = function __defNormalProp$3h(obj, key, value) {
  return key in obj ? __defProp$3h(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3h = function __spreadValues$3h(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3i.call(b, prop)) __defNormalProp$3h(a, prop, b[prop]);
  if (__getOwnPropSymbols$3i) {
    var _iterator314 = _createForOfIteratorHelper(__getOwnPropSymbols$3i(b)),
      _step315;
    try {
      for (_iterator314.s(); !(_step315 = _iterator314.n()).done;) {
        var prop = _step315.value;
        if (__propIsEnum$3i.call(b, prop)) __defNormalProp$3h(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator314.e(err);
    } finally {
      _iterator314.f();
    }
  }
  return a;
};
var __spreadProps$1z = function __spreadProps$1z(a, b) {
  return __defProps$1z(a, __getOwnPropDescs$1z(b));
};
var __objRest$1X = function __objRest$1X(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3i.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3i) {
    var _iterator315 = _createForOfIteratorHelper(__getOwnPropSymbols$3i(source)),
      _step316;
    try {
      for (_iterator315.s(); !(_step316 = _iterator315.n()).done;) {
        var prop = _step316.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3i.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator315.e(err);
    } finally {
      _iterator315.f();
    }
  }
  return target;
};
var Day = forwardRef(function (_a, ref) {
  var _cx27;
  var _b = _a,
    className = _b.className,
    value = _b.value,
    selected = _b.selected,
    weekend = _b.weekend,
    outside = _b.outside,
    _onMouseEnter2 = _b.onMouseEnter,
    classNames = _b.classNames,
    styles = _b.styles,
    hasValue = _b.hasValue,
    firstInRange = _b.firstInRange,
    lastInRange = _b.lastInRange,
    _b$__staticSelector7 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector7 === void 0 ? "Month" : _b$__staticSelector7,
    inRange = _b.inRange,
    size = _b.size,
    fullWidth = _b.fullWidth,
    firstInMonth = _b.firstInMonth,
    focusable = _b.focusable,
    hideOutsideDates = _b.hideOutsideDates,
    renderDay = _b.renderDay,
    others = __objRest$1X(_b, ["className", "value", "selected", "weekend", "outside", "onMouseEnter", "classNames", "styles", "hasValue", "firstInRange", "lastInRange", "__staticSelector", "inRange", "size", "fullWidth", "firstInMonth", "focusable", "hideOutsideDates", "renderDay"]);
  var _useStyles$1w = useStyles$1w({
      size: size,
      fullWidth: fullWidth,
      hideOutsideDates: hideOutsideDates
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$1w.classes,
    cx = _useStyles$1w.cx;
  return /* @__PURE__ */React__default.createElement("button", __spreadProps$1z(__spreadValues$3h({}, others), {
    type: "button",
    ref: ref,
    onMouseEnter: function onMouseEnter(event) {
      return _onMouseEnter2(value, event);
    },
    tabIndex: getDayTabIndex({
      focusable: focusable,
      hasValue: hasValue,
      selected: selected,
      firstInMonth: firstInMonth
    }),
    "data-autofocus": getDayAutofocus({
      hasValue: hasValue,
      selected: selected,
      firstInMonth: firstInMonth
    }),
    "data-mantine-stop-propagation": true,
    className: cx(classes.day, (_cx27 = {}, _defineProperty(_cx27, classes.outside, outside), _defineProperty(_cx27, classes.weekend, weekend), _defineProperty(_cx27, classes.selected, selected), _defineProperty(_cx27, classes.inRange, inRange), _defineProperty(_cx27, classes.firstInRange, firstInRange), _defineProperty(_cx27, classes.lastInRange, lastInRange), _cx27), className)
  }), typeof renderDay === "function" ? renderDay(value) : value.getDate());
});
Day.displayName = "@mantine/core/Day";
function isWeekend(date) {
  var weekendDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 6];
  return weekendDays.includes(date.getDay());
}
function isOutside(date, month) {
  return !isSameMonth(date, month);
}
function isDisabled(_ref178) {
  var minDate = _ref178.minDate,
    maxDate = _ref178.maxDate,
    excludeDate = _ref178.excludeDate,
    disableOutsideEvents = _ref178.disableOutsideEvents,
    date = _ref178.date,
    outside = _ref178.outside;
  var isAfterMax = maxDate instanceof Date && dayjs_min(maxDate).isBefore(date, "day");
  var isBeforeMin = minDate instanceof Date && dayjs_min(minDate).isAfter(date, "day");
  var shouldExclude = typeof excludeDate === "function" && excludeDate(date);
  var disabledOutside = !!disableOutsideEvents && !!outside;
  return isAfterMax || isBeforeMin || shouldExclude || disabledOutside;
}
function getRangeProps(date, range) {
  var hasRange = Array.isArray(range) && range.every(function (val) {
    return val instanceof Date;
  });
  var inclusiveRange = hasRange && [dayjs_min(range[0]).subtract(1, "day"), dayjs_min(range[1]).add(1, "day")];
  var firstInRange = hasRange && isSameDate(date, range[0]);
  var lastInRange = hasRange && isSameDate(date, range[1]);
  var inRange = hasRange && dayjs_min(date).isAfter(inclusiveRange[0], "day") && dayjs_min(date).isBefore(inclusiveRange[1], "day");
  return {
    firstInRange: firstInRange,
    lastInRange: lastInRange,
    inRange: inRange,
    selectedInRange: firstInRange || lastInRange
  };
}
function getDayProps(_ref179) {
  var date = _ref179.date,
    month = _ref179.month,
    hasValue = _ref179.hasValue,
    minDate = _ref179.minDate,
    maxDate = _ref179.maxDate,
    value = _ref179.value,
    excludeDate = _ref179.excludeDate,
    disableOutsideEvents = _ref179.disableOutsideEvents,
    range = _ref179.range,
    weekendDays = _ref179.weekendDays;
  var outside = isOutside(date, month);
  var selected = hasValue && (Array.isArray(value) ? value.some(function (val) {
    return isSameDate(val, date);
  }) : isSameDate(date, value));
  var _getRangeProps = getRangeProps(date, range),
    inRange = _getRangeProps.inRange,
    lastInRange = _getRangeProps.lastInRange,
    firstInRange = _getRangeProps.firstInRange,
    selectedInRange = _getRangeProps.selectedInRange;
  return {
    disabled: isDisabled({
      minDate: minDate,
      maxDate: maxDate,
      excludeDate: excludeDate,
      disableOutsideEvents: disableOutsideEvents,
      date: date,
      outside: outside
    }),
    weekend: isWeekend(date, weekendDays),
    selectedInRange: selectedInRange,
    selected: selected,
    inRange: inRange,
    firstInRange: firstInRange,
    lastInRange: lastInRange,
    outside: outside
  };
}
var __defProp$3i = Object.defineProperty;
var __defProps$1A = Object.defineProperties;
var __getOwnPropDescs$1A = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3j = Object.getOwnPropertySymbols;
var __hasOwnProp$3j = Object.prototype.hasOwnProperty;
var __propIsEnum$3j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3i = function __defNormalProp$3i(obj, key, value) {
  return key in obj ? __defProp$3i(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3i = function __spreadValues$3i(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3j.call(b, prop)) __defNormalProp$3i(a, prop, b[prop]);
  if (__getOwnPropSymbols$3j) {
    var _iterator316 = _createForOfIteratorHelper(__getOwnPropSymbols$3j(b)),
      _step317;
    try {
      for (_iterator316.s(); !(_step317 = _iterator316.n()).done;) {
        var prop = _step317.value;
        if (__propIsEnum$3j.call(b, prop)) __defNormalProp$3i(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator316.e(err);
    } finally {
      _iterator316.f();
    }
  }
  return a;
};
var __spreadProps$1A = function __spreadProps$1A(a, b) {
  return __defProps$1A(a, __getOwnPropDescs$1A(b));
};
var useStyles$1x = createStyles(function (theme, _ref180) {
  var fullWidth = _ref180.fullWidth;
  return {
    weekday: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[5]
    },
    month: __spreadProps$1A(__spreadValues$3i({}, theme.fn.fontStyles()), {
      borderCollapse: "collapse",
      width: fullWidth ? "100%" : "auto",
      tableLayout: "fixed"
    }),
    cell: {
      boxSizing: "border-box",
      padding: 0,
      borderTop: "1px solid transparent"
    },
    weekdayCell: {
      boxSizing: "border-box",
      padding: 0,
      fontWeight: "normal",
      paddingBottom: theme.spacing.xs / 2,
      textAlign: "center",
      cursor: "default",
      userSelect: "none"
    }
  };
});
var __defProp$3j = Object.defineProperty;
var __getOwnPropSymbols$3k = Object.getOwnPropertySymbols;
var __hasOwnProp$3k = Object.prototype.hasOwnProperty;
var __propIsEnum$3k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3j = function __defNormalProp$3j(obj, key, value) {
  return key in obj ? __defProp$3j(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3j = function __spreadValues$3j(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3k.call(b, prop)) __defNormalProp$3j(a, prop, b[prop]);
  if (__getOwnPropSymbols$3k) {
    var _iterator317 = _createForOfIteratorHelper(__getOwnPropSymbols$3k(b)),
      _step318;
    try {
      for (_iterator317.s(); !(_step318 = _iterator317.n()).done;) {
        var prop = _step318.value;
        if (__propIsEnum$3k.call(b, prop)) __defNormalProp$3j(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator317.e(err);
    } finally {
      _iterator317.f();
    }
  }
  return a;
};
var __objRest$1Y = function __objRest$1Y(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3k.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3k) {
    var _iterator318 = _createForOfIteratorHelper(__getOwnPropSymbols$3k(source)),
      _step319;
    try {
      for (_iterator318.s(); !(_step319 = _iterator318.n()).done;) {
        var prop = _step319.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3k.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator318.e(err);
    } finally {
      _iterator318.f();
    }
  }
  return target;
};
var no = function no() {
  return false;
};
var defaultProps$1k = {
  disableOutsideEvents: false,
  hideWeekdays: false,
  __staticSelector: "Month",
  size: "sm",
  fullWidth: false,
  preventFocus: false,
  focusable: true,
  firstDayOfWeek: "monday",
  hideOutsideDates: false,
  weekendDays: [0, 6]
};
var Month = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Month", defaultProps$1k, props),
    className = _a.className,
    month = _a.month,
    value = _a.value,
    onChange = _a.onChange,
    disableOutsideEvents = _a.disableOutsideEvents,
    locale = _a.locale,
    dayClassName = _a.dayClassName,
    dayStyle = _a.dayStyle,
    classNames = _a.classNames,
    styles = _a.styles,
    minDate = _a.minDate,
    maxDate = _a.maxDate,
    excludeDate = _a.excludeDate,
    onDayMouseEnter = _a.onDayMouseEnter,
    range$$1 = _a.range,
    hideWeekdays = _a.hideWeekdays,
    __staticSelector = _a.__staticSelector,
    size = _a.size,
    fullWidth = _a.fullWidth,
    preventFocus = _a.preventFocus,
    focusable = _a.focusable,
    firstDayOfWeek = _a.firstDayOfWeek,
    onDayKeyDown = _a.onDayKeyDown,
    daysRefs = _a.daysRefs,
    hideOutsideDates = _a.hideOutsideDates,
    _a$isDateInRange = _a.isDateInRange,
    isDateInRange = _a$isDateInRange === void 0 ? no : _a$isDateInRange,
    _a$isDateFirstInRange = _a.isDateFirstInRange,
    isDateFirstInRange = _a$isDateFirstInRange === void 0 ? no : _a$isDateFirstInRange,
    _a$isDateLastInRange = _a.isDateLastInRange,
    isDateLastInRange = _a$isDateLastInRange === void 0 ? no : _a$isDateLastInRange,
    renderDay = _a.renderDay,
    weekdayLabelFormat = _a.weekdayLabelFormat,
    weekendDays = _a.weekendDays,
    others = __objRest$1Y(_a, ["className", "month", "value", "onChange", "disableOutsideEvents", "locale", "dayClassName", "dayStyle", "classNames", "styles", "minDate", "maxDate", "excludeDate", "onDayMouseEnter", "range", "hideWeekdays", "__staticSelector", "size", "fullWidth", "preventFocus", "focusable", "firstDayOfWeek", "onDayKeyDown", "daysRefs", "hideOutsideDates", "isDateInRange", "isDateFirstInRange", "isDateLastInRange", "renderDay", "weekdayLabelFormat", "weekendDays"]);
  var _useStyles$1x = useStyles$1x({
      fullWidth: fullWidth
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$1x.classes,
    cx = _useStyles$1x.cx,
    theme = _useStyles$1x.theme;
  var finalLocale = locale || theme.datesLocale;
  var days = getMonthDays(month, firstDayOfWeek);
  var weekdays = getWeekdaysNames(finalLocale, firstDayOfWeek, weekdayLabelFormat).map(function (weekday) {
    return /* @__PURE__ */React__default.createElement("th", {
      className: classes.weekdayCell,
      key: weekday
    }, /* @__PURE__ */React__default.createElement(Text, {
      size: size,
      className: classes.weekday
    }, weekday.length >= 2 ? upperFirst(weekday) : weekday));
  });
  var hasValue = Array.isArray(value) ? value.every(function (item) {
    return item instanceof Date;
  }) : value instanceof Date;
  var hasValueInMonthRange = value instanceof Date && dayjs_min(value).isAfter(dayjs_min(month).startOf("month")) && dayjs_min(value).isBefore(dayjs_min(month).endOf("month"));
  var firstDayOfMonth = useMemo(function () {
    var actualFirstDayDisabled = false;
    var firstDay;
    for (var _i22 = 0; _i22 < days.length; _i22 += 1) {
      if (firstDay) {
        break;
      }
      var dates = days[_i22];
      for (var _j = 0; _j < dates.length; _j += 1) {
        var date = dates[_j];
        var dayProps = getDayProps({
          date: date,
          month: month,
          hasValue: hasValue,
          minDate: minDate,
          maxDate: maxDate,
          value: value,
          excludeDate: excludeDate,
          disableOutsideEvents: disableOutsideEvents,
          range: range$$1,
          weekendDays: weekendDays
        });
        if (actualFirstDayDisabled && !dayProps.disabled) {
          firstDay = date;
          break;
        }
        var first = hideOutsideDates ? isSameDate(date, dayjs_min(month).startOf("month").toDate()) : _j === 0 && _i22 === 0;
        if (first && !dayProps.disabled) {
          firstDay = date;
          break;
        } else if (first && dayProps.disabled) {
          actualFirstDayDisabled = true;
        }
      }
    }
    return firstDay;
  }, []);
  var rows = days.map(function (row, rowIndex) {
    var cells = row.map(function (date, cellIndex) {
      var dayProps = getDayProps({
        date: date,
        month: month,
        hasValue: hasValue,
        minDate: minDate,
        maxDate: maxDate,
        value: value,
        excludeDate: excludeDate,
        disableOutsideEvents: disableOutsideEvents,
        range: range$$1,
        weekendDays: weekendDays
      });
      var onKeyDownPayload = {
        rowIndex: rowIndex,
        cellIndex: cellIndex,
        date: date
      };
      return /* @__PURE__ */React__default.createElement("td", {
        className: classes.cell,
        key: cellIndex
      }, /* @__PURE__ */React__default.createElement(Day, {
        ref: function ref(button) {
          if (daysRefs) {
            if (!Array.isArray(daysRefs[rowIndex])) {
              daysRefs[rowIndex] = [];
            }
            daysRefs[rowIndex][cellIndex] = button;
          }
        },
        onClick: function onClick() {
          return typeof onChange === "function" && onChange(date);
        },
        onMouseDown: function onMouseDown(event) {
          return preventFocus && event.preventDefault();
        },
        value: date,
        outside: dayProps.outside,
        weekend: dayProps.weekend,
        inRange: dayProps.inRange || isDateInRange(date, dayProps),
        firstInRange: dayProps.firstInRange || isDateFirstInRange(date, dayProps),
        lastInRange: dayProps.lastInRange || isDateLastInRange(date, dayProps),
        firstInMonth: isSameDate(date, firstDayOfMonth),
        selected: dayProps.selected || dayProps.selectedInRange,
        hasValue: hasValueInMonthRange,
        onKeyDown: function onKeyDown(event) {
          return typeof onDayKeyDown === "function" && onDayKeyDown(onKeyDownPayload, event);
        },
        className: typeof dayClassName === "function" ? dayClassName(date, dayProps) : null,
        style: typeof dayStyle === "function" ? dayStyle(date, dayProps) : null,
        disabled: dayProps.disabled,
        onMouseEnter: typeof onDayMouseEnter === "function" ? onDayMouseEnter : no,
        size: size,
        fullWidth: fullWidth,
        focusable: focusable,
        hideOutsideDates: hideOutsideDates,
        __staticSelector: __staticSelector,
        styles: styles,
        classNames: classNames,
        renderDay: renderDay
      }));
    });
    return /* @__PURE__ */React__default.createElement("tr", {
      key: rowIndex
    }, cells);
  });
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$3j({
    component: "table",
    className: cx(classes.month, className),
    ref: ref
  }, others), !hideWeekdays && /* @__PURE__ */React__default.createElement("thead", null, /* @__PURE__ */React__default.createElement("tr", null, weekdays)), /* @__PURE__ */React__default.createElement("tbody", null, rows));
});
Month.displayName = "@mantine/dates/Month";
var __defProp$3k = Object.defineProperty;
var __getOwnPropSymbols$3l = Object.getOwnPropertySymbols;
var __hasOwnProp$3l = Object.prototype.hasOwnProperty;
var __propIsEnum$3l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3k = function __defNormalProp$3k(obj, key, value) {
  return key in obj ? __defProp$3k(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3k = function __spreadValues$3k(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3l.call(b, prop)) __defNormalProp$3k(a, prop, b[prop]);
  if (__getOwnPropSymbols$3l) {
    var _iterator319 = _createForOfIteratorHelper(__getOwnPropSymbols$3l(b)),
      _step320;
    try {
      for (_iterator319.s(); !(_step320 = _iterator319.n()).done;) {
        var prop = _step320.value;
        if (__propIsEnum$3l.call(b, prop)) __defNormalProp$3k(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator319.e(err);
    } finally {
      _iterator319.f();
    }
  }
  return a;
};
var __objRest$1Z = function __objRest$1Z(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3l.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3l) {
    var _iterator320 = _createForOfIteratorHelper(__getOwnPropSymbols$3l(source)),
      _step321;
    try {
      for (_iterator320.s(); !(_step321 = _iterator320.n()).done;) {
        var prop = _step321.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3l.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator320.e(err);
    } finally {
      _iterator320.f();
    }
  }
  return target;
};
function MonthsList(_a) {
  var _b = _a,
    amountOfMonths = _b.amountOfMonths,
    month = _b.month,
    locale = _b.locale,
    minDate = _b.minDate,
    maxDate = _b.maxDate,
    allowLevelChange = _b.allowLevelChange,
    size = _b.size,
    daysRefs = _b.daysRefs,
    onMonthChange = _b.onMonthChange,
    onNextLevel = _b.onNextLevel,
    _onDayKeyDown = _b.onDayKeyDown,
    classNames = _b.classNames,
    styles = _b.styles,
    _b$__staticSelector8 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector8 === void 0 ? "MonthsList" : _b$__staticSelector8,
    nextMonthLabel = _b.nextMonthLabel,
    previousMonthLabel = _b.previousMonthLabel,
    labelFormat = _b.labelFormat,
    weekdayLabelFormat = _b.weekdayLabelFormat,
    preventFocus = _b.preventFocus,
    renderDay = _b.renderDay,
    others = __objRest$1Z(_b, ["amountOfMonths", "month", "locale", "minDate", "maxDate", "allowLevelChange", "size", "daysRefs", "onMonthChange", "onNextLevel", "onDayKeyDown", "classNames", "styles", "__staticSelector", "nextMonthLabel", "previousMonthLabel", "labelFormat", "weekdayLabelFormat", "preventFocus", "renderDay"]);
  var nextMonth = dayjs_min(month).add(amountOfMonths, "months").toDate();
  var previousMonth = dayjs_min(month).subtract(1, "months").toDate();
  var months = Array(amountOfMonths).fill(0).map(function (_, index) {
    var monthDate = dayjs_min(month).add(index, "months").toDate();
    return /* @__PURE__ */React__default.createElement("div", {
      key: index
    }, /* @__PURE__ */React__default.createElement(CalendarHeader, {
      hasNext: index + 1 === amountOfMonths && isMonthInRange({
        date: nextMonth,
        minDate: minDate,
        maxDate: maxDate
      }),
      hasPrevious: index === 0 && isMonthInRange({
        date: previousMonth,
        minDate: minDate,
        maxDate: maxDate
      }),
      label: formatMonthLabel({
        month: monthDate,
        locale: locale,
        format: labelFormat
      }),
      onNext: function onNext() {
        return onMonthChange(dayjs_min(month).add(amountOfMonths, "months").toDate());
      },
      onPrevious: function onPrevious() {
        return onMonthChange(dayjs_min(month).subtract(amountOfMonths, "months").toDate());
      },
      onNextLevel: onNextLevel,
      nextLevelDisabled: !allowLevelChange,
      size: size,
      classNames: classNames,
      styles: styles,
      __staticSelector: __staticSelector,
      nextLabel: nextMonthLabel,
      previousLabel: previousMonthLabel,
      preventLevelFocus: index > 0,
      preventFocus: preventFocus
    }), /* @__PURE__ */React__default.createElement(Month, __spreadValues$3k({
      month: monthDate,
      daysRefs: daysRefs.current[index],
      onDayKeyDown: function onDayKeyDown() {
        for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
          args[_key13] = arguments[_key13];
        }
        return _onDayKeyDown.apply(void 0, [index].concat(args));
      },
      size: size,
      minDate: minDate,
      maxDate: maxDate,
      classNames: classNames,
      styles: styles,
      __staticSelector: __staticSelector,
      locale: locale,
      focusable: index === 0,
      preventFocus: preventFocus,
      renderDay: renderDay,
      weekdayLabelFormat: weekdayLabelFormat
    }, others)));
  });
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, months);
}
MonthsList.displayName = "@mantine/dates/MonthsList";
var useStyles$1y = createStyles(function (theme, _ref181) {
  var size = _ref181.size,
    amountOfMonths = _ref181.amountOfMonths,
    fullWidth = _ref181.fullWidth;
  var _maxWidth = theme.fn.size({
    size: size,
    sizes: sizes$p
  }) * 7;
  var maxWidth = amountOfMonths > 1 ? _maxWidth * amountOfMonths + (amountOfMonths - 1) * theme.spacing.md : _maxWidth;
  return {
    calendarBase: {
      boxSizing: "border-box",
      display: "flex",
      gap: theme.spacing.md,
      maxWidth: fullWidth ? "100%" : maxWidth
    }
  };
});
var __defProp$3l = Object.defineProperty;
var __getOwnPropSymbols$3m = Object.getOwnPropertySymbols;
var __hasOwnProp$3m = Object.prototype.hasOwnProperty;
var __propIsEnum$3m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3l = function __defNormalProp$3l(obj, key, value) {
  return key in obj ? __defProp$3l(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3l = function __spreadValues$3l(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3m.call(b, prop)) __defNormalProp$3l(a, prop, b[prop]);
  if (__getOwnPropSymbols$3m) {
    var _iterator321 = _createForOfIteratorHelper(__getOwnPropSymbols$3m(b)),
      _step322;
    try {
      for (_iterator321.s(); !(_step322 = _iterator321.n()).done;) {
        var prop = _step322.value;
        if (__propIsEnum$3m.call(b, prop)) __defNormalProp$3l(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator321.e(err);
    } finally {
      _iterator321.f();
    }
  }
  return a;
};
var __objRest$1_ = function __objRest$1_(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3m.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3m) {
    var _iterator322 = _createForOfIteratorHelper(__getOwnPropSymbols$3m(source)),
      _step323;
    try {
      for (_iterator322.s(); !(_step323 = _iterator322.n()).done;) {
        var prop = _step323.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3m.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator322.e(err);
    } finally {
      _iterator322.f();
    }
  }
  return target;
};
var CalendarBase = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    classNames = _b.classNames,
    styles = _b.styles,
    month = _b.month,
    initialMonth = _b.initialMonth,
    onMonthChange = _b.onMonthChange,
    locale = _b.locale,
    _b$amountOfMonths = _b.amountOfMonths,
    amountOfMonths = _b$amountOfMonths === void 0 ? 1 : _b$amountOfMonths,
    _b$size4 = _b.size,
    size = _b$size4 === void 0 ? "sm" : _b$size4,
    _b$allowLevelChange = _b.allowLevelChange,
    allowLevelChange = _b$allowLevelChange === void 0 ? true : _b$allowLevelChange,
    _b$initialLevel = _b.initialLevel,
    initialLevel = _b$initialLevel === void 0 ? "date" : _b$initialLevel,
    minDate = _b.minDate,
    maxDate = _b.maxDate,
    _b$__staticSelector9 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector9 === void 0 ? "CalendarBase" : _b$__staticSelector9,
    dayClassName = _b.dayClassName,
    dayStyle = _b.dayStyle,
    disableOutsideEvents = _b.disableOutsideEvents,
    excludeDate = _b.excludeDate,
    hideWeekdays = _b.hideWeekdays,
    fullWidth = _b.fullWidth,
    preventFocus = _b.preventFocus,
    _b$firstDayOfWeek = _b.firstDayOfWeek,
    firstDayOfWeek = _b$firstDayOfWeek === void 0 ? "monday" : _b$firstDayOfWeek,
    value = _b.value,
    onChange = _b.onChange,
    onDayMouseEnter = _b.onDayMouseEnter,
    range$$1 = _b.range,
    nextDecadeLabel = _b.nextDecadeLabel,
    nextMonthLabel = _b.nextMonthLabel,
    nextYearLabel = _b.nextYearLabel,
    previousDecadeLabel = _b.previousDecadeLabel,
    previousMonthLabel = _b.previousMonthLabel,
    previousYearLabel = _b.previousYearLabel,
    _b$labelFormat = _b.labelFormat,
    labelFormat = _b$labelFormat === void 0 ? "MMMM YYYY" : _b$labelFormat,
    weekdayLabelFormat = _b.weekdayLabelFormat,
    hideOutsideDates = _b.hideOutsideDates,
    isDateInRange = _b.isDateInRange,
    isDateFirstInRange = _b.isDateFirstInRange,
    isDateLastInRange = _b.isDateLastInRange,
    renderDay = _b.renderDay,
    weekendDays = _b.weekendDays,
    others = __objRest$1_(_b, ["className", "classNames", "styles", "month", "initialMonth", "onMonthChange", "locale", "amountOfMonths", "size", "allowLevelChange", "initialLevel", "minDate", "maxDate", "__staticSelector", "dayClassName", "dayStyle", "disableOutsideEvents", "excludeDate", "hideWeekdays", "fullWidth", "preventFocus", "firstDayOfWeek", "value", "onChange", "onDayMouseEnter", "range", "nextDecadeLabel", "nextMonthLabel", "nextYearLabel", "previousDecadeLabel", "previousMonthLabel", "previousYearLabel", "labelFormat", "weekdayLabelFormat", "hideOutsideDates", "isDateInRange", "isDateFirstInRange", "isDateLastInRange", "renderDay", "weekendDays"]);
  var _useState161 = useState(initialLevel),
    _useState162 = _slicedToArray(_useState161, 2),
    selectionState = _useState162[0],
    setSelectionState = _useState162[1];
  var _useStyles$1y = useStyles$1y({
      size: size,
      fullWidth: fullWidth,
      amountOfMonths: selectionState === "date" ? amountOfMonths : 1
    }, {
      name: __staticSelector,
      styles: styles,
      classNames: classNames
    }),
    classes = _useStyles$1y.classes,
    cx = _useStyles$1y.cx,
    theme = _useStyles$1y.theme;
  var finalLocale = locale || theme.datesLocale;
  var daysRefs = useRef(Array(amountOfMonths).fill(0).map(function () {
    return [];
  }));
  var _useUncontrolled33 = useUncontrolled({
      value: month,
      defaultValue: initialMonth,
      finalValue: new Date(),
      onChange: onMonthChange,
      rule: function rule(val) {
        return val instanceof Date;
      }
    }),
    _useUncontrolled34 = _slicedToArray(_useUncontrolled33, 2),
    _month = _useUncontrolled34[0],
    setMonth = _useUncontrolled34[1];
  var _useState163 = useState(_month.getFullYear()),
    _useState164 = _slicedToArray(_useState163, 2),
    yearSelection = _useState164[0],
    setYearSelection = _useState164[1];
  var minYear = minDate instanceof Date ? minDate.getFullYear() : 0;
  var maxYear = maxDate instanceof Date ? maxDate.getFullYear() : 1e4;
  var daysPerRow = 6;
  var focusOnNextFocusableDay = function focusOnNextFocusableDay(direction, monthIndex, payload) {
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var changeRow = ["down", "up"].includes(direction);
    var rowIndex = changeRow ? payload.rowIndex + (direction === "down" ? n : -n) : payload.rowIndex;
    var cellIndex = changeRow ? payload.cellIndex : payload.cellIndex + (direction === "right" ? n : -n);
    var dayToFocus = daysRefs.current[monthIndex][rowIndex][cellIndex];
    if (!dayToFocus) {
      return;
    }
    if (dayToFocus.disabled) {
      focusOnNextFocusableDay(direction, monthIndex, payload, n + 1);
    } else {
      dayToFocus.focus();
    }
  };
  var handleDayKeyDown = function handleDayKeyDown(monthIndex, payload, event) {
    var _a2;
    switch (event.code) {
      case "ArrowDown":
        {
          event.preventDefault();
          var hasRowBelow = payload.rowIndex + 1 < daysRefs.current[monthIndex].length;
          if (hasRowBelow) {
            focusOnNextFocusableDay("down", monthIndex, payload);
          }
          break;
        }
      case "ArrowUp":
        {
          event.preventDefault();
          var hasRowAbove = payload.rowIndex > 0;
          if (hasRowAbove) {
            focusOnNextFocusableDay("up", monthIndex, payload);
          }
          break;
        }
      case "ArrowRight":
        {
          event.preventDefault();
          var isNotLastCell = payload.cellIndex !== daysPerRow;
          if (isNotLastCell) {
            focusOnNextFocusableDay("right", monthIndex, payload);
          } else if (monthIndex + 1 < amountOfMonths) {
            if (daysRefs.current[monthIndex + 1][payload.rowIndex]) {
              (_a2 = daysRefs.current[monthIndex + 1][payload.rowIndex][0]) == null ? void 0 : _a2.focus();
            }
          }
          break;
        }
      case "ArrowLeft":
        {
          event.preventDefault();
          if (payload.cellIndex !== 0) {
            focusOnNextFocusableDay("left", monthIndex, payload);
          } else if (monthIndex > 0) {
            if (daysRefs.current[monthIndex - 1][payload.rowIndex]) {
              daysRefs.current[monthIndex - 1][payload.rowIndex][daysPerRow].focus();
            }
          }
        }
    }
  };
  return /* @__PURE__ */React__default.createElement(Box, __spreadValues$3l({
    className: cx(classes.calendarBase, className),
    ref: ref
  }, others), selectionState === "year" && /* @__PURE__ */React__default.createElement(YearPicker, {
    size: size,
    value: yearSelection,
    minYear: minYear,
    maxYear: maxYear,
    onChange: function onChange(year) {
      setYearSelection(year);
      setSelectionState("month");
    },
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    nextDecadeLabel: nextDecadeLabel,
    previousDecadeLabel: previousDecadeLabel,
    preventFocus: preventFocus
  }), selectionState === "month" && /* @__PURE__ */React__default.createElement(MonthPicker, {
    size: size,
    value: {
      month: _month.getMonth(),
      year: _month.getFullYear()
    },
    year: yearSelection,
    onYearChange: setYearSelection,
    onNextLevel: function onNextLevel() {
      return setSelectionState("year");
    },
    locale: finalLocale,
    minDate: minDate,
    maxDate: maxDate,
    onChange: function onChange(monthValue) {
      setMonth(new Date(yearSelection, monthValue, 1));
      setSelectionState("date");
    },
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    nextYearLabel: nextYearLabel,
    previousYearLabel: previousYearLabel,
    preventFocus: preventFocus
  }), selectionState === "date" && /* @__PURE__ */React__default.createElement(MonthsList, {
    amountOfMonths: amountOfMonths,
    month: _month,
    locale: finalLocale,
    minDate: minDate,
    maxDate: maxDate,
    allowLevelChange: allowLevelChange,
    size: size,
    daysRefs: daysRefs,
    onMonthChange: setMonth,
    onNextLevel: function onNextLevel() {
      return setSelectionState("month");
    },
    onDayKeyDown: handleDayKeyDown,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    dayClassName: dayClassName,
    dayStyle: dayStyle,
    disableOutsideEvents: disableOutsideEvents,
    excludeDate: excludeDate,
    hideWeekdays: hideWeekdays,
    fullWidth: fullWidth,
    preventFocus: preventFocus,
    firstDayOfWeek: firstDayOfWeek,
    value: value,
    range: range$$1,
    onChange: onChange,
    nextMonthLabel: nextMonthLabel,
    previousMonthLabel: previousMonthLabel,
    labelFormat: labelFormat,
    weekdayLabelFormat: weekdayLabelFormat,
    onDayMouseEnter: onDayMouseEnter,
    renderDay: renderDay,
    hideOutsideDates: hideOutsideDates,
    isDateInRange: isDateInRange,
    isDateFirstInRange: isDateFirstInRange,
    isDateLastInRange: isDateLastInRange,
    weekendDays: weekendDays
  }));
});
CalendarBase.displayName = "@mantine/dates/CalendarBase";
var __defProp$3m = Object.defineProperty;
var __getOwnPropSymbols$3n = Object.getOwnPropertySymbols;
var __hasOwnProp$3n = Object.prototype.hasOwnProperty;
var __propIsEnum$3n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3m = function __defNormalProp$3m(obj, key, value) {
  return key in obj ? __defProp$3m(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3m = function __spreadValues$3m(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3n.call(b, prop)) __defNormalProp$3m(a, prop, b[prop]);
  if (__getOwnPropSymbols$3n) {
    var _iterator323 = _createForOfIteratorHelper(__getOwnPropSymbols$3n(b)),
      _step324;
    try {
      for (_iterator323.s(); !(_step324 = _iterator323.n()).done;) {
        var prop = _step324.value;
        if (__propIsEnum$3n.call(b, prop)) __defNormalProp$3m(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator323.e(err);
    } finally {
      _iterator323.f();
    }
  }
  return a;
};
var __objRest$20 = function __objRest$20(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3n.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3n) {
    var _iterator324 = _createForOfIteratorHelper(__getOwnPropSymbols$3n(source)),
      _step325;
    try {
      for (_iterator324.s(); !(_step325 = _iterator324.n()).done;) {
        var prop = _step325.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3n.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator324.e(err);
    } finally {
      _iterator324.f();
    }
  }
  return target;
};
var defaultProps$1l = {
  __staticSelector: "Calendar"
};
function Calendar(props) {
  var _a = useMantineDefaultProps("Calendar", defaultProps$1l, props),
    _a$__staticSelector = _a.__staticSelector,
    __staticSelector = _a$__staticSelector === void 0 ? "Calendar" : _a$__staticSelector,
    multiple = _a.multiple,
    value = _a.value,
    onChange = _a.onChange,
    others = __objRest$20(_a, ["__staticSelector", "multiple", "value", "onChange"]);
  var handleChange = function handleChange(date) {
    if (!multiple) {
      return onChange(date);
    }
    var isSelected = value.some(function (val) {
      return isSameDate(val, date);
    });
    return onChange(isSelected ? value.filter(function (val) {
      return !isSameDate(val, date);
    }) : [].concat(_toConsumableArray2(value), [date]));
  };
  return /* @__PURE__ */React__default.createElement(CalendarBase, __spreadValues$3m({
    __staticSelector: __staticSelector,
    onChange: handleChange,
    value: value
  }, others));
}
Calendar.displayName = "@mantine/dates/Calendar";
var __defProp$3n = Object.defineProperty;
var __defProps$1B = Object.defineProperties;
var __getOwnPropDescs$1B = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3o = Object.getOwnPropertySymbols;
var __hasOwnProp$3o = Object.prototype.hasOwnProperty;
var __propIsEnum$3o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3n = function __defNormalProp$3n(obj, key, value) {
  return key in obj ? __defProp$3n(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3n = function __spreadValues$3n(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3o.call(b, prop)) __defNormalProp$3n(a, prop, b[prop]);
  if (__getOwnPropSymbols$3o) {
    var _iterator325 = _createForOfIteratorHelper(__getOwnPropSymbols$3o(b)),
      _step326;
    try {
      for (_iterator325.s(); !(_step326 = _iterator325.n()).done;) {
        var prop = _step326.value;
        if (__propIsEnum$3o.call(b, prop)) __defNormalProp$3n(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator325.e(err);
    } finally {
      _iterator325.f();
    }
  }
  return a;
};
var __spreadProps$1B = function __spreadProps$1B(a, b) {
  return __defProps$1B(a, __getOwnPropDescs$1B(b));
};
var useStyles$1z = createStyles(function (theme, _ref182, getRef) {
  var size = _ref182.size,
    invalid = _ref182.invalid;
  return {
    wrapper: __spreadProps$1B(__spreadValues$3n({}, theme.fn.fontStyles()), {
      position: "relative",
      cursor: "pointer"
    }),
    placeholder: {
      lineHeight: "".concat(theme.fn.size({
        size: size,
        sizes: sizes$2
      }) - 2, "px"),
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: invalid ? theme.colors.red[theme.colorScheme === "dark" ? 6 : 7] : theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
    },
    value: {
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    dropdownWrapper: {
      position: "relative",
      pointerEvents: "all"
    },
    input: _defineProperty({
      cursor: "pointer",
      whiteSpace: "nowrap"
    }, "&:not(.".concat(getRef("freeInput"), ")::selection"), {
      backgroundColor: "transparent"
    }),
    freeInput: {
      ref: getRef("freeInput"),
      cursor: "text"
    },
    dropdown: {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2]),
      padding: "".concat(theme.spacing.md, "px ").concat(theme.spacing.xs, "px")
    },
    arrow: {
      borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2],
      background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
    }
  };
});
var __defProp$3o = Object.defineProperty;
var __defProps$1C = Object.defineProperties;
var __getOwnPropDescs$1C = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3p = Object.getOwnPropertySymbols;
var __hasOwnProp$3p = Object.prototype.hasOwnProperty;
var __propIsEnum$3p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3o = function __defNormalProp$3o(obj, key, value) {
  return key in obj ? __defProp$3o(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3o = function __spreadValues$3o(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3p.call(b, prop)) __defNormalProp$3o(a, prop, b[prop]);
  if (__getOwnPropSymbols$3p) {
    var _iterator326 = _createForOfIteratorHelper(__getOwnPropSymbols$3p(b)),
      _step327;
    try {
      for (_iterator326.s(); !(_step327 = _iterator326.n()).done;) {
        var prop = _step327.value;
        if (__propIsEnum$3p.call(b, prop)) __defNormalProp$3o(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator326.e(err);
    } finally {
      _iterator326.f();
    }
  }
  return a;
};
var __spreadProps$1C = function __spreadProps$1C(a, b) {
  return __defProps$1C(a, __getOwnPropDescs$1C(b));
};
var __objRest$21 = function __objRest$21(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3p.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3p) {
    var _iterator327 = _createForOfIteratorHelper(__getOwnPropSymbols$3p(source)),
      _step328;
    try {
      for (_iterator327.s(); !(_step328 = _iterator327.n()).done;) {
        var prop = _step328.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3p.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator327.e(err);
    } finally {
      _iterator327.f();
    }
  }
  return target;
};
var RIGHT_SECTION_WIDTH$1 = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 40,
  xl: 44
};
var DatePickerBase = forwardRef(function (_a, ref) {
  var _b = _a,
    classNames = _b.classNames,
    className = _b.className,
    style = _b.style,
    styles = _b.styles,
    wrapperProps = _b.wrapperProps,
    required = _b.required,
    _b$allowFreeInput = _b.allowFreeInput,
    allowFreeInput = _b$allowFreeInput === void 0 ? false : _b$allowFreeInput,
    label = _b.label,
    error = _b.error,
    id = _b.id,
    description = _b.description,
    placeholder = _b.placeholder,
    _b$shadow = _b.shadow,
    shadow = _b$shadow === void 0 ? "sm" : _b$shadow,
    _b$transition = _b.transition,
    transition = _b$transition === void 0 ? "pop-top-left" : _b$transition,
    _b$transitionDuration = _b.transitionDuration,
    transitionDuration = _b$transitionDuration === void 0 ? 200 : _b$transitionDuration,
    transitionTimingFunction = _b.transitionTimingFunction,
    _b$closeDropdownOnScr = _b.closeDropdownOnScroll,
    closeDropdownOnScroll = _b$closeDropdownOnScr === void 0 ? false : _b$closeDropdownOnScr,
    _b$size5 = _b.size,
    size = _b$size5 === void 0 ? "sm" : _b$size5,
    children = _b.children,
    inputLabel = _b.inputLabel,
    _b$__staticSelector10 = _b.__staticSelector,
    __staticSelector = _b$__staticSelector10 === void 0 ? "DatePickerBase" : _b$__staticSelector10,
    dropdownOpened = _b.dropdownOpened,
    setDropdownOpened = _b.setDropdownOpened,
    _b$dropdownType = _b.dropdownType,
    dropdownType = _b$dropdownType === void 0 ? "popover" : _b$dropdownType,
    _b$dropdownPosition = _b.dropdownPosition,
    dropdownPosition = _b$dropdownPosition === void 0 ? "flip" : _b$dropdownPosition,
    _b$clearable = _b.clearable,
    clearable = _b$clearable === void 0 ? true : _b$clearable,
    clearButtonLabel = _b.clearButtonLabel,
    onClear = _b.onClear,
    _b$positionDependenci = _b.positionDependencies,
    positionDependencies = _b$positionDependenci === void 0 ? [] : _b$positionDependenci,
    _b$zIndex4 = _b.zIndex,
    zIndex = _b$zIndex4 === void 0 ? getDefaultZIndex("popover") : _b$zIndex4,
    _b$withinPortal2 = _b.withinPortal,
    withinPortal = _b$withinPortal2 === void 0 ? true : _b$withinPortal2,
    onBlur = _b.onBlur,
    onFocus = _b.onFocus,
    onChange = _b.onChange,
    onKeyDown = _b.onKeyDown,
    _b$name = _b.name,
    name = _b$name === void 0 ? "date" : _b$name,
    sx = _b.sx,
    _b$amountOfMonths2 = _b.amountOfMonths,
    amountOfMonths = _b$amountOfMonths2 === void 0 ? 1 : _b$amountOfMonths2,
    onDropdownClose = _b.onDropdownClose,
    onDropdownOpen = _b.onDropdownOpen,
    _b$clickOutsideEvents = _b.clickOutsideEvents,
    clickOutsideEvents = _b$clickOutsideEvents === void 0 ? ["mousedown", "touchstart"] : _b$clickOutsideEvents,
    modalZIndex = _b.modalZIndex,
    errorProps = _b.errorProps,
    labelProps = _b.labelProps,
    descriptionProps = _b.descriptionProps,
    _b$clearButtonTabInde = _b.clearButtonTabIndex,
    clearButtonTabIndex = _b$clearButtonTabInde === void 0 ? 0 : _b$clearButtonTabInde,
    others = __objRest$21(_b, ["classNames", "className", "style", "styles", "wrapperProps", "required", "allowFreeInput", "label", "error", "id", "description", "placeholder", "shadow", "transition", "transitionDuration", "transitionTimingFunction", "closeDropdownOnScroll", "size", "children", "inputLabel", "__staticSelector", "dropdownOpened", "setDropdownOpened", "dropdownType", "dropdownPosition", "clearable", "clearButtonLabel", "onClear", "positionDependencies", "zIndex", "withinPortal", "onBlur", "onFocus", "onChange", "onKeyDown", "name", "sx", "amountOfMonths", "onDropdownClose", "onDropdownOpen", "clickOutsideEvents", "modalZIndex", "errorProps", "labelProps", "descriptionProps", "clearButtonTabIndex"]);
  var _useStyles$1z = useStyles$1z({
      size: size,
      invalid: !!error
    }, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles$1z.classes,
    cx = _useStyles$1z.cx,
    theme = _useStyles$1z.theme;
  var _extractSystemStyles16 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles16.systemStyles,
    rest = _extractSystemStyles16.rest;
  var _useState165 = useState(null),
    _useState166 = _slicedToArray(_useState165, 2),
    dropdownElement = _useState166[0],
    setDropdownElement = _useState166[1];
  var _useState167 = useState(null),
    _useState168 = _slicedToArray(_useState167, 2),
    rootElement = _useState168[0],
    setRootElement = _useState168[1];
  var _useState169 = useState(null),
    _useState170 = _slicedToArray(_useState169, 2),
    referenceElement = _useState170[0],
    setReferenceElement = _useState170[1];
  var uuid = useUuid(id);
  var focusTrapRef = useFocusTrap(!allowFreeInput && dropdownOpened);
  var inputRef = useRef();
  var closeDropdown = function closeDropdown() {
    setDropdownOpened(false);
    onDropdownClose == null ? void 0 : onDropdownClose();
  };
  var openDropdown = function openDropdown() {
    setDropdownOpened(true);
    onDropdownOpen == null ? void 0 : onDropdownOpen();
  };
  var toggleDropdown = function toggleDropdown() {
    setDropdownOpened(!dropdownOpened);
    !dropdownOpened ? onDropdownOpen == null ? void 0 : onDropdownOpen() : onDropdownClose == null ? void 0 : onDropdownClose();
  };
  var closeOnEscape = function closeOnEscape(event) {
    if (event.nativeEvent.code === "Escape") {
      closeDropdown();
      window.setTimeout(function () {
        var _a2;
        return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
      }, 0);
    }
  };
  useClickOutside(function () {
    return dropdownType === "popover" && !allowFreeInput && closeDropdown();
  }, clickOutsideEvents, [dropdownElement, rootElement]);
  useWindowEvent("scroll", function () {
    return closeDropdownOnScroll && closeDropdown();
  });
  var rightSection = clearable ? /* @__PURE__ */React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: onClear,
    size: size,
    tabIndex: clearButtonTabIndex
  }) : null;
  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    if (allowFreeInput) {
      closeDropdown();
    }
  };
  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    if (allowFreeInput) {
      openDropdown();
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    typeof onKeyDown === "function" && onKeyDown(event);
    if ((event.code === "Space" || event.code === "Enter") && !allowFreeInput) {
      event.preventDefault();
      openDropdown();
    }
  };
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$3o(__spreadValues$3o({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    size: size,
    __staticSelector: __staticSelector,
    sx: sx,
    ref: setReferenceElement,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement("div", {
    ref: setRootElement
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.wrapper
  }, /* @__PURE__ */React__default.createElement(Input, __spreadValues$3o({
    classNames: __spreadProps$1C(__spreadValues$3o({}, classNames), {
      input: cx(classes.input, _defineProperty({}, classes.freeInput, allowFreeInput), classNames == null ? void 0 : classNames.input)
    }),
    styles: styles,
    onClick: function onClick() {
      return !allowFreeInput ? toggleDropdown() : openDropdown();
    },
    onKeyDown: handleKeyDown,
    id: uuid,
    ref: useMergedRef(ref, inputRef),
    __staticSelector: __staticSelector,
    size: size,
    name: name,
    placeholder: placeholder,
    value: inputLabel,
    required: required,
    invalid: !!error,
    readOnly: !allowFreeInput,
    rightSection: rightSection,
    rightSectionWidth: theme.fn.size({
      size: size,
      sizes: RIGHT_SECTION_WIDTH$1
    }),
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    onChange: onChange,
    autoComplete: "off"
  }, rest))), dropdownType === "popover" ? /* @__PURE__ */React__default.createElement(Popper$1, {
    referenceElement: referenceElement,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    forceUpdateDependencies: positionDependencies,
    transition: transition,
    mounted: dropdownOpened,
    position: dropdownPosition === "flip" ? "bottom" : dropdownPosition,
    placement: "start",
    gutter: 10,
    withinPortal: withinPortal,
    withArrow: true,
    arrowSize: 3,
    zIndex: zIndex,
    arrowClassName: classes.arrow,
    modifiers: [{
      name: "flip",
      enabled: dropdownPosition === "flip"
    }]
  }, /* @__PURE__ */React__default.createElement("div", {
    className: classes.dropdownWrapper,
    ref: setDropdownElement,
    "data-mantine-stop-propagation": dropdownOpened,
    onKeyDownCapture: closeOnEscape,
    "aria-hidden": allowFreeInput || void 0
  }, /* @__PURE__ */React__default.createElement(Paper, {
    className: classes.dropdown,
    shadow: shadow,
    ref: focusTrapRef
  }, children))) : /* @__PURE__ */React__default.createElement(Modal, {
    opened: dropdownOpened,
    onClose: closeDropdown,
    withCloseButton: false,
    size: amountOfMonths * 400,
    zIndex: modalZIndex
  }, children)));
});
DatePickerBase.displayName = "@mantine/dates/DatePickerBase";
var __defProp$3p = Object.defineProperty;
var __getOwnPropSymbols$3q = Object.getOwnPropertySymbols;
var __hasOwnProp$3q = Object.prototype.hasOwnProperty;
var __propIsEnum$3q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3p = function __defNormalProp$3p(obj, key, value) {
  return key in obj ? __defProp$3p(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3p = function __spreadValues$3p(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3q.call(b, prop)) __defNormalProp$3p(a, prop, b[prop]);
  if (__getOwnPropSymbols$3q) {
    var _iterator328 = _createForOfIteratorHelper(__getOwnPropSymbols$3q(b)),
      _step329;
    try {
      for (_iterator328.s(); !(_step329 = _iterator328.n()).done;) {
        var prop = _step329.value;
        if (__propIsEnum$3q.call(b, prop)) __defNormalProp$3p(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator328.e(err);
    } finally {
      _iterator328.f();
    }
  }
  return a;
};
var __objRest$22 = function __objRest$22(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3q) {
    var _iterator329 = _createForOfIteratorHelper(__getOwnPropSymbols$3q(source)),
      _step330;
    try {
      for (_iterator329.s(); !(_step330 = _iterator329.n()).done;) {
        var prop = _step330.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3q.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator329.e(err);
    } finally {
      _iterator329.f();
    }
  }
  return target;
};
var defaultProps$1m = {
  shadow: "sm",
  transitionDuration: 200,
  closeCalendarOnChange: true,
  labelFormat: "MMMM YYYY",
  initiallyOpened: false,
  name: "date",
  size: "sm",
  dropdownType: "popover",
  dropdownPosition: "flip",
  clearable: true,
  disabled: false,
  fixOnBlur: true,
  withinPortal: true,
  firstDayOfWeek: "monday",
  openDropdownOnClear: true
};
var DatePicker = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("DatePicker", defaultProps$1m, props),
    value = _a.value,
    onChange = _a.onChange,
    defaultValue = _a.defaultValue,
    classNames = _a.classNames,
    styles = _a.styles,
    shadow = _a.shadow,
    locale = _a.locale,
    inputFormat = _a.inputFormat,
    transitionDuration = _a.transitionDuration,
    transitionTimingFunction = _a.transitionTimingFunction,
    nextMonthLabel = _a.nextMonthLabel,
    previousMonthLabel = _a.previousMonthLabel,
    closeCalendarOnChange = _a.closeCalendarOnChange,
    labelFormat = _a.labelFormat,
    dayClassName = _a.dayClassName,
    dayStyle = _a.dayStyle,
    disableOutsideEvents = _a.disableOutsideEvents,
    minDate = _a.minDate,
    maxDate = _a.maxDate,
    excludeDate = _a.excludeDate,
    initialMonth = _a.initialMonth,
    initiallyOpened = _a.initiallyOpened,
    name = _a.name,
    size = _a.size,
    dropdownType = _a.dropdownType,
    dropdownPosition = _a.dropdownPosition,
    clearable = _a.clearable,
    disabled = _a.disabled,
    clearButtonLabel = _a.clearButtonLabel,
    fixOnBlur = _a.fixOnBlur,
    allowFreeInput = _a.allowFreeInput,
    withinPortal = _a.withinPortal,
    dateParser = _a.dateParser,
    firstDayOfWeek = _a.firstDayOfWeek,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    amountOfMonths = _a.amountOfMonths,
    allowLevelChange = _a.allowLevelChange,
    initialLevel = _a.initialLevel,
    onDropdownClose = _a.onDropdownClose,
    onDropdownOpen = _a.onDropdownOpen,
    hideOutsideDates = _a.hideOutsideDates,
    hideWeekdays = _a.hideWeekdays,
    renderDay = _a.renderDay,
    type = _a.type,
    openDropdownOnClear = _a.openDropdownOnClear,
    weekendDays = _a.weekendDays,
    others = __objRest$22(_a, ["value", "onChange", "defaultValue", "classNames", "styles", "shadow", "locale", "inputFormat", "transitionDuration", "transitionTimingFunction", "nextMonthLabel", "previousMonthLabel", "closeCalendarOnChange", "labelFormat", "dayClassName", "dayStyle", "disableOutsideEvents", "minDate", "maxDate", "excludeDate", "initialMonth", "initiallyOpened", "name", "size", "dropdownType", "dropdownPosition", "clearable", "disabled", "clearButtonLabel", "fixOnBlur", "allowFreeInput", "withinPortal", "dateParser", "firstDayOfWeek", "onFocus", "onBlur", "amountOfMonths", "allowLevelChange", "initialLevel", "onDropdownClose", "onDropdownOpen", "hideOutsideDates", "hideWeekdays", "renderDay", "type", "openDropdownOnClear", "weekendDays"]);
  var theme = useMantineTheme();
  var finalLocale = locale || theme.datesLocale;
  var dateFormat = type === "date" ? "YYYY-MM-DD" : inputFormat || theme.dateFormat;
  var _useState171 = useState(initiallyOpened),
    _useState172 = _slicedToArray(_useState171, 2),
    dropdownOpened = _useState172[0],
    setDropdownOpened = _useState172[1];
  var calendarSize = size === "lg" || size === "xl" ? "md" : "sm";
  var inputRef = useRef();
  var _useState173 = useState(defaultValue != null ? defaultValue : null),
    _useState174 = _slicedToArray(_useState173, 2),
    lastValidValue = _useState174[0],
    setLastValidValue = _useState174[1];
  var _useUncontrolled35 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: null,
      onChange: onChange,
      rule: function rule(val) {
        return val === null || val instanceof Date;
      }
    }),
    _useUncontrolled36 = _slicedToArray(_useUncontrolled35, 2),
    _value = _useUncontrolled36[0],
    setValue = _useUncontrolled36[1];
  var _useState175 = useState(_value || initialMonth || new Date()),
    _useState176 = _slicedToArray(_useState175, 2),
    calendarMonth = _useState176[0],
    setCalendarMonth = _useState176[1];
  var _useState177 = useState(false),
    _useState178 = _slicedToArray(_useState177, 2),
    focused = _useState178[0],
    setFocused = _useState178[1];
  var _useState179 = useState(_value instanceof Date ? upperFirst(dayjs_min(_value).locale(finalLocale).format(dateFormat)) : ""),
    _useState180 = _slicedToArray(_useState179, 2),
    inputState = _useState180[0],
    setInputState = _useState180[1];
  var closeDropdown = function closeDropdown() {
    setDropdownOpened(false);
    onDropdownClose == null ? void 0 : onDropdownClose();
  };
  var openDropdown = function openDropdown() {
    setDropdownOpened(true);
    onDropdownOpen == null ? void 0 : onDropdownOpen();
  };
  useEffect(function () {
    if (value === null && !focused) {
      setInputState("");
    }
    if (value instanceof Date && !focused) {
      setInputState(dayjs_min(value).locale(finalLocale).format(dateFormat));
    }
  }, [value, focused]);
  var handleValueChange = function handleValueChange(date) {
    setValue(date);
    setInputState(upperFirst(dayjs_min(date).locale(finalLocale).format(dateFormat)));
    closeCalendarOnChange && closeDropdown();
    window.setTimeout(function () {
      var _a2;
      return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
    }, 0);
  };
  var handleClear = function handleClear() {
    var _a2;
    setValue(null);
    setLastValidValue(null);
    setInputState("");
    openDropdownOnClear && openDropdown();
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  var parseDate = function parseDate(date) {
    return dateParser ? dateParser(date) : dayjs_min(date, dateFormat, finalLocale).toDate();
  };
  var setDateFromInput = function setDateFromInput() {
    var date = typeof _value === "string" ? parseDate(_value) : _value;
    if (maxDate && dayjs_min(date).isAfter(maxDate)) {
      date = maxDate;
    }
    if (minDate && dayjs_min(date).isBefore(minDate)) {
      date = minDate;
    }
    if (dayjs_min(date).isValid()) {
      setValue(date);
      setLastValidValue(date);
      setInputState(upperFirst(dayjs_min(date).locale(finalLocale).format(dateFormat)));
      setCalendarMonth(date);
    } else if (fixOnBlur) {
      setValue(lastValidValue);
    }
  };
  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    setFocused(false);
    if (allowFreeInput) {
      setDateFromInput();
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.code === "Enter" && allowFreeInput) {
      closeDropdown();
      setDateFromInput();
    }
  };
  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    setFocused(true);
  };
  var handleChange = function handleChange(event) {
    openDropdown();
    var date = parseDate(event.target.value);
    if (dayjs_min(date).isValid()) {
      setValue(date);
      setLastValidValue(date);
      setInputState(event.target.value);
      setCalendarMonth(date);
    } else {
      setInputState(event.target.value);
    }
  };
  return /* @__PURE__ */React__default.createElement(DatePickerBase, __spreadValues$3p({
    allowFreeInput: allowFreeInput,
    dropdownOpened: dropdownOpened,
    setDropdownOpened: setDropdownOpened,
    shadow: shadow,
    transitionDuration: transitionDuration,
    ref: useMergedRef(ref, inputRef),
    size: size,
    styles: styles,
    classNames: classNames,
    onChange: handleChange,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    onKeyDown: handleKeyDown,
    name: name,
    inputLabel: inputState,
    __staticSelector: "DatePicker",
    dropdownType: dropdownType,
    dropdownPosition: dropdownPosition,
    clearable: type === "date" ? false : clearable && !!_value && !disabled,
    clearButtonLabel: clearButtonLabel,
    onClear: handleClear,
    disabled: disabled,
    withinPortal: withinPortal,
    amountOfMonths: amountOfMonths,
    onDropdownClose: onDropdownClose,
    onDropdownOpen: onDropdownOpen,
    type: type
  }, others), /* @__PURE__ */React__default.createElement(Calendar, {
    classNames: classNames,
    styles: styles,
    locale: finalLocale,
    nextMonthLabel: nextMonthLabel,
    previousMonthLabel: previousMonthLabel,
    month: allowFreeInput ? calendarMonth : void 0,
    initialMonth: initialMonth || (_value instanceof Date ? _value : new Date()),
    onMonthChange: setCalendarMonth,
    value: _value instanceof Date ? _value : dayjs_min(_value).toDate(),
    onChange: handleValueChange,
    labelFormat: labelFormat,
    dayClassName: dayClassName,
    dayStyle: dayStyle,
    disableOutsideEvents: disableOutsideEvents,
    minDate: minDate,
    maxDate: maxDate,
    excludeDate: excludeDate,
    __staticSelector: "DatePicker",
    fullWidth: dropdownType === "modal",
    size: dropdownType === "modal" ? "lg" : calendarSize,
    firstDayOfWeek: firstDayOfWeek,
    preventFocus: allowFreeInput,
    amountOfMonths: amountOfMonths,
    allowLevelChange: allowLevelChange,
    initialLevel: initialLevel,
    hideOutsideDates: hideOutsideDates,
    hideWeekdays: hideWeekdays,
    renderDay: renderDay,
    weekendDays: weekendDays
  }));
});
DatePicker.displayName = "@mantine/dates/DatePicker";
var __defProp$3q = Object.defineProperty;
var __getOwnPropSymbols$3r = Object.getOwnPropertySymbols;
var __hasOwnProp$3r = Object.prototype.hasOwnProperty;
var __propIsEnum$3r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3q = function __defNormalProp$3q(obj, key, value) {
  return key in obj ? __defProp$3q(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3q = function __spreadValues$3q(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3r.call(b, prop)) __defNormalProp$3q(a, prop, b[prop]);
  if (__getOwnPropSymbols$3r) {
    var _iterator330 = _createForOfIteratorHelper(__getOwnPropSymbols$3r(b)),
      _step331;
    try {
      for (_iterator330.s(); !(_step331 = _iterator330.n()).done;) {
        var prop = _step331.value;
        if (__propIsEnum$3r.call(b, prop)) __defNormalProp$3q(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator330.e(err);
    } finally {
      _iterator330.f();
    }
  }
  return a;
};
var __objRest$23 = function __objRest$23(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3r.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3r) {
    var _iterator331 = _createForOfIteratorHelper(__getOwnPropSymbols$3r(source)),
      _step332;
    try {
      for (_iterator331.s(); !(_step332 = _iterator331.n()).done;) {
        var prop = _step332.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3r.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator331.e(err);
    } finally {
      _iterator331.f();
    }
  }
  return target;
};
var defaultProps$1n = {
  __staticSelector: "RangeCalendar",
  allowSingleDateInRange: false,
  amountOfMonths: 1
};
var RangeCalendar = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("RangeCalendar", defaultProps$1n, props),
    value = _a.value,
    onChange = _a.onChange,
    dayStyle = _a.dayStyle,
    onMouseLeave = _a.onMouseLeave,
    __staticSelector = _a.__staticSelector,
    allowSingleDateInRange = _a.allowSingleDateInRange,
    amountOfMonths = _a.amountOfMonths,
    others = __objRest$23(_a, ["value", "onChange", "dayStyle", "onMouseLeave", "__staticSelector", "allowSingleDateInRange", "amountOfMonths"]);
  var _useState181 = useState(null),
    _useState182 = _slicedToArray(_useState181, 2),
    hoveredDay = _useState182[0],
    setHoveredDay = _useState182[1];
  var _useState183 = useState(null),
    _useState184 = _slicedToArray(_useState183, 2),
    pickedDate = _useState184[0],
    setPickedDate = _useState184[1];
  var setRangeDate = function setRangeDate(date) {
    if (pickedDate instanceof Date) {
      if (isSameDate(date, pickedDate) && !allowSingleDateInRange) {
        setPickedDate(null);
        setHoveredDay(null);
        return null;
      }
      var result = [date, pickedDate];
      result.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
      onChange(result);
      setPickedDate(null);
      return null;
    }
    if (value[0] && isSameDate(date, value[0]) && !allowSingleDateInRange) {
      setPickedDate(null);
      setHoveredDay(null);
      onChange([null, null]);
      return null;
    }
    onChange([date, null]);
    setPickedDate(date);
    return null;
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    typeof onMouseLeave === "function" && onMouseLeave(event);
    setHoveredDay(null);
  };
  var shouldHighlightDate = function shouldHighlightDate(date, modifiers) {
    if (pickedDate instanceof Date && hoveredDay instanceof Date) {
      var result = [hoveredDay, pickedDate];
      result.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
      return !modifiers.selected && dayjs_min(date).subtract(1, "day").isBefore(result[1]) && dayjs_min(date).add(1, "day").isAfter(result[0]);
    }
    return false;
  };
  var isPickedDateFirstInRange = function isPickedDateFirstInRange(date, modifiers) {
    if (pickedDate instanceof Date && hoveredDay instanceof Date) {
      var result = [hoveredDay, pickedDate];
      result.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
      return modifiers.selected && dayjs_min(date).isBefore(result[1]);
    }
    return false;
  };
  var isPickedDateLastInRange = function isPickedDateLastInRange(date, modifiers) {
    if (pickedDate instanceof Date && hoveredDay instanceof Date) {
      var result = [hoveredDay, pickedDate];
      result.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
      return modifiers.selected && dayjs_min(date).isAfter(result[0]);
    }
    return false;
  };
  return /* @__PURE__ */React__default.createElement(CalendarBase, __spreadValues$3q({
    dayStyle: dayStyle,
    onMouseLeave: handleMouseLeave,
    onDayMouseEnter: function onDayMouseEnter(date) {
      return setHoveredDay(date);
    },
    onChange: setRangeDate,
    value: pickedDate,
    range: value,
    ref: ref,
    __staticSelector: __staticSelector,
    amountOfMonths: amountOfMonths,
    hideOutsideDates: amountOfMonths > 1,
    isDateInRange: shouldHighlightDate,
    isDateFirstInRange: isPickedDateFirstInRange,
    isDateLastInRange: isPickedDateLastInRange
  }, others));
});
RangeCalendar.displayName = "@mantine/dates/RangeCalendar";
var __defProp$3r = Object.defineProperty;
var __getOwnPropSymbols$3s = Object.getOwnPropertySymbols;
var __hasOwnProp$3s = Object.prototype.hasOwnProperty;
var __propIsEnum$3s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3r = function __defNormalProp$3r(obj, key, value) {
  return key in obj ? __defProp$3r(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3r = function __spreadValues$3r(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3s.call(b, prop)) __defNormalProp$3r(a, prop, b[prop]);
  if (__getOwnPropSymbols$3s) {
    var _iterator332 = _createForOfIteratorHelper(__getOwnPropSymbols$3s(b)),
      _step333;
    try {
      for (_iterator332.s(); !(_step333 = _iterator332.n()).done;) {
        var prop = _step333.value;
        if (__propIsEnum$3s.call(b, prop)) __defNormalProp$3r(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator332.e(err);
    } finally {
      _iterator332.f();
    }
  }
  return a;
};
var __objRest$24 = function __objRest$24(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3s.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3s) {
    var _iterator333 = _createForOfIteratorHelper(__getOwnPropSymbols$3s(source)),
      _step334;
    try {
      for (_iterator333.s(); !(_step334 = _iterator333.n()).done;) {
        var prop = _step334.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3s.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator333.e(err);
    } finally {
      _iterator333.f();
    }
  }
  return target;
};
var validationRule = function validationRule(val) {
  return Array.isArray(val) && val.length === 2 && val.every(function (v) {
    return v instanceof Date;
  });
};
var isFirstDateSet = function isFirstDateSet(val) {
  return Array.isArray(val) && val.length === 2 && val[0] instanceof Date;
};
var defaultProps$1o = {
  shadow: "sm",
  transitionDuration: 200,
  closeCalendarOnChange: true,
  labelFormat: "MMMM YYYY",
  initiallyOpened: false,
  size: "sm",
  dropdownType: "popover",
  labelSeparator: "\u2013",
  clearable: true,
  firstDayOfWeek: "monday",
  allowSingleDateInRange: false,
  amountOfMonths: 1,
  withinPortal: true,
  openDropdownOnClear: true
};
var DateRangePicker = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("DateRangePicker", defaultProps$1o, props),
    value = _a.value,
    onChange = _a.onChange,
    defaultValue = _a.defaultValue,
    classNames = _a.classNames,
    styles = _a.styles,
    shadow = _a.shadow,
    locale = _a.locale,
    inputFormat = _a.inputFormat,
    transitionDuration = _a.transitionDuration,
    transitionTimingFunction = _a.transitionTimingFunction,
    nextMonthLabel = _a.nextMonthLabel,
    previousMonthLabel = _a.previousMonthLabel,
    closeCalendarOnChange = _a.closeCalendarOnChange,
    labelFormat = _a.labelFormat,
    dayClassName = _a.dayClassName,
    dayStyle = _a.dayStyle,
    disableOutsideEvents = _a.disableOutsideEvents,
    minDate = _a.minDate,
    maxDate = _a.maxDate,
    excludeDate = _a.excludeDate,
    initialMonth = _a.initialMonth,
    initiallyOpened = _a.initiallyOpened,
    size = _a.size,
    dropdownType = _a.dropdownType,
    labelSeparator = _a.labelSeparator,
    clearable = _a.clearable,
    clearButtonLabel = _a.clearButtonLabel,
    firstDayOfWeek = _a.firstDayOfWeek,
    allowLevelChange = _a.allowLevelChange,
    allowSingleDateInRange = _a.allowSingleDateInRange,
    amountOfMonths = _a.amountOfMonths,
    withinPortal = _a.withinPortal,
    initialLevel = _a.initialLevel,
    onDropdownClose = _a.onDropdownClose,
    onDropdownOpen = _a.onDropdownOpen,
    hideOutsideDates = _a.hideOutsideDates,
    hideWeekdays = _a.hideWeekdays,
    renderDay = _a.renderDay,
    openDropdownOnClear = _a.openDropdownOnClear,
    weekendDays = _a.weekendDays,
    others = __objRest$24(_a, ["value", "onChange", "defaultValue", "classNames", "styles", "shadow", "locale", "inputFormat", "transitionDuration", "transitionTimingFunction", "nextMonthLabel", "previousMonthLabel", "closeCalendarOnChange", "labelFormat", "dayClassName", "dayStyle", "disableOutsideEvents", "minDate", "maxDate", "excludeDate", "initialMonth", "initiallyOpened", "size", "dropdownType", "labelSeparator", "clearable", "clearButtonLabel", "firstDayOfWeek", "allowLevelChange", "allowSingleDateInRange", "amountOfMonths", "withinPortal", "initialLevel", "onDropdownClose", "onDropdownOpen", "hideOutsideDates", "hideWeekdays", "renderDay", "openDropdownOnClear", "weekendDays"]);
  var theme = useMantineTheme();
  var finalLocale = locale || theme.datesLocale;
  var dateFormat = inputFormat || theme.dateFormat;
  var _useState185 = useState(initiallyOpened),
    _useState186 = _slicedToArray(_useState185, 2),
    dropdownOpened = _useState186[0],
    setDropdownOpened = _useState186[1];
  var calendarSize = size === "lg" || size === "xl" ? "md" : "sm";
  var inputRef = useRef();
  var _useUncontrolled37 = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: [null, null],
      onChange: onChange,
      rule: isFirstDateSet
    }),
    _useUncontrolled38 = _slicedToArray(_useUncontrolled37, 2),
    _value = _useUncontrolled38[0],
    setValue = _useUncontrolled38[1];
  var handleValueChange = function handleValueChange(range$$1) {
    setValue(range$$1);
    if (closeCalendarOnChange && validationRule(range$$1)) {
      setDropdownOpened(false);
      onDropdownClose == null ? void 0 : onDropdownClose();
      window.setTimeout(function () {
        var _a2;
        return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
      }, 0);
    }
  };
  var valueValid = validationRule(_value);
  var firstValueValid = isFirstDateSet(_value);
  var firstDateLabel = _value[0] ? upperFirst(dayjs_min(_value[0]).locale(finalLocale).format(dateFormat)) : "";
  var secondDateLabel = _value[1] ? upperFirst(dayjs_min(_value[1]).locale(finalLocale).format(dateFormat)) : "";
  var handleClear = function handleClear() {
    var _a2;
    setValue([null, null]);
    setDropdownOpened(true);
    openDropdownOnClear && (onDropdownOpen == null ? void 0 : onDropdownOpen());
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  var handleDropdownToggle = function handleDropdownToggle(isOpened) {
    if (!isOpened && firstValueValid && _value[1] === null) {
      handleClear();
    }
    setDropdownOpened(isOpened);
  };
  return /* @__PURE__ */React__default.createElement(DatePickerBase, __spreadValues$3r({
    dropdownOpened: dropdownOpened,
    setDropdownOpened: handleDropdownToggle,
    shadow: shadow,
    transitionDuration: transitionDuration,
    ref: useMergedRef(ref, inputRef),
    size: size,
    styles: styles,
    classNames: classNames,
    inputLabel: firstValueValid ? "".concat(firstDateLabel, " ").concat(labelSeparator, " ").concat(secondDateLabel) : "",
    __staticSelector: "DateRangePicker",
    dropdownType: dropdownType,
    clearable: clearable && firstValueValid,
    clearButtonLabel: clearButtonLabel,
    onClear: handleClear,
    withinPortal: withinPortal,
    amountOfMonths: amountOfMonths,
    onDropdownClose: onDropdownClose,
    onDropdownOpen: onDropdownOpen
  }, others), /* @__PURE__ */React__default.createElement(RangeCalendar, {
    classNames: classNames,
    styles: styles,
    locale: finalLocale,
    nextMonthLabel: nextMonthLabel,
    previousMonthLabel: previousMonthLabel,
    initialMonth: valueValid ? _value[0] : initialMonth,
    value: _value,
    onChange: handleValueChange,
    labelFormat: labelFormat,
    dayClassName: dayClassName,
    dayStyle: dayStyle,
    disableOutsideEvents: disableOutsideEvents,
    minDate: minDate,
    maxDate: maxDate,
    excludeDate: excludeDate,
    __staticSelector: "DateRangePicker",
    fullWidth: dropdownType === "modal",
    firstDayOfWeek: firstDayOfWeek,
    size: dropdownType === "modal" ? "lg" : calendarSize,
    allowLevelChange: allowLevelChange,
    allowSingleDateInRange: allowSingleDateInRange,
    amountOfMonths: amountOfMonths,
    initialLevel: initialLevel,
    hideOutsideDates: hideOutsideDates,
    hideWeekdays: hideWeekdays,
    renderDay: renderDay,
    weekendDays: weekendDays
  }));
});
DateRangePicker.displayName = "@mantine/dates/DateRangePicker";
function padTime(value) {
  var _val = parseInt(value, 10);
  return _val >= 10 ? _val.toString() : "0".concat(_val);
}
var __defProp$3s = Object.defineProperty;
var __defProps$1D = Object.defineProperties;
var __getOwnPropDescs$1D = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3t = Object.getOwnPropertySymbols;
var __hasOwnProp$3t = Object.prototype.hasOwnProperty;
var __propIsEnum$3t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3s = function __defNormalProp$3s(obj, key, value) {
  return key in obj ? __defProp$3s(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3s = function __spreadValues$3s(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3t.call(b, prop)) __defNormalProp$3s(a, prop, b[prop]);
  if (__getOwnPropSymbols$3t) {
    var _iterator334 = _createForOfIteratorHelper(__getOwnPropSymbols$3t(b)),
      _step335;
    try {
      for (_iterator334.s(); !(_step335 = _iterator334.n()).done;) {
        var prop = _step335.value;
        if (__propIsEnum$3t.call(b, prop)) __defNormalProp$3s(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator334.e(err);
    } finally {
      _iterator334.f();
    }
  }
  return a;
};
var __spreadProps$1D = function __spreadProps$1D(a, b) {
  return __defProps$1D(a, __getOwnPropDescs$1D(b));
};
var inputSizes = {
  xs: 20,
  sm: 23,
  md: 25,
  lg: 27,
  xl: 29
};
var useStyles$1A = createStyles(function (theme, _ref183) {
  var size = _ref183.size,
    hasValue = _ref183.hasValue;
  return {
    timeInput: __spreadProps$1D(__spreadValues$3s({}, theme.fn.fontStyles()), {
      width: theme.fn.size({
        size: size,
        sizes: inputSizes
      }),
      appearance: "none",
      backgroundColor: "transparent",
      color: "inherit",
      padding: 0,
      textAlign: "center",
      border: "1px solid transparent",
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      lineHeight: 1,
      outline: 0,
      "&:focus": {
        textAlign: hasValue ? void 0 : "start"
      },
      "&::placeholder": {
        width: "auto",
        textAlign: "left"
      },
      "&[disabled]": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
        cursor: "not-allowed"
      }
    }),
    amPmInput: {
      width: "auto",
      textAlign: "left"
    }
  };
});
var __defProp$3t = Object.defineProperty;
var __getOwnPropSymbols$3u = Object.getOwnPropertySymbols;
var __hasOwnProp$3u = Object.prototype.hasOwnProperty;
var __propIsEnum$3u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3t = function __defNormalProp$3t(obj, key, value) {
  return key in obj ? __defProp$3t(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3t = function __spreadValues$3t(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3u.call(b, prop)) __defNormalProp$3t(a, prop, b[prop]);
  if (__getOwnPropSymbols$3u) {
    var _iterator335 = _createForOfIteratorHelper(__getOwnPropSymbols$3u(b)),
      _step336;
    try {
      for (_iterator335.s(); !(_step336 = _iterator335.n()).done;) {
        var prop = _step336.value;
        if (__propIsEnum$3u.call(b, prop)) __defNormalProp$3t(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator335.e(err);
    } finally {
      _iterator335.f();
    }
  }
  return a;
};
var __objRest$25 = function __objRest$25(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3u.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3u) {
    var _iterator336 = _createForOfIteratorHelper(__getOwnPropSymbols$3u(source)),
      _step337;
    try {
      for (_iterator336.s(); !(_step337 = _iterator336.n()).done;) {
        var prop = _step337.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3u.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator336.e(err);
    } finally {
      _iterator336.f();
    }
  }
  return target;
};
var TimeField = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    onFocus = _b.onFocus,
    onBlur = _b.onBlur,
    onChange = _b.onChange,
    setValue = _b.setValue,
    _b$withSeparator = _b.withSeparator,
    withSeparator = _b$withSeparator === void 0 ? false : _b$withSeparator,
    _b$size6 = _b.size,
    size = _b$size6 === void 0 ? "sm" : _b$size6,
    max = _b.max,
    _b$min = _b.min,
    min = _b$min === void 0 ? 0 : _b$min,
    value = _b.value,
    others = __objRest$25(_b, ["className", "onFocus", "onBlur", "onChange", "setValue", "withSeparator", "size", "max", "min", "value"]);
  var _useState187 = useState(0),
    _useState188 = _slicedToArray(_useState187, 2),
    digitsEntered = _useState188[0],
    setDigitsEntered = _useState188[1];
  var _useStyles$1A = useStyles$1A({
      size: size,
      hasValue: !!value
    }),
    classes = _useStyles$1A.classes,
    cx = _useStyles$1A.cx,
    theme = _useStyles$1A.theme;
  var inputRef = useRef();
  var handleFocus = function handleFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    inputRef.current.select();
    setDigitsEntered(0);
  };
  var handleBlur = function handleBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    if (digitsEntered === 1) {
      typeof onChange === "function" && onChange(event.currentTarget.value, false);
    }
  };
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    inputRef.current.select();
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.nativeEvent.code === "ArrowUp") {
      event.preventDefault();
      var padded = padTime(clamp({
        value: parseInt(event.currentTarget.value, 10) + 1,
        max: max,
        min: min
      }).toString());
      if (value !== padded) {
        onChange(padded, false);
      }
    }
    if (event.nativeEvent.code === "ArrowDown") {
      event.preventDefault();
      var _padded = padTime(clamp({
        value: parseInt(event.currentTarget.value, 10) - 1,
        max: max,
        min: min
      }).toString());
      if (value !== _padded) {
        onChange(_padded, false);
      }
    }
  };
  var handleChange = function handleChange(event) {
    setDigitsEntered(digitsEntered + 1);
    var _val = parseInt(event.currentTarget.value, 10).toString();
    if (_val === "0" && digitsEntered === 0) {
      setValue("00");
      return;
    }
    onChange(_val, true, digitsEntered > 0);
  };
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement("input", __spreadValues$3t({
    type: "text",
    inputMode: "numeric",
    ref: useMergedRef(inputRef, ref),
    onChange: handleChange,
    onClick: handleClick,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    value: value,
    className: cx(classes.timeInput, className)
  }, others)), withSeparator && /* @__PURE__ */React__default.createElement(Text, {
    size: size,
    style: {
      lineHeight: 1,
      color: value ? "inherit" : theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
    }
  }, ":"));
});
TimeField.displayName = "@mantine/dates/TimeField";
function allButLastDigit(value) {
  return Math.floor(value / 10);
}
function createTimeHandler(_ref184) {
  var onChange = _ref184.onChange,
    nextRef = _ref184.nextRef,
    min = _ref184.min,
    max = _ref184.max,
    nextMax = _ref184.nextMax;
  return function (value, triggerShift) {
    var forceTriggerShift = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _a, _b;
    var parsed = parseInt(value, 10);
    if (Number.isNaN(parsed)) {
      return;
    }
    if (parsed > allButLastDigit(max) || forceTriggerShift) {
      var lastDigit = parsed % 10;
      var updatedValue;
      var carryOver;
      if (parsed > max && nextMax && lastDigit <= allButLastDigit(nextMax)) {
        updatedValue = padTime(allButLastDigit(parsed).toString());
        carryOver = padTime(lastDigit.toString());
      } else {
        updatedValue = padTime(clamp({
          value: parsed,
          min: min,
          max: max
        }).toString());
      }
      onChange(updatedValue, carryOver);
      triggerShift && ((_a = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _a.focus());
      triggerShift && ((_b = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _b.select());
      return;
    }
    onChange(parsed.toString());
  };
}
var useStyles$1B = createStyles(function (theme, _ref185) {
  var size = _ref185.size;
  return {
    timeInput: {},
    amPmInput: {},
    disabled: {
      opacity: 0.6,
      cursor: "not-allowed"
    },
    controls: {
      display: "flex",
      alignItems: "center",
      height: theme.fn.size({
        size: size,
        sizes: sizes$2
      }) - 2
    }
  };
});
var __defProp$3u = Object.defineProperty;
var __getOwnPropSymbols$3v = Object.getOwnPropertySymbols;
var __hasOwnProp$3v = Object.prototype.hasOwnProperty;
var __propIsEnum$3v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3u = function __defNormalProp$3u(obj, key, value) {
  return key in obj ? __defProp$3u(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3u = function __spreadValues$3u(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3v.call(b, prop)) __defNormalProp$3u(a, prop, b[prop]);
  if (__getOwnPropSymbols$3v) {
    var _iterator337 = _createForOfIteratorHelper(__getOwnPropSymbols$3v(b)),
      _step338;
    try {
      for (_iterator337.s(); !(_step338 = _iterator337.n()).done;) {
        var prop = _step338.value;
        if (__propIsEnum$3v.call(b, prop)) __defNormalProp$3u(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator337.e(err);
    } finally {
      _iterator337.f();
    }
  }
  return a;
};
var __objRest$26 = function __objRest$26(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3v.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3v) {
    var _iterator338 = _createForOfIteratorHelper(__getOwnPropSymbols$3v(source)),
      _step339;
    try {
      for (_iterator338.s(); !(_step339 = _iterator338.n()).done;) {
        var prop = _step339.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3v.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator338.e(err);
    } finally {
      _iterator338.f();
    }
  }
  return target;
};
var AmPmInput = forwardRef(function (_a, ref) {
  var _b = _a,
    className = _b.className,
    onChange = _b.onChange,
    onFocus = _b.onFocus,
    _b$size7 = _b.size,
    size = _b$size7 === void 0 ? "sm" : _b$size7,
    amLabel = _b.amLabel,
    pmLabel = _b.pmLabel,
    value = _b.value,
    others = __objRest$26(_b, ["className", "onChange", "onFocus", "size", "amLabel", "pmLabel", "value"]);
  var _useStyles$1A2 = useStyles$1A({
      size: size,
      hasValue: !!value
    }),
    classes = _useStyles$1A2.classes,
    cx = _useStyles$1A2.cx;
  var inputRef = useRef();
  var handleFocus = function handleFocus(event) {
    typeof onFocus === "function" && onFocus(event);
    inputRef.current.select();
  };
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    inputRef.current.select();
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.nativeEvent.code === "ArrowUp" || event.nativeEvent.code === "ArrowDown") {
      event.preventDefault();
      onChange(value === amLabel ? pmLabel : amLabel, true);
    }
  };
  var handleChange = function handleChange(event) {
    var lastInputVal = event.target.value.slice(-1).toLowerCase();
    if (lastInputVal === "p") {
      event.preventDefault();
      onChange(pmLabel, true);
      return;
    }
    if (lastInputVal === "a") {
      event.preventDefault();
      onChange(amLabel, true);
      return;
    }
    onChange(value.toString(), true);
  };
  return /* @__PURE__ */React__default.createElement("input", __spreadValues$3u({
    type: "text",
    ref: useMergedRef(inputRef, ref),
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onChange: handleChange,
    value: value,
    className: cx(classes.timeInput, classes.amPmInput)
  }, others));
});
AmPmInput.displayName = "@mantine/dates/AmPmInput";
function createAmPmHandler(_ref186) {
  var amLabel = _ref186.amLabel,
    pmLabel = _ref186.pmLabel,
    onChange = _ref186.onChange,
    nextRef = _ref186.nextRef;
  return function (value, triggerShift) {
    var _a, _b;
    var testRegex = new RegExp("(^(".concat(amLabel, "|").concat(pmLabel, ")?$)"));
    var valLower = value.toLowerCase();
    if (valLower === amLabel || valLower === pmLabel) {
      onChange(valLower);
      triggerShift && ((_a = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _a.focus());
      triggerShift && ((_b = nextRef == null ? void 0 : nextRef.current) == null ? void 0 : _b.select());
      return;
    }
    if (!testRegex.test(valLower)) {
      return;
    }
    onChange(valLower);
  };
}
function getDate(hours, minutes, seconds, format, pmLabel, amPm) {
  var date = dayjs_min();
  var _hours = parseInt(hours, 10);
  var _minutes = parseInt(minutes, 10);
  var _seconds = parseInt(seconds, 10);
  if (Number.isNaN(_hours)) {
    _hours = 0;
  }
  if (format === "12") {
    _hours %= 12;
    if (amPm === pmLabel) {
      _hours += 12;
    }
  }
  return date.hour(_hours).minute(Number.isNaN(_minutes) ? 0 : _minutes).second(Number.isNaN(_seconds) ? 0 : _seconds).millisecond(0).toDate();
}
function getTimeValues(value, format, amLabel, pmLabel) {
  if (!(value instanceof Date)) {
    return {
      hours: "",
      minutes: "",
      seconds: "",
      amPm: ""
    };
  }
  var _hours = value.getHours();
  var isPm = _hours >= 12;
  if (format === "12") {
    _hours %= 12;
    if (_hours === 0) {
      _hours += 12;
    }
  }
  return {
    hours: padTime(_hours.toString()),
    minutes: padTime(value.getMinutes().toString()),
    seconds: padTime(value.getSeconds().toString()),
    amPm: isPm ? pmLabel : amLabel
  };
}
var __defProp$3v = Object.defineProperty;
var __defProps$1E = Object.defineProperties;
var __getOwnPropDescs$1E = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3w = Object.getOwnPropertySymbols;
var __hasOwnProp$3w = Object.prototype.hasOwnProperty;
var __propIsEnum$3w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3v = function __defNormalProp$3v(obj, key, value) {
  return key in obj ? __defProp$3v(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3v = function __spreadValues$3v(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3w.call(b, prop)) __defNormalProp$3v(a, prop, b[prop]);
  if (__getOwnPropSymbols$3w) {
    var _iterator339 = _createForOfIteratorHelper(__getOwnPropSymbols$3w(b)),
      _step340;
    try {
      for (_iterator339.s(); !(_step340 = _iterator339.n()).done;) {
        var prop = _step340.value;
        if (__propIsEnum$3w.call(b, prop)) __defNormalProp$3v(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator339.e(err);
    } finally {
      _iterator339.f();
    }
  }
  return a;
};
var __spreadProps$1E = function __spreadProps$1E(a, b) {
  return __defProps$1E(a, __getOwnPropDescs$1E(b));
};
var __objRest$27 = function __objRest$27(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3w.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3w) {
    var _iterator340 = _createForOfIteratorHelper(__getOwnPropSymbols$3w(source)),
      _step341;
    try {
      for (_iterator340.s(); !(_step341 = _iterator340.n()).done;) {
        var prop = _step341.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3w.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator340.e(err);
    } finally {
      _iterator340.f();
    }
  }
  return target;
};
var RIGHT_SECTION_WIDTH$2 = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 40,
  xl: 44
};
var defaultProps$1p = {
  size: "sm",
  withSeconds: false,
  clearable: false,
  format: "24",
  amLabel: "am",
  pmLabel: "pm",
  timePlaceholder: "--",
  amPmPlaceholder: "am",
  disabled: false
};
var TimeInput = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("TimeInput", defaultProps$1p, props),
    required = _a.required,
    label = _a.label,
    error = _a.error,
    description = _a.description,
    className = _a.className,
    style = _a.style,
    size = _a.size,
    wrapperProps = _a.wrapperProps,
    classNames = _a.classNames,
    styles = _a.styles,
    id = _a.id,
    value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    withSeconds = _a.withSeconds,
    clearable = _a.clearable,
    clearButtonLabel = _a.clearButtonLabel,
    format = _a.format,
    amLabel = _a.amLabel,
    pmLabel = _a.pmLabel,
    name = _a.name,
    hoursLabel = _a.hoursLabel,
    minutesLabel = _a.minutesLabel,
    secondsLabel = _a.secondsLabel,
    amPmLabel = _a.amPmLabel,
    timePlaceholder = _a.timePlaceholder,
    amPmPlaceholder = _a.amPmPlaceholder,
    disabled = _a.disabled,
    sx = _a.sx,
    nextRef = _a.nextRef,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    errorProps = _a.errorProps,
    others = __objRest$27(_a, ["required", "label", "error", "description", "className", "style", "size", "wrapperProps", "classNames", "styles", "id", "value", "defaultValue", "onChange", "withSeconds", "clearable", "clearButtonLabel", "format", "amLabel", "pmLabel", "name", "hoursLabel", "minutesLabel", "secondsLabel", "amPmLabel", "timePlaceholder", "amPmPlaceholder", "disabled", "sx", "nextRef", "labelProps", "descriptionProps", "errorProps"]);
  var _useStyles$1B = useStyles$1B({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "TimeInput"
    }),
    classes = _useStyles$1B.classes,
    cx = _useStyles$1B.cx,
    theme = _useStyles$1B.theme;
  var _extractSystemStyles17 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles17.systemStyles,
    rest = _extractSystemStyles17.rest;
  var uuid = useUuid(id);
  var hoursRef = useRef();
  var minutesRef = useRef();
  var secondsRef = useRef();
  var amPmRef = useRef();
  var _useState189 = useState(getTimeValues(value || defaultValue, format, amLabel, pmLabel)),
    _useState190 = _slicedToArray(_useState189, 2),
    time = _useState190[0],
    setTime = _useState190[1];
  var _useState191 = useState(value || defaultValue),
    _useState192 = _slicedToArray(_useState191, 2),
    _value = _useState192[0],
    setValue = _useState192[1];
  useDidUpdate(function () {
    setTime(getTimeValues(_value, format, amLabel, pmLabel));
  }, [_value, format, amLabel, pmLabel]);
  useDidUpdate(function () {
    if ((value == null ? void 0 : value.getTime()) !== (_value == null ? void 0 : _value.getTime())) {
      setValue(value);
    }
  }, [value]);
  var setDate = function setDate(change) {
    var timeWithChange = __spreadValues$3v(__spreadValues$3v({}, time), change);
    var newDate = getDate(timeWithChange.hours, timeWithChange.minutes, timeWithChange.seconds, format, pmLabel, timeWithChange.amPm);
    setValue(newDate);
    typeof onChange === "function" && onChange(newDate);
  };
  var handleHoursChange = createTimeHandler({
    onChange: function onChange(val, carryOver) {
      setDate({
        hours: val,
        minutes: carryOver != null ? carryOver : time.minutes
      });
    },
    min: format === "12" ? 1 : 0,
    max: format === "12" ? 12 : 23,
    nextRef: minutesRef,
    nextMax: 59
  });
  var handleMinutesChange = createTimeHandler({
    onChange: function onChange(val, carryOver) {
      setDate({
        minutes: val,
        seconds: carryOver != null ? carryOver : time.seconds
      });
    },
    min: 0,
    max: 59,
    nextRef: withSeconds ? secondsRef : format === "12" ? amPmRef : nextRef,
    nextMax: withSeconds ? 59 : void 0
  });
  var handleSecondsChange = createTimeHandler({
    onChange: function onChange(val) {
      setDate({
        seconds: val
      });
    },
    min: 0,
    max: 59,
    nextRef: format === "12" ? amPmRef : nextRef
  });
  var handleAmPmChange = createAmPmHandler({
    amLabel: amLabel,
    pmLabel: pmLabel,
    onChange: function onChange(val) {
      setDate({
        amPm: val
      });
    },
    nextRef: nextRef
  });
  var handleClear = function handleClear() {
    setTime({
      hours: "",
      minutes: "",
      seconds: "",
      amPm: ""
    });
    setValue(null);
    onChange == null ? void 0 : onChange(null);
    hoursRef.current.focus();
  };
  var rightSection = clearable && _value ? /* @__PURE__ */React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: handleClear,
    size: size
  }) : null;
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$3v(__spreadValues$3v({
    required: required,
    label: label,
    error: error,
    description: description,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    size: size,
    __staticSelector: "TimeInput",
    id: uuid,
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement(Input, __spreadValues$3v({
    component: "div",
    __staticSelector: "TimeInput",
    required: required,
    invalid: !!error,
    onClick: function onClick() {
      return hoursRef.current.focus();
    },
    size: size,
    className: cx(_defineProperty({}, classes.disabled, disabled)),
    classNames: classNames,
    styles: styles,
    disabled: disabled,
    rightSection: rightSection,
    rightSectionWidth: theme.fn.size({
      size: size,
      sizes: RIGHT_SECTION_WIDTH$2
    })
  }, rest), /* @__PURE__ */React__default.createElement("div", {
    className: classes.controls
  }, /* @__PURE__ */React__default.createElement(TimeField, {
    ref: useMergedRef(hoursRef, ref),
    value: time.hours,
    onChange: handleHoursChange,
    setValue: function setValue(val) {
      return setTime(function (current) {
        return __spreadProps$1E(__spreadValues$3v({}, current), {
          hours: val
        });
      });
    },
    id: uuid,
    className: classes.timeInput,
    withSeparator: true,
    size: size,
    max: format === "12" ? 12 : 23,
    placeholder: timePlaceholder,
    "aria-label": hoursLabel,
    disabled: disabled,
    name: name
  }), /* @__PURE__ */React__default.createElement(TimeField, {
    ref: minutesRef,
    value: time.minutes,
    onChange: handleMinutesChange,
    setValue: function setValue(val) {
      return setTime(function (current) {
        return __spreadProps$1E(__spreadValues$3v({}, current), {
          minutes: val
        });
      });
    },
    className: classes.timeInput,
    withSeparator: withSeconds,
    size: size,
    max: 59,
    placeholder: timePlaceholder,
    "aria-label": minutesLabel,
    disabled: disabled
  }), withSeconds && /* @__PURE__ */React__default.createElement(TimeField, {
    ref: secondsRef,
    value: time.seconds,
    onChange: handleSecondsChange,
    setValue: function setValue(val) {
      return setTime(function (current) {
        return __spreadProps$1E(__spreadValues$3v({}, current), {
          seconds: val
        });
      });
    },
    className: classes.timeInput,
    size: size,
    max: 59,
    placeholder: timePlaceholder,
    "aria-label": secondsLabel,
    disabled: disabled
  }), format === "12" && /* @__PURE__ */React__default.createElement(AmPmInput, {
    ref: amPmRef,
    value: time.amPm,
    onChange: handleAmPmChange,
    placeholder: amPmPlaceholder,
    amLabel: amLabel,
    pmLabel: pmLabel,
    size: size,
    "aria-label": amPmLabel,
    disabled: disabled
  }))));
});
TimeInput.displayName = "@mantine/dates/TimeInput";
var useStyles$1C = createStyles(function (theme, _ref187) {
  var size = _ref187.size;
  return {
    timeField: {},
    disabled: {
      opacity: 0.6,
      cursor: "not-allowed"
    },
    inputWrapper: {
      display: "inline-flex",
      alignItems: "center",
      height: theme.fn.size({
        size: size,
        sizes: sizes$2
      }) - 2
    },
    separator: {
      paddingLeft: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 2,
      paddingRight: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 2,
      lineHeight: 1
    }
  };
});
var __defProp$3w = Object.defineProperty;
var __getOwnPropSymbols$3x = Object.getOwnPropertySymbols;
var __hasOwnProp$3x = Object.prototype.hasOwnProperty;
var __propIsEnum$3x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3w = function __defNormalProp$3w(obj, key, value) {
  return key in obj ? __defProp$3w(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3w = function __spreadValues$3w(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3x.call(b, prop)) __defNormalProp$3w(a, prop, b[prop]);
  if (__getOwnPropSymbols$3x) {
    var _iterator341 = _createForOfIteratorHelper(__getOwnPropSymbols$3x(b)),
      _step342;
    try {
      for (_iterator341.s(); !(_step342 = _iterator341.n()).done;) {
        var prop = _step342.value;
        if (__propIsEnum$3x.call(b, prop)) __defNormalProp$3w(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator341.e(err);
    } finally {
      _iterator341.f();
    }
  }
  return a;
};
var __objRest$28 = function __objRest$28(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$3x.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3x) {
    var _iterator342 = _createForOfIteratorHelper(__getOwnPropSymbols$3x(source)),
      _step343;
    try {
      for (_iterator342.s(); !(_step343 = _iterator342.n()).done;) {
        var prop = _step343.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3x.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator342.e(err);
    } finally {
      _iterator342.f();
    }
  }
  return target;
};
var RIGHT_SECTION_WIDTH$3 = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 40,
  xl: 44
};
var defaultProps$1q = {
  size: "sm",
  defaultValue: [null, null],
  withSeconds: false,
  clearable: false,
  format: "24",
  timePlaceholder: "--",
  amPmPlaceholder: "am",
  labelSeparator: "\u2013",
  disabled: false
};
var TimeRangeInput = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("TimeRangeInput", defaultProps$1q, props),
    required = _a.required,
    label = _a.label,
    error = _a.error,
    description = _a.description,
    className = _a.className,
    style = _a.style,
    size = _a.size,
    wrapperProps = _a.wrapperProps,
    classNames = _a.classNames,
    styles = _a.styles,
    id = _a.id,
    value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    withSeconds = _a.withSeconds,
    clearable = _a.clearable,
    clearButtonLabel = _a.clearButtonLabel,
    format = _a.format,
    name = _a.name,
    hoursLabel = _a.hoursLabel,
    minutesLabel = _a.minutesLabel,
    secondsLabel = _a.secondsLabel,
    amPmLabel = _a.amPmLabel,
    timePlaceholder = _a.timePlaceholder,
    amPmPlaceholder = _a.amPmPlaceholder,
    labelSeparator = _a.labelSeparator,
    disabled = _a.disabled,
    sx = _a.sx,
    labelProps = _a.labelProps,
    descriptionProps = _a.descriptionProps,
    errorProps = _a.errorProps,
    others = __objRest$28(_a, ["required", "label", "error", "description", "className", "style", "size", "wrapperProps", "classNames", "styles", "id", "value", "defaultValue", "onChange", "withSeconds", "clearable", "clearButtonLabel", "format", "name", "hoursLabel", "minutesLabel", "secondsLabel", "amPmLabel", "timePlaceholder", "amPmPlaceholder", "labelSeparator", "disabled", "sx", "labelProps", "descriptionProps", "errorProps"]);
  var _useStyles$1C = useStyles$1C({
      size: size
    }, {
      classNames: classNames,
      styles: styles,
      name: "TimeRangeInput"
    }),
    classes = _useStyles$1C.classes,
    cx = _useStyles$1C.cx,
    theme = _useStyles$1C.theme;
  var _extractSystemStyles18 = extractSystemStyles(others),
    systemStyles = _extractSystemStyles18.systemStyles,
    rest = _extractSystemStyles18.rest;
  var uuid = useUuid(id);
  var fromTimeRef = useRef();
  var toTimeRef = useRef();
  var _useState193 = useState(value != null ? value : defaultValue),
    _useState194 = _slicedToArray(_useState193, 2),
    _value = _useState194[0],
    setValue = _useState194[1];
  useDidUpdate(function () {
    typeof onChange === "function" && onChange(_value);
  }, [_value]);
  useDidUpdate(function () {
    var _a2, _b, _c, _d;
    if (((_a2 = value[0]) == null ? void 0 : _a2.getTime()) !== ((_b = _value[0]) == null ? void 0 : _b.getTime()) || ((_c = value[1]) == null ? void 0 : _c.getTime()) !== ((_d = _value[1]) == null ? void 0 : _d.getTime())) {
      setValue(value);
    }
  }, [value]);
  var handleClear = function handleClear() {
    var _a2;
    setValue([null, null]);
    (_a2 = fromTimeRef.current) == null ? void 0 : _a2.focus();
  };
  var rightSection = clearable && _value.filter(function (item) {
    return Boolean(item);
  }).length > 0 ? /* @__PURE__ */React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: handleClear,
    size: size
  }) : null;
  var forwardProps = {
    amPmLabel: amPmLabel,
    amPmPlaceholder: amPmPlaceholder,
    disabled: disabled,
    format: format,
    hoursLabel: hoursLabel,
    minutesLabel: minutesLabel,
    secondsLabel: secondsLabel,
    size: size,
    timePlaceholder: timePlaceholder,
    withSeconds: withSeconds
  };
  return /* @__PURE__ */React__default.createElement(InputWrapper, __spreadValues$3w(__spreadValues$3w({
    required: required,
    label: label,
    error: error,
    description: description,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    size: size,
    __staticSelector: "TimeRangeInput",
    id: uuid,
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React__default.createElement(Input, __spreadValues$3w({
    component: "div",
    __staticSelector: "TimeRangeInput",
    required: required,
    invalid: !!error,
    onClick: function onClick() {
      var _a2;
      (_a2 = fromTimeRef.current) == null ? void 0 : _a2.focus();
    },
    size: size,
    className: cx(_defineProperty({}, classes.disabled, disabled)),
    classNames: classNames,
    styles: styles,
    disabled: disabled,
    rightSection: rightSection,
    rightSectionWidth: theme.fn.size({
      size: size,
      sizes: RIGHT_SECTION_WIDTH$3
    })
  }, rest), /* @__PURE__ */React__default.createElement("div", {
    className: classes.inputWrapper
  }, /* @__PURE__ */React__default.createElement(TimeInput, __spreadValues$3w({
    ref: useMergedRef(fromTimeRef, ref),
    variant: "unstyled",
    value: _value[0],
    onChange: function onChange(date) {
      return setValue([date, _value[1]]);
    },
    name: name,
    nextRef: toTimeRef,
    id: uuid
  }, forwardProps)), /* @__PURE__ */React__default.createElement("span", {
    className: classes.separator,
    style: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
    }
  }, labelSeparator), /* @__PURE__ */React__default.createElement(TimeInput, __spreadValues$3w({
    ref: toTimeRef,
    variant: "unstyled",
    value: _value[1],
    onChange: function onChange(date) {
      return setValue([_value[0], date]);
    }
  }, forwardProps)))));
});
TimeRangeInput.displayName = "@mantine/dates/TimeRangeInput";
var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var AdminDataViewConfig =
/**
 *
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @param {String[]} displayTypes
 * @param {Function} datePickerHandler
 * @param {Function} displayViewPickerHandler
 * @param {Function} queryHandler
 * @param {Function} filterHandler
 * @param {Function} tableViewCountHandler
 * @param {Function} selectedEmployeeIdHandler
 */
function AdminDataViewConfig() {
  var adminDataViewReduxState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState();
  var displayTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var datePickerHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var displayViewPickerHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var queryHandler = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var filterHandler = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
  var tableViewCountHandler = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
  var selectedEmployeeIdHandler = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function () {};
  classCallCheck(this, AdminDataViewConfig);

  /** @type {String[]} */
  this.displayTypes = displayTypes;
  /** @type {String} */
  this.selectedDisplayView = adminDataViewReduxState.selectedDisplayView;
  /** @type {Boolean} */
  this.isDataLoading = adminDataViewReduxState.isDataLoading;
  /** @type {MetricDefinitionDisplay[]} */
  this.metricDefinitionDisplays = adminDataViewReduxState.metricDefinitionDisplays;
  /** @type {PayRuleDisplay[]} */
  this.payRuleDisplays = adminDataViewReduxState.payRuleDisplays;
  /** @type {PayRecordDisplay[]} */
  this.payRecordDisplays = adminDataViewReduxState.payRecordDisplays;
  /** @type {PayRecordDetailDisplay[]} */
  this.payRecordDetailDisplays = adminDataViewReduxState.payRecordDetailDisplays;
  /** @type {Date} */
  this.selectedDate = adminDataViewReduxState.selectedDate;
  /** @type {Function} */
  this.datePickerHandler = datePickerHandler;
  /** @type {Function} */
  this.displayViewPickerHandler = displayViewPickerHandler;
  /** @type {Function} */
  this.queryHandler = queryHandler;
  /** @type {Boolean} */
  this.hasAnyQueryRun = adminDataViewReduxState.hasAnyQueryRun;
  /** @type {String[]} */
  this.filterValues = adminDataViewReduxState.filterValues;
  /** @type {Function} */
  this.filterHandler = filterHandler;
  /** @type {Function} */
  this.tableViewCountHandler = tableViewCountHandler;
  /** @type {String} */
  this.tableViewCount = adminDataViewReduxState.tableViewCount;
  /** @type {String} */
  this.selectedEmployeeId = adminDataViewReduxState.selectedEmployeeId;
  /** @type {Function} */
  this.selectedEmployeeIdHandler = selectedEmployeeIdHandler;
};
var MetricDefinitionDisplay =
/**
 * @param {String} name
 * @param {String} metricNames
 * @param {String} expression
 */
function MetricDefinitionDisplay() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var expression = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  classCallCheck(this, MetricDefinitionDisplay);

  /** @type {String} */
  this.name = name;
  /** @type {String} */
  this.metricNames = metricNames;
  /** @type {String} */
  this.expression = expression;
};
var PayRuleDisplay =
/**
 * @param {String} name
 * @param {String} conditions
 * @param {String} adjustments
 * @param {String} startDate
 */
function PayRuleDisplay() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var conditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var adjustments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var startDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  classCallCheck(this, PayRuleDisplay);

  /** @type {String} */
  this.name = name;
  /** @type {String} */
  this.conditions = conditions;
  /** @type {String} */
  this.adjustments = adjustments;
  /** @type {String} */
  this.startDate = startDate;
};
var PayRecordDisplay =
/**
 * @param {String} expertID
 * @param {String} startDate
 * @param {String} endDate
 * @param {String} payRuleName
 * @param {String} totalCalls
 * @param {String} sales
 * @param {String} totalPay
 * @param {String} serveMetric
 * @param {String} serveValue
 * @param {String} servePay
 * @param {String} heroValue
 * @param {String} heroPay
 * @param {String} sp100Metric
 * @param {String} sp100Value
 * @param {String} sp100Pay
 */
function PayRecordDisplay() {
  var expertID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var payRuleName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var totalCalls = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var sales = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var totalPay = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var serveMetric = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var serveValue = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  var servePay = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  var heroValue = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';
  var heroPay = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : '';
  var sp100Metric = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : '';
  var sp100Value = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : '';
  var sp100Pay = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : '';
  classCallCheck(this, PayRecordDisplay);

  /** @type {String} */
  this.expertID = expertID;
  /** @type {String} */
  this.startDate = startDate;
  /** @type {String} */
  this.endDate = endDate;
  /** @type {String} */
  this.payRuleName = payRuleName;
  /** @type {String} */
  this.totalCalls = totalCalls;
  /** @type {String} */
  this.sales = sales;
  /** @type {String} */
  this.totalPay = totalPay;
  /** @type {String} */
  this.serveMetric = serveMetric;
  /** @type {String} */
  this.serveValue = serveValue;
  /** @type {String} */
  this.servePay = servePay;
  /** @type {String} */
  this.heroValue = heroValue;
  /** @type {String} */
  this.heroPay = heroPay;
  /** @type {String} */
  this.sp100Metric = sp100Metric;
  /** @type {String} */
  this.sp100Value = sp100Value;
  /** @type {String} */
  this.sp100Pay = sp100Pay;
};
var PayRecordDetailDisplay =
/**
 * @param {String} expertId
 * @param {String} startDate
 * @param {String} endDate
 * @param {String} payRuleName
 * @param {String} conditionFormula
 * @param {String} payFormula
 * @param {String} metricName
 * @param {String} metricValue
 */
function PayRecordDetailDisplay() {
  var expertId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var payRuleName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var conditionFormula = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var payFormula = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var metricName = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var metricValue = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  classCallCheck(this, PayRecordDetailDisplay);
  this.expertId = expertId;
  this.startDate = startDate;
  this.endDate = endDate;
  this.payRuleName = payRuleName;
  this.conditionFormula = conditionFormula;
  this.payFormula = payFormula;
  this.metricName = metricName;
  this.metricValue = metricValue;
};
var AdminDataViewReduxState =
/**
 *
 * @param {MetricDefinitionDisplay[]} metricDefinitionDisplays
 * @param {PayRuleDisplay[]} payRuleDisplays
 * @param {PayRecordDisplay[]} payRecordDisplays
 * @param {PayRecordDetailDisplay[]} payRecordDetailDisplays
 * @param {String} selectedDisplayView
 * @param {Date} selectedDate
 * @param {Boolean} isDataLoading
 * @param {Boolean} hasAnyQueryRun
 * @param {String[]} filterValues
 * @param {String} tableViewCount
 * @param {String} selectedEmployeeId
 */
function AdminDataViewReduxState() {
  var metricDefinitionDisplays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var payRuleDisplays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var payRecordDisplays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var payRecordDetailDisplays = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var selectedDisplayView = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var selectedDate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Date();
  var isDataLoading = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var hasAnyQueryRun = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var filterValues = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
  var tableViewCount = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  var selectedEmployeeId = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';
  classCallCheck(this, AdminDataViewReduxState);

  /** @type {MetricDefinitionDisplay[]} */
  this.metricDefinitionDisplays = metricDefinitionDisplays;
  /** @type {PayRuleDisplay[]} */
  this.payRuleDisplays = payRuleDisplays;
  /** @type {PayRecordDisplay[]} */
  this.payRecordDisplays = payRecordDisplays;
  /** @type {PayRecordDetailDisplay[]} */
  this.payRecordDetailDisplays = payRecordDetailDisplays;
  /** @type {String} */
  this.selectedDisplayView = selectedDisplayView;
  /** @type {Date} */
  this.selectedDate = selectedDate;
  /** @type {Boolean} */
  this.isDataLoading = isDataLoading;
  /** @type {Boolean} */
  this.hasAnyQueryRun = hasAnyQueryRun;
  /** @type {String[]} */
  this.filterValues = filterValues;
  /** @type {String} */
  this.tableViewCount = tableViewCount;
  /** @type {String} */
  this.selectedEmployeeId = selectedEmployeeId;
};

/**
 * @function adminDataViewReduxStateToSelectedEmployeeId
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns {String}
 */
var adminDataViewReduxStateToSelectedEmployeeId = function adminDataViewReduxStateToSelectedEmployeeId() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    _ref$selectedEmployee = _ref.selectedEmployeeId,
    selectedEmployeeId = _ref$selectedEmployee === undefined ? '' : _ref$selectedEmployee;
  return selectedEmployeeId;
};

/**
 * @function adminDataViewReduxStateToHasAnyQueryRun
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns {Boolean}
 */
var adminDataViewReduxStateToHasAnyQueryRun = function adminDataViewReduxStateToHasAnyQueryRun() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    _ref2$hasAnyQueryRun = _ref2.hasAnyQueryRun,
    hasAnyQueryRun = _ref2$hasAnyQueryRun === undefined ? false : _ref2$hasAnyQueryRun;
  return hasAnyQueryRun;
};

/**
 * @function adminDataViewReduxStateToMetricDefinitionDisplays
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns
 */
var adminDataViewReduxStateToMetricDefinitionDisplays = function adminDataViewReduxStateToMetricDefinitionDisplays() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref3.metricDefinitionDisplays;
  return metricDefinitionDisplays;
};

/**
 * @function adminDataViewReduxStateToPayRuleDisplays
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns
 */
var adminDataViewReduxStateToPayRuleDisplays = function adminDataViewReduxStateToPayRuleDisplays() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    payRuleDisplays = _ref4.payRuleDisplays;
  return payRuleDisplays;
};

/**
 * @function adminDataViewReduxStateToSelectedDisplayView
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns
 */
var adminDataViewReduxStateToSelectedDisplayView = function adminDataViewReduxStateToSelectedDisplayView() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    selectedDisplayView = _ref7.selectedDisplayView;
  return selectedDisplayView;
};

/**
 * @function adminDataViewReduxStateToSelectedDate
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns
 */
var adminDataViewReduxStateToSelectedDate = function adminDataViewReduxStateToSelectedDate() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    selectedDate = _ref8.selectedDate;
  return selectedDate;
};

/**
 * @function adminDataViewReduxStateToIsDataLoading
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns
 */
var adminDataViewReduxStateToIsDataLoading = function adminDataViewReduxStateToIsDataLoading() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    isDataLoading = _ref9.isDataLoading;
  return isDataLoading;
};

/**
 * @function adminDataViewReduxStateToFilterValues
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns
 */
var adminDataViewReduxStateToFilterValues = function adminDataViewReduxStateToFilterValues() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    filterValues = _ref10.filterValues;
  return filterValues;
};

/**
 * @function adminDataViewReduxStateToTableViewCount
 * @param {AdminDataViewReduxState} adminDataViewReduxState
 * @returns
 */
var adminDataViewReduxStateToTableViewCount = function adminDataViewReduxStateToTableViewCount() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    tableViewCount = _ref11.tableViewCount;
  return tableViewCount;
};
var TABLE_VIEW_COUNT_OPTIONS = ['10', '25', '50', 'All'];
var METRIC_DEFINITION_DISPLAY_FILE_NAME = 'metricDefinitions';
var PAY_RULE_DISPLAY_FILE_NAME = 'payRules';
var PAY_RECORD_DISPLAY_FILE_NAME = 'payRecords';
var PAY_RECORD_DETAIL_DISPLAY_FILE_NAME = 'payRecordDetail';

/**
 *
 * @prop {String} value
 * @prop {Function} setValue
 * @prop {String} id
 * @returns {React.ReactElement}
 */
var TableViewCountDropDown = function TableViewCountDropDown(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    id = _ref.id;
  return React__default.createElement(NativeSelect, {
    label: 'Results to view',
    className: 'drop-down',
    id: id,
    value: value
    //@ts-ignore
    ,
    onChange: setValue,
    data: TABLE_VIEW_COUNT_OPTIONS
  });
};
var PayRecordDetailViewComponent = function PayRecordDetailViewComponent(_ref) {
  var _ref$payRecordDetailD = _ref.payRecordDetailDisplays,
    payRecordDetailDisplays = _ref$payRecordDetailD === undefined ? [] : _ref$payRecordDetailD;
  return payRecordDetailTable(payRecordDetailDisplays);
};

/**
 * Creates the table header for the Pay Rule Display table
 * @returns
 */
var payRecordDetailDisplayTableHeader = function payRecordDetailDisplayTableHeader() {
  return React__default.createElement('thead', {
    className: 'admin-table-border'
  }, React__default.createElement('tr', null, React__default.createElement('th', null, 'Expert ID'), React__default.createElement('th', null, 'Start Date'), React__default.createElement('th', null, 'End Date'), React__default.createElement('th', null, 'Pay Rule Name'), React__default.createElement('th', null, 'Condition Formula'), React__default.createElement('th', null, 'Pay Formula'), React__default.createElement('th', null, 'Metric Name'), React__default.createElement('th', null, 'Metric Value')));
};

/**
 *
 * @param {PayRecordDetailDisplay[]} payRecordDetailDisplays
 * @returns
 */
var payRecordDetailDisplaysToTableBody = function payRecordDetailDisplaysToTableBody() {
  var payRecordDetailDisplays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return React__default.createElement('tbody', null, payRecordDetailDisplays.map(payRecordDetailDisplayToTableRow));
};

/**
 *
 * @param {PayRecordDetailDisplay} payRecordDetailDisplay
 * @param {Number} index
 * @returns
 */
var payRecordDetailDisplayToTableRow = function payRecordDetailDisplayToTableRow() {
  var payRecordDetailDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRecordDetailDisplay();
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return React__default.createElement('tr', {
    key: index
  }, payRecordDetailDisplayToTableRowItems(payRecordDetailDisplay));
};

/**
 *
 * @param {PayRecordDetailDisplay} payRecordDetailDisplay
 * @returns
 */
var payRecordDetailDisplayToTableRowItems = function payRecordDetailDisplayToTableRowItems(payRecordDetailDisplay) {
  return Object.values(payRecordDetailDisplay).map(payRecordDetailDisplayValueToRowItem);
};

/**
 *
 * @param {*} string
 * @param {*} index
 * @returns
 */
var payRecordDetailDisplayValueToRowItem = function payRecordDetailDisplayValueToRowItem() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return React__default.createElement('td', {
    key: index
  }, string);
};
var payRecordDetailTable = function payRecordDetailTable() {
  var payRecordDetailDisplays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return React__default.createElement(Table, {
    id: 'deep-dive-display-table',
    className: 'admin-display-table admin-table-border',
    striped: true,
    highlightOnHover: true,
    horizontalSpacing: 'xs',
    verticalSpacing: 'xs',
    border: 1
  }, payRecordDetailDisplayTableHeader(), payRecordDetailDisplaysToTableBody(payRecordDetailDisplays));
};
var PayRuleViewComponent = function PayRuleViewComponent(_ref) {
  var _ref$payRuleDisplays = _ref.payRuleDisplays,
    payRuleDisplays = _ref$payRuleDisplays === undefined ? [] : _ref$payRuleDisplays;
  return payRuleTable(payRuleDisplays);
};

/**
 * Creates the table header for the Pay Rule Display table
 * @returns {React.ReactElement}
 */
var payRuleDisplayTableHeader = function payRuleDisplayTableHeader() {
  return React__default.createElement('thead', {
    className: 'admin-table-border'
  }, React__default.createElement('tr', null, React__default.createElement('th', null, 'Name'), React__default.createElement('th', null, 'Conditions'), React__default.createElement('th', null, 'Adjustments'), React__default.createElement('th', null, 'Start Date')));
};

/**
 *
 * @param {PayRuleDisplay[]} payRuleDisplays
 * @returns {React.ReactElement}
 */
var payRuleDisplaysToTableBody = function payRuleDisplaysToTableBody(payRuleDisplays) {
  return React__default.createElement('tbody', null, payRuleDisplays.map(payRuleDisplayToTableRow));
};

/**
 *
 * @param {PayRuleDisplay} payRuleDisplay
 * @param {Number} index
 * @returns {React.ReactElement}
 */
var payRuleDisplayToTableRow = function payRuleDisplayToTableRow() {
  var payRuleDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleDisplay();
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return React__default.createElement('tr', {
    key: index
  }, payRuleDisplayToTableRowItems(payRuleDisplay));
};

/**
 *
 * @param {PayRuleDisplay} payRuleDisplay
 * @returns {React.ReactElement[]}
 */
var payRuleDisplayToTableRowItems = function payRuleDisplayToTableRowItems(payRuleDisplay) {
  return Object.values(payRuleDisplay).map(payRuleDisplayValueToRowItem);
};

/**
 *
 * @param {String} string
 * @param {Number} index
 * @returns {React.ReactElement}
 */
var payRuleDisplayValueToRowItem = function payRuleDisplayValueToRowItem() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return React__default.createElement('td', {
    key: index
  }, string);
};
var payRuleTable = function payRuleTable() {
  var payRuleDisplays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return React__default.createElement(Table, {
    id: 'pay-rules-display-table',
    className: 'admin-display-table admin-table-border',
    striped: true,
    highlightOnHover: true,
    horizontalSpacing: 'xs',
    verticalSpacing: 'xs',
    border: 1
  }, payRuleDisplayTableHeader(), payRuleDisplaysToTableBody(payRuleDisplays));
};
var PayRecordViewComponent = function PayRecordViewComponent(_ref) {
  var _ref$payRecordDisplay = _ref.payRecordDisplays,
    payRecordDisplays = _ref$payRecordDisplay === undefined ? [] : _ref$payRecordDisplay;
  return payRecordTable(payRecordDisplays);
};

/**
 * Creates the table header for the Pay Rule Display table
 * @returns
 */
var payRecordDisplayTableHeader = function payRecordDisplayTableHeader() {
  return React__default.createElement('thead', {
    className: 'admin-table-border'
  }, React__default.createElement('tr', null, React__default.createElement('th', null, 'Expert ID'), React__default.createElement('th', null, 'Start Date'), React__default.createElement('th', null, 'End Date'), React__default.createElement('th', null, 'Pay Rule Name'), React__default.createElement('th', null, 'Total Calls'), React__default.createElement('th', null, 'Sales'), React__default.createElement('th', null, 'Total Pay'), React__default.createElement('th', null, 'Serve Metric'), React__default.createElement('th', null, 'Serve Value'), React__default.createElement('th', null, 'Serve Pay'), React__default.createElement('th', null, 'HERO Value'), React__default.createElement('th', null, 'HERO Pay'), React__default.createElement('th', null, 'SP100 Metric'), React__default.createElement('th', null, 'SP100 Value'), React__default.createElement('th', null, 'SP100 Pay')));
};

/**
 *
 * @param {PayRecordDisplay[]} payRecordDisplays
 * @returns
 */
var payRecordDisplaysToTableBody = function payRecordDisplaysToTableBody(payRecordDisplays) {
  return React__default.createElement('tbody', null, payRecordDisplays.map(payRecordDisplayToTableRow));
};

/**
 *
 * @param {PayRecordDisplay} payRecordDisplay
 * @param {Number} index
 * @returns
 */
var payRecordDisplayToTableRow = function payRecordDisplayToTableRow() {
  var payRecordDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRecordDisplay();
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return React__default.createElement('tr', {
    key: index
  }, payRecordDisplayToTableRowItems(payRecordDisplay));
};

/**
 *
 * @param {PayRecordDisplay} payRecordDisplay
 * @returns
 */
var payRecordDisplayToTableRowItems = function payRecordDisplayToTableRowItems(payRecordDisplay) {
  return Object.values(payRecordDisplay).map(payRecordDisplayValueToRowItem);
};

/**
 *
 * @param {*} string
 * @param {*} index
 * @returns
 */
var payRecordDisplayValueToRowItem = function payRecordDisplayValueToRowItem() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return React__default.createElement('td', {
    key: index
  }, string);
};
var payRecordTable = function payRecordTable() {
  var payRecordDisplays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return React__default.createElement(Table, {
    id: 'pay-records-display-table',
    className: 'admin-display-table admin-table-border',
    striped: true,
    highlightOnHover: true,
    horizontalSpacing: 'xs',
    verticalSpacing: 'xs',
    border: 1
  }, payRecordDisplayTableHeader(), payRecordDisplaysToTableBody(payRecordDisplays));
};
var MetricDefinitionViewComponent = function MetricDefinitionViewComponent(_ref) {
  var _ref$metricDefinition = _ref.metricDefinitionDisplays,
    metricDefinitionDisplays = _ref$metricDefinition === undefined ? [] : _ref$metricDefinition;
  return metricDefinitionTable(metricDefinitionDisplays);
};

/**
 * Builds a header specific to metric definition displays
 *
 * @function metricDefinitionDisplayTableHeader
 * @returns {React.ReactElement}
 */
var metricDefinitionDisplayTableHeader = function metricDefinitionDisplayTableHeader() {
  return React__default.createElement('thead', {
    className: 'admin-table-border'
  }, React__default.createElement('tr', null, React__default.createElement('th', null, 'Name'), React__default.createElement('th', null, 'Metric Names'), React__default.createElement('th', null, 'Expression')));
};

/**
 * @function metricDefinitionDisplaysToTableBody
 * @param {MetricDefinitionDisplay []} metricDefinitionDisplays
 * @returns {React.ReactElement}
 */
var metricDefinitionDisplaysToTableBody = function metricDefinitionDisplaysToTableBody(metricDefinitionDisplays) {
  return React__default.createElement('tbody', null, metricDefinitionDisplays.map(metricDefinitionDisplayToTableRow));
};

/**
 * @function metricDefinitionDisplayToTableRow
 * @param {MetricDefinitionDisplay} metricDefinitionDisplay
 * @param {Number} index
 * @returns {React.ReactElement}
 */
var metricDefinitionDisplayToTableRow = function metricDefinitionDisplayToTableRow() {
  var metricDefinitionDisplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricDefinitionDisplay();
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return React__default.createElement('tr', {
    key: index
  }, metricDefinitionDisplayToTableRowItems(metricDefinitionDisplay));
};

/**
 * @function metricDefinitionDisplayToTableRowItems
 * @param {MetricDefinitionDisplay} metricDefinitionDisplay
 * @returns {React.ReactElement[]}
 */
var metricDefinitionDisplayToTableRowItems = function metricDefinitionDisplayToTableRowItems(metricDefinitionDisplay) {
  return Object.values(metricDefinitionDisplay).map(metricDefinitionDisplayValueToRowItem);
};

/**
 *
 * @param {String} string
 * @param {Number} index
 * @returns {React.ReactElement}
 */
var metricDefinitionDisplayValueToRowItem = function metricDefinitionDisplayValueToRowItem() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return React__default.createElement('td', {
    key: index
  }, string);
};

/**
 *
 * @param {MetricDefinitionDisplay[]} metricDefinitionDisplays
 * @returns {React.ReactElement}
 */
var metricDefinitionTable = function metricDefinitionTable() {
  var metricDefinitionDisplays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Table, {
    id: 'metric-definition-display-table',
    className: 'admin-display-table admin-table-border',
    striped: true,
    highlightOnHover: true,
    horizontalSpacing: 'xs',
    verticalSpacing: 'xs',
    border: 1
  }, metricDefinitionDisplayTableHeader(), metricDefinitionDisplaysToTableBody(metricDefinitionDisplays)));
};

/* 
FIXME This is a workaround due to the null coalesince operator in utils for stringsAndIndexToString as shown below
  466: const stringsAndIndexToString = (strings = [], index = 0) =>
  467:   strings[index] ?? '';
                        ^
  468: 
*/

/**
 * Returns lowercase representation of String
 *
 * stringToLowerCase :: String -> String
 * @param {String} string
 * @returns {String}
 */
var stringToLowerCase = function stringToLowerCase(string) {
  return string.toLowerCase();
};

/**
 * Compare two strings case insensitive
 *
 * stringEqualityDecisionCaseInsensitive :: String -> String -> Boolean
 * @function stringEqualityDecisionCaseInsensitive
 * @param {String} inputString
 * @param {String} comparisonString
 * @returns {Boolean}
 */
var stringEqualityDecisionCaseInsensitive = function stringEqualityDecisionCaseInsensitive(inputString, comparisonString) {
  return stringToLowerCase(inputString) === stringToLowerCase(comparisonString);
};

/**
 * @function viewCountStringAndArrayToArray
 * @param {String} viewCount
 * @param {Array} array
 * @returns
 */
var viewCountStringAndArrayToArray = function viewCountStringAndArrayToArray() {
  var viewCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (stringEqualityDecisionCaseInsensitive(viewCount, 'All')) return array;
  return array.slice(0, parseInt(viewCount));
};

/**
 * @function dateToFormattedDateString
 * @param {Date} date
 * @returns {String}
 */
var dateToFormattedDateString = function dateToFormattedDateString() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return date.toISOString().split('T')[0];
};
var core = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  var isSafari = exports.isSafari = function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };
  var isJsons = exports.isJsons = function isJsons(array) {
    return Array.isArray(array) && array.every(function (row) {
      return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
    });
  };
  var isArrays = exports.isArrays = function isArrays(array) {
    return Array.isArray(array) && array.every(function (row) {
      return Array.isArray(row);
    });
  };
  var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
    return Array.from(array.map(function (json) {
      return Object.keys(json);
    }).reduce(function (a, b) {
      return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
    }, []));
  };
  var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
    headers = headers || jsonsHeaders(jsons);
    var headerLabels = headers;
    var headerKeys = headers;
    if (isJsons(headers)) {
      headerLabels = headers.map(function (header) {
        return header.label;
      });
      headerKeys = headers.map(function (header) {
        return header.key;
      });
    }
    var data = jsons.map(function (object) {
      return headerKeys.map(function (header) {
        return getHeaderValue(header, object);
      });
    });
    return [headerLabels].concat(_toConsumableArray(data));
  };
  var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
    var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
      var value = o[p];
      if (value === undefined || value === null) {
        arr.splice(1);
      } else {
        return value;
      }
    }, obj);
    return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
  };
  var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
    return typeof element === 'undefined' || element === null ? '' : element;
  };
  var joiner = exports.joiner = function joiner(data) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
    var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
    return data.filter(function (e) {
      return e;
    }).map(function (row) {
      return row.map(function (element) {
        return elementOrEmpty(element);
      }).map(function (column) {
        return "" + enclosingCharacter + column + enclosingCharacter;
      }).join(separator);
    }).join("\n");
  };
  var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
    return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator, enclosingCharacter);
  };
  var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
    return joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
  };
  var string2csv = exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
    return headers ? headers.join(separator) + "\n" + data : data.replace(/"/g, '""');
  };
  var toCSV = exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
    if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
    if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
    if (typeof data === 'string') return string2csv(data, headers, separator);
    throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
  };
  var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
    var csv = toCSV(data, headers, separator, enclosingCharacter);
    var type = isSafari() ? 'application/csv' : 'text/csv';
    var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], {
      type: type
    });
    var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;
    var URL = window.URL || window.webkitURL;
    return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
  };
});
unwrapExports(core);
var core_1 = core.isSafari;
var core_2 = core.isJsons;
var core_3 = core.isArrays;
var core_4 = core.jsonsHeaders;
var core_5 = core.jsons2arrays;
var core_6 = core.getHeaderValue;
var core_7 = core.elementOrEmpty;
var core_8 = core.joiner;
var core_9 = core.arrays2csv;
var core_10 = core.jsons2csv;
var core_11 = core.string2csv;
var core_12 = core.toCSV;
var core_13 = core.buildURI;
var metaProps = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;
  var _react2 = _interopRequireDefault(React__default);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var propTypes$$1 = exports.propTypes = {
    data: (0, propTypes.oneOfType)([propTypes.string, propTypes.array, propTypes.func]).isRequired,
    headers: propTypes.array,
    target: propTypes.string,
    separator: propTypes.string,
    filename: propTypes.string,
    uFEFF: propTypes.bool,
    onClick: propTypes.func,
    asyncOnClick: propTypes.bool,
    enclosingCharacter: propTypes.string
  };
  var defaultProps = exports.defaultProps = {
    separator: ',',
    filename: 'generatedBy_react-csv.csv',
    uFEFF: true,
    asyncOnClick: false,
    enclosingCharacter: '"'
  };
  var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];
});
unwrapExports(metaProps);
var metaProps_1 = metaProps.PropsNotForwarded;
var metaProps_2 = metaProps.defaultProps;
var metaProps_3 = metaProps.propTypes;
var Download = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react2 = _interopRequireDefault(React__default);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var defaultProps = {
    target: '_blank'
  };
  var CSVDownload = function (_React$Component) {
    _inherits(CSVDownload, _React$Component);
    function CSVDownload(props) {
      _classCallCheck(this, CSVDownload);
      var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
      _this.state = {};
      return _this;
    }
    _createClass(CSVDownload, [{
      key: 'buildURI',
      value: function buildURI() {
        return core.buildURI.apply(undefined, arguments);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
          data = _props.data,
          headers = _props.headers,
          separator = _props.separator,
          enclosingCharacter = _props.enclosingCharacter,
          uFEFF = _props.uFEFF,
          target = _props.target,
          specs = _props.specs,
          replace = _props.replace;
        this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
      }
    }, {
      key: 'getWindow',
      value: function getWindow() {
        return this.state.page;
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return CSVDownload;
  }(_react2.default.Component);
  CSVDownload.defaultProps = Object.assign(metaProps.defaultProps, defaultProps);
  CSVDownload.propTypes = metaProps.propTypes;
  exports.default = CSVDownload;
});
unwrapExports(Download);
var Link = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react2 = _interopRequireDefault(React__default);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CSVLink = function (_React$Component) {
    _inherits(CSVLink, _React$Component);
    function CSVLink(props) {
      _classCallCheck(this, CSVLink);
      var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
      _this.buildURI = _this.buildURI.bind(_this);
      return _this;
    }
    _createClass(CSVLink, [{
      key: 'buildURI',
      value: function buildURI() {
        return core.buildURI.apply(undefined, arguments);
      }
    }, {
      key: 'handleLegacy',
      value: function handleLegacy(event) {
        var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (window.navigator.msSaveOrOpenBlob) {
          event.preventDefault();
          var _props = this.props,
            data = _props.data,
            headers = _props.headers,
            separator = _props.separator,
            filename = _props.filename,
            enclosingCharacter = _props.enclosingCharacter,
            uFEFF = _props.uFEFF;
          var csvData = isAsync && typeof data === 'function' ? data() : data;
          var blob = new Blob([uFEFF ? "\uFEFF" : '', (0, core.toCSV)(csvData, headers, separator, enclosingCharacter)]);
          window.navigator.msSaveBlob(blob, filename);
          return false;
        }
      }
    }, {
      key: 'handleAsyncClick',
      value: function handleAsyncClick(event) {
        var _this2 = this;
        var done = function done(proceed) {
          if (proceed === false) {
            event.preventDefault();
            return;
          }
          _this2.handleLegacy(event, true);
        };
        this.props.onClick(event, done);
      }
    }, {
      key: 'handleSyncClick',
      value: function handleSyncClick(event) {
        var stopEvent = this.props.onClick(event) === false;
        if (stopEvent) {
          event.preventDefault();
          return;
        }
        this.handleLegacy(event);
      }
    }, {
      key: 'handleClick',
      value: function handleClick() {
        var _this3 = this;
        return function (event) {
          if (typeof _this3.props.onClick === 'function') {
            return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
          }
          _this3.handleLegacy(event);
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;
        var _props2 = this.props,
          data = _props2.data,
          headers = _props2.headers,
          separator = _props2.separator,
          filename = _props2.filename,
          uFEFF = _props2.uFEFF,
          children = _props2.children,
          onClick = _props2.onClick,
          asyncOnClick = _props2.asyncOnClick,
          enclosingCharacter = _props2.enclosingCharacter,
          rest = _objectWithoutProperties(_props2, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick', 'enclosingCharacter']);
        var isNodeEnvironment = typeof window === 'undefined';
        var href = isNodeEnvironment ? '' : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);
        return _react2.default.createElement('a', _extends({
          download: filename
        }, rest, {
          ref: function ref(link) {
            return _this4.link = link;
          },
          target: '_self',
          href: href,
          onClick: this.handleClick()
        }), children);
      }
    }]);
    return CSVLink;
  }(_react2.default.Component);
  CSVLink.defaultProps = metaProps.defaultProps;
  CSVLink.propTypes = metaProps.propTypes;
  exports.default = CSVLink;
});
unwrapExports(Link);
var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CSVLink = exports.CSVDownload = undefined;
  var _Download2 = _interopRequireDefault(Download);
  var _Link2 = _interopRequireDefault(Link);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var CSVDownload = exports.CSVDownload = _Download2.default;
  var CSVLink = exports.CSVLink = _Link2.default;
});
unwrapExports(lib);
var lib_1 = lib.CSVLink;
var lib_2 = lib.CSVDownload;
var reactCsv = lib;
var reactCsv_1 = reactCsv.CSVLink;

/**
 * @function downloadButton
 * @param {String} fileName
 * @param {Object[]} data
 * @param {Date} date
 * @returns
 */
var downloadButton = function downloadButton() {
  var fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
  return React__default.createElement(Button, {
    id: 'download-csv-button',
    className: 'button-secondary'
  }, React__default.createElement(reactCsv_1, {
    filename: fileName + '-for-' + dateToFormattedDateString(date) + '.csv',
    data: data,
    separator: ';'
  }, 'Download CSV'));
};

/**
 * @function RESULT_TEXT
 * @param {Number} number
 * @returns {String}
 */
var RESULT_TEXT = function RESULT_TEXT() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return 'Total Items: ' + number;
};
/**
 * @function totalDisplayBadge
 * @param {Number} number
 * @returns {React.ReactElement}
 */
var totalDisplayBadge = function totalDisplayBadge(number) {
  return React__default.createElement(Badge, {
    id: 'table-total-items',
    size: 'lg',
    variant: 'filled'
  }, RESULT_TEXT(number));
};

/**
 * @function tableViewCountAndDateAndMetricDefinitionDisplaysToMetricDefinitionViewComponent
 * @param {String} tableViewCount
 * @param {Date} date
 * @param {MetricDefinitionDisplay[]} metricDefinitionDisplays
 * @returns {React.ReactElement}
 */
var tableViewCountAndDateAndMetricDefinitionDisplaysToMetricDefinitionViewComponent = function tableViewCountAndDateAndMetricDefinitionDisplaysToMetricDefinitionViewComponent() {
  var tableViewCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var metricDefinitionDisplays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (metricDefinitionDisplays.length > 0) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement('div', {
      className: 'container aux-table-items'
    }, downloadButton(METRIC_DEFINITION_DISPLAY_FILE_NAME, metricDefinitionDisplays, date), totalDisplayBadge(metricDefinitionDisplays.length)), React__default.createElement(MetricDefinitionViewComponent, {
      metricDefinitionDisplays: viewCountStringAndArrayToArray(tableViewCount, metricDefinitionDisplays)
    }));
  }
  return React__default.createElement(React__default.Fragment, null);
};

/**
 * @function tableViewCountAndDateAndPayRulesDisplaysToPayRuleViewComponent
 * @param {String} tableViewCount
 * @param {Date} date
 * @param {PayRuleDisplay[]} payRuleDisplays
 * @returns {React.ReactElement}
 */
var tableViewCountAndDateAndPayRulesDisplaysToPayRuleViewComponent = function tableViewCountAndDateAndPayRulesDisplaysToPayRuleViewComponent() {
  var tableViewCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var payRuleDisplays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (payRuleDisplays.length > 0) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement('div', {
      className: 'container aux-table-items'
    }, downloadButton(PAY_RULE_DISPLAY_FILE_NAME, payRuleDisplays, date), totalDisplayBadge(payRuleDisplays.length)), React__default.createElement(PayRuleViewComponent, {
      payRuleDisplays: viewCountStringAndArrayToArray(tableViewCount, payRuleDisplays)
    }));
  }
  return React__default.createElement(React__default.Fragment, null);
};

/**
 * @function tableViewCountAndDateAndPayRecordDisplaysToPayRecordViewComponent
 * @param {String} tableViewCount
 * @param {Date} date
 * @param {PayRecordDisplay[]} payRecordDisplays
 * @returns {React.ReactElement}
 */
var tableViewCountAndDateAndPayRecordDisplaysToPayRecordViewComponent = function tableViewCountAndDateAndPayRecordDisplaysToPayRecordViewComponent() {
  var tableViewCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var payRecordDisplays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (payRecordDisplays.length > 0) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement('div', {
      className: 'container aux-table-items'
    }, downloadButton(PAY_RECORD_DISPLAY_FILE_NAME, payRecordDisplays, date), totalDisplayBadge(payRecordDisplays.length)), React__default.createElement(PayRecordViewComponent, {
      payRecordDisplays: viewCountStringAndArrayToArray(tableViewCount, payRecordDisplays)
    }));
  }
  return React__default.createElement(React__default.Fragment, null);
};

/**
* @function tableViewCountAndDateAndPayRecordDetailDisplaysToPayRecordDetailViewComponent
* @param {String} tableViewCount
* @param {Date} date
* @param {PayRecordDetailDisplay[]} payRecordDetailDisplays
* @returns {React.ReactElement}
*/
var tableViewCountAndDateAndPayRecordDetailDisplaysToPayRecordDetailViewComponent = function tableViewCountAndDateAndPayRecordDetailDisplaysToPayRecordDetailViewComponent() {
  var tableViewCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var payRecordDetailDisplays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (payRecordDetailDisplays.length > 0) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement('div', {
      className: 'container aux-table-items'
    }, downloadButton(PAY_RECORD_DETAIL_DISPLAY_FILE_NAME, payRecordDetailDisplays, date), totalDisplayBadge(payRecordDetailDisplays.length)), React__default.createElement(PayRecordDetailViewComponent, {
      payRecordDetailDisplays: viewCountStringAndArrayToArray(tableViewCount, payRecordDetailDisplays)
    }));
  }
  return React__default.createElement(React__default.Fragment, null);
};

/**
 * Houses each view for the page and provides a location for the conditional rendering logic
 * @prop {MetricDefinitionDisplay[]} metricDefinitionDisplays
 * @prop {payRuleDisplays[]} payRuleDisplays
 * @prop {PayRecordDisplay[]} payRecordDisplays
 * @prop {PayRecordDetailDisplay[]} payRecordDetailDisplays
 * @prop {String} tableViewCount
 * @prop {Date} selectedDate
 * @returns {React.ReactElement}
 */
var DataViewContainerComponent = function DataViewContainerComponent(_ref) {
  var _ref$metricDefinition = _ref.metricDefinitionDisplays,
    metricDefinitionDisplays = _ref$metricDefinition === undefined ? [] : _ref$metricDefinition,
    _ref$payRuleDisplays = _ref.payRuleDisplays,
    payRuleDisplays = _ref$payRuleDisplays === undefined ? [] : _ref$payRuleDisplays,
    _ref$payRecordDisplay = _ref.payRecordDisplays,
    payRecordDisplays = _ref$payRecordDisplay === undefined ? [] : _ref$payRecordDisplay,
    _ref$payRecordDetailD = _ref.payRecordDetailDisplays,
    payRecordDetailDisplays = _ref$payRecordDetailD === undefined ? [] : _ref$payRecordDetailD,
    _ref$tableViewCount = _ref.tableViewCount,
    tableViewCount = _ref$tableViewCount === undefined ? '' : _ref$tableViewCount,
    _ref$selectedDate = _ref.selectedDate,
    selectedDate = _ref$selectedDate === undefined ? new Date() : _ref$selectedDate;
  return React__default.createElement(React__default.Fragment, null, tableViewCountAndDateAndMetricDefinitionDisplaysToMetricDefinitionViewComponent(tableViewCount, selectedDate, metricDefinitionDisplays), tableViewCountAndDateAndPayRulesDisplaysToPayRuleViewComponent(tableViewCount, selectedDate, payRuleDisplays), tableViewCountAndDateAndPayRecordDisplaysToPayRecordViewComponent(tableViewCount, selectedDate, payRecordDisplays), tableViewCountAndDateAndPayRecordDetailDisplaysToPayRecordDetailViewComponent(tableViewCount, selectedDate, payRecordDetailDisplays));
};

/**
 * @function queryDropDown
 * @param {String} value
 * @param {Function} setValue
 * @param {String[]} data
 * @returns {React.ReactElement}
 */
var queryDropDown = function queryDropDown(value, setValue, data) {
  return React__default.createElement(NativeSelect, {
    label: 'Select a Query',
    placeholder: 'Select a query',
    className: 'drop-down',
    value: value || data[0]
    //@ts-ignore
    ,
    onChange: setValue,
    data: data,
    required: true
  });
};

/**
 * @function empIdField
 * @param {String} value
 * @param {Function} setValue
 * @param {String} selectedDisplayView
 * @returns {React.ReactElement}
 */
var empIdField = function empIdField(value, setValue, selectedDisplayView) {
  if (selectedDisplayView === 'payRecordDetail') return React__default.createElement(TextInput, {
    label: 'Employee ID',
    value: value,
    onChange: setValue,
    required: true
  });
  return React__default.createElement(React__default.Fragment, null);
};

/**
 * @function datePicker
 *
 * @param {Function} datePickerHandler
 * @returns {React.ReactElement}
 */
var datePicker = function datePicker(selectedDate, datePickerHandler) {
  return React__default.createElement(DatePicker, {
    amountOfMonths: 3,
    required: true,
    label: 'Query date',
    placeholder: 'Select date',
    clearable: false,
    value: selectedDate
    //@ts-ignore
    ,
    onChange: datePickerHandler
  });
};

/**
 * Allows the user to add and delete an array of strings
 * @function filterMultiTextInput
 * @param {String[]} value
 * @param {Function} setValue
 * @returns {React.ReactElement}
 */
var filterMultiTextInput = function filterMultiTextInput(value, setValue) {
  return React__default.createElement(MultiSelect, {
    id: 'admin-table-filter-input',
    searchable: true,
    clearable: true,
    creatable: true,
    label: 'Filter Results',
    placeholder: 'Type and hit enter to filter, multiple filters can be created'
    // @ts-ignore
    ,
    onChange: setValue,
    getCreateLabel: createMultiSelectLabel,
    data: value
  });
};
/**
 * Displays under the filter while typing
 * @function createMultiSelectLabel
 * @param {String} query
 * @returns {String}
 */
var createMultiSelectLabel = function createMultiSelectLabel(query) {
  return '+ Create ' + query;
};

/**
 * The main component for the sub app
 *
 * @function AdminPageComponent
 * @param {AdminDataViewConfig} adminDataViewConfig
 * @returns {React.ReactElement}
 */
var AdminPageComponent = function AdminPageComponent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewConfig(),
    selectedDisplayView = _ref.selectedDisplayView,
    displayTypes = _ref.displayTypes,
    isDataLoading = _ref.isDataLoading,
    _ref$metricDefinition = _ref.metricDefinitionDisplays,
    metricDefinitionDisplays = _ref$metricDefinition === undefined ? [] : _ref$metricDefinition,
    _ref$payRuleDisplays = _ref.payRuleDisplays,
    payRuleDisplays = _ref$payRuleDisplays === undefined ? [] : _ref$payRuleDisplays,
    _ref$payRecordDisplay = _ref.payRecordDisplays,
    payRecordDisplays = _ref$payRecordDisplay === undefined ? [] : _ref$payRecordDisplay,
    _ref$payRecordDetailD = _ref.payRecordDetailDisplays,
    payRecordDetailDisplays = _ref$payRecordDetailD === undefined ? [] : _ref$payRecordDetailD,
    selectedDate = _ref.selectedDate,
    datePickerHandler = _ref.datePickerHandler,
    displayViewPickerHandler = _ref.displayViewPickerHandler,
    queryHandler = _ref.queryHandler,
    hasAnyQueryRun = _ref.hasAnyQueryRun,
    tableViewCount = _ref.tableViewCount,
    tableViewCountHandler = _ref.tableViewCountHandler,
    filterValues = _ref.filterValues,
    filterHandler = _ref.filterHandler,
    selectedEmployeeId = _ref.selectedEmployeeId,
    selectedEmployeeIdHandler = _ref.selectedEmployeeIdHandler;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement('div', {
    id: 'admin-view-container',
    className: 'container'
  }, React__default.createElement('div', null, React__default.createElement('div', {
    id: 'controls-container',
    className: 'container'
  }, React__default.createElement('div', {
    id: 'data-controls-container',
    className: 'container'
  }, queryDropDown(selectedDisplayView, displayViewPickerHandler, displayTypes), empIdField(selectedEmployeeId, selectedEmployeeIdHandler, selectedDisplayView), datePicker(selectedDate, datePickerHandler), React__default.createElement(Button, {
    id: 'submit-query-button',
    className: 'button-primary',
    loading: isDataLoading,
    onClick: function onClick() {
      return queryHandler();
    }
  }, 'Run Query')), React__default.createElement('div', {
    id: 'view-controls-container',
    className: 'container'
  }, filterMultiTextInput(filterValues, filterHandler), React__default.createElement(TableViewCountDropDown, {
    id: 'table-view-count-drop-down',
    value: tableViewCount,
    setValue: tableViewCountHandler
  }))), React__default.createElement('div', {
    id: 'view-container'
  }, React__default.createElement(DataViewContainerComponent, {
    metricDefinitionDisplays: metricDefinitionDisplays,
    payRuleDisplays: payRuleDisplays,
    payRecordDisplays: payRecordDisplays,
    payRecordDetailDisplays: payRecordDetailDisplays,
    tableViewCount: tableViewCount,
    selectedDate: selectedDate
  })))));
};
function createCommonjsModule$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols$1) {
      symbols = getOwnPropertySymbols$1(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/** @license React v0.19.1
 * scheduler-unstable_mock.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$3 = 0,
  g$3 = null,
  h$3 = null,
  k$2 = -1,
  l$3 = null,
  m$3 = -1,
  n$3 = !1,
  p$3 = !1,
  q$2 = !1,
  r$4 = !1;
function t$3() {
  return -1 !== m$3 && null !== l$3 && l$3.length >= m$3 || r$4 && q$2 ? n$3 = !0 : !1;
}
function x$3() {
  if (p$3) throw Error("Already flushing work.");
  if (null !== g$3) {
    var a = g$3;
    p$3 = !0;
    try {
      var b = !0;
      do b = a(!0, f$3); while (b);
      b || (g$3 = null);
      return !0;
    } finally {
      p$3 = !1;
    }
  } else return !1;
}
function z$3(a, b) {
  var c = a.length;
  a.push(b);
  a: for (;;) {
    var d = c - 1 >>> 1,
      e = a[d];
    if (void 0 !== e && 0 < A$3(e, b)) a[d] = b, a[c] = e, c = d;else break a;
  }
}
function B$1(a) {
  a = a[0];
  return void 0 === a ? null : a;
}
function C$2(a) {
  var b = a[0];
  if (void 0 !== b) {
    var c = a.pop();
    if (c !== b) {
      a[0] = c;
      a: for (var d = 0, e = a.length; d < e;) {
        var u = 2 * (d + 1) - 1,
          v = a[u],
          w = u + 1,
          y = a[w];
        if (void 0 !== v && 0 > A$3(v, c)) void 0 !== y && 0 > A$3(y, v) ? (a[d] = y, a[w] = c, d = w) : (a[d] = v, a[u] = c, d = u);else if (void 0 !== y && 0 > A$3(y, c)) a[d] = y, a[w] = c, d = w;else break a;
      }
    }
    return b;
  }
  return null;
}
function A$3(a, b) {
  var c = a.sortIndex - b.sortIndex;
  return 0 !== c ? c : a.id - b.id;
}
var D$2 = [],
  E$2 = [],
  F$1 = 1,
  G$1 = null,
  H$2 = 3,
  I$1 = !1,
  J$1 = !1,
  K$1 = !1;
function L$2(a) {
  for (var b = B$1(E$2); null !== b;) {
    if (null === b.callback) C$2(E$2);else if (b.startTime <= a) C$2(E$2), b.sortIndex = b.expirationTime, z$3(D$2, b);else break;
    b = B$1(E$2);
  }
}
function M$1(a) {
  K$1 = !1;
  L$2(a);
  if (!J$1) if (null !== B$1(D$2)) J$1 = !0, g$3 = N$1;else {
    var b = B$1(E$2);
    null !== b && (a = b.startTime - a, h$3 = M$1, k$2 = f$3 + a);
  }
}
function N$1(a, b) {
  J$1 = !1;
  K$1 && (K$1 = !1, h$3 = null, k$2 = -1);
  I$1 = !0;
  var c = H$2;
  try {
    L$2(b);
    for (G$1 = B$1(D$2); null !== G$1 && (!(G$1.expirationTime > b) || a && !t$3());) {
      var d = G$1.callback;
      if (null !== d) {
        G$1.callback = null;
        H$2 = G$1.priorityLevel;
        var e = d(G$1.expirationTime <= b);
        b = f$3;
        "function" === typeof e ? G$1.callback = e : G$1 === B$1(D$2) && C$2(D$2);
        L$2(b);
      } else C$2(D$2);
      G$1 = B$1(D$2);
    }
    if (null !== G$1) var u = !0;else {
      var v = B$1(E$2);
      if (null !== v) {
        var w = v.startTime - b;
        h$3 = M$1;
        k$2 = f$3 + w;
      }
      u = !1;
    }
    return u;
  } finally {
    G$1 = null, H$2 = c, I$1 = !1;
  }
}
function O$1(a) {
  switch (a) {
    case 1:
      return -1;
    case 2:
      return 250;
    case 5:
      return 1073741823;
    case 4:
      return 1E4;
    default:
      return 5E3;
  }
}
var unstable_IdlePriority = 5;
var unstable_ImmediatePriority = 1;
var unstable_LowPriority = 4;
var unstable_NormalPriority = 3;
var unstable_Profiling = null;
var unstable_UserBlockingPriority = 2;
var unstable_advanceTime = function unstable_advanceTime(a) {
  f$3 += a;
  null !== h$3 && k$2 <= f$3 && (h$3(f$3), k$2 = -1, h$3 = null);
};
var unstable_cancelCallback = function unstable_cancelCallback(a) {
  a.callback = null;
};
var unstable_clearYields = function unstable_clearYields() {
  if (null === l$3) return [];
  var a = l$3;
  l$3 = null;
  return a;
};
var unstable_continueExecution = function unstable_continueExecution() {
  J$1 || I$1 || (J$1 = !0, g$3 = N$1);
};
var unstable_flushAll = function unstable_flushAll() {
  if (null !== l$3) throw Error("Log is not empty. Assert on the log of yielded values before flushing additional work.");
  x$3();
  if (null !== l$3) throw Error("While flushing work, something yielded a value. Use an assertion helper to assert on the log of yielded values, e.g. expect(Scheduler).toFlushAndYield([...])");
};
var unstable_flushAllWithoutAsserting = x$3;
var unstable_flushExpired = function unstable_flushExpired() {
  if (p$3) throw Error("Already flushing work.");
  if (null !== g$3) {
    p$3 = !0;
    try {
      g$3(!1, f$3) || (g$3 = null);
    } finally {
      p$3 = !1;
    }
  }
};
var unstable_flushNumberOfYields = function unstable_flushNumberOfYields(a) {
  if (p$3) throw Error("Already flushing work.");
  if (null !== g$3) {
    var b = g$3;
    m$3 = a;
    p$3 = !0;
    try {
      a = !0;
      do a = b(!0, f$3); while (a && !n$3);
      a || (g$3 = null);
    } finally {
      m$3 = -1, p$3 = n$3 = !1;
    }
  }
};
var unstable_flushUntilNextPaint = function unstable_flushUntilNextPaint() {
  if (p$3) throw Error("Already flushing work.");
  if (null !== g$3) {
    var a = g$3;
    r$4 = !0;
    q$2 = !1;
    p$3 = !0;
    try {
      var b = !0;
      do b = a(!0, f$3); while (b && !n$3);
      b || (g$3 = null);
    } finally {
      p$3 = n$3 = r$4 = !1;
    }
  }
};
var unstable_forceFrameRate = function unstable_forceFrameRate() {};
var unstable_getCurrentPriorityLevel = function unstable_getCurrentPriorityLevel() {
  return H$2;
};
var unstable_getFirstCallbackNode = function unstable_getFirstCallbackNode() {
  return B$1(D$2);
};
var unstable_next = function unstable_next(a) {
  switch (H$2) {
    case 1:
    case 2:
    case 3:
      var b = 3;
      break;
    default:
      b = H$2;
  }
  var c = H$2;
  H$2 = b;
  try {
    return a();
  } finally {
    H$2 = c;
  }
};
var unstable_now = function unstable_now() {
  return f$3;
};
var unstable_pauseExecution = function unstable_pauseExecution() {};
var unstable_requestPaint = function unstable_requestPaint() {
  q$2 = !0;
};
var unstable_runWithPriority = function unstable_runWithPriority(a, b) {
  switch (a) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      break;
    default:
      a = 3;
  }
  var c = H$2;
  H$2 = a;
  try {
    return b();
  } finally {
    H$2 = c;
  }
};
var unstable_scheduleCallback = function unstable_scheduleCallback(a, b, c) {
  var d = f$3;
  if ("object" === typeof c && null !== c) {
    var e = c.delay;
    e = "number" === typeof e && 0 < e ? d + e : d;
    c = "number" === typeof c.timeout ? c.timeout : O$1(a);
  } else c = O$1(a), e = d;
  c = e + c;
  a = {
    id: F$1++,
    callback: b,
    priorityLevel: a,
    startTime: e,
    expirationTime: c,
    sortIndex: -1
  };
  e > d ? (a.sortIndex = e, z$3(E$2, a), null === B$1(D$2) && a === B$1(E$2) && (K$1 ? (h$3 = null, k$2 = -1) : K$1 = !0, h$3 = M$1, k$2 = f$3 + (e - d))) : (a.sortIndex = c, z$3(D$2, a), J$1 || I$1 || (J$1 = !0, g$3 = N$1));
  return a;
};
var unstable_shouldYield = function unstable_shouldYield() {
  var a = f$3;
  L$2(a);
  var b = B$1(D$2);
  return b !== G$1 && null !== G$1 && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < G$1.expirationTime || t$3();
};
var unstable_wrapCallback = function unstable_wrapCallback(a) {
  var b = H$2;
  return function () {
    var c = H$2;
    H$2 = b;
    try {
      return a.apply(this, arguments);
    } finally {
      H$2 = c;
    }
  };
};
var unstable_yieldValue = function unstable_yieldValue(a) {
  null === l$3 ? l$3 = [a] : l$3.push(a);
};
var schedulerUnstable_mock_production_min = {
  unstable_IdlePriority: unstable_IdlePriority,
  unstable_ImmediatePriority: unstable_ImmediatePriority,
  unstable_LowPriority: unstable_LowPriority,
  unstable_NormalPriority: unstable_NormalPriority,
  unstable_Profiling: unstable_Profiling,
  unstable_UserBlockingPriority: unstable_UserBlockingPriority,
  unstable_advanceTime: unstable_advanceTime,
  unstable_cancelCallback: unstable_cancelCallback,
  unstable_clearYields: unstable_clearYields,
  unstable_continueExecution: unstable_continueExecution,
  unstable_flushAll: unstable_flushAll,
  unstable_flushAllWithoutAsserting: unstable_flushAllWithoutAsserting,
  unstable_flushExpired: unstable_flushExpired,
  unstable_flushNumberOfYields: unstable_flushNumberOfYields,
  unstable_flushUntilNextPaint: unstable_flushUntilNextPaint,
  unstable_forceFrameRate: unstable_forceFrameRate,
  unstable_getCurrentPriorityLevel: unstable_getCurrentPriorityLevel,
  unstable_getFirstCallbackNode: unstable_getFirstCallbackNode,
  unstable_next: unstable_next,
  unstable_now: unstable_now,
  unstable_pauseExecution: unstable_pauseExecution,
  unstable_requestPaint: unstable_requestPaint,
  unstable_runWithPriority: unstable_runWithPriority,
  unstable_scheduleCallback: unstable_scheduleCallback,
  unstable_shouldYield: unstable_shouldYield,
  unstable_wrapCallback: unstable_wrapCallback,
  unstable_yieldValue: unstable_yieldValue
};
var schedulerUnstable_mock_development = createCommonjsModule$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var enableSchedulerDebugging = false;
      var currentTime = 0;
      var scheduledCallback = null;
      var scheduledTimeout = null;
      var timeoutTime = -1;
      var yieldedValues = null;
      var expectedNumberOfYields = -1;
      var didStop = false;
      var isFlushing = false;
      var needsPaint = false;
      var shouldYieldForPaint = false;
      function requestHostCallback(callback) {
        scheduledCallback = callback;
      }
      function requestHostTimeout(callback, ms) {
        scheduledTimeout = callback;
        timeoutTime = currentTime + ms;
      }
      function cancelHostTimeout() {
        scheduledTimeout = null;
        timeoutTime = -1;
      }
      function shouldYieldToHost() {
        if (expectedNumberOfYields !== -1 && yieldedValues !== null && yieldedValues.length >= expectedNumberOfYields || shouldYieldForPaint && needsPaint) {
          // We yielded at least as many values as expected. Stop flushing.
          didStop = true;
          return true;
        }
        return false;
      }
      function getCurrentTime() {
        return currentTime;
      }
      function forceFrameRate() {// No-op
      }
      function unstable_flushNumberOfYields(count) {
        if (isFlushing) {
          throw new Error('Already flushing work.');
        }
        if (scheduledCallback !== null) {
          var cb = scheduledCallback;
          expectedNumberOfYields = count;
          isFlushing = true;
          try {
            var hasMoreWork = true;
            do {
              hasMoreWork = cb(true, currentTime);
            } while (hasMoreWork && !didStop);
            if (!hasMoreWork) {
              scheduledCallback = null;
            }
          } finally {
            expectedNumberOfYields = -1;
            didStop = false;
            isFlushing = false;
          }
        }
      }
      function unstable_flushUntilNextPaint() {
        if (isFlushing) {
          throw new Error('Already flushing work.');
        }
        if (scheduledCallback !== null) {
          var cb = scheduledCallback;
          shouldYieldForPaint = true;
          needsPaint = false;
          isFlushing = true;
          try {
            var hasMoreWork = true;
            do {
              hasMoreWork = cb(true, currentTime);
            } while (hasMoreWork && !didStop);
            if (!hasMoreWork) {
              scheduledCallback = null;
            }
          } finally {
            shouldYieldForPaint = false;
            didStop = false;
            isFlushing = false;
          }
        }
      }
      function unstable_flushExpired() {
        if (isFlushing) {
          throw new Error('Already flushing work.');
        }
        if (scheduledCallback !== null) {
          isFlushing = true;
          try {
            var hasMoreWork = scheduledCallback(false, currentTime);
            if (!hasMoreWork) {
              scheduledCallback = null;
            }
          } finally {
            isFlushing = false;
          }
        }
      }
      function unstable_flushAllWithoutAsserting() {
        // Returns false if no work was flushed.
        if (isFlushing) {
          throw new Error('Already flushing work.');
        }
        if (scheduledCallback !== null) {
          var cb = scheduledCallback;
          isFlushing = true;
          try {
            var hasMoreWork = true;
            do {
              hasMoreWork = cb(true, currentTime);
            } while (hasMoreWork);
            if (!hasMoreWork) {
              scheduledCallback = null;
            }
            return true;
          } finally {
            isFlushing = false;
          }
        } else {
          return false;
        }
      }
      function unstable_clearYields() {
        if (yieldedValues === null) {
          return [];
        }
        var values = yieldedValues;
        yieldedValues = null;
        return values;
      }
      function unstable_flushAll() {
        if (yieldedValues !== null) {
          throw new Error('Log is not empty. Assert on the log of yielded values before ' + 'flushing additional work.');
        }
        unstable_flushAllWithoutAsserting();
        if (yieldedValues !== null) {
          throw new Error('While flushing work, something yielded a value. Use an ' + 'assertion helper to assert on the log of yielded values, e.g. ' + 'expect(Scheduler).toFlushAndYield([...])');
        }
      }
      function unstable_yieldValue(value) {
        if (yieldedValues === null) {
          yieldedValues = [value];
        } else {
          yieldedValues.push(value);
        }
      }
      function unstable_advanceTime(ms) {
        currentTime += ms;
        if (scheduledTimeout !== null && timeoutTime <= currentTime) {
          scheduledTimeout(currentTime);
          timeoutTime = -1;
          scheduledTimeout = null;
        }
      }
      function requestPaint() {
        needsPaint = true;
      }
      function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
      }
      function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
      }
      function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
          var last = heap.pop();
          if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
          }
          return first;
        } else {
          return null;
        }
      }
      function siftUp(heap, node, i) {
        var index = i;
        while (true) {
          var parentIndex = index - 1 >>> 1;
          var parent = heap[parentIndex];
          if (parent !== undefined && compare(parent, node) > 0) {
            // The parent is larger. Swap positions.
            heap[parentIndex] = node;
            heap[index] = parent;
            index = parentIndex;
          } else {
            // The parent is smaller. Exit.
            return;
          }
        }
      }
      function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while (index < length) {
          var leftIndex = (index + 1) * 2 - 1;
          var left = heap[leftIndex];
          var rightIndex = leftIndex + 1;
          var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

          if (left !== undefined && compare(left, node) < 0) {
            if (right !== undefined && compare(right, left) < 0) {
              heap[index] = right;
              heap[rightIndex] = node;
              index = rightIndex;
            } else {
              heap[index] = left;
              heap[leftIndex] = node;
              index = leftIndex;
            }
          } else if (right !== undefined && compare(right, node) < 0) {
            heap[index] = right;
            heap[rightIndex] = node;
            index = rightIndex;
          } else {
            // Neither child is smaller. Exit.
            return;
          }
        }
      }
      function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
      }

      // TODO: Use symbols?
      var NoPriority = 0;
      var ImmediatePriority = 1;
      var UserBlockingPriority = 2;
      var NormalPriority = 3;
      var LowPriority = 4;
      var IdlePriority = 5;
      var runIdCounter = 0;
      var mainThreadIdCounter = 0;
      var profilingStateSize = 4;
      var sharedProfilingBuffer =
      // $FlowFixMe Flow doesn't know about SharedArrayBuffer
      typeof SharedArrayBuffer === 'function' ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) :
      // $FlowFixMe Flow doesn't know about ArrayBuffer
      typeof ArrayBuffer === 'function' ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
      ;

      var profilingState = sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks

      var PRIORITY = 0;
      var CURRENT_TASK_ID = 1;
      var CURRENT_RUN_ID = 2;
      var QUEUE_SIZE = 3;
      {
        profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
        // array might include canceled tasks.

        profilingState[QUEUE_SIZE] = 0;
        profilingState[CURRENT_TASK_ID] = 0;
      } // Bytes per element is 4

      var INITIAL_EVENT_LOG_SIZE = 131072;
      var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes

      var eventLogSize = 0;
      var eventLogBuffer = null;
      var eventLog = null;
      var eventLogIndex = 0;
      var TaskStartEvent = 1;
      var TaskCompleteEvent = 2;
      var TaskErrorEvent = 3;
      var TaskCancelEvent = 4;
      var TaskRunEvent = 5;
      var TaskYieldEvent = 6;
      var SchedulerSuspendEvent = 7;
      var SchedulerResumeEvent = 8;
      function logEvent(entries) {
        if (eventLog !== null) {
          var offset = eventLogIndex;
          eventLogIndex += entries.length;
          if (eventLogIndex + 1 > eventLogSize) {
            eventLogSize *= 2;
            if (eventLogSize > MAX_EVENT_LOG_SIZE) {
              // Using console['error'] to evade Babel and ESLint
              console['error']("Scheduler Profiling: Event log exceeded maximum size. Don't " + 'forget to call `stopLoggingProfilingEvents()`.');
              stopLoggingProfilingEvents();
              return;
            }
            var newEventLog = new Int32Array(eventLogSize * 4);
            newEventLog.set(eventLog);
            eventLogBuffer = newEventLog.buffer;
            eventLog = newEventLog;
          }
          eventLog.set(entries, offset);
        }
      }
      function startLoggingProfilingEvents() {
        eventLogSize = INITIAL_EVENT_LOG_SIZE;
        eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
        eventLog = new Int32Array(eventLogBuffer);
        eventLogIndex = 0;
      }
      function stopLoggingProfilingEvents() {
        var buffer = eventLogBuffer;
        eventLogSize = 0;
        eventLogBuffer = null;
        eventLog = null;
        eventLogIndex = 0;
        return buffer;
      }
      function markTaskStart(task, ms) {
        {
          profilingState[QUEUE_SIZE]++;
          if (eventLog !== null) {
            // performance.now returns a float, representing milliseconds. When the
            // event is logged, it's coerced to an int. Convert to microseconds to
            // maintain extra degrees of precision.
            logEvent([TaskStartEvent, ms * 1000, task.id, task.priorityLevel]);
          }
        }
      }
      function markTaskCompleted(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskCompleteEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskCanceled(task, ms) {
        {
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskCancelEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskErrored(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskErrorEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskRun(task, ms) {
        {
          runIdCounter++;
          profilingState[PRIORITY] = task.priorityLevel;
          profilingState[CURRENT_TASK_ID] = task.id;
          profilingState[CURRENT_RUN_ID] = runIdCounter;
          if (eventLog !== null) {
            logEvent([TaskRunEvent, ms * 1000, task.id, runIdCounter]);
          }
        }
      }
      function markTaskYield(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[CURRENT_RUN_ID] = 0;
          if (eventLog !== null) {
            logEvent([TaskYieldEvent, ms * 1000, task.id, runIdCounter]);
          }
        }
      }
      function markSchedulerSuspended(ms) {
        {
          mainThreadIdCounter++;
          if (eventLog !== null) {
            logEvent([SchedulerSuspendEvent, ms * 1000, mainThreadIdCounter]);
          }
        }
      }
      function markSchedulerUnsuspended(ms) {
        {
          if (eventLog !== null) {
            logEvent([SchedulerResumeEvent, ms * 1000, mainThreadIdCounter]);
          }
        }
      }

      /* eslint-disable no-var */
      // Math.pow(2, 30) - 1
      // 0b111111111111111111111111111111

      var maxSigned31BitInt = 1073741823; // Times out immediately

      var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

      var USER_BLOCKING_PRIORITY = 250;
      var NORMAL_PRIORITY_TIMEOUT = 5000;
      var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

      var IDLE_PRIORITY = maxSigned31BitInt; // Tasks are stored on a min heap

      var taskQueue = [];
      var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

      var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
      var currentTask = null;
      var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

      var isPerformingWork = false;
      var isHostCallbackScheduled = false;
      var isHostTimeoutScheduled = false;
      function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while (timer !== null) {
          if (timer.callback === null) {
            // Timer was cancelled.
            pop(timerQueue);
          } else if (timer.startTime <= currentTime) {
            // Timer fired. Transfer to the task queue.
            pop(timerQueue);
            timer.sortIndex = timer.expirationTime;
            push(taskQueue, timer);
            {
              markTaskStart(timer, currentTime);
              timer.isQueued = true;
            }
          } else {
            // Remaining timers are pending.
            return;
          }
          timer = peek(timerQueue);
        }
      }
      function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
          if (peek(taskQueue) !== null) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          } else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
          }
        }
      }
      function flushWork(hasTimeRemaining, initialTime) {
        {
          markSchedulerUnsuspended(initialTime);
        } // We'll need a host callback the next time work is scheduled.

        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
          // We scheduled a timeout but it's no longer needed. Cancel it.
          isHostTimeoutScheduled = false;
          cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
          {
            try {
              return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
              if (currentTask !== null) {
                var currentTime = getCurrentTime();
                markTaskErrored(currentTask, currentTime);
                currentTask.isQueued = false;
              }
              throw error;
            }
          }
        } finally {
          currentTask = null;
          currentPriorityLevel = previousPriorityLevel;
          isPerformingWork = false;
          {
            var _currentTime = getCurrentTime();
            markSchedulerSuspended(_currentTime);
          }
        }
      }
      function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while (currentTask !== null && !enableSchedulerDebugging) {
          if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
            // This currentTask hasn't expired, and we've reached the deadline.
            break;
          }
          var callback = currentTask.callback;
          if (callback !== null) {
            currentTask.callback = null;
            currentPriorityLevel = currentTask.priorityLevel;
            var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
            markTaskRun(currentTask, currentTime);
            var continuationCallback = callback(didUserCallbackTimeout);
            currentTime = getCurrentTime();
            if (typeof continuationCallback === 'function') {
              currentTask.callback = continuationCallback;
              markTaskYield(currentTask, currentTime);
            } else {
              {
                markTaskCompleted(currentTask, currentTime);
                currentTask.isQueued = false;
              }
              if (currentTask === peek(taskQueue)) {
                pop(taskQueue);
              }
            }
            advanceTimers(currentTime);
          } else {
            pop(taskQueue);
          }
          currentTask = peek(taskQueue);
        } // Return whether there's additional work

        if (currentTask !== null) {
          return true;
        } else {
          var firstTimer = peek(timerQueue);
          if (firstTimer !== null) {
            requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
          }
          return false;
        }
      }
      function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
          case LowPriority:
          case IdlePriority:
            break;
          default:
            priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }
      function unstable_next(eventHandler) {
        var priorityLevel;
        switch (currentPriorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
            // Shift down to normal priority
            priorityLevel = NormalPriority;
            break;
          default:
            // Anything lower than normal priority should remain at the current level.
            priorityLevel = currentPriorityLevel;
            break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }
      function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function () {
          // This is a fork of runWithPriority, inlined for performance.
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;
          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      }
      function timeoutForPriorityLevel(priorityLevel) {
        switch (priorityLevel) {
          case ImmediatePriority:
            return IMMEDIATE_PRIORITY_TIMEOUT;
          case UserBlockingPriority:
            return USER_BLOCKING_PRIORITY;
          case IdlePriority:
            return IDLE_PRIORITY;
          case LowPriority:
            return LOW_PRIORITY_TIMEOUT;
          case NormalPriority:
          default:
            return NORMAL_PRIORITY_TIMEOUT;
        }
      }
      function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = getCurrentTime();
        var startTime;
        var timeout;
        if (typeof options === 'object' && options !== null) {
          var delay = options.delay;
          if (typeof delay === 'number' && delay > 0) {
            startTime = currentTime + delay;
          } else {
            startTime = currentTime;
          }
          timeout = typeof options.timeout === 'number' ? options.timeout : timeoutForPriorityLevel(priorityLevel);
        } else {
          timeout = timeoutForPriorityLevel(priorityLevel);
          startTime = currentTime;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
          id: taskIdCounter++,
          callback: callback,
          priorityLevel: priorityLevel,
          startTime: startTime,
          expirationTime: expirationTime,
          sortIndex: -1
        };
        {
          newTask.isQueued = false;
        }
        if (startTime > currentTime) {
          // This is a delayed task.
          newTask.sortIndex = startTime;
          push(timerQueue, newTask);
          if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
            // All tasks are delayed, and this is the task with the earliest delay.
            if (isHostTimeoutScheduled) {
              // Cancel an existing timeout.
              cancelHostTimeout();
            } else {
              isHostTimeoutScheduled = true;
            } // Schedule a timeout.

            requestHostTimeout(handleTimeout, startTime - currentTime);
          }
        } else {
          newTask.sortIndex = expirationTime;
          push(taskQueue, newTask);
          {
            markTaskStart(newTask, currentTime);
            newTask.isQueued = true;
          } // Schedule a host callback, if needed. If we're already performing work,
          // wait until the next time we yield.

          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          }
        }
        return newTask;
      }
      function unstable_pauseExecution() {}
      function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
          isHostCallbackScheduled = true;
          requestHostCallback(flushWork);
        }
      }
      function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
      }
      function unstable_cancelCallback(task) {
        {
          if (task.isQueued) {
            var currentTime = getCurrentTime();
            markTaskCanceled(task, currentTime);
            task.isQueued = false;
          }
        } // Null out the callback to indicate the task has been canceled. (Can't
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)

        task.callback = null;
      }
      function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
      }
      function unstable_shouldYield() {
        var currentTime = getCurrentTime();
        advanceTimers(currentTime);
        var firstTask = peek(taskQueue);
        return firstTask !== currentTask && currentTask !== null && firstTask !== null && firstTask.callback !== null && firstTask.startTime <= currentTime && firstTask.expirationTime < currentTask.expirationTime || shouldYieldToHost();
      }
      var unstable_requestPaint = requestPaint;
      var unstable_Profiling = {
        startLoggingProfilingEvents: startLoggingProfilingEvents,
        stopLoggingProfilingEvents: stopLoggingProfilingEvents,
        sharedProfilingBuffer: sharedProfilingBuffer
      };
      exports.unstable_IdlePriority = IdlePriority;
      exports.unstable_ImmediatePriority = ImmediatePriority;
      exports.unstable_LowPriority = LowPriority;
      exports.unstable_NormalPriority = NormalPriority;
      exports.unstable_Profiling = unstable_Profiling;
      exports.unstable_UserBlockingPriority = UserBlockingPriority;
      exports.unstable_advanceTime = unstable_advanceTime;
      exports.unstable_cancelCallback = unstable_cancelCallback;
      exports.unstable_clearYields = unstable_clearYields;
      exports.unstable_continueExecution = unstable_continueExecution;
      exports.unstable_flushAll = unstable_flushAll;
      exports.unstable_flushAllWithoutAsserting = unstable_flushAllWithoutAsserting;
      exports.unstable_flushExpired = unstable_flushExpired;
      exports.unstable_flushNumberOfYields = unstable_flushNumberOfYields;
      exports.unstable_flushUntilNextPaint = unstable_flushUntilNextPaint;
      exports.unstable_forceFrameRate = forceFrameRate;
      exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
      exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
      exports.unstable_next = unstable_next;
      exports.unstable_now = getCurrentTime;
      exports.unstable_pauseExecution = unstable_pauseExecution;
      exports.unstable_requestPaint = unstable_requestPaint;
      exports.unstable_runWithPriority = unstable_runWithPriority;
      exports.unstable_scheduleCallback = unstable_scheduleCallback;
      exports.unstable_shouldYield = unstable_shouldYield;
      exports.unstable_wrapCallback = unstable_wrapCallback;
      exports.unstable_yieldValue = unstable_yieldValue;
    })();
  }
});
var schedulerUnstable_mock_development_1 = schedulerUnstable_mock_development.unstable_IdlePriority;
var schedulerUnstable_mock_development_2 = schedulerUnstable_mock_development.unstable_ImmediatePriority;
var schedulerUnstable_mock_development_3 = schedulerUnstable_mock_development.unstable_LowPriority;
var schedulerUnstable_mock_development_4 = schedulerUnstable_mock_development.unstable_NormalPriority;
var schedulerUnstable_mock_development_5 = schedulerUnstable_mock_development.unstable_Profiling;
var schedulerUnstable_mock_development_6 = schedulerUnstable_mock_development.unstable_UserBlockingPriority;
var schedulerUnstable_mock_development_7 = schedulerUnstable_mock_development.unstable_advanceTime;
var schedulerUnstable_mock_development_8 = schedulerUnstable_mock_development.unstable_cancelCallback;
var schedulerUnstable_mock_development_9 = schedulerUnstable_mock_development.unstable_clearYields;
var schedulerUnstable_mock_development_10 = schedulerUnstable_mock_development.unstable_continueExecution;
var schedulerUnstable_mock_development_11 = schedulerUnstable_mock_development.unstable_flushAll;
var schedulerUnstable_mock_development_12 = schedulerUnstable_mock_development.unstable_flushAllWithoutAsserting;
var schedulerUnstable_mock_development_13 = schedulerUnstable_mock_development.unstable_flushExpired;
var schedulerUnstable_mock_development_14 = schedulerUnstable_mock_development.unstable_flushNumberOfYields;
var schedulerUnstable_mock_development_15 = schedulerUnstable_mock_development.unstable_flushUntilNextPaint;
var schedulerUnstable_mock_development_16 = schedulerUnstable_mock_development.unstable_forceFrameRate;
var schedulerUnstable_mock_development_17 = schedulerUnstable_mock_development.unstable_getCurrentPriorityLevel;
var schedulerUnstable_mock_development_18 = schedulerUnstable_mock_development.unstable_getFirstCallbackNode;
var schedulerUnstable_mock_development_19 = schedulerUnstable_mock_development.unstable_next;
var schedulerUnstable_mock_development_20 = schedulerUnstable_mock_development.unstable_now;
var schedulerUnstable_mock_development_21 = schedulerUnstable_mock_development.unstable_pauseExecution;
var schedulerUnstable_mock_development_22 = schedulerUnstable_mock_development.unstable_requestPaint;
var schedulerUnstable_mock_development_23 = schedulerUnstable_mock_development.unstable_runWithPriority;
var schedulerUnstable_mock_development_24 = schedulerUnstable_mock_development.unstable_scheduleCallback;
var schedulerUnstable_mock_development_25 = schedulerUnstable_mock_development.unstable_shouldYield;
var schedulerUnstable_mock_development_26 = schedulerUnstable_mock_development.unstable_wrapCallback;
var schedulerUnstable_mock_development_27 = schedulerUnstable_mock_development.unstable_yieldValue;
var unstable_mock = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = schedulerUnstable_mock_production_min;
  } else {
    module.exports = schedulerUnstable_mock_development;
  }
});
var n$1$1 = "function" === typeof Symbol && Symbol.for,
  p$1$1 = n$1$1 ? Symbol.for("react.element") : 60103,
  q$1$1 = n$1$1 ? Symbol.for("react.portal") : 60106,
  r$1$1 = n$1$1 ? Symbol.for("react.fragment") : 60107,
  t$1$1 = n$1$1 ? Symbol.for("react.strict_mode") : 60108,
  u$1 = n$1$1 ? Symbol.for("react.profiler") : 60114,
  v$3 = n$1$1 ? Symbol.for("react.provider") : 60109,
  w$3 = n$1$1 ? Symbol.for("react.context") : 60110,
  x$1$1 = n$1$1 ? Symbol.for("react.forward_ref") : 60112,
  y$3 = n$1$1 ? Symbol.for("react.suspense") : 60113,
  z$1$1 = n$1$1 ? Symbol.for("react.memo") : 60115,
  A$1$1 = n$1$1 ? Symbol.for("react.lazy") : 60116,
  B$1$1 = "function" === typeof Symbol && Symbol.iterator;
function C$1$1(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var D$1$1 = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
  E$1$1 = {};
function F$1$1(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = E$1$1;
  this.updater = c || D$1$1;
}
F$1$1.prototype.isReactComponent = {};
F$1$1.prototype.setState = function (a, b) {
  if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(C$1$1(85));
  this.updater.enqueueSetState(this, a, b, "setState");
};
F$1$1.prototype.forceUpdate = function (a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function G$1$1() {}
G$1$1.prototype = F$1$1.prototype;
function H$1$1(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = E$1$1;
  this.updater = c || D$1$1;
}
var I$1$1 = H$1$1.prototype = new G$1$1();
I$1$1.constructor = H$1$1;
objectAssign(I$1$1, F$1$1.prototype);
I$1$1.isPureReactComponent = !0;
var J$1$1 = {
    current: null
  },
  K$1$1 = Object.prototype.hasOwnProperty,
  L$1$1 = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function M$1$1(a, b, c) {
  var e,
    d = {},
    g = null,
    k = null;
  if (null != b) for (e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b) K$1$1.call(b, e) && !L$1$1.hasOwnProperty(e) && (d[e] = b[e]);
  var f = arguments.length - 2;
  if (1 === f) d.children = c;else if (1 < f) {
    for (var h = Array(f), m = 0; m < f; m++) h[m] = arguments[m + 2];
    d.children = h;
  }
  if (a && a.defaultProps) for (e in f = a.defaultProps, f) void 0 === d[e] && (d[e] = f[e]);
  return {
    $$typeof: p$1$1,
    type: a,
    key: g,
    ref: k,
    props: d,
    _owner: J$1$1.current
  };
}
function N$1$1(a, b) {
  return {
    $$typeof: p$1$1,
    type: a.type,
    key: b,
    ref: a.ref,
    props: a.props,
    _owner: a._owner
  };
}
function O$1$1(a) {
  return "object" === typeof a && null !== a && a.$$typeof === p$1$1;
}
function escape(a) {
  var b = {
    "=": "=0",
    ":": "=2"
  };
  return "$" + ("" + a).replace(/[=:]/g, function (a) {
    return b[a];
  });
}
var P$2 = /\/+/g,
  Q$1 = [];
function R$2(a, b, c, e) {
  if (Q$1.length) {
    var d = Q$1.pop();
    d.result = a;
    d.keyPrefix = b;
    d.func = c;
    d.context = e;
    d.count = 0;
    return d;
  }
  return {
    result: a,
    keyPrefix: b,
    func: c,
    context: e,
    count: 0
  };
}
function S$2(a) {
  a.result = null;
  a.keyPrefix = null;
  a.func = null;
  a.context = null;
  a.count = 0;
  10 > Q$1.length && Q$1.push(a);
}
function T$2(a, b, c, e) {
  var d = typeof a;
  if ("undefined" === d || "boolean" === d) a = null;
  var g = !1;
  if (null === a) g = !0;else switch (d) {
    case "string":
    case "number":
      g = !0;
      break;
    case "object":
      switch (a.$$typeof) {
        case p$1$1:
        case q$1$1:
          g = !0;
      }
  }
  if (g) return c(e, a, "" === b ? "." + U$1(a, 0) : b), 1;
  g = 0;
  b = "" === b ? "." : b + ":";
  if (Array.isArray(a)) for (var k = 0; k < a.length; k++) {
    d = a[k];
    var f = b + U$1(d, k);
    g += T$2(d, f, c, e);
  } else if (null === a || "object" !== typeof a ? f = null : (f = B$1$1 && a[B$1$1] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for (a = f.call(a), k = 0; !(d = a.next()).done;) d = d.value, f = b + U$1(d, k++), g += T$2(d, f, c, e);else if ("object" === d) throw c = "" + a, Error(C$1$1(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
  return g;
}
function V$1(a, b, c) {
  return null == a ? 0 : T$2(a, "", b, c);
}
function U$1(a, b) {
  return "object" === typeof a && null !== a && null != a.key ? escape(a.key) : b.toString(36);
}
function W$1(a, b) {
  a.func.call(a.context, b, a.count++);
}
function aa(a, b, c) {
  var e = a.result,
    d = a.keyPrefix;
  a = a.func.call(a.context, b, a.count++);
  Array.isArray(a) ? X$1(a, e, c, function (a) {
    return a;
  }) : null != a && (O$1$1(a) && (a = N$1$1(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(P$2, "$&/") + "/") + c)), e.push(a));
}
function X$1(a, b, c, e, d) {
  var g = "";
  null != c && (g = ("" + c).replace(P$2, "$&/") + "/");
  b = R$2(b, g, e, d);
  V$1(a, aa, b);
  S$2(b);
}
var Y$1 = {
  current: null
};
function Z$1() {
  var a = Y$1.current;
  if (null === a) throw Error(C$1$1(321));
  return a;
}
var ba = {
  ReactCurrentDispatcher: Y$1,
  ReactCurrentBatchConfig: {
    suspense: null
  },
  ReactCurrentOwner: J$1$1,
  IsSomeRendererActing: {
    current: !1
  },
  assign: objectAssign
};
var Children$1 = {
  map: function map(a, b, c) {
    if (null == a) return a;
    var e = [];
    X$1(a, e, null, b, c);
    return e;
  },
  forEach: function forEach(a, b, c) {
    if (null == a) return a;
    b = R$2(null, null, b, c);
    V$1(a, W$1, b);
    S$2(b);
  },
  count: function count(a) {
    return V$1(a, function () {
      return null;
    }, null);
  },
  toArray: function toArray(a) {
    var b = [];
    X$1(a, b, null, function (a) {
      return a;
    });
    return b;
  },
  only: function only(a) {
    if (!O$1$1(a)) throw Error(C$1$1(143));
    return a;
  }
};
var Component = F$1$1;
var Fragment$2 = r$1$1;
var Profiler$1 = u$1;
var PureComponent = H$1$1;
var StrictMode$1 = t$1$1;
var Suspense$1 = y$3;
var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ba;
var cloneElement$1 = function cloneElement$1(a, b, c) {
  if (null === a || void 0 === a) throw Error(C$1$1(267, a));
  var e = objectAssign({}, a.props),
    d = a.key,
    g = a.ref,
    k = a._owner;
  if (null != b) {
    void 0 !== b.ref && (g = b.ref, k = J$1$1.current);
    void 0 !== b.key && (d = "" + b.key);
    if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
    for (h in b) K$1$1.call(b, h) && !L$1$1.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
  }
  var h = arguments.length - 2;
  if (1 === h) e.children = c;else if (1 < h) {
    f = Array(h);
    for (var m = 0; m < h; m++) f[m] = arguments[m + 2];
    e.children = f;
  }
  return {
    $$typeof: p$1$1,
    type: a.type,
    key: d,
    ref: g,
    props: e,
    _owner: k
  };
};
var createContext$2 = function createContext$2(a, b) {
  void 0 === b && (b = null);
  a = {
    $$typeof: w$3,
    _calculateChangedBits: b,
    _currentValue: a,
    _currentValue2: a,
    _threadCount: 0,
    Provider: null,
    Consumer: null
  };
  a.Provider = {
    $$typeof: v$3,
    _context: a
  };
  return a.Consumer = a;
};
var createElement$1 = M$1$1;
var createFactory = function createFactory(a) {
  var b = M$1$1.bind(null, a);
  b.type = a;
  return b;
};
var createRef = function createRef() {
  return {
    current: null
  };
};
var forwardRef$1 = function forwardRef$1(a) {
  return {
    $$typeof: x$1$1,
    render: a
  };
};
var isValidElement$1 = O$1$1;
var lazy = function lazy(a) {
  return {
    $$typeof: A$1$1,
    _ctor: a,
    _status: -1,
    _result: null
  };
};
var memo = function memo(a, b) {
  return {
    $$typeof: z$1$1,
    type: a,
    compare: void 0 === b ? null : b
  };
};
var useCallback$1 = function useCallback$1(a, b) {
  return Z$1().useCallback(a, b);
};
var useContext$1 = function useContext$1(a, b) {
  return Z$1().useContext(a, b);
};
var useDebugValue = function useDebugValue() {};
var useEffect$1 = function useEffect$1(a, b) {
  return Z$1().useEffect(a, b);
};
var useImperativeHandle = function useImperativeHandle(a, b, c) {
  return Z$1().useImperativeHandle(a, b, c);
};
var useLayoutEffect$2 = function useLayoutEffect$2(a, b) {
  return Z$1().useLayoutEffect(a, b);
};
var useMemo$1 = function useMemo$1(a, b) {
  return Z$1().useMemo(a, b);
};
var useReducer$1 = function useReducer$1(a, b, c) {
  return Z$1().useReducer(a, b, c);
};
var useRef$1 = function useRef$1(a) {
  return Z$1().useRef(a);
};
var useState$1 = function useState$1(a) {
  return Z$1().useState(a);
};
var version = "16.13.1";
var react_production_min = {
  Children: Children$1,
  Component: Component,
  Fragment: Fragment$2,
  Profiler: Profiler$1,
  PureComponent: PureComponent,
  StrictMode: StrictMode$1,
  Suspense: Suspense$1,
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  cloneElement: cloneElement$1,
  createContext: createContext$2,
  createElement: createElement$1,
  createFactory: createFactory,
  createRef: createRef,
  forwardRef: forwardRef$1,
  isValidElement: isValidElement$1,
  lazy: lazy,
  memo: memo,
  useCallback: useCallback$1,
  useContext: useContext$1,
  useDebugValue: useDebugValue,
  useEffect: useEffect$1,
  useImperativeHandle: useImperativeHandle,
  useLayoutEffect: useLayoutEffect$2,
  useMemo: useMemo$1,
  useReducer: useReducer$1,
  useRef: useRef$1,
  useState: useState$1,
  version: version
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var printWarning$1 = function printWarning$1() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;
var react_development = createCommonjsModule$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var _assign = objectAssign;
      var checkPropTypes = checkPropTypes_1;
      var ReactVersion = '16.13.1';

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }
        return null;
      }

      /**
       * Keeps track of the current dispatcher.
       */
      var ReactCurrentDispatcher = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      };

      /**
       * Keeps track of the current batch's configuration such as how long an update
       * should suspend for if it needs to.
       */
      var ReactCurrentBatchConfig = {
        suspense: null
      };

      /**
       * Keeps track of the current owner.
       *
       * The current owner is the component who should own any components that are
       * currently being constructed.
       */
      var ReactCurrentOwner = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      };
      var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
      function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = '';
        if (source) {
          var path = source.fileName;
          var fileName = path.replace(BEFORE_SLASH_RE, '');
          {
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
              var match = path.match(BEFORE_SLASH_RE);
              if (match) {
                var pathBeforeSlash = match[1];
                if (pathBeforeSlash) {
                  var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
                  fileName = folderName + '/' + fileName;
                }
              }
            }
          }
          sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
        } else if (ownerName) {
          sourceInfo = ' (created by ' + ownerName + ')';
        }
        return '\n    in ' + (name || 'Unknown') + sourceInfo;
      }
      var Resolved = 1;
      function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }
      function getComponentName(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }
        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }
        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }
        if (typeof type === 'string') {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';
          case REACT_PORTAL_TYPE:
            return 'Portal';
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';
          case REACT_SUSPENSE_TYPE:
            return 'Suspense';
          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }
        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              return 'Context.Consumer';
            case REACT_PROVIDER_TYPE:
              return 'Context.Provider';
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
              return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
              return getComponentName(type.render);
            case REACT_LAZY_TYPE:
              {
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
                break;
              }
          }
        }
        return null;
      }
      var ReactDebugCurrentFrame = {};
      var currentlyValidatingElement = null;
      function setCurrentlyValidatingElement(element) {
        {
          currentlyValidatingElement = element;
        }
      }
      {
        // Stack implementation injected by the current renderer.
        ReactDebugCurrentFrame.getCurrentStack = null;
        ReactDebugCurrentFrame.getStackAddendum = function () {
          var stack = ''; // Add an extra top frame while an element is being validated

          if (currentlyValidatingElement) {
            var name = getComponentName(currentlyValidatingElement.type);
            var owner = currentlyValidatingElement._owner;
            stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
          } // Delegate to the injected renderer-specific implementation

          var impl = ReactDebugCurrentFrame.getCurrentStack;
          if (impl) {
            stack += impl() || '';
          }
          return stack;
        };
      }

      /**
       * Used by act() to track whether you're inside an act() scope.
       */
      var IsSomeRendererActing = {
        current: false
      };
      var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner,
        IsSomeRendererActing: IsSomeRendererActing,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: _assign
      };
      {
        _assign(ReactSharedInternals, {
          // These should not be included in production.
          ReactDebugCurrentFrame: ReactDebugCurrentFrame,
          // Shim for React DOM 16.0.0 which still destructured (but not used) this.
          // TODO: remove in React 17.0.
          ReactComponentTreeHook: {}
        });
      }

      // by calls to these methods by a Babel plugin.
      //
      // In PROD (or in packages without access to React internals),
      // they are left as they are instead.

      function warn(format) {
        {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          printWarning('warn', format, args);
        }
      }
      function error(format) {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          printWarning('error', format, args);
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;
          if (!hasExistingStack) {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== '') {
              format += '%s';
              args = args.concat([stack]);
            }
          }
          var argsWithFormat = args.map(function (item) {
            return '' + item;
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });
            throw new Error(message);
          } catch (x) {}
        }
      }
      var didWarnStateUpdateForUnmountedComponent = {};
      function warnNoop(publicInstance, callerName) {
        {
          var _constructor = publicInstance.constructor;
          var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
          var warningKey = componentName + "." + callerName;
          if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
            return;
          }
          error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);
          didWarnStateUpdateForUnmountedComponent[warningKey] = true;
        }
      }
      /**
       * This is the abstract API for an update queue.
       */

      var ReactNoopUpdateQueue = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function isMounted(publicInstance) {
          return false;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function enqueueForceUpdate(publicInstance, callback, callerName) {
          warnNoop(publicInstance, 'forceUpdate');
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState, callback, callerName) {
          warnNoop(publicInstance, 'replaceState');
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function enqueueSetState(publicInstance, partialState, callback, callerName) {
          warnNoop(publicInstance, 'setState');
        }
      };
      var emptyObject = {};
      {
        Object.freeze(emptyObject);
      }
      /**
       * Base class helpers for the updating state of a component.
       */

      function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.

        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.

        this.updater = updater || ReactNoopUpdateQueue;
      }
      Component.prototype.isReactComponent = {};
      /**
       * Sets a subset of the state. Always use this to mutate
       * state. You should treat `this.state` as immutable.
       *
       * There is no guarantee that `this.state` will be immediately updated, so
       * accessing `this.state` after calling this method may return the old value.
       *
       * There is no guarantee that calls to `setState` will run synchronously,
       * as they may eventually be batched together.  You can provide an optional
       * callback that will be executed when the call to setState is actually
       * completed.
       *
       * When a function is provided to setState, it will be called at some point in
       * the future (not synchronously). It will be called with the up to date
       * component arguments (state, props, context). These values can be different
       * from this.* because your function may be called after receiveProps but before
       * shouldComponentUpdate, and this new state, props, and context will not yet be
       * assigned to this.
       *
       * @param {object|function} partialState Next partial state or function to
       *        produce next partial state to be merged with current state.
       * @param {?function} callback Called after state is updated.
       * @final
       * @protected
       */

      Component.prototype.setState = function (partialState, callback) {
        if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
          {
            throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
          }
        }
        this.updater.enqueueSetState(this, partialState, callback, 'setState');
      };
      /**
       * Forces an update. This should only be invoked when it is known with
       * certainty that we are **not** in a DOM transaction.
       *
       * You may want to call this when you know that some deeper aspect of the
       * component's state has changed but `setState` was not called.
       *
       * This will not invoke `shouldComponentUpdate`, but it will invoke
       * `componentWillUpdate` and `componentDidUpdate`.
       *
       * @param {?function} callback Called after update is complete.
       * @final
       * @protected
       */

      Component.prototype.forceUpdate = function (callback) {
        this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
      };
      /**
       * Deprecated APIs. These APIs used to exist on classic React classes but since
       * we would like to deprecate them, we're not going to move them over to this
       * modern base class. Instead, we define a getter that warns if it's accessed.
       */

      {
        var deprecatedAPIs = {
          isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
          replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
        };
        var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
          Object.defineProperty(Component.prototype, methodName, {
            get: function get() {
              warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
              return undefined;
            }
          });
        };
        for (var fnName in deprecatedAPIs) {
          if (deprecatedAPIs.hasOwnProperty(fnName)) {
            defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
          }
        }
      }
      function ComponentDummy() {}
      ComponentDummy.prototype = Component.prototype;
      /**
       * Convenience component with default shallow equality check for sCU.
       */

      function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.

        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
      }
      var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
      pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

      _assign(pureComponentPrototype, Component.prototype);
      pureComponentPrototype.isPureReactComponent = true;

      // an immutable object with a single mutable value
      function createRef() {
        var refObject = {
          current: null
        };
        {
          Object.seal(refObject);
        }
        return refObject;
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }
      function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function warnAboutAccessingKey() {
          {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
            }
          }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
          get: warnAboutAccessingKey,
          configurable: true
        });
      }
      function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function warnAboutAccessingRef() {
          {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
            }
          }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
          get: warnAboutAccessingRef,
          configurable: true
        });
      }
      function warnIfStringRefCannotBeAutoConverted(config) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */

      var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * Create and return a new ReactElement of the given type.
       * See https://reactjs.org/docs/react-api.html#createelement
       */

      function createElement$$1(type, config, children) {
        var propName; // Reserved names are extracted

        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
          if (hasValidRef(config)) {
            ref = config.ref;
            {
              warnIfStringRefCannotBeAutoConverted(config);
            }
          }
          if (hasValidKey(config)) {
            key = '' + config.key;
          }
          self = config.__self === undefined ? null : config.__self;
          source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.

        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) {
          props.children = children;
        } else if (childrenLength > 1) {
          var childArray = Array(childrenLength);
          for (var i = 0; i < childrenLength; i++) {
            childArray[i] = arguments[i + 2];
          }
          {
            if (Object.freeze) {
              Object.freeze(childArray);
            }
          }
          props.children = childArray;
        } // Resolve default props

        if (type && type.defaultProps) {
          var defaultProps = type.defaultProps;
          for (propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }
        }
        {
          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
      }
      function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
      }
      /**
       * Clone and return a new ReactElement using element as the starting point.
       * See https://reactjs.org/docs/react-api.html#cloneelement
       */

      function cloneElement$$1(element, config, children) {
        if (!!(element === null || element === undefined)) {
          {
            throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
          }
        }
        var propName; // Original props are copied

        var props = _assign({}, element.props); // Reserved names are extracted

        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.

        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.

        var source = element._source; // Owner will be preserved, unless ref is overridden

        var owner = element._owner;
        if (config != null) {
          if (hasValidRef(config)) {
            // Silently steal the ref from the parent.
            ref = config.ref;
            owner = ReactCurrentOwner.current;
          }
          if (hasValidKey(config)) {
            key = '' + config.key;
          } // Remaining properties override existing props

          var defaultProps;
          if (element.type && element.type.defaultProps) {
            defaultProps = element.type.defaultProps;
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              if (config[propName] === undefined && defaultProps !== undefined) {
                // Resolve default props
                props[propName] = defaultProps[propName];
              } else {
                props[propName] = config[propName];
              }
            }
          }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.

        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) {
          props.children = children;
        } else if (childrenLength > 1) {
          var childArray = Array(childrenLength);
          for (var i = 0; i < childrenLength; i++) {
            childArray[i] = arguments[i + 2];
          }
          props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement$$1(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      var SEPARATOR = '.';
      var SUBSEPARATOR = ':';
      /**
       * Escape and wrap key so it is safe to use as a reactid
       *
       * @param {string} key to be escaped.
       * @return {string} the escaped key.
       */

      function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
          '=': '=0',
          ':': '=2'
        };
        var escapedString = ('' + key).replace(escapeRegex, function (match) {
          return escaperLookup[match];
        });
        return '$' + escapedString;
      }
      /**
       * TODO: Test that a single child and an array with one item have the same key
       * pattern.
       */

      var didWarnAboutMaps = false;
      var userProvidedKeyEscapeRegex = /\/+/g;
      function escapeUserProvidedKey(text) {
        return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
      }
      var POOL_SIZE = 10;
      var traverseContextPool = [];
      function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
        if (traverseContextPool.length) {
          var traverseContext = traverseContextPool.pop();
          traverseContext.result = mapResult;
          traverseContext.keyPrefix = keyPrefix;
          traverseContext.func = mapFunction;
          traverseContext.context = mapContext;
          traverseContext.count = 0;
          return traverseContext;
        } else {
          return {
            result: mapResult,
            keyPrefix: keyPrefix,
            func: mapFunction,
            context: mapContext,
            count: 0
          };
        }
      }
      function releaseTraverseContext(traverseContext) {
        traverseContext.result = null;
        traverseContext.keyPrefix = null;
        traverseContext.func = null;
        traverseContext.context = null;
        traverseContext.count = 0;
        if (traverseContextPool.length < POOL_SIZE) {
          traverseContextPool.push(traverseContext);
        }
      }
      /**
       * @param {?*} children Children tree container.
       * @param {!string} nameSoFar Name of the key path so far.
       * @param {!function} callback Callback to invoke with each child found.
       * @param {?*} traverseContext Used to pass information throughout the traversal
       * process.
       * @return {!number} The number of children in this subtree.
       */

      function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
        var type = typeof children;
        if (type === 'undefined' || type === 'boolean') {
          // All of the above are perceived as null.
          children = null;
        }
        var invokeCallback = false;
        if (children === null) {
          invokeCallback = true;
        } else {
          switch (type) {
            case 'string':
            case 'number':
              invokeCallback = true;
              break;
            case 'object':
              switch (children.$$typeof) {
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                  invokeCallback = true;
              }
          }
        }
        if (invokeCallback) {
          callback(traverseContext, children,
          // If it's the only child, treat the name as if it was wrapped in an array
          // so that it's consistent if the number of children grows.
          nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
          return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.

        var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (Array.isArray(children)) {
          for (var i = 0; i < children.length; i++) {
            child = children[i];
            nextName = nextNamePrefix + getComponentKey(child, i);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        } else {
          var iteratorFn = getIteratorFn(children);
          if (typeof iteratorFn === 'function') {
            {
              // Warn about using Maps as children
              if (iteratorFn === children.entries) {
                if (!didWarnAboutMaps) {
                  warn('Using Maps as children is deprecated and will be removed in ' + 'a future major release. Consider converting children to ' + 'an array of keyed ReactElements instead.');
                }
                didWarnAboutMaps = true;
              }
            }
            var iterator = iteratorFn.call(children);
            var step;
            var ii = 0;
            while (!(step = iterator.next()).done) {
              child = step.value;
              nextName = nextNamePrefix + getComponentKey(child, ii++);
              subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
            }
          } else if (type === 'object') {
            var addendum = '';
            {
              addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + ReactDebugCurrentFrame.getStackAddendum();
            }
            var childrenString = '' + children;
            {
              {
                throw Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + ")." + addendum);
              }
            }
          }
        }
        return subtreeCount;
      }
      /**
       * Traverses children that are typically specified as `props.children`, but
       * might also be specified through attributes:
       *
       * - `traverseAllChildren(this.props.children, ...)`
       * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
       *
       * The `traverseContext` is an optional argument that is passed through the
       * entire traversal. It can be used to store accumulations or anything else that
       * the callback might find relevant.
       *
       * @param {?*} children Children tree object.
       * @param {!function} callback To invoke upon traversing each child.
       * @param {?*} traverseContext Context for traversal.
       * @return {!number} The number of children in this subtree.
       */

      function traverseAllChildren(children, callback, traverseContext) {
        if (children == null) {
          return 0;
        }
        return traverseAllChildrenImpl(children, '', callback, traverseContext);
      }
      /**
       * Generate a key string that identifies a component within a set.
       *
       * @param {*} component A component that could contain a manual key.
       * @param {number} index Index that is used if a manual key is not provided.
       * @return {string}
       */

      function getComponentKey(component, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof component === 'object' && component !== null && component.key != null) {
          // Explicit key
          return escape(component.key);
        } // Implicit key determined by the index in the set

        return index.toString(36);
      }
      function forEachSingleChild(bookKeeping, child, name) {
        var func = bookKeeping.func,
          context = bookKeeping.context;
        func.call(context, child, bookKeeping.count++);
      }
      /**
       * Iterates through children that are typically specified as `props.children`.
       *
       * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
       *
       * The provided forEachFunc(child, index) will be called for each
       * leaf child.
       *
       * @param {?*} children Children tree container.
       * @param {function(*, int)} forEachFunc
       * @param {*} forEachContext Context for forEachContext.
       */

      function forEachChildren(children, forEachFunc, forEachContext) {
        if (children == null) {
          return children;
        }
        var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
        traverseAllChildren(children, forEachSingleChild, traverseContext);
        releaseTraverseContext(traverseContext);
      }
      function mapSingleChildIntoContext(bookKeeping, child, childKey) {
        var result = bookKeeping.result,
          keyPrefix = bookKeeping.keyPrefix,
          func = bookKeeping.func,
          context = bookKeeping.context;
        var mappedChild = func.call(context, child, bookKeeping.count++);
        if (Array.isArray(mappedChild)) {
          mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, function (c) {
            return c;
          });
        } else if (mappedChild != null) {
          if (isValidElement$$1(mappedChild)) {
            mappedChild = cloneAndReplaceKey(mappedChild,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
          }
          result.push(mappedChild);
        }
      }
      function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
        var escapedPrefix = '';
        if (prefix != null) {
          escapedPrefix = escapeUserProvidedKey(prefix) + '/';
        }
        var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
        traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
        releaseTraverseContext(traverseContext);
      }
      /**
       * Maps children that are typically specified as `props.children`.
       *
       * See https://reactjs.org/docs/react-api.html#reactchildrenmap
       *
       * The provided mapFunction(child, key, index) will be called for each
       * leaf child.
       *
       * @param {?*} children Children tree container.
       * @param {function(*, int)} func The map function.
       * @param {*} context Context for mapFunction.
       * @return {object} Object containing the ordered map of results.
       */

      function mapChildren(children, func, context) {
        if (children == null) {
          return children;
        }
        var result = [];
        mapIntoWithKeyPrefixInternal(children, result, null, func, context);
        return result;
      }
      /**
       * Count the number of children that are typically specified as
       * `props.children`.
       *
       * See https://reactjs.org/docs/react-api.html#reactchildrencount
       *
       * @param {?*} children Children tree container.
       * @return {number} The number of children.
       */

      function countChildren(children) {
        return traverseAllChildren(children, function () {
          return null;
        }, null);
      }
      /**
       * Flatten a children object (typically specified as `props.children`) and
       * return an array with appropriately re-keyed children.
       *
       * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
       */

      function toArray(children) {
        var result = [];
        mapIntoWithKeyPrefixInternal(children, result, null, function (child) {
          return child;
        });
        return result;
      }
      /**
       * Returns the first child in a collection of children and verifies that there
       * is only one child in the collection.
       *
       * See https://reactjs.org/docs/react-api.html#reactchildrenonly
       *
       * The current implementation of this function assumes that a single child gets
       * passed without a wrapper, but the purpose of this helper function is to
       * abstract away the particular structure of children.
       *
       * @param {?object} children Child collection structure.
       * @return {ReactElement} The first and only `ReactElement` contained in the
       * structure.
       */

      function onlyChild(children) {
        if (!isValidElement$$1(children)) {
          {
            throw Error("React.Children.only expected to receive a single React element child.");
          }
        }
        return children;
      }
      function createContext$$1(defaultValue, calculateChangedBits) {
        if (calculateChangedBits === undefined) {
          calculateChangedBits = null;
        } else {
          {
            if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
              error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
            }
          }
        }
        var context = {
          $$typeof: REACT_CONTEXT_TYPE,
          _calculateChangedBits: calculateChangedBits,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: defaultValue,
          _currentValue2: defaultValue,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null
        };
        context.Provider = {
          $$typeof: REACT_PROVIDER_TYPE,
          _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        {
          // A separate object, but proxies back to the original context object for
          // backwards compatibility. It has a different $$typeof, so we can properly
          // warn for the incorrect usage of Context as a Consumer.
          var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context,
            _calculateChangedBits: context._calculateChangedBits
          }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

          Object.defineProperties(Consumer, {
            Provider: {
              get: function get() {
                if (!hasWarnedAboutUsingConsumerProvider) {
                  hasWarnedAboutUsingConsumerProvider = true;
                  error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
                }
                return context.Provider;
              },
              set: function set(_Provider) {
                context.Provider = _Provider;
              }
            },
            _currentValue: {
              get: function get() {
                return context._currentValue;
              },
              set: function set(_currentValue) {
                context._currentValue = _currentValue;
              }
            },
            _currentValue2: {
              get: function get() {
                return context._currentValue2;
              },
              set: function set(_currentValue2) {
                context._currentValue2 = _currentValue2;
              }
            },
            _threadCount: {
              get: function get() {
                return context._threadCount;
              },
              set: function set(_threadCount) {
                context._threadCount = _threadCount;
              }
            },
            Consumer: {
              get: function get() {
                if (!hasWarnedAboutUsingNestedContextConsumers) {
                  hasWarnedAboutUsingNestedContextConsumers = true;
                  error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
                }
                return context.Consumer;
              }
            }
          }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

          context.Consumer = Consumer;
        }
        {
          context._currentRenderer = null;
          context._currentRenderer2 = null;
        }
        return context;
      }
      function lazy(ctor) {
        var lazyType = {
          $$typeof: REACT_LAZY_TYPE,
          _ctor: ctor,
          // React uses these fields to store the result.
          _status: -1,
          _result: null
        };
        {
          // In production, this would just set it on the object.
          var defaultProps;
          var propTypes$$1;
          Object.defineProperties(lazyType, {
            defaultProps: {
              configurable: true,
              get: function get() {
                return defaultProps;
              },
              set: function set(newDefaultProps) {
                error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');
                defaultProps = newDefaultProps; // Match production behavior more closely:

                Object.defineProperty(lazyType, 'defaultProps', {
                  enumerable: true
                });
              }
            },
            propTypes: {
              configurable: true,
              get: function get() {
                return propTypes$$1;
              },
              set: function set(newPropTypes) {
                error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');
                propTypes$$1 = newPropTypes; // Match production behavior more closely:

                Object.defineProperty(lazyType, 'propTypes', {
                  enumerable: true
                });
              }
            }
          });
        }
        return lazyType;
      }
      function forwardRef$$1(render) {
        {
          if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
            error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
          } else if (typeof render !== 'function') {
            error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
          } else {
            if (render.length !== 0 && render.length !== 2) {
              error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
            }
          }
          if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) {
              error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
            }
          }
        }
        return {
          $$typeof: REACT_FORWARD_REF_TYPE,
          render: render
        };
      }
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function memo(type, compare) {
        {
          if (!isValidElementType(type)) {
            error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
          }
        }
        return {
          $$typeof: REACT_MEMO_TYPE,
          type: type,
          compare: compare === undefined ? null : compare
        };
      }
      function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (!(dispatcher !== null)) {
          {
            throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
          }
        }
        return dispatcher;
      }
      function useContext$$1(Context, unstable_observedBits) {
        var dispatcher = resolveDispatcher();
        {
          if (unstable_observedBits !== undefined) {
            error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://fb.me/rules-of-hooks' : '');
          } // TODO: add a more generic warning for invalid values.

          if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.

            if (realContext.Consumer === Context) {
              error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
            } else if (realContext.Provider === Context) {
              error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
            }
          }
        }
        return dispatcher.useContext(Context, unstable_observedBits);
      }
      function useState$$1(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
      }
      function useReducer$$1(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
      }
      function useRef$$1(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
      }
      function useEffect$$1(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
      }
      function useLayoutEffect$$1(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
      }
      function useCallback$$1(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
      }
      function useMemo$$1(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
      }
      function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
      }
      function useDebugValue(value, formatterFn) {
        {
          var dispatcher = resolveDispatcher();
          return dispatcher.useDebugValue(value, formatterFn);
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
          var name = getComponentName(ReactCurrentOwner.current.type);
          if (name) {
            return '\n\nCheck the render method of `' + name + '`.';
          }
        }
        return '';
      }
      function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
          var fileName = source.fileName.replace(/^.*[\\\/]/, '');
          var lineNumber = source.lineNumber;
          return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
      }
      function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) {
          return getSourceInfoErrorAddendum(elementProps.__source);
        }
        return '';
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */

      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
          var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
          if (parentName) {
            info = "\n\nCheck the top-level render call using <" + parentName + ">.";
          }
        }
        return info;
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */

      function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) {
          return;
        }
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
          return;
        }
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.

        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
          // Give the component that originally created this child.
          childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        }
        setCurrentlyValidatingElement(element);
        {
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.', currentComponentErrorInfo, childOwner);
        }
        setCurrentlyValidatingElement(null);
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */

      function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') {
          return;
        }
        if (Array.isArray(node)) {
          for (var i = 0; i < node.length; i++) {
            var child = node[i];
            if (isValidElement$$1(child)) {
              validateExplicitKey(child, parentType);
            }
          }
        } else if (isValidElement$$1(node)) {
          // This element was passed in a valid location.
          if (node._store) {
            node._store.validated = true;
          }
        } else if (node) {
          var iteratorFn = getIteratorFn(node);
          if (typeof iteratorFn === 'function') {
            // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            if (iteratorFn !== node.entries) {
              var iterator = iteratorFn.call(node);
              var step;
              while (!(step = iterator.next()).done) {
                if (isValidElement$$1(step.value)) {
                  validateExplicitKey(step.value, parentType);
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */

      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }
          var name = getComponentName(type);
          var propTypes$$1;
          if (typeof type === 'function') {
            propTypes$$1 = type.propTypes;
          } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE ||
          // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes$$1 = type.propTypes;
          } else {
            return;
          }
          if (propTypes$$1) {
            setCurrentlyValidatingElement(element);
            checkPropTypes(propTypes$$1, element.props, 'prop', name, ReactDebugCurrentFrame.getStackAddendum);
            setCurrentlyValidatingElement(null);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
          }
          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */

      function validateFragmentProps(fragment) {
        {
          setCurrentlyValidatingElement(fragment);
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              break;
            }
          }
          if (fragment.ref !== null) {
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
          }
          setCurrentlyValidatingElement(null);
        }
      }
      function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.

        if (!validType) {
          var info = '';
          if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
            info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
          }
          var sourceInfo = getSourceInfoErrorAddendumForProps(props);
          if (sourceInfo) {
            info += sourceInfo;
          } else {
            info += getDeclarationErrorAddendum();
          }
          var typeString;
          if (type === null) {
            typeString = 'null';
          } else if (Array.isArray(type)) {
            typeString = 'array';
          } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
            typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
            info = ' Did you accidentally export a JSX literal instead of a component?';
          } else {
            typeString = typeof type;
          }
          {
            error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }
        }
        var element = createElement$$1.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.

        if (element == null) {
          return element;
        } // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)

        if (validType) {
          for (var i = 2; i < arguments.length; i++) {
            validateChildKeys(arguments[i], type);
          }
        }
        if (type === REACT_FRAGMENT_TYPE) {
          validateFragmentProps(element);
        } else {
          validatePropTypes(element);
        }
        return element;
      }
      var didWarnAboutDeprecatedCreateFactory = false;
      function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        {
          if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
          } // Legacy hook: remove it

          Object.defineProperty(validatedFactory, 'type', {
            enumerable: false,
            get: function get() {
              warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
              Object.defineProperty(this, 'type', {
                value: type
              });
              return type;
            }
          });
        }
        return validatedFactory;
      }
      function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement$$1.apply(this, arguments);
        for (var i = 2; i < arguments.length; i++) {
          validateChildKeys(arguments[i], newElement.type);
        }
        validatePropTypes(newElement);
        return newElement;
      }
      {
        try {
          var frozenObject = Object.freeze({});
          var testMap = new Map([[frozenObject, null]]);
          var testSet = new Set([frozenObject]); // This is necessary for Rollup to not consider these unused.
          // https://github.com/rollup/rollup/issues/1771
          // TODO: we can remove these if Rollup fixes the bug.

          testMap.set(0, 0);
          testSet.add(0);
        } catch (e) {}
      }
      var createElement$1 = createElementWithValidation;
      var cloneElement$1 = cloneElementWithValidation;
      var createFactory = createFactoryWithValidation;
      var Children$$1 = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
      };
      exports.Children = Children$$1;
      exports.Component = Component;
      exports.Fragment = REACT_FRAGMENT_TYPE;
      exports.Profiler = REACT_PROFILER_TYPE;
      exports.PureComponent = PureComponent;
      exports.StrictMode = REACT_STRICT_MODE_TYPE;
      exports.Suspense = REACT_SUSPENSE_TYPE;
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
      exports.cloneElement = cloneElement$1;
      exports.createContext = createContext$$1;
      exports.createElement = createElement$1;
      exports.createFactory = createFactory;
      exports.createRef = createRef;
      exports.forwardRef = forwardRef$$1;
      exports.isValidElement = isValidElement$$1;
      exports.lazy = lazy;
      exports.memo = memo;
      exports.useCallback = useCallback$$1;
      exports.useContext = useContext$$1;
      exports.useDebugValue = useDebugValue;
      exports.useEffect = useEffect$$1;
      exports.useImperativeHandle = useImperativeHandle;
      exports.useLayoutEffect = useLayoutEffect$$1;
      exports.useMemo = useMemo$$1;
      exports.useReducer = useReducer$$1;
      exports.useRef = useRef$$1;
      exports.useState = useState$$1;
      exports.version = ReactVersion;
    })();
  }
});
var react_development_1 = react_development.Children;
var react_development_2 = react_development.Component;
var react_development_3 = react_development.Fragment;
var react_development_4 = react_development.Profiler;
var react_development_5 = react_development.PureComponent;
var react_development_6 = react_development.StrictMode;
var react_development_7 = react_development.Suspense;
var react_development_8 = react_development.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var react_development_9 = react_development.cloneElement;
var react_development_10 = react_development.createContext;
var react_development_11 = react_development.createElement;
var react_development_12 = react_development.createFactory;
var react_development_13 = react_development.createRef;
var react_development_14 = react_development.forwardRef;
var react_development_15 = react_development.isValidElement;
var react_development_16 = react_development.lazy;
var react_development_17 = react_development.memo;
var react_development_18 = react_development.useCallback;
var react_development_19 = react_development.useContext;
var react_development_20 = react_development.useDebugValue;
var react_development_21 = react_development.useEffect;
var react_development_22 = react_development.useImperativeHandle;
var react_development_23 = react_development.useLayoutEffect;
var react_development_24 = react_development.useMemo;
var react_development_25 = react_development.useReducer;
var react_development_26 = react_development.useRef;
var react_development_27 = react_development.useState;
var react_development_28 = react_development.version;
var react = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = react_production_min;
  } else {
    module.exports = react_development;
  }
});
var scheduler_production_min = createCommonjsModule$1(function (module, exports) {
  var _f, g, h, k, l;
  if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var p = null,
      q = null,
      t = function t() {
        if (null !== p) try {
          var a = exports.unstable_now();
          p(!0, a);
          p = null;
        } catch (b) {
          throw setTimeout(t, 0), b;
        }
      },
      u = Date.now();
    exports.unstable_now = function () {
      return Date.now() - u;
    };
    _f = function f(a) {
      null !== p ? setTimeout(_f, 0, a) : (p = a, setTimeout(t, 0));
    };
    g = function g(a, b) {
      q = setTimeout(a, b);
    };
    h = function h() {
      clearTimeout(q);
    };
    k = function k() {
      return !1;
    };
    l = exports.unstable_forceFrameRate = function () {};
  } else {
    var w = window.performance,
      x = window.Date,
      y = window.setTimeout,
      z = window.clearTimeout;
    if ("undefined" !== typeof console) {
      var A = window.cancelAnimationFrame;
      "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
      "function" !== typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof w && "function" === typeof w.now) exports.unstable_now = function () {
      return w.now();
    };else {
      var B = x.now();
      exports.unstable_now = function () {
        return x.now() - B;
      };
    }
    var C = !1,
      D = null,
      E = -1,
      F = 5,
      G = 0;
    k = function k() {
      return exports.unstable_now() >= G;
    };
    l = function l() {};
    exports.unstable_forceFrameRate = function (a) {
      0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var H = new MessageChannel(),
      I = H.port2;
    H.port1.onmessage = function () {
      if (null !== D) {
        var a = exports.unstable_now();
        G = a + F;
        try {
          D(!0, a) ? I.postMessage(null) : (C = !1, D = null);
        } catch (b) {
          throw I.postMessage(null), b;
        }
      } else C = !1;
    };
    _f = function _f(a) {
      D = a;
      C || (C = !0, I.postMessage(null));
    };
    g = function g(a, b) {
      E = y(function () {
        a(exports.unstable_now());
      }, b);
    };
    h = function h() {
      z(E);
      E = -1;
    };
  }
  function J(a, b) {
    var c = a.length;
    a.push(b);
    a: for (;;) {
      var d = c - 1 >>> 1,
        e = a[d];
      if (void 0 !== e && 0 < K(e, b)) a[d] = b, a[c] = e, c = d;else break a;
    }
  }
  function L(a) {
    a = a[0];
    return void 0 === a ? null : a;
  }
  function M(a) {
    var b = a[0];
    if (void 0 !== b) {
      var c = a.pop();
      if (c !== b) {
        a[0] = c;
        a: for (var d = 0, e = a.length; d < e;) {
          var m = 2 * (d + 1) - 1,
            n = a[m],
            v = m + 1,
            r = a[v];
          if (void 0 !== n && 0 > K(n, c)) void 0 !== r && 0 > K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);else if (void 0 !== r && 0 > K(r, c)) a[d] = r, a[v] = c, d = v;else break a;
        }
      }
      return b;
    }
    return null;
  }
  function K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
  }
  var N = [],
    O = [],
    P = 1,
    Q = null,
    R = 3,
    S = !1,
    T = !1,
    U = !1;
  function V(a) {
    for (var b = L(O); null !== b;) {
      if (null === b.callback) M(O);else if (b.startTime <= a) M(O), b.sortIndex = b.expirationTime, J(N, b);else break;
      b = L(O);
    }
  }
  function W(a) {
    U = !1;
    V(a);
    if (!T) if (null !== L(N)) T = !0, _f(X);else {
      var b = L(O);
      null !== b && g(W, b.startTime - a);
    }
  }
  function X(a, b) {
    T = !1;
    U && (U = !1, h());
    S = !0;
    var c = R;
    try {
      V(b);
      for (Q = L(N); null !== Q && (!(Q.expirationTime > b) || a && !k());) {
        var d = Q.callback;
        if (null !== d) {
          Q.callback = null;
          R = Q.priorityLevel;
          var e = d(Q.expirationTime <= b);
          b = exports.unstable_now();
          "function" === typeof e ? Q.callback = e : Q === L(N) && M(N);
          V(b);
        } else M(N);
        Q = L(N);
      }
      if (null !== Q) var m = !0;else {
        var n = L(O);
        null !== n && g(W, n.startTime - b);
        m = !1;
      }
      return m;
    } finally {
      Q = null, R = c, S = !1;
    }
  }
  function Y(a) {
    switch (a) {
      case 1:
        return -1;
      case 2:
        return 250;
      case 5:
        return 1073741823;
      case 4:
        return 1E4;
      default:
        return 5E3;
    }
  }
  var Z = l;
  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;
  exports.unstable_cancelCallback = function (a) {
    a.callback = null;
  };
  exports.unstable_continueExecution = function () {
    T || S || (T = !0, _f(X));
  };
  exports.unstable_getCurrentPriorityLevel = function () {
    return R;
  };
  exports.unstable_getFirstCallbackNode = function () {
    return L(N);
  };
  exports.unstable_next = function (a) {
    switch (R) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;
      default:
        b = R;
    }
    var c = R;
    R = b;
    try {
      return a();
    } finally {
      R = c;
    }
  };
  exports.unstable_pauseExecution = function () {};
  exports.unstable_requestPaint = Z;
  exports.unstable_runWithPriority = function (a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        a = 3;
    }
    var c = R;
    R = a;
    try {
      return b();
    } finally {
      R = c;
    }
  };
  exports.unstable_scheduleCallback = function (a, b, c) {
    var d = exports.unstable_now();
    if ("object" === typeof c && null !== c) {
      var e = c.delay;
      e = "number" === typeof e && 0 < e ? d + e : d;
      c = "number" === typeof c.timeout ? c.timeout : Y(a);
    } else c = Y(a), e = d;
    c = e + c;
    a = {
      id: P++,
      callback: b,
      priorityLevel: a,
      startTime: e,
      expirationTime: c,
      sortIndex: -1
    };
    e > d ? (a.sortIndex = e, J(O, a), null === L(N) && a === L(O) && (U ? h() : U = !0, g(W, e - d))) : (a.sortIndex = c, J(N, a), T || S || (T = !0, _f(X)));
    return a;
  };
  exports.unstable_shouldYield = function () {
    var a = exports.unstable_now();
    V(a);
    var b = L(N);
    return b !== Q && null !== Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < Q.expirationTime || k();
  };
  exports.unstable_wrapCallback = function (a) {
    var b = R;
    return function () {
      var c = R;
      R = b;
      try {
        return a.apply(this, arguments);
      } finally {
        R = c;
      }
    };
  };
});
var scheduler_production_min_1 = scheduler_production_min.unstable_now;
var scheduler_production_min_2 = scheduler_production_min.unstable_forceFrameRate;
var scheduler_production_min_3 = scheduler_production_min.unstable_IdlePriority;
var scheduler_production_min_4 = scheduler_production_min.unstable_ImmediatePriority;
var scheduler_production_min_5 = scheduler_production_min.unstable_LowPriority;
var scheduler_production_min_6 = scheduler_production_min.unstable_NormalPriority;
var scheduler_production_min_7 = scheduler_production_min.unstable_Profiling;
var scheduler_production_min_8 = scheduler_production_min.unstable_UserBlockingPriority;
var scheduler_production_min_9 = scheduler_production_min.unstable_cancelCallback;
var scheduler_production_min_10 = scheduler_production_min.unstable_continueExecution;
var scheduler_production_min_11 = scheduler_production_min.unstable_getCurrentPriorityLevel;
var scheduler_production_min_12 = scheduler_production_min.unstable_getFirstCallbackNode;
var scheduler_production_min_13 = scheduler_production_min.unstable_next;
var scheduler_production_min_14 = scheduler_production_min.unstable_pauseExecution;
var scheduler_production_min_15 = scheduler_production_min.unstable_requestPaint;
var scheduler_production_min_16 = scheduler_production_min.unstable_runWithPriority;
var scheduler_production_min_17 = scheduler_production_min.unstable_scheduleCallback;
var scheduler_production_min_18 = scheduler_production_min.unstable_shouldYield;
var scheduler_production_min_19 = scheduler_production_min.unstable_wrapCallback;
var scheduler_development = createCommonjsModule$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var enableSchedulerDebugging = false;
      var _requestHostCallback;
      var requestHostTimeout;
      var cancelHostTimeout;
      var shouldYieldToHost;
      var requestPaint;
      if (
      // If Scheduler runs in a non-DOM environment, it falls back to a naive
      // implementation using setTimeout.
      typeof window === 'undefined' ||
      // Check if MessageChannel is supported, too.
      typeof MessageChannel !== 'function') {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function _flushCallback() {
          if (_callback !== null) {
            try {
              var currentTime = exports.unstable_now();
              var hasRemainingTime = true;
              _callback(hasRemainingTime, currentTime);
              _callback = null;
            } catch (e) {
              setTimeout(_flushCallback, 0);
              throw e;
            }
          }
        };
        var initialTime = Date.now();
        exports.unstable_now = function () {
          return Date.now() - initialTime;
        };
        _requestHostCallback = function requestHostCallback(cb) {
          if (_callback !== null) {
            // Protect against re-entrancy.
            setTimeout(_requestHostCallback, 0, cb);
          } else {
            _callback = cb;
            setTimeout(_flushCallback, 0);
          }
        };
        requestHostTimeout = function requestHostTimeout(cb, ms) {
          _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function cancelHostTimeout() {
          clearTimeout(_timeoutID);
        };
        shouldYieldToHost = function shouldYieldToHost() {
          return false;
        };
        requestPaint = exports.unstable_forceFrameRate = function () {};
      } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var performance = window.performance;
        var _Date = window.Date;
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== 'undefined') {
          // TODO: Scheduler no longer requires these methods to be polyfilled. But
          // maybe we want to continue warning if they don't exist, to preserve the
          // option to rely on it in the future?
          var requestAnimationFrame = window.requestAnimationFrame;
          var cancelAnimationFrame = window.cancelAnimationFrame; // TODO: Remove fb.me link

          if (typeof requestAnimationFrame !== 'function') {
            // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
          }
          if (typeof cancelAnimationFrame !== 'function') {
            // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
          }
        }
        if (typeof performance === 'object' && typeof performance.now === 'function') {
          exports.unstable_now = function () {
            return performance.now();
          };
        } else {
          var _initialTime = _Date.now();
          exports.unstable_now = function () {
            return _Date.now() - _initialTime;
          };
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.

        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable

        {
          // `isInputPending` is not available. Since we have no way of knowing if
          // there's pending input, always yield at the end of the frame.
          shouldYieldToHost = function shouldYieldToHost() {
            return exports.unstable_now() >= deadline;
          }; // Since we yield every frame regardless, `requestPaint` has no effect.

          requestPaint = function requestPaint() {};
        }
        exports.unstable_forceFrameRate = function (fps) {
          if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing framerates higher than 125 fps is not unsupported');
            return;
          }
          if (fps > 0) {
            yieldInterval = Math.floor(1000 / fps);
          } else {
            // reset the framerate
            yieldInterval = 5;
          }
        };
        var performWorkUntilDeadline = function performWorkUntilDeadline() {
          if (scheduledHostCallback !== null) {
            var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
            // cycle. This means there's always time remaining at the beginning of
            // the message event.

            deadline = currentTime + yieldInterval;
            var hasTimeRemaining = true;
            try {
              var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
              if (!hasMoreWork) {
                isMessageLoopRunning = false;
                scheduledHostCallback = null;
              } else {
                // If there's more work, schedule the next message event at the end
                // of the preceding one.
                port.postMessage(null);
              }
            } catch (error) {
              // If a scheduler task throws, exit the current browser task so the
              // error can be observed.
              port.postMessage(null);
              throw error;
            }
          } else {
            isMessageLoopRunning = false;
          } // Yielding to the browser will give it a chance to paint, so we can
        };

        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        _requestHostCallback = function _requestHostCallback(callback) {
          scheduledHostCallback = callback;
          if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            port.postMessage(null);
          }
        };
        requestHostTimeout = function requestHostTimeout(callback, ms) {
          taskTimeoutID = _setTimeout(function () {
            callback(exports.unstable_now());
          }, ms);
        };
        cancelHostTimeout = function cancelHostTimeout() {
          _clearTimeout(taskTimeoutID);
          taskTimeoutID = -1;
        };
      }
      function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
      }
      function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
      }
      function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
          var last = heap.pop();
          if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
          }
          return first;
        } else {
          return null;
        }
      }
      function siftUp(heap, node, i) {
        var index = i;
        while (true) {
          var parentIndex = index - 1 >>> 1;
          var parent = heap[parentIndex];
          if (parent !== undefined && compare(parent, node) > 0) {
            // The parent is larger. Swap positions.
            heap[parentIndex] = node;
            heap[index] = parent;
            index = parentIndex;
          } else {
            // The parent is smaller. Exit.
            return;
          }
        }
      }
      function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while (index < length) {
          var leftIndex = (index + 1) * 2 - 1;
          var left = heap[leftIndex];
          var rightIndex = leftIndex + 1;
          var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

          if (left !== undefined && compare(left, node) < 0) {
            if (right !== undefined && compare(right, left) < 0) {
              heap[index] = right;
              heap[rightIndex] = node;
              index = rightIndex;
            } else {
              heap[index] = left;
              heap[leftIndex] = node;
              index = leftIndex;
            }
          } else if (right !== undefined && compare(right, node) < 0) {
            heap[index] = right;
            heap[rightIndex] = node;
            index = rightIndex;
          } else {
            // Neither child is smaller. Exit.
            return;
          }
        }
      }
      function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
      }

      // TODO: Use symbols?
      var NoPriority = 0;
      var ImmediatePriority = 1;
      var UserBlockingPriority = 2;
      var NormalPriority = 3;
      var LowPriority = 4;
      var IdlePriority = 5;
      var runIdCounter = 0;
      var mainThreadIdCounter = 0;
      var profilingStateSize = 4;
      var sharedProfilingBuffer =
      // $FlowFixMe Flow doesn't know about SharedArrayBuffer
      typeof SharedArrayBuffer === 'function' ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) :
      // $FlowFixMe Flow doesn't know about ArrayBuffer
      typeof ArrayBuffer === 'function' ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
      ;

      var profilingState = sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks

      var PRIORITY = 0;
      var CURRENT_TASK_ID = 1;
      var CURRENT_RUN_ID = 2;
      var QUEUE_SIZE = 3;
      {
        profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
        // array might include canceled tasks.

        profilingState[QUEUE_SIZE] = 0;
        profilingState[CURRENT_TASK_ID] = 0;
      } // Bytes per element is 4

      var INITIAL_EVENT_LOG_SIZE = 131072;
      var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes

      var eventLogSize = 0;
      var eventLogBuffer = null;
      var eventLog = null;
      var eventLogIndex = 0;
      var TaskStartEvent = 1;
      var TaskCompleteEvent = 2;
      var TaskErrorEvent = 3;
      var TaskCancelEvent = 4;
      var TaskRunEvent = 5;
      var TaskYieldEvent = 6;
      var SchedulerSuspendEvent = 7;
      var SchedulerResumeEvent = 8;
      function logEvent(entries) {
        if (eventLog !== null) {
          var offset = eventLogIndex;
          eventLogIndex += entries.length;
          if (eventLogIndex + 1 > eventLogSize) {
            eventLogSize *= 2;
            if (eventLogSize > MAX_EVENT_LOG_SIZE) {
              // Using console['error'] to evade Babel and ESLint
              console['error']("Scheduler Profiling: Event log exceeded maximum size. Don't " + 'forget to call `stopLoggingProfilingEvents()`.');
              stopLoggingProfilingEvents();
              return;
            }
            var newEventLog = new Int32Array(eventLogSize * 4);
            newEventLog.set(eventLog);
            eventLogBuffer = newEventLog.buffer;
            eventLog = newEventLog;
          }
          eventLog.set(entries, offset);
        }
      }
      function startLoggingProfilingEvents() {
        eventLogSize = INITIAL_EVENT_LOG_SIZE;
        eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
        eventLog = new Int32Array(eventLogBuffer);
        eventLogIndex = 0;
      }
      function stopLoggingProfilingEvents() {
        var buffer = eventLogBuffer;
        eventLogSize = 0;
        eventLogBuffer = null;
        eventLog = null;
        eventLogIndex = 0;
        return buffer;
      }
      function markTaskStart(task, ms) {
        {
          profilingState[QUEUE_SIZE]++;
          if (eventLog !== null) {
            // performance.now returns a float, representing milliseconds. When the
            // event is logged, it's coerced to an int. Convert to microseconds to
            // maintain extra degrees of precision.
            logEvent([TaskStartEvent, ms * 1000, task.id, task.priorityLevel]);
          }
        }
      }
      function markTaskCompleted(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskCompleteEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskCanceled(task, ms) {
        {
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskCancelEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskErrored(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskErrorEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskRun(task, ms) {
        {
          runIdCounter++;
          profilingState[PRIORITY] = task.priorityLevel;
          profilingState[CURRENT_TASK_ID] = task.id;
          profilingState[CURRENT_RUN_ID] = runIdCounter;
          if (eventLog !== null) {
            logEvent([TaskRunEvent, ms * 1000, task.id, runIdCounter]);
          }
        }
      }
      function markTaskYield(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[CURRENT_RUN_ID] = 0;
          if (eventLog !== null) {
            logEvent([TaskYieldEvent, ms * 1000, task.id, runIdCounter]);
          }
        }
      }
      function markSchedulerSuspended(ms) {
        {
          mainThreadIdCounter++;
          if (eventLog !== null) {
            logEvent([SchedulerSuspendEvent, ms * 1000, mainThreadIdCounter]);
          }
        }
      }
      function markSchedulerUnsuspended(ms) {
        {
          if (eventLog !== null) {
            logEvent([SchedulerResumeEvent, ms * 1000, mainThreadIdCounter]);
          }
        }
      }

      /* eslint-disable no-var */
      // Math.pow(2, 30) - 1
      // 0b111111111111111111111111111111

      var maxSigned31BitInt = 1073741823; // Times out immediately

      var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

      var USER_BLOCKING_PRIORITY = 250;
      var NORMAL_PRIORITY_TIMEOUT = 5000;
      var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

      var IDLE_PRIORITY = maxSigned31BitInt; // Tasks are stored on a min heap

      var taskQueue = [];
      var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

      var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
      var currentTask = null;
      var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

      var isPerformingWork = false;
      var isHostCallbackScheduled = false;
      var isHostTimeoutScheduled = false;
      function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while (timer !== null) {
          if (timer.callback === null) {
            // Timer was cancelled.
            pop(timerQueue);
          } else if (timer.startTime <= currentTime) {
            // Timer fired. Transfer to the task queue.
            pop(timerQueue);
            timer.sortIndex = timer.expirationTime;
            push(taskQueue, timer);
            {
              markTaskStart(timer, currentTime);
              timer.isQueued = true;
            }
          } else {
            // Remaining timers are pending.
            return;
          }
          timer = peek(timerQueue);
        }
      }
      function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
          if (peek(taskQueue) !== null) {
            isHostCallbackScheduled = true;
            _requestHostCallback(flushWork);
          } else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
          }
        }
      }
      function flushWork(hasTimeRemaining, initialTime) {
        {
          markSchedulerUnsuspended(initialTime);
        } // We'll need a host callback the next time work is scheduled.

        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
          // We scheduled a timeout but it's no longer needed. Cancel it.
          isHostTimeoutScheduled = false;
          cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
          {
            try {
              return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
              if (currentTask !== null) {
                var currentTime = exports.unstable_now();
                markTaskErrored(currentTask, currentTime);
                currentTask.isQueued = false;
              }
              throw error;
            }
          }
        } finally {
          currentTask = null;
          currentPriorityLevel = previousPriorityLevel;
          isPerformingWork = false;
          {
            var _currentTime = exports.unstable_now();
            markSchedulerSuspended(_currentTime);
          }
        }
      }
      function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while (currentTask !== null && !enableSchedulerDebugging) {
          if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
            // This currentTask hasn't expired, and we've reached the deadline.
            break;
          }
          var callback = currentTask.callback;
          if (callback !== null) {
            currentTask.callback = null;
            currentPriorityLevel = currentTask.priorityLevel;
            var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
            markTaskRun(currentTask, currentTime);
            var continuationCallback = callback(didUserCallbackTimeout);
            currentTime = exports.unstable_now();
            if (typeof continuationCallback === 'function') {
              currentTask.callback = continuationCallback;
              markTaskYield(currentTask, currentTime);
            } else {
              {
                markTaskCompleted(currentTask, currentTime);
                currentTask.isQueued = false;
              }
              if (currentTask === peek(taskQueue)) {
                pop(taskQueue);
              }
            }
            advanceTimers(currentTime);
          } else {
            pop(taskQueue);
          }
          currentTask = peek(taskQueue);
        } // Return whether there's additional work

        if (currentTask !== null) {
          return true;
        } else {
          var firstTimer = peek(timerQueue);
          if (firstTimer !== null) {
            requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
          }
          return false;
        }
      }
      function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
          case LowPriority:
          case IdlePriority:
            break;
          default:
            priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }
      function unstable_next(eventHandler) {
        var priorityLevel;
        switch (currentPriorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
            // Shift down to normal priority
            priorityLevel = NormalPriority;
            break;
          default:
            // Anything lower than normal priority should remain at the current level.
            priorityLevel = currentPriorityLevel;
            break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }
      function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function () {
          // This is a fork of runWithPriority, inlined for performance.
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;
          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      }
      function timeoutForPriorityLevel(priorityLevel) {
        switch (priorityLevel) {
          case ImmediatePriority:
            return IMMEDIATE_PRIORITY_TIMEOUT;
          case UserBlockingPriority:
            return USER_BLOCKING_PRIORITY;
          case IdlePriority:
            return IDLE_PRIORITY;
          case LowPriority:
            return LOW_PRIORITY_TIMEOUT;
          case NormalPriority:
          default:
            return NORMAL_PRIORITY_TIMEOUT;
        }
      }
      function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = exports.unstable_now();
        var startTime;
        var timeout;
        if (typeof options === 'object' && options !== null) {
          var delay = options.delay;
          if (typeof delay === 'number' && delay > 0) {
            startTime = currentTime + delay;
          } else {
            startTime = currentTime;
          }
          timeout = typeof options.timeout === 'number' ? options.timeout : timeoutForPriorityLevel(priorityLevel);
        } else {
          timeout = timeoutForPriorityLevel(priorityLevel);
          startTime = currentTime;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
          id: taskIdCounter++,
          callback: callback,
          priorityLevel: priorityLevel,
          startTime: startTime,
          expirationTime: expirationTime,
          sortIndex: -1
        };
        {
          newTask.isQueued = false;
        }
        if (startTime > currentTime) {
          // This is a delayed task.
          newTask.sortIndex = startTime;
          push(timerQueue, newTask);
          if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
            // All tasks are delayed, and this is the task with the earliest delay.
            if (isHostTimeoutScheduled) {
              // Cancel an existing timeout.
              cancelHostTimeout();
            } else {
              isHostTimeoutScheduled = true;
            } // Schedule a timeout.

            requestHostTimeout(handleTimeout, startTime - currentTime);
          }
        } else {
          newTask.sortIndex = expirationTime;
          push(taskQueue, newTask);
          {
            markTaskStart(newTask, currentTime);
            newTask.isQueued = true;
          } // Schedule a host callback, if needed. If we're already performing work,
          // wait until the next time we yield.

          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            _requestHostCallback(flushWork);
          }
        }
        return newTask;
      }
      function unstable_pauseExecution() {}
      function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
          isHostCallbackScheduled = true;
          _requestHostCallback(flushWork);
        }
      }
      function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
      }
      function unstable_cancelCallback(task) {
        {
          if (task.isQueued) {
            var currentTime = exports.unstable_now();
            markTaskCanceled(task, currentTime);
            task.isQueued = false;
          }
        } // Null out the callback to indicate the task has been canceled. (Can't
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)

        task.callback = null;
      }
      function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
      }
      function unstable_shouldYield() {
        var currentTime = exports.unstable_now();
        advanceTimers(currentTime);
        var firstTask = peek(taskQueue);
        return firstTask !== currentTask && currentTask !== null && firstTask !== null && firstTask.callback !== null && firstTask.startTime <= currentTime && firstTask.expirationTime < currentTask.expirationTime || shouldYieldToHost();
      }
      var unstable_requestPaint = requestPaint;
      var unstable_Profiling = {
        startLoggingProfilingEvents: startLoggingProfilingEvents,
        stopLoggingProfilingEvents: stopLoggingProfilingEvents,
        sharedProfilingBuffer: sharedProfilingBuffer
      };
      exports.unstable_IdlePriority = IdlePriority;
      exports.unstable_ImmediatePriority = ImmediatePriority;
      exports.unstable_LowPriority = LowPriority;
      exports.unstable_NormalPriority = NormalPriority;
      exports.unstable_Profiling = unstable_Profiling;
      exports.unstable_UserBlockingPriority = UserBlockingPriority;
      exports.unstable_cancelCallback = unstable_cancelCallback;
      exports.unstable_continueExecution = unstable_continueExecution;
      exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
      exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
      exports.unstable_next = unstable_next;
      exports.unstable_pauseExecution = unstable_pauseExecution;
      exports.unstable_requestPaint = unstable_requestPaint;
      exports.unstable_runWithPriority = unstable_runWithPriority;
      exports.unstable_scheduleCallback = unstable_scheduleCallback;
      exports.unstable_shouldYield = unstable_shouldYield;
      exports.unstable_wrapCallback = unstable_wrapCallback;
    })();
  }
});
var scheduler_development_1 = scheduler_development.unstable_now;
var scheduler_development_2 = scheduler_development.unstable_forceFrameRate;
var scheduler_development_3 = scheduler_development.unstable_IdlePriority;
var scheduler_development_4 = scheduler_development.unstable_ImmediatePriority;
var scheduler_development_5 = scheduler_development.unstable_LowPriority;
var scheduler_development_6 = scheduler_development.unstable_NormalPriority;
var scheduler_development_7 = scheduler_development.unstable_Profiling;
var scheduler_development_8 = scheduler_development.unstable_UserBlockingPriority;
var scheduler_development_9 = scheduler_development.unstable_cancelCallback;
var scheduler_development_10 = scheduler_development.unstable_continueExecution;
var scheduler_development_11 = scheduler_development.unstable_getCurrentPriorityLevel;
var scheduler_development_12 = scheduler_development.unstable_getFirstCallbackNode;
var scheduler_development_13 = scheduler_development.unstable_next;
var scheduler_development_14 = scheduler_development.unstable_pauseExecution;
var scheduler_development_15 = scheduler_development.unstable_requestPaint;
var scheduler_development_16 = scheduler_development.unstable_runWithPriority;
var scheduler_development_17 = scheduler_development.unstable_scheduleCallback;
var scheduler_development_18 = scheduler_development.unstable_shouldYield;
var scheduler_development_19 = scheduler_development.unstable_wrapCallback;
var scheduler = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = scheduler_production_min;
  } else {
    module.exports = scheduler_development;
  }
});
var reactTestRenderer_production_min = createCommonjsModule$1(function (module) {
  function n(a) {
    for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function da(a, b) {
    for (var c = 0; c < b.length; c++) {
      var d = b[c];
      d.enumerable = d.enumerable || !1;
      d.configurable = !0;
      "value" in d && (d.writable = !0);
      Object.defineProperty(a, d.key, d);
    }
  }
  function ea(a, b, c) {
    b && da(a.prototype, b);
    c && da(a, c);
    return a;
  }
  var t = react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t.hasOwnProperty("ReactCurrentDispatcher") || (t.ReactCurrentDispatcher = {
    current: null
  });
  t.hasOwnProperty("ReactCurrentBatchConfig") || (t.ReactCurrentBatchConfig = {
    suspense: null
  });
  var y = "function" === typeof Symbol && Symbol.for,
    fa = y ? Symbol.for("react.element") : 60103,
    ha = y ? Symbol.for("react.portal") : 60106,
    ia = y ? Symbol.for("react.fragment") : 60107,
    ja = y ? Symbol.for("react.strict_mode") : 60108,
    ka = y ? Symbol.for("react.profiler") : 60114,
    la = y ? Symbol.for("react.provider") : 60109,
    ma = y ? Symbol.for("react.context") : 60110,
    na = y ? Symbol.for("react.concurrent_mode") : 60111,
    oa = y ? Symbol.for("react.forward_ref") : 60112,
    pa = y ? Symbol.for("react.suspense") : 60113,
    qa = y ? Symbol.for("react.suspense_list") : 60120,
    ra = y ? Symbol.for("react.memo") : 60115,
    sa = y ? Symbol.for("react.lazy") : 60116,
    ta = y ? Symbol.for("react.block") : 60121,
    ua = "function" === typeof Symbol && Symbol.iterator;
  function va(a) {
    if (null === a || "object" !== typeof a) return null;
    a = ua && a[ua] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }
  function wa(a) {
    if (-1 === a._status) {
      a._status = 0;
      var b = a._ctor;
      b = b();
      a._result = b;
      b.then(function (b) {
        0 === a._status && (b = b.default, a._status = 1, a._result = b);
      }, function (b) {
        0 === a._status && (a._status = 2, a._result = b);
      });
    }
  }
  function xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch (a) {
      case ia:
        return "Fragment";
      case ha:
        return "Portal";
      case ka:
        return "Profiler";
      case ja:
        return "StrictMode";
      case pa:
        return "Suspense";
      case qa:
        return "SuspenseList";
    }
    if ("object" === typeof a) switch (a.$$typeof) {
      case ma:
        return "Context.Consumer";
      case la:
        return "Context.Provider";
      case oa:
        var b = a.render;
        b = b.displayName || b.name || "";
        return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
      case ra:
        return xa(a.type);
      case ta:
        return xa(a.render);
      case sa:
        if (a = 1 === a._status ? a._result : null) return xa(a);
    }
    return null;
  }
  function ya(a) {
    var b = a,
      c = a;
    if (a.alternate) for (; b.return;) b = b.return;else {
      a = b;
      do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return; while (a);
    }
    return 3 === b.tag ? c : null;
  }
  function za(a) {
    if (ya(a) !== a) throw Error(n(188));
  }
  function Aa(a) {
    var b = a.alternate;
    if (!b) {
      b = ya(a);
      if (null === b) throw Error(n(188));
      return b !== a ? null : a;
    }
    for (var c = a, d = b;;) {
      var e = c.return;
      if (null === e) break;
      var f = e.alternate;
      if (null === f) {
        d = e.return;
        if (null !== d) {
          c = d;
          continue;
        }
        break;
      }
      if (e.child === f.child) {
        for (f = e.child; f;) {
          if (f === c) return za(e), a;
          if (f === d) return za(e), b;
          f = f.sibling;
        }
        throw Error(n(188));
      }
      if (c.return !== d.return) c = e, d = f;else {
        for (var g = !1, h = e.child; h;) {
          if (h === c) {
            g = !0;
            c = e;
            d = f;
            break;
          }
          if (h === d) {
            g = !0;
            d = e;
            c = f;
            break;
          }
          h = h.sibling;
        }
        if (!g) {
          for (h = f.child; h;) {
            if (h === c) {
              g = !0;
              c = f;
              d = e;
              break;
            }
            if (h === d) {
              g = !0;
              d = f;
              c = e;
              break;
            }
            h = h.sibling;
          }
          if (!g) throw Error(n(189));
        }
      }
      if (c.alternate !== d) throw Error(n(190));
    }
    if (3 !== c.tag) throw Error(n(188));
    return c.stateNode.current === c ? a : b;
  }
  function Ba(a) {
    a = Aa(a);
    if (!a) return null;
    for (var b = a;;) {
      if (5 === b.tag || 6 === b.tag) return b;
      if (b.child) b.child.return = b, b = b.child;else {
        if (b === a) break;
        for (; !b.sibling;) {
          if (!b.return || b.return === a) return null;
          b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
      }
    }
    return null;
  }
  var Ca = {},
    Da = {},
    Ea = new WeakMap();
  function Fa(a) {
    switch (a.tag) {
      case "INSTANCE":
        var b = a.rootContainerInstance.createNodeMock;
        b = b({
          type: a.type,
          props: a.props
        });
        "object" === typeof b && null !== b && Ea.set(b, a);
        return b;
      default:
        return a;
    }
  }
  function Ga(a, b) {
    var c = a.children.indexOf(b);
    -1 !== c && a.children.splice(c, 1);
    a.children.push(b);
  }
  function Ha(a, b, c) {
    var d = a.children.indexOf(b);
    -1 !== d && a.children.splice(d, 1);
    c = a.children.indexOf(c);
    a.children.splice(c, 0, b);
  }
  var Ia = setTimeout,
    Ja = clearTimeout,
    Ka = /^(.*)[\\\/]/;
  function La(a) {
    var b = "";
    do {
      a: switch (a.tag) {
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 9:
          var c = "";
          break a;
        default:
          var d = a._debugOwner,
            e = a._debugSource,
            f = xa(a.type);
          c = null;
          d && (c = xa(d.type));
          d = f;
          f = "";
          e ? f = " (at " + e.fileName.replace(Ka, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
          c = "\n    in " + (d || "Unknown") + f;
      }
      b += c;
      a = a.return;
    } while (a);
    return b;
  }
  var Ma = [],
    Na = -1;
  function B(a) {
    0 > Na || (a.current = Ma[Na], Ma[Na] = null, Na--);
  }
  function C(a, b) {
    Na++;
    Ma[Na] = a.current;
    a.current = b;
  }
  var Oa = {},
    D = {
      current: Oa
    },
    E = {
      current: !1
    },
    Pa = Oa;
  function Qa(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Oa;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {},
      f;
    for (f in c) e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
  }
  function F(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
  }
  function Ra() {
    B(E);
    B(D);
  }
  function Sa(a, b, c) {
    if (D.current !== Oa) throw Error(n(168));
    C(D, b);
    C(E, c);
  }
  function Ta(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for (var e in d) if (!(e in a)) throw Error(n(108, xa(b) || "Unknown", e));
    return objectAssign({}, c, {}, d);
  }
  function Ua(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Oa;
    Pa = D.current;
    C(D, a);
    C(E, E.current);
    return !0;
  }
  function Va(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(n(169));
    c ? (a = Ta(a, b, Pa), d.__reactInternalMemoizedMergedChildContext = a, B(E), B(D), C(D, a)) : B(E);
    C(E, c);
  }
  var Wa = scheduler.unstable_runWithPriority,
    Xa = scheduler.unstable_scheduleCallback,
    Ya = scheduler.unstable_cancelCallback,
    Za = scheduler.unstable_requestPaint,
    $a = scheduler.unstable_now,
    ab = scheduler.unstable_getCurrentPriorityLevel,
    bb = scheduler.unstable_ImmediatePriority,
    cb = scheduler.unstable_UserBlockingPriority,
    db = scheduler.unstable_NormalPriority,
    eb = scheduler.unstable_LowPriority,
    fb = scheduler.unstable_IdlePriority,
    gb = {},
    hb = scheduler.unstable_shouldYield,
    ib = void 0 !== Za ? Za : function () {},
    jb = null,
    kb = null,
    lb = !1,
    mb = $a(),
    G = 1E4 > mb ? $a : function () {
      return $a() - mb;
    };
  function nb() {
    switch (ab()) {
      case bb:
        return 99;
      case cb:
        return 98;
      case db:
        return 97;
      case eb:
        return 96;
      case fb:
        return 95;
      default:
        throw Error(n(332));
    }
  }
  function ob(a) {
    switch (a) {
      case 99:
        return bb;
      case 98:
        return cb;
      case 97:
        return db;
      case 96:
        return eb;
      case 95:
        return fb;
      default:
        throw Error(n(332));
    }
  }
  function pb(a, b) {
    a = ob(a);
    return Wa(a, b);
  }
  function qb(a, b, c) {
    a = ob(a);
    return Xa(a, b, c);
  }
  function rb(a) {
    null === jb ? (jb = [a], kb = Xa(bb, sb)) : jb.push(a);
    return gb;
  }
  function tb() {
    if (null !== kb) {
      var a = kb;
      kb = null;
      Ya(a);
    }
    sb();
  }
  function sb() {
    if (!lb && null !== jb) {
      lb = !0;
      var a = 0;
      try {
        var b = jb;
        pb(99, function () {
          for (; a < b.length; a++) {
            var c = b[a];
            do c = c(!0); while (null !== c);
          }
        });
        jb = null;
      } catch (c) {
        throw null !== jb && (jb = jb.slice(a + 1)), Xa(bb, tb), c;
      } finally {
        lb = !1;
      }
    }
  }
  function ub(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var vb = "function" === typeof Object.is ? Object.is : ub,
    wb = Object.prototype.hasOwnProperty;
  function xb(a, b) {
    if (vb(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a),
      d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for (d = 0; d < c.length; d++) if (!wb.call(b, c[d]) || !vb(a[c[d]], b[c[d]])) return !1;
    return !0;
  }
  function H(a, b) {
    if (a && a.defaultProps) {
      b = objectAssign({}, b);
      a = a.defaultProps;
      for (var c in a) void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
  }
  var yb = {
      current: null
    },
    zb = null,
    Ab = null,
    Bb = null;
  function Cb() {
    Bb = Ab = zb = null;
  }
  function Db(a) {
    var b = yb.current;
    B(yb);
    a.type._context._currentValue2 = b;
  }
  function Eb(a, b) {
    for (; null !== a;) {
      var c = a.alternate;
      if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;else break;
      a = a.return;
    }
  }
  function Fb(a, b) {
    zb = a;
    Bb = Ab = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (I = !0), a.firstContext = null);
  }
  function J(a, b) {
    if (Bb !== a && !1 !== b && 0 !== b) {
      if ("number" !== typeof b || 1073741823 === b) Bb = a, b = 1073741823;
      b = {
        context: a,
        observedBits: b,
        next: null
      };
      if (null === Ab) {
        if (null === zb) throw Error(n(308));
        Ab = b;
        zb.dependencies = {
          expirationTime: 0,
          firstContext: b,
          responders: null
        };
      } else Ab = Ab.next = b;
    }
    return a._currentValue2;
  }
  var Gb = !1;
  function Hb(a) {
    a.updateQueue = {
      baseState: a.memoizedState,
      baseQueue: null,
      shared: {
        pending: null
      },
      effects: null
    };
  }
  function Ib(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
      baseState: a.baseState,
      baseQueue: a.baseQueue,
      shared: a.shared,
      effects: a.effects
    });
  }
  function Jb(a, b) {
    a = {
      expirationTime: a,
      suspenseConfig: b,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
    return a.next = a;
  }
  function Kb(a, b) {
    a = a.updateQueue;
    if (null !== a) {
      a = a.shared;
      var c = a.pending;
      null === c ? b.next = b : (b.next = c.next, c.next = b);
      a.pending = b;
    }
  }
  function Lb(a, b) {
    var c = a.alternate;
    null !== c && Ib(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
  }
  function Mb(a, b, c, d) {
    var e = a.updateQueue;
    Gb = !1;
    var f = e.baseQueue,
      g = e.shared.pending;
    if (null !== g) {
      if (null !== f) {
        var h = f.next;
        f.next = g.next;
        g.next = h;
      }
      f = g;
      e.shared.pending = null;
      h = a.alternate;
      null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
      h = f.next;
      var k = e.baseState,
        l = 0,
        p = null,
        q = null,
        v = null;
      if (null !== h) {
        var x = h;
        do {
          g = x.expirationTime;
          if (g < d) {
            var P = {
              expirationTime: x.expirationTime,
              suspenseConfig: x.suspenseConfig,
              tag: x.tag,
              payload: x.payload,
              callback: x.callback,
              next: null
            };
            null === v ? (q = v = P, p = k) : v = v.next = P;
            g > l && (l = g);
          } else {
            null !== v && (v = v.next = {
              expirationTime: 1073741823,
              suspenseConfig: x.suspenseConfig,
              tag: x.tag,
              payload: x.payload,
              callback: x.callback,
              next: null
            });
            Nb(g, x.suspenseConfig);
            a: {
              var z = a,
                A = x;
              g = b;
              P = c;
              switch (A.tag) {
                case 1:
                  z = A.payload;
                  if ("function" === typeof z) {
                    k = z.call(P, k, g);
                    break a;
                  }
                  k = z;
                  break a;
                case 3:
                  z.effectTag = z.effectTag & -4097 | 64;
                case 0:
                  z = A.payload;
                  g = "function" === typeof z ? z.call(P, k, g) : z;
                  if (null === g || void 0 === g) break a;
                  k = objectAssign({}, k, g);
                  break a;
                case 2:
                  Gb = !0;
              }
            }
            null !== x.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [x] : g.push(x));
          }
          x = x.next;
          if (null === x || x === h) if (g = e.shared.pending, null === g) break;else x = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
        } while (1);
      }
      null === v ? p = k : v.next = q;
      e.baseState = p;
      e.baseQueue = v;
      Ob(l);
      a.expirationTime = l;
      a.memoizedState = k;
    }
  }
  function Pb(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for (b = 0; b < a.length; b++) {
      var d = a[b],
        e = d.callback;
      if (null !== e) {
        d.callback = null;
        d = e;
        e = c;
        if ("function" !== typeof d) throw Error(n(191, d));
        d.call(e);
      }
    }
  }
  var Qb = t.ReactCurrentBatchConfig,
    Rb = new react.Component().refs;
  function Sb(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : objectAssign({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
  }
  var Wb = {
    isMounted: function isMounted(a) {
      return (a = a._reactInternalFiber) ? ya(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
      a = a._reactInternalFiber;
      var d = Tb(),
        e = Qb.suspense;
      d = Ub(d, a, e);
      e = Jb(d, e);
      e.payload = b;
      void 0 !== c && null !== c && (e.callback = c);
      Kb(a, e);
      Vb(a, d);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
      a = a._reactInternalFiber;
      var d = Tb(),
        e = Qb.suspense;
      d = Ub(d, a, e);
      e = Jb(d, e);
      e.tag = 1;
      e.payload = b;
      void 0 !== c && null !== c && (e.callback = c);
      Kb(a, e);
      Vb(a, d);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
      a = a._reactInternalFiber;
      var c = Tb(),
        d = Qb.suspense;
      c = Ub(c, a, d);
      d = Jb(c, d);
      d.tag = 2;
      void 0 !== b && null !== b && (d.callback = b);
      Kb(a, d);
      Vb(a, c);
    }
  };
  function Xb(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !xb(c, d) || !xb(e, f) : !0;
  }
  function Yb(a, b, c) {
    var d = !1,
      e = Oa;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = J(f) : (e = F(b) ? Pa : D.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Qa(a, e) : Oa);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Wb;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
  }
  function Zb(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Wb.enqueueReplaceState(b, b.state, null);
  }
  function $b(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Rb;
    Hb(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = J(f) : (f = F(b) ? Pa : D.current, e.context = Qa(a, f));
    Mb(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Sb(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Wb.enqueueReplaceState(e, e.state, null), Mb(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
  }
  var ac = Array.isArray;
  function bc(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
      if (c._owner) {
        c = c._owner;
        if (c) {
          if (1 !== c.tag) throw Error(n(309));
          var d = c.stateNode;
        }
        if (!d) throw Error(n(147, a));
        var e = "" + a;
        if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
        b = function b(a) {
          var b = d.refs;
          b === Rb && (b = d.refs = {});
          null === a ? delete b[e] : b[e] = a;
        };
        b._stringRef = e;
        return b;
      }
      if ("string" !== typeof a) throw Error(n(284));
      if (!c._owner) throw Error(n(290, a));
    }
    return a;
  }
  function cc(a, b) {
    if ("textarea" !== a.type) throw Error(n(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
  }
  function dc(a) {
    function b(b, c) {
      if (a) {
        var d = b.lastEffect;
        null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
        c.nextEffect = null;
        c.effectTag = 8;
      }
    }
    function c(c, d) {
      if (!a) return null;
      for (; null !== d;) b(c, d), d = d.sibling;
      return null;
    }
    function d(a, b) {
      for (a = new Map(); null !== b;) null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
      return a;
    }
    function e(a, b) {
      a = ec(a, b);
      a.index = 0;
      a.sibling = null;
      return a;
    }
    function f(b, c, d) {
      b.index = d;
      if (!a) return c;
      d = b.alternate;
      if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
      b.effectTag = 2;
      return c;
    }
    function g(b) {
      a && null === b.alternate && (b.effectTag = 2);
      return b;
    }
    function h(a, b, c, d) {
      if (null === b || 6 !== b.tag) return b = fc(c, a.mode, d), b.return = a, b;
      b = e(b, c);
      b.return = a;
      return b;
    }
    function k(a, b, c, d) {
      if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = bc(a, b, c), d.return = a, d;
      d = gc(c.type, c.key, c.props, null, a.mode, d);
      d.ref = bc(a, b, c);
      d.return = a;
      return d;
    }
    function l(a, b, c, d) {
      if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = hc(c, a.mode, d), b.return = a, b;
      b = e(b, c.children || []);
      b.return = a;
      return b;
    }
    function p(a, b, c, d, f) {
      if (null === b || 7 !== b.tag) return b = ic(c, a.mode, d, f), b.return = a, b;
      b = e(b, c);
      b.return = a;
      return b;
    }
    function q(a, b, c) {
      if ("string" === typeof b || "number" === typeof b) return b = fc("" + b, a.mode, c), b.return = a, b;
      if ("object" === typeof b && null !== b) {
        switch (b.$$typeof) {
          case fa:
            return c = gc(b.type, b.key, b.props, null, a.mode, c), c.ref = bc(a, null, b), c.return = a, c;
          case ha:
            return b = hc(b, a.mode, c), b.return = a, b;
        }
        if (ac(b) || va(b)) return b = ic(b, a.mode, c, null), b.return = a, b;
        cc(a, b);
      }
      return null;
    }
    function v(a, b, c, d) {
      var e = null !== b ? b.key : null;
      if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
      if ("object" === typeof c && null !== c) {
        switch (c.$$typeof) {
          case fa:
            return c.key === e ? c.type === ia ? p(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
          case ha:
            return c.key === e ? l(a, b, c, d) : null;
        }
        if (ac(c) || va(c)) return null !== e ? null : p(a, b, c, d, null);
        cc(a, c);
      }
      return null;
    }
    function x(a, b, c, d, e) {
      if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
      if ("object" === typeof d && null !== d) {
        switch (d.$$typeof) {
          case fa:
            return a = a.get(null === d.key ? c : d.key) || null, d.type === ia ? p(b, a, d.props.children, e, d.key) : k(b, a, d, e);
          case ha:
            return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
        }
        if (ac(d) || va(d)) return a = a.get(c) || null, p(b, a, d, e, null);
        cc(b, d);
      }
      return null;
    }
    function P(e, g, h, k) {
      for (var l = null, A = null, u = g, r = g = 0, p = null; null !== u && r < h.length; r++) {
        u.index > r ? (p = u, u = null) : p = u.sibling;
        var w = v(e, u, h[r], k);
        if (null === w) {
          null === u && (u = p);
          break;
        }
        a && u && null === w.alternate && b(e, u);
        g = f(w, g, r);
        null === A ? l = w : A.sibling = w;
        A = w;
        u = p;
      }
      if (r === h.length) return c(e, u), l;
      if (null === u) {
        for (; r < h.length; r++) u = q(e, h[r], k), null !== u && (g = f(u, g, r), null === A ? l = u : A.sibling = u, A = u);
        return l;
      }
      for (u = d(e, u); r < h.length; r++) p = x(u, e, r, h[r], k), null !== p && (a && null !== p.alternate && u.delete(null === p.key ? r : p.key), g = f(p, g, r), null === A ? l = p : A.sibling = p, A = p);
      a && u.forEach(function (a) {
        return b(e, a);
      });
      return l;
    }
    function z(e, g, h, l) {
      var k = va(h);
      if ("function" !== typeof k) throw Error(n(150));
      h = k.call(h);
      if (null == h) throw Error(n(151));
      for (var u = k = null, r = g, A = g = 0, p = null, w = h.next(); null !== r && !w.done; A++, w = h.next()) {
        r.index > A ? (p = r, r = null) : p = r.sibling;
        var z = v(e, r, w.value, l);
        if (null === z) {
          null === r && (r = p);
          break;
        }
        a && r && null === z.alternate && b(e, r);
        g = f(z, g, A);
        null === u ? k = z : u.sibling = z;
        u = z;
        r = p;
      }
      if (w.done) return c(e, r), k;
      if (null === r) {
        for (; !w.done; A++, w = h.next()) w = q(e, w.value, l), null !== w && (g = f(w, g, A), null === u ? k = w : u.sibling = w, u = w);
        return k;
      }
      for (r = d(e, r); !w.done; A++, w = h.next()) w = x(r, e, A, w.value, l), null !== w && (a && null !== w.alternate && r.delete(null === w.key ? A : w.key), g = f(w, g, A), null === u ? k = w : u.sibling = w, u = w);
      a && r.forEach(function (a) {
        return b(e, a);
      });
      return k;
    }
    return function (a, d, f, h) {
      var k = "object" === typeof f && null !== f && f.type === ia && null === f.key;
      k && (f = f.props.children);
      var l = "object" === typeof f && null !== f;
      if (l) switch (f.$$typeof) {
        case fa:
          a: {
            l = f.key;
            for (k = d; null !== k;) {
              if (k.key === l) {
                switch (k.tag) {
                  case 7:
                    if (f.type === ia) {
                      c(a, k.sibling);
                      d = e(k, f.props.children);
                      d.return = a;
                      a = d;
                      break a;
                    }
                    break;
                  default:
                    if (k.elementType === f.type) {
                      c(a, k.sibling);
                      d = e(k, f.props);
                      d.ref = bc(a, k, f);
                      d.return = a;
                      a = d;
                      break a;
                    }
                }
                c(a, k);
                break;
              } else b(a, k);
              k = k.sibling;
            }
            f.type === ia ? (d = ic(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = gc(f.type, f.key, f.props, null, a.mode, h), h.ref = bc(a, d, f), h.return = a, a = h);
          }
          return g(a);
        case ha:
          a: {
            for (k = f.key; null !== d;) {
              if (d.key === k) {
                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                  c(a, d.sibling);
                  d = e(d, f.children || []);
                  d.return = a;
                  a = d;
                  break a;
                } else {
                  c(a, d);
                  break;
                }
              } else b(a, d);
              d = d.sibling;
            }
            d = hc(f, a.mode, h);
            d.return = a;
            a = d;
          }
          return g(a);
      }
      if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = fc(f, a.mode, h), d.return = a, a = d), g(a);
      if (ac(f)) return P(a, d, f, h);
      if (va(f)) return z(a, d, f, h);
      l && cc(a, f);
      if ("undefined" === typeof f && !k) switch (a.tag) {
        case 1:
        case 0:
          throw a = a.type, Error(n(152, a.displayName || a.name || "Component"));
      }
      return c(a, d);
    };
  }
  var jc = dc(!0),
    kc = dc(!1),
    lc = {},
    mc = {
      current: lc
    },
    nc = {
      current: lc
    },
    pc = {
      current: lc
    };
  function qc(a) {
    if (a === lc) throw Error(n(174));
    return a;
  }
  function rc(a, b) {
    C(pc, b);
    C(nc, a);
    C(mc, lc);
    B(mc);
    C(mc, Ca);
  }
  function sc() {
    B(mc);
    B(nc);
    B(pc);
  }
  function tc(a) {
    qc(pc.current);
    qc(mc.current) !== Ca && (C(nc, a), C(mc, Ca));
  }
  function uc(a) {
    nc.current === a && (B(mc), B(nc));
  }
  var K = {
    current: 0
  };
  function vc(a) {
    for (var b = a; null !== b;) {
      if (13 === b.tag) {
        var c = b.memoizedState,
          d;
        if (d = null !== c) {
          if (!(c = null === c.dehydrated)) throw Error(n(305));
          if (!c) throw Error(n(305));
          d = c;
        }
        if (d) return b;
      } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
        if (0 !== (b.effectTag & 64)) return b;
      } else if (null !== b.child) {
        b.child.return = b;
        b = b.child;
        continue;
      }
      if (b === a) break;
      for (; null === b.sibling;) {
        if (null === b.return || b.return === a) return null;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
    return null;
  }
  function wc(a, b) {
    return {
      responder: a,
      props: b
    };
  }
  var xc = t.ReactCurrentDispatcher,
    L = t.ReactCurrentBatchConfig,
    yc = 0,
    M = null,
    N = null,
    O = null,
    zc = !1;
  function Q() {
    throw Error(n(321));
  }
  function Ac(a, b) {
    if (null === b) return !1;
    for (var c = 0; c < b.length && c < a.length; c++) if (!vb(a[c], b[c])) return !1;
    return !0;
  }
  function Bc(a, b, c, d, e, f) {
    yc = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    xc.current = null === a || null === a.memoizedState ? Cc : Dc;
    a = c(d, e);
    if (b.expirationTime === yc) {
      f = 0;
      do {
        b.expirationTime = 0;
        if (!(25 > f)) throw Error(n(301));
        f += 1;
        O = N = null;
        b.updateQueue = null;
        xc.current = Ec;
        a = c(d, e);
      } while (b.expirationTime === yc);
    }
    xc.current = Fc;
    b = null !== N && null !== N.next;
    yc = 0;
    O = N = M = null;
    zc = !1;
    if (b) throw Error(n(300));
    return a;
  }
  function Gc() {
    var a = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
  }
  function Hc() {
    if (null === N) {
      var a = M.alternate;
      a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;else {
      if (null === a) throw Error(n(310));
      N = a;
      a = {
        memoizedState: N.memoizedState,
        baseState: N.baseState,
        baseQueue: N.baseQueue,
        queue: N.queue,
        next: null
      };
      null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
  }
  function Ic(a, b) {
    return "function" === typeof b ? b(a) : b;
  }
  function Jc(a) {
    var b = Hc(),
      c = b.queue;
    if (null === c) throw Error(n(311));
    c.lastRenderedReducer = a;
    var d = N,
      e = d.baseQueue,
      f = c.pending;
    if (null !== f) {
      if (null !== e) {
        var g = e.next;
        e.next = f.next;
        f.next = g;
      }
      d.baseQueue = e = f;
      c.pending = null;
    }
    if (null !== e) {
      e = e.next;
      d = d.baseState;
      var h = g = f = null,
        k = e;
      do {
        var l = k.expirationTime;
        if (l < yc) {
          var p = {
            expirationTime: k.expirationTime,
            suspenseConfig: k.suspenseConfig,
            action: k.action,
            eagerReducer: k.eagerReducer,
            eagerState: k.eagerState,
            next: null
          };
          null === h ? (g = h = p, f = d) : h = h.next = p;
          l > M.expirationTime && (M.expirationTime = l, Ob(l));
        } else null !== h && (h = h.next = {
          expirationTime: 1073741823,
          suspenseConfig: k.suspenseConfig,
          action: k.action,
          eagerReducer: k.eagerReducer,
          eagerState: k.eagerState,
          next: null
        }), Nb(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
        k = k.next;
      } while (null !== k && k !== e);
      null === h ? f = d : h.next = g;
      vb(d, b.memoizedState) || (I = !0);
      b.memoizedState = d;
      b.baseState = f;
      b.baseQueue = h;
      c.lastRenderedState = d;
    }
    return [b.memoizedState, c.dispatch];
  }
  function Kc(a) {
    var b = Hc(),
      c = b.queue;
    if (null === c) throw Error(n(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch,
      e = c.pending,
      f = b.memoizedState;
    if (null !== e) {
      c.pending = null;
      var g = e = e.next;
      do f = a(f, g.action), g = g.next; while (g !== e);
      vb(f, b.memoizedState) || (I = !0);
      b.memoizedState = f;
      null === b.baseQueue && (b.baseState = f);
      c.lastRenderedState = f;
    }
    return [f, d];
  }
  function Lc(a) {
    var b = Gc();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: Ic,
      lastRenderedState: a
    };
    a = a.dispatch = Mc.bind(null, M, a);
    return [b.memoizedState, a];
  }
  function Nc(a, b, c, d) {
    a = {
      tag: a,
      create: b,
      destroy: c,
      deps: d,
      next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
      lastEffect: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
  }
  function Oc() {
    return Hc().memoizedState;
  }
  function Pc(a, b, c, d) {
    var e = Gc();
    M.effectTag |= a;
    e.memoizedState = Nc(1 | b, c, void 0, void 0 === d ? null : d);
  }
  function Qc(a, b, c, d) {
    var e = Hc();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
      var g = N.memoizedState;
      f = g.destroy;
      if (null !== d && Ac(d, g.deps)) {
        Nc(b, c, f, d);
        return;
      }
    }
    M.effectTag |= a;
    e.memoizedState = Nc(1 | b, c, f, d);
  }
  function Rc(a, b) {
    return Pc(516, 4, a, b);
  }
  function Sc(a, b) {
    return Qc(516, 4, a, b);
  }
  function Tc(a, b) {
    return Qc(4, 2, a, b);
  }
  function Uc(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function () {
      b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
      b.current = null;
    };
  }
  function Vc(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return Qc(4, 2, Uc.bind(null, b, a), c);
  }
  function Wc() {}
  function Xc(a, b) {
    Gc().memoizedState = [a, void 0 === b ? null : b];
    return a;
  }
  function Yc(a, b) {
    var c = Hc();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Ac(b, d[1])) return d[0];
    c.memoizedState = [a, b];
    return a;
  }
  function Zc(a, b) {
    var c = Hc();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Ac(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [a, b];
    return a;
  }
  function $c(a, b, c) {
    var d = nb();
    pb(98 > d ? 98 : d, function () {
      a(!0);
    });
    pb(97 < d ? 97 : d, function () {
      var d = L.suspense;
      L.suspense = void 0 === b ? null : b;
      try {
        a(!1), c();
      } finally {
        L.suspense = d;
      }
    });
  }
  function Mc(a, b, c) {
    var d = Tb(),
      e = Qb.suspense;
    d = Ub(d, a, e);
    e = {
      expirationTime: d,
      suspenseConfig: e,
      action: c,
      eagerReducer: null,
      eagerState: null,
      next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === M || null !== f && f === M) zc = !0, e.expirationTime = yc, M.expirationTime = yc;else {
      if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
        var g = b.lastRenderedState,
          h = f(g, c);
        e.eagerReducer = f;
        e.eagerState = h;
        if (vb(h, g)) return;
      } catch (k) {} finally {}
      Vb(a, d);
    }
  }
  var Fc = {
      readContext: J,
      useCallback: Q,
      useContext: Q,
      useEffect: Q,
      useImperativeHandle: Q,
      useLayoutEffect: Q,
      useMemo: Q,
      useReducer: Q,
      useRef: Q,
      useState: Q,
      useDebugValue: Q,
      useResponder: Q,
      useDeferredValue: Q,
      useTransition: Q
    },
    Cc = {
      readContext: J,
      useCallback: Xc,
      useContext: J,
      useEffect: Rc,
      useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([a]) : null;
        return Pc(4, 2, Uc.bind(null, b, a), c);
      },
      useLayoutEffect: function useLayoutEffect(a, b) {
        return Pc(4, 2, a, b);
      },
      useMemo: function useMemo(a, b) {
        var c = Gc();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [a, b];
        return a;
      },
      useReducer: function useReducer(a, b, c) {
        var d = Gc();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: a,
          lastRenderedState: b
        };
        a = a.dispatch = Mc.bind(null, M, a);
        return [d.memoizedState, a];
      },
      useRef: function useRef(a) {
        var b = Gc();
        a = {
          current: a
        };
        return b.memoizedState = a;
      },
      useState: Lc,
      useDebugValue: Wc,
      useResponder: wc,
      useDeferredValue: function useDeferredValue(a, b) {
        var c = Lc(a),
          d = c[0],
          e = c[1];
        Rc(function () {
          var c = L.suspense;
          L.suspense = void 0 === b ? null : b;
          try {
            e(a);
          } finally {
            L.suspense = c;
          }
        }, [a, b]);
        return d;
      },
      useTransition: function useTransition(a) {
        var b = Lc(!1),
          c = b[0];
        b = b[1];
        return [Xc($c.bind(null, b, a), [b, a]), c];
      }
    },
    Dc = {
      readContext: J,
      useCallback: Yc,
      useContext: J,
      useEffect: Sc,
      useImperativeHandle: Vc,
      useLayoutEffect: Tc,
      useMemo: Zc,
      useReducer: Jc,
      useRef: Oc,
      useState: function useState() {
        return Jc(Ic);
      },
      useDebugValue: Wc,
      useResponder: wc,
      useDeferredValue: function useDeferredValue(a, b) {
        var c = Jc(Ic),
          d = c[0],
          e = c[1];
        Sc(function () {
          var c = L.suspense;
          L.suspense = void 0 === b ? null : b;
          try {
            e(a);
          } finally {
            L.suspense = c;
          }
        }, [a, b]);
        return d;
      },
      useTransition: function useTransition(a) {
        var b = Jc(Ic),
          c = b[0];
        b = b[1];
        return [Yc($c.bind(null, b, a), [b, a]), c];
      }
    },
    Ec = {
      readContext: J,
      useCallback: Yc,
      useContext: J,
      useEffect: Sc,
      useImperativeHandle: Vc,
      useLayoutEffect: Tc,
      useMemo: Zc,
      useReducer: Kc,
      useRef: Oc,
      useState: function useState() {
        return Kc(Ic);
      },
      useDebugValue: Wc,
      useResponder: wc,
      useDeferredValue: function useDeferredValue(a, b) {
        var c = Kc(Ic),
          d = c[0],
          e = c[1];
        Sc(function () {
          var c = L.suspense;
          L.suspense = void 0 === b ? null : b;
          try {
            e(a);
          } finally {
            L.suspense = c;
          }
        }, [a, b]);
        return d;
      },
      useTransition: function useTransition(a) {
        var b = Kc(Ic),
          c = b[0];
        b = b[1];
        return [Yc($c.bind(null, b, a), [b, a]), c];
      }
    },
    ad = t.ReactCurrentOwner,
    I = !1;
  function R(a, b, c, d) {
    b.child = null === a ? kc(b, null, c, d) : jc(b, a.child, c, d);
  }
  function bd(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    Fb(b, e);
    d = Bc(a, b, c, d, f, e);
    if (null !== a && !I) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), cd(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
  }
  function dd(a, b, c, d, e, f) {
    if (null === a) {
      var g = c.type;
      if ("function" === typeof g && !ed(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, fd(a, b, g, d, e, f);
      a = gc(c.type, null, d, null, b.mode, f);
      a.ref = b.ref;
      a.return = b;
      return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : xb, c(e, d) && a.ref === b.ref)) return cd(a, b, f);
    b.effectTag |= 1;
    a = ec(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }
  function fd(a, b, c, d, e, f) {
    return null !== a && xb(a.memoizedProps, d) && a.ref === b.ref && (I = !1, e < f) ? (b.expirationTime = a.expirationTime, cd(a, b, f)) : gd(a, b, c, d, f);
  }
  function hd(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
  }
  function gd(a, b, c, d, e) {
    var f = F(c) ? Pa : D.current;
    f = Qa(b, f);
    Fb(b, e);
    c = Bc(a, b, c, d, f, e);
    if (null !== a && !I) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), cd(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
  }
  function id(a, b, c, d, e) {
    if (F(c)) {
      var f = !0;
      Ua(b);
    } else f = !1;
    Fb(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Yb(b, c, d), $b(b, c, d, e), d = !0;else if (null === a) {
      var g = b.stateNode,
        h = b.memoizedProps;
      g.props = h;
      var k = g.context,
        l = c.contextType;
      "object" === typeof l && null !== l ? l = J(l) : (l = F(c) ? Pa : D.current, l = Qa(b, l));
      var p = c.getDerivedStateFromProps,
        q = "function" === typeof p || "function" === typeof g.getSnapshotBeforeUpdate;
      q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Zb(b, g, d, l);
      Gb = !1;
      var v = b.memoizedState;
      g.state = v;
      Mb(b, d, g, e);
      k = b.memoizedState;
      h !== d || v !== k || E.current || Gb ? ("function" === typeof p && (Sb(b, c, p, d), k = b.memoizedState), (h = Gb || Xb(b, c, h, d, v, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, Ib(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : H(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = J(l) : (l = F(c) ? Pa : D.current, l = Qa(b, l)), p = c.getDerivedStateFromProps, (q = "function" === typeof p || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Zb(b, g, d, l), Gb = !1, k = b.memoizedState, g.state = k, Mb(b, d, g, e), v = b.memoizedState, h !== d || k !== v || E.current || Gb ? ("function" === typeof p && (Sb(b, c, p, d), v = b.memoizedState), (p = Gb || Xb(b, c, h, d, k, v, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, v, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, v, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = v), g.props = d, g.state = v, g.context = l, d = p) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return jd(a, b, c, d, f, e);
  }
  function jd(a, b, c, d, e, f) {
    hd(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Va(b, c, !1), cd(a, b, f);
    d = b.stateNode;
    ad.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = jc(b, a.child, null, f), b.child = jc(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Va(b, c, !0);
    return b.child;
  }
  function kd(a) {
    var b = a.stateNode;
    b.pendingContext ? Sa(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Sa(a, b.context, !1);
    rc(a, b.containerInfo);
  }
  var ld = {
    dehydrated: null,
    retryTime: 0
  };
  function md(a, b, c) {
    var d = b.mode,
      e = b.pendingProps,
      f = K.current,
      g = !1,
      h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    C(K, f & 1);
    if (null === a) {
      if (g) {
        g = e.fallback;
        e = ic(null, d, 0, null);
        e.return = b;
        if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;) a.return = e, a = a.sibling;
        c = ic(g, d, c, null);
        c.return = b;
        e.sibling = c;
        b.memoizedState = ld;
        b.child = e;
        return c;
      }
      d = e.children;
      b.memoizedState = null;
      return b.child = kc(b, null, d, c);
    }
    if (null !== a.memoizedState) {
      a = a.child;
      d = a.sibling;
      if (g) {
        e = e.fallback;
        c = ec(a, a.pendingProps);
        c.return = b;
        if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for (c.child = g; null !== g;) g.return = c, g = g.sibling;
        d = ec(d, e);
        d.return = b;
        c.sibling = d;
        c.childExpirationTime = 0;
        b.memoizedState = ld;
        b.child = c;
        return d;
      }
      c = jc(b, a.child, e.children, c);
      b.memoizedState = null;
      return b.child = c;
    }
    a = a.child;
    if (g) {
      g = e.fallback;
      e = ic(null, d, 0, null);
      e.return = b;
      e.child = a;
      null !== a && (a.return = e);
      if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;) a.return = e, a = a.sibling;
      c = ic(g, d, c, null);
      c.return = b;
      e.sibling = c;
      c.effectTag |= 2;
      e.childExpirationTime = 0;
      b.memoizedState = ld;
      b.child = e;
      return c;
    }
    b.memoizedState = null;
    return b.child = jc(b, a, e.children, c);
  }
  function nd(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    Eb(a.return, b);
  }
  function od(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
      isBackwards: b,
      rendering: null,
      renderingStartTime: 0,
      last: d,
      tail: c,
      tailExpiration: 0,
      tailMode: e,
      lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
  }
  function pd(a, b, c) {
    var d = b.pendingProps,
      e = d.revealOrder,
      f = d.tail;
    R(a, b, d.children, c);
    d = K.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;else {
      if (null !== a && 0 !== (a.effectTag & 64)) a: for (a = b.child; null !== a;) {
        if (13 === a.tag) null !== a.memoizedState && nd(a, c);else if (19 === a.tag) nd(a, c);else if (null !== a.child) {
          a.child.return = a;
          a = a.child;
          continue;
        }
        if (a === b) break a;
        for (; null === a.sibling;) {
          if (null === a.return || a.return === b) break a;
          a = a.return;
        }
        a.sibling.return = a.return;
        a = a.sibling;
      }
      d &= 1;
    }
    C(K, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;else switch (e) {
      case "forwards":
        c = b.child;
        for (e = null; null !== c;) a = c.alternate, null !== a && null === vc(a) && (e = c), c = c.sibling;
        c = e;
        null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
        od(b, !1, e, c, f, b.lastEffect);
        break;
      case "backwards":
        c = null;
        e = b.child;
        for (b.child = null; null !== e;) {
          a = e.alternate;
          if (null !== a && null === vc(a)) {
            b.child = e;
            break;
          }
          a = e.sibling;
          e.sibling = c;
          c = e;
          e = a;
        }
        od(b, !0, c, null, f, b.lastEffect);
        break;
      case "together":
        od(b, !1, null, null, void 0, b.lastEffect);
        break;
      default:
        b.memoizedState = null;
    }
    return b.child;
  }
  function cd(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Ob(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(n(153));
    if (null !== b.child) {
      a = b.child;
      c = ec(a, a.pendingProps);
      b.child = c;
      for (c.return = b; null !== a.sibling;) a = a.sibling, c = c.sibling = ec(a, a.pendingProps), c.return = b;
      c.sibling = null;
    }
    return b.child;
  }
  var qd, rd, sd, td;
  qd = function qd(a, b) {
    for (var c = b.child; null !== c;) {
      if (5 === c.tag || 6 === c.tag) {
        var d = a,
          e = c.stateNode,
          f = d.children.indexOf(e);
        -1 !== f && d.children.splice(f, 1);
        d.children.push(e);
      } else if (4 !== c.tag && null !== c.child) {
        c.child.return = c;
        c = c.child;
        continue;
      }
      if (c === b) break;
      for (; null === c.sibling;) {
        if (null === c.return || c.return === b) return;
        c = c.return;
      }
      c.sibling.return = c.return;
      c = c.sibling;
    }
  };
  rd = function rd() {};
  sd = function sd(a, b, c, d) {
    a.memoizedProps !== d && (qc(mc.current), b.updateQueue = Da) && (b.effectTag |= 4);
  };
  td = function td(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
  };
  function ud(a, b) {
    switch (a.tailMode) {
      case "hidden":
        b = a.tail;
        for (var c = null; null !== b;) null !== b.alternate && (c = b), b = b.sibling;
        null === c ? a.tail = null : c.sibling = null;
        break;
      case "collapsed":
        c = a.tail;
        for (var d = null; null !== c;) null !== c.alternate && (d = c), c = c.sibling;
        null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
  }
  function vd(a, b, c) {
    var d = b.pendingProps;
    switch (b.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return null;
      case 1:
        return F(b.type) && Ra(), null;
      case 3:
        return sc(), B(E), B(D), a = b.stateNode, a.pendingContext && (a.context = a.pendingContext, a.pendingContext = null), rd(b), null;
      case 5:
        uc(b);
        var e = qc(pc.current);
        c = b.type;
        if (null !== a && null != b.stateNode) sd(a, b, c, d, e), a.ref !== b.ref && (b.effectTag |= 128);else {
          if (!d) {
            if (null === b.stateNode) throw Error(n(166));
            return null;
          }
          qc(mc.current);
          a = {
            type: c,
            props: d,
            isHidden: !1,
            children: [],
            internalInstanceHandle: b,
            rootContainerInstance: e,
            tag: "INSTANCE"
          };
          qd(a, b, !1, !1);
          b.stateNode = a;
          null !== b.ref && (b.effectTag |= 128);
        }
        return null;
      case 6:
        if (a && null != b.stateNode) td(a, b, a.memoizedProps, d);else {
          if ("string" !== typeof d && null === b.stateNode) throw Error(n(166));
          qc(pc.current);
          qc(mc.current);
          b.stateNode = {
            text: d,
            isHidden: !1,
            tag: "TEXT"
          };
        }
        return null;
      case 13:
        B(K);
        d = b.memoizedState;
        if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
        d = null !== d;
        e = !1;
        if (null !== a && (c = a.memoizedState, e = null !== c, !d && null !== c && (c = a.child.sibling, null !== c))) {
          var f = b.firstEffect;
          null !== f ? (b.firstEffect = c, c.nextEffect = f) : (b.firstEffect = b.lastEffect = c, c.nextEffect = null);
          c.effectTag = 8;
        }
        if (d && !e && 0 !== (b.mode & 2)) if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (K.current & 1)) S === wd && (S = xd);else {
          if (S === wd || S === xd) S = yd;
          0 !== zd && null !== T && (Ad(T, U), Bd(T, zd));
        }
        if (d || e) b.effectTag |= 4;
        return null;
      case 4:
        return sc(), rd(b), null;
      case 10:
        return Db(b), null;
      case 17:
        return F(b.type) && Ra(), null;
      case 19:
        B(K);
        d = b.memoizedState;
        if (null === d) return null;
        e = 0 !== (b.effectTag & 64);
        f = d.rendering;
        if (null === f) {
          if (e) ud(d, !1);else {
            if (S !== wd || null !== a && 0 !== (a.effectTag & 64)) for (a = b.child; null !== a;) {
              f = vc(a);
              if (null !== f) {
                b.effectTag |= 64;
                ud(d, !1);
                a = f.updateQueue;
                null !== a && (b.updateQueue = a, b.effectTag |= 4);
                null === d.lastEffect && (b.firstEffect = null);
                b.lastEffect = d.lastEffect;
                a = c;
                for (d = b.child; null !== d;) e = d, c = a, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, f = e.alternate, null === f ? (e.childExpirationTime = 0, e.expirationTime = c, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = f.childExpirationTime, e.expirationTime = f.expirationTime, e.child = f.child, e.memoizedProps = f.memoizedProps, e.memoizedState = f.memoizedState, e.updateQueue = f.updateQueue, c = f.dependencies, e.dependencies = null === c ? null : {
                  expirationTime: c.expirationTime,
                  firstContext: c.firstContext,
                  responders: c.responders
                }), d = d.sibling;
                C(K, K.current & 1 | 2);
                return b.child;
              }
              a = a.sibling;
            }
          }
        } else {
          if (!e) if (a = vc(f), null !== a) {
            if (b.effectTag |= 64, e = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.effectTag |= 4), ud(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
          } else 2 * G() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ud(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
          d.isBackwards ? (f.sibling = b.child, b.child = f) : (a = d.last, null !== a ? a.sibling = f : b.child = f, d.last = f);
        }
        return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = G() + 500), a = d.tail, d.rendering = a, d.tail = a.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = G(), a.sibling = null, b = K.current, C(K, e ? b & 1 | 2 : b & 1), a) : null;
    }
    throw Error(n(156, b.tag));
  }
  function Cd(a) {
    switch (a.tag) {
      case 1:
        F(a.type) && Ra();
        var b = a.effectTag;
        return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
      case 3:
        sc();
        B(E);
        B(D);
        b = a.effectTag;
        if (0 !== (b & 64)) throw Error(n(285));
        a.effectTag = b & -4097 | 64;
        return a;
      case 5:
        return uc(a), null;
      case 13:
        return B(K), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
      case 19:
        return B(K), null;
      case 4:
        return sc(), null;
      case 10:
        return Db(a), null;
      default:
        return null;
    }
  }
  function Dd(a, b) {
    return {
      value: a,
      source: b,
      stack: La(b)
    };
  }
  var Ed = "function" === typeof WeakSet ? WeakSet : Set;
  function Fd(a, b) {
    var c = b.source,
      d = b.stack;
    null === d && null !== c && (d = La(c));
    null !== c && xa(c.type);
    b = b.value;
    null !== a && 1 === a.tag && xa(a.type);
    try {
      console.error(b);
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function Gd(a, b) {
    try {
      b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
      Hd(a, c);
    }
  }
  function Id(a) {
    var b = a.ref;
    if (null !== b) if ("function" === typeof b) try {
      b(null);
    } catch (c) {
      Hd(a, c);
    } else b.current = null;
  }
  function Jd(a, b) {
    switch (b.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        return;
      case 1:
        if (b.effectTag & 256 && null !== a) {
          var c = a.memoizedProps,
            d = a.memoizedState;
          a = b.stateNode;
          b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : H(b.type, c), d);
          a.__reactInternalSnapshotBeforeUpdate = b;
        }
        return;
      case 3:
      case 5:
      case 6:
      case 4:
      case 17:
        return;
    }
    throw Error(n(163));
  }
  function Kd(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
      var c = b = b.next;
      do {
        if ((c.tag & a) === a) {
          var d = c.destroy;
          c.destroy = void 0;
          void 0 !== d && d();
        }
        c = c.next;
      } while (c !== b);
    }
  }
  function Md(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
      var c = b = b.next;
      do {
        if ((c.tag & a) === a) {
          var d = c.create;
          c.destroy = d();
        }
        c = c.next;
      } while (c !== b);
    }
  }
  function Nd(a, b, c) {
    switch (c.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        Md(3, c);
        return;
      case 1:
        a = c.stateNode;
        if (c.effectTag & 4) if (null === b) a.componentDidMount();else {
          var d = c.elementType === c.type ? b.memoizedProps : H(c.type, b.memoizedProps);
          a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
        }
        b = c.updateQueue;
        null !== b && Pb(c, b, a);
        return;
      case 3:
        b = c.updateQueue;
        if (null !== b) {
          a = null;
          if (null !== c.child) switch (c.child.tag) {
            case 5:
              a = Fa(c.child.stateNode);
              break;
            case 1:
              a = c.child.stateNode;
          }
          Pb(c, b, a);
        }
        return;
      case 5:
        return;
      case 6:
        return;
      case 4:
        return;
      case 12:
        return;
      case 13:
        return;
      case 19:
      case 17:
      case 20:
      case 21:
        return;
    }
    throw Error(n(163));
  }
  function Od(a, b, c) {
    "function" === typeof Pd && Pd(b);
    switch (b.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        a = b.updateQueue;
        if (null !== a && (a = a.lastEffect, null !== a)) {
          var d = a.next;
          pb(97 < c ? 97 : c, function () {
            var a = d;
            do {
              var c = a.destroy;
              if (void 0 !== c) {
                var g = b;
                try {
                  c();
                } catch (h) {
                  Hd(g, h);
                }
              }
              a = a.next;
            } while (a !== d);
          });
        }
        break;
      case 1:
        Id(b);
        c = b.stateNode;
        "function" === typeof c.componentWillUnmount && Gd(b, c);
        break;
      case 5:
        Id(b);
        break;
      case 4:
        Qd(a, b, c);
    }
  }
  function Rd(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Rd(b);
  }
  function Sd(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }
  function Td(a) {
    a: {
      for (var b = a.return; null !== b;) {
        if (Sd(b)) {
          var c = b;
          break a;
        }
        b = b.return;
      }
      throw Error(n(160));
    }
    b = c.stateNode;
    switch (c.tag) {
      case 5:
        var d = !1;
        break;
      case 3:
        b = b.containerInfo;
        d = !0;
        break;
      case 4:
        b = b.containerInfo;
        d = !0;
        break;
      default:
        throw Error(n(161));
    }
    c.effectTag & 16 && (c.effectTag &= -17);
    a: b: for (c = a;;) {
      for (; null === c.sibling;) {
        if (null === c.return || Sd(c.return)) {
          c = null;
          break a;
        }
        c = c.return;
      }
      c.sibling.return = c.return;
      for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;) {
        if (c.effectTag & 2) continue b;
        if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
      }
      if (!(c.effectTag & 2)) {
        c = c.stateNode;
        break a;
      }
    }
    d ? Ud(a, c, b) : Vd(a, c, b);
  }
  function Ud(a, b, c) {
    var d = a.tag,
      e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? Ha(c, a, b) : Ga(c, a);else if (4 !== d && (a = a.child, null !== a)) for (Ud(a, b, c), a = a.sibling; null !== a;) Ud(a, b, c), a = a.sibling;
  }
  function Vd(a, b, c) {
    var d = a.tag,
      e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? Ha(c, a, b) : Ga(c, a);else if (4 !== d && (a = a.child, null !== a)) for (Vd(a, b, c), a = a.sibling; null !== a;) Vd(a, b, c), a = a.sibling;
  }
  function Qd(a, b, c) {
    for (var d = b, e = !1, f;;) {
      if (!e) {
        e = d.return;
        a: for (;;) {
          if (null === e) throw Error(n(160));
          f = e.stateNode;
          switch (e.tag) {
            case 5:
              break a;
            case 3:
              f = f.containerInfo;
              break a;
            case 4:
              f = f.containerInfo;
              break a;
          }
          e = e.return;
        }
        e = !0;
      }
      if (5 === d.tag || 6 === d.tag) {
        a: for (var g = a, h = d, k = c, l = h;;) if (Od(g, l, k), null !== l.child && 4 !== l.tag) l.child.return = l, l = l.child;else {
          if (l === h) break a;
          for (; null === l.sibling;) {
            if (null === l.return || l.return === h) break a;
            l = l.return;
          }
          l.sibling.return = l.return;
          l = l.sibling;
        }
        g = f;
        h = g.children.indexOf(d.stateNode);
        g.children.splice(h, 1);
      } else if (4 === d.tag) {
        if (null !== d.child) {
          f = d.stateNode.containerInfo;
          d.child.return = d;
          d = d.child;
          continue;
        }
      } else if (Od(a, d, c), null !== d.child) {
        d.child.return = d;
        d = d.child;
        continue;
      }
      if (d === b) break;
      for (; null === d.sibling;) {
        if (null === d.return || d.return === b) return;
        d = d.return;
        4 === d.tag && (e = !1);
      }
      d.sibling.return = d.return;
      d = d.sibling;
    }
  }
  function Wd(a, b) {
    switch (b.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        Kd(3, b);
        return;
      case 1:
        return;
      case 5:
        a = b.stateNode;
        if (null != a) {
          var c = b.memoizedProps,
            d = b.type,
            e = b.updateQueue;
          b.updateQueue = null;
          null !== e && (a.type = d, a.props = c);
        }
        return;
      case 6:
        if (null === b.stateNode) throw Error(n(162));
        b.stateNode.text = b.memoizedProps;
        return;
      case 3:
        return;
      case 12:
        return;
      case 13:
        a = b;
        null === b.memoizedState ? c = !1 : (c = !0, a = b.child, Xd = G());
        if (null !== a) a: for (d = a;;) {
          if (5 === d.tag) e = d.stateNode, c ? e.isHidden = !0 : d.stateNode.isHidden = !1;else if (6 === d.tag) d.stateNode.isHidden = c ? !0 : !1;else if (13 === d.tag && null !== d.memoizedState && null === d.memoizedState.dehydrated) {
            e = d.child.sibling;
            e.return = d;
            d = e;
            continue;
          } else if (null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
          }
          if (d === a) break;
          for (; null === d.sibling;) {
            if (null === d.return || d.return === a) break a;
            d = d.return;
          }
          d.sibling.return = d.return;
          d = d.sibling;
        }
        Yd(b);
        return;
      case 19:
        Yd(b);
        return;
      case 17:
        return;
    }
    throw Error(n(163));
  }
  function Yd(a) {
    var b = a.updateQueue;
    if (null !== b) {
      a.updateQueue = null;
      var c = a.stateNode;
      null === c && (c = a.stateNode = new Ed());
      b.forEach(function (b) {
        var d = Zd.bind(null, a, b);
        c.has(b) || (c.add(b), b.then(d, d));
      });
    }
  }
  var $d = "function" === typeof WeakMap ? WeakMap : Map;
  function ae(a, b, c) {
    c = Jb(c, null);
    c.tag = 3;
    c.payload = {
      element: null
    };
    var d = b.value;
    c.callback = function () {
      be || (be = !0, ce = d);
      Fd(a, b);
    };
    return c;
  }
  function de(a, b, c) {
    c = Jb(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
      var e = b.value;
      c.payload = function () {
        Fd(a, b);
        return d(e);
      };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
      "function" !== typeof d && (null === ee ? ee = new Set([this]) : ee.add(this), Fd(a, b));
      var c = b.stack;
      this.componentDidCatch(b.value, {
        componentStack: null !== c ? c : ""
      });
    });
    return c;
  }
  var fe = Math.ceil,
    ge = t.ReactCurrentDispatcher,
    he = t.ReactCurrentOwner,
    V = 0,
    ie = 8,
    je = 16,
    ke = 32,
    wd = 0,
    le = 1,
    me = 2,
    xd = 3,
    yd = 4,
    ne = 5,
    W = V,
    T = null,
    X = null,
    U = 0,
    S = wd,
    oe = null,
    pe = 1073741823,
    qe = 1073741823,
    re = null,
    zd = 0,
    se = !1,
    Xd = 0,
    te = 500,
    Y = null,
    be = !1,
    ce = null,
    ee = null,
    ue = !1,
    ve = null,
    we = 90,
    xe = null,
    ye = 0,
    ze = null,
    Ae = 0;
  function Tb() {
    return (W & (je | ke)) !== V ? 1073741821 - (G() / 10 | 0) : 0 !== Ae ? Ae : Ae = 1073741821 - (G() / 10 | 0);
  }
  function Ub(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = nb();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & je) !== V) return U;
    if (null !== c) a = 1073741821 - 25 * (((1073741821 - a + (c.timeoutMs | 0 || 5E3) / 10) / 25 | 0) + 1);else switch (d) {
      case 99:
        a = 1073741823;
        break;
      case 98:
        a = 1073741821 - 10 * (((1073741821 - a + 15) / 10 | 0) + 1);
        break;
      case 97:
      case 96:
        a = 1073741821 - 25 * (((1073741821 - a + 500) / 25 | 0) + 1);
        break;
      case 95:
        a = 2;
        break;
      default:
        throw Error(n(326));
    }
    null !== T && a === U && --a;
    return a;
  }
  function Vb(a, b) {
    if (50 < ye) throw ye = 0, ze = null, Error(n(185));
    a = Be(a, b);
    if (null !== a) {
      var c = nb();
      1073741823 === b ? (W & ie) !== V && (W & (je | ke)) === V ? Ce(a) : (Z(a), W === V && tb()) : Z(a);
      (W & 4) === V || 98 !== c && 99 !== c || (null === xe ? xe = new Map([[a, b]]) : (c = xe.get(a), (void 0 === c || c > b) && xe.set(a, b)));
    }
  }
  function Be(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return,
      e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;else for (; null !== d;) {
      c = d.alternate;
      d.childExpirationTime < b && (d.childExpirationTime = b);
      null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
      if (null === d.return && 3 === d.tag) {
        e = d.stateNode;
        break;
      }
      d = d.return;
    }
    null !== e && (T === e && (Ob(b), S === yd && Ad(e, U)), Bd(e, b));
    return e;
  }
  function De(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Ee(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
  }
  function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = rb(Ce.bind(null, a));else {
      var b = De(a),
        c = a.callbackNode;
      if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);else {
        var d = Tb();
        1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
        if (null !== c) {
          var e = a.callbackPriority;
          if (a.callbackExpirationTime === b && e >= d) return;
          c !== gb && Ya(c);
        }
        a.callbackExpirationTime = b;
        a.callbackPriority = d;
        b = 1073741823 === b ? rb(Ce.bind(null, a)) : qb(d, Fe.bind(null, a), {
          timeout: 10 * (1073741821 - b) - G()
        });
        a.callbackNode = b;
      }
    }
  }
  function Fe(a, b) {
    Ae = 0;
    if (b) {
      b = Tb();
      var c = a.lastExpiredTime;
      if (0 === c || c > b) a.lastExpiredTime = b;
      Z(a);
      return null;
    }
    c = De(a);
    if (0 !== c) {
      b = a.callbackNode;
      if ((W & (je | ke)) !== V) throw Error(n(327));
      Ge();
      a === T && c === U || He(a, c);
      if (null !== X) {
        var d = W;
        W |= je;
        var e = Ie();
        do try {
          Je();
          break;
        } catch (h) {
          Ke(a, h);
        } while (1);
        Cb();
        W = d;
        ge.current = e;
        if (S === le) throw b = oe, He(a, c), Ad(a, c), Z(a), b;
        if (null === X) switch (e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d) {
          case wd:
          case le:
            throw Error(n(345));
          case me:
            c = 2 < c ? 2 : c;
            d = a.lastExpiredTime;
            if (0 === d || d > c) a.lastExpiredTime = c;
            break;
          case xd:
            Ad(a, c);
            d = a.lastSuspendedTime;
            c === d && (a.nextKnownPendingLevel = Le(e));
            if (1073741823 === pe && (e = Xd + te - G(), 10 < e)) {
              if (se) {
                var f = a.lastPingedTime;
                if (0 === f || f >= c) {
                  a.lastPingedTime = c;
                  He(a, c);
                  break;
                }
              }
              f = De(a);
              if (0 !== f && f !== c) break;
              if (0 !== d && d !== c) {
                a.lastPingedTime = d;
                break;
              }
              a.timeoutHandle = Ia(Me.bind(null, a), e);
              break;
            }
            Me(a);
            break;
          case yd:
            Ad(a, c);
            d = a.lastSuspendedTime;
            c === d && (a.nextKnownPendingLevel = Le(e));
            if (se && (e = a.lastPingedTime, 0 === e || e >= c)) {
              a.lastPingedTime = c;
              He(a, c);
              break;
            }
            e = De(a);
            if (0 !== e && e !== c) break;
            if (0 !== d && d !== c) {
              a.lastPingedTime = d;
              break;
            }
            1073741823 !== qe ? d = 10 * (1073741821 - qe) - G() : 1073741823 === pe ? d = 0 : (d = 10 * (1073741821 - pe) - 5E3, e = G(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * fe(d / 1960)) - d, c < d && (d = c));
            if (10 < d) {
              a.timeoutHandle = Ia(Me.bind(null, a), d);
              break;
            }
            Me(a);
            break;
          case ne:
            if (1073741823 !== pe && null !== re) {
              f = pe;
              var g = re;
              d = g.busyMinDurationMs | 0;
              0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = G() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
              if (10 < d) {
                Ad(a, c);
                a.timeoutHandle = Ia(Me.bind(null, a), d);
                break;
              }
            }
            Me(a);
            break;
          default:
            throw Error(n(329));
        }
        Z(a);
        if (a.callbackNode === b) return Fe.bind(null, a);
      }
    }
    return null;
  }
  function Ce(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (je | ke)) !== V) throw Error(n(327));
    Ge();
    a === T && b === U || He(a, b);
    if (null !== X) {
      var c = W;
      W |= je;
      var d = Ie();
      do try {
        Ne();
        break;
      } catch (e) {
        Ke(a, e);
      } while (1);
      Cb();
      W = c;
      ge.current = d;
      if (S === le) throw c = oe, He(a, b), Ad(a, b), Z(a), c;
      if (null !== X) throw Error(n(261));
      a.finishedWork = a.current.alternate;
      a.finishedExpirationTime = b;
      T = null;
      Me(a);
      Z(a);
    }
    return null;
  }
  function Oe(a, b) {
    var c = W;
    W |= 1;
    try {
      return a(b);
    } finally {
      W = c, W === V && tb();
    }
  }
  function He(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Ja(c));
    if (null !== X) for (c = X.return; null !== c;) {
      var d = c;
      switch (d.tag) {
        case 1:
          d = d.type.childContextTypes;
          null !== d && void 0 !== d && Ra();
          break;
        case 3:
          sc();
          B(E);
          B(D);
          break;
        case 5:
          uc(d);
          break;
        case 4:
          sc();
          break;
        case 13:
          B(K);
          break;
        case 19:
          B(K);
          break;
        case 10:
          Db(d);
      }
      c = c.return;
    }
    T = a;
    X = ec(a.current, null);
    U = b;
    S = wd;
    oe = null;
    qe = pe = 1073741823;
    re = null;
    zd = 0;
    se = !1;
  }
  function Ke(a, b) {
    do {
      try {
        Cb();
        xc.current = Fc;
        if (zc) for (var c = M.memoizedState; null !== c;) {
          var d = c.queue;
          null !== d && (d.pending = null);
          c = c.next;
        }
        yc = 0;
        O = N = M = null;
        zc = !1;
        if (null === X || null === X.return) return S = le, oe = b, X = null;
        a: {
          var e = a,
            f = X.return,
            g = X,
            h = b;
          b = U;
          g.effectTag |= 2048;
          g.firstEffect = g.lastEffect = null;
          if (null !== h && "object" === typeof h && "function" === typeof h.then) {
            var k = h;
            if (0 === (g.mode & 2)) {
              var l = g.alternate;
              l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
            }
            var p = 0 !== (K.current & 1),
              q = f;
            do {
              var v;
              if (v = 13 === q.tag) {
                var x = q.memoizedState;
                if (null !== x) v = null !== x.dehydrated ? !0 : !1;else {
                  var P = q.memoizedProps;
                  v = void 0 === P.fallback ? !1 : !0 !== P.unstable_avoidThisFallback ? !0 : p ? !1 : !0;
                }
              }
              if (v) {
                var z = q.updateQueue;
                if (null === z) {
                  var A = new Set();
                  A.add(k);
                  q.updateQueue = A;
                } else z.add(k);
                if (0 === (q.mode & 2)) {
                  q.effectTag |= 64;
                  g.effectTag &= -2981;
                  if (1 === g.tag) if (null === g.alternate) g.tag = 17;else {
                    var u = Jb(1073741823, null);
                    u.tag = 2;
                    Kb(g, u);
                  }
                  g.expirationTime = 1073741823;
                  break a;
                }
                h = void 0;
                g = b;
                var r = e.pingCache;
                null === r ? (r = e.pingCache = new $d(), h = new Set(), r.set(k, h)) : (h = r.get(k), void 0 === h && (h = new Set(), r.set(k, h)));
                if (!h.has(g)) {
                  h.add(g);
                  var Ld = Pe.bind(null, e, k, g);
                  k.then(Ld, Ld);
                }
                q.effectTag |= 4096;
                q.expirationTime = b;
                break a;
              }
              q = q.return;
            } while (null !== q);
            h = Error((xa(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + La(g));
          }
          S !== ne && (S = me);
          h = Dd(h, g);
          q = f;
          do {
            switch (q.tag) {
              case 3:
                k = h;
                q.effectTag |= 4096;
                q.expirationTime = b;
                var $e = ae(q, k, b);
                Lb(q, $e);
                break a;
              case 1:
                k = h;
                var af = q.type,
                  oc = q.stateNode;
                if (0 === (q.effectTag & 64) && ("function" === typeof af.getDerivedStateFromError || null !== oc && "function" === typeof oc.componentDidCatch && (null === ee || !ee.has(oc)))) {
                  q.effectTag |= 4096;
                  q.expirationTime = b;
                  var bf = de(q, k, b);
                  Lb(q, bf);
                  break a;
                }
            }
            q = q.return;
          } while (null !== q);
        }
        X = Qe(X);
      } catch (cf) {
        b = cf;
        continue;
      }
      break;
    } while (1);
  }
  function Ie() {
    var a = ge.current;
    ge.current = Fc;
    return null === a ? Fc : a;
  }
  function Nb(a, b) {
    a < pe && 2 < a && (pe = a);
    null !== b && a < qe && 2 < a && (qe = a, re = b);
  }
  function Ob(a) {
    a > zd && (zd = a);
  }
  function Ne() {
    for (; null !== X;) X = Re(X);
  }
  function Je() {
    for (; null !== X && !hb();) X = Re(X);
  }
  function Re(a) {
    var b = Se(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Qe(a));
    he.current = null;
    return b;
  }
  function Qe(a) {
    X = a;
    do {
      var b = X.alternate;
      a = X.return;
      if (0 === (X.effectTag & 2048)) {
        b = vd(b, X, U);
        if (1 === U || 1 !== X.childExpirationTime) {
          for (var c = 0, d = X.child; null !== d;) {
            var e = d.expirationTime,
              f = d.childExpirationTime;
            e > c && (c = e);
            f > c && (c = f);
            d = d.sibling;
          }
          X.childExpirationTime = c;
        }
        if (null !== b) return b;
        null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
      } else {
        b = Cd(X);
        if (null !== b) return b.effectTag &= 2047, b;
        null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
      }
      b = X.sibling;
      if (null !== b) return b;
      X = a;
    } while (null !== X);
    S === wd && (S = ne);
    return null;
  }
  function Le(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
  }
  function Me(a) {
    var b = nb();
    pb(99, Te.bind(null, a, b));
    return null;
  }
  function Te(a, b) {
    do Ge(); while (null !== ve);
    if ((W & (je | ke)) !== V) throw Error(n(327));
    var c = a.finishedWork,
      d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(n(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Le(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
      var f = W;
      W |= ke;
      he.current = null;
      Y = e;
      do try {
        Ue();
      } catch (z) {
        if (null === Y) throw Error(n(330));
        Hd(Y, z);
        Y = Y.nextEffect;
      } while (null !== Y);
      Y = e;
      do try {
        for (var g = a, h = b; null !== Y;) {
          var k = Y.effectTag;
          if (k & 128) {
            var l = Y.alternate;
            if (null !== l) {
              var p = l.ref;
              null !== p && ("function" === typeof p ? p(null) : p.current = null);
            }
          }
          switch (k & 1038) {
            case 2:
              Td(Y);
              Y.effectTag &= -3;
              break;
            case 6:
              Td(Y);
              Y.effectTag &= -3;
              Wd(Y.alternate, Y);
              break;
            case 1024:
              Y.effectTag &= -1025;
              break;
            case 1028:
              Y.effectTag &= -1025;
              Wd(Y.alternate, Y);
              break;
            case 4:
              Wd(Y.alternate, Y);
              break;
            case 8:
              var q = Y;
              Qd(g, q, h);
              Rd(q);
          }
          Y = Y.nextEffect;
        }
      } catch (z) {
        if (null === Y) throw Error(n(330));
        Hd(Y, z);
        Y = Y.nextEffect;
      } while (null !== Y);
      a.current = c;
      Y = e;
      do try {
        for (k = a; null !== Y;) {
          var v = Y.effectTag;
          v & 36 && Nd(k, Y.alternate, Y);
          if (v & 128) {
            l = void 0;
            var x = Y.ref;
            if (null !== x) {
              var P = Y.stateNode;
              switch (Y.tag) {
                case 5:
                  l = Fa(P);
                  break;
                default:
                  l = P;
              }
              "function" === typeof x ? x(l) : x.current = l;
            }
          }
          Y = Y.nextEffect;
        }
      } catch (z) {
        if (null === Y) throw Error(n(330));
        Hd(Y, z);
        Y = Y.nextEffect;
      } while (null !== Y);
      Y = null;
      ib();
      W = f;
    } else a.current = c;
    if (ue) ue = !1, ve = a, we = b;else for (Y = e; null !== Y;) b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (ee = null);
    1073741823 === b ? a === ze ? ye++ : (ye = 0, ze = a) : ye = 0;
    "function" === typeof Ve && Ve(c.stateNode, d);
    Z(a);
    if (be) throw be = !1, a = ce, ce = null, a;
    if ((W & ie) !== V) return null;
    tb();
    return null;
  }
  function Ue() {
    for (; null !== Y;) {
      var a = Y.effectTag;
      0 !== (a & 256) && Jd(Y.alternate, Y);
      0 === (a & 512) || ue || (ue = !0, qb(97, function () {
        Ge();
        return null;
      }));
      Y = Y.nextEffect;
    }
  }
  function Ge() {
    if (90 !== we) {
      var a = 97 < we ? 97 : we;
      we = 90;
      return pb(a, We);
    }
  }
  function We() {
    if (null === ve) return !1;
    var a = ve;
    ve = null;
    if ((W & (je | ke)) !== V) throw Error(n(331));
    var b = W;
    W |= ke;
    for (a = a.current.firstEffect; null !== a;) {
      try {
        var c = a;
        if (0 !== (c.effectTag & 512)) switch (c.tag) {
          case 0:
          case 11:
          case 15:
          case 22:
            Kd(5, c), Md(5, c);
        }
      } catch (d) {
        if (null === a) throw Error(n(330));
        Hd(a, d);
      }
      c = a.nextEffect;
      a.nextEffect = null;
      a = c;
    }
    W = b;
    tb();
    return !0;
  }
  function Xe(a, b, c) {
    b = Dd(c, b);
    b = ae(a, b, 1073741823);
    Kb(a, b);
    a = Be(a, 1073741823);
    null !== a && Z(a);
  }
  function Hd(a, b) {
    if (3 === a.tag) Xe(a, a, b);else for (var c = a.return; null !== c;) {
      if (3 === c.tag) {
        Xe(c, a, b);
        break;
      } else if (1 === c.tag) {
        var d = c.stateNode;
        if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === ee || !ee.has(d))) {
          a = Dd(b, a);
          a = de(c, a, 1073741823);
          Kb(c, a);
          c = Be(c, 1073741823);
          null !== c && Z(c);
          break;
        }
      }
      c = c.return;
    }
  }
  function Pe(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === yd || S === xd && 1073741823 === pe && G() - Xd < te ? He(a, U) : se = !0 : Ee(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
  }
  function Zd(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Tb(), b = Ub(b, a, null));
    a = Be(a, b);
    null !== a && Z(a);
  }
  var Se;
  Se = function Se(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
      if (a.memoizedProps !== b.pendingProps || E.current) I = !0;else {
        if (d < c) {
          I = !1;
          switch (b.tag) {
            case 3:
              kd(b);
              break;
            case 5:
              tc(b);
              break;
            case 1:
              F(b.type) && Ua(b);
              break;
            case 4:
              rc(b, b.stateNode.containerInfo);
              break;
            case 10:
              d = b.memoizedProps.value;
              var e = b.type._context;
              C(yb, e._currentValue2);
              e._currentValue2 = d;
              break;
            case 13:
              if (null !== b.memoizedState) {
                d = b.child.childExpirationTime;
                if (0 !== d && d >= c) return md(a, b, c);
                C(K, K.current & 1);
                b = cd(a, b, c);
                return null !== b ? b.sibling : null;
              }
              C(K, K.current & 1);
              break;
            case 19:
              d = b.childExpirationTime >= c;
              if (0 !== (a.effectTag & 64)) {
                if (d) return pd(a, b, c);
                b.effectTag |= 64;
              }
              e = b.memoizedState;
              null !== e && (e.rendering = null, e.tail = null);
              C(K, K.current);
              if (!d) return null;
          }
          return cd(a, b, c);
        }
        I = !1;
      }
    } else I = !1;
    b.expirationTime = 0;
    switch (b.tag) {
      case 2:
        d = b.type;
        null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
        a = b.pendingProps;
        e = Qa(b, D.current);
        Fb(b, c);
        e = Bc(null, b, d, a, e, c);
        b.effectTag |= 1;
        if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
          b.tag = 1;
          b.memoizedState = null;
          b.updateQueue = null;
          if (F(d)) {
            var f = !0;
            Ua(b);
          } else f = !1;
          b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
          Hb(b);
          var g = d.getDerivedStateFromProps;
          "function" === typeof g && Sb(b, d, g, a);
          e.updater = Wb;
          b.stateNode = e;
          e._reactInternalFiber = b;
          $b(b, d, a, c);
          b = jd(null, b, d, !0, f, c);
        } else b.tag = 0, R(null, b, e, c), b = b.child;
        return b;
      case 16:
        a: {
          e = b.elementType;
          null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
          a = b.pendingProps;
          wa(e);
          if (1 !== e._status) throw e._result;
          e = e._result;
          b.type = e;
          f = b.tag = Ye(e);
          a = H(e, a);
          switch (f) {
            case 0:
              b = gd(null, b, e, a, c);
              break a;
            case 1:
              b = id(null, b, e, a, c);
              break a;
            case 11:
              b = bd(null, b, e, a, c);
              break a;
            case 14:
              b = dd(null, b, e, H(e.type, a), d, c);
              break a;
          }
          throw Error(n(306, e, ""));
        }
        return b;
      case 0:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : H(d, e), gd(a, b, d, e, c);
      case 1:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : H(d, e), id(a, b, d, e, c);
      case 3:
        kd(b);
        d = b.updateQueue;
        if (null === a || null === d) throw Error(n(282));
        d = b.pendingProps;
        e = b.memoizedState;
        e = null !== e ? e.element : null;
        Ib(a, b);
        Mb(b, d, null, c);
        d = b.memoizedState.element;
        d === e ? b = cd(a, b, c) : (R(a, b, d, c), b = b.child);
        return b;
      case 5:
        return tc(b), d = b.pendingProps.children, hd(a, b), R(a, b, d, c), b = b.child, b;
      case 6:
        return null;
      case 13:
        return md(a, b, c);
      case 4:
        return rc(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = jc(b, null, d, c) : R(a, b, d, c), b.child;
      case 11:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : H(d, e), bd(a, b, d, e, c);
      case 7:
        return R(a, b, b.pendingProps, c), b.child;
      case 8:
        return R(a, b, b.pendingProps.children, c), b.child;
      case 12:
        return R(a, b, b.pendingProps.children, c), b.child;
      case 10:
        a: {
          d = b.type._context;
          e = b.pendingProps;
          g = b.memoizedProps;
          f = e.value;
          var h = b.type._context;
          C(yb, h._currentValue2);
          h._currentValue2 = f;
          if (null !== g) if (h = g.value, f = vb(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
            if (g.children === e.children && !E.current) {
              b = cd(a, b, c);
              break a;
            }
          } else for (h = b.child, null !== h && (h.return = b); null !== h;) {
            var k = h.dependencies;
            if (null !== k) {
              g = h.child;
              for (var l = k.firstContext; null !== l;) {
                if (l.context === d && 0 !== (l.observedBits & f)) {
                  1 === h.tag && (l = Jb(c, null), l.tag = 2, Kb(h, l));
                  h.expirationTime < c && (h.expirationTime = c);
                  l = h.alternate;
                  null !== l && l.expirationTime < c && (l.expirationTime = c);
                  Eb(h.return, c);
                  k.expirationTime < c && (k.expirationTime = c);
                  break;
                }
                l = l.next;
              }
            } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
            if (null !== g) g.return = h;else for (g = h; null !== g;) {
              if (g === b) {
                g = null;
                break;
              }
              h = g.sibling;
              if (null !== h) {
                h.return = g.return;
                g = h;
                break;
              }
              g = g.return;
            }
            h = g;
          }
          R(a, b, e.children, c);
          b = b.child;
        }
        return b;
      case 9:
        return e = b.type, f = b.pendingProps, d = f.children, Fb(b, c), e = J(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
      case 14:
        return e = b.type, f = H(e, b.pendingProps), f = H(e.type, f), dd(a, b, e, f, d, c);
      case 15:
        return fd(a, b, b.type, b.pendingProps, d, c);
      case 17:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : H(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, F(d) ? (a = !0, Ua(b)) : a = !1, Fb(b, c), Yb(b, d, e), $b(b, d, e, c), jd(null, b, d, !0, a, c);
      case 19:
        return pd(a, b, c);
    }
    throw Error(n(156, b.tag));
  };
  var Ve = null,
    Pd = null;
  function Ze(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
      var c = b.inject(a);
      Ve = function Ve(a) {
        try {
          b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
        } catch (e) {}
      };
      Pd = function Pd(a) {
        try {
          b.onCommitFiberUnmount(c, a);
        } catch (e) {}
      };
    } catch (d) {}
    return !0;
  }
  function df(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
  }
  function ed(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
  }
  function Ye(a) {
    if ("function" === typeof a) return ed(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
      a = a.$$typeof;
      if (a === oa) return 11;
      if (a === ra) return 14;
    }
    return 2;
  }
  function ec(a, b) {
    var c = a.alternate;
    null === c ? (c = new df(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
      expirationTime: b.expirationTime,
      firstContext: b.firstContext,
      responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
  }
  function gc(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ed(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
      case ia:
        return ic(c.children, e, f, b);
      case na:
        g = 8;
        e |= 7;
        break;
      case ja:
        g = 8;
        e |= 1;
        break;
      case ka:
        return a = new df(12, c, b, e | 8), a.elementType = ka, a.type = ka, a.expirationTime = f, a;
      case pa:
        return a = new df(13, c, b, e), a.type = pa, a.elementType = pa, a.expirationTime = f, a;
      case qa:
        return a = new df(19, c, b, e), a.elementType = qa, a.expirationTime = f, a;
      default:
        if ("object" === typeof a && null !== a) switch (a.$$typeof) {
          case la:
            g = 10;
            break a;
          case ma:
            g = 9;
            break a;
          case oa:
            g = 11;
            break a;
          case ra:
            g = 14;
            break a;
          case sa:
            g = 16;
            d = null;
            break a;
          case ta:
            g = 22;
            break a;
        }
        throw Error(n(130, null == a ? a : typeof a, ""));
    }
    b = new df(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
  }
  function ic(a, b, c, d) {
    a = new df(7, a, d, b);
    a.expirationTime = c;
    return a;
  }
  function fc(a, b, c) {
    a = new df(6, a, null, b);
    a.expirationTime = c;
    return a;
  }
  function hc(a, b, c) {
    b = new df(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
      containerInfo: a.containerInfo,
      pendingChildren: null,
      implementation: a.implementation
    };
    return b;
  }
  function ef(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
  }
  function ff(a, b, c) {
    a = new ef(a, b, c);
    b = new df(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    a.current = b;
    b.stateNode = a;
    Hb(b);
    return a;
  }
  function Ee(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
  }
  function Ad(a, b) {
    var c = a.firstSuspendedTime,
      d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
  }
  function Bd(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
  }
  var gf = null;
  function hf(a) {
    if (null === gf) try {
      var b = ("require" + Math.random()).slice(0, 7);
      gf = (module && module[b])("timers").setImmediate;
    } catch (c) {
      gf = function gf(a) {
        var b = new MessageChannel();
        b.port1.onmessage = a;
        b.port2.postMessage(void 0);
      };
    }
    return gf(a);
  }
  function jf(a, b, c, d) {
    var e = b.current,
      f = Tb(),
      g = Qb.suspense;
    f = Ub(f, e, g);
    a: if (c) {
      c = c._reactInternalFiber;
      b: {
        if (ya(c) !== c || 1 !== c.tag) throw Error(n(170));
        var h = c;
        do {
          switch (h.tag) {
            case 3:
              h = h.stateNode.context;
              break b;
            case 1:
              if (F(h.type)) {
                h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                break b;
              }
          }
          h = h.return;
        } while (null !== h);
        throw Error(n(171));
      }
      if (1 === c.tag) {
        var k = c.type;
        if (F(k)) {
          c = Ta(c, k, h);
          break a;
        }
      }
      c = h;
    } else c = Oa;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = Jb(f, g);
    b.payload = {
      element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Kb(e, b);
    Vb(e, f);
    return f;
  }
  var kf = t.IsSomeRendererActing,
    lf = "function" === typeof scheduler.unstable_flushAllWithoutAsserting,
    mf = scheduler.unstable_flushAllWithoutAsserting || function () {
      for (var a = !1; Ge();) a = !0;
      return a;
    };
  function nf(a) {
    try {
      mf(), hf(function () {
        mf() ? nf(a) : a();
      });
    } catch (b) {
      a(b);
    }
  }
  var of = 0,
    pf = !1,
    qf = {
      createNodeMock: function createNodeMock() {
        return null;
      }
    };
  function rf(a) {
    if (a.isHidden) return null;
    switch (a.tag) {
      case "TEXT":
        return a.text;
      case "INSTANCE":
        var b = a.props;
        var c = ["children"];
        if (null == b) b = {};else {
          var d = {},
            e = Object.keys(b),
            f;
          for (f = 0; f < e.length; f++) {
            var g = e[f];
            0 <= c.indexOf(g) || (d[g] = b[g]);
          }
          b = d;
        }
        c = null;
        if (a.children && a.children.length) for (d = 0; d < a.children.length; d++) e = rf(a.children[d]), null !== e && (null === c ? c = [e] : c.push(e));
        a = {
          type: a.type,
          props: b,
          children: c
        };
        Object.defineProperty(a, "$$typeof", {
          value: Symbol.for("react.test.json")
        });
        return a;
      default:
        throw Error("Unexpected node type in toJSON: " + a.tag);
    }
  }
  function sf(a) {
    if (!a) return null;
    a = tf(a);
    return 0 === a.length ? null : 1 === a.length ? uf(a[0]) : vf(a.map(uf));
  }
  function tf(a) {
    for (var b = []; null != a;) b.push(a), a = a.sibling;
    return b;
  }
  function vf(a) {
    var b = [];
    for (a = [{
      i: 0,
      array: a
    }]; a.length;) for (var c = a.pop(); c.i < c.array.length;) {
      var d = c.array[c.i];
      c.i += 1;
      if (Array.isArray(d)) {
        a.push(c);
        a.push({
          i: 0,
          array: d
        });
        break;
      }
      b.push(d);
    }
    return b;
  }
  function uf(a) {
    if (null == a) return null;
    switch (a.tag) {
      case 3:
        return sf(a.child);
      case 4:
        return sf(a.child);
      case 1:
        return {
          nodeType: "component",
          type: a.type,
          props: objectAssign({}, a.memoizedProps),
          instance: a.stateNode,
          rendered: sf(a.child)
        };
      case 0:
      case 15:
        return {
          nodeType: "component",
          type: a.type,
          props: objectAssign({}, a.memoizedProps),
          instance: null,
          rendered: sf(a.child)
        };
      case 22:
        return {
          nodeType: "block",
          type: a.type,
          props: objectAssign({}, a.memoizedProps),
          instance: null,
          rendered: sf(a.child)
        };
      case 5:
        return {
          nodeType: "host",
          type: a.type,
          props: objectAssign({}, a.memoizedProps),
          instance: null,
          rendered: vf(tf(a.child).map(uf))
        };
      case 6:
        return a.stateNode.text;
      case 7:
      case 10:
      case 9:
      case 8:
      case 12:
      case 11:
      case 14:
      case 17:
      case 21:
        return sf(a.child);
      default:
        throw Error(n(214, a.tag));
    }
  }
  var wf = new Set([0, 1, 5, 11, 14, 15, 22, 3]);
  function xf(a) {
    var b = [],
      c = a;
    if (null === c.child) return b;
    c.child.return = c;
    c = c.child;
    a: for (;;) {
      var d = !1;
      wf.has(c.tag) ? b.push(yf(c)) : 6 === c.tag ? b.push("" + c.memoizedProps) : d = !0;
      if (d && null !== c.child) c.child.return = c, c = c.child;else {
        for (; null === c.sibling;) {
          if (c.return === a) break a;
          c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
      }
    }
    return b;
  }
  var Bf = function () {
    function a(a) {
      if (!wf.has(a.tag)) throw Error(n(225, a.tag));
      this._fiber = a;
    }
    var b = a.prototype;
    b._currentFiber = function () {
      var a = Aa(this._fiber);
      if (null === a) throw Error(n(224));
      return a;
    };
    b.find = function (a) {
      return zf(this.findAll(a, {
        deep: !1
      }), "matching custom predicate: " + a.toString());
    };
    b.findByType = function (a) {
      return zf(this.findAllByType(a, {
        deep: !1
      }), 'with node type: "' + (a.displayName || a.name) + '"');
    };
    b.findByProps = function (a) {
      return zf(this.findAllByProps(a, {
        deep: !1
      }), "with props: " + JSON.stringify(a));
    };
    b.findAll = function (a) {
      return Af(this, a, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null);
    };
    b.findAllByType = function (a) {
      return Af(this, function (b) {
        return b.type === a;
      }, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null);
    };
    b.findAllByProps = function (a) {
      return Af(this, function (b) {
        var c;
        if (c = b.props) a: {
          for (var d in a) if (b.props[d] !== a[d]) {
            c = !1;
            break a;
          }
          c = !0;
        }
        return c;
      }, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null);
    };
    ea(a, [{
      key: "instance",
      get: function get() {
        return 5 === this._fiber.tag ? Fa(this._fiber.stateNode) : this._fiber.stateNode;
      }
    }, {
      key: "type",
      get: function get() {
        return this._fiber.type;
      }
    }, {
      key: "props",
      get: function get() {
        return this._currentFiber().memoizedProps;
      }
    }, {
      key: "parent",
      get: function get() {
        for (var a = this._fiber.return; null !== a;) {
          if (wf.has(a.tag)) {
            if (3 === a.tag && 2 > xf(a).length) break;
            return yf(a);
          }
          a = a.return;
        }
        return null;
      }
    }, {
      key: "children",
      get: function get() {
        return xf(this._currentFiber());
      }
    }]);
    return a;
  }();
  function Af(a, b, c) {
    var d = c ? c.deep : !0,
      e = [];
    if (b(a) && (e.push(a), !d)) return e;
    a.children.forEach(function (a) {
      "string" !== typeof a && e.push.apply(e, Af(a, b, c));
    });
    return e;
  }
  function zf(a, b) {
    if (1 === a.length) return a[0];
    throw Error((0 === a.length ? "No instances found " : "Expected 1 but found " + a.length + " instances ") + b);
  }
  var Cf = {
      _Scheduler: unstable_mock,
      create: function create(a, b) {
        var c = qf.createNodeMock,
          d = !1;
        "object" === typeof b && null !== b && ("function" === typeof b.createNodeMock && (c = b.createNodeMock), !0 === b.unstable_isConcurrent && (d = !0));
        var e = {
            children: [],
            createNodeMock: c,
            tag: "CONTAINER"
          },
          f = ff(e, d ? 2 : 0, !1);
        if (null == f) throw Error(n(215));
        jf(a, f, null, null);
        a = {
          _Scheduler: unstable_mock,
          root: void 0,
          toJSON: function toJSON() {
            if (null == f || null == f.current || null == e || 0 === e.children.length) return null;
            if (1 === e.children.length) return rf(e.children[0]);
            if (2 === e.children.length && !0 === e.children[0].isHidden && !1 === e.children[1].isHidden) return rf(e.children[1]);
            var a = null;
            if (e.children && e.children.length) for (var b = 0; b < e.children.length; b++) {
              var c = rf(e.children[b]);
              null !== c && (null === a ? a = [c] : a.push(c));
            }
            return a;
          },
          toTree: function toTree() {
            return null == f || null == f.current ? null : uf(f.current);
          },
          update: function update(a) {
            null != f && null != f.current && jf(a, f, null, null);
          },
          unmount: function unmount() {
            null != f && null != f.current && (jf(null, f, null, null), f = e = null);
          },
          getInstance: function getInstance() {
            if (null == f || null == f.current) return null;
            a: {
              var a = f.current;
              if (a.child) switch (a.child.tag) {
                case 5:
                  a = Fa(a.child.stateNode);
                  break a;
                default:
                  a = a.child.stateNode;
              } else a = null;
            }
            return a;
          },
          unstable_flushSync: function unstable_flushSync(a) {
            a: {
              if ((W & (je | ke)) !== V) throw Error(n(187));
              var b = W;
              W |= 1;
              try {
                var c = pb(99, a.bind(null, void 0));
                break a;
              } finally {
                W = b, tb();
              }
              c = void 0;
            }
            return c;
          }
        };
        Object.defineProperty(a, "root", {
          configurable: !0,
          enumerable: !0,
          get: function get() {
            if (null === f) throw Error("Can't access .root on unmounted test renderer");
            var a = xf(f.current);
            if (0 === a.length) throw Error("Can't access .root on unmounted test renderer");
            return 1 === a.length ? a[0] : yf(f.current);
          }
        });
        return a;
      },
      unstable_batchedUpdates: Oe,
      act: function act(a) {
        function b() {
          of--;
          kf.current = c;
        }
        !1 === pf && (pf = !0, console.error("act(...) is not supported in production builds of React, and might not behave as expected."));
        of++;
        var c = kf.current;
        kf.current = !0;
        try {
          var d = Oe(a);
        } catch (e) {
          throw b(), e;
        }
        if (null !== d && "object" === typeof d && "function" === typeof d.then) return {
          then: function then(a, f) {
            d.then(function () {
              1 < of || !0 === lf && !0 === c ? (b(), a()) : nf(function (c) {
                b();
                c ? f(c) : a();
              });
            }, function (a) {
              b();
              f(a);
            });
          }
        };
        try {
          1 !== of || !1 !== lf && !1 !== c || mf(), b();
        } catch (e) {
          throw b(), e;
        }
        return {
          then: function then(a) {
            a();
          }
        };
      }
    },
    Df = new WeakMap();
  function yf(a) {
    var b = Df.get(a);
    void 0 === b && null !== a.alternate && (b = Df.get(a.alternate));
    void 0 === b && (b = new Bf(a), Df.set(a, b));
    return b;
  }
  (function (a) {
    var b = a.findFiberByHostInstance;
    return Ze(objectAssign({}, a, {
      overrideHookState: null,
      overrideProps: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: t.ReactCurrentDispatcher,
      findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = Ba(a);
        return null === a ? null : a.stateNode;
      },
      findFiberByHostInstance: function findFiberByHostInstance(a) {
        return b ? b(a) : null;
      },
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null
    }));
  })({
    findFiberByHostInstance: function findFiberByHostInstance() {
      throw Error("TestRenderer does not support findFiberByHostInstance()");
    },
    bundleType: 0,
    version: "16.13.1",
    rendererPackageName: "react-test-renderer"
  });
  module.exports = Cf.default || Cf;
});

/** @license React v0.19.1
 * scheduler-tracing.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$3 = 0;
var __interactionsRef = null;
var __subscriberRef = null;
var unstable_clear = function unstable_clear(a) {
  return a();
};
var unstable_getCurrent = function unstable_getCurrent() {
  return null;
};
var unstable_getThreadID = function unstable_getThreadID() {
  return ++b$3;
};
var unstable_subscribe = function unstable_subscribe() {};
var unstable_trace = function unstable_trace(a, d, c) {
  return c();
};
var unstable_unsubscribe = function unstable_unsubscribe() {};
var unstable_wrap = function unstable_wrap(a) {
  return a;
};
var schedulerTracing_production_min = {
  __interactionsRef: __interactionsRef,
  __subscriberRef: __subscriberRef,
  unstable_clear: unstable_clear,
  unstable_getCurrent: unstable_getCurrent,
  unstable_getThreadID: unstable_getThreadID,
  unstable_subscribe: unstable_subscribe,
  unstable_trace: unstable_trace,
  unstable_unsubscribe: unstable_unsubscribe,
  unstable_wrap: unstable_wrap
};
var schedulerTracing_development = createCommonjsModule$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.

      var interactionIDCounter = 0;
      var threadIDCounter = 0; // Set of currently traced interactions.
      // Interactions "stack"–
      // Meaning that newly traced interactions are appended to the previously active set.
      // When an interaction goes out of scope, the previous set (if any) is restored.

      exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.

      exports.__subscriberRef = null;
      {
        exports.__interactionsRef = {
          current: new Set()
        };
        exports.__subscriberRef = {
          current: null
        };
      }
      function unstable_clear(callback) {
        var prevInteractions = exports.__interactionsRef.current;
        exports.__interactionsRef.current = new Set();
        try {
          return callback();
        } finally {
          exports.__interactionsRef.current = prevInteractions;
        }
      }
      function unstable_getCurrent() {
        {
          return exports.__interactionsRef.current;
        }
      }
      function unstable_getThreadID() {
        return ++threadIDCounter;
      }
      function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
          __count: 1,
          id: interactionIDCounter++,
          name: name,
          timestamp: timestamp
        };
        var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.

        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        exports.__interactionsRef.current = interactions;
        var subscriber = exports.__subscriberRef.current;
        var returnValue;
        try {
          if (subscriber !== null) {
            subscriber.onInteractionTraced(interaction);
          }
        } finally {
          try {
            if (subscriber !== null) {
              subscriber.onWorkStarted(interactions, threadID);
            }
          } finally {
            try {
              returnValue = callback();
            } finally {
              exports.__interactionsRef.current = prevInteractions;
              try {
                if (subscriber !== null) {
                  subscriber.onWorkStopped(interactions, threadID);
                }
              } finally {
                interaction.__count--; // If no async work was scheduled for this interaction,
                // Notify subscribers that it's completed.

                if (subscriber !== null && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              }
            }
          }
        }
        return returnValue;
      }
      function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = exports.__interactionsRef.current;
        var subscriber = exports.__subscriberRef.current;
        if (subscriber !== null) {
          subscriber.onWorkScheduled(wrappedInteractions, threadID);
        } // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.

        wrappedInteractions.forEach(function (interaction) {
          interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
          var prevInteractions = exports.__interactionsRef.current;
          exports.__interactionsRef.current = wrappedInteractions;
          subscriber = exports.__subscriberRef.current;
          try {
            var returnValue;
            try {
              if (subscriber !== null) {
                subscriber.onWorkStarted(wrappedInteractions, threadID);
              }
            } finally {
              try {
                returnValue = callback.apply(undefined, arguments);
              } finally {
                exports.__interactionsRef.current = prevInteractions;
                if (subscriber !== null) {
                  subscriber.onWorkStopped(wrappedInteractions, threadID);
                }
              }
            }
            return returnValue;
          } finally {
            if (!hasRun) {
              // We only expect a wrapped function to be executed once,
              // But in the event that it's executed more than once–
              // Only decrement the outstanding interaction counts once.
              hasRun = true; // Update pending async counts for all wrapped interactions.
              // If this was the last scheduled async work for any of them,
              // Mark them as completed.

              wrappedInteractions.forEach(function (interaction) {
                interaction.__count--;
                if (subscriber !== null && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              });
            }
          }
        }
        wrapped.cancel = function cancel() {
          subscriber = exports.__subscriberRef.current;
          try {
            if (subscriber !== null) {
              subscriber.onWorkCanceled(wrappedInteractions, threadID);
            }
          } finally {
            // Update pending async counts for all wrapped interactions.
            // If this was the last scheduled async work for any of them,
            // Mark them as completed.
            wrappedInteractions.forEach(function (interaction) {
              interaction.__count--;
              if (subscriber && interaction.__count === 0) {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
              }
            });
          }
        };
        return wrapped;
      }
      var subscribers = null;
      {
        subscribers = new Set();
      }
      function unstable_subscribe(subscriber) {
        {
          subscribers.add(subscriber);
          if (subscribers.size === 1) {
            exports.__subscriberRef.current = {
              onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
              onInteractionTraced: onInteractionTraced,
              onWorkCanceled: onWorkCanceled,
              onWorkScheduled: onWorkScheduled,
              onWorkStarted: onWorkStarted,
              onWorkStopped: onWorkStopped
            };
          }
        }
      }
      function unstable_unsubscribe(subscriber) {
        {
          subscribers.delete(subscriber);
          if (subscribers.size === 0) {
            exports.__subscriberRef.current = null;
          }
        }
      }
      function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onInteractionTraced(interaction);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkScheduled(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkStarted(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkStopped(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkCanceled(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      exports.unstable_clear = unstable_clear;
      exports.unstable_getCurrent = unstable_getCurrent;
      exports.unstable_getThreadID = unstable_getThreadID;
      exports.unstable_subscribe = unstable_subscribe;
      exports.unstable_trace = unstable_trace;
      exports.unstable_unsubscribe = unstable_unsubscribe;
      exports.unstable_wrap = unstable_wrap;
    })();
  }
});
var schedulerTracing_development_1 = schedulerTracing_development.__interactionsRef;
var schedulerTracing_development_2 = schedulerTracing_development.__subscriberRef;
var schedulerTracing_development_3 = schedulerTracing_development.unstable_clear;
var schedulerTracing_development_4 = schedulerTracing_development.unstable_getCurrent;
var schedulerTracing_development_5 = schedulerTracing_development.unstable_getThreadID;
var schedulerTracing_development_6 = schedulerTracing_development.unstable_subscribe;
var schedulerTracing_development_7 = schedulerTracing_development.unstable_trace;
var schedulerTracing_development_8 = schedulerTracing_development.unstable_unsubscribe;
var schedulerTracing_development_9 = schedulerTracing_development.unstable_wrap;
var tracing = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = schedulerTracing_production_min;
  } else {
    module.exports = schedulerTracing_development;
  }
});
var reactTestRenderer_development = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var _assign = objectAssign;
      var Scheduler = unstable_mock;
      var React = react;
      var checkPropTypes = checkPropTypes_1;
      var Scheduler$1 = scheduler;
      var tracing$1 = tracing;
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // Prevent newer renderers from RTE when used with older react package versions.
      // Current owner and dispatcher used to share the same ref,
      // but PR #14548 split them out to better support the react-debug-tools package.

      if (!ReactSharedInternals.hasOwnProperty('ReactCurrentDispatcher')) {
        ReactSharedInternals.ReactCurrentDispatcher = {
          current: null
        };
      }
      if (!ReactSharedInternals.hasOwnProperty('ReactCurrentBatchConfig')) {
        ReactSharedInternals.ReactCurrentBatchConfig = {
          suspense: null
        };
      }

      // by calls to these methods by a Babel plugin.
      //
      // In PROD (or in packages without access to React internals),
      // they are left as they are instead.

      function warn(format) {
        {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          printWarning('warn', format, args);
        }
      }
      function error(format) {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          printWarning('error', format, args);
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;
          if (!hasExistingStack) {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== '') {
              format += '%s';
              args = args.concat([stack]);
            }
          }
          var argsWithFormat = args.map(function (item) {
            return '' + item;
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });
            throw new Error(message);
          } catch (x) {}
        }
      }
      var FunctionComponent = 0;
      var ClassComponent = 1;
      var IndeterminateComponent = 2; // Before we know whether it is function or class

      var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

      var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

      var HostComponent = 5;
      var HostText = 6;
      var Fragment$$1 = 7;
      var Mode = 8;
      var ContextConsumer = 9;
      var ContextProvider = 10;
      var ForwardRef = 11;
      var Profiler = 12;
      var SuspenseComponent = 13;
      var MemoComponent = 14;
      var SimpleMemoComponent = 15;
      var LazyComponent = 16;
      var IncompleteClassComponent = 17;
      var DehydratedFragment = 18;
      var SuspenseListComponent = 19;
      var FundamentalComponent = 20;
      var ScopeComponent = 21;
      var Block = 22;

      /**
       * `ReactInstanceMap` maintains a mapping from a public facing stateful
       * instance (key) and the internal representation (value). This allows public
       * methods to accept the user facing instance as an argument and map them back
       * to internal methods.
       *
       * Note that this module is currently shared and assumed to be stateless.
       * If this becomes an actual Map, that will break.
       */
      function get(key) {
        return key._reactInternalFiber;
      }
      function set(key, value) {
        key._reactInternalFiber = value;
      }

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }
        return null;
      }
      var Uninitialized = -1;
      var Pending = 0;
      var Resolved = 1;
      var Rejected = 2;
      function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
      }
      function initializeLazyComponentType(lazyComponent) {
        if (lazyComponent._status === Uninitialized) {
          lazyComponent._status = Pending;
          var ctor = lazyComponent._ctor;
          var thenable = ctor();
          lazyComponent._result = thenable;
          thenable.then(function (moduleObject) {
            if (lazyComponent._status === Pending) {
              var defaultExport = moduleObject.default;
              {
                if (defaultExport === undefined) {
                  error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + "const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                }
              }
              lazyComponent._status = Resolved;
              lazyComponent._result = defaultExport;
            }
          }, function (error) {
            if (lazyComponent._status === Pending) {
              lazyComponent._status = Rejected;
              lazyComponent._result = error;
            }
          });
        }
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }
      function getComponentName(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }
        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }
        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }
        if (typeof type === 'string') {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';
          case REACT_PORTAL_TYPE:
            return 'Portal';
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';
          case REACT_SUSPENSE_TYPE:
            return 'Suspense';
          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }
        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              return 'Context.Consumer';
            case REACT_PROVIDER_TYPE:
              return 'Context.Provider';
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
              return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
              return getComponentName(type.render);
            case REACT_LAZY_TYPE:
              {
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
                break;
              }
          }
        }
        return null;
      }

      // Don't change these two values. They're used by React Dev Tools.
      var NoEffect = /*              */
      0;
      var PerformedWork = /*         */
      1; // You can change the rest (and add more).

      var Placement = /*             */
      2;
      var Update = /*                */
      4;
      var PlacementAndUpdate = /*    */
      6;
      var Deletion = /*              */
      8;
      var ContentReset = /*          */
      16;
      var Callback = /*              */
      32;
      var DidCapture = /*            */
      64;
      var Ref = /*                   */
      128;
      var Snapshot = /*              */
      256;
      var Passive = /*               */
      512;
      var Hydrating = /*             */
      1024;
      var HydratingAndUpdate = /*    */
      1028; // Passive & Update & Callback & Ref & Snapshot

      var LifecycleEffectMask = /*   */
      932; // Union of all host effects

      var HostEffectMask = /*        */
      2047;
      var Incomplete = /*            */
      2048;
      var ShouldCapture = /*         */
      4096;
      var enableFundamentalAPI = false;
      var warnAboutStringRefs = false;
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
          // If there is no alternate, this might be a new tree that isn't inserted
          // yet. If it is, then it will have a pending insertion effect on it.
          var nextNode = node;
          do {
            node = nextNode;
            if ((node.effectTag & (Placement | Hydrating)) !== NoEffect) {
              // This is an insertion or in-progress hydration. The nearest possible
              // mounted fiber is the parent but we need to continue to figure out
              // if that one is still mounted.
              nearestMounted = node.return;
            }
            nextNode = node.return;
          } while (nextNode);
        } else {
          while (node.return) {
            node = node.return;
          }
        }
        if (node.tag === HostRoot) {
          // TODO: Check if this was a nested HostRoot when used with
          // renderContainerIntoSubtree.
          return nearestMounted;
        } // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.

        return null;
      }
      function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
      }
      function isMounted(component) {
        {
          var owner = ReactCurrentOwner.current;
          if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) {
              error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component');
            }
            instance._warnedAboutRefsInRender = true;
          }
        }
        var fiber = get(component);
        if (!fiber) {
          return false;
        }
        return getNearestMountedFiber(fiber) === fiber;
      }
      function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) {
          {
            throw Error("Unable to find node on an unmounted component.");
          }
        }
      }
      function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
          // If there is no alternate, then we only need to check if it is mounted.
          var nearestMounted = getNearestMountedFiber(fiber);
          if (!(nearestMounted !== null)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
          if (nearestMounted !== fiber) {
            return null;
          }
          return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.

        var a = fiber;
        var b = alternate;
        while (true) {
          var parentA = a.return;
          if (parentA === null) {
            // We're at the root.
            break;
          }
          var parentB = parentA.alternate;
          if (parentB === null) {
            // There is no alternate. This is an unusual case. Currently, it only
            // happens when a Suspense component is hidden. An extra fragment fiber
            // is inserted in between the Suspense fiber and its children. Skip
            // over this extra fragment fiber and proceed to the next parent.
            var nextParent = parentA.return;
            if (nextParent !== null) {
              a = b = nextParent;
              continue;
            } // If there's no parent, we're at the root.

            break;
          } // If both copies of the parent fiber point to the same child, we can
          // assume that the child is current. This happens when we bailout on low
          // priority: the bailed out fiber's child reuses the current child.

          if (parentA.child === parentB.child) {
            var child = parentA.child;
            while (child) {
              if (child === a) {
                // We've determined that A is the current branch.
                assertIsMounted(parentA);
                return fiber;
              }
              if (child === b) {
                // We've determined that B is the current branch.
                assertIsMounted(parentA);
                return alternate;
              }
              child = child.sibling;
            } // We should never have an alternate for any mounting node. So the only
            // way this could possibly happen is if this was unmounted, if at all.

            {
              {
                throw Error("Unable to find node on an unmounted component.");
              }
            }
          }
          if (a.return !== b.return) {
            // The return pointer of A and the return pointer of B point to different
            // fibers. We assume that return pointers never criss-cross, so A must
            // belong to the child set of A.return, and B must belong to the child
            // set of B.return.
            a = parentA;
            b = parentB;
          } else {
            // The return pointers point to the same fiber. We'll have to use the
            // default, slow path: scan the child sets of each parent alternate to see
            // which child belongs to which set.
            //
            // Search parent A's child set
            var didFindChild = false;
            var _child = parentA.child;
            while (_child) {
              if (_child === a) {
                didFindChild = true;
                a = parentA;
                b = parentB;
                break;
              }
              if (_child === b) {
                didFindChild = true;
                b = parentA;
                a = parentB;
                break;
              }
              _child = _child.sibling;
            }
            if (!didFindChild) {
              // Search parent B's child set
              _child = parentB.child;
              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentB;
                  b = parentA;
                  break;
                }
                if (_child === b) {
                  didFindChild = true;
                  b = parentB;
                  a = parentA;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                {
                  throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
              }
            }
          }
          if (!(a.alternate === b)) {
            {
              throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.

        if (!(a.tag === HostRoot)) {
          {
            throw Error("Unable to find node on an unmounted component.");
          }
        }
        if (a.stateNode.current === a) {
          // We've determined that A is the current branch.
          return fiber;
        } // Otherwise B has to be current branch.

        return alternate;
      }
      function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) {
          return null;
        } // Next we'll drill down this component to find the first HostComponent/Text.

        var node = currentParent;
        while (true) {
          if (node.tag === HostComponent || node.tag === HostText) {
            return node;
          } else if (node.child) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === currentParent) {
            return null;
          }
          while (!node.sibling) {
            if (!node.return || node.return === currentParent) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable

        return null;
      }

      // can re-export everything from this module.

      function shim() {
        {
          {
            throw Error("The current renderer does not support hydration. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      } // Hydration (when unsupported)
      var isSuspenseInstancePending = shim;
      var isSuspenseInstanceFallback = shim;
      var NO_CONTEXT = {};
      var UPDATE_SIGNAL = {};
      var nodeToInstanceMap = new WeakMap();
      {
        Object.freeze(NO_CONTEXT);
        Object.freeze(UPDATE_SIGNAL);
      }
      function getPublicInstance(inst) {
        switch (inst.tag) {
          case 'INSTANCE':
            var createNodeMock = inst.rootContainerInstance.createNodeMock;
            var mockNode = createNodeMock({
              type: inst.type,
              props: inst.props
            });
            if (typeof mockNode === 'object' && mockNode !== null) {
              nodeToInstanceMap.set(mockNode, inst);
            }
            return mockNode;
          default:
            return inst;
        }
      }
      function appendChild(parentInstance, child) {
        {
          if (!Array.isArray(parentInstance.children)) {
            error('An invalid container has been provided. ' + 'This may indicate that another renderer is being used in addition to the test renderer. ' + '(For example, ReactDOM.createPortal inside of a ReactTestRenderer tree.) ' + 'This is not supported.');
          }
        }
        var index = parentInstance.children.indexOf(child);
        if (index !== -1) {
          parentInstance.children.splice(index, 1);
        }
        parentInstance.children.push(child);
      }
      function insertBefore(parentInstance, child, beforeChild) {
        var index = parentInstance.children.indexOf(child);
        if (index !== -1) {
          parentInstance.children.splice(index, 1);
        }
        var beforeIndex = parentInstance.children.indexOf(beforeChild);
        parentInstance.children.splice(beforeIndex, 0, child);
      }
      function removeChild(parentInstance, child) {
        var index = parentInstance.children.indexOf(child);
        parentInstance.children.splice(index, 1);
      }
      function getRootHostContext(rootContainerInstance) {
        return NO_CONTEXT;
      }
      function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        return NO_CONTEXT;
      }
      function prepareForCommit(containerInfo) {// noop
      }
      function resetAfterCommit(containerInfo) {// noop
      }
      function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var propsToUse = props;
        return {
          type: type,
          props: propsToUse,
          isHidden: false,
          children: [],
          internalInstanceHandle: internalInstanceHandle,
          rootContainerInstance: rootContainerInstance,
          tag: 'INSTANCE'
        };
      }
      function appendInitialChild(parentInstance, child) {
        var index = parentInstance.children.indexOf(child);
        if (index !== -1) {
          parentInstance.children.splice(index, 1);
        }
        parentInstance.children.push(child);
      }
      function prepareUpdate(testElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        return UPDATE_SIGNAL;
      }
      function shouldSetTextContent(type, props) {
        return false;
      }
      function shouldDeprioritizeSubtree(type, props) {
        return false;
      }
      function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        return {
          text: text,
          isHidden: false,
          tag: 'TEXT'
        };
      }
      var scheduleTimeout = setTimeout;
      var cancelTimeout = clearTimeout;
      var noTimeout = -1; // -------------------
      function commitUpdate(instance, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        instance.type = type;
        instance.props = newProps;
      }
      function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.text = newText;
      }
      function resetTextContent(testElement) {// noop
      }
      var appendChildToContainer = appendChild;
      var insertInContainerBefore = insertBefore;
      var removeChildFromContainer = removeChild;
      function hideInstance(instance) {
        instance.isHidden = true;
      }
      function hideTextInstance(textInstance) {
        textInstance.isHidden = true;
      }
      function unhideInstance(instance, props) {
        instance.isHidden = false;
      }
      function unhideTextInstance(textInstance, text) {
        textInstance.isHidden = false;
      }
      var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
      function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = '';
        if (source) {
          var path = source.fileName;
          var fileName = path.replace(BEFORE_SLASH_RE, '');
          {
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
              var match = path.match(BEFORE_SLASH_RE);
              if (match) {
                var pathBeforeSlash = match[1];
                if (pathBeforeSlash) {
                  var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
                  fileName = folderName + '/' + fileName;
                }
              }
            }
          }
          sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
        } else if (ownerName) {
          sourceInfo = ' (created by ' + ownerName + ')';
        }
        return '\n    in ' + (name || 'Unknown') + sourceInfo;
      }
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function describeFiber(fiber) {
        switch (fiber.tag) {
          case HostRoot:
          case HostPortal:
          case HostText:
          case Fragment$$1:
          case ContextProvider:
          case ContextConsumer:
            return '';
          default:
            var owner = fiber._debugOwner;
            var source = fiber._debugSource;
            var name = getComponentName(fiber.type);
            var ownerName = null;
            if (owner) {
              ownerName = getComponentName(owner.type);
            }
            return describeComponentFrame(name, source, ownerName);
        }
      }
      function getStackByFiberInDevAndProd(workInProgress) {
        var info = '';
        var node = workInProgress;
        do {
          info += describeFiber(node);
          node = node.return;
        } while (node);
        return info;
      }
      var current = null;
      var isRendering = false;
      function getCurrentFiberOwnerNameInDevOrNull() {
        {
          if (current === null) {
            return null;
          }
          var owner = current._debugOwner;
          if (owner !== null && typeof owner !== 'undefined') {
            return getComponentName(owner.type);
          }
        }
        return null;
      }
      function getCurrentFiberStackInDev() {
        {
          if (current === null) {
            return '';
          } // Safe because if current fiber exists, we are reconciling,
          // and it is guaranteed to be the work-in-progress version.

          return getStackByFiberInDevAndProd(current);
        }
      }
      function resetCurrentFiber() {
        {
          ReactDebugCurrentFrame.getCurrentStack = null;
          current = null;
          isRendering = false;
        }
      }
      function setCurrentFiber(fiber) {
        {
          ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
          current = fiber;
          isRendering = false;
        }
      }
      function setIsRendering(rendering) {
        {
          isRendering = rendering;
        }
      }

      // Prefix measurements so that it's possible to filter them.
      // Longer prefixes are hard to read in DevTools.
      var reactEmoji = "\u269B";
      var warningEmoji = "\u26D4";
      var supportsUserTiming = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function'; // Keep track of current fiber so that we know the path to unwind on pause.
      // TODO: this looks the same as nextUnitOfWork in scheduler. Can we unify them?

      var currentFiber = null; // If we're in the middle of user code, which fiber and method is it?
      // Reusing `currentFiber` would be confusing for this because user code fiber
      // can change during commit phase too, but we don't need to unwind it (since
      // lifecycles in the commit phase don't resemble a tree).

      var currentPhase = null;
      var currentPhaseFiber = null; // Did lifecycle hook schedule an update? This is often a performance problem,
      // so we will keep track of it, and include it in the report.
      // Track commits caused by cascading updates.

      var isCommitting = false;
      var hasScheduledUpdateInCurrentCommit = false;
      var hasScheduledUpdateInCurrentPhase = false;
      var commitCountInCurrentWorkLoop = 0;
      var effectCountInCurrentCommit = 0;
      // to avoid stretch the commit phase with measurement overhead.

      var labelsInCurrentCommit = new Set();
      var formatMarkName = function formatMarkName(markName) {
        return reactEmoji + " " + markName;
      };
      var formatLabel = function formatLabel(label, warning) {
        var prefix = warning ? warningEmoji + " " : reactEmoji + " ";
        var suffix = warning ? " Warning: " + warning : '';
        return "" + prefix + label + suffix;
      };
      var beginMark = function beginMark(markName) {
        performance.mark(formatMarkName(markName));
      };
      var clearMark = function clearMark(markName) {
        performance.clearMarks(formatMarkName(markName));
      };
      var endMark = function endMark(label, markName, warning) {
        var formattedMarkName = formatMarkName(markName);
        var formattedLabel = formatLabel(label, warning);
        try {
          performance.measure(formattedLabel, formattedMarkName);
        } catch (err) {} // If previous mark was missing for some reason, this will throw.
        // This could only happen if React crashed in an unexpected place earlier.
        // Don't pile on with more errors.
        // Clear marks immediately to avoid growing buffer.

        performance.clearMarks(formattedMarkName);
        performance.clearMeasures(formattedLabel);
      };
      var getFiberMarkName = function getFiberMarkName(label, debugID) {
        return label + " (#" + debugID + ")";
      };
      var getFiberLabel = function getFiberLabel(componentName, isMounted, phase) {
        if (phase === null) {
          // These are composite component total time measurements.
          return componentName + " [" + (isMounted ? 'update' : 'mount') + "]";
        } else {
          // Composite component methods.
          return componentName + "." + phase;
        }
      };
      var beginFiberMark = function beginFiberMark(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        if (isCommitting && labelsInCurrentCommit.has(label)) {
          // During the commit phase, we don't show duplicate labels because
          // there is a fixed overhead for every measurement, and we don't
          // want to stretch the commit phase beyond necessary.
          return false;
        }
        labelsInCurrentCommit.add(label);
        var markName = getFiberMarkName(label, debugID);
        beginMark(markName);
        return true;
      };
      var clearFiberMark = function clearFiberMark(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        clearMark(markName);
      };
      var endFiberMark = function endFiberMark(fiber, phase, warning) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        endMark(label, markName, warning);
      };
      var shouldIgnoreFiber = function shouldIgnoreFiber(fiber) {
        // Host components should be skipped in the timeline.
        // We could check typeof fiber.type, but does this work with RN?
        switch (fiber.tag) {
          case HostRoot:
          case HostComponent:
          case HostText:
          case HostPortal:
          case Fragment$$1:
          case ContextProvider:
          case ContextConsumer:
          case Mode:
            return true;
          default:
            return false;
        }
      };
      var clearPendingPhaseMeasurement = function clearPendingPhaseMeasurement() {
        if (currentPhase !== null && currentPhaseFiber !== null) {
          clearFiberMark(currentPhaseFiber, currentPhase);
        }
        currentPhaseFiber = null;
        currentPhase = null;
        hasScheduledUpdateInCurrentPhase = false;
      };
      var pauseTimers = function pauseTimers() {
        // Stops all currently active measurements so that they can be resumed
        // if we continue in a later deferred loop from the same unit of work.
        var fiber = currentFiber;
        while (fiber) {
          if (fiber._debugIsCurrentlyTiming) {
            endFiberMark(fiber, null, null);
          }
          fiber = fiber.return;
        }
      };
      var resumeTimersRecursively = function resumeTimersRecursively(fiber) {
        if (fiber.return !== null) {
          resumeTimersRecursively(fiber.return);
        }
        if (fiber._debugIsCurrentlyTiming) {
          beginFiberMark(fiber, null);
        }
      };
      var resumeTimers = function resumeTimers() {
        // Resumes all measurements that were active during the last deferred loop.
        if (currentFiber !== null) {
          resumeTimersRecursively(currentFiber);
        }
      };
      function recordEffect() {
        {
          effectCountInCurrentCommit++;
        }
      }
      function recordScheduleUpdate() {
        {
          if (isCommitting) {
            hasScheduledUpdateInCurrentCommit = true;
          }
          if (currentPhase !== null && currentPhase !== 'componentWillMount' && currentPhase !== 'componentWillReceiveProps') {
            hasScheduledUpdateInCurrentPhase = true;
          }
        }
      }
      function startWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, this is the fiber to unwind from.

          currentFiber = fiber;
          if (!beginFiberMark(fiber, null)) {
            return;
          }
          fiber._debugIsCurrentlyTiming = true;
        }
      }
      function cancelWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // Remember we shouldn't complete measurement for this fiber.
          // Otherwise flamechart will be deep even for small updates.

          fiber._debugIsCurrentlyTiming = false;
          clearFiberMark(fiber, null);
        }
      }
      function stopWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, its parent is the fiber to unwind from.

          currentFiber = fiber.return;
          if (!fiber._debugIsCurrentlyTiming) {
            return;
          }
          fiber._debugIsCurrentlyTiming = false;
          endFiberMark(fiber, null, null);
        }
      }
      function stopFailedWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, its parent is the fiber to unwind from.

          currentFiber = fiber.return;
          if (!fiber._debugIsCurrentlyTiming) {
            return;
          }
          fiber._debugIsCurrentlyTiming = false;
          var warning = fiber.tag === SuspenseComponent ? 'Rendering was suspended' : 'An error was thrown inside this error boundary';
          endFiberMark(fiber, null, warning);
        }
      }
      function startPhaseTimer(fiber, phase) {
        {
          if (!supportsUserTiming) {
            return;
          }
          clearPendingPhaseMeasurement();
          if (!beginFiberMark(fiber, phase)) {
            return;
          }
          currentPhaseFiber = fiber;
          currentPhase = phase;
        }
      }
      function stopPhaseTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          if (currentPhase !== null && currentPhaseFiber !== null) {
            var warning = hasScheduledUpdateInCurrentPhase ? 'Scheduled a cascading update' : null;
            endFiberMark(currentPhaseFiber, currentPhase, warning);
          }
          currentPhase = null;
          currentPhaseFiber = null;
        }
      }
      function startWorkLoopTimer(nextUnitOfWork) {
        {
          currentFiber = nextUnitOfWork;
          if (!supportsUserTiming) {
            return;
          }
          commitCountInCurrentWorkLoop = 0; // This is top level call.
          // Any other measurements are performed within.

          beginMark('(React Tree Reconciliation)'); // Resume any measurements that were in progress during the last loop.

          resumeTimers();
        }
      }
      function stopWorkLoopTimer(interruptedBy, didCompleteRoot) {
        {
          if (!supportsUserTiming) {
            return;
          }
          var warning = null;
          if (interruptedBy !== null) {
            if (interruptedBy.tag === HostRoot) {
              warning = 'A top-level update interrupted the previous render';
            } else {
              var componentName = getComponentName(interruptedBy.type) || 'Unknown';
              warning = "An update to " + componentName + " interrupted the previous render";
            }
          } else if (commitCountInCurrentWorkLoop > 1) {
            warning = 'There were cascading updates';
          }
          commitCountInCurrentWorkLoop = 0;
          var label = didCompleteRoot ? '(React Tree Reconciliation: Completed Root)' : '(React Tree Reconciliation: Yielded)'; // Pause any measurements until the next loop.

          pauseTimers();
          endMark(label, '(React Tree Reconciliation)', warning);
        }
      }
      function startCommitTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          isCommitting = true;
          hasScheduledUpdateInCurrentCommit = false;
          labelsInCurrentCommit.clear();
          beginMark('(Committing Changes)');
        }
      }
      function stopCommitTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var warning = null;
          if (hasScheduledUpdateInCurrentCommit) {
            warning = 'Lifecycle hook scheduled a cascading update';
          } else if (commitCountInCurrentWorkLoop > 0) {
            warning = 'Caused by a cascading update in earlier commit';
          }
          hasScheduledUpdateInCurrentCommit = false;
          commitCountInCurrentWorkLoop++;
          isCommitting = false;
          labelsInCurrentCommit.clear();
          endMark('(Committing Changes)', '(Committing Changes)', warning);
        }
      }
      function startCommitSnapshotEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Committing Snapshot Effects)');
        }
      }
      function stopCommitSnapshotEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Committing Snapshot Effects: " + count + " Total)", '(Committing Snapshot Effects)', null);
        }
      }
      function startCommitHostEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Committing Host Effects)');
        }
      }
      function stopCommitHostEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Committing Host Effects: " + count + " Total)", '(Committing Host Effects)', null);
        }
      }
      function startCommitLifeCyclesTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Calling Lifecycle Methods)');
        }
      }
      function stopCommitLifeCyclesTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Calling Lifecycle Methods: " + count + " Total)", '(Calling Lifecycle Methods)', null);
        }
      }
      var valueStack = [];
      var fiberStack;
      {
        fiberStack = [];
      }
      var index = -1;
      function createCursor(defaultValue) {
        return {
          current: defaultValue
        };
      }
      function pop(cursor, fiber) {
        if (index < 0) {
          {
            error('Unexpected pop.');
          }
          return;
        }
        {
          if (fiber !== fiberStack[index]) {
            error('Unexpected Fiber popped.');
          }
        }
        cursor.current = valueStack[index];
        valueStack[index] = null;
        {
          fiberStack[index] = null;
        }
        index--;
      }
      function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        {
          fiberStack[index] = fiber;
        }
        cursor.current = value;
      }
      var warnedAboutMissingGetChildContext;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      } // A cursor to the current merged context object on the stack.

      var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.

      var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
      // We use this to get access to the parent context after we have already
      // pushed the next context provider, and now need to merge their contexts.

      var previousContext = emptyContextObject;
      function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        {
          if (didPushOwnContextIfProvider && isContextProvider(Component)) {
            // If the fiber is a context provider itself, when we read its context
            // we may have already pushed its own child context on the stack. A context
            // provider should not "see" its own child context. Therefore we read the
            // previous (parent) context instead for a context provider.
            return previousContext;
          }
          return contextStackCursor.current;
        }
      }
      function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        {
          var instance = workInProgress.stateNode;
          instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
          instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
        }
      }
      function getMaskedContext(workInProgress, unmaskedContext) {
        {
          var type = workInProgress.type;
          var contextTypes = type.contextTypes;
          if (!contextTypes) {
            return emptyContextObject;
          } // Avoid recreating masked context unless unmasked context has changed.
          // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
          // This may trigger infinite loops if componentWillReceiveProps calls setState.

          var instance = workInProgress.stateNode;
          if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
            return instance.__reactInternalMemoizedMaskedChildContext;
          }
          var context = {};
          for (var key in contextTypes) {
            context[key] = unmaskedContext[key];
          }
          {
            var name = getComponentName(type) || 'Unknown';
            checkPropTypes(contextTypes, context, 'context', name, getCurrentFiberStackInDev);
          } // Cache unmasked context so we can avoid recreating masked context unless necessary.
          // Context is created before the class component is instantiated so check for instance.

          if (instance) {
            cacheContext(workInProgress, unmaskedContext, context);
          }
          return context;
        }
      }
      function hasContextChanged() {
        {
          return didPerformWorkStackCursor.current;
        }
      }
      function isContextProvider(type) {
        {
          var childContextTypes = type.childContextTypes;
          return childContextTypes !== null && childContextTypes !== undefined;
        }
      }
      function popContext(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }
      function popTopLevelContextObject(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }
      function pushTopLevelContextObject(fiber, context, didChange) {
        {
          if (!(contextStackCursor.current === emptyContextObject)) {
            {
              throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          push(contextStackCursor, context, fiber);
          push(didPerformWorkStackCursor, didChange, fiber);
        }
      }
      function processChildContext(fiber, type, parentContext) {
        {
          var instance = fiber.stateNode;
          var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
          // It has only been added in Fiber to match the (unintentional) behavior in Stack.

          if (typeof instance.getChildContext !== 'function') {
            {
              var componentName = getComponentName(type) || 'Unknown';
              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
              }
            }
            return parentContext;
          }
          var childContext;
          startPhaseTimer(fiber, 'getChildContext');
          childContext = instance.getChildContext();
          stopPhaseTimer();
          for (var contextKey in childContext) {
            if (!(contextKey in childContextTypes)) {
              {
                throw Error((getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
              }
            }
          }
          {
            var name = getComponentName(type) || 'Unknown';
            checkPropTypes(childContextTypes, childContext, 'child context', name,
            // In practice, there is one case in which we won't get a stack. It's when
            // somebody calls unstable_renderSubtreeIntoContainer() and we process
            // context from the parent component instance. The stack will be missing
            // because it's outside of the reconciliation, and so the pointer has not
            // been set. This is rare and doesn't matter. We'll also remove that API.
            getCurrentFiberStackInDev);
          }
          return _assign({}, parentContext, {}, childContext);
        }
      }
      function pushContextProvider(workInProgress) {
        {
          var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
          // If the instance does not exist yet, we will push null at first,
          // and replace it on the stack later when invalidating the context.

          var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
          // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

          previousContext = contextStackCursor.current;
          push(contextStackCursor, memoizedMergedChildContext, workInProgress);
          push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
          return true;
        }
      }
      function invalidateContextProvider(workInProgress, type, didChange) {
        {
          var instance = workInProgress.stateNode;
          if (!instance) {
            {
              throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.

            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          }
        }
      }
      function findCurrentUnmaskedContext(fiber) {
        {
          // Currently this is only used with renderSubtreeIntoContainer; not sure if it
          // makes sense elsewhere
          if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
            {
              throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          var node = fiber;
          do {
            switch (node.tag) {
              case HostRoot:
                return node.stateNode.context;
              case ClassComponent:
                {
                  var Component = node.type;
                  if (isContextProvider(Component)) {
                    return node.stateNode.__reactInternalMemoizedMergedChildContext;
                  }
                  break;
                }
            }
            node = node.return;
          } while (node !== null);
          {
            {
              throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
      }
      var LegacyRoot = 0;
      var BlockingRoot = 1;
      var ConcurrentRoot = 2;
      var Scheduler_runWithPriority = Scheduler$1.unstable_runWithPriority,
        Scheduler_scheduleCallback = Scheduler$1.unstable_scheduleCallback,
        Scheduler_cancelCallback = Scheduler$1.unstable_cancelCallback,
        Scheduler_shouldYield = Scheduler$1.unstable_shouldYield,
        Scheduler_requestPaint = Scheduler$1.unstable_requestPaint,
        Scheduler_now = Scheduler$1.unstable_now,
        Scheduler_getCurrentPriorityLevel = Scheduler$1.unstable_getCurrentPriorityLevel,
        Scheduler_ImmediatePriority = Scheduler$1.unstable_ImmediatePriority,
        Scheduler_UserBlockingPriority = Scheduler$1.unstable_UserBlockingPriority,
        Scheduler_NormalPriority = Scheduler$1.unstable_NormalPriority,
        Scheduler_LowPriority = Scheduler$1.unstable_LowPriority,
        Scheduler_IdlePriority = Scheduler$1.unstable_IdlePriority;
      {
        // Provide explicit error message when production+profiling bundle of e.g.
        // react-dom is used with production (non-profiling) bundle of
        // scheduler/tracing
        if (!(tracing$1.__interactionsRef != null && tracing$1.__interactionsRef.current != null)) {
          {
            throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at http://fb.me/react-profiling");
          }
        }
      }
      var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
      // ascending numbers so we can compare them like numbers. They start at 90 to
      // avoid clashing with Scheduler's priorities.

      var ImmediatePriority = 99;
      var UserBlockingPriority = 98;
      var NormalPriority = 97;
      var LowPriority = 96;
      var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.

      var NoPriority = 90;
      var shouldYield = Scheduler_shouldYield;
      var requestPaint =
      // Fall back gracefully if we're running an older version of Scheduler.
      Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function () {};
      var syncQueue = null;
      var immediateQueueCallbackNode = null;
      var isFlushingSyncQueue = false;
      var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
      // This will be the case for modern browsers that support `performance.now`. In
      // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
      // timestamp. In that case, subtract the module initialization time to simulate
      // the behavior of performance.now and keep our times small enough to fit
      // within 32 bits.
      // TODO: Consider lifting this into Scheduler.

      var now = initialTimeMs < 10000 ? Scheduler_now : function () {
        return Scheduler_now() - initialTimeMs;
      };
      function getCurrentPriorityLevel() {
        switch (Scheduler_getCurrentPriorityLevel()) {
          case Scheduler_ImmediatePriority:
            return ImmediatePriority;
          case Scheduler_UserBlockingPriority:
            return UserBlockingPriority;
          case Scheduler_NormalPriority:
            return NormalPriority;
          case Scheduler_LowPriority:
            return LowPriority;
          case Scheduler_IdlePriority:
            return IdlePriority;
          default:
            {
              {
                throw Error("Unknown priority level.");
              }
            }
        }
      }
      function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch (reactPriorityLevel) {
          case ImmediatePriority:
            return Scheduler_ImmediatePriority;
          case UserBlockingPriority:
            return Scheduler_UserBlockingPriority;
          case NormalPriority:
            return Scheduler_NormalPriority;
          case LowPriority:
            return Scheduler_LowPriority;
          case IdlePriority:
            return Scheduler_IdlePriority;
          default:
            {
              {
                throw Error("Unknown priority level.");
              }
            }
        }
      }
      function runWithPriority(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
      }
      function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
      }
      function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
          syncQueue = [callback]; // Flush the queue in the next tick, at the earliest.

          immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else {
          // Push onto existing queue. Don't need to schedule a callback because
          // we already scheduled one when we created the queue.
          syncQueue.push(callback);
        }
        return fakeCallbackNode;
      }
      function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) {
          Scheduler_cancelCallback(callbackNode);
        }
      }
      function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
          var node = immediateQueueCallbackNode;
          immediateQueueCallbackNode = null;
          Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
      }
      function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
          // Prevent re-entrancy.
          isFlushingSyncQueue = true;
          var i = 0;
          try {
            var _isSync = true;
            var queue = syncQueue;
            runWithPriority(ImmediatePriority, function () {
              for (; i < queue.length; i++) {
                var callback = queue[i];
                do {
                  callback = callback(_isSync);
                } while (callback !== null);
              }
            });
            syncQueue = null;
          } catch (error) {
            // If something throws, leave the remaining callbacks on the queue.
            if (syncQueue !== null) {
              syncQueue = syncQueue.slice(i + 1);
            } // Resume flushing in the next tick

            Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
            throw error;
          } finally {
            isFlushingSyncQueue = false;
          }
        }
      }
      var NoMode = 0;
      var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
      // tag instead

      var BlockingMode = 2;
      var ConcurrentMode = 4;
      var ProfileMode = 8;

      // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
      // Math.pow(2, 30) - 1
      // 0b111111111111111111111111111111
      var MAX_SIGNED_31_BIT_INT = 1073741823;
      var NoWork = 0; // TODO: Think of a better name for Never. The key difference with Idle is that
      // Never work can be committed in an inconsistent state without tearing the UI.
      // The main example is offscreen content, like a hidden subtree. So one possible
      // name is Offscreen. However, it also includes dehydrated Suspense boundaries,
      // which are inconsistent in the sense that they haven't finished yet, but
      // aren't visibly inconsistent because the server rendered HTML matches what the
      // hydrated tree would look like.

      var Never = 1; // Idle is slightly higher priority than Never. It must completely finish in
      // order to be consistent.

      var Idle = 2; // Continuous Hydration is slightly higher than Idle and is used to increase
      var Sync = MAX_SIGNED_31_BIT_INT;
      var Batched = Sync - 1;
      var UNIT_SIZE = 10;
      var MAGIC_NUMBER_OFFSET = Batched - 1; // 1 unit of expiration time represents 10ms.

      function msToExpirationTime(ms) {
        // Always subtract from the offset so that we don't clash with the magic number for NoWork.
        return MAGIC_NUMBER_OFFSET - (ms / UNIT_SIZE | 0);
      }
      function expirationTimeToMs(expirationTime) {
        return (MAGIC_NUMBER_OFFSET - expirationTime) * UNIT_SIZE;
      }
      function ceiling(num, precision) {
        return ((num / precision | 0) + 1) * precision;
      }
      function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
        return MAGIC_NUMBER_OFFSET - ceiling(MAGIC_NUMBER_OFFSET - currentTime + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
      } // TODO: This corresponds to Scheduler's NormalPriority, not LowPriority. Update
      // the names to reflect.

      var LOW_PRIORITY_EXPIRATION = 5000;
      var LOW_PRIORITY_BATCH_SIZE = 250;
      function computeAsyncExpiration(currentTime) {
        return computeExpirationBucket(currentTime, LOW_PRIORITY_EXPIRATION, LOW_PRIORITY_BATCH_SIZE);
      }
      function computeSuspenseExpiration(currentTime, timeoutMs) {
        // TODO: Should we warn if timeoutMs is lower than the normal pri expiration time?
        return computeExpirationBucket(currentTime, timeoutMs, LOW_PRIORITY_BATCH_SIZE);
      } // We intentionally set a higher expiration time for interactive updates in
      // dev than in production.
      //
      // If the main thread is being blocked so long that you hit the expiration,
      // it's a problem that could be solved with better scheduling.
      //
      // People will be more likely to notice this and fix it with the long
      // expiration time in development.
      //
      // In production we opt for better UX at the risk of masking scheduling
      // problems, by expiring fast.

      var HIGH_PRIORITY_EXPIRATION = 500;
      var HIGH_PRIORITY_BATCH_SIZE = 100;
      function computeInteractiveExpiration(currentTime) {
        return computeExpirationBucket(currentTime, HIGH_PRIORITY_EXPIRATION, HIGH_PRIORITY_BATCH_SIZE);
      }
      function inferPriorityFromExpirationTime(currentTime, expirationTime) {
        if (expirationTime === Sync) {
          return ImmediatePriority;
        }
        if (expirationTime === Never || expirationTime === Idle) {
          return IdlePriority;
        }
        var msUntil = expirationTimeToMs(expirationTime) - expirationTimeToMs(currentTime);
        if (msUntil <= 0) {
          return ImmediatePriority;
        }
        if (msUntil <= HIGH_PRIORITY_EXPIRATION + HIGH_PRIORITY_BATCH_SIZE) {
          return UserBlockingPriority;
        }
        if (msUntil <= LOW_PRIORITY_EXPIRATION + LOW_PRIORITY_BATCH_SIZE) {
          return NormalPriority;
        } // TODO: Handle LowPriority
        // Assume anything lower has idle priority

        return IdlePriority;
      }

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }

      var objectIs = typeof Object.is === 'function' ? Object.is : is;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      /**
       * Performs equality by iterating through keys on an object and returning false
       * when any key has values which are not strictly equal between the arguments.
       * Returns true when the values of all keys are strictly equal.
       */

      function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) {
          return true;
        }
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
          return false;
        } // Test for A's keys different from B.

        for (var i = 0; i < keysA.length; i++) {
          if (!hasOwnProperty.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
            return false;
          }
        }
        return true;
      }
      var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
        recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
        flushLegacyContextWarning: function flushLegacyContextWarning() {},
        discardPendingWarnings: function discardPendingWarnings() {}
      };
      {
        var findStrictRoot = function findStrictRoot(fiber) {
          var maybeStrictRoot = null;
          var node = fiber;
          while (node !== null) {
            if (node.mode & StrictMode) {
              maybeStrictRoot = node;
            }
            node = node.return;
          }
          return maybeStrictRoot;
        };
        var setToSortedString = function setToSortedString(set) {
          var array = [];
          set.forEach(function (value) {
            array.push(value);
          });
          return array.sort().join(', ');
        };
        var pendingComponentWillMountWarnings = [];
        var pendingUNSAFE_ComponentWillMountWarnings = [];
        var pendingComponentWillReceivePropsWarnings = [];
        var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        var pendingComponentWillUpdateWarnings = [];
        var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.

        var didWarnAboutUnsafeLifecycles = new Set();
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
          // Dedup strategy: Warn once per component.
          if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
            return;
          }
          if (typeof instance.componentWillMount === 'function' &&
          // Don't warn about react-lifecycles-compat polyfilled components.
          instance.componentWillMount.__suppressDeprecationWarning !== true) {
            pendingComponentWillMountWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') {
            pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
          }
          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
            pendingComponentWillReceivePropsWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
          }
          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
            pendingComponentWillUpdateWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
            pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
          }
        };
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
          // We do an initial pass to gather component names
          var componentWillMountUniqueNames = new Set();
          if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function (fiber) {
              componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
          }
          var UNSAFE_componentWillMountUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
              UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
          }
          var componentWillReceivePropsUniqueNames = new Set();
          if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
              componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
          }
          var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
              UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          }
          var componentWillUpdateUniqueNames = new Set();
          if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function (fiber) {
              componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
          }
          var UNSAFE_componentWillUpdateUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
              UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
          } // Finally, we flush all the warnings
          // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'

          if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
          }
          if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
          }
          if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
          }
          if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
          }
          if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
          }
          if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
          }
        };
        var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

        var didWarnAboutLegacyContext = new Set();
        ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
          var strictRoot = findStrictRoot(fiber);
          if (strictRoot === null) {
            error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
            return;
          } // Dedup strategy: Warn once per component.

          if (didWarnAboutLegacyContext.has(fiber.type)) {
            return;
          }
          var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
          if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
              warningsForRoot = [];
              pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
          }
        };
        ReactStrictModeWarnings.flushLegacyContextWarning = function () {
          pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
            if (fiberArray.length === 0) {
              return;
            }
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function (fiber) {
              uniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            var firstComponentStack = getStackByFiberInDevAndProd(firstFiber);
            error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://fb.me/react-legacy-context' + '%s', sortedNames, firstComponentStack);
          });
        };
        ReactStrictModeWarnings.discardPendingWarnings = function () {
          pendingComponentWillMountWarnings = [];
          pendingUNSAFE_ComponentWillMountWarnings = [];
          pendingComponentWillReceivePropsWarnings = [];
          pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          pendingComponentWillUpdateWarnings = [];
          pendingUNSAFE_ComponentWillUpdateWarnings = [];
          pendingLegacyContextWarning = new Map();
        };
      }
      var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.

      var failedBoundaries = null;
      var setRefreshHandler = function setRefreshHandler(handler) {
        {
          resolveFamily = handler;
        }
      };
      function resolveFunctionForHotReloading(type) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return type;
          }
          var family = resolveFamily(type);
          if (family === undefined) {
            return type;
          } // Use the latest known implementation.

          return family.current;
        }
      }
      function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
      }
      function resolveForwardRefForHotReloading(type) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return type;
          }
          var family = resolveFamily(type);
          if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
              // ForwardRef is special because its resolved .type is an object,
              // but it's possible that we only have its inner render function in the map.
              // If that inner render function is different, we'll build a new forwardRef type.
              var currentRender = resolveFunctionForHotReloading(type.render);
              if (type.render !== currentRender) {
                var syntheticType = {
                  $$typeof: REACT_FORWARD_REF_TYPE,
                  render: currentRender
                };
                if (type.displayName !== undefined) {
                  syntheticType.displayName = type.displayName;
                }
                return syntheticType;
              }
            }
            return type;
          } // Use the latest known implementation.

          return family.current;
        }
      }
      function isCompatibleFamilyForHotReloading(fiber, element) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return false;
          }
          var prevType = fiber.elementType;
          var nextType = element.type; // If we got here, we know types aren't === equal.

          var needsCompareFamilies = false;
          var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
          switch (fiber.tag) {
            case ClassComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                }
                break;
              }
            case FunctionComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  // We don't know the inner type yet.
                  // We're going to assume that the lazy inner type is stable,
                  // and so it is sufficient to avoid reconciling it away.
                  // We're not going to unwrap or actually use the new lazy type.
                  needsCompareFamilies = true;
                }
                break;
              }
            case ForwardRef:
              {
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
            case MemoComponent:
            case SimpleMemoComponent:
              {
                if ($$typeofNextType === REACT_MEMO_TYPE) {
                  // TODO: if it was but can no longer be simple,
                  // we shouldn't set this.
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
            default:
              return false;
          } // Check if both types have a family and it's the same one.

          if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
              return true;
            }
          }
          return false;
        }
      }
      function markFailedErrorBoundaryForHotReloading(fiber) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return;
          }
          if (typeof WeakSet !== 'function') {
            return;
          }
          if (failedBoundaries === null) {
            failedBoundaries = new WeakSet();
          }
          failedBoundaries.add(fiber);
        }
      }
      var scheduleRefresh = function scheduleRefresh(root, update) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return;
          }
          var staleFamilies = update.staleFamilies,
            updatedFamilies = update.updatedFamilies;
          flushPassiveEffects();
          flushSync$$1(function () {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
          });
        }
      };
      var scheduleRoot = function scheduleRoot(root, element) {
        {
          if (root.context !== emptyContextObject) {
            // Super edge case: root has a legacy _renderSubtree context
            // but we don't know the parentComponent so we can't pass it.
            // Just ignore. We'll delete this with _renderSubtree code path later.
            return;
          }
          flushPassiveEffects();
          syncUpdates(function () {
            updateContainer(element, root, null, null);
          });
        }
      };
      function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        {
          var alternate = fiber.alternate,
            child = fiber.child,
            sibling = fiber.sibling,
            tag = fiber.tag,
            type = fiber.type;
          var candidateType = null;
          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;
            case ForwardRef:
              candidateType = type.render;
              break;
          }
          if (resolveFamily === null) {
            throw new Error('Expected resolveFamily to be set during hot reload.');
          }
          var needsRender = false;
          var needsRemount = false;
          if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
              if (staleFamilies.has(family)) {
                needsRemount = true;
              } else if (updatedFamilies.has(family)) {
                if (tag === ClassComponent) {
                  needsRemount = true;
                } else {
                  needsRender = true;
                }
              }
            }
          }
          if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
              needsRemount = true;
            }
          }
          if (needsRemount) {
            fiber._debugNeedsRemount = true;
          }
          if (needsRemount || needsRender) {
            scheduleWork(fiber, Sync);
          }
          if (child !== null && !needsRemount) {
            scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
          }
          if (sibling !== null) {
            scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
          }
        }
      }
      var findHostInstancesForRefresh = function findHostInstancesForRefresh(root, families) {
        {
          var hostInstances = new Set();
          var types = new Set(families.map(function (family) {
            return family.current;
          }));
          findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
          return hostInstances;
        }
      };
      function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        {
          var child = fiber.child,
            sibling = fiber.sibling,
            tag = fiber.tag,
            type = fiber.type;
          var candidateType = null;
          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;
            case ForwardRef:
              candidateType = type.render;
              break;
          }
          var didMatch = false;
          if (candidateType !== null) {
            if (types.has(candidateType)) {
              didMatch = true;
            }
          }
          if (didMatch) {
            // We have a match. This only drills down to the closest host components.
            // There's no need to search deeper because for the purpose of giving
            // visual feedback, "flashing" outermost parent rectangles is sufficient.
            findHostInstancesForFiberShallowly(fiber, hostInstances);
          } else {
            // If there's no match, maybe there will be one further down in the child tree.
            if (child !== null) {
              findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
            }
          }
          if (sibling !== null) {
            findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
          }
        }
      }
      function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
          if (foundHostInstances) {
            return;
          } // If we didn't find any host children, fallback to closest host parent.

          var node = fiber;
          while (true) {
            switch (node.tag) {
              case HostComponent:
                hostInstances.add(node.stateNode);
                return;
              case HostPortal:
                hostInstances.add(node.stateNode.containerInfo);
                return;
              case HostRoot:
                hostInstances.add(node.stateNode.containerInfo);
                return;
            }
            if (node.return === null) {
              throw new Error('Expected to reach root first.');
            }
            node = node.return;
          }
        }
      }
      function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var node = fiber;
          var foundHostInstances = false;
          while (true) {
            if (node.tag === HostComponent) {
              // We got a match.
              foundHostInstances = true;
              hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === fiber) {
              return foundHostInstances;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === fiber) {
                return foundHostInstances;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
        return false;
      }
      function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
          // Resolve default props. Taken from ReactElement
          var props = _assign({}, baseProps);
          var defaultProps = Component.defaultProps;
          for (var propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }
          return props;
        }
        return baseProps;
      }
      function readLazyComponentType(lazyComponent) {
        initializeLazyComponentType(lazyComponent);
        if (lazyComponent._status !== Resolved) {
          throw lazyComponent._result;
        }
        return lazyComponent._result;
      }
      var valueCursor = createCursor(null);
      var rendererSigil;
      {
        // Use this to detect multiple renderers using the same context
        rendererSigil = {};
      }
      var currentlyRenderingFiber = null;
      var lastContextDependency = null;
      var lastContextWithAllBitsObserved = null;
      var isDisallowedContextReadInDEV = false;
      function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        {
          isDisallowedContextReadInDEV = false;
        }
      }
      function enterDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = true;
        }
      }
      function exitDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = false;
        }
      }
      function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        {
          push(valueCursor, context._currentValue2, providerFiber);
          context._currentValue2 = nextValue;
          {
            if (context._currentRenderer2 !== undefined && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) {
              error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
            }
            context._currentRenderer2 = rendererSigil;
          }
        }
      }
      function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        {
          context._currentValue2 = currentValue;
        }
      }
      function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) {
          // No change
          return 0;
        } else {
          var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          {
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
              error('calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
            }
          }
          return changedBits | 0;
        }
      }
      function scheduleWorkOnParentPath(parent, renderExpirationTime) {
        // Update the child expiration time of all the ancestors, including
        // the alternates.
        var node = parent;
        while (node !== null) {
          var alternate = node.alternate;
          if (node.childExpirationTime < renderExpirationTime) {
            node.childExpirationTime = renderExpirationTime;
            if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) {
              alternate.childExpirationTime = renderExpirationTime;
            }
          } else if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) {
            alternate.childExpirationTime = renderExpirationTime;
          } else {
            // Neither alternate was updated, which means the rest of the
            // ancestor path already has sufficient priority.
            break;
          }
          node = node.return;
        }
      }
      function propagateContextChange(workInProgress, context, changedBits, renderExpirationTime) {
        var fiber = workInProgress.child;
        if (fiber !== null) {
          // Set the return pointer of the child to the work-in-progress fiber.
          fiber.return = workInProgress;
        }
        while (fiber !== null) {
          var nextFiber = void 0; // Visit this fiber.

          var list = fiber.dependencies;
          if (list !== null) {
            nextFiber = fiber.child;
            var dependency = list.firstContext;
            while (dependency !== null) {
              // Check if the context matches.
              if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                // Match! Schedule an update on this fiber.
                if (fiber.tag === ClassComponent) {
                  // Schedule a force update on the work-in-progress.
                  var update = createUpdate(renderExpirationTime, null);
                  update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                  // update to the current fiber, too, which means it will persist even if
                  // this render is thrown away. Since it's a race condition, not sure it's
                  // worth fixing.

                  enqueueUpdate(fiber, update);
                }
                if (fiber.expirationTime < renderExpirationTime) {
                  fiber.expirationTime = renderExpirationTime;
                }
                var alternate = fiber.alternate;
                if (alternate !== null && alternate.expirationTime < renderExpirationTime) {
                  alternate.expirationTime = renderExpirationTime;
                }
                scheduleWorkOnParentPath(fiber.return, renderExpirationTime); // Mark the expiration time on the list, too.

                if (list.expirationTime < renderExpirationTime) {
                  list.expirationTime = renderExpirationTime;
                } // Since we already found a match, we can stop traversing the
                // dependency list.

                break;
              }
              dependency = dependency.next;
            }
          } else if (fiber.tag === ContextProvider) {
            // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
          } else {
            // Traverse down.
            nextFiber = fiber.child;
          }
          if (nextFiber !== null) {
            // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
          } else {
            // No child. Traverse to next sibling.
            nextFiber = fiber;
            while (nextFiber !== null) {
              if (nextFiber === workInProgress) {
                // We're back to the root of this subtree. Exit.
                nextFiber = null;
                break;
              }
              var sibling = nextFiber.sibling;
              if (sibling !== null) {
                // Set the return pointer of the sibling to the work-in-progress fiber.
                sibling.return = nextFiber.return;
                nextFiber = sibling;
                break;
              } // No more siblings. Traverse up.

              nextFiber = nextFiber.return;
            }
          }
          fiber = nextFiber;
        }
      }
      function prepareToReadContext(workInProgress, renderExpirationTime) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
          var firstContext = dependencies.firstContext;
          if (firstContext !== null) {
            if (dependencies.expirationTime >= renderExpirationTime) {
              // Context list has a pending update. Mark that this fiber performed work.
              markWorkInProgressReceivedUpdate();
            } // Reset the work-in-progress list

            dependencies.firstContext = null;
          }
        }
      }
      function _readContext(context, observedBits) {
        {
          // This warning would fire if you read context inside a Hook like useMemo.
          // Unlike the class check below, it's not enforced in production for perf.
          if (isDisallowedContextReadInDEV) {
            error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
          }
        }
        if (lastContextWithAllBitsObserved === context) ;else if (observedBits === false || observedBits === 0) ;else {
          var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.

          if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
            // Observe all updates.
            lastContextWithAllBitsObserved = context;
            resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
          } else {
            resolvedObservedBits = observedBits;
          }
          var contextItem = {
            context: context,
            observedBits: resolvedObservedBits,
            next: null
          };
          if (lastContextDependency === null) {
            if (!(currentlyRenderingFiber !== null)) {
              {
                throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
              }
            } // This is the first dependency for this component. Create a new list.

            lastContextDependency = contextItem;
            currentlyRenderingFiber.dependencies = {
              expirationTime: NoWork,
              firstContext: contextItem,
              responders: null
            };
          } else {
            // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
          }
        }
        return context._currentValue2;
      }
      var UpdateState = 0;
      var ReplaceState = 1;
      var ForceUpdate = 2;
      var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
      // It should only be read right after calling `processUpdateQueue`, via
      // `checkHasForceUpdateAfterProcessing`.

      var hasForceUpdate = false;
      var didWarnUpdateInsideUpdate;
      var currentlyProcessingQueue;
      {
        didWarnUpdateInsideUpdate = false;
        currentlyProcessingQueue = null;
      }
      function initializeUpdateQueue(fiber) {
        var queue = {
          baseState: fiber.memoizedState,
          baseQueue: null,
          shared: {
            pending: null
          },
          effects: null
        };
        fiber.updateQueue = queue;
      }
      function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
          var clone = {
            baseState: currentQueue.baseState,
            baseQueue: currentQueue.baseQueue,
            shared: currentQueue.shared,
            effects: currentQueue.effects
          };
          workInProgress.updateQueue = clone;
        }
      }
      function createUpdate(expirationTime, suspenseConfig) {
        var update = {
          expirationTime: expirationTime,
          suspenseConfig: suspenseConfig,
          tag: UpdateState,
          payload: null,
          callback: null,
          next: null
        };
        update.next = update;
        {
          update.priority = getCurrentPriorityLevel();
        }
        return update;
      }
      function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) {
          // Only occurs if the fiber has been unmounted.
          return;
        }
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) {
          // This is the first update. Create a circular list.
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }
        sharedQueue.pending = update;
        {
          if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
            didWarnUpdateInsideUpdate = true;
          }
        }
      }
      function enqueueCapturedUpdate(workInProgress, update) {
        var current = workInProgress.alternate;
        if (current !== null) {
          // Ensure the work-in-progress queue is a clone
          cloneUpdateQueue(current, workInProgress);
        } // Captured updates go only on the work-in-progress queue.

        var queue = workInProgress.updateQueue; // Append the update to the end of the list.

        var last = queue.baseQueue;
        if (last === null) {
          queue.baseQueue = update.next = update;
          update.next = update;
        } else {
          update.next = last.next;
          last.next = update;
        }
      }
      function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch (update.tag) {
          case ReplaceState:
            {
              var payload = update.payload;
              if (typeof payload === 'function') {
                // Updater function
                {
                  enterDisallowedContextReadInDEV();
                }
                var nextState = payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
                return nextState;
              } // State object

              return payload;
            }
          case CaptureUpdate:
            {
              workInProgress.effectTag = workInProgress.effectTag & ~ShouldCapture | DidCapture;
            }
          // Intentional fallthrough

          case UpdateState:
            {
              var _payload = update.payload;
              var partialState;
              if (typeof _payload === 'function') {
                // Updater function
                {
                  enterDisallowedContextReadInDEV();
                }
                partialState = _payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
              } else {
                // Partial state object
                partialState = _payload;
              }
              if (partialState === null || partialState === undefined) {
                // Null and undefined are treated as no-ops.
                return prevState;
              } // Merge the partial state and the previous state.

              return _assign({}, prevState, partialState);
            }
          case ForceUpdate:
            {
              hasForceUpdate = true;
              return prevState;
            }
        }
        return prevState;
      }
      function processUpdateQueue(workInProgress, props, instance, renderExpirationTime) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        {
          currentlyProcessingQueue = queue.shared;
        } // The last rebase update that is NOT part of the base state.

        var baseQueue = queue.baseQueue; // The last pending update that hasn't been processed yet.

        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
          // We have new updates that haven't been processed yet.
          // We'll add them to the base queue.
          if (baseQueue !== null) {
            // Merge the pending queue and the base queue.
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }
          baseQueue = pendingQueue;
          queue.shared.pending = null; // TODO: Pass `current` as argument

          var current = workInProgress.alternate;
          if (current !== null) {
            var currentQueue = current.updateQueue;
            if (currentQueue !== null) {
              currentQueue.baseQueue = pendingQueue;
            }
          }
        } // These values may change as we process the queue.

        if (baseQueue !== null) {
          var first = baseQueue.next; // Iterate through the list of updates to compute the result.

          var newState = queue.baseState;
          var newExpirationTime = NoWork;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          if (first !== null) {
            var update = first;
            do {
              var updateExpirationTime = update.expirationTime;
              if (updateExpirationTime < renderExpirationTime) {
                // Priority is insufficient. Skip this update. If this is the first
                // skipped update, the previous update/state is the new base
                // update/state.
                var clone = {
                  expirationTime: update.expirationTime,
                  suspenseConfig: update.suspenseConfig,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };
                if (newBaseQueueLast === null) {
                  newBaseQueueFirst = newBaseQueueLast = clone;
                  newBaseState = newState;
                } else {
                  newBaseQueueLast = newBaseQueueLast.next = clone;
                } // Update the remaining priority in the queue.

                if (updateExpirationTime > newExpirationTime) {
                  newExpirationTime = updateExpirationTime;
                }
              } else {
                // This update does have sufficient priority.
                if (newBaseQueueLast !== null) {
                  var _clone = {
                    expirationTime: Sync,
                    // This update is going to be committed so we never want uncommit it.
                    suspenseConfig: update.suspenseConfig,
                    tag: update.tag,
                    payload: update.payload,
                    callback: update.callback,
                    next: null
                  };
                  newBaseQueueLast = newBaseQueueLast.next = _clone;
                } // Mark the event time of this update as relevant to this render pass.
                // TODO: This should ideally use the true event time of this update rather than
                // its priority which is a derived and not reverseable value.
                // TODO: We should skip this update if it was already committed but currently
                // we have no way of detecting the difference between a committed and suspended
                // update here.

                markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.

                newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                var callback = update.callback;
                if (callback !== null) {
                  workInProgress.effectTag |= Callback;
                  var effects = queue.effects;
                  if (effects === null) {
                    queue.effects = [update];
                  } else {
                    effects.push(update);
                  }
                }
              }
              update = update.next;
              if (update === null || update === first) {
                pendingQueue = queue.shared.pending;
                if (pendingQueue === null) {
                  break;
                } else {
                  // An update was scheduled from inside a reducer. Add the new
                  // pending updates to the end of the list and keep processing.
                  update = baseQueue.next = pendingQueue.next;
                  pendingQueue.next = first;
                  queue.baseQueue = baseQueue = pendingQueue;
                  queue.shared.pending = null;
                }
              }
            } while (true);
          }
          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          }
          queue.baseState = newBaseState;
          queue.baseQueue = newBaseQueueLast; // Set the remaining expiration time to be whatever is remaining in the queue.
          // This should be fine because the only two other things that contribute to
          // expiration time are props and context. We're already in the middle of the
          // begin phase by the time we start processing the queue, so we've already
          // dealt with the props. Context in components that specify
          // shouldComponentUpdate is tricky; but we'll have to account for
          // that regardless.

          markUnprocessedUpdateTime(newExpirationTime);
          workInProgress.expirationTime = newExpirationTime;
          workInProgress.memoizedState = newState;
        }
        {
          currentlyProcessingQueue = null;
        }
      }
      function callCallback(callback, context) {
        if (!(typeof callback === 'function')) {
          {
            throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
          }
        }
        callback.call(context);
      }
      function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
      }
      function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
      }
      function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) {
          for (var i = 0; i < effects.length; i++) {
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
              effect.callback = null;
              callCallback(callback, instance);
            }
          }
        }
      }
      var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
      function requestCurrentSuspenseConfig() {
        return ReactCurrentBatchConfig.suspense;
      }
      var fakeInternalInstance = {};
      var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
      // We'll use it to determine whether we need to initialize legacy refs.

      var emptyRefsObject = new React.Component().refs;
      var didWarnAboutStateAssignmentForComponent;
      var didWarnAboutUninitializedState;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
      var didWarnAboutLegacyLifecyclesAndDerivedState;
      var didWarnAboutUndefinedDerivedState;
      var warnOnUndefinedDerivedState;
      var warnOnInvalidCallback;
      var didWarnAboutDirectlyAssigningPropsToState;
      var didWarnAboutContextTypeAndContextTypes;
      var didWarnAboutInvalidateContextType;
      {
        didWarnAboutStateAssignmentForComponent = new Set();
        didWarnAboutUninitializedState = new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
        didWarnAboutDirectlyAssigningPropsToState = new Set();
        didWarnAboutUndefinedDerivedState = new Set();
        didWarnAboutContextTypeAndContextTypes = new Set();
        didWarnAboutInvalidateContextType = new Set();
        var didWarnOnInvalidCallback = new Set();
        warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
          if (callback === null || typeof callback === 'function') {
            return;
          }
          var key = callerName + "_" + callback;
          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        };
        warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
          if (partialState === undefined) {
            var componentName = getComponentName(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
            }
          }
        }; // This is so gross but it's at least non-critical and can be removed if
        // it causes problems. This is meant to give a nicer error message for
        // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
        // ...)) which otherwise throws a "_processChildContext is not a function"
        // exception.

        Object.defineProperty(fakeInternalInstance, '_processChildContext', {
          enumerable: false,
          value: function value() {
            {
              {
                throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
              }
            }
          }
        });
        Object.freeze(fakeInternalInstance);
      }
      function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          warnOnUndefinedDerivedState(ctor, partialState);
        } // Merge the partial state and the previous state.

        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.

        if (workInProgress.expirationTime === NoWork) {
          // Queue is always non-null for classes
          var updateQueue = workInProgress.updateQueue;
          updateQueue.baseState = memoizedState;
        }
      }
      var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.payload = payload;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'setState');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.tag = ReplaceState;
          update.payload = payload;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'replaceState');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.tag = ForceUpdate;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'forceUpdate');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        }
      };
      function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
          startPhaseTimer(workInProgress, 'shouldComponentUpdate');
          var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
          stopPhaseTimer();
          {
            if (shouldUpdate === undefined) {
              error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component');
            }
          }
          return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) {
          return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        }
        return true;
      }
      function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        {
          var name = getComponentName(ctor) || 'Component';
          var renderPresent = instance.render;
          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') {
              error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
            } else {
              error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
            }
          }
          if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
            error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
          }
          if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
          }
          if (instance.propTypes) {
            error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
          }
          if (instance.contextType) {
            error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
          }
          {
            if (instance.contextTypes) {
              error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
            }
            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
              didWarnAboutContextTypeAndContextTypes.add(ctor);
              error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
            }
          }
          if (typeof instance.componentShouldUpdate === 'function') {
            error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
          }
          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
            error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
          }
          if (typeof instance.componentDidUnmount === 'function') {
            error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
          }
          if (typeof instance.componentDidReceiveProps === 'function') {
            error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
          }
          if (typeof instance.componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
          }
          if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
          }
          var hasMutatedProps = instance.props !== newProps;
          if (instance.props !== undefined && hasMutatedProps) {
            error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
          }
          if (instance.defaultProps) {
            error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
          }
          if (typeof instance.getDerivedStateFromProps === 'function') {
            error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }
          if (typeof instance.getDerivedStateFromError === 'function') {
            error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }
          if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
            error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
          }
          var _state = instance.state;
          if (_state && (typeof _state !== 'object' || isArray(_state))) {
            error('%s.state: must be set to an object or null', name);
          }
          if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
            error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
          }
        }
      }
      function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

        set(instance, workInProgress);
        {
          instance._reactInternalInstance = fakeInternalInstance;
        }
      }
      function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        {
          if ('contextType' in ctor) {
            var isValid =
            // Allow null for conditional declaration
            contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              var addendum = '';
              if (contextType === undefined) {
                addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
              } else if (typeof contextType !== 'object') {
                addendum = ' However, it is set to a ' + typeof contextType + '.';
              } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                addendum = ' Did you accidentally pass the Context.Provider instead?';
              } else if (contextType._context !== undefined) {
                // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
              } else {
                addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
              }
              error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(ctor) || 'Component', addendum);
            }
          }
        }
        if (typeof contextType === 'object' && contextType !== null) {
          context = _readContext(contextType);
        } else {
          unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          var contextTypes = ctor.contextTypes;
          isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
          context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.

        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        {
          if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
          } // If new component APIs are defined, "unsafe" lifecycles won't be called.
          // Warn about these lifecycles if they are present.
          // Don't warn about react-lifecycles-compat polyfilled methods though.

          if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = 'componentWillMount';
            } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
              foundWillMountName = 'UNSAFE_componentWillMount';
            }
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = 'componentWillReceiveProps';
            } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
              foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            }
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = 'componentWillUpdate';
            } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            }
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentName(ctor) || 'Component';
              var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
              }
            }
          }
        } // Cache unmasked context so we can avoid recreating masked context unless necessary.
        // ReactFiberContext usually updates this cache but can't for newly-created instances.

        if (isLegacyContextConsumer) {
          cacheContext(workInProgress, unmaskedContext, context);
        }
        return instance;
      }
      function callComponentWillMount(workInProgress, instance) {
        startPhaseTimer(workInProgress, 'componentWillMount');
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') {
          instance.componentWillMount();
        }
        if (typeof instance.UNSAFE_componentWillMount === 'function') {
          instance.UNSAFE_componentWillMount();
        }
        stopPhaseTimer();
        if (oldState !== instance.state) {
          {
            error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }
      function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        startPhaseTimer(workInProgress, 'componentWillReceiveProps');
        if (typeof instance.componentWillReceiveProps === 'function') {
          instance.componentWillReceiveProps(newProps, nextContext);
        }
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
          instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        }
        stopPhaseTimer();
        if (instance.state !== oldState) {
          {
            var componentName = getComponentName(workInProgress.type) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
              didWarnAboutStateAssignmentForComponent.add(componentName);
              error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
            }
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      } // Invokes the mount life-cycles on a previously never rendered instance.

      function mountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        {
          checkClassInstance(workInProgress, ctor, newProps);
        }
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) {
          instance.context = _readContext(contextType);
        } else {
          var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        {
          if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
            }
          }
          if (workInProgress.mode & StrictMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
          }
          {
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
          }
        }
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
          callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
          // process them now.

          processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
          instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') {
          workInProgress.effectTag |= Update;
        }
      }
      function resumeMountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext(contextType);
        } else {
          var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }
          return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            startPhaseTimer(workInProgress, 'componentWillMount');
            if (typeof instance.componentWillMount === 'function') {
              instance.componentWillMount();
            }
            if (typeof instance.UNSAFE_componentWillMount === 'function') {
              instance.UNSAFE_componentWillMount();
            }
            stopPhaseTimer();
          }
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }
        } else {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          } // If shouldComponentUpdate returned false, we should still update the
          // memoized state to indicate that this work can be reused.

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      } // Invokes the update life-cycles and returns false if it shouldn't rerender.

      function updateClassInstance(current, workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var oldProps = workInProgress.memoizedProps;
        instance.props = workInProgress.type === workInProgress.elementType ? oldProps : resolveDefaultProps(workInProgress.type, oldProps);
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext(contextType);
        } else {
          var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Update;
            }
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Snapshot;
            }
          }
          return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
            startPhaseTimer(workInProgress, 'componentWillUpdate');
            if (typeof instance.componentWillUpdate === 'function') {
              instance.componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            stopPhaseTimer();
          }
          if (typeof instance.componentDidUpdate === 'function') {
            workInProgress.effectTag |= Update;
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            workInProgress.effectTag |= Snapshot;
          }
        } else {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Update;
            }
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Snapshot;
            }
          } // If shouldComponentUpdate returned false, we should still update the
          // memoized props/state to indicate that this work can be reused.

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      }
      var didWarnAboutMaps;
      var didWarnAboutGenerators;
      var didWarnAboutStringRefs;
      var ownerHasKeyUseWarning;
      var ownerHasFunctionTypeWarning;
      var warnForMissingKey = function warnForMissingKey(child) {};
      {
        didWarnAboutMaps = false;
        didWarnAboutGenerators = false;
        didWarnAboutStringRefs = {};
        /**
         * Warn if there's no key explicitly set on dynamic arrays of children or
         * object keys are not valid. This allows us to keep track of children between
         * updates.
         */

        ownerHasKeyUseWarning = {};
        ownerHasFunctionTypeWarning = {};
        warnForMissingKey = function warnForMissingKey(child) {
          if (child === null || typeof child !== 'object') {
            return;
          }
          if (!child._store || child._store.validated || child.key != null) {
            return;
          }
          if (!(typeof child._store === 'object')) {
            {
              throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          child._store.validated = true;
          var currentComponentErrorInfo = 'Each child in a list should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.' + getCurrentFiberStackInDev();
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          error('Each child in a list should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.');
        };
      }
      var isArray$1 = Array.isArray;
      function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
          {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) &&
            // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
              var componentName = getComponentName(returnFiber.type) || 'Component';
              if (!didWarnAboutStringRefs[componentName]) {
                {
                  error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-string-ref%s', mixedRef, getStackByFiberInDevAndProd(returnFiber));
                }
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
          if (element._owner) {
            var owner = element._owner;
            var inst;
            if (owner) {
              var ownerFiber = owner;
              if (!(ownerFiber.tag === ClassComponent)) {
                {
                  throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref");
                }
              }
              inst = ownerFiber.stateNode;
            }
            if (!inst) {
              {
                throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

            if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
              return current.ref;
            }
            var ref = function ref(value) {
              var refs = inst.refs;
              if (refs === emptyRefsObject) {
                // This is a lazy pooled frozen object, so we need to initialize.
                refs = inst.refs = {};
              }
              if (value === null) {
                delete refs[stringRef];
              } else {
                refs[stringRef] = value;
              }
            };
            ref._stringRef = stringRef;
            return ref;
          } else {
            if (!(typeof mixedRef === 'string')) {
              {
                throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
              }
            }
            if (!element._owner) {
              {
                throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.");
              }
            }
          }
        }
        return mixedRef;
      }
      function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== 'textarea') {
          var addendum = '';
          {
            addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + getCurrentFiberStackInDev();
          }
          {
            {
              throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + ")." + addendum);
            }
          }
        }
      }
      function warnOnFunctionType() {
        {
          var currentComponentErrorInfo = 'Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.' + getCurrentFiberStackInDev();
          if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
          error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
        }
      } // This wrapper function exists because I expect to clone the code in each path
      // to be able to optimize each path individually by branching early. This needs
      // a compiler or we can do it manually. Helpers that don't need this branching
      // live outside of this function.

      function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
          if (!shouldTrackSideEffects) {
            // Noop.
            return;
          } // Deletions are added in reversed order so we add it to the front.
          // At this point, the return fiber's effect list is empty except for
          // deletions, so we can just append the deletion to the list. The remaining
          // effects aren't added until the complete phase. Once we implement
          // resuming, this may not be true.

          var last = returnFiber.lastEffect;
          if (last !== null) {
            last.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
          }
          childToDelete.nextEffect = null;
          childToDelete.effectTag = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
          if (!shouldTrackSideEffects) {
            // Noop.
            return null;
          } // TODO: For the shouldClone case, this could be micro-optimized a bit by
          // assuming that after the first child we've already added everything.

          var childToDelete = currentFirstChild;
          while (childToDelete !== null) {
            deleteChild(returnFiber, childToDelete);
            childToDelete = childToDelete.sibling;
          }
          return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
          // Add the remaining children to a temporary map so that we can find them by
          // keys quickly. Implicit (null) keys get added to this set with their index
          // instead.
          var existingChildren = new Map();
          var existingChild = currentFirstChild;
          while (existingChild !== null) {
            if (existingChild.key !== null) {
              existingChildren.set(existingChild.key, existingChild);
            } else {
              existingChildren.set(existingChild.index, existingChild);
            }
            existingChild = existingChild.sibling;
          }
          return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
          // We currently set sibling to null and index to 0 here because it is easy
          // to forget to do before returning it. E.g. for the single child case.
          var clone = createWorkInProgress(fiber, pendingProps);
          clone.index = 0;
          clone.sibling = null;
          return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
          newFiber.index = newIndex;
          if (!shouldTrackSideEffects) {
            // Noop.
            return lastPlacedIndex;
          }
          var current = newFiber.alternate;
          if (current !== null) {
            var oldIndex = current.index;
            if (oldIndex < lastPlacedIndex) {
              // This is a move.
              newFiber.effectTag = Placement;
              return lastPlacedIndex;
            } else {
              // This item can stay in place.
              return oldIndex;
            }
          } else {
            // This is an insertion.
            newFiber.effectTag = Placement;
            return lastPlacedIndex;
          }
        }
        function placeSingleChild(newFiber) {
          // This is simpler for the single child case. We only need to do a
          // placement for inserting new children.
          if (shouldTrackSideEffects && newFiber.alternate === null) {
            newFiber.effectTag = Placement;
          }
          return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, expirationTime) {
          if (current === null || current.tag !== HostText) {
            // Insert
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, textContent);
            existing.return = returnFiber;
            return existing;
          }
        }
        function updateElement(returnFiber, current, element, expirationTime) {
          if (current !== null) {
            if (current.elementType === element.type ||
            // Keep this check inline so it only runs on the false path:
            isCompatibleFamilyForHotReloading(current, element)) {
              // Move based on index
              var existing = useFiber(current, element.props);
              existing.ref = coerceRef(returnFiber, current, element);
              existing.return = returnFiber;
              {
                existing._debugSource = element._source;
                existing._debugOwner = element._owner;
              }
              return existing;
            }
          } // Insert

          var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
          created.ref = coerceRef(returnFiber, current, element);
          created.return = returnFiber;
          return created;
        }
        function updatePortal(returnFiber, current, portal, expirationTime) {
          if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
            // Insert
            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, portal.children || []);
            existing.return = returnFiber;
            return existing;
          }
        }
        function updateFragment(returnFiber, current, fragment, expirationTime, key) {
          if (current === null || current.tag !== Fragment$$1) {
            // Insert
            var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, fragment);
            existing.return = returnFiber;
            return existing;
          }
        }
        function createChild(returnFiber, newChild, expirationTime) {
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys. If the previous node is implicitly keyed
            // we can continue to replace it without aborting even if it is not a text
            // node.
            var created = createFiberFromText('' + newChild, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);
                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created.return = returnFiber;
                  return _created;
                }
              case REACT_PORTAL_TYPE:
                {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);
                  _created2.return = returnFiber;
                  return _created2;
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);
              _created3.return = returnFiber;
              return _created3;
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
          // Update the fiber if the keys match, otherwise return null.
          var key = oldFiber !== null ? oldFiber.key : null;
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys. If the previous node is implicitly keyed
            // we can continue to replace it without aborting even if it is not a text
            // node.
            if (key !== null) {
              return null;
            }
            return updateTextNode(returnFiber, oldFiber, '' + newChild, expirationTime);
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  if (newChild.key === key) {
                    if (newChild.type === REACT_FRAGMENT_TYPE) {
                      return updateFragment(returnFiber, oldFiber, newChild.props.children, expirationTime, key);
                    }
                    return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
              case REACT_PORTAL_TYPE:
                {
                  if (newChild.key === key) {
                    return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              if (key !== null) {
                return null;
              }
              return updateFragment(returnFiber, oldFiber, newChild, expirationTime, null);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys, so we neither have to check the old nor
            // new node for the key. If both are text nodes, they match.
            var matchedFiber = existingChildren.get(newIdx) || null;
            return updateTextNode(returnFiber, matchedFiber, '' + newChild, expirationTime);
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  if (newChild.type === REACT_FRAGMENT_TYPE) {
                    return updateFragment(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                  }
                  return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                }
              case REACT_PORTAL_TYPE:
                {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              var _matchedFiber3 = existingChildren.get(newIdx) || null;
              return updateFragment(returnFiber, _matchedFiber3, newChild, expirationTime, null);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        /**
         * Warns if there is a duplicate or missing key
         */

        function warnOnInvalidKey(child, knownKeys) {
          {
            if (typeof child !== 'object' || child === null) {
              return knownKeys;
            }
            switch (child.$$typeof) {
              case REACT_ELEMENT_TYPE:
              case REACT_PORTAL_TYPE:
                warnForMissingKey(child);
                var key = child.key;
                if (typeof key !== 'string') {
                  break;
                }
                if (knownKeys === null) {
                  knownKeys = new Set();
                  knownKeys.add(key);
                  break;
                }
                if (!knownKeys.has(key)) {
                  knownKeys.add(key);
                  break;
                }
                error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);
                break;
            }
          }
          return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
          // This algorithm can't optimize by searching from both ends since we
          // don't have backpointers on fibers. I'm trying to see how far we can get
          // with that model. If it ends up not being worth the tradeoffs, we can
          // add it later.
          // Even with a two ended optimization, we'd want to optimize for the case
          // where there are few changes and brute force the comparison instead of
          // going for the Map. It'd like to explore hitting that path first in
          // forward-only mode and only go for the Map once we notice that we need
          // lots of look ahead. This doesn't handle reversal as well as two ended
          // search but that's unusual. Besides, for the two ended optimization to
          // work on Iterables, we'd need to copy the whole set.
          // In this first iteration, we'll just live with hitting the bad case
          // (adding everything to a Map) in for every insert/move.
          // If you change this code, also update reconcileChildrenIterator() which
          // uses the same algorithm.
          {
            // First, validate keys.
            var knownKeys = null;
            for (var i = 0; i < newChildren.length; i++) {
              var child = newChildren[i];
              knownKeys = warnOnInvalidKey(child, knownKeys);
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);
            if (newFiber === null) {
              // TODO: This breaks on empty slots like null children. That's
              // unfortunate because it triggers the slow path all the time. We need
              // a better way to communicate whether this was a miss or null,
              // boolean, undefined, etc.
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }
              break;
            }
            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                // We matched the slot, but we didn't reuse the existing fiber, so we
                // need to delete the existing child.
                deleteChild(returnFiber, oldFiber);
              }
            }
            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
            if (previousNewFiber === null) {
              // TODO: Move out of the loop. This only happens for the first run.
              resultingFirstChild = newFiber;
            } else {
              // TODO: Defer siblings if we're not at the right index for this slot.
              // I.e. if we had null values before, then we want to defer this
              // for each null value. However, we also don't want to call updateSlot
              // with the previous one.
              previousNewFiber.sibling = newFiber;
            }
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }
          if (newIdx === newChildren.length) {
            // We've reached the end of the new children. We can delete the rest.
            deleteRemainingChildren(returnFiber, oldFiber);
            return resultingFirstChild;
          }
          if (oldFiber === null) {
            // If we don't have any more existing children we can choose a fast path
            // since the rest will all be insertions.
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);
              if (_newFiber === null) {
                continue;
              }
              lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = _newFiber;
              } else {
                previousNewFiber.sibling = _newFiber;
              }
              previousNewFiber = _newFiber;
            }
            return resultingFirstChild;
          } // Add all children to a key map for quick lookups.

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

          for (; newIdx < newChildren.length; newIdx++) {
            var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);
            if (_newFiber2 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber2.alternate !== null) {
                  // The new fiber is a work in progress, but if there exists a
                  // current, that means that we reused the fiber. We need to delete
                  // it from the child list so that we don't add it to the deletion
                  // list.
                  existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                }
              }
              lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber2;
              } else {
                previousNewFiber.sibling = _newFiber2;
              }
              previousNewFiber = _newFiber2;
            }
          }
          if (shouldTrackSideEffects) {
            // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }
          return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
          // This is the same implementation as reconcileChildrenArray(),
          // but using the iterator instead.
          var iteratorFn = getIteratorFn(newChildrenIterable);
          if (!(typeof iteratorFn === 'function')) {
            {
              throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          {
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' &&
            // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
              if (!didWarnAboutGenerators) {
                error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
              }
              didWarnAboutGenerators = true;
            } // Warn about using Maps as children

            if (newChildrenIterable.entries === iteratorFn) {
              if (!didWarnAboutMaps) {
                error('Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.');
              }
              didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.

            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
              var knownKeys = null;
              var _step = _newChildren.next();
              for (; !_step.done; _step = _newChildren.next()) {
                var child = _step.value;
                knownKeys = warnOnInvalidKey(child, knownKeys);
              }
            }
          }
          var newChildren = iteratorFn.call(newChildrenIterable);
          if (!(newChildren != null)) {
            {
              throw Error("An iterable object provided no iterator.");
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          var step = newChildren.next();
          for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);
            if (newFiber === null) {
              // TODO: This breaks on empty slots like null children. That's
              // unfortunate because it triggers the slow path all the time. We need
              // a better way to communicate whether this was a miss or null,
              // boolean, undefined, etc.
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }
              break;
            }
            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                // We matched the slot, but we didn't reuse the existing fiber, so we
                // need to delete the existing child.
                deleteChild(returnFiber, oldFiber);
              }
            }
            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
            if (previousNewFiber === null) {
              // TODO: Move out of the loop. This only happens for the first run.
              resultingFirstChild = newFiber;
            } else {
              // TODO: Defer siblings if we're not at the right index for this slot.
              // I.e. if we had null values before, then we want to defer this
              // for each null value. However, we also don't want to call updateSlot
              // with the previous one.
              previousNewFiber.sibling = newFiber;
            }
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }
          if (step.done) {
            // We've reached the end of the new children. We can delete the rest.
            deleteRemainingChildren(returnFiber, oldFiber);
            return resultingFirstChild;
          }
          if (oldFiber === null) {
            // If we don't have any more existing children we can choose a fast path
            // since the rest will all be insertions.
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber3 = createChild(returnFiber, step.value, expirationTime);
              if (_newFiber3 === null) {
                continue;
              }
              lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = _newFiber3;
              } else {
                previousNewFiber.sibling = _newFiber3;
              }
              previousNewFiber = _newFiber3;
            }
            return resultingFirstChild;
          } // Add all children to a key map for quick lookups.

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

          for (; !step.done; newIdx++, step = newChildren.next()) {
            var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);
            if (_newFiber4 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber4.alternate !== null) {
                  // The new fiber is a work in progress, but if there exists a
                  // current, that means that we reused the fiber. We need to delete
                  // it from the child list so that we don't add it to the deletion
                  // list.
                  existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                }
              }
              lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber4;
              } else {
                previousNewFiber.sibling = _newFiber4;
              }
              previousNewFiber = _newFiber4;
            }
          }
          if (shouldTrackSideEffects) {
            // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }
          return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
          // There's no need to check for keys on text nodes since we don't have a
          // way to define them.
          if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
            // We already have an existing node so let's just update it and delete
            // the rest.
            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
            var existing = useFiber(currentFirstChild, textContent);
            existing.return = returnFiber;
            return existing;
          } // The existing first child is not a text node so we need to create one
          // and delete the existing ones.

          deleteRemainingChildren(returnFiber, currentFirstChild);
          var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
          created.return = returnFiber;
          return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
          var key = element.key;
          var child = currentFirstChild;
          while (child !== null) {
            // TODO: If key === null and child.key === null, then this only applies to
            // the first item in the list.
            if (child.key === key) {
              switch (child.tag) {
                case Fragment$$1:
                  {
                    if (element.type === REACT_FRAGMENT_TYPE) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var existing = useFiber(child, element.props.children);
                      existing.return = returnFiber;
                      {
                        existing._debugSource = element._source;
                        existing._debugOwner = element._owner;
                      }
                      return existing;
                    }
                    break;
                  }
                case Block:

                // We intentionally fallthrough here if enableBlocksAPI is not on.
                // eslint-disable-next-lined no-fallthrough

                default:
                  {
                    if (child.elementType === element.type ||
                    // Keep this check inline so it only runs on the false path:
                    isCompatibleFamilyForHotReloading(child, element)) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var _existing3 = useFiber(child, element.props);
                      _existing3.ref = coerceRef(returnFiber, child, element);
                      _existing3.return = returnFiber;
                      {
                        _existing3._debugSource = element._source;
                        _existing3._debugOwner = element._owner;
                      }
                      return _existing3;
                    }
                    break;
                  }
              } // Didn't match.

              deleteRemainingChildren(returnFiber, child);
              break;
            } else {
              deleteChild(returnFiber, child);
            }
            child = child.sibling;
          }
          if (element.type === REACT_FRAGMENT_TYPE) {
            var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
            created.return = returnFiber;
            return created;
          } else {
            var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);
            _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
            _created4.return = returnFiber;
            return _created4;
          }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
          var key = portal.key;
          var child = currentFirstChild;
          while (child !== null) {
            // TODO: If key === null and child.key === null, then this only applies to
            // the first item in the list.
            if (child.key === key) {
              if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, portal.children || []);
                existing.return = returnFiber;
                return existing;
              } else {
                deleteRemainingChildren(returnFiber, child);
                break;
              }
            } else {
              deleteChild(returnFiber, child);
            }
            child = child.sibling;
          }
          var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
          created.return = returnFiber;
          return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.

        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, expirationTime) {
          // This function is not recursive.
          // If the top level item is an array, we treat it as a set of children,
          // not as a fragment. Nested arrays on the other hand will be treated as
          // fragment nodes. Recursion happens at the normal flow.
          // Handle top level unkeyed fragments as if they were arrays.
          // This leads to an ambiguity between <>{[...]}</> and <>...</>.
          // We treat the ambiguous cases above the same.
          var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
          if (isUnkeyedTopLevelFragment) {
            newChild = newChild.props.children;
          } // Handle object types

          var isObject = typeof newChild === 'object' && newChild !== null;
          if (isObject) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));
              case REACT_PORTAL_TYPE:
                return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
            }
          }
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, expirationTime));
          }
          if (isArray$1(newChild)) {
            return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
          }
          if (getIteratorFn(newChild)) {
            return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
          }
          if (isObject) {
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
            // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch (returnFiber.tag) {
              case ClassComponent:
                {
                  {
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) {
                      // We allow auto-mocks to proceed as if they're returning null.
                      break;
                    }
                  }
                }
              // Intentionally fall through to the next case, which handles both
              // functions and classes
              // eslint-disable-next-lined no-fallthrough

              case FunctionComponent:
                {
                  var Component = returnFiber.type;
                  {
                    {
                      throw Error((Component.displayName || Component.name || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
                    }
                  }
                }
            }
          } // Remaining cases are all treated as empty.

          return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
      }
      var reconcileChildFibers = ChildReconciler(true);
      var mountChildFibers = ChildReconciler(false);
      function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) {
          {
            throw Error("Resuming work not yet implemented.");
          }
        }
        if (workInProgress.child === null) {
          return;
        }
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while (currentChild.sibling !== null) {
          currentChild = currentChild.sibling;
          newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
          newChild.return = workInProgress;
        }
        newChild.sibling = null;
      } // Reset a workInProgress child set to prepare it for a second pass.

      function resetChildFibers(workInProgress, renderExpirationTime) {
        var child = workInProgress.child;
        while (child !== null) {
          resetWorkInProgress(child, renderExpirationTime);
          child = child.sibling;
        }
      }
      var NO_CONTEXT$1 = {};
      var contextStackCursor$1 = createCursor(NO_CONTEXT$1);
      var contextFiberStackCursor = createCursor(NO_CONTEXT$1);
      var rootInstanceStackCursor = createCursor(NO_CONTEXT$1);
      function requiredContext(c) {
        if (!(c !== NO_CONTEXT$1)) {
          {
            throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        return c;
      }
      function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
      }
      function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.

        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.

        push(contextStackCursor$1, NO_CONTEXT$1, fiber);
        var nextRootContext = getRootHostContext(); // Now that we know this function doesn't throw, replace it.

        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
      }
      function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
      }
      function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
      }
      function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.

        if (context === nextContext) {
          return;
        } // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.

        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
      }
      function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) {
          return;
        }
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
      }
      var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
      // inherited deeply down the subtree. The upper bits only affect
      // this immediate suspense boundary and gets reset each new
      // boundary or suspense list.

      var SubtreeSuspenseContextMask = 1; // Subtree Flags:
      // InvisibleParentSuspenseContext indicates that one of our parent Suspense
      // boundaries is not currently showing visible main content.
      // Either because it is already showing a fallback or is not mounted at all.
      // We can use this to determine if it is desirable to trigger a fallback at
      // the parent. If not, then we might need to trigger undesirable boundaries
      // and/or suspend the commit to avoid hiding the parent content.

      var InvisibleParentSuspenseContext = 1; // Shallow Flags:
      // ForceSuspenseFallback can be used by SuspenseList to force newly added
      // items into their fallback state during one of the render passes.

      var ForceSuspenseFallback = 2;
      var suspenseStackCursor = createCursor(DefaultSuspenseContext);
      function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
      }
      function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
      }
      function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
      }
      function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
      }
      function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
      }
      function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
      }
      function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
          if (nextState.dehydrated !== null) {
            // A dehydrated boundary always captures.
            return true;
          }
          return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.

        if (props.fallback === undefined) {
          return false;
        } // Regular boundaries always capture.

        if (props.unstable_avoidThisFallback !== true) {
          return true;
        } // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.

        if (hasInvisibleParent) {
          return false;
        } // If the parent is not able to handle it, we must handle it.

        return true;
      }
      function findFirstSuspended(row) {
        var node = row;
        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;
            if (state !== null) {
              var dehydrated = state.dehydrated;
              if (dehydrated === null || isSuspenseInstancePending() || isSuspenseInstanceFallback()) {
                return node;
              }
            }
          } else if (node.tag === SuspenseListComponent &&
          // revealOrder undefined can't be trusted because it don't
          // keep track of whether it suspended or not.
          node.memoizedProps.revealOrder !== undefined) {
            var didSuspend = (node.effectTag & DidCapture) !== NoEffect;
            if (didSuspend) {
              return node;
            }
          } else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === row) {
            return null;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === row) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
        return null;
      }
      function createDeprecatedResponderListener(responder, props) {
        var eventResponderListener = {
          responder: responder,
          props: props
        };
        {
          Object.freeze(eventResponderListener);
        }
        return eventResponderListener;
      }
      var HasEffect = /* */
      1; // Represents the phase in which the effect (not the clean-up) fires.

      var Layout = /*    */
      2;
      var Passive$1 = /*   */
      4;
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher,
        ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
      var didWarnAboutMismatchedHooksForComponent;
      {
        didWarnAboutMismatchedHooksForComponent = new Set();
      }

      // These are set right before calling the component.
      var renderExpirationTime = NoWork; // The work-in-progress fiber. I've named it differently to distinguish it from
      // the work-in-progress hook.

      var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
      // current hook list is the list that belongs to the current fiber. The
      // work-in-progress hook list is a new list that will be added to the
      // work-in-progress fiber.

      var currentHook = null;
      var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
      // does not get reset if we do another render pass; only when we're completely
      // finished evaluating this component. This is an optimization so we know
      // whether we need to clear render phase updates after a throw.

      var didScheduleRenderPhaseUpdate = false;
      var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook

      var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
      // The list stores the order of hooks used during the initial render (mount).
      // Subsequent renders (updates) reference this list.

      var hookTypesDev = null;
      var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
      // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
      // When true, such Hooks will always be "remounted". Only used during hot reload.

      var ignorePreviousDependencies = false;
      function mountHookTypesDev() {
        {
          var hookName = currentHookNameInDev;
          if (hookTypesDev === null) {
            hookTypesDev = [hookName];
          } else {
            hookTypesDev.push(hookName);
          }
        }
      }
      function updateHookTypesDev() {
        {
          var hookName = currentHookNameInDev;
          if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
              warnOnHookMismatchInDev(hookName);
            }
          }
        }
      }
      function checkDepsAreArrayDev(deps) {
        {
          if (deps !== undefined && deps !== null && !Array.isArray(deps)) {
            // Verify deps, but only on mount to avoid extra checks.
            // It's unlikely their type would change as usually you define them inline.
            error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
          }
        }
      }
      function warnOnHookMismatchInDev(currentHookName) {
        {
          var componentName = getComponentName(currentlyRenderingFiber$1.type);
          if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
              var table = '';
              var secondColumnStart = 30;
              for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
                var oldHookName = hookTypesDev[i];
                var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                // lol @ IE not supporting String#repeat

                while (row.length < secondColumnStart) {
                  row += ' ';
                }
                row += newHookName + '\n';
                table += row;
              }
              error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://fb.me/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
            }
          }
        }
      }
      function throwInvalidHookError() {
        {
          {
            throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
          }
        }
      }
      function areHookInputsEqual(nextDeps, prevDeps) {
        {
          if (ignorePreviousDependencies) {
            // Only true when this component is being hot reloaded.
            return false;
          }
        }
        if (prevDeps === null) {
          {
            error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
          }
          return false;
        }
        {
          // Don't bother comparing lengths in prod because these arrays should be
          // passed inline.
          if (nextDeps.length !== prevDeps.length) {
            error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
          }
        }
        for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
          if (objectIs(nextDeps[i], prevDeps[i])) {
            continue;
          }
          return false;
        }
        return true;
      }
      function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderExpirationTime) {
        renderExpirationTime = nextRenderExpirationTime;
        currentlyRenderingFiber$1 = workInProgress;
        {
          hookTypesDev = current !== null ? current._debugHookTypes : null;
          hookTypesUpdateIndexDev = -1; // Used for hot reloading:

          ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        }
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.expirationTime = NoWork; // The following should have already been reset
        // currentHook = null;
        // workInProgressHook = null;
        // didScheduleRenderPhaseUpdate = false;
        // TODO Warn if no hooks are used at all during mount, then some are used during update.
        // Currently we will identify the update render as a mount because memoizedState === null.
        // This is tricky because it's valid for certain types of components (e.g. React.lazy)
        // Using memoizedState to differentiate between mount/update only works if at least one stateful hook is used.
        // Non-stateful hooks (e.g. context) don't get added to memoizedState,
        // so memoizedState would be null during updates and mounts.

        {
          if (current !== null && current.memoizedState !== null) {
            ReactCurrentDispatcher.current = HooksDispatcherOnUpdateInDEV;
          } else if (hookTypesDev !== null) {
            // This dispatcher handles an edge case where a component is updating,
            // but no stateful hooks have been used.
            // We want to match the production code behavior (which will use HooksDispatcherOnMount),
            // but with the extra DEV validation to ensure hooks ordering hasn't changed.
            // This dispatcher does that.
            ReactCurrentDispatcher.current = HooksDispatcherOnMountWithHookTypesInDEV;
          } else {
            ReactCurrentDispatcher.current = HooksDispatcherOnMountInDEV;
          }
        }
        var children = Component(props, secondArg); // Check if there was a render phase update

        if (workInProgress.expirationTime === renderExpirationTime) {
          // Keep rendering in a loop for as long as render phase updates continue to
          // be scheduled. Use a counter to prevent infinite loops.
          var numberOfReRenders = 0;
          do {
            workInProgress.expirationTime = NoWork;
            if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
              {
                throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
              }
            }
            numberOfReRenders += 1;
            {
              // Even when hot reloading, allow dependencies to stabilize
              // after first render to prevent infinite render phase updates.
              ignorePreviousDependencies = false;
            } // Start over from the beginning of the list

            currentHook = null;
            workInProgressHook = null;
            workInProgress.updateQueue = null;
            {
              // Also validate hook order for cascading updates.
              hookTypesUpdateIndexDev = -1;
            }
            ReactCurrentDispatcher.current = HooksDispatcherOnRerenderInDEV;
            children = Component(props, secondArg);
          } while (workInProgress.expirationTime === renderExpirationTime);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.

        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        {
          workInProgress._debugHookTypes = hookTypesDev;
        } // This check uses currentHook so that it works the same in DEV and prod bundles.
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.

        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          currentHookNameInDev = null;
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
        }
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) {
          {
            throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
          }
        }
        return children;
      }
      function bailoutHooks(current, workInProgress, expirationTime) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.effectTag &= ~(Passive | Update);
        if (current.expirationTime <= expirationTime) {
          current.expirationTime = NoWork;
        }
      }
      function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
          // There were render phase updates. These are only valid for this render
          // phase, which we are now aborting. Remove the updates from the queues so
          // they do not persist to the next render. Do not remove updates from hooks
          // that weren't processed.
          //
          // Only reset the updates from the queue if it has a clone. If it does
          // not have a clone, that means it wasn't processed, and the updates were
          // scheduled before we entered the render phase.
          var hook = currentlyRenderingFiber$1.memoizedState;
          while (hook !== null) {
            var queue = hook.queue;
            if (queue !== null) {
              queue.pending = null;
            }
            hook = hook.next;
          }
        }
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
          currentHookNameInDev = null;
        }
        didScheduleRenderPhaseUpdate = false;
      }
      function mountWorkInProgressHook() {
        var hook = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };
        if (workInProgressHook === null) {
          // This is the first hook in the list
          currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        } else {
          // Append to the end of the list
          workInProgressHook = workInProgressHook.next = hook;
        }
        return workInProgressHook;
      }
      function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
          var current = currentlyRenderingFiber$1.alternate;
          if (current !== null) {
            nextCurrentHook = current.memoizedState;
          } else {
            nextCurrentHook = null;
          }
        } else {
          nextCurrentHook = currentHook.next;
        }
        var nextWorkInProgressHook;
        if (workInProgressHook === null) {
          nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        } else {
          nextWorkInProgressHook = workInProgressHook.next;
        }
        if (nextWorkInProgressHook !== null) {
          // There's already a work-in-progress. Reuse it.
          workInProgressHook = nextWorkInProgressHook;
          nextWorkInProgressHook = workInProgressHook.next;
          currentHook = nextCurrentHook;
        } else {
          // Clone from the current hook.
          if (!(nextCurrentHook !== null)) {
            {
              throw Error("Rendered more hooks than during the previous render.");
            }
          }
          currentHook = nextCurrentHook;
          var newHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
          };
          if (workInProgressHook === null) {
            // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
          } else {
            // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
          }
        }
        return workInProgressHook;
      }
      function createFunctionComponentUpdateQueue() {
        return {
          lastEffect: null
        };
      }
      function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
      }
      function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) {
          initialState = init(initialArg);
        } else {
          initialState = initialArg;
        }
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: reducer,
          lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }
      function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) {
          {
            throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
          }
        }
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.

        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.

        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
          // We have new updates that haven't been processed yet.
          // We'll add them to the base queue.
          if (baseQueue !== null) {
            // Merge the pending queue and the base queue.
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }
          current.baseQueue = baseQueue = pendingQueue;
          queue.pending = null;
        }
        if (baseQueue !== null) {
          // We have a queue to process.
          var first = baseQueue.next;
          var newState = current.baseState;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          var update = first;
          do {
            var updateExpirationTime = update.expirationTime;
            if (updateExpirationTime < renderExpirationTime) {
              // Priority is insufficient. Skip this update. If this is the first
              // skipped update, the previous update/state is the new base
              // update/state.
              var clone = {
                expirationTime: update.expirationTime,
                suspenseConfig: update.suspenseConfig,
                action: update.action,
                eagerReducer: update.eagerReducer,
                eagerState: update.eagerState,
                next: null
              };
              if (newBaseQueueLast === null) {
                newBaseQueueFirst = newBaseQueueLast = clone;
                newBaseState = newState;
              } else {
                newBaseQueueLast = newBaseQueueLast.next = clone;
              } // Update the remaining priority in the queue.

              if (updateExpirationTime > currentlyRenderingFiber$1.expirationTime) {
                currentlyRenderingFiber$1.expirationTime = updateExpirationTime;
                markUnprocessedUpdateTime(updateExpirationTime);
              }
            } else {
              // This update does have sufficient priority.
              if (newBaseQueueLast !== null) {
                var _clone = {
                  expirationTime: Sync,
                  // This update is going to be committed so we never want uncommit it.
                  suspenseConfig: update.suspenseConfig,
                  action: update.action,
                  eagerReducer: update.eagerReducer,
                  eagerState: update.eagerState,
                  next: null
                };
                newBaseQueueLast = newBaseQueueLast.next = _clone;
              } // Mark the event time of this update as relevant to this render pass.
              // TODO: This should ideally use the true event time of this update rather than
              // its priority which is a derived and not reverseable value.
              // TODO: We should skip this update if it was already committed but currently
              // we have no way of detecting the difference between a committed and suspended
              // update here.

              markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.

              if (update.eagerReducer === reducer) {
                // If this update was processed eagerly, and its reducer matches the
                // current reducer, we can use the eagerly computed state.
                newState = update.eagerState;
              } else {
                var action = update.action;
                newState = reducer(newState, action);
              }
            }
            update = update.next;
          } while (update !== null && update !== first);
          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          } // Mark that the fiber performed work, but only if the new state is
          // different from the current state.

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }
          hook.memoizedState = newState;
          hook.baseState = newBaseState;
          hook.baseQueue = newBaseQueueLast;
          queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [hook.memoizedState, dispatch];
      }
      function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) {
          {
            throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
          }
        }
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.

        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
          // The queue doesn't persist past this render pass.
          queue.pending = null;
          var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
          var update = firstRenderPhaseUpdate;
          do {
            // Process this render phase update. We don't have to check the
            // priority because it will always be the same as the current
            // render's.
            var action = update.action;
            newState = reducer(newState, action);
            update = update.next;
          } while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
          // different from the current state.

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }
          hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
          // the base state unless the queue is empty.
          // TODO: Not sure if this is the desired semantics, but it's what we
          // do for gDSFP. I can't remember why.

          if (hook.baseQueue === null) {
            hook.baseState = newState;
          }
          queue.lastRenderedState = newState;
        }
        return [newState, dispatch];
      }
      function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') {
          // $FlowFixMe: Flow doesn't like mixed types
          initialState = initialState();
        }
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }
      function updateState(initialState) {
        return updateReducer(basicStateReducer);
      }
      function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
      }
      function pushEffect(tag, create, destroy, deps) {
        var effect = {
          tag: tag,
          create: create,
          destroy: destroy,
          deps: deps,
          // Circular
          next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
          var lastEffect = componentUpdateQueue.lastEffect;
          if (lastEffect === null) {
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var firstEffect = lastEffect.next;
            lastEffect.next = effect;
            effect.next = firstEffect;
            componentUpdateQueue.lastEffect = effect;
          }
        }
        return effect;
      }
      function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
          current: initialValue
        };
        {
          Object.seal(ref);
        }
        hook.memoizedState = ref;
        return ref;
      }
      function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
      }
      function mountEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, undefined, nextDeps);
      }
      function updateEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
          var prevEffect = currentHook.memoizedState;
          destroy = prevEffect.destroy;
          if (nextDeps !== null) {
            var prevDeps = prevEffect.deps;
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              pushEffect(hookEffectTag, create, destroy, nextDeps);
              return;
            }
          }
        }
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, destroy, nextDeps);
      }
      function mountEffect(create, deps) {
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
          }
        }
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
      }
      function updateEffect(create, deps) {
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
          }
        }
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
      }
      function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
      }
      function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
      }
      function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
          var refCallback = ref;
          var _inst = create();
          refCallback(_inst);
          return function () {
            refCallback(null);
          };
        } else if (ref !== null && ref !== undefined) {
          var refObject = ref;
          {
            if (!refObject.hasOwnProperty('current')) {
              error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            }
          }
          var _inst2 = create();
          refObject.current = _inst2;
          return function () {
            refObject.current = null;
          };
        }
      }
      function mountImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        } // TODO: If deps are provided, should we skip comparing the ref itself?

        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }
      function updateImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        } // TODO: If deps are provided, should we skip comparing the ref itself?

        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }
      function mountDebugValue(value, formatterFn) {// This hook is normally a no-op.
        // The react-debug-hooks package injects its own implementation
        // so that e.g. DevTools can display custom hook values.
      }
      var updateDebugValue = mountDebugValue;
      function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }
      function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }
      function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }
      function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
          // Assume these are defined. If they're not, areHookInputsEqual will warn.
          if (nextDeps !== null) {
            var prevDeps = prevState[1];
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }
      function mountDeferredValue(value, config) {
        var _mountState = mountState(value),
          prevValue = _mountState[0],
          setValue = _mountState[1];
        mountEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function updateDeferredValue(value, config) {
        var _updateState = updateState(),
          prevValue = _updateState[0],
          setValue = _updateState[1];
        updateEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function rerenderDeferredValue(value, config) {
        var _rerenderState = rerenderState(),
          prevValue = _rerenderState[0],
          setValue = _rerenderState[1];
        updateEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function startTransition(setPending, config, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority(priorityLevel < UserBlockingPriority ? UserBlockingPriority : priorityLevel, function () {
          setPending(true);
        });
        runWithPriority(priorityLevel > NormalPriority ? NormalPriority : priorityLevel, function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setPending(false);
            callback();
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        });
      }
      function mountTransition(config) {
        var _mountState2 = mountState(false),
          isPending = _mountState2[0],
          setPending = _mountState2[1];
        var start = mountCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function updateTransition(config) {
        var _updateState2 = updateState(),
          isPending = _updateState2[0],
          setPending = _updateState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function rerenderTransition(config) {
        var _rerenderState2 = rerenderState(),
          isPending = _rerenderState2[0],
          setPending = _rerenderState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function dispatchAction(fiber, queue, action) {
        {
          if (typeof arguments[3] === 'function') {
            error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
          }
        }
        var currentTime = requestCurrentTimeForUpdate();
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
        var update = {
          expirationTime: expirationTime,
          suspenseConfig: suspenseConfig,
          action: action,
          eagerReducer: null,
          eagerState: null,
          next: null
        };
        {
          update.priority = getCurrentPriorityLevel();
        } // Append the update to the end of the list.

        var pending = queue.pending;
        if (pending === null) {
          // This is the first update. Create a circular list.
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
          // This is a render phase update. Stash it in a lazily-created map of
          // queue -> linked list of updates. After this render pass, we'll restart
          // and apply the stashed updates on top of the work-in-progress hook.
          didScheduleRenderPhaseUpdate = true;
          update.expirationTime = renderExpirationTime;
          currentlyRenderingFiber$1.expirationTime = renderExpirationTime;
        } else {
          if (fiber.expirationTime === NoWork && (alternate === null || alternate.expirationTime === NoWork)) {
            // The queue is currently empty, which means we can eagerly compute the
            // next state before entering the render phase. If the new state is the
            // same as the current state, we may be able to bail out entirely.
            var lastRenderedReducer = queue.lastRenderedReducer;
            if (lastRenderedReducer !== null) {
              var prevDispatcher;
              {
                prevDispatcher = ReactCurrentDispatcher.current;
                ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              }
              try {
                var currentState = queue.lastRenderedState;
                var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                // it, on the update object. If the reducer hasn't changed by the
                // time we enter the render phase, then the eager state can be used
                // without calling the reducer again.

                update.eagerReducer = lastRenderedReducer;
                update.eagerState = eagerState;
                if (objectIs(eagerState, currentState)) {
                  // Fast path. We can bail out without scheduling React to re-render.
                  // It's still possible that we'll need to rebase this update later,
                  // if the component re-renders for a different reason and by that
                  // time the reducer has changed.
                  return;
                }
              } catch (error) {// Suppress the error. It will throw again in the render phase.
              } finally {
                {
                  ReactCurrentDispatcher.current = prevDispatcher;
                }
              }
            }
          }
          {
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
              warnIfNotScopedWithMatchingAct(fiber);
              warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
          }
          scheduleWork(fiber, expirationTime);
        }
      }
      var ContextOnlyDispatcher = {
        readContext: _readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useResponder: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError
      };
      var HooksDispatcherOnMountInDEV = null;
      var HooksDispatcherOnMountWithHookTypesInDEV = null;
      var HooksDispatcherOnUpdateInDEV = null;
      var HooksDispatcherOnRerenderInDEV = null;
      var InvalidNestedHooksDispatcherOnMountInDEV = null;
      var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
      var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
      {
        var warnInvalidContextAccess = function warnInvalidContextAccess() {
          error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
        };
        var warnInvalidHookAccess = function warnInvalidHookAccess() {
          error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://fb.me/rules-of-hooks');
        };
        HooksDispatcherOnMountInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition(config);
          }
        };
        HooksDispatcherOnMountWithHookTypesInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition(config);
          }
        };
        HooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition(config);
          }
        };
        HooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnMountInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition(config);
          }
        };
      }
      var now$1 = Scheduler$1.unstable_now;
      var commitTime = 0;
      var profilerStartTime = -1;
      function getCommitTime() {
        return commitTime;
      }
      function recordCommitTime() {
        commitTime = now$1();
      }
      function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) {
          fiber.actualStartTime = now$1();
        }
      }
      function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
      }
      function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
          var elapsedTime = now$1() - profilerStartTime;
          fiber.actualDuration += elapsedTime;
          if (overrideBaseTime) {
            fiber.selfBaseDuration = elapsedTime;
          }
          profilerStartTime = -1;
        }
      }
      function enterHydrationState(fiber) {
        {
          return false;
        }
      }
      function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        {
          {
            {
              throw Error("Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
      }
      function prepareToHydrateHostTextInstance(fiber) {
        {
          {
            {
              throw Error("Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
      }
      function popHydrationState(fiber) {
        {
          return false;
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var didReceiveUpdate = false;
      var didWarnAboutBadClass;
      var didWarnAboutModulePatternComponent;
      var didWarnAboutContextTypeOnFunctionComponent;
      var didWarnAboutGetDerivedStateOnFunctionComponent;
      var didWarnAboutFunctionRefs;
      var didWarnAboutReassigningProps;
      var didWarnAboutRevealOrder;
      var didWarnAboutTailOptions;
      {
        didWarnAboutBadClass = {};
        didWarnAboutModulePatternComponent = {};
        didWarnAboutContextTypeOnFunctionComponent = {};
        didWarnAboutGetDerivedStateOnFunctionComponent = {};
        didWarnAboutFunctionRefs = {};
        didWarnAboutReassigningProps = false;
        didWarnAboutRevealOrder = {};
        didWarnAboutTailOptions = {};
      }
      function reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime) {
        if (current === null) {
          // If this is a fresh new component that hasn't been rendered yet, we
          // won't update its child set by applying minimal side-effects. Instead,
          // we will add them all to the child before it gets rendered. That means
          // we can optimize this reconciliation pass by not tracking side-effects.
          workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          // If the current child is the same as the work in progress, it means that
          // we haven't yet started any work on these children. Therefore, we use
          // the clone algorithm to create a copy of all the current children.
          // If we had any progressed work already, that is invalid at this point so
          // let's throw it out.
          workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderExpirationTime);
        }
      }
      function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderExpirationTime); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.

        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
      }
      function updateForwardRef(current, workInProgress, Component, nextProps, renderExpirationTime) {
        // TODO: current can be non-null here even if the component
        // hasn't yet mounted. This happens after the first render suspends.
        // We'll need to figure out if this is fine or can cause issues.
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent

        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
          setIsRendering(false);
        }
        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderExpirationTime);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (current === null) {
          var type = Component.type;
          if (isSimpleFunctionComponent(type) && Component.compare === null &&
          // SimpleMemoComponent codepath doesn't resolve outer props either.
          Component.defaultProps === undefined) {
            var resolvedType = type;
            {
              resolvedType = resolveFunctionForHotReloading(type);
            } // If this is a plain function component without default props,
            // and with only the default shallow comparison, we upgrade it
            // to a SimpleMemoComponent to allow fast path updates.

            workInProgress.tag = SimpleMemoComponent;
            workInProgress.type = resolvedType;
            {
              validateFunctionComponentInDev(workInProgress, type);
            }
            return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateExpirationTime, renderExpirationTime);
          }
          {
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) {
              // Inner memo component props aren't currently validated in createElement.
              // We could move it there, but we'd still need this for lazy code path.
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(type), getCurrentFiberStackInDev);
            }
          }
          var child = createFiberFromTypeAndProps(Component.type, null, nextProps, null, workInProgress.mode, renderExpirationTime);
          child.ref = workInProgress.ref;
          child.return = workInProgress;
          workInProgress.child = child;
          return child;
        }
        {
          var _type = Component.type;
          var _innerPropTypes = _type.propTypes;
          if (_innerPropTypes) {
            // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(_innerPropTypes, nextProps,
            // Resolved props
            'prop', getComponentName(_type), getCurrentFiberStackInDev);
          }
        }
        var currentChild = current.child; // This is always exactly one child

        if (updateExpirationTime < renderExpirationTime) {
          // This will be the props with resolved defaultProps,
          // unlike current.memoizedProps which will be the unresolved ones.
          var prevProps = currentChild.memoizedProps; // Default to shallow comparison

          var compare = Component.compare;
          compare = compare !== null ? compare : shallowEqual;
          if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
          }
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
      }
      function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        // TODO: current can be non-null here even if the component
        // hasn't yet mounted. This happens when the inner render suspends.
        // We'll need to figure out if this is fine or can cause issues.
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
              // We warn when you define propTypes on lazy()
              // so let's just skip over it to find memo() outer wrapper.
              // Inner props for memo are validated later.
              outerMemoType = refineResolvedLazyComponent(outerMemoType);
            }
            var outerPropTypes = outerMemoType && outerMemoType.propTypes;
            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, nextProps,
              // Resolved (SimpleMemoComponent has no defaultProps)
              'prop', getComponentName(outerMemoType), getCurrentFiberStackInDev);
            } // Inner propTypes will be validated in the function component path.
          }
        }

        if (current !== null) {
          var prevProps = current.memoizedProps;
          if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref &&
          // Prevent bailout if the implementation changed due to hot reload.
          workInProgress.type === current.type) {
            didReceiveUpdate = false;
            if (updateExpirationTime < renderExpirationTime) {
              // The pending update priority was cleared at the beginning of
              // beginWork. We're about to bail out, but there might be additional
              // updates at a lower priority. Usually, the priority level of the
              // remaining updates is accumlated during the evaluation of the
              // component (i.e. when processing the update queue). But since since
              // we're bailing out early *without* evaluating the component, we need
              // to account for it here, too. Reset to the value of the current fiber.
              // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
              // because a MemoComponent fiber does not have hooks or an update queue;
              // rather, it wraps around an inner component, which may or may not
              // contains hooks.
              // TODO: Move the reset at in beginWork out of the common path so that
              // this is no longer necessary.
              workInProgress.expirationTime = current.expirationTime;
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            }
          }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime);
      }
      function updateFragment(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateMode(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateProfiler(current, workInProgress, renderExpirationTime) {
        {
          workInProgress.effectTag |= Update;
        }
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
          // Schedule a Ref effect
          workInProgress.effectTag |= Ref;
        }
      }
      function updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        }
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
          setIsRendering(false);
        }
        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderExpirationTime);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateClassComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        } // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.

        var hasContext;
        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
          if (current !== null) {
            // A class component without an instance only mounts if it suspended
            // inside a non-concurrent tree, in an inconsistent state. We want to
            // treat it like a new mount, even though an empty version of it already
            // committed. Disconnect the alternate pointers.
            current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

            workInProgress.effectTag |= Placement;
          } // In the initial pass we might need to construct the instance.

          constructClassInstance(workInProgress, Component, nextProps);
          mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
          shouldUpdate = true;
        } else if (current === null) {
          // In a resume, we'll already have an instance we can reuse.
          shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        } else {
          shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderExpirationTime);
        }
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime);
        {
          var inst = workInProgress.stateNode;
          if (inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) {
              error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentName(workInProgress.type) || 'a component');
            }
            didWarnAboutReassigningProps = true;
          }
        }
        return nextUnitOfWork;
      }
      function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (!shouldUpdate && !didCaptureError) {
          // Context providers should defer to sCU for rendering
          if (hasContext) {
            invalidateContextProvider(workInProgress, Component, false);
          }
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var instance = workInProgress.stateNode; // Rerender

        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
          // If we captured an error, but getDerivedStateFromError is not defined,
          // unmount all the children. componentDidCatch will schedule an update to
          // re-render a fallback. This is temporary until we migrate everyone to
          // the new API.
          // TODO: Warn in a future release.
          nextChildren = null;
          {
            stopProfilerTimerIfRunning();
          }
        } else {
          {
            setIsRendering(true);
            nextChildren = instance.render();
            setIsRendering(false);
          }
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        if (current !== null && didCaptureError) {
          // If we're recovering from an error, reconcile without reusing any of
          // the existing children. Conceptually, the normal children and the children
          // that are shown on error are two different sets, so we shouldn't reuse
          // normal children even if their identities match.
          forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        } // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.

        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.

        if (hasContext) {
          invalidateContextProvider(workInProgress, Component, true);
        }
        return workInProgress.child;
      }
      function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) {
          pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        } else if (root.context) {
          // Should always be set
          pushTopLevelContextObject(workInProgress, root.context, false);
        }
        pushHostContainer(workInProgress, root.containerInfo);
      }
      function updateHostRoot(current, workInProgress, renderExpirationTime) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) {
          {
            throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderExpirationTime);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".

        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState()) {
          // If we don't have any current children this might be the first pass.
          // We always try to hydrate. If this isn't a hydration pass there won't
          // be any children to hydrate which is effectively the same thing as
          // not hydrating.
          var child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
          workInProgress.child = child;
          var node = child;
          while (node) {
            // Mark each child as hydrating. This is a fast path to know whether this
            // tree is part of a hydrating tree. This is used to determine if a child
            // node has fully mounted yet, and for scheduling event replaying.
            // Conceptually this is similar to Placement in that a new subtree is
            // inserted into the React tree here. It just happens to not need DOM
            // mutations because it already exists.
            node.effectTag = node.effectTag & ~Placement | Hydrating;
            node = node.sibling;
          }
        } else {
          // Otherwise reset hydration state in case we aborted and resumed another
          // root.
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        }
        return workInProgress.child;
      }
      function updateHostComponent(current, workInProgress, renderExpirationTime) {
        pushHostContext(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        if (prevProps !== null && shouldSetTextContent()) {
          // If we're switching from a direct text child to a normal child, or to
          // empty, we need to schedule the text content to be reset.
          workInProgress.effectTag |= ContentReset;
        }
        markRef(current, workInProgress); // Check the host config to see if the children are offscreen/hidden.

        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree()) {
          {
            markSpawnedWork(Never);
          } // Schedule this fiber to re-render at offscreen priority. Then bailout.

          workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
          return null;
        }
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateHostText(current, workInProgress) {
        // immediately after.

        return null;
      }
      function mountLazyComponent(_current, workInProgress, elementType, updateExpirationTime, renderExpirationTime) {
        if (_current !== null) {
          // A lazy component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps; // We can't start a User Timing measurement with correct label yet.
        // Cancel and resume right after we know the tag.

        cancelWorkTimer(workInProgress);
        var Component = readLazyComponentType(elementType); // Store the unwrapped component in the type.

        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        startWorkTimer(workInProgress);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch (resolvedTag) {
          case FunctionComponent:
            {
              {
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
              }
              child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case ClassComponent:
            {
              {
                workInProgress.type = Component = resolveClassForHotReloading(Component);
              }
              child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case ForwardRef:
            {
              {
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
              }
              child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case MemoComponent:
            {
              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = Component.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, resolvedProps,
                    // Resolved for outer only
                    'prop', getComponentName(Component), getCurrentFiberStackInDev);
                  }
                }
              }
              child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps),
              // The inner type can have defaults too
              updateExpirationTime, renderExpirationTime);
              return child;
            }
        }
        var hint = '';
        {
          if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
            hint = ' Did you wrap a component in React.lazy() more than once?';
          }
        } // This message intentionally doesn't mention ForwardRef or MemoComponent
        // because the fact that it's a separate type of work is an
        // implementation detail.

        {
          {
            throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
          }
        }
      }
      function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (_current !== null) {
          // An incomplete component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        } // Promote the fiber to a class and try rendering again.

        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.

        var hasContext;
        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
      }
      function mountIndeterminateComponent(_current, workInProgress, Component, renderExpirationTime) {
        if (_current !== null) {
          // An indeterminate component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var value;
        {
          if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
              error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }
          if (workInProgress.mode & StrictMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
          }
          setIsRendering(true);
          ReactCurrentOwner$1.current = workInProgress;
          value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
          setIsRendering(false);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
          {
            var _componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
              error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
              didWarnAboutModulePatternComponent[_componentName] = true;
            }
          } // Proceed under the assumption that this is a class instance

          workInProgress.tag = ClassComponent; // Throw out any hooks that were used.

          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
          // During mounting we don't know the child context yet as the instance doesn't exist.
          // We will invalidate the child context in finishClassComponent() right after rendering.

          var hasContext = false;
          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
          } else {
            hasContext = false;
          }
          workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
          initializeUpdateQueue(workInProgress);
          var getDerivedStateFromProps = Component.getDerivedStateFromProps;
          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
          }
          adoptClassInstance(workInProgress, value);
          mountClassInstance(workInProgress, Component, props, renderExpirationTime);
          return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
        } else {
          // Proceed under the assumption that this is a function component
          workInProgress.tag = FunctionComponent;
          reconcileChildren(null, workInProgress, value, renderExpirationTime);
          {
            validateFunctionComponentInDev(workInProgress, Component);
          }
          return workInProgress.child;
        }
      }
      function validateFunctionComponentInDev(workInProgress, Component) {
        {
          if (Component) {
            if (Component.childContextTypes) {
              error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
            }
          }
          if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) {
              info += '\n\nCheck the render method of `' + ownerName + '`.';
            }
            var warningKey = ownerName || workInProgress._debugID || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) {
              warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            }
            if (!didWarnAboutFunctionRefs[warningKey]) {
              didWarnAboutFunctionRefs[warningKey] = true;
              error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
            }
          }
          if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName2 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2]) {
              error('%s: Function components do not support getDerivedStateFromProps.', _componentName2);
              didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2] = true;
            }
          }
          if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName3 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName3]) {
              error('%s: Function components do not support contextType.', _componentName3);
              didWarnAboutContextTypeOnFunctionComponent[_componentName3] = true;
            }
          }
        }
      }
      var SUSPENDED_MARKER = {
        dehydrated: null,
        retryTime: NoWork
      };
      function shouldRemainOnFallback(suspenseContext, current, workInProgress) {
        // If the context is telling us that we should show a fallback, and we're not
        // already showing content, then we should show the fallback instead.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback) && (current === null || current.memoizedState !== null);
      }
      function updateSuspenseComponent(current, workInProgress, renderExpirationTime) {
        var mode = workInProgress.mode;
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.

        {
          if (shouldSuspend(workInProgress)) {
            workInProgress.effectTag |= DidCapture;
          }
        }
        var suspenseContext = suspenseStackCursor.current;
        var nextDidTimeout = false;
        var didSuspend = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
          // Something in this boundary's subtree already suspended. Switch to
          // rendering the fallback children.
          nextDidTimeout = true;
          workInProgress.effectTag &= ~DidCapture;
        } else {
          // Attempting the main content
          if (current === null || current.memoizedState !== null) {
            // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) {
              suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
          }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // This next part is a bit confusing. If the children timeout, we switch to
        // showing the fallback children in place of the "primary" children.
        // However, we don't want to delete the primary children because then their
        // state will be lost (both the React state and the host state, e.g.
        // uncontrolled form inputs). Instead we keep them mounted and hide them.
        // Both the fallback children AND the primary children are rendered at the
        // same time. Once the primary children are un-suspended, we can delete
        // the fallback children — don't need to preserve their state.
        //
        // The two sets of children are siblings in the host environment, but
        // semantically, for purposes of reconciliation, they are two separate sets.
        // So we store them using two fragment fibers.
        //
        // However, we want to avoid allocating extra fibers for every placeholder.
        // They're only necessary when the children time out, because that's the
        // only time when both sets are mounted.
        //
        // So, the extra fragment fibers are only used if the children time out.
        // Otherwise, we render the primary children directly. This requires some
        // custom reconciliation logic to preserve the state of the primary
        // children. It's essentially a very basic form of re-parenting.

        if (current === null) {
          // If we're currently hydrating, try to hydrate this boundary.
          // But only if this has a fallback.
          if (nextProps.fallback !== undefined) ; // This is the initial mount. This branch is pretty simple because there's
          // no previous state that needs to be preserved.

          if (nextDidTimeout) {
            // Mount separate fragments for primary and fallback children.
            var nextFallbackChildren = nextProps.fallback;
            var primaryChildFragment = createFiberFromFragment(null, mode, NoWork, null);
            primaryChildFragment.return = workInProgress;
            if ((workInProgress.mode & BlockingMode) === NoMode) {
              // Outside of blocking mode, we commit the effects from the
              // partially completed, timed-out tree, too.
              var progressedState = workInProgress.memoizedState;
              var progressedPrimaryChild = progressedState !== null ? workInProgress.child.child : workInProgress.child;
              primaryChildFragment.child = progressedPrimaryChild;
              var progressedChild = progressedPrimaryChild;
              while (progressedChild !== null) {
                progressedChild.return = primaryChildFragment;
                progressedChild = progressedChild.sibling;
              }
            }
            var fallbackChildFragment = createFiberFromFragment(nextFallbackChildren, mode, renderExpirationTime, null);
            fallbackChildFragment.return = workInProgress;
            primaryChildFragment.sibling = fallbackChildFragment; // Skip the primary children, and continue working on the
            // fallback children.

            workInProgress.memoizedState = SUSPENDED_MARKER;
            workInProgress.child = primaryChildFragment;
            return fallbackChildFragment;
          } else {
            // Mount the primary children without an intermediate fragment fiber.
            var nextPrimaryChildren = nextProps.children;
            workInProgress.memoizedState = null;
            return workInProgress.child = mountChildFibers(workInProgress, null, nextPrimaryChildren, renderExpirationTime);
          }
        } else {
          // This is an update. This branch is more complicated because we need to
          // ensure the state of the primary children is preserved.
          var prevState = current.memoizedState;
          if (prevState !== null) {
            // wrapped in a fragment fiber.

            var currentPrimaryChildFragment = current.child;
            var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
            if (nextDidTimeout) {
              // Still timed out. Reuse the current primary children by cloning
              // its fragment. We're going to skip over these entirely.
              var _nextFallbackChildren2 = nextProps.fallback;
              var _primaryChildFragment2 = createWorkInProgress(currentPrimaryChildFragment, currentPrimaryChildFragment.pendingProps);
              _primaryChildFragment2.return = workInProgress;
              if ((workInProgress.mode & BlockingMode) === NoMode) {
                // Outside of blocking mode, we commit the effects from the
                // partially completed, timed-out tree, too.
                var _progressedState = workInProgress.memoizedState;
                var _progressedPrimaryChild = _progressedState !== null ? workInProgress.child.child : workInProgress.child;
                if (_progressedPrimaryChild !== currentPrimaryChildFragment.child) {
                  _primaryChildFragment2.child = _progressedPrimaryChild;
                  var _progressedChild2 = _progressedPrimaryChild;
                  while (_progressedChild2 !== null) {
                    _progressedChild2.return = _primaryChildFragment2;
                    _progressedChild2 = _progressedChild2.sibling;
                  }
                }
              } // Because primaryChildFragment is a new fiber that we're inserting as the
              // parent of a new tree, we need to set its treeBaseDuration.

              if (workInProgress.mode & ProfileMode) {
                // treeBaseDuration is the sum of all the child tree base durations.
                var _treeBaseDuration = 0;
                var _hiddenChild = _primaryChildFragment2.child;
                while (_hiddenChild !== null) {
                  _treeBaseDuration += _hiddenChild.treeBaseDuration;
                  _hiddenChild = _hiddenChild.sibling;
                }
                _primaryChildFragment2.treeBaseDuration = _treeBaseDuration;
              } // Clone the fallback child fragment, too. These we'll continue
              // working on.

              var _fallbackChildFragment2 = createWorkInProgress(currentFallbackChildFragment, _nextFallbackChildren2);
              _fallbackChildFragment2.return = workInProgress;
              _primaryChildFragment2.sibling = _fallbackChildFragment2;
              _primaryChildFragment2.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
              // fallback children.

              workInProgress.memoizedState = SUSPENDED_MARKER;
              workInProgress.child = _primaryChildFragment2;
              return _fallbackChildFragment2;
            } else {
              // No longer suspended. Switch back to showing the primary children,
              // and remove the intermediate fragment fiber.
              var _nextPrimaryChildren = nextProps.children;
              var currentPrimaryChild = currentPrimaryChildFragment.child;
              var primaryChild = reconcileChildFibers(workInProgress, currentPrimaryChild, _nextPrimaryChildren, renderExpirationTime); // If this render doesn't suspend, we need to delete the fallback
              // children. Wait until the complete phase, after we've confirmed the
              // fallback is no longer needed.
              // TODO: Would it be better to store the fallback fragment on
              // the stateNode?
              // Continue rendering the children, like we normally do.

              workInProgress.memoizedState = null;
              return workInProgress.child = primaryChild;
            }
          } else {
            // The current tree has not already timed out. That means the primary
            // children are not wrapped in a fragment fiber.
            var _currentPrimaryChild = current.child;
            if (nextDidTimeout) {
              // Timed out. Wrap the children in a fragment fiber to keep them
              // separate from the fallback children.
              var _nextFallbackChildren3 = nextProps.fallback;
              var _primaryChildFragment3 = createFiberFromFragment(
              // It shouldn't matter what the pending props are because we aren't
              // going to render this fragment.
              null, mode, NoWork, null);
              _primaryChildFragment3.return = workInProgress;
              _primaryChildFragment3.child = _currentPrimaryChild;
              if (_currentPrimaryChild !== null) {
                _currentPrimaryChild.return = _primaryChildFragment3;
              } // Even though we're creating a new fiber, there are no new children,
              // because we're reusing an already mounted tree. So we don't need to
              // schedule a placement.
              // primaryChildFragment.effectTag |= Placement;

              if ((workInProgress.mode & BlockingMode) === NoMode) {
                // Outside of blocking mode, we commit the effects from the
                // partially completed, timed-out tree, too.
                var _progressedState2 = workInProgress.memoizedState;
                var _progressedPrimaryChild2 = _progressedState2 !== null ? workInProgress.child.child : workInProgress.child;
                _primaryChildFragment3.child = _progressedPrimaryChild2;
                var _progressedChild3 = _progressedPrimaryChild2;
                while (_progressedChild3 !== null) {
                  _progressedChild3.return = _primaryChildFragment3;
                  _progressedChild3 = _progressedChild3.sibling;
                }
              } // Because primaryChildFragment is a new fiber that we're inserting as the
              // parent of a new tree, we need to set its treeBaseDuration.

              if (workInProgress.mode & ProfileMode) {
                // treeBaseDuration is the sum of all the child tree base durations.
                var _treeBaseDuration2 = 0;
                var _hiddenChild2 = _primaryChildFragment3.child;
                while (_hiddenChild2 !== null) {
                  _treeBaseDuration2 += _hiddenChild2.treeBaseDuration;
                  _hiddenChild2 = _hiddenChild2.sibling;
                }
                _primaryChildFragment3.treeBaseDuration = _treeBaseDuration2;
              } // Create a fragment from the fallback children, too.

              var _fallbackChildFragment3 = createFiberFromFragment(_nextFallbackChildren3, mode, renderExpirationTime, null);
              _fallbackChildFragment3.return = workInProgress;
              _primaryChildFragment3.sibling = _fallbackChildFragment3;
              _fallbackChildFragment3.effectTag |= Placement;
              _primaryChildFragment3.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
              // fallback children.

              workInProgress.memoizedState = SUSPENDED_MARKER;
              workInProgress.child = _primaryChildFragment3;
              return _fallbackChildFragment3;
            } else {
              // Still haven't timed out. Continue rendering the children, like we
              // normally do.
              workInProgress.memoizedState = null;
              var _nextPrimaryChildren2 = nextProps.children;
              return workInProgress.child = reconcileChildFibers(workInProgress, _currentPrimaryChild, _nextPrimaryChildren2, renderExpirationTime);
            }
          }
        }
      }
      function scheduleWorkOnFiber(fiber, renderExpirationTime) {
        if (fiber.expirationTime < renderExpirationTime) {
          fiber.expirationTime = renderExpirationTime;
        }
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < renderExpirationTime) {
          alternate.expirationTime = renderExpirationTime;
        }
        scheduleWorkOnParentPath(fiber.return, renderExpirationTime);
      }
      function propagateSuspenseContextChange(workInProgress, firstChild, renderExpirationTime) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;
            if (state !== null) {
              scheduleWorkOnFiber(node, renderExpirationTime);
            }
          } else if (node.tag === SuspenseListComponent) {
            // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderExpirationTime);
          } else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === workInProgress) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === workInProgress) {
              return;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while (row !== null) {
          var currentRow = row.alternate; // New rows can't be content rows.

          if (currentRow !== null && findFirstSuspended(currentRow) === null) {
            lastContentRow = row;
          }
          row = row.sibling;
        }
        return lastContentRow;
      }
      function validateRevealOrder(revealOrder) {
        {
          if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') {
              switch (revealOrder.toLowerCase()) {
                case 'together':
                case 'forwards':
                case 'backwards':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                case 'forward':
                case 'backward':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                default:
                  error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
                  break;
              }
            } else {
              error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
            }
          }
        }
      }
      function validateTailOptions(tailMode, revealOrder) {
        {
          if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
              didWarnAboutTailOptions[tailMode] = true;
              error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
              didWarnAboutTailOptions[tailMode] = true;
              error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
            }
          }
        }
      }
      function validateSuspenseListNestedChild(childSlot, index) {
        {
          var isArray = Array.isArray(childSlot);
          var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';
          if (isArray || isIterable) {
            var type = isArray ? 'array' : 'iterable';
            error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);
            return false;
          }
        }
        return true;
      }
      function validateSuspenseListChildren(children, revealOrder) {
        {
          if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) {
              for (var i = 0; i < children.length; i++) {
                if (!validateSuspenseListNestedChild(children[i], i)) {
                  return;
                }
              }
            } else {
              var iteratorFn = getIteratorFn(children);
              if (typeof iteratorFn === 'function') {
                var childrenIterator = iteratorFn.call(children);
                if (childrenIterator) {
                  var step = childrenIterator.next();
                  var _i = 0;
                  for (; !step.done; step = childrenIterator.next()) {
                    if (!validateSuspenseListNestedChild(step.value, _i)) {
                      return;
                    }
                    _i++;
                  }
                }
              } else {
                error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
              }
            }
          }
        }
      }
      function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) {
          workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailExpiration: 0,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
          };
        } else {
          // We can reuse the existing object from previous renders.
          renderState.isBackwards = isBackwards;
          renderState.rendering = null;
          renderState.renderingStartTime = 0;
          renderState.last = lastContentRow;
          renderState.tail = tail;
          renderState.tailExpiration = 0;
          renderState.tailMode = tailMode;
          renderState.lastEffect = lastEffectBeforeRendering;
        }
      } // This can end up rendering this component multiple passes.
      // The first pass splits the children fibers into two sets. A head and tail.
      // We first render the head. If anything is in fallback state, we do another
      // pass through beginWork to rerender all children (including the tail) with
      // the force suspend context. If the first render didn't have anything in
      // in fallback state. Then we render each row in the tail one-by-one.
      // That happens in the completeWork phase without going back to beginWork.

      function updateSuspenseListComponent(current, workInProgress, renderExpirationTime) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
          suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          workInProgress.effectTag |= DidCapture;
        } else {
          var didSuspendBefore = current !== null && (current.effectTag & DidCapture) !== NoEffect;
          if (didSuspendBefore) {
            // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderExpirationTime);
          }
          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) {
          // Outside of blocking mode, SuspenseList doesn't work so we just
          // use make it a noop by treating it as the default revealOrder.
          workInProgress.memoizedState = null;
        } else {
          switch (revealOrder) {
            case 'forwards':
              {
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                  // The whole list is part of the tail.
                  // TODO: We could fast path by just rendering the tail now.
                  tail = workInProgress.child;
                  workInProgress.child = null;
                } else {
                  // Disconnect the tail rows after the content row.
                  // We're going to render them separately later.
                  tail = lastContentRow.sibling;
                  lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false,
                // isBackwards
                tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
              }
            case 'backwards':
              {
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while (row !== null) {
                  var currentRow = row.alternate; // New rows can't be content rows.

                  if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    // This is the beginning of the main content.
                    workInProgress.child = row;
                    break;
                  }
                  var nextRow = row.sibling;
                  row.sibling = _tail;
                  _tail = row;
                  row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.

                initSuspenseListRenderState(workInProgress, true,
                // isBackwards
                _tail, null,
                // last
                tailMode, workInProgress.lastEffect);
                break;
              }
            case 'together':
              {
                initSuspenseListRenderState(workInProgress, false,
                // isBackwards
                null,
                // tail
                null,
                // last
                undefined, workInProgress.lastEffect);
                break;
              }
            default:
              {
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
              }
          }
        }
        return workInProgress.child;
      }
      function updatePortalComponent(current, workInProgress, renderExpirationTime) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) {
          // Portals are special because we don't append the children during mount
          // but at commit. Therefore we need to track insertions which the normal
          // flow doesn't do during mount. This doesn't happen at the root because
          // the root always starts with a "current" with a null child.
          // TODO: Consider unifying this with how the root works.
          workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        }
        return workInProgress.child;
      }
      function updateContextProvider(current, workInProgress, renderExpirationTime) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        {
          var providerPropTypes = workInProgress.type.propTypes;
          if (providerPropTypes) {
            checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider', getCurrentFiberStackInDev);
          }
        }
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
          var oldValue = oldProps.value;
          var changedBits = calculateChangedBits(context, newValue, oldValue);
          if (changedBits === 0) {
            // No change. Bailout early if children are the same.
            if (oldProps.children === newProps.children && !hasContextChanged()) {
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            }
          } else {
            // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
          }
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
      }
      var hasWarnedAboutUsingContextAsConsumer = false;
      function updateContextConsumer(current, workInProgress, renderExpirationTime) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        // DEV mode, we create a separate object for Context.Consumer that acts
        // like a proxy to Context. This proxy object adds unnecessary code in PROD
        // so we use the old behaviour (Context.Consumer references Context) to
        // reduce size and overhead. The separate object references context via
        // a property called "_context", which also gives us the ability to check
        // in DEV mode if this property exists or not and warn if it does not.

        {
          if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
              }
            }
          } else {
            context = context._context;
          }
        }
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        {
          if (typeof render !== 'function') {
            error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
          }
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var newValue = _readContext(context, newProps.unstable_observedBits);
        var newChildren;
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          newChildren = render(newValue);
          setIsRendering(false);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
      }
      function bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime) {
        cancelWorkTimer(workInProgress);
        if (current !== null) {
          // Reuse previous dependencies
          workInProgress.dependencies = current.dependencies;
        }
        {
          // Don't update "base" render times for bailouts.
          stopProfilerTimerIfRunning();
        }
        var updateExpirationTime = workInProgress.expirationTime;
        if (updateExpirationTime !== NoWork) {
          markUnprocessedUpdateTime(updateExpirationTime);
        } // Check if the children have any pending work.

        var childExpirationTime = workInProgress.childExpirationTime;
        if (childExpirationTime < renderExpirationTime) {
          // The children don't have any work either. We can skip them.
          // TODO: Once we add back resuming, we should check if the children are
          // a work-in-progress set. If so, we need to transfer their effects.
          return null;
        } else {
          // This fiber doesn't have work, but its subtree does. Clone the child
          // fibers and continue.
          cloneChildFibers(current, workInProgress);
          return workInProgress.child;
        }
      }
      function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        {
          var returnFiber = oldWorkInProgress.return;
          if (returnFiber === null) {
            throw new Error('Cannot swap the root fiber.');
          } // Disconnect from the old current.
          // It will get deleted.

          current.alternate = null;
          oldWorkInProgress.alternate = null; // Connect to the new tree.

          newWorkInProgress.index = oldWorkInProgress.index;
          newWorkInProgress.sibling = oldWorkInProgress.sibling;
          newWorkInProgress.return = oldWorkInProgress.return;
          newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.

          if (oldWorkInProgress === returnFiber.child) {
            returnFiber.child = newWorkInProgress;
          } else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) {
              throw new Error('Expected parent to have a child.');
            }
            while (prevSibling.sibling !== oldWorkInProgress) {
              prevSibling = prevSibling.sibling;
              if (prevSibling === null) {
                throw new Error('Expected to find the previous sibling.');
              }
            }
            prevSibling.sibling = newWorkInProgress;
          } // Delete the old fiber and place the new one.
          // Since the old fiber is disconnected, we have to schedule it manually.

          var last = returnFiber.lastEffect;
          if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = current;
          }
          current.nextEffect = null;
          current.effectTag = Deletion;
          newWorkInProgress.effectTag |= Placement; // Restart work from the new fiber.

          return newWorkInProgress;
        }
      }
      function beginWork(current, workInProgress, renderExpirationTime) {
        var updateExpirationTime = workInProgress.expirationTime;
        {
          if (workInProgress._debugNeedsRemount && current !== null) {
            // This will restart the begin phase with a new fiber.
            return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.expirationTime));
          }
        }
        if (current !== null) {
          var oldProps = current.memoizedProps;
          var newProps = workInProgress.pendingProps;
          if (oldProps !== newProps || hasContextChanged() ||
          // Force a re-render if the implementation changed due to hot reload:
          workInProgress.type !== current.type) {
            // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
          } else if (updateExpirationTime < renderExpirationTime) {
            didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
            // the begin phase. There's still some bookkeeping we that needs to be done
            // in this optimized path, mostly pushing stuff onto the stack.

            switch (workInProgress.tag) {
              case HostRoot:
                pushHostRootContext(workInProgress);
                break;
              case HostComponent:
                pushHostContext(workInProgress);
                if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(workInProgress.type)) {
                  {
                    markSpawnedWork(Never);
                  } // Schedule this fiber to re-render at offscreen priority. Then bailout.

                  workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
                  return null;
                }
                break;
              case ClassComponent:
                {
                  var Component = workInProgress.type;
                  if (isContextProvider(Component)) {
                    pushContextProvider(workInProgress);
                  }
                  break;
                }
              case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
              case ContextProvider:
                {
                  var newValue = workInProgress.memoizedProps.value;
                  pushProvider(workInProgress, newValue);
                  break;
                }
              case Profiler:
                {
                  // Profiler should only call onRender when one of its descendants actually rendered.
                  var hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                  if (hasChildWork) {
                    workInProgress.effectTag |= Update;
                  }
                }
                break;
              case SuspenseComponent:
                {
                  var state = workInProgress.memoizedState;
                  if (state !== null) {
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.

                    var primaryChildFragment = workInProgress.child;
                    var primaryChildExpirationTime = primaryChildFragment.childExpirationTime;
                    if (primaryChildExpirationTime !== NoWork && primaryChildExpirationTime >= renderExpirationTime) {
                      // The primary children have pending work. Use the normal path
                      // to attempt to render the primary children again.
                      return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
                    } else {
                      pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                      // priority. Bailout.

                      var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
                      if (child !== null) {
                        // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                      } else {
                        return null;
                      }
                    }
                  } else {
                    pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  }
                  break;
                }
              case SuspenseListComponent:
                {
                  var didSuspendBefore = (current.effectTag & DidCapture) !== NoEffect;
                  var _hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                  if (didSuspendBefore) {
                    if (_hasChildWork) {
                      // If something was in fallback state last time, and we have all the
                      // same children then we're still in progressive loading state.
                      // Something might get unblocked by state updates or retries in the
                      // tree which will affect the tail. So we need to use the normal
                      // path to compute the correct tail.
                      return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
                    } // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.

                    workInProgress.effectTag |= DidCapture;
                  } // If nothing suspended before and we're rendering the same children,
                  // then the tail doesn't matter. Anything new that suspends will work
                  // in the "together" mode, so we can continue from the state we had.

                  var renderState = workInProgress.memoizedState;
                  if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                  }
                  pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                  if (_hasChildWork) {
                    break;
                  } else {
                    // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    return null;
                  }
                }
            }
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
          } else {
            // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
          }
        } else {
          didReceiveUpdate = false;
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.

        workInProgress.expirationTime = NoWork;
        switch (workInProgress.tag) {
          case IndeterminateComponent:
            {
              return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderExpirationTime);
            }
          case LazyComponent:
            {
              var elementType = workInProgress.elementType;
              return mountLazyComponent(current, workInProgress, elementType, updateExpirationTime, renderExpirationTime);
            }
          case FunctionComponent:
            {
              var _Component = workInProgress.type;
              var unresolvedProps = workInProgress.pendingProps;
              var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
              return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderExpirationTime);
            }
          case ClassComponent:
            {
              var _Component2 = workInProgress.type;
              var _unresolvedProps = workInProgress.pendingProps;
              var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
              return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderExpirationTime);
            }
          case HostRoot:
            return updateHostRoot(current, workInProgress, renderExpirationTime);
          case HostComponent:
            return updateHostComponent(current, workInProgress, renderExpirationTime);
          case HostText:
            return updateHostText();
          case SuspenseComponent:
            return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
          case HostPortal:
            return updatePortalComponent(current, workInProgress, renderExpirationTime);
          case ForwardRef:
            {
              var type = workInProgress.type;
              var _unresolvedProps2 = workInProgress.pendingProps;
              var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
              return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderExpirationTime);
            }
          case Fragment$$1:
            return updateFragment(current, workInProgress, renderExpirationTime);
          case Mode:
            return updateMode(current, workInProgress, renderExpirationTime);
          case Profiler:
            return updateProfiler(current, workInProgress, renderExpirationTime);
          case ContextProvider:
            return updateContextProvider(current, workInProgress, renderExpirationTime);
          case ContextConsumer:
            return updateContextConsumer(current, workInProgress, renderExpirationTime);
          case MemoComponent:
            {
              var _type2 = workInProgress.type;
              var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.

              var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = _type2.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, _resolvedProps3,
                    // Resolved for outer only
                    'prop', getComponentName(_type2), getCurrentFiberStackInDev);
                  }
                }
              }
              _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
              return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateExpirationTime, renderExpirationTime);
            }
          case SimpleMemoComponent:
            {
              return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateExpirationTime, renderExpirationTime);
            }
          case IncompleteClassComponent:
            {
              var _Component3 = workInProgress.type;
              var _unresolvedProps4 = workInProgress.pendingProps;
              var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
              return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderExpirationTime);
            }
          case SuspenseListComponent:
            {
              return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
            }
        }
        {
          {
            throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.effectTag |= Update;
      }
      function markRef$1(workInProgress) {
        workInProgress.effectTag |= Ref;
      }
      var appendAllChildren;
      var updateHostContainer;
      var updateHostComponent$1;
      var updateHostText$1;
      {
        // Mutation mode
        appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
          // We only have the top Fiber that was created but we need recurse down its
          // children to find all the terminal nodes.
          var node = workInProgress.child;
          while (node !== null) {
            if (node.tag === HostComponent || node.tag === HostText) {
              appendInitialChild(parent, node.stateNode);
            } else if (node.tag === HostPortal) ;else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === workInProgress) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        };
        updateHostContainer = function updateHostContainer(workInProgress) {// Noop
        };
        updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance) {
          // If we have an alternate, that means this is an update and we need to
          // schedule a side-effect to do the updates.
          var oldProps = current.memoizedProps;
          if (oldProps === newProps) {
            // In mutation mode, this is sufficient for a bailout because
            // we won't touch this node even if children changed.
            return;
          } // If we get updated because one of our children updated, we don't
          // have newProps so we'll have to reuse them.
          // TODO: Split the update API as separate for the props vs. children.
          // Even better would be if children weren't special cased at all tho.

          var instance = workInProgress.stateNode;
          var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
          // component is hitting the resume path. Figure out why. Possibly
          // related to `hidden`.

          var updatePayload = prepareUpdate(); // TODO: Type this specific to this type of component.

          workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
          // is a new ref we mark this as an update. All the work is done in commitWork.

          if (updatePayload) {
            markUpdate(workInProgress);
          }
        };
        updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
          // If the text differs, mark it as an update. All the work in done in commitWork.
          if (oldText !== newText) {
            markUpdate(workInProgress);
          }
        };
      }
      function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        switch (renderState.tailMode) {
          case 'hidden':
            {
              // Any insertions at the end of the tail list after this point
              // should be invisible. If there are already mounted boundaries
              // anything before them are not considered for collapsing.
              // Therefore we need to go through the whole tail to find if
              // there are any.
              var tailNode = renderState.tail;
              var lastTailNode = null;
              while (tailNode !== null) {
                if (tailNode.alternate !== null) {
                  lastTailNode = tailNode;
                }
                tailNode = tailNode.sibling;
              } // Next we're simply going to delete all insertions after the
              // last rendered item.

              if (lastTailNode === null) {
                // All remaining items in the tail are insertions.
                renderState.tail = null;
              } else {
                // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
              }
              break;
            }
          case 'collapsed':
            {
              // Any insertions at the end of the tail list after this point
              // should be invisible. If there are already mounted boundaries
              // anything before them are not considered for collapsing.
              // Therefore we need to go through the whole tail to find if
              // there are any.
              var _tailNode = renderState.tail;
              var _lastTailNode = null;
              while (_tailNode !== null) {
                if (_tailNode.alternate !== null) {
                  _lastTailNode = _tailNode;
                }
                _tailNode = _tailNode.sibling;
              } // Next we're simply going to delete all insertions after the
              // last rendered item.

              if (_lastTailNode === null) {
                // All remaining items in the tail are insertions.
                if (!hasRenderedATailFallback && renderState.tail !== null) {
                  // We suspended during the head. We want to show at least one
                  // row at the tail. So we'll keep on and cut off the rest.
                  renderState.tail.sibling = null;
                } else {
                  renderState.tail = null;
                }
              } else {
                // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
              }
              break;
            }
        }
      }
      function completeWork(current, workInProgress, renderExpirationTime) {
        var newProps = workInProgress.pendingProps;
        switch (workInProgress.tag) {
          case IndeterminateComponent:
          case LazyComponent:
          case SimpleMemoComponent:
          case FunctionComponent:
          case ForwardRef:
          case Fragment$$1:
          case Mode:
          case Profiler:
          case ContextConsumer:
          case MemoComponent:
            return null;
          case ClassComponent:
            {
              var Component = workInProgress.type;
              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }
              return null;
            }
          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              var fiberRoot = workInProgress.stateNode;
              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }
              if (current === null || current.child === null) {
                // If we hydrated, pop so that we can delete any remaining children
                // that weren't hydrated.
                var wasHydrated = popHydrationState();
                if (wasHydrated) {
                  // If we hydrated, then we'll need to schedule an update for
                  // the commit side-effects on the root.
                  markUpdate(workInProgress);
                }
              }
              updateHostContainer(workInProgress);
              return null;
            }
          case HostComponent:
            {
              popHostContext(workInProgress);
              var rootContainerInstance = getRootHostContainer();
              var type = workInProgress.type;
              if (current !== null && workInProgress.stateNode != null) {
                updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                if (current.ref !== workInProgress.ref) {
                  markRef$1(workInProgress);
                }
              } else {
                if (!newProps) {
                  if (!(workInProgress.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  } // This can happen when we abort work.

                  return null;
                }
                var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                // "stack" as the parent. Then append children as we go in beginWork
                // or completeWork depending on whether we want to add them top->down or
                // bottom->up. Top->down is faster in IE11.

                var _wasHydrated = popHydrationState();
                if (_wasHydrated) {
                  // TODO: Move this and createInstance step into the beginPhase
                  // to consolidate.
                  if (prepareToHydrateHostInstance()) {
                    // If changes to the hydrated node need to be applied at the
                    // commit-phase we mark this as such.
                    markUpdate(workInProgress);
                  }
                } else {
                  var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                  appendAllChildren(instance, workInProgress, false, false); // This needs to be set before we mount Flare event listeners

                  workInProgress.stateNode = instance;
                }
                if (workInProgress.ref !== null) {
                  // If there is a ref on a host node we need to schedule a callback
                  markRef$1(workInProgress);
                }
              }
              return null;
            }
          case HostText:
            {
              var newText = newProps;
              if (current && workInProgress.stateNode != null) {
                var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                // to schedule a side-effect to do the updates.

                updateHostText$1(current, workInProgress, oldText, newText);
              } else {
                if (typeof newText !== 'string') {
                  if (!(workInProgress.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  } // This can happen when we abort work.
                }

                var _rootContainerInstance = getRootHostContainer();
                var _currentHostContext = getHostContext();
                var _wasHydrated2 = popHydrationState();
                if (_wasHydrated2) {
                  if (prepareToHydrateHostTextInstance()) {
                    markUpdate(workInProgress);
                  }
                } else {
                  workInProgress.stateNode = createTextInstance(newText);
                }
              }
              return null;
            }
          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var nextState = workInProgress.memoizedState;
              if ((workInProgress.effectTag & DidCapture) !== NoEffect) {
                // Something suspended. Re-render with the fallback children.
                workInProgress.expirationTime = renderExpirationTime; // Do not reset the effect list.

                return workInProgress;
              }
              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = false;
              if (current === null) {
                if (workInProgress.memoizedProps.fallback !== undefined) ;
              } else {
                var prevState = current.memoizedState;
                prevDidTimeout = prevState !== null;
                if (!nextDidTimeout && prevState !== null) {
                  // We just switched from the fallback to the normal children.
                  // Delete the fallback.
                  // TODO: Would it be better to store the fallback fragment on
                  // the stateNode during the begin phase?
                  var currentFallbackChild = current.child.sibling;
                  if (currentFallbackChild !== null) {
                    // Deletions go at the beginning of the return fiber's effect list
                    var first = workInProgress.firstEffect;
                    if (first !== null) {
                      workInProgress.firstEffect = currentFallbackChild;
                      currentFallbackChild.nextEffect = first;
                    } else {
                      workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChild;
                      currentFallbackChild.nextEffect = null;
                    }
                    currentFallbackChild.effectTag = Deletion;
                  }
                }
              }
              if (nextDidTimeout && !prevDidTimeout) {
                // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                if ((workInProgress.mode & BlockingMode) !== NoMode) {
                  // TODO: Move this back to throwException because this is too late
                  // if this is a large tree which is common for initial loads. We
                  // don't know if we should restart a render or not until we get
                  // this marker, and this is too late.
                  // If this render already had a ping or lower pri updates,
                  // and this is the first time we know we're going to suspend we
                  // should be able to immediately restart from within throwException.
                  var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                  if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                    // If this was in an invisible tree or a new render, then showing
                    // this boundary is ok.
                    renderDidSuspend();
                  } else {
                    // Otherwise, we're going to have to hide content so we should
                    // suspend for longer if possible.
                    renderDidSuspendDelayIfPossible();
                  }
                }
              }
              {
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) {
                  // If this boundary just timed out, schedule an effect to attach a
                  // retry listener to the promise. This flag is also used to hide the
                  // primary children. In mutation mode, we also need the flag to
                  // *unhide* children that were previously hidden, so check if this
                  // is currently timed out, too.
                  workInProgress.effectTag |= Update;
                }
              }
              return null;
            }
          case HostPortal:
            popHostContainer(workInProgress);
            updateHostContainer(workInProgress);
            return null;
          case ContextProvider:
            // Pop provider fiber
            popProvider(workInProgress);
            return null;
          case IncompleteClassComponent:
            {
              // Same as class component case. I put it down here so that the tags are
              // sequential to ensure this switch is compiled to a jump table.
              var _Component = workInProgress.type;
              if (isContextProvider(_Component)) {
                popContext(workInProgress);
              }
              return null;
            }
          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress);
              var renderState = workInProgress.memoizedState;
              if (renderState === null) {
                // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
              }
              var didSuspendAlready = (workInProgress.effectTag & DidCapture) !== NoEffect;
              var renderedTail = renderState.rendering;
              if (renderedTail === null) {
                // We just rendered the head.
                if (!didSuspendAlready) {
                  // This is the first pass. We need to figure out if anything is still
                  // suspended in the rendered set.
                  // If new content unsuspended, but there's still some content that
                  // didn't. Then we need to do a second pass that forces everything
                  // to keep showing their fallbacks.
                  // We might be suspended if something in this render pass suspended, or
                  // something in the previous committed pass suspended. Otherwise,
                  // there's no chance so we can skip the expensive call to
                  // findFirstSuspended.
                  var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.effectTag & DidCapture) === NoEffect);
                  if (!cannotBeSuspended) {
                    var row = workInProgress.child;
                    while (row !== null) {
                      var suspended = findFirstSuspended(row);
                      if (suspended !== null) {
                        didSuspendAlready = true;
                        workInProgress.effectTag |= DidCapture;
                        cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                        // part of the second pass. In that case nothing will subscribe to
                        // its thennables. Instead, we'll transfer its thennables to the
                        // SuspenseList so that it can retry if they resolve.
                        // There might be multiple of these in the list but since we're
                        // going to wait for all of them anyway, it doesn't really matter
                        // which ones gets to ping. In theory we could get clever and keep
                        // track of how many dependencies remain but it gets tricky because
                        // in the meantime, we can add/remove/change items and dependencies.
                        // We might bail out of the loop before finding any but that
                        // doesn't matter since that means that the other boundaries that
                        // we did find already has their listeners attached.

                        var newThennables = suspended.updateQueue;
                        if (newThennables !== null) {
                          workInProgress.updateQueue = newThennables;
                          workInProgress.effectTag |= Update;
                        } // Rerender the whole list, but this time, we'll force fallbacks
                        // to stay in place.
                        // Reset the effect list before doing the second pass since that's now invalid.

                        if (renderState.lastEffect === null) {
                          workInProgress.firstEffect = null;
                        }
                        workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.

                        resetChildFibers(workInProgress, renderExpirationTime); // Set up the Suspense Context to force suspense and immediately
                        // rerender the children.

                        pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                        return workInProgress.child;
                      }
                      row = row.sibling;
                    }
                  }
                } else {
                  cutOffTailIfNeeded(renderState, false);
                } // Next we're going to render the tail.
              } else {
                // Append the rendered row to the child list.
                if (!didSuspendAlready) {
                  var _suspended = findFirstSuspended(renderedTail);
                  if (_suspended !== null) {
                    workInProgress.effectTag |= DidCapture;
                    didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                    // get lost if this row ends up dropped during a second pass.

                    var _newThennables = _suspended.updateQueue;
                    if (_newThennables !== null) {
                      workInProgress.updateQueue = _newThennables;
                      workInProgress.effectTag |= Update;
                    }
                    cutOffTailIfNeeded(renderState, true); // This might have been modified.

                    if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate) {
                      // We need to delete the row we just rendered.
                      // Reset the effect list to what it was before we rendered this
                      // child. The nested children have already appended themselves.
                      var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.

                      if (lastEffect !== null) {
                        lastEffect.nextEffect = null;
                      } // We're done.

                      return null;
                    }
                  } else if (
                  // The time it took to render last row is greater than time until
                  // the expiration.
                  now() * 2 - renderState.renderingStartTime > renderState.tailExpiration && renderExpirationTime > Never) {
                    // We have now passed our CPU deadline and we'll just give up further
                    // attempts to render the main content and only render fallbacks.
                    // The assumption is that this is usually faster.
                    workInProgress.effectTag |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                    // to get it started back up to attempt the next item. If we can show
                    // them, then they really have the same priority as this render.
                    // So we'll pick it back up the very next render pass once we've had
                    // an opportunity to yield for paint.

                    var nextPriority = renderExpirationTime - 1;
                    workInProgress.expirationTime = workInProgress.childExpirationTime = nextPriority;
                    {
                      markSpawnedWork(nextPriority);
                    }
                  }
                }
                if (renderState.isBackwards) {
                  // The effect list of the backwards tail will have been added
                  // to the end. This breaks the guarantee that life-cycles fire in
                  // sibling order but that isn't a strong guarantee promised by React.
                  // Especially since these might also just pop in during future commits.
                  // Append to the beginning of the list.
                  renderedTail.sibling = workInProgress.child;
                  workInProgress.child = renderedTail;
                } else {
                  var previousSibling = renderState.last;
                  if (previousSibling !== null) {
                    previousSibling.sibling = renderedTail;
                  } else {
                    workInProgress.child = renderedTail;
                  }
                  renderState.last = renderedTail;
                }
              }
              if (renderState.tail !== null) {
                // We still have tail rows to render.
                if (renderState.tailExpiration === 0) {
                  // Heuristic for how long we're willing to spend rendering rows
                  // until we just give up and show what we have so far.
                  var TAIL_EXPIRATION_TIMEOUT_MS = 500;
                  renderState.tailExpiration = now() + TAIL_EXPIRATION_TIMEOUT_MS; // TODO: This is meant to mimic the train model or JND but this
                  // is a per component value. It should really be since the start
                  // of the total render or last commit. Consider using something like
                  // globalMostRecentFallbackTime. That doesn't account for being
                  // suspended for part of the time or when it's a new render.
                  // It should probably use a global start time value instead.
                } // Pop a row.

                var next = renderState.tail;
                renderState.rendering = next;
                renderState.tail = next.sibling;
                renderState.lastEffect = workInProgress.lastEffect;
                renderState.renderingStartTime = now();
                next.sibling = null; // Restore the context.
                // TODO: We can probably just avoid popping it instead and only
                // setting it the first time we go from not suspended to suspended.

                var suspenseContext = suspenseStackCursor.current;
                if (didSuspendAlready) {
                  suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                } else {
                  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                }
                pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.

                return next;
              }
              return null;
            }
        }
        {
          {
            throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function unwindWork(workInProgress, renderExpirationTime) {
        switch (workInProgress.tag) {
          case ClassComponent:
            {
              var Component = workInProgress.type;
              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }
              var effectTag = workInProgress.effectTag;
              if (effectTag & ShouldCapture) {
                workInProgress.effectTag = effectTag & ~ShouldCapture | DidCapture;
                return workInProgress;
              }
              return null;
            }
          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              var _effectTag = workInProgress.effectTag;
              if (!((_effectTag & DidCapture) === NoEffect)) {
                {
                  throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                }
              }
              workInProgress.effectTag = _effectTag & ~ShouldCapture | DidCapture;
              return workInProgress;
            }
          case HostComponent:
            {
              // TODO: popHydrationState
              popHostContext(workInProgress);
              return null;
            }
          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var _effectTag2 = workInProgress.effectTag;
              if (_effectTag2 & ShouldCapture) {
                workInProgress.effectTag = _effectTag2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.

                return workInProgress;
              }
              return null;
            }
          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
              // caught by a nested boundary. If not, it should bubble through.

              return null;
            }
          case HostPortal:
            popHostContainer(workInProgress);
            return null;
          case ContextProvider:
            popProvider(workInProgress);
            return null;
          default:
            return null;
        }
      }
      function unwindInterruptedWork(interruptedWork) {
        switch (interruptedWork.tag) {
          case ClassComponent:
            {
              var childContextTypes = interruptedWork.type.childContextTypes;
              if (childContextTypes !== null && childContextTypes !== undefined) {
                popContext(interruptedWork);
              }
              break;
            }
          case HostRoot:
            {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              break;
            }
          case HostComponent:
            {
              popHostContext(interruptedWork);
              break;
            }
          case HostPortal:
            popHostContainer(interruptedWork);
            break;
          case SuspenseComponent:
            popSuspenseContext(interruptedWork);
            break;
          case SuspenseListComponent:
            popSuspenseContext(interruptedWork);
            break;
          case ContextProvider:
            popProvider(interruptedWork);
            break;
        }
      }
      function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
          value: value,
          source: source,
          stack: getStackByFiberInDevAndProd(source)
        };
      }
      var invokeGuardedCallbackImpl = function invokeGuardedCallbackImpl(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
          func.apply(context, funcArgs);
        } catch (error) {
          this.onError(error);
        }
      };
      {
        // In DEV mode, we swap out invokeGuardedCallback for a special version
        // that plays more nicely with the browser's DevTools. The idea is to preserve
        // "Pause on exceptions" behavior. Because React wraps all user-provided
        // functions in invokeGuardedCallback, and the production version of
        // invokeGuardedCallback uses a try-catch, all user exceptions are treated
        // like caught exceptions, and the DevTools won't pause unless the developer
        // takes the extra step of enabling pause on caught exceptions. This is
        // unintuitive, though, because even though React has caught the error, from
        // the developer's perspective, the error is uncaught.
        //
        // To preserve the expected "Pause on exceptions" behavior, we don't use a
        // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
        // DOM node, and call the user-provided callback from inside an event handler
        // for that fake event. If the callback throws, the error is "captured" using
        // a global event handler. But because the error happens in a different
        // event loop context, it does not interrupt the normal program flow.
        // Effectively, this gives us try-catch behavior without actually using
        // try-catch. Neat!
        // Check that the browser supports the APIs we need to implement our special
        // DEV version of invokeGuardedCallback
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
          var fakeNode = document.createElement('react');
          var invokeGuardedCallbackDev = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== 'undefined')) {
              {
                throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
              }
            }
            var evt = document.createEvent('Event'); // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.

            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.

            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688

            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event'); // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.

            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
              // We immediately remove the callback from event listeners so that
              // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
              // nested call would trigger the fake event handlers of any call higher
              // in the stack.
              fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
              // window.event assignment in both IE <= 10 as they throw an error
              // "Member not found" in strict mode, and in Firefox which does not
              // support window.event.

              if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                window.event = windowEvent;
              }
              func.apply(context, funcArgs);
              didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.

            var error; // Use this to track whether the error event is ever called.

            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
              error = event.error;
              didSetError = true;
              if (error === null && event.colno === 0 && event.lineno === 0) {
                isCrossOriginError = true;
              }
              if (event.defaultPrevented) {
                // Some other error handler has prevented default.
                // Browsers silence the error report if this happens.
                // We'll remember this to later decide whether to log it or not.
                if (error != null && typeof error === 'object') {
                  try {
                    error._suppressLogging = true;
                  } catch (inner) {// Ignore.
                  }
                }
              }
            } // Create a fake event type.

            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.

            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) {
              Object.defineProperty(window, 'event', windowEventDescriptor);
            }
            if (didError) {
              if (!didSetError) {
                // The callback errored, but the error event never fired.
                error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
              } else if (isCrossOriginError) {
                error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://fb.me/react-crossorigin-error for more information.');
              }
              this.onError(error);
            } // Remove our event listeners

            window.removeEventListener('error', handleWindowError);
          };
          invokeGuardedCallbackImpl = invokeGuardedCallbackDev;
        }
      }
      var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
      var hasError = false;
      var caughtError = null; // Used by event system to capture/rethrow the first error.
      var reporter = {
        onError: function onError(error) {
          hasError = true;
          caughtError = error;
        }
      };
      /**
       * Call a function while guarding against errors that happens within it.
       * Returns an error if it throws, otherwise null.
       *
       * In production, this is implemented using a try-catch. The reason we don't
       * use a try-catch directly is so that we can swap out a different
       * implementation in DEV mode.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
      }
      function hasCaughtError() {
        return hasError;
      }
      function clearCaughtError() {
        if (hasError) {
          var error = caughtError;
          hasError = false;
          caughtError = null;
          return error;
        } else {
          {
            {
              throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
      }
      function logCapturedError(capturedError) {
        var error = capturedError.error;
        {
          var componentName = capturedError.componentName,
            componentStack = capturedError.componentStack,
            errorBoundaryName = capturedError.errorBoundaryName,
            errorBoundaryFound = capturedError.errorBoundaryFound,
            willRetry = capturedError.willRetry; // Browsers support silencing uncaught errors by calling
          // `preventDefault()` in window `error` handler.
          // We record this information as an expando on the error.

          if (error != null && error._suppressLogging) {
            if (errorBoundaryFound && willRetry) {
              // The error is recoverable and was silenced.
              // Ignore it and don't print the stack addendum.
              // This is handy for testing error boundaries without noise.
              return;
            } // The error is fatal. Since the silencing might have
            // been accidental, we'll surface it anyway.
            // However, the browser would have silenced the original error
            // so we'll print it first, and then print the stack addendum.

            console['error'](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
          }

          var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
          var errorBoundaryMessage; // errorBoundaryFound check is sufficient; errorBoundaryName check is to satisfy Flow.

          if (errorBoundaryFound && errorBoundaryName) {
            if (willRetry) {
              errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            } else {
              errorBoundaryMessage = "This error was initially handled by the error boundary " + errorBoundaryName + ".\n" + "Recreating the tree from scratch failed so React will unmount the tree.";
            }
          } else {
            errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://fb.me/react-error-boundaries to learn more about error boundaries.';
          }
          var combinedMessage = "" + componentNameMessage + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
          // We don't include the original error message and JS stack because the browser
          // has already printed it. Even if the application swallows the error, it is still
          // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

          console['error'](combinedMessage); // Don't transform to our wrapper
        }
      }

      var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
      {
        didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
      }
      var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
      function logError(boundary, errorInfo) {
        var source = errorInfo.source;
        var stack = errorInfo.stack;
        if (stack === null && source !== null) {
          stack = getStackByFiberInDevAndProd(source);
        }
        var capturedError = {
          componentName: source !== null ? getComponentName(source.type) : null,
          componentStack: stack !== null ? stack : '',
          error: errorInfo.value,
          errorBoundary: null,
          errorBoundaryName: null,
          errorBoundaryFound: false,
          willRetry: false
        };
        if (boundary !== null && boundary.tag === ClassComponent) {
          capturedError.errorBoundary = boundary.stateNode;
          capturedError.errorBoundaryName = getComponentName(boundary.type);
          capturedError.errorBoundaryFound = true;
          capturedError.willRetry = true;
        }
        try {
          logCapturedError(capturedError);
        } catch (e) {
          // This method must not throw, or React internal state will get messed up.
          // If console.error is overridden, or logCapturedError() shows a dialog that throws,
          // we want to report this error outside of the normal stack as a last resort.
          // https://github.com/facebook/react/issues/13188
          setTimeout(function () {
            throw e;
          });
        }
      }
      var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current, instance) {
        startPhaseTimer(current, 'componentWillUnmount');
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
        stopPhaseTimer();
      }; // Capture errors so they don't interrupt unmounting.

      function safelyCallComponentWillUnmount(current, instance) {
        {
          invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
          if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
          }
        }
      }
      function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
          if (typeof ref === 'function') {
            {
              invokeGuardedCallback(null, ref, null, null);
              if (hasCaughtError()) {
                var refError = clearCaughtError();
                captureCommitPhaseError(current, refError);
              }
            }
          } else {
            ref.current = null;
          }
        }
      }
      function safelyCallDestroy(current, destroy) {
        {
          invokeGuardedCallback(null, destroy, null);
          if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
          }
        }
      }
      function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
          case Block:
            {
              return;
            }
          case ClassComponent:
            {
              if (finishedWork.effectTag & Snapshot) {
                if (current !== null) {
                  var prevProps = current.memoizedProps;
                  var prevState = current.memoizedState;
                  startPhaseTimer(finishedWork, 'getSnapshotBeforeUpdate');
                  var instance = finishedWork.stateNode; // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                    if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                  stopPhaseTimer();
                }
              }
              return;
            }
          case HostRoot:
          case HostComponent:
          case HostText:
          case HostPortal:
          case IncompleteClassComponent:
            // Nothing to do for these component types
            return;
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;
          do {
            if ((effect.tag & tag) === tag) {
              // Unmount
              var destroy = effect.destroy;
              effect.destroy = undefined;
              if (destroy !== undefined) {
                destroy();
              }
            }
            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }
      function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;
          do {
            if ((effect.tag & tag) === tag) {
              // Mount
              var create = effect.create;
              effect.destroy = create();
              {
                var destroy = effect.destroy;
                if (destroy !== undefined && typeof destroy !== 'function') {
                  var addendum = void 0;
                  if (destroy === null) {
                    addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
                  } else if (typeof destroy.then === 'function') {
                    addendum = '\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + 'useEffect(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://fb.me/react-hooks-data-fetching';
                  } else {
                    addendum = ' You returned: ' + destroy;
                  }
                  error('An effect function must not return anything besides a function, ' + 'which is used for clean-up.%s%s', addendum, getStackByFiberInDevAndProd(finishedWork));
                }
              }
            }
            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }
      function commitPassiveHookEffects(finishedWork) {
        if ((finishedWork.effectTag & Passive) !== NoEffect) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
              {
                // TODO (#17945) We should call all passive destroy functions (for all fibers)
                // before calling any create functions. The current approach only serializes
                // these for a single fiber.
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork);
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
              }
          }
        }
      }
      function commitLifeCycles(finishedRoot, current, finishedWork, committedExpirationTime) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
          case Block:
            {
              // At this point layout effects have already been destroyed (during mutation phase).
              // This is done to prevent sibling component effects from interfering with each other,
              // e.g. a destroy function in one component should never override a ref set
              // by a create function in another component during the same commit.
              commitHookEffectListMount(Layout | HasEffect, finishedWork);
              return;
            }
          case ClassComponent:
            {
              var instance = finishedWork.stateNode;
              if (finishedWork.effectTag & Update) {
                if (current === null) {
                  startPhaseTimer(finishedWork, 'componentDidMount'); // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  instance.componentDidMount();
                  stopPhaseTimer();
                } else {
                  var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                  var prevState = current.memoizedState;
                  startPhaseTimer(finishedWork, 'componentDidUpdate'); // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                  stopPhaseTimer();
                }
              }
              var updateQueue = finishedWork.updateQueue;
              if (updateQueue !== null) {
                {
                  if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                    if (instance.props !== finishedWork.memoizedProps) {
                      error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                    }
                    if (instance.state !== finishedWork.memoizedState) {
                      error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                    }
                  }
                } // We could update instance props and state here,
                // but instead we rely on them being set during last render.
                // TODO: revisit this when we implement resuming.

                commitUpdateQueue(finishedWork, updateQueue, instance);
              }
              return;
            }
          case HostRoot:
            {
              var _updateQueue = finishedWork.updateQueue;
              if (_updateQueue !== null) {
                var _instance = null;
                if (finishedWork.child !== null) {
                  switch (finishedWork.child.tag) {
                    case HostComponent:
                      _instance = getPublicInstance(finishedWork.child.stateNode);
                      break;
                    case ClassComponent:
                      _instance = finishedWork.child.stateNode;
                      break;
                  }
                }
                commitUpdateQueue(finishedWork, _updateQueue, _instance);
              }
              return;
            }
          case HostComponent:
            {
              var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
              // (eg DOM renderer may schedule auto-focus for inputs and form controls).
              // These effects should only be committed when components are first mounted,
              // aka when there is no current/alternate.

              if (current === null && finishedWork.effectTag & Update) {
                var type = finishedWork.type;
                var props = finishedWork.memoizedProps;
              }
              return;
            }
          case HostText:
            {
              // We have no life-cycles associated with text.
              return;
            }
          case HostPortal:
            {
              // We have no life-cycles associated with portals.
              return;
            }
          case Profiler:
            {
              {
                var onRender = finishedWork.memoizedProps.onRender;
                if (typeof onRender === 'function') {
                  {
                    onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime(), finishedRoot.memoizedInteractions);
                  }
                }
              }
              return;
            }
          case SuspenseComponent:
            {
              return;
            }
          case SuspenseListComponent:
          case IncompleteClassComponent:
          case FundamentalComponent:
          case ScopeComponent:
            return;
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function hideOrUnhideAllChildren(finishedWork, isHidden) {
        {
          // We only have the top Fiber that was inserted but we need to recurse down its
          // children to find all the terminal nodes.
          var node = finishedWork;
          while (true) {
            if (node.tag === HostComponent) {
              var instance = node.stateNode;
              if (isHidden) {
                hideInstance(instance);
              } else {
                unhideInstance(node.stateNode, node.memoizedProps);
              }
            } else if (node.tag === HostText) {
              var _instance3 = node.stateNode;
              if (isHidden) {
                hideTextInstance(_instance3);
              } else {
                unhideTextInstance(_instance3, node.memoizedProps);
              }
            } else if (node.tag === SuspenseComponent && node.memoizedState !== null && node.memoizedState.dehydrated === null) {
              // Found a nested Suspense component that timed out. Skip over the
              // primary child fragment, which should remain hidden.
              var fallbackChildFragment = node.child.sibling;
              fallbackChildFragment.return = node;
              node = fallbackChildFragment;
              continue;
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === finishedWork) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === finishedWork) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
      }
      function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
          var instance = finishedWork.stateNode;
          var instanceToUse;
          switch (finishedWork.tag) {
            case HostComponent:
              instanceToUse = getPublicInstance(instance);
              break;
            default:
              instanceToUse = instance;
          } // Moved outside to ensure DCE works with this flag

          if (typeof ref === 'function') {
            ref(instanceToUse);
          } else {
            {
              if (!ref.hasOwnProperty('current')) {
                error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().%s', getComponentName(finishedWork.type), getStackByFiberInDevAndProd(finishedWork));
              }
            }
            ref.current = instanceToUse;
          }
        }
      }
      function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
          if (typeof currentRef === 'function') {
            currentRef(null);
          } else {
            currentRef.current = null;
          }
        }
      } // User-originating errors (lifecycles and refs) should not interrupt
      // deletion, so don't let them throw. Host-originating errors should
      // interrupt deletion, so it's okay

      function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch (current.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
          case Block:
            {
              var updateQueue = current.updateQueue;
              if (updateQueue !== null) {
                var lastEffect = updateQueue.lastEffect;
                if (lastEffect !== null) {
                  var firstEffect = lastEffect.next;
                  {
                    // When the owner fiber is deleted, the destroy function of a passive
                    // effect hook is called during the synchronous commit phase. This is
                    // a concession to implementation complexity. Calling it in the
                    // passive effect phase (like they usually are, when dependencies
                    // change during an update) would require either traversing the
                    // children of the deleted fiber again, or including unmount effects
                    // as part of the fiber effect list.
                    //
                    // Because this is during the sync commit phase, we need to change
                    // the priority.
                    //
                    // TODO: Reconsider this implementation trade off.
                    var priorityLevel = renderPriorityLevel > NormalPriority ? NormalPriority : renderPriorityLevel;
                    runWithPriority(priorityLevel, function () {
                      var effect = firstEffect;
                      do {
                        var _destroy = effect.destroy;
                        if (_destroy !== undefined) {
                          safelyCallDestroy(current, _destroy);
                        }
                        effect = effect.next;
                      } while (effect !== firstEffect);
                    });
                  }
                }
              }
              return;
            }
          case ClassComponent:
            {
              safelyDetachRef(current);
              var instance = current.stateNode;
              if (typeof instance.componentWillUnmount === 'function') {
                safelyCallComponentWillUnmount(current, instance);
              }
              return;
            }
          case HostComponent:
            {
              safelyDetachRef(current);
              return;
            }
          case HostPortal:
            {
              // TODO: this is recursive.
              // We are also not using this parent because
              // the portal will get pushed immediately.
              {
                unmountHostComponents(finishedRoot, current, renderPriorityLevel);
              }
              return;
            }
          case FundamentalComponent:
            {
              return;
            }
          case DehydratedFragment:
            {
              return;
            }
          case ScopeComponent:
            {
              return;
            }
        }
      }
      function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while (true) {
          commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because they may contain more composite or host nodes.
          // Skip portals because commitUnmount() currently visits them recursively.

          if (node.child !== null &&
          // If we use mutation we drill down into portals using commitUnmount above.
          // If we don't use mutation we drill down into portals here instead.
          node.tag !== HostPortal) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === root) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === root) {
              return;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function detachFiber(current) {
        var alternate = current.alternate; // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.

        current.return = null;
        current.child = null;
        current.memoizedState = null;
        current.updateQueue = null;
        current.dependencies = null;
        current.alternate = null;
        current.firstEffect = null;
        current.lastEffect = null;
        current.pendingProps = null;
        current.memoizedProps = null;
        current.stateNode = null;
        if (alternate !== null) {
          detachFiber(alternate);
        }
      }
      function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while (parent !== null) {
          if (isHostParent(parent)) {
            return parent;
          }
          parent = parent.return;
        }
        {
          {
            throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
      }
      function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while (true) {
          // If we didn't find anything, let's try the next sibling.
          while (node.sibling === null) {
            if (node.return === null || isHostParent(node.return)) {
              // If we pop out of the root or hit the parent the fiber we are the
              // last sibling.
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
          while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
            // If it is not host node and, we might have a host node inside it.
            // Try to search down until we find one.
            if (node.effectTag & Placement) {
              // If we don't have a child, try the siblings instead.
              continue siblings;
            } // If we don't have a child, try the siblings instead.
            // We also skip portals because they are not part of this host tree.

            if (node.child === null || node.tag === HostPortal) {
              continue siblings;
            } else {
              node.child.return = node;
              node = node.child;
            }
          } // Check if this host node is stable or about to be placed.

          if (!(node.effectTag & Placement)) {
            // Found it!
            return node.stateNode;
          }
        }
      }
      function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.

        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch (parentFiber.tag) {
          case HostComponent:
            parent = parentStateNode;
            isContainer = false;
            break;
          case HostRoot:
            parent = parentStateNode.containerInfo;
            isContainer = true;
            break;
          case HostPortal:
            parent = parentStateNode.containerInfo;
            isContainer = true;
            break;
          case FundamentalComponent:

          // eslint-disable-next-line-no-fallthrough

          default:
            {
              {
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
        }
        if (parentFiber.effectTag & ContentReset) {
          parentFiber.effectTag &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.

        if (isContainer) {
          insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        } else {
          insertOrAppendPlacementNode(finishedWork, before, parent);
        }
      }
      function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
          var stateNode = isHost ? node.stateNode : node.stateNode.instance;
          if (before) {
            insertInContainerBefore(parent, stateNode, before);
          } else {
            appendChildToContainer(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;
          if (child !== null) {
            insertOrAppendPlacementNodeIntoContainer(child, before, parent);
            var sibling = child.sibling;
            while (sibling !== null) {
              insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }
      function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
          var stateNode = isHost ? node.stateNode : node.stateNode.instance;
          if (before) {
            insertBefore(parent, stateNode, before);
          } else {
            appendChild(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;
          if (child !== null) {
            insertOrAppendPlacementNode(child, before, parent);
            var sibling = child.sibling;
            while (sibling !== null) {
              insertOrAppendPlacementNode(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }
      function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.

        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.

        var currentParent;
        var currentParentIsContainer;
        while (true) {
          if (!currentParentIsValid) {
            var parent = node.return;
            findParent: while (true) {
              if (!(parent !== null)) {
                {
                  throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var parentStateNode = parent.stateNode;
              switch (parent.tag) {
                case HostComponent:
                  currentParent = parentStateNode;
                  currentParentIsContainer = false;
                  break findParent;
                case HostRoot:
                  currentParent = parentStateNode.containerInfo;
                  currentParentIsContainer = true;
                  break findParent;
                case HostPortal:
                  currentParent = parentStateNode.containerInfo;
                  currentParentIsContainer = true;
                  break findParent;
              }
              parent = parent.return;
            }
            currentParentIsValid = true;
          }
          if (node.tag === HostComponent || node.tag === HostText) {
            commitNestedUnmounts(finishedRoot, node, renderPriorityLevel); // After all the children have unmounted, it is now safe to remove the
            // node from the tree.

            if (currentParentIsContainer) {
              removeChildFromContainer(currentParent, node.stateNode);
            } else {
              removeChild(currentParent, node.stateNode);
            } // Don't visit children because we already visited them.
          } else if (node.tag === HostPortal) {
            if (node.child !== null) {
              // When we go into a portal, it becomes the parent to remove from.
              // We will reassign it back when we pop the portal on the way up.
              currentParent = node.stateNode.containerInfo;
              currentParentIsContainer = true; // Visit children because portals might contain host components.

              node.child.return = node;
              node = node.child;
              continue;
            }
          } else {
            commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because we may find more host components below.

            if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
          }
          if (node === current) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === current) {
              return;
            }
            node = node.return;
            if (node.tag === HostPortal) {
              // When we go out of the portal, we need to restore the parent.
              // Since we don't keep a stack of them, we will search for it.
              currentParentIsValid = false;
            }
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        {
          // Recursively delete all host nodes from the parent.
          // Detach refs and call componentWillUnmount() on the whole subtree.
          unmountHostComponents(finishedRoot, current, renderPriorityLevel);
        }
        detachFiber(current);
      }
      function commitWork(current, finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
          case Block:
            {
              // Layout effects are destroyed during the mutation phase so that all
              // destroy functions for all fibers are called before any create functions.
              // This prevents sibling component effects from interfering with each other,
              // e.g. a destroy function in one component should never override a ref set
              // by a create function in another component during the same commit.
              commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
              return;
            }
          case ClassComponent:
            {
              return;
            }
          case HostComponent:
            {
              var instance = finishedWork.stateNode;
              if (instance != null) {
                // Commit the work prepared earlier.
                var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.

                var oldProps = current !== null ? current.memoizedProps : newProps;
                var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

                var updatePayload = finishedWork.updateQueue;
                finishedWork.updateQueue = null;
                if (updatePayload !== null) {
                  commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
              }
              return;
            }
          case HostText:
            {
              if (!(finishedWork.stateNode !== null)) {
                {
                  throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var textInstance = finishedWork.stateNode;
              var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
              // as the newProps. The updatePayload will contain the real change in
              // this case.

              var oldText = current !== null ? current.memoizedProps : newText;
              commitTextUpdate(textInstance, oldText, newText);
              return;
            }
          case HostRoot:
            {
              return;
            }
          case Profiler:
            {
              return;
            }
          case SuspenseComponent:
            {
              commitSuspenseComponent(finishedWork);
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
          case SuspenseListComponent:
            {
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
          case IncompleteClassComponent:
            {
              return;
            }
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        var newDidTimeout;
        var primaryChildParent = finishedWork;
        if (newState === null) {
          newDidTimeout = false;
        } else {
          newDidTimeout = true;
          primaryChildParent = finishedWork.child;
          markCommitTimeOfFallback();
        }
        if (primaryChildParent !== null) {
          hideOrUnhideAllChildren(primaryChildParent, newDidTimeout);
        }
      }
      function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of thenables.
        // For each thenable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var thenables = finishedWork.updateQueue;
        if (thenables !== null) {
          finishedWork.updateQueue = null;
          var retryCache = finishedWork.stateNode;
          if (retryCache === null) {
            retryCache = finishedWork.stateNode = new PossiblyWeakSet();
          }
          thenables.forEach(function (thenable) {
            // Memoize using the boundary fiber to prevent redundant listeners.
            var retry = resolveRetryThenable.bind(null, finishedWork, thenable);
            if (!retryCache.has(thenable)) {
              {
                if (thenable.__reactDoNotTraceInteractions !== true) {
                  retry = tracing$1.unstable_wrap(retry);
                }
              }
              retryCache.add(thenable);
              thenable.then(retry, retry);
            }
          });
        }
      }
      function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
      }
      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
      function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null); // Unmount the root by rendering null.

        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".

        update.payload = {
          element: null
        };
        var error = errorInfo.value;
        update.callback = function () {
          onUncaughtError(error);
          logError(fiber, errorInfo);
        };
        return update;
      }
      function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
          var error$1 = errorInfo.value;
          update.payload = function () {
            logError(fiber, errorInfo);
            return getDerivedStateFromError(error$1);
          };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') {
          update.callback = function callback() {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            if (typeof getDerivedStateFromError !== 'function') {
              // To preserve the preexisting retry behavior of error boundaries,
              // we keep track of which ones already failed during this batch.
              // This gets reset before we yield back to the browser.
              // TODO: Warn in strict mode if getDerivedStateFromError is
              // not defined.
              markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined

              logError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
              componentStack: stack !== null ? stack : ''
            });
            {
              if (typeof getDerivedStateFromError !== 'function') {
                // If componentDidCatch is the only error boundary method defined,
                // then it needs to call setState to recover from errors.
                // If no state update is scheduled then the boundary will swallow the error.
                if (fiber.expirationTime !== Sync) {
                  error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown');
                }
              }
            }
          };
        } else {
          update.callback = function () {
            markFailedErrorBoundaryForHotReloading(fiber);
          };
        }
        return update;
      }
      function attachPingListener(root, renderExpirationTime, thenable) {
        // Attach a listener to the promise to "ping" the root and retry. But
        // only if one does not already exist for the current render expiration
        // time (which acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
          pingCache = root.pingCache = new PossiblyWeakMap();
          threadIDs = new Set();
          pingCache.set(thenable, threadIDs);
        } else {
          threadIDs = pingCache.get(thenable);
          if (threadIDs === undefined) {
            threadIDs = new Set();
            pingCache.set(thenable, threadIDs);
          }
        }
        if (!threadIDs.has(renderExpirationTime)) {
          // Memoize using the thread ID to prevent redundant listeners.
          threadIDs.add(renderExpirationTime);
          var ping = pingSuspendedRoot.bind(null, root, thenable, renderExpirationTime);
          thenable.then(ping, ping);
        }
      }
      function throwException(root, returnFiber, sourceFiber, value, renderExpirationTime) {
        // The source fiber did not complete.
        sourceFiber.effectTag |= Incomplete; // Its effect list is no longer valid.

        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
          // This is a thenable.
          var thenable = value;
          if ((sourceFiber.mode & BlockingMode) === NoMode) {
            // Reset the memoizedState to what it was before we attempted
            // to render it.
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
              sourceFiber.updateQueue = currentSource.updateQueue;
              sourceFiber.memoizedState = currentSource.memoizedState;
              sourceFiber.expirationTime = currentSource.expirationTime;
            } else {
              sourceFiber.updateQueue = null;
              sourceFiber.memoizedState = null;
            }
          }
          var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.

          var _workInProgress = returnFiber;
          do {
            if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
              // Found the nearest boundary.
              // Stash the promise on the boundary fiber. If the boundary times out, we'll
              // attach another listener to flip the boundary back to its normal state.
              var thenables = _workInProgress.updateQueue;
              if (thenables === null) {
                var updateQueue = new Set();
                updateQueue.add(thenable);
                _workInProgress.updateQueue = updateQueue;
              } else {
                thenables.add(thenable);
              } // If the boundary is outside of blocking mode, we should *not*
              // suspend the commit. Pretend as if the suspended component rendered
              // null and keep rendering. In the commit phase, we'll schedule a
              // subsequent synchronous update to re-render the Suspense.
              //
              // Note: It doesn't matter whether the component that suspended was
              // inside a blocking mode tree. If the Suspense is outside of it, we
              // should *not* suspend the commit.

              if ((_workInProgress.mode & BlockingMode) === NoMode) {
                _workInProgress.effectTag |= DidCapture; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.

                sourceFiber.effectTag &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                  var currentSourceFiber = sourceFiber.alternate;
                  if (currentSourceFiber === null) {
                    // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                  } else {
                    // When we try rendering again, we should not reuse the current fiber,
                    // since it's known to be in an inconsistent state. Use a force update to
                    // prevent a bail out.
                    var update = createUpdate(Sync, null);
                    update.tag = ForceUpdate;
                    enqueueUpdate(sourceFiber, update);
                  }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.

                sourceFiber.expirationTime = Sync; // Exit without suspending.

                return;
              } // Confirmed that the boundary is in a concurrent mode tree. Continue
              // with the normal suspend path.
              //
              // After this we'll use a set of heuristics to determine whether this
              // render pass will run to completion or restart or "suspend" the commit.
              // The actual logic for this is spread out in different places.
              //
              // This first principle is that if we're going to suspend when we complete
              // a root, then we should also restart if we get an update or ping that
              // might unsuspend it, and vice versa. The only reason to suspend is
              // because you think you might want to restart before committing. However,
              // it doesn't make sense to restart only while in the period we're suspended.
              //
              // Restarting too aggressively is also not good because it starves out any
              // intermediate loading state. So we use heuristics to determine when.
              // Suspense Heuristics
              //
              // If nothing threw a Promise or all the same fallbacks are already showing,
              // then don't suspend/restart.
              //
              // If this is an initial render of a new tree of Suspense boundaries and
              // those trigger a fallback, then don't suspend/restart. We want to ensure
              // that we can show the initial loading state as quickly as possible.
              //
              // If we hit a "Delayed" case, such as when we'd switch from content back into
              // a fallback, then we should always suspend/restart. SuspenseConfig applies to
              // this case. If none is defined, JND is used instead.
              //
              // If we're already showing a fallback and it gets "retried", allowing us to show
              // another level, but there's still an inner boundary that would show a fallback,
              // then we suspend/restart for 500ms since the last time we showed a fallback
              // anywhere in the tree. This effectively throttles progressive loading into a
              // consistent train of commits. This also gives us an opportunity to restart to
              // get to the completed state slightly earlier.
              //
              // If there's ambiguity due to batching it's resolved in preference of:
              // 1) "delayed", 2) "initial render", 3) "retry".
              //
              // We want to ensure that a "busy" state doesn't get force committed. We want to
              // ensure that new initial loading states can commit as soon as possible.

              attachPingListener(root, renderExpirationTime, thenable);
              _workInProgress.effectTag |= ShouldCapture;
              _workInProgress.expirationTime = renderExpirationTime;
              return;
            } // This boundary already captured during this render. Continue to the next
            // boundary.

            _workInProgress = _workInProgress.return;
          } while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
          // TODO: Use invariant so the message is stripped in prod?

          value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.' + getStackByFiberInDevAndProd(sourceFiber));
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.

        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
          switch (workInProgress.tag) {
            case HostRoot:
              {
                var _errorInfo = value;
                workInProgress.effectTag |= ShouldCapture;
                workInProgress.expirationTime = renderExpirationTime;
                var _update = createRootErrorUpdate(workInProgress, _errorInfo, renderExpirationTime);
                enqueueCapturedUpdate(workInProgress, _update);
                return;
              }
            case ClassComponent:
              // Capture and retry
              var errorInfo = value;
              var ctor = workInProgress.type;
              var instance = workInProgress.stateNode;
              if ((workInProgress.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                workInProgress.effectTag |= ShouldCapture;
                workInProgress.expirationTime = renderExpirationTime; // Schedule the error boundary to re-render using updated state

                var _update2 = createClassErrorUpdate(workInProgress, errorInfo, renderExpirationTime);
                enqueueCapturedUpdate(workInProgress, _update2);
                return;
              }
              break;
          }
          workInProgress = workInProgress.return;
        } while (workInProgress !== null);
      }
      var ceil = Math.ceil;
      var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
        ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
        IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
      var NoContext = /*                    */
      0;
      var BatchedContext = /*               */
      1;
      var DiscreteEventContext = /*         */
      4;
      var LegacyUnbatchedContext = /*       */
      8;
      var RenderContext = /*                */
      16;
      var CommitContext = /*                */
      32;
      var RootIncomplete = 0;
      var RootFatalErrored = 1;
      var RootErrored = 2;
      var RootSuspended = 3;
      var RootSuspendedWithDelay = 4;
      var RootCompleted = 5;
      // Describes where we are in the React execution stack
      var executionContext = NoContext; // The root we're working on

      var workInProgressRoot = null; // The fiber we're working on

      var workInProgress = null; // The expiration time we're rendering

      var renderExpirationTime$1 = NoWork; // Whether to root completed, errored, suspended, etc.

      var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown

      var workInProgressRootFatalError = null; // Most recent event time among processed updates during this render.
      // This is conceptually a time stamp but expressed in terms of an ExpirationTime
      // because we deal mostly with expiration times in the hot path, so this avoids
      // the conversion happening in the hot path.

      var workInProgressRootLatestProcessedExpirationTime = Sync;
      var workInProgressRootLatestSuspenseTimeout = Sync;
      var workInProgressRootCanSuspendUsingConfig = null; // The work left over by components that were visited during this render. Only
      // includes unprocessed updates, not work in bailed out children.

      var workInProgressRootNextUnprocessedUpdateTime = NoWork; // If we're pinged while rendering we don't always restart immediately.
      // This flag determines if it might be worthwhile to restart if an opportunity
      // happens latere.

      var workInProgressRootHasPendingPing = false; // The most recent time we committed a fallback. This lets us ensure a train
      // model where we don't commit new loading states in too quick succession.

      var globalMostRecentFallbackTime = 0;
      var FALLBACK_THROTTLE_MS = 500;
      var nextEffect = null;
      var hasUncaughtError = false;
      var firstUncaughtError = null;
      var legacyErrorBoundariesThatAlreadyFailed = null;
      var rootDoesHavePassiveEffects = false;
      var rootWithPendingPassiveEffects = null;
      var pendingPassiveEffectsRenderPriority = NoPriority;
      var pendingPassiveEffectsExpirationTime = NoWork;
      var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates

      var NESTED_UPDATE_LIMIT = 50;
      var nestedUpdateCount = 0;
      var rootWithNestedUpdates = null;
      var NESTED_PASSIVE_UPDATE_LIMIT = 50;
      var nestedPassiveUpdateCount = 0;
      var interruptedBy = null; // Marks the need to reschedule pending interactions at these expiration times
      // during the commit phase. This enables them to be traced across components
      // that spawn new work during render. E.g. hidden boundaries, suspended SSR
      // hydration or SuspenseList.

      var spawnedWorkDuringRender = null; // Expiration times are computed by adding to the current time (the start
      // time). However, if two updates are scheduled within the same event, we
      // should treat their start times as simultaneous, even if the actual clock
      // time has advanced between the first and second call.
      // In other words, because expiration times determine how updates are batched,
      // we want all updates of like priority that occur within the same event to
      // receive the same expiration time. Otherwise we get tearing.

      var currentEventTime = NoWork;
      function requestCurrentTimeForUpdate() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          // We're inside React, so it's fine to read the actual time.
          return msToExpirationTime(now());
        } // We're not inside React, so we may be in the middle of a browser event.

        if (currentEventTime !== NoWork) {
          // Use the same start time for all updates until we enter React again.
          return currentEventTime;
        } // This is the first update since React yielded. Compute a new start time.

        currentEventTime = msToExpirationTime(now());
        return currentEventTime;
      }
      function getCurrentTime() {
        return msToExpirationTime(now());
      }
      function computeExpirationForFiber(currentTime, fiber, suspenseConfig) {
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) {
          return Sync;
        }
        var priorityLevel = getCurrentPriorityLevel();
        if ((mode & ConcurrentMode) === NoMode) {
          return priorityLevel === ImmediatePriority ? Sync : Batched;
        }
        if ((executionContext & RenderContext) !== NoContext) {
          // Use whatever time we're already rendering
          // TODO: Should there be a way to opt out, like with `runWithPriority`?
          return renderExpirationTime$1;
        }
        var expirationTime;
        if (suspenseConfig !== null) {
          // Compute an expiration time based on the Suspense timeout.
          expirationTime = computeSuspenseExpiration(currentTime, suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
        } else {
          // Compute an expiration time based on the Scheduler priority.
          switch (priorityLevel) {
            case ImmediatePriority:
              expirationTime = Sync;
              break;
            case UserBlockingPriority:
              // TODO: Rename this to computeUserBlockingExpiration
              expirationTime = computeInteractiveExpiration(currentTime);
              break;
            case NormalPriority:
            case LowPriority:
              // TODO: Handle LowPriority
              // TODO: Rename this to... something better.
              expirationTime = computeAsyncExpiration(currentTime);
              break;
            case IdlePriority:
              expirationTime = Idle;
              break;
            default:
              {
                {
                  throw Error("Expected a valid priority level");
                }
              }
          }
        } // If we're in the middle of rendering a tree, do not update at the same
        // expiration time that is already rendering.
        // TODO: We shouldn't have to do this if the update is on a different root.
        // Refactor computeExpirationForFiber + scheduleUpdate so we have access to
        // the root when we check for this condition.

        if (workInProgressRoot !== null && expirationTime === renderExpirationTime$1) {
          // This is a trick to move this update into a separate batch
          expirationTime -= 1;
        }
        return expirationTime;
      }
      function scheduleUpdateOnFiber(fiber, expirationTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateTimeFromFiberToRoot(fiber, expirationTime);
        if (root === null) {
          warnAboutUpdateOnUnmountedFiberInDEV(fiber);
          return;
        }
        checkForInterruption(fiber, expirationTime);
        recordScheduleUpdate(); // TODO: computeExpirationForFiber also reads the priority. Pass the
        // priority as an argument to that function and this one.

        var priorityLevel = getCurrentPriorityLevel();
        if (expirationTime === Sync) {
          if (
          // Check if we're inside unbatchedUpdates
          (executionContext & LegacyUnbatchedContext) !== NoContext &&
          // Check if we're not already rendering
          (executionContext & (RenderContext | CommitContext)) === NoContext) {
            // Register pending interactions on the root to avoid losing traced interaction data.
            schedulePendingInteractions(root, expirationTime); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
            // root inside of batchedUpdates should be synchronous, but layout updates
            // should be deferred until the end of the batch.

            performSyncWorkOnRoot(root);
          } else {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, expirationTime);
            if (executionContext === NoContext) {
              // Flush the synchronous work now, unless we're already working or inside
              // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
              // scheduleCallbackForFiber to preserve the ability to schedule a callback
              // without immediately flushing it. We only do this for user-initiated
              // updates, to preserve historical behavior of legacy mode.
              flushSyncCallbackQueue();
            }
          }
        } else {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, expirationTime);
        }
        if ((executionContext & DiscreteEventContext) !== NoContext && (
        // Only updates at user-blocking priority or greater are considered
        // discrete, even inside a discrete event.
        priorityLevel === UserBlockingPriority || priorityLevel === ImmediatePriority)) {
          // This is the result of a discrete event. Track the lowest priority
          // discrete update per root so we can flush them early, if needed.
          if (rootsWithPendingDiscreteUpdates === null) {
            rootsWithPendingDiscreteUpdates = new Map([[root, expirationTime]]);
          } else {
            var lastDiscreteTime = rootsWithPendingDiscreteUpdates.get(root);
            if (lastDiscreteTime === undefined || lastDiscreteTime > expirationTime) {
              rootsWithPendingDiscreteUpdates.set(root, expirationTime);
            }
          }
        }
      }
      var scheduleWork = scheduleUpdateOnFiber; // This is split into a separate function so we can mark a fiber with pending
      // work without treating it as a typical update that originates from an event;
      // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
      // on a fiber.

      function markUpdateTimeFromFiberToRoot(fiber, expirationTime) {
        // Update the source fiber's expiration time
        if (fiber.expirationTime < expirationTime) {
          fiber.expirationTime = expirationTime;
        }
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < expirationTime) {
          alternate.expirationTime = expirationTime;
        } // Walk the parent path to the root and update the child expiration time.

        var node = fiber.return;
        var root = null;
        if (node === null && fiber.tag === HostRoot) {
          root = fiber.stateNode;
        } else {
          while (node !== null) {
            alternate = node.alternate;
            if (node.childExpirationTime < expirationTime) {
              node.childExpirationTime = expirationTime;
              if (alternate !== null && alternate.childExpirationTime < expirationTime) {
                alternate.childExpirationTime = expirationTime;
              }
            } else if (alternate !== null && alternate.childExpirationTime < expirationTime) {
              alternate.childExpirationTime = expirationTime;
            }
            if (node.return === null && node.tag === HostRoot) {
              root = node.stateNode;
              break;
            }
            node = node.return;
          }
        }
        if (root !== null) {
          if (workInProgressRoot === root) {
            // Received an update to a tree that's in the middle of rendering. Mark
            // that's unprocessed work on this root.
            markUnprocessedUpdateTime(expirationTime);
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              // The root already suspended with a delay, which means this render
              // definitely won't finish. Since we have a new update, let's mark it as
              // suspended now, right before marking the incoming update. This has the
              // effect of interrupting the current render and switching to the update.
              // TODO: This happens to work when receiving an update during the render
              // phase, because of the trick inside computeExpirationForFiber to
              // subtract 1 from `renderExpirationTime` to move it into a
              // separate bucket. But we should probably model it with an exception,
              // using the same mechanism we use to force hydration of a subtree.
              // TODO: This does not account for low pri updates that were already
              // scheduled before the root started rendering. Need to track the next
              // pending expiration time (perhaps by backtracking the return path) and
              // then trigger a restart in the `renderDidSuspendDelayIfPossible` path.
              markRootSuspendedAtTime(root, renderExpirationTime$1);
            }
          } // Mark that the root has a pending update.

          markRootUpdatedAtTime(root, expirationTime);
        }
        return root;
      }
      function getNextRootExpirationTimeToWorkOn(root) {
        // Determines the next expiration time that the root should render, taking
        // into account levels that may be suspended, or levels that may have
        // received a ping.
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
          return lastExpiredTime;
        } // "Pending" refers to any update that hasn't committed yet, including if it
        // suspended. The "suspended" range is therefore a subset.

        var firstPendingTime = root.firstPendingTime;
        if (!isRootSuspendedAtTime(root, firstPendingTime)) {
          // The highest priority pending time is not suspended. Let's work on that.
          return firstPendingTime;
        } // If the first pending time is suspended, check if there's a lower priority
        // pending level that we know about. Or check if we received a ping. Work
        // on whichever is higher priority.

        var lastPingedTime = root.lastPingedTime;
        var nextKnownPendingLevel = root.nextKnownPendingLevel;
        var nextLevel = lastPingedTime > nextKnownPendingLevel ? lastPingedTime : nextKnownPendingLevel;
        if (nextLevel <= Idle && firstPendingTime !== nextLevel) {
          // Don't work on Idle/Never priority unless everything else is committed.
          return NoWork;
        }
        return nextLevel;
      } // Use this function to schedule a task for a root. There's only one task per
      // root; if a task was already scheduled, we'll check to make sure the
      // expiration time of the existing task is the same as the expiration time of
      // the next level that the root has work on. This function is called on every
      // update, and right before exiting a task.

      function ensureRootIsScheduled(root) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
          // Special case: Expired work should flush synchronously.
          root.callbackExpirationTime = Sync;
          root.callbackPriority = ImmediatePriority;
          root.callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
          return;
        }
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        var existingCallbackNode = root.callbackNode;
        if (expirationTime === NoWork) {
          // There's nothing to work on.
          if (existingCallbackNode !== null) {
            root.callbackNode = null;
            root.callbackExpirationTime = NoWork;
            root.callbackPriority = NoPriority;
          }
          return;
        } // TODO: If this is an update, we already read the current time. Pass the
        // time as an argument.

        var currentTime = requestCurrentTimeForUpdate();
        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime); // If there's an existing render task, confirm it has the correct priority and
        // expiration time. Otherwise, we'll cancel it and schedule a new one.

        if (existingCallbackNode !== null) {
          var existingCallbackPriority = root.callbackPriority;
          var existingCallbackExpirationTime = root.callbackExpirationTime;
          if (
          // Callback must have the exact same expiration time.
          existingCallbackExpirationTime === expirationTime &&
          // Callback must have greater or equal priority.
          existingCallbackPriority >= priorityLevel) {
            // Existing callback is sufficient.
            return;
          } // Need to schedule a new task.
          // TODO: Instead of scheduling a new task, we should be able to change the
          // priority of the existing one.

          cancelCallback(existingCallbackNode);
        }
        root.callbackExpirationTime = expirationTime;
        root.callbackPriority = priorityLevel;
        var callbackNode;
        if (expirationTime === Sync) {
          // Sync React callbacks are scheduled on a special internal queue
          callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        } else {
          callbackNode = scheduleCallback(priorityLevel, performConcurrentWorkOnRoot.bind(null, root),
          // Compute a task timeout based on the expiration time. This also affects
          // ordering because tasks are processed in timeout order.
          {
            timeout: expirationTimeToMs(expirationTime) - now()
          });
        }
        root.callbackNode = callbackNode;
      } // This is the entry point for every concurrent task, i.e. anything that
      // goes through Scheduler.

      function performConcurrentWorkOnRoot(root, didTimeout) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoWork;
        if (didTimeout) {
          // The render task took too long to complete. Mark the current time as
          // expired to synchronously render all expired work in a single batch.
          var currentTime = requestCurrentTimeForUpdate();
          markRootExpiredAtTime(root, currentTime); // This will schedule a synchronous callback.

          ensureRootIsScheduled(root);
          return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.

        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        if (expirationTime !== NoWork) {
          var originalCallbackNode = root.callbackNode;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
          // and prepare a fresh one. Otherwise we'll continue where we left off.

          if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
            prepareFreshStack(root, expirationTime);
            startWorkOnPendingInteractions(root, expirationTime);
          } // If we have a work-in-progress fiber, it means there's still work to do
          // in this root.

          if (workInProgress !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= RenderContext;
            var prevDispatcher = pushDispatcher();
            var prevInteractions = pushInteractions(root);
            startWorkLoopTimer(workInProgress);
            do {
              try {
                workLoopConcurrent();
                break;
              } catch (thrownValue) {
                handleError(root, thrownValue);
              }
            } while (true);
            resetContextDependencies();
            executionContext = prevExecutionContext;
            popDispatcher(prevDispatcher);
            {
              popInteractions(prevInteractions);
            }
            if (workInProgressRootExitStatus === RootFatalErrored) {
              var fatalError = workInProgressRootFatalError;
              stopInterruptedWorkLoopTimer();
              prepareFreshStack(root, expirationTime);
              markRootSuspendedAtTime(root, expirationTime);
              ensureRootIsScheduled(root);
              throw fatalError;
            }
            if (workInProgress !== null) {
              // There's still work left over. Exit without committing.
              stopInterruptedWorkLoopTimer();
            } else {
              // We now have a consistent tree. The next step is either to commit it,
              // or, if something suspended, wait to commit it after a timeout.
              stopFinishedWorkLoopTimer();
              var finishedWork = root.finishedWork = root.current.alternate;
              root.finishedExpirationTime = expirationTime;
              finishConcurrentRender(root, finishedWork, workInProgressRootExitStatus, expirationTime);
            }
            ensureRootIsScheduled(root);
            if (root.callbackNode === originalCallbackNode) {
              // The task node scheduled for this root is the same one that's
              // currently executed. Need to return a continuation.
              return performConcurrentWorkOnRoot.bind(null, root);
            }
          }
        }
        return null;
      }
      function finishConcurrentRender(root, finishedWork, exitStatus, expirationTime) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        switch (exitStatus) {
          case RootIncomplete:
          case RootFatalErrored:
            {
              {
                {
                  throw Error("Root did not complete. This is a bug in React.");
                }
              }
            }
          // Flow knows about invariant, so it complains if I add a break
          // statement, but eslint doesn't know about invariant, so it complains
          // if I do. eslint-disable-next-line no-fallthrough

          case RootErrored:
            {
              // If this was an async render, the error may have happened due to
              // a mutation in a concurrent event. Try rendering one more time,
              // synchronously, to see if the error goes away. If there are
              // lower priority updates, let's include those, too, in case they
              // fix the inconsistency. Render at Idle to include all updates.
              // If it was Idle or Never or some not-yet-invented time, render
              // at that time.
              markRootExpiredAtTime(root, expirationTime > Idle ? Idle : expirationTime); // We assume that this second render pass will be synchronous
              // and therefore not hit this path again.

              break;
            }
          case RootSuspended:
            {
              markRootSuspendedAtTime(root, expirationTime);
              var lastSuspendedTime = root.lastSuspendedTime;
              if (expirationTime === lastSuspendedTime) {
                root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
              } // We have an acceptable loading state. We need to figure out if we
              // should immediately commit it or wait a bit.
              // If we have processed new updates during this render, we may now
              // have a new loading state ready. We want to ensure that we commit
              // that as soon as possible.

              var hasNotProcessedNewUpdates = workInProgressRootLatestProcessedExpirationTime === Sync;
              if (hasNotProcessedNewUpdates &&
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current) {
                // If we have not processed any new updates during this pass, then
                // this is either a retry of an existing fallback state or a
                // hidden tree. Hidden trees shouldn't be batched with other work
                // and after that's fixed it can only be a retry. We're going to
                // throttle committing retries so that we don't show too many
                // loading states too quickly.
                var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.

                if (msUntilTimeout > 10) {
                  if (workInProgressRootHasPendingPing) {
                    var lastPingedTime = root.lastPingedTime;
                    if (lastPingedTime === NoWork || lastPingedTime >= expirationTime) {
                      // This render was pinged but we didn't get to restart
                      // earlier so try restarting now instead.
                      root.lastPingedTime = expirationTime;
                      prepareFreshStack(root, expirationTime);
                      break;
                    }
                  }
                  var nextTime = getNextRootExpirationTimeToWorkOn(root);
                  if (nextTime !== NoWork && nextTime !== expirationTime) {
                    // There's additional work on this root.
                    break;
                  }
                  if (lastSuspendedTime !== NoWork && lastSuspendedTime !== expirationTime) {
                    // We should prefer to render the fallback of at the last
                    // suspended level. Ping the last suspended level to try
                    // rendering it again.
                    root.lastPingedTime = lastSuspendedTime;
                    break;
                  } // The render is suspended, it hasn't timed out, and there's no
                  // lower priority work to do. Instead of committing the fallback
                  // immediately, wait for more data to arrive.

                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                  break;
                }
              } // The work expired. Commit immediately.

              commitRoot(root);
              break;
            }
          case RootSuspendedWithDelay:
            {
              markRootSuspendedAtTime(root, expirationTime);
              var _lastSuspendedTime = root.lastSuspendedTime;
              if (expirationTime === _lastSuspendedTime) {
                root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
              }
              if (
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current) {
                // We're suspended in a state that should be avoided. We'll try to
                // avoid committing it for as long as the timeouts let us.
                if (workInProgressRootHasPendingPing) {
                  var _lastPingedTime = root.lastPingedTime;
                  if (_lastPingedTime === NoWork || _lastPingedTime >= expirationTime) {
                    // This render was pinged but we didn't get to restart earlier
                    // so try restarting now instead.
                    root.lastPingedTime = expirationTime;
                    prepareFreshStack(root, expirationTime);
                    break;
                  }
                }
                var _nextTime = getNextRootExpirationTimeToWorkOn(root);
                if (_nextTime !== NoWork && _nextTime !== expirationTime) {
                  // There's additional work on this root.
                  break;
                }
                if (_lastSuspendedTime !== NoWork && _lastSuspendedTime !== expirationTime) {
                  // We should prefer to render the fallback of at the last
                  // suspended level. Ping the last suspended level to try
                  // rendering it again.
                  root.lastPingedTime = _lastSuspendedTime;
                  break;
                }
                var _msUntilTimeout;
                if (workInProgressRootLatestSuspenseTimeout !== Sync) {
                  // We have processed a suspense config whose expiration time we
                  // can use as the timeout.
                  _msUntilTimeout = expirationTimeToMs(workInProgressRootLatestSuspenseTimeout) - now();
                } else if (workInProgressRootLatestProcessedExpirationTime === Sync) {
                  // This should never normally happen because only new updates
                  // cause delayed states, so we should have processed something.
                  // However, this could also happen in an offscreen tree.
                  _msUntilTimeout = 0;
                } else {
                  // If we don't have a suspense config, we're going to use a
                  // heuristic to determine how long we can suspend.
                  var eventTimeMs = inferTimeFromExpirationTime(workInProgressRootLatestProcessedExpirationTime);
                  var currentTimeMs = now();
                  var timeUntilExpirationMs = expirationTimeToMs(expirationTime) - currentTimeMs;
                  var timeElapsed = currentTimeMs - eventTimeMs;
                  if (timeElapsed < 0) {
                    // We get this wrong some time since we estimate the time.
                    timeElapsed = 0;
                  }
                  _msUntilTimeout = jnd(timeElapsed) - timeElapsed; // Clamp the timeout to the expiration time. TODO: Once the
                  // event time is exact instead of inferred from expiration time
                  // we don't need this.

                  if (timeUntilExpirationMs < _msUntilTimeout) {
                    _msUntilTimeout = timeUntilExpirationMs;
                  }
                } // Don't bother with a very short suspense time.

                if (_msUntilTimeout > 10) {
                  // The render is suspended, it hasn't timed out, and there's no
                  // lower priority work to do. Instead of committing the fallback
                  // immediately, wait for more data to arrive.
                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                  break;
                }
              } // The work expired. Commit immediately.

              commitRoot(root);
              break;
            }
          case RootCompleted:
            {
              // The work completed. Ready to commit.
              if (
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current && workInProgressRootLatestProcessedExpirationTime !== Sync && workInProgressRootCanSuspendUsingConfig !== null) {
                // If we have exceeded the minimum loading delay, which probably
                // means we have shown a spinner already, we might have to suspend
                // a bit longer to ensure that the spinner is shown for
                // enough time.
                var _msUntilTimeout2 = computeMsUntilSuspenseLoadingDelay(workInProgressRootLatestProcessedExpirationTime, expirationTime, workInProgressRootCanSuspendUsingConfig);
                if (_msUntilTimeout2 > 10) {
                  markRootSuspendedAtTime(root, expirationTime);
                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout2);
                  break;
                }
              }
              commitRoot(root);
              break;
            }
          default:
            {
              {
                {
                  throw Error("Unknown root exit status.");
                }
              }
            }
        }
      } // This is the entry point for synchronous tasks that don't go
      // through Scheduler

      function performSyncWorkOnRoot(root) {
        // Check if there's expired work on this root. Otherwise, render at Sync.
        var lastExpiredTime = root.lastExpiredTime;
        var expirationTime = lastExpiredTime !== NoWork ? lastExpiredTime : Sync;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Should not already be working.");
          }
        }
        flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.

        if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
          prepareFreshStack(root, expirationTime);
          startWorkOnPendingInteractions(root, expirationTime);
        } // If we have a work-in-progress fiber, it means there's still work to do
        // in this root.

        if (workInProgress !== null) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher();
          var prevInteractions = pushInteractions(root);
          startWorkLoopTimer(workInProgress);
          do {
            try {
              workLoopSync();
              break;
            } catch (thrownValue) {
              handleError(root, thrownValue);
            }
          } while (true);
          resetContextDependencies();
          executionContext = prevExecutionContext;
          popDispatcher(prevDispatcher);
          {
            popInteractions(prevInteractions);
          }
          if (workInProgressRootExitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            stopInterruptedWorkLoopTimer();
            prepareFreshStack(root, expirationTime);
            markRootSuspendedAtTime(root, expirationTime);
            ensureRootIsScheduled(root);
            throw fatalError;
          }
          if (workInProgress !== null) {
            // This is a sync render, so we should have finished the whole tree.
            {
              {
                throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          } else {
            // We now have a consistent tree. Because this is a sync render, we
            // will commit it even if something suspended.
            stopFinishedWorkLoopTimer();
            root.finishedWork = root.current.alternate;
            root.finishedExpirationTime = expirationTime;
            finishSyncRender(root);
          } // Before exiting, make sure there's a callback scheduled for the next
          // pending level.

          ensureRootIsScheduled(root);
        }
        return null;
      }
      function finishSyncRender(root) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        commitRoot(root);
      }
      function syncUpdates(fn, a, b, c) {
        return runWithPriority(ImmediatePriority, fn.bind(null, a, b, c));
      }
      function batchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function flushSync$$1(fn, a) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          {
            {
              throw Error("flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.");
            }
          }
        }
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
          return runWithPriority(ImmediatePriority, fn.bind(null, a));
        } finally {
          executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
          // Note that this will happen even if batchedUpdates is higher up
          // the stack.

          flushSyncCallbackQueue();
        }
      }
      function prepareFreshStack(root, expirationTime) {
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
          // The root previous suspended and scheduled a timeout to commit a fallback
          // state. Now that we have additional work, cancel the timeout.
          root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

          cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
          var interruptedWork = workInProgress.return;
          while (interruptedWork !== null) {
            unwindInterruptedWork(interruptedWork);
            interruptedWork = interruptedWork.return;
          }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        renderExpirationTime$1 = expirationTime;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootLatestProcessedExpirationTime = Sync;
        workInProgressRootLatestSuspenseTimeout = Sync;
        workInProgressRootCanSuspendUsingConfig = null;
        workInProgressRootNextUnprocessedUpdateTime = NoWork;
        workInProgressRootHasPendingPing = false;
        {
          spawnedWorkDuringRender = null;
        }
        {
          ReactStrictModeWarnings.discardPendingWarnings();
        }
      }
      function handleError(root, thrownValue) {
        do {
          try {
            // Reset module-level state that was set during the render phase.
            resetContextDependencies();
            resetHooksAfterThrow();
            resetCurrentFiber();
            if (workInProgress === null || workInProgress.return === null) {
              // Expected to be working on a non-root fiber. This is a fatal error
              // because there's no ancestor that can handle it; the root is
              // supposed to capture all errors that weren't caught by an error
              // boundary.
              workInProgressRootExitStatus = RootFatalErrored;
              workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
              // sibling, or the parent if there are no siblings. But since the root
              // has no siblings nor a parent, we set it to null. Usually this is
              // handled by `completeUnitOfWork` or `unwindWork`, but since we're
              // interntionally not calling those, we need set it here.
              // TODO: Consider calling `unwindWork` to pop the contexts.

              workInProgress = null;
              return null;
            }
            if (workInProgress.mode & ProfileMode) {
              // Record the time spent rendering before an error was thrown. This
              // avoids inaccurate Profiler durations in the case of a
              // suspended render.
              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, true);
            }
            throwException(root, workInProgress.return, workInProgress, thrownValue, renderExpirationTime$1);
            workInProgress = completeUnitOfWork(workInProgress);
          } catch (yetAnotherThrownValue) {
            // Something in the return path also threw.
            thrownValue = yetAnotherThrownValue;
            continue;
          } // Return to the normal work loop.

          return;
        } while (true);
      }
      function pushDispatcher(root) {
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) {
          // The React isomorphic package does not include a default dispatcher.
          // Instead the first renderer will lazily attach one, in order to give
          // nicer error messages.
          return ContextOnlyDispatcher;
        } else {
          return prevDispatcher;
        }
      }
      function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
      function pushInteractions(root) {
        {
          var prevInteractions = tracing$1.__interactionsRef.current;
          tracing$1.__interactionsRef.current = root.memoizedInteractions;
          return prevInteractions;
        }
      }
      function popInteractions(prevInteractions) {
        {
          tracing$1.__interactionsRef.current = prevInteractions;
        }
      }
      function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
      }
      function markRenderEventTimeAndConfig(expirationTime, suspenseConfig) {
        if (expirationTime < workInProgressRootLatestProcessedExpirationTime && expirationTime > Idle) {
          workInProgressRootLatestProcessedExpirationTime = expirationTime;
        }
        if (suspenseConfig !== null) {
          if (expirationTime < workInProgressRootLatestSuspenseTimeout && expirationTime > Idle) {
            workInProgressRootLatestSuspenseTimeout = expirationTime; // Most of the time we only have one config and getting wrong is not bad.

            workInProgressRootCanSuspendUsingConfig = suspenseConfig;
          }
        }
      }
      function markUnprocessedUpdateTime(expirationTime) {
        if (expirationTime > workInProgressRootNextUnprocessedUpdateTime) {
          workInProgressRootNextUnprocessedUpdateTime = expirationTime;
        }
      }
      function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) {
          workInProgressRootExitStatus = RootSuspended;
        }
      }
      function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
          workInProgressRootExitStatus = RootSuspendedWithDelay;
        } // Check if there's a lower priority update somewhere else in the tree.

        if (workInProgressRootNextUnprocessedUpdateTime !== NoWork && workInProgressRoot !== null) {
          // Mark the current render as suspended, and then mark that there's a
          // pending update.
          // TODO: This should immediately interrupt the current render, instead
          // of waiting until the next time we yield.
          markRootSuspendedAtTime(workInProgressRoot, renderExpirationTime$1);
          markRootUpdatedAtTime(workInProgressRoot, workInProgressRootNextUnprocessedUpdateTime);
        }
      }
      function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) {
          workInProgressRootExitStatus = RootErrored;
        }
      } // Called during render to determine if anything has suspended.
      // Returns false if we're not sure.

      function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
      }
      function inferTimeFromExpirationTime(expirationTime) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - LOW_PRIORITY_EXPIRATION;
      }
      function inferTimeFromExpirationTimeWithSuspenseConfig(expirationTime, suspenseConfig) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time by subtracting the timeout
        // that was added to the event time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - (suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
      } // The work loop is an extremely hot path. Tell Closure not to inline it.

      /** @noinline */

      function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while (workInProgress !== null) {
          workInProgress = performUnitOfWork(workInProgress);
        }
      }
      /** @noinline */

      function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while (workInProgress !== null && !shouldYield()) {
          workInProgress = performUnitOfWork(workInProgress);
        }
      }
      function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        startWorkTimer(unitOfWork);
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          startProfilerTimer(unitOfWork);
          next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
          stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else {
          next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
        }
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) {
          // If this doesn't spawn new work, complete the current work.
          next = completeUnitOfWork(unitOfWork);
        }
        ReactCurrentOwner$2.current = null;
        return next;
      }
      function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        workInProgress = unitOfWork;
        do {
          // The current, flushed, state of this fiber is the alternate. Ideally
          // nothing should rely on this, but relying on it here means that we don't
          // need an additional field on the work in progress.
          var current = workInProgress.alternate;
          var returnFiber = workInProgress.return; // Check if the work completed or if something threw.

          if ((workInProgress.effectTag & Incomplete) === NoEffect) {
            setCurrentFiber(workInProgress);
            var next = void 0;
            if ((workInProgress.mode & ProfileMode) === NoMode) {
              next = completeWork(current, workInProgress, renderExpirationTime$1);
            } else {
              startProfilerTimer(workInProgress);
              next = completeWork(current, workInProgress, renderExpirationTime$1); // Update render duration assuming we didn't error.

              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
            }
            stopWorkTimer(workInProgress);
            resetCurrentFiber();
            resetChildExpirationTime(workInProgress);
            if (next !== null) {
              // Completing this fiber spawned new work. Work on that next.
              return next;
            }
            if (returnFiber !== null &&
            // Do not append effects to parents if a sibling failed to complete
            (returnFiber.effectTag & Incomplete) === NoEffect) {
              // Append all the effects of the subtree and this fiber onto the effect
              // list of the parent. The completion order of the children affects the
              // side-effect order.
              if (returnFiber.firstEffect === null) {
                returnFiber.firstEffect = workInProgress.firstEffect;
              }
              if (workInProgress.lastEffect !== null) {
                if (returnFiber.lastEffect !== null) {
                  returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                }
                returnFiber.lastEffect = workInProgress.lastEffect;
              } // If this fiber had side-effects, we append it AFTER the children's
              // side-effects. We can perform certain side-effects earlier if needed,
              // by doing multiple passes over the effect list. We don't want to
              // schedule our own side-effect on our own list because if end up
              // reusing children we'll schedule this effect onto itself since we're
              // at the end.

              var effectTag = workInProgress.effectTag; // Skip both NoWork and PerformedWork tags when creating the effect
              // list. PerformedWork effect is read by React DevTools but shouldn't be
              // committed.

              if (effectTag > PerformedWork) {
                if (returnFiber.lastEffect !== null) {
                  returnFiber.lastEffect.nextEffect = workInProgress;
                } else {
                  returnFiber.firstEffect = workInProgress;
                }
                returnFiber.lastEffect = workInProgress;
              }
            }
          } else {
            // This fiber did not complete because something threw. Pop values off
            // the stack without entering the complete phase. If this is a boundary,
            // capture values if possible.
            var _next = unwindWork(workInProgress); // Because this fiber did not complete, don't reset its expiration time.

            if ((workInProgress.mode & ProfileMode) !== NoMode) {
              // Record the render duration for the fiber that errored.
              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false); // Include the time spent working on failed children before continuing.

              var actualDuration = workInProgress.actualDuration;
              var child = workInProgress.child;
              while (child !== null) {
                actualDuration += child.actualDuration;
                child = child.sibling;
              }
              workInProgress.actualDuration = actualDuration;
            }
            if (_next !== null) {
              // If completing this work spawned new work, do that next. We'll come
              // back here again.
              // Since we're restarting, remove anything that is not a host effect
              // from the effect tag.
              // TODO: The name stopFailedWorkTimer is misleading because Suspense
              // also captures and restarts.
              stopFailedWorkTimer(workInProgress);
              _next.effectTag &= HostEffectMask;
              return _next;
            }
            stopWorkTimer(workInProgress);
            if (returnFiber !== null) {
              // Mark the parent fiber as incomplete and clear its effect list.
              returnFiber.firstEffect = returnFiber.lastEffect = null;
              returnFiber.effectTag |= Incomplete;
            }
          }
          var siblingFiber = workInProgress.sibling;
          if (siblingFiber !== null) {
            // If there is more work to do in this returnFiber, do that next.
            return siblingFiber;
          } // Otherwise, return to the parent

          workInProgress = returnFiber;
        } while (workInProgress !== null); // We've reached the root.

        if (workInProgressRootExitStatus === RootIncomplete) {
          workInProgressRootExitStatus = RootCompleted;
        }
        return null;
      }
      function getRemainingExpirationTime(fiber) {
        var updateExpirationTime = fiber.expirationTime;
        var childExpirationTime = fiber.childExpirationTime;
        return updateExpirationTime > childExpirationTime ? updateExpirationTime : childExpirationTime;
      }
      function resetChildExpirationTime(completedWork) {
        if (renderExpirationTime$1 !== Never && completedWork.childExpirationTime === Never) {
          // The children of this component are hidden. Don't bubble their
          // expiration times.
          return;
        }
        var newChildExpirationTime = NoWork; // Bubble up the earliest expiration time.

        if ((completedWork.mode & ProfileMode) !== NoMode) {
          // In profiling mode, resetChildExpirationTime is also used to reset
          // profiler durations.
          var actualDuration = completedWork.actualDuration;
          var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
          // only be updated if work is done on the fiber (i.e. it doesn't bailout).
          // When work is done, it should bubble to the parent's actualDuration. If
          // the fiber has not been cloned though, (meaning no work was done), then
          // this value will reflect the amount of time spent working on a previous
          // render. In that case it should not bubble. We determine whether it was
          // cloned by comparing the child pointer.

          var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
          var child = completedWork.child;
          while (child !== null) {
            var childUpdateExpirationTime = child.expirationTime;
            var childChildExpirationTime = child.childExpirationTime;
            if (childUpdateExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = childUpdateExpirationTime;
            }
            if (childChildExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = childChildExpirationTime;
            }
            if (shouldBubbleActualDurations) {
              actualDuration += child.actualDuration;
            }
            treeBaseDuration += child.treeBaseDuration;
            child = child.sibling;
          }
          completedWork.actualDuration = actualDuration;
          completedWork.treeBaseDuration = treeBaseDuration;
        } else {
          var _child = completedWork.child;
          while (_child !== null) {
            var _childUpdateExpirationTime = _child.expirationTime;
            var _childChildExpirationTime = _child.childExpirationTime;
            if (_childUpdateExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = _childUpdateExpirationTime;
            }
            if (_childChildExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = _childChildExpirationTime;
            }
            _child = _child.sibling;
          }
        }
        completedWork.childExpirationTime = newChildExpirationTime;
      }
      function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority(ImmediatePriority, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
      }
      function commitRootImpl(root, renderPriorityLevel) {
        do {
          // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
          // means `flushPassiveEffects` will sometimes result in additional
          // passive effects. So we need to keep flushing in a loop until there are
          // no more pending effects.
          // TODO: Might be better if `flushPassiveEffects` did not automatically
          // flush synchronous work at the end, to avoid factoring hazards like this.
          flushPassiveEffects();
        } while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Should not already be working.");
          }
        }
        var finishedWork = root.finishedWork;
        var expirationTime = root.finishedExpirationTime;
        if (finishedWork === null) {
          return null;
        }
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        if (!(finishedWork !== root.current)) {
          {
            throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
          }
        } // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.

        root.callbackNode = null;
        root.callbackExpirationTime = NoWork;
        root.callbackPriority = NoPriority;
        root.nextKnownPendingLevel = NoWork;
        startCommitTimer(); // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.

        var remainingExpirationTimeBeforeCommit = getRemainingExpirationTime(finishedWork);
        markRootFinishedAtTime(root, expirationTime, remainingExpirationTimeBeforeCommit);
        if (root === workInProgressRoot) {
          // We can reset these now that they are finished.
          workInProgressRoot = null;
          workInProgress = null;
          renderExpirationTime$1 = NoWork;
        } // This indicates that the last root we worked on is not the same one that
        // we're committing now. This most commonly happens when a suspended root
        // times out.
        // Get the list of effects.

        var firstEffect;
        if (finishedWork.effectTag > PerformedWork) {
          // A fiber's effect list consists only of its children, not itself. So if
          // the root has an effect, we need to add it to the end of the list. The
          // resulting list is the set that would belong to the root's parent, if it
          // had one; that is, all the effects in the tree including the root.
          if (finishedWork.lastEffect !== null) {
            finishedWork.lastEffect.nextEffect = finishedWork;
            firstEffect = finishedWork.firstEffect;
          } else {
            firstEffect = finishedWork;
          }
        } else {
          // There is no effect on the root.
          firstEffect = finishedWork.firstEffect;
        }
        if (firstEffect !== null) {
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles

          ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
          // of the effect list for each phase: all mutation effects come before all
          // layout effects, and so on.
          // The first phase a "before mutation" phase. We use this phase to read the
          // state of the host tree right before we mutate it. This is where
          // getSnapshotBeforeUpdate is called.

          startCommitSnapshotEffectsTimer();
          prepareForCommit(root.containerInfo);
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitBeforeMutationEffects, null);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var error = clearCaughtError();
                captureCommitPhaseError(nextEffect, error);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitSnapshotEffectsTimer();
          {
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
          } // The next phase is the mutation phase, where we mutate the host tree.

          startCommitHostEffectsTimer();
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error = clearCaughtError();
                captureCommitPhaseError(nextEffect, _error);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitHostEffectsTimer();
          resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
          // the mutation phase, so that the previous tree is still current during
          // componentWillUnmount, but before the layout phase, so that the finished
          // work is current during componentDidMount/Update.

          root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
          // the host tree after it's been mutated. The idiomatic use case for this is
          // layout, but class component lifecycles also fire here for legacy reasons.

          startCommitLifeCyclesTimer();
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitLayoutEffects, null, root, expirationTime);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error2 = clearCaughtError();
                captureCommitPhaseError(nextEffect, _error2);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitLifeCyclesTimer();
          nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
          // opportunity to paint.

          requestPaint();
          {
            popInteractions(prevInteractions);
          }
          executionContext = prevExecutionContext;
        } else {
          // No effects.
          root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
          // no effects.
          // TODO: Maybe there's a better way to report this.

          startCommitSnapshotEffectsTimer();
          stopCommitSnapshotEffectsTimer();
          {
            recordCommitTime();
          }
          startCommitHostEffectsTimer();
          stopCommitHostEffectsTimer();
          startCommitLifeCyclesTimer();
          stopCommitLifeCyclesTimer();
        }
        stopCommitTimer();
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
          // This commit has passive effects. Stash a reference to them. But don't
          // schedule a callback until after flushing layout work.
          rootDoesHavePassiveEffects = false;
          rootWithPendingPassiveEffects = root;
          pendingPassiveEffectsExpirationTime = expirationTime;
          pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
          // We are done with the effect chain at this point so let's clear the
          // nextEffect pointers to assist with GC. If we have passive effects, we'll
          // clear this in flushPassiveEffects.
          nextEffect = firstEffect;
          while (nextEffect !== null) {
            var nextNextEffect = nextEffect.nextEffect;
            nextEffect.nextEffect = null;
            nextEffect = nextNextEffect;
          }
        } // Check if there's remaining work on this root

        var remainingExpirationTime = root.firstPendingTime;
        if (remainingExpirationTime !== NoWork) {
          {
            if (spawnedWorkDuringRender !== null) {
              var expirationTimes = spawnedWorkDuringRender;
              spawnedWorkDuringRender = null;
              for (var i = 0; i < expirationTimes.length; i++) {
                scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
              }
            }
            schedulePendingInteractions(root, remainingExpirationTime);
          }
        } else {
          // If there's no remaining work, we can clear the set of already failed
          // error boundaries.
          legacyErrorBoundariesThatAlreadyFailed = null;
        }
        {
          if (!rootDidHavePassiveEffects) {
            // If there are no passive effects, then we can complete the pending interactions.
            // Otherwise, we'll wait until after the passive effects are flushed.
            // Wait to do this until after remaining work has been scheduled,
            // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
            finishPendingInteractions(root, expirationTime);
          }
        }
        if (remainingExpirationTime === Sync) {
          // Count the number of times the root synchronously re-renders without
          // finishing. If there are too many, it indicates an infinite update loop.
          if (root === rootWithNestedUpdates) {
            nestedUpdateCount++;
          } else {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = root;
          }
        } else {
          nestedUpdateCount = 0;
        }
        onCommitRoot(finishedWork.stateNode, expirationTime); // Always call this before exiting `commitRoot`, to ensure that any
        // additional work on this root is scheduled.

        ensureRootIsScheduled(root);
        if (hasUncaughtError) {
          hasUncaughtError = false;
          var _error3 = firstUncaughtError;
          firstUncaughtError = null;
          throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
          // This is a legacy edge case. We just committed the initial mount of
          // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
          // synchronously, but layout updates should be deferred until the end
          // of the batch.
          return null;
        } // If layout work was scheduled, flush it now.

        flushSyncCallbackQueue();
        return null;
      }
      function commitBeforeMutationEffects() {
        while (nextEffect !== null) {
          var effectTag = nextEffect.effectTag;
          if ((effectTag & Snapshot) !== NoEffect) {
            setCurrentFiber(nextEffect);
            recordEffect();
            var current = nextEffect.alternate;
            commitBeforeMutationLifeCycles(current, nextEffect);
            resetCurrentFiber();
          }
          if ((effectTag & Passive) !== NoEffect) {
            // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            if (!rootDoesHavePassiveEffects) {
              rootDoesHavePassiveEffects = true;
              scheduleCallback(NormalPriority, function () {
                flushPassiveEffects();
                return null;
              });
            }
          }
          nextEffect = nextEffect.nextEffect;
        }
      }
      function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while (nextEffect !== null) {
          setCurrentFiber(nextEffect);
          var effectTag = nextEffect.effectTag;
          if (effectTag & ContentReset) {
            commitResetTextContent(nextEffect);
          }
          if (effectTag & Ref) {
            var current = nextEffect.alternate;
            if (current !== null) {
              commitDetachRef(current);
            }
          } // The following switch statement is only concerned about placement,
          // updates, and deletions. To avoid needing to add a case for every possible
          // bitmap value, we remove the secondary effects from the effect tag and
          // switch on that value.

          var primaryEffectTag = effectTag & (Placement | Update | Deletion | Hydrating);
          switch (primaryEffectTag) {
            case Placement:
              {
                commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                // inserted, before any life-cycles like componentDidMount gets called.
                // TODO: findDOMNode doesn't rely on this any more but isMounted does
                // and isMounted is deprecated anyway so we should be able to kill this.

                nextEffect.effectTag &= ~Placement;
                break;
              }
            case PlacementAndUpdate:
              {
                // Placement
                commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                // inserted, before any life-cycles like componentDidMount gets called.

                nextEffect.effectTag &= ~Placement; // Update

                var _current = nextEffect.alternate;
                commitWork(_current, nextEffect);
                break;
              }
            case Hydrating:
              {
                nextEffect.effectTag &= ~Hydrating;
                break;
              }
            case HydratingAndUpdate:
              {
                nextEffect.effectTag &= ~Hydrating; // Update

                var _current2 = nextEffect.alternate;
                commitWork(_current2, nextEffect);
                break;
              }
            case Update:
              {
                var _current3 = nextEffect.alternate;
                commitWork(_current3, nextEffect);
                break;
              }
            case Deletion:
              {
                commitDeletion(root, nextEffect, renderPriorityLevel);
                break;
              }
          } // TODO: Only record a mutation effect if primaryEffectTag is non-zero.

          recordEffect();
          resetCurrentFiber();
          nextEffect = nextEffect.nextEffect;
        }
      }
      function commitLayoutEffects(root, committedExpirationTime) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while (nextEffect !== null) {
          setCurrentFiber(nextEffect);
          var effectTag = nextEffect.effectTag;
          if (effectTag & (Update | Callback)) {
            recordEffect();
            var current = nextEffect.alternate;
            commitLifeCycles(root, current, nextEffect);
          }
          if (effectTag & Ref) {
            recordEffect();
            commitAttachRef(nextEffect);
          }
          resetCurrentFiber();
          nextEffect = nextEffect.nextEffect;
        }
      }
      function flushPassiveEffects() {
        if (pendingPassiveEffectsRenderPriority !== NoPriority) {
          var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority ? NormalPriority : pendingPassiveEffectsRenderPriority;
          pendingPassiveEffectsRenderPriority = NoPriority;
          return runWithPriority(priorityLevel, flushPassiveEffectsImpl);
        }
      }
      function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) {
          return false;
        }
        var root = rootWithPendingPassiveEffects;
        var expirationTime = pendingPassiveEffectsExpirationTime;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsExpirationTime = NoWork;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Cannot flush passive effects while already rendering.");
          }
        }
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root);
        {
          // Note: This currently assumes there are no passive effects on the root fiber
          // because the root is not part of its own effect list.
          // This could change in the future.
          var _effect2 = root.current.firstEffect;
          while (_effect2 !== null) {
            {
              setCurrentFiber(_effect2);
              invokeGuardedCallback(null, commitPassiveHookEffects, null, _effect2);
              if (hasCaughtError()) {
                if (!(_effect2 !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error5 = clearCaughtError();
                captureCommitPhaseError(_effect2, _error5);
              }
              resetCurrentFiber();
            }
            var nextNextEffect = _effect2.nextEffect; // Remove nextEffect pointer to assist GC

            _effect2.nextEffect = null;
            _effect2 = nextNextEffect;
          }
        }
        {
          popInteractions(prevInteractions);
          finishPendingInteractions(root, expirationTime);
        }
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.

        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
      }
      function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
      }
      function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) {
          legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
        } else {
          legacyErrorBoundariesThatAlreadyFailed.add(instance);
        }
      }
      function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
          hasUncaughtError = true;
          firstUncaughtError = error;
        }
      }
      var onUncaughtError = prepareToThrowUncaughtError;
      function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, Sync);
        enqueueUpdate(rootFiber, update);
        var root = markUpdateTimeFromFiberToRoot(rootFiber, Sync);
        if (root !== null) {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, Sync);
        }
      }
      function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
          // Error was thrown at the root. There is no parent, so the root
          // itself should capture it.
          captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
          return;
        }
        var fiber = sourceFiber.return;
        while (fiber !== null) {
          if (fiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
            return;
          } else if (fiber.tag === ClassComponent) {
            var ctor = fiber.type;
            var instance = fiber.stateNode;
            if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
              var errorInfo = createCapturedValue(error, sourceFiber);
              var update = createClassErrorUpdate(fiber, errorInfo,
              // TODO: This is always sync
              Sync);
              enqueueUpdate(fiber, update);
              var root = markUpdateTimeFromFiberToRoot(fiber, Sync);
              if (root !== null) {
                ensureRootIsScheduled(root);
                schedulePendingInteractions(root, Sync);
              }
              return;
            }
          }
          fiber = fiber.return;
        }
      }
      function pingSuspendedRoot(root, thenable, suspendedTime) {
        var pingCache = root.pingCache;
        if (pingCache !== null) {
          // The thenable resolved, so we no longer need to memoize, because it will
          // never be thrown again.
          pingCache.delete(thenable);
        }
        if (workInProgressRoot === root && renderExpirationTime$1 === suspendedTime) {
          // Received a ping at the same priority level at which we're currently
          // rendering. We might want to restart this render. This should mirror
          // the logic of whether or not a root suspends once it completes.
          // TODO: If we're rendering sync either due to Sync, Batched or expired,
          // we should probably never restart.
          // If we're suspended with delay, we'll always suspend so we can always
          // restart. If we're suspended without any updates, it might be a retry.
          // If it's early in the retry we can restart. We can't know for sure
          // whether we'll eventually process an update during this render pass,
          // but it's somewhat unlikely that we get to a ping before that, since
          // getting to the root most update is usually very fast.
          if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && workInProgressRootLatestProcessedExpirationTime === Sync && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
            // Restart from the root. Don't need to schedule a ping because
            // we're already working on this tree.
            prepareFreshStack(root, renderExpirationTime$1);
          } else {
            // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootHasPendingPing = true;
          }
          return;
        }
        if (!isRootSuspendedAtTime(root, suspendedTime)) {
          // The root is no longer suspended at this time.
          return;
        }
        var lastPingedTime = root.lastPingedTime;
        if (lastPingedTime !== NoWork && lastPingedTime < suspendedTime) {
          // There's already a lower priority ping scheduled.
          return;
        } // Mark the time at which this ping was scheduled.

        root.lastPingedTime = suspendedTime;
        ensureRootIsScheduled(root);
        schedulePendingInteractions(root, suspendedTime);
      }
      function retryTimedOutBoundary(boundaryFiber, retryTime) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryTime === NoWork) {
          var suspenseConfig = null; // Retries don't carry over the already committed update.

          var currentTime = requestCurrentTimeForUpdate();
          retryTime = computeExpirationForFiber(currentTime, boundaryFiber, suspenseConfig);
        } // TODO: Special case idle priority?

        var root = markUpdateTimeFromFiberToRoot(boundaryFiber, retryTime);
        if (root !== null) {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, retryTime);
        }
      }
      function resolveRetryThenable(boundaryFiber, thenable) {
        var retryTime = NoWork; // Default

        var retryCache;
        {
          retryCache = boundaryFiber.stateNode;
        }
        if (retryCache !== null) {
          // The thenable resolved, so we no longer need to memoize, because it will
          // never be thrown again.
          retryCache.delete(thenable);
        }
        retryTimedOutBoundary(boundaryFiber, retryTime);
      } // Computes the next Just Noticeable Difference (JND) boundary.
      // The theory is that a person can't tell the difference between small differences in time.
      // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
      // difference in the experience. However, waiting for longer might mean that we can avoid
      // showing an intermediate loading state. The longer we have already waited, the harder it
      // is to tell small differences in time. Therefore, the longer we've already waited,
      // the longer we can wait additionally. At some point we have to give up though.
      // We pick a train model where the next boundary commits at a consistent schedule.
      // These particular numbers are vague estimates. We expect to adjust them based on research.

      function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
      }
      function computeMsUntilSuspenseLoadingDelay(mostRecentEventTime, committedExpirationTime, suspenseConfig) {
        var busyMinDurationMs = suspenseConfig.busyMinDurationMs | 0;
        if (busyMinDurationMs <= 0) {
          return 0;
        }
        var busyDelayMs = suspenseConfig.busyDelayMs | 0; // Compute the time until this render pass would expire.

        var currentTimeMs = now();
        var eventTimeMs = inferTimeFromExpirationTimeWithSuspenseConfig(mostRecentEventTime, suspenseConfig);
        var timeElapsed = currentTimeMs - eventTimeMs;
        if (timeElapsed <= busyDelayMs) {
          // If we haven't yet waited longer than the initial delay, we don't
          // have to wait any additional time.
          return 0;
        }
        var msUntilTimeout = busyDelayMs + busyMinDurationMs - timeElapsed; // This is the value that is passed to `setTimeout`.

        return msUntilTimeout;
      }
      function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
          nestedUpdateCount = 0;
          rootWithNestedUpdates = null;
          {
            {
              throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
            }
          }
        }
        {
          if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
          }
        }
      }
      function flushRenderPhaseStrictModeWarningsInDEV() {
        {
          ReactStrictModeWarnings.flushLegacyContextWarning();
          {
            ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
          }
        }
      }
      function stopFinishedWorkLoopTimer() {
        var didCompleteRoot = true;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
      }
      function stopInterruptedWorkLoopTimer() {
        // TODO: Track which fiber caused the interruption.
        var didCompleteRoot = false;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
      }
      function checkForInterruption(fiberThatReceivedUpdate, updateExpirationTime) {
        if (workInProgressRoot !== null && updateExpirationTime > renderExpirationTime$1) {
          interruptedBy = fiberThatReceivedUpdate;
        }
      }
      var didWarnStateUpdateForUnmountedComponent = null;
      function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        {
          var tag = fiber.tag;
          if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
            // Only warn for user-defined components, not internal ones like Suspense.
            return;
          }
          // the problematic code almost always lies inside that component.

          var componentName = getComponentName(fiber.type) || 'ReactComponent';
          if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
              return;
            }
            didWarnStateUpdateForUnmountedComponent.add(componentName);
          } else {
            didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
          }
          error("Can't perform a React state update on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.%s', tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function', getStackByFiberInDevAndProd(fiber));
        }
      }
      var beginWork$1;
      {
        beginWork$1 = beginWork;
      }
      var didWarnAboutUpdateInRender = false;
      var didWarnAboutUpdateInRenderForAnotherComponent;
      {
        didWarnAboutUpdateInRenderForAnotherComponent = new Set();
      }
      function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        {
          if (isRendering && (executionContext & RenderContext) !== NoContext) {
            switch (fiber.tag) {
              case FunctionComponent:
              case ForwardRef:
              case SimpleMemoComponent:
                {
                  var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.

                  var dedupeKey = renderingComponentName;
                  if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || 'Unknown';
                    error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://fb.me/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
                  }
                  break;
                }
              case ClassComponent:
                {
                  if (!didWarnAboutUpdateInRender) {
                    error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');
                    didWarnAboutUpdateInRender = true;
                  }
                  break;
                }
            }
          }
        }
      } // a 'shared' variable that changes when act() opens/closes in tests.

      var IsThisRendererActing = {
        current: false
      };
      function warnIfNotScopedWithMatchingAct(fiber) {
        {
          if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
            error("It looks like you're using the wrong act() around your test interactions.\n" + 'Be sure to use the matching version of act() corresponding to your renderer:\n\n' + '// for react-dom:\n' + "import {act} from 'react-dom/test-utils';\n" + '// ...\n' + 'act(() => ...);\n\n' + '// for react-test-renderer:\n' + "import TestRenderer from 'react-test-renderer';\n" + 'const {act} = TestRenderer;\n' + '// ...\n' + 'act(() => ...);' + '%s', getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        {
          if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            error('An update to %s ran an effect, but was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://fb.me/react-wrap-tests-with-act' + '%s', getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        {
          if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://fb.me/react-wrap-tests-with-act' + '%s', getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.

      var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
      // scheduler is the actual recommendation. The alternative could be a testing build,
      // a new lib, or whatever; we dunno just yet. This message is for early adopters
      // to get their tests right.

      function warnIfUnmockedScheduler(fiber) {
        {
          if (didWarnAboutUnmockedScheduler === false && Scheduler$1.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
              didWarnAboutUnmockedScheduler = true;
              error('In Concurrent or Sync modes, the "scheduler" module needs to be mocked ' + 'to guarantee consistent behaviour across tests and browsers. ' + 'For example, with jest: \n' + "jest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\n" + 'For more info, visit https://fb.me/react-mock-scheduler');
            }
          }
        }
      }
      function computeThreadID(root, expirationTime) {
        // Interaction threads are unique per root and expiration time.
        return expirationTime * 1000 + root.interactionThreadID;
      }
      function markSpawnedWork(expirationTime) {
        if (spawnedWorkDuringRender === null) {
          spawnedWorkDuringRender = [expirationTime];
        } else {
          spawnedWorkDuringRender.push(expirationTime);
        }
      }
      function scheduleInteractions(root, expirationTime, interactions) {
        if (interactions.size > 0) {
          var pendingInteractionMap = root.pendingInteractionMap;
          var pendingInteractions = pendingInteractionMap.get(expirationTime);
          if (pendingInteractions != null) {
            interactions.forEach(function (interaction) {
              if (!pendingInteractions.has(interaction)) {
                // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
              }
              pendingInteractions.add(interaction);
            });
          } else {
            pendingInteractionMap.set(expirationTime, new Set(interactions)); // Update the pending async work count for the current interactions.

            interactions.forEach(function (interaction) {
              interaction.__count++;
            });
          }
          var subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null) {
            var threadID = computeThreadID(root, expirationTime);
            subscriber.onWorkScheduled(interactions, threadID);
          }
        }
      }
      function schedulePendingInteractions(root, expirationTime) {
        scheduleInteractions(root, expirationTime, tracing$1.__interactionsRef.current);
      }
      function startWorkOnPendingInteractions(root, expirationTime) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.

        var interactions = new Set();
        root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledExpirationTime) {
          if (scheduledExpirationTime >= expirationTime) {
            scheduledInteractions.forEach(function (interaction) {
              return interactions.add(interaction);
            });
          }
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.

        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
          var subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null) {
            var threadID = computeThreadID(root, expirationTime);
            try {
              subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
              // If the subscriber throws, rethrow it in a separate task
              scheduleCallback(ImmediatePriority, function () {
                throw error;
              });
            }
          }
        }
      }
      function finishPendingInteractions(root, committedExpirationTime) {
        var earliestRemainingTimeAfterCommit = root.firstPendingTime;
        var subscriber;
        try {
          subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null && root.memoizedInteractions.size > 0) {
            var threadID = computeThreadID(root, committedExpirationTime);
            subscriber.onWorkStopped(root.memoizedInteractions, threadID);
          }
        } catch (error) {
          // If the subscriber throws, rethrow it in a separate task
          scheduleCallback(ImmediatePriority, function () {
            throw error;
          });
        } finally {
          // Clear completed interactions from the pending Map.
          // Unless the render was suspended or cascading work was scheduled,
          // In which case– leave pending interactions until the subsequent render.
          var pendingInteractionMap = root.pendingInteractionMap;
          pendingInteractionMap.forEach(function (scheduledInteractions, scheduledExpirationTime) {
            // Only decrement the pending interaction count if we're done.
            // If there's still work at the current priority,
            // That indicates that we are waiting for suspense data.
            if (scheduledExpirationTime > earliestRemainingTimeAfterCommit) {
              pendingInteractionMap.delete(scheduledExpirationTime);
              scheduledInteractions.forEach(function (interaction) {
                interaction.__count--;
                if (subscriber !== null && interaction.__count === 0) {
                  try {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority, function () {
                      throw error;
                    });
                  }
                }
              });
            }
          });
        }
      }
      var onScheduleFiberRoot = null;
      var onCommitFiberRoot = null;
      var onCommitFiberUnmount = null;
      var hasLoggedError = false;
      var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
      function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
          // No DevTools
          return false;
        }
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) {
          // This isn't a real property on the hook, but it can be set to opt out
          // of DevTools integration and associated warnings and logs.
          // https://github.com/facebook/react/issues/3877
          return true;
        }
        if (!hook.supportsFiber) {
          {
            error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://fb.me/react-devtools');
          } // DevTools exists, even though it doesn't support Fiber.

          return true;
        }
        try {
          var rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

          {
            // Only used by Fast Refresh
            if (typeof hook.onScheduleFiberRoot === 'function') {
              onScheduleFiberRoot = function onScheduleFiberRoot(root, children) {
                try {
                  hook.onScheduleFiberRoot(rendererID, root, children);
                } catch (err) {
                  if (!hasLoggedError) {
                    hasLoggedError = true;
                    error('React instrumentation encountered an error: %s', err);
                  }
                }
              };
            }
          }
          onCommitFiberRoot = function onCommitFiberRoot(root, expirationTime) {
            try {
              var didError = (root.current.effectTag & DidCapture) === DidCapture;
              {
                var currentTime = getCurrentTime();
                var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime);
                hook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
              }
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          };
          onCommitFiberUnmount = function onCommitFiberUnmount(fiber) {
            try {
              hook.onCommitFiberUnmount(rendererID, fiber);
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          };
        } catch (err) {
          // Catch all errors because it is unsafe to throw during initialization.
          {
            error('React instrumentation encountered an error: %s.', err);
          }
        } // DevTools exists

        return true;
      }
      function onScheduleRoot(root, children) {
        if (typeof onScheduleFiberRoot === 'function') {
          onScheduleFiberRoot(root, children);
        }
      }
      function onCommitRoot(root, expirationTime) {
        if (typeof onCommitFiberRoot === 'function') {
          onCommitFiberRoot(root, expirationTime);
        }
      }
      function onCommitUnmount(fiber) {
        if (typeof onCommitFiberUnmount === 'function') {
          onCommitFiberUnmount(fiber);
        }
      }
      var hasBadMapPolyfill;
      {
        hasBadMapPolyfill = false;
        try {
          var nonExtensibleObject = Object.preventExtensions({});
          var testMap = new Map([[nonExtensibleObject, null]]);
          var testSet = new Set([nonExtensibleObject]); // This is necessary for Rollup to not consider these unused.
          // https://github.com/rollup/rollup/issues/1771
          // TODO: we can remove these if Rollup fixes the bug.

          testMap.set(0, 0);
          testSet.add(0);
        } catch (e) {
          // TODO: Consider warning about bad polyfills
          hasBadMapPolyfill = true;
        }
      }
      var debugCounter = 1;
      function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber

        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects

        this.effectTag = NoEffect;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.expirationTime = NoWork;
        this.childExpirationTime = NoWork;
        this.alternate = null;
        {
          // Note: The following is done to avoid a v8 performance cliff.
          //
          // Initializing the fields below to smis and later updating them with
          // double values will cause Fibers to end up having separate shapes.
          // This behavior/bug has something to do with Object.preventExtension().
          // Fortunately this only impacts DEV builds.
          // Unfortunately it makes React unusably slow for some applications.
          // To work around this, initialize the fields below with doubles.
          //
          // Learn more about this here:
          // https://github.com/facebook/react/issues/14365
          // https://bugs.chromium.org/p/v8/issues/detail?id=8538
          this.actualDuration = Number.NaN;
          this.actualStartTime = Number.NaN;
          this.selfBaseDuration = Number.NaN;
          this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
          // This won't trigger the performance cliff mentioned above,
          // and it simplifies other profiler code (including DevTools).

          this.actualDuration = 0;
          this.actualStartTime = -1;
          this.selfBaseDuration = 0;
          this.treeBaseDuration = 0;
        } // This is normally DEV-only except www when it adds listeners.
        // TODO: remove the User Timing integration in favor of Root Events.

        {
          this._debugID = debugCounter++;
          this._debugIsCurrentlyTiming = false;
        }
        {
          this._debugSource = null;
          this._debugOwner = null;
          this._debugNeedsRemount = false;
          this._debugHookTypes = null;
          if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
            Object.preventExtensions(this);
          }
        }
      } // This is a constructor function, rather than a POJO constructor, still
      // please ensure we do the following:
      // 1) Nobody should add any instance methods on this. Instance methods can be
      //    more difficult to predict when they get optimized and they are almost
      //    never inlined properly in static compilers.
      // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
      //    always know when it is a fiber.
      // 3) We might want to experiment with using numeric keys since they are easier
      //    to optimize in a non-JIT environment.
      // 4) We can easily go from a constructor to a createFiber object literal if that
      //    is faster.
      // 5) It should be easy to port this to a C struct and keep a C implementation
      //    compatible.

      var createFiber = function createFiber(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
      };
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct(type) && type.defaultProps === undefined;
      }
      function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') {
          return shouldConstruct(Component) ? ClassComponent : FunctionComponent;
        } else if (Component !== undefined && Component !== null) {
          var $$typeof = Component.$$typeof;
          if ($$typeof === REACT_FORWARD_REF_TYPE) {
            return ForwardRef;
          }
          if ($$typeof === REACT_MEMO_TYPE) {
            return MemoComponent;
          }
        }
        return IndeterminateComponent;
      } // This is used to create an alternate fiber to do work on.

      function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
          // We use a double buffering pooling technique because we know that we'll
          // only ever need at most two versions of a tree. We pool the "other" unused
          // node that we're free to reuse. This is lazily created to avoid allocating
          // extra objects for things that are never updated. It also allow us to
          // reclaim the extra memory if needed.
          workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
          workInProgress.elementType = current.elementType;
          workInProgress.type = current.type;
          workInProgress.stateNode = current.stateNode;
          {
            // DEV-only fields
            {
              workInProgress._debugID = current._debugID;
            }
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
          }
          workInProgress.alternate = current;
          current.alternate = workInProgress;
        } else {
          workInProgress.pendingProps = pendingProps; // We already have an alternate.
          // Reset the effect tag.

          workInProgress.effectTag = NoEffect; // The effect list is no longer valid.

          workInProgress.nextEffect = null;
          workInProgress.firstEffect = null;
          workInProgress.lastEffect = null;
          {
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
          }
        }
        workInProgress.childExpirationTime = current.childExpirationTime;
        workInProgress.expirationTime = current.expirationTime;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.

        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
          expirationTime: currentDependencies.expirationTime,
          firstContext: currentDependencies.firstContext,
          responders: currentDependencies.responders
        }; // These will be overridden during the parent's reconciliation

        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        {
          workInProgress.selfBaseDuration = current.selfBaseDuration;
          workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        {
          workInProgress._debugNeedsRemount = current._debugNeedsRemount;
          switch (workInProgress.tag) {
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
              workInProgress.type = resolveFunctionForHotReloading(current.type);
              break;
            case ClassComponent:
              workInProgress.type = resolveClassForHotReloading(current.type);
              break;
            case ForwardRef:
              workInProgress.type = resolveForwardRefForHotReloading(current.type);
              break;
          }
        }
        return workInProgress;
      } // Used to reuse a Fiber for a second pass.

      function resetWorkInProgress(workInProgress, renderExpirationTime) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.effectTag &= Placement; // The effect list is no longer valid.

        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
          // Reset to createFiber's initial values.
          workInProgress.childExpirationTime = NoWork;
          workInProgress.expirationTime = renderExpirationTime;
          workInProgress.child = null;
          workInProgress.memoizedProps = null;
          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null;
          workInProgress.dependencies = null;
          {
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
          }
        } else {
          // Reset to the cloned values that createWorkInProgress would've.
          workInProgress.childExpirationTime = current.childExpirationTime;
          workInProgress.expirationTime = current.expirationTime;
          workInProgress.child = current.child;
          workInProgress.memoizedProps = current.memoizedProps;
          workInProgress.memoizedState = current.memoizedState;
          workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
          // it cannot be shared with the current fiber.

          var currentDependencies = current.dependencies;
          workInProgress.dependencies = currentDependencies === null ? null : {
            expirationTime: currentDependencies.expirationTime,
            firstContext: currentDependencies.firstContext,
            responders: currentDependencies.responders
          };
          {
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
          }
        }
        return workInProgress;
      }
      function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) {
          mode = ConcurrentMode | BlockingMode | StrictMode;
        } else if (tag === BlockingRoot) {
          mode = BlockingMode | StrictMode;
        } else {
          mode = NoMode;
        }
        if (isDevToolsPresent) {
          // Always collect profile timings when DevTools are present.
          // This enables DevTools to start capturing timing at any point–
          // Without some nodes in the tree having empty base times.
          mode |= ProfileMode;
        }
        return createFiber(HostRoot, null, null, mode);
      }
      function createFiberFromTypeAndProps(type,
      // React$ElementType
      key, pendingProps, owner, mode, expirationTime) {
        var fiber;
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.

        var resolvedType = type;
        if (typeof type === 'function') {
          if (shouldConstruct(type)) {
            fiberTag = ClassComponent;
            {
              resolvedType = resolveClassForHotReloading(resolvedType);
            }
          } else {
            {
              resolvedType = resolveFunctionForHotReloading(resolvedType);
            }
          }
        } else if (typeof type === 'string') {
          fiberTag = HostComponent;
        } else {
          getTag: switch (type) {
            case REACT_FRAGMENT_TYPE:
              return createFiberFromFragment(pendingProps.children, mode, expirationTime, key);
            case REACT_CONCURRENT_MODE_TYPE:
              fiberTag = Mode;
              mode |= ConcurrentMode | BlockingMode | StrictMode;
              break;
            case REACT_STRICT_MODE_TYPE:
              fiberTag = Mode;
              mode |= StrictMode;
              break;
            case REACT_PROFILER_TYPE:
              return createFiberFromProfiler(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_TYPE:
              return createFiberFromSuspense(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_LIST_TYPE:
              return createFiberFromSuspenseList(pendingProps, mode, expirationTime, key);
            default:
              {
                if (typeof type === 'object' && type !== null) {
                  switch (type.$$typeof) {
                    case REACT_PROVIDER_TYPE:
                      fiberTag = ContextProvider;
                      break getTag;
                    case REACT_CONTEXT_TYPE:
                      // This is a consumer
                      fiberTag = ContextConsumer;
                      break getTag;
                    case REACT_FORWARD_REF_TYPE:
                      fiberTag = ForwardRef;
                      {
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                      }
                      break getTag;
                    case REACT_MEMO_TYPE:
                      fiberTag = MemoComponent;
                      break getTag;
                    case REACT_LAZY_TYPE:
                      fiberTag = LazyComponent;
                      resolvedType = null;
                      break getTag;
                    case REACT_BLOCK_TYPE:
                      fiberTag = Block;
                      break getTag;
                  }
                }
                var info = '';
                {
                  if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                    info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                  }
                  var ownerName = owner ? getComponentName(owner.type) : null;
                  if (ownerName) {
                    info += '\n\nCheck the render method of `' + ownerName + '`.';
                  }
                }
                {
                  {
                    throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
                  }
                }
              }
          }
        }
        fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromElement(element, mode, expirationTime) {
        var owner = null;
        {
          owner = element._owner;
        }
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime);
        {
          fiber._debugSource = element._source;
          fiber._debugOwner = element._owner;
        }
        return fiber;
      }
      function createFiberFromFragment(elements, mode, expirationTime, key) {
        var fiber = createFiber(Fragment$$1, elements, key, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromProfiler(pendingProps, mode, expirationTime, key) {
        {
          if (typeof pendingProps.id !== 'string' || typeof pendingProps.onRender !== 'function') {
            error('Profiler must specify an "id" string and "onRender" function as props');
          }
        }
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.

        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromSuspense(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.

        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromSuspenseList(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        {
          // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
          // This needs to be fixed in getComponentName so that it relies on the tag
          // instead.
          fiber.type = REACT_SUSPENSE_LIST_TYPE;
        }
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromText(content, mode, expirationTime) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromPortal(portal, mode, expirationTime) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.expirationTime = expirationTime;
        fiber.stateNode = {
          containerInfo: portal.containerInfo,
          pendingChildren: null,
          // Used by persistent updates
          implementation: portal.implementation
        };
        return fiber;
      } // Used for stashing WIP properties to replay failed work in DEV.

      function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.current = null;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.pingCache = null;
        this.finishedExpirationTime = NoWork;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoPriority;
        this.firstPendingTime = NoWork;
        this.firstSuspendedTime = NoWork;
        this.lastSuspendedTime = NoWork;
        this.nextKnownPendingLevel = NoWork;
        this.lastPingedTime = NoWork;
        this.lastExpiredTime = NoWork;
        {
          this.interactionThreadID = tracing$1.unstable_getThreadID();
          this.memoizedInteractions = new Set();
          this.pendingInteractionMap = new Map();
        }
      }
      function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.

        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
      }
      function isRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        return firstSuspendedTime !== NoWork && firstSuspendedTime >= expirationTime && lastSuspendedTime <= expirationTime;
      }
      function markRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        if (firstSuspendedTime < expirationTime) {
          root.firstSuspendedTime = expirationTime;
        }
        if (lastSuspendedTime > expirationTime || firstSuspendedTime === NoWork) {
          root.lastSuspendedTime = expirationTime;
        }
        if (expirationTime <= root.lastPingedTime) {
          root.lastPingedTime = NoWork;
        }
        if (expirationTime <= root.lastExpiredTime) {
          root.lastExpiredTime = NoWork;
        }
      }
      function markRootUpdatedAtTime(root, expirationTime) {
        // Update the range of pending times
        var firstPendingTime = root.firstPendingTime;
        if (expirationTime > firstPendingTime) {
          root.firstPendingTime = expirationTime;
        } // Update the range of suspended times. Treat everything lower priority or
        // equal to this update as unsuspended.

        var firstSuspendedTime = root.firstSuspendedTime;
        if (firstSuspendedTime !== NoWork) {
          if (expirationTime >= firstSuspendedTime) {
            // The entire suspended range is now unsuspended.
            root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
          } else if (expirationTime >= root.lastSuspendedTime) {
            root.lastSuspendedTime = expirationTime + 1;
          } // This is a pending level. Check if it's higher priority than the next
          // known pending level.

          if (expirationTime > root.nextKnownPendingLevel) {
            root.nextKnownPendingLevel = expirationTime;
          }
        }
      }
      function markRootFinishedAtTime(root, finishedExpirationTime, remainingExpirationTime) {
        // Update the range of pending times
        root.firstPendingTime = remainingExpirationTime; // Update the range of suspended times. Treat everything higher priority or
        // equal to this update as unsuspended.

        if (finishedExpirationTime <= root.lastSuspendedTime) {
          // The entire suspended range is now unsuspended.
          root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
        } else if (finishedExpirationTime <= root.firstSuspendedTime) {
          // Part of the suspended range is now unsuspended. Narrow the range to
          // include everything between the unsuspended time (non-inclusive) and the
          // last suspended time.
          root.firstSuspendedTime = finishedExpirationTime - 1;
        }
        if (finishedExpirationTime <= root.lastPingedTime) {
          // Clear the pinged time
          root.lastPingedTime = NoWork;
        }
        if (finishedExpirationTime <= root.lastExpiredTime) {
          // Clear the expired time
          root.lastExpiredTime = NoWork;
        }
      }
      function markRootExpiredAtTime(root, expirationTime) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime === NoWork || lastExpiredTime > expirationTime) {
          root.lastExpiredTime = expirationTime;
        }
      }
      var didWarnAboutMessageChannel = false;
      var enqueueTaskImpl = null;
      function enqueueTask(task) {
        if (enqueueTaskImpl === null) {
          try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ('require' + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.

            enqueueTaskImpl = nodeRequire('timers').setImmediate;
          } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function enqueueTaskImpl(callback) {
              {
                if (didWarnAboutMessageChannel === false) {
                  didWarnAboutMessageChannel = true;
                  if (typeof MessageChannel === 'undefined') {
                    error('This browser does not have a MessageChannel implementation, ' + 'so enqueuing tasks via await act(async () => ...) will fail. ' + 'Please file an issue at https://github.com/facebook/react/issues ' + 'if you encounter this warning.');
                  }
                }
              }
              var channel = new MessageChannel();
              channel.port1.onmessage = callback;
              channel.port2.postMessage(undefined);
            };
          }
        }
        return enqueueTaskImpl(task);
      }
      var didWarnAboutNestedUpdates;
      {
        didWarnAboutNestedUpdates = false;
      }
      function getContextForSubtree(parentComponent) {
        if (!parentComponent) {
          return emptyContextObject;
        }
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
          var Component = fiber.type;
          if (isContextProvider(Component)) {
            return processChildContext(fiber, Component, parentContext);
          }
        }
        return parentContext;
      }
      function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
      }
      function updateContainer(element, container, parentComponent, callback) {
        {
          onScheduleRoot(container, element);
        }
        var current$1 = container.current;
        var currentTime = requestCurrentTimeForUpdate();
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
          }
        }
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, current$1, suspenseConfig);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) {
          container.context = context;
        } else {
          container.pendingContext = context;
        }
        {
          if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
          }
        }
        var update = createUpdate(expirationTime, suspenseConfig); // Caution: React DevTools currently depends on this property
        // being called "element".

        update.payload = {
          element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
          {
            if (typeof callback !== 'function') {
              error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
            }
          }
          update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleWork(current$1, expirationTime);
        return expirationTime;
      }
      function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) {
          return null;
        }
        switch (containerFiber.child.tag) {
          case HostComponent:
            return getPublicInstance(containerFiber.child.stateNode);
          default:
            return containerFiber.child.stateNode;
        }
      }
      var shouldSuspendImpl = function shouldSuspendImpl(fiber) {
        return false;
      };
      function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
      }
      var overrideHookState = null;
      var overrideProps = null;
      var scheduleUpdate = null;
      var setSuspenseHandler = null;
      {
        var copyWithSetImpl = function copyWithSetImpl(obj, path, idx, value) {
          if (idx >= path.length) {
            return value;
          }
          var key = path[idx];
          var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here

          updated[key] = copyWithSetImpl(obj[key], path, idx + 1, value);
          return updated;
        };
        var copyWithSet = function copyWithSet(obj, path, value) {
          return copyWithSetImpl(obj, path, 0, value);
        }; // Support DevTools editable values for useState and useReducer.

        overrideHookState = function overrideHookState(fiber, id, path, value) {
          // For now, the "id" of stateful hooks is just the stateful hook index.
          // This may change in the future with e.g. nested hooks.
          var currentHook = fiber.memoizedState;
          while (currentHook !== null && id > 0) {
            currentHook = currentHook.next;
            id--;
          }
          if (currentHook !== null) {
            var newState = copyWithSet(currentHook.memoizedState, path, value);
            currentHook.memoizedState = newState;
            currentHook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.

            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleWork(fiber, Sync);
          }
        }; // Support DevTools props for function components, forwardRef, memo, host components, etc.

        overrideProps = function overrideProps(fiber, path, value) {
          fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }
          scheduleWork(fiber, Sync);
        };
        scheduleUpdate = function scheduleUpdate(fiber) {
          scheduleWork(fiber, Sync);
        };
        setSuspenseHandler = function setSuspenseHandler(newShouldSuspendImpl) {
          shouldSuspendImpl = newShouldSuspendImpl;
        };
      }
      function injectIntoDevTools(devToolsConfig) {
        var _findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals(_assign({}, devToolsConfig, {
          overrideHookState: overrideHookState,
          overrideProps: overrideProps,
          setSuspenseHandler: setSuspenseHandler,
          scheduleUpdate: scheduleUpdate,
          currentDispatcherRef: ReactCurrentDispatcher,
          findHostInstanceByFiber: function findHostInstanceByFiber(fiber) {
            var hostFiber = findCurrentHostFiber(fiber);
            if (hostFiber === null) {
              return null;
            }
            return hostFiber.stateNode;
          },
          findFiberByHostInstance: function findFiberByHostInstance(instance) {
            if (!_findFiberByHostInstance) {
              // Might not be implemented by the renderer.
              return null;
            }
            return _findFiberByHostInstance(instance);
          },
          // React Refresh
          findHostInstancesForRefresh: findHostInstancesForRefresh,
          scheduleRefresh: scheduleRefresh,
          scheduleRoot: scheduleRoot,
          setRefreshHandler: setRefreshHandler,
          // Enables DevTools to append owner stacks to error messages in DEV mode.
          getCurrentFiber: function getCurrentFiber() {
            return current;
          }
        }));
      }
      var IsSomeRendererActing$1 = ReactSharedInternals.IsSomeRendererActing;
      var isSchedulerMocked = typeof Scheduler$1.unstable_flushAllWithoutAsserting === 'function';
      var flushWork = Scheduler$1.unstable_flushAllWithoutAsserting || function () {
        var didFlushWork = false;
        while (flushPassiveEffects()) {
          didFlushWork = true;
        }
        return didFlushWork;
      };
      function flushWorkAndMicroTasks(onDone) {
        try {
          flushWork();
          enqueueTask(function () {
            if (flushWork()) {
              flushWorkAndMicroTasks(onDone);
            } else {
              onDone();
            }
          });
        } catch (err) {
          onDone(err);
        }
      } // we track the 'depth' of the act() calls with this counter,
      // so we can tell if any async act() calls try to run in parallel.

      var actingUpdatesScopeDepth = 0;
      function act(callback) {
        var previousActingUpdatesScopeDepth = actingUpdatesScopeDepth;
        var previousIsSomeRendererActing;
        var previousIsThisRendererActing;
        actingUpdatesScopeDepth++;
        previousIsSomeRendererActing = IsSomeRendererActing$1.current;
        previousIsThisRendererActing = IsThisRendererActing.current;
        IsSomeRendererActing$1.current = true;
        IsThisRendererActing.current = true;
        function onDone() {
          actingUpdatesScopeDepth--;
          IsSomeRendererActing$1.current = previousIsSomeRendererActing;
          IsThisRendererActing.current = previousIsThisRendererActing;
          {
            if (actingUpdatesScopeDepth > previousActingUpdatesScopeDepth) {
              // if it's _less than_ previousActingUpdatesScopeDepth, then we can assume the 'other' one has warned
              error('You seem to have overlapping act() calls, this is not supported. ' + 'Be sure to await previous act() calls before making a new one. ');
            }
          }
        }
        var result;
        try {
          result = batchedUpdates(callback);
        } catch (error) {
          // on sync errors, we still want to 'cleanup' and decrement actingUpdatesScopeDepth
          onDone();
          throw error;
        }
        if (result !== null && typeof result === 'object' && typeof result.then === 'function') {
          // setup a boolean that gets set to true only
          // once this act() call is await-ed
          var called = false;
          {
            if (typeof Promise !== 'undefined') {
              //eslint-disable-next-line no-undef
              Promise.resolve().then(function () {}).then(function () {
                if (called === false) {
                  error('You called act(async () => ...) without await. ' + 'This could lead to unexpected testing behaviour, interleaving multiple act ' + 'calls and mixing their scopes. You should - await act(async () => ...);');
                }
              });
            }
          } // in the async case, the returned thenable runs the callback, flushes
          // effects and  microtasks in a loop until flushPassiveEffects() === false,
          // and cleans up

          return {
            then: function then(resolve, reject) {
              called = true;
              result.then(function () {
                if (actingUpdatesScopeDepth > 1 || isSchedulerMocked === true && previousIsSomeRendererActing === true) {
                  onDone();
                  resolve();
                  return;
                } // we're about to exit the act() scope,
                // now's the time to flush tasks/effects

                flushWorkAndMicroTasks(function (err) {
                  onDone();
                  if (err) {
                    reject(err);
                  } else {
                    resolve();
                  }
                });
              }, function (err) {
                onDone();
                reject(err);
              });
            }
          };
        } else {
          {
            if (result !== undefined) {
              error('The callback passed to act(...) function ' + 'must return undefined, or a Promise. You returned %s', result);
            }
          } // flush effects until none remain, and cleanup

          try {
            if (actingUpdatesScopeDepth === 1 && (isSchedulerMocked === false || previousIsSomeRendererActing === false)) {
              // we're about to exit the act() scope,
              // now's the time to flush effects
              flushWork();
            }
            onDone();
          } catch (err) {
            onDone();
            throw err;
          } // in the sync case, the returned thenable only warns *if* await-ed

          return {
            then: function then(resolve) {
              {
                error('Do not await the result of calling act(...) with sync logic, it is not a Promise.');
              }
              resolve();
            }
          };
        }
      }
      var ReactVersion = '16.13.1';
      var defaultTestOptions = {
        createNodeMock: function createNodeMock() {
          return null;
        }
      };
      function _toJSON(inst) {
        if (inst.isHidden) {
          // Omit timed out children from output entirely. This seems like the least
          // surprising behavior. We could perhaps add a separate API that includes
          // them, if it turns out people need it.
          return null;
        }
        switch (inst.tag) {
          case 'TEXT':
            return inst.text;
          case 'INSTANCE':
            {
              /* eslint-disable no-unused-vars */
              // We don't include the `children` prop in JSON.
              // Instead, we will include the actual rendered children.
              var _inst$props = inst.props,
                children = _inst$props.children,
                props = _objectWithoutPropertiesLoose(_inst$props, ["children"]);
              /* eslint-enable */

              var renderedChildren = null;
              if (inst.children && inst.children.length) {
                for (var i = 0; i < inst.children.length; i++) {
                  var renderedChild = _toJSON(inst.children[i]);
                  if (renderedChild !== null) {
                    if (renderedChildren === null) {
                      renderedChildren = [renderedChild];
                    } else {
                      renderedChildren.push(renderedChild);
                    }
                  }
                }
              }
              var json = {
                type: inst.type,
                props: props,
                children: renderedChildren
              };
              Object.defineProperty(json, '$$typeof', {
                value: Symbol.for('react.test.json')
              });
              return json;
            }
          default:
            throw new Error("Unexpected node type in toJSON: " + inst.tag);
        }
      }
      function childrenToTree(node) {
        if (!node) {
          return null;
        }
        var children = nodeAndSiblingsArray(node);
        if (children.length === 0) {
          return null;
        } else if (children.length === 1) {
          return _toTree(children[0]);
        }
        return flatten(children.map(_toTree));
      }
      function nodeAndSiblingsArray(nodeWithSibling) {
        var array = [];
        var node = nodeWithSibling;
        while (node != null) {
          array.push(node);
          node = node.sibling;
        }
        return array;
      }
      function flatten(arr) {
        var result = [];
        var stack = [{
          i: 0,
          array: arr
        }];
        while (stack.length) {
          var n = stack.pop();
          while (n.i < n.array.length) {
            var el = n.array[n.i];
            n.i += 1;
            if (Array.isArray(el)) {
              stack.push(n);
              stack.push({
                i: 0,
                array: el
              });
              break;
            }
            result.push(el);
          }
        }
        return result;
      }
      function _toTree(node) {
        if (node == null) {
          return null;
        }
        switch (node.tag) {
          case HostRoot:
            return childrenToTree(node.child);
          case HostPortal:
            return childrenToTree(node.child);
          case ClassComponent:
            return {
              nodeType: 'component',
              type: node.type,
              props: _assign({}, node.memoizedProps),
              instance: node.stateNode,
              rendered: childrenToTree(node.child)
            };
          case FunctionComponent:
          case SimpleMemoComponent:
            return {
              nodeType: 'component',
              type: node.type,
              props: _assign({}, node.memoizedProps),
              instance: null,
              rendered: childrenToTree(node.child)
            };
          case Block:
            return {
              nodeType: 'block',
              type: node.type,
              props: _assign({}, node.memoizedProps),
              instance: null,
              rendered: childrenToTree(node.child)
            };
          case HostComponent:
            {
              return {
                nodeType: 'host',
                type: node.type,
                props: _assign({}, node.memoizedProps),
                instance: null,
                // TODO: use createNodeMock here somehow?
                rendered: flatten(nodeAndSiblingsArray(node.child).map(_toTree))
              };
            }
          case HostText:
            return node.stateNode.text;
          case Fragment$$1:
          case ContextProvider:
          case ContextConsumer:
          case Mode:
          case Profiler:
          case ForwardRef:
          case MemoComponent:
          case IncompleteClassComponent:
          case ScopeComponent:
            return childrenToTree(node.child);
          default:
            {
              {
                throw Error("toTree() does not yet know how to handle nodes with tag=" + node.tag);
              }
            }
        }
      }
      var validWrapperTypes = new Set([FunctionComponent, ClassComponent, HostComponent, ForwardRef, MemoComponent, SimpleMemoComponent, Block,
      // Normally skipped, but used when there's more than one root child.
      HostRoot]);
      function getChildren(parent) {
        var children = [];
        var startingNode = parent;
        var node = startingNode;
        if (node.child === null) {
          return children;
        }
        node.child.return = node;
        node = node.child;
        outer: while (true) {
          var descend = false;
          if (validWrapperTypes.has(node.tag)) {
            children.push(wrapFiber(node));
          } else if (node.tag === HostText) {
            children.push('' + node.memoizedProps);
          } else {
            descend = true;
          }
          if (descend && node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          while (node.sibling === null) {
            if (node.return === startingNode) {
              break outer;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
        return children;
      }
      var ReactTestInstance = /*#__PURE__*/
      function () {
        var _proto = ReactTestInstance.prototype;
        _proto._currentFiber = function _currentFiber() {
          // Throws if this component has been unmounted.
          var fiber = findCurrentFiberUsingSlowPath(this._fiber);
          if (!(fiber !== null)) {
            {
              throw Error("Can't read from currently-mounting component. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          return fiber;
        };
        function ReactTestInstance(fiber) {
          if (!validWrapperTypes.has(fiber.tag)) {
            {
              throw Error("Unexpected object passed to ReactTestInstance constructor (tag: " + fiber.tag + "). This is probably a bug in React.");
            }
          }
          this._fiber = fiber;
        }

        // Custom search functions
        _proto.find = function find(predicate) {
          return expectOne(this.findAll(predicate, {
            deep: false
          }), "matching custom predicate: " + predicate.toString());
        };
        _proto.findByType = function findByType(type) {
          return expectOne(this.findAllByType(type, {
            deep: false
          }), "with node type: \"" + (type.displayName || type.name) + "\"");
        };
        _proto.findByProps = function findByProps(props) {
          return expectOne(this.findAllByProps(props, {
            deep: false
          }), "with props: " + JSON.stringify(props));
        };
        _proto.findAll = function findAll(predicate) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return _findAll(this, predicate, options);
        };
        _proto.findAllByType = function findAllByType(type) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return _findAll(this, function (node) {
            return node.type === type;
          }, options);
        };
        _proto.findAllByProps = function findAllByProps(props) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return _findAll(this, function (node) {
            return node.props && propsMatch(node.props, props);
          }, options);
        };
        _createClass(ReactTestInstance, [{
          key: "instance",
          get: function get() {
            if (this._fiber.tag === HostComponent) {
              return getPublicInstance(this._fiber.stateNode);
            } else {
              return this._fiber.stateNode;
            }
          }
        }, {
          key: "type",
          get: function get() {
            return this._fiber.type;
          }
        }, {
          key: "props",
          get: function get() {
            return this._currentFiber().memoizedProps;
          }
        }, {
          key: "parent",
          get: function get() {
            var parent = this._fiber.return;
            while (parent !== null) {
              if (validWrapperTypes.has(parent.tag)) {
                if (parent.tag === HostRoot) {
                  // Special case: we only "materialize" instances for roots
                  // if they have more than a single child. So we'll check that now.
                  if (getChildren(parent).length < 2) {
                    return null;
                  }
                }
                return wrapFiber(parent);
              }
              parent = parent.return;
            }
            return null;
          }
        }, {
          key: "children",
          get: function get() {
            return getChildren(this._currentFiber());
          }
        }]);
        return ReactTestInstance;
      }();
      function _findAll(root, predicate, options) {
        var deep = options ? options.deep : true;
        var results = [];
        if (predicate(root)) {
          results.push(root);
          if (!deep) {
            return results;
          }
        }
        root.children.forEach(function (child) {
          if (typeof child === 'string') {
            return;
          }
          results.push.apply(results, _findAll(child, predicate, options));
        });
        return results;
      }
      function expectOne(all, message) {
        if (all.length === 1) {
          return all[0];
        }
        var prefix = all.length === 0 ? 'No instances found ' : "Expected 1 but found " + all.length + " instances ";
        throw new Error(prefix + message);
      }
      function propsMatch(props, filter) {
        for (var key in filter) {
          if (props[key] !== filter[key]) {
            return false;
          }
        }
        return true;
      }
      var ReactTestRendererFiber = {
        _Scheduler: Scheduler,
        create: function create(element, options) {
          var createNodeMock = defaultTestOptions.createNodeMock;
          var isConcurrent = false;
          if (typeof options === 'object' && options !== null) {
            if (typeof options.createNodeMock === 'function') {
              createNodeMock = options.createNodeMock;
            }
            if (options.unstable_isConcurrent === true) {
              isConcurrent = true;
            }
          }
          var container = {
            children: [],
            createNodeMock: createNodeMock,
            tag: 'CONTAINER'
          };
          var root = createContainer(container, isConcurrent ? ConcurrentRoot : LegacyRoot, false);
          if (!(root != null)) {
            {
              throw Error("something went wrong");
            }
          }
          updateContainer(element, root, null, null);
          var entry = {
            _Scheduler: Scheduler,
            root: undefined,
            // makes flow happy
            // we define a 'getter' for 'root' below using 'Object.defineProperty'
            toJSON: function toJSON() {
              if (root == null || root.current == null || container == null) {
                return null;
              }
              if (container.children.length === 0) {
                return null;
              }
              if (container.children.length === 1) {
                return _toJSON(container.children[0]);
              }
              if (container.children.length === 2 && container.children[0].isHidden === true && container.children[1].isHidden === false) {
                // Omit timed out children from output entirely, including the fact that we
                // temporarily wrap fallback and timed out children in an array.
                return _toJSON(container.children[1]);
              }
              var renderedChildren = null;
              if (container.children && container.children.length) {
                for (var i = 0; i < container.children.length; i++) {
                  var renderedChild = _toJSON(container.children[i]);
                  if (renderedChild !== null) {
                    if (renderedChildren === null) {
                      renderedChildren = [renderedChild];
                    } else {
                      renderedChildren.push(renderedChild);
                    }
                  }
                }
              }
              return renderedChildren;
            },
            toTree: function toTree() {
              if (root == null || root.current == null) {
                return null;
              }
              return _toTree(root.current);
            },
            update: function update(newElement) {
              if (root == null || root.current == null) {
                return;
              }
              updateContainer(newElement, root, null, null);
            },
            unmount: function unmount() {
              if (root == null || root.current == null) {
                return;
              }
              updateContainer(null, root, null, null);
              container = null;
              root = null;
            },
            getInstance: function getInstance() {
              if (root == null || root.current == null) {
                return null;
              }
              return getPublicRootInstance(root);
            },
            unstable_flushSync: function unstable_flushSync(fn) {
              return flushSync$$1(fn);
            }
          };
          Object.defineProperty(entry, 'root', {
            configurable: true,
            enumerable: true,
            get: function get() {
              if (root === null) {
                throw new Error("Can't access .root on unmounted test renderer");
              }
              var children = getChildren(root.current);
              if (children.length === 0) {
                throw new Error("Can't access .root on unmounted test renderer");
              } else if (children.length === 1) {
                // Normally, we skip the root and just give you the child.
                return children[0];
              } else {
                // However, we give you the root if there's more than one root child.
                // We could make this the behavior for all cases but it would be a breaking change.
                return wrapFiber(root.current);
              }
            }
          });
          return entry;
        },
        /* eslint-disable-next-line camelcase */
        unstable_batchedUpdates: batchedUpdates,
        act: act
      };
      var fiberToWrapper = new WeakMap();
      function wrapFiber(fiber) {
        var wrapper = fiberToWrapper.get(fiber);
        if (wrapper === undefined && fiber.alternate !== null) {
          wrapper = fiberToWrapper.get(fiber.alternate);
        }
        if (wrapper === undefined) {
          wrapper = new ReactTestInstance(fiber);
          fiberToWrapper.set(fiber, wrapper);
        }
        return wrapper;
      } // Enable ReactTestRenderer to be used to test DevTools integration.

      injectIntoDevTools({
        findFiberByHostInstance: function findFiberByHostInstance() {
          throw new Error('TestRenderer does not support findFiberByHostInstance()');
        },
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-test-renderer'
      });

      // TODO: decide on the top-level export form.
      // This is hacky but makes it work with both Rollup and Jest.

      var reactTestRenderer = ReactTestRendererFiber.default || ReactTestRendererFiber;
      module.exports = reactTestRenderer;
    })();
  }
});
var reactTestRenderer = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactTestRenderer_production_min;
  } else {
    module.exports = reactTestRenderer_development;
  }
});
function u$1$1(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!react) throw Error(u$1$1(227));
function ba$1(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);
  try {
    b.apply(c, l);
  } catch (m) {
    this.onError(m);
  }
}
var da = !1,
  ea = null,
  fa = !1,
  ha = null,
  ia = {
    onError: function onError(a) {
      da = !0;
      ea = a;
    }
  };
function ja(a, b, c, d, e, f, g, h, k) {
  da = !1;
  ea = null;
  ba$1.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
  ja.apply(this, arguments);
  if (da) {
    if (da) {
      var l = ea;
      da = !1;
      ea = null;
    } else throw Error(u$1$1(198));
    fa || (fa = !0, ha = l);
  }
}
var la = null,
  ma = null,
  na = null;
function oa(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = na(c);
  ka(d, b, void 0, a);
  a.currentTarget = null;
}
var pa = null,
  qa = {};
function ra() {
  if (pa) for (var a in qa) {
    var b = qa[a],
      c = pa.indexOf(a);
    if (!(-1 < c)) throw Error(u$1$1(96, a));
    if (!sa[c]) {
      if (!b.extractEvents) throw Error(u$1$1(97, a));
      sa[c] = b;
      c = b.eventTypes;
      for (var d in c) {
        var e = void 0;
        var f = c[d],
          g = b,
          h = d;
        if (ta.hasOwnProperty(h)) throw Error(u$1$1(99, h));
        ta[h] = f;
        var k = f.phasedRegistrationNames;
        if (k) {
          for (e in k) k.hasOwnProperty(e) && ua(k[e], g, h);
          e = !0;
        } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
        if (!e) throw Error(u$1$1(98, d, a));
      }
    }
  }
}
function ua(a, b, c) {
  if (va[a]) throw Error(u$1$1(100, a));
  va[a] = b;
  wa[a] = b.eventTypes[c].dependencies;
}
var sa = [],
  ta = {},
  va = {},
  wa = {};
function xa(a) {
  var b = !1,
    c;
  for (c in a) if (a.hasOwnProperty(c)) {
    var d = a[c];
    if (!qa.hasOwnProperty(c) || qa[c] !== d) {
      if (qa[c]) throw Error(u$1$1(102, c));
      qa[c] = d;
      b = !0;
    }
  }
  b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
  za = null,
  Aa = null,
  Ba = null;
function Ca(a) {
  if (a = ma(a)) {
    if ("function" !== typeof za) throw Error(u$1$1(280));
    var b = a.stateNode;
    b && (b = la(b), za(a.stateNode, a.type, b));
  }
}
function Da(a) {
  Aa ? Ba ? Ba.push(a) : Ba = [a] : Aa = a;
}
function Ea() {
  if (Aa) {
    var a = Aa,
      b = Ba;
    Ba = Aa = null;
    Ca(a);
    if (b) for (a = 0; a < b.length; a++) Ca(b[a]);
  }
}
function Fa(a, b) {
  return a(b);
}
function Ga(a, b, c, d, e) {
  return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa,
  Ja = !1,
  Ka = !1;
function La() {
  if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
  if (Ka) return a(b, c);
  Ka = !0;
  try {
    return Ia(a, b, c);
  } finally {
    Ka = !1, La();
  }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  Oa = Object.prototype.hasOwnProperty,
  Pa = {},
  Qa = {};
function Ra(a) {
  if (Oa.call(Qa, a)) return !0;
  if (Oa.call(Pa, a)) return !1;
  if (Na.test(a)) return Qa[a] = !0;
  Pa[a] = !0;
  return !1;
}
function Sa(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;
  switch (typeof b) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      if (d) return !1;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;
    default:
      return !1;
  }
}
function Ta(a, b, c, d) {
  if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
  if (d) return !1;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;
    case 4:
      return !1 === b;
    case 5:
      return isNaN(b);
    case 6:
      return isNaN(b) || 1 > b;
  }
  return !1;
}
function v$1$1(a, b, c, d, e, f) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f;
}
var C$2$1 = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 0, !1, a, null, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  C$2$1[b] = new v$1$1(b, 1, !1, a[1], null, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 2, !1, a.toLowerCase(), null, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 3, !1, a.toLowerCase(), null, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 3, !0, a, null, !1);
});
["capture", "download"].forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 4, !1, a, null, !1);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 6, !1, a, null, !1);
});
["rowSpan", "start"].forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(Ua, Va);
  C$2$1[b] = new v$1$1(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(Ua, Va);
  C$2$1[b] = new v$1$1(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(Ua, Va);
  C$2$1[b] = new v$1$1(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 1, !1, a.toLowerCase(), null, !1);
});
C$2$1.xlinkHref = new v$1$1("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
["src", "href", "action", "formAction"].forEach(function (a) {
  C$2$1[a] = new v$1$1(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
  current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
  suspense: null
});
function Xa(a, b, c, d) {
  var e = C$2$1.hasOwnProperty(b) ? C$2$1[b] : null;
  var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
  f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/,
  E$2$1 = "function" === typeof Symbol && Symbol.for,
  Za = E$2$1 ? Symbol.for("react.element") : 60103,
  $a = E$2$1 ? Symbol.for("react.portal") : 60106,
  ab = E$2$1 ? Symbol.for("react.fragment") : 60107,
  bb = E$2$1 ? Symbol.for("react.strict_mode") : 60108,
  cb = E$2$1 ? Symbol.for("react.profiler") : 60114,
  db = E$2$1 ? Symbol.for("react.provider") : 60109,
  eb = E$2$1 ? Symbol.for("react.context") : 60110,
  fb = E$2$1 ? Symbol.for("react.concurrent_mode") : 60111,
  gb = E$2$1 ? Symbol.for("react.forward_ref") : 60112,
  hb = E$2$1 ? Symbol.for("react.suspense") : 60113,
  ib = E$2$1 ? Symbol.for("react.suspense_list") : 60120,
  jb = E$2$1 ? Symbol.for("react.memo") : 60115,
  kb = E$2$1 ? Symbol.for("react.lazy") : 60116,
  lb = E$2$1 ? Symbol.for("react.block") : 60121,
  mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
  if (null === a || "object" !== typeof a) return null;
  a = mb && a[mb] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}
function ob(a) {
  if (-1 === a._status) {
    a._status = 0;
    var b = a._ctor;
    b = b();
    a._result = b;
    b.then(function (b) {
      0 === a._status && (b = b.default, a._status = 1, a._result = b);
    }, function (b) {
      0 === a._status && (a._status = 2, a._result = b);
    });
  }
}
function pb(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;
  switch (a) {
    case ab:
      return "Fragment";
    case $a:
      return "Portal";
    case cb:
      return "Profiler";
    case bb:
      return "StrictMode";
    case hb:
      return "Suspense";
    case ib:
      return "SuspenseList";
  }
  if ("object" === typeof a) switch (a.$$typeof) {
    case eb:
      return "Context.Consumer";
    case db:
      return "Context.Provider";
    case gb:
      var b = a.render;
      b = b.displayName || b.name || "";
      return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
    case jb:
      return pb(a.type);
    case lb:
      return pb(a.render);
    case kb:
      if (a = 1 === a._status ? a._result : null) return pb(a);
  }
  return null;
}
function qb(a) {
  var b = "";
  do {
    a: switch (a.tag) {
      case 3:
      case 4:
      case 6:
      case 7:
      case 10:
      case 9:
        var c = "";
        break a;
      default:
        var d = a._debugOwner,
          e = a._debugSource,
          f = pb(a.type);
        c = null;
        d && (c = pb(d.type));
        d = f;
        f = "";
        e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
        c = "\n    in " + (d || "Unknown") + f;
    }
    b += c;
    a = a.return;
  } while (a);
  return b;
}
function rb(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return a;
    default:
      return "";
  }
}
function sb(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
  var b = sb(a) ? "checked" : "value",
    c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
    d = "" + a[b];
  if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get,
      f = c.set;
    Object.defineProperty(a, b, {
      configurable: !0,
      get: function get() {
        return e.call(this);
      },
      set: function set(a) {
        d = "" + a;
        f.call(this, a);
      }
    });
    Object.defineProperty(a, b, {
      enumerable: c.enumerable
    });
    return {
      getValue: function getValue() {
        return d;
      },
      setValue: function setValue(a) {
        d = "" + a;
      },
      stopTracking: function stopTracking() {
        a._valueTracker = null;
        delete a[b];
      }
    };
  }
}
function xb(a) {
  a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
  if (!a) return !1;
  var b = a._valueTracker;
  if (!b) return !0;
  var c = b.getValue();
  var d = "";
  a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
  var c = b.checked;
  return objectAssign({}, b, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: null != c ? c : a._wrapperState.initialChecked
  });
}
function Ab(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
    d = null != b.checked ? b.checked : b.defaultChecked;
  c = rb(null != b.value ? b.value : c);
  a._wrapperState = {
    initialChecked: d,
    initialValue: c,
    controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
  };
}
function Bb(a, b) {
  b = b.checked;
  null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
  Bb(a, b);
  var c = rb(b.value),
    d = b.type;
  if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;
    if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }
  c = a.name;
  "" !== c && (a.name = "");
  a.defaultChecked = !!a._wrapperState.initialChecked;
  "" !== c && (a.name = c);
}
function Db(a, b, c) {
  if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
  var b = "";
  react.Children.forEach(a, function (a) {
    null != a && (b += a);
  });
  return b;
}
function Gb(a, b) {
  a = objectAssign({
    children: void 0
  }, b);
  if (b = Fb(b.children)) a.children = b;
  return a;
}
function Hb(a, b, c, d) {
  a = a.options;
  if (b) {
    b = {};
    for (var e = 0; e < c.length; e++) b["$" + c[e]] = !0;
    for (c = 0; c < a.length; c++) e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
  } else {
    c = "" + rb(c);
    b = null;
    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;
        d && (a[e].defaultSelected = !0);
        return;
      }
      null !== b || a[e].disabled || (b = a[e]);
    }
    null !== b && (b.selected = !0);
  }
}
function Ib(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(u$1$1(91));
  return objectAssign({}, b, {
    value: void 0,
    defaultValue: void 0,
    children: "" + a._wrapperState.initialValue
  });
}
function Jb(a, b) {
  var c = b.value;
  if (null == c) {
    c = b.children;
    b = b.defaultValue;
    if (null != c) {
      if (null != b) throw Error(u$1$1(92));
      if (Array.isArray(c)) {
        if (!(1 >= c.length)) throw Error(u$1$1(93));
        c = c[0];
      }
      b = c;
    }
    null == b && (b = "");
    c = b;
  }
  a._wrapperState = {
    initialValue: rb(c)
  };
}
function Kb(a, b) {
  var c = rb(b.value),
    d = rb(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function Ob(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb,
  Qb = function (a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
      MSApp.execUnsafeLocalFunction(function () {
        return a(b, c, d, e);
      });
    } : a;
  }(function (a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;else {
      Pb = Pb || document.createElement("div");
      Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
      for (b = Pb.firstChild; a.firstChild;) a.removeChild(a.firstChild);
      for (; b.firstChild;) a.appendChild(b.firstChild);
    }
  });
function Rb(a, b) {
  if (b) {
    var c = a.firstChild;
    if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;
      return;
    }
  }
  a.textContent = b;
}
function Sb(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
  },
  Ub = {},
  Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
  if (Ub[a]) return Ub[a];
  if (!Tb[a]) return a;
  var b = Tb[a],
    c;
  for (c in b) if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
  return a;
}
var Xb = Wb("animationend"),
  Yb = Wb("animationiteration"),
  Zb = Wb("animationstart"),
  $b = Wb("transitionend"),
  ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
  bc = new ("function" === typeof WeakMap ? WeakMap : Map)();
function cc(a) {
  var b = bc.get(a);
  void 0 === b && (b = new Map(), bc.set(a, b));
  return b;
}
function dc(a) {
  var b = a,
    c = a;
  if (a.alternate) for (; b.return;) b = b.return;else {
    a = b;
    do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return; while (a);
  }
  return 3 === b.tag ? c : null;
}
function ec(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;
    null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
    if (null !== b) return b.dehydrated;
  }
  return null;
}
function fc(a) {
  if (dc(a) !== a) throw Error(u$1$1(188));
}
function gc(a) {
  var b = a.alternate;
  if (!b) {
    b = dc(a);
    if (null === b) throw Error(u$1$1(188));
    return b !== a ? null : a;
  }
  for (var c = a, d = b;;) {
    var e = c.return;
    if (null === e) break;
    var f = e.alternate;
    if (null === f) {
      d = e.return;
      if (null !== d) {
        c = d;
        continue;
      }
      break;
    }
    if (e.child === f.child) {
      for (f = e.child; f;) {
        if (f === c) return fc(e), a;
        if (f === d) return fc(e), b;
        f = f.sibling;
      }
      throw Error(u$1$1(188));
    }
    if (c.return !== d.return) c = e, d = f;else {
      for (var g = !1, h = e.child; h;) {
        if (h === c) {
          g = !0;
          c = e;
          d = f;
          break;
        }
        if (h === d) {
          g = !0;
          d = e;
          c = f;
          break;
        }
        h = h.sibling;
      }
      if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;
            c = f;
            d = e;
            break;
          }
          if (h === d) {
            g = !0;
            d = f;
            c = e;
            break;
          }
          h = h.sibling;
        }
        if (!g) throw Error(u$1$1(189));
      }
    }
    if (c.alternate !== d) throw Error(u$1$1(190));
  }
  if (3 !== c.tag) throw Error(u$1$1(188));
  return c.stateNode.current === c ? a : b;
}
function hc(a) {
  a = gc(a);
  if (!a) return null;
  for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;
    if (b.child) b.child.return = b, b = b.child;else {
      if (b === a) break;
      for (; !b.sibling;) {
        if (!b.return || b.return === a) return null;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
  }
  return null;
}
function ic(a, b) {
  if (null == b) throw Error(u$1$1(30));
  if (null == a) return b;
  if (Array.isArray(a)) {
    if (Array.isArray(b)) return a.push.apply(a, b), a;
    a.push(b);
    return a;
  }
  return Array.isArray(b) ? [a].concat(b) : [a, b];
}
function jc(a, b, c) {
  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
  if (a) {
    var b = a._dispatchListeners,
      c = a._dispatchInstances;
    if (Array.isArray(b)) for (var d = 0; d < b.length && !a.isPropagationStopped(); d++) oa(a, b[d], c[d]);else b && oa(a, b, c);
    a._dispatchListeners = null;
    a._dispatchInstances = null;
    a.isPersistent() || a.constructor.release(a);
  }
}
function mc(a) {
  null !== a && (kc = ic(kc, a));
  a = kc;
  kc = null;
  if (a) {
    jc(a, lc);
    if (kc) throw Error(u$1$1(95));
    if (fa) throw a = ha, fa = !1, ha = null, a;
  }
}
function nc(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
  if (!ya) return !1;
  a = "on" + a;
  var b = (a in document);
  b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
  return b;
}
var pc = [];
function qc(a) {
  a.topLevelType = null;
  a.nativeEvent = null;
  a.targetInst = null;
  a.ancestors.length = 0;
  10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
  if (pc.length) {
    var e = pc.pop();
    e.topLevelType = a;
    e.eventSystemFlags = d;
    e.nativeEvent = b;
    e.targetInst = c;
    return e;
  }
  return {
    topLevelType: a,
    eventSystemFlags: d,
    nativeEvent: b,
    targetInst: c,
    ancestors: []
  };
}
function sc(a) {
  var b = a.targetInst,
    c = b;
  do {
    if (!c) {
      a.ancestors.push(c);
      break;
    }
    var d = c;
    if (3 === d.tag) d = d.stateNode.containerInfo;else {
      for (; d.return;) d = d.return;
      d = 3 !== d.tag ? null : d.stateNode.containerInfo;
    }
    if (!d) break;
    b = c.tag;
    5 !== b && 6 !== b || a.ancestors.push(c);
    c = tc(d);
  } while (c);
  for (c = 0; c < a.ancestors.length; c++) {
    b = a.ancestors[c];
    var e = nc(a.nativeEvent);
    d = a.topLevelType;
    var f = a.nativeEvent,
      g = a.eventSystemFlags;
    0 === c && (g |= 64);
    for (var h = null, k = 0; k < sa.length; k++) {
      var l = sa[k];
      l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
    }
    mc(h);
  }
}
function uc(a, b, c) {
  if (!c.has(a)) {
    switch (a) {
      case "scroll":
        vc(b, "scroll", !0);
        break;
      case "focus":
      case "blur":
        vc(b, "focus", !0);
        vc(b, "blur", !0);
        c.set("blur", null);
        c.set("focus", null);
        break;
      case "cancel":
      case "close":
        oc(a) && vc(b, a, !0);
        break;
      case "invalid":
      case "submit":
      case "reset":
        break;
      default:
        -1 === ac.indexOf(a) && F$2(a, b);
    }
    c.set(a, null);
  }
}
var wc,
  xc,
  yc,
  zc = !1,
  Ac = [],
  Bc = null,
  Cc = null,
  Dc = null,
  Ec = new Map(),
  Fc = new Map(),
  Gc = [],
  Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),
  Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
  var c = cc(b);
  Hc.forEach(function (a) {
    uc(a, b, c);
  });
  Ic.forEach(function (a) {
    uc(a, b, c);
  });
}
function Kc(a, b, c, d, e) {
  return {
    blockedOn: a,
    topLevelType: b,
    eventSystemFlags: c | 32,
    nativeEvent: e,
    container: d
  };
}
function Lc(a, b) {
  switch (a) {
    case "focus":
    case "blur":
      Bc = null;
      break;
    case "dragenter":
    case "dragleave":
      Cc = null;
      break;
    case "mouseover":
    case "mouseout":
      Dc = null;
      break;
    case "pointerover":
    case "pointerout":
      Ec.delete(b.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Fc.delete(b.pointerId);
  }
}
function Mc(a, b, c, d, e, f) {
  if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
  a.eventSystemFlags |= d;
  return a;
}
function Oc(a, b, c, d, e) {
  switch (b) {
    case "focus":
      return Bc = Mc(Bc, a, b, c, d, e), !0;
    case "dragenter":
      return Cc = Mc(Cc, a, b, c, d, e), !0;
    case "mouseover":
      return Dc = Mc(Dc, a, b, c, d, e), !0;
    case "pointerover":
      var f = e.pointerId;
      Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
      return !0;
    case "gotpointercapture":
      return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
  }
  return !1;
}
function Pc(a) {
  var b = tc(a.target);
  if (null !== b) {
    var c = dc(b);
    if (null !== c) if (b = c.tag, 13 === b) {
      if (b = ec(c), null !== b) {
        a.blockedOn = b;
        scheduler.unstable_runWithPriority(a.priority, function () {
          yc(c);
        });
        return;
      }
    } else if (3 === b && c.stateNode.hydrate) {
      a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
      return;
    }
  }
  a.blockedOn = null;
}
function Qc(a) {
  if (null !== a.blockedOn) return !1;
  var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
  if (null !== b) {
    var c = Nc(b);
    null !== c && xc(c);
    a.blockedOn = b;
    return !1;
  }
  return !0;
}
function Sc(a, b, c) {
  Qc(a) && c.delete(b);
}
function Tc() {
  for (zc = !1; 0 < Ac.length;) {
    var a = Ac[0];
    if (null !== a.blockedOn) {
      a = Nc(a.blockedOn);
      null !== a && wc(a);
      break;
    }
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    null !== b ? a.blockedOn = b : Ac.shift();
  }
  null !== Bc && Qc(Bc) && (Bc = null);
  null !== Cc && Qc(Cc) && (Cc = null);
  null !== Dc && Qc(Dc) && (Dc = null);
  Ec.forEach(Sc);
  Fc.forEach(Sc);
}
function Uc(a, b) {
  a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, scheduler.unstable_scheduleCallback(scheduler.unstable_NormalPriority, Tc)));
}
function Vc(a) {
  function b(b) {
    return Uc(b, a);
  }
  if (0 < Ac.length) {
    Uc(Ac[0], a);
    for (var c = 1; c < Ac.length; c++) {
      var d = Ac[c];
      d.blockedOn === a && (d.blockedOn = null);
    }
  }
  null !== Bc && Uc(Bc, a);
  null !== Cc && Uc(Cc, a);
  null !== Dc && Uc(Dc, a);
  Ec.forEach(b);
  Fc.forEach(b);
  for (c = 0; c < Gc.length; c++) d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
  for (; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);) Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {},
  Yc = new Map(),
  Zc = new Map(),
  $c = ["abort", "abort", Xb, "animationEnd", Yb, "animationIteration", Zb, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", $b, "transitionEnd", "waiting", "waiting"];
function ad(a, b) {
  for (var c = 0; c < a.length; c += 2) {
    var d = a[c],
      e = a[c + 1],
      f = "on" + (e[0].toUpperCase() + e.slice(1));
    f = {
      phasedRegistrationNames: {
        bubbled: f,
        captured: f + "Capture"
      },
      dependencies: [d],
      eventPriority: b
    };
    Zc.set(d, b);
    Yc.set(d, f);
    Wc[e] = f;
  }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for (var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++) Zc.set(bd[cd], 0);
var dd = scheduler.unstable_UserBlockingPriority,
  ed = scheduler.unstable_runWithPriority,
  fd = !0;
function F$2(a, b) {
  vc(b, a, !1);
}
function vc(a, b, c) {
  var d = Zc.get(b);
  switch (void 0 === d ? 2 : d) {
    case 0:
      d = gd.bind(null, b, 1, a);
      break;
    case 1:
      d = hd.bind(null, b, 1, a);
      break;
    default:
      d = id.bind(null, b, 1, a);
  }
  c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
  Ja || Ha();
  var e = id,
    f = Ja;
  Ja = !0;
  try {
    Ga(e, a, b, c, d);
  } finally {
    (Ja = f) || La();
  }
}
function hd(a, b, c, d) {
  ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
  if (fd) if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);else {
    var e = Rc(a, b, c, d);
    if (null === e) Lc(a, d);else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);else if (!Oc(e, a, b, c, d)) {
      Lc(a, d);
      a = rc(a, d, null, b);
      try {
        Ma(sc, a);
      } finally {
        qc(a);
      }
    }
  }
}
function Rc(a, b, c, d) {
  c = nc(d);
  c = tc(c);
  if (null !== c) {
    var e = dc(c);
    if (null === e) c = null;else {
      var f = e.tag;
      if (13 === f) {
        c = ec(e);
        if (null !== c) return c;
        c = null;
      } else if (3 === f) {
        if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
        c = null;
      } else e !== c && (c = null);
    }
  }
  a = rc(a, d, c, b);
  try {
    Ma(sc, a);
  } finally {
    qc(a);
  }
  return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
  kd = ["Webkit", "ms", "Moz", "O"];
Object.keys(jd).forEach(function (a) {
  kd.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    jd[b] = jd[a];
  });
});
function ld(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
  a = a.style;
  for (var c in b) if (b.hasOwnProperty(c)) {
    var d = 0 === c.indexOf("--"),
      e = ld(c, b[c], d);
    "float" === c && (c = "cssFloat");
    d ? a.setProperty(c, e) : a[c] = e;
  }
}
var nd = objectAssign({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});
function od(a, b) {
  if (b) {
    if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u$1$1(137, a, ""));
    if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(u$1$1(60));
      if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u$1$1(61));
    }
    if (null != b.style && "object" !== typeof b.style) throw Error(u$1$1(62, ""));
  }
}
function pd(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;
  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var qd = Mb.html;
function rd(a, b) {
  a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
  var c = cc(a);
  b = wa[b];
  for (var d = 0; d < b.length; d++) uc(b[d], a, c);
}
function sd() {}
function td(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;
  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}
function ud(a) {
  for (; a && a.firstChild;) a = a.firstChild;
  return a;
}
function vd(a, b) {
  var c = ud(a);
  a = 0;
  for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;
      if (a <= b && d >= b) return {
        node: c,
        offset: b - a
      };
      a = d;
    }
    a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }
        c = c.parentNode;
      }
      c = void 0;
    }
    c = ud(c);
  }
}
function wd(a, b) {
  return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
  for (var a = window, b = td(); b instanceof a.HTMLIFrameElement;) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = !1;
    }
    if (c) a = b.contentWindow;else break;
    b = td(a.document);
  }
  return b;
}
function yd(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$",
  Ad = "/$",
  Bd = "$?",
  Cd = "$!",
  Dd = null,
  Ed = null;
function Fd(a, b) {
  switch (a) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!b.autoFocus;
  }
  return !1;
}
function Gd(a, b) {
  return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0,
  Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;
    if (1 === b || 3 === b) break;
  }
  return a;
}
function Kd(a) {
  a = a.previousSibling;
  for (var b = 0; a;) {
    if (8 === a.nodeType) {
      var c = a.data;
      if (c === zd || c === Cd || c === Bd) {
        if (0 === b) return a;
        b--;
      } else c === Ad && b++;
    }
    a = a.previousSibling;
  }
  return null;
}
var Ld = Math.random().toString(36).slice(2),
  Md = "__reactInternalInstance$" + Ld,
  Nd = "__reactEventHandlers$" + Ld,
  Od = "__reactContainere$" + Ld;
function tc(a) {
  var b = a[Md];
  if (b) return b;
  for (var c = a.parentNode; c;) {
    if (b = c[Od] || c[Md]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = Kd(a); null !== a;) {
        if (c = a[Md]) return c;
        a = Kd(a);
      }
      return b;
    }
    a = c;
    c = a.parentNode;
  }
  return null;
}
function Nc(a) {
  a = a[Md] || a[Od];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(u$1$1(33));
}
function Qd(a) {
  return a[Nd] || null;
}
function Rd(a) {
  do a = a.return; while (a && 5 !== a.tag);
  return a ? a : null;
}
function Sd(a, b) {
  var c = a.stateNode;
  if (!c) return null;
  var d = la(c);
  if (!d) return null;
  c = d[b];
  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;
    default:
      a = !1;
  }
  if (a) return null;
  if (c && "function" !== typeof c) throw Error(u$1$1(231, b, typeof c));
  return c;
}
function Td(a, b, c) {
  if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    for (var b = a._targetInst, c = []; b;) c.push(b), b = Rd(b);
    for (b = c.length; 0 < b--;) Td(c[b], "captured", a);
    for (b = 0; b < c.length; b++) Td(c[b], "bubbled", a);
  }
}
function Vd(a, b, c) {
  a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
  a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
  jc(a, Ud);
}
var Yd = null,
  Zd = null,
  $d = null;
function ae$1() {
  if ($d) return $d;
  var a,
    b = Zd,
    c = b.length,
    d,
    e = "value" in Yd ? Yd.value : Yd.textContent,
    f = e.length;
  for (a = 0; a < c && b[a] === e[a]; a++);
  var g = c - a;
  for (d = 1; d <= g && b[c - d] === e[f - d]; d++);
  return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
  return !0;
}
function ce$1() {
  return !1;
}
function G$2(a, b, c, d) {
  this.dispatchConfig = a;
  this._targetInst = b;
  this.nativeEvent = c;
  a = this.constructor.Interface;
  for (var e in a) a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
  this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce$1;
  this.isPropagationStopped = ce$1;
  return this;
}
objectAssign(G$2.prototype, {
  preventDefault: function preventDefault() {
    this.defaultPrevented = !0;
    var a = this.nativeEvent;
    a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
  },
  stopPropagation: function stopPropagation() {
    var a = this.nativeEvent;
    a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
  },
  persist: function persist() {
    this.isPersistent = be;
  },
  isPersistent: ce$1,
  destructor: function destructor() {
    var a = this.constructor.Interface,
      b;
    for (b in a) this[b] = null;
    this.nativeEvent = this._targetInst = this.dispatchConfig = null;
    this.isPropagationStopped = this.isDefaultPrevented = ce$1;
    this._dispatchInstances = this._dispatchListeners = null;
  }
});
G$2.Interface = {
  type: null,
  target: null,
  currentTarget: function currentTarget() {
    return null;
  },
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};
G$2.extend = function (a) {
  function b() {}
  function c() {
    return d.apply(this, arguments);
  }
  var d = this;
  b.prototype = d.prototype;
  var e = new b();
  objectAssign(e, c.prototype);
  c.prototype = e;
  c.prototype.constructor = c;
  c.Interface = objectAssign({}, d.Interface, a);
  c.extend = d.extend;
  de(c);
  return c;
};
de(G$2);
function ee$1(a, b, c, d) {
  if (this.eventPool.length) {
    var e = this.eventPool.pop();
    this.call(e, a, b, c, d);
    return e;
  }
  return new this(a, b, c, d);
}
function fe$1(a) {
  if (!(a instanceof this)) throw Error(u$1$1(279));
  a.destructor();
  10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
  a.eventPool = [];
  a.getPooled = ee$1;
  a.release = fe$1;
}
var ge = G$2.extend({
    data: null
  }),
  he$1 = G$2.extend({
    data: null
  }),
  ie$1 = [9, 13, 27, 32],
  je = ya && "CompositionEvent" in window,
  ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le$1 = ya && "TextEvent" in window && !ke,
  me = ya && (!je || ke && 8 < ke && 11 >= ke),
  ne$1 = String.fromCharCode(32),
  oe$1 = {
    beforeInput: {
      phasedRegistrationNames: {
        bubbled: "onBeforeInput",
        captured: "onBeforeInputCapture"
      },
      dependencies: ["compositionend", "keypress", "textInput", "paste"]
    },
    compositionEnd: {
      phasedRegistrationNames: {
        bubbled: "onCompositionEnd",
        captured: "onCompositionEndCapture"
      },
      dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
      phasedRegistrationNames: {
        bubbled: "onCompositionStart",
        captured: "onCompositionStartCapture"
      },
      dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
      phasedRegistrationNames: {
        bubbled: "onCompositionUpdate",
        captured: "onCompositionUpdateCapture"
      },
      dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
  },
  pe$1 = !1;
function qe(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== ie$1.indexOf(b.keyCode);
    case "keydown":
      return 229 !== b.keyCode;
    case "keypress":
    case "mousedown":
    case "blur":
      return !0;
    default:
      return !1;
  }
}
function re$1(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}
var se$1 = !1;
function te$1(a, b) {
  switch (a) {
    case "compositionend":
      return re$1(b);
    case "keypress":
      if (32 !== b.which) return null;
      pe$1 = !0;
      return ne$1;
    case "textInput":
      return a = b.data, a === ne$1 && pe$1 ? null : a;
    default:
      return null;
  }
}
function ue$1(a, b) {
  if (se$1) return "compositionend" === a || !je && qe(a, b) ? (a = ae$1(), $d = Zd = Yd = null, se$1 = !1, a) : null;
  switch (a) {
    case "paste":
      return null;
    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;
        if (b.which) return String.fromCharCode(b.which);
      }
      return null;
    case "compositionend":
      return me && "ko" !== b.locale ? null : b.data;
    default:
      return null;
  }
}
var ve$1 = {
    eventTypes: oe$1,
    extractEvents: function extractEvents(a, b, c, d) {
      var e;
      if (je) b: {
        switch (a) {
          case "compositionstart":
            var f = oe$1.compositionStart;
            break b;
          case "compositionend":
            f = oe$1.compositionEnd;
            break b;
          case "compositionupdate":
            f = oe$1.compositionUpdate;
            break b;
        }
        f = void 0;
      } else se$1 ? qe(a, c) && (f = oe$1.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe$1.compositionStart);
      f ? (me && "ko" !== c.locale && (se$1 || f !== oe$1.compositionStart ? f === oe$1.compositionEnd && se$1 && (e = ae$1()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se$1 = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re$1(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
      (a = le$1 ? te$1(a, c) : ue$1(a, c)) ? (b = he$1.getPooled(oe$1.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
      return null === e ? b : null === b ? e : [e, b];
    }
  },
  we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
function xe(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
  change: {
    phasedRegistrationNames: {
      bubbled: "onChange",
      captured: "onChangeCapture"
    },
    dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
  }
};
function ze(a, b, c) {
  a = G$2.getPooled(ye.change, a, b, c);
  a.type = "change";
  Da(c);
  Xd(a);
  return a;
}
var Ae = null,
  Be = null;
function Ce(a) {
  mc(a);
}
function De(a) {
  var b = Pd(a);
  if (yb(b)) return a;
}
function Ee(a, b) {
  if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
  Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
  if ("value" === a.propertyName && De(Be)) if (a = ze(Be, a, nc(a)), Ja) mc(a);else {
    Ja = !0;
    try {
      Fa(Ce, a);
    } finally {
      Ja = !1, La();
    }
  }
}
function Ie(a, b, c) {
  "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
  if ("click" === a) return De(b);
}
function Le(a, b) {
  if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = b ? Pd(b) : window,
        f = e.nodeName && e.nodeName.toLowerCase();
      if ("select" === f || "input" === f && "file" === e.type) var g = Ee;else if (xe(e)) {
        if (Fe) g = Le;else {
          g = Je;
          var h = Ie;
        }
      } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
      if (g && (g = g(a, b))) return ze(g, c, d);
      h && h(a, e, b);
      "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
  },
  Ne = G$2.extend({
    view: null,
    detail: null
  }),
  Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
function Pe(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
  return Pe;
}
var Re = 0,
  Se = 0,
  Te = !1,
  Ue = !1,
  Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function relatedTarget(a) {
      return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function movementX(a) {
      if ("movementX" in a) return a.movementX;
      var b = Re;
      Re = a.screenX;
      return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function movementY(a) {
      if ("movementY" in a) return a.movementY;
      var b = Se;
      Se = a.screenY;
      return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
  }),
  We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
  }),
  Xe = {
    mouseEnter: {
      registrationName: "onMouseEnter",
      dependencies: ["mouseout", "mouseover"]
    },
    mouseLeave: {
      registrationName: "onMouseLeave",
      dependencies: ["mouseout", "mouseover"]
    },
    pointerEnter: {
      registrationName: "onPointerEnter",
      dependencies: ["pointerout", "pointerover"]
    },
    pointerLeave: {
      registrationName: "onPointerLeave",
      dependencies: ["pointerout", "pointerover"]
    }
  },
  Ye = {
    eventTypes: Xe,
    extractEvents: function extractEvents(a, b, c, d, e) {
      var f = "mouseover" === a || "pointerover" === a,
        g = "mouseout" === a || "pointerout" === a;
      if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
      f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
      if (g) {
        if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
          var h = dc(b);
          if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
        }
      } else g = null;
      if (g === b) return null;
      if ("mouseout" === a || "mouseover" === a) {
        var k = Ve;
        var l = Xe.mouseLeave;
        var m = Xe.mouseEnter;
        var p = "mouse";
      } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
      a = null == g ? f : Pd(g);
      f = null == b ? f : Pd(b);
      l = k.getPooled(l, g, c, d);
      l.type = p + "leave";
      l.target = a;
      l.relatedTarget = f;
      c = k.getPooled(m, b, c, d);
      c.type = p + "enter";
      c.target = f;
      c.relatedTarget = a;
      d = g;
      p = b;
      if (d && p) a: {
        k = d;
        m = p;
        g = 0;
        for (a = k; a; a = Rd(a)) g++;
        a = 0;
        for (b = m; b; b = Rd(b)) a++;
        for (; 0 < g - a;) k = Rd(k), g--;
        for (; 0 < a - g;) m = Rd(m), a--;
        for (; g--;) {
          if (k === m || k === m.alternate) break a;
          k = Rd(k);
          m = Rd(m);
        }
        k = null;
      } else k = null;
      m = k;
      for (k = []; d && d !== m;) {
        g = d.alternate;
        if (null !== g && g === m) break;
        k.push(d);
        d = Rd(d);
      }
      for (d = []; p && p !== m;) {
        g = p.alternate;
        if (null !== g && g === m) break;
        d.push(p);
        p = Rd(p);
      }
      for (p = 0; p < k.length; p++) Vd(k[p], "bubbled", l);
      for (p = d.length; 0 < p--;) Vd(d[p], "captured", c);
      return 0 === (e & 64) ? [l] : [l, c];
    }
  };
function Ze(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze,
  af = Object.prototype.hasOwnProperty;
function bf(a, b) {
  if ($e(a, b)) return !0;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
  var c = Object.keys(a),
    d = Object.keys(b);
  if (c.length !== d.length) return !1;
  for (d = 0; d < c.length; d++) if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
  return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode,
  df = {
    select: {
      phasedRegistrationNames: {
        bubbled: "onSelect",
        captured: "onSelectCapture"
      },
      dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
  },
  ef = null,
  ff = null,
  gf = null,
  hf = !1;
function jf(a, b) {
  var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
  if (hf || null == ef || ef !== td(c)) return null;
  c = ef;
  "selectionStart" in c && yd(c) ? c = {
    start: c.selectionStart,
    end: c.selectionEnd
  } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
    anchorNode: c.anchorNode,
    anchorOffset: c.anchorOffset,
    focusNode: c.focusNode,
    focusOffset: c.focusOffset
  });
  return gf && bf(gf, c) ? null : (gf = c, a = G$2.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function extractEvents(a, b, c, d, e, f) {
      e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
      if (!(f = !e)) {
        a: {
          e = cc(e);
          f = wa.onSelect;
          for (var g = 0; g < f.length; g++) if (!e.has(f[g])) {
            e = !1;
            break a;
          }
          e = !0;
        }
        f = !e;
      }
      if (f) return null;
      e = b ? Pd(b) : window;
      switch (a) {
        case "focus":
          if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
          break;
        case "blur":
          gf = ff = ef = null;
          break;
        case "mousedown":
          hf = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          return hf = !1, jf(c, d);
        case "selectionchange":
          if (cf) break;
        case "keydown":
        case "keyup":
          return jf(c, d);
      }
      return null;
    }
  },
  lf = G$2.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
  mf = G$2.extend({
    clipboardData: function clipboardData(a) {
      return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
  }),
  nf = Ne.extend({
    relatedTarget: null
  });
function of(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
  qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
  rf = Ne.extend({
    key: function key(a) {
      if (a.key) {
        var b = pf[a.key] || a.key;
        if ("Unidentified" !== b) return b;
      }
      return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function charCode(a) {
      return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function keyCode(a) {
      return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
      return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
  }),
  sf = Ve.extend({
    dataTransfer: null
  }),
  tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
  }),
  uf = G$2.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
  vf = Ve.extend({
    deltaX: function deltaX(a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
  }),
  wf = {
    eventTypes: Wc,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = Yc.get(a);
      if (!e) return null;
      switch (a) {
        case "keypress":
          if (0 === of(c)) return null;
        case "keydown":
        case "keyup":
          a = rf;
          break;
        case "blur":
        case "focus":
          a = nf;
          break;
        case "click":
          if (2 === c.button) return null;
        case "auxclick":
        case "dblclick":
        case "mousedown":
        case "mousemove":
        case "mouseup":
        case "mouseout":
        case "mouseover":
        case "contextmenu":
          a = Ve;
          break;
        case "drag":
        case "dragend":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "dragstart":
        case "drop":
          a = sf;
          break;
        case "touchcancel":
        case "touchend":
        case "touchmove":
        case "touchstart":
          a = tf;
          break;
        case Xb:
        case Yb:
        case Zb:
          a = lf;
          break;
        case $b:
          a = uf;
          break;
        case "scroll":
          a = Ne;
          break;
        case "wheel":
          a = vf;
          break;
        case "copy":
        case "cut":
        case "paste":
          a = mf;
          break;
        case "gotpointercapture":
        case "lostpointercapture":
        case "pointercancel":
        case "pointerdown":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerup":
          a = We;
          break;
        default:
          a = G$2;
      }
      b = a.getPooled(e, b, c, d);
      Xd(b);
      return b;
    }
  };
if (pa) throw Error(u$1$1(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
  SimpleEventPlugin: wf,
  EnterLeaveEventPlugin: Ye,
  ChangeEventPlugin: Me,
  SelectEventPlugin: kf,
  BeforeInputEventPlugin: ve$1
});
var yf = [],
  zf = -1;
function H$2$1(a) {
  0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I$2(a, b) {
  zf++;
  yf[zf] = a.current;
  a.current = b;
}
var Af = {},
  J$2 = {
    current: Af
  },
  K$2 = {
    current: !1
  },
  Bf = Af;
function Cf(a, b) {
  var c = a.type.contextTypes;
  if (!c) return Af;
  var d = a.stateNode;
  if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
  var e = {},
    f;
  for (f in c) e[f] = b[f];
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}
function L$2$1(a) {
  a = a.childContextTypes;
  return null !== a && void 0 !== a;
}
function Df() {
  H$2$1(K$2);
  H$2$1(J$2);
}
function Ef(a, b, c) {
  if (J$2.current !== Af) throw Error(u$1$1(168));
  I$2(J$2, b);
  I$2(K$2, c);
}
function Ff(a, b, c) {
  var d = a.stateNode;
  a = b.childContextTypes;
  if ("function" !== typeof d.getChildContext) return c;
  d = d.getChildContext();
  for (var e in d) if (!(e in a)) throw Error(u$1$1(108, pb(b) || "Unknown", e));
  return objectAssign({}, c, {}, d);
}
function Gf(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
  Bf = J$2.current;
  I$2(J$2, a);
  I$2(K$2, K$2.current);
  return !0;
}
function Hf(a, b, c) {
  var d = a.stateNode;
  if (!d) throw Error(u$1$1(169));
  c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H$2$1(K$2), H$2$1(J$2), I$2(J$2, a)) : H$2$1(K$2);
  I$2(K$2, c);
}
var If = scheduler.unstable_runWithPriority,
  Jf = scheduler.unstable_scheduleCallback,
  Kf = scheduler.unstable_cancelCallback,
  Lf = scheduler.unstable_requestPaint,
  Mf = scheduler.unstable_now,
  Nf = scheduler.unstable_getCurrentPriorityLevel,
  Of = scheduler.unstable_ImmediatePriority,
  Pf = scheduler.unstable_UserBlockingPriority,
  Qf = scheduler.unstable_NormalPriority,
  Rf = scheduler.unstable_LowPriority,
  Sf = scheduler.unstable_IdlePriority,
  Tf = {},
  Uf = scheduler.unstable_shouldYield,
  Vf = void 0 !== Lf ? Lf : function () {},
  Wf = null,
  Xf = null,
  Yf = !1,
  Zf = Mf(),
  $f = 1E4 > Zf ? Mf : function () {
    return Mf() - Zf;
  };
function ag() {
  switch (Nf()) {
    case Of:
      return 99;
    case Pf:
      return 98;
    case Qf:
      return 97;
    case Rf:
      return 96;
    case Sf:
      return 95;
    default:
      throw Error(u$1$1(332));
  }
}
function bg(a) {
  switch (a) {
    case 99:
      return Of;
    case 98:
      return Pf;
    case 97:
      return Qf;
    case 96:
      return Rf;
    case 95:
      return Sf;
    default:
      throw Error(u$1$1(332));
  }
}
function cg(a, b) {
  a = bg(a);
  return If(a, b);
}
function dg(a, b, c) {
  a = bg(a);
  return Jf(a, b, c);
}
function eg(a) {
  null === Wf ? (Wf = [a], Xf = Jf(Of, fg)) : Wf.push(a);
  return Tf;
}
function gg() {
  if (null !== Xf) {
    var a = Xf;
    Xf = null;
    Kf(a);
  }
  fg();
}
function fg() {
  if (!Yf && null !== Wf) {
    Yf = !0;
    var a = 0;
    try {
      var b = Wf;
      cg(99, function () {
        for (; a < b.length; a++) {
          var c = b[a];
          do c = c(!0); while (null !== c);
        }
      });
      Wf = null;
    } catch (c) {
      throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
    } finally {
      Yf = !1;
    }
  }
}
function hg(a, b, c) {
  c /= 10;
  return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
  if (a && a.defaultProps) {
    b = objectAssign({}, b);
    a = a.defaultProps;
    for (var c in a) void 0 === b[c] && (b[c] = a[c]);
  }
  return b;
}
var jg = {
    current: null
  },
  kg = null,
  lg = null,
  mg = null;
function ng() {
  mg = lg = kg = null;
}
function og(a) {
  var b = jg.current;
  H$2$1(jg);
  a.type._context._currentValue = b;
}
function pg(a, b) {
  for (; null !== a;) {
    var c = a.alternate;
    if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;else break;
    a = a.return;
  }
}
function qg(a, b) {
  kg = a;
  mg = lg = null;
  a = a.dependencies;
  null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
  if (mg !== a && !1 !== b && 0 !== b) {
    if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
    b = {
      context: a,
      observedBits: b,
      next: null
    };
    if (null === lg) {
      if (null === kg) throw Error(u$1$1(308));
      lg = b;
      kg.dependencies = {
        expirationTime: 0,
        firstContext: b,
        responders: null
      };
    } else lg = lg.next = b;
  }
  return a._currentValue;
}
var tg = !1;
function ug(a) {
  a.updateQueue = {
    baseState: a.memoizedState,
    baseQueue: null,
    shared: {
      pending: null
    },
    effects: null
  };
}
function vg(a, b) {
  a = a.updateQueue;
  b.updateQueue === a && (b.updateQueue = {
    baseState: a.baseState,
    baseQueue: a.baseQueue,
    shared: a.shared,
    effects: a.effects
  });
}
function wg(a, b) {
  a = {
    expirationTime: a,
    suspenseConfig: b,
    tag: 0,
    payload: null,
    callback: null,
    next: null
  };
  return a.next = a;
}
function xg(a, b) {
  a = a.updateQueue;
  if (null !== a) {
    a = a.shared;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
  }
}
function yg(a, b) {
  var c = a.alternate;
  null !== c && vg(c, a);
  a = a.updateQueue;
  c = a.baseQueue;
  null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
  var e = a.updateQueue;
  tg = !1;
  var f = e.baseQueue,
    g = e.shared.pending;
  if (null !== g) {
    if (null !== f) {
      var h = f.next;
      f.next = g.next;
      g.next = h;
    }
    f = g;
    e.shared.pending = null;
    h = a.alternate;
    null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
  }
  if (null !== f) {
    h = f.next;
    var k = e.baseState,
      l = 0,
      m = null,
      p = null,
      x = null;
    if (null !== h) {
      var z = h;
      do {
        g = z.expirationTime;
        if (g < d) {
          var ca = {
            expirationTime: z.expirationTime,
            suspenseConfig: z.suspenseConfig,
            tag: z.tag,
            payload: z.payload,
            callback: z.callback,
            next: null
          };
          null === x ? (p = x = ca, m = k) : x = x.next = ca;
          g > l && (l = g);
        } else {
          null !== x && (x = x.next = {
            expirationTime: 1073741823,
            suspenseConfig: z.suspenseConfig,
            tag: z.tag,
            payload: z.payload,
            callback: z.callback,
            next: null
          });
          Ag(g, z.suspenseConfig);
          a: {
            var D = a,
              t = z;
            g = b;
            ca = c;
            switch (t.tag) {
              case 1:
                D = t.payload;
                if ("function" === typeof D) {
                  k = D.call(ca, k, g);
                  break a;
                }
                k = D;
                break a;
              case 3:
                D.effectTag = D.effectTag & -4097 | 64;
              case 0:
                D = t.payload;
                g = "function" === typeof D ? D.call(ca, k, g) : D;
                if (null === g || void 0 === g) break a;
                k = objectAssign({}, k, g);
                break a;
              case 2:
                tg = !0;
            }
          }
          null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [z] : g.push(z));
        }
        z = z.next;
        if (null === z || z === h) if (g = e.shared.pending, null === g) break;else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
      } while (1);
    }
    null === x ? m = k : x.next = p;
    e.baseState = m;
    e.baseQueue = x;
    Bg(l);
    a.expirationTime = l;
    a.memoizedState = k;
  }
}
function Cg(a, b, c) {
  a = b.effects;
  b.effects = null;
  if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b],
      e = d.callback;
    if (null !== e) {
      d.callback = null;
      d = e;
      e = c;
      if ("function" !== typeof d) throw Error(u$1$1(191, d));
      d.call(e);
    }
  }
}
var Dg = Wa.ReactCurrentBatchConfig,
  Eg = new react.Component().refs;
function Fg(a, b, c, d) {
  b = a.memoizedState;
  c = c(d, b);
  c = null === c || void 0 === c ? b : objectAssign({}, b, c);
  a.memoizedState = c;
  0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
  isMounted: function isMounted(a) {
    return (a = a._reactInternalFiber) ? dc(a) === a : !1;
  },
  enqueueSetState: function enqueueSetState(a, b, c) {
    a = a._reactInternalFiber;
    var d = Gg(),
      e = Dg.suspense;
    d = Hg(d, a, e);
    e = wg(d, e);
    e.payload = b;
    void 0 !== c && null !== c && (e.callback = c);
    xg(a, e);
    Ig(a, d);
  },
  enqueueReplaceState: function enqueueReplaceState(a, b, c) {
    a = a._reactInternalFiber;
    var d = Gg(),
      e = Dg.suspense;
    d = Hg(d, a, e);
    e = wg(d, e);
    e.tag = 1;
    e.payload = b;
    void 0 !== c && null !== c && (e.callback = c);
    xg(a, e);
    Ig(a, d);
  },
  enqueueForceUpdate: function enqueueForceUpdate(a, b) {
    a = a._reactInternalFiber;
    var c = Gg(),
      d = Dg.suspense;
    c = Hg(c, a, d);
    d = wg(c, d);
    d.tag = 2;
    void 0 !== b && null !== b && (d.callback = b);
    xg(a, d);
    Ig(a, c);
  }
};
function Kg(a, b, c, d, e, f, g) {
  a = a.stateNode;
  return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
  var d = !1,
    e = Af;
  var f = b.contextType;
  "object" === typeof f && null !== f ? f = sg(f) : (e = L$2$1(b) ? Bf : J$2.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
  b = new b(c, f);
  a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
  b.updater = Jg;
  a.stateNode = b;
  b._reactInternalFiber = a;
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
  return b;
}
function Mg(a, b, c, d) {
  a = b.state;
  "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
  "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
  b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = Eg;
  ug(a);
  var f = b.contextType;
  "object" === typeof f && null !== f ? e.context = sg(f) : (f = L$2$1(b) ? Bf : J$2.current, e.context = Cf(a, f));
  zg(a, c, e, d);
  e.state = a.memoizedState;
  f = b.getDerivedStateFromProps;
  "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
  "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
  "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
  a = c.ref;
  if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;
      if (c) {
        if (1 !== c.tag) throw Error(u$1$1(309));
        var d = c.stateNode;
      }
      if (!d) throw Error(u$1$1(147, a));
      var e = "" + a;
      if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
      b = function b(a) {
        var b = d.refs;
        b === Eg && (b = d.refs = {});
        null === a ? delete b[e] : b[e] = a;
      };
      b._stringRef = e;
      return b;
    }
    if ("string" !== typeof a) throw Error(u$1$1(284));
    if (!c._owner) throw Error(u$1$1(290, a));
  }
  return a;
}
function Qg(a, b) {
  if ("textarea" !== a.type) throw Error(u$1$1(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
  function b(b, c) {
    if (a) {
      var d = b.lastEffect;
      null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
      c.nextEffect = null;
      c.effectTag = 8;
    }
  }
  function c(c, d) {
    if (!a) return null;
    for (; null !== d;) b(c, d), d = d.sibling;
    return null;
  }
  function d(a, b) {
    for (a = new Map(); null !== b;) null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    return a;
  }
  function e(a, b) {
    a = Sg(a, b);
    a.index = 0;
    a.sibling = null;
    return a;
  }
  function f(b, c, d) {
    b.index = d;
    if (!a) return c;
    d = b.alternate;
    if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
    b.effectTag = 2;
    return c;
  }
  function g(b) {
    a && null === b.alternate && (b.effectTag = 2);
    return b;
  }
  function h(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
    b = e(b, c);
    b.return = a;
    return b;
  }
  function k(a, b, c, d) {
    if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
    d = Ug(c.type, c.key, c.props, null, a.mode, d);
    d.ref = Pg(a, b, c);
    d.return = a;
    return d;
  }
  function l(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
    b = e(b, c.children || []);
    b.return = a;
    return b;
  }
  function m(a, b, c, d, f) {
    if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
    b = e(b, c);
    b.return = a;
    return b;
  }
  function p(a, b, c) {
    if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
    if ("object" === typeof b && null !== b) {
      switch (b.$$typeof) {
        case Za:
          return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
        case $a:
          return b = Vg(b, a.mode, c), b.return = a, b;
      }
      if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
      Qg(a, b);
    }
    return null;
  }
  function x(a, b, c, d) {
    var e = null !== b ? b.key : null;
    if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
    if ("object" === typeof c && null !== c) {
      switch (c.$$typeof) {
        case Za:
          return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
        case $a:
          return c.key === e ? l(a, b, c, d) : null;
      }
      if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
      Qg(a, c);
    }
    return null;
  }
  function z(a, b, c, d, e) {
    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
    if ("object" === typeof d && null !== d) {
      switch (d.$$typeof) {
        case Za:
          return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
        case $a:
          return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
      }
      if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
      Qg(b, d);
    }
    return null;
  }
  function ca(e, g, h, k) {
    for (var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++) {
      m.index > y ? (A = m, m = null) : A = m.sibling;
      var q = x(e, m, h[y], k);
      if (null === q) {
        null === m && (m = A);
        break;
      }
      a && m && null === q.alternate && b(e, m);
      g = f(q, g, y);
      null === t ? l = q : t.sibling = q;
      t = q;
      m = A;
    }
    if (y === h.length) return c(e, m), l;
    if (null === m) {
      for (; y < h.length; y++) m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
      return l;
    }
    for (m = d(e, m); y < h.length; y++) A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
    a && m.forEach(function (a) {
      return b(e, a);
    });
    return l;
  }
  function D(e, g, h, l) {
    var k = nb(h);
    if ("function" !== typeof k) throw Error(u$1$1(150));
    h = k.call(h);
    if (null == h) throw Error(u$1$1(151));
    for (var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()) {
      t.index > y ? (A = t, t = null) : A = t.sibling;
      var D = x(e, t, q.value, l);
      if (null === D) {
        null === t && (t = A);
        break;
      }
      a && t && null === D.alternate && b(e, t);
      g = f(D, g, y);
      null === m ? k = D : m.sibling = D;
      m = D;
      t = A;
    }
    if (q.done) return c(e, t), k;
    if (null === t) {
      for (; !q.done; y++, q = h.next()) q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
      return k;
    }
    for (t = d(e, t); !q.done; y++, q = h.next()) q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
    a && t.forEach(function (a) {
      return b(e, a);
    });
    return k;
  }
  return function (a, d, f, h) {
    var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
    k && (f = f.props.children);
    var l = "object" === typeof f && null !== f;
    if (l) switch (f.$$typeof) {
      case Za:
        a: {
          l = f.key;
          for (k = d; null !== k;) {
            if (k.key === l) {
              switch (k.tag) {
                case 7:
                  if (f.type === ab) {
                    c(a, k.sibling);
                    d = e(k, f.props.children);
                    d.return = a;
                    a = d;
                    break a;
                  }
                  break;
                default:
                  if (k.elementType === f.type) {
                    c(a, k.sibling);
                    d = e(k, f.props);
                    d.ref = Pg(a, k, f);
                    d.return = a;
                    a = d;
                    break a;
                  }
              }
              c(a, k);
              break;
            } else b(a, k);
            k = k.sibling;
          }
          f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
        }
        return g(a);
      case $a:
        a: {
          for (k = f.key; null !== d;) {
            if (d.key === k) {
              if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                c(a, d.sibling);
                d = e(d, f.children || []);
                d.return = a;
                a = d;
                break a;
              } else {
                c(a, d);
                break;
              }
            } else b(a, d);
            d = d.sibling;
          }
          d = Vg(f, a.mode, h);
          d.return = a;
          a = d;
        }
        return g(a);
    }
    if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
    if (Og(f)) return ca(a, d, f, h);
    if (nb(f)) return D(a, d, f, h);
    l && Qg(a, f);
    if ("undefined" === typeof f && !k) switch (a.tag) {
      case 1:
      case 0:
        throw a = a.type, Error(u$1$1(152, a.displayName || a.name || "Component"));
    }
    return c(a, d);
  };
}
var Xg = Rg(!0),
  Yg = Rg(!1),
  Zg = {},
  $g = {
    current: Zg
  },
  ah = {
    current: Zg
  },
  bh = {
    current: Zg
  };
function ch(a) {
  if (a === Zg) throw Error(u$1$1(174));
  return a;
}
function dh(a, b) {
  I$2(bh, b);
  I$2(ah, a);
  I$2($g, Zg);
  a = b.nodeType;
  switch (a) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
      break;
    default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
  }
  H$2$1($g);
  I$2($g, b);
}
function eh() {
  H$2$1($g);
  H$2$1(ah);
  H$2$1(bh);
}
function fh(a) {
  ch(bh.current);
  var b = ch($g.current);
  var c = Ob(b, a.type);
  b !== c && (I$2(ah, a), I$2($g, c));
}
function gh(a) {
  ah.current === a && (H$2$1($g), H$2$1(ah));
}
var M$2 = {
  current: 0
};
function hh(a) {
  for (var b = a; null !== b;) {
    if (13 === b.tag) {
      var c = b.memoizedState;
      if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.effectTag & 64)) return b;
    } else if (null !== b.child) {
      b.child.return = b;
      b = b.child;
      continue;
    }
    if (b === a) break;
    for (; null === b.sibling;) {
      if (null === b.return || b.return === a) return null;
      b = b.return;
    }
    b.sibling.return = b.return;
    b = b.sibling;
  }
  return null;
}
function ih(a, b) {
  return {
    responder: a,
    props: b
  };
}
var jh = Wa.ReactCurrentDispatcher,
  kh = Wa.ReactCurrentBatchConfig,
  lh = 0,
  N$2 = null,
  O$2 = null,
  P$1$1 = null,
  mh = !1;
function Q$1$1() {
  throw Error(u$1$1(321));
}
function nh(a, b) {
  if (null === b) return !1;
  for (var c = 0; c < b.length && c < a.length; c++) if (!$e(a[c], b[c])) return !1;
  return !0;
}
function oh(a, b, c, d, e, f) {
  lh = f;
  N$2 = b;
  b.memoizedState = null;
  b.updateQueue = null;
  b.expirationTime = 0;
  jh.current = null === a || null === a.memoizedState ? ph : qh;
  a = c(d, e);
  if (b.expirationTime === lh) {
    f = 0;
    do {
      b.expirationTime = 0;
      if (!(25 > f)) throw Error(u$1$1(301));
      f += 1;
      P$1$1 = O$2 = null;
      b.updateQueue = null;
      jh.current = rh;
      a = c(d, e);
    } while (b.expirationTime === lh);
  }
  jh.current = sh;
  b = null !== O$2 && null !== O$2.next;
  lh = 0;
  P$1$1 = O$2 = N$2 = null;
  mh = !1;
  if (b) throw Error(u$1$1(300));
  return a;
}
function th() {
  var a = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  null === P$1$1 ? N$2.memoizedState = P$1$1 = a : P$1$1 = P$1$1.next = a;
  return P$1$1;
}
function uh() {
  if (null === O$2) {
    var a = N$2.alternate;
    a = null !== a ? a.memoizedState : null;
  } else a = O$2.next;
  var b = null === P$1$1 ? N$2.memoizedState : P$1$1.next;
  if (null !== b) P$1$1 = b, O$2 = a;else {
    if (null === a) throw Error(u$1$1(310));
    O$2 = a;
    a = {
      memoizedState: O$2.memoizedState,
      baseState: O$2.baseState,
      baseQueue: O$2.baseQueue,
      queue: O$2.queue,
      next: null
    };
    null === P$1$1 ? N$2.memoizedState = P$1$1 = a : P$1$1 = P$1$1.next = a;
  }
  return P$1$1;
}
function vh(a, b) {
  return "function" === typeof b ? b(a) : b;
}
function wh(a) {
  var b = uh(),
    c = b.queue;
  if (null === c) throw Error(u$1$1(311));
  c.lastRenderedReducer = a;
  var d = O$2,
    e = d.baseQueue,
    f = c.pending;
  if (null !== f) {
    if (null !== e) {
      var g = e.next;
      e.next = f.next;
      f.next = g;
    }
    d.baseQueue = e = f;
    c.pending = null;
  }
  if (null !== e) {
    e = e.next;
    d = d.baseState;
    var h = g = f = null,
      k = e;
    do {
      var l = k.expirationTime;
      if (l < lh) {
        var m = {
          expirationTime: k.expirationTime,
          suspenseConfig: k.suspenseConfig,
          action: k.action,
          eagerReducer: k.eagerReducer,
          eagerState: k.eagerState,
          next: null
        };
        null === h ? (g = h = m, f = d) : h = h.next = m;
        l > N$2.expirationTime && (N$2.expirationTime = l, Bg(l));
      } else null !== h && (h = h.next = {
        expirationTime: 1073741823,
        suspenseConfig: k.suspenseConfig,
        action: k.action,
        eagerReducer: k.eagerReducer,
        eagerState: k.eagerState,
        next: null
      }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
      k = k.next;
    } while (null !== k && k !== e);
    null === h ? f = d : h.next = g;
    $e(d, b.memoizedState) || (rg = !0);
    b.memoizedState = d;
    b.baseState = f;
    b.baseQueue = h;
    c.lastRenderedState = d;
  }
  return [b.memoizedState, c.dispatch];
}
function xh(a) {
  var b = uh(),
    c = b.queue;
  if (null === c) throw Error(u$1$1(311));
  c.lastRenderedReducer = a;
  var d = c.dispatch,
    e = c.pending,
    f = b.memoizedState;
  if (null !== e) {
    c.pending = null;
    var g = e = e.next;
    do f = a(f, g.action), g = g.next; while (g !== e);
    $e(f, b.memoizedState) || (rg = !0);
    b.memoizedState = f;
    null === b.baseQueue && (b.baseState = f);
    c.lastRenderedState = f;
  }
  return [f, d];
}
function yh(a) {
  var b = th();
  "function" === typeof a && (a = a());
  b.memoizedState = b.baseState = a;
  a = b.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: vh,
    lastRenderedState: a
  };
  a = a.dispatch = zh.bind(null, N$2, a);
  return [b.memoizedState, a];
}
function Ah(a, b, c, d) {
  a = {
    tag: a,
    create: b,
    destroy: c,
    deps: d,
    next: null
  };
  b = N$2.updateQueue;
  null === b ? (b = {
    lastEffect: null
  }, N$2.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
  return a;
}
function Bh() {
  return uh().memoizedState;
}
function Ch(a, b, c, d) {
  var e = th();
  N$2.effectTag |= a;
  e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
  var e = uh();
  d = void 0 === d ? null : d;
  var f = void 0;
  if (null !== O$2) {
    var g = O$2.memoizedState;
    f = g.destroy;
    if (null !== d && nh(d, g.deps)) {
      Ah(b, c, f, d);
      return;
    }
  }
  N$2.effectTag |= a;
  e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
  return Ch(516, 4, a, b);
}
function Fh(a, b) {
  return Dh(516, 4, a, b);
}
function Gh(a, b) {
  return Dh(4, 2, a, b);
}
function Hh(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function () {
    b(null);
  };
  if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
    b.current = null;
  };
}
function Ih(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
  th().memoizedState = [a, void 0 === b ? null : b];
  return a;
}
function Lh(a, b) {
  var c = uh();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && nh(b, d[1])) return d[0];
  c.memoizedState = [a, b];
  return a;
}
function Mh(a, b) {
  var c = uh();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && nh(b, d[1])) return d[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}
function Nh(a, b, c) {
  var d = ag();
  cg(98 > d ? 98 : d, function () {
    a(!0);
  });
  cg(97 < d ? 97 : d, function () {
    var d = kh.suspense;
    kh.suspense = void 0 === b ? null : b;
    try {
      a(!1), c();
    } finally {
      kh.suspense = d;
    }
  });
}
function zh(a, b, c) {
  var d = Gg(),
    e = Dg.suspense;
  d = Hg(d, a, e);
  e = {
    expirationTime: d,
    suspenseConfig: e,
    action: c,
    eagerReducer: null,
    eagerState: null,
    next: null
  };
  var f = b.pending;
  null === f ? e.next = e : (e.next = f.next, f.next = e);
  b.pending = e;
  f = a.alternate;
  if (a === N$2 || null !== f && f === N$2) mh = !0, e.expirationTime = lh, N$2.expirationTime = lh;else {
    if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
      var g = b.lastRenderedState,
        h = f(g, c);
      e.eagerReducer = f;
      e.eagerState = h;
      if ($e(h, g)) return;
    } catch (k) {} finally {}
    Ig(a, d);
  }
}
var sh = {
    readContext: sg,
    useCallback: Q$1$1,
    useContext: Q$1$1,
    useEffect: Q$1$1,
    useImperativeHandle: Q$1$1,
    useLayoutEffect: Q$1$1,
    useMemo: Q$1$1,
    useReducer: Q$1$1,
    useRef: Q$1$1,
    useState: Q$1$1,
    useDebugValue: Q$1$1,
    useResponder: Q$1$1,
    useDeferredValue: Q$1$1,
    useTransition: Q$1$1
  },
  ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
      c = null !== c && void 0 !== c ? c.concat([a]) : null;
      return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
      return Ch(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
      var c = th();
      b = void 0 === b ? null : b;
      a = a();
      c.memoizedState = [a, b];
      return a;
    },
    useReducer: function useReducer(a, b, c) {
      var d = th();
      b = void 0 !== c ? c(b) : b;
      d.memoizedState = d.baseState = b;
      a = d.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: a,
        lastRenderedState: b
      };
      a = a.dispatch = zh.bind(null, N$2, a);
      return [d.memoizedState, a];
    },
    useRef: function useRef(a) {
      var b = th();
      a = {
        current: a
      };
      return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
      var c = yh(a),
        d = c[0],
        e = c[1];
      Eh(function () {
        var c = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
          e(a);
        } finally {
          kh.suspense = c;
        }
      }, [a, b]);
      return d;
    },
    useTransition: function useTransition(a) {
      var b = yh(!1),
        c = b[0];
      b = b[1];
      return [Kh(Nh.bind(null, b, a), [b, a]), c];
    }
  },
  qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function useState() {
      return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
      var c = wh(vh),
        d = c[0],
        e = c[1];
      Fh(function () {
        var c = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
          e(a);
        } finally {
          kh.suspense = c;
        }
      }, [a, b]);
      return d;
    },
    useTransition: function useTransition(a) {
      var b = wh(vh),
        c = b[0];
      b = b[1];
      return [Lh(Nh.bind(null, b, a), [b, a]), c];
    }
  },
  rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function useState() {
      return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
      var c = xh(vh),
        d = c[0],
        e = c[1];
      Fh(function () {
        var c = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
          e(a);
        } finally {
          kh.suspense = c;
        }
      }, [a, b]);
      return d;
    },
    useTransition: function useTransition(a) {
      var b = xh(vh),
        c = b[0];
      b = b[1];
      return [Lh(Nh.bind(null, b, a), [b, a]), c];
    }
  },
  Oh = null,
  Ph = null,
  Qh = !1;
function Rh(a, b) {
  var c = Sh(5, null, null, 0);
  c.elementType = "DELETED";
  c.type = "DELETED";
  c.stateNode = b;
  c.return = a;
  c.effectTag = 8;
  null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return null !== b ? (a.stateNode = b, !0) : !1;
    case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
    case 13:
      return !1;
    default:
      return !1;
  }
}
function Uh(a) {
  if (Qh) {
    var b = Ph;
    if (b) {
      var c = b;
      if (!Th(a, b)) {
        b = Jd(c.nextSibling);
        if (!b || !Th(a, b)) {
          a.effectTag = a.effectTag & -1025 | 2;
          Qh = !1;
          Oh = a;
          return;
        }
        Rh(Oh, c);
      }
      Oh = a;
      Ph = Jd(b.firstChild);
    } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
  }
}
function Vh(a) {
  for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) a = a.return;
  Oh = a;
}
function Wh(a) {
  if (a !== Oh) return !1;
  if (!Qh) return Vh(a), Qh = !0, !1;
  var b = a.type;
  if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for (b = Ph; b;) Rh(a, b), b = Jd(b.nextSibling);
  Vh(a);
  if (13 === a.tag) {
    a = a.memoizedState;
    a = null !== a ? a.dehydrated : null;
    if (!a) throw Error(u$1$1(317));
    a: {
      a = a.nextSibling;
      for (b = 0; a;) {
        if (8 === a.nodeType) {
          var c = a.data;
          if (c === Ad) {
            if (0 === b) {
              Ph = Jd(a.nextSibling);
              break a;
            }
            b--;
          } else c !== zd && c !== Cd && c !== Bd || b++;
        }
        a = a.nextSibling;
      }
      Ph = null;
    }
  } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
  return !0;
}
function Xh() {
  Ph = Oh = null;
  Qh = !1;
}
var Yh = Wa.ReactCurrentOwner,
  rg = !1;
function R$1$1(a, b, c, d) {
  b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
  c = c.render;
  var f = b.ref;
  qg(b, e);
  d = oh(a, b, c, d, f, e);
  if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
  b.effectTag |= 1;
  R$1$1(a, b, d, e);
  return b.child;
}
function ai(a, b, c, d, e, f) {
  if (null === a) {
    var g = c.type;
    if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
    a = Ug(c.type, null, d, null, b.mode, f);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }
  g = a.child;
  if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
  b.effectTag |= 1;
  a = Sg(g, d);
  a.ref = b.ref;
  a.return = b;
  return b.child = a;
}
function ci(a, b, c, d, e, f) {
  return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
  var c = b.ref;
  if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
  var f = L$2$1(c) ? Bf : J$2.current;
  f = Cf(b, f);
  qg(b, e);
  c = oh(a, b, c, d, f, e);
  if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
  b.effectTag |= 1;
  R$1$1(a, b, c, e);
  return b.child;
}
function fi(a, b, c, d, e) {
  if (L$2$1(c)) {
    var f = !0;
    Gf(b);
  } else f = !1;
  qg(b, e);
  if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;else if (null === a) {
    var g = b.stateNode,
      h = b.memoizedProps;
    g.props = h;
    var k = g.context,
      l = c.contextType;
    "object" === typeof l && null !== l ? l = sg(l) : (l = L$2$1(c) ? Bf : J$2.current, l = Cf(b, l));
    var m = c.getDerivedStateFromProps,
      p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
    p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
    tg = !1;
    var x = b.memoizedState;
    g.state = x;
    zg(b, d, g, e);
    k = b.memoizedState;
    h !== d || x !== k || K$2.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
  } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L$2$1(c) ? Bf : J$2.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K$2.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
  return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
  ei(a, b);
  var g = 0 !== (b.effectTag & 64);
  if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
  d = b.stateNode;
  Yh.current = b;
  var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
  b.effectTag |= 1;
  null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R$1$1(a, b, h, f);
  b.memoizedState = d.state;
  e && Hf(b, c, !0);
  return b.child;
}
function hi(a) {
  var b = a.stateNode;
  b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
  dh(a, b.containerInfo);
}
var ii = {
  dehydrated: null,
  retryTime: 0
};
function ji(a, b, c) {
  var d = b.mode,
    e = b.pendingProps,
    f = M$2.current,
    g = !1,
    h;
  (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
  h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
  I$2(M$2, f & 1);
  if (null === a) {
    void 0 !== e.fallback && Uh(b);
    if (g) {
      g = e.fallback;
      e = Wg(null, d, 0, null);
      e.return = b;
      if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;) a.return = e, a = a.sibling;
      c = Wg(g, d, c, null);
      c.return = b;
      e.sibling = c;
      b.memoizedState = ii;
      b.child = e;
      return c;
    }
    d = e.children;
    b.memoizedState = null;
    return b.child = Yg(b, null, d, c);
  }
  if (null !== a.memoizedState) {
    a = a.child;
    d = a.sibling;
    if (g) {
      e = e.fallback;
      c = Sg(a, a.pendingProps);
      c.return = b;
      if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for (c.child = g; null !== g;) g.return = c, g = g.sibling;
      d = Sg(d, e);
      d.return = b;
      c.sibling = d;
      c.childExpirationTime = 0;
      b.memoizedState = ii;
      b.child = c;
      return d;
    }
    c = Xg(b, a.child, e.children, c);
    b.memoizedState = null;
    return b.child = c;
  }
  a = a.child;
  if (g) {
    g = e.fallback;
    e = Wg(null, d, 0, null);
    e.return = b;
    e.child = a;
    null !== a && (a.return = e);
    if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;) a.return = e, a = a.sibling;
    c = Wg(g, d, c, null);
    c.return = b;
    e.sibling = c;
    c.effectTag |= 2;
    e.childExpirationTime = 0;
    b.memoizedState = ii;
    b.child = e;
    return c;
  }
  b.memoizedState = null;
  return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
  a.expirationTime < b && (a.expirationTime = b);
  var c = a.alternate;
  null !== c && c.expirationTime < b && (c.expirationTime = b);
  pg(a.return, b);
}
function li(a, b, c, d, e, f) {
  var g = a.memoizedState;
  null === g ? a.memoizedState = {
    isBackwards: b,
    rendering: null,
    renderingStartTime: 0,
    last: d,
    tail: c,
    tailExpiration: 0,
    tailMode: e,
    lastEffect: f
  } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
  var d = b.pendingProps,
    e = d.revealOrder,
    f = d.tail;
  R$1$1(a, b, d.children, c);
  d = M$2.current;
  if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;else {
    if (null !== a && 0 !== (a.effectTag & 64)) a: for (a = b.child; null !== a;) {
      if (13 === a.tag) null !== a.memoizedState && ki(a, c);else if (19 === a.tag) ki(a, c);else if (null !== a.child) {
        a.child.return = a;
        a = a.child;
        continue;
      }
      if (a === b) break a;
      for (; null === a.sibling;) {
        if (null === a.return || a.return === b) break a;
        a = a.return;
      }
      a.sibling.return = a.return;
      a = a.sibling;
    }
    d &= 1;
  }
  I$2(M$2, d);
  if (0 === (b.mode & 2)) b.memoizedState = null;else switch (e) {
    case "forwards":
      c = b.child;
      for (e = null; null !== c;) a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
      c = e;
      null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
      li(b, !1, e, c, f, b.lastEffect);
      break;
    case "backwards":
      c = null;
      e = b.child;
      for (b.child = null; null !== e;) {
        a = e.alternate;
        if (null !== a && null === hh(a)) {
          b.child = e;
          break;
        }
        a = e.sibling;
        e.sibling = c;
        c = e;
        e = a;
      }
      li(b, !0, c, null, f, b.lastEffect);
      break;
    case "together":
      li(b, !1, null, null, void 0, b.lastEffect);
      break;
    default:
      b.memoizedState = null;
  }
  return b.child;
}
function $h(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);
  var d = b.expirationTime;
  0 !== d && Bg(d);
  if (b.childExpirationTime < c) return null;
  if (null !== a && b.child !== a.child) throw Error(u$1$1(153));
  if (null !== b.child) {
    a = b.child;
    c = Sg(a, a.pendingProps);
    b.child = c;
    for (c.return = b; null !== a.sibling;) a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
    c.sibling = null;
  }
  return b.child;
}
var ni, oi, pi, qi;
ni = function ni(a, b) {
  for (var c = b.child; null !== c;) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === b) break;
    for (; null === c.sibling;) {
      if (null === c.return || c.return === b) return;
      c = c.return;
    }
    c.sibling.return = c.return;
    c = c.sibling;
  }
};
oi = function oi() {};
pi = function pi(a, b, c, d, e) {
  var f = a.memoizedProps;
  if (f !== d) {
    var g = b.stateNode;
    ch($g.current);
    a = null;
    switch (c) {
      case "input":
        f = zb(g, f);
        d = zb(g, d);
        a = [];
        break;
      case "option":
        f = Gb(g, f);
        d = Gb(g, d);
        a = [];
        break;
      case "select":
        f = objectAssign({}, f, {
          value: void 0
        });
        d = objectAssign({}, d, {
          value: void 0
        });
        a = [];
        break;
      case "textarea":
        f = Ib(g, f);
        d = Ib(g, d);
        a = [];
        break;
      default:
        "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
    }
    od(c, d);
    var h, k;
    c = null;
    for (h in f) if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) if ("style" === h) for (k in g = f[h], g) g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
    for (h in d) {
      var l = d[h];
      g = null != f ? f[h] : void 0;
      if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) if ("style" === h) {
        if (g) {
          for (k in g) !g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
          for (k in l) l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
        } else c || (a || (a = []), a.push(h, c)), c = l;
      } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
    }
    c && (a = a || []).push("style", c);
    e = a;
    if (b.updateQueue = e) b.effectTag |= 4;
  }
};
qi = function qi(a, b, c, d) {
  c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
  switch (a.tailMode) {
    case "hidden":
      b = a.tail;
      for (var c = null; null !== b;) null !== b.alternate && (c = b), b = b.sibling;
      null === c ? a.tail = null : c.sibling = null;
      break;
    case "collapsed":
      c = a.tail;
      for (var d = null; null !== c;) null !== c.alternate && (d = c), c = c.sibling;
      null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
  }
}
function si(a, b, c) {
  var d = b.pendingProps;
  switch (b.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;
    case 1:
      return L$2$1(b.type) && Df(), null;
    case 3:
      return eh(), H$2$1(K$2), H$2$1(J$2), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
    case 5:
      gh(b);
      c = ch(bh.current);
      var e = b.type;
      if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);else {
        if (!d) {
          if (null === b.stateNode) throw Error(u$1$1(166));
          return null;
        }
        a = ch($g.current);
        if (Wh(b)) {
          d = b.stateNode;
          e = b.type;
          var f = b.memoizedProps;
          d[Md] = b;
          d[Nd] = f;
          switch (e) {
            case "iframe":
            case "object":
            case "embed":
              F$2("load", d);
              break;
            case "video":
            case "audio":
              for (a = 0; a < ac.length; a++) F$2(ac[a], d);
              break;
            case "source":
              F$2("error", d);
              break;
            case "img":
            case "image":
            case "link":
              F$2("error", d);
              F$2("load", d);
              break;
            case "form":
              F$2("reset", d);
              F$2("submit", d);
              break;
            case "details":
              F$2("toggle", d);
              break;
            case "input":
              Ab(d, f);
              F$2("invalid", d);
              rd(c, "onChange");
              break;
            case "select":
              d._wrapperState = {
                wasMultiple: !!f.multiple
              };
              F$2("invalid", d);
              rd(c, "onChange");
              break;
            case "textarea":
              Jb(d, f), F$2("invalid", d), rd(c, "onChange");
          }
          od(e, f);
          a = null;
          for (var g in f) if (f.hasOwnProperty(g)) {
            var h = f[g];
            "children" === g ? "string" === typeof h ? d.textContent !== h && (a = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (a = ["children", "" + h]) : va.hasOwnProperty(g) && null != h && rd(c, g);
          }
          switch (e) {
            case "input":
              xb(d);
              Eb(d, f, !0);
              break;
            case "textarea":
              xb(d);
              Lb(d);
              break;
            case "select":
            case "option":
              break;
            default:
              "function" === typeof f.onClick && (d.onclick = sd);
          }
          c = a;
          b.updateQueue = c;
          null !== c && (b.effectTag |= 4);
        } else {
          g = 9 === c.nodeType ? c : c.ownerDocument;
          a === qd && (a = Nb(e));
          a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
            is: d.is
          }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
          a[Md] = b;
          a[Nd] = d;
          ni(a, b, !1, !1);
          b.stateNode = a;
          g = pd(e, d);
          switch (e) {
            case "iframe":
            case "object":
            case "embed":
              F$2("load", a);
              h = d;
              break;
            case "video":
            case "audio":
              for (h = 0; h < ac.length; h++) F$2(ac[h], a);
              h = d;
              break;
            case "source":
              F$2("error", a);
              h = d;
              break;
            case "img":
            case "image":
            case "link":
              F$2("error", a);
              F$2("load", a);
              h = d;
              break;
            case "form":
              F$2("reset", a);
              F$2("submit", a);
              h = d;
              break;
            case "details":
              F$2("toggle", a);
              h = d;
              break;
            case "input":
              Ab(a, d);
              h = zb(a, d);
              F$2("invalid", a);
              rd(c, "onChange");
              break;
            case "option":
              h = Gb(a, d);
              break;
            case "select":
              a._wrapperState = {
                wasMultiple: !!d.multiple
              };
              h = objectAssign({}, d, {
                value: void 0
              });
              F$2("invalid", a);
              rd(c, "onChange");
              break;
            case "textarea":
              Jb(a, d);
              h = Ib(a, d);
              F$2("invalid", a);
              rd(c, "onChange");
              break;
            default:
              h = d;
          }
          od(e, h);
          var k = h;
          for (f in k) if (k.hasOwnProperty(f)) {
            var l = k[f];
            "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
          }
          switch (e) {
            case "input":
              xb(a);
              Eb(a, d, !1);
              break;
            case "textarea":
              xb(a);
              Lb(a);
              break;
            case "option":
              null != d.value && a.setAttribute("value", "" + rb(d.value));
              break;
            case "select":
              a.multiple = !!d.multiple;
              c = d.value;
              null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
              break;
            default:
              "function" === typeof h.onClick && (a.onclick = sd);
          }
          Fd(e, d) && (b.effectTag |= 4);
        }
        null !== b.ref && (b.effectTag |= 128);
      }
      return null;
    case 6:
      if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(u$1$1(166));
        c = ch(bh.current);
        ch($g.current);
        Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
      }
      return null;
    case 13:
      H$2$1(M$2);
      d = b.memoizedState;
      if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
      c = null !== d;
      d = !1;
      null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
      if (c && !d && 0 !== (b.mode & 2)) if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M$2.current & 1)) S$1$1 === ti && (S$1$1 = ui);else {
        if (S$1$1 === ti || S$1$1 === ui) S$1$1 = vi;
        0 !== wi && null !== T$1$1 && (xi(T$1$1, U$1$1), yi(T$1$1, wi));
      }
      if (c || d) b.effectTag |= 4;
      return null;
    case 4:
      return eh(), oi(b), null;
    case 10:
      return og(b), null;
    case 17:
      return L$2$1(b.type) && Df(), null;
    case 19:
      H$2$1(M$2);
      d = b.memoizedState;
      if (null === d) return null;
      e = 0 !== (b.effectTag & 64);
      f = d.rendering;
      if (null === f) {
        if (e) ri(d, !1);else {
          if (S$1$1 !== ti || null !== a && 0 !== (a.effectTag & 64)) for (f = b.child; null !== f;) {
            a = hh(f);
            if (null !== a) {
              b.effectTag |= 64;
              ri(d, !1);
              e = a.updateQueue;
              null !== e && (b.updateQueue = e, b.effectTag |= 4);
              null === d.lastEffect && (b.firstEffect = null);
              b.lastEffect = d.lastEffect;
              for (d = b.child; null !== d;) e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                expirationTime: f.expirationTime,
                firstContext: f.firstContext,
                responders: f.responders
              }), d = d.sibling;
              I$2(M$2, M$2.current & 1 | 2);
              return b.child;
            }
            f = f.sibling;
          }
        }
      } else {
        if (!e) if (a = hh(f), null !== a) {
          if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
        } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
        d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
      }
      return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M$2.current, I$2(M$2, e ? b & 1 | 2 : b & 1), c) : null;
  }
  throw Error(u$1$1(156, b.tag));
}
function zi(a) {
  switch (a.tag) {
    case 1:
      L$2$1(a.type) && Df();
      var b = a.effectTag;
      return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
    case 3:
      eh();
      H$2$1(K$2);
      H$2$1(J$2);
      b = a.effectTag;
      if (0 !== (b & 64)) throw Error(u$1$1(285));
      a.effectTag = b & -4097 | 64;
      return a;
    case 5:
      return gh(a), null;
    case 13:
      return H$2$1(M$2), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
    case 19:
      return H$2$1(M$2), null;
    case 4:
      return eh(), null;
    case 10:
      return og(a), null;
    default:
      return null;
  }
}
function Ai(a, b) {
  return {
    value: a,
    source: b,
    stack: qb(b)
  };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
  var c = b.source,
    d = b.stack;
  null === d && null !== c && (d = qb(c));
  null !== c && pb(c.type);
  b = b.value;
  null !== a && 1 === a.tag && pb(a.type);
  try {
    console.error(b);
  } catch (e) {
    setTimeout(function () {
      throw e;
    });
  }
}
function Di(a, b) {
  try {
    b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
  } catch (c) {
    Ei(a, c);
  }
}
function Fi(a) {
  var b = a.ref;
  if (null !== b) if ("function" === typeof b) try {
    b(null);
  } catch (c) {
    Ei(a, c);
  } else b.current = null;
}
function Gi(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      return;
    case 1:
      if (b.effectTag & 256 && null !== a) {
        var c = a.memoizedProps,
          d = a.memoizedState;
        a = b.stateNode;
        b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
        a.__reactInternalSnapshotBeforeUpdate = b;
      }
      return;
    case 3:
    case 5:
    case 6:
    case 4:
    case 17:
      return;
  }
  throw Error(u$1$1(163));
}
function Hi(a, b) {
  b = b.updateQueue;
  b = null !== b ? b.lastEffect : null;
  if (null !== b) {
    var c = b = b.next;
    do {
      if ((c.tag & a) === a) {
        var d = c.destroy;
        c.destroy = void 0;
        void 0 !== d && d();
      }
      c = c.next;
    } while (c !== b);
  }
}
function Ii(a, b) {
  b = b.updateQueue;
  b = null !== b ? b.lastEffect : null;
  if (null !== b) {
    var c = b = b.next;
    do {
      if ((c.tag & a) === a) {
        var d = c.create;
        c.destroy = d();
      }
      c = c.next;
    } while (c !== b);
  }
}
function Ji(a, b, c) {
  switch (c.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      Ii(3, c);
      return;
    case 1:
      a = c.stateNode;
      if (c.effectTag & 4) if (null === b) a.componentDidMount();else {
        var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
        a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
      }
      b = c.updateQueue;
      null !== b && Cg(c, b, a);
      return;
    case 3:
      b = c.updateQueue;
      if (null !== b) {
        a = null;
        if (null !== c.child) switch (c.child.tag) {
          case 5:
            a = c.child.stateNode;
            break;
          case 1:
            a = c.child.stateNode;
        }
        Cg(c, b, a);
      }
      return;
    case 5:
      a = c.stateNode;
      null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
      return;
    case 6:
      return;
    case 4:
      return;
    case 12:
      return;
    case 13:
      null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
      return;
    case 19:
    case 17:
    case 20:
    case 21:
      return;
  }
  throw Error(u$1$1(163));
}
function Ki(a, b, c) {
  "function" === typeof Li && Li(b);
  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      a = b.updateQueue;
      if (null !== a && (a = a.lastEffect, null !== a)) {
        var d = a.next;
        cg(97 < c ? 97 : c, function () {
          var a = d;
          do {
            var c = a.destroy;
            if (void 0 !== c) {
              var g = b;
              try {
                c();
              } catch (h) {
                Ei(g, h);
              }
            }
            a = a.next;
          } while (a !== d);
        });
      }
      break;
    case 1:
      Fi(b);
      c = b.stateNode;
      "function" === typeof c.componentWillUnmount && Di(b, c);
      break;
    case 5:
      Fi(b);
      break;
    case 4:
      Mi(a, b, c);
  }
}
function Ni(a) {
  var b = a.alternate;
  a.return = null;
  a.child = null;
  a.memoizedState = null;
  a.updateQueue = null;
  a.dependencies = null;
  a.alternate = null;
  a.firstEffect = null;
  a.lastEffect = null;
  a.pendingProps = null;
  a.memoizedProps = null;
  a.stateNode = null;
  null !== b && Ni(b);
}
function Oi(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
  a: {
    for (var b = a.return; null !== b;) {
      if (Oi(b)) {
        var c = b;
        break a;
      }
      b = b.return;
    }
    throw Error(u$1$1(160));
  }
  b = c.stateNode;
  switch (c.tag) {
    case 5:
      var d = !1;
      break;
    case 3:
      b = b.containerInfo;
      d = !0;
      break;
    case 4:
      b = b.containerInfo;
      d = !0;
      break;
    default:
      throw Error(u$1$1(161));
  }
  c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
  a: b: for (c = a;;) {
    for (; null === c.sibling;) {
      if (null === c.return || Oi(c.return)) {
        c = null;
        break a;
      }
      c = c.return;
    }
    c.sibling.return = c.return;
    for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;) {
      if (c.effectTag & 2) continue b;
      if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
    }
    if (!(c.effectTag & 2)) {
      c = c.stateNode;
      break a;
    }
  }
  d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
  var d = a.tag,
    e = 5 === d || 6 === d;
  if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));else if (4 !== d && (a = a.child, null !== a)) for (Qi(a, b, c), a = a.sibling; null !== a;) Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
  var d = a.tag,
    e = 5 === d || 6 === d;
  if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);else if (4 !== d && (a = a.child, null !== a)) for (Ri(a, b, c), a = a.sibling; null !== a;) Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
  for (var d = b, e = !1, f, g;;) {
    if (!e) {
      e = d.return;
      a: for (;;) {
        if (null === e) throw Error(u$1$1(160));
        f = e.stateNode;
        switch (e.tag) {
          case 5:
            g = !1;
            break a;
          case 3:
            f = f.containerInfo;
            g = !0;
            break a;
          case 4:
            f = f.containerInfo;
            g = !0;
            break a;
        }
        e = e.return;
      }
      e = !0;
    }
    if (5 === d.tag || 6 === d.tag) {
      a: for (var h = a, k = d, l = c, m = k;;) if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;else {
        if (m === k) break a;
        for (; null === m.sibling;) {
          if (null === m.return || m.return === k) break a;
          m = m.return;
        }
        m.sibling.return = m.return;
        m = m.sibling;
      }
      g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
    } else if (4 === d.tag) {
      if (null !== d.child) {
        f = d.stateNode.containerInfo;
        g = !0;
        d.child.return = d;
        d = d.child;
        continue;
      }
    } else if (Ki(a, d, c), null !== d.child) {
      d.child.return = d;
      d = d.child;
      continue;
    }
    if (d === b) break;
    for (; null === d.sibling;) {
      if (null === d.return || d.return === b) return;
      d = d.return;
      4 === d.tag && (e = !1);
    }
    d.sibling.return = d.return;
    d = d.sibling;
  }
}
function Si(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      Hi(3, b);
      return;
    case 1:
      return;
    case 5:
      var c = b.stateNode;
      if (null != c) {
        var d = b.memoizedProps,
          e = null !== a ? a.memoizedProps : d;
        a = b.type;
        var f = b.updateQueue;
        b.updateQueue = null;
        if (null !== f) {
          c[Nd] = d;
          "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
          pd(a, e);
          b = pd(a, d);
          for (e = 0; e < f.length; e += 2) {
            var g = f[e],
              h = f[e + 1];
            "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
          }
          switch (a) {
            case "input":
              Cb(c, d);
              break;
            case "textarea":
              Kb(c, d);
              break;
            case "select":
              b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
          }
        }
      }
      return;
    case 6:
      if (null === b.stateNode) throw Error(u$1$1(162));
      b.stateNode.nodeValue = b.memoizedProps;
      return;
    case 3:
      b = b.stateNode;
      b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
      return;
    case 12:
      return;
    case 13:
      c = b;
      null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
      if (null !== c) a: for (a = c;;) {
        if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
          f = a.child.sibling;
          f.return = a;
          a = f;
          continue;
        } else if (null !== a.child) {
          a.child.return = a;
          a = a.child;
          continue;
        }
        if (a === c) break;
        for (; null === a.sibling;) {
          if (null === a.return || a.return === c) break a;
          a = a.return;
        }
        a.sibling.return = a.return;
        a = a.sibling;
      }
      Ui(b);
      return;
    case 19:
      Ui(b);
      return;
    case 17:
      return;
  }
  throw Error(u$1$1(163));
}
function Ui(a) {
  var b = a.updateQueue;
  if (null !== b) {
    a.updateQueue = null;
    var c = a.stateNode;
    null === c && (c = a.stateNode = new Bi());
    b.forEach(function (b) {
      var d = Vi.bind(null, a, b);
      c.has(b) || (c.add(b), b.then(d, d));
    });
  }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
  c = wg(c, null);
  c.tag = 3;
  c.payload = {
    element: null
  };
  var d = b.value;
  c.callback = function () {
    Yi || (Yi = !0, Zi = d);
    Ci(a, b);
  };
  return c;
}
function $i(a, b, c) {
  c = wg(c, null);
  c.tag = 3;
  var d = a.type.getDerivedStateFromError;
  if ("function" === typeof d) {
    var e = b.value;
    c.payload = function () {
      Ci(a, b);
      return d(e);
    };
  }
  var f = a.stateNode;
  null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
    "function" !== typeof d && (null === aj ? aj = new Set([this]) : aj.add(this), Ci(a, b));
    var c = b.stack;
    this.componentDidCatch(b.value, {
      componentStack: null !== c ? c : ""
    });
  });
  return c;
}
var bj = Math.ceil,
  cj = Wa.ReactCurrentDispatcher,
  dj = Wa.ReactCurrentOwner,
  V$1$1 = 0,
  ej = 8,
  fj = 16,
  gj = 32,
  ti = 0,
  hj = 1,
  ij = 2,
  ui = 3,
  vi = 4,
  jj = 5,
  W$1$1 = V$1$1,
  T$1$1 = null,
  X$1$1 = null,
  U$1$1 = 0,
  S$1$1 = ti,
  kj = null,
  lj = 1073741823,
  mj = 1073741823,
  nj = null,
  wi = 0,
  oj = !1,
  Ti = 0,
  pj = 500,
  Y$1$1 = null,
  Yi = !1,
  Zi = null,
  aj = null,
  qj = !1,
  rj = null,
  sj = 90,
  tj = null,
  uj = 0,
  vj = null,
  wj = 0;
function Gg() {
  return (W$1$1 & (fj | gj)) !== V$1$1 ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
  b = b.mode;
  if (0 === (b & 2)) return 1073741823;
  var d = ag();
  if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
  if ((W$1$1 & fj) !== V$1$1) return U$1$1;
  if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);else switch (d) {
    case 99:
      a = 1073741823;
      break;
    case 98:
      a = hg(a, 150, 100);
      break;
    case 97:
    case 96:
      a = hg(a, 5E3, 250);
      break;
    case 95:
      a = 2;
      break;
    default:
      throw Error(u$1$1(326));
  }
  null !== T$1$1 && a === U$1$1 && --a;
  return a;
}
function Ig(a, b) {
  if (50 < uj) throw uj = 0, vj = null, Error(u$1$1(185));
  a = xj(a, b);
  if (null !== a) {
    var c = ag();
    1073741823 === b ? (W$1$1 & ej) !== V$1$1 && (W$1$1 & (fj | gj)) === V$1$1 ? yj(a) : (Z$1$1(a), W$1$1 === V$1$1 && gg()) : Z$1$1(a);
    (W$1$1 & 4) === V$1$1 || 98 !== c && 99 !== c || (null === tj ? tj = new Map([[a, b]]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
  }
}
function xj(a, b) {
  a.expirationTime < b && (a.expirationTime = b);
  var c = a.alternate;
  null !== c && c.expirationTime < b && (c.expirationTime = b);
  var d = a.return,
    e = null;
  if (null === d && 3 === a.tag) e = a.stateNode;else for (; null !== d;) {
    c = d.alternate;
    d.childExpirationTime < b && (d.childExpirationTime = b);
    null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
    if (null === d.return && 3 === d.tag) {
      e = d.stateNode;
      break;
    }
    d = d.return;
  }
  null !== e && (T$1$1 === e && (Bg(b), S$1$1 === vi && xi(e, U$1$1)), yi(e, b));
  return e;
}
function zj(a) {
  var b = a.lastExpiredTime;
  if (0 !== b) return b;
  b = a.firstPendingTime;
  if (!Aj(a, b)) return b;
  var c = a.lastPingedTime;
  a = a.nextKnownPendingLevel;
  a = c > a ? c : a;
  return 2 >= a && b !== a ? 0 : a;
}
function Z$1$1(a) {
  if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));else {
    var b = zj(a),
      c = a.callbackNode;
    if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);else {
      var d = Gg();
      1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
      if (null !== c) {
        var e = a.callbackPriority;
        if (a.callbackExpirationTime === b && e >= d) return;
        c !== Tf && Kf(c);
      }
      a.callbackExpirationTime = b;
      a.callbackPriority = d;
      b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
        timeout: 10 * (1073741821 - b) - $f()
      });
      a.callbackNode = b;
    }
  }
}
function Bj(a, b) {
  wj = 0;
  if (b) return b = Gg(), Cj(a, b), Z$1$1(a), null;
  var c = zj(a);
  if (0 !== c) {
    b = a.callbackNode;
    if ((W$1$1 & (fj | gj)) !== V$1$1) throw Error(u$1$1(327));
    Dj();
    a === T$1$1 && c === U$1$1 || Ej(a, c);
    if (null !== X$1$1) {
      var d = W$1$1;
      W$1$1 |= fj;
      var e = Fj();
      do try {
        Gj();
        break;
      } catch (h) {
        Hj(a, h);
      } while (1);
      ng();
      W$1$1 = d;
      cj.current = e;
      if (S$1$1 === hj) throw b = kj, Ej(a, c), xi(a, c), Z$1$1(a), b;
      if (null === X$1$1) switch (e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S$1$1, T$1$1 = null, d) {
        case ti:
        case hj:
          throw Error(u$1$1(345));
        case ij:
          Cj(a, 2 < c ? 2 : c);
          break;
        case ui:
          xi(a, c);
          d = a.lastSuspendedTime;
          c === d && (a.nextKnownPendingLevel = Ij(e));
          if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
            if (oj) {
              var f = a.lastPingedTime;
              if (0 === f || f >= c) {
                a.lastPingedTime = c;
                Ej(a, c);
                break;
              }
            }
            f = zj(a);
            if (0 !== f && f !== c) break;
            if (0 !== d && d !== c) {
              a.lastPingedTime = d;
              break;
            }
            a.timeoutHandle = Hd(Jj.bind(null, a), e);
            break;
          }
          Jj(a);
          break;
        case vi:
          xi(a, c);
          d = a.lastSuspendedTime;
          c === d && (a.nextKnownPendingLevel = Ij(e));
          if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
            a.lastPingedTime = c;
            Ej(a, c);
            break;
          }
          e = zj(a);
          if (0 !== e && e !== c) break;
          if (0 !== d && d !== c) {
            a.lastPingedTime = d;
            break;
          }
          1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
          if (10 < d) {
            a.timeoutHandle = Hd(Jj.bind(null, a), d);
            break;
          }
          Jj(a);
          break;
        case jj:
          if (1073741823 !== lj && null !== nj) {
            f = lj;
            var g = nj;
            d = g.busyMinDurationMs | 0;
            0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
            if (10 < d) {
              xi(a, c);
              a.timeoutHandle = Hd(Jj.bind(null, a), d);
              break;
            }
          }
          Jj(a);
          break;
        default:
          throw Error(u$1$1(329));
      }
      Z$1$1(a);
      if (a.callbackNode === b) return Bj.bind(null, a);
    }
  }
  return null;
}
function yj(a) {
  var b = a.lastExpiredTime;
  b = 0 !== b ? b : 1073741823;
  if ((W$1$1 & (fj | gj)) !== V$1$1) throw Error(u$1$1(327));
  Dj();
  a === T$1$1 && b === U$1$1 || Ej(a, b);
  if (null !== X$1$1) {
    var c = W$1$1;
    W$1$1 |= fj;
    var d = Fj();
    do try {
      Kj();
      break;
    } catch (e) {
      Hj(a, e);
    } while (1);
    ng();
    W$1$1 = c;
    cj.current = d;
    if (S$1$1 === hj) throw c = kj, Ej(a, b), xi(a, b), Z$1$1(a), c;
    if (null !== X$1$1) throw Error(u$1$1(261));
    a.finishedWork = a.current.alternate;
    a.finishedExpirationTime = b;
    T$1$1 = null;
    Jj(a);
    Z$1$1(a);
  }
  return null;
}
function Lj() {
  if (null !== tj) {
    var a = tj;
    tj = null;
    a.forEach(function (a, c) {
      Cj(c, a);
      Z$1$1(c);
    });
    gg();
  }
}
function Mj(a, b) {
  var c = W$1$1;
  W$1$1 |= 1;
  try {
    return a(b);
  } finally {
    W$1$1 = c, W$1$1 === V$1$1 && gg();
  }
}
function Nj(a, b) {
  var c = W$1$1;
  W$1$1 &= -2;
  W$1$1 |= ej;
  try {
    return a(b);
  } finally {
    W$1$1 = c, W$1$1 === V$1$1 && gg();
  }
}
function Ej(a, b) {
  a.finishedWork = null;
  a.finishedExpirationTime = 0;
  var c = a.timeoutHandle;
  -1 !== c && (a.timeoutHandle = -1, Id(c));
  if (null !== X$1$1) for (c = X$1$1.return; null !== c;) {
    var d = c;
    switch (d.tag) {
      case 1:
        d = d.type.childContextTypes;
        null !== d && void 0 !== d && Df();
        break;
      case 3:
        eh();
        H$2$1(K$2);
        H$2$1(J$2);
        break;
      case 5:
        gh(d);
        break;
      case 4:
        eh();
        break;
      case 13:
        H$2$1(M$2);
        break;
      case 19:
        H$2$1(M$2);
        break;
      case 10:
        og(d);
    }
    c = c.return;
  }
  T$1$1 = a;
  X$1$1 = Sg(a.current, null);
  U$1$1 = b;
  S$1$1 = ti;
  kj = null;
  mj = lj = 1073741823;
  nj = null;
  wi = 0;
  oj = !1;
}
function Hj(a, b) {
  do {
    try {
      ng();
      jh.current = sh;
      if (mh) for (var c = N$2.memoizedState; null !== c;) {
        var d = c.queue;
        null !== d && (d.pending = null);
        c = c.next;
      }
      lh = 0;
      P$1$1 = O$2 = N$2 = null;
      mh = !1;
      if (null === X$1$1 || null === X$1$1.return) return S$1$1 = hj, kj = b, X$1$1 = null;
      a: {
        var e = a,
          f = X$1$1.return,
          g = X$1$1,
          h = b;
        b = U$1$1;
        g.effectTag |= 2048;
        g.firstEffect = g.lastEffect = null;
        if (null !== h && "object" === typeof h && "function" === typeof h.then) {
          var k = h;
          if (0 === (g.mode & 2)) {
            var l = g.alternate;
            l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
          }
          var m = 0 !== (M$2.current & 1),
            p = f;
          do {
            var x;
            if (x = 13 === p.tag) {
              var z = p.memoizedState;
              if (null !== z) x = null !== z.dehydrated ? !0 : !1;else {
                var ca = p.memoizedProps;
                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
              }
            }
            if (x) {
              var D = p.updateQueue;
              if (null === D) {
                var t = new Set();
                t.add(k);
                p.updateQueue = t;
              } else D.add(k);
              if (0 === (p.mode & 2)) {
                p.effectTag |= 64;
                g.effectTag &= -2981;
                if (1 === g.tag) if (null === g.alternate) g.tag = 17;else {
                  var y = wg(1073741823, null);
                  y.tag = 2;
                  xg(g, y);
                }
                g.expirationTime = 1073741823;
                break a;
              }
              h = void 0;
              g = b;
              var A = e.pingCache;
              null === A ? (A = e.pingCache = new Wi(), h = new Set(), A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set(), A.set(k, h)));
              if (!h.has(g)) {
                h.add(g);
                var q = Oj.bind(null, e, k, g);
                k.then(q, q);
              }
              p.effectTag |= 4096;
              p.expirationTime = b;
              break a;
            }
            p = p.return;
          } while (null !== p);
          h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
        }
        S$1$1 !== jj && (S$1$1 = ij);
        h = Ai(h, g);
        p = f;
        do {
          switch (p.tag) {
            case 3:
              k = h;
              p.effectTag |= 4096;
              p.expirationTime = b;
              var B = Xi(p, k, b);
              yg(p, B);
              break a;
            case 1:
              k = h;
              var w = p.type,
                ub = p.stateNode;
              if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                p.effectTag |= 4096;
                p.expirationTime = b;
                var vb = $i(p, k, b);
                yg(p, vb);
                break a;
              }
          }
          p = p.return;
        } while (null !== p);
      }
      X$1$1 = Pj(X$1$1);
    } catch (Xc) {
      b = Xc;
      continue;
    }
    break;
  } while (1);
}
function Fj() {
  var a = cj.current;
  cj.current = sh;
  return null === a ? sh : a;
}
function Ag(a, b) {
  a < lj && 2 < a && (lj = a);
  null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
  a > wi && (wi = a);
}
function Kj() {
  for (; null !== X$1$1;) X$1$1 = Qj(X$1$1);
}
function Gj() {
  for (; null !== X$1$1 && !Uf();) X$1$1 = Qj(X$1$1);
}
function Qj(a) {
  var b = Rj(a.alternate, a, U$1$1);
  a.memoizedProps = a.pendingProps;
  null === b && (b = Pj(a));
  dj.current = null;
  return b;
}
function Pj(a) {
  X$1$1 = a;
  do {
    var b = X$1$1.alternate;
    a = X$1$1.return;
    if (0 === (X$1$1.effectTag & 2048)) {
      b = si(b, X$1$1, U$1$1);
      if (1 === U$1$1 || 1 !== X$1$1.childExpirationTime) {
        for (var c = 0, d = X$1$1.child; null !== d;) {
          var e = d.expirationTime,
            f = d.childExpirationTime;
          e > c && (c = e);
          f > c && (c = f);
          d = d.sibling;
        }
        X$1$1.childExpirationTime = c;
      }
      if (null !== b) return b;
      null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X$1$1.firstEffect), null !== X$1$1.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X$1$1.firstEffect), a.lastEffect = X$1$1.lastEffect), 1 < X$1$1.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X$1$1 : a.firstEffect = X$1$1, a.lastEffect = X$1$1));
    } else {
      b = zi(X$1$1);
      if (null !== b) return b.effectTag &= 2047, b;
      null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
    }
    b = X$1$1.sibling;
    if (null !== b) return b;
    X$1$1 = a;
  } while (null !== X$1$1);
  S$1$1 === ti && (S$1$1 = jj);
  return null;
}
function Ij(a) {
  var b = a.expirationTime;
  a = a.childExpirationTime;
  return b > a ? b : a;
}
function Jj(a) {
  var b = ag();
  cg(99, Sj.bind(null, a, b));
  return null;
}
function Sj(a, b) {
  do Dj(); while (null !== rj);
  if ((W$1$1 & (fj | gj)) !== V$1$1) throw Error(u$1$1(327));
  var c = a.finishedWork,
    d = a.finishedExpirationTime;
  if (null === c) return null;
  a.finishedWork = null;
  a.finishedExpirationTime = 0;
  if (c === a.current) throw Error(u$1$1(177));
  a.callbackNode = null;
  a.callbackExpirationTime = 0;
  a.callbackPriority = 90;
  a.nextKnownPendingLevel = 0;
  var e = Ij(c);
  a.firstPendingTime = e;
  d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
  d <= a.lastPingedTime && (a.lastPingedTime = 0);
  d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
  a === T$1$1 && (X$1$1 = T$1$1 = null, U$1$1 = 0);
  1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
  if (null !== e) {
    var f = W$1$1;
    W$1$1 |= gj;
    dj.current = null;
    Dd = fd;
    var g = xd();
    if (yd(g)) {
      if ("selectionStart" in g) var h = {
        start: g.selectionStart,
        end: g.selectionEnd
      };else a: {
        h = (h = g.ownerDocument) && h.defaultView || window;
        var k = h.getSelection && h.getSelection();
        if (k && 0 !== k.rangeCount) {
          h = k.anchorNode;
          var l = k.anchorOffset,
            m = k.focusNode;
          k = k.focusOffset;
          try {
            h.nodeType, m.nodeType;
          } catch (wb) {
            h = null;
            break a;
          }
          var p = 0,
            x = -1,
            z = -1,
            ca = 0,
            D = 0,
            t = g,
            y = null;
          b: for (;;) {
            for (var A;;) {
              t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
              t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
              3 === t.nodeType && (p += t.nodeValue.length);
              if (null === (A = t.firstChild)) break;
              y = t;
              t = A;
            }
            for (;;) {
              if (t === g) break b;
              y === h && ++ca === l && (x = p);
              y === m && ++D === k && (z = p);
              if (null !== (A = t.nextSibling)) break;
              t = y;
              y = t.parentNode;
            }
            t = A;
          }
          h = -1 === x || -1 === z ? null : {
            start: x,
            end: z
          };
        } else h = null;
      }
      h = h || {
        start: 0,
        end: 0
      };
    } else h = null;
    Ed = {
      activeElementDetached: null,
      focusedElem: g,
      selectionRange: h
    };
    fd = !1;
    Y$1$1 = e;
    do try {
      Tj();
    } catch (wb) {
      if (null === Y$1$1) throw Error(u$1$1(330));
      Ei(Y$1$1, wb);
      Y$1$1 = Y$1$1.nextEffect;
    } while (null !== Y$1$1);
    Y$1$1 = e;
    do try {
      for (g = a, h = b; null !== Y$1$1;) {
        var q = Y$1$1.effectTag;
        q & 16 && Rb(Y$1$1.stateNode, "");
        if (q & 128) {
          var B = Y$1$1.alternate;
          if (null !== B) {
            var w = B.ref;
            null !== w && ("function" === typeof w ? w(null) : w.current = null);
          }
        }
        switch (q & 1038) {
          case 2:
            Pi(Y$1$1);
            Y$1$1.effectTag &= -3;
            break;
          case 6:
            Pi(Y$1$1);
            Y$1$1.effectTag &= -3;
            Si(Y$1$1.alternate, Y$1$1);
            break;
          case 1024:
            Y$1$1.effectTag &= -1025;
            break;
          case 1028:
            Y$1$1.effectTag &= -1025;
            Si(Y$1$1.alternate, Y$1$1);
            break;
          case 4:
            Si(Y$1$1.alternate, Y$1$1);
            break;
          case 8:
            l = Y$1$1, Mi(g, l, h), Ni(l);
        }
        Y$1$1 = Y$1$1.nextEffect;
      }
    } catch (wb) {
      if (null === Y$1$1) throw Error(u$1$1(330));
      Ei(Y$1$1, wb);
      Y$1$1 = Y$1$1.nextEffect;
    } while (null !== Y$1$1);
    w = Ed;
    B = xd();
    q = w.focusedElem;
    h = w.selectionRange;
    if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
      null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
      B = [];
      for (w = q; w = w.parentNode;) 1 === w.nodeType && B.push({
        element: w,
        left: w.scrollLeft,
        top: w.scrollTop
      });
      "function" === typeof q.focus && q.focus();
      for (q = 0; q < B.length; q++) w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
    }
    fd = !!Dd;
    Ed = Dd = null;
    a.current = c;
    Y$1$1 = e;
    do try {
      for (q = a; null !== Y$1$1;) {
        var ub = Y$1$1.effectTag;
        ub & 36 && Ji(q, Y$1$1.alternate, Y$1$1);
        if (ub & 128) {
          B = void 0;
          var vb = Y$1$1.ref;
          if (null !== vb) {
            var Xc = Y$1$1.stateNode;
            switch (Y$1$1.tag) {
              case 5:
                B = Xc;
                break;
              default:
                B = Xc;
            }
            "function" === typeof vb ? vb(B) : vb.current = B;
          }
        }
        Y$1$1 = Y$1$1.nextEffect;
      }
    } catch (wb) {
      if (null === Y$1$1) throw Error(u$1$1(330));
      Ei(Y$1$1, wb);
      Y$1$1 = Y$1$1.nextEffect;
    } while (null !== Y$1$1);
    Y$1$1 = null;
    Vf();
    W$1$1 = f;
  } else a.current = c;
  if (qj) qj = !1, rj = a, sj = b;else for (Y$1$1 = e; null !== Y$1$1;) b = Y$1$1.nextEffect, Y$1$1.nextEffect = null, Y$1$1 = b;
  b = a.firstPendingTime;
  0 === b && (aj = null);
  1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
  "function" === typeof Uj && Uj(c.stateNode, d);
  Z$1$1(a);
  if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
  if ((W$1$1 & ej) !== V$1$1) return null;
  gg();
  return null;
}
function Tj() {
  for (; null !== Y$1$1;) {
    var a = Y$1$1.effectTag;
    0 !== (a & 256) && Gi(Y$1$1.alternate, Y$1$1);
    0 === (a & 512) || qj || (qj = !0, dg(97, function () {
      Dj();
      return null;
    }));
    Y$1$1 = Y$1$1.nextEffect;
  }
}
function Dj() {
  if (90 !== sj) {
    var a = 97 < sj ? 97 : sj;
    sj = 90;
    return cg(a, Vj);
  }
}
function Vj() {
  if (null === rj) return !1;
  var a = rj;
  rj = null;
  if ((W$1$1 & (fj | gj)) !== V$1$1) throw Error(u$1$1(331));
  var b = W$1$1;
  W$1$1 |= gj;
  for (a = a.current.firstEffect; null !== a;) {
    try {
      var c = a;
      if (0 !== (c.effectTag & 512)) switch (c.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          Hi(5, c), Ii(5, c);
      }
    } catch (d) {
      if (null === a) throw Error(u$1$1(330));
      Ei(a, d);
    }
    c = a.nextEffect;
    a.nextEffect = null;
    a = c;
  }
  W$1$1 = b;
  gg();
  return !0;
}
function Wj(a, b, c) {
  b = Ai(c, b);
  b = Xi(a, b, 1073741823);
  xg(a, b);
  a = xj(a, 1073741823);
  null !== a && Z$1$1(a);
}
function Ei(a, b) {
  if (3 === a.tag) Wj(a, a, b);else for (var c = a.return; null !== c;) {
    if (3 === c.tag) {
      Wj(c, a, b);
      break;
    } else if (1 === c.tag) {
      var d = c.stateNode;
      if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
        a = Ai(b, a);
        a = $i(c, a, 1073741823);
        xg(c, a);
        c = xj(c, 1073741823);
        null !== c && Z$1$1(c);
        break;
      }
    }
    c = c.return;
  }
}
function Oj(a, b, c) {
  var d = a.pingCache;
  null !== d && d.delete(b);
  T$1$1 === a && U$1$1 === c ? S$1$1 === vi || S$1$1 === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U$1$1) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z$1$1(a)));
}
function Vi(a, b) {
  var c = a.stateNode;
  null !== c && c.delete(b);
  b = 0;
  0 === b && (b = Gg(), b = Hg(b, a, null));
  a = xj(a, b);
  null !== a && Z$1$1(a);
}
var Rj;
Rj = function Rj(a, b, c) {
  var d = b.expirationTime;
  if (null !== a) {
    var e = b.pendingProps;
    if (a.memoizedProps !== e || K$2.current) rg = !0;else {
      if (d < c) {
        rg = !1;
        switch (b.tag) {
          case 3:
            hi(b);
            Xh();
            break;
          case 5:
            fh(b);
            if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
            break;
          case 1:
            L$2$1(b.type) && Gf(b);
            break;
          case 4:
            dh(b, b.stateNode.containerInfo);
            break;
          case 10:
            d = b.memoizedProps.value;
            e = b.type._context;
            I$2(jg, e._currentValue);
            e._currentValue = d;
            break;
          case 13:
            if (null !== b.memoizedState) {
              d = b.child.childExpirationTime;
              if (0 !== d && d >= c) return ji(a, b, c);
              I$2(M$2, M$2.current & 1);
              b = $h(a, b, c);
              return null !== b ? b.sibling : null;
            }
            I$2(M$2, M$2.current & 1);
            break;
          case 19:
            d = b.childExpirationTime >= c;
            if (0 !== (a.effectTag & 64)) {
              if (d) return mi(a, b, c);
              b.effectTag |= 64;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null);
            I$2(M$2, M$2.current);
            if (!d) return null;
        }
        return $h(a, b, c);
      }
      rg = !1;
    }
  } else rg = !1;
  b.expirationTime = 0;
  switch (b.tag) {
    case 2:
      d = b.type;
      null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
      a = b.pendingProps;
      e = Cf(b, J$2.current);
      qg(b, c);
      e = oh(null, b, d, a, e, c);
      b.effectTag |= 1;
      if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
        b.tag = 1;
        b.memoizedState = null;
        b.updateQueue = null;
        if (L$2$1(d)) {
          var f = !0;
          Gf(b);
        } else f = !1;
        b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
        ug(b);
        var g = d.getDerivedStateFromProps;
        "function" === typeof g && Fg(b, d, g, a);
        e.updater = Jg;
        b.stateNode = e;
        e._reactInternalFiber = b;
        Ng(b, d, a, c);
        b = gi(null, b, d, !0, f, c);
      } else b.tag = 0, R$1$1(null, b, e, c), b = b.child;
      return b;
    case 16:
      a: {
        e = b.elementType;
        null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
        a = b.pendingProps;
        ob(e);
        if (1 !== e._status) throw e._result;
        e = e._result;
        b.type = e;
        f = b.tag = Xj(e);
        a = ig(e, a);
        switch (f) {
          case 0:
            b = di(null, b, e, a, c);
            break a;
          case 1:
            b = fi(null, b, e, a, c);
            break a;
          case 11:
            b = Zh(null, b, e, a, c);
            break a;
          case 14:
            b = ai(null, b, e, ig(e.type, a), d, c);
            break a;
        }
        throw Error(u$1$1(306, e, ""));
      }
      return b;
    case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
    case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
    case 3:
      hi(b);
      d = b.updateQueue;
      if (null === a || null === d) throw Error(u$1$1(282));
      d = b.pendingProps;
      e = b.memoizedState;
      e = null !== e ? e.element : null;
      vg(a, b);
      zg(b, d, null, c);
      d = b.memoizedState.element;
      if (d === e) Xh(), b = $h(a, b, c);else {
        if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
        if (e) for (c = Yg(b, null, d, c), b.child = c; c;) c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;else R$1$1(a, b, d, c), Xh();
        b = b.child;
      }
      return b;
    case 5:
      return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R$1$1(a, b, g, c), b = b.child), b;
    case 6:
      return null === a && Uh(b), null;
    case 13:
      return ji(a, b, c);
    case 4:
      return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R$1$1(a, b, d, c), b.child;
    case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
    case 7:
      return R$1$1(a, b, b.pendingProps, c), b.child;
    case 8:
      return R$1$1(a, b, b.pendingProps.children, c), b.child;
    case 12:
      return R$1$1(a, b, b.pendingProps.children, c), b.child;
    case 10:
      a: {
        d = b.type._context;
        e = b.pendingProps;
        g = b.memoizedProps;
        f = e.value;
        var h = b.type._context;
        I$2(jg, h._currentValue);
        h._currentValue = f;
        if (null !== g) if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
          if (g.children === e.children && !K$2.current) {
            b = $h(a, b, c);
            break a;
          }
        } else for (h = b.child, null !== h && (h.return = b); null !== h;) {
          var k = h.dependencies;
          if (null !== k) {
            g = h.child;
            for (var l = k.firstContext; null !== l;) {
              if (l.context === d && 0 !== (l.observedBits & f)) {
                1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                h.expirationTime < c && (h.expirationTime = c);
                l = h.alternate;
                null !== l && l.expirationTime < c && (l.expirationTime = c);
                pg(h.return, c);
                k.expirationTime < c && (k.expirationTime = c);
                break;
              }
              l = l.next;
            }
          } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
          if (null !== g) g.return = h;else for (g = h; null !== g;) {
            if (g === b) {
              g = null;
              break;
            }
            h = g.sibling;
            if (null !== h) {
              h.return = g.return;
              g = h;
              break;
            }
            g = g.return;
          }
          h = g;
        }
        R$1$1(a, b, e.children, c);
        b = b.child;
      }
      return b;
    case 9:
      return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R$1$1(a, b, d, c), b.child;
    case 14:
      return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
    case 15:
      return ci(a, b, b.type, b.pendingProps, d, c);
    case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L$2$1(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
    case 19:
      return mi(a, b, c);
  }
  throw Error(u$1$1(156, b.tag));
};
var Uj = null,
  Li = null;
function Yj(a) {
  if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
  var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (b.isDisabled || !b.supportsFiber) return !0;
  try {
    var c = b.inject(a);
    Uj = function Uj(a) {
      try {
        b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
      } catch (e) {}
    };
    Li = function Li(a) {
      try {
        b.onCommitFiberUnmount(c, a);
      } catch (e) {}
    };
  } catch (d) {}
  return !0;
}
function Zj(a, b, c, d) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d;
  this.effectTag = 0;
  this.lastEffect = this.firstEffect = this.nextEffect = null;
  this.childExpirationTime = this.expirationTime = 0;
  this.alternate = null;
}
function Sh(a, b, c, d) {
  return new Zj(a, b, c, d);
}
function bi(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}
function Xj(a) {
  if ("function" === typeof a) return bi(a) ? 1 : 0;
  if (void 0 !== a && null !== a) {
    a = a.$$typeof;
    if (a === gb) return 11;
    if (a === jb) return 14;
  }
  return 2;
}
function Sg(a, b) {
  var c = a.alternate;
  null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
  c.childExpirationTime = a.childExpirationTime;
  c.expirationTime = a.expirationTime;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = null === b ? null : {
    expirationTime: b.expirationTime,
    firstContext: b.firstContext,
    responders: b.responders
  };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}
function Ug(a, b, c, d, e, f) {
  var g = 2;
  d = a;
  if ("function" === typeof a) bi(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
    case ab:
      return Wg(c.children, e, f, b);
    case fb:
      g = 8;
      e |= 7;
      break;
    case bb:
      g = 8;
      e |= 1;
      break;
    case cb:
      return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
    case hb:
      return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
    case ib:
      return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
    default:
      if ("object" === typeof a && null !== a) switch (a.$$typeof) {
        case db:
          g = 10;
          break a;
        case eb:
          g = 9;
          break a;
        case gb:
          g = 11;
          break a;
        case jb:
          g = 14;
          break a;
        case kb:
          g = 16;
          d = null;
          break a;
        case lb:
          g = 22;
          break a;
      }
      throw Error(u$1$1(130, null == a ? a : typeof a, ""));
  }
  b = Sh(g, c, b, e);
  b.elementType = a;
  b.type = d;
  b.expirationTime = f;
  return b;
}
function Wg(a, b, c, d) {
  a = Sh(7, a, d, b);
  a.expirationTime = c;
  return a;
}
function Tg(a, b, c) {
  a = Sh(6, a, null, b);
  a.expirationTime = c;
  return a;
}
function Vg(a, b, c) {
  b = Sh(4, null !== a.children ? a.children : [], a.key, b);
  b.expirationTime = c;
  b.stateNode = {
    containerInfo: a.containerInfo,
    pendingChildren: null,
    implementation: a.implementation
  };
  return b;
}
function ak(a, b, c) {
  this.tag = b;
  this.current = null;
  this.containerInfo = a;
  this.pingCache = this.pendingChildren = null;
  this.finishedExpirationTime = 0;
  this.finishedWork = null;
  this.timeoutHandle = -1;
  this.pendingContext = this.context = null;
  this.hydrate = c;
  this.callbackNode = null;
  this.callbackPriority = 90;
  this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
  var c = a.firstSuspendedTime;
  a = a.lastSuspendedTime;
  return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
  var c = a.firstSuspendedTime,
    d = a.lastSuspendedTime;
  c < b && (a.firstSuspendedTime = b);
  if (d > b || 0 === c) a.lastSuspendedTime = b;
  b <= a.lastPingedTime && (a.lastPingedTime = 0);
  b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
  b > a.firstPendingTime && (a.firstPendingTime = b);
  var c = a.firstSuspendedTime;
  0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
  var c = a.lastExpiredTime;
  if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
  var e = b.current,
    f = Gg(),
    g = Dg.suspense;
  f = Hg(f, e, g);
  a: if (c) {
    c = c._reactInternalFiber;
    b: {
      if (dc(c) !== c || 1 !== c.tag) throw Error(u$1$1(170));
      var h = c;
      do {
        switch (h.tag) {
          case 3:
            h = h.stateNode.context;
            break b;
          case 1:
            if (L$2$1(h.type)) {
              h = h.stateNode.__reactInternalMemoizedMergedChildContext;
              break b;
            }
        }
        h = h.return;
      } while (null !== h);
      throw Error(u$1$1(171));
    }
    if (1 === c.tag) {
      var k = c.type;
      if (L$2$1(k)) {
        c = Ff(c, k, h);
        break a;
      }
    }
    c = h;
  } else c = Af;
  null === b.context ? b.context = c : b.pendingContext = c;
  b = wg(f, g);
  b.payload = {
    element: a
  };
  d = void 0 === d ? null : d;
  null !== d && (b.callback = d);
  xg(e, b);
  Ig(e, f);
  return f;
}
function ck(a) {
  a = a.current;
  if (!a.child) return null;
  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;
    default:
      return a.child.stateNode;
  }
}
function dk(a, b) {
  a = a.memoizedState;
  null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
  dk(a, b);
  (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
  c = null != c && !0 === c.hydrate;
  var d = new ak(a, b, c),
    e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
  d.current = e;
  e.stateNode = d;
  ug(e);
  a[Od] = d.current;
  c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
  this._internalRoot = d;
}
fk.prototype.render = function (a) {
  bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function () {
  var a = this._internalRoot,
    b = a.containerInfo;
  bk(null, a, null, function () {
    b[Od] = null;
  });
};
function gk(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
  if (!b) for (var c; c = a.lastChild;) a.removeChild(c);
  return new fk(a, 0, b ? {
    hydrate: !0
  } : void 0);
}
function ik(a, b, c, d, e) {
  var f = c._reactRootContainer;
  if (f) {
    var g = f._internalRoot;
    if ("function" === typeof e) {
      var h = e;
      e = function e() {
        var a = ck(g);
        h.call(a);
      };
    }
    bk(b, g, a, e);
  } else {
    f = c._reactRootContainer = hk(c, d);
    g = f._internalRoot;
    if ("function" === typeof e) {
      var k = e;
      e = function e() {
        var a = ck(g);
        k.call(a);
      };
    }
    Nj(function () {
      bk(b, g, a, e);
    });
  }
  return ck(g);
}
function jk(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return {
    $$typeof: $a,
    key: null == d ? null : "" + d,
    children: a,
    containerInfo: b,
    implementation: c
  };
}
wc = function wc(a) {
  if (13 === a.tag) {
    var b = hg(Gg(), 150, 100);
    Ig(a, b);
    ek(a, b);
  }
};
xc = function xc(a) {
  13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function yc(a) {
  if (13 === a.tag) {
    var b = Gg();
    b = Hg(b, a, null);
    Ig(a, b);
    ek(a, b);
  }
};
za = function za(a, b, c) {
  switch (b) {
    case "input":
      Cb(a, c);
      b = c.name;
      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) c = c.parentNode;
        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
        for (b = 0; b < c.length; b++) {
          var d = c[b];
          if (d !== a && d.form === a.form) {
            var e = Qd(d);
            if (!e) throw Error(u$1$1(90));
            yb(d);
            Cb(d, e);
          }
        }
      }
      break;
    case "textarea":
      Kb(a, c);
      break;
    case "select":
      b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
  }
};
Fa = Mj;
Ga = function Ga(a, b, c, d, e) {
  var f = W$1$1;
  W$1$1 |= 4;
  try {
    return cg(98, a.bind(null, b, c, d, e));
  } finally {
    W$1$1 = f, W$1$1 === V$1$1 && gg();
  }
};
Ha = function Ha() {
  (W$1$1 & (1 | fj | gj)) === V$1$1 && (Lj(), Dj());
};
Ia = function Ia(a, b) {
  var c = W$1$1;
  W$1$1 |= 2;
  try {
    return a(b);
  } finally {
    W$1$1 = c, W$1$1 === V$1$1 && gg();
  }
};
function kk(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!gk(b)) throw Error(u$1$1(200));
  return jk(a, b, null, c);
}
var lk = {
  Events: [Nc, Pd, Qd, xa, ta, Xd, function (a) {
    jc(a, Wd);
  }, Da, Ea, id, mc, Dj, {
    current: !1
  }]
};
(function (a) {
  var b = a.findFiberByHostInstance;
  return Yj(objectAssign({}, a, {
    overrideHookState: null,
    overrideProps: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: Wa.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
      a = hc(a);
      return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: function findFiberByHostInstance(a) {
      return b ? b(a) : null;
    },
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
  }));
})({
  findFiberByHostInstance: tc,
  bundleType: 0,
  version: "16.13.1",
  rendererPackageName: "react-dom"
});
var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED$1 = lk;
var createPortal$1 = kk;
var findDOMNode = function findDOMNode(a) {
  if (null == a) return null;
  if (1 === a.nodeType) return a;
  var b = a._reactInternalFiber;
  if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(u$1$1(188));
    throw Error(u$1$1(268, Object.keys(a)));
  }
  a = hc(b);
  a = null === a ? null : a.stateNode;
  return a;
};
var flushSync$1 = function flushSync$1(a, b) {
  if ((W$1$1 & (fj | gj)) !== V$1$1) throw Error(u$1$1(187));
  var c = W$1$1;
  W$1$1 |= 1;
  try {
    return cg(99, a.bind(null, b));
  } finally {
    W$1$1 = c, gg();
  }
};
var hydrate = function hydrate(a, b, c) {
  if (!gk(b)) throw Error(u$1$1(200));
  return ik(null, a, b, !0, c);
};
var render = function render(a, b, c) {
  if (!gk(b)) throw Error(u$1$1(200));
  return ik(null, a, b, !1, c);
};
var unmountComponentAtNode = function unmountComponentAtNode(a) {
  if (!gk(a)) throw Error(u$1$1(40));
  return a._reactRootContainer ? (Nj(function () {
    ik(null, null, a, !1, function () {
      a._reactRootContainer = null;
      a[Od] = null;
    });
  }), !0) : !1;
};
var unstable_batchedUpdates = Mj;
var unstable_createPortal = function unstable_createPortal(a, b) {
  return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
var unstable_renderSubtreeIntoContainer = function unstable_renderSubtreeIntoContainer(a, b, c, d) {
  if (!gk(c)) throw Error(u$1$1(200));
  if (null == a || void 0 === a._reactInternalFiber) throw Error(u$1$1(38));
  return ik(a, b, c, !1, d);
};
var version$1 = "16.13.1";
var reactDom_production_min = {
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED$1,
  createPortal: createPortal$1,
  findDOMNode: findDOMNode,
  flushSync: flushSync$1,
  hydrate: hydrate,
  render: render,
  unmountComponentAtNode: unmountComponentAtNode,
  unstable_batchedUpdates: unstable_batchedUpdates,
  unstable_createPortal: unstable_createPortal,
  unstable_renderSubtreeIntoContainer: unstable_renderSubtreeIntoContainer,
  version: version$1
};
var reactDom_development = createCommonjsModule$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = react;
      var _assign = objectAssign;
      var Scheduler = scheduler;
      var checkPropTypes = checkPropTypes_1;
      var tracing$1 = tracing;
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // Prevent newer renderers from RTE when used with older react package versions.
      // Current owner and dispatcher used to share the same ref,
      // but PR #14548 split them out to better support the react-debug-tools package.

      if (!ReactSharedInternals.hasOwnProperty('ReactCurrentDispatcher')) {
        ReactSharedInternals.ReactCurrentDispatcher = {
          current: null
        };
      }
      if (!ReactSharedInternals.hasOwnProperty('ReactCurrentBatchConfig')) {
        ReactSharedInternals.ReactCurrentBatchConfig = {
          suspense: null
        };
      }

      // by calls to these methods by a Babel plugin.
      //
      // In PROD (or in packages without access to React internals),
      // they are left as they are instead.

      function warn(format) {
        {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          printWarning('warn', format, args);
        }
      }
      function error(format) {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          printWarning('error', format, args);
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;
          if (!hasExistingStack) {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== '') {
              format += '%s';
              args = args.concat([stack]);
            }
          }
          var argsWithFormat = args.map(function (item) {
            return '' + item;
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });
            throw new Error(message);
          } catch (x) {}
        }
      }
      if (!React) {
        {
          throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
        }
      }
      var invokeGuardedCallbackImpl = function invokeGuardedCallbackImpl(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
          func.apply(context, funcArgs);
        } catch (error) {
          this.onError(error);
        }
      };
      {
        // In DEV mode, we swap out invokeGuardedCallback for a special version
        // that plays more nicely with the browser's DevTools. The idea is to preserve
        // "Pause on exceptions" behavior. Because React wraps all user-provided
        // functions in invokeGuardedCallback, and the production version of
        // invokeGuardedCallback uses a try-catch, all user exceptions are treated
        // like caught exceptions, and the DevTools won't pause unless the developer
        // takes the extra step of enabling pause on caught exceptions. This is
        // unintuitive, though, because even though React has caught the error, from
        // the developer's perspective, the error is uncaught.
        //
        // To preserve the expected "Pause on exceptions" behavior, we don't use a
        // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
        // DOM node, and call the user-provided callback from inside an event handler
        // for that fake event. If the callback throws, the error is "captured" using
        // a global event handler. But because the error happens in a different
        // event loop context, it does not interrupt the normal program flow.
        // Effectively, this gives us try-catch behavior without actually using
        // try-catch. Neat!
        // Check that the browser supports the APIs we need to implement our special
        // DEV version of invokeGuardedCallback
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
          var fakeNode = document.createElement('react');
          var invokeGuardedCallbackDev = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== 'undefined')) {
              {
                throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
              }
            }
            var evt = document.createEvent('Event'); // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.

            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.

            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688

            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event'); // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.

            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
              // We immediately remove the callback from event listeners so that
              // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
              // nested call would trigger the fake event handlers of any call higher
              // in the stack.
              fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
              // window.event assignment in both IE <= 10 as they throw an error
              // "Member not found" in strict mode, and in Firefox which does not
              // support window.event.

              if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                window.event = windowEvent;
              }
              func.apply(context, funcArgs);
              didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.

            var error; // Use this to track whether the error event is ever called.

            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
              error = event.error;
              didSetError = true;
              if (error === null && event.colno === 0 && event.lineno === 0) {
                isCrossOriginError = true;
              }
              if (event.defaultPrevented) {
                // Some other error handler has prevented default.
                // Browsers silence the error report if this happens.
                // We'll remember this to later decide whether to log it or not.
                if (error != null && typeof error === 'object') {
                  try {
                    error._suppressLogging = true;
                  } catch (inner) {// Ignore.
                  }
                }
              }
            } // Create a fake event type.

            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.

            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) {
              Object.defineProperty(window, 'event', windowEventDescriptor);
            }
            if (didError) {
              if (!didSetError) {
                // The callback errored, but the error event never fired.
                error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
              } else if (isCrossOriginError) {
                error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://fb.me/react-crossorigin-error for more information.');
              }
              this.onError(error);
            } // Remove our event listeners

            window.removeEventListener('error', handleWindowError);
          };
          invokeGuardedCallbackImpl = invokeGuardedCallbackDev;
        }
      }
      var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
      var hasError = false;
      var caughtError = null; // Used by event system to capture/rethrow the first error.

      var hasRethrowError = false;
      var rethrowError = null;
      var reporter = {
        onError: function onError(error) {
          hasError = true;
          caughtError = error;
        }
      };
      /**
       * Call a function while guarding against errors that happens within it.
       * Returns an error if it throws, otherwise null.
       *
       * In production, this is implemented using a try-catch. The reason we don't
       * use a try-catch directly is so that we can swap out a different
       * implementation in DEV mode.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
      }
      /**
       * Same as invokeGuardedCallback, but instead of returning an error, it stores
       * it in a global so it can be rethrown by `rethrowCaughtError` later.
       * TODO: See if caughtError and rethrowError can be unified.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
          var error = clearCaughtError();
          if (!hasRethrowError) {
            hasRethrowError = true;
            rethrowError = error;
          }
        }
      }
      /**
       * During execution of guarded functions we will capture the first error which
       * we will rethrow to be handled by the top level error handler.
       */

      function rethrowCaughtError() {
        if (hasRethrowError) {
          var error = rethrowError;
          hasRethrowError = false;
          rethrowError = null;
          throw error;
        }
      }
      function hasCaughtError() {
        return hasError;
      }
      function clearCaughtError() {
        if (hasError) {
          var error = caughtError;
          hasError = false;
          caughtError = null;
          return error;
        } else {
          {
            {
              throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
      }
      var getFiberCurrentPropsFromNode = null;
      var getInstanceFromNode = null;
      var getNodeFromInstance = null;
      function setComponentTree(getFiberCurrentPropsFromNodeImpl, getInstanceFromNodeImpl, getNodeFromInstanceImpl) {
        getFiberCurrentPropsFromNode = getFiberCurrentPropsFromNodeImpl;
        getInstanceFromNode = getInstanceFromNodeImpl;
        getNodeFromInstance = getNodeFromInstanceImpl;
        {
          if (!getNodeFromInstance || !getInstanceFromNode) {
            error('EventPluginUtils.setComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.');
          }
        }
      }
      var validateEventDispatches;
      {
        validateEventDispatches = function validateEventDispatches(event) {
          var dispatchListeners = event._dispatchListeners;
          var dispatchInstances = event._dispatchInstances;
          var listenersIsArr = Array.isArray(dispatchListeners);
          var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
          var instancesIsArr = Array.isArray(dispatchInstances);
          var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
          if (instancesIsArr !== listenersIsArr || instancesLen !== listenersLen) {
            error('EventPluginUtils: Invalid `event`.');
          }
        };
      }
      /**
       * Dispatch the event to the listener.
       * @param {SyntheticEvent} event SyntheticEvent to handle
       * @param {function} listener Application-level callback
       * @param {*} inst Internal component instance
       */

      function executeDispatch(event, listener, inst) {
        var type = event.type || 'unknown-event';
        event.currentTarget = getNodeFromInstance(inst);
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
      }
      /**
       * Standard/simple iteration through an event's collected dispatches.
       */

      function executeDispatchesInOrder(event) {
        var dispatchListeners = event._dispatchListeners;
        var dispatchInstances = event._dispatchInstances;
        {
          validateEventDispatches(event);
        }
        if (Array.isArray(dispatchListeners)) {
          for (var i = 0; i < dispatchListeners.length; i++) {
            if (event.isPropagationStopped()) {
              break;
            } // Listeners and Instances are two parallel arrays that are always in sync.

            executeDispatch(event, dispatchListeners[i], dispatchInstances[i]);
          }
        } else if (dispatchListeners) {
          executeDispatch(event, dispatchListeners, dispatchInstances);
        }
        event._dispatchListeners = null;
        event._dispatchInstances = null;
      }
      var FunctionComponent = 0;
      var ClassComponent = 1;
      var IndeterminateComponent = 2; // Before we know whether it is function or class

      var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

      var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

      var HostComponent = 5;
      var HostText = 6;
      var Fragment$$1 = 7;
      var Mode = 8;
      var ContextConsumer = 9;
      var ContextProvider = 10;
      var ForwardRef = 11;
      var Profiler = 12;
      var SuspenseComponent = 13;
      var MemoComponent = 14;
      var SimpleMemoComponent = 15;
      var LazyComponent = 16;
      var IncompleteClassComponent = 17;
      var DehydratedFragment = 18;
      var SuspenseListComponent = 19;
      var FundamentalComponent = 20;
      var ScopeComponent = 21;
      var Block = 22;

      /**
       * Injectable ordering of event plugins.
       */
      var eventPluginOrder = null;
      /**
       * Injectable mapping from names to event plugin modules.
       */

      var namesToPlugins = {};
      /**
       * Recomputes the plugin list using the injected plugins and plugin ordering.
       *
       * @private
       */

      function recomputePluginOrdering() {
        if (!eventPluginOrder) {
          // Wait until an `eventPluginOrder` is injected.
          return;
        }
        for (var pluginName in namesToPlugins) {
          var pluginModule = namesToPlugins[pluginName];
          var pluginIndex = eventPluginOrder.indexOf(pluginName);
          if (!(pluginIndex > -1)) {
            {
              throw Error("EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `" + pluginName + "`.");
            }
          }
          if (plugins[pluginIndex]) {
            continue;
          }
          if (!pluginModule.extractEvents) {
            {
              throw Error("EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `" + pluginName + "` does not.");
            }
          }
          plugins[pluginIndex] = pluginModule;
          var publishedEvents = pluginModule.eventTypes;
          for (var eventName in publishedEvents) {
            if (!publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName)) {
              {
                throw Error("EventPluginRegistry: Failed to publish event `" + eventName + "` for plugin `" + pluginName + "`.");
              }
            }
          }
        }
      }
      /**
       * Publishes an event so that it can be dispatched by the supplied plugin.
       *
       * @param {object} dispatchConfig Dispatch configuration for the event.
       * @param {object} PluginModule Plugin publishing the event.
       * @return {boolean} True if the event was successfully published.
       * @private
       */

      function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
        if (!!eventNameDispatchConfigs.hasOwnProperty(eventName)) {
          {
            throw Error("EventPluginRegistry: More than one plugin attempted to publish the same event name, `" + eventName + "`.");
          }
        }
        eventNameDispatchConfigs[eventName] = dispatchConfig;
        var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
        if (phasedRegistrationNames) {
          for (var phaseName in phasedRegistrationNames) {
            if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
              var phasedRegistrationName = phasedRegistrationNames[phaseName];
              publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
            }
          }
          return true;
        } else if (dispatchConfig.registrationName) {
          publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
          return true;
        }
        return false;
      }
      /**
       * Publishes a registration name that is used to identify dispatched events.
       *
       * @param {string} registrationName Registration name to add.
       * @param {object} PluginModule Plugin publishing the event.
       * @private
       */

      function publishRegistrationName(registrationName, pluginModule, eventName) {
        if (!!registrationNameModules[registrationName]) {
          {
            throw Error("EventPluginRegistry: More than one plugin attempted to publish the same registration name, `" + registrationName + "`.");
          }
        }
        registrationNameModules[registrationName] = pluginModule;
        registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
        {
          var lowerCasedName = registrationName.toLowerCase();
          possibleRegistrationNames[lowerCasedName] = registrationName;
          if (registrationName === 'onDoubleClick') {
            possibleRegistrationNames.ondblclick = registrationName;
          }
        }
      }
      /**
       * Registers plugins so that they can extract and dispatch events.
       */

      /**
       * Ordered list of injected plugins.
       */

      var plugins = [];
      /**
       * Mapping from event name to dispatch config
       */

      var eventNameDispatchConfigs = {};
      /**
       * Mapping from registration name to plugin module
       */

      var registrationNameModules = {};
      /**
       * Mapping from registration name to event name
       */

      var registrationNameDependencies = {};
      /**
       * Mapping from lowercase registration names to the properly cased version,
       * used to warn in the case of missing event handlers. Available
       * only in true.
       * @type {Object}
       */

      var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true

      /**
       * Injects an ordering of plugins (by plugin name). This allows the ordering
       * to be decoupled from injection of the actual plugins so that ordering is
       * always deterministic regardless of packaging, on-the-fly injection, etc.
       *
       * @param {array} InjectedEventPluginOrder
       * @internal
       */

      function injectEventPluginOrder(injectedEventPluginOrder) {
        if (!!eventPluginOrder) {
          {
            throw Error("EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.");
          }
        } // Clone the ordering so it cannot be dynamically mutated.

        eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
        recomputePluginOrdering();
      }
      /**
       * Injects plugins to be used by plugin event system. The plugin names must be
       * in the ordering injected by `injectEventPluginOrder`.
       *
       * Plugins can be injected as part of page initialization or on-the-fly.
       *
       * @param {object} injectedNamesToPlugins Map from names to plugin modules.
       * @internal
       */

      function injectEventPluginsByName(injectedNamesToPlugins) {
        var isOrderingDirty = false;
        for (var pluginName in injectedNamesToPlugins) {
          if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
            continue;
          }
          var pluginModule = injectedNamesToPlugins[pluginName];
          if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
            if (!!namesToPlugins[pluginName]) {
              {
                throw Error("EventPluginRegistry: Cannot inject two different event plugins using the same name, `" + pluginName + "`.");
              }
            }
            namesToPlugins[pluginName] = pluginModule;
            isOrderingDirty = true;
          }
        }
        if (isOrderingDirty) {
          recomputePluginOrdering();
        }
      }
      var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
      var PLUGIN_EVENT_SYSTEM = 1;
      var IS_REPLAYED = 1 << 5;
      var IS_FIRST_ANCESTOR = 1 << 6;
      var restoreImpl = null;
      var restoreTarget = null;
      var restoreQueue = null;
      function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) {
          // Unmounted
          return;
        }
        if (!(typeof restoreImpl === 'function')) {
          {
            throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.

        if (stateNode) {
          var _props = getFiberCurrentPropsFromNode(stateNode);
          restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
      }
      function setRestoreImplementation(impl) {
        restoreImpl = impl;
      }
      function enqueueStateRestore(target) {
        if (restoreTarget) {
          if (restoreQueue) {
            restoreQueue.push(target);
          } else {
            restoreQueue = [target];
          }
        } else {
          restoreTarget = target;
        }
      }
      function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
      }
      function restoreStateIfNeeded() {
        if (!restoreTarget) {
          return;
        }
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) {
          for (var i = 0; i < queuedTargets.length; i++) {
            restoreStateOfTarget(queuedTargets[i]);
          }
        }
      }
      var enableDeprecatedFlareAPI = false; // Experimental Host Component support.

      var enableFundamentalAPI = false; // Experimental Scope support.
      var warnAboutStringRefs = false;

      // the renderer. Such as when we're dispatching events or if third party
      // libraries need to call batchedUpdates. Eventually, this API will go away when
      // everything is batched by default. We'll then have a similar API to opt-out of
      // scheduled work and instead do synchronous work.
      // Defaults

      var batchedUpdatesImpl = function batchedUpdatesImpl(fn, bookkeeping) {
        return fn(bookkeeping);
      };
      var discreteUpdatesImpl = function discreteUpdatesImpl(fn, a, b, c, d) {
        return fn(a, b, c, d);
      };
      var flushDiscreteUpdatesImpl = function flushDiscreteUpdatesImpl() {};
      var batchedEventUpdatesImpl = batchedUpdatesImpl;
      var isInsideEventHandler = false;
      var isBatchingEventUpdates = false;
      function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
          // If a controlled event was fired, we may need to restore the state of
          // the DOM node back to the controlled value. This is necessary when React
          // bails out of the update without touching the DOM.
          flushDiscreteUpdatesImpl();
          restoreStateIfNeeded();
        }
      }
      function batchedUpdates(fn, bookkeeping) {
        if (isInsideEventHandler) {
          // If we are currently inside another batch, we need to wait until it
          // fully completes before restoring state.
          return fn(bookkeeping);
        }
        isInsideEventHandler = true;
        try {
          return batchedUpdatesImpl(fn, bookkeeping);
        } finally {
          isInsideEventHandler = false;
          finishEventHandler();
        }
      }
      function batchedEventUpdates(fn, a, b) {
        if (isBatchingEventUpdates) {
          // If we are currently inside another batch, we need to wait until it
          // fully completes before restoring state.
          return fn(a, b);
        }
        isBatchingEventUpdates = true;
        try {
          return batchedEventUpdatesImpl(fn, a, b);
        } finally {
          isBatchingEventUpdates = false;
          finishEventHandler();
        }
      } // This is for the React Flare event system
      function discreteUpdates(fn, a, b, c, d) {
        var prevIsInsideEventHandler = isInsideEventHandler;
        isInsideEventHandler = true;
        try {
          return discreteUpdatesImpl(fn, a, b, c, d);
        } finally {
          isInsideEventHandler = prevIsInsideEventHandler;
          if (!isInsideEventHandler) {
            finishEventHandler();
          }
        }
      }
      function flushDiscreteUpdatesIfNeeded(timeStamp) {
        // event.timeStamp isn't overly reliable due to inconsistencies in
        // how different browsers have historically provided the time stamp.
        // Some browsers provide high-resolution time stamps for all events,
        // some provide low-resolution time stamps for all events. FF < 52
        // even mixes both time stamps together. Some browsers even report
        // negative time stamps or time stamps that are 0 (iOS9) in some cases.
        // Given we are only comparing two time stamps with equality (!==),
        // we are safe from the resolution differences. If the time stamp is 0
        // we bail-out of preventing the flush, which can affect semantics,
        // such as if an earlier flush removes or adds event listeners that
        // are fired in the subsequent flush. However, this is the same
        // behaviour as we had before this change, so the risks are low.
        if (!isInsideEventHandler && !enableDeprecatedFlareAPI) {
          flushDiscreteUpdatesImpl();
        }
      }
      function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        discreteUpdatesImpl = _discreteUpdatesImpl;
        flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
        batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
      }
      var DiscreteEvent = 0;
      var UserBlockingEvent = 1;
      var ContinuousEvent = 2;

      // A reserved attribute.
      // It is handled by React separately and shouldn't be written to the DOM.
      var RESERVED = 0; // A simple string attribute.
      // Attributes that aren't in the whitelist are presumed to have this type.

      var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
      // "enumerated" attributes with "true" and "false" as possible values.
      // When true, it should be set to a "true" string.
      // When false, it should be set to a "false" string.

      var BOOLEANISH_STRING = 2; // A real boolean attribute.
      // When true, it should be present (set either to an empty string or its name).
      // When false, it should be omitted.

      var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
      // When true, it should be present (set either to an empty string or its name).
      // When false, it should be omitted.
      // For any other value, should be present with that value.

      var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
      // When falsy, it should be removed.

      var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
      // When falsy, it should be removed.

      var POSITIVE_NUMERIC = 6;

      /* eslint-disable max-len */
      var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
      /* eslint-enable max-len */

      var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
      var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
      var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var illegalAttributeNameCache = {};
      var validatedAttributeNameCache = {};
      function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
          return true;
        }
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
          return false;
        }
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
          validatedAttributeNameCache[attributeName] = true;
          return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        {
          error('Invalid attribute name: `%s`', attributeName);
        }
        return false;
      }
      function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) {
          return propertyInfo.type === RESERVED;
        }
        if (isCustomComponentTag) {
          return false;
        }
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
          return true;
        }
        return false;
      }
      function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) {
          return false;
        }
        switch (typeof value) {
          case 'function': // $FlowIssue symbol is perfectly valid here

          case 'symbol':
            // eslint-disable-line
            return true;
          case 'boolean':
            {
              if (isCustomComponentTag) {
                return false;
              }
              if (propertyInfo !== null) {
                return !propertyInfo.acceptsBooleans;
              } else {
                var prefix = name.toLowerCase().slice(0, 5);
                return prefix !== 'data-' && prefix !== 'aria-';
              }
            }
          default:
            return false;
        }
      }
      function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') {
          return true;
        }
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
          return true;
        }
        if (isCustomComponentTag) {
          return false;
        }
        if (propertyInfo !== null) {
          switch (propertyInfo.type) {
            case BOOLEAN:
              return !value;
            case OVERLOADED_BOOLEAN:
              return value === false;
            case NUMERIC:
              return isNaN(value);
            case POSITIVE_NUMERIC:
              return isNaN(value) || value < 1;
          }
        }
        return false;
      }
      function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
      }
      function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
      } // When adding attributes to this list, be sure to also add them to
      // the `possibleStandardNames` module to ensure casing and incorrect
      // name warnings.

      var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

      var reservedProps = ['children', 'dangerouslySetInnerHTML',
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
      reservedProps.forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // A few React string attributes have a different name.
      // This is a mapping from React prop names to the attribute names.

      [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
        var name = _ref[0],
          attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false,
        // mustUseProperty
        attributeName,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are "enumerated" HTML attributes that accept "true" and "false".
      // In React, we let users pass `true` and `false` even though technically
      // these aren't boolean attributes (they are coerced to strings).

      ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
        // mustUseProperty
        name.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are "enumerated" SVG attributes that accept "true" and "false".
      // In React, we let users pass `true` and `false` even though technically
      // these aren't boolean attributes (they are coerced to strings).
      // Since these are SVG attributes, their attribute names are case-sensitive.

      ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are HTML boolean attributes.

      ['allowFullScreen', 'async',
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless',
      // Microdata
      'itemScope'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false,
        // mustUseProperty
        name.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are the few React props that we set as DOM properties
      // rather than attributes. These are all booleans.

      ['checked',
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are HTML attributes that are "overloaded booleans": they behave like
      // booleans, but can also accept a string value.

      ['capture', 'download' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are HTML attributes that must be positive numbers.

      ['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are HTML attributes that must be numbers.

      ['rowSpan', 'start'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false,
        // mustUseProperty
        name.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        false);
      });
      var CAMELIZE = /[\-\:]([a-z])/g;
      var capitalize = function capitalize(token) {
        return token[1].toUpperCase();
      }; // This is a list of all SVG attributes that need special casing, namespacing,
      // or boolean value assignment. Regular attributes that just accept strings
      // and have the same names are omitted, just like in the HTML whitelist.
      // Some of these attributes can be hard to find. This list was created by
      // scraping the MDN documentation.

      ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false,
        // mustUseProperty
        attributeName, null,
        // attributeNamespace
        false);
      }); // String SVG attributes with the xlink namespace.

      ['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false,
        // mustUseProperty
        attributeName, 'http://www.w3.org/1999/xlink', false);
      }); // String SVG attributes with the xml namespace.

      ['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false,
        // mustUseProperty
        attributeName, 'http://www.w3.org/XML/1998/namespace', false);
      }); // These attribute exists both in HTML and SVG.
      // The attribute name is case-sensitive in SVG so we can't just use
      // the React name like we do for attributes that exist only in HTML.

      ['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
        // mustUseProperty
        attributeName.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These attributes accept URLs. These must not allow javascript: URLS.
      // These will also need to accept Trusted Types object in the future.

      var xlinkHref = 'xlinkHref';
      properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false,
      // mustUseProperty
      'xlink:href', 'http://www.w3.org/1999/xlink', true);
      ['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
        // mustUseProperty
        attributeName.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        true);
      });
      var ReactDebugCurrentFrame = null;
      {
        ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      } // A javascript: URL can contain leading C0 control or \u0020 SPACE,
      // and any newline or tab are filtered out as if they're not part of the URL.
      // https://url.spec.whatwg.org/#url-parsing
      // Tab or newline are defined as \r\n\t:
      // https://infra.spec.whatwg.org/#ascii-tab-or-newline
      // A C0 control is a code point in the range \u0000 NULL to \u001F
      // INFORMATION SEPARATOR ONE, inclusive:
      // https://infra.spec.whatwg.org/#c0-control-or-space

      /* eslint-disable max-len */

      var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
      var didWarn = false;
      function sanitizeURL(url) {
        {
          if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
          }
        }
      }

      /**
       * Get the value for a property on a node. Only used in DEV for SSR validation.
       * The "expected" argument is used as a hint of what the expected value is.
       * Some properties have multiple equivalent values.
       */
      function getValueForProperty(node, name, expected, propertyInfo) {
        {
          if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
          } else {
            if (propertyInfo.sanitizeURL) {
              // If we haven't fully disabled javascript: URLs, and if
              // the hydration is successful of a javascript: URL, we
              // still want to warn on the client.
              sanitizeURL('' + expected);
            }
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
              if (node.hasAttribute(attributeName)) {
                var value = node.getAttribute(attributeName);
                if (value === '') {
                  return true;
                }
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                  return value;
                }
                if (value === '' + expected) {
                  return expected;
                }
                return value;
              }
            } else if (node.hasAttribute(attributeName)) {
              if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
              }
              if (propertyInfo.type === BOOLEAN) {
                // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
              } // Even if this property uses a namespace we use getAttribute
              // because we assume its namespaced name is the same as our config.
              // To use getAttributeNS we need the local name which we don't have
              // in our config atm.

              stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
              return stringValue === null ? expected : stringValue;
            } else if (stringValue === '' + expected) {
              return expected;
            } else {
              return stringValue;
            }
          }
        }
      }
      /**
       * Get the value for a attribute on a node. Only used in DEV for SSR validation.
       * The third argument is used as a hint of what the expected value is. Some
       * attributes have multiple equivalent values.
       */

      function getValueForAttribute(node, name, expected) {
        {
          if (!isAttributeNameSafe(name)) {
            return;
          }
          if (!node.hasAttribute(name)) {
            return expected === undefined ? undefined : null;
          }
          var value = node.getAttribute(name);
          if (value === '' + expected) {
            return expected;
          }
          return value;
        }
      }
      /**
       * Sets the value for a property on a node.
       *
       * @param {DOMElement} node
       * @param {string} name
       * @param {*} value
       */

      function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
          return;
        }
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
          value = null;
        } // If the prop isn't in the special list, treat it as a simple attribute.

        if (isCustomComponentTag || propertyInfo === null) {
          if (isAttributeNameSafe(name)) {
            var _attributeName = name;
            if (value === null) {
              node.removeAttribute(_attributeName);
            } else {
              node.setAttribute(_attributeName, '' + value);
            }
          }
          return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
          var propertyName = propertyInfo.propertyName;
          if (value === null) {
            var type = propertyInfo.type;
            node[propertyName] = type === BOOLEAN ? false : '';
          } else {
            // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
          }
          return;
        } // The rest are treated as attributes with special cases.

        var attributeName = propertyInfo.attributeName,
          attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) {
          node.removeAttribute(attributeName);
        } else {
          var _type = propertyInfo.type;
          var attributeValue;
          if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
            // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
          } else {
            // `setAttribute` with objects becomes only `[object]` in IE8/9,
            // ('' + value) makes it output the correct toString()-value.
            {
              attributeValue = '' + value;
            }
            if (propertyInfo.sanitizeURL) {
              sanitizeURL(attributeValue.toString());
            }
          }
          if (attributeNamespace) {
            node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
          } else {
            node.setAttribute(attributeName, attributeValue);
          }
        }
      }
      var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
      function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = '';
        if (source) {
          var path = source.fileName;
          var fileName = path.replace(BEFORE_SLASH_RE, '');
          {
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
              var match = path.match(BEFORE_SLASH_RE);
              if (match) {
                var pathBeforeSlash = match[1];
                if (pathBeforeSlash) {
                  var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
                  fileName = folderName + '/' + fileName;
                }
              }
            }
          }
          sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
        } else if (ownerName) {
          sourceInfo = ' (created by ' + ownerName + ')';
        }
        return '\n    in ' + (name || 'Unknown') + sourceInfo;
      }

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }
        return null;
      }
      var Uninitialized = -1;
      var Pending = 0;
      var Resolved = 1;
      var Rejected = 2;
      function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
      }
      function initializeLazyComponentType(lazyComponent) {
        if (lazyComponent._status === Uninitialized) {
          lazyComponent._status = Pending;
          var ctor = lazyComponent._ctor;
          var thenable = ctor();
          lazyComponent._result = thenable;
          thenable.then(function (moduleObject) {
            if (lazyComponent._status === Pending) {
              var defaultExport = moduleObject.default;
              {
                if (defaultExport === undefined) {
                  error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + "const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                }
              }
              lazyComponent._status = Resolved;
              lazyComponent._result = defaultExport;
            }
          }, function (error) {
            if (lazyComponent._status === Pending) {
              lazyComponent._status = Rejected;
              lazyComponent._result = error;
            }
          });
        }
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }
      function getComponentName(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }
        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }
        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }
        if (typeof type === 'string') {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';
          case REACT_PORTAL_TYPE:
            return 'Portal';
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';
          case REACT_SUSPENSE_TYPE:
            return 'Suspense';
          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }
        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              return 'Context.Consumer';
            case REACT_PROVIDER_TYPE:
              return 'Context.Provider';
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
              return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
              return getComponentName(type.render);
            case REACT_LAZY_TYPE:
              {
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
                break;
              }
          }
        }
        return null;
      }
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function describeFiber(fiber) {
        switch (fiber.tag) {
          case HostRoot:
          case HostPortal:
          case HostText:
          case Fragment$$1:
          case ContextProvider:
          case ContextConsumer:
            return '';
          default:
            var owner = fiber._debugOwner;
            var source = fiber._debugSource;
            var name = getComponentName(fiber.type);
            var ownerName = null;
            if (owner) {
              ownerName = getComponentName(owner.type);
            }
            return describeComponentFrame(name, source, ownerName);
        }
      }
      function getStackByFiberInDevAndProd(workInProgress) {
        var info = '';
        var node = workInProgress;
        do {
          info += describeFiber(node);
          node = node.return;
        } while (node);
        return info;
      }
      var current = null;
      var isRendering = false;
      function getCurrentFiberOwnerNameInDevOrNull() {
        {
          if (current === null) {
            return null;
          }
          var owner = current._debugOwner;
          if (owner !== null && typeof owner !== 'undefined') {
            return getComponentName(owner.type);
          }
        }
        return null;
      }
      function getCurrentFiberStackInDev() {
        {
          if (current === null) {
            return '';
          } // Safe because if current fiber exists, we are reconciling,
          // and it is guaranteed to be the work-in-progress version.

          return getStackByFiberInDevAndProd(current);
        }
      }
      function resetCurrentFiber() {
        {
          ReactDebugCurrentFrame$1.getCurrentStack = null;
          current = null;
          isRendering = false;
        }
      }
      function setCurrentFiber(fiber) {
        {
          ReactDebugCurrentFrame$1.getCurrentStack = getCurrentFiberStackInDev;
          current = fiber;
          isRendering = false;
        }
      }
      function setIsRendering(rendering) {
        {
          isRendering = rendering;
        }
      }

      // Flow does not allow string concatenation of most non-string types. To work
      // around this limitation, we use an opaque type that can only be obtained by
      // passing the value through getToStringValue first.
      function toString(value) {
        return '' + value;
      }
      function getToStringValue(value) {
        switch (typeof value) {
          case 'boolean':
          case 'number':
          case 'object':
          case 'string':
          case 'undefined':
            return value;
          default:
            // function, symbol are assigned as empty strings
            return '';
        }
      }
      var ReactDebugCurrentFrame$2 = null;
      var ReactControlledValuePropTypes = {
        checkPropTypes: null
      };
      {
        ReactDebugCurrentFrame$2 = ReactSharedInternals.ReactDebugCurrentFrame;
        var hasReadOnlyValue = {
          button: true,
          checkbox: true,
          image: true,
          hidden: true,
          radio: true,
          reset: true,
          submit: true
        };
        var propTypes$$1 = {
          value: function value(props, propName, componentName) {
            if (hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) {
              return null;
            }
            return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
          },
          checked: function checked(props, propName, componentName) {
            if (props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) {
              return null;
            }
            return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
          }
        };
        /**
         * Provide a linked `value` attribute for controlled forms. You should not use
         * this outside of the ReactDOM controlled form components.
         */

        ReactControlledValuePropTypes.checkPropTypes = function (tagName, props) {
          checkPropTypes(propTypes$$1, props, 'prop', tagName, ReactDebugCurrentFrame$2.getStackAddendum);
        };
      }
      function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
      }
      function getTracker(node) {
        return node._valueTracker;
      }
      function detachTracker(node) {
        node._valueTracker = null;
      }
      function getValueFromNode(node) {
        var value = '';
        if (!node) {
          return value;
        }
        if (isCheckable(node)) {
          value = node.checked ? 'true' : 'false';
        } else {
          value = node.value;
        }
        return value;
      }
      function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)

        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
          return;
        }
        var _get = descriptor.get,
          _set = descriptor.set;
        Object.defineProperty(node, valueField, {
          configurable: true,
          get: function get() {
            return _get.call(this);
          },
          set: function set(value) {
            currentValue = '' + value;
            _set.call(this, value);
          }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768

        Object.defineProperty(node, valueField, {
          enumerable: descriptor.enumerable
        });
        var tracker = {
          getValue: function getValue() {
            return currentValue;
          },
          setValue: function setValue(value) {
            currentValue = '' + value;
          },
          stopTracking: function stopTracking() {
            detachTracker(node);
            delete node[valueField];
          }
        };
        return tracker;
      }
      function track(node) {
        if (getTracker(node)) {
          return;
        } // TODO: Once it's just Fiber we can move this to node._wrapperState

        node._valueTracker = trackValueOnNode(node);
      }
      function updateValueIfChanged(node) {
        if (!node) {
          return false;
        }
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed

        if (!tracker) {
          return true;
        }
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
          tracker.setValue(nextValue);
          return true;
        }
        return false;
      }
      var didWarnValueDefaultValue = false;
      var didWarnCheckedDefaultChecked = false;
      var didWarnControlledToUncontrolled = false;
      var didWarnUncontrolledToControlled = false;
      function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
      }
      /**
       * Implements an <input> host component that allows setting these optional
       * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
       *
       * If `checked` or `value` are not supplied (or null/undefined), user actions
       * that affect the checked state or value will trigger updates to the element.
       *
       * If they are supplied (and not null/undefined), the rendered element will not
       * trigger updates to the element. Instead, the props must change in order for
       * the rendered element to be updated.
       *
       * The rendered element will be initialized as unchecked (or `defaultChecked`)
       * with an empty value (or `defaultValue`).
       *
       * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
       */

      function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = _assign({}, props, {
          defaultChecked: undefined,
          defaultValue: undefined,
          value: undefined,
          checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
      }
      function initWrapperState(element, props) {
        {
          ReactControlledValuePropTypes.checkPropTypes('input', props);
          if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
          }
          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
          }
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
          initialChecked: props.checked != null ? props.checked : props.defaultChecked,
          initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
          controlled: isControlled(props)
        };
      }
      function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) {
          setValueForProperty(node, 'checked', checked, false);
        }
      }
      function updateWrapper(element, props) {
        var node = element;
        {
          var controlled = isControlled(props);
          if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error('A component is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', props.type);
            didWarnUncontrolledToControlled = true;
          }
          if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error('A component is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', props.type);
            didWarnControlledToUncontrolled = true;
          }
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
          if (type === 'number') {
            if (value === 0 && node.value === '' ||
            // We explicitly want to coerce to number here if possible.
            // eslint-disable-next-line
            node.value != value) {
              node.value = toString(value);
            }
          } else if (node.value !== toString(value)) {
            node.value = toString(value);
          }
        } else if (type === 'submit' || type === 'reset') {
          // Submit/reset inputs need the attribute removed completely to avoid
          // blank-text buttons.
          node.removeAttribute('value');
          return;
        }
        {
          // When syncing the value attribute, the value comes from a cascade of
          // properties:
          //  1. The value React property
          //  2. The defaultValue React property
          //  3. Otherwise there should be no change
          if (props.hasOwnProperty('value')) {
            setDefaultValue(node, props.type, value);
          } else if (props.hasOwnProperty('defaultValue')) {
            setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
          }
        }
        {
          // When syncing the checked attribute, it only changes when it needs
          // to be removed, such as transitioning from a checkbox into a text input
          if (props.checked == null && props.defaultChecked != null) {
            node.defaultChecked = !!props.defaultChecked;
          }
        }
      }
      function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.

        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
          var type = props.type;
          var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
          // default value provided by the browser. See: #12872

          if (isButton && (props.value === undefined || props.value === null)) {
            return;
          }
          var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
          // from being lost during SSR hydration.

          if (!isHydrating) {
            {
              // When syncing the value attribute, the value property should use
              // the wrapperState._initialValue property. This uses:
              //
              //   1. The value React property when present
              //   2. The defaultValue React property when present
              //   3. An empty string
              if (initialValue !== node.value) {
                node.value = initialValue;
              }
            }
          }
          {
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
          }
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.

        var name = node.name;
        if (name !== '') {
          node.name = '';
        }
        {
          // When syncing the checked attribute, both the checked property and
          // attribute are assigned at the same time using defaultChecked. This uses:
          //
          //   1. The checked React property when present
          //   2. The defaultChecked React property when present
          //   3. Otherwise, false
          node.defaultChecked = !node.defaultChecked;
          node.defaultChecked = !!node._wrapperState.initialChecked;
        }
        if (name !== '') {
          node.name = name;
        }
      }
      function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
      }
      function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
          var queryRoot = rootNode;
          while (queryRoot.parentNode) {
            queryRoot = queryRoot.parentNode;
          } // If `rootNode.form` was non-null, then we could try `form.elements`,
          // but that sometimes behaves strangely in IE8. We could also try using
          // `form.getElementsByName`, but that will only return direct children
          // and won't include inputs that use the HTML5 `form=` attribute. Since
          // the input might not even be in a form. It might not even be in the
          // document. Let's just use the local `querySelectorAll` to ensure we don't
          // miss anything.

          var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
          for (var i = 0; i < group.length; i++) {
            var otherNode = group[i];
            if (otherNode === rootNode || otherNode.form !== rootNode.form) {
              continue;
            } // This will throw if radio buttons rendered by different copies of React
            // and the same name are rendered into the same form (same as #1939).
            // That's probably okay; we don't support it just as we don't support
            // mixing React radio buttons with non-React ones.

            var otherProps = getFiberCurrentPropsFromNode$1(otherNode);
            if (!otherProps) {
              {
                throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
              }
            } // We need update the tracked value on the named cousin since the value
            // was changed but the input saw no event or value set

            updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
            // was previously checked to update will cause it to be come re-checked
            // as appropriate.

            updateWrapper(otherNode, otherProps);
          }
        }
      } // In Chrome, assigning defaultValue to certain input types triggers input validation.
      // For number inputs, the display value loses trailing decimal points. For email inputs,
      // Chrome raises "The specified value <x> is not a valid email address".
      //
      // Here we check to see if the defaultValue has actually changed, avoiding these problems
      // when the user is inputting text
      //
      // https://github.com/facebook/react/issues/7253

      function setDefaultValue(node, type, value) {
        if (
        // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
        type !== 'number' || node.ownerDocument.activeElement !== node) {
          if (value == null) {
            node.defaultValue = toString(node._wrapperState.initialValue);
          } else if (node.defaultValue !== toString(value)) {
            node.defaultValue = toString(value);
          }
        }
      }
      var didWarnSelectedSetOnOption = false;
      var didWarnInvalidChild = false;
      function flattenChildren(children) {
        var content = ''; // Flatten children. We'll warn if they are invalid
        // during validateProps() which runs for hydration too.
        // Note that this would throw on non-element objects.
        // Elements are stringified (which is normally irrelevant
        // but matters for <fbt>).

        React.Children.forEach(children, function (child) {
          if (child == null) {
            return;
          }
          content += child; // Note: we don't warn about invalid children here.
          // Instead, this is done separately below so that
          // it happens during the hydration codepath too.
        });

        return content;
      }
      /**
       * Implements an <option> host component that warns when `selected` is set.
       */

      function validateProps(element, props) {
        {
          // This mirrors the codepath above, but runs for hydration too.
          // Warn about invalid children here so that client and hydration are consistent.
          // TODO: this seems like it could cause a DEV-only throw for hydration
          // if children contains a non-element object. We should try to avoid that.
          if (typeof props.children === 'object' && props.children !== null) {
            React.Children.forEach(props.children, function (child) {
              if (child == null) {
                return;
              }
              if (typeof child === 'string' || typeof child === 'number') {
                return;
              }
              if (typeof child.type !== 'string') {
                return;
              }
              if (!didWarnInvalidChild) {
                didWarnInvalidChild = true;
                error('Only strings and numbers are supported as <option> children.');
              }
            });
          } // TODO: Remove support for `selected` in <option>.

          if (props.selected != null && !didWarnSelectedSetOnOption) {
            error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
            didWarnSelectedSetOnOption = true;
          }
        }
      }
      function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) {
          element.setAttribute('value', toString(getToStringValue(props.value)));
        }
      }
      function getHostProps$1(element, props) {
        var hostProps = _assign({
          children: undefined
        }, props);
        var content = flattenChildren(props.children);
        if (content) {
          hostProps.children = content;
        }
        return hostProps;
      }
      var didWarnValueDefaultValue$1;
      {
        didWarnValueDefaultValue$1 = false;
      }
      function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) {
          return '\n\nCheck the render method of `' + ownerName + '`.';
        }
        return '';
      }
      var valuePropNames = ['value', 'defaultValue'];
      /**
       * Validation function for `value` and `defaultValue`.
       */

      function checkSelectPropTypes(props) {
        {
          ReactControlledValuePropTypes.checkPropTypes('select', props);
          for (var i = 0; i < valuePropNames.length; i++) {
            var propName = valuePropNames[i];
            if (props[propName] == null) {
              continue;
            }
            var isArray = Array.isArray(props[propName]);
            if (props.multiple && !isArray) {
              error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
            } else if (!props.multiple && isArray) {
              error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
            }
          }
        }
      }
      function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
          var selectedValues = propValue;
          var selectedValue = {};
          for (var i = 0; i < selectedValues.length; i++) {
            // Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
          }
          for (var _i = 0; _i < options.length; _i++) {
            var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
            if (options[_i].selected !== selected) {
              options[_i].selected = selected;
            }
            if (selected && setDefaultSelected) {
              options[_i].defaultSelected = true;
            }
          }
        } else {
          // Do not set `select.value` as exact behavior isn't consistent across all
          // browsers for all cases.
          var _selectedValue = toString(getToStringValue(propValue));
          var defaultSelected = null;
          for (var _i2 = 0; _i2 < options.length; _i2++) {
            if (options[_i2].value === _selectedValue) {
              options[_i2].selected = true;
              if (setDefaultSelected) {
                options[_i2].defaultSelected = true;
              }
              return;
            }
            if (defaultSelected === null && !options[_i2].disabled) {
              defaultSelected = options[_i2];
            }
          }
          if (defaultSelected !== null) {
            defaultSelected.selected = true;
          }
        }
      }
      /**
       * Implements a <select> host component that allows optionally setting the
       * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
       * stringable. If `multiple` is true, the prop must be an array of stringables.
       *
       * If `value` is not supplied (or null/undefined), user actions that change the
       * selected option will trigger updates to the rendered options.
       *
       * If it is supplied (and not null/undefined), the rendered options will not
       * update in response to user actions. Instead, the `value` prop must change in
       * order for the rendered options to update.
       *
       * If `defaultValue` is provided, any options with the supplied values will be
       * selected.
       */

      function getHostProps$2(element, props) {
        return _assign({}, props, {
          value: undefined
        });
      }
      function initWrapperState$1(element, props) {
        var node = element;
        {
          checkSelectPropTypes(props);
        }
        node._wrapperState = {
          wasMultiple: !!props.multiple
        };
        {
          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');
            didWarnValueDefaultValue$1 = true;
          }
        }
      }
      function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        } else if (props.defaultValue != null) {
          updateOptions(node, !!props.multiple, props.defaultValue, true);
        }
      }
      function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        } else if (wasMultiple !== !!props.multiple) {
          // For simplicity, reapply `defaultValue` if `multiple` is toggled.
          if (props.defaultValue != null) {
            updateOptions(node, !!props.multiple, props.defaultValue, true);
          } else {
            // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
          }
        }
      }
      function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        }
      }
      var didWarnValDefaultVal = false;

      /**
       * Implements a <textarea> host component that allows setting `value`, and
       * `defaultValue`. This differs from the traditional DOM API because value is
       * usually set as PCDATA children.
       *
       * If `value` is not supplied (or null/undefined), user actions that affect the
       * value will trigger updates to the element.
       *
       * If `value` is supplied (and not null/undefined), the rendered element will
       * not trigger updates to the element. Instead, the `value` prop must change in
       * order for the rendered element to be updated.
       *
       * The rendered element will be initialized with an empty value, the prop
       * `defaultValue` if specified, or the children content (deprecated).
       */
      function getHostProps$3(element, props) {
        var node = element;
        if (!(props.dangerouslySetInnerHTML == null)) {
          {
            throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
          }
        } // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.

        var hostProps = _assign({}, props, {
          value: undefined,
          defaultValue: undefined,
          children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
      }
      function initWrapperState$2(element, props) {
        var node = element;
        {
          ReactControlledValuePropTypes.checkPropTypes('textarea', props);
          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
          }
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it

        if (initialValue == null) {
          var children = props.children,
            defaultValue = props.defaultValue;
          if (children != null) {
            {
              error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
            }
            {
              if (!(defaultValue == null)) {
                {
                  throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                }
              }
              if (Array.isArray(children)) {
                if (!(children.length <= 1)) {
                  {
                    throw Error("<textarea> can only have at most one child.");
                  }
                }
                children = children[0];
              }
              defaultValue = children;
            }
          }
          if (defaultValue == null) {
            defaultValue = '';
          }
          initialValue = defaultValue;
        }
        node._wrapperState = {
          initialValue: getToStringValue(initialValue)
        };
      }
      function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed

          if (newValue !== node.value) {
            node.value = newValue;
          }
          if (props.defaultValue == null && node.defaultValue !== newValue) {
            node.defaultValue = newValue;
          }
        }
        if (defaultValue != null) {
          node.defaultValue = toString(defaultValue);
        }
      }
      function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.

        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/

        if (textContent === node._wrapperState.initialValue) {
          if (textContent !== '' && textContent !== null) {
            node.value = textContent;
          }
        }
      }
      function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
      }
      var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
      var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
      var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
      var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
      }; // Assumes there is no parent namespace.

      function getIntrinsicNamespace(type) {
        switch (type) {
          case 'svg':
            return SVG_NAMESPACE;
          case 'math':
            return MATH_NAMESPACE;
          default:
            return HTML_NAMESPACE;
        }
      }
      function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
          // No (or default) parent namespace: potential entry point.
          return getIntrinsicNamespace(type);
        }
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
          // We're leaving SVG.
          return HTML_NAMESPACE;
        } // By default, pass namespace below.

        return parentNamespace;
      }

      /* globals MSApp */

      /**
       * Create a function which has 'unsafe' privileges (required by windows8 apps)
       */
      var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
          return function (arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function () {
              return func(arg0, arg1, arg2, arg3);
            });
          };
        } else {
          return func;
        }
      };
      var reusableSVGContainer;
      /**
       * Set the innerHTML property of a node
       *
       * @param {DOMElement} node
       * @param {string} html
       * @internal
       */

      var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
        if (node.namespaceURI === Namespaces.svg) {
          if (!('innerHTML' in node)) {
            // IE does not have innerHTML for SVG nodes, so instead we inject the
            // new markup in a temp node and then move the child nodes across into
            // the target node
            reusableSVGContainer = reusableSVGContainer || document.createElement('div');
            reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
            var svgNode = reusableSVGContainer.firstChild;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            while (svgNode.firstChild) {
              node.appendChild(svgNode.firstChild);
            }
            return;
          }
        }
        node.innerHTML = html;
      });

      /**
       * HTML nodeType values that represent the type of the node
       */
      var ELEMENT_NODE = 1;
      var TEXT_NODE = 3;
      var COMMENT_NODE = 8;
      var DOCUMENT_NODE = 9;
      var DOCUMENT_FRAGMENT_NODE = 11;

      /**
       * Set the textContent property of a node. For text updates, it's faster
       * to set the `nodeValue` of the Text node directly instead of using
       * `.textContent` which will remove the existing node and create a new one.
       *
       * @param {DOMElement} node
       * @param {string} text
       * @internal
       */

      var setTextContent = function setTextContent(node, text) {
        if (text) {
          var firstChild = node.firstChild;
          if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
            firstChild.nodeValue = text;
            return;
          }
        }
        node.textContent = text;
      };

      // Do not use the below two methods directly!
      // Instead use constants exported from DOMTopLevelEventTypes in ReactDOM.
      // (It is the only module that is allowed to access these methods.)
      function unsafeCastStringToDOMTopLevelType(topLevelType) {
        return topLevelType;
      }
      function unsafeCastDOMTopLevelTypeToString(topLevelType) {
        return topLevelType;
      }

      /**
       * Generate a mapping of standard vendor prefixes using the defined style property and event name.
       *
       * @param {string} styleProp
       * @param {string} eventName
       * @returns {object}
       */

      function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
      }
      /**
       * A list of event names to a configurable list of vendor prefixes.
       */

      var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
      };
      /**
       * Event names that have already been detected and prefixed (if applicable).
       */

      var prefixedEventNames = {};
      /**
       * Element to check for prefixes on.
       */

      var style = {};
      /**
       * Bootstrap if a DOM exists.
       */

      if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.

        if (!('AnimationEvent' in window)) {
          delete vendorPrefixes.animationend.animation;
          delete vendorPrefixes.animationiteration.animation;
          delete vendorPrefixes.animationstart.animation;
        } // Same as above

        if (!('TransitionEvent' in window)) {
          delete vendorPrefixes.transitionend.transition;
        }
      }
      /**
       * Attempts to determine the correct vendor prefixed event name.
       *
       * @param {string} eventName
       * @returns {string}
       */

      function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) {
          return prefixedEventNames[eventName];
        } else if (!vendorPrefixes[eventName]) {
          return eventName;
        }
        var prefixMap = vendorPrefixes[eventName];
        for (var styleProp in prefixMap) {
          if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
            return prefixedEventNames[eventName] = prefixMap[styleProp];
          }
        }
        return eventName;
      }

      /**
       * To identify top level events in ReactDOM, we use constants defined by this
       * module. This is the only module that uses the unsafe* methods to express
       * that the constants actually correspond to the browser event names. This lets
       * us save some bundle size by avoiding a top level type -> event name map.
       * The rest of ReactDOM code should import top level types from this file.
       */

      var TOP_ABORT = unsafeCastStringToDOMTopLevelType('abort');
      var TOP_ANIMATION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationend'));
      var TOP_ANIMATION_ITERATION = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationiteration'));
      var TOP_ANIMATION_START = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationstart'));
      var TOP_BLUR = unsafeCastStringToDOMTopLevelType('blur');
      var TOP_CAN_PLAY = unsafeCastStringToDOMTopLevelType('canplay');
      var TOP_CAN_PLAY_THROUGH = unsafeCastStringToDOMTopLevelType('canplaythrough');
      var TOP_CANCEL = unsafeCastStringToDOMTopLevelType('cancel');
      var TOP_CHANGE = unsafeCastStringToDOMTopLevelType('change');
      var TOP_CLICK = unsafeCastStringToDOMTopLevelType('click');
      var TOP_CLOSE = unsafeCastStringToDOMTopLevelType('close');
      var TOP_COMPOSITION_END = unsafeCastStringToDOMTopLevelType('compositionend');
      var TOP_COMPOSITION_START = unsafeCastStringToDOMTopLevelType('compositionstart');
      var TOP_COMPOSITION_UPDATE = unsafeCastStringToDOMTopLevelType('compositionupdate');
      var TOP_CONTEXT_MENU = unsafeCastStringToDOMTopLevelType('contextmenu');
      var TOP_COPY = unsafeCastStringToDOMTopLevelType('copy');
      var TOP_CUT = unsafeCastStringToDOMTopLevelType('cut');
      var TOP_DOUBLE_CLICK = unsafeCastStringToDOMTopLevelType('dblclick');
      var TOP_AUX_CLICK = unsafeCastStringToDOMTopLevelType('auxclick');
      var TOP_DRAG = unsafeCastStringToDOMTopLevelType('drag');
      var TOP_DRAG_END = unsafeCastStringToDOMTopLevelType('dragend');
      var TOP_DRAG_ENTER = unsafeCastStringToDOMTopLevelType('dragenter');
      var TOP_DRAG_EXIT = unsafeCastStringToDOMTopLevelType('dragexit');
      var TOP_DRAG_LEAVE = unsafeCastStringToDOMTopLevelType('dragleave');
      var TOP_DRAG_OVER = unsafeCastStringToDOMTopLevelType('dragover');
      var TOP_DRAG_START = unsafeCastStringToDOMTopLevelType('dragstart');
      var TOP_DROP = unsafeCastStringToDOMTopLevelType('drop');
      var TOP_DURATION_CHANGE = unsafeCastStringToDOMTopLevelType('durationchange');
      var TOP_EMPTIED = unsafeCastStringToDOMTopLevelType('emptied');
      var TOP_ENCRYPTED = unsafeCastStringToDOMTopLevelType('encrypted');
      var TOP_ENDED = unsafeCastStringToDOMTopLevelType('ended');
      var TOP_ERROR = unsafeCastStringToDOMTopLevelType('error');
      var TOP_FOCUS = unsafeCastStringToDOMTopLevelType('focus');
      var TOP_GOT_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType('gotpointercapture');
      var TOP_INPUT = unsafeCastStringToDOMTopLevelType('input');
      var TOP_INVALID = unsafeCastStringToDOMTopLevelType('invalid');
      var TOP_KEY_DOWN = unsafeCastStringToDOMTopLevelType('keydown');
      var TOP_KEY_PRESS = unsafeCastStringToDOMTopLevelType('keypress');
      var TOP_KEY_UP = unsafeCastStringToDOMTopLevelType('keyup');
      var TOP_LOAD = unsafeCastStringToDOMTopLevelType('load');
      var TOP_LOAD_START = unsafeCastStringToDOMTopLevelType('loadstart');
      var TOP_LOADED_DATA = unsafeCastStringToDOMTopLevelType('loadeddata');
      var TOP_LOADED_METADATA = unsafeCastStringToDOMTopLevelType('loadedmetadata');
      var TOP_LOST_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType('lostpointercapture');
      var TOP_MOUSE_DOWN = unsafeCastStringToDOMTopLevelType('mousedown');
      var TOP_MOUSE_MOVE = unsafeCastStringToDOMTopLevelType('mousemove');
      var TOP_MOUSE_OUT = unsafeCastStringToDOMTopLevelType('mouseout');
      var TOP_MOUSE_OVER = unsafeCastStringToDOMTopLevelType('mouseover');
      var TOP_MOUSE_UP = unsafeCastStringToDOMTopLevelType('mouseup');
      var TOP_PASTE = unsafeCastStringToDOMTopLevelType('paste');
      var TOP_PAUSE = unsafeCastStringToDOMTopLevelType('pause');
      var TOP_PLAY = unsafeCastStringToDOMTopLevelType('play');
      var TOP_PLAYING = unsafeCastStringToDOMTopLevelType('playing');
      var TOP_POINTER_CANCEL = unsafeCastStringToDOMTopLevelType('pointercancel');
      var TOP_POINTER_DOWN = unsafeCastStringToDOMTopLevelType('pointerdown');
      var TOP_POINTER_MOVE = unsafeCastStringToDOMTopLevelType('pointermove');
      var TOP_POINTER_OUT = unsafeCastStringToDOMTopLevelType('pointerout');
      var TOP_POINTER_OVER = unsafeCastStringToDOMTopLevelType('pointerover');
      var TOP_POINTER_UP = unsafeCastStringToDOMTopLevelType('pointerup');
      var TOP_PROGRESS = unsafeCastStringToDOMTopLevelType('progress');
      var TOP_RATE_CHANGE = unsafeCastStringToDOMTopLevelType('ratechange');
      var TOP_RESET = unsafeCastStringToDOMTopLevelType('reset');
      var TOP_SCROLL = unsafeCastStringToDOMTopLevelType('scroll');
      var TOP_SEEKED = unsafeCastStringToDOMTopLevelType('seeked');
      var TOP_SEEKING = unsafeCastStringToDOMTopLevelType('seeking');
      var TOP_SELECTION_CHANGE = unsafeCastStringToDOMTopLevelType('selectionchange');
      var TOP_STALLED = unsafeCastStringToDOMTopLevelType('stalled');
      var TOP_SUBMIT = unsafeCastStringToDOMTopLevelType('submit');
      var TOP_SUSPEND = unsafeCastStringToDOMTopLevelType('suspend');
      var TOP_TEXT_INPUT = unsafeCastStringToDOMTopLevelType('textInput');
      var TOP_TIME_UPDATE = unsafeCastStringToDOMTopLevelType('timeupdate');
      var TOP_TOGGLE = unsafeCastStringToDOMTopLevelType('toggle');
      var TOP_TOUCH_CANCEL = unsafeCastStringToDOMTopLevelType('touchcancel');
      var TOP_TOUCH_END = unsafeCastStringToDOMTopLevelType('touchend');
      var TOP_TOUCH_MOVE = unsafeCastStringToDOMTopLevelType('touchmove');
      var TOP_TOUCH_START = unsafeCastStringToDOMTopLevelType('touchstart');
      var TOP_TRANSITION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('transitionend'));
      var TOP_VOLUME_CHANGE = unsafeCastStringToDOMTopLevelType('volumechange');
      var TOP_WAITING = unsafeCastStringToDOMTopLevelType('waiting');
      var TOP_WHEEL = unsafeCastStringToDOMTopLevelType('wheel'); // List of events that need to be individually attached to media elements.
      // Note that events in this list will *not* be listened to at the top level
      // unless they're explicitly whitelisted in `ReactBrowserEventEmitter.listenTo`.

      var mediaEventTypes = [TOP_ABORT, TOP_CAN_PLAY, TOP_CAN_PLAY_THROUGH, TOP_DURATION_CHANGE, TOP_EMPTIED, TOP_ENCRYPTED, TOP_ENDED, TOP_ERROR, TOP_LOADED_DATA, TOP_LOADED_METADATA, TOP_LOAD_START, TOP_PAUSE, TOP_PLAY, TOP_PLAYING, TOP_PROGRESS, TOP_RATE_CHANGE, TOP_SEEKED, TOP_SEEKING, TOP_STALLED, TOP_SUSPEND, TOP_TIME_UPDATE, TOP_VOLUME_CHANGE, TOP_WAITING];
      function getRawEventName(topLevelType) {
        return unsafeCastDOMTopLevelTypeToString(topLevelType);
      }
      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map; // prettier-ignore

      var elementListenerMap = new PossiblyWeakMap();
      function getListenerMapForElement(element) {
        var listenerMap = elementListenerMap.get(element);
        if (listenerMap === undefined) {
          listenerMap = new Map();
          elementListenerMap.set(element, listenerMap);
        }
        return listenerMap;
      }

      /**
       * `ReactInstanceMap` maintains a mapping from a public facing stateful
       * instance (key) and the internal representation (value). This allows public
       * methods to accept the user facing instance as an argument and map them back
       * to internal methods.
       *
       * Note that this module is currently shared and assumed to be stateless.
       * If this becomes an actual Map, that will break.
       */
      function get(key) {
        return key._reactInternalFiber;
      }
      function has(key) {
        return key._reactInternalFiber !== undefined;
      }
      function set(key, value) {
        key._reactInternalFiber = value;
      }

      // Don't change these two values. They're used by React Dev Tools.
      var NoEffect = /*              */
      0;
      var PerformedWork = /*         */
      1; // You can change the rest (and add more).

      var Placement = /*             */
      2;
      var Update = /*                */
      4;
      var PlacementAndUpdate = /*    */
      6;
      var Deletion = /*              */
      8;
      var ContentReset = /*          */
      16;
      var Callback = /*              */
      32;
      var DidCapture = /*            */
      64;
      var Ref = /*                   */
      128;
      var Snapshot = /*              */
      256;
      var Passive = /*               */
      512;
      var Hydrating = /*             */
      1024;
      var HydratingAndUpdate = /*    */
      1028; // Passive & Update & Callback & Ref & Snapshot

      var LifecycleEffectMask = /*   */
      932; // Union of all host effects

      var HostEffectMask = /*        */
      2047;
      var Incomplete = /*            */
      2048;
      var ShouldCapture = /*         */
      4096;
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
          // If there is no alternate, this might be a new tree that isn't inserted
          // yet. If it is, then it will have a pending insertion effect on it.
          var nextNode = node;
          do {
            node = nextNode;
            if ((node.effectTag & (Placement | Hydrating)) !== NoEffect) {
              // This is an insertion or in-progress hydration. The nearest possible
              // mounted fiber is the parent but we need to continue to figure out
              // if that one is still mounted.
              nearestMounted = node.return;
            }
            nextNode = node.return;
          } while (nextNode);
        } else {
          while (node.return) {
            node = node.return;
          }
        }
        if (node.tag === HostRoot) {
          // TODO: Check if this was a nested HostRoot when used with
          // renderContainerIntoSubtree.
          return nearestMounted;
        } // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.

        return null;
      }
      function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
          var suspenseState = fiber.memoizedState;
          if (suspenseState === null) {
            var current = fiber.alternate;
            if (current !== null) {
              suspenseState = current.memoizedState;
            }
          }
          if (suspenseState !== null) {
            return suspenseState.dehydrated;
          }
        }
        return null;
      }
      function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
      }
      function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
      }
      function isMounted(component) {
        {
          var owner = ReactCurrentOwner.current;
          if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) {
              error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component');
            }
            instance._warnedAboutRefsInRender = true;
          }
        }
        var fiber = get(component);
        if (!fiber) {
          return false;
        }
        return getNearestMountedFiber(fiber) === fiber;
      }
      function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) {
          {
            throw Error("Unable to find node on an unmounted component.");
          }
        }
      }
      function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
          // If there is no alternate, then we only need to check if it is mounted.
          var nearestMounted = getNearestMountedFiber(fiber);
          if (!(nearestMounted !== null)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
          if (nearestMounted !== fiber) {
            return null;
          }
          return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.

        var a = fiber;
        var b = alternate;
        while (true) {
          var parentA = a.return;
          if (parentA === null) {
            // We're at the root.
            break;
          }
          var parentB = parentA.alternate;
          if (parentB === null) {
            // There is no alternate. This is an unusual case. Currently, it only
            // happens when a Suspense component is hidden. An extra fragment fiber
            // is inserted in between the Suspense fiber and its children. Skip
            // over this extra fragment fiber and proceed to the next parent.
            var nextParent = parentA.return;
            if (nextParent !== null) {
              a = b = nextParent;
              continue;
            } // If there's no parent, we're at the root.

            break;
          } // If both copies of the parent fiber point to the same child, we can
          // assume that the child is current. This happens when we bailout on low
          // priority: the bailed out fiber's child reuses the current child.

          if (parentA.child === parentB.child) {
            var child = parentA.child;
            while (child) {
              if (child === a) {
                // We've determined that A is the current branch.
                assertIsMounted(parentA);
                return fiber;
              }
              if (child === b) {
                // We've determined that B is the current branch.
                assertIsMounted(parentA);
                return alternate;
              }
              child = child.sibling;
            } // We should never have an alternate for any mounting node. So the only
            // way this could possibly happen is if this was unmounted, if at all.

            {
              {
                throw Error("Unable to find node on an unmounted component.");
              }
            }
          }
          if (a.return !== b.return) {
            // The return pointer of A and the return pointer of B point to different
            // fibers. We assume that return pointers never criss-cross, so A must
            // belong to the child set of A.return, and B must belong to the child
            // set of B.return.
            a = parentA;
            b = parentB;
          } else {
            // The return pointers point to the same fiber. We'll have to use the
            // default, slow path: scan the child sets of each parent alternate to see
            // which child belongs to which set.
            //
            // Search parent A's child set
            var didFindChild = false;
            var _child = parentA.child;
            while (_child) {
              if (_child === a) {
                didFindChild = true;
                a = parentA;
                b = parentB;
                break;
              }
              if (_child === b) {
                didFindChild = true;
                b = parentA;
                a = parentB;
                break;
              }
              _child = _child.sibling;
            }
            if (!didFindChild) {
              // Search parent B's child set
              _child = parentB.child;
              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentB;
                  b = parentA;
                  break;
                }
                if (_child === b) {
                  didFindChild = true;
                  b = parentB;
                  a = parentA;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                {
                  throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
              }
            }
          }
          if (!(a.alternate === b)) {
            {
              throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.

        if (!(a.tag === HostRoot)) {
          {
            throw Error("Unable to find node on an unmounted component.");
          }
        }
        if (a.stateNode.current === a) {
          // We've determined that A is the current branch.
          return fiber;
        } // Otherwise B has to be current branch.

        return alternate;
      }
      function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) {
          return null;
        } // Next we'll drill down this component to find the first HostComponent/Text.

        var node = currentParent;
        while (true) {
          if (node.tag === HostComponent || node.tag === HostText) {
            return node;
          } else if (node.child) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === currentParent) {
            return null;
          }
          while (!node.sibling) {
            if (!node.return || node.return === currentParent) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable

        return null;
      }
      function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) {
          return null;
        } // Next we'll drill down this component to find the first HostComponent/Text.

        var node = currentParent;
        while (true) {
          if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) {
            return node;
          } else if (node.child && node.tag !== HostPortal) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === currentParent) {
            return null;
          }
          while (!node.sibling) {
            if (!node.return || node.return === currentParent) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable

        return null;
      }

      /**
       * Accumulates items that must not be null or undefined into the first one. This
       * is used to conserve memory by avoiding array allocations, and thus sacrifices
       * API cleanness. Since `current` can be null before being passed in and not
       * null after this function, make sure to assign it back to `current`:
       *
       * `a = accumulateInto(a, b);`
       *
       * This API should be sparingly used. Try `accumulate` for something cleaner.
       *
       * @return {*|array<*>} An accumulation of items.
       */

      function accumulateInto(current, next) {
        if (!(next != null)) {
          {
            throw Error("accumulateInto(...): Accumulated items must not be null or undefined.");
          }
        }
        if (current == null) {
          return next;
        } // Both are not empty. Warning: Never call x.concat(y) when you are not
        // certain that x is an Array (x could be a string with concat method).

        if (Array.isArray(current)) {
          if (Array.isArray(next)) {
            current.push.apply(current, next);
            return current;
          }
          current.push(next);
          return current;
        }
        if (Array.isArray(next)) {
          // A bit too dangerous to mutate `next`.
          return [current].concat(next);
        }
        return [current, next];
      }

      /**
       * @param {array} arr an "accumulation" of items which is either an Array or
       * a single item. Useful when paired with the `accumulate` module. This is a
       * simple utility that allows us to reason about a collection of items, but
       * handling the case when there is exactly one item (and we do not need to
       * allocate an array).
       * @param {function} cb Callback invoked with each element or a collection.
       * @param {?} [scope] Scope used as `this` in a callback.
       */
      function forEachAccumulated(arr, cb, scope) {
        if (Array.isArray(arr)) {
          arr.forEach(cb, scope);
        } else if (arr) {
          cb.call(scope, arr);
        }
      }

      /**
       * Internal queue of events that have accumulated their dispatches and are
       * waiting to have their dispatches executed.
       */

      var eventQueue = null;
      /**
       * Dispatches an event and releases it back into the pool, unless persistent.
       *
       * @param {?object} event Synthetic event to be dispatched.
       * @private
       */

      var executeDispatchesAndRelease = function executeDispatchesAndRelease(event) {
        if (event) {
          executeDispatchesInOrder(event);
          if (!event.isPersistent()) {
            event.constructor.release(event);
          }
        }
      };
      var executeDispatchesAndReleaseTopLevel = function executeDispatchesAndReleaseTopLevel(e) {
        return executeDispatchesAndRelease(e);
      };
      function runEventsInBatch(events) {
        if (events !== null) {
          eventQueue = accumulateInto(eventQueue, events);
        } // Set `eventQueue` to null before processing it so that we can tell if more
        // events get enqueued while processing.

        var processingEventQueue = eventQueue;
        eventQueue = null;
        if (!processingEventQueue) {
          return;
        }
        forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
        if (!!eventQueue) {
          {
            throw Error("processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.");
          }
        } // This would be a good time to rethrow if any of the event handlers threw.

        rethrowCaughtError();
      }

      /**
       * Gets the target node from a native browser event by accounting for
       * inconsistencies in browser DOM APIs.
       *
       * @param {object} nativeEvent Native browser event.
       * @return {DOMEventTarget} Target node.
       */

      function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963

        if (target.correspondingUseElement) {
          target = target.correspondingUseElement;
        } // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html

        return target.nodeType === TEXT_NODE ? target.parentNode : target;
      }

      /**
       * Checks if an event is supported in the current execution environment.
       *
       * NOTE: This will not work correctly for non-generic events such as `change`,
       * `reset`, `load`, `error`, and `select`.
       *
       * Borrows from Modernizr.
       *
       * @param {string} eventNameSuffix Event name, e.g. "click".
       * @return {boolean} True if the event is supported.
       * @internal
       * @license Modernizr 3.0.0pre (Custom Build) | MIT
       */

      function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) {
          return false;
        }
        var eventName = 'on' + eventNameSuffix;
        var isSupported = (eventName in document);
        if (!isSupported) {
          var element = document.createElement('div');
          element.setAttribute(eventName, 'return;');
          isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
      }

      /**
       * Summary of `DOMEventPluginSystem` event handling:
       *
       *  - Top-level delegation is used to trap most native browser events. This
       *    may only occur in the main thread and is the responsibility of
       *    ReactDOMEventListener, which is injected and can therefore support
       *    pluggable event sources. This is the only work that occurs in the main
       *    thread.
       *
       *  - We normalize and de-duplicate events to account for browser quirks. This
       *    may be done in the worker thread.
       *
       *  - Forward these native events (with the associated top-level type used to
       *    trap it) to `EventPluginRegistry`, which in turn will ask plugins if they want
       *    to extract any synthetic events.
       *
       *  - The `EventPluginRegistry` will then process each event by annotating them with
       *    "dispatches", a sequence of listeners and IDs that care about that event.
       *
       *  - The `EventPluginRegistry` then dispatches the events.
       *
       * Overview of React and the event system:
       *
       * +------------+    .
       * |    DOM     |    .
       * +------------+    .
       *       |           .
       *       v           .
       * +------------+    .
       * | ReactEvent |    .
       * |  Listener  |    .
       * +------------+    .                         +-----------+
       *       |           .               +--------+|SimpleEvent|
       *       |           .               |         |Plugin     |
       * +-----|------+    .               v         +-----------+
       * |     |      |    .    +--------------+                    +------------+
       * |     +-----------.--->|PluginRegistry|                    |    Event   |
       * |            |    .    |              |     +-----------+  | Propagators|
       * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
       * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
       * |            |    .    |              |     +-----------+  |  utilities |
       * |     +-----------.--->|              |                    +------------+
       * |     |      |    .    +--------------+
       * +-----|------+    .                ^        +-----------+
       *       |           .                |        |Enter/Leave|
       *       +           .                +-------+|Plugin     |
       * +-------------+   .                         +-----------+
       * | application |   .
       * |-------------|   .
       * |             |   .
       * |             |   .
       * +-------------+   .
       *                   .
       *    React Core     .  General Purpose Event Plugin System
       */

      var CALLBACK_BOOKKEEPING_POOL_SIZE = 10;
      var callbackBookkeepingPool = [];
      function releaseTopLevelCallbackBookKeeping(instance) {
        instance.topLevelType = null;
        instance.nativeEvent = null;
        instance.targetInst = null;
        instance.ancestors.length = 0;
        if (callbackBookkeepingPool.length < CALLBACK_BOOKKEEPING_POOL_SIZE) {
          callbackBookkeepingPool.push(instance);
        }
      } // Used to store ancestor hierarchy in top level callback

      function getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags) {
        if (callbackBookkeepingPool.length) {
          var instance = callbackBookkeepingPool.pop();
          instance.topLevelType = topLevelType;
          instance.eventSystemFlags = eventSystemFlags;
          instance.nativeEvent = nativeEvent;
          instance.targetInst = targetInst;
          return instance;
        }
        return {
          topLevelType: topLevelType,
          eventSystemFlags: eventSystemFlags,
          nativeEvent: nativeEvent,
          targetInst: targetInst,
          ancestors: []
        };
      }
      /**
       * Find the deepest React component completely containing the root of the
       * passed-in instance (for use when entire React trees are nested within each
       * other). If React trees are not nested, returns null.
       */

      function findRootContainerNode(inst) {
        if (inst.tag === HostRoot) {
          return inst.stateNode.containerInfo;
        } // TODO: It may be a good idea to cache this to prevent unnecessary DOM
        // traversal, but caching is difficult to do correctly without using a
        // mutation observer to listen for all DOM changes.

        while (inst.return) {
          inst = inst.return;
        }
        if (inst.tag !== HostRoot) {
          // This can happen if we're in a detached tree.
          return null;
        }
        return inst.stateNode.containerInfo;
      }
      /**
       * Allows registered plugins an opportunity to extract events from top-level
       * native browser events.
       *
       * @return {*} An accumulation of synthetic events.
       * @internal
       */

      function extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
        var events = null;
        for (var i = 0; i < plugins.length; i++) {
          // Not every plugin in the ordering may be loaded at runtime.
          var possiblePlugin = plugins[i];
          if (possiblePlugin) {
            var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            if (extractedEvents) {
              events = accumulateInto(events, extractedEvents);
            }
          }
        }
        return events;
      }
      function runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
        var events = extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        runEventsInBatch(events);
      }
      function handleTopLevel(bookKeeping) {
        var targetInst = bookKeeping.targetInst; // Loop through the hierarchy, in case there's any nested components.
        // It's important that we build the array of ancestors before calling any
        // event handlers, because event handlers can modify the DOM, leading to
        // inconsistencies with ReactMount's node cache. See #1105.

        var ancestor = targetInst;
        do {
          if (!ancestor) {
            var ancestors = bookKeeping.ancestors;
            ancestors.push(ancestor);
            break;
          }
          var root = findRootContainerNode(ancestor);
          if (!root) {
            break;
          }
          var tag = ancestor.tag;
          if (tag === HostComponent || tag === HostText) {
            bookKeeping.ancestors.push(ancestor);
          }
          ancestor = getClosestInstanceFromNode(root);
        } while (ancestor);
        for (var i = 0; i < bookKeeping.ancestors.length; i++) {
          targetInst = bookKeeping.ancestors[i];
          var eventTarget = getEventTarget(bookKeeping.nativeEvent);
          var topLevelType = bookKeeping.topLevelType;
          var nativeEvent = bookKeeping.nativeEvent;
          var eventSystemFlags = bookKeeping.eventSystemFlags; // If this is the first ancestor, we mark it on the system flags

          if (i === 0) {
            eventSystemFlags |= IS_FIRST_ANCESTOR;
          }
          runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, eventTarget, eventSystemFlags);
        }
      }
      function dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst) {
        var bookKeeping = getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags);
        try {
          // Event queue being processed in the same cycle allows
          // `preventDefault`.
          batchedEventUpdates(handleTopLevel, bookKeeping);
        } finally {
          releaseTopLevelCallbackBookKeeping(bookKeeping);
        }
      }
      /**
       * We listen for bubbled touch events on the document object.
       *
       * Firefox v8.01 (and possibly others) exhibited strange behavior when
       * mounting `onmousemove` events at some node that was not the document
       * element. The symptoms were that if your mouse is not moving over something
       * contained within that mount point (for example on the background) the
       * top-level listeners for `onmousemove` won't be called. However, if you
       * register the `mousemove` on the document object, then it will of course
       * catch all `mousemove`s. This along with iOS quirks, justifies restricting
       * top-level listeners to the document object only, at least for these
       * movement types of events and possibly all events.
       *
       * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
       *
       * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
       * they bubble to document.
       *
       * @param {string} registrationName Name of listener (e.g. `onClick`).
       * @param {object} mountAt Container where to mount the listener
       */

      function legacyListenToEvent(registrationName, mountAt) {
        var listenerMap = getListenerMapForElement(mountAt);
        var dependencies = registrationNameDependencies[registrationName];
        for (var i = 0; i < dependencies.length; i++) {
          var dependency = dependencies[i];
          legacyListenToTopLevelEvent(dependency, mountAt, listenerMap);
        }
      }
      function legacyListenToTopLevelEvent(topLevelType, mountAt, listenerMap) {
        if (!listenerMap.has(topLevelType)) {
          switch (topLevelType) {
            case TOP_SCROLL:
              trapCapturedEvent(TOP_SCROLL, mountAt);
              break;
            case TOP_FOCUS:
            case TOP_BLUR:
              trapCapturedEvent(TOP_FOCUS, mountAt);
              trapCapturedEvent(TOP_BLUR, mountAt); // We set the flag for a single dependency later in this function,
              // but this ensures we mark both as attached rather than just one.

              listenerMap.set(TOP_BLUR, null);
              listenerMap.set(TOP_FOCUS, null);
              break;
            case TOP_CANCEL:
            case TOP_CLOSE:
              if (isEventSupported(getRawEventName(topLevelType))) {
                trapCapturedEvent(topLevelType, mountAt);
              }
              break;
            case TOP_INVALID:
            case TOP_SUBMIT:
            case TOP_RESET:
              // We listen to them on the target DOM elements.
              // Some of them bubble so we don't want them to fire twice.
              break;
            default:
              // By default, listen on the top level to all non-media events.
              // Media events don't bubble so adding the listener wouldn't do anything.
              var isMediaEvent = mediaEventTypes.indexOf(topLevelType) !== -1;
              if (!isMediaEvent) {
                trapBubbledEvent(topLevelType, mountAt);
              }
              break;
          }
          listenerMap.set(topLevelType, null);
        }
      }
      function isListeningToAllDependencies(registrationName, mountAt) {
        var listenerMap = getListenerMapForElement(mountAt);
        var dependencies = registrationNameDependencies[registrationName];
        for (var i = 0; i < dependencies.length; i++) {
          var dependency = dependencies[i];
          if (!listenerMap.has(dependency)) {
            return false;
          }
        }
        return true;
      }
      var attemptUserBlockingHydration;
      function setAttemptUserBlockingHydration(fn) {
        attemptUserBlockingHydration = fn;
      }
      var attemptContinuousHydration;
      function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
      }
      var attemptHydrationAtCurrentPriority;
      function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
      } // TODO: Upgrade this definition once we're on a newer version of Flow that
      var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.

      var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
      // if the last target was dehydrated.

      var queuedFocus = null;
      var queuedDrag = null;
      var queuedMouse = null; // For pointer events there can be one latest event per pointerId.

      var queuedPointers = new Map();
      var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.

      var queuedExplicitHydrationTargets = [];
      function hasQueuedDiscreteEvents() {
        return queuedDiscreteEvents.length > 0;
      }
      var discreteReplayableEvents = [TOP_MOUSE_DOWN, TOP_MOUSE_UP, TOP_TOUCH_CANCEL, TOP_TOUCH_END, TOP_TOUCH_START, TOP_AUX_CLICK, TOP_DOUBLE_CLICK, TOP_POINTER_CANCEL, TOP_POINTER_DOWN, TOP_POINTER_UP, TOP_DRAG_END, TOP_DRAG_START, TOP_DROP, TOP_COMPOSITION_END, TOP_COMPOSITION_START, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_INPUT, TOP_TEXT_INPUT, TOP_CLOSE, TOP_CANCEL, TOP_COPY, TOP_CUT, TOP_PASTE, TOP_CLICK, TOP_CHANGE, TOP_CONTEXT_MENU, TOP_RESET, TOP_SUBMIT];
      var continuousReplayableEvents = [TOP_FOCUS, TOP_BLUR, TOP_DRAG_ENTER, TOP_DRAG_LEAVE, TOP_MOUSE_OVER, TOP_MOUSE_OUT, TOP_POINTER_OVER, TOP_POINTER_OUT, TOP_GOT_POINTER_CAPTURE, TOP_LOST_POINTER_CAPTURE];
      function isReplayableDiscreteEvent(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
      }
      function trapReplayableEventForDocument(topLevelType, document, listenerMap) {
        legacyListenToTopLevelEvent(topLevelType, document, listenerMap);
      }
      function eagerlyTrapReplayableEvents(container, document) {
        var listenerMapForDoc = getListenerMapForElement(document); // Discrete

        discreteReplayableEvents.forEach(function (topLevelType) {
          trapReplayableEventForDocument(topLevelType, document, listenerMapForDoc);
        }); // Continuous

        continuousReplayableEvents.forEach(function (topLevelType) {
          trapReplayableEventForDocument(topLevelType, document, listenerMapForDoc);
        });
      }
      function createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        return {
          blockedOn: blockedOn,
          topLevelType: topLevelType,
          eventSystemFlags: eventSystemFlags | IS_REPLAYED,
          nativeEvent: nativeEvent,
          container: container
        };
      }
      function queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
        queuedDiscreteEvents.push(queuedEvent);
      } // Resets the replaying for this type of continuous event to no event.

      function clearIfContinuousEvent(topLevelType, nativeEvent) {
        switch (topLevelType) {
          case TOP_FOCUS:
          case TOP_BLUR:
            queuedFocus = null;
            break;
          case TOP_DRAG_ENTER:
          case TOP_DRAG_LEAVE:
            queuedDrag = null;
            break;
          case TOP_MOUSE_OVER:
          case TOP_MOUSE_OUT:
            queuedMouse = null;
            break;
          case TOP_POINTER_OVER:
          case TOP_POINTER_OUT:
            {
              var pointerId = nativeEvent.pointerId;
              queuedPointers.delete(pointerId);
              break;
            }
          case TOP_GOT_POINTER_CAPTURE:
          case TOP_LOST_POINTER_CAPTURE:
            {
              var _pointerId = nativeEvent.pointerId;
              queuedPointerCaptures.delete(_pointerId);
              break;
            }
        }
      }
      function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
          var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
          if (blockedOn !== null) {
            var _fiber2 = getInstanceFromNode$1(blockedOn);
            if (_fiber2 !== null) {
              // Attempt to increase the priority of this target.
              attemptContinuousHydration(_fiber2);
            }
          }
          return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags and store a single event to be
        // replayed.

        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        return existingQueuedEvent;
      }
      function queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch (topLevelType) {
          case TOP_FOCUS:
            {
              var focusEvent = nativeEvent;
              queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, topLevelType, eventSystemFlags, container, focusEvent);
              return true;
            }
          case TOP_DRAG_ENTER:
            {
              var dragEvent = nativeEvent;
              queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, topLevelType, eventSystemFlags, container, dragEvent);
              return true;
            }
          case TOP_MOUSE_OVER:
            {
              var mouseEvent = nativeEvent;
              queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, topLevelType, eventSystemFlags, container, mouseEvent);
              return true;
            }
          case TOP_POINTER_OVER:
            {
              var pointerEvent = nativeEvent;
              var pointerId = pointerEvent.pointerId;
              queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, topLevelType, eventSystemFlags, container, pointerEvent));
              return true;
            }
          case TOP_GOT_POINTER_CAPTURE:
            {
              var _pointerEvent = nativeEvent;
              var _pointerId2 = _pointerEvent.pointerId;
              queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, topLevelType, eventSystemFlags, container, _pointerEvent));
              return true;
            }
        }
        return false;
      } // Check if this target is unblocked. Returns true if it's unblocked.

      function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with attemptToDispatchEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
          var nearestMounted = getNearestMountedFiber(targetInst);
          if (nearestMounted !== null) {
            var tag = nearestMounted.tag;
            if (tag === SuspenseComponent) {
              var instance = getSuspenseInstanceFromFiber(nearestMounted);
              if (instance !== null) {
                // We're blocked on hydrating this boundary.
                // Increase its priority.
                queuedTarget.blockedOn = instance;
                Scheduler.unstable_runWithPriority(queuedTarget.priority, function () {
                  attemptHydrationAtCurrentPriority(nearestMounted);
                });
                return;
              }
            } else if (tag === HostRoot) {
              var root = nearestMounted.stateNode;
              if (root.hydrate) {
                queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                // a root other than sync.

                return;
              }
            }
          }
        }
        queuedTarget.blockedOn = null;
      }
      function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) {
          return false;
        }
        var nextBlockedOn = attemptToDispatchEvent(queuedEvent.topLevelType, queuedEvent.eventSystemFlags, queuedEvent.container, queuedEvent.nativeEvent);
        if (nextBlockedOn !== null) {
          // We're still blocked. Try again later.
          var _fiber3 = getInstanceFromNode$1(nextBlockedOn);
          if (_fiber3 !== null) {
            attemptContinuousHydration(_fiber3);
          }
          queuedEvent.blockedOn = nextBlockedOn;
          return false;
        }
        return true;
      }
      function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
          map.delete(key);
        }
      }
      function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false; // First replay discrete events.

        while (queuedDiscreteEvents.length > 0) {
          var nextDiscreteEvent = queuedDiscreteEvents[0];
          if (nextDiscreteEvent.blockedOn !== null) {
            // We're still blocked.
            // Increase the priority of this boundary to unblock
            // the next discrete event.
            var _fiber4 = getInstanceFromNode$1(nextDiscreteEvent.blockedOn);
            if (_fiber4 !== null) {
              attemptUserBlockingHydration(_fiber4);
            }
            break;
          }
          var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.topLevelType, nextDiscreteEvent.eventSystemFlags, nextDiscreteEvent.container, nextDiscreteEvent.nativeEvent);
          if (nextBlockedOn !== null) {
            // We're still blocked. Try again later.
            nextDiscreteEvent.blockedOn = nextBlockedOn;
          } else {
            // We've successfully replayed the first event. Let's try the next one.
            queuedDiscreteEvents.shift();
          }
        } // Next replay any continuous events.

        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
          queuedFocus = null;
        }
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
          queuedDrag = null;
        }
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
          queuedMouse = null;
        }
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
      }
      function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
          queuedEvent.blockedOn = null;
          if (!hasScheduledReplayAttempt) {
            hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
            // now unblocked. This first might not actually be unblocked yet.
            // We could check it early to avoid scheduling an unnecessary callback.

            Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
          }
        }
      }
      function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
          scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
          // worth it because we expect very few discrete events to queue up and once
          // we are actually fully unblocked it will be fast to replay them.

          for (var i = 1; i < queuedDiscreteEvents.length; i++) {
            var queuedEvent = queuedDiscreteEvents[i];
            if (queuedEvent.blockedOn === unblocked) {
              queuedEvent.blockedOn = null;
            }
          }
        }
        if (queuedFocus !== null) {
          scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        }
        if (queuedDrag !== null) {
          scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        }
        if (queuedMouse !== null) {
          scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        }
        var unblock = function unblock(queuedEvent) {
          return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
          var queuedTarget = queuedExplicitHydrationTargets[_i];
          if (queuedTarget.blockedOn === unblocked) {
            queuedTarget.blockedOn = null;
          }
        }
        while (queuedExplicitHydrationTargets.length > 0) {
          var nextExplicitTarget = queuedExplicitHydrationTargets[0];
          if (nextExplicitTarget.blockedOn !== null) {
            // We're still blocked.
            break;
          } else {
            attemptExplicitHydrationTarget(nextExplicitTarget);
            if (nextExplicitTarget.blockedOn === null) {
              // We're unblocked.
              queuedExplicitHydrationTargets.shift();
            }
          }
        }
      }
      function addEventBubbleListener(element, eventType, listener) {
        element.addEventListener(eventType, listener, false);
      }
      function addEventCaptureListener(element, eventType, listener) {
        element.addEventListener(eventType, listener, true);
      }

      // do it in two places, which duplicates logic
      // and increases the bundle size, we do it all
      // here once. If we remove or refactor the
      // SimpleEventPlugin, we should also remove or
      // update the below line.

      var simpleEventPluginEventTypes = {};
      var topLevelEventsToDispatchConfig = new Map();
      var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
      // the code required to apply the same logic for event prioritization and that of the
      // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
      // duplication (for which there would be quite a bit). For the events that are not needed
      // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
      // array of top level events.
      // Lastly, we ignore prettier so we can keep the formatting sane.
      // prettier-ignore

      var discreteEventPairsForSimpleEventPlugin = [TOP_BLUR, 'blur', TOP_CANCEL, 'cancel', TOP_CLICK, 'click', TOP_CLOSE, 'close', TOP_CONTEXT_MENU, 'contextMenu', TOP_COPY, 'copy', TOP_CUT, 'cut', TOP_AUX_CLICK, 'auxClick', TOP_DOUBLE_CLICK, 'doubleClick', TOP_DRAG_END, 'dragEnd', TOP_DRAG_START, 'dragStart', TOP_DROP, 'drop', TOP_FOCUS, 'focus', TOP_INPUT, 'input', TOP_INVALID, 'invalid', TOP_KEY_DOWN, 'keyDown', TOP_KEY_PRESS, 'keyPress', TOP_KEY_UP, 'keyUp', TOP_MOUSE_DOWN, 'mouseDown', TOP_MOUSE_UP, 'mouseUp', TOP_PASTE, 'paste', TOP_PAUSE, 'pause', TOP_PLAY, 'play', TOP_POINTER_CANCEL, 'pointerCancel', TOP_POINTER_DOWN, 'pointerDown', TOP_POINTER_UP, 'pointerUp', TOP_RATE_CHANGE, 'rateChange', TOP_RESET, 'reset', TOP_SEEKED, 'seeked', TOP_SUBMIT, 'submit', TOP_TOUCH_CANCEL, 'touchCancel', TOP_TOUCH_END, 'touchEnd', TOP_TOUCH_START, 'touchStart', TOP_VOLUME_CHANGE, 'volumeChange'];
      var otherDiscreteEvents = [TOP_CHANGE, TOP_SELECTION_CHANGE, TOP_TEXT_INPUT, TOP_COMPOSITION_START, TOP_COMPOSITION_END, TOP_COMPOSITION_UPDATE]; // prettier-ignore

      var userBlockingPairsForSimpleEventPlugin = [TOP_DRAG, 'drag', TOP_DRAG_ENTER, 'dragEnter', TOP_DRAG_EXIT, 'dragExit', TOP_DRAG_LEAVE, 'dragLeave', TOP_DRAG_OVER, 'dragOver', TOP_MOUSE_MOVE, 'mouseMove', TOP_MOUSE_OUT, 'mouseOut', TOP_MOUSE_OVER, 'mouseOver', TOP_POINTER_MOVE, 'pointerMove', TOP_POINTER_OUT, 'pointerOut', TOP_POINTER_OVER, 'pointerOver', TOP_SCROLL, 'scroll', TOP_TOGGLE, 'toggle', TOP_TOUCH_MOVE, 'touchMove', TOP_WHEEL, 'wheel']; // prettier-ignore

      var continuousPairsForSimpleEventPlugin = [TOP_ABORT, 'abort', TOP_ANIMATION_END, 'animationEnd', TOP_ANIMATION_ITERATION, 'animationIteration', TOP_ANIMATION_START, 'animationStart', TOP_CAN_PLAY, 'canPlay', TOP_CAN_PLAY_THROUGH, 'canPlayThrough', TOP_DURATION_CHANGE, 'durationChange', TOP_EMPTIED, 'emptied', TOP_ENCRYPTED, 'encrypted', TOP_ENDED, 'ended', TOP_ERROR, 'error', TOP_GOT_POINTER_CAPTURE, 'gotPointerCapture', TOP_LOAD, 'load', TOP_LOADED_DATA, 'loadedData', TOP_LOADED_METADATA, 'loadedMetadata', TOP_LOAD_START, 'loadStart', TOP_LOST_POINTER_CAPTURE, 'lostPointerCapture', TOP_PLAYING, 'playing', TOP_PROGRESS, 'progress', TOP_SEEKING, 'seeking', TOP_STALLED, 'stalled', TOP_SUSPEND, 'suspend', TOP_TIME_UPDATE, 'timeUpdate', TOP_TRANSITION_END, 'transitionEnd', TOP_WAITING, 'waiting'];
      /**
       * Turns
       * ['abort', ...]
       * into
       * eventTypes = {
       *   'abort': {
       *     phasedRegistrationNames: {
       *       bubbled: 'onAbort',
       *       captured: 'onAbortCapture',
       *     },
       *     dependencies: [TOP_ABORT],
       *   },
       *   ...
       * };
       * topLevelEventsToDispatchConfig = new Map([
       *   [TOP_ABORT, { sameConfig }],
       * ]);
       */

      function processSimpleEventPluginPairsByPriority(eventTypes, priority) {
        // As the event types are in pairs of two, we need to iterate
        // through in twos. The events are in pairs of two to save code
        // and improve init perf of processing this array, as it will
        // result in far fewer object allocations and property accesses
        // if we only use three arrays to process all the categories of
        // instead of tuples.
        for (var i = 0; i < eventTypes.length; i += 2) {
          var topEvent = eventTypes[i];
          var event = eventTypes[i + 1];
          var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
          var onEvent = 'on' + capitalizedEvent;
          var config = {
            phasedRegistrationNames: {
              bubbled: onEvent,
              captured: onEvent + 'Capture'
            },
            dependencies: [topEvent],
            eventPriority: priority
          };
          eventPriorities.set(topEvent, priority);
          topLevelEventsToDispatchConfig.set(topEvent, config);
          simpleEventPluginEventTypes[event] = config;
        }
      }
      function processTopEventPairsByPriority(eventTypes, priority) {
        for (var i = 0; i < eventTypes.length; i++) {
          eventPriorities.set(eventTypes[i], priority);
        }
      } // SimpleEventPlugin

      processSimpleEventPluginPairsByPriority(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
      processSimpleEventPluginPairsByPriority(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
      processSimpleEventPluginPairsByPriority(continuousPairsForSimpleEventPlugin, ContinuousEvent); // Not used by SimpleEventPlugin

      processTopEventPairsByPriority(otherDiscreteEvents, DiscreteEvent);
      function getEventPriorityForPluginSystem(topLevelType) {
        var priority = eventPriorities.get(topLevelType); // Default to a ContinuousEvent. Note: we might
        // want to warn if we can't detect the priority
        // for the event.

        return priority === undefined ? ContinuousEvent : priority;
      }

      // Intentionally not named imports because Rollup would use dynamic dispatch for
      var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
        runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?

      var _enabled = true;
      function setEnabled(enabled) {
        _enabled = !!enabled;
      }
      function isEnabled() {
        return _enabled;
      }
      function trapBubbledEvent(topLevelType, element) {
        trapEventForPluginEventSystem(element, topLevelType, false);
      }
      function trapCapturedEvent(topLevelType, element) {
        trapEventForPluginEventSystem(element, topLevelType, true);
      }
      function trapEventForPluginEventSystem(container, topLevelType, capture) {
        var listener;
        switch (getEventPriorityForPluginSystem(topLevelType)) {
          case DiscreteEvent:
            listener = dispatchDiscreteEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
            break;
          case UserBlockingEvent:
            listener = dispatchUserBlockingUpdate.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
            break;
          case ContinuousEvent:
          default:
            listener = dispatchEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
            break;
        }
        var rawEventName = getRawEventName(topLevelType);
        if (capture) {
          addEventCaptureListener(container, rawEventName, listener);
        } else {
          addEventBubbleListener(container, rawEventName, listener);
        }
      }
      function dispatchDiscreteEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
        discreteUpdates(dispatchEvent, topLevelType, eventSystemFlags, container, nativeEvent);
      }
      function dispatchUserBlockingUpdate(topLevelType, eventSystemFlags, container, nativeEvent) {
        runWithPriority(UserBlockingPriority, dispatchEvent.bind(null, topLevelType, eventSystemFlags, container, nativeEvent));
      }
      function dispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        if (!_enabled) {
          return;
        }
        if (hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(topLevelType)) {
          // If we already have a queue of discrete events, and this is another discrete
          // event, then we can't dispatch it regardless of its target, since they
          // need to dispatch in order.
          queueDiscreteEvent(null,
          // Flags that we're not actually blocked on anything as far as we know.
          topLevelType, eventSystemFlags, container, nativeEvent);
          return;
        }
        var blockedOn = attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent);
        if (blockedOn === null) {
          // We successfully dispatched this event.
          clearIfContinuousEvent(topLevelType, nativeEvent);
          return;
        }
        if (isReplayableDiscreteEvent(topLevelType)) {
          // This this to be replayed later once the target is available.
          queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
          return;
        }
        if (queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent)) {
          return;
        } // We need to clear only if we didn't queue because
        // queueing is accummulative.

        clearIfContinuousEvent(topLevelType, nativeEvent); // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.

        {
          dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, null);
        }
      } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.

      function attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        // TODO: Warn if _enabled is false.
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
          var nearestMounted = getNearestMountedFiber(targetInst);
          if (nearestMounted === null) {
            // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
          } else {
            var tag = nearestMounted.tag;
            if (tag === SuspenseComponent) {
              var instance = getSuspenseInstanceFromFiber(nearestMounted);
              if (instance !== null) {
                // Queue the event to be replayed later. Abort dispatching since we
                // don't want this event dispatched twice through the event system.
                // TODO: If this is the first discrete event in the queue. Schedule an increased
                // priority for this boundary.
                return instance;
              } // This shouldn't happen, something went wrong but to avoid blocking
              // the whole system, dispatch the event without a target.
              // TODO: Warn.

              targetInst = null;
            } else if (tag === HostRoot) {
              var root = nearestMounted.stateNode;
              if (root.hydrate) {
                // If this happens during a replay something went wrong and it might block
                // the whole system.
                return getContainerFromFiber(nearestMounted);
              }
              targetInst = null;
            } else if (nearestMounted !== targetInst) {
              // If we get an event (ex: img onload) before committing that
              // component's mount, ignore it for now (that is, treat it as if it was an
              // event on a non-React tree). We might also consider queueing events and
              // dispatching them after the mount.
              targetInst = null;
            }
          }
        }
        {
          dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst);
        } // We're not blocked on anything.

        return null;
      }

      // List derived from Gecko source code:
      // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
      var shorthandToLonghand = {
        animation: ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction'],
        background: ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize'],
        backgroundPosition: ['backgroundPositionX', 'backgroundPositionY'],
        border: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTopColor', 'borderTopStyle', 'borderTopWidth'],
        borderBlockEnd: ['borderBlockEndColor', 'borderBlockEndStyle', 'borderBlockEndWidth'],
        borderBlockStart: ['borderBlockStartColor', 'borderBlockStartStyle', 'borderBlockStartWidth'],
        borderBottom: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth'],
        borderColor: ['borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor'],
        borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
        borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndStyle', 'borderInlineEndWidth'],
        borderInlineStart: ['borderInlineStartColor', 'borderInlineStartStyle', 'borderInlineStartWidth'],
        borderLeft: ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth'],
        borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
        borderRight: ['borderRightColor', 'borderRightStyle', 'borderRightWidth'],
        borderStyle: ['borderBottomStyle', 'borderLeftStyle', 'borderRightStyle', 'borderTopStyle'],
        borderTop: ['borderTopColor', 'borderTopStyle', 'borderTopWidth'],
        borderWidth: ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth'],
        columnRule: ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth'],
        columns: ['columnCount', 'columnWidth'],
        flex: ['flexBasis', 'flexGrow', 'flexShrink'],
        flexFlow: ['flexDirection', 'flexWrap'],
        font: ['fontFamily', 'fontFeatureSettings', 'fontKerning', 'fontLanguageOverride', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontWeight', 'lineHeight'],
        fontVariant: ['fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition'],
        gap: ['columnGap', 'rowGap'],
        grid: ['gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
        gridArea: ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart'],
        gridColumn: ['gridColumnEnd', 'gridColumnStart'],
        gridColumnGap: ['columnGap'],
        gridGap: ['columnGap', 'rowGap'],
        gridRow: ['gridRowEnd', 'gridRowStart'],
        gridRowGap: ['rowGap'],
        gridTemplate: ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
        listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
        margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
        marker: ['markerEnd', 'markerMid', 'markerStart'],
        mask: ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPositionX', 'maskPositionY', 'maskRepeat', 'maskSize'],
        maskPosition: ['maskPositionX', 'maskPositionY'],
        outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
        overflow: ['overflowX', 'overflowY'],
        padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
        placeContent: ['alignContent', 'justifyContent'],
        placeItems: ['alignItems', 'justifyItems'],
        placeSelf: ['alignSelf', 'justifySelf'],
        textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle'],
        textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
        transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
        wordWrap: ['overflowWrap']
      };

      /**
       * CSS properties which accept numbers but are not in units of "px".
       */
      var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
      };
      /**
       * @param {string} prefix vendor-specific prefix, eg: Webkit
       * @param {string} key style name, eg: transitionDuration
       * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
       * WebkitTransitionDuration
       */

      function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
      }
      /**
       * Support style names that may come passed in prefixed by adding permutations
       * of vendor prefixes.
       */

      var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
      // infinite loop, because it iterates over the newly added props too.

      Object.keys(isUnitlessNumber).forEach(function (prop) {
        prefixes.forEach(function (prefix) {
          isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
      });

      /**
       * Convert a value into the proper css writable value. The style name `name`
       * should be logical (no hyphens), as specified
       * in `CSSProperty.isUnitlessNumber`.
       *
       * @param {string} name CSS property name such as `topMargin`.
       * @param {*} value CSS property value such as `10px`.
       * @return {string} Normalized style value with dimensions applied.
       */

      function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) {
          return '';
        }
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
          return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        }

        return ('' + value).trim();
      }
      var uppercasePattern = /([A-Z])/g;
      var msPattern = /^ms-/;
      /**
       * Hyphenates a camelcased CSS property name, for example:
       *
       *   > hyphenateStyleName('backgroundColor')
       *   < "background-color"
       *   > hyphenateStyleName('MozTransition')
       *   < "-moz-transition"
       *   > hyphenateStyleName('msTransition')
       *   < "-ms-transition"
       *
       * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
       * is converted to `-ms-`.
       */

      function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
      }
      var warnValidStyle = function warnValidStyle() {};
      {
        // 'msTransform' is correct, but the other prefixes should be capitalized
        var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
        var msPattern$1 = /^-ms-/;
        var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

        var badStyleValueWithSemicolonPattern = /;\s*$/;
        var warnedStyleNames = {};
        var warnedStyleValues = {};
        var warnedForNaNValue = false;
        var warnedForInfinityValue = false;
        var camelize = function camelize(string) {
          return string.replace(hyphenPattern, function (_, character) {
            return character.toUpperCase();
          });
        };
        var warnHyphenatedStyleName = function warnHyphenatedStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }
          warnedStyleNames[name] = true;
          error('Unsupported style property %s. Did you mean %s?', name,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          camelize(name.replace(msPattern$1, 'ms-')));
        };
        var warnBadVendoredStyleName = function warnBadVendoredStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }
          warnedStyleNames[name] = true;
          error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
        };
        var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value) {
          if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
            return;
          }
          warnedStyleValues[value] = true;
          error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
        };
        var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value) {
          if (warnedForNaNValue) {
            return;
          }
          warnedForNaNValue = true;
          error('`NaN` is an invalid value for the `%s` css style property.', name);
        };
        var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value) {
          if (warnedForInfinityValue) {
            return;
          }
          warnedForInfinityValue = true;
          error('`Infinity` is an invalid value for the `%s` css style property.', name);
        };
        warnValidStyle = function warnValidStyle(name, value) {
          if (name.indexOf('-') > -1) {
            warnHyphenatedStyleName(name);
          } else if (badVendoredStyleNamePattern.test(name)) {
            warnBadVendoredStyleName(name);
          } else if (badStyleValueWithSemicolonPattern.test(value)) {
            warnStyleValueWithSemicolon(name, value);
          }
          if (typeof value === 'number') {
            if (isNaN(value)) {
              warnStyleValueIsNaN(name, value);
            } else if (!isFinite(value)) {
              warnStyleValueIsInfinity(name, value);
            }
          }
        };
      }
      var warnValidStyle$1 = warnValidStyle;

      /**
       * Operations for dealing with CSS properties.
       */

      /**
       * This creates a string that is expected to be equivalent to the style
       * attribute generated by server-side rendering. It by-passes warnings and
       * security checks so it's not safe to use this value for anything other than
       * comparison. It is only used in DEV for SSR validation.
       */

      function createDangerousStringForStyles(styles) {
        {
          var serialized = '';
          var delimiter = '';
          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }
            var styleValue = styles[styleName];
            if (styleValue != null) {
              var isCustomProperty = styleName.indexOf('--') === 0;
              serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
              serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
              delimiter = ';';
            }
          }
          return serialized || null;
        }
      }
      /**
       * Sets the value for multiple styles on a node.  If a value is specified as
       * '' (empty string), the corresponding style property will be unset.
       *
       * @param {DOMElement} node
       * @param {object} styles
       */

      function setValueForStyles(node, styles) {
        var style = node.style;
        for (var styleName in styles) {
          if (!styles.hasOwnProperty(styleName)) {
            continue;
          }
          var isCustomProperty = styleName.indexOf('--') === 0;
          {
            if (!isCustomProperty) {
              warnValidStyle$1(styleName, styles[styleName]);
            }
          }
          var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
          if (styleName === 'float') {
            styleName = 'cssFloat';
          }
          if (isCustomProperty) {
            style.setProperty(styleName, styleValue);
          } else {
            style[styleName] = styleValue;
          }
        }
      }
      function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
      }
      /**
       * Given {color: 'red', overflow: 'hidden'} returns {
       *   color: 'color',
       *   overflowX: 'overflow',
       *   overflowY: 'overflow',
       * }. This can be read as "the overflowY property was set by the overflow
       * shorthand". That is, the values are the property that each was derived from.
       */

      function expandShorthandMap(styles) {
        var expanded = {};
        for (var key in styles) {
          var longhands = shorthandToLonghand[key] || [key];
          for (var i = 0; i < longhands.length; i++) {
            expanded[longhands[i]] = key;
          }
        }
        return expanded;
      }
      /**
       * When mixing shorthand and longhand property names, we warn during updates if
       * we expect an incorrect result to occur. In particular, we warn for:
       *
       * Updating a shorthand property (longhand gets overwritten):
       *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
       *   becomes .style.font = 'baz'
       * Removing a shorthand property (longhand gets lost too):
       *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
       *   becomes .style.font = ''
       * Removing a longhand property (should revert to shorthand; doesn't):
       *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
       *   becomes .style.fontVariant = ''
       */

      function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        {
          if (!nextStyles) {
            return;
          }
          var expandedUpdates = expandShorthandMap(styleUpdates);
          var expandedStyles = expandShorthandMap(nextStyles);
          var warnedAbout = {};
          for (var key in expandedUpdates) {
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
              var warningKey = originalKey + ',' + correctOriginalKey;
              if (warnedAbout[warningKey]) {
                continue;
              }
              warnedAbout[warningKey] = true;
              error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + "avoid this, don't mix shorthand and non-shorthand properties " + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
          }
        }
      }

      // For HTML, certain tags should omit their close tag. We keep a whitelist for
      // those special-case tags.
      var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
      };

      // `omittedCloseTags` except that `menuitem` should still have its closing tag.

      var voidElementTags = _assign({
        menuitem: true
      }, omittedCloseTags);
      var HTML = '__html';
      var ReactDebugCurrentFrame$3 = null;
      {
        ReactDebugCurrentFrame$3 = ReactSharedInternals.ReactDebugCurrentFrame;
      }
      function assertValidProps(tag, props) {
        if (!props) {
          return;
        } // Note the use of `==` which checks for null or undefined.

        if (voidElementTags[tag]) {
          if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
            {
              throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + ReactDebugCurrentFrame$3.getStackAddendum());
            }
          }
        }
        if (props.dangerouslySetInnerHTML != null) {
          if (!(props.children == null)) {
            {
              throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            }
          }
          if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
            {
              throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.");
            }
          }
        }
        {
          if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
            error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
          }
        }
        if (!(props.style == null || typeof props.style === 'object')) {
          {
            throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + ReactDebugCurrentFrame$3.getStackAddendum());
          }
        }
      }
      function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) {
          return typeof props.is === 'string';
        }
        switch (tagName) {
          // These are reserved SVG and MathML elements.
          // We don't mind this whitelist too much because we expect it to never grow.
          // The alternative is to track the namespace in a few places which is convoluted.
          // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
          case 'annotation-xml':
          case 'color-profile':
          case 'font-face':
          case 'font-face-src':
          case 'font-face-uri':
          case 'font-face-format':
          case 'font-face-name':
          case 'missing-glyph':
            return false;
          default:
            return true;
        }
      }

      // When adding attributes to the HTML or SVG whitelist, be sure to
      // also add them to this module to ensure casing and incorrect name
      // warnings.
      var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
      };
      var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
      };
      var warnedProperties = {};
      var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
      var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
      var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
      function validateProperty(tagName, name) {
        {
          if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
            return true;
          }
          if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.

            if (correctName == null) {
              error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
              warnedProperties[name] = true;
              return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.

            if (name !== correctName) {
              error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
              warnedProperties[name] = true;
              return true;
            }
          }
          if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.

            if (standardName == null) {
              warnedProperties[name] = true;
              return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.

            if (name !== standardName) {
              error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
              warnedProperties[name] = true;
              return true;
            }
          }
        }
        return true;
      }
      function warnInvalidARIAProps(type, props) {
        {
          var invalidProps = [];
          for (var key in props) {
            var isValid = validateProperty(type, key);
            if (!isValid) {
              invalidProps.push(key);
            }
          }
          var unknownPropString = invalidProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');
          if (invalidProps.length === 1) {
            error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop', unknownPropString, type);
          } else if (invalidProps.length > 1) {
            error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop', unknownPropString, type);
          }
        }
      }
      function validateProperties(type, props) {
        if (isCustomComponent(type, props)) {
          return;
        }
        warnInvalidARIAProps(type, props);
      }
      var didWarnValueNull = false;
      function validateProperties$1(type, props) {
        {
          if (type !== 'input' && type !== 'textarea' && type !== 'select') {
            return;
          }
          if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) {
              error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
            } else {
              error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
            }
          }
        }
      }
      var validateProperty$1 = function validateProperty$1() {};
      {
        var warnedProperties$1 = {};
        var _hasOwnProperty = Object.prototype.hasOwnProperty;
        var EVENT_NAME_REGEX = /^on./;
        var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
        var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
        var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
        validateProperty$1 = function validateProperty$1(tagName, name, value, canUseEventSystem) {
          if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
            return true;
          }
          var lowerCasedName = name.toLowerCase();
          if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
            warnedProperties$1[name] = true;
            return true;
          } // We can't rely on the event system being injected on the server.

          if (canUseEventSystem) {
            if (registrationNameModules.hasOwnProperty(name)) {
              return true;
            }
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
              error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
              warnedProperties$1[name] = true;
              return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
              error('Unknown event handler property `%s`. It will be ignored.', name);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) {
              error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
            }
            warnedProperties$1[name] = true;
            return true;
          } // Let the ARIA attribute hook validate ARIA attributes

          if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
            return true;
          }
          if (lowerCasedName === 'innerhtml') {
            error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
            warnedProperties$1[name] = true;
            return true;
          }
          if (lowerCasedName === 'aria') {
            error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
            warnedProperties$1[name] = true;
            return true;
          }
          if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
            warnedProperties$1[name] = true;
            return true;
          }
          if (typeof value === 'number' && isNaN(value)) {
            error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
            warnedProperties$1[name] = true;
            return true;
          }
          var propertyInfo = getPropertyInfo(name);
          var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

          if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
              error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
          }
          if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) {
              error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
            } else {
              error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            }
            warnedProperties$1[name] = true;
            return true;
          } // Now that we've validated casing, do not validate
          // data types for reserved props

          if (isReserved) {
            return true;
          } // Warn when a known attribute is a bad type

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
          } // Warn when passing the strings 'false' or 'true' into a boolean prop

          if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
          }
          return true;
        };
      }
      var warnUnknownProperties = function warnUnknownProperties(type, props, canUseEventSystem) {
        {
          var unknownProps = [];
          for (var key in props) {
            var isValid = validateProperty$1(type, key, props[key], canUseEventSystem);
            if (!isValid) {
              unknownProps.push(key);
            }
          }
          var unknownPropString = unknownProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');
          if (unknownProps.length === 1) {
            error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior', unknownPropString, type);
          } else if (unknownProps.length > 1) {
            error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior', unknownPropString, type);
          }
        }
      };
      function validateProperties$2(type, props, canUseEventSystem) {
        if (isCustomComponent(type, props)) {
          return;
        }
        warnUnknownProperties(type, props, canUseEventSystem);
      }
      var didWarnInvalidHydration = false;
      var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
      var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
      var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
      var AUTOFOCUS = 'autoFocus';
      var CHILDREN = 'children';
      var STYLE = 'style';
      var HTML$1 = '__html';
      var HTML_NAMESPACE$1 = Namespaces.html;
      var warnedUnknownTags;
      var suppressHydrationWarning;
      var validatePropertiesInDevelopment;
      var warnForTextDifference;
      var warnForPropDifference;
      var warnForExtraAttributes;
      var warnForInvalidEventListener;
      var canDiffStyleForHydrationWarning;
      var normalizeMarkupForTextOrAttribute;
      var normalizeHTML;
      {
        warnedUnknownTags = {
          // Chrome is the only major browser not shipping <time>. But as of July
          // 2017 it intends to ship it due to widespread usage. We intentionally
          // *don't* warn for <time> even if it's unrecognized by Chrome because
          // it soon will be, and many apps have been using it anyway.
          time: true,
          // There are working polyfills for <dialog>. Let people use it.
          dialog: true,
          // Electron ships a custom <webview> tag to display external web content in
          // an isolated frame and process.
          // This tag is not present in non Electron environments such as JSDom which
          // is often used for testing purposes.
          // @see https://electronjs.org/docs/api/webview-tag
          webview: true
        };
        validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {
          validateProperties(type, props);
          validateProperties$1(type, props);
          validateProperties$2(type, props, /* canUseEventSystem */
          true);
        }; // IE 11 parses & normalizes the style attribute as opposed to other
        // browsers. It adds spaces and sorts the properties in some
        // non-alphabetical order. Handling that would require sorting CSS
        // properties in the client & server versions or applying
        // `expectedStyle` to a temporary DOM node to read its `style` attribute
        // normalized. Since it only affects IE, we're skipping style warnings
        // in that browser completely in favor of doing all that work.
        // See https://github.com/facebook/react/issues/11807

        canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
        // It also can turn \u0000 into \uFFFD inside attributes.
        // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
        // If we have a mismatch, it might be caused by that.
        // We will still patch up in this case but not fire the warning.

        var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
        var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
        normalizeMarkupForTextOrAttribute = function normalizeMarkupForTextOrAttribute(markup) {
          var markupString = typeof markup === 'string' ? markup : '' + markup;
          return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
        };
        warnForTextDifference = function warnForTextDifference(serverText, clientText) {
          if (didWarnInvalidHydration) {
            return;
          }
          var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
          var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
          if (normalizedServerText === normalizedClientText) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
        };
        warnForPropDifference = function warnForPropDifference(propName, serverValue, clientValue) {
          if (didWarnInvalidHydration) {
            return;
          }
          var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
          var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
          if (normalizedServerValue === normalizedClientValue) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
        };
        warnForExtraAttributes = function warnForExtraAttributes(attributeNames) {
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          var names = [];
          attributeNames.forEach(function (name) {
            names.push(name);
          });
          error('Extra attributes from the server: %s', names);
        };
        warnForInvalidEventListener = function warnForInvalidEventListener(registrationName, listener) {
          if (listener === false) {
            error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
          } else {
            error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
          }
        }; // Parse the HTML and read it back to normalize the HTML string so that it
        // can be used for comparison.

        normalizeHTML = function normalizeHTML(parent, html) {
          // We could have created a separate document here to avoid
          // re-initializing custom elements if they exist. But this breaks
          // how <noscript> is being handled. So we use the same document.
          // See the discussion in https://github.com/facebook/react/pull/11157.
          var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
          testElement.innerHTML = html;
          return testElement.innerHTML;
        };
      }
      function ensureListeningTo(rootContainerElement, registrationName) {
        var isDocumentOrFragment = rootContainerElement.nodeType === DOCUMENT_NODE || rootContainerElement.nodeType === DOCUMENT_FRAGMENT_NODE;
        var doc = isDocumentOrFragment ? rootContainerElement : rootContainerElement.ownerDocument;
        legacyListenToEvent(registrationName, doc);
      }
      function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
      }
      function noop() {}
      function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
      }
      function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for (var propKey in nextProps) {
          if (!nextProps.hasOwnProperty(propKey)) {
            continue;
          }
          var nextProp = nextProps[propKey];
          if (propKey === STYLE) {
            {
              if (nextProp) {
                // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
              }
            } // Relies on `updateStylesByID` not mutating `styleUpdates`.

            setValueForStyles(domElement, nextProp);
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
            if (nextHtml != null) {
              setInnerHTML(domElement, nextHtml);
            }
          } else if (propKey === CHILDREN) {
            if (typeof nextProp === 'string') {
              // Avoid setting initial textContent when the text is empty. In IE11 setting
              // textContent on a <textarea> will cause the placeholder to not
              // show within the <textarea> until it has been focused and blurred again.
              // https://github.com/facebook/react/issues/6731#issuecomment-254874553
              var canSetTextContent = tag !== 'textarea' || nextProp !== '';
              if (canSetTextContent) {
                setTextContent(domElement, nextProp);
              }
            } else if (typeof nextProp === 'number') {
              setTextContent(domElement, '' + nextProp);
            }
          } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameModules.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }
              ensureListeningTo(rootContainerElement, propKey);
            }
          } else if (nextProp != null) {
            setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
          }
        }
      }
      function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for (var i = 0; i < updatePayload.length; i += 2) {
          var propKey = updatePayload[i];
          var propValue = updatePayload[i + 1];
          if (propKey === STYLE) {
            setValueForStyles(domElement, propValue);
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            setInnerHTML(domElement, propValue);
          } else if (propKey === CHILDREN) {
            setTextContent(domElement, propValue);
          } else {
            setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
          }
        }
      }
      function createElement$$1(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.

        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE$1) {
          namespaceURI = getIntrinsicNamespace(type);
        }
        if (namespaceURI === HTML_NAMESPACE$1) {
          {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.

            if (!isCustomComponentTag && type !== type.toLowerCase()) {
              error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
            }
          }
          if (type === 'script') {
            // Create the script via .innerHTML so its "parser-inserted" flag is
            // set to true and it does not execute
            var div = ownerDocument.createElement('div');
            div.innerHTML = '<script><' + '/script>'; // eslint-disable-line
            // This is guaranteed to yield a script element.

            var firstChild = div.firstChild;
            domElement = div.removeChild(firstChild);
          } else if (typeof props.is === 'string') {
            // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
              is: props.is
            });
          } else {
            // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
            // See discussion in https://github.com/facebook/react/pull/6896
            // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
            domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
            // attributes on `select`s needs to be added before `option`s are inserted.
            // This prevents:
            // - a bug where the `select` does not scroll to the correct option because singular
            //  `select` elements automatically pick the first item #13222
            // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
            // See https://github.com/facebook/react/issues/13222
            // and https://github.com/facebook/react/issues/14239

            if (type === 'select') {
              var node = domElement;
              if (props.multiple) {
                node.multiple = true;
              } else if (props.size) {
                // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                // it is possible that no option is selected.
                //
                // This is only necessary when a select in "single selection mode".
                node.size = props.size;
              }
            }
          }
        } else {
          domElement = ownerDocument.createElementNS(namespaceURI, type);
        }
        {
          if (namespaceURI === HTML_NAMESPACE$1) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
              warnedUnknownTags[type] = true;
              error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
            }
          }
        }
        return domElement;
      }
      function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
      }
      function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        {
          validatePropertiesInDevelopment(tag, rawProps);
        } // TODO: Make sure that we check isMounted before firing any of these events.

        var props;
        switch (tag) {
          case 'iframe':
          case 'object':
          case 'embed':
            trapBubbledEvent(TOP_LOAD, domElement);
            props = rawProps;
            break;
          case 'video':
          case 'audio':
            // Create listener for each media event
            for (var i = 0; i < mediaEventTypes.length; i++) {
              trapBubbledEvent(mediaEventTypes[i], domElement);
            }
            props = rawProps;
            break;
          case 'source':
            trapBubbledEvent(TOP_ERROR, domElement);
            props = rawProps;
            break;
          case 'img':
          case 'image':
          case 'link':
            trapBubbledEvent(TOP_ERROR, domElement);
            trapBubbledEvent(TOP_LOAD, domElement);
            props = rawProps;
            break;
          case 'form':
            trapBubbledEvent(TOP_RESET, domElement);
            trapBubbledEvent(TOP_SUBMIT, domElement);
            props = rawProps;
            break;
          case 'details':
            trapBubbledEvent(TOP_TOGGLE, domElement);
            props = rawProps;
            break;
          case 'input':
            initWrapperState(domElement, rawProps);
            props = getHostProps(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          case 'option':
            validateProps(domElement, rawProps);
            props = getHostProps$1(domElement, rawProps);
            break;
          case 'select':
            initWrapperState$1(domElement, rawProps);
            props = getHostProps$2(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          case 'textarea':
            initWrapperState$2(domElement, rawProps);
            props = getHostProps$3(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          default:
            props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch (tag) {
          case 'input':
            // TODO: Make sure we check if this is still unmounted or do any clean
            // up necessary since we never stop tracking anymore.
            track(domElement);
            postMountWrapper(domElement, rawProps, false);
            break;
          case 'textarea':
            // TODO: Make sure we check if this is still unmounted or do any clean
            // up necessary since we never stop tracking anymore.
            track(domElement);
            postMountWrapper$3(domElement);
            break;
          case 'option':
            postMountWrapper$1(domElement, rawProps);
            break;
          case 'select':
            postMountWrapper$2(domElement, rawProps);
            break;
          default:
            if (typeof props.onClick === 'function') {
              // TODO: This cast may not be sound for SVG, MathML or custom elements.
              trapClickOnNonInteractiveElement(domElement);
            }
            break;
        }
      } // Calculate the diff between the two objects.

      function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        {
          validatePropertiesInDevelopment(tag, nextRawProps);
        }
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch (tag) {
          case 'input':
            lastProps = getHostProps(domElement, lastRawProps);
            nextProps = getHostProps(domElement, nextRawProps);
            updatePayload = [];
            break;
          case 'option':
            lastProps = getHostProps$1(domElement, lastRawProps);
            nextProps = getHostProps$1(domElement, nextRawProps);
            updatePayload = [];
            break;
          case 'select':
            lastProps = getHostProps$2(domElement, lastRawProps);
            nextProps = getHostProps$2(domElement, nextRawProps);
            updatePayload = [];
            break;
          case 'textarea':
            lastProps = getHostProps$3(domElement, lastRawProps);
            nextProps = getHostProps$3(domElement, nextRawProps);
            updatePayload = [];
            break;
          default:
            lastProps = lastRawProps;
            nextProps = nextRawProps;
            if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
              // TODO: This cast may not be sound for SVG, MathML or custom elements.
              trapClickOnNonInteractiveElement(domElement);
            }
            break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for (propKey in lastProps) {
          if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
            continue;
          }
          if (propKey === STYLE) {
            var lastStyle = lastProps[propKey];
            for (styleName in lastStyle) {
              if (lastStyle.hasOwnProperty(styleName)) {
                if (!styleUpdates) {
                  styleUpdates = {};
                }
                styleUpdates[styleName] = '';
              }
            }
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameModules.hasOwnProperty(propKey)) {
            // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            if (!updatePayload) {
              updatePayload = [];
            }
          } else {
            // For all other deleted properties we add it to the queue. We use
            // the whitelist in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
          }
        }
        for (propKey in nextProps) {
          var nextProp = nextProps[propKey];
          var lastProp = lastProps != null ? lastProps[propKey] : undefined;
          if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
            continue;
          }
          if (propKey === STYLE) {
            {
              if (nextProp) {
                // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
              }
            }
            if (lastProp) {
              // Unset styles on `lastProp` but not on `nextProp`.
              for (styleName in lastProp) {
                if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }
                  styleUpdates[styleName] = '';
                }
              } // Update styles that changed since `lastProp`.

              for (styleName in nextProp) {
                if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }
                  styleUpdates[styleName] = nextProp[styleName];
                }
              }
            } else {
              // Relies on `updateStylesByID` not mutating `styleUpdates`.
              if (!styleUpdates) {
                if (!updatePayload) {
                  updatePayload = [];
                }
                updatePayload.push(propKey, styleUpdates);
              }
              styleUpdates = nextProp;
            }
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
            var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
            if (nextHtml != null) {
              if (lastHtml !== nextHtml) {
                (updatePayload = updatePayload || []).push(propKey, nextHtml);
              }
            }
          } else if (propKey === CHILDREN) {
            if (lastProp !== nextProp && (typeof nextProp === 'string' || typeof nextProp === 'number')) {
              (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            }
          } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (registrationNameModules.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              // We eagerly listen to this even though we haven't committed yet.
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }
              ensureListeningTo(rootContainerElement, propKey);
            }
            if (!updatePayload && lastProp !== nextProp) {
              // This is a special case. If any listener updates we need to ensure
              // that the "current" props pointer gets updated so we need a commit
              // to update this element.
              updatePayload = [];
            }
          } else {
            // For any other property we always add it to the queue and then we
            // filter it out using the whitelist during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
          }
        }
        if (styleUpdates) {
          {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
          }
          (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
      } // Apply the diff.

      function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
          updateChecked(domElement, nextRawProps);
        }
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.

        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.

        switch (tag) {
          case 'input':
            // Update the wrapper around inputs *after* updating props. This has to
            // happen after `updateDOMProperties`. Otherwise HTML5 input validations
            // raise warnings and prevent the new value from being assigned.
            updateWrapper(domElement, nextRawProps);
            break;
          case 'textarea':
            updateWrapper$1(domElement, nextRawProps);
            break;
          case 'select':
            // <select> value update needs to occur after <option> children
            // reconciliation
            postUpdateWrapper(domElement, nextRawProps);
            break;
        }
      }
      function getPossibleStandardName(propName) {
        {
          var lowerCasedName = propName.toLowerCase();
          if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            return null;
          }
          return possibleStandardNames[lowerCasedName] || null;
        }
      }
      function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
        var isCustomComponentTag;
        var extraAttributeNames;
        {
          suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
          isCustomComponentTag = isCustomComponent(tag, rawProps);
          validatePropertiesInDevelopment(tag, rawProps);
        } // TODO: Make sure that we check isMounted before firing any of these events.

        switch (tag) {
          case 'iframe':
          case 'object':
          case 'embed':
            trapBubbledEvent(TOP_LOAD, domElement);
            break;
          case 'video':
          case 'audio':
            // Create listener for each media event
            for (var i = 0; i < mediaEventTypes.length; i++) {
              trapBubbledEvent(mediaEventTypes[i], domElement);
            }
            break;
          case 'source':
            trapBubbledEvent(TOP_ERROR, domElement);
            break;
          case 'img':
          case 'image':
          case 'link':
            trapBubbledEvent(TOP_ERROR, domElement);
            trapBubbledEvent(TOP_LOAD, domElement);
            break;
          case 'form':
            trapBubbledEvent(TOP_RESET, domElement);
            trapBubbledEvent(TOP_SUBMIT, domElement);
            break;
          case 'details':
            trapBubbledEvent(TOP_TOGGLE, domElement);
            break;
          case 'input':
            initWrapperState(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          case 'option':
            validateProps(domElement, rawProps);
            break;
          case 'select':
            initWrapperState$1(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          case 'textarea':
            initWrapperState$2(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
        }
        assertValidProps(tag, rawProps);
        {
          extraAttributeNames = new Set();
          var attributes = domElement.attributes;
          for (var _i = 0; _i < attributes.length; _i++) {
            var name = attributes[_i].name.toLowerCase();
            switch (name) {
              // Built-in SSR attribute is whitelisted
              case 'data-reactroot':
                break;
              // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.

              case 'value':
                break;
              case 'checked':
                break;
              case 'selected':
                break;
              default:
                // Intentionally use the original name.
                // See discussion in https://github.com/facebook/react/pull/10676.
                extraAttributeNames.add(attributes[_i].name);
            }
          }
        }
        var updatePayload = null;
        for (var propKey in rawProps) {
          if (!rawProps.hasOwnProperty(propKey)) {
            continue;
          }
          var nextProp = rawProps[propKey];
          if (propKey === CHILDREN) {
            // For text content children we compare against textContent. This
            // might match additional HTML that is hidden when we read it using
            // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
            // satisfies our requirement. Our requirement is not to produce perfect
            // HTML and attributes. Ideally we should preserve structure but it's
            // ok not to if the visible content is still enough to indicate what
            // even listeners these nodes might be wired up to.
            // TODO: Warn if there is more than a single textNode as a child.
            // TODO: Should we use domElement.firstChild.nodeValue to compare?
            if (typeof nextProp === 'string') {
              if (domElement.textContent !== nextProp) {
                if (!suppressHydrationWarning) {
                  warnForTextDifference(domElement.textContent, nextProp);
                }
                updatePayload = [CHILDREN, nextProp];
              }
            } else if (typeof nextProp === 'number') {
              if (domElement.textContent !== '' + nextProp) {
                if (!suppressHydrationWarning) {
                  warnForTextDifference(domElement.textContent, nextProp);
                }
                updatePayload = [CHILDREN, '' + nextProp];
              }
            }
          } else if (registrationNameModules.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }
              ensureListeningTo(rootContainerElement, propKey);
            }
          } else if (
          // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof isCustomComponentTag === 'boolean') {
            // Validate that the properties correspond to their expected values.
            var serverValue = void 0;
            var propertyInfo = getPropertyInfo(propKey);
            if (suppressHydrationWarning) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING ||
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var serverHTML = domElement.innerHTML;
              var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
              var expectedHTML = normalizeHTML(domElement, nextHtml != null ? nextHtml : '');
              if (expectedHTML !== serverHTML) {
                warnForPropDifference(propKey, serverHTML, expectedHTML);
              }
            } else if (propKey === STYLE) {
              // $FlowFixMe - Should be inferred as not undefined.
              extraAttributeNames.delete(propKey);
              if (canDiffStyleForHydrationWarning) {
                var expectedStyle = createDangerousStringForStyles(nextProp);
                serverValue = domElement.getAttribute('style');
                if (expectedStyle !== serverValue) {
                  warnForPropDifference(propKey, serverValue, expectedStyle);
                }
              }
            } else if (isCustomComponentTag) {
              // $FlowFixMe - Should be inferred as not undefined.
              extraAttributeNames.delete(propKey.toLowerCase());
              serverValue = getValueForAttribute(domElement, propKey, nextProp);
              if (nextProp !== serverValue) {
                warnForPropDifference(propKey, serverValue, nextProp);
              }
            } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
              var isMismatchDueToBadCasing = false;
              if (propertyInfo !== null) {
                // $FlowFixMe - Should be inferred as not undefined.
                extraAttributeNames.delete(propertyInfo.attributeName);
                serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
              } else {
                var ownNamespace = parentNamespace;
                if (ownNamespace === HTML_NAMESPACE$1) {
                  ownNamespace = getIntrinsicNamespace(tag);
                }
                if (ownNamespace === HTML_NAMESPACE$1) {
                  // $FlowFixMe - Should be inferred as not undefined.
                  extraAttributeNames.delete(propKey.toLowerCase());
                } else {
                  var standardName = getPossibleStandardName(propKey);
                  if (standardName !== null && standardName !== propKey) {
                    // If an SVG prop is supplied with bad casing, it will
                    // be successfully parsed from HTML, but will produce a mismatch
                    // (and would be incorrectly rendered on the client).
                    // However, we already warn about bad casing elsewhere.
                    // So we'll skip the misleading extra mismatch warning in this case.
                    isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.

                    extraAttributeNames.delete(standardName);
                  } // $FlowFixMe - Should be inferred as not undefined.

                  extraAttributeNames.delete(propKey);
                }
                serverValue = getValueForAttribute(domElement, propKey, nextProp);
              }
              if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
                warnForPropDifference(propKey, serverValue, nextProp);
              }
            }
          }
        }
        {
          // $FlowFixMe - Should be inferred as not undefined.
          if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
            // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
          }
        }
        switch (tag) {
          case 'input':
            // TODO: Make sure we check if this is still unmounted or do any clean
            // up necessary since we never stop tracking anymore.
            track(domElement);
            postMountWrapper(domElement, rawProps, true);
            break;
          case 'textarea':
            // TODO: Make sure we check if this is still unmounted or do any clean
            // up necessary since we never stop tracking anymore.
            track(domElement);
            postMountWrapper$3(domElement);
            break;
          case 'select':
          case 'option':
            // For input and textarea we current always set the value property at
            // post mount to force it to diverge from attributes. However, for
            // option and select we don't quite do the same thing and select
            // is not resilient to the DOM state changing so we don't do that here.
            // TODO: Consider not doing this for input and textarea.
            break;
          default:
            if (typeof rawProps.onClick === 'function') {
              // TODO: This cast may not be sound for SVG, MathML or custom elements.
              trapClickOnNonInteractiveElement(domElement);
            }
            break;
        }
        return updatePayload;
      }
      function diffHydratedText(textNode, text) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
      }
      function warnForUnmatchedText(textNode, text) {
        {
          warnForTextDifference(textNode.nodeValue, text);
        }
      }
      function warnForDeletedHydratableElement(parentNode, child) {
        {
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
        }
      }
      function warnForDeletedHydratableText(parentNode, child) {
        {
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
        }
      }
      function warnForInsertedHydratedElement(parentNode, tag, props) {
        {
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
        }
      }
      function warnForInsertedHydratedText(parentNode, text) {
        {
          if (text === '') {
            // We expect to insert empty text nodes since they're not represented in
            // the HTML.
            // TODO: Remove this special case if we can just avoid inserting empty
            // text nodes.
            return;
          }
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
        }
      }
      function restoreControlledState$3(domElement, tag, props) {
        switch (tag) {
          case 'input':
            restoreControlledState(domElement, props);
            return;
          case 'textarea':
            restoreControlledState$2(domElement, props);
            return;
          case 'select':
            restoreControlledState$1(domElement, props);
            return;
        }
      }
      function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') {
          return null;
        }
        try {
          return doc.activeElement || doc.body;
        } catch (e) {
          return doc.body;
        }
      }

      /**
       * Given any node return the first leaf node without children.
       *
       * @param {DOMElement|DOMTextNode} node
       * @return {DOMElement|DOMTextNode}
       */

      function getLeafNode(node) {
        while (node && node.firstChild) {
          node = node.firstChild;
        }
        return node;
      }
      /**
       * Get the next sibling within a container. This will walk up the
       * DOM if a node's siblings have been exhausted.
       *
       * @param {DOMElement|DOMTextNode} node
       * @return {?DOMElement|DOMTextNode}
       */

      function getSiblingNode(node) {
        while (node) {
          if (node.nextSibling) {
            return node.nextSibling;
          }
          node = node.parentNode;
        }
      }
      /**
       * Get object describing the nodes which contain characters at offset.
       *
       * @param {DOMElement|DOMTextNode} root
       * @param {number} offset
       * @return {?object}
       */

      function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while (node) {
          if (node.nodeType === TEXT_NODE) {
            nodeEnd = nodeStart + node.textContent.length;
            if (nodeStart <= offset && nodeEnd >= offset) {
              return {
                node: node,
                offset: offset - nodeStart
              };
            }
            nodeStart = nodeEnd;
          }
          node = getLeafNode(getSiblingNode(node));
        }
      }

      /**
       * @param {DOMElement} outerNode
       * @return {?object}
       */

      function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) {
          return null;
        }
        var anchorNode = selection.anchorNode,
          anchorOffset = selection.anchorOffset,
          focusNode = selection.focusNode,
          focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427

        try {
          /* eslint-disable no-unused-expressions */
          anchorNode.nodeType;
          focusNode.nodeType;
          /* eslint-enable no-unused-expressions */
        } catch (e) {
          return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
      }
      /**
       * Returns {start, end} where `start` is the character/codepoint index of
       * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
       * `end` is the index of (focusNode, focusOffset).
       *
       * Returns null if you pass in garbage input but we should probably just crash.
       *
       * Exported only for testing.
       */

      function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while (true) {
          var next = null;
          while (true) {
            if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
              start = length + anchorOffset;
            }
            if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
              end = length + focusOffset;
            }
            if (node.nodeType === TEXT_NODE) {
              length += node.nodeValue.length;
            }
            if ((next = node.firstChild) === null) {
              break;
            } // Moving from `node` to its first child `next`.

            parentNode = node;
            node = next;
          }
          while (true) {
            if (node === outerNode) {
              // If `outerNode` has children, this is always the second time visiting
              // it. If it has no children, this is still the first loop, and the only
              // valid selection is anchorNode and focusNode both equal to this node
              // and both offsets 0, in which case we will have handled above.
              break outer;
            }
            if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
              start = length;
            }
            if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
              end = length;
            }
            if ((next = node.nextSibling) !== null) {
              break;
            }
            node = parentNode;
            parentNode = node.parentNode;
          } // Moving from `node` to its next sibling `next`.

          node = next;
        }
        if (start === -1 || end === -1) {
          // This should never happen. (Would happen if the anchor/focus nodes aren't
          // actually inside the passed-in node.)
          return null;
        }
        return {
          start: start,
          end: end
        };
      }
      /**
       * In modern non-IE browsers, we can support both forward and backward
       * selections.
       *
       * Note: IE10+ supports the Selection object, but it does not support
       * the `extend` method, which means that even in modern IE, it's not possible
       * to programmatically create a backward selection. Thus, for all IE
       * versions, we use the old IE API to create our selections.
       *
       * @param {DOMElement|DOMTextNode} node
       * @param {object} offsets
       */

      function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)

        if (!win.getSelection) {
          return;
        }
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.

        if (!selection.extend && start > end) {
          var temp = end;
          end = start;
          start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
          if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
            return;
          }
          var range = doc.createRange();
          range.setStart(startMarker.node, startMarker.offset);
          selection.removeAllRanges();
          if (start > end) {
            selection.addRange(range);
            selection.extend(endMarker.node, endMarker.offset);
          } else {
            range.setEnd(endMarker.node, endMarker.offset);
            selection.addRange(range);
          }
        }
      }
      function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
      }
      function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) {
          return false;
        } else if (outerNode === innerNode) {
          return true;
        } else if (isTextNode(outerNode)) {
          return false;
        } else if (isTextNode(innerNode)) {
          return containsNode(outerNode, innerNode.parentNode);
        } else if ('contains' in outerNode) {
          return outerNode.contains(innerNode);
        } else if (outerNode.compareDocumentPosition) {
          return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        } else {
          return false;
        }
      }
      function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
      }
      function isSameOriginFrame(iframe) {
        try {
          // Accessing the contentDocument of a HTMLIframeElement can cause the browser
          // to throw, e.g. if it has a cross-origin src attribute.
          // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
          // iframe.contentDocument.defaultView;
          // A safety way is to access one of the cross origin properties: Window or Location
          // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
          // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
          return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
          return false;
        }
      }
      function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while (element instanceof win.HTMLIFrameElement) {
          if (isSameOriginFrame(element)) {
            win = element.contentWindow;
          } else {
            return element;
          }
          element = getActiveElement(win.document);
        }
        return element;
      }
      /**
       * @ReactInputSelection: React input selection module. Based on Selection.js,
       * but modified to be suitable for react and has a couple of bug fixes (doesn't
       * assume buttons have range selections allowed).
       * Input selection module for React.
       */

      /**
       * @hasSelectionCapabilities: we get the element types that support selection
       * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
       * and `selectionEnd` rows.
       */

      function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
      }
      function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
          // Used by Flare
          activeElementDetached: null,
          focusedElem: focusedElem,
          selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
      }
      /**
       * @restoreSelection: If any selection information was potentially lost,
       * restore it. This is useful when performing operations that could remove dom
       * nodes and place them back in, resulting in focus being lost.
       */

      function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
          if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
            setSelection(priorFocusedElem, priorSelectionRange);
          } // Focusing a node can change the scroll position, which is undesirable

          var ancestors = [];
          var ancestor = priorFocusedElem;
          while (ancestor = ancestor.parentNode) {
            if (ancestor.nodeType === ELEMENT_NODE) {
              ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
              });
            }
          }
          if (typeof priorFocusedElem.focus === 'function') {
            priorFocusedElem.focus();
          }
          for (var i = 0; i < ancestors.length; i++) {
            var info = ancestors[i];
            info.element.scrollLeft = info.left;
            info.element.scrollTop = info.top;
          }
        }
      }
      /**
       * @getSelection: Gets the selection bounds of a focused textarea, input or
       * contentEditable node.
       * -@input: Look up selection bounds of this input
       * -@return {start: selectionStart, end: selectionEnd}
       */

      function getSelection(input) {
        var selection;
        if ('selectionStart' in input) {
          // Modern browser with input or textarea.
          selection = {
            start: input.selectionStart,
            end: input.selectionEnd
          };
        } else {
          // Content editable or old IE textarea.
          selection = getOffsets(input);
        }
        return selection || {
          start: 0,
          end: 0
        };
      }
      /**
       * @setSelection: Sets the selection bounds of a textarea or input and focuses
       * the input.
       * -@input     Set selection bounds of this input or textarea
       * -@offsets   Object of same form that is returned from get*
       */

      function setSelection(input, offsets) {
        var start = offsets.start,
          end = offsets.end;
        if (end === undefined) {
          end = start;
        }
        if ('selectionStart' in input) {
          input.selectionStart = start;
          input.selectionEnd = Math.min(end, input.value.length);
        } else {
          setOffsets(input, offsets);
        }
      }
      var validateDOMNesting = function validateDOMNesting() {};
      var updatedAncestorInfo = function updatedAncestorInfo() {};
      {
        // This validation code was written based on the HTML5 parsing spec:
        // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
        //
        // Note: this does not catch all invalid nesting, nor does it try to (as it's
        // not clear what practical benefit doing so provides); instead, we warn only
        // for cases where the parser will give a parse tree differing from what React
        // intended. For example, <b><div></div></b> is invalid but we don't warn
        // because it still parses correctly; we do warn for other cases like nested
        // <p> tags where the beginning of the second element implicitly closes the
        // first, causing a confusing mess.
        // https://html.spec.whatwg.org/multipage/syntax.html#special
        var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope

        var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject', 'desc', 'title']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope

        var buttonScopeTags = inScopeTags.concat(['button']); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags

        var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
        var emptyAncestorInfo = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
        updatedAncestorInfo = function updatedAncestorInfo(oldInfo, tag) {
          var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
          var info = {
            tag: tag
          };
          if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
          }
          if (buttonScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.pTagInButtonScope = null;
          } // See rules for 'li', 'dd', 'dt' start tags in
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody

          if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
          }
          ancestorInfo.current = info;
          if (tag === 'form') {
            ancestorInfo.formTag = info;
          }
          if (tag === 'a') {
            ancestorInfo.aTagInScope = info;
          }
          if (tag === 'button') {
            ancestorInfo.buttonTagInScope = info;
          }
          if (tag === 'nobr') {
            ancestorInfo.nobrTagInScope = info;
          }
          if (tag === 'p') {
            ancestorInfo.pTagInButtonScope = info;
          }
          if (tag === 'li') {
            ancestorInfo.listItemTagAutoclosing = info;
          }
          if (tag === 'dd' || tag === 'dt') {
            ancestorInfo.dlItemTagAutoclosing = info;
          }
          return ancestorInfo;
        };
        /**
         * Returns whether
         */

        var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
          // First, let's check if we're in an unusual parsing mode...
          switch (parentTag) {
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
              return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
              return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but

            case 'option':
              return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr

            case 'tr':
              return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody

            case 'tbody':
            case 'thead':
            case 'tfoot':
              return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup

            case 'colgroup':
              return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable

            case 'table':
              return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead

            case 'head':
              return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element

            case 'html':
              return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
              return tag === 'frame';
            case '#document':
              return tag === 'html';
          } // Probably in the "in body" parsing mode, so we outlaw only tag combos
          // where the parsing rules cause implicit opens or closes to be added.
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody

          switch (tag) {
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
              return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
              // These tags are only valid with a few parents that have special child
              // parsing rules -- if we're down here, then none of those matched and
              // so we allow it only if we don't know what the parent is, as all other
              // cases are invalid.
              return parentTag == null;
          }
          return true;
        };
        /**
         * Returns whether
         */

        var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
          switch (tag) {
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return ancestorInfo.pTagInButtonScope;
            case 'form':
              return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
              return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
              return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
              return ancestorInfo.buttonTagInScope;
            case 'a':
              // Spec says something about storing a list of markers, but it sounds
              // equivalent to this check.
              return ancestorInfo.aTagInScope;
            case 'nobr':
              return ancestorInfo.nobrTagInScope;
          }
          return null;
        };
        var didWarn$1 = {};
        validateDOMNesting = function validateDOMNesting(childTag, childText, ancestorInfo) {
          ancestorInfo = ancestorInfo || emptyAncestorInfo;
          var parentInfo = ancestorInfo.current;
          var parentTag = parentInfo && parentInfo.tag;
          if (childText != null) {
            if (childTag != null) {
              error('validateDOMNesting: when childText is passed, childTag should be null');
            }
            childTag = '#text';
          }
          var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
          var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
          var invalidParentOrAncestor = invalidParent || invalidAncestor;
          if (!invalidParentOrAncestor) {
            return;
          }
          var ancestorTag = invalidParentOrAncestor.tag;
          var addendum = getCurrentFiberStackInDev();
          var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + addendum;
          if (didWarn$1[warnKey]) {
            return;
          }
          didWarn$1[warnKey] = true;
          var tagDisplayName = childTag;
          var whitespaceInfo = '';
          if (childTag === '#text') {
            if (/\S/.test(childText)) {
              tagDisplayName = 'Text nodes';
            } else {
              tagDisplayName = 'Whitespace text nodes';
              whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
            }
          } else {
            tagDisplayName = '<' + childTag + '>';
          }
          if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') {
              info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
            }
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
          } else {
            error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
          }
        };
      }
      var SUPPRESS_HYDRATION_WARNING$1;
      {
        SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
      }
      var SUSPENSE_START_DATA = '$';
      var SUSPENSE_END_DATA = '/$';
      var SUSPENSE_PENDING_START_DATA = '$?';
      var SUSPENSE_FALLBACK_START_DATA = '$!';
      var STYLE$1 = 'style';
      var eventsEnabled = null;
      var selectionInformation = null;
      function shouldAutoFocusHostComponent(type, props) {
        switch (type) {
          case 'button':
          case 'input':
          case 'select':
          case 'textarea':
            return !!props.autoFocus;
        }
        return false;
      }
      function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch (nodeType) {
          case DOCUMENT_NODE:
          case DOCUMENT_FRAGMENT_NODE:
            {
              type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
              var root = rootContainerInstance.documentElement;
              namespace = root ? root.namespaceURI : getChildNamespace(null, '');
              break;
            }
          default:
            {
              var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
              var ownNamespace = container.namespaceURI || null;
              type = container.tagName;
              namespace = getChildNamespace(ownNamespace, type);
              break;
            }
        }
        {
          var validatedTag = type.toLowerCase();
          var ancestorInfo = updatedAncestorInfo(null, validatedTag);
          return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
          };
        }
      }
      function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        {
          var parentHostContextDev = parentHostContext;
          var namespace = getChildNamespace(parentHostContextDev.namespace, type);
          var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
          return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
          };
        }
      }
      function getPublicInstance(instance) {
        return instance;
      }
      function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        setEnabled(false);
      }
      function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
      }
      function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        {
          // TODO: take namespace into account when validating.
          var hostContextDev = hostContext;
          validateDOMNesting(type, null, hostContextDev.ancestorInfo);
          if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
          }
          parentNamespace = hostContextDev.namespace;
        }
        var domElement = createElement$$1(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
      }
      function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
      }
      function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        return shouldAutoFocusHostComponent(type, props);
      }
      function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        {
          var hostContextDev = hostContext;
          if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
          }
        }
        return diffProperties(domElement, type, oldProps, newProps, rootContainerInstance);
      }
      function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
      }
      function shouldDeprioritizeSubtree(type, props) {
        return !!props.hidden;
      }
      function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        {
          var hostContextDev = hostContext;
          validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        }
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
      }
      // if a component just imports ReactDOM (e.g. for findDOMNode).
      // Some environments might not have setTimeout or clearTimeout.

      var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
      var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
      var noTimeout = -1; // -------------------
      function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        if (shouldAutoFocusHostComponent(type, newProps)) {
          domElement.focus();
        }
      }
      function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.

        updateProperties(domElement, updatePayload, type, oldProps, newProps);
      }
      function resetTextContent(domElement) {
        setTextContent(domElement, '');
      }
      function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
      }
      function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
      }
      function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
          parentNode = container.parentNode;
          parentNode.insertBefore(child, container);
        } else {
          parentNode = container;
          parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918

        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
          // TODO: This cast may not be sound for SVG, MathML or custom elements.
          trapClickOnNonInteractiveElement(parentNode);
        }
      }
      function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
      }
      function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) {
          container.parentNode.insertBefore(child, beforeChild);
        } else {
          container.insertBefore(child, beforeChild);
        }
      }
      function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
      }
      function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) {
          container.parentNode.removeChild(child);
        } else {
          container.removeChild(child);
        }
      }
      function hideInstance(instance) {
        // pass host context to this method?

        instance = instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') {
          style.setProperty('display', 'none', 'important');
        } else {
          style.display = 'none';
        }
      }
      function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
      }
      function unhideInstance(instance, props) {
        instance = instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
      }
      function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
      } // -------------------
      function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
          return null;
        } // This has now been refined to an element node.

        return instance;
      }
      function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) {
          // Empty strings are not parsed by HTML so there won't be a correct match here.
          return null;
        } // This has now been refined to a text node.

        return instance;
      }
      function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
      }
      function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
      }
      function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for (; node != null; node = node.nextSibling) {
          var nodeType = node.nodeType;
          if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
            break;
          }
        }
        return node;
      }
      function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
      }
      function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
      }
      function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.

        updateFiberProps(instance, props);
        var parentNamespace;
        {
          var hostContextDev = hostContext;
          parentNamespace = hostContextDev.namespace;
        }
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance);
      }
      function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
      }
      function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.

        var depth = 0;
        while (node) {
          if (node.nodeType === COMMENT_NODE) {
            var data = node.data;
            if (data === SUSPENSE_END_DATA) {
              if (depth === 0) {
                return getNextHydratableSibling(node);
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
              depth++;
            }
          }
          node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.

        return null;
      } // Returns the SuspenseInstance if this node is a direct child of a
      // SuspenseInstance. I.e. if its previous sibling is a Comment with
      // SUSPENSE_x_START_DATA. Otherwise, null.

      function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.

        var depth = 0;
        while (node) {
          if (node.nodeType === COMMENT_NODE) {
            var data = node.data;
            if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
              if (depth === 0) {
                return node;
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_END_DATA) {
              depth++;
            }
          }
          node = node.previousSibling;
        }
        return null;
      }
      function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
      }
      function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
      }
      function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
        {
          warnForUnmatchedText(textInstance, text);
        }
      }
      function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          warnForUnmatchedText(textInstance, text);
        }
      }
      function didNotHydrateContainerInstance(parentContainer, instance) {
        {
          if (instance.nodeType === ELEMENT_NODE) {
            warnForDeletedHydratableElement(parentContainer, instance);
          } else if (instance.nodeType === COMMENT_NODE) ;else {
            warnForDeletedHydratableText(parentContainer, instance);
          }
        }
      }
      function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          if (instance.nodeType === ELEMENT_NODE) {
            warnForDeletedHydratableElement(parentInstance, instance);
          } else if (instance.nodeType === COMMENT_NODE) ;else {
            warnForDeletedHydratableText(parentInstance, instance);
          }
        }
      }
      function didNotFindHydratableContainerInstance(parentContainer, type, props) {
        {
          warnForInsertedHydratedElement(parentContainer, type);
        }
      }
      function didNotFindHydratableContainerTextInstance(parentContainer, text) {
        {
          warnForInsertedHydratedText(parentContainer, text);
        }
      }
      function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          warnForInsertedHydratedElement(parentInstance, type);
        }
      }
      function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          warnForInsertedHydratedText(parentInstance, text);
        }
      }
      function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) ;
      }
      var randomKey = Math.random().toString(36).slice(2);
      var internalInstanceKey = '__reactInternalInstance$' + randomKey;
      var internalEventHandlersKey = '__reactEventHandlers$' + randomKey;
      var internalContainerInstanceKey = '__reactContainere$' + randomKey;
      function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
      }
      function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
      }
      function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
      }
      function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
      } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
      // If the target node is part of a hydrated or not yet rendered subtree, then
      // this may also return a SuspenseComponent or HostRoot to indicate that.
      // Conceptually the HostRoot fiber is a child of the Container node. So if you
      // pass the Container node as the targetNode, you will not actually get the
      // HostRoot back. To get to the HostRoot, you need to pass a child of it.
      // The same thing applies to Suspense boundaries.

      function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) {
          // Don't return HostRoot or SuspenseComponent here.
          return targetInst;
        } // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.

        var parentNode = targetNode.parentNode;
        while (parentNode) {
          // We'll check if this is a container root that could include
          // React nodes in the future. We need to check this first because
          // if we're a child of a dehydrated container, we need to first
          // find that inner container before moving on to finding the parent
          // instance. Note that we don't check this field on  the targetNode
          // itself because the fibers are conceptually between the container
          // node and the first child. It isn't surrounding the container node.
          // If it's not a container, we check if it's an instance.
          targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
          if (targetInst) {
            // Since this wasn't the direct target of the event, we might have
            // stepped past dehydrated DOM nodes to get here. However they could
            // also have been non-React nodes. We need to answer which one.
            // If we the instance doesn't have any children, then there can't be
            // a nested suspense boundary within it. So we can use this as a fast
            // bailout. Most of the time, when people add non-React children to
            // the tree, it is using a ref to a child-less DOM node.
            // Normally we'd only need to check one of the fibers because if it
            // has ever gone from having children to deleting them or vice versa
            // it would have deleted the dehydrated boundary nested inside already.
            // However, since the HostRoot starts out with an alternate it might
            // have one on the alternate so we need to check in case this was a
            // root.
            var alternate = targetInst.alternate;
            if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
              // Next we need to figure out if the node that skipped past is
              // nested within a dehydrated boundary and if so, which one.
              var suspenseInstance = getParentSuspenseInstance(targetNode);
              while (suspenseInstance !== null) {
                // We found a suspense instance. That means that we haven't
                // hydrated it yet. Even though we leave the comments in the
                // DOM after hydrating, and there are boundaries in the DOM
                // that could already be hydrated, we wouldn't have found them
                // through this pass since if the target is hydrated it would
                // have had an internalInstanceKey on it.
                // Let's get the fiber associated with the SuspenseComponent
                // as the deepest instance.
                var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                if (targetSuspenseInst) {
                  return targetSuspenseInst;
                } // If we don't find a Fiber on the comment, it might be because
                // we haven't gotten to hydrate it yet. There might still be a
                // parent boundary that hasn't above this one so we need to find
                // the outer most that is known.

                suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                // host component also hasn't hydrated yet. We can return it
                // below since it will bail out on the isMounted check later.
              }
            }

            return targetInst;
          }
          targetNode = parentNode;
          parentNode = targetNode.parentNode;
        }
        return null;
      }
      /**
       * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
       * instance, or null if the node was not rendered by this React.
       */

      function getInstanceFromNode$1(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
          if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
            return inst;
          } else {
            return null;
          }
        }
        return null;
      }
      /**
       * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
       * DOM node.
       */

      function getNodeFromInstance$1(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) {
          // In Fiber this, is just the state node right now. We assume it will be
          // a host component or host text.
          return inst.stateNode;
        } // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.

        {
          {
            throw Error("getNodeFromInstance: Invalid argument.");
          }
        }
      }
      function getFiberCurrentPropsFromNode$1(node) {
        return node[internalEventHandlersKey] || null;
      }
      function updateFiberProps(node, props) {
        node[internalEventHandlersKey] = props;
      }
      function getParent(inst) {
        do {
          inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
          // That is depending on if we want nested subtrees (layers) to bubble
          // events to their parent. We could also go through parentNode on the
          // host node but that wouldn't work for React Native and doesn't let us
          // do the portal feature.
        } while (inst && inst.tag !== HostComponent);
        if (inst) {
          return inst;
        }
        return null;
      }
      /**
       * Return the lowest common ancestor of A and B, or null if they are in
       * different trees.
       */

      function getLowestCommonAncestor(instA, instB) {
        var depthA = 0;
        for (var tempA = instA; tempA; tempA = getParent(tempA)) {
          depthA++;
        }
        var depthB = 0;
        for (var tempB = instB; tempB; tempB = getParent(tempB)) {
          depthB++;
        } // If A is deeper, crawl up.

        while (depthA - depthB > 0) {
          instA = getParent(instA);
          depthA--;
        } // If B is deeper, crawl up.

        while (depthB - depthA > 0) {
          instB = getParent(instB);
          depthB--;
        } // Walk in lockstep until we find a match.

        var depth = depthA;
        while (depth--) {
          if (instA === instB || instA === instB.alternate) {
            return instA;
          }
          instA = getParent(instA);
          instB = getParent(instB);
        }
        return null;
      }
      /**
       * Simulates the traversal of a two-phase, capture/bubble event dispatch.
       */

      function traverseTwoPhase(inst, fn, arg) {
        var path = [];
        while (inst) {
          path.push(inst);
          inst = getParent(inst);
        }
        var i;
        for (i = path.length; i-- > 0;) {
          fn(path[i], 'captured', arg);
        }
        for (i = 0; i < path.length; i++) {
          fn(path[i], 'bubbled', arg);
        }
      }
      /**
       * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
       * should would receive a `mouseEnter` or `mouseLeave` event.
       *
       * Does not invoke the callback on the nearest common ancestor because nothing
       * "entered" or "left" that element.
       */

      function traverseEnterLeave(from, to, fn, argFrom, argTo) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        var pathFrom = [];
        while (true) {
          if (!from) {
            break;
          }
          if (from === common) {
            break;
          }
          var alternate = from.alternate;
          if (alternate !== null && alternate === common) {
            break;
          }
          pathFrom.push(from);
          from = getParent(from);
        }
        var pathTo = [];
        while (true) {
          if (!to) {
            break;
          }
          if (to === common) {
            break;
          }
          var _alternate = to.alternate;
          if (_alternate !== null && _alternate === common) {
            break;
          }
          pathTo.push(to);
          to = getParent(to);
        }
        for (var i = 0; i < pathFrom.length; i++) {
          fn(pathFrom[i], 'bubbled', argFrom);
        }
        for (var _i = pathTo.length; _i-- > 0;) {
          fn(pathTo[_i], 'captured', argTo);
        }
      }
      function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
      }
      function shouldPreventMouseEvent(name, type, props) {
        switch (name) {
          case 'onClick':
          case 'onClickCapture':
          case 'onDoubleClick':
          case 'onDoubleClickCapture':
          case 'onMouseDown':
          case 'onMouseDownCapture':
          case 'onMouseMove':
          case 'onMouseMoveCapture':
          case 'onMouseUp':
          case 'onMouseUpCapture':
          case 'onMouseEnter':
            return !!(props.disabled && isInteractive(type));
          default:
            return false;
        }
      }
      /**
       * @param {object} inst The instance, which is the source of events.
       * @param {string} registrationName Name of listener (e.g. `onClick`).
       * @return {?function} The stored callback.
       */

      function getListener(inst, registrationName) {
        var listener; // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
        // live here; needs to be moved to a better place soon

        var stateNode = inst.stateNode;
        if (!stateNode) {
          // Work in progress (ex: onload events in incremental mode).
          return null;
        }
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (!props) {
          // Work in progress.
          return null;
        }
        listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
          return null;
        }
        if (!(!listener || typeof listener === 'function')) {
          {
            throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
          }
        }
        return listener;
      }

      /**
       * Some event types have a notion of different registration names for different
       * "phases" of propagation. This finds listeners by a given phase.
       */
      function listenerAtPhase(inst, event, propagationPhase) {
        var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
        return getListener(inst, registrationName);
      }
      /**
       * A small set of propagation patterns, each of which will accept a small amount
       * of information, and generate a set of "dispatch ready event objects" - which
       * are sets of events that have already been annotated with a set of dispatched
       * listener functions/ids. The API is designed this way to discourage these
       * propagation strategies from actually executing the dispatches, since we
       * always want to collect the entire set of dispatches before executing even a
       * single one.
       */

      /**
       * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
       * here, allows us to not have to bind or create functions for each event.
       * Mutating the event's members allows us to not have to create a wrapping
       * "dispatch" object that pairs the event with the listener.
       */

      function accumulateDirectionalDispatches(inst, phase, event) {
        {
          if (!inst) {
            error('Dispatching inst must not be null');
          }
        }
        var listener = listenerAtPhase(inst, event, phase);
        if (listener) {
          event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
          event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
        }
      }
      /**
       * Collect dispatches (must be entirely collected before dispatching - see unit
       * tests). Lazily allocate the array to conserve memory.  We must loop through
       * each event and perform the traversal for each one. We cannot perform a
       * single traversal for the entire collection of events because each event may
       * have a different target.
       */

      function accumulateTwoPhaseDispatchesSingle(event) {
        if (event && event.dispatchConfig.phasedRegistrationNames) {
          traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
        }
      }
      /**
       * Accumulates without regard to direction, does not look for phased
       * registration names. Same as `accumulateDirectDispatchesSingle` but without
       * requiring that the `dispatchMarker` be the same as the dispatched ID.
       */

      function accumulateDispatches(inst, ignoredDirection, event) {
        if (inst && event && event.dispatchConfig.registrationName) {
          var registrationName = event.dispatchConfig.registrationName;
          var listener = getListener(inst, registrationName);
          if (listener) {
            event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
            event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
          }
        }
      }
      /**
       * Accumulates dispatches on an `SyntheticEvent`, but only for the
       * `dispatchMarker`.
       * @param {SyntheticEvent} event
       */

      function accumulateDirectDispatchesSingle(event) {
        if (event && event.dispatchConfig.registrationName) {
          accumulateDispatches(event._targetInst, null, event);
        }
      }
      function accumulateTwoPhaseDispatches(events) {
        forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
      }
      function accumulateEnterLeaveDispatches(leave, enter, from, to) {
        traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
      }
      function accumulateDirectDispatches(events) {
        forEachAccumulated(events, accumulateDirectDispatchesSingle);
      }

      /**
       * These variables store information about text content of a target node,
       * allowing comparison of content before and after a given event.
       *
       * Identify the node where selection currently begins, then observe
       * both its text content and its current position in the DOM. Since the
       * browser may natively replace the target node during composition, we can
       * use its position to find its replacement.
       *
       *
       */
      var root = null;
      var startText = null;
      var fallbackText = null;
      function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
      }
      function reset() {
        root = null;
        startText = null;
        fallbackText = null;
      }
      function getData() {
        if (fallbackText) {
          return fallbackText;
        }
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for (start = 0; start < startLength; start++) {
          if (startValue[start] !== endValue[start]) {
            break;
          }
        }
        var minEnd = startLength - start;
        for (end = 1; end <= minEnd; end++) {
          if (startValue[startLength - end] !== endValue[endLength - end]) {
            break;
          }
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
      }
      function getText() {
        if ('value' in root) {
          return root.value;
        }
        return root.textContent;
      }
      var EVENT_POOL_SIZE = 10;
      /**
       * @interface Event
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var EventInterface = {
        type: null,
        target: null,
        // currentTarget is set when dispatching; no use in copying it here
        currentTarget: function currentTarget() {
          return null;
        },
        eventPhase: null,
        bubbles: null,
        cancelable: null,
        timeStamp: function timeStamp(event) {
          return event.timeStamp || Date.now();
        },
        defaultPrevented: null,
        isTrusted: null
      };
      function functionThatReturnsTrue() {
        return true;
      }
      function functionThatReturnsFalse() {
        return false;
      }
      /**
       * Synthetic events are dispatched by event plugins, typically in response to a
       * top-level event delegation handler.
       *
       * These systems should generally use pooling to reduce the frequency of garbage
       * collection. The system should check `isPersistent` to determine whether the
       * event should be released into the pool after being dispatched. Users that
       * need a persisted event should invoke `persist`.
       *
       * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
       * normalizing browser quirks. Subclasses do not necessarily have to implement a
       * DOM interface; custom application-specific events can also subclass this.
       *
       * @param {object} dispatchConfig Configuration used to dispatch this event.
       * @param {*} targetInst Marker identifying the event target.
       * @param {object} nativeEvent Native browser event.
       * @param {DOMEventTarget} nativeEventTarget Target node.
       */

      function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
        {
          // these have a getter/setter for warnings
          delete this.nativeEvent;
          delete this.preventDefault;
          delete this.stopPropagation;
          delete this.isDefaultPrevented;
          delete this.isPropagationStopped;
        }
        this.dispatchConfig = dispatchConfig;
        this._targetInst = targetInst;
        this.nativeEvent = nativeEvent;
        var Interface = this.constructor.Interface;
        for (var propName in Interface) {
          if (!Interface.hasOwnProperty(propName)) {
            continue;
          }
          {
            delete this[propName]; // this has a getter/setter for warnings
          }

          var normalize = Interface[propName];
          if (normalize) {
            this[propName] = normalize(nativeEvent);
          } else {
            if (propName === 'target') {
              this.target = nativeEventTarget;
            } else {
              this[propName] = nativeEvent[propName];
            }
          }
        }
        var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
        if (defaultPrevented) {
          this.isDefaultPrevented = functionThatReturnsTrue;
        } else {
          this.isDefaultPrevented = functionThatReturnsFalse;
        }
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
      }
      _assign(SyntheticEvent.prototype, {
        preventDefault: function preventDefault() {
          this.defaultPrevented = true;
          var event = this.nativeEvent;
          if (!event) {
            return;
          }
          if (event.preventDefault) {
            event.preventDefault();
          } else if (typeof event.returnValue !== 'unknown') {
            event.returnValue = false;
          }
          this.isDefaultPrevented = functionThatReturnsTrue;
        },
        stopPropagation: function stopPropagation() {
          var event = this.nativeEvent;
          if (!event) {
            return;
          }
          if (event.stopPropagation) {
            event.stopPropagation();
          } else if (typeof event.cancelBubble !== 'unknown') {
            // The ChangeEventPlugin registers a "propertychange" event for
            // IE. This event does not support bubbling or cancelling, and
            // any references to cancelBubble throw "Member not found".  A
            // typeof check of "unknown" circumvents this issue (and is also
            // IE specific).
            event.cancelBubble = true;
          }
          this.isPropagationStopped = functionThatReturnsTrue;
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function persist() {
          this.isPersistent = functionThatReturnsTrue;
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: functionThatReturnsFalse,
        /**
         * `PooledClass` looks for `destructor` on each instance it releases.
         */
        destructor: function destructor() {
          var Interface = this.constructor.Interface;
          for (var propName in Interface) {
            {
              Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
            }
          }
          this.dispatchConfig = null;
          this._targetInst = null;
          this.nativeEvent = null;
          this.isDefaultPrevented = functionThatReturnsFalse;
          this.isPropagationStopped = functionThatReturnsFalse;
          this._dispatchListeners = null;
          this._dispatchInstances = null;
          {
            Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
            Object.defineProperty(this, 'isDefaultPrevented', getPooledWarningPropertyDefinition('isDefaultPrevented', functionThatReturnsFalse));
            Object.defineProperty(this, 'isPropagationStopped', getPooledWarningPropertyDefinition('isPropagationStopped', functionThatReturnsFalse));
            Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', function () {}));
            Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', function () {}));
          }
        }
      });
      SyntheticEvent.Interface = EventInterface;
      /**
       * Helper to reduce boilerplate when creating subclasses.
       */

      SyntheticEvent.extend = function (Interface) {
        var Super = this;
        var E = function E() {};
        E.prototype = Super.prototype;
        var prototype = new E();
        function Class() {
          return Super.apply(this, arguments);
        }
        _assign(prototype, Class.prototype);
        Class.prototype = prototype;
        Class.prototype.constructor = Class;
        Class.Interface = _assign({}, Super.Interface, Interface);
        Class.extend = Super.extend;
        addEventPoolingTo(Class);
        return Class;
      };
      addEventPoolingTo(SyntheticEvent);
      /**
       * Helper to nullify syntheticEvent instance properties when destructing
       *
       * @param {String} propName
       * @param {?object} getVal
       * @return {object} defineProperty object
       */

      function getPooledWarningPropertyDefinition(propName, getVal) {
        var isFunction = typeof getVal === 'function';
        return {
          configurable: true,
          set: set,
          get: get
        };
        function set(val) {
          var action = isFunction ? 'setting the method' : 'setting the property';
          warn(action, 'This is effectively a no-op');
          return val;
        }
        function get() {
          var action = isFunction ? 'accessing the method' : 'accessing the property';
          var result = isFunction ? 'This is a no-op function' : 'This is set to null';
          warn(action, result);
          return getVal;
        }
        function warn(action, result) {
          {
            error("This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result);
          }
        }
      }
      function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
        var EventConstructor = this;
        if (EventConstructor.eventPool.length) {
          var instance = EventConstructor.eventPool.pop();
          EventConstructor.call(instance, dispatchConfig, targetInst, nativeEvent, nativeInst);
          return instance;
        }
        return new EventConstructor(dispatchConfig, targetInst, nativeEvent, nativeInst);
      }
      function releasePooledEvent(event) {
        var EventConstructor = this;
        if (!(event instanceof EventConstructor)) {
          {
            throw Error("Trying to release an event instance into a pool of a different type.");
          }
        }
        event.destructor();
        if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) {
          EventConstructor.eventPool.push(event);
        }
      }
      function addEventPoolingTo(EventConstructor) {
        EventConstructor.eventPool = [];
        EventConstructor.getPooled = getPooledEvent;
        EventConstructor.release = releasePooledEvent;
      }

      /**
       * @interface Event
       * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
       */

      var SyntheticCompositionEvent = SyntheticEvent.extend({
        data: null
      });

      /**
       * @interface Event
       * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
       *      /#events-inputevents
       */

      var SyntheticInputEvent = SyntheticEvent.extend({
        data: null
      });
      var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space

      var START_KEYCODE = 229;
      var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
      var documentMode = null;
      if (canUseDOM && 'documentMode' in document) {
        documentMode = document.documentMode;
      } // Webkit offers a very useful `textInput` event that can be used to
      // directly represent `beforeInput`. The IE `textinput` event is not as
      // useful, so we don't use it.

      var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
      // by the native compositionend event may be incorrect. Japanese ideographic
      // spaces, for instance (\u3000) are not recorded correctly.

      var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
      var SPACEBAR_CODE = 32;
      var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE); // Events and their corresponding property names.

      var eventTypes = {
        beforeInput: {
          phasedRegistrationNames: {
            bubbled: 'onBeforeInput',
            captured: 'onBeforeInputCapture'
          },
          dependencies: [TOP_COMPOSITION_END, TOP_KEY_PRESS, TOP_TEXT_INPUT, TOP_PASTE]
        },
        compositionEnd: {
          phasedRegistrationNames: {
            bubbled: 'onCompositionEnd',
            captured: 'onCompositionEndCapture'
          },
          dependencies: [TOP_BLUR, TOP_COMPOSITION_END, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
        },
        compositionStart: {
          phasedRegistrationNames: {
            bubbled: 'onCompositionStart',
            captured: 'onCompositionStartCapture'
          },
          dependencies: [TOP_BLUR, TOP_COMPOSITION_START, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
        },
        compositionUpdate: {
          phasedRegistrationNames: {
            bubbled: 'onCompositionUpdate',
            captured: 'onCompositionUpdateCapture'
          },
          dependencies: [TOP_BLUR, TOP_COMPOSITION_UPDATE, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
        }
      }; // Track whether we've ever handled a keypress on the space key.

      var hasSpaceKeypress = false;
      /**
       * Return whether a native keypress event is assumed to be a command.
       * This is required because Firefox fires `keypress` events for key commands
       * (cut, copy, select-all, etc.) even though no character is inserted.
       */

      function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
        // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
      }
      /**
       * Translate native top level events into event types.
       *
       * @param {string} topLevelType
       * @return {object}
       */

      function getCompositionEventType(topLevelType) {
        switch (topLevelType) {
          case TOP_COMPOSITION_START:
            return eventTypes.compositionStart;
          case TOP_COMPOSITION_END:
            return eventTypes.compositionEnd;
          case TOP_COMPOSITION_UPDATE:
            return eventTypes.compositionUpdate;
        }
      }
      /**
       * Does our fallback best-guess model think this event signifies that
       * composition has begun?
       *
       * @param {string} topLevelType
       * @param {object} nativeEvent
       * @return {boolean}
       */

      function isFallbackCompositionStart(topLevelType, nativeEvent) {
        return topLevelType === TOP_KEY_DOWN && nativeEvent.keyCode === START_KEYCODE;
      }
      /**
       * Does our fallback mode think that this event is the end of composition?
       *
       * @param {string} topLevelType
       * @param {object} nativeEvent
       * @return {boolean}
       */

      function isFallbackCompositionEnd(topLevelType, nativeEvent) {
        switch (topLevelType) {
          case TOP_KEY_UP:
            // Command keys insert or clear IME input.
            return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
          case TOP_KEY_DOWN:
            // Expect IME keyCode on each keydown. If we get any other
            // code we must have exited earlier.
            return nativeEvent.keyCode !== START_KEYCODE;
          case TOP_KEY_PRESS:
          case TOP_MOUSE_DOWN:
          case TOP_BLUR:
            // Events are not possible without cancelling IME.
            return true;
          default:
            return false;
        }
      }
      /**
       * Google Input Tools provides composition data via a CustomEvent,
       * with the `data` property populated in the `detail` object. If this
       * is available on the event object, use it. If not, this is a plain
       * composition event and we have nothing special to extract.
       *
       * @param {object} nativeEvent
       * @return {?string}
       */

      function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) {
          return detail.data;
        }
        return null;
      }
      /**
       * Check if a composition event was triggered by Korean IME.
       * Our fallback mode does not work well with IE's Korean IME,
       * so just use native composition events when Korean IME is used.
       * Although CompositionEvent.locale property is deprecated,
       * it is available in IE, where our fallback mode is enabled.
       *
       * @param {object} nativeEvent
       * @return {boolean}
       */

      function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
      } // Track the current IME composition status, if any.

      var isComposing = false;
      /**
       * @return {?object} A SyntheticCompositionEvent.
       */

      function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) {
          eventType = getCompositionEventType(topLevelType);
        } else if (!isComposing) {
          if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
            eventType = eventTypes.compositionStart;
          }
        } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
          eventType = eventTypes.compositionEnd;
        }
        if (!eventType) {
          return null;
        }
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
          // The current composition is stored statically and must not be
          // overwritten while composition continues.
          if (!isComposing && eventType === eventTypes.compositionStart) {
            isComposing = initialize(nativeEventTarget);
          } else if (eventType === eventTypes.compositionEnd) {
            if (isComposing) {
              fallbackData = getData();
            }
          }
        }
        var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
        if (fallbackData) {
          // Inject data generated from fallback path into the synthetic event.
          // This matches the property of native CompositionEventInterface.
          event.data = fallbackData;
        } else {
          var customData = getDataFromCustomEvent(nativeEvent);
          if (customData !== null) {
            event.data = customData;
          }
        }
        accumulateTwoPhaseDispatches(event);
        return event;
      }
      /**
       * @param {TopLevelType} topLevelType Number from `TopLevelType`.
       * @param {object} nativeEvent Native browser event.
       * @return {?string} The string corresponding to this `beforeInput` event.
       */

      function getNativeBeforeInputChars(topLevelType, nativeEvent) {
        switch (topLevelType) {
          case TOP_COMPOSITION_END:
            return getDataFromCustomEvent(nativeEvent);
          case TOP_KEY_PRESS:
            /**
             * If native `textInput` events are available, our goal is to make
             * use of them. However, there is a special case: the spacebar key.
             * In Webkit, preventing default on a spacebar `textInput` event
             * cancels character insertion, but it *also* causes the browser
             * to fall back to its default spacebar behavior of scrolling the
             * page.
             *
             * Tracking at:
             * https://code.google.com/p/chromium/issues/detail?id=355103
             *
             * To avoid this issue, use the keypress event as if no `textInput`
             * event is available.
             */
            var which = nativeEvent.which;
            if (which !== SPACEBAR_CODE) {
              return null;
            }
            hasSpaceKeypress = true;
            return SPACEBAR_CHAR;
          case TOP_TEXT_INPUT:
            // Record the characters to be added to the DOM.
            var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
            // it at the keypress level and bail immediately. Android Chrome
            // doesn't give us keycodes, so we need to ignore it.

            if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
              return null;
            }
            return chars;
          default:
            // For other native event types, do nothing.
            return null;
        }
      }
      /**
       * For browsers that do not provide the `textInput` event, extract the
       * appropriate string to use for SyntheticInputEvent.
       *
       * @param {number} topLevelType Number from `TopLevelEventTypes`.
       * @param {object} nativeEvent Native browser event.
       * @return {?string} The fallback string for this `beforeInput` event.
       */

      function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
          if (topLevelType === TOP_COMPOSITION_END || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
            var chars = getData();
            reset();
            isComposing = false;
            return chars;
          }
          return null;
        }
        switch (topLevelType) {
          case TOP_PASTE:
            // If a paste event occurs after a keypress, throw out the input
            // chars. Paste events should not lead to BeforeInput events.
            return null;
          case TOP_KEY_PRESS:
            /**
             * As of v27, Firefox may fire keypress events even when no character
             * will be inserted. A few possibilities:
             *
             * - `which` is `0`. Arrow keys, Esc key, etc.
             *
             * - `which` is the pressed key code, but no char is available.
             *   Ex: 'AltGr + d` in Polish. There is no modified character for
             *   this key combination and no character is inserted into the
             *   document, but FF fires the keypress for char code `100` anyway.
             *   No `input` event will occur.
             *
             * - `which` is the pressed key code, but a command combination is
             *   being used. Ex: `Cmd+C`. No character is inserted, and no
             *   `input` event will occur.
             */
            if (!isKeypressCommand(nativeEvent)) {
              // IE fires the `keypress` event when a user types an emoji via
              // Touch keyboard of Windows.  In such a case, the `char` property
              // holds an emoji character like `\uD83D\uDE0A`.  Because its length
              // is 2, the property `which` does not represent an emoji correctly.
              // In such a case, we directly return the `char` property instead of
              // using `which`.
              if (nativeEvent.char && nativeEvent.char.length > 1) {
                return nativeEvent.char;
              } else if (nativeEvent.which) {
                return String.fromCharCode(nativeEvent.which);
              }
            }
            return null;
          case TOP_COMPOSITION_END:
            return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
          default:
            return null;
        }
      }
      /**
       * Extract a SyntheticInputEvent for `beforeInput`, based on either native
       * `textInput` or fallback behavior.
       *
       * @return {?object} A SyntheticInputEvent.
       */

      function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) {
          chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
        } else {
          chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
        } // If no characters are being inserted, no BeforeInput event should
        // be fired.

        if (!chars) {
          return null;
        }
        var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
        event.data = chars;
        accumulateTwoPhaseDispatches(event);
        return event;
      }
      /**
       * Create an `onBeforeInput` event to match
       * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
       *
       * This event plugin is based on the native `textInput` event
       * available in Chrome, Safari, Opera, and IE. This event fires after
       * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
       *
       * `beforeInput` is spec'd but not implemented in any browsers, and
       * the `input` event does not provide any useful information about what has
       * actually been added, contrary to the spec. Thus, `textInput` is the best
       * available event to identify the characters that have actually been inserted
       * into the target node.
       *
       * This plugin is also responsible for emitting `composition` events, thus
       * allowing us to share composition fallback code for both `beforeInput` and
       * `composition` event types.
       */

      var BeforeInputEventPlugin = {
        eventTypes: eventTypes,
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var composition = extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
          var beforeInput = extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
          if (composition === null) {
            return beforeInput;
          }
          if (beforeInput === null) {
            return composition;
          }
          return [composition, beforeInput];
        }
      };

      /**
       * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
       */
      var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
      };
      function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') {
          return !!supportedInputTypes[elem.type];
        }
        if (nodeName === 'textarea') {
          return true;
        }
        return false;
      }
      var eventTypes$1 = {
        change: {
          phasedRegistrationNames: {
            bubbled: 'onChange',
            captured: 'onChangeCapture'
          },
          dependencies: [TOP_BLUR, TOP_CHANGE, TOP_CLICK, TOP_FOCUS, TOP_INPUT, TOP_KEY_DOWN, TOP_KEY_UP, TOP_SELECTION_CHANGE]
        }
      };
      function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
        var event = SyntheticEvent.getPooled(eventTypes$1.change, inst, nativeEvent, target);
        event.type = 'change'; // Flag this event loop as needing state restore.

        enqueueStateRestore(target);
        accumulateTwoPhaseDispatches(event);
        return event;
      }
      /**
       * For IE shims
       */

      var activeElement = null;
      var activeElementInst = null;
      /**
       * SECTION: handle `change` event
       */

      function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
      }
      function manualDispatchChangeEvent(nativeEvent) {
        var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.

        batchedUpdates(runEventInBatch, event);
      }
      function runEventInBatch(event) {
        runEventsInBatch(event);
      }
      function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance$1(targetInst);
        if (updateValueIfChanged(targetNode)) {
          return targetInst;
        }
      }
      function getTargetInstForChangeEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_CHANGE) {
          return targetInst;
        }
      }
      /**
       * SECTION: handle `input` event
       */

      var isInputEventSupported = false;
      if (canUseDOM) {
        // IE9 claims to support the input event but fails to trigger it when
        // deleting text, so we ignore its input events.
        isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
      }
      /**
       * (For IE <=9) Starts tracking propertychange events on the passed-in element
       * and override the value property so that we can distinguish user events from
       * value changes in JS.
       */

      function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
      }
      /**
       * (For IE <=9) Removes the event listeners from the currently-tracked element,
       * if any exists.
       */

      function stopWatchingForValueChange() {
        if (!activeElement) {
          return;
        }
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
      }
      /**
       * (For IE <=9) Handles a propertychange event, sending a `change` event if
       * the value of the active element has changed.
       */

      function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') {
          return;
        }
        if (getInstIfValueChanged(activeElementInst)) {
          manualDispatchChangeEvent(nativeEvent);
        }
      }
      function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
        if (topLevelType === TOP_FOCUS) {
          // In IE9, propertychange fires for most input events but is buggy and
          // doesn't fire when text is deleted, but conveniently, selectionchange
          // appears to fire in all of the remaining cases so we catch those and
          // forward the event if the value has changed
          // In either case, we don't want to call the event handler if the value
          // is changed from JS so we redefine a setter for `.value` that updates
          // our activeElementValue variable, allowing us to ignore those changes
          //
          // stopWatching() should be a noop here but we call it just in case we
          // missed a blur event somehow.
          stopWatchingForValueChange();
          startWatchingForValueChange(target, targetInst);
        } else if (topLevelType === TOP_BLUR) {
          stopWatchingForValueChange();
        }
      } // For IE8 and IE9.

      function getTargetInstForInputEventPolyfill(topLevelType, targetInst) {
        if (topLevelType === TOP_SELECTION_CHANGE || topLevelType === TOP_KEY_UP || topLevelType === TOP_KEY_DOWN) {
          // On the selectionchange event, the target is just document which isn't
          // helpful for us so just check activeElement instead.
          //
          // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
          // propertychange on the first input event after setting `value` from a
          // script and fires only keydown, keypress, keyup. Catching keyup usually
          // gets it and catching keydown lets us fire an event for the first
          // keystroke if user does a key repeat (it'll be a little delayed: right
          // before the second keystroke). Other input methods (e.g., paste) seem to
          // fire selectionchange normally.
          return getInstIfValueChanged(activeElementInst);
        }
      }
      /**
       * SECTION: handle `click` event
       */

      function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
      }
      function getTargetInstForClickEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_CLICK) {
          return getInstIfValueChanged(targetInst);
        }
      }
      function getTargetInstForInputOrChangeEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_INPUT || topLevelType === TOP_CHANGE) {
          return getInstIfValueChanged(targetInst);
        }
      }
      function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') {
          return;
        }
        {
          // If controlled, assign the value attribute to the current value on blur
          setDefaultValue(node, 'number', node.value);
        }
      }
      /**
       * This plugin creates an `onChange` event that normalizes change events
       * across form elements. This event fires at a time when it's possible to
       * change the element's value without seeing a flicker.
       *
       * Supported elements are:
       * - input (see `isTextInputElement`)
       * - textarea
       * - select
       */

      var ChangeEventPlugin = {
        eventTypes: eventTypes$1,
        _isInputEventSupported: isInputEventSupported,
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
          var getTargetInstFunc, handleEventFunc;
          if (shouldUseChangeEvent(targetNode)) {
            getTargetInstFunc = getTargetInstForChangeEvent;
          } else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) {
              getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            } else {
              getTargetInstFunc = getTargetInstForInputEventPolyfill;
              handleEventFunc = handleEventsForInputEventPolyfill;
            }
          } else if (shouldUseClickEvent(targetNode)) {
            getTargetInstFunc = getTargetInstForClickEvent;
          }
          if (getTargetInstFunc) {
            var inst = getTargetInstFunc(topLevelType, targetInst);
            if (inst) {
              var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
              return event;
            }
          }
          if (handleEventFunc) {
            handleEventFunc(topLevelType, targetNode, targetInst);
          } // When blurring, set the value attribute for number inputs

          if (topLevelType === TOP_BLUR) {
            handleControlledInputBlur(targetNode);
          }
        }
      };
      var SyntheticUIEvent = SyntheticEvent.extend({
        view: null,
        detail: null
      });

      /**
       * Translation from modifier key to the associated property in the event.
       * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
       */
      var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
      }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
      // getModifierState. If getModifierState is not supported, we map it to a set of
      // modifier keys exposed by the event. In this case, Lock-keys are not supported.

      function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) {
          return nativeEvent.getModifierState(keyArg);
        }
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
      }
      function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
      }
      var previousScreenX = 0;
      var previousScreenY = 0; // Use flags to signal movementX/Y has already been set

      var isMovementXSet = false;
      var isMovementYSet = false;
      /**
       * @interface MouseEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticMouseEvent = SyntheticUIEvent.extend({
        screenX: null,
        screenY: null,
        clientX: null,
        clientY: null,
        pageX: null,
        pageY: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        getModifierState: getEventModifierState,
        button: null,
        buttons: null,
        relatedTarget: function relatedTarget(event) {
          return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
        },
        movementX: function movementX(event) {
          if ('movementX' in event) {
            return event.movementX;
          }
          var screenX = previousScreenX;
          previousScreenX = event.screenX;
          if (!isMovementXSet) {
            isMovementXSet = true;
            return 0;
          }
          return event.type === 'mousemove' ? event.screenX - screenX : 0;
        },
        movementY: function movementY(event) {
          if ('movementY' in event) {
            return event.movementY;
          }
          var screenY = previousScreenY;
          previousScreenY = event.screenY;
          if (!isMovementYSet) {
            isMovementYSet = true;
            return 0;
          }
          return event.type === 'mousemove' ? event.screenY - screenY : 0;
        }
      });

      /**
       * @interface PointerEvent
       * @see http://www.w3.org/TR/pointerevents/
       */

      var SyntheticPointerEvent = SyntheticMouseEvent.extend({
        pointerId: null,
        width: null,
        height: null,
        pressure: null,
        tangentialPressure: null,
        tiltX: null,
        tiltY: null,
        twist: null,
        pointerType: null,
        isPrimary: null
      });
      var eventTypes$2 = {
        mouseEnter: {
          registrationName: 'onMouseEnter',
          dependencies: [TOP_MOUSE_OUT, TOP_MOUSE_OVER]
        },
        mouseLeave: {
          registrationName: 'onMouseLeave',
          dependencies: [TOP_MOUSE_OUT, TOP_MOUSE_OVER]
        },
        pointerEnter: {
          registrationName: 'onPointerEnter',
          dependencies: [TOP_POINTER_OUT, TOP_POINTER_OVER]
        },
        pointerLeave: {
          registrationName: 'onPointerLeave',
          dependencies: [TOP_POINTER_OUT, TOP_POINTER_OVER]
        }
      };
      var EnterLeaveEventPlugin = {
        eventTypes: eventTypes$2,
        /**
         * For almost every interaction we care about, there will be both a top-level
         * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
         * we do not extract duplicate events. However, moving the mouse into the
         * browser from outside will not fire a `mouseout` event. In this case, we use
         * the `mouseover` top-level event.
         */
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var isOverEvent = topLevelType === TOP_MOUSE_OVER || topLevelType === TOP_POINTER_OVER;
          var isOutEvent = topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_POINTER_OUT;
          if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0 && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
            // If this is an over event with a target, then we've already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            return null;
          }
          if (!isOutEvent && !isOverEvent) {
            // Must not be a mouse or pointer in or out - ignoring.
            return null;
          }
          var win;
          if (nativeEventTarget.window === nativeEventTarget) {
            // `nativeEventTarget` is probably a window object.
            win = nativeEventTarget;
          } else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) {
              win = doc.defaultView || doc.parentWindow;
            } else {
              win = window;
            }
          }
          var from;
          var to;
          if (isOutEvent) {
            from = targetInst;
            var related = nativeEvent.relatedTarget || nativeEvent.toElement;
            to = related ? getClosestInstanceFromNode(related) : null;
            if (to !== null) {
              var nearestMounted = getNearestMountedFiber(to);
              if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
                to = null;
              }
            }
          } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
          }
          if (from === to) {
            // Nothing pertains to our managed components.
            return null;
          }
          var eventInterface, leaveEventType, enterEventType, eventTypePrefix;
          if (topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_MOUSE_OVER) {
            eventInterface = SyntheticMouseEvent;
            leaveEventType = eventTypes$2.mouseLeave;
            enterEventType = eventTypes$2.mouseEnter;
            eventTypePrefix = 'mouse';
          } else if (topLevelType === TOP_POINTER_OUT || topLevelType === TOP_POINTER_OVER) {
            eventInterface = SyntheticPointerEvent;
            leaveEventType = eventTypes$2.pointerLeave;
            enterEventType = eventTypes$2.pointerEnter;
            eventTypePrefix = 'pointer';
          }
          var fromNode = from == null ? win : getNodeFromInstance$1(from);
          var toNode = to == null ? win : getNodeFromInstance$1(to);
          var leave = eventInterface.getPooled(leaveEventType, from, nativeEvent, nativeEventTarget);
          leave.type = eventTypePrefix + 'leave';
          leave.target = fromNode;
          leave.relatedTarget = toNode;
          var enter = eventInterface.getPooled(enterEventType, to, nativeEvent, nativeEventTarget);
          enter.type = eventTypePrefix + 'enter';
          enter.target = toNode;
          enter.relatedTarget = fromNode;
          accumulateEnterLeaveDispatches(leave, enter, from, to); // If we are not processing the first ancestor, then we
          // should not process the same nativeEvent again, as we
          // will have already processed it in the first ancestor.

          if ((eventSystemFlags & IS_FIRST_ANCESTOR) === 0) {
            return [leave];
          }
          return [leave, enter];
        }
      };

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }

      var objectIs = typeof Object.is === 'function' ? Object.is : is;
      var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
      /**
       * Performs equality by iterating through keys on an object and returning false
       * when any key has values which are not strictly equal between the arguments.
       * Returns true when the values of all keys are strictly equal.
       */

      function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) {
          return true;
        }
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
          return false;
        } // Test for A's keys different from B.

        for (var i = 0; i < keysA.length; i++) {
          if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
            return false;
          }
        }
        return true;
      }
      var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
      var eventTypes$3 = {
        select: {
          phasedRegistrationNames: {
            bubbled: 'onSelect',
            captured: 'onSelectCapture'
          },
          dependencies: [TOP_BLUR, TOP_CONTEXT_MENU, TOP_DRAG_END, TOP_FOCUS, TOP_KEY_DOWN, TOP_KEY_UP, TOP_MOUSE_DOWN, TOP_MOUSE_UP, TOP_SELECTION_CHANGE]
        }
      };
      var activeElement$1 = null;
      var activeElementInst$1 = null;
      var lastSelection = null;
      var mouseDown = false;
      /**
       * Get an object which is a unique representation of the current selection.
       *
       * The return value will not be consistent across nodes or browsers, but
       * two identical selections on the same node will return identical objects.
       *
       * @param {DOMElement} node
       * @return {object}
       */

      function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) {
          return {
            start: node.selectionStart,
            end: node.selectionEnd
          };
        } else {
          var win = node.ownerDocument && node.ownerDocument.defaultView || window;
          var selection = win.getSelection();
          return {
            anchorNode: selection.anchorNode,
            anchorOffset: selection.anchorOffset,
            focusNode: selection.focusNode,
            focusOffset: selection.focusOffset
          };
        }
      }
      /**
       * Get document associated with the event target.
       *
       * @param {object} nativeEventTarget
       * @return {Document}
       */

      function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
      }
      /**
       * Poll selection to see whether it's changed.
       *
       * @param {object} nativeEvent
       * @param {object} nativeEventTarget
       * @return {?SyntheticEvent}
       */

      function constructSelectEvent(nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
          return null;
        } // Only fire when selection has actually changed.

        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
          lastSelection = currentSelection;
          var syntheticEvent = SyntheticEvent.getPooled(eventTypes$3.select, activeElementInst$1, nativeEvent, nativeEventTarget);
          syntheticEvent.type = 'select';
          syntheticEvent.target = activeElement$1;
          accumulateTwoPhaseDispatches(syntheticEvent);
          return syntheticEvent;
        }
        return null;
      }
      /**
       * This plugin creates an `onSelect` event that normalizes select events
       * across form elements.
       *
       * Supported elements are:
       * - input (see `isTextInputElement`)
       * - textarea
       * - contentEditable
       *
       * This differs from native browser implementations in the following ways:
       * - Fires on contentEditable fields as well as inputs.
       * - Fires for collapsed selection.
       * - Fires after user input.
       */

      var SelectEventPlugin = {
        eventTypes: eventTypes$3,
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, container) {
          var containerOrDoc = container || getEventTargetDocument(nativeEventTarget); // Track whether all listeners exists for this plugin. If none exist, we do
          // not extract events. See #3639.

          if (!containerOrDoc || !isListeningToAllDependencies('onSelect', containerOrDoc)) {
            return null;
          }
          var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
          switch (topLevelType) {
            // Track the input node that has focus.
            case TOP_FOCUS:
              if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                activeElement$1 = targetNode;
                activeElementInst$1 = targetInst;
                lastSelection = null;
              }
              break;
            case TOP_BLUR:
              activeElement$1 = null;
              activeElementInst$1 = null;
              lastSelection = null;
              break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.

            case TOP_MOUSE_DOWN:
              mouseDown = true;
              break;
            case TOP_CONTEXT_MENU:
            case TOP_MOUSE_UP:
            case TOP_DRAG_END:
              mouseDown = false;
              return constructSelectEvent(nativeEvent, nativeEventTarget);
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.

            case TOP_SELECTION_CHANGE:
              if (skipSelectionChangeEvent) {
                break;
              }

            // falls through

            case TOP_KEY_DOWN:
            case TOP_KEY_UP:
              return constructSelectEvent(nativeEvent, nativeEventTarget);
          }
          return null;
        }
      };

      /**
       * @interface Event
       * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
       * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
       */

      var SyntheticAnimationEvent = SyntheticEvent.extend({
        animationName: null,
        elapsedTime: null,
        pseudoElement: null
      });

      /**
       * @interface Event
       * @see http://www.w3.org/TR/clipboard-apis/
       */

      var SyntheticClipboardEvent = SyntheticEvent.extend({
        clipboardData: function clipboardData(event) {
          return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
      });

      /**
       * @interface FocusEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticFocusEvent = SyntheticUIEvent.extend({
        relatedTarget: null
      });

      /**
       * `charCode` represents the actual "character code" and is safe to use with
       * `String.fromCharCode`. As such, only keys that correspond to printable
       * characters produce a valid `charCode`, the only exception to this is Enter.
       * The Tab-key is considered non-printable and does not have a `charCode`,
       * presumably because it does not produce a tab-character in browsers.
       *
       * @param {object} nativeEvent Native browser event.
       * @return {number} Normalized `charCode` property.
       */
      function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
          charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.

          if (charCode === 0 && keyCode === 13) {
            charCode = 13;
          }
        } else {
          // IE8 does not implement `charCode`, but `keyCode` has the correct value.
          charCode = keyCode;
        } // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.

        if (charCode === 10) {
          charCode = 13;
        } // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.

        if (charCode >= 32 || charCode === 13) {
          return charCode;
        }
        return 0;
      }

      /**
       * Normalization of deprecated HTML5 `key` values
       * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
       */

      var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
      };
      /**
       * Translation from legacy `keyCode` to HTML5 `key`
       * Only special keys supported, all others depend on keyboard layout or browser
       * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
       */

      var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
      };
      /**
       * @param {object} nativeEvent Native browser event.
       * @return {string} Normalized `key` property.
       */

      function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
          // Normalize inconsistent values reported by browsers due to
          // implementations of a working draft specification.
          // FireFox implements `key` but returns `MozPrintableKey` for all
          // printable characters (normalized to `Unidentified`), ignore it.
          var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
          if (key !== 'Unidentified') {
            return key;
          }
        } // Browser does not implement `key`, polyfill as much of it as we can.

        if (nativeEvent.type === 'keypress') {
          var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
          // thus be captured by `keypress`, no other non-printable key should.

          return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
          // While user keyboard layout determines the actual meaning of each
          // `keyCode` value, almost all function keys have a universal value.
          return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        }
        return '';
      }

      /**
       * @interface KeyboardEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticKeyboardEvent = SyntheticUIEvent.extend({
        key: getEventKey,
        location: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        repeat: null,
        locale: null,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function charCode(event) {
          // `charCode` is the result of a KeyPress event and represents the value of
          // the actual printable character.
          // KeyPress is deprecated, but its replacement is not yet final and not
          // implemented in any major browser. Only KeyPress has charCode.
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }
          return 0;
        },
        keyCode: function keyCode(event) {
          // `keyCode` is the result of a KeyDown/Up event and represents the value of
          // physical keyboard key.
          // The actual meaning of the value depends on the users' keyboard layout
          // which cannot be detected. Assuming that it is a US keyboard layout
          // provides a surprisingly accurate mapping for US and European users.
          // Due to this, it is left to the user to implement at this time.
          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }
          return 0;
        },
        which: function which(event) {
          // `which` is an alias for either `keyCode` or `charCode` depending on the
          // type of the event.
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }
          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }
          return 0;
        }
      });

      /**
       * @interface DragEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticDragEvent = SyntheticMouseEvent.extend({
        dataTransfer: null
      });

      /**
       * @interface TouchEvent
       * @see http://www.w3.org/TR/touch-events/
       */

      var SyntheticTouchEvent = SyntheticUIEvent.extend({
        touches: null,
        targetTouches: null,
        changedTouches: null,
        altKey: null,
        metaKey: null,
        ctrlKey: null,
        shiftKey: null,
        getModifierState: getEventModifierState
      });

      /**
       * @interface Event
       * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
       * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
       */

      var SyntheticTransitionEvent = SyntheticEvent.extend({
        propertyName: null,
        elapsedTime: null,
        pseudoElement: null
      });

      /**
       * @interface WheelEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticWheelEvent = SyntheticMouseEvent.extend({
        deltaX: function deltaX(event) {
          return 'deltaX' in event ? event.deltaX :
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function deltaY(event) {
          return 'deltaY' in event ? event.deltaY :
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          'wheelDeltaY' in event ? -event.wheelDeltaY :
          // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
          'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: null,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: null
      });
      var knownHTMLTopLevelTypes = [TOP_ABORT, TOP_CANCEL, TOP_CAN_PLAY, TOP_CAN_PLAY_THROUGH, TOP_CLOSE, TOP_DURATION_CHANGE, TOP_EMPTIED, TOP_ENCRYPTED, TOP_ENDED, TOP_ERROR, TOP_INPUT, TOP_INVALID, TOP_LOAD, TOP_LOADED_DATA, TOP_LOADED_METADATA, TOP_LOAD_START, TOP_PAUSE, TOP_PLAY, TOP_PLAYING, TOP_PROGRESS, TOP_RATE_CHANGE, TOP_RESET, TOP_SEEKED, TOP_SEEKING, TOP_STALLED, TOP_SUBMIT, TOP_SUSPEND, TOP_TIME_UPDATE, TOP_TOGGLE, TOP_VOLUME_CHANGE, TOP_WAITING];
      var SimpleEventPlugin = {
        // simpleEventPluginEventTypes gets populated from
        // the DOMEventProperties module.
        eventTypes: simpleEventPluginEventTypes,
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var dispatchConfig = topLevelEventsToDispatchConfig.get(topLevelType);
          if (!dispatchConfig) {
            return null;
          }
          var EventConstructor;
          switch (topLevelType) {
            case TOP_KEY_PRESS:
              // Firefox creates a keypress event for function keys too. This removes
              // the unwanted keypress events. Enter is however both printable and
              // non-printable. One would expect Tab to be as well (but it isn't).
              if (getEventCharCode(nativeEvent) === 0) {
                return null;
              }

            /* falls through */

            case TOP_KEY_DOWN:
            case TOP_KEY_UP:
              EventConstructor = SyntheticKeyboardEvent;
              break;
            case TOP_BLUR:
            case TOP_FOCUS:
              EventConstructor = SyntheticFocusEvent;
              break;
            case TOP_CLICK:
              // Firefox creates a click event on right mouse clicks. This removes the
              // unwanted click events.
              if (nativeEvent.button === 2) {
                return null;
              }

            /* falls through */

            case TOP_AUX_CLICK:
            case TOP_DOUBLE_CLICK:
            case TOP_MOUSE_DOWN:
            case TOP_MOUSE_MOVE:
            case TOP_MOUSE_UP: // TODO: Disabled elements should not respond to mouse events

            /* falls through */

            case TOP_MOUSE_OUT:
            case TOP_MOUSE_OVER:
            case TOP_CONTEXT_MENU:
              EventConstructor = SyntheticMouseEvent;
              break;
            case TOP_DRAG:
            case TOP_DRAG_END:
            case TOP_DRAG_ENTER:
            case TOP_DRAG_EXIT:
            case TOP_DRAG_LEAVE:
            case TOP_DRAG_OVER:
            case TOP_DRAG_START:
            case TOP_DROP:
              EventConstructor = SyntheticDragEvent;
              break;
            case TOP_TOUCH_CANCEL:
            case TOP_TOUCH_END:
            case TOP_TOUCH_MOVE:
            case TOP_TOUCH_START:
              EventConstructor = SyntheticTouchEvent;
              break;
            case TOP_ANIMATION_END:
            case TOP_ANIMATION_ITERATION:
            case TOP_ANIMATION_START:
              EventConstructor = SyntheticAnimationEvent;
              break;
            case TOP_TRANSITION_END:
              EventConstructor = SyntheticTransitionEvent;
              break;
            case TOP_SCROLL:
              EventConstructor = SyntheticUIEvent;
              break;
            case TOP_WHEEL:
              EventConstructor = SyntheticWheelEvent;
              break;
            case TOP_COPY:
            case TOP_CUT:
            case TOP_PASTE:
              EventConstructor = SyntheticClipboardEvent;
              break;
            case TOP_GOT_POINTER_CAPTURE:
            case TOP_LOST_POINTER_CAPTURE:
            case TOP_POINTER_CANCEL:
            case TOP_POINTER_DOWN:
            case TOP_POINTER_MOVE:
            case TOP_POINTER_OUT:
            case TOP_POINTER_OVER:
            case TOP_POINTER_UP:
              EventConstructor = SyntheticPointerEvent;
              break;
            default:
              {
                if (knownHTMLTopLevelTypes.indexOf(topLevelType) === -1) {
                  error('SimpleEventPlugin: Unhandled event type, `%s`. This warning ' + 'is likely caused by a bug in React. Please file an issue.', topLevelType);
                }
              } // HTML Events
              // @see http://www.w3.org/TR/html5/index.html#events-0

              EventConstructor = SyntheticEvent;
              break;
          }
          var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
          accumulateTwoPhaseDispatches(event);
          return event;
        }
      };

      /**
       * Specifies a deterministic ordering of `EventPlugin`s. A convenient way to
       * reason about plugins, without having to package every one of them. This
       * is better than having plugins be ordered in the same order that they
       * are injected because that ordering would be influenced by the packaging order.
       * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
       * preventing default on events is convenient in `SimpleEventPlugin` handlers.
       */

      var DOMEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
      /**
       * Inject modules for resolving DOM hierarchy and plugin ordering.
       */

      injectEventPluginOrder(DOMEventPluginOrder);
      setComponentTree(getFiberCurrentPropsFromNode$1, getInstanceFromNode$1, getNodeFromInstance$1);
      /**
       * Some important event plugins included by default (without having to require
       * them).
       */

      injectEventPluginsByName({
        SimpleEventPlugin: SimpleEventPlugin,
        EnterLeaveEventPlugin: EnterLeaveEventPlugin,
        ChangeEventPlugin: ChangeEventPlugin,
        SelectEventPlugin: SelectEventPlugin,
        BeforeInputEventPlugin: BeforeInputEventPlugin
      });

      // Prefix measurements so that it's possible to filter them.
      // Longer prefixes are hard to read in DevTools.
      var reactEmoji = "\u269B";
      var warningEmoji = "\u26D4";
      var supportsUserTiming = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function'; // Keep track of current fiber so that we know the path to unwind on pause.
      // TODO: this looks the same as nextUnitOfWork in scheduler. Can we unify them?

      var currentFiber = null; // If we're in the middle of user code, which fiber and method is it?
      // Reusing `currentFiber` would be confusing for this because user code fiber
      // can change during commit phase too, but we don't need to unwind it (since
      // lifecycles in the commit phase don't resemble a tree).

      var currentPhase = null;
      var currentPhaseFiber = null; // Did lifecycle hook schedule an update? This is often a performance problem,
      // so we will keep track of it, and include it in the report.
      // Track commits caused by cascading updates.

      var isCommitting = false;
      var hasScheduledUpdateInCurrentCommit = false;
      var hasScheduledUpdateInCurrentPhase = false;
      var commitCountInCurrentWorkLoop = 0;
      var effectCountInCurrentCommit = 0;
      // to avoid stretch the commit phase with measurement overhead.

      var labelsInCurrentCommit = new Set();
      var formatMarkName = function formatMarkName(markName) {
        return reactEmoji + " " + markName;
      };
      var formatLabel = function formatLabel(label, warning) {
        var prefix = warning ? warningEmoji + " " : reactEmoji + " ";
        var suffix = warning ? " Warning: " + warning : '';
        return "" + prefix + label + suffix;
      };
      var beginMark = function beginMark(markName) {
        performance.mark(formatMarkName(markName));
      };
      var clearMark = function clearMark(markName) {
        performance.clearMarks(formatMarkName(markName));
      };
      var endMark = function endMark(label, markName, warning) {
        var formattedMarkName = formatMarkName(markName);
        var formattedLabel = formatLabel(label, warning);
        try {
          performance.measure(formattedLabel, formattedMarkName);
        } catch (err) {} // If previous mark was missing for some reason, this will throw.
        // This could only happen if React crashed in an unexpected place earlier.
        // Don't pile on with more errors.
        // Clear marks immediately to avoid growing buffer.

        performance.clearMarks(formattedMarkName);
        performance.clearMeasures(formattedLabel);
      };
      var getFiberMarkName = function getFiberMarkName(label, debugID) {
        return label + " (#" + debugID + ")";
      };
      var getFiberLabel = function getFiberLabel(componentName, isMounted, phase) {
        if (phase === null) {
          // These are composite component total time measurements.
          return componentName + " [" + (isMounted ? 'update' : 'mount') + "]";
        } else {
          // Composite component methods.
          return componentName + "." + phase;
        }
      };
      var beginFiberMark = function beginFiberMark(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        if (isCommitting && labelsInCurrentCommit.has(label)) {
          // During the commit phase, we don't show duplicate labels because
          // there is a fixed overhead for every measurement, and we don't
          // want to stretch the commit phase beyond necessary.
          return false;
        }
        labelsInCurrentCommit.add(label);
        var markName = getFiberMarkName(label, debugID);
        beginMark(markName);
        return true;
      };
      var clearFiberMark = function clearFiberMark(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        clearMark(markName);
      };
      var endFiberMark = function endFiberMark(fiber, phase, warning) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        endMark(label, markName, warning);
      };
      var shouldIgnoreFiber = function shouldIgnoreFiber(fiber) {
        // Host components should be skipped in the timeline.
        // We could check typeof fiber.type, but does this work with RN?
        switch (fiber.tag) {
          case HostRoot:
          case HostComponent:
          case HostText:
          case HostPortal:
          case Fragment$$1:
          case ContextProvider:
          case ContextConsumer:
          case Mode:
            return true;
          default:
            return false;
        }
      };
      var clearPendingPhaseMeasurement = function clearPendingPhaseMeasurement() {
        if (currentPhase !== null && currentPhaseFiber !== null) {
          clearFiberMark(currentPhaseFiber, currentPhase);
        }
        currentPhaseFiber = null;
        currentPhase = null;
        hasScheduledUpdateInCurrentPhase = false;
      };
      var pauseTimers = function pauseTimers() {
        // Stops all currently active measurements so that they can be resumed
        // if we continue in a later deferred loop from the same unit of work.
        var fiber = currentFiber;
        while (fiber) {
          if (fiber._debugIsCurrentlyTiming) {
            endFiberMark(fiber, null, null);
          }
          fiber = fiber.return;
        }
      };
      var resumeTimersRecursively = function resumeTimersRecursively(fiber) {
        if (fiber.return !== null) {
          resumeTimersRecursively(fiber.return);
        }
        if (fiber._debugIsCurrentlyTiming) {
          beginFiberMark(fiber, null);
        }
      };
      var resumeTimers = function resumeTimers() {
        // Resumes all measurements that were active during the last deferred loop.
        if (currentFiber !== null) {
          resumeTimersRecursively(currentFiber);
        }
      };
      function recordEffect() {
        {
          effectCountInCurrentCommit++;
        }
      }
      function recordScheduleUpdate() {
        {
          if (isCommitting) {
            hasScheduledUpdateInCurrentCommit = true;
          }
          if (currentPhase !== null && currentPhase !== 'componentWillMount' && currentPhase !== 'componentWillReceiveProps') {
            hasScheduledUpdateInCurrentPhase = true;
          }
        }
      }
      function startWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, this is the fiber to unwind from.

          currentFiber = fiber;
          if (!beginFiberMark(fiber, null)) {
            return;
          }
          fiber._debugIsCurrentlyTiming = true;
        }
      }
      function cancelWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // Remember we shouldn't complete measurement for this fiber.
          // Otherwise flamechart will be deep even for small updates.

          fiber._debugIsCurrentlyTiming = false;
          clearFiberMark(fiber, null);
        }
      }
      function stopWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, its parent is the fiber to unwind from.

          currentFiber = fiber.return;
          if (!fiber._debugIsCurrentlyTiming) {
            return;
          }
          fiber._debugIsCurrentlyTiming = false;
          endFiberMark(fiber, null, null);
        }
      }
      function stopFailedWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, its parent is the fiber to unwind from.

          currentFiber = fiber.return;
          if (!fiber._debugIsCurrentlyTiming) {
            return;
          }
          fiber._debugIsCurrentlyTiming = false;
          var warning = fiber.tag === SuspenseComponent ? 'Rendering was suspended' : 'An error was thrown inside this error boundary';
          endFiberMark(fiber, null, warning);
        }
      }
      function startPhaseTimer(fiber, phase) {
        {
          if (!supportsUserTiming) {
            return;
          }
          clearPendingPhaseMeasurement();
          if (!beginFiberMark(fiber, phase)) {
            return;
          }
          currentPhaseFiber = fiber;
          currentPhase = phase;
        }
      }
      function stopPhaseTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          if (currentPhase !== null && currentPhaseFiber !== null) {
            var warning = hasScheduledUpdateInCurrentPhase ? 'Scheduled a cascading update' : null;
            endFiberMark(currentPhaseFiber, currentPhase, warning);
          }
          currentPhase = null;
          currentPhaseFiber = null;
        }
      }
      function startWorkLoopTimer(nextUnitOfWork) {
        {
          currentFiber = nextUnitOfWork;
          if (!supportsUserTiming) {
            return;
          }
          commitCountInCurrentWorkLoop = 0; // This is top level call.
          // Any other measurements are performed within.

          beginMark('(React Tree Reconciliation)'); // Resume any measurements that were in progress during the last loop.

          resumeTimers();
        }
      }
      function stopWorkLoopTimer(interruptedBy, didCompleteRoot) {
        {
          if (!supportsUserTiming) {
            return;
          }
          var warning = null;
          if (interruptedBy !== null) {
            if (interruptedBy.tag === HostRoot) {
              warning = 'A top-level update interrupted the previous render';
            } else {
              var componentName = getComponentName(interruptedBy.type) || 'Unknown';
              warning = "An update to " + componentName + " interrupted the previous render";
            }
          } else if (commitCountInCurrentWorkLoop > 1) {
            warning = 'There were cascading updates';
          }
          commitCountInCurrentWorkLoop = 0;
          var label = didCompleteRoot ? '(React Tree Reconciliation: Completed Root)' : '(React Tree Reconciliation: Yielded)'; // Pause any measurements until the next loop.

          pauseTimers();
          endMark(label, '(React Tree Reconciliation)', warning);
        }
      }
      function startCommitTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          isCommitting = true;
          hasScheduledUpdateInCurrentCommit = false;
          labelsInCurrentCommit.clear();
          beginMark('(Committing Changes)');
        }
      }
      function stopCommitTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var warning = null;
          if (hasScheduledUpdateInCurrentCommit) {
            warning = 'Lifecycle hook scheduled a cascading update';
          } else if (commitCountInCurrentWorkLoop > 0) {
            warning = 'Caused by a cascading update in earlier commit';
          }
          hasScheduledUpdateInCurrentCommit = false;
          commitCountInCurrentWorkLoop++;
          isCommitting = false;
          labelsInCurrentCommit.clear();
          endMark('(Committing Changes)', '(Committing Changes)', warning);
        }
      }
      function startCommitSnapshotEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Committing Snapshot Effects)');
        }
      }
      function stopCommitSnapshotEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Committing Snapshot Effects: " + count + " Total)", '(Committing Snapshot Effects)', null);
        }
      }
      function startCommitHostEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Committing Host Effects)');
        }
      }
      function stopCommitHostEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Committing Host Effects: " + count + " Total)", '(Committing Host Effects)', null);
        }
      }
      function startCommitLifeCyclesTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Calling Lifecycle Methods)');
        }
      }
      function stopCommitLifeCyclesTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Calling Lifecycle Methods: " + count + " Total)", '(Calling Lifecycle Methods)', null);
        }
      }
      var valueStack = [];
      var fiberStack;
      {
        fiberStack = [];
      }
      var index = -1;
      function createCursor(defaultValue) {
        return {
          current: defaultValue
        };
      }
      function pop(cursor, fiber) {
        if (index < 0) {
          {
            error('Unexpected pop.');
          }
          return;
        }
        {
          if (fiber !== fiberStack[index]) {
            error('Unexpected Fiber popped.');
          }
        }
        cursor.current = valueStack[index];
        valueStack[index] = null;
        {
          fiberStack[index] = null;
        }
        index--;
      }
      function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        {
          fiberStack[index] = fiber;
        }
        cursor.current = value;
      }
      var warnedAboutMissingGetChildContext;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      } // A cursor to the current merged context object on the stack.

      var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.

      var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
      // We use this to get access to the parent context after we have already
      // pushed the next context provider, and now need to merge their contexts.

      var previousContext = emptyContextObject;
      function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        {
          if (didPushOwnContextIfProvider && isContextProvider(Component)) {
            // If the fiber is a context provider itself, when we read its context
            // we may have already pushed its own child context on the stack. A context
            // provider should not "see" its own child context. Therefore we read the
            // previous (parent) context instead for a context provider.
            return previousContext;
          }
          return contextStackCursor.current;
        }
      }
      function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        {
          var instance = workInProgress.stateNode;
          instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
          instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
        }
      }
      function getMaskedContext(workInProgress, unmaskedContext) {
        {
          var type = workInProgress.type;
          var contextTypes = type.contextTypes;
          if (!contextTypes) {
            return emptyContextObject;
          } // Avoid recreating masked context unless unmasked context has changed.
          // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
          // This may trigger infinite loops if componentWillReceiveProps calls setState.

          var instance = workInProgress.stateNode;
          if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
            return instance.__reactInternalMemoizedMaskedChildContext;
          }
          var context = {};
          for (var key in contextTypes) {
            context[key] = unmaskedContext[key];
          }
          {
            var name = getComponentName(type) || 'Unknown';
            checkPropTypes(contextTypes, context, 'context', name, getCurrentFiberStackInDev);
          } // Cache unmasked context so we can avoid recreating masked context unless necessary.
          // Context is created before the class component is instantiated so check for instance.

          if (instance) {
            cacheContext(workInProgress, unmaskedContext, context);
          }
          return context;
        }
      }
      function hasContextChanged() {
        {
          return didPerformWorkStackCursor.current;
        }
      }
      function isContextProvider(type) {
        {
          var childContextTypes = type.childContextTypes;
          return childContextTypes !== null && childContextTypes !== undefined;
        }
      }
      function popContext(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }
      function popTopLevelContextObject(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }
      function pushTopLevelContextObject(fiber, context, didChange) {
        {
          if (!(contextStackCursor.current === emptyContextObject)) {
            {
              throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          push(contextStackCursor, context, fiber);
          push(didPerformWorkStackCursor, didChange, fiber);
        }
      }
      function processChildContext(fiber, type, parentContext) {
        {
          var instance = fiber.stateNode;
          var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
          // It has only been added in Fiber to match the (unintentional) behavior in Stack.

          if (typeof instance.getChildContext !== 'function') {
            {
              var componentName = getComponentName(type) || 'Unknown';
              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
              }
            }
            return parentContext;
          }
          var childContext;
          startPhaseTimer(fiber, 'getChildContext');
          childContext = instance.getChildContext();
          stopPhaseTimer();
          for (var contextKey in childContext) {
            if (!(contextKey in childContextTypes)) {
              {
                throw Error((getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
              }
            }
          }
          {
            var name = getComponentName(type) || 'Unknown';
            checkPropTypes(childContextTypes, childContext, 'child context', name,
            // In practice, there is one case in which we won't get a stack. It's when
            // somebody calls unstable_renderSubtreeIntoContainer() and we process
            // context from the parent component instance. The stack will be missing
            // because it's outside of the reconciliation, and so the pointer has not
            // been set. This is rare and doesn't matter. We'll also remove that API.
            getCurrentFiberStackInDev);
          }
          return _assign({}, parentContext, {}, childContext);
        }
      }
      function pushContextProvider(workInProgress) {
        {
          var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
          // If the instance does not exist yet, we will push null at first,
          // and replace it on the stack later when invalidating the context.

          var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
          // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

          previousContext = contextStackCursor.current;
          push(contextStackCursor, memoizedMergedChildContext, workInProgress);
          push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
          return true;
        }
      }
      function invalidateContextProvider(workInProgress, type, didChange) {
        {
          var instance = workInProgress.stateNode;
          if (!instance) {
            {
              throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.

            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          }
        }
      }
      function findCurrentUnmaskedContext(fiber) {
        {
          // Currently this is only used with renderSubtreeIntoContainer; not sure if it
          // makes sense elsewhere
          if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
            {
              throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          var node = fiber;
          do {
            switch (node.tag) {
              case HostRoot:
                return node.stateNode.context;
              case ClassComponent:
                {
                  var Component = node.type;
                  if (isContextProvider(Component)) {
                    return node.stateNode.__reactInternalMemoizedMergedChildContext;
                  }
                  break;
                }
            }
            node = node.return;
          } while (node !== null);
          {
            {
              throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
      }
      var LegacyRoot = 0;
      var BlockingRoot = 1;
      var ConcurrentRoot = 2;
      var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority,
        Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback,
        Scheduler_cancelCallback = Scheduler.unstable_cancelCallback,
        Scheduler_shouldYield = Scheduler.unstable_shouldYield,
        Scheduler_requestPaint = Scheduler.unstable_requestPaint,
        Scheduler_now = Scheduler.unstable_now,
        Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel,
        Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority,
        Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
        Scheduler_NormalPriority = Scheduler.unstable_NormalPriority,
        Scheduler_LowPriority = Scheduler.unstable_LowPriority,
        Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
      {
        // Provide explicit error message when production+profiling bundle of e.g.
        // react-dom is used with production (non-profiling) bundle of
        // scheduler/tracing
        if (!(tracing$1.__interactionsRef != null && tracing$1.__interactionsRef.current != null)) {
          {
            throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at http://fb.me/react-profiling");
          }
        }
      }
      var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
      // ascending numbers so we can compare them like numbers. They start at 90 to
      // avoid clashing with Scheduler's priorities.

      var ImmediatePriority = 99;
      var UserBlockingPriority$1 = 98;
      var NormalPriority = 97;
      var LowPriority = 96;
      var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.

      var NoPriority = 90;
      var shouldYield = Scheduler_shouldYield;
      var requestPaint =
      // Fall back gracefully if we're running an older version of Scheduler.
      Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function () {};
      var syncQueue = null;
      var immediateQueueCallbackNode = null;
      var isFlushingSyncQueue = false;
      var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
      // This will be the case for modern browsers that support `performance.now`. In
      // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
      // timestamp. In that case, subtract the module initialization time to simulate
      // the behavior of performance.now and keep our times small enough to fit
      // within 32 bits.
      // TODO: Consider lifting this into Scheduler.

      var now = initialTimeMs < 10000 ? Scheduler_now : function () {
        return Scheduler_now() - initialTimeMs;
      };
      function getCurrentPriorityLevel() {
        switch (Scheduler_getCurrentPriorityLevel()) {
          case Scheduler_ImmediatePriority:
            return ImmediatePriority;
          case Scheduler_UserBlockingPriority:
            return UserBlockingPriority$1;
          case Scheduler_NormalPriority:
            return NormalPriority;
          case Scheduler_LowPriority:
            return LowPriority;
          case Scheduler_IdlePriority:
            return IdlePriority;
          default:
            {
              {
                throw Error("Unknown priority level.");
              }
            }
        }
      }
      function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch (reactPriorityLevel) {
          case ImmediatePriority:
            return Scheduler_ImmediatePriority;
          case UserBlockingPriority$1:
            return Scheduler_UserBlockingPriority;
          case NormalPriority:
            return Scheduler_NormalPriority;
          case LowPriority:
            return Scheduler_LowPriority;
          case IdlePriority:
            return Scheduler_IdlePriority;
          default:
            {
              {
                throw Error("Unknown priority level.");
              }
            }
        }
      }
      function runWithPriority$1(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
      }
      function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
      }
      function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
          syncQueue = [callback]; // Flush the queue in the next tick, at the earliest.

          immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else {
          // Push onto existing queue. Don't need to schedule a callback because
          // we already scheduled one when we created the queue.
          syncQueue.push(callback);
        }
        return fakeCallbackNode;
      }
      function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) {
          Scheduler_cancelCallback(callbackNode);
        }
      }
      function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
          var node = immediateQueueCallbackNode;
          immediateQueueCallbackNode = null;
          Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
      }
      function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
          // Prevent re-entrancy.
          isFlushingSyncQueue = true;
          var i = 0;
          try {
            var _isSync = true;
            var queue = syncQueue;
            runWithPriority$1(ImmediatePriority, function () {
              for (; i < queue.length; i++) {
                var callback = queue[i];
                do {
                  callback = callback(_isSync);
                } while (callback !== null);
              }
            });
            syncQueue = null;
          } catch (error) {
            // If something throws, leave the remaining callbacks on the queue.
            if (syncQueue !== null) {
              syncQueue = syncQueue.slice(i + 1);
            } // Resume flushing in the next tick

            Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
            throw error;
          } finally {
            isFlushingSyncQueue = false;
          }
        }
      }
      var NoMode = 0;
      var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
      // tag instead

      var BlockingMode = 2;
      var ConcurrentMode = 4;
      var ProfileMode = 8;

      // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
      // Math.pow(2, 30) - 1
      // 0b111111111111111111111111111111
      var MAX_SIGNED_31_BIT_INT = 1073741823;
      var NoWork = 0; // TODO: Think of a better name for Never. The key difference with Idle is that
      // Never work can be committed in an inconsistent state without tearing the UI.
      // The main example is offscreen content, like a hidden subtree. So one possible
      // name is Offscreen. However, it also includes dehydrated Suspense boundaries,
      // which are inconsistent in the sense that they haven't finished yet, but
      // aren't visibly inconsistent because the server rendered HTML matches what the
      // hydrated tree would look like.

      var Never = 1; // Idle is slightly higher priority than Never. It must completely finish in
      // order to be consistent.

      var Idle = 2; // Continuous Hydration is slightly higher than Idle and is used to increase
      // priority of hover targets.

      var ContinuousHydration = 3;
      var Sync = MAX_SIGNED_31_BIT_INT;
      var Batched = Sync - 1;
      var UNIT_SIZE = 10;
      var MAGIC_NUMBER_OFFSET = Batched - 1; // 1 unit of expiration time represents 10ms.

      function msToExpirationTime(ms) {
        // Always subtract from the offset so that we don't clash with the magic number for NoWork.
        return MAGIC_NUMBER_OFFSET - (ms / UNIT_SIZE | 0);
      }
      function expirationTimeToMs(expirationTime) {
        return (MAGIC_NUMBER_OFFSET - expirationTime) * UNIT_SIZE;
      }
      function ceiling(num, precision) {
        return ((num / precision | 0) + 1) * precision;
      }
      function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
        return MAGIC_NUMBER_OFFSET - ceiling(MAGIC_NUMBER_OFFSET - currentTime + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
      } // TODO: This corresponds to Scheduler's NormalPriority, not LowPriority. Update
      // the names to reflect.

      var LOW_PRIORITY_EXPIRATION = 5000;
      var LOW_PRIORITY_BATCH_SIZE = 250;
      function computeAsyncExpiration(currentTime) {
        return computeExpirationBucket(currentTime, LOW_PRIORITY_EXPIRATION, LOW_PRIORITY_BATCH_SIZE);
      }
      function computeSuspenseExpiration(currentTime, timeoutMs) {
        // TODO: Should we warn if timeoutMs is lower than the normal pri expiration time?
        return computeExpirationBucket(currentTime, timeoutMs, LOW_PRIORITY_BATCH_SIZE);
      } // We intentionally set a higher expiration time for interactive updates in
      // dev than in production.
      //
      // If the main thread is being blocked so long that you hit the expiration,
      // it's a problem that could be solved with better scheduling.
      //
      // People will be more likely to notice this and fix it with the long
      // expiration time in development.
      //
      // In production we opt for better UX at the risk of masking scheduling
      // problems, by expiring fast.

      var HIGH_PRIORITY_EXPIRATION = 500;
      var HIGH_PRIORITY_BATCH_SIZE = 100;
      function computeInteractiveExpiration(currentTime) {
        return computeExpirationBucket(currentTime, HIGH_PRIORITY_EXPIRATION, HIGH_PRIORITY_BATCH_SIZE);
      }
      function inferPriorityFromExpirationTime(currentTime, expirationTime) {
        if (expirationTime === Sync) {
          return ImmediatePriority;
        }
        if (expirationTime === Never || expirationTime === Idle) {
          return IdlePriority;
        }
        var msUntil = expirationTimeToMs(expirationTime) - expirationTimeToMs(currentTime);
        if (msUntil <= 0) {
          return ImmediatePriority;
        }
        if (msUntil <= HIGH_PRIORITY_EXPIRATION + HIGH_PRIORITY_BATCH_SIZE) {
          return UserBlockingPriority$1;
        }
        if (msUntil <= LOW_PRIORITY_EXPIRATION + LOW_PRIORITY_BATCH_SIZE) {
          return NormalPriority;
        } // TODO: Handle LowPriority
        // Assume anything lower has idle priority

        return IdlePriority;
      }
      var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
        recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
        flushLegacyContextWarning: function flushLegacyContextWarning() {},
        discardPendingWarnings: function discardPendingWarnings() {}
      };
      {
        var findStrictRoot = function findStrictRoot(fiber) {
          var maybeStrictRoot = null;
          var node = fiber;
          while (node !== null) {
            if (node.mode & StrictMode) {
              maybeStrictRoot = node;
            }
            node = node.return;
          }
          return maybeStrictRoot;
        };
        var setToSortedString = function setToSortedString(set) {
          var array = [];
          set.forEach(function (value) {
            array.push(value);
          });
          return array.sort().join(', ');
        };
        var pendingComponentWillMountWarnings = [];
        var pendingUNSAFE_ComponentWillMountWarnings = [];
        var pendingComponentWillReceivePropsWarnings = [];
        var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        var pendingComponentWillUpdateWarnings = [];
        var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.

        var didWarnAboutUnsafeLifecycles = new Set();
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
          // Dedup strategy: Warn once per component.
          if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
            return;
          }
          if (typeof instance.componentWillMount === 'function' &&
          // Don't warn about react-lifecycles-compat polyfilled components.
          instance.componentWillMount.__suppressDeprecationWarning !== true) {
            pendingComponentWillMountWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') {
            pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
          }
          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
            pendingComponentWillReceivePropsWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
          }
          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
            pendingComponentWillUpdateWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
            pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
          }
        };
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
          // We do an initial pass to gather component names
          var componentWillMountUniqueNames = new Set();
          if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function (fiber) {
              componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
          }
          var UNSAFE_componentWillMountUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
              UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
          }
          var componentWillReceivePropsUniqueNames = new Set();
          if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
              componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
          }
          var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
              UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          }
          var componentWillUpdateUniqueNames = new Set();
          if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function (fiber) {
              componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
          }
          var UNSAFE_componentWillUpdateUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
              UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
          } // Finally, we flush all the warnings
          // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'

          if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
          }
          if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
          }
          if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
          }
          if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
          }
          if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
          }
          if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
          }
        };
        var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

        var didWarnAboutLegacyContext = new Set();
        ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
          var strictRoot = findStrictRoot(fiber);
          if (strictRoot === null) {
            error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
            return;
          } // Dedup strategy: Warn once per component.

          if (didWarnAboutLegacyContext.has(fiber.type)) {
            return;
          }
          var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
          if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
              warningsForRoot = [];
              pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
          }
        };
        ReactStrictModeWarnings.flushLegacyContextWarning = function () {
          pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
            if (fiberArray.length === 0) {
              return;
            }
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function (fiber) {
              uniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            var firstComponentStack = getStackByFiberInDevAndProd(firstFiber);
            error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://fb.me/react-legacy-context' + '%s', sortedNames, firstComponentStack);
          });
        };
        ReactStrictModeWarnings.discardPendingWarnings = function () {
          pendingComponentWillMountWarnings = [];
          pendingUNSAFE_ComponentWillMountWarnings = [];
          pendingComponentWillReceivePropsWarnings = [];
          pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          pendingComponentWillUpdateWarnings = [];
          pendingUNSAFE_ComponentWillUpdateWarnings = [];
          pendingLegacyContextWarning = new Map();
        };
      }
      var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.

      var failedBoundaries = null;
      var setRefreshHandler = function setRefreshHandler(handler) {
        {
          resolveFamily = handler;
        }
      };
      function resolveFunctionForHotReloading(type) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return type;
          }
          var family = resolveFamily(type);
          if (family === undefined) {
            return type;
          } // Use the latest known implementation.

          return family.current;
        }
      }
      function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
      }
      function resolveForwardRefForHotReloading(type) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return type;
          }
          var family = resolveFamily(type);
          if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
              // ForwardRef is special because its resolved .type is an object,
              // but it's possible that we only have its inner render function in the map.
              // If that inner render function is different, we'll build a new forwardRef type.
              var currentRender = resolveFunctionForHotReloading(type.render);
              if (type.render !== currentRender) {
                var syntheticType = {
                  $$typeof: REACT_FORWARD_REF_TYPE,
                  render: currentRender
                };
                if (type.displayName !== undefined) {
                  syntheticType.displayName = type.displayName;
                }
                return syntheticType;
              }
            }
            return type;
          } // Use the latest known implementation.

          return family.current;
        }
      }
      function isCompatibleFamilyForHotReloading(fiber, element) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return false;
          }
          var prevType = fiber.elementType;
          var nextType = element.type; // If we got here, we know types aren't === equal.

          var needsCompareFamilies = false;
          var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
          switch (fiber.tag) {
            case ClassComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                }
                break;
              }
            case FunctionComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  // We don't know the inner type yet.
                  // We're going to assume that the lazy inner type is stable,
                  // and so it is sufficient to avoid reconciling it away.
                  // We're not going to unwrap or actually use the new lazy type.
                  needsCompareFamilies = true;
                }
                break;
              }
            case ForwardRef:
              {
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
            case MemoComponent:
            case SimpleMemoComponent:
              {
                if ($$typeofNextType === REACT_MEMO_TYPE) {
                  // TODO: if it was but can no longer be simple,
                  // we shouldn't set this.
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
            default:
              return false;
          } // Check if both types have a family and it's the same one.

          if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
              return true;
            }
          }
          return false;
        }
      }
      function markFailedErrorBoundaryForHotReloading(fiber) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return;
          }
          if (typeof WeakSet !== 'function') {
            return;
          }
          if (failedBoundaries === null) {
            failedBoundaries = new WeakSet();
          }
          failedBoundaries.add(fiber);
        }
      }
      var scheduleRefresh = function scheduleRefresh(root, update) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return;
          }
          var staleFamilies = update.staleFamilies,
            updatedFamilies = update.updatedFamilies;
          flushPassiveEffects();
          flushSync$$1(function () {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
          });
        }
      };
      var scheduleRoot = function scheduleRoot(root, element) {
        {
          if (root.context !== emptyContextObject) {
            // Super edge case: root has a legacy _renderSubtree context
            // but we don't know the parentComponent so we can't pass it.
            // Just ignore. We'll delete this with _renderSubtree code path later.
            return;
          }
          flushPassiveEffects();
          syncUpdates(function () {
            updateContainer(element, root, null, null);
          });
        }
      };
      function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        {
          var alternate = fiber.alternate,
            child = fiber.child,
            sibling = fiber.sibling,
            tag = fiber.tag,
            type = fiber.type;
          var candidateType = null;
          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;
            case ForwardRef:
              candidateType = type.render;
              break;
          }
          if (resolveFamily === null) {
            throw new Error('Expected resolveFamily to be set during hot reload.');
          }
          var needsRender = false;
          var needsRemount = false;
          if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
              if (staleFamilies.has(family)) {
                needsRemount = true;
              } else if (updatedFamilies.has(family)) {
                if (tag === ClassComponent) {
                  needsRemount = true;
                } else {
                  needsRender = true;
                }
              }
            }
          }
          if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
              needsRemount = true;
            }
          }
          if (needsRemount) {
            fiber._debugNeedsRemount = true;
          }
          if (needsRemount || needsRender) {
            scheduleWork(fiber, Sync);
          }
          if (child !== null && !needsRemount) {
            scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
          }
          if (sibling !== null) {
            scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
          }
        }
      }
      var findHostInstancesForRefresh = function findHostInstancesForRefresh(root, families) {
        {
          var hostInstances = new Set();
          var types = new Set(families.map(function (family) {
            return family.current;
          }));
          findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
          return hostInstances;
        }
      };
      function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        {
          var child = fiber.child,
            sibling = fiber.sibling,
            tag = fiber.tag,
            type = fiber.type;
          var candidateType = null;
          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;
            case ForwardRef:
              candidateType = type.render;
              break;
          }
          var didMatch = false;
          if (candidateType !== null) {
            if (types.has(candidateType)) {
              didMatch = true;
            }
          }
          if (didMatch) {
            // We have a match. This only drills down to the closest host components.
            // There's no need to search deeper because for the purpose of giving
            // visual feedback, "flashing" outermost parent rectangles is sufficient.
            findHostInstancesForFiberShallowly(fiber, hostInstances);
          } else {
            // If there's no match, maybe there will be one further down in the child tree.
            if (child !== null) {
              findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
            }
          }
          if (sibling !== null) {
            findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
          }
        }
      }
      function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
          if (foundHostInstances) {
            return;
          } // If we didn't find any host children, fallback to closest host parent.

          var node = fiber;
          while (true) {
            switch (node.tag) {
              case HostComponent:
                hostInstances.add(node.stateNode);
                return;
              case HostPortal:
                hostInstances.add(node.stateNode.containerInfo);
                return;
              case HostRoot:
                hostInstances.add(node.stateNode.containerInfo);
                return;
            }
            if (node.return === null) {
              throw new Error('Expected to reach root first.');
            }
            node = node.return;
          }
        }
      }
      function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var node = fiber;
          var foundHostInstances = false;
          while (true) {
            if (node.tag === HostComponent) {
              // We got a match.
              foundHostInstances = true;
              hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === fiber) {
              return foundHostInstances;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === fiber) {
                return foundHostInstances;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
        return false;
      }
      function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
          // Resolve default props. Taken from ReactElement
          var props = _assign({}, baseProps);
          var defaultProps = Component.defaultProps;
          for (var propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }
          return props;
        }
        return baseProps;
      }
      function readLazyComponentType(lazyComponent) {
        initializeLazyComponentType(lazyComponent);
        if (lazyComponent._status !== Resolved) {
          throw lazyComponent._result;
        }
        return lazyComponent._result;
      }
      var valueCursor = createCursor(null);
      var rendererSigil;
      {
        // Use this to detect multiple renderers using the same context
        rendererSigil = {};
      }
      var currentlyRenderingFiber = null;
      var lastContextDependency = null;
      var lastContextWithAllBitsObserved = null;
      var isDisallowedContextReadInDEV = false;
      function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        {
          isDisallowedContextReadInDEV = false;
        }
      }
      function enterDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = true;
        }
      }
      function exitDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = false;
        }
      }
      function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        {
          push(valueCursor, context._currentValue, providerFiber);
          context._currentValue = nextValue;
          {
            if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
              error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
            }
            context._currentRenderer = rendererSigil;
          }
        }
      }
      function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        {
          context._currentValue = currentValue;
        }
      }
      function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) {
          // No change
          return 0;
        } else {
          var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          {
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
              error('calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
            }
          }
          return changedBits | 0;
        }
      }
      function scheduleWorkOnParentPath(parent, renderExpirationTime) {
        // Update the child expiration time of all the ancestors, including
        // the alternates.
        var node = parent;
        while (node !== null) {
          var alternate = node.alternate;
          if (node.childExpirationTime < renderExpirationTime) {
            node.childExpirationTime = renderExpirationTime;
            if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) {
              alternate.childExpirationTime = renderExpirationTime;
            }
          } else if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) {
            alternate.childExpirationTime = renderExpirationTime;
          } else {
            // Neither alternate was updated, which means the rest of the
            // ancestor path already has sufficient priority.
            break;
          }
          node = node.return;
        }
      }
      function propagateContextChange(workInProgress, context, changedBits, renderExpirationTime) {
        var fiber = workInProgress.child;
        if (fiber !== null) {
          // Set the return pointer of the child to the work-in-progress fiber.
          fiber.return = workInProgress;
        }
        while (fiber !== null) {
          var nextFiber = void 0; // Visit this fiber.

          var list = fiber.dependencies;
          if (list !== null) {
            nextFiber = fiber.child;
            var dependency = list.firstContext;
            while (dependency !== null) {
              // Check if the context matches.
              if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                // Match! Schedule an update on this fiber.
                if (fiber.tag === ClassComponent) {
                  // Schedule a force update on the work-in-progress.
                  var update = createUpdate(renderExpirationTime, null);
                  update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                  // update to the current fiber, too, which means it will persist even if
                  // this render is thrown away. Since it's a race condition, not sure it's
                  // worth fixing.

                  enqueueUpdate(fiber, update);
                }
                if (fiber.expirationTime < renderExpirationTime) {
                  fiber.expirationTime = renderExpirationTime;
                }
                var alternate = fiber.alternate;
                if (alternate !== null && alternate.expirationTime < renderExpirationTime) {
                  alternate.expirationTime = renderExpirationTime;
                }
                scheduleWorkOnParentPath(fiber.return, renderExpirationTime); // Mark the expiration time on the list, too.

                if (list.expirationTime < renderExpirationTime) {
                  list.expirationTime = renderExpirationTime;
                } // Since we already found a match, we can stop traversing the
                // dependency list.

                break;
              }
              dependency = dependency.next;
            }
          } else if (fiber.tag === ContextProvider) {
            // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
          } else {
            // Traverse down.
            nextFiber = fiber.child;
          }
          if (nextFiber !== null) {
            // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
          } else {
            // No child. Traverse to next sibling.
            nextFiber = fiber;
            while (nextFiber !== null) {
              if (nextFiber === workInProgress) {
                // We're back to the root of this subtree. Exit.
                nextFiber = null;
                break;
              }
              var sibling = nextFiber.sibling;
              if (sibling !== null) {
                // Set the return pointer of the sibling to the work-in-progress fiber.
                sibling.return = nextFiber.return;
                nextFiber = sibling;
                break;
              } // No more siblings. Traverse up.

              nextFiber = nextFiber.return;
            }
          }
          fiber = nextFiber;
        }
      }
      function prepareToReadContext(workInProgress, renderExpirationTime) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
          var firstContext = dependencies.firstContext;
          if (firstContext !== null) {
            if (dependencies.expirationTime >= renderExpirationTime) {
              // Context list has a pending update. Mark that this fiber performed work.
              markWorkInProgressReceivedUpdate();
            } // Reset the work-in-progress list

            dependencies.firstContext = null;
          }
        }
      }
      function _readContext2(context, observedBits) {
        {
          // This warning would fire if you read context inside a Hook like useMemo.
          // Unlike the class check below, it's not enforced in production for perf.
          if (isDisallowedContextReadInDEV) {
            error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
          }
        }
        if (lastContextWithAllBitsObserved === context) ;else if (observedBits === false || observedBits === 0) ;else {
          var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.

          if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
            // Observe all updates.
            lastContextWithAllBitsObserved = context;
            resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
          } else {
            resolvedObservedBits = observedBits;
          }
          var contextItem = {
            context: context,
            observedBits: resolvedObservedBits,
            next: null
          };
          if (lastContextDependency === null) {
            if (!(currentlyRenderingFiber !== null)) {
              {
                throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
              }
            } // This is the first dependency for this component. Create a new list.

            lastContextDependency = contextItem;
            currentlyRenderingFiber.dependencies = {
              expirationTime: NoWork,
              firstContext: contextItem,
              responders: null
            };
          } else {
            // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
          }
        }
        return context._currentValue;
      }
      var UpdateState = 0;
      var ReplaceState = 1;
      var ForceUpdate = 2;
      var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
      // It should only be read right after calling `processUpdateQueue`, via
      // `checkHasForceUpdateAfterProcessing`.

      var hasForceUpdate = false;
      var didWarnUpdateInsideUpdate;
      var currentlyProcessingQueue;
      {
        didWarnUpdateInsideUpdate = false;
        currentlyProcessingQueue = null;
      }
      function initializeUpdateQueue(fiber) {
        var queue = {
          baseState: fiber.memoizedState,
          baseQueue: null,
          shared: {
            pending: null
          },
          effects: null
        };
        fiber.updateQueue = queue;
      }
      function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
          var clone = {
            baseState: currentQueue.baseState,
            baseQueue: currentQueue.baseQueue,
            shared: currentQueue.shared,
            effects: currentQueue.effects
          };
          workInProgress.updateQueue = clone;
        }
      }
      function createUpdate(expirationTime, suspenseConfig) {
        var update = {
          expirationTime: expirationTime,
          suspenseConfig: suspenseConfig,
          tag: UpdateState,
          payload: null,
          callback: null,
          next: null
        };
        update.next = update;
        {
          update.priority = getCurrentPriorityLevel();
        }
        return update;
      }
      function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) {
          // Only occurs if the fiber has been unmounted.
          return;
        }
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) {
          // This is the first update. Create a circular list.
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }
        sharedQueue.pending = update;
        {
          if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
            didWarnUpdateInsideUpdate = true;
          }
        }
      }
      function enqueueCapturedUpdate(workInProgress, update) {
        var current = workInProgress.alternate;
        if (current !== null) {
          // Ensure the work-in-progress queue is a clone
          cloneUpdateQueue(current, workInProgress);
        } // Captured updates go only on the work-in-progress queue.

        var queue = workInProgress.updateQueue; // Append the update to the end of the list.

        var last = queue.baseQueue;
        if (last === null) {
          queue.baseQueue = update.next = update;
          update.next = update;
        } else {
          update.next = last.next;
          last.next = update;
        }
      }
      function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch (update.tag) {
          case ReplaceState:
            {
              var payload = update.payload;
              if (typeof payload === 'function') {
                // Updater function
                {
                  enterDisallowedContextReadInDEV();
                  if (workInProgress.mode & StrictMode) {
                    payload.call(instance, prevState, nextProps);
                  }
                }
                var nextState = payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
                return nextState;
              } // State object

              return payload;
            }
          case CaptureUpdate:
            {
              workInProgress.effectTag = workInProgress.effectTag & ~ShouldCapture | DidCapture;
            }
          // Intentional fallthrough

          case UpdateState:
            {
              var _payload = update.payload;
              var partialState;
              if (typeof _payload === 'function') {
                // Updater function
                {
                  enterDisallowedContextReadInDEV();
                  if (workInProgress.mode & StrictMode) {
                    _payload.call(instance, prevState, nextProps);
                  }
                }
                partialState = _payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
              } else {
                // Partial state object
                partialState = _payload;
              }
              if (partialState === null || partialState === undefined) {
                // Null and undefined are treated as no-ops.
                return prevState;
              } // Merge the partial state and the previous state.

              return _assign({}, prevState, partialState);
            }
          case ForceUpdate:
            {
              hasForceUpdate = true;
              return prevState;
            }
        }
        return prevState;
      }
      function processUpdateQueue(workInProgress, props, instance, renderExpirationTime) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        {
          currentlyProcessingQueue = queue.shared;
        } // The last rebase update that is NOT part of the base state.

        var baseQueue = queue.baseQueue; // The last pending update that hasn't been processed yet.

        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
          // We have new updates that haven't been processed yet.
          // We'll add them to the base queue.
          if (baseQueue !== null) {
            // Merge the pending queue and the base queue.
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }
          baseQueue = pendingQueue;
          queue.shared.pending = null; // TODO: Pass `current` as argument

          var current = workInProgress.alternate;
          if (current !== null) {
            var currentQueue = current.updateQueue;
            if (currentQueue !== null) {
              currentQueue.baseQueue = pendingQueue;
            }
          }
        } // These values may change as we process the queue.

        if (baseQueue !== null) {
          var first = baseQueue.next; // Iterate through the list of updates to compute the result.

          var newState = queue.baseState;
          var newExpirationTime = NoWork;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          if (first !== null) {
            var update = first;
            do {
              var updateExpirationTime = update.expirationTime;
              if (updateExpirationTime < renderExpirationTime) {
                // Priority is insufficient. Skip this update. If this is the first
                // skipped update, the previous update/state is the new base
                // update/state.
                var clone = {
                  expirationTime: update.expirationTime,
                  suspenseConfig: update.suspenseConfig,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };
                if (newBaseQueueLast === null) {
                  newBaseQueueFirst = newBaseQueueLast = clone;
                  newBaseState = newState;
                } else {
                  newBaseQueueLast = newBaseQueueLast.next = clone;
                } // Update the remaining priority in the queue.

                if (updateExpirationTime > newExpirationTime) {
                  newExpirationTime = updateExpirationTime;
                }
              } else {
                // This update does have sufficient priority.
                if (newBaseQueueLast !== null) {
                  var _clone = {
                    expirationTime: Sync,
                    // This update is going to be committed so we never want uncommit it.
                    suspenseConfig: update.suspenseConfig,
                    tag: update.tag,
                    payload: update.payload,
                    callback: update.callback,
                    next: null
                  };
                  newBaseQueueLast = newBaseQueueLast.next = _clone;
                } // Mark the event time of this update as relevant to this render pass.
                // TODO: This should ideally use the true event time of this update rather than
                // its priority which is a derived and not reverseable value.
                // TODO: We should skip this update if it was already committed but currently
                // we have no way of detecting the difference between a committed and suspended
                // update here.

                markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.

                newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                var callback = update.callback;
                if (callback !== null) {
                  workInProgress.effectTag |= Callback;
                  var effects = queue.effects;
                  if (effects === null) {
                    queue.effects = [update];
                  } else {
                    effects.push(update);
                  }
                }
              }
              update = update.next;
              if (update === null || update === first) {
                pendingQueue = queue.shared.pending;
                if (pendingQueue === null) {
                  break;
                } else {
                  // An update was scheduled from inside a reducer. Add the new
                  // pending updates to the end of the list and keep processing.
                  update = baseQueue.next = pendingQueue.next;
                  pendingQueue.next = first;
                  queue.baseQueue = baseQueue = pendingQueue;
                  queue.shared.pending = null;
                }
              }
            } while (true);
          }
          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          }
          queue.baseState = newBaseState;
          queue.baseQueue = newBaseQueueLast; // Set the remaining expiration time to be whatever is remaining in the queue.
          // This should be fine because the only two other things that contribute to
          // expiration time are props and context. We're already in the middle of the
          // begin phase by the time we start processing the queue, so we've already
          // dealt with the props. Context in components that specify
          // shouldComponentUpdate is tricky; but we'll have to account for
          // that regardless.

          markUnprocessedUpdateTime(newExpirationTime);
          workInProgress.expirationTime = newExpirationTime;
          workInProgress.memoizedState = newState;
        }
        {
          currentlyProcessingQueue = null;
        }
      }
      function callCallback(callback, context) {
        if (!(typeof callback === 'function')) {
          {
            throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
          }
        }
        callback.call(context);
      }
      function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
      }
      function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
      }
      function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) {
          for (var i = 0; i < effects.length; i++) {
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
              effect.callback = null;
              callCallback(callback, instance);
            }
          }
        }
      }
      var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
      function requestCurrentSuspenseConfig() {
        return ReactCurrentBatchConfig.suspense;
      }
      var fakeInternalInstance = {};
      var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
      // We'll use it to determine whether we need to initialize legacy refs.

      var emptyRefsObject = new React.Component().refs;
      var didWarnAboutStateAssignmentForComponent;
      var didWarnAboutUninitializedState;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
      var didWarnAboutLegacyLifecyclesAndDerivedState;
      var didWarnAboutUndefinedDerivedState;
      var warnOnUndefinedDerivedState;
      var warnOnInvalidCallback;
      var didWarnAboutDirectlyAssigningPropsToState;
      var didWarnAboutContextTypeAndContextTypes;
      var didWarnAboutInvalidateContextType;
      {
        didWarnAboutStateAssignmentForComponent = new Set();
        didWarnAboutUninitializedState = new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
        didWarnAboutDirectlyAssigningPropsToState = new Set();
        didWarnAboutUndefinedDerivedState = new Set();
        didWarnAboutContextTypeAndContextTypes = new Set();
        didWarnAboutInvalidateContextType = new Set();
        var didWarnOnInvalidCallback = new Set();
        warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
          if (callback === null || typeof callback === 'function') {
            return;
          }
          var key = callerName + "_" + callback;
          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        };
        warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
          if (partialState === undefined) {
            var componentName = getComponentName(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
            }
          }
        }; // This is so gross but it's at least non-critical and can be removed if
        // it causes problems. This is meant to give a nicer error message for
        // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
        // ...)) which otherwise throws a "_processChildContext is not a function"
        // exception.

        Object.defineProperty(fakeInternalInstance, '_processChildContext', {
          enumerable: false,
          value: function value() {
            {
              {
                throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
              }
            }
          }
        });
        Object.freeze(fakeInternalInstance);
      }
      function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        {
          if (workInProgress.mode & StrictMode) {
            // Invoke the function an extra time to help detect side-effects.
            getDerivedStateFromProps(nextProps, prevState);
          }
        }
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          warnOnUndefinedDerivedState(ctor, partialState);
        } // Merge the partial state and the previous state.

        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.

        if (workInProgress.expirationTime === NoWork) {
          // Queue is always non-null for classes
          var updateQueue = workInProgress.updateQueue;
          updateQueue.baseState = memoizedState;
        }
      }
      var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.payload = payload;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'setState');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.tag = ReplaceState;
          update.payload = payload;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'replaceState');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.tag = ForceUpdate;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'forceUpdate');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        }
      };
      function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
          {
            if (workInProgress.mode & StrictMode) {
              // Invoke the function an extra time to help detect side-effects.
              instance.shouldComponentUpdate(newProps, newState, nextContext);
            }
          }
          startPhaseTimer(workInProgress, 'shouldComponentUpdate');
          var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
          stopPhaseTimer();
          {
            if (shouldUpdate === undefined) {
              error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component');
            }
          }
          return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) {
          return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        }
        return true;
      }
      function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        {
          var name = getComponentName(ctor) || 'Component';
          var renderPresent = instance.render;
          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') {
              error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
            } else {
              error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
            }
          }
          if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
            error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
          }
          if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
          }
          if (instance.propTypes) {
            error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
          }
          if (instance.contextType) {
            error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
          }
          {
            if (instance.contextTypes) {
              error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
            }
            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
              didWarnAboutContextTypeAndContextTypes.add(ctor);
              error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
            }
          }
          if (typeof instance.componentShouldUpdate === 'function') {
            error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
          }
          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
            error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
          }
          if (typeof instance.componentDidUnmount === 'function') {
            error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
          }
          if (typeof instance.componentDidReceiveProps === 'function') {
            error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
          }
          if (typeof instance.componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
          }
          if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
          }
          var hasMutatedProps = instance.props !== newProps;
          if (instance.props !== undefined && hasMutatedProps) {
            error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
          }
          if (instance.defaultProps) {
            error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
          }
          if (typeof instance.getDerivedStateFromProps === 'function') {
            error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }
          if (typeof instance.getDerivedStateFromError === 'function') {
            error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }
          if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
            error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
          }
          var _state = instance.state;
          if (_state && (typeof _state !== 'object' || isArray(_state))) {
            error('%s.state: must be set to an object or null', name);
          }
          if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
            error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
          }
        }
      }
      function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

        set(instance, workInProgress);
        {
          instance._reactInternalInstance = fakeInternalInstance;
        }
      }
      function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        {
          if ('contextType' in ctor) {
            var isValid =
            // Allow null for conditional declaration
            contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              var addendum = '';
              if (contextType === undefined) {
                addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
              } else if (typeof contextType !== 'object') {
                addendum = ' However, it is set to a ' + typeof contextType + '.';
              } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                addendum = ' Did you accidentally pass the Context.Provider instead?';
              } else if (contextType._context !== undefined) {
                // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
              } else {
                addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
              }
              error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(ctor) || 'Component', addendum);
            }
          }
        }
        if (typeof contextType === 'object' && contextType !== null) {
          context = _readContext2(contextType);
        } else {
          unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          var contextTypes = ctor.contextTypes;
          isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
          context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.

        {
          if (workInProgress.mode & StrictMode) {
            new ctor(props, context); // eslint-disable-line no-new
          }
        }

        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        {
          if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
          } // If new component APIs are defined, "unsafe" lifecycles won't be called.
          // Warn about these lifecycles if they are present.
          // Don't warn about react-lifecycles-compat polyfilled methods though.

          if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = 'componentWillMount';
            } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
              foundWillMountName = 'UNSAFE_componentWillMount';
            }
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = 'componentWillReceiveProps';
            } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
              foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            }
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = 'componentWillUpdate';
            } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            }
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentName(ctor) || 'Component';
              var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
              }
            }
          }
        } // Cache unmasked context so we can avoid recreating masked context unless necessary.
        // ReactFiberContext usually updates this cache but can't for newly-created instances.

        if (isLegacyContextConsumer) {
          cacheContext(workInProgress, unmaskedContext, context);
        }
        return instance;
      }
      function callComponentWillMount(workInProgress, instance) {
        startPhaseTimer(workInProgress, 'componentWillMount');
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') {
          instance.componentWillMount();
        }
        if (typeof instance.UNSAFE_componentWillMount === 'function') {
          instance.UNSAFE_componentWillMount();
        }
        stopPhaseTimer();
        if (oldState !== instance.state) {
          {
            error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }
      function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        startPhaseTimer(workInProgress, 'componentWillReceiveProps');
        if (typeof instance.componentWillReceiveProps === 'function') {
          instance.componentWillReceiveProps(newProps, nextContext);
        }
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
          instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        }
        stopPhaseTimer();
        if (instance.state !== oldState) {
          {
            var componentName = getComponentName(workInProgress.type) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
              didWarnAboutStateAssignmentForComponent.add(componentName);
              error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
            }
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      } // Invokes the mount life-cycles on a previously never rendered instance.

      function mountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        {
          checkClassInstance(workInProgress, ctor, newProps);
        }
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) {
          instance.context = _readContext2(contextType);
        } else {
          var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        {
          if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
            }
          }
          if (workInProgress.mode & StrictMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
          }
          {
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
          }
        }
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
          callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
          // process them now.

          processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
          instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') {
          workInProgress.effectTag |= Update;
        }
      }
      function resumeMountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext2(contextType);
        } else {
          var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }
          return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            startPhaseTimer(workInProgress, 'componentWillMount');
            if (typeof instance.componentWillMount === 'function') {
              instance.componentWillMount();
            }
            if (typeof instance.UNSAFE_componentWillMount === 'function') {
              instance.UNSAFE_componentWillMount();
            }
            stopPhaseTimer();
          }
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }
        } else {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          } // If shouldComponentUpdate returned false, we should still update the
          // memoized state to indicate that this work can be reused.

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      } // Invokes the update life-cycles and returns false if it shouldn't rerender.

      function updateClassInstance(current, workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var oldProps = workInProgress.memoizedProps;
        instance.props = workInProgress.type === workInProgress.elementType ? oldProps : resolveDefaultProps(workInProgress.type, oldProps);
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext2(contextType);
        } else {
          var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Update;
            }
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Snapshot;
            }
          }
          return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
            startPhaseTimer(workInProgress, 'componentWillUpdate');
            if (typeof instance.componentWillUpdate === 'function') {
              instance.componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            stopPhaseTimer();
          }
          if (typeof instance.componentDidUpdate === 'function') {
            workInProgress.effectTag |= Update;
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            workInProgress.effectTag |= Snapshot;
          }
        } else {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Update;
            }
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Snapshot;
            }
          } // If shouldComponentUpdate returned false, we should still update the
          // memoized props/state to indicate that this work can be reused.

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      }
      var didWarnAboutMaps;
      var didWarnAboutGenerators;
      var didWarnAboutStringRefs;
      var ownerHasKeyUseWarning;
      var ownerHasFunctionTypeWarning;
      var warnForMissingKey = function warnForMissingKey(child) {};
      {
        didWarnAboutMaps = false;
        didWarnAboutGenerators = false;
        didWarnAboutStringRefs = {};
        /**
         * Warn if there's no key explicitly set on dynamic arrays of children or
         * object keys are not valid. This allows us to keep track of children between
         * updates.
         */

        ownerHasKeyUseWarning = {};
        ownerHasFunctionTypeWarning = {};
        warnForMissingKey = function warnForMissingKey(child) {
          if (child === null || typeof child !== 'object') {
            return;
          }
          if (!child._store || child._store.validated || child.key != null) {
            return;
          }
          if (!(typeof child._store === 'object')) {
            {
              throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          child._store.validated = true;
          var currentComponentErrorInfo = 'Each child in a list should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.' + getCurrentFiberStackInDev();
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          error('Each child in a list should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.');
        };
      }
      var isArray$1 = Array.isArray;
      function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
          {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) &&
            // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
              var componentName = getComponentName(returnFiber.type) || 'Component';
              if (!didWarnAboutStringRefs[componentName]) {
                {
                  error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-string-ref%s', mixedRef, getStackByFiberInDevAndProd(returnFiber));
                }
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
          if (element._owner) {
            var owner = element._owner;
            var inst;
            if (owner) {
              var ownerFiber = owner;
              if (!(ownerFiber.tag === ClassComponent)) {
                {
                  throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref");
                }
              }
              inst = ownerFiber.stateNode;
            }
            if (!inst) {
              {
                throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

            if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
              return current.ref;
            }
            var ref = function ref(value) {
              var refs = inst.refs;
              if (refs === emptyRefsObject) {
                // This is a lazy pooled frozen object, so we need to initialize.
                refs = inst.refs = {};
              }
              if (value === null) {
                delete refs[stringRef];
              } else {
                refs[stringRef] = value;
              }
            };
            ref._stringRef = stringRef;
            return ref;
          } else {
            if (!(typeof mixedRef === 'string')) {
              {
                throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
              }
            }
            if (!element._owner) {
              {
                throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.");
              }
            }
          }
        }
        return mixedRef;
      }
      function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== 'textarea') {
          var addendum = '';
          {
            addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + getCurrentFiberStackInDev();
          }
          {
            {
              throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + ")." + addendum);
            }
          }
        }
      }
      function warnOnFunctionType() {
        {
          var currentComponentErrorInfo = 'Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.' + getCurrentFiberStackInDev();
          if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
          error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
        }
      } // This wrapper function exists because I expect to clone the code in each path
      // to be able to optimize each path individually by branching early. This needs
      // a compiler or we can do it manually. Helpers that don't need this branching
      // live outside of this function.

      function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
          if (!shouldTrackSideEffects) {
            // Noop.
            return;
          } // Deletions are added in reversed order so we add it to the front.
          // At this point, the return fiber's effect list is empty except for
          // deletions, so we can just append the deletion to the list. The remaining
          // effects aren't added until the complete phase. Once we implement
          // resuming, this may not be true.

          var last = returnFiber.lastEffect;
          if (last !== null) {
            last.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
          }
          childToDelete.nextEffect = null;
          childToDelete.effectTag = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
          if (!shouldTrackSideEffects) {
            // Noop.
            return null;
          } // TODO: For the shouldClone case, this could be micro-optimized a bit by
          // assuming that after the first child we've already added everything.

          var childToDelete = currentFirstChild;
          while (childToDelete !== null) {
            deleteChild(returnFiber, childToDelete);
            childToDelete = childToDelete.sibling;
          }
          return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
          // Add the remaining children to a temporary map so that we can find them by
          // keys quickly. Implicit (null) keys get added to this set with their index
          // instead.
          var existingChildren = new Map();
          var existingChild = currentFirstChild;
          while (existingChild !== null) {
            if (existingChild.key !== null) {
              existingChildren.set(existingChild.key, existingChild);
            } else {
              existingChildren.set(existingChild.index, existingChild);
            }
            existingChild = existingChild.sibling;
          }
          return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
          // We currently set sibling to null and index to 0 here because it is easy
          // to forget to do before returning it. E.g. for the single child case.
          var clone = createWorkInProgress(fiber, pendingProps);
          clone.index = 0;
          clone.sibling = null;
          return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
          newFiber.index = newIndex;
          if (!shouldTrackSideEffects) {
            // Noop.
            return lastPlacedIndex;
          }
          var current = newFiber.alternate;
          if (current !== null) {
            var oldIndex = current.index;
            if (oldIndex < lastPlacedIndex) {
              // This is a move.
              newFiber.effectTag = Placement;
              return lastPlacedIndex;
            } else {
              // This item can stay in place.
              return oldIndex;
            }
          } else {
            // This is an insertion.
            newFiber.effectTag = Placement;
            return lastPlacedIndex;
          }
        }
        function placeSingleChild(newFiber) {
          // This is simpler for the single child case. We only need to do a
          // placement for inserting new children.
          if (shouldTrackSideEffects && newFiber.alternate === null) {
            newFiber.effectTag = Placement;
          }
          return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, expirationTime) {
          if (current === null || current.tag !== HostText) {
            // Insert
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, textContent);
            existing.return = returnFiber;
            return existing;
          }
        }
        function updateElement(returnFiber, current, element, expirationTime) {
          if (current !== null) {
            if (current.elementType === element.type ||
            // Keep this check inline so it only runs on the false path:
            isCompatibleFamilyForHotReloading(current, element)) {
              // Move based on index
              var existing = useFiber(current, element.props);
              existing.ref = coerceRef(returnFiber, current, element);
              existing.return = returnFiber;
              {
                existing._debugSource = element._source;
                existing._debugOwner = element._owner;
              }
              return existing;
            }
          } // Insert

          var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
          created.ref = coerceRef(returnFiber, current, element);
          created.return = returnFiber;
          return created;
        }
        function updatePortal(returnFiber, current, portal, expirationTime) {
          if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
            // Insert
            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, portal.children || []);
            existing.return = returnFiber;
            return existing;
          }
        }
        function updateFragment(returnFiber, current, fragment, expirationTime, key) {
          if (current === null || current.tag !== Fragment$$1) {
            // Insert
            var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, fragment);
            existing.return = returnFiber;
            return existing;
          }
        }
        function createChild(returnFiber, newChild, expirationTime) {
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys. If the previous node is implicitly keyed
            // we can continue to replace it without aborting even if it is not a text
            // node.
            var created = createFiberFromText('' + newChild, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);
                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created.return = returnFiber;
                  return _created;
                }
              case REACT_PORTAL_TYPE:
                {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);
                  _created2.return = returnFiber;
                  return _created2;
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);
              _created3.return = returnFiber;
              return _created3;
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
          // Update the fiber if the keys match, otherwise return null.
          var key = oldFiber !== null ? oldFiber.key : null;
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys. If the previous node is implicitly keyed
            // we can continue to replace it without aborting even if it is not a text
            // node.
            if (key !== null) {
              return null;
            }
            return updateTextNode(returnFiber, oldFiber, '' + newChild, expirationTime);
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  if (newChild.key === key) {
                    if (newChild.type === REACT_FRAGMENT_TYPE) {
                      return updateFragment(returnFiber, oldFiber, newChild.props.children, expirationTime, key);
                    }
                    return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
              case REACT_PORTAL_TYPE:
                {
                  if (newChild.key === key) {
                    return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              if (key !== null) {
                return null;
              }
              return updateFragment(returnFiber, oldFiber, newChild, expirationTime, null);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys, so we neither have to check the old nor
            // new node for the key. If both are text nodes, they match.
            var matchedFiber = existingChildren.get(newIdx) || null;
            return updateTextNode(returnFiber, matchedFiber, '' + newChild, expirationTime);
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  if (newChild.type === REACT_FRAGMENT_TYPE) {
                    return updateFragment(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                  }
                  return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                }
              case REACT_PORTAL_TYPE:
                {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              var _matchedFiber3 = existingChildren.get(newIdx) || null;
              return updateFragment(returnFiber, _matchedFiber3, newChild, expirationTime, null);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        /**
         * Warns if there is a duplicate or missing key
         */

        function warnOnInvalidKey(child, knownKeys) {
          {
            if (typeof child !== 'object' || child === null) {
              return knownKeys;
            }
            switch (child.$$typeof) {
              case REACT_ELEMENT_TYPE:
              case REACT_PORTAL_TYPE:
                warnForMissingKey(child);
                var key = child.key;
                if (typeof key !== 'string') {
                  break;
                }
                if (knownKeys === null) {
                  knownKeys = new Set();
                  knownKeys.add(key);
                  break;
                }
                if (!knownKeys.has(key)) {
                  knownKeys.add(key);
                  break;
                }
                error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);
                break;
            }
          }
          return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
          // This algorithm can't optimize by searching from both ends since we
          // don't have backpointers on fibers. I'm trying to see how far we can get
          // with that model. If it ends up not being worth the tradeoffs, we can
          // add it later.
          // Even with a two ended optimization, we'd want to optimize for the case
          // where there are few changes and brute force the comparison instead of
          // going for the Map. It'd like to explore hitting that path first in
          // forward-only mode and only go for the Map once we notice that we need
          // lots of look ahead. This doesn't handle reversal as well as two ended
          // search but that's unusual. Besides, for the two ended optimization to
          // work on Iterables, we'd need to copy the whole set.
          // In this first iteration, we'll just live with hitting the bad case
          // (adding everything to a Map) in for every insert/move.
          // If you change this code, also update reconcileChildrenIterator() which
          // uses the same algorithm.
          {
            // First, validate keys.
            var knownKeys = null;
            for (var i = 0; i < newChildren.length; i++) {
              var child = newChildren[i];
              knownKeys = warnOnInvalidKey(child, knownKeys);
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);
            if (newFiber === null) {
              // TODO: This breaks on empty slots like null children. That's
              // unfortunate because it triggers the slow path all the time. We need
              // a better way to communicate whether this was a miss or null,
              // boolean, undefined, etc.
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }
              break;
            }
            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                // We matched the slot, but we didn't reuse the existing fiber, so we
                // need to delete the existing child.
                deleteChild(returnFiber, oldFiber);
              }
            }
            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
            if (previousNewFiber === null) {
              // TODO: Move out of the loop. This only happens for the first run.
              resultingFirstChild = newFiber;
            } else {
              // TODO: Defer siblings if we're not at the right index for this slot.
              // I.e. if we had null values before, then we want to defer this
              // for each null value. However, we also don't want to call updateSlot
              // with the previous one.
              previousNewFiber.sibling = newFiber;
            }
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }
          if (newIdx === newChildren.length) {
            // We've reached the end of the new children. We can delete the rest.
            deleteRemainingChildren(returnFiber, oldFiber);
            return resultingFirstChild;
          }
          if (oldFiber === null) {
            // If we don't have any more existing children we can choose a fast path
            // since the rest will all be insertions.
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);
              if (_newFiber === null) {
                continue;
              }
              lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = _newFiber;
              } else {
                previousNewFiber.sibling = _newFiber;
              }
              previousNewFiber = _newFiber;
            }
            return resultingFirstChild;
          } // Add all children to a key map for quick lookups.

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

          for (; newIdx < newChildren.length; newIdx++) {
            var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);
            if (_newFiber2 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber2.alternate !== null) {
                  // The new fiber is a work in progress, but if there exists a
                  // current, that means that we reused the fiber. We need to delete
                  // it from the child list so that we don't add it to the deletion
                  // list.
                  existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                }
              }
              lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber2;
              } else {
                previousNewFiber.sibling = _newFiber2;
              }
              previousNewFiber = _newFiber2;
            }
          }
          if (shouldTrackSideEffects) {
            // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }
          return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
          // This is the same implementation as reconcileChildrenArray(),
          // but using the iterator instead.
          var iteratorFn = getIteratorFn(newChildrenIterable);
          if (!(typeof iteratorFn === 'function')) {
            {
              throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          {
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' &&
            // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
              if (!didWarnAboutGenerators) {
                error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
              }
              didWarnAboutGenerators = true;
            } // Warn about using Maps as children

            if (newChildrenIterable.entries === iteratorFn) {
              if (!didWarnAboutMaps) {
                error('Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.');
              }
              didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.

            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
              var knownKeys = null;
              var _step = _newChildren.next();
              for (; !_step.done; _step = _newChildren.next()) {
                var child = _step.value;
                knownKeys = warnOnInvalidKey(child, knownKeys);
              }
            }
          }
          var newChildren = iteratorFn.call(newChildrenIterable);
          if (!(newChildren != null)) {
            {
              throw Error("An iterable object provided no iterator.");
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          var step = newChildren.next();
          for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);
            if (newFiber === null) {
              // TODO: This breaks on empty slots like null children. That's
              // unfortunate because it triggers the slow path all the time. We need
              // a better way to communicate whether this was a miss or null,
              // boolean, undefined, etc.
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }
              break;
            }
            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                // We matched the slot, but we didn't reuse the existing fiber, so we
                // need to delete the existing child.
                deleteChild(returnFiber, oldFiber);
              }
            }
            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
            if (previousNewFiber === null) {
              // TODO: Move out of the loop. This only happens for the first run.
              resultingFirstChild = newFiber;
            } else {
              // TODO: Defer siblings if we're not at the right index for this slot.
              // I.e. if we had null values before, then we want to defer this
              // for each null value. However, we also don't want to call updateSlot
              // with the previous one.
              previousNewFiber.sibling = newFiber;
            }
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }
          if (step.done) {
            // We've reached the end of the new children. We can delete the rest.
            deleteRemainingChildren(returnFiber, oldFiber);
            return resultingFirstChild;
          }
          if (oldFiber === null) {
            // If we don't have any more existing children we can choose a fast path
            // since the rest will all be insertions.
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber3 = createChild(returnFiber, step.value, expirationTime);
              if (_newFiber3 === null) {
                continue;
              }
              lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = _newFiber3;
              } else {
                previousNewFiber.sibling = _newFiber3;
              }
              previousNewFiber = _newFiber3;
            }
            return resultingFirstChild;
          } // Add all children to a key map for quick lookups.

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

          for (; !step.done; newIdx++, step = newChildren.next()) {
            var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);
            if (_newFiber4 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber4.alternate !== null) {
                  // The new fiber is a work in progress, but if there exists a
                  // current, that means that we reused the fiber. We need to delete
                  // it from the child list so that we don't add it to the deletion
                  // list.
                  existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                }
              }
              lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber4;
              } else {
                previousNewFiber.sibling = _newFiber4;
              }
              previousNewFiber = _newFiber4;
            }
          }
          if (shouldTrackSideEffects) {
            // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }
          return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
          // There's no need to check for keys on text nodes since we don't have a
          // way to define them.
          if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
            // We already have an existing node so let's just update it and delete
            // the rest.
            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
            var existing = useFiber(currentFirstChild, textContent);
            existing.return = returnFiber;
            return existing;
          } // The existing first child is not a text node so we need to create one
          // and delete the existing ones.

          deleteRemainingChildren(returnFiber, currentFirstChild);
          var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
          created.return = returnFiber;
          return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
          var key = element.key;
          var child = currentFirstChild;
          while (child !== null) {
            // TODO: If key === null and child.key === null, then this only applies to
            // the first item in the list.
            if (child.key === key) {
              switch (child.tag) {
                case Fragment$$1:
                  {
                    if (element.type === REACT_FRAGMENT_TYPE) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var existing = useFiber(child, element.props.children);
                      existing.return = returnFiber;
                      {
                        existing._debugSource = element._source;
                        existing._debugOwner = element._owner;
                      }
                      return existing;
                    }
                    break;
                  }
                case Block:

                // We intentionally fallthrough here if enableBlocksAPI is not on.
                // eslint-disable-next-lined no-fallthrough

                default:
                  {
                    if (child.elementType === element.type ||
                    // Keep this check inline so it only runs on the false path:
                    isCompatibleFamilyForHotReloading(child, element)) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var _existing3 = useFiber(child, element.props);
                      _existing3.ref = coerceRef(returnFiber, child, element);
                      _existing3.return = returnFiber;
                      {
                        _existing3._debugSource = element._source;
                        _existing3._debugOwner = element._owner;
                      }
                      return _existing3;
                    }
                    break;
                  }
              } // Didn't match.

              deleteRemainingChildren(returnFiber, child);
              break;
            } else {
              deleteChild(returnFiber, child);
            }
            child = child.sibling;
          }
          if (element.type === REACT_FRAGMENT_TYPE) {
            var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
            created.return = returnFiber;
            return created;
          } else {
            var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);
            _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
            _created4.return = returnFiber;
            return _created4;
          }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
          var key = portal.key;
          var child = currentFirstChild;
          while (child !== null) {
            // TODO: If key === null and child.key === null, then this only applies to
            // the first item in the list.
            if (child.key === key) {
              if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, portal.children || []);
                existing.return = returnFiber;
                return existing;
              } else {
                deleteRemainingChildren(returnFiber, child);
                break;
              }
            } else {
              deleteChild(returnFiber, child);
            }
            child = child.sibling;
          }
          var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
          created.return = returnFiber;
          return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.

        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, expirationTime) {
          // This function is not recursive.
          // If the top level item is an array, we treat it as a set of children,
          // not as a fragment. Nested arrays on the other hand will be treated as
          // fragment nodes. Recursion happens at the normal flow.
          // Handle top level unkeyed fragments as if they were arrays.
          // This leads to an ambiguity between <>{[...]}</> and <>...</>.
          // We treat the ambiguous cases above the same.
          var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
          if (isUnkeyedTopLevelFragment) {
            newChild = newChild.props.children;
          } // Handle object types

          var isObject = typeof newChild === 'object' && newChild !== null;
          if (isObject) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));
              case REACT_PORTAL_TYPE:
                return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
            }
          }
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, expirationTime));
          }
          if (isArray$1(newChild)) {
            return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
          }
          if (getIteratorFn(newChild)) {
            return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
          }
          if (isObject) {
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
            // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch (returnFiber.tag) {
              case ClassComponent:
                {
                  {
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) {
                      // We allow auto-mocks to proceed as if they're returning null.
                      break;
                    }
                  }
                }
              // Intentionally fall through to the next case, which handles both
              // functions and classes
              // eslint-disable-next-lined no-fallthrough

              case FunctionComponent:
                {
                  var Component = returnFiber.type;
                  {
                    {
                      throw Error((Component.displayName || Component.name || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
                    }
                  }
                }
            }
          } // Remaining cases are all treated as empty.

          return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
      }
      var reconcileChildFibers = ChildReconciler(true);
      var mountChildFibers = ChildReconciler(false);
      function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) {
          {
            throw Error("Resuming work not yet implemented.");
          }
        }
        if (workInProgress.child === null) {
          return;
        }
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while (currentChild.sibling !== null) {
          currentChild = currentChild.sibling;
          newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
          newChild.return = workInProgress;
        }
        newChild.sibling = null;
      } // Reset a workInProgress child set to prepare it for a second pass.

      function resetChildFibers(workInProgress, renderExpirationTime) {
        var child = workInProgress.child;
        while (child !== null) {
          resetWorkInProgress(child, renderExpirationTime);
          child = child.sibling;
        }
      }
      var NO_CONTEXT = {};
      var contextStackCursor$1 = createCursor(NO_CONTEXT);
      var contextFiberStackCursor = createCursor(NO_CONTEXT);
      var rootInstanceStackCursor = createCursor(NO_CONTEXT);
      function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) {
          {
            throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        return c;
      }
      function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
      }
      function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.

        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.

        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.

        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
      }
      function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
      }
      function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
      }
      function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.

        if (context === nextContext) {
          return;
        } // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.

        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
      }
      function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) {
          return;
        }
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
      }
      var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
      // inherited deeply down the subtree. The upper bits only affect
      // this immediate suspense boundary and gets reset each new
      // boundary or suspense list.

      var SubtreeSuspenseContextMask = 1; // Subtree Flags:
      // InvisibleParentSuspenseContext indicates that one of our parent Suspense
      // boundaries is not currently showing visible main content.
      // Either because it is already showing a fallback or is not mounted at all.
      // We can use this to determine if it is desirable to trigger a fallback at
      // the parent. If not, then we might need to trigger undesirable boundaries
      // and/or suspend the commit to avoid hiding the parent content.

      var InvisibleParentSuspenseContext = 1; // Shallow Flags:
      // ForceSuspenseFallback can be used by SuspenseList to force newly added
      // items into their fallback state during one of the render passes.

      var ForceSuspenseFallback = 2;
      var suspenseStackCursor = createCursor(DefaultSuspenseContext);
      function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
      }
      function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
      }
      function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
      }
      function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
      }
      function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
      }
      function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
      }
      function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
          if (nextState.dehydrated !== null) {
            // A dehydrated boundary always captures.
            return true;
          }
          return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.

        if (props.fallback === undefined) {
          return false;
        } // Regular boundaries always capture.

        if (props.unstable_avoidThisFallback !== true) {
          return true;
        } // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.

        if (hasInvisibleParent) {
          return false;
        } // If the parent is not able to handle it, we must handle it.

        return true;
      }
      function findFirstSuspended(row) {
        var node = row;
        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;
            if (state !== null) {
              var dehydrated = state.dehydrated;
              if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                return node;
              }
            }
          } else if (node.tag === SuspenseListComponent &&
          // revealOrder undefined can't be trusted because it don't
          // keep track of whether it suspended or not.
          node.memoizedProps.revealOrder !== undefined) {
            var didSuspend = (node.effectTag & DidCapture) !== NoEffect;
            if (didSuspend) {
              return node;
            }
          } else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === row) {
            return null;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === row) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
        return null;
      }
      function createDeprecatedResponderListener(responder, props) {
        var eventResponderListener = {
          responder: responder,
          props: props
        };
        {
          Object.freeze(eventResponderListener);
        }
        return eventResponderListener;
      }
      var HasEffect = /* */
      1; // Represents the phase in which the effect (not the clean-up) fires.

      var Layout = /*    */
      2;
      var Passive$1 = /*   */
      4;
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher,
        ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
      var didWarnAboutMismatchedHooksForComponent;
      {
        didWarnAboutMismatchedHooksForComponent = new Set();
      }

      // These are set right before calling the component.
      var renderExpirationTime = NoWork; // The work-in-progress fiber. I've named it differently to distinguish it from
      // the work-in-progress hook.

      var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
      // current hook list is the list that belongs to the current fiber. The
      // work-in-progress hook list is a new list that will be added to the
      // work-in-progress fiber.

      var currentHook = null;
      var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
      // does not get reset if we do another render pass; only when we're completely
      // finished evaluating this component. This is an optimization so we know
      // whether we need to clear render phase updates after a throw.

      var didScheduleRenderPhaseUpdate = false;
      var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook

      var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
      // The list stores the order of hooks used during the initial render (mount).
      // Subsequent renders (updates) reference this list.

      var hookTypesDev = null;
      var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
      // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
      // When true, such Hooks will always be "remounted". Only used during hot reload.

      var ignorePreviousDependencies = false;
      function mountHookTypesDev() {
        {
          var hookName = currentHookNameInDev;
          if (hookTypesDev === null) {
            hookTypesDev = [hookName];
          } else {
            hookTypesDev.push(hookName);
          }
        }
      }
      function updateHookTypesDev() {
        {
          var hookName = currentHookNameInDev;
          if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
              warnOnHookMismatchInDev(hookName);
            }
          }
        }
      }
      function checkDepsAreArrayDev(deps) {
        {
          if (deps !== undefined && deps !== null && !Array.isArray(deps)) {
            // Verify deps, but only on mount to avoid extra checks.
            // It's unlikely their type would change as usually you define them inline.
            error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
          }
        }
      }
      function warnOnHookMismatchInDev(currentHookName) {
        {
          var componentName = getComponentName(currentlyRenderingFiber$1.type);
          if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
              var table = '';
              var secondColumnStart = 30;
              for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
                var oldHookName = hookTypesDev[i];
                var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                // lol @ IE not supporting String#repeat

                while (row.length < secondColumnStart) {
                  row += ' ';
                }
                row += newHookName + '\n';
                table += row;
              }
              error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://fb.me/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
            }
          }
        }
      }
      function throwInvalidHookError() {
        {
          {
            throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
          }
        }
      }
      function areHookInputsEqual(nextDeps, prevDeps) {
        {
          if (ignorePreviousDependencies) {
            // Only true when this component is being hot reloaded.
            return false;
          }
        }
        if (prevDeps === null) {
          {
            error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
          }
          return false;
        }
        {
          // Don't bother comparing lengths in prod because these arrays should be
          // passed inline.
          if (nextDeps.length !== prevDeps.length) {
            error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
          }
        }
        for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
          if (objectIs(nextDeps[i], prevDeps[i])) {
            continue;
          }
          return false;
        }
        return true;
      }
      function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderExpirationTime) {
        renderExpirationTime = nextRenderExpirationTime;
        currentlyRenderingFiber$1 = workInProgress;
        {
          hookTypesDev = current !== null ? current._debugHookTypes : null;
          hookTypesUpdateIndexDev = -1; // Used for hot reloading:

          ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        }
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.expirationTime = NoWork; // The following should have already been reset
        // currentHook = null;
        // workInProgressHook = null;
        // didScheduleRenderPhaseUpdate = false;
        // TODO Warn if no hooks are used at all during mount, then some are used during update.
        // Currently we will identify the update render as a mount because memoizedState === null.
        // This is tricky because it's valid for certain types of components (e.g. React.lazy)
        // Using memoizedState to differentiate between mount/update only works if at least one stateful hook is used.
        // Non-stateful hooks (e.g. context) don't get added to memoizedState,
        // so memoizedState would be null during updates and mounts.

        {
          if (current !== null && current.memoizedState !== null) {
            ReactCurrentDispatcher.current = HooksDispatcherOnUpdateInDEV;
          } else if (hookTypesDev !== null) {
            // This dispatcher handles an edge case where a component is updating,
            // but no stateful hooks have been used.
            // We want to match the production code behavior (which will use HooksDispatcherOnMount),
            // but with the extra DEV validation to ensure hooks ordering hasn't changed.
            // This dispatcher does that.
            ReactCurrentDispatcher.current = HooksDispatcherOnMountWithHookTypesInDEV;
          } else {
            ReactCurrentDispatcher.current = HooksDispatcherOnMountInDEV;
          }
        }
        var children = Component(props, secondArg); // Check if there was a render phase update

        if (workInProgress.expirationTime === renderExpirationTime) {
          // Keep rendering in a loop for as long as render phase updates continue to
          // be scheduled. Use a counter to prevent infinite loops.
          var numberOfReRenders = 0;
          do {
            workInProgress.expirationTime = NoWork;
            if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
              {
                throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
              }
            }
            numberOfReRenders += 1;
            {
              // Even when hot reloading, allow dependencies to stabilize
              // after first render to prevent infinite render phase updates.
              ignorePreviousDependencies = false;
            } // Start over from the beginning of the list

            currentHook = null;
            workInProgressHook = null;
            workInProgress.updateQueue = null;
            {
              // Also validate hook order for cascading updates.
              hookTypesUpdateIndexDev = -1;
            }
            ReactCurrentDispatcher.current = HooksDispatcherOnRerenderInDEV;
            children = Component(props, secondArg);
          } while (workInProgress.expirationTime === renderExpirationTime);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.

        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        {
          workInProgress._debugHookTypes = hookTypesDev;
        } // This check uses currentHook so that it works the same in DEV and prod bundles.
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.

        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          currentHookNameInDev = null;
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
        }
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) {
          {
            throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
          }
        }
        return children;
      }
      function bailoutHooks(current, workInProgress, expirationTime) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.effectTag &= ~(Passive | Update);
        if (current.expirationTime <= expirationTime) {
          current.expirationTime = NoWork;
        }
      }
      function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
          // There were render phase updates. These are only valid for this render
          // phase, which we are now aborting. Remove the updates from the queues so
          // they do not persist to the next render. Do not remove updates from hooks
          // that weren't processed.
          //
          // Only reset the updates from the queue if it has a clone. If it does
          // not have a clone, that means it wasn't processed, and the updates were
          // scheduled before we entered the render phase.
          var hook = currentlyRenderingFiber$1.memoizedState;
          while (hook !== null) {
            var queue = hook.queue;
            if (queue !== null) {
              queue.pending = null;
            }
            hook = hook.next;
          }
        }
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
          currentHookNameInDev = null;
        }
        didScheduleRenderPhaseUpdate = false;
      }
      function mountWorkInProgressHook() {
        var hook = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };
        if (workInProgressHook === null) {
          // This is the first hook in the list
          currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        } else {
          // Append to the end of the list
          workInProgressHook = workInProgressHook.next = hook;
        }
        return workInProgressHook;
      }
      function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
          var current = currentlyRenderingFiber$1.alternate;
          if (current !== null) {
            nextCurrentHook = current.memoizedState;
          } else {
            nextCurrentHook = null;
          }
        } else {
          nextCurrentHook = currentHook.next;
        }
        var nextWorkInProgressHook;
        if (workInProgressHook === null) {
          nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        } else {
          nextWorkInProgressHook = workInProgressHook.next;
        }
        if (nextWorkInProgressHook !== null) {
          // There's already a work-in-progress. Reuse it.
          workInProgressHook = nextWorkInProgressHook;
          nextWorkInProgressHook = workInProgressHook.next;
          currentHook = nextCurrentHook;
        } else {
          // Clone from the current hook.
          if (!(nextCurrentHook !== null)) {
            {
              throw Error("Rendered more hooks than during the previous render.");
            }
          }
          currentHook = nextCurrentHook;
          var newHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
          };
          if (workInProgressHook === null) {
            // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
          } else {
            // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
          }
        }
        return workInProgressHook;
      }
      function createFunctionComponentUpdateQueue() {
        return {
          lastEffect: null
        };
      }
      function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
      }
      function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) {
          initialState = init(initialArg);
        } else {
          initialState = initialArg;
        }
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: reducer,
          lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }
      function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) {
          {
            throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
          }
        }
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.

        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.

        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
          // We have new updates that haven't been processed yet.
          // We'll add them to the base queue.
          if (baseQueue !== null) {
            // Merge the pending queue and the base queue.
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }
          current.baseQueue = baseQueue = pendingQueue;
          queue.pending = null;
        }
        if (baseQueue !== null) {
          // We have a queue to process.
          var first = baseQueue.next;
          var newState = current.baseState;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          var update = first;
          do {
            var updateExpirationTime = update.expirationTime;
            if (updateExpirationTime < renderExpirationTime) {
              // Priority is insufficient. Skip this update. If this is the first
              // skipped update, the previous update/state is the new base
              // update/state.
              var clone = {
                expirationTime: update.expirationTime,
                suspenseConfig: update.suspenseConfig,
                action: update.action,
                eagerReducer: update.eagerReducer,
                eagerState: update.eagerState,
                next: null
              };
              if (newBaseQueueLast === null) {
                newBaseQueueFirst = newBaseQueueLast = clone;
                newBaseState = newState;
              } else {
                newBaseQueueLast = newBaseQueueLast.next = clone;
              } // Update the remaining priority in the queue.

              if (updateExpirationTime > currentlyRenderingFiber$1.expirationTime) {
                currentlyRenderingFiber$1.expirationTime = updateExpirationTime;
                markUnprocessedUpdateTime(updateExpirationTime);
              }
            } else {
              // This update does have sufficient priority.
              if (newBaseQueueLast !== null) {
                var _clone = {
                  expirationTime: Sync,
                  // This update is going to be committed so we never want uncommit it.
                  suspenseConfig: update.suspenseConfig,
                  action: update.action,
                  eagerReducer: update.eagerReducer,
                  eagerState: update.eagerState,
                  next: null
                };
                newBaseQueueLast = newBaseQueueLast.next = _clone;
              } // Mark the event time of this update as relevant to this render pass.
              // TODO: This should ideally use the true event time of this update rather than
              // its priority which is a derived and not reverseable value.
              // TODO: We should skip this update if it was already committed but currently
              // we have no way of detecting the difference between a committed and suspended
              // update here.

              markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.

              if (update.eagerReducer === reducer) {
                // If this update was processed eagerly, and its reducer matches the
                // current reducer, we can use the eagerly computed state.
                newState = update.eagerState;
              } else {
                var action = update.action;
                newState = reducer(newState, action);
              }
            }
            update = update.next;
          } while (update !== null && update !== first);
          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          } // Mark that the fiber performed work, but only if the new state is
          // different from the current state.

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }
          hook.memoizedState = newState;
          hook.baseState = newBaseState;
          hook.baseQueue = newBaseQueueLast;
          queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [hook.memoizedState, dispatch];
      }
      function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) {
          {
            throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
          }
        }
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.

        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
          // The queue doesn't persist past this render pass.
          queue.pending = null;
          var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
          var update = firstRenderPhaseUpdate;
          do {
            // Process this render phase update. We don't have to check the
            // priority because it will always be the same as the current
            // render's.
            var action = update.action;
            newState = reducer(newState, action);
            update = update.next;
          } while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
          // different from the current state.

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }
          hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
          // the base state unless the queue is empty.
          // TODO: Not sure if this is the desired semantics, but it's what we
          // do for gDSFP. I can't remember why.

          if (hook.baseQueue === null) {
            hook.baseState = newState;
          }
          queue.lastRenderedState = newState;
        }
        return [newState, dispatch];
      }
      function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') {
          // $FlowFixMe: Flow doesn't like mixed types
          initialState = initialState();
        }
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }
      function updateState(initialState) {
        return updateReducer(basicStateReducer);
      }
      function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
      }
      function pushEffect(tag, create, destroy, deps) {
        var effect = {
          tag: tag,
          create: create,
          destroy: destroy,
          deps: deps,
          // Circular
          next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
          var lastEffect = componentUpdateQueue.lastEffect;
          if (lastEffect === null) {
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var firstEffect = lastEffect.next;
            lastEffect.next = effect;
            effect.next = firstEffect;
            componentUpdateQueue.lastEffect = effect;
          }
        }
        return effect;
      }
      function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
          current: initialValue
        };
        {
          Object.seal(ref);
        }
        hook.memoizedState = ref;
        return ref;
      }
      function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
      }
      function mountEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, undefined, nextDeps);
      }
      function updateEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
          var prevEffect = currentHook.memoizedState;
          destroy = prevEffect.destroy;
          if (nextDeps !== null) {
            var prevDeps = prevEffect.deps;
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              pushEffect(hookEffectTag, create, destroy, nextDeps);
              return;
            }
          }
        }
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, destroy, nextDeps);
      }
      function mountEffect(create, deps) {
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
          }
        }
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
      }
      function updateEffect(create, deps) {
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
          }
        }
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
      }
      function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
      }
      function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
      }
      function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
          var refCallback = ref;
          var _inst = create();
          refCallback(_inst);
          return function () {
            refCallback(null);
          };
        } else if (ref !== null && ref !== undefined) {
          var refObject = ref;
          {
            if (!refObject.hasOwnProperty('current')) {
              error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            }
          }
          var _inst2 = create();
          refObject.current = _inst2;
          return function () {
            refObject.current = null;
          };
        }
      }
      function mountImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        } // TODO: If deps are provided, should we skip comparing the ref itself?

        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }
      function updateImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        } // TODO: If deps are provided, should we skip comparing the ref itself?

        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }
      function mountDebugValue(value, formatterFn) {// This hook is normally a no-op.
        // The react-debug-hooks package injects its own implementation
        // so that e.g. DevTools can display custom hook values.
      }
      var updateDebugValue = mountDebugValue;
      function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }
      function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }
      function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }
      function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
          // Assume these are defined. If they're not, areHookInputsEqual will warn.
          if (nextDeps !== null) {
            var prevDeps = prevState[1];
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }
      function mountDeferredValue(value, config) {
        var _mountState = mountState(value),
          prevValue = _mountState[0],
          setValue = _mountState[1];
        mountEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function updateDeferredValue(value, config) {
        var _updateState = updateState(),
          prevValue = _updateState[0],
          setValue = _updateState[1];
        updateEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function rerenderDeferredValue(value, config) {
        var _rerenderState = rerenderState(),
          prevValue = _rerenderState[0],
          setValue = _rerenderState[1];
        updateEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function startTransition(setPending, config, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(priorityLevel < UserBlockingPriority$1 ? UserBlockingPriority$1 : priorityLevel, function () {
          setPending(true);
        });
        runWithPriority$1(priorityLevel > NormalPriority ? NormalPriority : priorityLevel, function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setPending(false);
            callback();
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        });
      }
      function mountTransition(config) {
        var _mountState2 = mountState(false),
          isPending = _mountState2[0],
          setPending = _mountState2[1];
        var start = mountCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function updateTransition(config) {
        var _updateState2 = updateState(),
          isPending = _updateState2[0],
          setPending = _updateState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function rerenderTransition(config) {
        var _rerenderState2 = rerenderState(),
          isPending = _rerenderState2[0],
          setPending = _rerenderState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function dispatchAction(fiber, queue, action) {
        {
          if (typeof arguments[3] === 'function') {
            error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
          }
        }
        var currentTime = requestCurrentTimeForUpdate();
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
        var update = {
          expirationTime: expirationTime,
          suspenseConfig: suspenseConfig,
          action: action,
          eagerReducer: null,
          eagerState: null,
          next: null
        };
        {
          update.priority = getCurrentPriorityLevel();
        } // Append the update to the end of the list.

        var pending = queue.pending;
        if (pending === null) {
          // This is the first update. Create a circular list.
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
          // This is a render phase update. Stash it in a lazily-created map of
          // queue -> linked list of updates. After this render pass, we'll restart
          // and apply the stashed updates on top of the work-in-progress hook.
          didScheduleRenderPhaseUpdate = true;
          update.expirationTime = renderExpirationTime;
          currentlyRenderingFiber$1.expirationTime = renderExpirationTime;
        } else {
          if (fiber.expirationTime === NoWork && (alternate === null || alternate.expirationTime === NoWork)) {
            // The queue is currently empty, which means we can eagerly compute the
            // next state before entering the render phase. If the new state is the
            // same as the current state, we may be able to bail out entirely.
            var lastRenderedReducer = queue.lastRenderedReducer;
            if (lastRenderedReducer !== null) {
              var prevDispatcher;
              {
                prevDispatcher = ReactCurrentDispatcher.current;
                ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              }
              try {
                var currentState = queue.lastRenderedState;
                var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                // it, on the update object. If the reducer hasn't changed by the
                // time we enter the render phase, then the eager state can be used
                // without calling the reducer again.

                update.eagerReducer = lastRenderedReducer;
                update.eagerState = eagerState;
                if (objectIs(eagerState, currentState)) {
                  // Fast path. We can bail out without scheduling React to re-render.
                  // It's still possible that we'll need to rebase this update later,
                  // if the component re-renders for a different reason and by that
                  // time the reducer has changed.
                  return;
                }
              } catch (error) {// Suppress the error. It will throw again in the render phase.
              } finally {
                {
                  ReactCurrentDispatcher.current = prevDispatcher;
                }
              }
            }
          }
          {
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
              warnIfNotScopedWithMatchingAct(fiber);
              warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
          }
          scheduleWork(fiber, expirationTime);
        }
      }
      var ContextOnlyDispatcher = {
        readContext: _readContext2,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useResponder: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError
      };
      var HooksDispatcherOnMountInDEV = null;
      var HooksDispatcherOnMountWithHookTypesInDEV = null;
      var HooksDispatcherOnUpdateInDEV = null;
      var HooksDispatcherOnRerenderInDEV = null;
      var InvalidNestedHooksDispatcherOnMountInDEV = null;
      var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
      var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
      {
        var warnInvalidContextAccess = function warnInvalidContextAccess() {
          error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
        };
        var warnInvalidHookAccess = function warnInvalidHookAccess() {
          error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://fb.me/rules-of-hooks');
        };
        HooksDispatcherOnMountInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext2(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return _readContext2(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition(config);
          }
        };
        HooksDispatcherOnMountWithHookTypesInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext2(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext2(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition(config);
          }
        };
        HooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext2(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext2(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition(config);
          }
        };
        HooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext2(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext2(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnMountInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext2(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return _readContext2(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext2(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext2(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext2(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext2(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition(config);
          }
        };
      }
      var now$1 = Scheduler.unstable_now;
      var commitTime = 0;
      var profilerStartTime = -1;
      function getCommitTime() {
        return commitTime;
      }
      function recordCommitTime() {
        commitTime = now$1();
      }
      function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) {
          fiber.actualStartTime = now$1();
        }
      }
      function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
      }
      function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
          var elapsedTime = now$1() - profilerStartTime;
          fiber.actualDuration += elapsedTime;
          if (overrideBaseTime) {
            fiber.selfBaseDuration = elapsedTime;
          }
          profilerStartTime = -1;
        }
      }

      // This may have been an insertion or a hydration.

      var hydrationParentFiber = null;
      var nextHydratableInstance = null;
      var isHydrating = false;
      function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
      }
      function deleteHydratableInstance(returnFiber, instance) {
        {
          switch (returnFiber.tag) {
            case HostRoot:
              didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
              break;
            case HostComponent:
              didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
              break;
          }
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.effectTag = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.

        if (returnFiber.lastEffect !== null) {
          returnFiber.lastEffect.nextEffect = childToDelete;
          returnFiber.lastEffect = childToDelete;
        } else {
          returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
        }
      }
      function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.effectTag = fiber.effectTag & ~Hydrating | Placement;
        {
          switch (returnFiber.tag) {
            case HostRoot:
              {
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch (fiber.tag) {
                  case HostComponent:
                    var type = fiber.type;
                    var props = fiber.pendingProps;
                    didNotFindHydratableContainerInstance(parentContainer, type);
                    break;
                  case HostText:
                    var text = fiber.pendingProps;
                    didNotFindHydratableContainerTextInstance(parentContainer, text);
                    break;
                }
                break;
              }
            case HostComponent:
              {
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch (fiber.tag) {
                  case HostComponent:
                    var _type = fiber.type;
                    var _props = fiber.pendingProps;
                    didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                    break;
                  case HostText:
                    var _text = fiber.pendingProps;
                    didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                    break;
                  case SuspenseComponent:
                    didNotFindHydratableSuspenseInstance(parentType, parentProps);
                    break;
                }
                break;
              }
            default:
              return;
          }
        }
      }
      function tryHydrate(fiber, nextInstance) {
        switch (fiber.tag) {
          case HostComponent:
            {
              var type = fiber.type;
              var props = fiber.pendingProps;
              var instance = canHydrateInstance(nextInstance, type);
              if (instance !== null) {
                fiber.stateNode = instance;
                return true;
              }
              return false;
            }
          case HostText:
            {
              var text = fiber.pendingProps;
              var textInstance = canHydrateTextInstance(nextInstance, text);
              if (textInstance !== null) {
                fiber.stateNode = textInstance;
                return true;
              }
              return false;
            }
          case SuspenseComponent:
            {
              return false;
            }
          default:
            return false;
        }
      }
      function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) {
          return;
        }
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
          // Nothing to hydrate. Make it an insertion.
          insertNonHydratedInstance(hydrationParentFiber, fiber);
          isHydrating = false;
          hydrationParentFiber = fiber;
          return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
          // If we can't hydrate this instance let's try the next one.
          // We use this as a heuristic. It's based on intuition and not data so it
          // might be flawed or unnecessary.
          nextInstance = getNextHydratableSibling(firstAttemptedInstance);
          if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          } // We matched the next one, we'll now assume that the first one was
          // superfluous and we'll delete it. Since we can't eagerly delete it
          // we'll have to schedule a deletion. To do that, this node needs a dummy
          // fiber associated with it.

          deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
      }
      function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.

        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.

        if (updatePayload !== null) {
          return true;
        }
        return false;
      }
      function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        {
          if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) {
              switch (returnFiber.tag) {
                case HostRoot:
                  {
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                  }
                case HostComponent:
                  {
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
                  }
              }
            }
          }
        }
        return shouldUpdate;
      }
      function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) {
          {
            throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
      }
      function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
          parent = parent.return;
        }
        hydrationParentFiber = parent;
      }
      function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) {
          // We're deeper than the current hydration context, inside an inserted
          // tree.
          return false;
        }
        if (!isHydrating) {
          // If we're not currently hydrating but we're in a hydration context, then
          // we were an insertion and now need to pop up reenter hydration of our
          // siblings.
          popToNextHostParent(fiber);
          isHydrating = true;
          return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.

        if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
          var nextInstance = nextHydratableInstance;
          while (nextInstance) {
            deleteHydratableInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
          }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) {
          nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        } else {
          nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        }
        return true;
      }
      function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var didReceiveUpdate = false;
      var didWarnAboutBadClass;
      var didWarnAboutModulePatternComponent;
      var didWarnAboutContextTypeOnFunctionComponent;
      var didWarnAboutGetDerivedStateOnFunctionComponent;
      var didWarnAboutFunctionRefs;
      var didWarnAboutReassigningProps;
      var didWarnAboutRevealOrder;
      var didWarnAboutTailOptions;
      {
        didWarnAboutBadClass = {};
        didWarnAboutModulePatternComponent = {};
        didWarnAboutContextTypeOnFunctionComponent = {};
        didWarnAboutGetDerivedStateOnFunctionComponent = {};
        didWarnAboutFunctionRefs = {};
        didWarnAboutReassigningProps = false;
        didWarnAboutRevealOrder = {};
        didWarnAboutTailOptions = {};
      }
      function reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime) {
        if (current === null) {
          // If this is a fresh new component that hasn't been rendered yet, we
          // won't update its child set by applying minimal side-effects. Instead,
          // we will add them all to the child before it gets rendered. That means
          // we can optimize this reconciliation pass by not tracking side-effects.
          workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          // If the current child is the same as the work in progress, it means that
          // we haven't yet started any work on these children. Therefore, we use
          // the clone algorithm to create a copy of all the current children.
          // If we had any progressed work already, that is invalid at this point so
          // let's throw it out.
          workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderExpirationTime);
        }
      }
      function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderExpirationTime); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.

        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
      }
      function updateForwardRef(current, workInProgress, Component, nextProps, renderExpirationTime) {
        // TODO: current can be non-null here even if the component
        // hasn't yet mounted. This happens after the first render suspends.
        // We'll need to figure out if this is fine or can cause issues.
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent

        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
          if (workInProgress.mode & StrictMode) {
            // Only double-render components with Hooks
            if (workInProgress.memoizedState !== null) {
              nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
            }
          }
          setIsRendering(false);
        }
        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderExpirationTime);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (current === null) {
          var type = Component.type;
          if (isSimpleFunctionComponent(type) && Component.compare === null &&
          // SimpleMemoComponent codepath doesn't resolve outer props either.
          Component.defaultProps === undefined) {
            var resolvedType = type;
            {
              resolvedType = resolveFunctionForHotReloading(type);
            } // If this is a plain function component without default props,
            // and with only the default shallow comparison, we upgrade it
            // to a SimpleMemoComponent to allow fast path updates.

            workInProgress.tag = SimpleMemoComponent;
            workInProgress.type = resolvedType;
            {
              validateFunctionComponentInDev(workInProgress, type);
            }
            return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateExpirationTime, renderExpirationTime);
          }
          {
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) {
              // Inner memo component props aren't currently validated in createElement.
              // We could move it there, but we'd still need this for lazy code path.
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(type), getCurrentFiberStackInDev);
            }
          }
          var child = createFiberFromTypeAndProps(Component.type, null, nextProps, null, workInProgress.mode, renderExpirationTime);
          child.ref = workInProgress.ref;
          child.return = workInProgress;
          workInProgress.child = child;
          return child;
        }
        {
          var _type = Component.type;
          var _innerPropTypes = _type.propTypes;
          if (_innerPropTypes) {
            // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(_innerPropTypes, nextProps,
            // Resolved props
            'prop', getComponentName(_type), getCurrentFiberStackInDev);
          }
        }
        var currentChild = current.child; // This is always exactly one child

        if (updateExpirationTime < renderExpirationTime) {
          // This will be the props with resolved defaultProps,
          // unlike current.memoizedProps which will be the unresolved ones.
          var prevProps = currentChild.memoizedProps; // Default to shallow comparison

          var compare = Component.compare;
          compare = compare !== null ? compare : shallowEqual;
          if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
          }
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
      }
      function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        // TODO: current can be non-null here even if the component
        // hasn't yet mounted. This happens when the inner render suspends.
        // We'll need to figure out if this is fine or can cause issues.
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
              // We warn when you define propTypes on lazy()
              // so let's just skip over it to find memo() outer wrapper.
              // Inner props for memo are validated later.
              outerMemoType = refineResolvedLazyComponent(outerMemoType);
            }
            var outerPropTypes = outerMemoType && outerMemoType.propTypes;
            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, nextProps,
              // Resolved (SimpleMemoComponent has no defaultProps)
              'prop', getComponentName(outerMemoType), getCurrentFiberStackInDev);
            } // Inner propTypes will be validated in the function component path.
          }
        }

        if (current !== null) {
          var prevProps = current.memoizedProps;
          if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref &&
          // Prevent bailout if the implementation changed due to hot reload.
          workInProgress.type === current.type) {
            didReceiveUpdate = false;
            if (updateExpirationTime < renderExpirationTime) {
              // The pending update priority was cleared at the beginning of
              // beginWork. We're about to bail out, but there might be additional
              // updates at a lower priority. Usually, the priority level of the
              // remaining updates is accumlated during the evaluation of the
              // component (i.e. when processing the update queue). But since since
              // we're bailing out early *without* evaluating the component, we need
              // to account for it here, too. Reset to the value of the current fiber.
              // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
              // because a MemoComponent fiber does not have hooks or an update queue;
              // rather, it wraps around an inner component, which may or may not
              // contains hooks.
              // TODO: Move the reset at in beginWork out of the common path so that
              // this is no longer necessary.
              workInProgress.expirationTime = current.expirationTime;
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            }
          }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime);
      }
      function updateFragment(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateMode(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateProfiler(current, workInProgress, renderExpirationTime) {
        {
          workInProgress.effectTag |= Update;
        }
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
          // Schedule a Ref effect
          workInProgress.effectTag |= Ref;
        }
      }
      function updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        }
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
          if (workInProgress.mode & StrictMode) {
            // Only double-render components with Hooks
            if (workInProgress.memoizedState !== null) {
              nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
            }
          }
          setIsRendering(false);
        }
        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderExpirationTime);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateClassComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        } // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.

        var hasContext;
        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
          if (current !== null) {
            // A class component without an instance only mounts if it suspended
            // inside a non-concurrent tree, in an inconsistent state. We want to
            // treat it like a new mount, even though an empty version of it already
            // committed. Disconnect the alternate pointers.
            current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

            workInProgress.effectTag |= Placement;
          } // In the initial pass we might need to construct the instance.

          constructClassInstance(workInProgress, Component, nextProps);
          mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
          shouldUpdate = true;
        } else if (current === null) {
          // In a resume, we'll already have an instance we can reuse.
          shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        } else {
          shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderExpirationTime);
        }
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime);
        {
          var inst = workInProgress.stateNode;
          if (inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) {
              error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentName(workInProgress.type) || 'a component');
            }
            didWarnAboutReassigningProps = true;
          }
        }
        return nextUnitOfWork;
      }
      function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (!shouldUpdate && !didCaptureError) {
          // Context providers should defer to sCU for rendering
          if (hasContext) {
            invalidateContextProvider(workInProgress, Component, false);
          }
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var instance = workInProgress.stateNode; // Rerender

        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
          // If we captured an error, but getDerivedStateFromError is not defined,
          // unmount all the children. componentDidCatch will schedule an update to
          // re-render a fallback. This is temporary until we migrate everyone to
          // the new API.
          // TODO: Warn in a future release.
          nextChildren = null;
          {
            stopProfilerTimerIfRunning();
          }
        } else {
          {
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictMode) {
              instance.render();
            }
            setIsRendering(false);
          }
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        if (current !== null && didCaptureError) {
          // If we're recovering from an error, reconcile without reusing any of
          // the existing children. Conceptually, the normal children and the children
          // that are shown on error are two different sets, so we shouldn't reuse
          // normal children even if their identities match.
          forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        } // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.

        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.

        if (hasContext) {
          invalidateContextProvider(workInProgress, Component, true);
        }
        return workInProgress.child;
      }
      function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) {
          pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        } else if (root.context) {
          // Should always be set
          pushTopLevelContextObject(workInProgress, root.context, false);
        }
        pushHostContainer(workInProgress, root.containerInfo);
      }
      function updateHostRoot(current, workInProgress, renderExpirationTime) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) {
          {
            throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderExpirationTime);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".

        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
          // If the state is the same as before, that's a bailout because we had
          // no work that expires at this time.
          resetHydrationState();
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
          // If we don't have any current children this might be the first pass.
          // We always try to hydrate. If this isn't a hydration pass there won't
          // be any children to hydrate which is effectively the same thing as
          // not hydrating.
          var child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
          workInProgress.child = child;
          var node = child;
          while (node) {
            // Mark each child as hydrating. This is a fast path to know whether this
            // tree is part of a hydrating tree. This is used to determine if a child
            // node has fully mounted yet, and for scheduling event replaying.
            // Conceptually this is similar to Placement in that a new subtree is
            // inserted into the React tree here. It just happens to not need DOM
            // mutations because it already exists.
            node.effectTag = node.effectTag & ~Placement | Hydrating;
            node = node.sibling;
          }
        } else {
          // Otherwise reset hydration state in case we aborted and resumed another
          // root.
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
          resetHydrationState();
        }
        return workInProgress.child;
      }
      function updateHostComponent(current, workInProgress, renderExpirationTime) {
        pushHostContext(workInProgress);
        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        }
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) {
          // We special case a direct text child of a host node. This is a common
          // case. We won't handle it as a reified child. We will instead handle
          // this in the host environment that also has access to this prop. That
          // avoids allocating another HostText fiber and traversing it.
          nextChildren = null;
        } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
          // If we're switching from a direct text child to a normal child, or to
          // empty, we need to schedule the text content to be reset.
          workInProgress.effectTag |= ContentReset;
        }
        markRef(current, workInProgress); // Check the host config to see if the children are offscreen/hidden.

        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(type, nextProps)) {
          {
            markSpawnedWork(Never);
          } // Schedule this fiber to re-render at offscreen priority. Then bailout.

          workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
          return null;
        }
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateHostText(current, workInProgress) {
        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        } // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.

        return null;
      }
      function mountLazyComponent(_current, workInProgress, elementType, updateExpirationTime, renderExpirationTime) {
        if (_current !== null) {
          // A lazy component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps; // We can't start a User Timing measurement with correct label yet.
        // Cancel and resume right after we know the tag.

        cancelWorkTimer(workInProgress);
        var Component = readLazyComponentType(elementType); // Store the unwrapped component in the type.

        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        startWorkTimer(workInProgress);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch (resolvedTag) {
          case FunctionComponent:
            {
              {
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
              }
              child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case ClassComponent:
            {
              {
                workInProgress.type = Component = resolveClassForHotReloading(Component);
              }
              child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case ForwardRef:
            {
              {
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
              }
              child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case MemoComponent:
            {
              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = Component.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, resolvedProps,
                    // Resolved for outer only
                    'prop', getComponentName(Component), getCurrentFiberStackInDev);
                  }
                }
              }
              child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps),
              // The inner type can have defaults too
              updateExpirationTime, renderExpirationTime);
              return child;
            }
        }
        var hint = '';
        {
          if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
            hint = ' Did you wrap a component in React.lazy() more than once?';
          }
        } // This message intentionally doesn't mention ForwardRef or MemoComponent
        // because the fact that it's a separate type of work is an
        // implementation detail.

        {
          {
            throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
          }
        }
      }
      function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (_current !== null) {
          // An incomplete component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        } // Promote the fiber to a class and try rendering again.

        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.

        var hasContext;
        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
      }
      function mountIndeterminateComponent(_current, workInProgress, Component, renderExpirationTime) {
        if (_current !== null) {
          // An indeterminate component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var value;
        {
          if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
              error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }
          if (workInProgress.mode & StrictMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
          }
          setIsRendering(true);
          ReactCurrentOwner$1.current = workInProgress;
          value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
          setIsRendering(false);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
          {
            var _componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
              error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
              didWarnAboutModulePatternComponent[_componentName] = true;
            }
          } // Proceed under the assumption that this is a class instance

          workInProgress.tag = ClassComponent; // Throw out any hooks that were used.

          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
          // During mounting we don't know the child context yet as the instance doesn't exist.
          // We will invalidate the child context in finishClassComponent() right after rendering.

          var hasContext = false;
          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
          } else {
            hasContext = false;
          }
          workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
          initializeUpdateQueue(workInProgress);
          var getDerivedStateFromProps = Component.getDerivedStateFromProps;
          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
          }
          adoptClassInstance(workInProgress, value);
          mountClassInstance(workInProgress, Component, props, renderExpirationTime);
          return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
        } else {
          // Proceed under the assumption that this is a function component
          workInProgress.tag = FunctionComponent;
          {
            if (workInProgress.mode & StrictMode) {
              // Only double-render components with Hooks
              if (workInProgress.memoizedState !== null) {
                value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
              }
            }
          }
          reconcileChildren(null, workInProgress, value, renderExpirationTime);
          {
            validateFunctionComponentInDev(workInProgress, Component);
          }
          return workInProgress.child;
        }
      }
      function validateFunctionComponentInDev(workInProgress, Component) {
        {
          if (Component) {
            if (Component.childContextTypes) {
              error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
            }
          }
          if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) {
              info += '\n\nCheck the render method of `' + ownerName + '`.';
            }
            var warningKey = ownerName || workInProgress._debugID || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) {
              warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            }
            if (!didWarnAboutFunctionRefs[warningKey]) {
              didWarnAboutFunctionRefs[warningKey] = true;
              error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
            }
          }
          if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName2 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2]) {
              error('%s: Function components do not support getDerivedStateFromProps.', _componentName2);
              didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2] = true;
            }
          }
          if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName3 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName3]) {
              error('%s: Function components do not support contextType.', _componentName3);
              didWarnAboutContextTypeOnFunctionComponent[_componentName3] = true;
            }
          }
        }
      }
      var SUSPENDED_MARKER = {
        dehydrated: null,
        retryTime: NoWork
      };
      function shouldRemainOnFallback(suspenseContext, current, workInProgress) {
        // If the context is telling us that we should show a fallback, and we're not
        // already showing content, then we should show the fallback instead.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback) && (current === null || current.memoizedState !== null);
      }
      function updateSuspenseComponent(current, workInProgress, renderExpirationTime) {
        var mode = workInProgress.mode;
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.

        {
          if (shouldSuspend(workInProgress)) {
            workInProgress.effectTag |= DidCapture;
          }
        }
        var suspenseContext = suspenseStackCursor.current;
        var nextDidTimeout = false;
        var didSuspend = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
          // Something in this boundary's subtree already suspended. Switch to
          // rendering the fallback children.
          nextDidTimeout = true;
          workInProgress.effectTag &= ~DidCapture;
        } else {
          // Attempting the main content
          if (current === null || current.memoizedState !== null) {
            // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) {
              suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
          }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // This next part is a bit confusing. If the children timeout, we switch to
        // showing the fallback children in place of the "primary" children.
        // However, we don't want to delete the primary children because then their
        // state will be lost (both the React state and the host state, e.g.
        // uncontrolled form inputs). Instead we keep them mounted and hide them.
        // Both the fallback children AND the primary children are rendered at the
        // same time. Once the primary children are un-suspended, we can delete
        // the fallback children — don't need to preserve their state.
        //
        // The two sets of children are siblings in the host environment, but
        // semantically, for purposes of reconciliation, they are two separate sets.
        // So we store them using two fragment fibers.
        //
        // However, we want to avoid allocating extra fibers for every placeholder.
        // They're only necessary when the children time out, because that's the
        // only time when both sets are mounted.
        //
        // So, the extra fragment fibers are only used if the children time out.
        // Otherwise, we render the primary children directly. This requires some
        // custom reconciliation logic to preserve the state of the primary
        // children. It's essentially a very basic form of re-parenting.

        if (current === null) {
          // If we're currently hydrating, try to hydrate this boundary.
          // But only if this has a fallback.
          if (nextProps.fallback !== undefined) {
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
          } // This is the initial mount. This branch is pretty simple because there's
          // no previous state that needs to be preserved.

          if (nextDidTimeout) {
            // Mount separate fragments for primary and fallback children.
            var nextFallbackChildren = nextProps.fallback;
            var primaryChildFragment = createFiberFromFragment(null, mode, NoWork, null);
            primaryChildFragment.return = workInProgress;
            if ((workInProgress.mode & BlockingMode) === NoMode) {
              // Outside of blocking mode, we commit the effects from the
              // partially completed, timed-out tree, too.
              var progressedState = workInProgress.memoizedState;
              var progressedPrimaryChild = progressedState !== null ? workInProgress.child.child : workInProgress.child;
              primaryChildFragment.child = progressedPrimaryChild;
              var progressedChild = progressedPrimaryChild;
              while (progressedChild !== null) {
                progressedChild.return = primaryChildFragment;
                progressedChild = progressedChild.sibling;
              }
            }
            var fallbackChildFragment = createFiberFromFragment(nextFallbackChildren, mode, renderExpirationTime, null);
            fallbackChildFragment.return = workInProgress;
            primaryChildFragment.sibling = fallbackChildFragment; // Skip the primary children, and continue working on the
            // fallback children.

            workInProgress.memoizedState = SUSPENDED_MARKER;
            workInProgress.child = primaryChildFragment;
            return fallbackChildFragment;
          } else {
            // Mount the primary children without an intermediate fragment fiber.
            var nextPrimaryChildren = nextProps.children;
            workInProgress.memoizedState = null;
            return workInProgress.child = mountChildFibers(workInProgress, null, nextPrimaryChildren, renderExpirationTime);
          }
        } else {
          // This is an update. This branch is more complicated because we need to
          // ensure the state of the primary children is preserved.
          var prevState = current.memoizedState;
          if (prevState !== null) {
            // wrapped in a fragment fiber.

            var currentPrimaryChildFragment = current.child;
            var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
            if (nextDidTimeout) {
              // Still timed out. Reuse the current primary children by cloning
              // its fragment. We're going to skip over these entirely.
              var _nextFallbackChildren2 = nextProps.fallback;
              var _primaryChildFragment2 = createWorkInProgress(currentPrimaryChildFragment, currentPrimaryChildFragment.pendingProps);
              _primaryChildFragment2.return = workInProgress;
              if ((workInProgress.mode & BlockingMode) === NoMode) {
                // Outside of blocking mode, we commit the effects from the
                // partially completed, timed-out tree, too.
                var _progressedState = workInProgress.memoizedState;
                var _progressedPrimaryChild = _progressedState !== null ? workInProgress.child.child : workInProgress.child;
                if (_progressedPrimaryChild !== currentPrimaryChildFragment.child) {
                  _primaryChildFragment2.child = _progressedPrimaryChild;
                  var _progressedChild2 = _progressedPrimaryChild;
                  while (_progressedChild2 !== null) {
                    _progressedChild2.return = _primaryChildFragment2;
                    _progressedChild2 = _progressedChild2.sibling;
                  }
                }
              } // Because primaryChildFragment is a new fiber that we're inserting as the
              // parent of a new tree, we need to set its treeBaseDuration.

              if (workInProgress.mode & ProfileMode) {
                // treeBaseDuration is the sum of all the child tree base durations.
                var _treeBaseDuration = 0;
                var _hiddenChild = _primaryChildFragment2.child;
                while (_hiddenChild !== null) {
                  _treeBaseDuration += _hiddenChild.treeBaseDuration;
                  _hiddenChild = _hiddenChild.sibling;
                }
                _primaryChildFragment2.treeBaseDuration = _treeBaseDuration;
              } // Clone the fallback child fragment, too. These we'll continue
              // working on.

              var _fallbackChildFragment2 = createWorkInProgress(currentFallbackChildFragment, _nextFallbackChildren2);
              _fallbackChildFragment2.return = workInProgress;
              _primaryChildFragment2.sibling = _fallbackChildFragment2;
              _primaryChildFragment2.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
              // fallback children.

              workInProgress.memoizedState = SUSPENDED_MARKER;
              workInProgress.child = _primaryChildFragment2;
              return _fallbackChildFragment2;
            } else {
              // No longer suspended. Switch back to showing the primary children,
              // and remove the intermediate fragment fiber.
              var _nextPrimaryChildren = nextProps.children;
              var currentPrimaryChild = currentPrimaryChildFragment.child;
              var primaryChild = reconcileChildFibers(workInProgress, currentPrimaryChild, _nextPrimaryChildren, renderExpirationTime); // If this render doesn't suspend, we need to delete the fallback
              // children. Wait until the complete phase, after we've confirmed the
              // fallback is no longer needed.
              // TODO: Would it be better to store the fallback fragment on
              // the stateNode?
              // Continue rendering the children, like we normally do.

              workInProgress.memoizedState = null;
              return workInProgress.child = primaryChild;
            }
          } else {
            // The current tree has not already timed out. That means the primary
            // children are not wrapped in a fragment fiber.
            var _currentPrimaryChild = current.child;
            if (nextDidTimeout) {
              // Timed out. Wrap the children in a fragment fiber to keep them
              // separate from the fallback children.
              var _nextFallbackChildren3 = nextProps.fallback;
              var _primaryChildFragment3 = createFiberFromFragment(
              // It shouldn't matter what the pending props are because we aren't
              // going to render this fragment.
              null, mode, NoWork, null);
              _primaryChildFragment3.return = workInProgress;
              _primaryChildFragment3.child = _currentPrimaryChild;
              if (_currentPrimaryChild !== null) {
                _currentPrimaryChild.return = _primaryChildFragment3;
              } // Even though we're creating a new fiber, there are no new children,
              // because we're reusing an already mounted tree. So we don't need to
              // schedule a placement.
              // primaryChildFragment.effectTag |= Placement;

              if ((workInProgress.mode & BlockingMode) === NoMode) {
                // Outside of blocking mode, we commit the effects from the
                // partially completed, timed-out tree, too.
                var _progressedState2 = workInProgress.memoizedState;
                var _progressedPrimaryChild2 = _progressedState2 !== null ? workInProgress.child.child : workInProgress.child;
                _primaryChildFragment3.child = _progressedPrimaryChild2;
                var _progressedChild3 = _progressedPrimaryChild2;
                while (_progressedChild3 !== null) {
                  _progressedChild3.return = _primaryChildFragment3;
                  _progressedChild3 = _progressedChild3.sibling;
                }
              } // Because primaryChildFragment is a new fiber that we're inserting as the
              // parent of a new tree, we need to set its treeBaseDuration.

              if (workInProgress.mode & ProfileMode) {
                // treeBaseDuration is the sum of all the child tree base durations.
                var _treeBaseDuration2 = 0;
                var _hiddenChild2 = _primaryChildFragment3.child;
                while (_hiddenChild2 !== null) {
                  _treeBaseDuration2 += _hiddenChild2.treeBaseDuration;
                  _hiddenChild2 = _hiddenChild2.sibling;
                }
                _primaryChildFragment3.treeBaseDuration = _treeBaseDuration2;
              } // Create a fragment from the fallback children, too.

              var _fallbackChildFragment3 = createFiberFromFragment(_nextFallbackChildren3, mode, renderExpirationTime, null);
              _fallbackChildFragment3.return = workInProgress;
              _primaryChildFragment3.sibling = _fallbackChildFragment3;
              _fallbackChildFragment3.effectTag |= Placement;
              _primaryChildFragment3.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
              // fallback children.

              workInProgress.memoizedState = SUSPENDED_MARKER;
              workInProgress.child = _primaryChildFragment3;
              return _fallbackChildFragment3;
            } else {
              // Still haven't timed out. Continue rendering the children, like we
              // normally do.
              workInProgress.memoizedState = null;
              var _nextPrimaryChildren2 = nextProps.children;
              return workInProgress.child = reconcileChildFibers(workInProgress, _currentPrimaryChild, _nextPrimaryChildren2, renderExpirationTime);
            }
          }
        }
      }
      function scheduleWorkOnFiber(fiber, renderExpirationTime) {
        if (fiber.expirationTime < renderExpirationTime) {
          fiber.expirationTime = renderExpirationTime;
        }
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < renderExpirationTime) {
          alternate.expirationTime = renderExpirationTime;
        }
        scheduleWorkOnParentPath(fiber.return, renderExpirationTime);
      }
      function propagateSuspenseContextChange(workInProgress, firstChild, renderExpirationTime) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;
            if (state !== null) {
              scheduleWorkOnFiber(node, renderExpirationTime);
            }
          } else if (node.tag === SuspenseListComponent) {
            // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderExpirationTime);
          } else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === workInProgress) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === workInProgress) {
              return;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while (row !== null) {
          var currentRow = row.alternate; // New rows can't be content rows.

          if (currentRow !== null && findFirstSuspended(currentRow) === null) {
            lastContentRow = row;
          }
          row = row.sibling;
        }
        return lastContentRow;
      }
      function validateRevealOrder(revealOrder) {
        {
          if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') {
              switch (revealOrder.toLowerCase()) {
                case 'together':
                case 'forwards':
                case 'backwards':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                case 'forward':
                case 'backward':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                default:
                  error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
                  break;
              }
            } else {
              error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
            }
          }
        }
      }
      function validateTailOptions(tailMode, revealOrder) {
        {
          if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
              didWarnAboutTailOptions[tailMode] = true;
              error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
              didWarnAboutTailOptions[tailMode] = true;
              error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
            }
          }
        }
      }
      function validateSuspenseListNestedChild(childSlot, index) {
        {
          var isArray = Array.isArray(childSlot);
          var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';
          if (isArray || isIterable) {
            var type = isArray ? 'array' : 'iterable';
            error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);
            return false;
          }
        }
        return true;
      }
      function validateSuspenseListChildren(children, revealOrder) {
        {
          if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) {
              for (var i = 0; i < children.length; i++) {
                if (!validateSuspenseListNestedChild(children[i], i)) {
                  return;
                }
              }
            } else {
              var iteratorFn = getIteratorFn(children);
              if (typeof iteratorFn === 'function') {
                var childrenIterator = iteratorFn.call(children);
                if (childrenIterator) {
                  var step = childrenIterator.next();
                  var _i = 0;
                  for (; !step.done; step = childrenIterator.next()) {
                    if (!validateSuspenseListNestedChild(step.value, _i)) {
                      return;
                    }
                    _i++;
                  }
                }
              } else {
                error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
              }
            }
          }
        }
      }
      function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) {
          workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailExpiration: 0,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
          };
        } else {
          // We can reuse the existing object from previous renders.
          renderState.isBackwards = isBackwards;
          renderState.rendering = null;
          renderState.renderingStartTime = 0;
          renderState.last = lastContentRow;
          renderState.tail = tail;
          renderState.tailExpiration = 0;
          renderState.tailMode = tailMode;
          renderState.lastEffect = lastEffectBeforeRendering;
        }
      } // This can end up rendering this component multiple passes.
      // The first pass splits the children fibers into two sets. A head and tail.
      // We first render the head. If anything is in fallback state, we do another
      // pass through beginWork to rerender all children (including the tail) with
      // the force suspend context. If the first render didn't have anything in
      // in fallback state. Then we render each row in the tail one-by-one.
      // That happens in the completeWork phase without going back to beginWork.

      function updateSuspenseListComponent(current, workInProgress, renderExpirationTime) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
          suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          workInProgress.effectTag |= DidCapture;
        } else {
          var didSuspendBefore = current !== null && (current.effectTag & DidCapture) !== NoEffect;
          if (didSuspendBefore) {
            // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderExpirationTime);
          }
          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) {
          // Outside of blocking mode, SuspenseList doesn't work so we just
          // use make it a noop by treating it as the default revealOrder.
          workInProgress.memoizedState = null;
        } else {
          switch (revealOrder) {
            case 'forwards':
              {
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                  // The whole list is part of the tail.
                  // TODO: We could fast path by just rendering the tail now.
                  tail = workInProgress.child;
                  workInProgress.child = null;
                } else {
                  // Disconnect the tail rows after the content row.
                  // We're going to render them separately later.
                  tail = lastContentRow.sibling;
                  lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false,
                // isBackwards
                tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
              }
            case 'backwards':
              {
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while (row !== null) {
                  var currentRow = row.alternate; // New rows can't be content rows.

                  if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    // This is the beginning of the main content.
                    workInProgress.child = row;
                    break;
                  }
                  var nextRow = row.sibling;
                  row.sibling = _tail;
                  _tail = row;
                  row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.

                initSuspenseListRenderState(workInProgress, true,
                // isBackwards
                _tail, null,
                // last
                tailMode, workInProgress.lastEffect);
                break;
              }
            case 'together':
              {
                initSuspenseListRenderState(workInProgress, false,
                // isBackwards
                null,
                // tail
                null,
                // last
                undefined, workInProgress.lastEffect);
                break;
              }
            default:
              {
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
              }
          }
        }
        return workInProgress.child;
      }
      function updatePortalComponent(current, workInProgress, renderExpirationTime) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) {
          // Portals are special because we don't append the children during mount
          // but at commit. Therefore we need to track insertions which the normal
          // flow doesn't do during mount. This doesn't happen at the root because
          // the root always starts with a "current" with a null child.
          // TODO: Consider unifying this with how the root works.
          workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        }
        return workInProgress.child;
      }
      function updateContextProvider(current, workInProgress, renderExpirationTime) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        {
          var providerPropTypes = workInProgress.type.propTypes;
          if (providerPropTypes) {
            checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider', getCurrentFiberStackInDev);
          }
        }
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
          var oldValue = oldProps.value;
          var changedBits = calculateChangedBits(context, newValue, oldValue);
          if (changedBits === 0) {
            // No change. Bailout early if children are the same.
            if (oldProps.children === newProps.children && !hasContextChanged()) {
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            }
          } else {
            // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
          }
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
      }
      var hasWarnedAboutUsingContextAsConsumer = false;
      function updateContextConsumer(current, workInProgress, renderExpirationTime) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        // DEV mode, we create a separate object for Context.Consumer that acts
        // like a proxy to Context. This proxy object adds unnecessary code in PROD
        // so we use the old behaviour (Context.Consumer references Context) to
        // reduce size and overhead. The separate object references context via
        // a property called "_context", which also gives us the ability to check
        // in DEV mode if this property exists or not and warn if it does not.

        {
          if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
              }
            }
          } else {
            context = context._context;
          }
        }
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        {
          if (typeof render !== 'function') {
            error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
          }
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var newValue = _readContext2(context, newProps.unstable_observedBits);
        var newChildren;
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          newChildren = render(newValue);
          setIsRendering(false);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
      }
      function bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime) {
        cancelWorkTimer(workInProgress);
        if (current !== null) {
          // Reuse previous dependencies
          workInProgress.dependencies = current.dependencies;
        }
        {
          // Don't update "base" render times for bailouts.
          stopProfilerTimerIfRunning();
        }
        var updateExpirationTime = workInProgress.expirationTime;
        if (updateExpirationTime !== NoWork) {
          markUnprocessedUpdateTime(updateExpirationTime);
        } // Check if the children have any pending work.

        var childExpirationTime = workInProgress.childExpirationTime;
        if (childExpirationTime < renderExpirationTime) {
          // The children don't have any work either. We can skip them.
          // TODO: Once we add back resuming, we should check if the children are
          // a work-in-progress set. If so, we need to transfer their effects.
          return null;
        } else {
          // This fiber doesn't have work, but its subtree does. Clone the child
          // fibers and continue.
          cloneChildFibers(current, workInProgress);
          return workInProgress.child;
        }
      }
      function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        {
          var returnFiber = oldWorkInProgress.return;
          if (returnFiber === null) {
            throw new Error('Cannot swap the root fiber.');
          } // Disconnect from the old current.
          // It will get deleted.

          current.alternate = null;
          oldWorkInProgress.alternate = null; // Connect to the new tree.

          newWorkInProgress.index = oldWorkInProgress.index;
          newWorkInProgress.sibling = oldWorkInProgress.sibling;
          newWorkInProgress.return = oldWorkInProgress.return;
          newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.

          if (oldWorkInProgress === returnFiber.child) {
            returnFiber.child = newWorkInProgress;
          } else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) {
              throw new Error('Expected parent to have a child.');
            }
            while (prevSibling.sibling !== oldWorkInProgress) {
              prevSibling = prevSibling.sibling;
              if (prevSibling === null) {
                throw new Error('Expected to find the previous sibling.');
              }
            }
            prevSibling.sibling = newWorkInProgress;
          } // Delete the old fiber and place the new one.
          // Since the old fiber is disconnected, we have to schedule it manually.

          var last = returnFiber.lastEffect;
          if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = current;
          }
          current.nextEffect = null;
          current.effectTag = Deletion;
          newWorkInProgress.effectTag |= Placement; // Restart work from the new fiber.

          return newWorkInProgress;
        }
      }
      function beginWork(current, workInProgress, renderExpirationTime) {
        var updateExpirationTime = workInProgress.expirationTime;
        {
          if (workInProgress._debugNeedsRemount && current !== null) {
            // This will restart the begin phase with a new fiber.
            return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.expirationTime));
          }
        }
        if (current !== null) {
          var oldProps = current.memoizedProps;
          var newProps = workInProgress.pendingProps;
          if (oldProps !== newProps || hasContextChanged() ||
          // Force a re-render if the implementation changed due to hot reload:
          workInProgress.type !== current.type) {
            // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
          } else if (updateExpirationTime < renderExpirationTime) {
            didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
            // the begin phase. There's still some bookkeeping we that needs to be done
            // in this optimized path, mostly pushing stuff onto the stack.

            switch (workInProgress.tag) {
              case HostRoot:
                pushHostRootContext(workInProgress);
                resetHydrationState();
                break;
              case HostComponent:
                pushHostContext(workInProgress);
                if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(workInProgress.type, newProps)) {
                  {
                    markSpawnedWork(Never);
                  } // Schedule this fiber to re-render at offscreen priority. Then bailout.

                  workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
                  return null;
                }
                break;
              case ClassComponent:
                {
                  var Component = workInProgress.type;
                  if (isContextProvider(Component)) {
                    pushContextProvider(workInProgress);
                  }
                  break;
                }
              case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
              case ContextProvider:
                {
                  var newValue = workInProgress.memoizedProps.value;
                  pushProvider(workInProgress, newValue);
                  break;
                }
              case Profiler:
                {
                  // Profiler should only call onRender when one of its descendants actually rendered.
                  var hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                  if (hasChildWork) {
                    workInProgress.effectTag |= Update;
                  }
                }
                break;
              case SuspenseComponent:
                {
                  var state = workInProgress.memoizedState;
                  if (state !== null) {
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.

                    var primaryChildFragment = workInProgress.child;
                    var primaryChildExpirationTime = primaryChildFragment.childExpirationTime;
                    if (primaryChildExpirationTime !== NoWork && primaryChildExpirationTime >= renderExpirationTime) {
                      // The primary children have pending work. Use the normal path
                      // to attempt to render the primary children again.
                      return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
                    } else {
                      pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                      // priority. Bailout.

                      var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
                      if (child !== null) {
                        // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                      } else {
                        return null;
                      }
                    }
                  } else {
                    pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  }
                  break;
                }
              case SuspenseListComponent:
                {
                  var didSuspendBefore = (current.effectTag & DidCapture) !== NoEffect;
                  var _hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                  if (didSuspendBefore) {
                    if (_hasChildWork) {
                      // If something was in fallback state last time, and we have all the
                      // same children then we're still in progressive loading state.
                      // Something might get unblocked by state updates or retries in the
                      // tree which will affect the tail. So we need to use the normal
                      // path to compute the correct tail.
                      return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
                    } // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.

                    workInProgress.effectTag |= DidCapture;
                  } // If nothing suspended before and we're rendering the same children,
                  // then the tail doesn't matter. Anything new that suspends will work
                  // in the "together" mode, so we can continue from the state we had.

                  var renderState = workInProgress.memoizedState;
                  if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                  }
                  pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                  if (_hasChildWork) {
                    break;
                  } else {
                    // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    return null;
                  }
                }
            }
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
          } else {
            // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
          }
        } else {
          didReceiveUpdate = false;
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.

        workInProgress.expirationTime = NoWork;
        switch (workInProgress.tag) {
          case IndeterminateComponent:
            {
              return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderExpirationTime);
            }
          case LazyComponent:
            {
              var elementType = workInProgress.elementType;
              return mountLazyComponent(current, workInProgress, elementType, updateExpirationTime, renderExpirationTime);
            }
          case FunctionComponent:
            {
              var _Component = workInProgress.type;
              var unresolvedProps = workInProgress.pendingProps;
              var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
              return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderExpirationTime);
            }
          case ClassComponent:
            {
              var _Component2 = workInProgress.type;
              var _unresolvedProps = workInProgress.pendingProps;
              var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
              return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderExpirationTime);
            }
          case HostRoot:
            return updateHostRoot(current, workInProgress, renderExpirationTime);
          case HostComponent:
            return updateHostComponent(current, workInProgress, renderExpirationTime);
          case HostText:
            return updateHostText(current, workInProgress);
          case SuspenseComponent:
            return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
          case HostPortal:
            return updatePortalComponent(current, workInProgress, renderExpirationTime);
          case ForwardRef:
            {
              var type = workInProgress.type;
              var _unresolvedProps2 = workInProgress.pendingProps;
              var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
              return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderExpirationTime);
            }
          case Fragment$$1:
            return updateFragment(current, workInProgress, renderExpirationTime);
          case Mode:
            return updateMode(current, workInProgress, renderExpirationTime);
          case Profiler:
            return updateProfiler(current, workInProgress, renderExpirationTime);
          case ContextProvider:
            return updateContextProvider(current, workInProgress, renderExpirationTime);
          case ContextConsumer:
            return updateContextConsumer(current, workInProgress, renderExpirationTime);
          case MemoComponent:
            {
              var _type2 = workInProgress.type;
              var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.

              var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = _type2.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, _resolvedProps3,
                    // Resolved for outer only
                    'prop', getComponentName(_type2), getCurrentFiberStackInDev);
                  }
                }
              }
              _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
              return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateExpirationTime, renderExpirationTime);
            }
          case SimpleMemoComponent:
            {
              return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateExpirationTime, renderExpirationTime);
            }
          case IncompleteClassComponent:
            {
              var _Component3 = workInProgress.type;
              var _unresolvedProps4 = workInProgress.pendingProps;
              var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
              return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderExpirationTime);
            }
          case SuspenseListComponent:
            {
              return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
            }
        }
        {
          {
            throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.effectTag |= Update;
      }
      function markRef$1(workInProgress) {
        workInProgress.effectTag |= Ref;
      }
      var appendAllChildren;
      var updateHostContainer;
      var updateHostComponent$1;
      var updateHostText$1;
      {
        // Mutation mode
        appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
          // We only have the top Fiber that was created but we need recurse down its
          // children to find all the terminal nodes.
          var node = workInProgress.child;
          while (node !== null) {
            if (node.tag === HostComponent || node.tag === HostText) {
              appendInitialChild(parent, node.stateNode);
            } else if (node.tag === HostPortal) ;else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === workInProgress) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        };
        updateHostContainer = function updateHostContainer(workInProgress) {// Noop
        };
        updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance) {
          // If we have an alternate, that means this is an update and we need to
          // schedule a side-effect to do the updates.
          var oldProps = current.memoizedProps;
          if (oldProps === newProps) {
            // In mutation mode, this is sufficient for a bailout because
            // we won't touch this node even if children changed.
            return;
          } // If we get updated because one of our children updated, we don't
          // have newProps so we'll have to reuse them.
          // TODO: Split the update API as separate for the props vs. children.
          // Even better would be if children weren't special cased at all tho.

          var instance = workInProgress.stateNode;
          var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
          // component is hitting the resume path. Figure out why. Possibly
          // related to `hidden`.

          var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.

          workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
          // is a new ref we mark this as an update. All the work is done in commitWork.

          if (updatePayload) {
            markUpdate(workInProgress);
          }
        };
        updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
          // If the text differs, mark it as an update. All the work in done in commitWork.
          if (oldText !== newText) {
            markUpdate(workInProgress);
          }
        };
      }
      function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        switch (renderState.tailMode) {
          case 'hidden':
            {
              // Any insertions at the end of the tail list after this point
              // should be invisible. If there are already mounted boundaries
              // anything before them are not considered for collapsing.
              // Therefore we need to go through the whole tail to find if
              // there are any.
              var tailNode = renderState.tail;
              var lastTailNode = null;
              while (tailNode !== null) {
                if (tailNode.alternate !== null) {
                  lastTailNode = tailNode;
                }
                tailNode = tailNode.sibling;
              } // Next we're simply going to delete all insertions after the
              // last rendered item.

              if (lastTailNode === null) {
                // All remaining items in the tail are insertions.
                renderState.tail = null;
              } else {
                // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
              }
              break;
            }
          case 'collapsed':
            {
              // Any insertions at the end of the tail list after this point
              // should be invisible. If there are already mounted boundaries
              // anything before them are not considered for collapsing.
              // Therefore we need to go through the whole tail to find if
              // there are any.
              var _tailNode = renderState.tail;
              var _lastTailNode = null;
              while (_tailNode !== null) {
                if (_tailNode.alternate !== null) {
                  _lastTailNode = _tailNode;
                }
                _tailNode = _tailNode.sibling;
              } // Next we're simply going to delete all insertions after the
              // last rendered item.

              if (_lastTailNode === null) {
                // All remaining items in the tail are insertions.
                if (!hasRenderedATailFallback && renderState.tail !== null) {
                  // We suspended during the head. We want to show at least one
                  // row at the tail. So we'll keep on and cut off the rest.
                  renderState.tail.sibling = null;
                } else {
                  renderState.tail = null;
                }
              } else {
                // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
              }
              break;
            }
        }
      }
      function completeWork(current, workInProgress, renderExpirationTime) {
        var newProps = workInProgress.pendingProps;
        switch (workInProgress.tag) {
          case IndeterminateComponent:
          case LazyComponent:
          case SimpleMemoComponent:
          case FunctionComponent:
          case ForwardRef:
          case Fragment$$1:
          case Mode:
          case Profiler:
          case ContextConsumer:
          case MemoComponent:
            return null;
          case ClassComponent:
            {
              var Component = workInProgress.type;
              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }
              return null;
            }
          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              var fiberRoot = workInProgress.stateNode;
              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }
              if (current === null || current.child === null) {
                // If we hydrated, pop so that we can delete any remaining children
                // that weren't hydrated.
                var wasHydrated = popHydrationState(workInProgress);
                if (wasHydrated) {
                  // If we hydrated, then we'll need to schedule an update for
                  // the commit side-effects on the root.
                  markUpdate(workInProgress);
                }
              }
              updateHostContainer(workInProgress);
              return null;
            }
          case HostComponent:
            {
              popHostContext(workInProgress);
              var rootContainerInstance = getRootHostContainer();
              var type = workInProgress.type;
              if (current !== null && workInProgress.stateNode != null) {
                updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                if (current.ref !== workInProgress.ref) {
                  markRef$1(workInProgress);
                }
              } else {
                if (!newProps) {
                  if (!(workInProgress.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  } // This can happen when we abort work.

                  return null;
                }
                var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                // "stack" as the parent. Then append children as we go in beginWork
                // or completeWork depending on whether we want to add them top->down or
                // bottom->up. Top->down is faster in IE11.

                var _wasHydrated = popHydrationState(workInProgress);
                if (_wasHydrated) {
                  // TODO: Move this and createInstance step into the beginPhase
                  // to consolidate.
                  if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
                    // If changes to the hydrated node need to be applied at the
                    // commit-phase we mark this as such.
                    markUpdate(workInProgress);
                  }
                } else {
                  var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                  appendAllChildren(instance, workInProgress, false, false); // This needs to be set before we mount Flare event listeners

                  workInProgress.stateNode = instance;
                  // (eg DOM renderer supports auto-focus for certain elements).
                  // Make sure such renderers get scheduled for later work.

                  if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
                    markUpdate(workInProgress);
                  }
                }
                if (workInProgress.ref !== null) {
                  // If there is a ref on a host node we need to schedule a callback
                  markRef$1(workInProgress);
                }
              }
              return null;
            }
          case HostText:
            {
              var newText = newProps;
              if (current && workInProgress.stateNode != null) {
                var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                // to schedule a side-effect to do the updates.

                updateHostText$1(current, workInProgress, oldText, newText);
              } else {
                if (typeof newText !== 'string') {
                  if (!(workInProgress.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  } // This can happen when we abort work.
                }

                var _rootContainerInstance = getRootHostContainer();
                var _currentHostContext = getHostContext();
                var _wasHydrated2 = popHydrationState(workInProgress);
                if (_wasHydrated2) {
                  if (prepareToHydrateHostTextInstance(workInProgress)) {
                    markUpdate(workInProgress);
                  }
                } else {
                  workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
              }
              return null;
            }
          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var nextState = workInProgress.memoizedState;
              if ((workInProgress.effectTag & DidCapture) !== NoEffect) {
                // Something suspended. Re-render with the fallback children.
                workInProgress.expirationTime = renderExpirationTime; // Do not reset the effect list.

                return workInProgress;
              }
              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = false;
              if (current === null) {
                if (workInProgress.memoizedProps.fallback !== undefined) {
                  popHydrationState(workInProgress);
                }
              } else {
                var prevState = current.memoizedState;
                prevDidTimeout = prevState !== null;
                if (!nextDidTimeout && prevState !== null) {
                  // We just switched from the fallback to the normal children.
                  // Delete the fallback.
                  // TODO: Would it be better to store the fallback fragment on
                  // the stateNode during the begin phase?
                  var currentFallbackChild = current.child.sibling;
                  if (currentFallbackChild !== null) {
                    // Deletions go at the beginning of the return fiber's effect list
                    var first = workInProgress.firstEffect;
                    if (first !== null) {
                      workInProgress.firstEffect = currentFallbackChild;
                      currentFallbackChild.nextEffect = first;
                    } else {
                      workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChild;
                      currentFallbackChild.nextEffect = null;
                    }
                    currentFallbackChild.effectTag = Deletion;
                  }
                }
              }
              if (nextDidTimeout && !prevDidTimeout) {
                // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                if ((workInProgress.mode & BlockingMode) !== NoMode) {
                  // TODO: Move this back to throwException because this is too late
                  // if this is a large tree which is common for initial loads. We
                  // don't know if we should restart a render or not until we get
                  // this marker, and this is too late.
                  // If this render already had a ping or lower pri updates,
                  // and this is the first time we know we're going to suspend we
                  // should be able to immediately restart from within throwException.
                  var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                  if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                    // If this was in an invisible tree or a new render, then showing
                    // this boundary is ok.
                    renderDidSuspend();
                  } else {
                    // Otherwise, we're going to have to hide content so we should
                    // suspend for longer if possible.
                    renderDidSuspendDelayIfPossible();
                  }
                }
              }
              {
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) {
                  // If this boundary just timed out, schedule an effect to attach a
                  // retry listener to the promise. This flag is also used to hide the
                  // primary children. In mutation mode, we also need the flag to
                  // *unhide* children that were previously hidden, so check if this
                  // is currently timed out, too.
                  workInProgress.effectTag |= Update;
                }
              }
              return null;
            }
          case HostPortal:
            popHostContainer(workInProgress);
            updateHostContainer(workInProgress);
            return null;
          case ContextProvider:
            // Pop provider fiber
            popProvider(workInProgress);
            return null;
          case IncompleteClassComponent:
            {
              // Same as class component case. I put it down here so that the tags are
              // sequential to ensure this switch is compiled to a jump table.
              var _Component = workInProgress.type;
              if (isContextProvider(_Component)) {
                popContext(workInProgress);
              }
              return null;
            }
          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress);
              var renderState = workInProgress.memoizedState;
              if (renderState === null) {
                // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
              }
              var didSuspendAlready = (workInProgress.effectTag & DidCapture) !== NoEffect;
              var renderedTail = renderState.rendering;
              if (renderedTail === null) {
                // We just rendered the head.
                if (!didSuspendAlready) {
                  // This is the first pass. We need to figure out if anything is still
                  // suspended in the rendered set.
                  // If new content unsuspended, but there's still some content that
                  // didn't. Then we need to do a second pass that forces everything
                  // to keep showing their fallbacks.
                  // We might be suspended if something in this render pass suspended, or
                  // something in the previous committed pass suspended. Otherwise,
                  // there's no chance so we can skip the expensive call to
                  // findFirstSuspended.
                  var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.effectTag & DidCapture) === NoEffect);
                  if (!cannotBeSuspended) {
                    var row = workInProgress.child;
                    while (row !== null) {
                      var suspended = findFirstSuspended(row);
                      if (suspended !== null) {
                        didSuspendAlready = true;
                        workInProgress.effectTag |= DidCapture;
                        cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                        // part of the second pass. In that case nothing will subscribe to
                        // its thennables. Instead, we'll transfer its thennables to the
                        // SuspenseList so that it can retry if they resolve.
                        // There might be multiple of these in the list but since we're
                        // going to wait for all of them anyway, it doesn't really matter
                        // which ones gets to ping. In theory we could get clever and keep
                        // track of how many dependencies remain but it gets tricky because
                        // in the meantime, we can add/remove/change items and dependencies.
                        // We might bail out of the loop before finding any but that
                        // doesn't matter since that means that the other boundaries that
                        // we did find already has their listeners attached.

                        var newThennables = suspended.updateQueue;
                        if (newThennables !== null) {
                          workInProgress.updateQueue = newThennables;
                          workInProgress.effectTag |= Update;
                        } // Rerender the whole list, but this time, we'll force fallbacks
                        // to stay in place.
                        // Reset the effect list before doing the second pass since that's now invalid.

                        if (renderState.lastEffect === null) {
                          workInProgress.firstEffect = null;
                        }
                        workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.

                        resetChildFibers(workInProgress, renderExpirationTime); // Set up the Suspense Context to force suspense and immediately
                        // rerender the children.

                        pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                        return workInProgress.child;
                      }
                      row = row.sibling;
                    }
                  }
                } else {
                  cutOffTailIfNeeded(renderState, false);
                } // Next we're going to render the tail.
              } else {
                // Append the rendered row to the child list.
                if (!didSuspendAlready) {
                  var _suspended = findFirstSuspended(renderedTail);
                  if (_suspended !== null) {
                    workInProgress.effectTag |= DidCapture;
                    didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                    // get lost if this row ends up dropped during a second pass.

                    var _newThennables = _suspended.updateQueue;
                    if (_newThennables !== null) {
                      workInProgress.updateQueue = _newThennables;
                      workInProgress.effectTag |= Update;
                    }
                    cutOffTailIfNeeded(renderState, true); // This might have been modified.

                    if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate) {
                      // We need to delete the row we just rendered.
                      // Reset the effect list to what it was before we rendered this
                      // child. The nested children have already appended themselves.
                      var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.

                      if (lastEffect !== null) {
                        lastEffect.nextEffect = null;
                      } // We're done.

                      return null;
                    }
                  } else if (
                  // The time it took to render last row is greater than time until
                  // the expiration.
                  now() * 2 - renderState.renderingStartTime > renderState.tailExpiration && renderExpirationTime > Never) {
                    // We have now passed our CPU deadline and we'll just give up further
                    // attempts to render the main content and only render fallbacks.
                    // The assumption is that this is usually faster.
                    workInProgress.effectTag |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                    // to get it started back up to attempt the next item. If we can show
                    // them, then they really have the same priority as this render.
                    // So we'll pick it back up the very next render pass once we've had
                    // an opportunity to yield for paint.

                    var nextPriority = renderExpirationTime - 1;
                    workInProgress.expirationTime = workInProgress.childExpirationTime = nextPriority;
                    {
                      markSpawnedWork(nextPriority);
                    }
                  }
                }
                if (renderState.isBackwards) {
                  // The effect list of the backwards tail will have been added
                  // to the end. This breaks the guarantee that life-cycles fire in
                  // sibling order but that isn't a strong guarantee promised by React.
                  // Especially since these might also just pop in during future commits.
                  // Append to the beginning of the list.
                  renderedTail.sibling = workInProgress.child;
                  workInProgress.child = renderedTail;
                } else {
                  var previousSibling = renderState.last;
                  if (previousSibling !== null) {
                    previousSibling.sibling = renderedTail;
                  } else {
                    workInProgress.child = renderedTail;
                  }
                  renderState.last = renderedTail;
                }
              }
              if (renderState.tail !== null) {
                // We still have tail rows to render.
                if (renderState.tailExpiration === 0) {
                  // Heuristic for how long we're willing to spend rendering rows
                  // until we just give up and show what we have so far.
                  var TAIL_EXPIRATION_TIMEOUT_MS = 500;
                  renderState.tailExpiration = now() + TAIL_EXPIRATION_TIMEOUT_MS; // TODO: This is meant to mimic the train model or JND but this
                  // is a per component value. It should really be since the start
                  // of the total render or last commit. Consider using something like
                  // globalMostRecentFallbackTime. That doesn't account for being
                  // suspended for part of the time or when it's a new render.
                  // It should probably use a global start time value instead.
                } // Pop a row.

                var next = renderState.tail;
                renderState.rendering = next;
                renderState.tail = next.sibling;
                renderState.lastEffect = workInProgress.lastEffect;
                renderState.renderingStartTime = now();
                next.sibling = null; // Restore the context.
                // TODO: We can probably just avoid popping it instead and only
                // setting it the first time we go from not suspended to suspended.

                var suspenseContext = suspenseStackCursor.current;
                if (didSuspendAlready) {
                  suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                } else {
                  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                }
                pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.

                return next;
              }
              return null;
            }
        }
        {
          {
            throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function unwindWork(workInProgress, renderExpirationTime) {
        switch (workInProgress.tag) {
          case ClassComponent:
            {
              var Component = workInProgress.type;
              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }
              var effectTag = workInProgress.effectTag;
              if (effectTag & ShouldCapture) {
                workInProgress.effectTag = effectTag & ~ShouldCapture | DidCapture;
                return workInProgress;
              }
              return null;
            }
          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              var _effectTag = workInProgress.effectTag;
              if (!((_effectTag & DidCapture) === NoEffect)) {
                {
                  throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                }
              }
              workInProgress.effectTag = _effectTag & ~ShouldCapture | DidCapture;
              return workInProgress;
            }
          case HostComponent:
            {
              // TODO: popHydrationState
              popHostContext(workInProgress);
              return null;
            }
          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var _effectTag2 = workInProgress.effectTag;
              if (_effectTag2 & ShouldCapture) {
                workInProgress.effectTag = _effectTag2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.

                return workInProgress;
              }
              return null;
            }
          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
              // caught by a nested boundary. If not, it should bubble through.

              return null;
            }
          case HostPortal:
            popHostContainer(workInProgress);
            return null;
          case ContextProvider:
            popProvider(workInProgress);
            return null;
          default:
            return null;
        }
      }
      function unwindInterruptedWork(interruptedWork) {
        switch (interruptedWork.tag) {
          case ClassComponent:
            {
              var childContextTypes = interruptedWork.type.childContextTypes;
              if (childContextTypes !== null && childContextTypes !== undefined) {
                popContext(interruptedWork);
              }
              break;
            }
          case HostRoot:
            {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              break;
            }
          case HostComponent:
            {
              popHostContext(interruptedWork);
              break;
            }
          case HostPortal:
            popHostContainer(interruptedWork);
            break;
          case SuspenseComponent:
            popSuspenseContext(interruptedWork);
            break;
          case SuspenseListComponent:
            popSuspenseContext(interruptedWork);
            break;
          case ContextProvider:
            popProvider(interruptedWork);
            break;
        }
      }
      function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
          value: value,
          source: source,
          stack: getStackByFiberInDevAndProd(source)
        };
      }
      function logCapturedError(capturedError) {
        var error = capturedError.error;
        {
          var componentName = capturedError.componentName,
            componentStack = capturedError.componentStack,
            errorBoundaryName = capturedError.errorBoundaryName,
            errorBoundaryFound = capturedError.errorBoundaryFound,
            willRetry = capturedError.willRetry; // Browsers support silencing uncaught errors by calling
          // `preventDefault()` in window `error` handler.
          // We record this information as an expando on the error.

          if (error != null && error._suppressLogging) {
            if (errorBoundaryFound && willRetry) {
              // The error is recoverable and was silenced.
              // Ignore it and don't print the stack addendum.
              // This is handy for testing error boundaries without noise.
              return;
            } // The error is fatal. Since the silencing might have
            // been accidental, we'll surface it anyway.
            // However, the browser would have silenced the original error
            // so we'll print it first, and then print the stack addendum.

            console['error'](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
          }

          var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
          var errorBoundaryMessage; // errorBoundaryFound check is sufficient; errorBoundaryName check is to satisfy Flow.

          if (errorBoundaryFound && errorBoundaryName) {
            if (willRetry) {
              errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            } else {
              errorBoundaryMessage = "This error was initially handled by the error boundary " + errorBoundaryName + ".\n" + "Recreating the tree from scratch failed so React will unmount the tree.";
            }
          } else {
            errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://fb.me/react-error-boundaries to learn more about error boundaries.';
          }
          var combinedMessage = "" + componentNameMessage + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
          // We don't include the original error message and JS stack because the browser
          // has already printed it. Even if the application swallows the error, it is still
          // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

          console['error'](combinedMessage); // Don't transform to our wrapper
        }
      }

      var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
      {
        didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
      }
      var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
      function logError(boundary, errorInfo) {
        var source = errorInfo.source;
        var stack = errorInfo.stack;
        if (stack === null && source !== null) {
          stack = getStackByFiberInDevAndProd(source);
        }
        var capturedError = {
          componentName: source !== null ? getComponentName(source.type) : null,
          componentStack: stack !== null ? stack : '',
          error: errorInfo.value,
          errorBoundary: null,
          errorBoundaryName: null,
          errorBoundaryFound: false,
          willRetry: false
        };
        if (boundary !== null && boundary.tag === ClassComponent) {
          capturedError.errorBoundary = boundary.stateNode;
          capturedError.errorBoundaryName = getComponentName(boundary.type);
          capturedError.errorBoundaryFound = true;
          capturedError.willRetry = true;
        }
        try {
          logCapturedError(capturedError);
        } catch (e) {
          // This method must not throw, or React internal state will get messed up.
          // If console.error is overridden, or logCapturedError() shows a dialog that throws,
          // we want to report this error outside of the normal stack as a last resort.
          // https://github.com/facebook/react/issues/13188
          setTimeout(function () {
            throw e;
          });
        }
      }
      var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current, instance) {
        startPhaseTimer(current, 'componentWillUnmount');
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
        stopPhaseTimer();
      }; // Capture errors so they don't interrupt unmounting.

      function safelyCallComponentWillUnmount(current, instance) {
        {
          invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
          if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
          }
        }
      }
      function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
          if (typeof ref === 'function') {
            {
              invokeGuardedCallback(null, ref, null, null);
              if (hasCaughtError()) {
                var refError = clearCaughtError();
                captureCommitPhaseError(current, refError);
              }
            }
          } else {
            ref.current = null;
          }
        }
      }
      function safelyCallDestroy(current, destroy) {
        {
          invokeGuardedCallback(null, destroy, null);
          if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
          }
        }
      }
      function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
          case Block:
            {
              return;
            }
          case ClassComponent:
            {
              if (finishedWork.effectTag & Snapshot) {
                if (current !== null) {
                  var prevProps = current.memoizedProps;
                  var prevState = current.memoizedState;
                  startPhaseTimer(finishedWork, 'getSnapshotBeforeUpdate');
                  var instance = finishedWork.stateNode; // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                    if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                  stopPhaseTimer();
                }
              }
              return;
            }
          case HostRoot:
          case HostComponent:
          case HostText:
          case HostPortal:
          case IncompleteClassComponent:
            // Nothing to do for these component types
            return;
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;
          do {
            if ((effect.tag & tag) === tag) {
              // Unmount
              var destroy = effect.destroy;
              effect.destroy = undefined;
              if (destroy !== undefined) {
                destroy();
              }
            }
            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }
      function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;
          do {
            if ((effect.tag & tag) === tag) {
              // Mount
              var create = effect.create;
              effect.destroy = create();
              {
                var destroy = effect.destroy;
                if (destroy !== undefined && typeof destroy !== 'function') {
                  var addendum = void 0;
                  if (destroy === null) {
                    addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
                  } else if (typeof destroy.then === 'function') {
                    addendum = '\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + 'useEffect(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://fb.me/react-hooks-data-fetching';
                  } else {
                    addendum = ' You returned: ' + destroy;
                  }
                  error('An effect function must not return anything besides a function, ' + 'which is used for clean-up.%s%s', addendum, getStackByFiberInDevAndProd(finishedWork));
                }
              }
            }
            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }
      function commitPassiveHookEffects(finishedWork) {
        if ((finishedWork.effectTag & Passive) !== NoEffect) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
              {
                // TODO (#17945) We should call all passive destroy functions (for all fibers)
                // before calling any create functions. The current approach only serializes
                // these for a single fiber.
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork);
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
              }
          }
        }
      }
      function commitLifeCycles(finishedRoot, current, finishedWork, committedExpirationTime) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
          case Block:
            {
              // At this point layout effects have already been destroyed (during mutation phase).
              // This is done to prevent sibling component effects from interfering with each other,
              // e.g. a destroy function in one component should never override a ref set
              // by a create function in another component during the same commit.
              commitHookEffectListMount(Layout | HasEffect, finishedWork);
              return;
            }
          case ClassComponent:
            {
              var instance = finishedWork.stateNode;
              if (finishedWork.effectTag & Update) {
                if (current === null) {
                  startPhaseTimer(finishedWork, 'componentDidMount'); // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  instance.componentDidMount();
                  stopPhaseTimer();
                } else {
                  var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                  var prevState = current.memoizedState;
                  startPhaseTimer(finishedWork, 'componentDidUpdate'); // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                  stopPhaseTimer();
                }
              }
              var updateQueue = finishedWork.updateQueue;
              if (updateQueue !== null) {
                {
                  if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                    if (instance.props !== finishedWork.memoizedProps) {
                      error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                    }
                    if (instance.state !== finishedWork.memoizedState) {
                      error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                    }
                  }
                } // We could update instance props and state here,
                // but instead we rely on them being set during last render.
                // TODO: revisit this when we implement resuming.

                commitUpdateQueue(finishedWork, updateQueue, instance);
              }
              return;
            }
          case HostRoot:
            {
              var _updateQueue = finishedWork.updateQueue;
              if (_updateQueue !== null) {
                var _instance = null;
                if (finishedWork.child !== null) {
                  switch (finishedWork.child.tag) {
                    case HostComponent:
                      _instance = getPublicInstance(finishedWork.child.stateNode);
                      break;
                    case ClassComponent:
                      _instance = finishedWork.child.stateNode;
                      break;
                  }
                }
                commitUpdateQueue(finishedWork, _updateQueue, _instance);
              }
              return;
            }
          case HostComponent:
            {
              var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
              // (eg DOM renderer may schedule auto-focus for inputs and form controls).
              // These effects should only be committed when components are first mounted,
              // aka when there is no current/alternate.

              if (current === null && finishedWork.effectTag & Update) {
                var type = finishedWork.type;
                var props = finishedWork.memoizedProps;
                commitMount(_instance2, type, props);
              }
              return;
            }
          case HostText:
            {
              // We have no life-cycles associated with text.
              return;
            }
          case HostPortal:
            {
              // We have no life-cycles associated with portals.
              return;
            }
          case Profiler:
            {
              {
                var onRender = finishedWork.memoizedProps.onRender;
                if (typeof onRender === 'function') {
                  {
                    onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime(), finishedRoot.memoizedInteractions);
                  }
                }
              }
              return;
            }
          case SuspenseComponent:
            {
              commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
              return;
            }
          case SuspenseListComponent:
          case IncompleteClassComponent:
          case FundamentalComponent:
          case ScopeComponent:
            return;
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function hideOrUnhideAllChildren(finishedWork, isHidden) {
        {
          // We only have the top Fiber that was inserted but we need to recurse down its
          // children to find all the terminal nodes.
          var node = finishedWork;
          while (true) {
            if (node.tag === HostComponent) {
              var instance = node.stateNode;
              if (isHidden) {
                hideInstance(instance);
              } else {
                unhideInstance(node.stateNode, node.memoizedProps);
              }
            } else if (node.tag === HostText) {
              var _instance3 = node.stateNode;
              if (isHidden) {
                hideTextInstance(_instance3);
              } else {
                unhideTextInstance(_instance3, node.memoizedProps);
              }
            } else if (node.tag === SuspenseComponent && node.memoizedState !== null && node.memoizedState.dehydrated === null) {
              // Found a nested Suspense component that timed out. Skip over the
              // primary child fragment, which should remain hidden.
              var fallbackChildFragment = node.child.sibling;
              fallbackChildFragment.return = node;
              node = fallbackChildFragment;
              continue;
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === finishedWork) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === finishedWork) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
      }
      function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
          var instance = finishedWork.stateNode;
          var instanceToUse;
          switch (finishedWork.tag) {
            case HostComponent:
              instanceToUse = getPublicInstance(instance);
              break;
            default:
              instanceToUse = instance;
          } // Moved outside to ensure DCE works with this flag

          if (typeof ref === 'function') {
            ref(instanceToUse);
          } else {
            {
              if (!ref.hasOwnProperty('current')) {
                error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().%s', getComponentName(finishedWork.type), getStackByFiberInDevAndProd(finishedWork));
              }
            }
            ref.current = instanceToUse;
          }
        }
      }
      function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
          if (typeof currentRef === 'function') {
            currentRef(null);
          } else {
            currentRef.current = null;
          }
        }
      } // User-originating errors (lifecycles and refs) should not interrupt
      // deletion, so don't let them throw. Host-originating errors should
      // interrupt deletion, so it's okay

      function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch (current.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
          case Block:
            {
              var updateQueue = current.updateQueue;
              if (updateQueue !== null) {
                var lastEffect = updateQueue.lastEffect;
                if (lastEffect !== null) {
                  var firstEffect = lastEffect.next;
                  {
                    // When the owner fiber is deleted, the destroy function of a passive
                    // effect hook is called during the synchronous commit phase. This is
                    // a concession to implementation complexity. Calling it in the
                    // passive effect phase (like they usually are, when dependencies
                    // change during an update) would require either traversing the
                    // children of the deleted fiber again, or including unmount effects
                    // as part of the fiber effect list.
                    //
                    // Because this is during the sync commit phase, we need to change
                    // the priority.
                    //
                    // TODO: Reconsider this implementation trade off.
                    var priorityLevel = renderPriorityLevel > NormalPriority ? NormalPriority : renderPriorityLevel;
                    runWithPriority$1(priorityLevel, function () {
                      var effect = firstEffect;
                      do {
                        var _destroy = effect.destroy;
                        if (_destroy !== undefined) {
                          safelyCallDestroy(current, _destroy);
                        }
                        effect = effect.next;
                      } while (effect !== firstEffect);
                    });
                  }
                }
              }
              return;
            }
          case ClassComponent:
            {
              safelyDetachRef(current);
              var instance = current.stateNode;
              if (typeof instance.componentWillUnmount === 'function') {
                safelyCallComponentWillUnmount(current, instance);
              }
              return;
            }
          case HostComponent:
            {
              safelyDetachRef(current);
              return;
            }
          case HostPortal:
            {
              // TODO: this is recursive.
              // We are also not using this parent because
              // the portal will get pushed immediately.
              {
                unmountHostComponents(finishedRoot, current, renderPriorityLevel);
              }
              return;
            }
          case FundamentalComponent:
            {
              return;
            }
          case DehydratedFragment:
            {
              return;
            }
          case ScopeComponent:
            {
              return;
            }
        }
      }
      function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while (true) {
          commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because they may contain more composite or host nodes.
          // Skip portals because commitUnmount() currently visits them recursively.

          if (node.child !== null &&
          // If we use mutation we drill down into portals using commitUnmount above.
          // If we don't use mutation we drill down into portals here instead.
          node.tag !== HostPortal) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === root) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === root) {
              return;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function detachFiber(current) {
        var alternate = current.alternate; // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.

        current.return = null;
        current.child = null;
        current.memoizedState = null;
        current.updateQueue = null;
        current.dependencies = null;
        current.alternate = null;
        current.firstEffect = null;
        current.lastEffect = null;
        current.pendingProps = null;
        current.memoizedProps = null;
        current.stateNode = null;
        if (alternate !== null) {
          detachFiber(alternate);
        }
      }
      function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while (parent !== null) {
          if (isHostParent(parent)) {
            return parent;
          }
          parent = parent.return;
        }
        {
          {
            throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
      }
      function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while (true) {
          // If we didn't find anything, let's try the next sibling.
          while (node.sibling === null) {
            if (node.return === null || isHostParent(node.return)) {
              // If we pop out of the root or hit the parent the fiber we are the
              // last sibling.
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
          while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
            // If it is not host node and, we might have a host node inside it.
            // Try to search down until we find one.
            if (node.effectTag & Placement) {
              // If we don't have a child, try the siblings instead.
              continue siblings;
            } // If we don't have a child, try the siblings instead.
            // We also skip portals because they are not part of this host tree.

            if (node.child === null || node.tag === HostPortal) {
              continue siblings;
            } else {
              node.child.return = node;
              node = node.child;
            }
          } // Check if this host node is stable or about to be placed.

          if (!(node.effectTag & Placement)) {
            // Found it!
            return node.stateNode;
          }
        }
      }
      function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.

        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch (parentFiber.tag) {
          case HostComponent:
            parent = parentStateNode;
            isContainer = false;
            break;
          case HostRoot:
            parent = parentStateNode.containerInfo;
            isContainer = true;
            break;
          case HostPortal:
            parent = parentStateNode.containerInfo;
            isContainer = true;
            break;
          case FundamentalComponent:

          // eslint-disable-next-line-no-fallthrough

          default:
            {
              {
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
        }
        if (parentFiber.effectTag & ContentReset) {
          // Reset the text content of the parent before doing any insertions
          resetTextContent(parent); // Clear ContentReset from the effect tag

          parentFiber.effectTag &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.

        if (isContainer) {
          insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        } else {
          insertOrAppendPlacementNode(finishedWork, before, parent);
        }
      }
      function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
          var stateNode = isHost ? node.stateNode : node.stateNode.instance;
          if (before) {
            insertInContainerBefore(parent, stateNode, before);
          } else {
            appendChildToContainer(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;
          if (child !== null) {
            insertOrAppendPlacementNodeIntoContainer(child, before, parent);
            var sibling = child.sibling;
            while (sibling !== null) {
              insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }
      function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
          var stateNode = isHost ? node.stateNode : node.stateNode.instance;
          if (before) {
            insertBefore(parent, stateNode, before);
          } else {
            appendChild(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;
          if (child !== null) {
            insertOrAppendPlacementNode(child, before, parent);
            var sibling = child.sibling;
            while (sibling !== null) {
              insertOrAppendPlacementNode(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }
      function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.

        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.

        var currentParent;
        var currentParentIsContainer;
        while (true) {
          if (!currentParentIsValid) {
            var parent = node.return;
            findParent: while (true) {
              if (!(parent !== null)) {
                {
                  throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var parentStateNode = parent.stateNode;
              switch (parent.tag) {
                case HostComponent:
                  currentParent = parentStateNode;
                  currentParentIsContainer = false;
                  break findParent;
                case HostRoot:
                  currentParent = parentStateNode.containerInfo;
                  currentParentIsContainer = true;
                  break findParent;
                case HostPortal:
                  currentParent = parentStateNode.containerInfo;
                  currentParentIsContainer = true;
                  break findParent;
              }
              parent = parent.return;
            }
            currentParentIsValid = true;
          }
          if (node.tag === HostComponent || node.tag === HostText) {
            commitNestedUnmounts(finishedRoot, node, renderPriorityLevel); // After all the children have unmounted, it is now safe to remove the
            // node from the tree.

            if (currentParentIsContainer) {
              removeChildFromContainer(currentParent, node.stateNode);
            } else {
              removeChild(currentParent, node.stateNode);
            } // Don't visit children because we already visited them.
          } else if (node.tag === HostPortal) {
            if (node.child !== null) {
              // When we go into a portal, it becomes the parent to remove from.
              // We will reassign it back when we pop the portal on the way up.
              currentParent = node.stateNode.containerInfo;
              currentParentIsContainer = true; // Visit children because portals might contain host components.

              node.child.return = node;
              node = node.child;
              continue;
            }
          } else {
            commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because we may find more host components below.

            if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
          }
          if (node === current) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === current) {
              return;
            }
            node = node.return;
            if (node.tag === HostPortal) {
              // When we go out of the portal, we need to restore the parent.
              // Since we don't keep a stack of them, we will search for it.
              currentParentIsValid = false;
            }
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        {
          // Recursively delete all host nodes from the parent.
          // Detach refs and call componentWillUnmount() on the whole subtree.
          unmountHostComponents(finishedRoot, current, renderPriorityLevel);
        }
        detachFiber(current);
      }
      function commitWork(current, finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
          case Block:
            {
              // Layout effects are destroyed during the mutation phase so that all
              // destroy functions for all fibers are called before any create functions.
              // This prevents sibling component effects from interfering with each other,
              // e.g. a destroy function in one component should never override a ref set
              // by a create function in another component during the same commit.
              commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
              return;
            }
          case ClassComponent:
            {
              return;
            }
          case HostComponent:
            {
              var instance = finishedWork.stateNode;
              if (instance != null) {
                // Commit the work prepared earlier.
                var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.

                var oldProps = current !== null ? current.memoizedProps : newProps;
                var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

                var updatePayload = finishedWork.updateQueue;
                finishedWork.updateQueue = null;
                if (updatePayload !== null) {
                  commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
              }
              return;
            }
          case HostText:
            {
              if (!(finishedWork.stateNode !== null)) {
                {
                  throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var textInstance = finishedWork.stateNode;
              var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
              // as the newProps. The updatePayload will contain the real change in
              // this case.

              var oldText = current !== null ? current.memoizedProps : newText;
              commitTextUpdate(textInstance, oldText, newText);
              return;
            }
          case HostRoot:
            {
              {
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                  // We've just hydrated. No need to hydrate again.
                  _root.hydrate = false;
                  commitHydratedContainer(_root.containerInfo);
                }
              }
              return;
            }
          case Profiler:
            {
              return;
            }
          case SuspenseComponent:
            {
              commitSuspenseComponent(finishedWork);
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
          case SuspenseListComponent:
            {
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
          case IncompleteClassComponent:
            {
              return;
            }
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        var newDidTimeout;
        var primaryChildParent = finishedWork;
        if (newState === null) {
          newDidTimeout = false;
        } else {
          newDidTimeout = true;
          primaryChildParent = finishedWork.child;
          markCommitTimeOfFallback();
        }
        if (primaryChildParent !== null) {
          hideOrUnhideAllChildren(primaryChildParent, newDidTimeout);
        }
      }
      function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
          var current = finishedWork.alternate;
          if (current !== null) {
            var prevState = current.memoizedState;
            if (prevState !== null) {
              var suspenseInstance = prevState.dehydrated;
              if (suspenseInstance !== null) {
                commitHydratedSuspenseInstance(suspenseInstance);
              }
            }
          }
        }
      }
      function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of thenables.
        // For each thenable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var thenables = finishedWork.updateQueue;
        if (thenables !== null) {
          finishedWork.updateQueue = null;
          var retryCache = finishedWork.stateNode;
          if (retryCache === null) {
            retryCache = finishedWork.stateNode = new PossiblyWeakSet();
          }
          thenables.forEach(function (thenable) {
            // Memoize using the boundary fiber to prevent redundant listeners.
            var retry = resolveRetryThenable.bind(null, finishedWork, thenable);
            if (!retryCache.has(thenable)) {
              {
                if (thenable.__reactDoNotTraceInteractions !== true) {
                  retry = tracing$1.unstable_wrap(retry);
                }
              }
              retryCache.add(thenable);
              thenable.then(retry, retry);
            }
          });
        }
      }
      function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
      }
      var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
      function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null); // Unmount the root by rendering null.

        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".

        update.payload = {
          element: null
        };
        var error = errorInfo.value;
        update.callback = function () {
          onUncaughtError(error);
          logError(fiber, errorInfo);
        };
        return update;
      }
      function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
          var error$1 = errorInfo.value;
          update.payload = function () {
            logError(fiber, errorInfo);
            return getDerivedStateFromError(error$1);
          };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') {
          update.callback = function callback() {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            if (typeof getDerivedStateFromError !== 'function') {
              // To preserve the preexisting retry behavior of error boundaries,
              // we keep track of which ones already failed during this batch.
              // This gets reset before we yield back to the browser.
              // TODO: Warn in strict mode if getDerivedStateFromError is
              // not defined.
              markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined

              logError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
              componentStack: stack !== null ? stack : ''
            });
            {
              if (typeof getDerivedStateFromError !== 'function') {
                // If componentDidCatch is the only error boundary method defined,
                // then it needs to call setState to recover from errors.
                // If no state update is scheduled then the boundary will swallow the error.
                if (fiber.expirationTime !== Sync) {
                  error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown');
                }
              }
            }
          };
        } else {
          update.callback = function () {
            markFailedErrorBoundaryForHotReloading(fiber);
          };
        }
        return update;
      }
      function attachPingListener(root, renderExpirationTime, thenable) {
        // Attach a listener to the promise to "ping" the root and retry. But
        // only if one does not already exist for the current render expiration
        // time (which acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
          pingCache = root.pingCache = new PossiblyWeakMap$1();
          threadIDs = new Set();
          pingCache.set(thenable, threadIDs);
        } else {
          threadIDs = pingCache.get(thenable);
          if (threadIDs === undefined) {
            threadIDs = new Set();
            pingCache.set(thenable, threadIDs);
          }
        }
        if (!threadIDs.has(renderExpirationTime)) {
          // Memoize using the thread ID to prevent redundant listeners.
          threadIDs.add(renderExpirationTime);
          var ping = pingSuspendedRoot.bind(null, root, thenable, renderExpirationTime);
          thenable.then(ping, ping);
        }
      }
      function throwException(root, returnFiber, sourceFiber, value, renderExpirationTime) {
        // The source fiber did not complete.
        sourceFiber.effectTag |= Incomplete; // Its effect list is no longer valid.

        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
          // This is a thenable.
          var thenable = value;
          if ((sourceFiber.mode & BlockingMode) === NoMode) {
            // Reset the memoizedState to what it was before we attempted
            // to render it.
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
              sourceFiber.updateQueue = currentSource.updateQueue;
              sourceFiber.memoizedState = currentSource.memoizedState;
              sourceFiber.expirationTime = currentSource.expirationTime;
            } else {
              sourceFiber.updateQueue = null;
              sourceFiber.memoizedState = null;
            }
          }
          var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.

          var _workInProgress = returnFiber;
          do {
            if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
              // Found the nearest boundary.
              // Stash the promise on the boundary fiber. If the boundary times out, we'll
              // attach another listener to flip the boundary back to its normal state.
              var thenables = _workInProgress.updateQueue;
              if (thenables === null) {
                var updateQueue = new Set();
                updateQueue.add(thenable);
                _workInProgress.updateQueue = updateQueue;
              } else {
                thenables.add(thenable);
              } // If the boundary is outside of blocking mode, we should *not*
              // suspend the commit. Pretend as if the suspended component rendered
              // null and keep rendering. In the commit phase, we'll schedule a
              // subsequent synchronous update to re-render the Suspense.
              //
              // Note: It doesn't matter whether the component that suspended was
              // inside a blocking mode tree. If the Suspense is outside of it, we
              // should *not* suspend the commit.

              if ((_workInProgress.mode & BlockingMode) === NoMode) {
                _workInProgress.effectTag |= DidCapture; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.

                sourceFiber.effectTag &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                  var currentSourceFiber = sourceFiber.alternate;
                  if (currentSourceFiber === null) {
                    // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                  } else {
                    // When we try rendering again, we should not reuse the current fiber,
                    // since it's known to be in an inconsistent state. Use a force update to
                    // prevent a bail out.
                    var update = createUpdate(Sync, null);
                    update.tag = ForceUpdate;
                    enqueueUpdate(sourceFiber, update);
                  }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.

                sourceFiber.expirationTime = Sync; // Exit without suspending.

                return;
              } // Confirmed that the boundary is in a concurrent mode tree. Continue
              // with the normal suspend path.
              //
              // After this we'll use a set of heuristics to determine whether this
              // render pass will run to completion or restart or "suspend" the commit.
              // The actual logic for this is spread out in different places.
              //
              // This first principle is that if we're going to suspend when we complete
              // a root, then we should also restart if we get an update or ping that
              // might unsuspend it, and vice versa. The only reason to suspend is
              // because you think you might want to restart before committing. However,
              // it doesn't make sense to restart only while in the period we're suspended.
              //
              // Restarting too aggressively is also not good because it starves out any
              // intermediate loading state. So we use heuristics to determine when.
              // Suspense Heuristics
              //
              // If nothing threw a Promise or all the same fallbacks are already showing,
              // then don't suspend/restart.
              //
              // If this is an initial render of a new tree of Suspense boundaries and
              // those trigger a fallback, then don't suspend/restart. We want to ensure
              // that we can show the initial loading state as quickly as possible.
              //
              // If we hit a "Delayed" case, such as when we'd switch from content back into
              // a fallback, then we should always suspend/restart. SuspenseConfig applies to
              // this case. If none is defined, JND is used instead.
              //
              // If we're already showing a fallback and it gets "retried", allowing us to show
              // another level, but there's still an inner boundary that would show a fallback,
              // then we suspend/restart for 500ms since the last time we showed a fallback
              // anywhere in the tree. This effectively throttles progressive loading into a
              // consistent train of commits. This also gives us an opportunity to restart to
              // get to the completed state slightly earlier.
              //
              // If there's ambiguity due to batching it's resolved in preference of:
              // 1) "delayed", 2) "initial render", 3) "retry".
              //
              // We want to ensure that a "busy" state doesn't get force committed. We want to
              // ensure that new initial loading states can commit as soon as possible.

              attachPingListener(root, renderExpirationTime, thenable);
              _workInProgress.effectTag |= ShouldCapture;
              _workInProgress.expirationTime = renderExpirationTime;
              return;
            } // This boundary already captured during this render. Continue to the next
            // boundary.

            _workInProgress = _workInProgress.return;
          } while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
          // TODO: Use invariant so the message is stripped in prod?

          value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.' + getStackByFiberInDevAndProd(sourceFiber));
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.

        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
          switch (workInProgress.tag) {
            case HostRoot:
              {
                var _errorInfo = value;
                workInProgress.effectTag |= ShouldCapture;
                workInProgress.expirationTime = renderExpirationTime;
                var _update = createRootErrorUpdate(workInProgress, _errorInfo, renderExpirationTime);
                enqueueCapturedUpdate(workInProgress, _update);
                return;
              }
            case ClassComponent:
              // Capture and retry
              var errorInfo = value;
              var ctor = workInProgress.type;
              var instance = workInProgress.stateNode;
              if ((workInProgress.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                workInProgress.effectTag |= ShouldCapture;
                workInProgress.expirationTime = renderExpirationTime; // Schedule the error boundary to re-render using updated state

                var _update2 = createClassErrorUpdate(workInProgress, errorInfo, renderExpirationTime);
                enqueueCapturedUpdate(workInProgress, _update2);
                return;
              }
              break;
          }
          workInProgress = workInProgress.return;
        } while (workInProgress !== null);
      }
      var ceil = Math.ceil;
      var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
        ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
        IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
      var NoContext = /*                    */
      0;
      var BatchedContext = /*               */
      1;
      var EventContext = /*                 */
      2;
      var DiscreteEventContext = /*         */
      4;
      var LegacyUnbatchedContext = /*       */
      8;
      var RenderContext = /*                */
      16;
      var CommitContext = /*                */
      32;
      var RootIncomplete = 0;
      var RootFatalErrored = 1;
      var RootErrored = 2;
      var RootSuspended = 3;
      var RootSuspendedWithDelay = 4;
      var RootCompleted = 5;
      // Describes where we are in the React execution stack
      var executionContext = NoContext; // The root we're working on

      var workInProgressRoot = null; // The fiber we're working on

      var workInProgress = null; // The expiration time we're rendering

      var renderExpirationTime$1 = NoWork; // Whether to root completed, errored, suspended, etc.

      var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown

      var workInProgressRootFatalError = null; // Most recent event time among processed updates during this render.
      // This is conceptually a time stamp but expressed in terms of an ExpirationTime
      // because we deal mostly with expiration times in the hot path, so this avoids
      // the conversion happening in the hot path.

      var workInProgressRootLatestProcessedExpirationTime = Sync;
      var workInProgressRootLatestSuspenseTimeout = Sync;
      var workInProgressRootCanSuspendUsingConfig = null; // The work left over by components that were visited during this render. Only
      // includes unprocessed updates, not work in bailed out children.

      var workInProgressRootNextUnprocessedUpdateTime = NoWork; // If we're pinged while rendering we don't always restart immediately.
      // This flag determines if it might be worthwhile to restart if an opportunity
      // happens latere.

      var workInProgressRootHasPendingPing = false; // The most recent time we committed a fallback. This lets us ensure a train
      // model where we don't commit new loading states in too quick succession.

      var globalMostRecentFallbackTime = 0;
      var FALLBACK_THROTTLE_MS = 500;
      var nextEffect = null;
      var hasUncaughtError = false;
      var firstUncaughtError = null;
      var legacyErrorBoundariesThatAlreadyFailed = null;
      var rootDoesHavePassiveEffects = false;
      var rootWithPendingPassiveEffects = null;
      var pendingPassiveEffectsRenderPriority = NoPriority;
      var pendingPassiveEffectsExpirationTime = NoWork;
      var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates

      var NESTED_UPDATE_LIMIT = 50;
      var nestedUpdateCount = 0;
      var rootWithNestedUpdates = null;
      var NESTED_PASSIVE_UPDATE_LIMIT = 50;
      var nestedPassiveUpdateCount = 0;
      var interruptedBy = null; // Marks the need to reschedule pending interactions at these expiration times
      // during the commit phase. This enables them to be traced across components
      // that spawn new work during render. E.g. hidden boundaries, suspended SSR
      // hydration or SuspenseList.

      var spawnedWorkDuringRender = null; // Expiration times are computed by adding to the current time (the start
      // time). However, if two updates are scheduled within the same event, we
      // should treat their start times as simultaneous, even if the actual clock
      // time has advanced between the first and second call.
      // In other words, because expiration times determine how updates are batched,
      // we want all updates of like priority that occur within the same event to
      // receive the same expiration time. Otherwise we get tearing.

      var currentEventTime = NoWork;
      function requestCurrentTimeForUpdate() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          // We're inside React, so it's fine to read the actual time.
          return msToExpirationTime(now());
        } // We're not inside React, so we may be in the middle of a browser event.

        if (currentEventTime !== NoWork) {
          // Use the same start time for all updates until we enter React again.
          return currentEventTime;
        } // This is the first update since React yielded. Compute a new start time.

        currentEventTime = msToExpirationTime(now());
        return currentEventTime;
      }
      function getCurrentTime() {
        return msToExpirationTime(now());
      }
      function computeExpirationForFiber(currentTime, fiber, suspenseConfig) {
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) {
          return Sync;
        }
        var priorityLevel = getCurrentPriorityLevel();
        if ((mode & ConcurrentMode) === NoMode) {
          return priorityLevel === ImmediatePriority ? Sync : Batched;
        }
        if ((executionContext & RenderContext) !== NoContext) {
          // Use whatever time we're already rendering
          // TODO: Should there be a way to opt out, like with `runWithPriority`?
          return renderExpirationTime$1;
        }
        var expirationTime;
        if (suspenseConfig !== null) {
          // Compute an expiration time based on the Suspense timeout.
          expirationTime = computeSuspenseExpiration(currentTime, suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
        } else {
          // Compute an expiration time based on the Scheduler priority.
          switch (priorityLevel) {
            case ImmediatePriority:
              expirationTime = Sync;
              break;
            case UserBlockingPriority$1:
              // TODO: Rename this to computeUserBlockingExpiration
              expirationTime = computeInteractiveExpiration(currentTime);
              break;
            case NormalPriority:
            case LowPriority:
              // TODO: Handle LowPriority
              // TODO: Rename this to... something better.
              expirationTime = computeAsyncExpiration(currentTime);
              break;
            case IdlePriority:
              expirationTime = Idle;
              break;
            default:
              {
                {
                  throw Error("Expected a valid priority level");
                }
              }
          }
        } // If we're in the middle of rendering a tree, do not update at the same
        // expiration time that is already rendering.
        // TODO: We shouldn't have to do this if the update is on a different root.
        // Refactor computeExpirationForFiber + scheduleUpdate so we have access to
        // the root when we check for this condition.

        if (workInProgressRoot !== null && expirationTime === renderExpirationTime$1) {
          // This is a trick to move this update into a separate batch
          expirationTime -= 1;
        }
        return expirationTime;
      }
      function scheduleUpdateOnFiber(fiber, expirationTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateTimeFromFiberToRoot(fiber, expirationTime);
        if (root === null) {
          warnAboutUpdateOnUnmountedFiberInDEV(fiber);
          return;
        }
        checkForInterruption(fiber, expirationTime);
        recordScheduleUpdate(); // TODO: computeExpirationForFiber also reads the priority. Pass the
        // priority as an argument to that function and this one.

        var priorityLevel = getCurrentPriorityLevel();
        if (expirationTime === Sync) {
          if (
          // Check if we're inside unbatchedUpdates
          (executionContext & LegacyUnbatchedContext) !== NoContext &&
          // Check if we're not already rendering
          (executionContext & (RenderContext | CommitContext)) === NoContext) {
            // Register pending interactions on the root to avoid losing traced interaction data.
            schedulePendingInteractions(root, expirationTime); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
            // root inside of batchedUpdates should be synchronous, but layout updates
            // should be deferred until the end of the batch.

            performSyncWorkOnRoot(root);
          } else {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, expirationTime);
            if (executionContext === NoContext) {
              // Flush the synchronous work now, unless we're already working or inside
              // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
              // scheduleCallbackForFiber to preserve the ability to schedule a callback
              // without immediately flushing it. We only do this for user-initiated
              // updates, to preserve historical behavior of legacy mode.
              flushSyncCallbackQueue();
            }
          }
        } else {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, expirationTime);
        }
        if ((executionContext & DiscreteEventContext) !== NoContext && (
        // Only updates at user-blocking priority or greater are considered
        // discrete, even inside a discrete event.
        priorityLevel === UserBlockingPriority$1 || priorityLevel === ImmediatePriority)) {
          // This is the result of a discrete event. Track the lowest priority
          // discrete update per root so we can flush them early, if needed.
          if (rootsWithPendingDiscreteUpdates === null) {
            rootsWithPendingDiscreteUpdates = new Map([[root, expirationTime]]);
          } else {
            var lastDiscreteTime = rootsWithPendingDiscreteUpdates.get(root);
            if (lastDiscreteTime === undefined || lastDiscreteTime > expirationTime) {
              rootsWithPendingDiscreteUpdates.set(root, expirationTime);
            }
          }
        }
      }
      var scheduleWork = scheduleUpdateOnFiber; // This is split into a separate function so we can mark a fiber with pending
      // work without treating it as a typical update that originates from an event;
      // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
      // on a fiber.

      function markUpdateTimeFromFiberToRoot(fiber, expirationTime) {
        // Update the source fiber's expiration time
        if (fiber.expirationTime < expirationTime) {
          fiber.expirationTime = expirationTime;
        }
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < expirationTime) {
          alternate.expirationTime = expirationTime;
        } // Walk the parent path to the root and update the child expiration time.

        var node = fiber.return;
        var root = null;
        if (node === null && fiber.tag === HostRoot) {
          root = fiber.stateNode;
        } else {
          while (node !== null) {
            alternate = node.alternate;
            if (node.childExpirationTime < expirationTime) {
              node.childExpirationTime = expirationTime;
              if (alternate !== null && alternate.childExpirationTime < expirationTime) {
                alternate.childExpirationTime = expirationTime;
              }
            } else if (alternate !== null && alternate.childExpirationTime < expirationTime) {
              alternate.childExpirationTime = expirationTime;
            }
            if (node.return === null && node.tag === HostRoot) {
              root = node.stateNode;
              break;
            }
            node = node.return;
          }
        }
        if (root !== null) {
          if (workInProgressRoot === root) {
            // Received an update to a tree that's in the middle of rendering. Mark
            // that's unprocessed work on this root.
            markUnprocessedUpdateTime(expirationTime);
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              // The root already suspended with a delay, which means this render
              // definitely won't finish. Since we have a new update, let's mark it as
              // suspended now, right before marking the incoming update. This has the
              // effect of interrupting the current render and switching to the update.
              // TODO: This happens to work when receiving an update during the render
              // phase, because of the trick inside computeExpirationForFiber to
              // subtract 1 from `renderExpirationTime` to move it into a
              // separate bucket. But we should probably model it with an exception,
              // using the same mechanism we use to force hydration of a subtree.
              // TODO: This does not account for low pri updates that were already
              // scheduled before the root started rendering. Need to track the next
              // pending expiration time (perhaps by backtracking the return path) and
              // then trigger a restart in the `renderDidSuspendDelayIfPossible` path.
              markRootSuspendedAtTime(root, renderExpirationTime$1);
            }
          } // Mark that the root has a pending update.

          markRootUpdatedAtTime(root, expirationTime);
        }
        return root;
      }
      function getNextRootExpirationTimeToWorkOn(root) {
        // Determines the next expiration time that the root should render, taking
        // into account levels that may be suspended, or levels that may have
        // received a ping.
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
          return lastExpiredTime;
        } // "Pending" refers to any update that hasn't committed yet, including if it
        // suspended. The "suspended" range is therefore a subset.

        var firstPendingTime = root.firstPendingTime;
        if (!isRootSuspendedAtTime(root, firstPendingTime)) {
          // The highest priority pending time is not suspended. Let's work on that.
          return firstPendingTime;
        } // If the first pending time is suspended, check if there's a lower priority
        // pending level that we know about. Or check if we received a ping. Work
        // on whichever is higher priority.

        var lastPingedTime = root.lastPingedTime;
        var nextKnownPendingLevel = root.nextKnownPendingLevel;
        var nextLevel = lastPingedTime > nextKnownPendingLevel ? lastPingedTime : nextKnownPendingLevel;
        if (nextLevel <= Idle && firstPendingTime !== nextLevel) {
          // Don't work on Idle/Never priority unless everything else is committed.
          return NoWork;
        }
        return nextLevel;
      } // Use this function to schedule a task for a root. There's only one task per
      // root; if a task was already scheduled, we'll check to make sure the
      // expiration time of the existing task is the same as the expiration time of
      // the next level that the root has work on. This function is called on every
      // update, and right before exiting a task.

      function ensureRootIsScheduled(root) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
          // Special case: Expired work should flush synchronously.
          root.callbackExpirationTime = Sync;
          root.callbackPriority = ImmediatePriority;
          root.callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
          return;
        }
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        var existingCallbackNode = root.callbackNode;
        if (expirationTime === NoWork) {
          // There's nothing to work on.
          if (existingCallbackNode !== null) {
            root.callbackNode = null;
            root.callbackExpirationTime = NoWork;
            root.callbackPriority = NoPriority;
          }
          return;
        } // TODO: If this is an update, we already read the current time. Pass the
        // time as an argument.

        var currentTime = requestCurrentTimeForUpdate();
        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime); // If there's an existing render task, confirm it has the correct priority and
        // expiration time. Otherwise, we'll cancel it and schedule a new one.

        if (existingCallbackNode !== null) {
          var existingCallbackPriority = root.callbackPriority;
          var existingCallbackExpirationTime = root.callbackExpirationTime;
          if (
          // Callback must have the exact same expiration time.
          existingCallbackExpirationTime === expirationTime &&
          // Callback must have greater or equal priority.
          existingCallbackPriority >= priorityLevel) {
            // Existing callback is sufficient.
            return;
          } // Need to schedule a new task.
          // TODO: Instead of scheduling a new task, we should be able to change the
          // priority of the existing one.

          cancelCallback(existingCallbackNode);
        }
        root.callbackExpirationTime = expirationTime;
        root.callbackPriority = priorityLevel;
        var callbackNode;
        if (expirationTime === Sync) {
          // Sync React callbacks are scheduled on a special internal queue
          callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        } else {
          callbackNode = scheduleCallback(priorityLevel, performConcurrentWorkOnRoot.bind(null, root),
          // Compute a task timeout based on the expiration time. This also affects
          // ordering because tasks are processed in timeout order.
          {
            timeout: expirationTimeToMs(expirationTime) - now()
          });
        }
        root.callbackNode = callbackNode;
      } // This is the entry point for every concurrent task, i.e. anything that
      // goes through Scheduler.

      function performConcurrentWorkOnRoot(root, didTimeout) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoWork;
        if (didTimeout) {
          // The render task took too long to complete. Mark the current time as
          // expired to synchronously render all expired work in a single batch.
          var currentTime = requestCurrentTimeForUpdate();
          markRootExpiredAtTime(root, currentTime); // This will schedule a synchronous callback.

          ensureRootIsScheduled(root);
          return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.

        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        if (expirationTime !== NoWork) {
          var originalCallbackNode = root.callbackNode;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
          // and prepare a fresh one. Otherwise we'll continue where we left off.

          if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
            prepareFreshStack(root, expirationTime);
            startWorkOnPendingInteractions(root, expirationTime);
          } // If we have a work-in-progress fiber, it means there's still work to do
          // in this root.

          if (workInProgress !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= RenderContext;
            var prevDispatcher = pushDispatcher();
            var prevInteractions = pushInteractions(root);
            startWorkLoopTimer(workInProgress);
            do {
              try {
                workLoopConcurrent();
                break;
              } catch (thrownValue) {
                handleError(root, thrownValue);
              }
            } while (true);
            resetContextDependencies();
            executionContext = prevExecutionContext;
            popDispatcher(prevDispatcher);
            {
              popInteractions(prevInteractions);
            }
            if (workInProgressRootExitStatus === RootFatalErrored) {
              var fatalError = workInProgressRootFatalError;
              stopInterruptedWorkLoopTimer();
              prepareFreshStack(root, expirationTime);
              markRootSuspendedAtTime(root, expirationTime);
              ensureRootIsScheduled(root);
              throw fatalError;
            }
            if (workInProgress !== null) {
              // There's still work left over. Exit without committing.
              stopInterruptedWorkLoopTimer();
            } else {
              // We now have a consistent tree. The next step is either to commit it,
              // or, if something suspended, wait to commit it after a timeout.
              stopFinishedWorkLoopTimer();
              var finishedWork = root.finishedWork = root.current.alternate;
              root.finishedExpirationTime = expirationTime;
              finishConcurrentRender(root, finishedWork, workInProgressRootExitStatus, expirationTime);
            }
            ensureRootIsScheduled(root);
            if (root.callbackNode === originalCallbackNode) {
              // The task node scheduled for this root is the same one that's
              // currently executed. Need to return a continuation.
              return performConcurrentWorkOnRoot.bind(null, root);
            }
          }
        }
        return null;
      }
      function finishConcurrentRender(root, finishedWork, exitStatus, expirationTime) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        switch (exitStatus) {
          case RootIncomplete:
          case RootFatalErrored:
            {
              {
                {
                  throw Error("Root did not complete. This is a bug in React.");
                }
              }
            }
          // Flow knows about invariant, so it complains if I add a break
          // statement, but eslint doesn't know about invariant, so it complains
          // if I do. eslint-disable-next-line no-fallthrough

          case RootErrored:
            {
              // If this was an async render, the error may have happened due to
              // a mutation in a concurrent event. Try rendering one more time,
              // synchronously, to see if the error goes away. If there are
              // lower priority updates, let's include those, too, in case they
              // fix the inconsistency. Render at Idle to include all updates.
              // If it was Idle or Never or some not-yet-invented time, render
              // at that time.
              markRootExpiredAtTime(root, expirationTime > Idle ? Idle : expirationTime); // We assume that this second render pass will be synchronous
              // and therefore not hit this path again.

              break;
            }
          case RootSuspended:
            {
              markRootSuspendedAtTime(root, expirationTime);
              var lastSuspendedTime = root.lastSuspendedTime;
              if (expirationTime === lastSuspendedTime) {
                root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
              } // We have an acceptable loading state. We need to figure out if we
              // should immediately commit it or wait a bit.
              // If we have processed new updates during this render, we may now
              // have a new loading state ready. We want to ensure that we commit
              // that as soon as possible.

              var hasNotProcessedNewUpdates = workInProgressRootLatestProcessedExpirationTime === Sync;
              if (hasNotProcessedNewUpdates &&
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current) {
                // If we have not processed any new updates during this pass, then
                // this is either a retry of an existing fallback state or a
                // hidden tree. Hidden trees shouldn't be batched with other work
                // and after that's fixed it can only be a retry. We're going to
                // throttle committing retries so that we don't show too many
                // loading states too quickly.
                var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.

                if (msUntilTimeout > 10) {
                  if (workInProgressRootHasPendingPing) {
                    var lastPingedTime = root.lastPingedTime;
                    if (lastPingedTime === NoWork || lastPingedTime >= expirationTime) {
                      // This render was pinged but we didn't get to restart
                      // earlier so try restarting now instead.
                      root.lastPingedTime = expirationTime;
                      prepareFreshStack(root, expirationTime);
                      break;
                    }
                  }
                  var nextTime = getNextRootExpirationTimeToWorkOn(root);
                  if (nextTime !== NoWork && nextTime !== expirationTime) {
                    // There's additional work on this root.
                    break;
                  }
                  if (lastSuspendedTime !== NoWork && lastSuspendedTime !== expirationTime) {
                    // We should prefer to render the fallback of at the last
                    // suspended level. Ping the last suspended level to try
                    // rendering it again.
                    root.lastPingedTime = lastSuspendedTime;
                    break;
                  } // The render is suspended, it hasn't timed out, and there's no
                  // lower priority work to do. Instead of committing the fallback
                  // immediately, wait for more data to arrive.

                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                  break;
                }
              } // The work expired. Commit immediately.

              commitRoot(root);
              break;
            }
          case RootSuspendedWithDelay:
            {
              markRootSuspendedAtTime(root, expirationTime);
              var _lastSuspendedTime = root.lastSuspendedTime;
              if (expirationTime === _lastSuspendedTime) {
                root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
              }
              if (
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current) {
                // We're suspended in a state that should be avoided. We'll try to
                // avoid committing it for as long as the timeouts let us.
                if (workInProgressRootHasPendingPing) {
                  var _lastPingedTime = root.lastPingedTime;
                  if (_lastPingedTime === NoWork || _lastPingedTime >= expirationTime) {
                    // This render was pinged but we didn't get to restart earlier
                    // so try restarting now instead.
                    root.lastPingedTime = expirationTime;
                    prepareFreshStack(root, expirationTime);
                    break;
                  }
                }
                var _nextTime = getNextRootExpirationTimeToWorkOn(root);
                if (_nextTime !== NoWork && _nextTime !== expirationTime) {
                  // There's additional work on this root.
                  break;
                }
                if (_lastSuspendedTime !== NoWork && _lastSuspendedTime !== expirationTime) {
                  // We should prefer to render the fallback of at the last
                  // suspended level. Ping the last suspended level to try
                  // rendering it again.
                  root.lastPingedTime = _lastSuspendedTime;
                  break;
                }
                var _msUntilTimeout;
                if (workInProgressRootLatestSuspenseTimeout !== Sync) {
                  // We have processed a suspense config whose expiration time we
                  // can use as the timeout.
                  _msUntilTimeout = expirationTimeToMs(workInProgressRootLatestSuspenseTimeout) - now();
                } else if (workInProgressRootLatestProcessedExpirationTime === Sync) {
                  // This should never normally happen because only new updates
                  // cause delayed states, so we should have processed something.
                  // However, this could also happen in an offscreen tree.
                  _msUntilTimeout = 0;
                } else {
                  // If we don't have a suspense config, we're going to use a
                  // heuristic to determine how long we can suspend.
                  var eventTimeMs = inferTimeFromExpirationTime(workInProgressRootLatestProcessedExpirationTime);
                  var currentTimeMs = now();
                  var timeUntilExpirationMs = expirationTimeToMs(expirationTime) - currentTimeMs;
                  var timeElapsed = currentTimeMs - eventTimeMs;
                  if (timeElapsed < 0) {
                    // We get this wrong some time since we estimate the time.
                    timeElapsed = 0;
                  }
                  _msUntilTimeout = jnd(timeElapsed) - timeElapsed; // Clamp the timeout to the expiration time. TODO: Once the
                  // event time is exact instead of inferred from expiration time
                  // we don't need this.

                  if (timeUntilExpirationMs < _msUntilTimeout) {
                    _msUntilTimeout = timeUntilExpirationMs;
                  }
                } // Don't bother with a very short suspense time.

                if (_msUntilTimeout > 10) {
                  // The render is suspended, it hasn't timed out, and there's no
                  // lower priority work to do. Instead of committing the fallback
                  // immediately, wait for more data to arrive.
                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                  break;
                }
              } // The work expired. Commit immediately.

              commitRoot(root);
              break;
            }
          case RootCompleted:
            {
              // The work completed. Ready to commit.
              if (
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current && workInProgressRootLatestProcessedExpirationTime !== Sync && workInProgressRootCanSuspendUsingConfig !== null) {
                // If we have exceeded the minimum loading delay, which probably
                // means we have shown a spinner already, we might have to suspend
                // a bit longer to ensure that the spinner is shown for
                // enough time.
                var _msUntilTimeout2 = computeMsUntilSuspenseLoadingDelay(workInProgressRootLatestProcessedExpirationTime, expirationTime, workInProgressRootCanSuspendUsingConfig);
                if (_msUntilTimeout2 > 10) {
                  markRootSuspendedAtTime(root, expirationTime);
                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout2);
                  break;
                }
              }
              commitRoot(root);
              break;
            }
          default:
            {
              {
                {
                  throw Error("Unknown root exit status.");
                }
              }
            }
        }
      } // This is the entry point for synchronous tasks that don't go
      // through Scheduler

      function performSyncWorkOnRoot(root) {
        // Check if there's expired work on this root. Otherwise, render at Sync.
        var lastExpiredTime = root.lastExpiredTime;
        var expirationTime = lastExpiredTime !== NoWork ? lastExpiredTime : Sync;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Should not already be working.");
          }
        }
        flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.

        if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
          prepareFreshStack(root, expirationTime);
          startWorkOnPendingInteractions(root, expirationTime);
        } // If we have a work-in-progress fiber, it means there's still work to do
        // in this root.

        if (workInProgress !== null) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher();
          var prevInteractions = pushInteractions(root);
          startWorkLoopTimer(workInProgress);
          do {
            try {
              workLoopSync();
              break;
            } catch (thrownValue) {
              handleError(root, thrownValue);
            }
          } while (true);
          resetContextDependencies();
          executionContext = prevExecutionContext;
          popDispatcher(prevDispatcher);
          {
            popInteractions(prevInteractions);
          }
          if (workInProgressRootExitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            stopInterruptedWorkLoopTimer();
            prepareFreshStack(root, expirationTime);
            markRootSuspendedAtTime(root, expirationTime);
            ensureRootIsScheduled(root);
            throw fatalError;
          }
          if (workInProgress !== null) {
            // This is a sync render, so we should have finished the whole tree.
            {
              {
                throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          } else {
            // We now have a consistent tree. Because this is a sync render, we
            // will commit it even if something suspended.
            stopFinishedWorkLoopTimer();
            root.finishedWork = root.current.alternate;
            root.finishedExpirationTime = expirationTime;
            finishSyncRender(root);
          } // Before exiting, make sure there's a callback scheduled for the next
          // pending level.

          ensureRootIsScheduled(root);
        }
        return null;
      }
      function finishSyncRender(root) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        commitRoot(root);
      }
      function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
          {
            if ((executionContext & RenderContext) !== NoContext) {
              error('unstable_flushDiscreteUpdates: Cannot flush updates when React is ' + 'already rendering.');
            }
          } // We're already rendering, so we can't synchronously flush pending work.
          // This is probably a nested event dispatch triggered by a lifecycle/effect,
          // like `el.focus()`. Exit.

          return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.

        flushPassiveEffects();
      }
      function syncUpdates(fn, a, b, c) {
        return runWithPriority$1(ImmediatePriority, fn.bind(null, a, b, c));
      }
      function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
          // For each root with pending discrete updates, schedule a callback to
          // immediately flush them.
          var roots = rootsWithPendingDiscreteUpdates;
          rootsWithPendingDiscreteUpdates = null;
          roots.forEach(function (expirationTime, root) {
            markRootExpiredAtTime(root, expirationTime);
            ensureRootIsScheduled(root);
          }); // Now flush the immediate queue.

          flushSyncCallbackQueue();
        }
      }
      function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function batchedEventUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function discreteUpdates$1(fn, a, b, c, d) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
          // Should this
          return runWithPriority$1(UserBlockingPriority$1, fn.bind(null, a, b, c, d));
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function flushSync$$1(fn, a) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          {
            {
              throw Error("flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.");
            }
          }
        }
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
          return runWithPriority$1(ImmediatePriority, fn.bind(null, a));
        } finally {
          executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
          // Note that this will happen even if batchedUpdates is higher up
          // the stack.

          flushSyncCallbackQueue();
        }
      }
      function prepareFreshStack(root, expirationTime) {
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
          // The root previous suspended and scheduled a timeout to commit a fallback
          // state. Now that we have additional work, cancel the timeout.
          root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

          cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
          var interruptedWork = workInProgress.return;
          while (interruptedWork !== null) {
            unwindInterruptedWork(interruptedWork);
            interruptedWork = interruptedWork.return;
          }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        renderExpirationTime$1 = expirationTime;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootLatestProcessedExpirationTime = Sync;
        workInProgressRootLatestSuspenseTimeout = Sync;
        workInProgressRootCanSuspendUsingConfig = null;
        workInProgressRootNextUnprocessedUpdateTime = NoWork;
        workInProgressRootHasPendingPing = false;
        {
          spawnedWorkDuringRender = null;
        }
        {
          ReactStrictModeWarnings.discardPendingWarnings();
        }
      }
      function handleError(root, thrownValue) {
        do {
          try {
            // Reset module-level state that was set during the render phase.
            resetContextDependencies();
            resetHooksAfterThrow();
            resetCurrentFiber();
            if (workInProgress === null || workInProgress.return === null) {
              // Expected to be working on a non-root fiber. This is a fatal error
              // because there's no ancestor that can handle it; the root is
              // supposed to capture all errors that weren't caught by an error
              // boundary.
              workInProgressRootExitStatus = RootFatalErrored;
              workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
              // sibling, or the parent if there are no siblings. But since the root
              // has no siblings nor a parent, we set it to null. Usually this is
              // handled by `completeUnitOfWork` or `unwindWork`, but since we're
              // interntionally not calling those, we need set it here.
              // TODO: Consider calling `unwindWork` to pop the contexts.

              workInProgress = null;
              return null;
            }
            if (workInProgress.mode & ProfileMode) {
              // Record the time spent rendering before an error was thrown. This
              // avoids inaccurate Profiler durations in the case of a
              // suspended render.
              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, true);
            }
            throwException(root, workInProgress.return, workInProgress, thrownValue, renderExpirationTime$1);
            workInProgress = completeUnitOfWork(workInProgress);
          } catch (yetAnotherThrownValue) {
            // Something in the return path also threw.
            thrownValue = yetAnotherThrownValue;
            continue;
          } // Return to the normal work loop.

          return;
        } while (true);
      }
      function pushDispatcher(root) {
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) {
          // The React isomorphic package does not include a default dispatcher.
          // Instead the first renderer will lazily attach one, in order to give
          // nicer error messages.
          return ContextOnlyDispatcher;
        } else {
          return prevDispatcher;
        }
      }
      function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
      function pushInteractions(root) {
        {
          var prevInteractions = tracing$1.__interactionsRef.current;
          tracing$1.__interactionsRef.current = root.memoizedInteractions;
          return prevInteractions;
        }
      }
      function popInteractions(prevInteractions) {
        {
          tracing$1.__interactionsRef.current = prevInteractions;
        }
      }
      function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
      }
      function markRenderEventTimeAndConfig(expirationTime, suspenseConfig) {
        if (expirationTime < workInProgressRootLatestProcessedExpirationTime && expirationTime > Idle) {
          workInProgressRootLatestProcessedExpirationTime = expirationTime;
        }
        if (suspenseConfig !== null) {
          if (expirationTime < workInProgressRootLatestSuspenseTimeout && expirationTime > Idle) {
            workInProgressRootLatestSuspenseTimeout = expirationTime; // Most of the time we only have one config and getting wrong is not bad.

            workInProgressRootCanSuspendUsingConfig = suspenseConfig;
          }
        }
      }
      function markUnprocessedUpdateTime(expirationTime) {
        if (expirationTime > workInProgressRootNextUnprocessedUpdateTime) {
          workInProgressRootNextUnprocessedUpdateTime = expirationTime;
        }
      }
      function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) {
          workInProgressRootExitStatus = RootSuspended;
        }
      }
      function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
          workInProgressRootExitStatus = RootSuspendedWithDelay;
        } // Check if there's a lower priority update somewhere else in the tree.

        if (workInProgressRootNextUnprocessedUpdateTime !== NoWork && workInProgressRoot !== null) {
          // Mark the current render as suspended, and then mark that there's a
          // pending update.
          // TODO: This should immediately interrupt the current render, instead
          // of waiting until the next time we yield.
          markRootSuspendedAtTime(workInProgressRoot, renderExpirationTime$1);
          markRootUpdatedAtTime(workInProgressRoot, workInProgressRootNextUnprocessedUpdateTime);
        }
      }
      function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) {
          workInProgressRootExitStatus = RootErrored;
        }
      } // Called during render to determine if anything has suspended.
      // Returns false if we're not sure.

      function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
      }
      function inferTimeFromExpirationTime(expirationTime) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - LOW_PRIORITY_EXPIRATION;
      }
      function inferTimeFromExpirationTimeWithSuspenseConfig(expirationTime, suspenseConfig) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time by subtracting the timeout
        // that was added to the event time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - (suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
      } // The work loop is an extremely hot path. Tell Closure not to inline it.

      /** @noinline */

      function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while (workInProgress !== null) {
          workInProgress = performUnitOfWork(workInProgress);
        }
      }
      /** @noinline */

      function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while (workInProgress !== null && !shouldYield()) {
          workInProgress = performUnitOfWork(workInProgress);
        }
      }
      function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        startWorkTimer(unitOfWork);
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          startProfilerTimer(unitOfWork);
          next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
          stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else {
          next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
        }
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) {
          // If this doesn't spawn new work, complete the current work.
          next = completeUnitOfWork(unitOfWork);
        }
        ReactCurrentOwner$2.current = null;
        return next;
      }
      function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        workInProgress = unitOfWork;
        do {
          // The current, flushed, state of this fiber is the alternate. Ideally
          // nothing should rely on this, but relying on it here means that we don't
          // need an additional field on the work in progress.
          var current = workInProgress.alternate;
          var returnFiber = workInProgress.return; // Check if the work completed or if something threw.

          if ((workInProgress.effectTag & Incomplete) === NoEffect) {
            setCurrentFiber(workInProgress);
            var next = void 0;
            if ((workInProgress.mode & ProfileMode) === NoMode) {
              next = completeWork(current, workInProgress, renderExpirationTime$1);
            } else {
              startProfilerTimer(workInProgress);
              next = completeWork(current, workInProgress, renderExpirationTime$1); // Update render duration assuming we didn't error.

              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
            }
            stopWorkTimer(workInProgress);
            resetCurrentFiber();
            resetChildExpirationTime(workInProgress);
            if (next !== null) {
              // Completing this fiber spawned new work. Work on that next.
              return next;
            }
            if (returnFiber !== null &&
            // Do not append effects to parents if a sibling failed to complete
            (returnFiber.effectTag & Incomplete) === NoEffect) {
              // Append all the effects of the subtree and this fiber onto the effect
              // list of the parent. The completion order of the children affects the
              // side-effect order.
              if (returnFiber.firstEffect === null) {
                returnFiber.firstEffect = workInProgress.firstEffect;
              }
              if (workInProgress.lastEffect !== null) {
                if (returnFiber.lastEffect !== null) {
                  returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                }
                returnFiber.lastEffect = workInProgress.lastEffect;
              } // If this fiber had side-effects, we append it AFTER the children's
              // side-effects. We can perform certain side-effects earlier if needed,
              // by doing multiple passes over the effect list. We don't want to
              // schedule our own side-effect on our own list because if end up
              // reusing children we'll schedule this effect onto itself since we're
              // at the end.

              var effectTag = workInProgress.effectTag; // Skip both NoWork and PerformedWork tags when creating the effect
              // list. PerformedWork effect is read by React DevTools but shouldn't be
              // committed.

              if (effectTag > PerformedWork) {
                if (returnFiber.lastEffect !== null) {
                  returnFiber.lastEffect.nextEffect = workInProgress;
                } else {
                  returnFiber.firstEffect = workInProgress;
                }
                returnFiber.lastEffect = workInProgress;
              }
            }
          } else {
            // This fiber did not complete because something threw. Pop values off
            // the stack without entering the complete phase. If this is a boundary,
            // capture values if possible.
            var _next = unwindWork(workInProgress); // Because this fiber did not complete, don't reset its expiration time.

            if ((workInProgress.mode & ProfileMode) !== NoMode) {
              // Record the render duration for the fiber that errored.
              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false); // Include the time spent working on failed children before continuing.

              var actualDuration = workInProgress.actualDuration;
              var child = workInProgress.child;
              while (child !== null) {
                actualDuration += child.actualDuration;
                child = child.sibling;
              }
              workInProgress.actualDuration = actualDuration;
            }
            if (_next !== null) {
              // If completing this work spawned new work, do that next. We'll come
              // back here again.
              // Since we're restarting, remove anything that is not a host effect
              // from the effect tag.
              // TODO: The name stopFailedWorkTimer is misleading because Suspense
              // also captures and restarts.
              stopFailedWorkTimer(workInProgress);
              _next.effectTag &= HostEffectMask;
              return _next;
            }
            stopWorkTimer(workInProgress);
            if (returnFiber !== null) {
              // Mark the parent fiber as incomplete and clear its effect list.
              returnFiber.firstEffect = returnFiber.lastEffect = null;
              returnFiber.effectTag |= Incomplete;
            }
          }
          var siblingFiber = workInProgress.sibling;
          if (siblingFiber !== null) {
            // If there is more work to do in this returnFiber, do that next.
            return siblingFiber;
          } // Otherwise, return to the parent

          workInProgress = returnFiber;
        } while (workInProgress !== null); // We've reached the root.

        if (workInProgressRootExitStatus === RootIncomplete) {
          workInProgressRootExitStatus = RootCompleted;
        }
        return null;
      }
      function getRemainingExpirationTime(fiber) {
        var updateExpirationTime = fiber.expirationTime;
        var childExpirationTime = fiber.childExpirationTime;
        return updateExpirationTime > childExpirationTime ? updateExpirationTime : childExpirationTime;
      }
      function resetChildExpirationTime(completedWork) {
        if (renderExpirationTime$1 !== Never && completedWork.childExpirationTime === Never) {
          // The children of this component are hidden. Don't bubble their
          // expiration times.
          return;
        }
        var newChildExpirationTime = NoWork; // Bubble up the earliest expiration time.

        if ((completedWork.mode & ProfileMode) !== NoMode) {
          // In profiling mode, resetChildExpirationTime is also used to reset
          // profiler durations.
          var actualDuration = completedWork.actualDuration;
          var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
          // only be updated if work is done on the fiber (i.e. it doesn't bailout).
          // When work is done, it should bubble to the parent's actualDuration. If
          // the fiber has not been cloned though, (meaning no work was done), then
          // this value will reflect the amount of time spent working on a previous
          // render. In that case it should not bubble. We determine whether it was
          // cloned by comparing the child pointer.

          var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
          var child = completedWork.child;
          while (child !== null) {
            var childUpdateExpirationTime = child.expirationTime;
            var childChildExpirationTime = child.childExpirationTime;
            if (childUpdateExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = childUpdateExpirationTime;
            }
            if (childChildExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = childChildExpirationTime;
            }
            if (shouldBubbleActualDurations) {
              actualDuration += child.actualDuration;
            }
            treeBaseDuration += child.treeBaseDuration;
            child = child.sibling;
          }
          completedWork.actualDuration = actualDuration;
          completedWork.treeBaseDuration = treeBaseDuration;
        } else {
          var _child = completedWork.child;
          while (_child !== null) {
            var _childUpdateExpirationTime = _child.expirationTime;
            var _childChildExpirationTime = _child.childExpirationTime;
            if (_childUpdateExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = _childUpdateExpirationTime;
            }
            if (_childChildExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = _childChildExpirationTime;
            }
            _child = _child.sibling;
          }
        }
        completedWork.childExpirationTime = newChildExpirationTime;
      }
      function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(ImmediatePriority, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
      }
      function commitRootImpl(root, renderPriorityLevel) {
        do {
          // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
          // means `flushPassiveEffects` will sometimes result in additional
          // passive effects. So we need to keep flushing in a loop until there are
          // no more pending effects.
          // TODO: Might be better if `flushPassiveEffects` did not automatically
          // flush synchronous work at the end, to avoid factoring hazards like this.
          flushPassiveEffects();
        } while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Should not already be working.");
          }
        }
        var finishedWork = root.finishedWork;
        var expirationTime = root.finishedExpirationTime;
        if (finishedWork === null) {
          return null;
        }
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        if (!(finishedWork !== root.current)) {
          {
            throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
          }
        } // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.

        root.callbackNode = null;
        root.callbackExpirationTime = NoWork;
        root.callbackPriority = NoPriority;
        root.nextKnownPendingLevel = NoWork;
        startCommitTimer(); // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.

        var remainingExpirationTimeBeforeCommit = getRemainingExpirationTime(finishedWork);
        markRootFinishedAtTime(root, expirationTime, remainingExpirationTimeBeforeCommit);
        if (root === workInProgressRoot) {
          // We can reset these now that they are finished.
          workInProgressRoot = null;
          workInProgress = null;
          renderExpirationTime$1 = NoWork;
        } // This indicates that the last root we worked on is not the same one that
        // we're committing now. This most commonly happens when a suspended root
        // times out.
        // Get the list of effects.

        var firstEffect;
        if (finishedWork.effectTag > PerformedWork) {
          // A fiber's effect list consists only of its children, not itself. So if
          // the root has an effect, we need to add it to the end of the list. The
          // resulting list is the set that would belong to the root's parent, if it
          // had one; that is, all the effects in the tree including the root.
          if (finishedWork.lastEffect !== null) {
            finishedWork.lastEffect.nextEffect = finishedWork;
            firstEffect = finishedWork.firstEffect;
          } else {
            firstEffect = finishedWork;
          }
        } else {
          // There is no effect on the root.
          firstEffect = finishedWork.firstEffect;
        }
        if (firstEffect !== null) {
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles

          ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
          // of the effect list for each phase: all mutation effects come before all
          // layout effects, and so on.
          // The first phase a "before mutation" phase. We use this phase to read the
          // state of the host tree right before we mutate it. This is where
          // getSnapshotBeforeUpdate is called.

          startCommitSnapshotEffectsTimer();
          prepareForCommit(root.containerInfo);
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitBeforeMutationEffects, null);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var error = clearCaughtError();
                captureCommitPhaseError(nextEffect, error);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitSnapshotEffectsTimer();
          {
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
          } // The next phase is the mutation phase, where we mutate the host tree.

          startCommitHostEffectsTimer();
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error = clearCaughtError();
                captureCommitPhaseError(nextEffect, _error);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitHostEffectsTimer();
          resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
          // the mutation phase, so that the previous tree is still current during
          // componentWillUnmount, but before the layout phase, so that the finished
          // work is current during componentDidMount/Update.

          root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
          // the host tree after it's been mutated. The idiomatic use case for this is
          // layout, but class component lifecycles also fire here for legacy reasons.

          startCommitLifeCyclesTimer();
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitLayoutEffects, null, root, expirationTime);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error2 = clearCaughtError();
                captureCommitPhaseError(nextEffect, _error2);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitLifeCyclesTimer();
          nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
          // opportunity to paint.

          requestPaint();
          {
            popInteractions(prevInteractions);
          }
          executionContext = prevExecutionContext;
        } else {
          // No effects.
          root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
          // no effects.
          // TODO: Maybe there's a better way to report this.

          startCommitSnapshotEffectsTimer();
          stopCommitSnapshotEffectsTimer();
          {
            recordCommitTime();
          }
          startCommitHostEffectsTimer();
          stopCommitHostEffectsTimer();
          startCommitLifeCyclesTimer();
          stopCommitLifeCyclesTimer();
        }
        stopCommitTimer();
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
          // This commit has passive effects. Stash a reference to them. But don't
          // schedule a callback until after flushing layout work.
          rootDoesHavePassiveEffects = false;
          rootWithPendingPassiveEffects = root;
          pendingPassiveEffectsExpirationTime = expirationTime;
          pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
          // We are done with the effect chain at this point so let's clear the
          // nextEffect pointers to assist with GC. If we have passive effects, we'll
          // clear this in flushPassiveEffects.
          nextEffect = firstEffect;
          while (nextEffect !== null) {
            var nextNextEffect = nextEffect.nextEffect;
            nextEffect.nextEffect = null;
            nextEffect = nextNextEffect;
          }
        } // Check if there's remaining work on this root

        var remainingExpirationTime = root.firstPendingTime;
        if (remainingExpirationTime !== NoWork) {
          {
            if (spawnedWorkDuringRender !== null) {
              var expirationTimes = spawnedWorkDuringRender;
              spawnedWorkDuringRender = null;
              for (var i = 0; i < expirationTimes.length; i++) {
                scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
              }
            }
            schedulePendingInteractions(root, remainingExpirationTime);
          }
        } else {
          // If there's no remaining work, we can clear the set of already failed
          // error boundaries.
          legacyErrorBoundariesThatAlreadyFailed = null;
        }
        {
          if (!rootDidHavePassiveEffects) {
            // If there are no passive effects, then we can complete the pending interactions.
            // Otherwise, we'll wait until after the passive effects are flushed.
            // Wait to do this until after remaining work has been scheduled,
            // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
            finishPendingInteractions(root, expirationTime);
          }
        }
        if (remainingExpirationTime === Sync) {
          // Count the number of times the root synchronously re-renders without
          // finishing. If there are too many, it indicates an infinite update loop.
          if (root === rootWithNestedUpdates) {
            nestedUpdateCount++;
          } else {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = root;
          }
        } else {
          nestedUpdateCount = 0;
        }
        onCommitRoot(finishedWork.stateNode, expirationTime); // Always call this before exiting `commitRoot`, to ensure that any
        // additional work on this root is scheduled.

        ensureRootIsScheduled(root);
        if (hasUncaughtError) {
          hasUncaughtError = false;
          var _error3 = firstUncaughtError;
          firstUncaughtError = null;
          throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
          // This is a legacy edge case. We just committed the initial mount of
          // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
          // synchronously, but layout updates should be deferred until the end
          // of the batch.
          return null;
        } // If layout work was scheduled, flush it now.

        flushSyncCallbackQueue();
        return null;
      }
      function commitBeforeMutationEffects() {
        while (nextEffect !== null) {
          var effectTag = nextEffect.effectTag;
          if ((effectTag & Snapshot) !== NoEffect) {
            setCurrentFiber(nextEffect);
            recordEffect();
            var current = nextEffect.alternate;
            commitBeforeMutationLifeCycles(current, nextEffect);
            resetCurrentFiber();
          }
          if ((effectTag & Passive) !== NoEffect) {
            // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            if (!rootDoesHavePassiveEffects) {
              rootDoesHavePassiveEffects = true;
              scheduleCallback(NormalPriority, function () {
                flushPassiveEffects();
                return null;
              });
            }
          }
          nextEffect = nextEffect.nextEffect;
        }
      }
      function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while (nextEffect !== null) {
          setCurrentFiber(nextEffect);
          var effectTag = nextEffect.effectTag;
          if (effectTag & ContentReset) {
            commitResetTextContent(nextEffect);
          }
          if (effectTag & Ref) {
            var current = nextEffect.alternate;
            if (current !== null) {
              commitDetachRef(current);
            }
          } // The following switch statement is only concerned about placement,
          // updates, and deletions. To avoid needing to add a case for every possible
          // bitmap value, we remove the secondary effects from the effect tag and
          // switch on that value.

          var primaryEffectTag = effectTag & (Placement | Update | Deletion | Hydrating);
          switch (primaryEffectTag) {
            case Placement:
              {
                commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                // inserted, before any life-cycles like componentDidMount gets called.
                // TODO: findDOMNode doesn't rely on this any more but isMounted does
                // and isMounted is deprecated anyway so we should be able to kill this.

                nextEffect.effectTag &= ~Placement;
                break;
              }
            case PlacementAndUpdate:
              {
                // Placement
                commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                // inserted, before any life-cycles like componentDidMount gets called.

                nextEffect.effectTag &= ~Placement; // Update

                var _current = nextEffect.alternate;
                commitWork(_current, nextEffect);
                break;
              }
            case Hydrating:
              {
                nextEffect.effectTag &= ~Hydrating;
                break;
              }
            case HydratingAndUpdate:
              {
                nextEffect.effectTag &= ~Hydrating; // Update

                var _current2 = nextEffect.alternate;
                commitWork(_current2, nextEffect);
                break;
              }
            case Update:
              {
                var _current3 = nextEffect.alternate;
                commitWork(_current3, nextEffect);
                break;
              }
            case Deletion:
              {
                commitDeletion(root, nextEffect, renderPriorityLevel);
                break;
              }
          } // TODO: Only record a mutation effect if primaryEffectTag is non-zero.

          recordEffect();
          resetCurrentFiber();
          nextEffect = nextEffect.nextEffect;
        }
      }
      function commitLayoutEffects(root, committedExpirationTime) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while (nextEffect !== null) {
          setCurrentFiber(nextEffect);
          var effectTag = nextEffect.effectTag;
          if (effectTag & (Update | Callback)) {
            recordEffect();
            var current = nextEffect.alternate;
            commitLifeCycles(root, current, nextEffect);
          }
          if (effectTag & Ref) {
            recordEffect();
            commitAttachRef(nextEffect);
          }
          resetCurrentFiber();
          nextEffect = nextEffect.nextEffect;
        }
      }
      function flushPassiveEffects() {
        if (pendingPassiveEffectsRenderPriority !== NoPriority) {
          var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority ? NormalPriority : pendingPassiveEffectsRenderPriority;
          pendingPassiveEffectsRenderPriority = NoPriority;
          return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
        }
      }
      function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) {
          return false;
        }
        var root = rootWithPendingPassiveEffects;
        var expirationTime = pendingPassiveEffectsExpirationTime;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsExpirationTime = NoWork;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Cannot flush passive effects while already rendering.");
          }
        }
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root);
        {
          // Note: This currently assumes there are no passive effects on the root fiber
          // because the root is not part of its own effect list.
          // This could change in the future.
          var _effect2 = root.current.firstEffect;
          while (_effect2 !== null) {
            {
              setCurrentFiber(_effect2);
              invokeGuardedCallback(null, commitPassiveHookEffects, null, _effect2);
              if (hasCaughtError()) {
                if (!(_effect2 !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error5 = clearCaughtError();
                captureCommitPhaseError(_effect2, _error5);
              }
              resetCurrentFiber();
            }
            var nextNextEffect = _effect2.nextEffect; // Remove nextEffect pointer to assist GC

            _effect2.nextEffect = null;
            _effect2 = nextNextEffect;
          }
        }
        {
          popInteractions(prevInteractions);
          finishPendingInteractions(root, expirationTime);
        }
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.

        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
      }
      function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
      }
      function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) {
          legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
        } else {
          legacyErrorBoundariesThatAlreadyFailed.add(instance);
        }
      }
      function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
          hasUncaughtError = true;
          firstUncaughtError = error;
        }
      }
      var onUncaughtError = prepareToThrowUncaughtError;
      function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, Sync);
        enqueueUpdate(rootFiber, update);
        var root = markUpdateTimeFromFiberToRoot(rootFiber, Sync);
        if (root !== null) {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, Sync);
        }
      }
      function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
          // Error was thrown at the root. There is no parent, so the root
          // itself should capture it.
          captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
          return;
        }
        var fiber = sourceFiber.return;
        while (fiber !== null) {
          if (fiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
            return;
          } else if (fiber.tag === ClassComponent) {
            var ctor = fiber.type;
            var instance = fiber.stateNode;
            if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
              var errorInfo = createCapturedValue(error, sourceFiber);
              var update = createClassErrorUpdate(fiber, errorInfo,
              // TODO: This is always sync
              Sync);
              enqueueUpdate(fiber, update);
              var root = markUpdateTimeFromFiberToRoot(fiber, Sync);
              if (root !== null) {
                ensureRootIsScheduled(root);
                schedulePendingInteractions(root, Sync);
              }
              return;
            }
          }
          fiber = fiber.return;
        }
      }
      function pingSuspendedRoot(root, thenable, suspendedTime) {
        var pingCache = root.pingCache;
        if (pingCache !== null) {
          // The thenable resolved, so we no longer need to memoize, because it will
          // never be thrown again.
          pingCache.delete(thenable);
        }
        if (workInProgressRoot === root && renderExpirationTime$1 === suspendedTime) {
          // Received a ping at the same priority level at which we're currently
          // rendering. We might want to restart this render. This should mirror
          // the logic of whether or not a root suspends once it completes.
          // TODO: If we're rendering sync either due to Sync, Batched or expired,
          // we should probably never restart.
          // If we're suspended with delay, we'll always suspend so we can always
          // restart. If we're suspended without any updates, it might be a retry.
          // If it's early in the retry we can restart. We can't know for sure
          // whether we'll eventually process an update during this render pass,
          // but it's somewhat unlikely that we get to a ping before that, since
          // getting to the root most update is usually very fast.
          if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && workInProgressRootLatestProcessedExpirationTime === Sync && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
            // Restart from the root. Don't need to schedule a ping because
            // we're already working on this tree.
            prepareFreshStack(root, renderExpirationTime$1);
          } else {
            // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootHasPendingPing = true;
          }
          return;
        }
        if (!isRootSuspendedAtTime(root, suspendedTime)) {
          // The root is no longer suspended at this time.
          return;
        }
        var lastPingedTime = root.lastPingedTime;
        if (lastPingedTime !== NoWork && lastPingedTime < suspendedTime) {
          // There's already a lower priority ping scheduled.
          return;
        } // Mark the time at which this ping was scheduled.

        root.lastPingedTime = suspendedTime;
        ensureRootIsScheduled(root);
        schedulePendingInteractions(root, suspendedTime);
      }
      function retryTimedOutBoundary(boundaryFiber, retryTime) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryTime === NoWork) {
          var suspenseConfig = null; // Retries don't carry over the already committed update.

          var currentTime = requestCurrentTimeForUpdate();
          retryTime = computeExpirationForFiber(currentTime, boundaryFiber, suspenseConfig);
        } // TODO: Special case idle priority?

        var root = markUpdateTimeFromFiberToRoot(boundaryFiber, retryTime);
        if (root !== null) {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, retryTime);
        }
      }
      function resolveRetryThenable(boundaryFiber, thenable) {
        var retryTime = NoWork; // Default

        var retryCache;
        {
          retryCache = boundaryFiber.stateNode;
        }
        if (retryCache !== null) {
          // The thenable resolved, so we no longer need to memoize, because it will
          // never be thrown again.
          retryCache.delete(thenable);
        }
        retryTimedOutBoundary(boundaryFiber, retryTime);
      } // Computes the next Just Noticeable Difference (JND) boundary.
      // The theory is that a person can't tell the difference between small differences in time.
      // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
      // difference in the experience. However, waiting for longer might mean that we can avoid
      // showing an intermediate loading state. The longer we have already waited, the harder it
      // is to tell small differences in time. Therefore, the longer we've already waited,
      // the longer we can wait additionally. At some point we have to give up though.
      // We pick a train model where the next boundary commits at a consistent schedule.
      // These particular numbers are vague estimates. We expect to adjust them based on research.

      function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
      }
      function computeMsUntilSuspenseLoadingDelay(mostRecentEventTime, committedExpirationTime, suspenseConfig) {
        var busyMinDurationMs = suspenseConfig.busyMinDurationMs | 0;
        if (busyMinDurationMs <= 0) {
          return 0;
        }
        var busyDelayMs = suspenseConfig.busyDelayMs | 0; // Compute the time until this render pass would expire.

        var currentTimeMs = now();
        var eventTimeMs = inferTimeFromExpirationTimeWithSuspenseConfig(mostRecentEventTime, suspenseConfig);
        var timeElapsed = currentTimeMs - eventTimeMs;
        if (timeElapsed <= busyDelayMs) {
          // If we haven't yet waited longer than the initial delay, we don't
          // have to wait any additional time.
          return 0;
        }
        var msUntilTimeout = busyDelayMs + busyMinDurationMs - timeElapsed; // This is the value that is passed to `setTimeout`.

        return msUntilTimeout;
      }
      function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
          nestedUpdateCount = 0;
          rootWithNestedUpdates = null;
          {
            {
              throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
            }
          }
        }
        {
          if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
          }
        }
      }
      function flushRenderPhaseStrictModeWarningsInDEV() {
        {
          ReactStrictModeWarnings.flushLegacyContextWarning();
          {
            ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
          }
        }
      }
      function stopFinishedWorkLoopTimer() {
        var didCompleteRoot = true;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
      }
      function stopInterruptedWorkLoopTimer() {
        // TODO: Track which fiber caused the interruption.
        var didCompleteRoot = false;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
      }
      function checkForInterruption(fiberThatReceivedUpdate, updateExpirationTime) {
        if (workInProgressRoot !== null && updateExpirationTime > renderExpirationTime$1) {
          interruptedBy = fiberThatReceivedUpdate;
        }
      }
      var didWarnStateUpdateForUnmountedComponent = null;
      function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        {
          var tag = fiber.tag;
          if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
            // Only warn for user-defined components, not internal ones like Suspense.
            return;
          }
          // the problematic code almost always lies inside that component.

          var componentName = getComponentName(fiber.type) || 'ReactComponent';
          if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
              return;
            }
            didWarnStateUpdateForUnmountedComponent.add(componentName);
          } else {
            didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
          }
          error("Can't perform a React state update on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.%s', tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function', getStackByFiberInDevAndProd(fiber));
        }
      }
      var beginWork$1;
      {
        var dummyFiber = null;
        beginWork$1 = function beginWork$1(current, unitOfWork, expirationTime) {
          // If a component throws an error, we replay it again in a synchronously
          // dispatched event, so that the debugger will treat it as an uncaught
          // error See ReactErrorUtils for more information.
          // Before entering the begin phase, copy the work-in-progress onto a dummy
          // fiber. If beginWork throws, we'll use this to reset the state.
          var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
          try {
            return beginWork(current, unitOfWork, expirationTime);
          } catch (originalError) {
            if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
              // Don't replay promises. Treat everything else like an error.
              throw originalError;
            } // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.

            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame

            unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.

            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) {
              // Reset the profiler timer.
              startProfilerTimer(unitOfWork);
            } // Run beginWork again.

            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, expirationTime);
            if (hasCaughtError()) {
              var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
              // Rethrow this error instead of the original one.

              throw replayError;
            } else {
              // This branch is reachable if the render phase is impure.
              throw originalError;
            }
          }
        };
      }
      var didWarnAboutUpdateInRender = false;
      var didWarnAboutUpdateInRenderForAnotherComponent;
      {
        didWarnAboutUpdateInRenderForAnotherComponent = new Set();
      }
      function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        {
          if (isRendering && (executionContext & RenderContext) !== NoContext) {
            switch (fiber.tag) {
              case FunctionComponent:
              case ForwardRef:
              case SimpleMemoComponent:
                {
                  var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.

                  var dedupeKey = renderingComponentName;
                  if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || 'Unknown';
                    error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://fb.me/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
                  }
                  break;
                }
              case ClassComponent:
                {
                  if (!didWarnAboutUpdateInRender) {
                    error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');
                    didWarnAboutUpdateInRender = true;
                  }
                  break;
                }
            }
          }
        }
      } // a 'shared' variable that changes when act() opens/closes in tests.

      var IsThisRendererActing = {
        current: false
      };
      function warnIfNotScopedWithMatchingAct(fiber) {
        {
          if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
            error("It looks like you're using the wrong act() around your test interactions.\n" + 'Be sure to use the matching version of act() corresponding to your renderer:\n\n' + '// for react-dom:\n' + "import {act} from 'react-dom/test-utils';\n" + '// ...\n' + 'act(() => ...);\n\n' + '// for react-test-renderer:\n' + "import TestRenderer from 'react-test-renderer';\n" + 'const {act} = TestRenderer;\n' + '// ...\n' + 'act(() => ...);' + '%s', getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        {
          if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            error('An update to %s ran an effect, but was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://fb.me/react-wrap-tests-with-act' + '%s', getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        {
          if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://fb.me/react-wrap-tests-with-act' + '%s', getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.

      var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
      // scheduler is the actual recommendation. The alternative could be a testing build,
      // a new lib, or whatever; we dunno just yet. This message is for early adopters
      // to get their tests right.

      function warnIfUnmockedScheduler(fiber) {
        {
          if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
              didWarnAboutUnmockedScheduler = true;
              error('In Concurrent or Sync modes, the "scheduler" module needs to be mocked ' + 'to guarantee consistent behaviour across tests and browsers. ' + 'For example, with jest: \n' + "jest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\n" + 'For more info, visit https://fb.me/react-mock-scheduler');
            }
          }
        }
      }
      function computeThreadID(root, expirationTime) {
        // Interaction threads are unique per root and expiration time.
        return expirationTime * 1000 + root.interactionThreadID;
      }
      function markSpawnedWork(expirationTime) {
        if (spawnedWorkDuringRender === null) {
          spawnedWorkDuringRender = [expirationTime];
        } else {
          spawnedWorkDuringRender.push(expirationTime);
        }
      }
      function scheduleInteractions(root, expirationTime, interactions) {
        if (interactions.size > 0) {
          var pendingInteractionMap = root.pendingInteractionMap;
          var pendingInteractions = pendingInteractionMap.get(expirationTime);
          if (pendingInteractions != null) {
            interactions.forEach(function (interaction) {
              if (!pendingInteractions.has(interaction)) {
                // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
              }
              pendingInteractions.add(interaction);
            });
          } else {
            pendingInteractionMap.set(expirationTime, new Set(interactions)); // Update the pending async work count for the current interactions.

            interactions.forEach(function (interaction) {
              interaction.__count++;
            });
          }
          var subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null) {
            var threadID = computeThreadID(root, expirationTime);
            subscriber.onWorkScheduled(interactions, threadID);
          }
        }
      }
      function schedulePendingInteractions(root, expirationTime) {
        scheduleInteractions(root, expirationTime, tracing$1.__interactionsRef.current);
      }
      function startWorkOnPendingInteractions(root, expirationTime) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.

        var interactions = new Set();
        root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledExpirationTime) {
          if (scheduledExpirationTime >= expirationTime) {
            scheduledInteractions.forEach(function (interaction) {
              return interactions.add(interaction);
            });
          }
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.

        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
          var subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null) {
            var threadID = computeThreadID(root, expirationTime);
            try {
              subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
              // If the subscriber throws, rethrow it in a separate task
              scheduleCallback(ImmediatePriority, function () {
                throw error;
              });
            }
          }
        }
      }
      function finishPendingInteractions(root, committedExpirationTime) {
        var earliestRemainingTimeAfterCommit = root.firstPendingTime;
        var subscriber;
        try {
          subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null && root.memoizedInteractions.size > 0) {
            var threadID = computeThreadID(root, committedExpirationTime);
            subscriber.onWorkStopped(root.memoizedInteractions, threadID);
          }
        } catch (error) {
          // If the subscriber throws, rethrow it in a separate task
          scheduleCallback(ImmediatePriority, function () {
            throw error;
          });
        } finally {
          // Clear completed interactions from the pending Map.
          // Unless the render was suspended or cascading work was scheduled,
          // In which case– leave pending interactions until the subsequent render.
          var pendingInteractionMap = root.pendingInteractionMap;
          pendingInteractionMap.forEach(function (scheduledInteractions, scheduledExpirationTime) {
            // Only decrement the pending interaction count if we're done.
            // If there's still work at the current priority,
            // That indicates that we are waiting for suspense data.
            if (scheduledExpirationTime > earliestRemainingTimeAfterCommit) {
              pendingInteractionMap.delete(scheduledExpirationTime);
              scheduledInteractions.forEach(function (interaction) {
                interaction.__count--;
                if (subscriber !== null && interaction.__count === 0) {
                  try {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority, function () {
                      throw error;
                    });
                  }
                }
              });
            }
          });
        }
      }
      var onScheduleFiberRoot = null;
      var onCommitFiberRoot = null;
      var onCommitFiberUnmount = null;
      var hasLoggedError = false;
      var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
      function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
          // No DevTools
          return false;
        }
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) {
          // This isn't a real property on the hook, but it can be set to opt out
          // of DevTools integration and associated warnings and logs.
          // https://github.com/facebook/react/issues/3877
          return true;
        }
        if (!hook.supportsFiber) {
          {
            error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://fb.me/react-devtools');
          } // DevTools exists, even though it doesn't support Fiber.

          return true;
        }
        try {
          var rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

          {
            // Only used by Fast Refresh
            if (typeof hook.onScheduleFiberRoot === 'function') {
              onScheduleFiberRoot = function onScheduleFiberRoot(root, children) {
                try {
                  hook.onScheduleFiberRoot(rendererID, root, children);
                } catch (err) {
                  if (!hasLoggedError) {
                    hasLoggedError = true;
                    error('React instrumentation encountered an error: %s', err);
                  }
                }
              };
            }
          }
          onCommitFiberRoot = function onCommitFiberRoot(root, expirationTime) {
            try {
              var didError = (root.current.effectTag & DidCapture) === DidCapture;
              {
                var currentTime = getCurrentTime();
                var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime);
                hook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
              }
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          };
          onCommitFiberUnmount = function onCommitFiberUnmount(fiber) {
            try {
              hook.onCommitFiberUnmount(rendererID, fiber);
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          };
        } catch (err) {
          // Catch all errors because it is unsafe to throw during initialization.
          {
            error('React instrumentation encountered an error: %s.', err);
          }
        } // DevTools exists

        return true;
      }
      function onScheduleRoot(root, children) {
        if (typeof onScheduleFiberRoot === 'function') {
          onScheduleFiberRoot(root, children);
        }
      }
      function onCommitRoot(root, expirationTime) {
        if (typeof onCommitFiberRoot === 'function') {
          onCommitFiberRoot(root, expirationTime);
        }
      }
      function onCommitUnmount(fiber) {
        if (typeof onCommitFiberUnmount === 'function') {
          onCommitFiberUnmount(fiber);
        }
      }
      var hasBadMapPolyfill;
      {
        hasBadMapPolyfill = false;
        try {
          var nonExtensibleObject = Object.preventExtensions({});
          var testMap = new Map([[nonExtensibleObject, null]]);
          var testSet = new Set([nonExtensibleObject]); // This is necessary for Rollup to not consider these unused.
          // https://github.com/rollup/rollup/issues/1771
          // TODO: we can remove these if Rollup fixes the bug.

          testMap.set(0, 0);
          testSet.add(0);
        } catch (e) {
          // TODO: Consider warning about bad polyfills
          hasBadMapPolyfill = true;
        }
      }
      var debugCounter = 1;
      function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber

        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects

        this.effectTag = NoEffect;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.expirationTime = NoWork;
        this.childExpirationTime = NoWork;
        this.alternate = null;
        {
          // Note: The following is done to avoid a v8 performance cliff.
          //
          // Initializing the fields below to smis and later updating them with
          // double values will cause Fibers to end up having separate shapes.
          // This behavior/bug has something to do with Object.preventExtension().
          // Fortunately this only impacts DEV builds.
          // Unfortunately it makes React unusably slow for some applications.
          // To work around this, initialize the fields below with doubles.
          //
          // Learn more about this here:
          // https://github.com/facebook/react/issues/14365
          // https://bugs.chromium.org/p/v8/issues/detail?id=8538
          this.actualDuration = Number.NaN;
          this.actualStartTime = Number.NaN;
          this.selfBaseDuration = Number.NaN;
          this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
          // This won't trigger the performance cliff mentioned above,
          // and it simplifies other profiler code (including DevTools).

          this.actualDuration = 0;
          this.actualStartTime = -1;
          this.selfBaseDuration = 0;
          this.treeBaseDuration = 0;
        } // This is normally DEV-only except www when it adds listeners.
        // TODO: remove the User Timing integration in favor of Root Events.

        {
          this._debugID = debugCounter++;
          this._debugIsCurrentlyTiming = false;
        }
        {
          this._debugSource = null;
          this._debugOwner = null;
          this._debugNeedsRemount = false;
          this._debugHookTypes = null;
          if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
            Object.preventExtensions(this);
          }
        }
      } // This is a constructor function, rather than a POJO constructor, still
      // please ensure we do the following:
      // 1) Nobody should add any instance methods on this. Instance methods can be
      //    more difficult to predict when they get optimized and they are almost
      //    never inlined properly in static compilers.
      // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
      //    always know when it is a fiber.
      // 3) We might want to experiment with using numeric keys since they are easier
      //    to optimize in a non-JIT environment.
      // 4) We can easily go from a constructor to a createFiber object literal if that
      //    is faster.
      // 5) It should be easy to port this to a C struct and keep a C implementation
      //    compatible.

      var createFiber = function createFiber(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
      };
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct(type) && type.defaultProps === undefined;
      }
      function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') {
          return shouldConstruct(Component) ? ClassComponent : FunctionComponent;
        } else if (Component !== undefined && Component !== null) {
          var $$typeof = Component.$$typeof;
          if ($$typeof === REACT_FORWARD_REF_TYPE) {
            return ForwardRef;
          }
          if ($$typeof === REACT_MEMO_TYPE) {
            return MemoComponent;
          }
        }
        return IndeterminateComponent;
      } // This is used to create an alternate fiber to do work on.

      function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
          // We use a double buffering pooling technique because we know that we'll
          // only ever need at most two versions of a tree. We pool the "other" unused
          // node that we're free to reuse. This is lazily created to avoid allocating
          // extra objects for things that are never updated. It also allow us to
          // reclaim the extra memory if needed.
          workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
          workInProgress.elementType = current.elementType;
          workInProgress.type = current.type;
          workInProgress.stateNode = current.stateNode;
          {
            // DEV-only fields
            {
              workInProgress._debugID = current._debugID;
            }
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
          }
          workInProgress.alternate = current;
          current.alternate = workInProgress;
        } else {
          workInProgress.pendingProps = pendingProps; // We already have an alternate.
          // Reset the effect tag.

          workInProgress.effectTag = NoEffect; // The effect list is no longer valid.

          workInProgress.nextEffect = null;
          workInProgress.firstEffect = null;
          workInProgress.lastEffect = null;
          {
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
          }
        }
        workInProgress.childExpirationTime = current.childExpirationTime;
        workInProgress.expirationTime = current.expirationTime;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.

        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
          expirationTime: currentDependencies.expirationTime,
          firstContext: currentDependencies.firstContext,
          responders: currentDependencies.responders
        }; // These will be overridden during the parent's reconciliation

        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        {
          workInProgress.selfBaseDuration = current.selfBaseDuration;
          workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        {
          workInProgress._debugNeedsRemount = current._debugNeedsRemount;
          switch (workInProgress.tag) {
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
              workInProgress.type = resolveFunctionForHotReloading(current.type);
              break;
            case ClassComponent:
              workInProgress.type = resolveClassForHotReloading(current.type);
              break;
            case ForwardRef:
              workInProgress.type = resolveForwardRefForHotReloading(current.type);
              break;
          }
        }
        return workInProgress;
      } // Used to reuse a Fiber for a second pass.

      function resetWorkInProgress(workInProgress, renderExpirationTime) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.effectTag &= Placement; // The effect list is no longer valid.

        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
          // Reset to createFiber's initial values.
          workInProgress.childExpirationTime = NoWork;
          workInProgress.expirationTime = renderExpirationTime;
          workInProgress.child = null;
          workInProgress.memoizedProps = null;
          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null;
          workInProgress.dependencies = null;
          {
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
          }
        } else {
          // Reset to the cloned values that createWorkInProgress would've.
          workInProgress.childExpirationTime = current.childExpirationTime;
          workInProgress.expirationTime = current.expirationTime;
          workInProgress.child = current.child;
          workInProgress.memoizedProps = current.memoizedProps;
          workInProgress.memoizedState = current.memoizedState;
          workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
          // it cannot be shared with the current fiber.

          var currentDependencies = current.dependencies;
          workInProgress.dependencies = currentDependencies === null ? null : {
            expirationTime: currentDependencies.expirationTime,
            firstContext: currentDependencies.firstContext,
            responders: currentDependencies.responders
          };
          {
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
          }
        }
        return workInProgress;
      }
      function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) {
          mode = ConcurrentMode | BlockingMode | StrictMode;
        } else if (tag === BlockingRoot) {
          mode = BlockingMode | StrictMode;
        } else {
          mode = NoMode;
        }
        if (isDevToolsPresent) {
          // Always collect profile timings when DevTools are present.
          // This enables DevTools to start capturing timing at any point–
          // Without some nodes in the tree having empty base times.
          mode |= ProfileMode;
        }
        return createFiber(HostRoot, null, null, mode);
      }
      function createFiberFromTypeAndProps(type,
      // React$ElementType
      key, pendingProps, owner, mode, expirationTime) {
        var fiber;
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.

        var resolvedType = type;
        if (typeof type === 'function') {
          if (shouldConstruct(type)) {
            fiberTag = ClassComponent;
            {
              resolvedType = resolveClassForHotReloading(resolvedType);
            }
          } else {
            {
              resolvedType = resolveFunctionForHotReloading(resolvedType);
            }
          }
        } else if (typeof type === 'string') {
          fiberTag = HostComponent;
        } else {
          getTag: switch (type) {
            case REACT_FRAGMENT_TYPE:
              return createFiberFromFragment(pendingProps.children, mode, expirationTime, key);
            case REACT_CONCURRENT_MODE_TYPE:
              fiberTag = Mode;
              mode |= ConcurrentMode | BlockingMode | StrictMode;
              break;
            case REACT_STRICT_MODE_TYPE:
              fiberTag = Mode;
              mode |= StrictMode;
              break;
            case REACT_PROFILER_TYPE:
              return createFiberFromProfiler(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_TYPE:
              return createFiberFromSuspense(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_LIST_TYPE:
              return createFiberFromSuspenseList(pendingProps, mode, expirationTime, key);
            default:
              {
                if (typeof type === 'object' && type !== null) {
                  switch (type.$$typeof) {
                    case REACT_PROVIDER_TYPE:
                      fiberTag = ContextProvider;
                      break getTag;
                    case REACT_CONTEXT_TYPE:
                      // This is a consumer
                      fiberTag = ContextConsumer;
                      break getTag;
                    case REACT_FORWARD_REF_TYPE:
                      fiberTag = ForwardRef;
                      {
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                      }
                      break getTag;
                    case REACT_MEMO_TYPE:
                      fiberTag = MemoComponent;
                      break getTag;
                    case REACT_LAZY_TYPE:
                      fiberTag = LazyComponent;
                      resolvedType = null;
                      break getTag;
                    case REACT_BLOCK_TYPE:
                      fiberTag = Block;
                      break getTag;
                  }
                }
                var info = '';
                {
                  if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                    info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                  }
                  var ownerName = owner ? getComponentName(owner.type) : null;
                  if (ownerName) {
                    info += '\n\nCheck the render method of `' + ownerName + '`.';
                  }
                }
                {
                  {
                    throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
                  }
                }
              }
          }
        }
        fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromElement(element, mode, expirationTime) {
        var owner = null;
        {
          owner = element._owner;
        }
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime);
        {
          fiber._debugSource = element._source;
          fiber._debugOwner = element._owner;
        }
        return fiber;
      }
      function createFiberFromFragment(elements, mode, expirationTime, key) {
        var fiber = createFiber(Fragment$$1, elements, key, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromProfiler(pendingProps, mode, expirationTime, key) {
        {
          if (typeof pendingProps.id !== 'string' || typeof pendingProps.onRender !== 'function') {
            error('Profiler must specify an "id" string and "onRender" function as props');
          }
        }
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.

        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromSuspense(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.

        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromSuspenseList(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        {
          // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
          // This needs to be fixed in getComponentName so that it relies on the tag
          // instead.
          fiber.type = REACT_SUSPENSE_LIST_TYPE;
        }
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromText(content, mode, expirationTime) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.

        fiber.elementType = 'DELETED';
        fiber.type = 'DELETED';
        return fiber;
      }
      function createFiberFromPortal(portal, mode, expirationTime) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.expirationTime = expirationTime;
        fiber.stateNode = {
          containerInfo: portal.containerInfo,
          pendingChildren: null,
          // Used by persistent updates
          implementation: portal.implementation
        };
        return fiber;
      } // Used for stashing WIP properties to replay failed work in DEV.

      function assignFiberPropertiesInDEV(target, source) {
        if (target === null) {
          // This Fiber's initial properties will always be overwritten.
          // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
          target = createFiber(IndeterminateComponent, null, null, NoMode);
        } // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.

        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.effectTag = source.effectTag;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.expirationTime = source.expirationTime;
        target.childExpirationTime = source.childExpirationTime;
        target.alternate = source.alternate;
        {
          target.actualDuration = source.actualDuration;
          target.actualStartTime = source.actualStartTime;
          target.selfBaseDuration = source.selfBaseDuration;
          target.treeBaseDuration = source.treeBaseDuration;
        }
        {
          target._debugID = source._debugID;
        }
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugIsCurrentlyTiming = source._debugIsCurrentlyTiming;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
      }
      function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.current = null;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.pingCache = null;
        this.finishedExpirationTime = NoWork;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoPriority;
        this.firstPendingTime = NoWork;
        this.firstSuspendedTime = NoWork;
        this.lastSuspendedTime = NoWork;
        this.nextKnownPendingLevel = NoWork;
        this.lastPingedTime = NoWork;
        this.lastExpiredTime = NoWork;
        {
          this.interactionThreadID = tracing$1.unstable_getThreadID();
          this.memoizedInteractions = new Set();
          this.pendingInteractionMap = new Map();
        }
      }
      function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.

        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
      }
      function isRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        return firstSuspendedTime !== NoWork && firstSuspendedTime >= expirationTime && lastSuspendedTime <= expirationTime;
      }
      function markRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        if (firstSuspendedTime < expirationTime) {
          root.firstSuspendedTime = expirationTime;
        }
        if (lastSuspendedTime > expirationTime || firstSuspendedTime === NoWork) {
          root.lastSuspendedTime = expirationTime;
        }
        if (expirationTime <= root.lastPingedTime) {
          root.lastPingedTime = NoWork;
        }
        if (expirationTime <= root.lastExpiredTime) {
          root.lastExpiredTime = NoWork;
        }
      }
      function markRootUpdatedAtTime(root, expirationTime) {
        // Update the range of pending times
        var firstPendingTime = root.firstPendingTime;
        if (expirationTime > firstPendingTime) {
          root.firstPendingTime = expirationTime;
        } // Update the range of suspended times. Treat everything lower priority or
        // equal to this update as unsuspended.

        var firstSuspendedTime = root.firstSuspendedTime;
        if (firstSuspendedTime !== NoWork) {
          if (expirationTime >= firstSuspendedTime) {
            // The entire suspended range is now unsuspended.
            root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
          } else if (expirationTime >= root.lastSuspendedTime) {
            root.lastSuspendedTime = expirationTime + 1;
          } // This is a pending level. Check if it's higher priority than the next
          // known pending level.

          if (expirationTime > root.nextKnownPendingLevel) {
            root.nextKnownPendingLevel = expirationTime;
          }
        }
      }
      function markRootFinishedAtTime(root, finishedExpirationTime, remainingExpirationTime) {
        // Update the range of pending times
        root.firstPendingTime = remainingExpirationTime; // Update the range of suspended times. Treat everything higher priority or
        // equal to this update as unsuspended.

        if (finishedExpirationTime <= root.lastSuspendedTime) {
          // The entire suspended range is now unsuspended.
          root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
        } else if (finishedExpirationTime <= root.firstSuspendedTime) {
          // Part of the suspended range is now unsuspended. Narrow the range to
          // include everything between the unsuspended time (non-inclusive) and the
          // last suspended time.
          root.firstSuspendedTime = finishedExpirationTime - 1;
        }
        if (finishedExpirationTime <= root.lastPingedTime) {
          // Clear the pinged time
          root.lastPingedTime = NoWork;
        }
        if (finishedExpirationTime <= root.lastExpiredTime) {
          // Clear the expired time
          root.lastExpiredTime = NoWork;
        }
      }
      function markRootExpiredAtTime(root, expirationTime) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime === NoWork || lastExpiredTime > expirationTime) {
          root.lastExpiredTime = expirationTime;
        }
      }
      var didWarnAboutNestedUpdates;
      var didWarnAboutFindNodeInStrictMode;
      {
        didWarnAboutNestedUpdates = false;
        didWarnAboutFindNodeInStrictMode = {};
      }
      function getContextForSubtree(parentComponent) {
        if (!parentComponent) {
          return emptyContextObject;
        }
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
          var Component = fiber.type;
          if (isContextProvider(Component)) {
            return processChildContext(fiber, Component, parentContext);
          }
        }
        return parentContext;
      }
      function findHostInstanceWithWarning(component, methodName) {
        {
          var fiber = get(component);
          if (fiber === undefined) {
            if (typeof component.render === 'function') {
              {
                {
                  throw Error("Unable to find node on an unmounted component.");
                }
              }
            } else {
              {
                {
                  throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
                }
              }
            }
          }
          var hostFiber = findCurrentHostFiber(fiber);
          if (hostFiber === null) {
            return null;
          }
          if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
              didWarnAboutFindNodeInStrictMode[componentName] = true;
              if (fiber.mode & StrictMode) {
                error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-find-node%s', methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
              } else {
                error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-find-node%s', methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
              }
            }
          }
          return hostFiber.stateNode;
        }
      }
      function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
      }
      function updateContainer(element, container, parentComponent, callback) {
        {
          onScheduleRoot(container, element);
        }
        var current$1 = container.current;
        var currentTime = requestCurrentTimeForUpdate();
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
          }
        }
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, current$1, suspenseConfig);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) {
          container.context = context;
        } else {
          container.pendingContext = context;
        }
        {
          if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
          }
        }
        var update = createUpdate(expirationTime, suspenseConfig); // Caution: React DevTools currently depends on this property
        // being called "element".

        update.payload = {
          element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
          {
            if (typeof callback !== 'function') {
              error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
            }
          }
          update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleWork(current$1, expirationTime);
        return expirationTime;
      }
      function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) {
          return null;
        }
        switch (containerFiber.child.tag) {
          case HostComponent:
            return getPublicInstance(containerFiber.child.stateNode);
          default:
            return containerFiber.child.stateNode;
        }
      }
      function markRetryTimeImpl(fiber, retryTime) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) {
          if (suspenseState.retryTime < retryTime) {
            suspenseState.retryTime = retryTime;
          }
        }
      } // Increases the priority of thennables when they resolve within this boundary.

      function markRetryTimeIfNotHydrated(fiber, retryTime) {
        markRetryTimeImpl(fiber, retryTime);
        var alternate = fiber.alternate;
        if (alternate) {
          markRetryTimeImpl(alternate, retryTime);
        }
      }
      function attemptUserBlockingHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          // We ignore HostRoots here because we can't increase
          // their priority and they should not suspend on I/O,
          // since you have to wrap anything that might suspend in
          // Suspense.
          return;
        }
        var expTime = computeInteractiveExpiration(requestCurrentTimeForUpdate());
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
      }
      function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          // We ignore HostRoots here because we can't increase
          // their priority and they should not suspend on I/O,
          // since you have to wrap anything that might suspend in
          // Suspense.
          return;
        }
        scheduleWork(fiber, ContinuousHydration);
        markRetryTimeIfNotHydrated(fiber, ContinuousHydration);
      }
      function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          // We ignore HostRoots here because we can't increase
          // their priority other than synchronously flush it.
          return;
        }
        var currentTime = requestCurrentTimeForUpdate();
        var expTime = computeExpirationForFiber(currentTime, fiber, null);
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
      }
      function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) {
          return null;
        }
        if (hostFiber.tag === FundamentalComponent) {
          return hostFiber.stateNode.instance;
        }
        return hostFiber.stateNode;
      }
      var shouldSuspendImpl = function shouldSuspendImpl(fiber) {
        return false;
      };
      function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
      }
      var overrideHookState = null;
      var overrideProps = null;
      var scheduleUpdate = null;
      var setSuspenseHandler = null;
      {
        var copyWithSetImpl = function copyWithSetImpl(obj, path, idx, value) {
          if (idx >= path.length) {
            return value;
          }
          var key = path[idx];
          var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here

          updated[key] = copyWithSetImpl(obj[key], path, idx + 1, value);
          return updated;
        };
        var copyWithSet = function copyWithSet(obj, path, value) {
          return copyWithSetImpl(obj, path, 0, value);
        }; // Support DevTools editable values for useState and useReducer.

        overrideHookState = function overrideHookState(fiber, id, path, value) {
          // For now, the "id" of stateful hooks is just the stateful hook index.
          // This may change in the future with e.g. nested hooks.
          var currentHook = fiber.memoizedState;
          while (currentHook !== null && id > 0) {
            currentHook = currentHook.next;
            id--;
          }
          if (currentHook !== null) {
            var newState = copyWithSet(currentHook.memoizedState, path, value);
            currentHook.memoizedState = newState;
            currentHook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.

            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleWork(fiber, Sync);
          }
        }; // Support DevTools props for function components, forwardRef, memo, host components, etc.

        overrideProps = function overrideProps(fiber, path, value) {
          fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }
          scheduleWork(fiber, Sync);
        };
        scheduleUpdate = function scheduleUpdate(fiber) {
          scheduleWork(fiber, Sync);
        };
        setSuspenseHandler = function setSuspenseHandler(newShouldSuspendImpl) {
          shouldSuspendImpl = newShouldSuspendImpl;
        };
      }
      function injectIntoDevTools(devToolsConfig) {
        var _findFiberByHostInstance2 = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals(_assign({}, devToolsConfig, {
          overrideHookState: overrideHookState,
          overrideProps: overrideProps,
          setSuspenseHandler: setSuspenseHandler,
          scheduleUpdate: scheduleUpdate,
          currentDispatcherRef: ReactCurrentDispatcher,
          findHostInstanceByFiber: function findHostInstanceByFiber(fiber) {
            var hostFiber = findCurrentHostFiber(fiber);
            if (hostFiber === null) {
              return null;
            }
            return hostFiber.stateNode;
          },
          findFiberByHostInstance: function findFiberByHostInstance(instance) {
            if (!_findFiberByHostInstance2) {
              // Might not be implemented by the renderer.
              return null;
            }
            return _findFiberByHostInstance2(instance);
          },
          // React Refresh
          findHostInstancesForRefresh: findHostInstancesForRefresh,
          scheduleRefresh: scheduleRefresh,
          scheduleRoot: scheduleRoot,
          setRefreshHandler: setRefreshHandler,
          // Enables DevTools to append owner stacks to error messages in DEV mode.
          getCurrentFiber: function getCurrentFiber() {
            return current;
          }
        }));
      }
      var IsSomeRendererActing$1 = ReactSharedInternals.IsSomeRendererActing;
      function ReactDOMRoot(container, options) {
        this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
      }
      function ReactDOMBlockingRoot(container, tag, options) {
        this._internalRoot = createRootImpl(container, tag, options);
      }
      ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function (children) {
        var root = this._internalRoot;
        {
          if (typeof arguments[1] === 'function') {
            error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
          }
          var container = root.containerInfo;
          if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
              if (hostInstance.parentNode !== container) {
                error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + "root.unmount() to empty a root's container.");
              }
            }
          }
        }
        updateContainer(children, root, null, null);
      };
      ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function () {
        {
          if (typeof arguments[0] === 'function') {
            error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
          }
        }
        var root = this._internalRoot;
        var container = root.containerInfo;
        updateContainer(null, root, null, function () {
          unmarkContainerAsRoot(container);
        });
      };
      function createRootImpl(container, tag, options) {
        // Tag is either LegacyRoot or Concurrent Root
        var hydrate = options != null && options.hydrate === true;
        var hydrationCallbacks = options != null && options.hydrationOptions || null;
        var root = createContainer(container, tag, hydrate);
        markContainerAsRoot(root.current, container);
        if (hydrate && tag !== LegacyRoot) {
          var doc = container.nodeType === DOCUMENT_NODE ? container : container.ownerDocument;
          eagerlyTrapReplayableEvents(container, doc);
        }
        return root;
      }
      function createLegacyRoot(container, options) {
        return new ReactDOMBlockingRoot(container, LegacyRoot, options);
      }
      function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
      }
      var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
      var topLevelUpdateWarnings;
      var warnedAboutHydrateAPI = false;
      {
        topLevelUpdateWarnings = function topLevelUpdateWarnings(container) {
          if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
            if (hostInstance) {
              if (hostInstance.parentNode !== container) {
                error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
              }
            }
          }
          var isRootRenderedBySomeReact = !!container._reactRootContainer;
          var rootEl = getReactRootElementInContainer(container);
          var hasNonRootReactChild = !!(rootEl && getInstanceFromNode$1(rootEl));
          if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
            error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
          }
          if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
            error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
          }
        };
      }
      function getReactRootElementInContainer(container) {
        if (!container) {
          return null;
        }
        if (container.nodeType === DOCUMENT_NODE) {
          return container.documentElement;
        } else {
          return container.firstChild;
        }
      }
      function shouldHydrateDueToLegacyHeuristic(container) {
        var rootElement = getReactRootElementInContainer(container);
        return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
      }
      function legacyCreateRootFromDOMContainer(container, forceHydrate) {
        var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.

        if (!shouldHydrate) {
          var warned = false;
          var rootSibling;
          while (rootSibling = container.lastChild) {
            {
              if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                warned = true;
                error('render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.');
              }
            }
            container.removeChild(rootSibling);
          }
        }
        {
          if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
            warnedAboutHydrateAPI = true;
            warn('render(): Calling ReactDOM.render() to hydrate server-rendered markup ' + 'will stop working in React v17. Replace the ReactDOM.render() call ' + 'with ReactDOM.hydrate() if you want React to attach to the server HTML.');
          }
        }
        return createLegacyRoot(container, shouldHydrate ? {
          hydrate: true
        } : undefined);
      }
      function warnOnInvalidCallback$1(callback, callerName) {
        {
          if (callback !== null && typeof callback !== 'function') {
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        }
      }
      function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        {
          topLevelUpdateWarnings(container);
          warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        } // TODO: Without `any` type, Flow says "Property cannot be accessed on any
        // member of intersection type." Whyyyyyy.

        var root = container._reactRootContainer;
        var fiberRoot;
        if (!root) {
          // Initial mount
          root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
          fiberRoot = root._internalRoot;
          if (typeof callback === 'function') {
            var originalCallback = callback;
            callback = function callback() {
              var instance = getPublicRootInstance(fiberRoot);
              originalCallback.call(instance);
            };
          } // Initial mount should not be batched.

          unbatchedUpdates(function () {
            updateContainer(children, fiberRoot, parentComponent, callback);
          });
        } else {
          fiberRoot = root._internalRoot;
          if (typeof callback === 'function') {
            var _originalCallback = callback;
            callback = function callback() {
              var instance = getPublicRootInstance(fiberRoot);
              _originalCallback.call(instance);
            };
          } // Update

          updateContainer(children, fiberRoot, parentComponent, callback);
        }
        return getPublicRootInstance(fiberRoot);
      }
      function findDOMNode(componentOrElement) {
        {
          var owner = ReactCurrentOwner$3.current;
          if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) {
              error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(owner.type) || 'A component');
            }
            owner.stateNode._warnedAboutRefsInRender = true;
          }
        }
        if (componentOrElement == null) {
          return null;
        }
        if (componentOrElement.nodeType === ELEMENT_NODE) {
          return componentOrElement;
        }
        {
          return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
        }
      }
      function hydrate(element, container, callback) {
        if (!isValidContainer(container)) {
          {
            throw Error("Target container is not a DOM element.");
          }
        }
        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
          if (isModernRoot) {
            error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call createRoot(container, {hydrate: true}).render(element)?');
          }
        } // TODO: throw or warn if we couldn't hydrate?

        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
      }
      function render(element, container, callback) {
        if (!isValidContainer(container)) {
          {
            throw Error("Target container is not a DOM element.");
          }
        }
        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
          if (isModernRoot) {
            error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
          }
        }
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
      }
      function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        if (!isValidContainer(containerNode)) {
          {
            throw Error("Target container is not a DOM element.");
          }
        }
        if (!(parentComponent != null && has(parentComponent))) {
          {
            throw Error("parentComponent must be a valid React Component");
          }
        }
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
      }
      function unmountComponentAtNode(container) {
        if (!isValidContainer(container)) {
          {
            throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
          }
        }
        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
          if (isModernRoot) {
            error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?');
          }
        }
        if (container._reactRootContainer) {
          {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode$1(rootEl);
            if (renderedByDifferentReact) {
              error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.');
            }
          } // Unmount should not be batched.

          unbatchedUpdates(function () {
            legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
              // $FlowFixMe This should probably use `delete container._reactRootContainer`
              container._reactRootContainer = null;
              unmarkContainerAsRoot(container);
            });
          }); // If you call unmountComponentAtNode twice in quick succession, you'll
          // get `true` twice. That's probably fine?

          return true;
        } else {
          {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode$1(_rootEl)); // Check if the container itself is a React root node.

            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) {
              error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
            }
          }
          return false;
        }
      }
      function createPortal$$1(children, containerInfo,
      // TODO: figure out the API for cross-renderer implementation.
      implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return {
          // This tag allow us to uniquely identify this as a React Portal
          $$typeof: REACT_PORTAL_TYPE,
          key: key == null ? null : '' + key,
          children: children,
          containerInfo: containerInfo,
          implementation: implementation
        };
      }
      var ReactVersion = '16.13.1';
      setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
      setAttemptContinuousHydration(attemptContinuousHydration$1);
      setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
      var didWarnAboutUnstableCreatePortal = false;
      {
        if (typeof Map !== 'function' ||
        // $FlowIssue Flow incorrectly thinks Map has no prototype
        Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' ||
        // $FlowIssue Flow incorrectly thinks Set has no prototype
        Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
          error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
        }
      }
      setRestoreImplementation(restoreControlledState$3);
      setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
      function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) {
          {
            throw Error("Target container is not a DOM element.");
          }
        } // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.

        return createPortal$$1(children, container, null, key);
      }
      function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
      }
      function unstable_createPortal(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        {
          if (!didWarnAboutUnstableCreatePortal) {
            didWarnAboutUnstableCreatePortal = true;
            warn('The ReactDOM.unstable_createPortal() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactDOM.createPortal() instead. It has the exact same API, ' + 'but without the "unstable_" prefix.');
          }
        }
        return createPortal$1(children, container, key);
      }
      var Internals = {
        // Keep in sync with ReactDOMUnstableNativeDependencies.js
        // ReactTestUtils.js, and ReactTestUtilsAct.js. This is an array for better minification.
        Events: [getInstanceFromNode$1, getNodeFromInstance$1, getFiberCurrentPropsFromNode$1, injectEventPluginsByName, eventNameDispatchConfigs, accumulateTwoPhaseDispatches, accumulateDirectDispatches, enqueueStateRestore, restoreStateIfNeeded, dispatchEvent, runEventsInBatch, flushPassiveEffects, IsThisRendererActing]
      };
      var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
      });
      {
        if (!foundDevTools && canUseDOM && window.top === window.self) {
          // If we're in Chrome or Firefox, provide a download link if not installed.
          if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.

            if (/^(https?|file):$/.test(protocol)) {
              // eslint-disable-next-line react-internal/no-production-logging
              console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://fb.me/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://fb.me/react-devtools-faq' : ''), 'font-weight:bold');
            }
          }
        }
      }
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
      exports.createPortal = createPortal$1;
      exports.findDOMNode = findDOMNode;
      exports.flushSync = flushSync$$1;
      exports.hydrate = hydrate;
      exports.render = render;
      exports.unmountComponentAtNode = unmountComponentAtNode;
      exports.unstable_batchedUpdates = batchedUpdates$1;
      exports.unstable_createPortal = unstable_createPortal;
      exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
      exports.version = ReactVersion;
    })();
  }
});
var reactDom_development_1 = reactDom_development.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var reactDom_development_2 = reactDom_development.createPortal;
var reactDom_development_3 = reactDom_development.findDOMNode;
var reactDom_development_4 = reactDom_development.flushSync;
var reactDom_development_5 = reactDom_development.hydrate;
var reactDom_development_6 = reactDom_development.render;
var reactDom_development_7 = reactDom_development.unmountComponentAtNode;
var reactDom_development_8 = reactDom_development.unstable_batchedUpdates;
var reactDom_development_9 = reactDom_development.unstable_createPortal;
var reactDom_development_10 = reactDom_development.unstable_renderSubtreeIntoContainer;
var reactDom_development_11 = reactDom_development.version;
var reactDom = createCommonjsModule$1(function (module) {
  function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
      return;
    }
    if (process.env.NODE_ENV !== 'production') {
      // This branch is unreachable because this function is only called
      // in production, but the condition is true only in development.
      // Therefore if the branch is still here, dead code elimination wasn't
      // properly applied.
      // Don't change the message. React DevTools relies on it. Also make sure
      // this message doesn't occur elsewhere in this function, or it will cause
      // a false positive.
      throw new Error('^_^');
    }
    try {
      // Verify that the code above has been dead code eliminated (DCE'd).
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      // DevTools shouldn't crash React, no matter what.
      // We should still report in case we break this code.
      console.error(err);
    }
  }
  if (process.env.NODE_ENV === 'production') {
    // DCE check should happen before ReactDOM bundle executes so that
    // DevTools can report bad minification during injection.
    checkDCE();
    module.exports = reactDom_production_min;
  } else {
    module.exports = reactDom_development;
  }
});
function styleInject$1(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".element-event-handler {\n  width: 100%;\n  cursor: pointer;\n  user-select: none;\n}\n";
styleInject$1(css_248z);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var DEFAULT_VIEW_BOX = '0 0 24 24';
var SvgElement = function SvgElement() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var viewBox = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_VIEW_BOX;
  _classCallCheck(this, SvgElement);
  this.style = style;
  this.paths = paths;
  this.fill = fill;
  this.viewBox = viewBox;
};
var PathElement = function PathElement() {
  var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  _classCallCheck(this, PathElement);
  this.d = d;
  this.fill = fill;
};
var SvgStyle = function SvgStyle() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  _classCallCheck(this, SvgStyle);
  this.width = width;
  this.height = height;
  this.transform = transform;
};
var ReduxAction = function ReduxAction() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  _classCallCheck(this, ReduxAction);
  this.type = type;
  this.payload = payload;
};
var ARROW_FILL = 'inherit';
var ARROW_BACKGROUND_FILL = 'none';
var ARROW_PATHS = [new PathElement('M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z', ARROW_FILL), new PathElement('M0 0h24v24H0V0z', ARROW_BACKGROUND_FILL)];
var CARROT_PATH_FILL = 'inherit';
var CARROT_D = 'M10 0H0L5 5L10 0Z';
var CARROT_PATHS = [new PathElement(CARROT_D, CARROT_PATH_FILL)];
var valueToIsEqual = function valueToIsEqual(value1) {
  return function (value2) {
    return value1 === value2;
  };
}; // booleanToIsExpression :: Boolean -> Any -> Any -> Any

var css_248z$1 = ".tooltip-text {\n  background: var(--payper-tooltip-text-background);\n  border: 1px solid var(--payper-tooltip-text-border-color);\n  border-radius: 4px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 130%;\n  padding: 6px 8px;\n  z-index: 1;\n  max-width: 200px;\n  min-width: 150px;\n}\n\n.tooltip-text * {\n  color: rgba(255, 255, 255, 0.9);\n  display: inline;\n}\n\n.image-with-tooltip {\n  margin-left: 4px;\n  display: flex;\n  align-items: center;\n  fill: var(--payper-image-with-tooltip-fill);\n}\n\n.img-tooltip-container {\n  z-index: 1;\n  transform: scale(0);\n  position: absolute;\n  margin-left: 30px;\n}\n\n.img-tooltip-container::before{\n  content: \"\\A\";\n  border-style: solid;\n  border-width: 10px 15px 10px 0;\n  border-color: transparent var(--payper-tooltip-text-background) transparent transparent;\n  position: absolute;\n  left: -5px;\n  top: calc(50% - 10px);\n}\n\n.image-with-tooltip svg:hover + * {\n  transform: scale(1);\n}\n";
styleInject$1(css_248z$1);
var INFO_WIDTH = '16';
var INFO_HEIGHT = '16';
var INFO_SVG = new SvgElement(new SvgStyle(INFO_WIDTH, INFO_HEIGHT), [new PathElement('M0 0h24v24H0z', 'none'), new PathElement('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z', 'inherit')]);
var DEFAULT_SVG = new SvgElement(); // tooltipToHasSvgElement :: String -> Boolean

// ACTIONS --------------------------------------
var SELECTED_EMPID_CHANGED = 'SELECTED_EMPID_CHANGED';
var stringToSelectedEmployeeIdChangeAction = function stringToSelectedEmployeeIdChangeAction() {
  var empId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return new ReduxAction(SELECTED_EMPID_CHANGED, empId);
};
var stateAndEmployeeIdToSelectedEmployeeIdChangeAction = function stateAndEmployeeIdToSelectedEmployeeIdChangeAction() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref.metricDefinitionDisplays,
    payRuleDisplays = _ref.payRuleDisplays,
    payRecordDisplays = _ref.payRecordDisplays,
    payRecordDetailDisplays = _ref.payRecordDetailDisplays,
    selectedDate = _ref.selectedDate,
    selectedDisplayView = _ref.selectedDisplayView,
    isDataLoading = _ref.isDataLoading,
    hasAnyQueryRun = _ref.hasAnyQueryRun,
    filterValues = _ref.filterValues,
    tableViewCount = _ref.tableViewCount;
  var employeeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, employeeId);
};
var QUERY_CONTROLS_DATE_VALUE_CHANGED = 'QUERY_CONTROLS_DATE_VALUE_CHANGED';
var dateToQueryControlsDateValueChangeAction = function dateToQueryControlsDateValueChangeAction(date) {
  return new ReduxAction(QUERY_CONTROLS_DATE_VALUE_CHANGED, date);
};
var stateAndQueryControlsDatePickerValueToState = function stateAndQueryControlsDatePickerValueToState() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref2.metricDefinitionDisplays,
    selectedDisplayView = _ref2.selectedDisplayView,
    payRuleDisplays = _ref2.payRuleDisplays,
    payRecordDisplays = _ref2.payRecordDisplays,
    payRecordDetailDisplays = _ref2.payRecordDetailDisplays,
    isDataLoading = _ref2.isDataLoading,
    hasAnyQueryRun = _ref2.hasAnyQueryRun,
    filterValues = _ref2.filterValues,
    tableViewCount = _ref2.tableViewCount,
    selectedEmployeeId = _ref2.selectedEmployeeId;
  var selectedValue = arguments[1];
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedValue, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};
var QUERY_CONTROLS_DROPDOWN_VALUE_CHANGED = 'QUERY_CONTROLS_DROPDOWN_VALUE_CHANGED';
var stringToQueryControlsDropdownValueChangeAction = function stringToQueryControlsDropdownValueChangeAction(string) {
  return new ReduxAction(QUERY_CONTROLS_DROPDOWN_VALUE_CHANGED, string);
};
var stateAndQueryControlsDropDownValueToState = function stateAndQueryControlsDropDownValueToState() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref3.metricDefinitionDisplays,
    payRuleDisplays = _ref3.payRuleDisplays,
    payRecordDisplays = _ref3.payRecordDisplays,
    payRecordDetailDisplays = _ref3.payRecordDetailDisplays,
    selectedDate = _ref3.selectedDate,
    isDataLoading = _ref3.isDataLoading,
    hasAnyQueryRun = _ref3.hasAnyQueryRun,
    filterValues = _ref3.filterValues,
    tableViewCount = _ref3.tableViewCount,
    selectedEmployeeId = _ref3.selectedEmployeeId;
  var selectedValue = arguments[1];
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedValue, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};
var METRIC_DEFINITION_DISPLAYS_CHANGED = 'METRIC_DEFINITION_DISPLAYS_CHANGED';
var metricDefinitionDisplaysToMetricDefinitionDisplaysChangeAction = function metricDefinitionDisplaysToMetricDefinitionDisplaysChangeAction(metricDefinitionDisplays) {
  return new ReduxAction(METRIC_DEFINITION_DISPLAYS_CHANGED, metricDefinitionDisplays);
};
var stateAndMetricDefinitionDisplaysToState = function stateAndMetricDefinitionDisplaysToState() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    payRuleDisplays = _ref4.payRuleDisplays,
    payRecordDisplays = _ref4.payRecordDisplays,
    payRecordDetailDisplays = _ref4.payRecordDetailDisplays,
    selectedDisplayView = _ref4.selectedDisplayView,
    selectedDate = _ref4.selectedDate,
    isDataLoading = _ref4.isDataLoading,
    hasAnyQueryRun = _ref4.hasAnyQueryRun,
    filterValues = _ref4.filterValues,
    tableViewCount = _ref4.tableViewCount,
    selectedEmployeeId = _ref4.selectedEmployeeId;
  var metricDefinitionDisplays = arguments[1];
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};
var PAY_RULE_DISPLAYS_CHANGED = 'PAY_RULE_DISPLAYS_CHANGED';
var payRuleDisplaysToPayRuleDisplaysChangeAction = function payRuleDisplaysToPayRuleDisplaysChangeAction(payRuleDisplays) {
  return new ReduxAction(PAY_RULE_DISPLAYS_CHANGED, payRuleDisplays);
};
var stateAndPayRuleDisplaysToState = function stateAndPayRuleDisplaysToState() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref5.metricDefinitionDisplays,
    payRecordDisplays = _ref5.payRecordDisplays,
    payRecordDetailDisplays = _ref5.payRecordDetailDisplays,
    selectedDisplayView = _ref5.selectedDisplayView,
    selectedDate = _ref5.selectedDate,
    isDataLoading = _ref5.isDataLoading,
    hasAnyQueryRun = _ref5.hasAnyQueryRun,
    filterValues = _ref5.filterValues,
    tableViewCount = _ref5.tableViewCount,
    selectedEmployeeId = _ref5.selectedEmployeeId;
  var payRuleDisplays = arguments[1];
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};
var PAY_RECORD_DISPLAYS_CHANGED = 'PAY_RECORD_DISPLAYS_CHANGED';
var payRecordDisplaysToPayRecordDisplaysChangeAction = function payRecordDisplaysToPayRecordDisplaysChangeAction(payRecordDisplays) {
  return new ReduxAction(PAY_RECORD_DISPLAYS_CHANGED, payRecordDisplays);
};
var stateAndPayRecordDisplaysToState = function stateAndPayRecordDisplaysToState() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref6.metricDefinitionDisplays,
    payRuleDisplays = _ref6.payRuleDisplays,
    payRecordDetailDisplays = _ref6.payRecordDetailDisplays,
    selectedDisplayView = _ref6.selectedDisplayView,
    selectedDate = _ref6.selectedDate,
    isDataLoading = _ref6.isDataLoading,
    hasAnyQueryRun = _ref6.hasAnyQueryRun,
    filterValues = _ref6.filterValues,
    tableViewCount = _ref6.tableViewCount,
    selectedEmployeeId = _ref6.selectedEmployeeId;
  var payRecordDisplays = arguments[1];
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};
var PAY_RECORD_DETAIL_DISPLAYS_CHANGED = 'PAY_RECORD_DETAIL_DISPLAYS_CHANGED';
var payRecordDetailDisplaysToPayRecordDetailDisplaysChangeAction = function payRecordDetailDisplaysToPayRecordDetailDisplaysChangeAction(payRecordDetailDisplays) {
  return new ReduxAction(PAY_RECORD_DETAIL_DISPLAYS_CHANGED, payRecordDetailDisplays);
};
var stateAndPayRecordDetailDisplaysToState = function stateAndPayRecordDetailDisplaysToState() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref7.metricDefinitionDisplays,
    payRuleDisplays = _ref7.payRuleDisplays,
    payRecordDisplays = _ref7.payRecordDisplays,
    selectedDisplayView = _ref7.selectedDisplayView,
    selectedDate = _ref7.selectedDate,
    isDataLoading = _ref7.isDataLoading,
    hasAnyQueryRun = _ref7.hasAnyQueryRun,
    filterValues = _ref7.filterValues,
    tableViewCount = _ref7.tableViewCount,
    selectedEmployeeId = _ref7.selectedEmployeeId;
  var payRecordDetailDisplays = arguments[1];
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};
var IS_DATA_LOADING_VALUE_CHANGED = 'IS_DATA_LOADING_VALUE_CHANGED';
var booleanToIsDataLoadingChangeAction = function booleanToIsDataLoadingChangeAction(boolean) {
  return new ReduxAction(IS_DATA_LOADING_VALUE_CHANGED, boolean);
};
var stateAndIsDataLoadingToState = function stateAndIsDataLoadingToState() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref8.metricDefinitionDisplays,
    payRuleDisplays = _ref8.payRuleDisplays,
    payRecordDisplays = _ref8.payRecordDisplays,
    payRecordDetailDisplays = _ref8.payRecordDetailDisplays,
    selectedDisplayView = _ref8.selectedDisplayView,
    selectedDate = _ref8.selectedDate,
    hasAnyQueryRun = _ref8.hasAnyQueryRun,
    filterValues = _ref8.filterValues,
    tableViewCount = _ref8.tableViewCount,
    selectedEmployeeId = _ref8.selectedEmployeeId;
  var isDataLoading = arguments[1];
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};
var HAS_ANY_QUERY_RUN_VALUE_CHANGED = 'HAS_ANY_QUERY_RUN_VALUE_CHANGED';
var booleanToHasAnyQueryRunChangeAction = function booleanToHasAnyQueryRunChangeAction() {
  var boolean = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return new ReduxAction(HAS_ANY_QUERY_RUN_VALUE_CHANGED, boolean);
};
var stateAndHasAnyQueryRunToState = function stateAndHasAnyQueryRunToState() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref9.metricDefinitionDisplays,
    payRuleDisplays = _ref9.payRuleDisplays,
    payRecordDisplays = _ref9.payRecordDisplays,
    payRecordDetailDisplays = _ref9.payRecordDetailDisplays,
    selectedDisplayView = _ref9.selectedDisplayView,
    selectedDate = _ref9.selectedDate,
    isDataLoading = _ref9.isDataLoading,
    filterValues = _ref9.filterValues,
    tableViewCount = _ref9.tableViewCount,
    selectedEmployeeId = _ref9.selectedEmployeeId;
  var hasAnyQueryBeenRun = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryBeenRun, filterValues, tableViewCount, selectedEmployeeId);
};
var EMPTY_ALL_DISPLAY_VALUES = 'EMPTY_ALL_DISPLAY_VALUES';
var emptyAllDisplayValuesAction = function emptyAllDisplayValuesAction() {
  return new ReduxAction(EMPTY_ALL_DISPLAY_VALUES);
};
var stateToStateWithEmptyDisplays = function stateToStateWithEmptyDisplays() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    selectedDate = _ref10.selectedDate,
    selectedDisplayView = _ref10.selectedDisplayView,
    isDataLoading = _ref10.isDataLoading,
    hasAnyQueryRun = _ref10.hasAnyQueryRun,
    tableViewCount = _ref10.tableViewCount,
    selectedEmployeeId = _ref10.selectedEmployeeId;
  return new AdminDataViewReduxState([], [], [], [], selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, [], tableViewCount, selectedEmployeeId);
};
var QUERY_CONTROLS_FILTER_VALUES_CHANGED = 'QUERY_CONTROLS_FILTER_VALUES_CHANGED';
var stringsToQueryControlsFilterValuesChangeAction = function stringsToQueryControlsFilterValuesChangeAction() {
  var filterValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new ReduxAction(QUERY_CONTROLS_FILTER_VALUES_CHANGED, filterValues);
};
var stateAndFilterValuesToState = function stateAndFilterValuesToState() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref11.metricDefinitionDisplays,
    payRuleDisplays = _ref11.payRuleDisplays,
    payRecordDisplays = _ref11.payRecordDisplays,
    payRecordDetailDisplays = _ref11.payRecordDetailDisplays,
    selectedDate = _ref11.selectedDate,
    selectedDisplayView = _ref11.selectedDisplayView,
    isDataLoading = _ref11.isDataLoading,
    hasAnyQueryRun = _ref11.hasAnyQueryRun,
    tableViewCount = _ref11.tableViewCount,
    selectedEmployeeId = _ref11.selectedEmployeeId;
  var filterValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};
var VIEW_CONTROLS_TABLE_ITEM_VIEW_COUNT_CHANGED = 'VIEW_CONTROLS_TABLE_ITEM_VIEW_COUNT_CHANGED';
var stringToViewControlsTableViewCountChangeAction = function stringToViewControlsTableViewCountChangeAction() {
  var tableViewCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return new ReduxAction(VIEW_CONTROLS_TABLE_ITEM_VIEW_COUNT_CHANGED, tableViewCount);
};
var stateAndTableViewCountToState = function stateAndTableViewCountToState() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState(),
    metricDefinitionDisplays = _ref12.metricDefinitionDisplays,
    payRuleDisplays = _ref12.payRuleDisplays,
    payRecordDisplays = _ref12.payRecordDisplays,
    payRecordDetailDisplays = _ref12.payRecordDetailDisplays,
    selectedDate = _ref12.selectedDate,
    selectedDisplayView = _ref12.selectedDisplayView,
    isDataLoading = _ref12.isDataLoading,
    hasAnyQueryRun = _ref12.hasAnyQueryRun,
    filterValues = _ref12.filterValues,
    selectedEmployeeId = _ref12.selectedEmployeeId;
  var tableViewCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return new AdminDataViewReduxState(metricDefinitionDisplays, payRuleDisplays, payRecordDisplays, payRecordDetailDisplays, selectedDisplayView, selectedDate, isDataLoading, hasAnyQueryRun, filterValues, tableViewCount, selectedEmployeeId);
};

// REDUCER --------------------------------------
var AdminDataViewReduxStateReducer = function AdminDataViewReduxStateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AdminDataViewReduxState();
  var _ref13 = arguments[1];
  var _ref13$type = _ref13.type,
    type = _ref13$type === undefined ? '' : _ref13$type,
    payload = _ref13.payload;
  var isType = valueToIsEqual(type);
  if (isType(QUERY_CONTROLS_DATE_VALUE_CHANGED)) return stateAndQueryControlsDatePickerValueToState(state, payload);
  if (isType(QUERY_CONTROLS_DROPDOWN_VALUE_CHANGED)) return stateAndQueryControlsDropDownValueToState(state, payload);
  if (isType(IS_DATA_LOADING_VALUE_CHANGED)) return stateAndIsDataLoadingToState(state, payload);
  if (isType(HAS_ANY_QUERY_RUN_VALUE_CHANGED)) return stateAndHasAnyQueryRunToState(state, payload);
  if (isType(METRIC_DEFINITION_DISPLAYS_CHANGED)) return stateAndMetricDefinitionDisplaysToState(state, payload);
  if (isType(PAY_RULE_DISPLAYS_CHANGED)) return stateAndPayRuleDisplaysToState(state, payload);
  if (isType(PAY_RECORD_DISPLAYS_CHANGED)) return stateAndPayRecordDisplaysToState(state, payload);
  if (isType(PAY_RECORD_DETAIL_DISPLAYS_CHANGED)) return stateAndPayRecordDetailDisplaysToState(state, payload);
  if (isType(EMPTY_ALL_DISPLAY_VALUES)) return stateToStateWithEmptyDisplays(state);
  if (isType(QUERY_CONTROLS_FILTER_VALUES_CHANGED)) return stateAndFilterValuesToState(state, payload);
  if (isType(VIEW_CONTROLS_TABLE_ITEM_VIEW_COUNT_CHANGED)) return stateAndTableViewCountToState(state, payload);
  if (isType(SELECTED_EMPID_CHANGED)) {
    return stateAndEmployeeIdToSelectedEmployeeIdChangeAction(state, payload);
  }
  return state;
};

// const queryTypes = [
//   new QueryType('payRules', new QueryOptions(true)),
//   new QueryType('metricDefinitions', new QueryOptions(false)),
// ];

// ReactDOM.render(
//   <AdminPageComponent
//     queryTypes={queryTypes}
//     setQueryType={() => {}}
//     setDate={() => {}}
//     data={[{ test: 'test' }]}
//     dataLoading={false}
//   />,
//   document.getElementById('root')
// );

export { AdminPageComponent, AdminDataViewReduxState, AdminDataViewConfig, adminDataViewReduxStateToMetricDefinitionDisplays, adminDataViewReduxStateToPayRuleDisplays, adminDataViewReduxStateToSelectedDisplayView, adminDataViewReduxStateToSelectedDate, adminDataViewReduxStateToIsDataLoading, adminDataViewReduxStateToFilterValues, adminDataViewReduxStateToTableViewCount, adminDataViewReduxStateToSelectedEmployeeId, adminDataViewReduxStateToHasAnyQueryRun, MetricDefinitionDisplay, PayRuleDisplay, PayRecordDisplay, PayRecordDetailDisplay, AdminDataViewReduxStateReducer, booleanToHasAnyQueryRunChangeAction, payRecordDetailDisplaysToPayRecordDetailDisplaysChangeAction, payRuleDisplaysToPayRuleDisplaysChangeAction, payRecordDisplaysToPayRecordDisplaysChangeAction, metricDefinitionDisplaysToMetricDefinitionDisplaysChangeAction, stringToQueryControlsDropdownValueChangeAction, dateToQueryControlsDateValueChangeAction, stringsToQueryControlsFilterValuesChangeAction, booleanToIsDataLoadingChangeAction, emptyAllDisplayValuesAction, stringToViewControlsTableViewCountChangeAction, stringToSelectedEmployeeIdChangeAction, TABLE_VIEW_COUNT_OPTIONS };